(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("WpYDg", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0af9915fb6e5dbf3$export$6503ec6e8aabbaf; }, function (v) { return $0af9915fb6e5dbf3$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0af9915fb6e5dbf3$export$f7ad0328861e2f03; }, function (v) { return $0af9915fb6e5dbf3$export$f7ad0328861e2f03 = v; });
var $0af9915fb6e5dbf3$export$6503ec6e8aabbaf;
var $0af9915fb6e5dbf3$export$f7ad0328861e2f03;
"use strict";
var $0af9915fb6e5dbf3$var$mapping = new Map();
function $0af9915fb6e5dbf3$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0af9915fb6e5dbf3$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0af9915fb6e5dbf3$var$resolve(id) {
    var resolved = $0af9915fb6e5dbf3$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0af9915fb6e5dbf3$export$6503ec6e8aabbaf = $0af9915fb6e5dbf3$var$register;
$0af9915fb6e5dbf3$export$f7ad0328861e2f03 = $0af9915fb6e5dbf3$var$resolve;

});

parcelRegister("5ptLS", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $3f06617b94aa676e$export$bdfd709ae4826697; }, function (v) { return $3f06617b94aa676e$export$bdfd709ae4826697 = v; });
var $3f06617b94aa676e$export$bdfd709ae4826697;
var $3f06617b94aa676e$export$c9e73fbda7da57b6;
var $3f06617b94aa676e$export$5a759dc7a1cfb72a;
"use strict";
var $3f06617b94aa676e$var$bundleURL = {};
function $3f06617b94aa676e$var$getBundleURLCached(id) {
    var value = $3f06617b94aa676e$var$bundleURL[id];
    if (!value) {
        value = $3f06617b94aa676e$var$getBundleURL();
        $3f06617b94aa676e$var$bundleURL[id] = value;
    }
    return value;
}
function $3f06617b94aa676e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $3f06617b94aa676e$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $3f06617b94aa676e$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $3f06617b94aa676e$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$3f06617b94aa676e$export$bdfd709ae4826697 = $3f06617b94aa676e$var$getBundleURLCached;
$3f06617b94aa676e$export$c9e73fbda7da57b6 = $3f06617b94aa676e$var$getBaseURL;
$3f06617b94aa676e$export$5a759dc7a1cfb72a = $3f06617b94aa676e$var$getOrigin;

});

parcelRegister("6rcps", function(module, exports) {
'use strict';

module.exports = (parcelRequire("g1nA1"));

});
parcelRegister("g1nA1", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ba9f07d11e8eecf4$export$ffb0004e005737fa; }, function (v) { return $ba9f07d11e8eecf4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ba9f07d11e8eecf4$export$34b9dba7ce09269b; }, function (v) { return $ba9f07d11e8eecf4$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ba9f07d11e8eecf4$export$25062201e9e25d76; }, function (v) { return $ba9f07d11e8eecf4$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba9f07d11e8eecf4$export$ffb0004e005737fa;
var $ba9f07d11e8eecf4$export$34b9dba7ce09269b;
var $ba9f07d11e8eecf4$export$25062201e9e25d76;
'use strict';

var $8ZuGG = parcelRequire("8ZuGG");
var $ba9f07d11e8eecf4$var$k = Symbol.for("react.element"), $ba9f07d11e8eecf4$var$l = Symbol.for("react.fragment"), $ba9f07d11e8eecf4$var$m = Object.prototype.hasOwnProperty, $ba9f07d11e8eecf4$var$n = $8ZuGG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ba9f07d11e8eecf4$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba9f07d11e8eecf4$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ba9f07d11e8eecf4$var$m.call(a, b) && !$ba9f07d11e8eecf4$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ba9f07d11e8eecf4$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ba9f07d11e8eecf4$var$n.current
    };
}
$ba9f07d11e8eecf4$export$ffb0004e005737fa = $ba9f07d11e8eecf4$var$l;
$ba9f07d11e8eecf4$export$34b9dba7ce09269b = $ba9f07d11e8eecf4$var$q;
$ba9f07d11e8eecf4$export$25062201e9e25d76 = $ba9f07d11e8eecf4$var$q;

});
parcelRegister("8ZuGG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fZqWx"));

});
parcelRegister("fZqWx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $ba4173e472b74fdb$export$dca3b0875bd9a954; }, function (v) { return $ba4173e472b74fdb$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ba4173e472b74fdb$export$16fa2f45be04daa8; }, function (v) { return $ba4173e472b74fdb$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ba4173e472b74fdb$export$ffb0004e005737fa; }, function (v) { return $ba4173e472b74fdb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ba4173e472b74fdb$export$e2c29f18771995cb; }, function (v) { return $ba4173e472b74fdb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ba4173e472b74fdb$export$221d75b3f55bb0bd; }, function (v) { return $ba4173e472b74fdb$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ba4173e472b74fdb$export$5f8d39834fd61797; }, function (v) { return $ba4173e472b74fdb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ba4173e472b74fdb$export$74bf444e3cd11ea5; }, function (v) { return $ba4173e472b74fdb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ba4173e472b74fdb$export$ae55be85d98224ed; }, function (v) { return $ba4173e472b74fdb$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $ba4173e472b74fdb$export$3ba232387fd5d6dd; }, function (v) { return $ba4173e472b74fdb$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ba4173e472b74fdb$export$e530037191fcd5d7; }, function (v) { return $ba4173e472b74fdb$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ba4173e472b74fdb$export$fd42f52fd3ae1109; }, function (v) { return $ba4173e472b74fdb$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ba4173e472b74fdb$export$c8a8987d4410bf2d; }, function (v) { return $ba4173e472b74fdb$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $ba4173e472b74fdb$export$d38cd72104c1f0e9; }, function (v) { return $ba4173e472b74fdb$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $ba4173e472b74fdb$export$7d1e3a5e95ceca43; }, function (v) { return $ba4173e472b74fdb$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ba4173e472b74fdb$export$257a8862b851cb5b; }, function (v) { return $ba4173e472b74fdb$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ba4173e472b74fdb$export$a8257692ac88316c; }, function (v) { return $ba4173e472b74fdb$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ba4173e472b74fdb$export$488013bae63b21da; }, function (v) { return $ba4173e472b74fdb$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ba4173e472b74fdb$export$7c73462e0d25e514; }, function (v) { return $ba4173e472b74fdb$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ba4173e472b74fdb$export$7568632d0d33d16d; }, function (v) { return $ba4173e472b74fdb$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $ba4173e472b74fdb$export$88948ce120ea2619; }, function (v) { return $ba4173e472b74fdb$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ba4173e472b74fdb$export$35808ee640e87ca7; }, function (v) { return $ba4173e472b74fdb$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ba4173e472b74fdb$export$fae74005e78b1a27; }, function (v) { return $ba4173e472b74fdb$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ba4173e472b74fdb$export$dc8fbce3eb94dc1e; }, function (v) { return $ba4173e472b74fdb$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ba4173e472b74fdb$export$6a7bc4e911dc01cf; }, function (v) { return $ba4173e472b74fdb$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ba4173e472b74fdb$export$6d9c69b0de29b591; }, function (v) { return $ba4173e472b74fdb$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $ba4173e472b74fdb$export$f680877a34711e37; }, function (v) { return $ba4173e472b74fdb$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ba4173e472b74fdb$export$d5a552a76deda3c2; }, function (v) { return $ba4173e472b74fdb$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ba4173e472b74fdb$export$aaabe4eda9ed9969; }, function (v) { return $ba4173e472b74fdb$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ba4173e472b74fdb$export$e5c5a5f917a5871c; }, function (v) { return $ba4173e472b74fdb$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ba4173e472b74fdb$export$1538c33de8887b59; }, function (v) { return $ba4173e472b74fdb$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $ba4173e472b74fdb$export$13e3392192263954; }, function (v) { return $ba4173e472b74fdb$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ba4173e472b74fdb$export$b8f5890fc79d6aca; }, function (v) { return $ba4173e472b74fdb$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ba4173e472b74fdb$export$60241385465d0a34; }, function (v) { return $ba4173e472b74fdb$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ba4173e472b74fdb$export$306c0aa65ff9ec16; }, function (v) { return $ba4173e472b74fdb$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ba4173e472b74fdb$export$7b286972b8d8ccbf; }, function (v) { return $ba4173e472b74fdb$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ba4173e472b74fdb$export$83d89fbfd8236492; }, function (v) { return $ba4173e472b74fdb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba4173e472b74fdb$export$dca3b0875bd9a954;
var $ba4173e472b74fdb$export$16fa2f45be04daa8;
var $ba4173e472b74fdb$export$ffb0004e005737fa;
var $ba4173e472b74fdb$export$e2c29f18771995cb;
var $ba4173e472b74fdb$export$221d75b3f55bb0bd;
var $ba4173e472b74fdb$export$5f8d39834fd61797;
var $ba4173e472b74fdb$export$74bf444e3cd11ea5;
var $ba4173e472b74fdb$export$ae55be85d98224ed;
var $ba4173e472b74fdb$export$3ba232387fd5d6dd;
var $ba4173e472b74fdb$export$e530037191fcd5d7;
var $ba4173e472b74fdb$export$fd42f52fd3ae1109;
var $ba4173e472b74fdb$export$c8a8987d4410bf2d;
var $ba4173e472b74fdb$export$d38cd72104c1f0e9;
var $ba4173e472b74fdb$export$7d1e3a5e95ceca43;
var $ba4173e472b74fdb$export$257a8862b851cb5b;
var $ba4173e472b74fdb$export$a8257692ac88316c;
var $ba4173e472b74fdb$export$488013bae63b21da;
var $ba4173e472b74fdb$export$7c73462e0d25e514;
var $ba4173e472b74fdb$export$7568632d0d33d16d;
var $ba4173e472b74fdb$export$88948ce120ea2619;
var $ba4173e472b74fdb$export$35808ee640e87ca7;
var $ba4173e472b74fdb$export$fae74005e78b1a27;
var $ba4173e472b74fdb$export$dc8fbce3eb94dc1e;
var $ba4173e472b74fdb$export$6a7bc4e911dc01cf;
var $ba4173e472b74fdb$export$6d9c69b0de29b591;
var $ba4173e472b74fdb$export$f680877a34711e37;
var $ba4173e472b74fdb$export$d5a552a76deda3c2;
var $ba4173e472b74fdb$export$aaabe4eda9ed9969;
var $ba4173e472b74fdb$export$e5c5a5f917a5871c;
var $ba4173e472b74fdb$export$1538c33de8887b59;
var $ba4173e472b74fdb$export$13e3392192263954;
var $ba4173e472b74fdb$export$b8f5890fc79d6aca;
var $ba4173e472b74fdb$export$60241385465d0a34;
var $ba4173e472b74fdb$export$306c0aa65ff9ec16;
var $ba4173e472b74fdb$export$7b286972b8d8ccbf;
var $ba4173e472b74fdb$export$83d89fbfd8236492;
'use strict';
var $ba4173e472b74fdb$var$l = Symbol.for("react.element"), $ba4173e472b74fdb$var$n = Symbol.for("react.portal"), $ba4173e472b74fdb$var$p = Symbol.for("react.fragment"), $ba4173e472b74fdb$var$q = Symbol.for("react.strict_mode"), $ba4173e472b74fdb$var$r = Symbol.for("react.profiler"), $ba4173e472b74fdb$var$t = Symbol.for("react.provider"), $ba4173e472b74fdb$var$u = Symbol.for("react.context"), $ba4173e472b74fdb$var$v = Symbol.for("react.forward_ref"), $ba4173e472b74fdb$var$w = Symbol.for("react.suspense"), $ba4173e472b74fdb$var$x = Symbol.for("react.memo"), $ba4173e472b74fdb$var$y = Symbol.for("react.lazy"), $ba4173e472b74fdb$var$z = Symbol.iterator;
function $ba4173e472b74fdb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ba4173e472b74fdb$var$z && a[$ba4173e472b74fdb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ba4173e472b74fdb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ba4173e472b74fdb$var$C = Object.assign, $ba4173e472b74fdb$var$D = {};
function $ba4173e472b74fdb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4173e472b74fdb$var$D;
    this.updater = e || $ba4173e472b74fdb$var$B;
}
$ba4173e472b74fdb$var$E.prototype.isReactComponent = {};
$ba4173e472b74fdb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$ba4173e472b74fdb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $ba4173e472b74fdb$var$F() {}
$ba4173e472b74fdb$var$F.prototype = $ba4173e472b74fdb$var$E.prototype;
function $ba4173e472b74fdb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4173e472b74fdb$var$D;
    this.updater = e || $ba4173e472b74fdb$var$B;
}
var $ba4173e472b74fdb$var$H = $ba4173e472b74fdb$var$G.prototype = new $ba4173e472b74fdb$var$F;
$ba4173e472b74fdb$var$H.constructor = $ba4173e472b74fdb$var$G;
$ba4173e472b74fdb$var$C($ba4173e472b74fdb$var$H, $ba4173e472b74fdb$var$E.prototype);
$ba4173e472b74fdb$var$H.isPureReactComponent = !0;
var $ba4173e472b74fdb$var$I = Array.isArray, $ba4173e472b74fdb$var$J = Object.prototype.hasOwnProperty, $ba4173e472b74fdb$var$K = {
    current: null
}, $ba4173e472b74fdb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba4173e472b74fdb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$ba4173e472b74fdb$var$J.call(b, d) && !$ba4173e472b74fdb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $ba4173e472b74fdb$var$K.current
    };
}
function $ba4173e472b74fdb$var$N(a, b) {
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $ba4173e472b74fdb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ba4173e472b74fdb$var$l;
}
function $ba4173e472b74fdb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $ba4173e472b74fdb$var$P = /\/+/g;
function $ba4173e472b74fdb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $ba4173e472b74fdb$var$escape("" + a.key) : b.toString(36);
}
function $ba4173e472b74fdb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $ba4173e472b74fdb$var$l:
                case $ba4173e472b74fdb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $ba4173e472b74fdb$var$Q(h, 0) : d, $ba4173e472b74fdb$var$I(c) ? (e = "", null != a && (e = a.replace($ba4173e472b74fdb$var$P, "$&/") + "/"), $ba4173e472b74fdb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($ba4173e472b74fdb$var$O(c) && (c = $ba4173e472b74fdb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($ba4173e472b74fdb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($ba4173e472b74fdb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $ba4173e472b74fdb$var$Q(k, g);
        h += $ba4173e472b74fdb$var$R(k, b, e, f, c);
    }
    else if (f = $ba4173e472b74fdb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $ba4173e472b74fdb$var$Q(k, g++), h += $ba4173e472b74fdb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $ba4173e472b74fdb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $ba4173e472b74fdb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $ba4173e472b74fdb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $ba4173e472b74fdb$var$U = {
    current: null
}, $ba4173e472b74fdb$var$V = {
    transition: null
}, $ba4173e472b74fdb$var$W = {
    ReactCurrentDispatcher: $ba4173e472b74fdb$var$U,
    ReactCurrentBatchConfig: $ba4173e472b74fdb$var$V,
    ReactCurrentOwner: $ba4173e472b74fdb$var$K
};
function $ba4173e472b74fdb$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$ba4173e472b74fdb$export$dca3b0875bd9a954 = {
    map: $ba4173e472b74fdb$var$S,
    forEach: function(a, b, e) {
        $ba4173e472b74fdb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $ba4173e472b74fdb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $ba4173e472b74fdb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$ba4173e472b74fdb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$ba4173e472b74fdb$export$16fa2f45be04daa8 = $ba4173e472b74fdb$var$E;
$ba4173e472b74fdb$export$ffb0004e005737fa = $ba4173e472b74fdb$var$p;
$ba4173e472b74fdb$export$e2c29f18771995cb = $ba4173e472b74fdb$var$r;
$ba4173e472b74fdb$export$221d75b3f55bb0bd = $ba4173e472b74fdb$var$G;
$ba4173e472b74fdb$export$5f8d39834fd61797 = $ba4173e472b74fdb$var$q;
$ba4173e472b74fdb$export$74bf444e3cd11ea5 = $ba4173e472b74fdb$var$w;
$ba4173e472b74fdb$export$ae55be85d98224ed = $ba4173e472b74fdb$var$W;
$ba4173e472b74fdb$export$3ba232387fd5d6dd = $ba4173e472b74fdb$var$X;
$ba4173e472b74fdb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $ba4173e472b74fdb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $ba4173e472b74fdb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$ba4173e472b74fdb$var$J.call(b, f) && !$ba4173e472b74fdb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$ba4173e472b74fdb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $ba4173e472b74fdb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $ba4173e472b74fdb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$ba4173e472b74fdb$export$c8a8987d4410bf2d = $ba4173e472b74fdb$var$M;
$ba4173e472b74fdb$export$d38cd72104c1f0e9 = function(a) {
    var b = $ba4173e472b74fdb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$ba4173e472b74fdb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ba4173e472b74fdb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $ba4173e472b74fdb$var$v,
        render: a
    };
};
$ba4173e472b74fdb$export$a8257692ac88316c = $ba4173e472b74fdb$var$O;
$ba4173e472b74fdb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $ba4173e472b74fdb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $ba4173e472b74fdb$var$T
    };
};
$ba4173e472b74fdb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $ba4173e472b74fdb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$ba4173e472b74fdb$export$7568632d0d33d16d = function(a) {
    var b = $ba4173e472b74fdb$var$V.transition;
    $ba4173e472b74fdb$var$V.transition = {};
    try {
        a();
    } finally{
        $ba4173e472b74fdb$var$V.transition = b;
    }
};
$ba4173e472b74fdb$export$88948ce120ea2619 = $ba4173e472b74fdb$var$X;
$ba4173e472b74fdb$export$35808ee640e87ca7 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useCallback(a, b);
};
$ba4173e472b74fdb$export$fae74005e78b1a27 = function(a) {
    return $ba4173e472b74fdb$var$U.current.useContext(a);
};
$ba4173e472b74fdb$export$dc8fbce3eb94dc1e = function() {};
$ba4173e472b74fdb$export$6a7bc4e911dc01cf = function(a) {
    return $ba4173e472b74fdb$var$U.current.useDeferredValue(a);
};
$ba4173e472b74fdb$export$6d9c69b0de29b591 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useEffect(a, b);
};
$ba4173e472b74fdb$export$f680877a34711e37 = function() {
    return $ba4173e472b74fdb$var$U.current.useId();
};
$ba4173e472b74fdb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useImperativeHandle(a, b, e);
};
$ba4173e472b74fdb$export$aaabe4eda9ed9969 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useInsertionEffect(a, b);
};
$ba4173e472b74fdb$export$e5c5a5f917a5871c = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useLayoutEffect(a, b);
};
$ba4173e472b74fdb$export$1538c33de8887b59 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useMemo(a, b);
};
$ba4173e472b74fdb$export$13e3392192263954 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useReducer(a, b, e);
};
$ba4173e472b74fdb$export$b8f5890fc79d6aca = function(a) {
    return $ba4173e472b74fdb$var$U.current.useRef(a);
};
$ba4173e472b74fdb$export$60241385465d0a34 = function(a) {
    return $ba4173e472b74fdb$var$U.current.useState(a);
};
$ba4173e472b74fdb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useSyncExternalStore(a, b, e);
};
$ba4173e472b74fdb$export$7b286972b8d8ccbf = function() {
    return $ba4173e472b74fdb$var$U.current.useTransition();
};
$ba4173e472b74fdb$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("h1d60", function(module, exports) {
'use strict';
function $c63cb039bba59465$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c63cb039bba59465$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c63cb039bba59465$var$checkDCE();

module.exports = (parcelRequire("lAuEq"));

});
parcelRegister("lAuEq", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fb74bc6f62fb4035$export$ae55be85d98224ed; }, function (v) { return $fb74bc6f62fb4035$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fb74bc6f62fb4035$export$d39a5bbd09211389; }, function (v) { return $fb74bc6f62fb4035$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fb74bc6f62fb4035$export$882461b6382ed46c; }, function (v) { return $fb74bc6f62fb4035$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fb74bc6f62fb4035$export$466bfc07425424d5; }, function (v) { return $fb74bc6f62fb4035$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fb74bc6f62fb4035$export$cd75ccfd720a3cd4; }, function (v) { return $fb74bc6f62fb4035$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fb74bc6f62fb4035$export$fa8d919ba61d84db; }, function (v) { return $fb74bc6f62fb4035$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fb74bc6f62fb4035$export$757ceba2d55c277e; }, function (v) { return $fb74bc6f62fb4035$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fb74bc6f62fb4035$export$b3890eb0ae9dca99; }, function (v) { return $fb74bc6f62fb4035$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fb74bc6f62fb4035$export$502457920280e6be; }, function (v) { return $fb74bc6f62fb4035$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fb74bc6f62fb4035$export$c78a37762a8d58e1; }, function (v) { return $fb74bc6f62fb4035$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fb74bc6f62fb4035$export$dc54d992c10e8a18; }, function (v) { return $fb74bc6f62fb4035$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fb74bc6f62fb4035$export$83d89fbfd8236492; }, function (v) { return $fb74bc6f62fb4035$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fb74bc6f62fb4035$export$ae55be85d98224ed;
var $fb74bc6f62fb4035$export$d39a5bbd09211389;
var $fb74bc6f62fb4035$export$882461b6382ed46c;
var $fb74bc6f62fb4035$export$466bfc07425424d5;
var $fb74bc6f62fb4035$export$cd75ccfd720a3cd4;
var $fb74bc6f62fb4035$export$fa8d919ba61d84db;
var $fb74bc6f62fb4035$export$757ceba2d55c277e;
var $fb74bc6f62fb4035$export$b3890eb0ae9dca99;
var $fb74bc6f62fb4035$export$502457920280e6be;
var $fb74bc6f62fb4035$export$c78a37762a8d58e1;
var $fb74bc6f62fb4035$export$dc54d992c10e8a18;
var $fb74bc6f62fb4035$export$83d89fbfd8236492;
'use strict';

var $8ZuGG = parcelRequire("8ZuGG");

var $lIEVH = parcelRequire("lIEVH");
function $fb74bc6f62fb4035$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fb74bc6f62fb4035$var$da = new Set, $fb74bc6f62fb4035$var$ea = {};
function $fb74bc6f62fb4035$var$fa(a, b) {
    $fb74bc6f62fb4035$var$ha(a, b);
    $fb74bc6f62fb4035$var$ha(a + "Capture", b);
}
function $fb74bc6f62fb4035$var$ha(a, b) {
    $fb74bc6f62fb4035$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fb74bc6f62fb4035$var$da.add(b[a]);
}
var $fb74bc6f62fb4035$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fb74bc6f62fb4035$var$ja = Object.prototype.hasOwnProperty, $fb74bc6f62fb4035$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fb74bc6f62fb4035$var$la = {}, $fb74bc6f62fb4035$var$ma = {};
function $fb74bc6f62fb4035$var$oa(a) {
    if ($fb74bc6f62fb4035$var$ja.call($fb74bc6f62fb4035$var$ma, a)) return !0;
    if ($fb74bc6f62fb4035$var$ja.call($fb74bc6f62fb4035$var$la, a)) return !1;
    if ($fb74bc6f62fb4035$var$ka.test(a)) return $fb74bc6f62fb4035$var$ma[a] = !0;
    $fb74bc6f62fb4035$var$la[a] = !0;
    return !1;
}
function $fb74bc6f62fb4035$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fb74bc6f62fb4035$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fb74bc6f62fb4035$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fb74bc6f62fb4035$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fb74bc6f62fb4035$var$ra = /[\-:]([a-z])/g;
function $fb74bc6f62fb4035$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fb74bc6f62fb4035$var$z.xlinkHref = new $fb74bc6f62fb4035$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fb74bc6f62fb4035$var$ta(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$z.hasOwnProperty(b) ? $fb74bc6f62fb4035$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fb74bc6f62fb4035$var$qa(b, c, e, d) && (c = null), d || null === e ? $fb74bc6f62fb4035$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fb74bc6f62fb4035$var$ua = $8ZuGG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fb74bc6f62fb4035$var$va = Symbol.for("react.element"), $fb74bc6f62fb4035$var$wa = Symbol.for("react.portal"), $fb74bc6f62fb4035$var$ya = Symbol.for("react.fragment"), $fb74bc6f62fb4035$var$za = Symbol.for("react.strict_mode"), $fb74bc6f62fb4035$var$Aa = Symbol.for("react.profiler"), $fb74bc6f62fb4035$var$Ba = Symbol.for("react.provider"), $fb74bc6f62fb4035$var$Ca = Symbol.for("react.context"), $fb74bc6f62fb4035$var$Da = Symbol.for("react.forward_ref"), $fb74bc6f62fb4035$var$Ea = Symbol.for("react.suspense"), $fb74bc6f62fb4035$var$Fa = Symbol.for("react.suspense_list"), $fb74bc6f62fb4035$var$Ga = Symbol.for("react.memo"), $fb74bc6f62fb4035$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fb74bc6f62fb4035$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fb74bc6f62fb4035$var$Ja = Symbol.iterator;
function $fb74bc6f62fb4035$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fb74bc6f62fb4035$var$Ja && a[$fb74bc6f62fb4035$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fb74bc6f62fb4035$var$A = Object.assign, $fb74bc6f62fb4035$var$La;
function $fb74bc6f62fb4035$var$Ma(a) {
    if (void 0 === $fb74bc6f62fb4035$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fb74bc6f62fb4035$var$La = b && b[1] || "";
    }
    return "\n" + $fb74bc6f62fb4035$var$La + a;
}
var $fb74bc6f62fb4035$var$Na = !1;
function $fb74bc6f62fb4035$var$Oa(a, b) {
    if (!a || $fb74bc6f62fb4035$var$Na) return "";
    $fb74bc6f62fb4035$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fb74bc6f62fb4035$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fb74bc6f62fb4035$var$Ma(a) : "";
}
function $fb74bc6f62fb4035$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fb74bc6f62fb4035$var$Ma(a.type);
        case 16:
            return $fb74bc6f62fb4035$var$Ma("Lazy");
        case 13:
            return $fb74bc6f62fb4035$var$Ma("Suspense");
        case 19:
            return $fb74bc6f62fb4035$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fb74bc6f62fb4035$var$Oa(a.type, !1), a;
        case 11:
            return a = $fb74bc6f62fb4035$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fb74bc6f62fb4035$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fb74bc6f62fb4035$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fb74bc6f62fb4035$var$ya:
            return "Fragment";
        case $fb74bc6f62fb4035$var$wa:
            return "Portal";
        case $fb74bc6f62fb4035$var$Aa:
            return "Profiler";
        case $fb74bc6f62fb4035$var$za:
            return "StrictMode";
        case $fb74bc6f62fb4035$var$Ea:
            return "Suspense";
        case $fb74bc6f62fb4035$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fb74bc6f62fb4035$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fb74bc6f62fb4035$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fb74bc6f62fb4035$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fb74bc6f62fb4035$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fb74bc6f62fb4035$var$Qa(a.type) || "Memo";
        case $fb74bc6f62fb4035$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fb74bc6f62fb4035$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fb74bc6f62fb4035$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fb74bc6f62fb4035$var$Qa(b);
        case 8:
            return b === $fb74bc6f62fb4035$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fb74bc6f62fb4035$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fb74bc6f62fb4035$var$Ua(a) {
    var b = $fb74bc6f62fb4035$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fb74bc6f62fb4035$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fb74bc6f62fb4035$var$Ua(a));
}
function $fb74bc6f62fb4035$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fb74bc6f62fb4035$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fb74bc6f62fb4035$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fb74bc6f62fb4035$var$Ya(a, b) {
    var c = b.checked;
    return $fb74bc6f62fb4035$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fb74bc6f62fb4035$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fb74bc6f62fb4035$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fb74bc6f62fb4035$var$ab(a, b) {
    b = b.checked;
    null != b && $fb74bc6f62fb4035$var$ta(a, "checked", b, !1);
}
function $fb74bc6f62fb4035$var$bb(a, b) {
    $fb74bc6f62fb4035$var$ab(a, b);
    var c = $fb74bc6f62fb4035$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fb74bc6f62fb4035$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fb74bc6f62fb4035$var$cb(a, b.type, $fb74bc6f62fb4035$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fb74bc6f62fb4035$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fb74bc6f62fb4035$var$cb(a, b, c) {
    if ("number" !== b || $fb74bc6f62fb4035$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fb74bc6f62fb4035$var$eb = Array.isArray;
function $fb74bc6f62fb4035$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fb74bc6f62fb4035$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fb74bc6f62fb4035$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fb74bc6f62fb4035$var$p(91));
    return $fb74bc6f62fb4035$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fb74bc6f62fb4035$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fb74bc6f62fb4035$var$p(92));
            if ($fb74bc6f62fb4035$var$eb(c)) {
                if (1 < c.length) throw Error($fb74bc6f62fb4035$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fb74bc6f62fb4035$var$Sa(c)
    };
}
function $fb74bc6f62fb4035$var$ib(a, b) {
    var c = $fb74bc6f62fb4035$var$Sa(b.value), d = $fb74bc6f62fb4035$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fb74bc6f62fb4035$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fb74bc6f62fb4035$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fb74bc6f62fb4035$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fb74bc6f62fb4035$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fb74bc6f62fb4035$var$mb, $fb74bc6f62fb4035$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fb74bc6f62fb4035$var$mb = $fb74bc6f62fb4035$var$mb || document.createElement("div");
        $fb74bc6f62fb4035$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fb74bc6f62fb4035$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fb74bc6f62fb4035$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fb74bc6f62fb4035$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fb74bc6f62fb4035$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fb74bc6f62fb4035$var$pb).forEach(function(a) {
    $fb74bc6f62fb4035$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fb74bc6f62fb4035$var$pb[b] = $fb74bc6f62fb4035$var$pb[a];
    });
});
function $fb74bc6f62fb4035$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fb74bc6f62fb4035$var$pb.hasOwnProperty(a) && $fb74bc6f62fb4035$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fb74bc6f62fb4035$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fb74bc6f62fb4035$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fb74bc6f62fb4035$var$tb = $fb74bc6f62fb4035$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fb74bc6f62fb4035$var$ub(a, b) {
    if (b) {
        if ($fb74bc6f62fb4035$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fb74bc6f62fb4035$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fb74bc6f62fb4035$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fb74bc6f62fb4035$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fb74bc6f62fb4035$var$p(62));
    }
}
function $fb74bc6f62fb4035$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fb74bc6f62fb4035$var$wb = null;
function $fb74bc6f62fb4035$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fb74bc6f62fb4035$var$yb = null, $fb74bc6f62fb4035$var$zb = null, $fb74bc6f62fb4035$var$Ab = null;
function $fb74bc6f62fb4035$var$Bb(a) {
    if (a = $fb74bc6f62fb4035$var$Cb(a)) {
        if ("function" !== typeof $fb74bc6f62fb4035$var$yb) throw Error($fb74bc6f62fb4035$var$p(280));
        var b = a.stateNode;
        b && (b = $fb74bc6f62fb4035$var$Db(b), $fb74bc6f62fb4035$var$yb(a.stateNode, a.type, b));
    }
}
function $fb74bc6f62fb4035$var$Eb(a) {
    $fb74bc6f62fb4035$var$zb ? $fb74bc6f62fb4035$var$Ab ? $fb74bc6f62fb4035$var$Ab.push(a) : $fb74bc6f62fb4035$var$Ab = [
        a
    ] : $fb74bc6f62fb4035$var$zb = a;
}
function $fb74bc6f62fb4035$var$Fb() {
    if ($fb74bc6f62fb4035$var$zb) {
        var a = $fb74bc6f62fb4035$var$zb, b = $fb74bc6f62fb4035$var$Ab;
        $fb74bc6f62fb4035$var$Ab = $fb74bc6f62fb4035$var$zb = null;
        $fb74bc6f62fb4035$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fb74bc6f62fb4035$var$Bb(b[a]);
    }
}
function $fb74bc6f62fb4035$var$Gb(a, b) {
    return a(b);
}
function $fb74bc6f62fb4035$var$Hb() {}
var $fb74bc6f62fb4035$var$Ib = !1;
function $fb74bc6f62fb4035$var$Jb(a, b, c) {
    if ($fb74bc6f62fb4035$var$Ib) return a(b, c);
    $fb74bc6f62fb4035$var$Ib = !0;
    try {
        return $fb74bc6f62fb4035$var$Gb(a, b, c);
    } finally{
        if ($fb74bc6f62fb4035$var$Ib = !1, null !== $fb74bc6f62fb4035$var$zb || null !== $fb74bc6f62fb4035$var$Ab) $fb74bc6f62fb4035$var$Hb(), $fb74bc6f62fb4035$var$Fb();
    }
}
function $fb74bc6f62fb4035$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fb74bc6f62fb4035$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fb74bc6f62fb4035$var$p(231, b, typeof c));
    return c;
}
var $fb74bc6f62fb4035$var$Lb = !1;
if ($fb74bc6f62fb4035$var$ia) try {
    var $fb74bc6f62fb4035$var$Mb = {};
    Object.defineProperty($fb74bc6f62fb4035$var$Mb, "passive", {
        get: function() {
            $fb74bc6f62fb4035$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fb74bc6f62fb4035$var$Mb, $fb74bc6f62fb4035$var$Mb);
    window.removeEventListener("test", $fb74bc6f62fb4035$var$Mb, $fb74bc6f62fb4035$var$Mb);
} catch (a) {
    $fb74bc6f62fb4035$var$Lb = !1;
}
function $fb74bc6f62fb4035$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fb74bc6f62fb4035$var$Ob = !1, $fb74bc6f62fb4035$var$Pb = null, $fb74bc6f62fb4035$var$Qb = !1, $fb74bc6f62fb4035$var$Rb = null, $fb74bc6f62fb4035$var$Sb = {
    onError: function(a) {
        $fb74bc6f62fb4035$var$Ob = !0;
        $fb74bc6f62fb4035$var$Pb = a;
    }
};
function $fb74bc6f62fb4035$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fb74bc6f62fb4035$var$Ob = !1;
    $fb74bc6f62fb4035$var$Pb = null;
    $fb74bc6f62fb4035$var$Nb.apply($fb74bc6f62fb4035$var$Sb, arguments);
}
function $fb74bc6f62fb4035$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fb74bc6f62fb4035$var$Tb.apply(this, arguments);
    if ($fb74bc6f62fb4035$var$Ob) {
        if ($fb74bc6f62fb4035$var$Ob) {
            var l = $fb74bc6f62fb4035$var$Pb;
            $fb74bc6f62fb4035$var$Ob = !1;
            $fb74bc6f62fb4035$var$Pb = null;
        } else throw Error($fb74bc6f62fb4035$var$p(198));
        $fb74bc6f62fb4035$var$Qb || ($fb74bc6f62fb4035$var$Qb = !0, $fb74bc6f62fb4035$var$Rb = l);
    }
}
function $fb74bc6f62fb4035$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fb74bc6f62fb4035$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Xb(a) {
    if ($fb74bc6f62fb4035$var$Vb(a) !== a) throw Error($fb74bc6f62fb4035$var$p(188));
}
function $fb74bc6f62fb4035$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fb74bc6f62fb4035$var$Vb(a);
        if (null === b) throw Error($fb74bc6f62fb4035$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fb74bc6f62fb4035$var$Xb(e), a;
                if (f === d) return $fb74bc6f62fb4035$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fb74bc6f62fb4035$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fb74bc6f62fb4035$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fb74bc6f62fb4035$var$p(190));
    }
    if (3 !== c.tag) throw Error($fb74bc6f62fb4035$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fb74bc6f62fb4035$var$Zb(a) {
    a = $fb74bc6f62fb4035$var$Yb(a);
    return null !== a ? $fb74bc6f62fb4035$var$$b(a) : null;
}
function $fb74bc6f62fb4035$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fb74bc6f62fb4035$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$ac = $lIEVH.unstable_scheduleCallback, $fb74bc6f62fb4035$var$bc = $lIEVH.unstable_cancelCallback, $fb74bc6f62fb4035$var$cc = $lIEVH.unstable_shouldYield, $fb74bc6f62fb4035$var$dc = $lIEVH.unstable_requestPaint, $fb74bc6f62fb4035$var$B = $lIEVH.unstable_now, $fb74bc6f62fb4035$var$ec = $lIEVH.unstable_getCurrentPriorityLevel, $fb74bc6f62fb4035$var$fc = $lIEVH.unstable_ImmediatePriority, $fb74bc6f62fb4035$var$gc = $lIEVH.unstable_UserBlockingPriority, $fb74bc6f62fb4035$var$hc = $lIEVH.unstable_NormalPriority, $fb74bc6f62fb4035$var$ic = $lIEVH.unstable_LowPriority, $fb74bc6f62fb4035$var$jc = $lIEVH.unstable_IdlePriority, $fb74bc6f62fb4035$var$kc = null, $fb74bc6f62fb4035$var$lc = null;
function $fb74bc6f62fb4035$var$mc(a) {
    if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onCommitFiberRoot) try {
        $fb74bc6f62fb4035$var$lc.onCommitFiberRoot($fb74bc6f62fb4035$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fb74bc6f62fb4035$var$oc = Math.clz32 ? Math.clz32 : $fb74bc6f62fb4035$var$nc, $fb74bc6f62fb4035$var$pc = Math.log, $fb74bc6f62fb4035$var$qc = Math.LN2;
function $fb74bc6f62fb4035$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fb74bc6f62fb4035$var$pc(a) / $fb74bc6f62fb4035$var$qc | 0) | 0;
}
var $fb74bc6f62fb4035$var$rc = 64, $fb74bc6f62fb4035$var$sc = 4194304;
function $fb74bc6f62fb4035$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fb74bc6f62fb4035$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fb74bc6f62fb4035$var$tc(h) : (f &= g, 0 !== f && (d = $fb74bc6f62fb4035$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fb74bc6f62fb4035$var$tc(g) : 0 !== f && (d = $fb74bc6f62fb4035$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fb74bc6f62fb4035$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fb74bc6f62fb4035$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fb74bc6f62fb4035$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fb74bc6f62fb4035$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fb74bc6f62fb4035$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fb74bc6f62fb4035$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fb74bc6f62fb4035$var$yc() {
    var a = $fb74bc6f62fb4035$var$rc;
    $fb74bc6f62fb4035$var$rc <<= 1;
    0 === ($fb74bc6f62fb4035$var$rc & 4194240) && ($fb74bc6f62fb4035$var$rc = 64);
    return a;
}
function $fb74bc6f62fb4035$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fb74bc6f62fb4035$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fb74bc6f62fb4035$var$oc(b);
    a[b] = c;
}
function $fb74bc6f62fb4035$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fb74bc6f62fb4035$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fb74bc6f62fb4035$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fb74bc6f62fb4035$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fb74bc6f62fb4035$var$C = 0;
function $fb74bc6f62fb4035$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fb74bc6f62fb4035$var$Ec, $fb74bc6f62fb4035$var$Fc, $fb74bc6f62fb4035$var$Gc, $fb74bc6f62fb4035$var$Hc, $fb74bc6f62fb4035$var$Ic, $fb74bc6f62fb4035$var$Jc = !1, $fb74bc6f62fb4035$var$Kc = [], $fb74bc6f62fb4035$var$Lc = null, $fb74bc6f62fb4035$var$Mc = null, $fb74bc6f62fb4035$var$Nc = null, $fb74bc6f62fb4035$var$Oc = new Map, $fb74bc6f62fb4035$var$Pc = new Map, $fb74bc6f62fb4035$var$Qc = [], $fb74bc6f62fb4035$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fb74bc6f62fb4035$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fb74bc6f62fb4035$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fb74bc6f62fb4035$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fb74bc6f62fb4035$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fb74bc6f62fb4035$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fb74bc6f62fb4035$var$Pc.delete(b.pointerId);
    }
}
function $fb74bc6f62fb4035$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fb74bc6f62fb4035$var$Cb(b), null !== b && $fb74bc6f62fb4035$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fb74bc6f62fb4035$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fb74bc6f62fb4035$var$Lc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fb74bc6f62fb4035$var$Mc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fb74bc6f62fb4035$var$Nc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fb74bc6f62fb4035$var$Oc.set(f, $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fb74bc6f62fb4035$var$Pc.set(f, $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fb74bc6f62fb4035$var$Vc(a) {
    var b = $fb74bc6f62fb4035$var$Wc(a.target);
    if (null !== b) {
        var c = $fb74bc6f62fb4035$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fb74bc6f62fb4035$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fb74bc6f62fb4035$var$Ic(a.priority, function() {
                        $fb74bc6f62fb4035$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fb74bc6f62fb4035$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fb74bc6f62fb4035$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fb74bc6f62fb4035$var$wb = d;
            c.target.dispatchEvent(d);
            $fb74bc6f62fb4035$var$wb = null;
        } else return b = $fb74bc6f62fb4035$var$Cb(c), null !== b && $fb74bc6f62fb4035$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Zc(a, b, c) {
    $fb74bc6f62fb4035$var$Xc(a) && c.delete(b);
}
function $fb74bc6f62fb4035$var$$c() {
    $fb74bc6f62fb4035$var$Jc = !1;
    null !== $fb74bc6f62fb4035$var$Lc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Lc) && ($fb74bc6f62fb4035$var$Lc = null);
    null !== $fb74bc6f62fb4035$var$Mc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Mc) && ($fb74bc6f62fb4035$var$Mc = null);
    null !== $fb74bc6f62fb4035$var$Nc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Nc) && ($fb74bc6f62fb4035$var$Nc = null);
    $fb74bc6f62fb4035$var$Oc.forEach($fb74bc6f62fb4035$var$Zc);
    $fb74bc6f62fb4035$var$Pc.forEach($fb74bc6f62fb4035$var$Zc);
}
function $fb74bc6f62fb4035$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fb74bc6f62fb4035$var$Jc || ($fb74bc6f62fb4035$var$Jc = !0, $lIEVH.unstable_scheduleCallback($lIEVH.unstable_NormalPriority, $fb74bc6f62fb4035$var$$c)));
}
function $fb74bc6f62fb4035$var$bd(a) {
    function b(b) {
        return $fb74bc6f62fb4035$var$ad(b, a);
    }
    if (0 < $fb74bc6f62fb4035$var$Kc.length) {
        $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Kc[0], a);
        for(var c = 1; c < $fb74bc6f62fb4035$var$Kc.length; c++){
            var d = $fb74bc6f62fb4035$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fb74bc6f62fb4035$var$Lc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Lc, a);
    null !== $fb74bc6f62fb4035$var$Mc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Mc, a);
    null !== $fb74bc6f62fb4035$var$Nc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Nc, a);
    $fb74bc6f62fb4035$var$Oc.forEach(b);
    $fb74bc6f62fb4035$var$Pc.forEach(b);
    for(c = 0; c < $fb74bc6f62fb4035$var$Qc.length; c++)d = $fb74bc6f62fb4035$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fb74bc6f62fb4035$var$Qc.length && (c = $fb74bc6f62fb4035$var$Qc[0], null === c.blockedOn);)$fb74bc6f62fb4035$var$Vc(c), null === c.blockedOn && $fb74bc6f62fb4035$var$Qc.shift();
}
var $fb74bc6f62fb4035$var$cd = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$dd = !0;
function $fb74bc6f62fb4035$var$ed(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$C, f = $fb74bc6f62fb4035$var$cd.transition;
    $fb74bc6f62fb4035$var$cd.transition = null;
    try {
        $fb74bc6f62fb4035$var$C = 1, $fb74bc6f62fb4035$var$fd(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$C = e, $fb74bc6f62fb4035$var$cd.transition = f;
    }
}
function $fb74bc6f62fb4035$var$gd(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$C, f = $fb74bc6f62fb4035$var$cd.transition;
    $fb74bc6f62fb4035$var$cd.transition = null;
    try {
        $fb74bc6f62fb4035$var$C = 4, $fb74bc6f62fb4035$var$fd(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$C = e, $fb74bc6f62fb4035$var$cd.transition = f;
    }
}
function $fb74bc6f62fb4035$var$fd(a, b, c, d) {
    if ($fb74bc6f62fb4035$var$dd) {
        var e = $fb74bc6f62fb4035$var$Yc(a, b, c, d);
        if (null === e) $fb74bc6f62fb4035$var$hd(a, b, d, $fb74bc6f62fb4035$var$id, c), $fb74bc6f62fb4035$var$Sc(a, d);
        else if ($fb74bc6f62fb4035$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fb74bc6f62fb4035$var$Sc(a, d), b & 4 && -1 < $fb74bc6f62fb4035$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fb74bc6f62fb4035$var$Cb(e);
                null !== f && $fb74bc6f62fb4035$var$Ec(f);
                f = $fb74bc6f62fb4035$var$Yc(a, b, c, d);
                null === f && $fb74bc6f62fb4035$var$hd(a, b, d, $fb74bc6f62fb4035$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fb74bc6f62fb4035$var$hd(a, b, d, null, c);
    }
}
var $fb74bc6f62fb4035$var$id = null;
function $fb74bc6f62fb4035$var$Yc(a, b, c, d) {
    $fb74bc6f62fb4035$var$id = null;
    a = $fb74bc6f62fb4035$var$xb(d);
    a = $fb74bc6f62fb4035$var$Wc(a);
    if (null !== a) {
        if (b = $fb74bc6f62fb4035$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fb74bc6f62fb4035$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fb74bc6f62fb4035$var$id = a;
    return null;
}
function $fb74bc6f62fb4035$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fb74bc6f62fb4035$var$ec()){
                case $fb74bc6f62fb4035$var$fc:
                    return 1;
                case $fb74bc6f62fb4035$var$gc:
                    return 4;
                case $fb74bc6f62fb4035$var$hc:
                case $fb74bc6f62fb4035$var$ic:
                    return 16;
                case $fb74bc6f62fb4035$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fb74bc6f62fb4035$var$kd = null, $fb74bc6f62fb4035$var$ld = null, $fb74bc6f62fb4035$var$md = null;
function $fb74bc6f62fb4035$var$nd() {
    if ($fb74bc6f62fb4035$var$md) return $fb74bc6f62fb4035$var$md;
    var a, b = $fb74bc6f62fb4035$var$ld, c = b.length, d, e = "value" in $fb74bc6f62fb4035$var$kd ? $fb74bc6f62fb4035$var$kd.value : $fb74bc6f62fb4035$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fb74bc6f62fb4035$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fb74bc6f62fb4035$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fb74bc6f62fb4035$var$pd() {
    return !0;
}
function $fb74bc6f62fb4035$var$qd() {
    return !1;
}
function $fb74bc6f62fb4035$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fb74bc6f62fb4035$var$pd : $fb74bc6f62fb4035$var$qd;
        this.isPropagationStopped = $fb74bc6f62fb4035$var$qd;
        return this;
    }
    $fb74bc6f62fb4035$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fb74bc6f62fb4035$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fb74bc6f62fb4035$var$pd);
        },
        persist: function() {},
        isPersistent: $fb74bc6f62fb4035$var$pd
    });
    return b;
}
var $fb74bc6f62fb4035$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fb74bc6f62fb4035$var$td = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$sd), $fb74bc6f62fb4035$var$ud = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    view: 0,
    detail: 0
}), $fb74bc6f62fb4035$var$vd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$ud), $fb74bc6f62fb4035$var$wd, $fb74bc6f62fb4035$var$xd, $fb74bc6f62fb4035$var$yd, $fb74bc6f62fb4035$var$Ad = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fb74bc6f62fb4035$var$yd && ($fb74bc6f62fb4035$var$yd && "mousemove" === a.type ? ($fb74bc6f62fb4035$var$wd = a.screenX - $fb74bc6f62fb4035$var$yd.screenX, $fb74bc6f62fb4035$var$xd = a.screenY - $fb74bc6f62fb4035$var$yd.screenY) : $fb74bc6f62fb4035$var$xd = $fb74bc6f62fb4035$var$wd = 0, $fb74bc6f62fb4035$var$yd = a);
        return $fb74bc6f62fb4035$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fb74bc6f62fb4035$var$xd;
    }
}), $fb74bc6f62fb4035$var$Bd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ad), $fb74bc6f62fb4035$var$Cd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    dataTransfer: 0
}), $fb74bc6f62fb4035$var$Dd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Cd), $fb74bc6f62fb4035$var$Ed = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    relatedTarget: 0
}), $fb74bc6f62fb4035$var$Fd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ed), $fb74bc6f62fb4035$var$Gd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb74bc6f62fb4035$var$Hd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Gd), $fb74bc6f62fb4035$var$Id = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fb74bc6f62fb4035$var$Jd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Id), $fb74bc6f62fb4035$var$Kd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    data: 0
}), $fb74bc6f62fb4035$var$Ld = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Kd), $fb74bc6f62fb4035$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fb74bc6f62fb4035$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fb74bc6f62fb4035$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fb74bc6f62fb4035$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fb74bc6f62fb4035$var$Od[a]) ? !!b[a] : !1;
}
function $fb74bc6f62fb4035$var$zd() {
    return $fb74bc6f62fb4035$var$Pd;
}
var $fb74bc6f62fb4035$var$Qd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fb74bc6f62fb4035$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fb74bc6f62fb4035$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fb74bc6f62fb4035$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fb74bc6f62fb4035$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fb74bc6f62fb4035$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fb74bc6f62fb4035$var$Rd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Qd), $fb74bc6f62fb4035$var$Sd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fb74bc6f62fb4035$var$Td = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Sd), $fb74bc6f62fb4035$var$Ud = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd
}), $fb74bc6f62fb4035$var$Vd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ud), $fb74bc6f62fb4035$var$Wd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb74bc6f62fb4035$var$Xd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Wd), $fb74bc6f62fb4035$var$Yd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fb74bc6f62fb4035$var$Zd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Yd), $fb74bc6f62fb4035$var$$d = [
    9,
    13,
    27,
    32
], $fb74bc6f62fb4035$var$ae = $fb74bc6f62fb4035$var$ia && "CompositionEvent" in window, $fb74bc6f62fb4035$var$be = null;
$fb74bc6f62fb4035$var$ia && "documentMode" in document && ($fb74bc6f62fb4035$var$be = document.documentMode);
var $fb74bc6f62fb4035$var$ce = $fb74bc6f62fb4035$var$ia && "TextEvent" in window && !$fb74bc6f62fb4035$var$be, $fb74bc6f62fb4035$var$de = $fb74bc6f62fb4035$var$ia && (!$fb74bc6f62fb4035$var$ae || $fb74bc6f62fb4035$var$be && 8 < $fb74bc6f62fb4035$var$be && 11 >= $fb74bc6f62fb4035$var$be), $fb74bc6f62fb4035$var$ee = String.fromCharCode(32), $fb74bc6f62fb4035$var$fe = !1;
function $fb74bc6f62fb4035$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fb74bc6f62fb4035$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fb74bc6f62fb4035$var$ie = !1;
function $fb74bc6f62fb4035$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fb74bc6f62fb4035$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fb74bc6f62fb4035$var$fe = !0;
            return $fb74bc6f62fb4035$var$ee;
        case "textInput":
            return a = b.data, a === $fb74bc6f62fb4035$var$ee && $fb74bc6f62fb4035$var$fe ? null : a;
        default:
            return null;
    }
}
function $fb74bc6f62fb4035$var$ke(a, b) {
    if ($fb74bc6f62fb4035$var$ie) return "compositionend" === a || !$fb74bc6f62fb4035$var$ae && $fb74bc6f62fb4035$var$ge(a, b) ? (a = $fb74bc6f62fb4035$var$nd(), $fb74bc6f62fb4035$var$md = $fb74bc6f62fb4035$var$ld = $fb74bc6f62fb4035$var$kd = null, $fb74bc6f62fb4035$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fb74bc6f62fb4035$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fb74bc6f62fb4035$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fb74bc6f62fb4035$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fb74bc6f62fb4035$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fb74bc6f62fb4035$var$ne(a, b, c, d) {
    $fb74bc6f62fb4035$var$Eb(d);
    b = $fb74bc6f62fb4035$var$oe(b, "onChange");
    0 < b.length && (c = new $fb74bc6f62fb4035$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fb74bc6f62fb4035$var$pe = null, $fb74bc6f62fb4035$var$qe = null;
function $fb74bc6f62fb4035$var$re(a) {
    $fb74bc6f62fb4035$var$se(a, 0);
}
function $fb74bc6f62fb4035$var$te(a) {
    var b = $fb74bc6f62fb4035$var$ue(a);
    if ($fb74bc6f62fb4035$var$Wa(b)) return a;
}
function $fb74bc6f62fb4035$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fb74bc6f62fb4035$var$we = !1;
if ($fb74bc6f62fb4035$var$ia) {
    var $fb74bc6f62fb4035$var$xe;
    if ($fb74bc6f62fb4035$var$ia) {
        var $fb74bc6f62fb4035$var$ye = "oninput" in document;
        if (!$fb74bc6f62fb4035$var$ye) {
            var $fb74bc6f62fb4035$var$ze = document.createElement("div");
            $fb74bc6f62fb4035$var$ze.setAttribute("oninput", "return;");
            $fb74bc6f62fb4035$var$ye = "function" === typeof $fb74bc6f62fb4035$var$ze.oninput;
        }
        $fb74bc6f62fb4035$var$xe = $fb74bc6f62fb4035$var$ye;
    } else $fb74bc6f62fb4035$var$xe = !1;
    $fb74bc6f62fb4035$var$we = $fb74bc6f62fb4035$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fb74bc6f62fb4035$var$Ae() {
    $fb74bc6f62fb4035$var$pe && ($fb74bc6f62fb4035$var$pe.detachEvent("onpropertychange", $fb74bc6f62fb4035$var$Be), $fb74bc6f62fb4035$var$qe = $fb74bc6f62fb4035$var$pe = null);
}
function $fb74bc6f62fb4035$var$Be(a) {
    if ("value" === a.propertyName && $fb74bc6f62fb4035$var$te($fb74bc6f62fb4035$var$qe)) {
        var b = [];
        $fb74bc6f62fb4035$var$ne(b, $fb74bc6f62fb4035$var$qe, a, $fb74bc6f62fb4035$var$xb(a));
        $fb74bc6f62fb4035$var$Jb($fb74bc6f62fb4035$var$re, b);
    }
}
function $fb74bc6f62fb4035$var$Ce(a, b, c) {
    "focusin" === a ? ($fb74bc6f62fb4035$var$Ae(), $fb74bc6f62fb4035$var$pe = b, $fb74bc6f62fb4035$var$qe = c, $fb74bc6f62fb4035$var$pe.attachEvent("onpropertychange", $fb74bc6f62fb4035$var$Be)) : "focusout" === a && $fb74bc6f62fb4035$var$Ae();
}
function $fb74bc6f62fb4035$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fb74bc6f62fb4035$var$te($fb74bc6f62fb4035$var$qe);
}
function $fb74bc6f62fb4035$var$Ee(a, b) {
    if ("click" === a) return $fb74bc6f62fb4035$var$te(b);
}
function $fb74bc6f62fb4035$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fb74bc6f62fb4035$var$te(b);
}
function $fb74bc6f62fb4035$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fb74bc6f62fb4035$var$He = "function" === typeof Object.is ? Object.is : $fb74bc6f62fb4035$var$Ge;
function $fb74bc6f62fb4035$var$Ie(a, b) {
    if ($fb74bc6f62fb4035$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fb74bc6f62fb4035$var$ja.call(b, e) || !$fb74bc6f62fb4035$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fb74bc6f62fb4035$var$Ke(a, b) {
    var c = $fb74bc6f62fb4035$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fb74bc6f62fb4035$var$Je(c);
    }
}
function $fb74bc6f62fb4035$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fb74bc6f62fb4035$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fb74bc6f62fb4035$var$Me() {
    for(var a = window, b = $fb74bc6f62fb4035$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fb74bc6f62fb4035$var$Xa(a.document);
    }
    return b;
}
function $fb74bc6f62fb4035$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fb74bc6f62fb4035$var$Oe(a) {
    var b = $fb74bc6f62fb4035$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fb74bc6f62fb4035$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fb74bc6f62fb4035$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fb74bc6f62fb4035$var$Ke(c, f);
                var g = $fb74bc6f62fb4035$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fb74bc6f62fb4035$var$Pe = $fb74bc6f62fb4035$var$ia && "documentMode" in document && 11 >= document.documentMode, $fb74bc6f62fb4035$var$Qe = null, $fb74bc6f62fb4035$var$Re = null, $fb74bc6f62fb4035$var$Se = null, $fb74bc6f62fb4035$var$Te = !1;
function $fb74bc6f62fb4035$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fb74bc6f62fb4035$var$Te || null == $fb74bc6f62fb4035$var$Qe || $fb74bc6f62fb4035$var$Qe !== $fb74bc6f62fb4035$var$Xa(d) || (d = $fb74bc6f62fb4035$var$Qe, "selectionStart" in d && $fb74bc6f62fb4035$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fb74bc6f62fb4035$var$Se && $fb74bc6f62fb4035$var$Ie($fb74bc6f62fb4035$var$Se, d) || ($fb74bc6f62fb4035$var$Se = d, d = $fb74bc6f62fb4035$var$oe($fb74bc6f62fb4035$var$Re, "onSelect"), 0 < d.length && (b = new $fb74bc6f62fb4035$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fb74bc6f62fb4035$var$Qe)));
}
function $fb74bc6f62fb4035$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fb74bc6f62fb4035$var$We = {
    animationend: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationStart"),
    transitionend: $fb74bc6f62fb4035$var$Ve("Transition", "TransitionEnd")
}, $fb74bc6f62fb4035$var$Xe = {}, $fb74bc6f62fb4035$var$Ye = {};
$fb74bc6f62fb4035$var$ia && ($fb74bc6f62fb4035$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fb74bc6f62fb4035$var$We.animationend.animation, delete $fb74bc6f62fb4035$var$We.animationiteration.animation, delete $fb74bc6f62fb4035$var$We.animationstart.animation), "TransitionEvent" in window || delete $fb74bc6f62fb4035$var$We.transitionend.transition);
function $fb74bc6f62fb4035$var$Ze(a) {
    if ($fb74bc6f62fb4035$var$Xe[a]) return $fb74bc6f62fb4035$var$Xe[a];
    if (!$fb74bc6f62fb4035$var$We[a]) return a;
    var b = $fb74bc6f62fb4035$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fb74bc6f62fb4035$var$Ye) return $fb74bc6f62fb4035$var$Xe[a] = b[c];
    return a;
}
var $fb74bc6f62fb4035$var$$e = $fb74bc6f62fb4035$var$Ze("animationend"), $fb74bc6f62fb4035$var$af = $fb74bc6f62fb4035$var$Ze("animationiteration"), $fb74bc6f62fb4035$var$bf = $fb74bc6f62fb4035$var$Ze("animationstart"), $fb74bc6f62fb4035$var$cf = $fb74bc6f62fb4035$var$Ze("transitionend"), $fb74bc6f62fb4035$var$df = new Map, $fb74bc6f62fb4035$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fb74bc6f62fb4035$var$ff(a, b) {
    $fb74bc6f62fb4035$var$df.set(a, b);
    $fb74bc6f62fb4035$var$fa(b, [
        a
    ]);
}
for(var $fb74bc6f62fb4035$var$gf = 0; $fb74bc6f62fb4035$var$gf < $fb74bc6f62fb4035$var$ef.length; $fb74bc6f62fb4035$var$gf++){
    var $fb74bc6f62fb4035$var$hf = $fb74bc6f62fb4035$var$ef[$fb74bc6f62fb4035$var$gf], $fb74bc6f62fb4035$var$jf = $fb74bc6f62fb4035$var$hf.toLowerCase(), $fb74bc6f62fb4035$var$kf = $fb74bc6f62fb4035$var$hf[0].toUpperCase() + $fb74bc6f62fb4035$var$hf.slice(1);
    $fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$jf, "on" + $fb74bc6f62fb4035$var$kf);
}
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$$e, "onAnimationEnd");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$af, "onAnimationIteration");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$bf, "onAnimationStart");
$fb74bc6f62fb4035$var$ff("dblclick", "onDoubleClick");
$fb74bc6f62fb4035$var$ff("focusin", "onFocus");
$fb74bc6f62fb4035$var$ff("focusout", "onBlur");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$cf, "onTransitionEnd");
$fb74bc6f62fb4035$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fb74bc6f62fb4035$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fb74bc6f62fb4035$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fb74bc6f62fb4035$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fb74bc6f62fb4035$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fb74bc6f62fb4035$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fb74bc6f62fb4035$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fb74bc6f62fb4035$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fb74bc6f62fb4035$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fb74bc6f62fb4035$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fb74bc6f62fb4035$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fb74bc6f62fb4035$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fb74bc6f62fb4035$var$lf));
function $fb74bc6f62fb4035$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fb74bc6f62fb4035$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fb74bc6f62fb4035$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fb74bc6f62fb4035$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fb74bc6f62fb4035$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fb74bc6f62fb4035$var$Qb) throw a = $fb74bc6f62fb4035$var$Rb, $fb74bc6f62fb4035$var$Qb = !1, $fb74bc6f62fb4035$var$Rb = null, a;
}
function $fb74bc6f62fb4035$var$D(a, b) {
    var c = b[$fb74bc6f62fb4035$var$of];
    void 0 === c && (c = b[$fb74bc6f62fb4035$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fb74bc6f62fb4035$var$pf(b, a, 2, !1), c.add(d));
}
function $fb74bc6f62fb4035$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fb74bc6f62fb4035$var$pf(c, a, d, b);
}
var $fb74bc6f62fb4035$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fb74bc6f62fb4035$var$sf(a) {
    if (!a[$fb74bc6f62fb4035$var$rf]) {
        a[$fb74bc6f62fb4035$var$rf] = !0;
        $fb74bc6f62fb4035$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fb74bc6f62fb4035$var$mf.has(b) || $fb74bc6f62fb4035$var$qf(b, !1, a), $fb74bc6f62fb4035$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fb74bc6f62fb4035$var$rf] || (b[$fb74bc6f62fb4035$var$rf] = !0, $fb74bc6f62fb4035$var$qf("selectionchange", !1, b));
    }
}
function $fb74bc6f62fb4035$var$pf(a, b, c, d) {
    switch($fb74bc6f62fb4035$var$jd(b)){
        case 1:
            var e = $fb74bc6f62fb4035$var$ed;
            break;
        case 4:
            e = $fb74bc6f62fb4035$var$gd;
            break;
        default:
            e = $fb74bc6f62fb4035$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fb74bc6f62fb4035$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fb74bc6f62fb4035$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fb74bc6f62fb4035$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fb74bc6f62fb4035$var$Jb(function() {
        var d = f, e = $fb74bc6f62fb4035$var$xb(c), g = [];
        a: {
            var h = $fb74bc6f62fb4035$var$df.get(a);
            if (void 0 !== h) {
                var k = $fb74bc6f62fb4035$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fb74bc6f62fb4035$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fb74bc6f62fb4035$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fb74bc6f62fb4035$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fb74bc6f62fb4035$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fb74bc6f62fb4035$var$Vd;
                        break;
                    case $fb74bc6f62fb4035$var$$e:
                    case $fb74bc6f62fb4035$var$af:
                    case $fb74bc6f62fb4035$var$bf:
                        k = $fb74bc6f62fb4035$var$Hd;
                        break;
                    case $fb74bc6f62fb4035$var$cf:
                        k = $fb74bc6f62fb4035$var$Xd;
                        break;
                    case "scroll":
                        k = $fb74bc6f62fb4035$var$vd;
                        break;
                    case "wheel":
                        k = $fb74bc6f62fb4035$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fb74bc6f62fb4035$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fb74bc6f62fb4035$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fb74bc6f62fb4035$var$Kb(w, x), null != F && t.push($fb74bc6f62fb4035$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fb74bc6f62fb4035$var$wb && (n = c.relatedTarget || c.fromElement) && ($fb74bc6f62fb4035$var$Wc(n) || n[$fb74bc6f62fb4035$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fb74bc6f62fb4035$var$Wc(n) : null, null !== n && (J = $fb74bc6f62fb4035$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fb74bc6f62fb4035$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fb74bc6f62fb4035$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fb74bc6f62fb4035$var$ue(k);
                        u = null == n ? h : $fb74bc6f62fb4035$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fb74bc6f62fb4035$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fb74bc6f62fb4035$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fb74bc6f62fb4035$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fb74bc6f62fb4035$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fb74bc6f62fb4035$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fb74bc6f62fb4035$var$vf(t);
                                x = $fb74bc6f62fb4035$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fb74bc6f62fb4035$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fb74bc6f62fb4035$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fb74bc6f62fb4035$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fb74bc6f62fb4035$var$ve;
                else if ($fb74bc6f62fb4035$var$me(h)) {
                    if ($fb74bc6f62fb4035$var$we) na = $fb74bc6f62fb4035$var$Fe;
                    else {
                        na = $fb74bc6f62fb4035$var$De;
                        var xa = $fb74bc6f62fb4035$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fb74bc6f62fb4035$var$Ee);
                if (na && (na = na(a, d))) {
                    $fb74bc6f62fb4035$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fb74bc6f62fb4035$var$cb(h, "number", h.value);
            }
            xa = d ? $fb74bc6f62fb4035$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fb74bc6f62fb4035$var$me(xa) || "true" === xa.contentEditable) $fb74bc6f62fb4035$var$Qe = xa, $fb74bc6f62fb4035$var$Re = d, $fb74bc6f62fb4035$var$Se = null;
                    break;
                case "focusout":
                    $fb74bc6f62fb4035$var$Se = $fb74bc6f62fb4035$var$Re = $fb74bc6f62fb4035$var$Qe = null;
                    break;
                case "mousedown":
                    $fb74bc6f62fb4035$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fb74bc6f62fb4035$var$Te = !1;
                    $fb74bc6f62fb4035$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fb74bc6f62fb4035$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fb74bc6f62fb4035$var$Ue(g, c, e);
            }
            var $a;
            if ($fb74bc6f62fb4035$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fb74bc6f62fb4035$var$ie ? $fb74bc6f62fb4035$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fb74bc6f62fb4035$var$de && "ko" !== c.locale && ($fb74bc6f62fb4035$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fb74bc6f62fb4035$var$ie && ($a = $fb74bc6f62fb4035$var$nd()) : ($fb74bc6f62fb4035$var$kd = e, $fb74bc6f62fb4035$var$ld = "value" in $fb74bc6f62fb4035$var$kd ? $fb74bc6f62fb4035$var$kd.value : $fb74bc6f62fb4035$var$kd.textContent, $fb74bc6f62fb4035$var$ie = !0)), xa = $fb74bc6f62fb4035$var$oe(d, ba), 0 < xa.length && (ba = new $fb74bc6f62fb4035$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fb74bc6f62fb4035$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fb74bc6f62fb4035$var$ce ? $fb74bc6f62fb4035$var$je(a, c) : $fb74bc6f62fb4035$var$ke(a, c)) d = $fb74bc6f62fb4035$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fb74bc6f62fb4035$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fb74bc6f62fb4035$var$se(g, b);
    });
}
function $fb74bc6f62fb4035$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fb74bc6f62fb4035$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fb74bc6f62fb4035$var$Kb(a, c), null != f && d.unshift($fb74bc6f62fb4035$var$tf(a, f, e)), f = $fb74bc6f62fb4035$var$Kb(a, b), null != f && d.push($fb74bc6f62fb4035$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fb74bc6f62fb4035$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fb74bc6f62fb4035$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fb74bc6f62fb4035$var$Kb(c, f), null != k && g.unshift($fb74bc6f62fb4035$var$tf(c, k, h))) : e || (k = $fb74bc6f62fb4035$var$Kb(c, f), null != k && g.push($fb74bc6f62fb4035$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fb74bc6f62fb4035$var$xf = /\r\n?/g, $fb74bc6f62fb4035$var$yf = /\u0000|\uFFFD/g;
function $fb74bc6f62fb4035$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fb74bc6f62fb4035$var$xf, "\n").replace($fb74bc6f62fb4035$var$yf, "");
}
function $fb74bc6f62fb4035$var$Af(a, b, c) {
    b = $fb74bc6f62fb4035$var$zf(b);
    if ($fb74bc6f62fb4035$var$zf(a) !== b && c) throw Error($fb74bc6f62fb4035$var$p(425));
}
function $fb74bc6f62fb4035$var$Bf() {}
var $fb74bc6f62fb4035$var$Cf = null, $fb74bc6f62fb4035$var$Df = null;
function $fb74bc6f62fb4035$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fb74bc6f62fb4035$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fb74bc6f62fb4035$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fb74bc6f62fb4035$var$Hf = "function" === typeof Promise ? Promise : void 0, $fb74bc6f62fb4035$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fb74bc6f62fb4035$var$Hf ? function(a) {
    return $fb74bc6f62fb4035$var$Hf.resolve(null).then(a).catch($fb74bc6f62fb4035$var$If);
} : $fb74bc6f62fb4035$var$Ff;
function $fb74bc6f62fb4035$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fb74bc6f62fb4035$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fb74bc6f62fb4035$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fb74bc6f62fb4035$var$bd(b);
}
function $fb74bc6f62fb4035$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$Nf = Math.random().toString(36).slice(2), $fb74bc6f62fb4035$var$Of = "__reactFiber$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Pf = "__reactProps$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$uf = "__reactContainer$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$of = "__reactEvents$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Qf = "__reactListeners$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Rf = "__reactHandles$" + $fb74bc6f62fb4035$var$Nf;
function $fb74bc6f62fb4035$var$Wc(a) {
    var b = a[$fb74bc6f62fb4035$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fb74bc6f62fb4035$var$uf] || c[$fb74bc6f62fb4035$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fb74bc6f62fb4035$var$Mf(a); null !== a;){
                if (c = a[$fb74bc6f62fb4035$var$Of]) return c;
                a = $fb74bc6f62fb4035$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Cb(a) {
    a = a[$fb74bc6f62fb4035$var$Of] || a[$fb74bc6f62fb4035$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fb74bc6f62fb4035$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fb74bc6f62fb4035$var$p(33));
}
function $fb74bc6f62fb4035$var$Db(a) {
    return a[$fb74bc6f62fb4035$var$Pf] || null;
}
var $fb74bc6f62fb4035$var$Sf = [], $fb74bc6f62fb4035$var$Tf = -1;
function $fb74bc6f62fb4035$var$Uf(a) {
    return {
        current: a
    };
}
function $fb74bc6f62fb4035$var$E(a) {
    0 > $fb74bc6f62fb4035$var$Tf || (a.current = $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf], $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf] = null, $fb74bc6f62fb4035$var$Tf--);
}
function $fb74bc6f62fb4035$var$G(a, b) {
    $fb74bc6f62fb4035$var$Tf++;
    $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf] = a.current;
    a.current = b;
}
var $fb74bc6f62fb4035$var$Vf = {}, $fb74bc6f62fb4035$var$H = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$Vf), $fb74bc6f62fb4035$var$Wf = $fb74bc6f62fb4035$var$Uf(!1), $fb74bc6f62fb4035$var$Xf = $fb74bc6f62fb4035$var$Vf;
function $fb74bc6f62fb4035$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fb74bc6f62fb4035$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fb74bc6f62fb4035$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fb74bc6f62fb4035$var$$f() {
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
}
function $fb74bc6f62fb4035$var$ag(a, b, c) {
    if ($fb74bc6f62fb4035$var$H.current !== $fb74bc6f62fb4035$var$Vf) throw Error($fb74bc6f62fb4035$var$p(168));
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, b);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, c);
}
function $fb74bc6f62fb4035$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fb74bc6f62fb4035$var$p(108, $fb74bc6f62fb4035$var$Ra(a) || "Unknown", e));
    return $fb74bc6f62fb4035$var$A({}, c, d);
}
function $fb74bc6f62fb4035$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fb74bc6f62fb4035$var$Vf;
    $fb74bc6f62fb4035$var$Xf = $fb74bc6f62fb4035$var$H.current;
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, a);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, $fb74bc6f62fb4035$var$Wf.current);
    return !0;
}
function $fb74bc6f62fb4035$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fb74bc6f62fb4035$var$p(169));
    c ? (a = $fb74bc6f62fb4035$var$bg(a, b, $fb74bc6f62fb4035$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H), $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, a)) : $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, c);
}
var $fb74bc6f62fb4035$var$eg = null, $fb74bc6f62fb4035$var$fg = !1, $fb74bc6f62fb4035$var$gg = !1;
function $fb74bc6f62fb4035$var$hg(a) {
    null === $fb74bc6f62fb4035$var$eg ? $fb74bc6f62fb4035$var$eg = [
        a
    ] : $fb74bc6f62fb4035$var$eg.push(a);
}
function $fb74bc6f62fb4035$var$ig(a) {
    $fb74bc6f62fb4035$var$fg = !0;
    $fb74bc6f62fb4035$var$hg(a);
}
function $fb74bc6f62fb4035$var$jg() {
    if (!$fb74bc6f62fb4035$var$gg && null !== $fb74bc6f62fb4035$var$eg) {
        $fb74bc6f62fb4035$var$gg = !0;
        var a = 0, b = $fb74bc6f62fb4035$var$C;
        try {
            var c = $fb74bc6f62fb4035$var$eg;
            for($fb74bc6f62fb4035$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fb74bc6f62fb4035$var$eg = null;
            $fb74bc6f62fb4035$var$fg = !1;
        } catch (e) {
            throw null !== $fb74bc6f62fb4035$var$eg && ($fb74bc6f62fb4035$var$eg = $fb74bc6f62fb4035$var$eg.slice(a + 1)), $fb74bc6f62fb4035$var$ac($fb74bc6f62fb4035$var$fc, $fb74bc6f62fb4035$var$jg), e;
        } finally{
            $fb74bc6f62fb4035$var$C = b, $fb74bc6f62fb4035$var$gg = !1;
        }
    }
    return null;
}
var $fb74bc6f62fb4035$var$kg = [], $fb74bc6f62fb4035$var$lg = 0, $fb74bc6f62fb4035$var$mg = null, $fb74bc6f62fb4035$var$ng = 0, $fb74bc6f62fb4035$var$og = [], $fb74bc6f62fb4035$var$pg = 0, $fb74bc6f62fb4035$var$qg = null, $fb74bc6f62fb4035$var$rg = 1, $fb74bc6f62fb4035$var$sg = "";
function $fb74bc6f62fb4035$var$tg(a, b) {
    $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg++] = $fb74bc6f62fb4035$var$ng;
    $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg++] = $fb74bc6f62fb4035$var$mg;
    $fb74bc6f62fb4035$var$mg = a;
    $fb74bc6f62fb4035$var$ng = b;
}
function $fb74bc6f62fb4035$var$ug(a, b, c) {
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$rg;
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$sg;
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$qg;
    $fb74bc6f62fb4035$var$qg = a;
    var d = $fb74bc6f62fb4035$var$rg;
    a = $fb74bc6f62fb4035$var$sg;
    var e = 32 - $fb74bc6f62fb4035$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fb74bc6f62fb4035$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fb74bc6f62fb4035$var$rg = 1 << 32 - $fb74bc6f62fb4035$var$oc(b) + e | c << e | d;
        $fb74bc6f62fb4035$var$sg = f + a;
    } else $fb74bc6f62fb4035$var$rg = 1 << f | c << e | d, $fb74bc6f62fb4035$var$sg = a;
}
function $fb74bc6f62fb4035$var$vg(a) {
    null !== a.return && ($fb74bc6f62fb4035$var$tg(a, 1), $fb74bc6f62fb4035$var$ug(a, 1, 0));
}
function $fb74bc6f62fb4035$var$wg(a) {
    for(; a === $fb74bc6f62fb4035$var$mg;)$fb74bc6f62fb4035$var$mg = $fb74bc6f62fb4035$var$kg[--$fb74bc6f62fb4035$var$lg], $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg] = null, $fb74bc6f62fb4035$var$ng = $fb74bc6f62fb4035$var$kg[--$fb74bc6f62fb4035$var$lg], $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg] = null;
    for(; a === $fb74bc6f62fb4035$var$qg;)$fb74bc6f62fb4035$var$qg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null, $fb74bc6f62fb4035$var$sg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null, $fb74bc6f62fb4035$var$rg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null;
}
var $fb74bc6f62fb4035$var$xg = null, $fb74bc6f62fb4035$var$yg = null, $fb74bc6f62fb4035$var$I = !1, $fb74bc6f62fb4035$var$zg = null;
function $fb74bc6f62fb4035$var$Ag(a, b) {
    var c = $fb74bc6f62fb4035$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fb74bc6f62fb4035$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fb74bc6f62fb4035$var$qg ? {
                id: $fb74bc6f62fb4035$var$rg,
                overflow: $fb74bc6f62fb4035$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fb74bc6f62fb4035$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fb74bc6f62fb4035$var$Eg(a) {
    if ($fb74bc6f62fb4035$var$I) {
        var b = $fb74bc6f62fb4035$var$yg;
        if (b) {
            var c = b;
            if (!$fb74bc6f62fb4035$var$Cg(a, b)) {
                if ($fb74bc6f62fb4035$var$Dg(a)) throw Error($fb74bc6f62fb4035$var$p(418));
                b = $fb74bc6f62fb4035$var$Lf(c.nextSibling);
                var d = $fb74bc6f62fb4035$var$xg;
                b && $fb74bc6f62fb4035$var$Cg(a, b) ? $fb74bc6f62fb4035$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fb74bc6f62fb4035$var$I = !1, $fb74bc6f62fb4035$var$xg = a);
            }
        } else {
            if ($fb74bc6f62fb4035$var$Dg(a)) throw Error($fb74bc6f62fb4035$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fb74bc6f62fb4035$var$I = !1;
            $fb74bc6f62fb4035$var$xg = a;
        }
    }
}
function $fb74bc6f62fb4035$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fb74bc6f62fb4035$var$xg = a;
}
function $fb74bc6f62fb4035$var$Gg(a) {
    if (a !== $fb74bc6f62fb4035$var$xg) return !1;
    if (!$fb74bc6f62fb4035$var$I) return $fb74bc6f62fb4035$var$Fg(a), $fb74bc6f62fb4035$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fb74bc6f62fb4035$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fb74bc6f62fb4035$var$yg)) {
        if ($fb74bc6f62fb4035$var$Dg(a)) throw $fb74bc6f62fb4035$var$Hg(), Error($fb74bc6f62fb4035$var$p(418));
        for(; b;)$fb74bc6f62fb4035$var$Ag(a, b), b = $fb74bc6f62fb4035$var$Lf(b.nextSibling);
    }
    $fb74bc6f62fb4035$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fb74bc6f62fb4035$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fb74bc6f62fb4035$var$yg = null;
        }
    } else $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$xg ? $fb74bc6f62fb4035$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fb74bc6f62fb4035$var$Hg() {
    for(var a = $fb74bc6f62fb4035$var$yg; a;)a = $fb74bc6f62fb4035$var$Lf(a.nextSibling);
}
function $fb74bc6f62fb4035$var$Ig() {
    $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$xg = null;
    $fb74bc6f62fb4035$var$I = !1;
}
function $fb74bc6f62fb4035$var$Jg(a) {
    null === $fb74bc6f62fb4035$var$zg ? $fb74bc6f62fb4035$var$zg = [
        a
    ] : $fb74bc6f62fb4035$var$zg.push(a);
}
var $fb74bc6f62fb4035$var$Kg = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig;
function $fb74bc6f62fb4035$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fb74bc6f62fb4035$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fb74bc6f62fb4035$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fb74bc6f62fb4035$var$p(284));
        if (!c._owner) throw Error($fb74bc6f62fb4035$var$p(290, a));
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fb74bc6f62fb4035$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fb74bc6f62fb4035$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $fb74bc6f62fb4035$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fb74bc6f62fb4035$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fb74bc6f62fb4035$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fb74bc6f62fb4035$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fb74bc6f62fb4035$var$Ha && $fb74bc6f62fb4035$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $fb74bc6f62fb4035$var$Lg(a, b, c), d.return = a, d;
        d = $fb74bc6f62fb4035$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fb74bc6f62fb4035$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fb74bc6f62fb4035$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fb74bc6f62fb4035$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fb74bc6f62fb4035$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return c = $fb74bc6f62fb4035$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $fb74bc6f62fb4035$var$Lg(a, null, b), c.return = a, c;
                case $fb74bc6f62fb4035$var$wa:
                    return b = $fb74bc6f62fb4035$var$Sg(b, a.mode, c), b.return = a, b;
                case $fb74bc6f62fb4035$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fb74bc6f62fb4035$var$eb(b) || $fb74bc6f62fb4035$var$Ka(b)) return b = $fb74bc6f62fb4035$var$Tg(b, a.mode, c, null), b.return = a, b;
            $fb74bc6f62fb4035$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fb74bc6f62fb4035$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fb74bc6f62fb4035$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fb74bc6f62fb4035$var$eb(c) || $fb74bc6f62fb4035$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fb74bc6f62fb4035$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fb74bc6f62fb4035$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fb74bc6f62fb4035$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fb74bc6f62fb4035$var$eb(d) || $fb74bc6f62fb4035$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fb74bc6f62fb4035$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fb74bc6f62fb4035$var$Ka(h);
        if ("function" !== typeof l) throw Error($fb74bc6f62fb4035$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fb74bc6f62fb4035$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fb74bc6f62fb4035$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fb74bc6f62fb4035$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fb74bc6f62fb4035$var$Ha && $fb74bc6f62fb4035$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fb74bc6f62fb4035$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fb74bc6f62fb4035$var$ya ? (d = $fb74bc6f62fb4035$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fb74bc6f62fb4035$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $fb74bc6f62fb4035$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fb74bc6f62fb4035$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fb74bc6f62fb4035$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fb74bc6f62fb4035$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fb74bc6f62fb4035$var$eb(f)) return n(a, d, f, h);
            if ($fb74bc6f62fb4035$var$Ka(f)) return t(a, d, f, h);
            $fb74bc6f62fb4035$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fb74bc6f62fb4035$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fb74bc6f62fb4035$var$Ug = $fb74bc6f62fb4035$var$Og(!0), $fb74bc6f62fb4035$var$Vg = $fb74bc6f62fb4035$var$Og(!1), $fb74bc6f62fb4035$var$Wg = $fb74bc6f62fb4035$var$Uf(null), $fb74bc6f62fb4035$var$Xg = null, $fb74bc6f62fb4035$var$Yg = null, $fb74bc6f62fb4035$var$Zg = null;
function $fb74bc6f62fb4035$var$$g() {
    $fb74bc6f62fb4035$var$Zg = $fb74bc6f62fb4035$var$Yg = $fb74bc6f62fb4035$var$Xg = null;
}
function $fb74bc6f62fb4035$var$ah(a) {
    var b = $fb74bc6f62fb4035$var$Wg.current;
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wg);
    a._currentValue = b;
}
function $fb74bc6f62fb4035$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fb74bc6f62fb4035$var$ch(a, b) {
    $fb74bc6f62fb4035$var$Xg = a;
    $fb74bc6f62fb4035$var$Zg = $fb74bc6f62fb4035$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fb74bc6f62fb4035$var$dh = !0), a.firstContext = null);
}
function $fb74bc6f62fb4035$var$eh(a) {
    var b = a._currentValue;
    if ($fb74bc6f62fb4035$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fb74bc6f62fb4035$var$Yg) {
            if (null === $fb74bc6f62fb4035$var$Xg) throw Error($fb74bc6f62fb4035$var$p(308));
            $fb74bc6f62fb4035$var$Yg = a;
            $fb74bc6f62fb4035$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fb74bc6f62fb4035$var$Yg = $fb74bc6f62fb4035$var$Yg.next = a;
    }
    return b;
}
var $fb74bc6f62fb4035$var$fh = null;
function $fb74bc6f62fb4035$var$gh(a) {
    null === $fb74bc6f62fb4035$var$fh ? $fb74bc6f62fb4035$var$fh = [
        a
    ] : $fb74bc6f62fb4035$var$fh.push(a);
}
function $fb74bc6f62fb4035$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fb74bc6f62fb4035$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fb74bc6f62fb4035$var$ih(a, d);
}
function $fb74bc6f62fb4035$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fb74bc6f62fb4035$var$jh = !1;
function $fb74bc6f62fb4035$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fb74bc6f62fb4035$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fb74bc6f62fb4035$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fb74bc6f62fb4035$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fb74bc6f62fb4035$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fb74bc6f62fb4035$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fb74bc6f62fb4035$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fb74bc6f62fb4035$var$ih(a, c);
}
function $fb74bc6f62fb4035$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fb74bc6f62fb4035$var$Cc(a, c);
    }
}
function $fb74bc6f62fb4035$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fb74bc6f62fb4035$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $fb74bc6f62fb4035$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fb74bc6f62fb4035$var$A({}, q, r);
                            break a;
                        case 2:
                            $fb74bc6f62fb4035$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fb74bc6f62fb4035$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fb74bc6f62fb4035$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fb74bc6f62fb4035$var$p(191, e));
            e.call(d);
        }
    }
}
var $fb74bc6f62fb4035$var$th = {}, $fb74bc6f62fb4035$var$uh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th), $fb74bc6f62fb4035$var$vh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th), $fb74bc6f62fb4035$var$wh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th);
function $fb74bc6f62fb4035$var$xh(a) {
    if (a === $fb74bc6f62fb4035$var$th) throw Error($fb74bc6f62fb4035$var$p(174));
    return a;
}
function $fb74bc6f62fb4035$var$yh(a, b) {
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$wh, b);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$vh, a);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, $fb74bc6f62fb4035$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fb74bc6f62fb4035$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fb74bc6f62fb4035$var$lb(b, a);
    }
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, b);
}
function $fb74bc6f62fb4035$var$zh() {
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$vh);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$wh);
}
function $fb74bc6f62fb4035$var$Ah(a) {
    $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
    var b = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
    var c = $fb74bc6f62fb4035$var$lb(b, a.type);
    b !== c && ($fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$vh, a), $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, c));
}
function $fb74bc6f62fb4035$var$Bh(a) {
    $fb74bc6f62fb4035$var$vh.current === a && ($fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$vh));
}
var $fb74bc6f62fb4035$var$L = $fb74bc6f62fb4035$var$Uf(0);
function $fb74bc6f62fb4035$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$Dh = [];
function $fb74bc6f62fb4035$var$Eh() {
    for(var a = 0; a < $fb74bc6f62fb4035$var$Dh.length; a++)$fb74bc6f62fb4035$var$Dh[a]._workInProgressVersionPrimary = null;
    $fb74bc6f62fb4035$var$Dh.length = 0;
}
var $fb74bc6f62fb4035$var$Fh = $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher, $fb74bc6f62fb4035$var$Gh = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$Hh = 0, $fb74bc6f62fb4035$var$M = null, $fb74bc6f62fb4035$var$N = null, $fb74bc6f62fb4035$var$O = null, $fb74bc6f62fb4035$var$Ih = !1, $fb74bc6f62fb4035$var$Jh = !1, $fb74bc6f62fb4035$var$Kh = 0, $fb74bc6f62fb4035$var$Lh = 0;
function $fb74bc6f62fb4035$var$P() {
    throw Error($fb74bc6f62fb4035$var$p(321));
}
function $fb74bc6f62fb4035$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fb74bc6f62fb4035$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fb74bc6f62fb4035$var$Nh(a, b, c, d, e, f) {
    $fb74bc6f62fb4035$var$Hh = f;
    $fb74bc6f62fb4035$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fb74bc6f62fb4035$var$Fh.current = null === a || null === a.memoizedState ? $fb74bc6f62fb4035$var$Oh : $fb74bc6f62fb4035$var$Ph;
    a = c(d, e);
    if ($fb74bc6f62fb4035$var$Jh) {
        f = 0;
        do {
            $fb74bc6f62fb4035$var$Jh = !1;
            $fb74bc6f62fb4035$var$Kh = 0;
            if (25 <= f) throw Error($fb74bc6f62fb4035$var$p(301));
            f += 1;
            $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = null;
            b.updateQueue = null;
            $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Qh;
            a = c(d, e);
        }while ($fb74bc6f62fb4035$var$Jh);
    }
    $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Rh;
    b = null !== $fb74bc6f62fb4035$var$N && null !== $fb74bc6f62fb4035$var$N.next;
    $fb74bc6f62fb4035$var$Hh = 0;
    $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = $fb74bc6f62fb4035$var$M = null;
    $fb74bc6f62fb4035$var$Ih = !1;
    if (b) throw Error($fb74bc6f62fb4035$var$p(300));
    return a;
}
function $fb74bc6f62fb4035$var$Sh() {
    var a = 0 !== $fb74bc6f62fb4035$var$Kh;
    $fb74bc6f62fb4035$var$Kh = 0;
    return a;
}
function $fb74bc6f62fb4035$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState = $fb74bc6f62fb4035$var$O = a : $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$O.next = a;
    return $fb74bc6f62fb4035$var$O;
}
function $fb74bc6f62fb4035$var$Uh() {
    if (null === $fb74bc6f62fb4035$var$N) {
        var a = $fb74bc6f62fb4035$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fb74bc6f62fb4035$var$N.next;
    var b = null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState : $fb74bc6f62fb4035$var$O.next;
    if (null !== b) $fb74bc6f62fb4035$var$O = b, $fb74bc6f62fb4035$var$N = a;
    else {
        if (null === a) throw Error($fb74bc6f62fb4035$var$p(310));
        $fb74bc6f62fb4035$var$N = a;
        a = {
            memoizedState: $fb74bc6f62fb4035$var$N.memoizedState,
            baseState: $fb74bc6f62fb4035$var$N.baseState,
            baseQueue: $fb74bc6f62fb4035$var$N.baseQueue,
            queue: $fb74bc6f62fb4035$var$N.queue,
            next: null
        };
        null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState = $fb74bc6f62fb4035$var$O = a : $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$O.next = a;
    }
    return $fb74bc6f62fb4035$var$O;
}
function $fb74bc6f62fb4035$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fb74bc6f62fb4035$var$Wh(a) {
    var b = $fb74bc6f62fb4035$var$Uh(), c = b.queue;
    if (null === c) throw Error($fb74bc6f62fb4035$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fb74bc6f62fb4035$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fb74bc6f62fb4035$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fb74bc6f62fb4035$var$M.lanes |= m;
                $fb74bc6f62fb4035$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fb74bc6f62fb4035$var$He(d, b.memoizedState) || ($fb74bc6f62fb4035$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fb74bc6f62fb4035$var$M.lanes |= f, $fb74bc6f62fb4035$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fb74bc6f62fb4035$var$Xh(a) {
    var b = $fb74bc6f62fb4035$var$Uh(), c = b.queue;
    if (null === c) throw Error($fb74bc6f62fb4035$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fb74bc6f62fb4035$var$He(f, b.memoizedState) || ($fb74bc6f62fb4035$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fb74bc6f62fb4035$var$Yh() {}
function $fb74bc6f62fb4035$var$Zh(a, b) {
    var c = $fb74bc6f62fb4035$var$M, d = $fb74bc6f62fb4035$var$Uh(), e = b(), f = !$fb74bc6f62fb4035$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fb74bc6f62fb4035$var$dh = !0);
    d = d.queue;
    $fb74bc6f62fb4035$var$$h($fb74bc6f62fb4035$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fb74bc6f62fb4035$var$O && $fb74bc6f62fb4035$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fb74bc6f62fb4035$var$bi(9, $fb74bc6f62fb4035$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $fb74bc6f62fb4035$var$Q) throw Error($fb74bc6f62fb4035$var$p(349));
        0 !== ($fb74bc6f62fb4035$var$Hh & 30) || $fb74bc6f62fb4035$var$di(c, b, e);
    }
    return e;
}
function $fb74bc6f62fb4035$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fb74bc6f62fb4035$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fb74bc6f62fb4035$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fb74bc6f62fb4035$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fb74bc6f62fb4035$var$ei(b) && $fb74bc6f62fb4035$var$fi(a);
}
function $fb74bc6f62fb4035$var$ai(a, b, c) {
    return c(function() {
        $fb74bc6f62fb4035$var$ei(b) && $fb74bc6f62fb4035$var$fi(a);
    });
}
function $fb74bc6f62fb4035$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fb74bc6f62fb4035$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fb74bc6f62fb4035$var$fi(a) {
    var b = $fb74bc6f62fb4035$var$ih(a, 1);
    null !== b && $fb74bc6f62fb4035$var$gi(b, a, 1, -1);
}
function $fb74bc6f62fb4035$var$hi(a) {
    var b = $fb74bc6f62fb4035$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fb74bc6f62fb4035$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fb74bc6f62fb4035$var$ii.bind(null, $fb74bc6f62fb4035$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fb74bc6f62fb4035$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fb74bc6f62fb4035$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fb74bc6f62fb4035$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fb74bc6f62fb4035$var$ji() {
    return $fb74bc6f62fb4035$var$Uh().memoizedState;
}
function $fb74bc6f62fb4035$var$ki(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$Th();
    $fb74bc6f62fb4035$var$M.flags |= a;
    e.memoizedState = $fb74bc6f62fb4035$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fb74bc6f62fb4035$var$li(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fb74bc6f62fb4035$var$N) {
        var g = $fb74bc6f62fb4035$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fb74bc6f62fb4035$var$Mh(d, g.deps)) {
            e.memoizedState = $fb74bc6f62fb4035$var$bi(b, c, f, d);
            return;
        }
    }
    $fb74bc6f62fb4035$var$M.flags |= a;
    e.memoizedState = $fb74bc6f62fb4035$var$bi(1 | b, c, f, d);
}
function $fb74bc6f62fb4035$var$mi(a, b) {
    return $fb74bc6f62fb4035$var$ki(8390656, 8, a, b);
}
function $fb74bc6f62fb4035$var$$h(a, b) {
    return $fb74bc6f62fb4035$var$li(2048, 8, a, b);
}
function $fb74bc6f62fb4035$var$ni(a, b) {
    return $fb74bc6f62fb4035$var$li(4, 2, a, b);
}
function $fb74bc6f62fb4035$var$oi(a, b) {
    return $fb74bc6f62fb4035$var$li(4, 4, a, b);
}
function $fb74bc6f62fb4035$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fb74bc6f62fb4035$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fb74bc6f62fb4035$var$li(4, 4, $fb74bc6f62fb4035$var$pi.bind(null, b, a), c);
}
function $fb74bc6f62fb4035$var$ri() {}
function $fb74bc6f62fb4035$var$si(a, b) {
    var c = $fb74bc6f62fb4035$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fb74bc6f62fb4035$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fb74bc6f62fb4035$var$ti(a, b) {
    var c = $fb74bc6f62fb4035$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fb74bc6f62fb4035$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fb74bc6f62fb4035$var$ui(a, b, c) {
    if (0 === ($fb74bc6f62fb4035$var$Hh & 21)) return a.baseState && (a.baseState = !1, $fb74bc6f62fb4035$var$dh = !0), a.memoizedState = c;
    $fb74bc6f62fb4035$var$He(c, b) || (c = $fb74bc6f62fb4035$var$yc(), $fb74bc6f62fb4035$var$M.lanes |= c, $fb74bc6f62fb4035$var$rh |= c, a.baseState = !0);
    return b;
}
function $fb74bc6f62fb4035$var$vi(a, b) {
    var c = $fb74bc6f62fb4035$var$C;
    $fb74bc6f62fb4035$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fb74bc6f62fb4035$var$Gh.transition;
    $fb74bc6f62fb4035$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fb74bc6f62fb4035$var$C = c, $fb74bc6f62fb4035$var$Gh.transition = d;
    }
}
function $fb74bc6f62fb4035$var$wi() {
    return $fb74bc6f62fb4035$var$Uh().memoizedState;
}
function $fb74bc6f62fb4035$var$xi(a, b, c) {
    var d = $fb74bc6f62fb4035$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb74bc6f62fb4035$var$zi(a)) $fb74bc6f62fb4035$var$Ai(b, c);
    else if (c = $fb74bc6f62fb4035$var$hh(a, b, c, d), null !== c) {
        var e = $fb74bc6f62fb4035$var$R();
        $fb74bc6f62fb4035$var$gi(c, a, d, e);
        $fb74bc6f62fb4035$var$Bi(c, b, d);
    }
}
function $fb74bc6f62fb4035$var$ii(a, b, c) {
    var d = $fb74bc6f62fb4035$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb74bc6f62fb4035$var$zi(a)) $fb74bc6f62fb4035$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fb74bc6f62fb4035$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fb74bc6f62fb4035$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fb74bc6f62fb4035$var$hh(a, b, e, d);
        null !== c && (e = $fb74bc6f62fb4035$var$R(), $fb74bc6f62fb4035$var$gi(c, a, d, e), $fb74bc6f62fb4035$var$Bi(c, b, d));
    }
}
function $fb74bc6f62fb4035$var$zi(a) {
    var b = a.alternate;
    return a === $fb74bc6f62fb4035$var$M || null !== b && b === $fb74bc6f62fb4035$var$M;
}
function $fb74bc6f62fb4035$var$Ai(a, b) {
    $fb74bc6f62fb4035$var$Jh = $fb74bc6f62fb4035$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fb74bc6f62fb4035$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fb74bc6f62fb4035$var$Cc(a, c);
    }
}
var $fb74bc6f62fb4035$var$Rh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$P,
    useContext: $fb74bc6f62fb4035$var$P,
    useEffect: $fb74bc6f62fb4035$var$P,
    useImperativeHandle: $fb74bc6f62fb4035$var$P,
    useInsertionEffect: $fb74bc6f62fb4035$var$P,
    useLayoutEffect: $fb74bc6f62fb4035$var$P,
    useMemo: $fb74bc6f62fb4035$var$P,
    useReducer: $fb74bc6f62fb4035$var$P,
    useRef: $fb74bc6f62fb4035$var$P,
    useState: $fb74bc6f62fb4035$var$P,
    useDebugValue: $fb74bc6f62fb4035$var$P,
    useDeferredValue: $fb74bc6f62fb4035$var$P,
    useTransition: $fb74bc6f62fb4035$var$P,
    useMutableSource: $fb74bc6f62fb4035$var$P,
    useSyncExternalStore: $fb74bc6f62fb4035$var$P,
    useId: $fb74bc6f62fb4035$var$P,
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Oh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: function(a, b) {
        $fb74bc6f62fb4035$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fb74bc6f62fb4035$var$ki(4194308, 4, $fb74bc6f62fb4035$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fb74bc6f62fb4035$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fb74bc6f62fb4035$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fb74bc6f62fb4035$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fb74bc6f62fb4035$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fb74bc6f62fb4035$var$xi.bind(null, $fb74bc6f62fb4035$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fb74bc6f62fb4035$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fb74bc6f62fb4035$var$hi,
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        return $fb74bc6f62fb4035$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$hi(!1), b = a[0];
        a = $fb74bc6f62fb4035$var$vi.bind(null, a[1]);
        $fb74bc6f62fb4035$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fb74bc6f62fb4035$var$M, e = $fb74bc6f62fb4035$var$Th();
        if ($fb74bc6f62fb4035$var$I) {
            if (void 0 === c) throw Error($fb74bc6f62fb4035$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fb74bc6f62fb4035$var$Q) throw Error($fb74bc6f62fb4035$var$p(349));
            0 !== ($fb74bc6f62fb4035$var$Hh & 30) || $fb74bc6f62fb4035$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fb74bc6f62fb4035$var$mi($fb74bc6f62fb4035$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fb74bc6f62fb4035$var$bi(9, $fb74bc6f62fb4035$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fb74bc6f62fb4035$var$Th(), b = $fb74bc6f62fb4035$var$Q.identifierPrefix;
        if ($fb74bc6f62fb4035$var$I) {
            var c = $fb74bc6f62fb4035$var$sg;
            var d = $fb74bc6f62fb4035$var$rg;
            c = (d & ~(1 << 32 - $fb74bc6f62fb4035$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fb74bc6f62fb4035$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fb74bc6f62fb4035$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Ph = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$si,
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$$h,
    useImperativeHandle: $fb74bc6f62fb4035$var$qi,
    useInsertionEffect: $fb74bc6f62fb4035$var$ni,
    useLayoutEffect: $fb74bc6f62fb4035$var$oi,
    useMemo: $fb74bc6f62fb4035$var$ti,
    useReducer: $fb74bc6f62fb4035$var$Wh,
    useRef: $fb74bc6f62fb4035$var$ji,
    useState: function() {
        return $fb74bc6f62fb4035$var$Wh($fb74bc6f62fb4035$var$Vh);
    },
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        var b = $fb74bc6f62fb4035$var$Uh();
        return $fb74bc6f62fb4035$var$ui(b, $fb74bc6f62fb4035$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$Wh($fb74bc6f62fb4035$var$Vh)[0], b = $fb74bc6f62fb4035$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fb74bc6f62fb4035$var$Yh,
    useSyncExternalStore: $fb74bc6f62fb4035$var$Zh,
    useId: $fb74bc6f62fb4035$var$wi,
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Qh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$si,
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$$h,
    useImperativeHandle: $fb74bc6f62fb4035$var$qi,
    useInsertionEffect: $fb74bc6f62fb4035$var$ni,
    useLayoutEffect: $fb74bc6f62fb4035$var$oi,
    useMemo: $fb74bc6f62fb4035$var$ti,
    useReducer: $fb74bc6f62fb4035$var$Xh,
    useRef: $fb74bc6f62fb4035$var$ji,
    useState: function() {
        return $fb74bc6f62fb4035$var$Xh($fb74bc6f62fb4035$var$Vh);
    },
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        var b = $fb74bc6f62fb4035$var$Uh();
        return null === $fb74bc6f62fb4035$var$N ? b.memoizedState = a : $fb74bc6f62fb4035$var$ui(b, $fb74bc6f62fb4035$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$Xh($fb74bc6f62fb4035$var$Vh)[0], b = $fb74bc6f62fb4035$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fb74bc6f62fb4035$var$Yh,
    useSyncExternalStore: $fb74bc6f62fb4035$var$Zh,
    useId: $fb74bc6f62fb4035$var$wi,
    unstable_isNewReconciler: !1
};
function $fb74bc6f62fb4035$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $fb74bc6f62fb4035$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $fb74bc6f62fb4035$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fb74bc6f62fb4035$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fb74bc6f62fb4035$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fb74bc6f62fb4035$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fb74bc6f62fb4035$var$R(), e = $fb74bc6f62fb4035$var$yi(a), f = $fb74bc6f62fb4035$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fb74bc6f62fb4035$var$nh(a, f, e);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, e, d), $fb74bc6f62fb4035$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fb74bc6f62fb4035$var$R(), e = $fb74bc6f62fb4035$var$yi(a), f = $fb74bc6f62fb4035$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fb74bc6f62fb4035$var$nh(a, f, e);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, e, d), $fb74bc6f62fb4035$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fb74bc6f62fb4035$var$R(), d = $fb74bc6f62fb4035$var$yi(a), e = $fb74bc6f62fb4035$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fb74bc6f62fb4035$var$nh(a, e, d);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, d, c), $fb74bc6f62fb4035$var$oh(b, a, d));
    }
};
function $fb74bc6f62fb4035$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fb74bc6f62fb4035$var$Ie(c, d) || !$fb74bc6f62fb4035$var$Ie(e, f) : !0;
}
function $fb74bc6f62fb4035$var$Gi(a, b, c) {
    var d = !1, e = $fb74bc6f62fb4035$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fb74bc6f62fb4035$var$eh(f) : (e = $fb74bc6f62fb4035$var$Zf(b) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fb74bc6f62fb4035$var$Yf(a, e) : $fb74bc6f62fb4035$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fb74bc6f62fb4035$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fb74bc6f62fb4035$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fb74bc6f62fb4035$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $fb74bc6f62fb4035$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $fb74bc6f62fb4035$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fb74bc6f62fb4035$var$eh(f) : (f = $fb74bc6f62fb4035$var$Zf(b) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, e.context = $fb74bc6f62fb4035$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fb74bc6f62fb4035$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fb74bc6f62fb4035$var$Ei.enqueueReplaceState(e, e.state, null), $fb74bc6f62fb4035$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fb74bc6f62fb4035$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $fb74bc6f62fb4035$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fb74bc6f62fb4035$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fb74bc6f62fb4035$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fb74bc6f62fb4035$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $fb74bc6f62fb4035$var$Ni(a, b, c) {
    c = $fb74bc6f62fb4035$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fb74bc6f62fb4035$var$Oi || ($fb74bc6f62fb4035$var$Oi = !0, $fb74bc6f62fb4035$var$Pi = d);
        $fb74bc6f62fb4035$var$Li(a, b);
    };
    return c;
}
function $fb74bc6f62fb4035$var$Qi(a, b, c) {
    c = $fb74bc6f62fb4035$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fb74bc6f62fb4035$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fb74bc6f62fb4035$var$Li(a, b);
        "function" !== typeof d && (null === $fb74bc6f62fb4035$var$Ri ? $fb74bc6f62fb4035$var$Ri = new Set([
            this
        ]) : $fb74bc6f62fb4035$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fb74bc6f62fb4035$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fb74bc6f62fb4035$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fb74bc6f62fb4035$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $fb74bc6f62fb4035$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fb74bc6f62fb4035$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fb74bc6f62fb4035$var$mh(-1, 1), b.tag = 2, $fb74bc6f62fb4035$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fb74bc6f62fb4035$var$Wi = $fb74bc6f62fb4035$var$ua.ReactCurrentOwner, $fb74bc6f62fb4035$var$dh = !1;
function $fb74bc6f62fb4035$var$Xi(a, b, c, d) {
    b.child = null === a ? $fb74bc6f62fb4035$var$Vg(b, null, c, d) : $fb74bc6f62fb4035$var$Ug(b, a.child, c, d);
}
function $fb74bc6f62fb4035$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fb74bc6f62fb4035$var$ch(b, e);
    d = $fb74bc6f62fb4035$var$Nh(a, b, c, d, f, e);
    c = $fb74bc6f62fb4035$var$Sh();
    if (null !== a && !$fb74bc6f62fb4035$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fb74bc6f62fb4035$var$Zi(a, b, e);
    $fb74bc6f62fb4035$var$I && c && $fb74bc6f62fb4035$var$vg(b);
    b.flags |= 1;
    $fb74bc6f62fb4035$var$Xi(a, b, d, e);
    return b.child;
}
function $fb74bc6f62fb4035$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fb74bc6f62fb4035$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fb74bc6f62fb4035$var$bj(a, b, f, d, e);
        a = $fb74bc6f62fb4035$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fb74bc6f62fb4035$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fb74bc6f62fb4035$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $fb74bc6f62fb4035$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fb74bc6f62fb4035$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fb74bc6f62fb4035$var$Ie(f, d) && a.ref === b.ref) {
            if ($fb74bc6f62fb4035$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fb74bc6f62fb4035$var$dh = !0);
            else return b.lanes = a.lanes, $fb74bc6f62fb4035$var$Zi(a, b, e);
        }
    }
    return $fb74bc6f62fb4035$var$cj(a, b, c, d, e);
}
function $fb74bc6f62fb4035$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj);
            $fb74bc6f62fb4035$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= d;
    $fb74bc6f62fb4035$var$Xi(a, b, e, c);
    return b.child;
}
function $fb74bc6f62fb4035$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fb74bc6f62fb4035$var$cj(a, b, c, d, e) {
    var f = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current;
    f = $fb74bc6f62fb4035$var$Yf(b, f);
    $fb74bc6f62fb4035$var$ch(b, e);
    c = $fb74bc6f62fb4035$var$Nh(a, b, c, d, f, e);
    d = $fb74bc6f62fb4035$var$Sh();
    if (null !== a && !$fb74bc6f62fb4035$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fb74bc6f62fb4035$var$Zi(a, b, e);
    $fb74bc6f62fb4035$var$I && d && $fb74bc6f62fb4035$var$vg(b);
    b.flags |= 1;
    $fb74bc6f62fb4035$var$Xi(a, b, c, e);
    return b.child;
}
function $fb74bc6f62fb4035$var$hj(a, b, c, d, e) {
    if ($fb74bc6f62fb4035$var$Zf(c)) {
        var f = !0;
        $fb74bc6f62fb4035$var$cg(b);
    } else f = !1;
    $fb74bc6f62fb4035$var$ch(b, e);
    if (null === b.stateNode) $fb74bc6f62fb4035$var$ij(a, b), $fb74bc6f62fb4035$var$Gi(b, c, d), $fb74bc6f62fb4035$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fb74bc6f62fb4035$var$eh(l) : (l = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, l = $fb74bc6f62fb4035$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fb74bc6f62fb4035$var$Hi(b, g, d, l);
        $fb74bc6f62fb4035$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fb74bc6f62fb4035$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fb74bc6f62fb4035$var$Wf.current || $fb74bc6f62fb4035$var$jh ? ("function" === typeof m && ($fb74bc6f62fb4035$var$Di(b, c, m, d), k = b.memoizedState), (h = $fb74bc6f62fb4035$var$jh || $fb74bc6f62fb4035$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fb74bc6f62fb4035$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fb74bc6f62fb4035$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fb74bc6f62fb4035$var$eh(k) : (k = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, k = $fb74bc6f62fb4035$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fb74bc6f62fb4035$var$Hi(b, g, d, k);
        $fb74bc6f62fb4035$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $fb74bc6f62fb4035$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fb74bc6f62fb4035$var$Wf.current || $fb74bc6f62fb4035$var$jh ? ("function" === typeof y && ($fb74bc6f62fb4035$var$Di(b, c, y, d), n = b.memoizedState), (l = $fb74bc6f62fb4035$var$jh || $fb74bc6f62fb4035$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fb74bc6f62fb4035$var$jj(a, b, c, d, f, e);
}
function $fb74bc6f62fb4035$var$jj(a, b, c, d, e, f) {
    $fb74bc6f62fb4035$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fb74bc6f62fb4035$var$dg(b, c, !1), $fb74bc6f62fb4035$var$Zi(a, b, f);
    d = b.stateNode;
    $fb74bc6f62fb4035$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fb74bc6f62fb4035$var$Ug(b, a.child, null, f), b.child = $fb74bc6f62fb4035$var$Ug(b, null, h, f)) : $fb74bc6f62fb4035$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fb74bc6f62fb4035$var$dg(b, c, !0);
    return b.child;
}
function $fb74bc6f62fb4035$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fb74bc6f62fb4035$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fb74bc6f62fb4035$var$ag(a, b.context, !1);
    $fb74bc6f62fb4035$var$yh(a, b.containerInfo);
}
function $fb74bc6f62fb4035$var$lj(a, b, c, d, e) {
    $fb74bc6f62fb4035$var$Ig();
    $fb74bc6f62fb4035$var$Jg(e);
    b.flags |= 256;
    $fb74bc6f62fb4035$var$Xi(a, b, c, d);
    return b.child;
}
var $fb74bc6f62fb4035$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fb74bc6f62fb4035$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fb74bc6f62fb4035$var$oj(a, b, c) {
    var d = b.pendingProps, e = $fb74bc6f62fb4035$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, e & 1);
    if (null === a) {
        $fb74bc6f62fb4035$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fb74bc6f62fb4035$var$pj(g, d, 0, null), a = $fb74bc6f62fb4035$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fb74bc6f62fb4035$var$nj(c), b.memoizedState = $fb74bc6f62fb4035$var$mj, a) : $fb74bc6f62fb4035$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fb74bc6f62fb4035$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fb74bc6f62fb4035$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fb74bc6f62fb4035$var$Pg(h, f) : (f = $fb74bc6f62fb4035$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fb74bc6f62fb4035$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fb74bc6f62fb4035$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fb74bc6f62fb4035$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fb74bc6f62fb4035$var$qj(a, b) {
    b = $fb74bc6f62fb4035$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fb74bc6f62fb4035$var$sj(a, b, c, d) {
    null !== d && $fb74bc6f62fb4035$var$Jg(d);
    $fb74bc6f62fb4035$var$Ug(b, a.child, null, c);
    a = $fb74bc6f62fb4035$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fb74bc6f62fb4035$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fb74bc6f62fb4035$var$Ki(Error($fb74bc6f62fb4035$var$p(422))), $fb74bc6f62fb4035$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fb74bc6f62fb4035$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fb74bc6f62fb4035$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fb74bc6f62fb4035$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $fb74bc6f62fb4035$var$nj(g);
        b.memoizedState = $fb74bc6f62fb4035$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fb74bc6f62fb4035$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fb74bc6f62fb4035$var$p(419));
        d = $fb74bc6f62fb4035$var$Ki(f, d, void 0);
        return $fb74bc6f62fb4035$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fb74bc6f62fb4035$var$dh || h) {
        d = $fb74bc6f62fb4035$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fb74bc6f62fb4035$var$ih(a, e), $fb74bc6f62fb4035$var$gi(d, a, e, -1));
        }
        $fb74bc6f62fb4035$var$tj();
        d = $fb74bc6f62fb4035$var$Ki(Error($fb74bc6f62fb4035$var$p(421)));
        return $fb74bc6f62fb4035$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fb74bc6f62fb4035$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(e.nextSibling);
    $fb74bc6f62fb4035$var$xg = b;
    $fb74bc6f62fb4035$var$I = !0;
    $fb74bc6f62fb4035$var$zg = null;
    null !== a && ($fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$rg, $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$sg, $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$qg, $fb74bc6f62fb4035$var$rg = a.id, $fb74bc6f62fb4035$var$sg = a.overflow, $fb74bc6f62fb4035$var$qg = b);
    b = $fb74bc6f62fb4035$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fb74bc6f62fb4035$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fb74bc6f62fb4035$var$bh(a.return, b, c);
}
function $fb74bc6f62fb4035$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fb74bc6f62fb4035$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fb74bc6f62fb4035$var$Xi(a, b, d.children, c);
    d = $fb74bc6f62fb4035$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fb74bc6f62fb4035$var$vj(a, c, b);
            else if (19 === a.tag) $fb74bc6f62fb4035$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fb74bc6f62fb4035$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fb74bc6f62fb4035$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fb74bc6f62fb4035$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fb74bc6f62fb4035$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $fb74bc6f62fb4035$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fb74bc6f62fb4035$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fb74bc6f62fb4035$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fb74bc6f62fb4035$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fb74bc6f62fb4035$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fb74bc6f62fb4035$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fb74bc6f62fb4035$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fb74bc6f62fb4035$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $fb74bc6f62fb4035$var$kj(b);
            $fb74bc6f62fb4035$var$Ig();
            break;
        case 5:
            $fb74bc6f62fb4035$var$Ah(b);
            break;
        case 1:
            $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$cg(b);
            break;
        case 4:
            $fb74bc6f62fb4035$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fb74bc6f62fb4035$var$oj(a, b, c);
                $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1);
                a = $fb74bc6f62fb4035$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fb74bc6f62fb4035$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fb74bc6f62fb4035$var$dj(a, b, c);
    }
    return $fb74bc6f62fb4035$var$Zi(a, b, c);
}
var $fb74bc6f62fb4035$var$zj, $fb74bc6f62fb4035$var$Aj, $fb74bc6f62fb4035$var$Bj, $fb74bc6f62fb4035$var$Cj;
$fb74bc6f62fb4035$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fb74bc6f62fb4035$var$Aj = function() {};
$fb74bc6f62fb4035$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fb74bc6f62fb4035$var$Ya(a, e);
                d = $fb74bc6f62fb4035$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fb74bc6f62fb4035$var$A({}, e, {
                    value: void 0
                });
                d = $fb74bc6f62fb4035$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fb74bc6f62fb4035$var$gb(a, e);
                d = $fb74bc6f62fb4035$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fb74bc6f62fb4035$var$Bf);
        }
        $fb74bc6f62fb4035$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fb74bc6f62fb4035$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fb74bc6f62fb4035$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fb74bc6f62fb4035$var$Dj(a, b) {
    if (!$fb74bc6f62fb4035$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fb74bc6f62fb4035$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fb74bc6f62fb4035$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $fb74bc6f62fb4035$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fb74bc6f62fb4035$var$S(b), null;
        case 1:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), $fb74bc6f62fb4035$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fb74bc6f62fb4035$var$zh();
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
            $fb74bc6f62fb4035$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fb74bc6f62fb4035$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fb74bc6f62fb4035$var$zg && ($fb74bc6f62fb4035$var$Fj($fb74bc6f62fb4035$var$zg), $fb74bc6f62fb4035$var$zg = null));
            $fb74bc6f62fb4035$var$Aj(a, b);
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 5:
            $fb74bc6f62fb4035$var$Bh(b);
            var e = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fb74bc6f62fb4035$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fb74bc6f62fb4035$var$p(166));
                    $fb74bc6f62fb4035$var$S(b);
                    return null;
                }
                a = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
                if ($fb74bc6f62fb4035$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fb74bc6f62fb4035$var$Of] = b;
                    d[$fb74bc6f62fb4035$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fb74bc6f62fb4035$var$D("cancel", d);
                            $fb74bc6f62fb4035$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fb74bc6f62fb4035$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fb74bc6f62fb4035$var$lf.length; e++)$fb74bc6f62fb4035$var$D($fb74bc6f62fb4035$var$lf[e], d);
                            break;
                        case "source":
                            $fb74bc6f62fb4035$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fb74bc6f62fb4035$var$D("error", d);
                            $fb74bc6f62fb4035$var$D("load", d);
                            break;
                        case "details":
                            $fb74bc6f62fb4035$var$D("toggle", d);
                            break;
                        case "input":
                            $fb74bc6f62fb4035$var$Za(d, f);
                            $fb74bc6f62fb4035$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fb74bc6f62fb4035$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$hb(d, f), $fb74bc6f62fb4035$var$D("invalid", d);
                    }
                    $fb74bc6f62fb4035$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fb74bc6f62fb4035$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fb74bc6f62fb4035$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fb74bc6f62fb4035$var$Va(d);
                            $fb74bc6f62fb4035$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$Va(d);
                            $fb74bc6f62fb4035$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fb74bc6f62fb4035$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fb74bc6f62fb4035$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fb74bc6f62fb4035$var$Of] = b;
                    a[$fb74bc6f62fb4035$var$Pf] = d;
                    $fb74bc6f62fb4035$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fb74bc6f62fb4035$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fb74bc6f62fb4035$var$D("cancel", a);
                                $fb74bc6f62fb4035$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fb74bc6f62fb4035$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fb74bc6f62fb4035$var$lf.length; e++)$fb74bc6f62fb4035$var$D($fb74bc6f62fb4035$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fb74bc6f62fb4035$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fb74bc6f62fb4035$var$D("error", a);
                                $fb74bc6f62fb4035$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fb74bc6f62fb4035$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fb74bc6f62fb4035$var$Za(a, d);
                                e = $fb74bc6f62fb4035$var$Ya(a, d);
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fb74bc6f62fb4035$var$A({}, d, {
                                    value: void 0
                                });
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fb74bc6f62fb4035$var$hb(a, d);
                                e = $fb74bc6f62fb4035$var$gb(a, d);
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fb74bc6f62fb4035$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fb74bc6f62fb4035$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fb74bc6f62fb4035$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fb74bc6f62fb4035$var$ob(a, k) : "number" === typeof k && $fb74bc6f62fb4035$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fb74bc6f62fb4035$var$D("scroll", a) : null != k && $fb74bc6f62fb4035$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fb74bc6f62fb4035$var$Va(a);
                                $fb74bc6f62fb4035$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fb74bc6f62fb4035$var$Va(a);
                                $fb74bc6f62fb4035$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fb74bc6f62fb4035$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fb74bc6f62fb4035$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fb74bc6f62fb4035$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fb74bc6f62fb4035$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fb74bc6f62fb4035$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fb74bc6f62fb4035$var$p(166));
                c = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
                $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
                if ($fb74bc6f62fb4035$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fb74bc6f62fb4035$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fb74bc6f62fb4035$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fb74bc6f62fb4035$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fb74bc6f62fb4035$var$Of] = b, b.stateNode = d;
            }
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 13:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fb74bc6f62fb4035$var$I && null !== $fb74bc6f62fb4035$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fb74bc6f62fb4035$var$Hg(), $fb74bc6f62fb4035$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fb74bc6f62fb4035$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fb74bc6f62fb4035$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fb74bc6f62fb4035$var$p(317));
                        f[$fb74bc6f62fb4035$var$Of] = b;
                    } else $fb74bc6f62fb4035$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fb74bc6f62fb4035$var$S(b);
                    f = !1;
                } else null !== $fb74bc6f62fb4035$var$zg && ($fb74bc6f62fb4035$var$Fj($fb74bc6f62fb4035$var$zg), $fb74bc6f62fb4035$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fb74bc6f62fb4035$var$L.current & 1) ? 0 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 3) : $fb74bc6f62fb4035$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 4:
            return $fb74bc6f62fb4035$var$zh(), $fb74bc6f62fb4035$var$Aj(a, b), null === a && $fb74bc6f62fb4035$var$sf(b.stateNode.containerInfo), $fb74bc6f62fb4035$var$S(b), null;
        case 10:
            return $fb74bc6f62fb4035$var$ah(b.type._context), $fb74bc6f62fb4035$var$S(b), null;
        case 17:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), $fb74bc6f62fb4035$var$S(b), null;
        case 19:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            f = b.memoizedState;
            if (null === f) return $fb74bc6f62fb4035$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fb74bc6f62fb4035$var$Dj(f, !1);
                else {
                    if (0 !== $fb74bc6f62fb4035$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fb74bc6f62fb4035$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fb74bc6f62fb4035$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fb74bc6f62fb4035$var$B() > $fb74bc6f62fb4035$var$Gj && (b.flags |= 128, d = !0, $fb74bc6f62fb4035$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fb74bc6f62fb4035$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fb74bc6f62fb4035$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fb74bc6f62fb4035$var$I) return $fb74bc6f62fb4035$var$S(b), null;
                    } else 2 * $fb74bc6f62fb4035$var$B() - f.renderingStartTime > $fb74bc6f62fb4035$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $fb74bc6f62fb4035$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fb74bc6f62fb4035$var$B(), b.sibling = null, c = $fb74bc6f62fb4035$var$L.current, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, d ? c & 1 | 2 : c & 1), b;
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 22:
        case 23:
            return $fb74bc6f62fb4035$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fb74bc6f62fb4035$var$fj & 1073741824) && ($fb74bc6f62fb4035$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fb74bc6f62fb4035$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fb74bc6f62fb4035$var$p(156, b.tag));
}
function $fb74bc6f62fb4035$var$Ij(a, b) {
    $fb74bc6f62fb4035$var$wg(b);
    switch(b.tag){
        case 1:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fb74bc6f62fb4035$var$zh(), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H), $fb74bc6f62fb4035$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fb74bc6f62fb4035$var$Bh(b), null;
        case 13:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fb74bc6f62fb4035$var$p(340));
                $fb74bc6f62fb4035$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L), null;
        case 4:
            return $fb74bc6f62fb4035$var$zh(), null;
        case 10:
            return $fb74bc6f62fb4035$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $fb74bc6f62fb4035$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fb74bc6f62fb4035$var$Jj = !1, $fb74bc6f62fb4035$var$U = !1, $fb74bc6f62fb4035$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $fb74bc6f62fb4035$var$V = null;
function $fb74bc6f62fb4035$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fb74bc6f62fb4035$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fb74bc6f62fb4035$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fb74bc6f62fb4035$var$W(a, b, d);
    }
}
var $fb74bc6f62fb4035$var$Nj = !1;
function $fb74bc6f62fb4035$var$Oj(a, b) {
    $fb74bc6f62fb4035$var$Cf = $fb74bc6f62fb4035$var$dd;
    a = $fb74bc6f62fb4035$var$Me();
    if ($fb74bc6f62fb4035$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fb74bc6f62fb4035$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fb74bc6f62fb4035$var$dd = !1;
    for($fb74bc6f62fb4035$var$V = b; null !== $fb74bc6f62fb4035$var$V;)if (b = $fb74bc6f62fb4035$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fb74bc6f62fb4035$var$V = a;
    else for(; null !== $fb74bc6f62fb4035$var$V;){
        b = $fb74bc6f62fb4035$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fb74bc6f62fb4035$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(163));
            }
        } catch (F) {
            $fb74bc6f62fb4035$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fb74bc6f62fb4035$var$V = a;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
    n = $fb74bc6f62fb4035$var$Nj;
    $fb74bc6f62fb4035$var$Nj = !1;
    return n;
}
function $fb74bc6f62fb4035$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fb74bc6f62fb4035$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fb74bc6f62fb4035$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fb74bc6f62fb4035$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fb74bc6f62fb4035$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fb74bc6f62fb4035$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fb74bc6f62fb4035$var$Of], delete b[$fb74bc6f62fb4035$var$Pf], delete b[$fb74bc6f62fb4035$var$of], delete b[$fb74bc6f62fb4035$var$Qf], delete b[$fb74bc6f62fb4035$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fb74bc6f62fb4035$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fb74bc6f62fb4035$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fb74bc6f62fb4035$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fb74bc6f62fb4035$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fb74bc6f62fb4035$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fb74bc6f62fb4035$var$Vj(a, b, c), a = a.sibling; null !== a;)$fb74bc6f62fb4035$var$Vj(a, b, c), a = a.sibling;
}
function $fb74bc6f62fb4035$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fb74bc6f62fb4035$var$Wj(a, b, c), a = a.sibling; null !== a;)$fb74bc6f62fb4035$var$Wj(a, b, c), a = a.sibling;
}
var $fb74bc6f62fb4035$var$X = null, $fb74bc6f62fb4035$var$Xj = !1;
function $fb74bc6f62fb4035$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$fb74bc6f62fb4035$var$Zj(a, b, c), c = c.sibling;
}
function $fb74bc6f62fb4035$var$Zj(a, b, c) {
    if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onCommitFiberUnmount) try {
        $fb74bc6f62fb4035$var$lc.onCommitFiberUnmount($fb74bc6f62fb4035$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fb74bc6f62fb4035$var$U || $fb74bc6f62fb4035$var$Lj(c, b);
        case 6:
            var d = $fb74bc6f62fb4035$var$X, e = $fb74bc6f62fb4035$var$Xj;
            $fb74bc6f62fb4035$var$X = null;
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            $fb74bc6f62fb4035$var$X = d;
            $fb74bc6f62fb4035$var$Xj = e;
            null !== $fb74bc6f62fb4035$var$X && ($fb74bc6f62fb4035$var$Xj ? (a = $fb74bc6f62fb4035$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fb74bc6f62fb4035$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fb74bc6f62fb4035$var$X && ($fb74bc6f62fb4035$var$Xj ? (a = $fb74bc6f62fb4035$var$X, c = c.stateNode, 8 === a.nodeType ? $fb74bc6f62fb4035$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fb74bc6f62fb4035$var$Kf(a, c), $fb74bc6f62fb4035$var$bd(a)) : $fb74bc6f62fb4035$var$Kf($fb74bc6f62fb4035$var$X, c.stateNode));
            break;
        case 4:
            d = $fb74bc6f62fb4035$var$X;
            e = $fb74bc6f62fb4035$var$Xj;
            $fb74bc6f62fb4035$var$X = c.stateNode.containerInfo;
            $fb74bc6f62fb4035$var$Xj = !0;
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            $fb74bc6f62fb4035$var$X = d;
            $fb74bc6f62fb4035$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fb74bc6f62fb4035$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fb74bc6f62fb4035$var$Mj(c, b, g) : 0 !== (f & 4) && $fb74bc6f62fb4035$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 1:
            if (!$fb74bc6f62fb4035$var$U && ($fb74bc6f62fb4035$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fb74bc6f62fb4035$var$W(c, b, h);
            }
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 21:
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fb74bc6f62fb4035$var$U = (d = $fb74bc6f62fb4035$var$U) || null !== c.memoizedState, $fb74bc6f62fb4035$var$Yj(a, b, c), $fb74bc6f62fb4035$var$U = d) : $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        default:
            $fb74bc6f62fb4035$var$Yj(a, b, c);
    }
}
function $fb74bc6f62fb4035$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fb74bc6f62fb4035$var$Kj);
        b.forEach(function(b) {
            var d = $fb74bc6f62fb4035$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fb74bc6f62fb4035$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fb74bc6f62fb4035$var$X = h.stateNode;
                        $fb74bc6f62fb4035$var$Xj = !1;
                        break a;
                    case 3:
                        $fb74bc6f62fb4035$var$X = h.stateNode.containerInfo;
                        $fb74bc6f62fb4035$var$Xj = !0;
                        break a;
                    case 4:
                        $fb74bc6f62fb4035$var$X = h.stateNode.containerInfo;
                        $fb74bc6f62fb4035$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fb74bc6f62fb4035$var$X) throw Error($fb74bc6f62fb4035$var$p(160));
            $fb74bc6f62fb4035$var$Zj(f, g, e);
            $fb74bc6f62fb4035$var$X = null;
            $fb74bc6f62fb4035$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fb74bc6f62fb4035$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fb74bc6f62fb4035$var$dk(b, a), b = b.sibling;
}
function $fb74bc6f62fb4035$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4) {
                try {
                    $fb74bc6f62fb4035$var$Pj(3, a, a.return), $fb74bc6f62fb4035$var$Qj(3, a);
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
                try {
                    $fb74bc6f62fb4035$var$Pj(5, a, a.return);
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 512 && null !== c && $fb74bc6f62fb4035$var$Lj(c, c.return);
            break;
        case 5:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 512 && null !== c && $fb74bc6f62fb4035$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fb74bc6f62fb4035$var$ob(e, "");
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fb74bc6f62fb4035$var$ab(e, f);
                    $fb74bc6f62fb4035$var$vb(h, g);
                    var l = $fb74bc6f62fb4035$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fb74bc6f62fb4035$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fb74bc6f62fb4035$var$nb(e, q) : "children" === m ? $fb74bc6f62fb4035$var$ob(e, q) : $fb74bc6f62fb4035$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fb74bc6f62fb4035$var$bb(e, f);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fb74bc6f62fb4035$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fb74bc6f62fb4035$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fb74bc6f62fb4035$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fb74bc6f62fb4035$var$Pf] = f;
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fb74bc6f62fb4035$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fb74bc6f62fb4035$var$bd(b.containerInfo);
            } catch (t) {
                $fb74bc6f62fb4035$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            break;
        case 13:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fb74bc6f62fb4035$var$fk = $fb74bc6f62fb4035$var$B()));
            d & 4 && $fb74bc6f62fb4035$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fb74bc6f62fb4035$var$U = (l = $fb74bc6f62fb4035$var$U) || m, $fb74bc6f62fb4035$var$ck(b, a), $fb74bc6f62fb4035$var$U = l) : $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fb74bc6f62fb4035$var$V = a, m = a.child; null !== m;){
                    for(q = $fb74bc6f62fb4035$var$V = m; null !== $fb74bc6f62fb4035$var$V;){
                        r = $fb74bc6f62fb4035$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fb74bc6f62fb4035$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $fb74bc6f62fb4035$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fb74bc6f62fb4035$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fb74bc6f62fb4035$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fb74bc6f62fb4035$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fb74bc6f62fb4035$var$V = y) : $fb74bc6f62fb4035$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fb74bc6f62fb4035$var$rb("display", g));
                            } catch (t) {
                                $fb74bc6f62fb4035$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fb74bc6f62fb4035$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 4 && $fb74bc6f62fb4035$var$ak(a);
            break;
        case 21:
            break;
        default:
            $fb74bc6f62fb4035$var$ck(b, a), $fb74bc6f62fb4035$var$ek(a);
    }
}
function $fb74bc6f62fb4035$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fb74bc6f62fb4035$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fb74bc6f62fb4035$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fb74bc6f62fb4035$var$ob(e, ""), d.flags &= -33);
                    var f = $fb74bc6f62fb4035$var$Uj(a);
                    $fb74bc6f62fb4035$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fb74bc6f62fb4035$var$Uj(a);
                    $fb74bc6f62fb4035$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(161));
            }
        } catch (k) {
            $fb74bc6f62fb4035$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fb74bc6f62fb4035$var$hk(a, b, c) {
    $fb74bc6f62fb4035$var$V = a;
    $fb74bc6f62fb4035$var$ik(a, b, c);
}
function $fb74bc6f62fb4035$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fb74bc6f62fb4035$var$V;){
        var e = $fb74bc6f62fb4035$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fb74bc6f62fb4035$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fb74bc6f62fb4035$var$U;
                h = $fb74bc6f62fb4035$var$Jj;
                var l = $fb74bc6f62fb4035$var$U;
                $fb74bc6f62fb4035$var$Jj = g;
                if (($fb74bc6f62fb4035$var$U = k) && !l) for($fb74bc6f62fb4035$var$V = e; null !== $fb74bc6f62fb4035$var$V;)g = $fb74bc6f62fb4035$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fb74bc6f62fb4035$var$jk(e) : null !== k ? (k.return = g, $fb74bc6f62fb4035$var$V = k) : $fb74bc6f62fb4035$var$jk(e);
                for(; null !== f;)$fb74bc6f62fb4035$var$V = f, $fb74bc6f62fb4035$var$ik(f, b, c), f = f.sibling;
                $fb74bc6f62fb4035$var$V = e;
                $fb74bc6f62fb4035$var$Jj = h;
                $fb74bc6f62fb4035$var$U = l;
            }
            $fb74bc6f62fb4035$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fb74bc6f62fb4035$var$V = f) : $fb74bc6f62fb4035$var$kk(a, b, c);
    }
}
function $fb74bc6f62fb4035$var$kk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fb74bc6f62fb4035$var$U || $fb74bc6f62fb4035$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fb74bc6f62fb4035$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fb74bc6f62fb4035$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fb74bc6f62fb4035$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fb74bc6f62fb4035$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fb74bc6f62fb4035$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fb74bc6f62fb4035$var$p(163));
                }
                $fb74bc6f62fb4035$var$U || b.flags & 512 && $fb74bc6f62fb4035$var$Rj(b);
            } catch (r) {
                $fb74bc6f62fb4035$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fb74bc6f62fb4035$var$V = c;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
function $fb74bc6f62fb4035$var$gk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fb74bc6f62fb4035$var$V = c;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
function $fb74bc6f62fb4035$var$jk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Qj(4, b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fb74bc6f62fb4035$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Rj(b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Rj(b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fb74bc6f62fb4035$var$W(b, b.return, k);
        }
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fb74bc6f62fb4035$var$V = h;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
var $fb74bc6f62fb4035$var$lk = Math.ceil, $fb74bc6f62fb4035$var$mk = $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher, $fb74bc6f62fb4035$var$nk = $fb74bc6f62fb4035$var$ua.ReactCurrentOwner, $fb74bc6f62fb4035$var$ok = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$K = 0, $fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Y = null, $fb74bc6f62fb4035$var$Z = 0, $fb74bc6f62fb4035$var$fj = 0, $fb74bc6f62fb4035$var$ej = $fb74bc6f62fb4035$var$Uf(0), $fb74bc6f62fb4035$var$T = 0, $fb74bc6f62fb4035$var$pk = null, $fb74bc6f62fb4035$var$rh = 0, $fb74bc6f62fb4035$var$qk = 0, $fb74bc6f62fb4035$var$rk = 0, $fb74bc6f62fb4035$var$sk = null, $fb74bc6f62fb4035$var$tk = null, $fb74bc6f62fb4035$var$fk = 0, $fb74bc6f62fb4035$var$Gj = Infinity, $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Oi = !1, $fb74bc6f62fb4035$var$Pi = null, $fb74bc6f62fb4035$var$Ri = null, $fb74bc6f62fb4035$var$vk = !1, $fb74bc6f62fb4035$var$wk = null, $fb74bc6f62fb4035$var$xk = 0, $fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = null, $fb74bc6f62fb4035$var$Ak = -1, $fb74bc6f62fb4035$var$Bk = 0;
function $fb74bc6f62fb4035$var$R() {
    return 0 !== ($fb74bc6f62fb4035$var$K & 6) ? $fb74bc6f62fb4035$var$B() : -1 !== $fb74bc6f62fb4035$var$Ak ? $fb74bc6f62fb4035$var$Ak : $fb74bc6f62fb4035$var$Ak = $fb74bc6f62fb4035$var$B();
}
function $fb74bc6f62fb4035$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fb74bc6f62fb4035$var$K & 2) && 0 !== $fb74bc6f62fb4035$var$Z) return $fb74bc6f62fb4035$var$Z & -$fb74bc6f62fb4035$var$Z;
    if (null !== $fb74bc6f62fb4035$var$Kg.transition) return 0 === $fb74bc6f62fb4035$var$Bk && ($fb74bc6f62fb4035$var$Bk = $fb74bc6f62fb4035$var$yc()), $fb74bc6f62fb4035$var$Bk;
    a = $fb74bc6f62fb4035$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fb74bc6f62fb4035$var$jd(a.type);
    return a;
}
function $fb74bc6f62fb4035$var$gi(a, b, c, d) {
    if (50 < $fb74bc6f62fb4035$var$yk) throw $fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = null, Error($fb74bc6f62fb4035$var$p(185));
    $fb74bc6f62fb4035$var$Ac(a, c, d);
    if (0 === ($fb74bc6f62fb4035$var$K & 2) || a !== $fb74bc6f62fb4035$var$Q) a === $fb74bc6f62fb4035$var$Q && (0 === ($fb74bc6f62fb4035$var$K & 2) && ($fb74bc6f62fb4035$var$qk |= c), 4 === $fb74bc6f62fb4035$var$T && $fb74bc6f62fb4035$var$Ck(a, $fb74bc6f62fb4035$var$Z)), $fb74bc6f62fb4035$var$Dk(a, d), 1 === c && 0 === $fb74bc6f62fb4035$var$K && 0 === (b.mode & 1) && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$fg && $fb74bc6f62fb4035$var$jg());
}
function $fb74bc6f62fb4035$var$Dk(a, b) {
    var c = a.callbackNode;
    $fb74bc6f62fb4035$var$wc(a, b);
    var d = $fb74bc6f62fb4035$var$uc(a, a === $fb74bc6f62fb4035$var$Q ? $fb74bc6f62fb4035$var$Z : 0);
    if (0 === d) null !== c && $fb74bc6f62fb4035$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fb74bc6f62fb4035$var$bc(c);
        if (1 === b) 0 === a.tag ? $fb74bc6f62fb4035$var$ig($fb74bc6f62fb4035$var$Ek.bind(null, a)) : $fb74bc6f62fb4035$var$hg($fb74bc6f62fb4035$var$Ek.bind(null, a)), $fb74bc6f62fb4035$var$Jf(function() {
            0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$jg();
        }), c = null;
        else {
            switch($fb74bc6f62fb4035$var$Dc(d)){
                case 1:
                    c = $fb74bc6f62fb4035$var$fc;
                    break;
                case 4:
                    c = $fb74bc6f62fb4035$var$gc;
                    break;
                case 16:
                    c = $fb74bc6f62fb4035$var$hc;
                    break;
                case 536870912:
                    c = $fb74bc6f62fb4035$var$jc;
                    break;
                default:
                    c = $fb74bc6f62fb4035$var$hc;
            }
            c = $fb74bc6f62fb4035$var$Fk(c, $fb74bc6f62fb4035$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fb74bc6f62fb4035$var$Gk(a, b) {
    $fb74bc6f62fb4035$var$Ak = -1;
    $fb74bc6f62fb4035$var$Bk = 0;
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    var c = a.callbackNode;
    if ($fb74bc6f62fb4035$var$Hk() && a.callbackNode !== c) return null;
    var d = $fb74bc6f62fb4035$var$uc(a, a === $fb74bc6f62fb4035$var$Q ? $fb74bc6f62fb4035$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fb74bc6f62fb4035$var$Ik(a, d);
    else {
        b = d;
        var e = $fb74bc6f62fb4035$var$K;
        $fb74bc6f62fb4035$var$K |= 2;
        var f = $fb74bc6f62fb4035$var$Jk();
        if ($fb74bc6f62fb4035$var$Q !== a || $fb74bc6f62fb4035$var$Z !== b) $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$Kk(a, b);
        for(;;)try {
            $fb74bc6f62fb4035$var$Lk();
            break;
        } catch (h) {
            $fb74bc6f62fb4035$var$Mk(a, h);
        }
        $fb74bc6f62fb4035$var$$g();
        $fb74bc6f62fb4035$var$mk.current = f;
        $fb74bc6f62fb4035$var$K = e;
        null !== $fb74bc6f62fb4035$var$Y ? b = 0 : ($fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Z = 0, b = $fb74bc6f62fb4035$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fb74bc6f62fb4035$var$xc(a), 0 !== e && (d = e, b = $fb74bc6f62fb4035$var$Nk(a, e)));
        if (1 === b) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, d), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
        if (6 === b) $fb74bc6f62fb4035$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fb74bc6f62fb4035$var$Ok(e) && (b = $fb74bc6f62fb4035$var$Ik(a, d), 2 === b && (f = $fb74bc6f62fb4035$var$xc(a), 0 !== f && (d = f, b = $fb74bc6f62fb4035$var$Nk(a, f))), 1 === b)) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, d), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fb74bc6f62fb4035$var$p(345));
                case 2:
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 3:
                    $fb74bc6f62fb4035$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $fb74bc6f62fb4035$var$fk + 500 - $fb74bc6f62fb4035$var$B(), 10 < b)) {
                        if (0 !== $fb74bc6f62fb4035$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fb74bc6f62fb4035$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fb74bc6f62fb4035$var$Ff($fb74bc6f62fb4035$var$Pk.bind(null, a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk), b);
                        break;
                    }
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 4:
                    $fb74bc6f62fb4035$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fb74bc6f62fb4035$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fb74bc6f62fb4035$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fb74bc6f62fb4035$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fb74bc6f62fb4035$var$Ff($fb74bc6f62fb4035$var$Pk.bind(null, a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk), d);
                        break;
                    }
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 5:
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(329));
            }
        }
    }
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    return a.callbackNode === c ? $fb74bc6f62fb4035$var$Gk.bind(null, a) : null;
}
function $fb74bc6f62fb4035$var$Nk(a, b) {
    var c = $fb74bc6f62fb4035$var$sk;
    a.current.memoizedState.isDehydrated && ($fb74bc6f62fb4035$var$Kk(a, b).flags |= 256);
    a = $fb74bc6f62fb4035$var$Ik(a, b);
    2 !== a && (b = $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$tk = c, null !== b && $fb74bc6f62fb4035$var$Fj(b));
    return a;
}
function $fb74bc6f62fb4035$var$Fj(a) {
    null === $fb74bc6f62fb4035$var$tk ? $fb74bc6f62fb4035$var$tk = a : $fb74bc6f62fb4035$var$tk.push.apply($fb74bc6f62fb4035$var$tk, a);
}
function $fb74bc6f62fb4035$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fb74bc6f62fb4035$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Ck(a, b) {
    b &= ~$fb74bc6f62fb4035$var$rk;
    b &= ~$fb74bc6f62fb4035$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fb74bc6f62fb4035$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fb74bc6f62fb4035$var$Ek(a) {
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    $fb74bc6f62fb4035$var$Hk();
    var b = $fb74bc6f62fb4035$var$uc(a, 0);
    if (0 === (b & 1)) return $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), null;
    var c = $fb74bc6f62fb4035$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fb74bc6f62fb4035$var$xc(a);
        0 !== d && (b = d, c = $fb74bc6f62fb4035$var$Nk(a, d));
    }
    if (1 === c) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, b), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
    if (6 === c) throw Error($fb74bc6f62fb4035$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    return null;
}
function $fb74bc6f62fb4035$var$Qk(a, b) {
    var c = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fb74bc6f62fb4035$var$K = c, 0 === $fb74bc6f62fb4035$var$K && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$fg && $fb74bc6f62fb4035$var$jg());
    }
}
function $fb74bc6f62fb4035$var$Rk(a) {
    null !== $fb74bc6f62fb4035$var$wk && 0 === $fb74bc6f62fb4035$var$wk.tag && 0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$Hk();
    var b = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 1;
    var c = $fb74bc6f62fb4035$var$ok.transition, d = $fb74bc6f62fb4035$var$C;
    try {
        if ($fb74bc6f62fb4035$var$ok.transition = null, $fb74bc6f62fb4035$var$C = 1, a) return a();
    } finally{
        $fb74bc6f62fb4035$var$C = d, $fb74bc6f62fb4035$var$ok.transition = c, $fb74bc6f62fb4035$var$K = b, 0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$jg();
    }
}
function $fb74bc6f62fb4035$var$Hj() {
    $fb74bc6f62fb4035$var$fj = $fb74bc6f62fb4035$var$ej.current;
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$ej);
}
function $fb74bc6f62fb4035$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fb74bc6f62fb4035$var$Gf(c));
    if (null !== $fb74bc6f62fb4035$var$Y) for(c = $fb74bc6f62fb4035$var$Y.return; null !== c;){
        var d = c;
        $fb74bc6f62fb4035$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fb74bc6f62fb4035$var$$f();
                break;
            case 3:
                $fb74bc6f62fb4035$var$zh();
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
                $fb74bc6f62fb4035$var$Eh();
                break;
            case 5:
                $fb74bc6f62fb4035$var$Bh(d);
                break;
            case 4:
                $fb74bc6f62fb4035$var$zh();
                break;
            case 13:
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
                break;
            case 19:
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
                break;
            case 10:
                $fb74bc6f62fb4035$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $fb74bc6f62fb4035$var$Hj();
        }
        c = c.return;
    }
    $fb74bc6f62fb4035$var$Q = a;
    $fb74bc6f62fb4035$var$Y = a = $fb74bc6f62fb4035$var$Pg(a.current, null);
    $fb74bc6f62fb4035$var$Z = $fb74bc6f62fb4035$var$fj = b;
    $fb74bc6f62fb4035$var$T = 0;
    $fb74bc6f62fb4035$var$pk = null;
    $fb74bc6f62fb4035$var$rk = $fb74bc6f62fb4035$var$qk = $fb74bc6f62fb4035$var$rh = 0;
    $fb74bc6f62fb4035$var$tk = $fb74bc6f62fb4035$var$sk = null;
    if (null !== $fb74bc6f62fb4035$var$fh) {
        for(b = 0; b < $fb74bc6f62fb4035$var$fh.length; b++)if (c = $fb74bc6f62fb4035$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fb74bc6f62fb4035$var$fh = null;
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mk(a, b) {
    do {
        var c = $fb74bc6f62fb4035$var$Y;
        try {
            $fb74bc6f62fb4035$var$$g();
            $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Rh;
            if ($fb74bc6f62fb4035$var$Ih) {
                for(var d = $fb74bc6f62fb4035$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fb74bc6f62fb4035$var$Ih = !1;
            }
            $fb74bc6f62fb4035$var$Hh = 0;
            $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = $fb74bc6f62fb4035$var$M = null;
            $fb74bc6f62fb4035$var$Jh = !1;
            $fb74bc6f62fb4035$var$Kh = 0;
            $fb74bc6f62fb4035$var$nk.current = null;
            if (null === c || null === c.return) {
                $fb74bc6f62fb4035$var$T = 1;
                $fb74bc6f62fb4035$var$pk = b;
                $fb74bc6f62fb4035$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fb74bc6f62fb4035$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fb74bc6f62fb4035$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fb74bc6f62fb4035$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $fb74bc6f62fb4035$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fb74bc6f62fb4035$var$Si(f, l, b);
                            $fb74bc6f62fb4035$var$tj();
                            break a;
                        }
                        k = Error($fb74bc6f62fb4035$var$p(426));
                    }
                } else if ($fb74bc6f62fb4035$var$I && h.mode & 1) {
                    var J = $fb74bc6f62fb4035$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fb74bc6f62fb4035$var$Vi(J, g, h, f, b);
                        $fb74bc6f62fb4035$var$Jg($fb74bc6f62fb4035$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $fb74bc6f62fb4035$var$Ji(k, h);
                4 !== $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 2);
                null === $fb74bc6f62fb4035$var$sk ? $fb74bc6f62fb4035$var$sk = [
                    f
                ] : $fb74bc6f62fb4035$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fb74bc6f62fb4035$var$Ni(f, k, b);
                            $fb74bc6f62fb4035$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fb74bc6f62fb4035$var$Ri || !$fb74bc6f62fb4035$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fb74bc6f62fb4035$var$Qi(f, h, b);
                                $fb74bc6f62fb4035$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fb74bc6f62fb4035$var$Sk(c);
        } catch (na) {
            b = na;
            $fb74bc6f62fb4035$var$Y === c && null !== c && ($fb74bc6f62fb4035$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fb74bc6f62fb4035$var$Jk() {
    var a = $fb74bc6f62fb4035$var$mk.current;
    $fb74bc6f62fb4035$var$mk.current = $fb74bc6f62fb4035$var$Rh;
    return null === a ? $fb74bc6f62fb4035$var$Rh : a;
}
function $fb74bc6f62fb4035$var$tj() {
    if (0 === $fb74bc6f62fb4035$var$T || 3 === $fb74bc6f62fb4035$var$T || 2 === $fb74bc6f62fb4035$var$T) $fb74bc6f62fb4035$var$T = 4;
    null === $fb74bc6f62fb4035$var$Q || 0 === ($fb74bc6f62fb4035$var$rh & 268435455) && 0 === ($fb74bc6f62fb4035$var$qk & 268435455) || $fb74bc6f62fb4035$var$Ck($fb74bc6f62fb4035$var$Q, $fb74bc6f62fb4035$var$Z);
}
function $fb74bc6f62fb4035$var$Ik(a, b) {
    var c = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 2;
    var d = $fb74bc6f62fb4035$var$Jk();
    if ($fb74bc6f62fb4035$var$Q !== a || $fb74bc6f62fb4035$var$Z !== b) $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Kk(a, b);
    for(;;)try {
        $fb74bc6f62fb4035$var$Tk();
        break;
    } catch (e) {
        $fb74bc6f62fb4035$var$Mk(a, e);
    }
    $fb74bc6f62fb4035$var$$g();
    $fb74bc6f62fb4035$var$K = c;
    $fb74bc6f62fb4035$var$mk.current = d;
    if (null !== $fb74bc6f62fb4035$var$Y) throw Error($fb74bc6f62fb4035$var$p(261));
    $fb74bc6f62fb4035$var$Q = null;
    $fb74bc6f62fb4035$var$Z = 0;
    return $fb74bc6f62fb4035$var$T;
}
function $fb74bc6f62fb4035$var$Tk() {
    for(; null !== $fb74bc6f62fb4035$var$Y;)$fb74bc6f62fb4035$var$Uk($fb74bc6f62fb4035$var$Y);
}
function $fb74bc6f62fb4035$var$Lk() {
    for(; null !== $fb74bc6f62fb4035$var$Y && !$fb74bc6f62fb4035$var$cc();)$fb74bc6f62fb4035$var$Uk($fb74bc6f62fb4035$var$Y);
}
function $fb74bc6f62fb4035$var$Uk(a) {
    var b = $fb74bc6f62fb4035$var$Vk(a.alternate, a, $fb74bc6f62fb4035$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fb74bc6f62fb4035$var$Sk(a) : $fb74bc6f62fb4035$var$Y = b;
    $fb74bc6f62fb4035$var$nk.current = null;
}
function $fb74bc6f62fb4035$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fb74bc6f62fb4035$var$Ej(c, b, $fb74bc6f62fb4035$var$fj), null !== c) {
                $fb74bc6f62fb4035$var$Y = c;
                return;
            }
        } else {
            c = $fb74bc6f62fb4035$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fb74bc6f62fb4035$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fb74bc6f62fb4035$var$T = 6;
                $fb74bc6f62fb4035$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fb74bc6f62fb4035$var$Y = b;
            return;
        }
        $fb74bc6f62fb4035$var$Y = b = a;
    }while (null !== b);
    0 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 5);
}
function $fb74bc6f62fb4035$var$Pk(a, b, c) {
    var d = $fb74bc6f62fb4035$var$C, e = $fb74bc6f62fb4035$var$ok.transition;
    try {
        $fb74bc6f62fb4035$var$ok.transition = null, $fb74bc6f62fb4035$var$C = 1, $fb74bc6f62fb4035$var$Wk(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$ok.transition = e, $fb74bc6f62fb4035$var$C = d;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Wk(a, b, c, d) {
    do $fb74bc6f62fb4035$var$Hk();
    while (null !== $fb74bc6f62fb4035$var$wk);
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fb74bc6f62fb4035$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fb74bc6f62fb4035$var$Bc(a, f);
    a === $fb74bc6f62fb4035$var$Q && ($fb74bc6f62fb4035$var$Y = $fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fb74bc6f62fb4035$var$vk || ($fb74bc6f62fb4035$var$vk = !0, $fb74bc6f62fb4035$var$Fk($fb74bc6f62fb4035$var$hc, function() {
        $fb74bc6f62fb4035$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fb74bc6f62fb4035$var$ok.transition;
        $fb74bc6f62fb4035$var$ok.transition = null;
        var g = $fb74bc6f62fb4035$var$C;
        $fb74bc6f62fb4035$var$C = 1;
        var h = $fb74bc6f62fb4035$var$K;
        $fb74bc6f62fb4035$var$K |= 4;
        $fb74bc6f62fb4035$var$nk.current = null;
        $fb74bc6f62fb4035$var$Oj(a, c);
        $fb74bc6f62fb4035$var$dk(c, a);
        $fb74bc6f62fb4035$var$Oe($fb74bc6f62fb4035$var$Df);
        $fb74bc6f62fb4035$var$dd = !!$fb74bc6f62fb4035$var$Cf;
        $fb74bc6f62fb4035$var$Df = $fb74bc6f62fb4035$var$Cf = null;
        a.current = c;
        $fb74bc6f62fb4035$var$hk(c, a, e);
        $fb74bc6f62fb4035$var$dc();
        $fb74bc6f62fb4035$var$K = h;
        $fb74bc6f62fb4035$var$C = g;
        $fb74bc6f62fb4035$var$ok.transition = f;
    } else a.current = c;
    $fb74bc6f62fb4035$var$vk && ($fb74bc6f62fb4035$var$vk = !1, $fb74bc6f62fb4035$var$wk = a, $fb74bc6f62fb4035$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($fb74bc6f62fb4035$var$Ri = null);
    $fb74bc6f62fb4035$var$mc(c.stateNode, d);
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fb74bc6f62fb4035$var$Oi) throw $fb74bc6f62fb4035$var$Oi = !1, a = $fb74bc6f62fb4035$var$Pi, $fb74bc6f62fb4035$var$Pi = null, a;
    0 !== ($fb74bc6f62fb4035$var$xk & 1) && 0 !== a.tag && $fb74bc6f62fb4035$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fb74bc6f62fb4035$var$zk ? $fb74bc6f62fb4035$var$yk++ : ($fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = a) : $fb74bc6f62fb4035$var$yk = 0;
    $fb74bc6f62fb4035$var$jg();
    return null;
}
function $fb74bc6f62fb4035$var$Hk() {
    if (null !== $fb74bc6f62fb4035$var$wk) {
        var a = $fb74bc6f62fb4035$var$Dc($fb74bc6f62fb4035$var$xk), b = $fb74bc6f62fb4035$var$ok.transition, c = $fb74bc6f62fb4035$var$C;
        try {
            $fb74bc6f62fb4035$var$ok.transition = null;
            $fb74bc6f62fb4035$var$C = 16 > a ? 16 : a;
            if (null === $fb74bc6f62fb4035$var$wk) var d = !1;
            else {
                a = $fb74bc6f62fb4035$var$wk;
                $fb74bc6f62fb4035$var$wk = null;
                $fb74bc6f62fb4035$var$xk = 0;
                if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(331));
                var e = $fb74bc6f62fb4035$var$K;
                $fb74bc6f62fb4035$var$K |= 4;
                for($fb74bc6f62fb4035$var$V = a.current; null !== $fb74bc6f62fb4035$var$V;){
                    var f = $fb74bc6f62fb4035$var$V, g = f.child;
                    if (0 !== ($fb74bc6f62fb4035$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fb74bc6f62fb4035$var$V = l; null !== $fb74bc6f62fb4035$var$V;){
                                    var m = $fb74bc6f62fb4035$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fb74bc6f62fb4035$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fb74bc6f62fb4035$var$V = q;
                                    else for(; null !== $fb74bc6f62fb4035$var$V;){
                                        m = $fb74bc6f62fb4035$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fb74bc6f62fb4035$var$Sj(m);
                                        if (m === l) {
                                            $fb74bc6f62fb4035$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fb74bc6f62fb4035$var$V = r;
                                            break;
                                        }
                                        $fb74bc6f62fb4035$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fb74bc6f62fb4035$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fb74bc6f62fb4035$var$V = g;
                    else b: for(; null !== $fb74bc6f62fb4035$var$V;){
                        f = $fb74bc6f62fb4035$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fb74bc6f62fb4035$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fb74bc6f62fb4035$var$V = x;
                            break b;
                        }
                        $fb74bc6f62fb4035$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fb74bc6f62fb4035$var$V = w; null !== $fb74bc6f62fb4035$var$V;){
                    g = $fb74bc6f62fb4035$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fb74bc6f62fb4035$var$V = u;
                    else b: for(g = w; null !== $fb74bc6f62fb4035$var$V;){
                        h = $fb74bc6f62fb4035$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fb74bc6f62fb4035$var$Qj(9, h);
                            }
                        } catch (na) {
                            $fb74bc6f62fb4035$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fb74bc6f62fb4035$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fb74bc6f62fb4035$var$V = F;
                            break b;
                        }
                        $fb74bc6f62fb4035$var$V = h.return;
                    }
                }
                $fb74bc6f62fb4035$var$K = e;
                $fb74bc6f62fb4035$var$jg();
                if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onPostCommitFiberRoot) try {
                    $fb74bc6f62fb4035$var$lc.onPostCommitFiberRoot($fb74bc6f62fb4035$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fb74bc6f62fb4035$var$C = c, $fb74bc6f62fb4035$var$ok.transition = b;
        }
    }
    return !1;
}
function $fb74bc6f62fb4035$var$Xk(a, b, c) {
    b = $fb74bc6f62fb4035$var$Ji(c, b);
    b = $fb74bc6f62fb4035$var$Ni(a, b, 1);
    a = $fb74bc6f62fb4035$var$nh(a, b, 1);
    b = $fb74bc6f62fb4035$var$R();
    null !== a && ($fb74bc6f62fb4035$var$Ac(a, 1, b), $fb74bc6f62fb4035$var$Dk(a, b));
}
function $fb74bc6f62fb4035$var$W(a, b, c) {
    if (3 === a.tag) $fb74bc6f62fb4035$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fb74bc6f62fb4035$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fb74bc6f62fb4035$var$Ri || !$fb74bc6f62fb4035$var$Ri.has(d))) {
                a = $fb74bc6f62fb4035$var$Ji(c, a);
                a = $fb74bc6f62fb4035$var$Qi(b, a, 1);
                b = $fb74bc6f62fb4035$var$nh(b, a, 1);
                a = $fb74bc6f62fb4035$var$R();
                null !== b && ($fb74bc6f62fb4035$var$Ac(b, 1, a), $fb74bc6f62fb4035$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fb74bc6f62fb4035$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fb74bc6f62fb4035$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $fb74bc6f62fb4035$var$Q === a && ($fb74bc6f62fb4035$var$Z & c) === c && (4 === $fb74bc6f62fb4035$var$T || 3 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$Z & 130023424) === $fb74bc6f62fb4035$var$Z && 500 > $fb74bc6f62fb4035$var$B() - $fb74bc6f62fb4035$var$fk ? $fb74bc6f62fb4035$var$Kk(a, 0) : $fb74bc6f62fb4035$var$rk |= c);
    $fb74bc6f62fb4035$var$Dk(a, b);
}
function $fb74bc6f62fb4035$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fb74bc6f62fb4035$var$sc, $fb74bc6f62fb4035$var$sc <<= 1, 0 === ($fb74bc6f62fb4035$var$sc & 130023424) && ($fb74bc6f62fb4035$var$sc = 4194304)));
    var c = $fb74bc6f62fb4035$var$R();
    a = $fb74bc6f62fb4035$var$ih(a, b);
    null !== a && ($fb74bc6f62fb4035$var$Ac(a, b, c), $fb74bc6f62fb4035$var$Dk(a, c));
}
function $fb74bc6f62fb4035$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fb74bc6f62fb4035$var$Yk(a, c);
}
function $fb74bc6f62fb4035$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fb74bc6f62fb4035$var$p(314));
    }
    null !== d && d.delete(b);
    $fb74bc6f62fb4035$var$Yk(a, c);
}
var $fb74bc6f62fb4035$var$Vk;
$fb74bc6f62fb4035$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fb74bc6f62fb4035$var$Wf.current) $fb74bc6f62fb4035$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fb74bc6f62fb4035$var$dh = !1, $fb74bc6f62fb4035$var$yj(a, b, c);
            $fb74bc6f62fb4035$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fb74bc6f62fb4035$var$dh = !1, $fb74bc6f62fb4035$var$I && 0 !== (b.flags & 1048576) && $fb74bc6f62fb4035$var$ug(b, $fb74bc6f62fb4035$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fb74bc6f62fb4035$var$ij(a, b);
            a = b.pendingProps;
            var e = $fb74bc6f62fb4035$var$Yf(b, $fb74bc6f62fb4035$var$H.current);
            $fb74bc6f62fb4035$var$ch(b, c);
            e = $fb74bc6f62fb4035$var$Nh(null, b, d, a, e, c);
            var f = $fb74bc6f62fb4035$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fb74bc6f62fb4035$var$Zf(d) ? (f = !0, $fb74bc6f62fb4035$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fb74bc6f62fb4035$var$kh(b), e.updater = $fb74bc6f62fb4035$var$Ei, b.stateNode = e, e._reactInternals = b, $fb74bc6f62fb4035$var$Ii(b, d, a, c), b = $fb74bc6f62fb4035$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $fb74bc6f62fb4035$var$I && f && $fb74bc6f62fb4035$var$vg(b), $fb74bc6f62fb4035$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fb74bc6f62fb4035$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fb74bc6f62fb4035$var$Zk(d);
                a = $fb74bc6f62fb4035$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $fb74bc6f62fb4035$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fb74bc6f62fb4035$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fb74bc6f62fb4035$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fb74bc6f62fb4035$var$$i(null, b, d, $fb74bc6f62fb4035$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($fb74bc6f62fb4035$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $fb74bc6f62fb4035$var$kj(b);
                if (null === a) throw Error($fb74bc6f62fb4035$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fb74bc6f62fb4035$var$lh(a, b);
                $fb74bc6f62fb4035$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fb74bc6f62fb4035$var$Ji(Error($fb74bc6f62fb4035$var$p(423)), b);
                        b = $fb74bc6f62fb4035$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fb74bc6f62fb4035$var$Ji(Error($fb74bc6f62fb4035$var$p(424)), b);
                        b = $fb74bc6f62fb4035$var$lj(a, b, d, c, e);
                        break a;
                    } else for($fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(b.stateNode.containerInfo.firstChild), $fb74bc6f62fb4035$var$xg = b, $fb74bc6f62fb4035$var$I = !0, $fb74bc6f62fb4035$var$zg = null, c = $fb74bc6f62fb4035$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fb74bc6f62fb4035$var$Ig();
                    if (d === e) {
                        b = $fb74bc6f62fb4035$var$Zi(a, b, c);
                        break a;
                    }
                    $fb74bc6f62fb4035$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fb74bc6f62fb4035$var$Ah(b), null === a && $fb74bc6f62fb4035$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fb74bc6f62fb4035$var$Ef(d, e) ? g = null : null !== f && $fb74bc6f62fb4035$var$Ef(d, f) && (b.flags |= 32), $fb74bc6f62fb4035$var$gj(a, b), $fb74bc6f62fb4035$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $fb74bc6f62fb4035$var$Eg(b), null;
        case 13:
            return $fb74bc6f62fb4035$var$oj(a, b, c);
        case 4:
            return $fb74bc6f62fb4035$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fb74bc6f62fb4035$var$Ug(b, null, d, c) : $fb74bc6f62fb4035$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$Yi(a, b, d, e, c);
        case 7:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fb74bc6f62fb4035$var$He(f.value, g)) {
                        if (f.children === e.children && !$fb74bc6f62fb4035$var$Wf.current) {
                            b = $fb74bc6f62fb4035$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fb74bc6f62fb4035$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fb74bc6f62fb4035$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fb74bc6f62fb4035$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fb74bc6f62fb4035$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fb74bc6f62fb4035$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fb74bc6f62fb4035$var$ch(b, c), e = $fb74bc6f62fb4035$var$eh(e), d = d(e), b.flags |= 1, $fb74bc6f62fb4035$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fb74bc6f62fb4035$var$Ci(d, b.pendingProps), e = $fb74bc6f62fb4035$var$Ci(d.type, e), $fb74bc6f62fb4035$var$$i(a, b, d, e, c);
        case 15:
            return $fb74bc6f62fb4035$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$ij(a, b), b.tag = 1, $fb74bc6f62fb4035$var$Zf(d) ? (a = !0, $fb74bc6f62fb4035$var$cg(b)) : a = !1, $fb74bc6f62fb4035$var$ch(b, c), $fb74bc6f62fb4035$var$Gi(b, d, e), $fb74bc6f62fb4035$var$Ii(b, d, e, c), $fb74bc6f62fb4035$var$jj(null, b, d, !0, a, c);
        case 19:
            return $fb74bc6f62fb4035$var$xj(a, b, c);
        case 22:
            return $fb74bc6f62fb4035$var$dj(a, b, c);
    }
    throw Error($fb74bc6f62fb4035$var$p(156, b.tag));
};
function $fb74bc6f62fb4035$var$Fk(a, b) {
    return $fb74bc6f62fb4035$var$ac(a, b);
}
function $fb74bc6f62fb4035$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fb74bc6f62fb4035$var$Bg(a, b, c, d) {
    return new $fb74bc6f62fb4035$var$$k(a, b, c, d);
}
function $fb74bc6f62fb4035$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fb74bc6f62fb4035$var$Zk(a) {
    if ("function" === typeof a) return $fb74bc6f62fb4035$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fb74bc6f62fb4035$var$Da) return 11;
        if (a === $fb74bc6f62fb4035$var$Ga) return 14;
    }
    return 2;
}
function $fb74bc6f62fb4035$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $fb74bc6f62fb4035$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fb74bc6f62fb4035$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fb74bc6f62fb4035$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fb74bc6f62fb4035$var$ya:
            return $fb74bc6f62fb4035$var$Tg(c.children, e, f, b);
        case $fb74bc6f62fb4035$var$za:
            g = 8;
            e |= 8;
            break;
        case $fb74bc6f62fb4035$var$Aa:
            return a = $fb74bc6f62fb4035$var$Bg(12, c, b, e | 2), a.elementType = $fb74bc6f62fb4035$var$Aa, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Ea:
            return a = $fb74bc6f62fb4035$var$Bg(13, c, b, e), a.elementType = $fb74bc6f62fb4035$var$Ea, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Fa:
            return a = $fb74bc6f62fb4035$var$Bg(19, c, b, e), a.elementType = $fb74bc6f62fb4035$var$Fa, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Ia:
            return $fb74bc6f62fb4035$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fb74bc6f62fb4035$var$Ba:
                    g = 10;
                    break a;
                case $fb74bc6f62fb4035$var$Ca:
                    g = 9;
                    break a;
                case $fb74bc6f62fb4035$var$Da:
                    g = 11;
                    break a;
                case $fb74bc6f62fb4035$var$Ga:
                    g = 14;
                    break a;
                case $fb74bc6f62fb4035$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fb74bc6f62fb4035$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fb74bc6f62fb4035$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fb74bc6f62fb4035$var$Tg(a, b, c, d) {
    a = $fb74bc6f62fb4035$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fb74bc6f62fb4035$var$pj(a, b, c, d) {
    a = $fb74bc6f62fb4035$var$Bg(22, a, d, b);
    a.elementType = $fb74bc6f62fb4035$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fb74bc6f62fb4035$var$Qg(a, b, c) {
    a = $fb74bc6f62fb4035$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fb74bc6f62fb4035$var$Sg(a, b, c) {
    b = $fb74bc6f62fb4035$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fb74bc6f62fb4035$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fb74bc6f62fb4035$var$zc(0);
    this.expirationTimes = $fb74bc6f62fb4035$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fb74bc6f62fb4035$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fb74bc6f62fb4035$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $fb74bc6f62fb4035$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fb74bc6f62fb4035$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fb74bc6f62fb4035$var$kh(f);
    return a;
}
function $fb74bc6f62fb4035$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fb74bc6f62fb4035$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fb74bc6f62fb4035$var$dl(a) {
    if (!a) return $fb74bc6f62fb4035$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fb74bc6f62fb4035$var$Vb(a) !== a || 1 !== a.tag) throw Error($fb74bc6f62fb4035$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fb74bc6f62fb4035$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fb74bc6f62fb4035$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fb74bc6f62fb4035$var$Zf(c)) return $fb74bc6f62fb4035$var$bg(a, c, b);
    }
    return b;
}
function $fb74bc6f62fb4035$var$el(a, b, c, d, e, f, g, h, k) {
    a = $fb74bc6f62fb4035$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $fb74bc6f62fb4035$var$dl(null);
    c = a.current;
    d = $fb74bc6f62fb4035$var$R();
    e = $fb74bc6f62fb4035$var$yi(c);
    f = $fb74bc6f62fb4035$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fb74bc6f62fb4035$var$nh(c, f, e);
    a.current.lanes = e;
    $fb74bc6f62fb4035$var$Ac(a, e, d);
    $fb74bc6f62fb4035$var$Dk(a, d);
    return a;
}
function $fb74bc6f62fb4035$var$fl(a, b, c, d) {
    var e = b.current, f = $fb74bc6f62fb4035$var$R(), g = $fb74bc6f62fb4035$var$yi(e);
    c = $fb74bc6f62fb4035$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fb74bc6f62fb4035$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fb74bc6f62fb4035$var$nh(e, b, g);
    null !== a && ($fb74bc6f62fb4035$var$gi(a, e, g, f), $fb74bc6f62fb4035$var$oh(a, e, g));
    return g;
}
function $fb74bc6f62fb4035$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fb74bc6f62fb4035$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fb74bc6f62fb4035$var$il(a, b) {
    $fb74bc6f62fb4035$var$hl(a, b);
    (a = a.alternate) && $fb74bc6f62fb4035$var$hl(a, b);
}
function $fb74bc6f62fb4035$var$jl() {
    return null;
}
var $fb74bc6f62fb4035$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fb74bc6f62fb4035$var$ll(a) {
    this._internalRoot = a;
}
$fb74bc6f62fb4035$var$ml.prototype.render = $fb74bc6f62fb4035$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fb74bc6f62fb4035$var$p(409));
    $fb74bc6f62fb4035$var$fl(a, b, null, null);
};
$fb74bc6f62fb4035$var$ml.prototype.unmount = $fb74bc6f62fb4035$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fb74bc6f62fb4035$var$Rk(function() {
            $fb74bc6f62fb4035$var$fl(null, a, null, null);
        });
        b[$fb74bc6f62fb4035$var$uf] = null;
    }
};
function $fb74bc6f62fb4035$var$ml(a) {
    this._internalRoot = a;
}
$fb74bc6f62fb4035$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fb74bc6f62fb4035$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fb74bc6f62fb4035$var$Qc.length && 0 !== b && b < $fb74bc6f62fb4035$var$Qc[c].priority; c++);
        $fb74bc6f62fb4035$var$Qc.splice(c, 0, a);
        0 === c && $fb74bc6f62fb4035$var$Vc(a);
    }
};
function $fb74bc6f62fb4035$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fb74bc6f62fb4035$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fb74bc6f62fb4035$var$pl() {}
function $fb74bc6f62fb4035$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fb74bc6f62fb4035$var$gl(g);
                f.call(a);
            };
        }
        var g = $fb74bc6f62fb4035$var$el(b, d, a, 0, null, !1, !1, "", $fb74bc6f62fb4035$var$pl);
        a._reactRootContainer = g;
        a[$fb74bc6f62fb4035$var$uf] = g.current;
        $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fb74bc6f62fb4035$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fb74bc6f62fb4035$var$gl(k);
            h.call(a);
        };
    }
    var k = $fb74bc6f62fb4035$var$bl(a, 0, !1, null, null, !1, !1, "", $fb74bc6f62fb4035$var$pl);
    a._reactRootContainer = k;
    a[$fb74bc6f62fb4035$var$uf] = k.current;
    $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fb74bc6f62fb4035$var$Rk(function() {
        $fb74bc6f62fb4035$var$fl(b, k, c, d);
    });
    return k;
}
function $fb74bc6f62fb4035$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fb74bc6f62fb4035$var$gl(g);
                h.call(a);
            };
        }
        $fb74bc6f62fb4035$var$fl(b, g, a, e);
    } else g = $fb74bc6f62fb4035$var$ql(c, b, a, e, d);
    return $fb74bc6f62fb4035$var$gl(g);
}
$fb74bc6f62fb4035$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fb74bc6f62fb4035$var$tc(b.pendingLanes);
                0 !== c && ($fb74bc6f62fb4035$var$Cc(b, c | 1), $fb74bc6f62fb4035$var$Dk(b, $fb74bc6f62fb4035$var$B()), 0 === ($fb74bc6f62fb4035$var$K & 6) && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$jg()));
            }
            break;
        case 13:
            $fb74bc6f62fb4035$var$Rk(function() {
                var b = $fb74bc6f62fb4035$var$ih(a, 1);
                if (null !== b) {
                    var c = $fb74bc6f62fb4035$var$R();
                    $fb74bc6f62fb4035$var$gi(b, a, 1, c);
                }
            }), $fb74bc6f62fb4035$var$il(a, 1);
    }
};
$fb74bc6f62fb4035$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fb74bc6f62fb4035$var$ih(a, 134217728);
        if (null !== b) {
            var c = $fb74bc6f62fb4035$var$R();
            $fb74bc6f62fb4035$var$gi(b, a, 134217728, c);
        }
        $fb74bc6f62fb4035$var$il(a, 134217728);
    }
};
$fb74bc6f62fb4035$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fb74bc6f62fb4035$var$yi(a), c = $fb74bc6f62fb4035$var$ih(a, b);
        if (null !== c) {
            var d = $fb74bc6f62fb4035$var$R();
            $fb74bc6f62fb4035$var$gi(c, a, b, d);
        }
        $fb74bc6f62fb4035$var$il(a, b);
    }
};
$fb74bc6f62fb4035$var$Hc = function() {
    return $fb74bc6f62fb4035$var$C;
};
$fb74bc6f62fb4035$var$Ic = function(a, b) {
    var c = $fb74bc6f62fb4035$var$C;
    try {
        return $fb74bc6f62fb4035$var$C = a, b();
    } finally{
        $fb74bc6f62fb4035$var$C = c;
    }
};
$fb74bc6f62fb4035$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fb74bc6f62fb4035$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fb74bc6f62fb4035$var$Db(d);
                        if (!e) throw Error($fb74bc6f62fb4035$var$p(90));
                        $fb74bc6f62fb4035$var$Wa(d);
                        $fb74bc6f62fb4035$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fb74bc6f62fb4035$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fb74bc6f62fb4035$var$fb(a, !!c.multiple, b, !1);
    }
};
$fb74bc6f62fb4035$var$Gb = $fb74bc6f62fb4035$var$Qk;
$fb74bc6f62fb4035$var$Hb = $fb74bc6f62fb4035$var$Rk;
var $fb74bc6f62fb4035$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $fb74bc6f62fb4035$var$Cb,
        $fb74bc6f62fb4035$var$ue,
        $fb74bc6f62fb4035$var$Db,
        $fb74bc6f62fb4035$var$Eb,
        $fb74bc6f62fb4035$var$Fb,
        $fb74bc6f62fb4035$var$Qk
    ]
}, $fb74bc6f62fb4035$var$tl = {
    findFiberByHostInstance: $fb74bc6f62fb4035$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $fb74bc6f62fb4035$var$ul = {
    bundleType: $fb74bc6f62fb4035$var$tl.bundleType,
    version: $fb74bc6f62fb4035$var$tl.version,
    rendererPackageName: $fb74bc6f62fb4035$var$tl.rendererPackageName,
    rendererConfig: $fb74bc6f62fb4035$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fb74bc6f62fb4035$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fb74bc6f62fb4035$var$tl.findFiberByHostInstance || $fb74bc6f62fb4035$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fb74bc6f62fb4035$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fb74bc6f62fb4035$var$vl.isDisabled && $fb74bc6f62fb4035$var$vl.supportsFiber) try {
        $fb74bc6f62fb4035$var$kc = $fb74bc6f62fb4035$var$vl.inject($fb74bc6f62fb4035$var$ul), $fb74bc6f62fb4035$var$lc = $fb74bc6f62fb4035$var$vl;
    } catch (a) {}
}
$fb74bc6f62fb4035$export$ae55be85d98224ed = $fb74bc6f62fb4035$var$sl;
$fb74bc6f62fb4035$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fb74bc6f62fb4035$var$nl(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$cl(a, b, null, c);
};
$fb74bc6f62fb4035$export$882461b6382ed46c = function(a, b) {
    if (!$fb74bc6f62fb4035$var$nl(a)) throw Error($fb74bc6f62fb4035$var$p(299));
    var c = !1, d = "", e = $fb74bc6f62fb4035$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fb74bc6f62fb4035$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$fb74bc6f62fb4035$var$uf] = b.current;
    $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fb74bc6f62fb4035$var$ll(b);
};
$fb74bc6f62fb4035$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fb74bc6f62fb4035$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fb74bc6f62fb4035$var$p(268, a));
    }
    a = $fb74bc6f62fb4035$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fb74bc6f62fb4035$export$cd75ccfd720a3cd4 = function(a) {
    return $fb74bc6f62fb4035$var$Rk(a);
};
$fb74bc6f62fb4035$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$ol(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$rl(null, a, b, !0, c);
};
$fb74bc6f62fb4035$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$nl(a)) throw Error($fb74bc6f62fb4035$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fb74bc6f62fb4035$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fb74bc6f62fb4035$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fb74bc6f62fb4035$var$uf] = b.current;
    $fb74bc6f62fb4035$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fb74bc6f62fb4035$var$ml(b);
};
$fb74bc6f62fb4035$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$ol(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$rl(null, a, b, !1, c);
};
$fb74bc6f62fb4035$export$502457920280e6be = function(a) {
    if (!$fb74bc6f62fb4035$var$ol(a)) throw Error($fb74bc6f62fb4035$var$p(40));
    return a._reactRootContainer ? ($fb74bc6f62fb4035$var$Rk(function() {
        $fb74bc6f62fb4035$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fb74bc6f62fb4035$var$uf] = null;
        });
    }), !0) : !1;
};
$fb74bc6f62fb4035$export$c78a37762a8d58e1 = $fb74bc6f62fb4035$var$Qk;
$fb74bc6f62fb4035$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fb74bc6f62fb4035$var$ol(c)) throw Error($fb74bc6f62fb4035$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fb74bc6f62fb4035$var$p(38));
    return $fb74bc6f62fb4035$var$rl(a, b, c, !1, d);
};
$fb74bc6f62fb4035$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("lIEVH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hxGUg"));

});
parcelRegister("hxGUg", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $cc56cd16c950906e$export$c4744153514ff05d; }, function (v) { return $cc56cd16c950906e$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $cc56cd16c950906e$export$3e506c1ccc9cc1a7; }, function (v) { return $cc56cd16c950906e$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $cc56cd16c950906e$export$e26fe2ed2fa76875; }, function (v) { return $cc56cd16c950906e$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $cc56cd16c950906e$export$502329bbf4b505b1; }, function (v) { return $cc56cd16c950906e$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $cc56cd16c950906e$export$6e3807111c4874c4; }, function (v) { return $cc56cd16c950906e$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $cc56cd16c950906e$export$c27134553091fb3a; }, function (v) { return $cc56cd16c950906e$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $cc56cd16c950906e$export$33ee1acdc04fd2a2; }, function (v) { return $cc56cd16c950906e$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $cc56cd16c950906e$export$b00a404bbd5edef2; }, function (v) { return $cc56cd16c950906e$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $cc56cd16c950906e$export$8352ce38b91d0c62; }, function (v) { return $cc56cd16c950906e$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $cc56cd16c950906e$export$d66a1c1c77bd778b; }, function (v) { return $cc56cd16c950906e$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $cc56cd16c950906e$export$d3dfb8e4810cb555; }, function (v) { return $cc56cd16c950906e$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $cc56cd16c950906e$export$839f9183b0465a69; }, function (v) { return $cc56cd16c950906e$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $cc56cd16c950906e$export$72fdf0e06517287b; }, function (v) { return $cc56cd16c950906e$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $cc56cd16c950906e$export$4b844e58a3e414b4; }, function (v) { return $cc56cd16c950906e$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $cc56cd16c950906e$export$816d2913ae6b83b1; }, function (v) { return $cc56cd16c950906e$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $cc56cd16c950906e$export$61bcfe829111a1d0; }, function (v) { return $cc56cd16c950906e$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $cc56cd16c950906e$export$7ee8c9beb337bc3f; }, function (v) { return $cc56cd16c950906e$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $cc56cd16c950906e$export$b5836b71941fa3ed; }, function (v) { return $cc56cd16c950906e$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $cc56cd16c950906e$export$cf845f2c119da08a; }, function (v) { return $cc56cd16c950906e$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cc56cd16c950906e$export$c4744153514ff05d;
var $cc56cd16c950906e$export$3e506c1ccc9cc1a7;
var $cc56cd16c950906e$export$e26fe2ed2fa76875;
var $cc56cd16c950906e$export$502329bbf4b505b1;
var $cc56cd16c950906e$export$6e3807111c4874c4;
var $cc56cd16c950906e$export$c27134553091fb3a;
var $cc56cd16c950906e$export$33ee1acdc04fd2a2;
var $cc56cd16c950906e$export$b00a404bbd5edef2;
var $cc56cd16c950906e$export$8352ce38b91d0c62;
var $cc56cd16c950906e$export$d66a1c1c77bd778b;
var $cc56cd16c950906e$export$d3dfb8e4810cb555;
var $cc56cd16c950906e$export$839f9183b0465a69;
var $cc56cd16c950906e$export$72fdf0e06517287b;
var $cc56cd16c950906e$export$4b844e58a3e414b4;
var $cc56cd16c950906e$export$816d2913ae6b83b1;
var $cc56cd16c950906e$export$61bcfe829111a1d0;
var $cc56cd16c950906e$export$7ee8c9beb337bc3f;
var $cc56cd16c950906e$export$b5836b71941fa3ed;
var $cc56cd16c950906e$export$cf845f2c119da08a;
'use strict';
function $cc56cd16c950906e$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $cc56cd16c950906e$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $cc56cd16c950906e$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $cc56cd16c950906e$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $cc56cd16c950906e$var$g(C, c)) n < e && 0 > $cc56cd16c950906e$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $cc56cd16c950906e$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $cc56cd16c950906e$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cc56cd16c950906e$var$l = performance;
    $cc56cd16c950906e$export$c4744153514ff05d = function() {
        return $cc56cd16c950906e$var$l.now();
    };
} else {
    var $cc56cd16c950906e$var$p = Date, $cc56cd16c950906e$var$q = $cc56cd16c950906e$var$p.now();
    $cc56cd16c950906e$export$c4744153514ff05d = function() {
        return $cc56cd16c950906e$var$p.now() - $cc56cd16c950906e$var$q;
    };
}
var $cc56cd16c950906e$var$r = [], $cc56cd16c950906e$var$t = [], $cc56cd16c950906e$var$u = 1, $cc56cd16c950906e$var$v = null, $cc56cd16c950906e$var$y = 3, $cc56cd16c950906e$var$z = !1, $cc56cd16c950906e$var$A = !1, $cc56cd16c950906e$var$B = !1, $cc56cd16c950906e$var$D = "function" === typeof setTimeout ? setTimeout : null, $cc56cd16c950906e$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $cc56cd16c950906e$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $cc56cd16c950906e$var$G(a) {
    for(var b = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$t); null !== b;){
        if (null === b.callback) $cc56cd16c950906e$var$k($cc56cd16c950906e$var$t);
        else if (b.startTime <= a) $cc56cd16c950906e$var$k($cc56cd16c950906e$var$t), b.sortIndex = b.expirationTime, $cc56cd16c950906e$var$f($cc56cd16c950906e$var$r, b);
        else break;
        b = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$t);
    }
}
function $cc56cd16c950906e$var$H(a) {
    $cc56cd16c950906e$var$B = !1;
    $cc56cd16c950906e$var$G(a);
    if (!$cc56cd16c950906e$var$A) {
        if (null !== $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r)) $cc56cd16c950906e$var$A = !0, $cc56cd16c950906e$var$I($cc56cd16c950906e$var$J);
        else {
            var b = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$t);
            null !== b && $cc56cd16c950906e$var$K($cc56cd16c950906e$var$H, b.startTime - a);
        }
    }
}
function $cc56cd16c950906e$var$J(a, b) {
    $cc56cd16c950906e$var$A = !1;
    $cc56cd16c950906e$var$B && ($cc56cd16c950906e$var$B = !1, $cc56cd16c950906e$var$E($cc56cd16c950906e$var$L), $cc56cd16c950906e$var$L = -1);
    $cc56cd16c950906e$var$z = !0;
    var c = $cc56cd16c950906e$var$y;
    try {
        $cc56cd16c950906e$var$G(b);
        for($cc56cd16c950906e$var$v = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r); null !== $cc56cd16c950906e$var$v && (!($cc56cd16c950906e$var$v.expirationTime > b) || a && !$cc56cd16c950906e$var$M());){
            var d = $cc56cd16c950906e$var$v.callback;
            if ("function" === typeof d) {
                $cc56cd16c950906e$var$v.callback = null;
                $cc56cd16c950906e$var$y = $cc56cd16c950906e$var$v.priorityLevel;
                var e = d($cc56cd16c950906e$var$v.expirationTime <= b);
                b = $cc56cd16c950906e$export$c4744153514ff05d();
                "function" === typeof e ? $cc56cd16c950906e$var$v.callback = e : $cc56cd16c950906e$var$v === $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r) && $cc56cd16c950906e$var$k($cc56cd16c950906e$var$r);
                $cc56cd16c950906e$var$G(b);
            } else $cc56cd16c950906e$var$k($cc56cd16c950906e$var$r);
            $cc56cd16c950906e$var$v = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r);
        }
        if (null !== $cc56cd16c950906e$var$v) var w = !0;
        else {
            var m = $cc56cd16c950906e$var$h($cc56cd16c950906e$var$t);
            null !== m && $cc56cd16c950906e$var$K($cc56cd16c950906e$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $cc56cd16c950906e$var$v = null, $cc56cd16c950906e$var$y = c, $cc56cd16c950906e$var$z = !1;
    }
}
var $cc56cd16c950906e$var$N = !1, $cc56cd16c950906e$var$O = null, $cc56cd16c950906e$var$L = -1, $cc56cd16c950906e$var$P = 5, $cc56cd16c950906e$var$Q = -1;
function $cc56cd16c950906e$var$M() {
    return $cc56cd16c950906e$export$c4744153514ff05d() - $cc56cd16c950906e$var$Q < $cc56cd16c950906e$var$P ? !1 : !0;
}
function $cc56cd16c950906e$var$R() {
    if (null !== $cc56cd16c950906e$var$O) {
        var a = $cc56cd16c950906e$export$c4744153514ff05d();
        $cc56cd16c950906e$var$Q = a;
        var b = !0;
        try {
            b = $cc56cd16c950906e$var$O(!0, a);
        } finally{
            b ? $cc56cd16c950906e$var$S() : ($cc56cd16c950906e$var$N = !1, $cc56cd16c950906e$var$O = null);
        }
    } else $cc56cd16c950906e$var$N = !1;
}
var $cc56cd16c950906e$var$S;
if ("function" === typeof $cc56cd16c950906e$var$F) $cc56cd16c950906e$var$S = function() {
    $cc56cd16c950906e$var$F($cc56cd16c950906e$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cc56cd16c950906e$var$T = new MessageChannel, $cc56cd16c950906e$var$U = $cc56cd16c950906e$var$T.port2;
    $cc56cd16c950906e$var$T.port1.onmessage = $cc56cd16c950906e$var$R;
    $cc56cd16c950906e$var$S = function() {
        $cc56cd16c950906e$var$U.postMessage(null);
    };
} else $cc56cd16c950906e$var$S = function() {
    $cc56cd16c950906e$var$D($cc56cd16c950906e$var$R, 0);
};
function $cc56cd16c950906e$var$I(a) {
    $cc56cd16c950906e$var$O = a;
    $cc56cd16c950906e$var$N || ($cc56cd16c950906e$var$N = !0, $cc56cd16c950906e$var$S());
}
function $cc56cd16c950906e$var$K(a, b) {
    $cc56cd16c950906e$var$L = $cc56cd16c950906e$var$D(function() {
        a($cc56cd16c950906e$export$c4744153514ff05d());
    }, b);
}
$cc56cd16c950906e$export$3e506c1ccc9cc1a7 = 5;
$cc56cd16c950906e$export$e26fe2ed2fa76875 = 1;
$cc56cd16c950906e$export$502329bbf4b505b1 = 4;
$cc56cd16c950906e$export$6e3807111c4874c4 = 3;
$cc56cd16c950906e$export$c27134553091fb3a = null;
$cc56cd16c950906e$export$33ee1acdc04fd2a2 = 2;
$cc56cd16c950906e$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$cc56cd16c950906e$export$8352ce38b91d0c62 = function() {
    $cc56cd16c950906e$var$A || $cc56cd16c950906e$var$z || ($cc56cd16c950906e$var$A = !0, $cc56cd16c950906e$var$I($cc56cd16c950906e$var$J));
};
$cc56cd16c950906e$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cc56cd16c950906e$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$cc56cd16c950906e$export$d3dfb8e4810cb555 = function() {
    return $cc56cd16c950906e$var$y;
};
$cc56cd16c950906e$export$839f9183b0465a69 = function() {
    return $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r);
};
$cc56cd16c950906e$export$72fdf0e06517287b = function(a) {
    switch($cc56cd16c950906e$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $cc56cd16c950906e$var$y;
    }
    var c = $cc56cd16c950906e$var$y;
    $cc56cd16c950906e$var$y = b;
    try {
        return a();
    } finally{
        $cc56cd16c950906e$var$y = c;
    }
};
$cc56cd16c950906e$export$4b844e58a3e414b4 = function() {};
$cc56cd16c950906e$export$816d2913ae6b83b1 = function() {};
$cc56cd16c950906e$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $cc56cd16c950906e$var$y;
    $cc56cd16c950906e$var$y = a;
    try {
        return b();
    } finally{
        $cc56cd16c950906e$var$y = c;
    }
};
$cc56cd16c950906e$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $cc56cd16c950906e$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $cc56cd16c950906e$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $cc56cd16c950906e$var$f($cc56cd16c950906e$var$t, a), null === $cc56cd16c950906e$var$h($cc56cd16c950906e$var$r) && a === $cc56cd16c950906e$var$h($cc56cd16c950906e$var$t) && ($cc56cd16c950906e$var$B ? ($cc56cd16c950906e$var$E($cc56cd16c950906e$var$L), $cc56cd16c950906e$var$L = -1) : $cc56cd16c950906e$var$B = !0, $cc56cd16c950906e$var$K($cc56cd16c950906e$var$H, c - d))) : (a.sortIndex = e, $cc56cd16c950906e$var$f($cc56cd16c950906e$var$r, a), $cc56cd16c950906e$var$A || $cc56cd16c950906e$var$z || ($cc56cd16c950906e$var$A = !0, $cc56cd16c950906e$var$I($cc56cd16c950906e$var$J)));
    return a;
};
$cc56cd16c950906e$export$b5836b71941fa3ed = $cc56cd16c950906e$var$M;
$cc56cd16c950906e$export$cf845f2c119da08a = function(a) {
    var b = $cc56cd16c950906e$var$y;
    return function() {
        var c = $cc56cd16c950906e$var$y;
        $cc56cd16c950906e$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $cc56cd16c950906e$var$y = c;
        }
    };
};

});




parcelRegister("2jEfy", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $1afc93e7ad661c6f$export$306c0aa65ff9ec16; }, function (v) { return $1afc93e7ad661c6f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1afc93e7ad661c6f$export$306c0aa65ff9ec16;
'use strict';

var $8ZuGG = parcelRequire("8ZuGG");
function $1afc93e7ad661c6f$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1afc93e7ad661c6f$var$k = "function" === typeof Object.is ? Object.is : $1afc93e7ad661c6f$var$h, $1afc93e7ad661c6f$var$l = $8ZuGG.useState, $1afc93e7ad661c6f$var$m = $8ZuGG.useEffect, $1afc93e7ad661c6f$var$n = $8ZuGG.useLayoutEffect, $1afc93e7ad661c6f$var$p = $8ZuGG.useDebugValue;
function $1afc93e7ad661c6f$var$q(a, b) {
    var d = b(), f = $1afc93e7ad661c6f$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $1afc93e7ad661c6f$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $1afc93e7ad661c6f$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $1afc93e7ad661c6f$var$m(function() {
        $1afc93e7ad661c6f$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $1afc93e7ad661c6f$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $1afc93e7ad661c6f$var$p(d);
    return d;
}
function $1afc93e7ad661c6f$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$1afc93e7ad661c6f$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $1afc93e7ad661c6f$var$t(a, b) {
    return b();
}
var $1afc93e7ad661c6f$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $1afc93e7ad661c6f$var$t : $1afc93e7ad661c6f$var$q;
$1afc93e7ad661c6f$export$306c0aa65ff9ec16 = void 0 !== $8ZuGG.useSyncExternalStore ? $8ZuGG.useSyncExternalStore : $1afc93e7ad661c6f$var$u;

});

parcelRegister("hi0mu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c96465ee8dcba95d$export$bf730a2d8bf68b42; }, function (v) { return $c96465ee8dcba95d$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c96465ee8dcba95d$export$bf730a2d8bf68b42;
'use strict';

var $8ZuGG = parcelRequire("8ZuGG");

var $hU7R8 = parcelRequire("hU7R8");
function $c96465ee8dcba95d$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c96465ee8dcba95d$var$q = "function" === typeof Object.is ? Object.is : $c96465ee8dcba95d$var$p, $c96465ee8dcba95d$var$r = $hU7R8.useSyncExternalStore, $c96465ee8dcba95d$var$t = $8ZuGG.useRef, $c96465ee8dcba95d$var$u = $8ZuGG.useEffect, $c96465ee8dcba95d$var$v = $8ZuGG.useMemo, $c96465ee8dcba95d$var$w = $8ZuGG.useDebugValue;
$c96465ee8dcba95d$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $c96465ee8dcba95d$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c96465ee8dcba95d$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($c96465ee8dcba95d$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $c96465ee8dcba95d$var$r(a, c[0], c[1]);
    $c96465ee8dcba95d$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c96465ee8dcba95d$var$w(d);
    return d;
};

});
parcelRegister("hU7R8", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2jEfy"));

});


parcelRegister("6vRlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdf05f220c62599$export$2e2bcd8739ae039; });
function $4bdf05f220c62599$export$2e2bcd8739ae039() {
    return $4bdf05f220c62599$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4bdf05f220c62599$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4KVmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3767f35f1676fd22$export$2e2bcd8739ae039; });
function $3767f35f1676fd22$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("f8lb0", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $b0480792e44c0014$export$2b8d127b894957b9; }, function (v) { return $b0480792e44c0014$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $b0480792e44c0014$export$cea3a54a6425200c; }, function (v) { return $b0480792e44c0014$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $b0480792e44c0014$export$a7c73072b1a182ae; }, function (v) { return $b0480792e44c0014$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $b0480792e44c0014$export$9f27bc3417b4524d; }, function (v) { return $b0480792e44c0014$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $b0480792e44c0014$export$db77ccec0bb4ccac; }, function (v) { return $b0480792e44c0014$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $b0480792e44c0014$export$8392c0c9d3dcbd35; }, function (v) { return $b0480792e44c0014$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b0480792e44c0014$export$ffb0004e005737fa; }, function (v) { return $b0480792e44c0014$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $b0480792e44c0014$export$b624eff549462981; }, function (v) { return $b0480792e44c0014$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $b0480792e44c0014$export$7897aa7841a5380c; }, function (v) { return $b0480792e44c0014$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $b0480792e44c0014$export$602eac185826482c; }, function (v) { return $b0480792e44c0014$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $b0480792e44c0014$export$e2c29f18771995cb; }, function (v) { return $b0480792e44c0014$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b0480792e44c0014$export$5f8d39834fd61797; }, function (v) { return $b0480792e44c0014$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b0480792e44c0014$export$74bf444e3cd11ea5; }, function (v) { return $b0480792e44c0014$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $b0480792e44c0014$export$92387174baf9b227; }, function (v) { return $b0480792e44c0014$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $b0480792e44c0014$export$ec112efeb987d9c6; }, function (v) { return $b0480792e44c0014$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $b0480792e44c0014$export$b706b080d889d2c9; }, function (v) { return $b0480792e44c0014$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $b0480792e44c0014$export$5be5a87408f70ddc; }, function (v) { return $b0480792e44c0014$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $b0480792e44c0014$export$45a5e7f76e0caa8d; }, function (v) { return $b0480792e44c0014$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $b0480792e44c0014$export$455c2e768291efa6; }, function (v) { return $b0480792e44c0014$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $b0480792e44c0014$export$9522e17588c12572; }, function (v) { return $b0480792e44c0014$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $b0480792e44c0014$export$2110ac352bb060b9; }, function (v) { return $b0480792e44c0014$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $b0480792e44c0014$export$56885ab8b9c456ab; }, function (v) { return $b0480792e44c0014$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $b0480792e44c0014$export$d927fcb6adf8f9de; }, function (v) { return $b0480792e44c0014$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $b0480792e44c0014$export$b82d16f27459e05a; }, function (v) { return $b0480792e44c0014$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $b0480792e44c0014$export$522c17b4f5e123e8; }, function (v) { return $b0480792e44c0014$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $b0480792e44c0014$export$1aabd8a0274ecfd6; }, function (v) { return $b0480792e44c0014$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $b0480792e44c0014$export$9b621391a187a31a; }, function (v) { return $b0480792e44c0014$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $b0480792e44c0014$export$f5bbd400c2f4426f; }, function (v) { return $b0480792e44c0014$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b0480792e44c0014$export$2b8d127b894957b9;
var $b0480792e44c0014$export$cea3a54a6425200c;
var $b0480792e44c0014$export$a7c73072b1a182ae;
var $b0480792e44c0014$export$9f27bc3417b4524d;
var $b0480792e44c0014$export$db77ccec0bb4ccac;
var $b0480792e44c0014$export$8392c0c9d3dcbd35;
var $b0480792e44c0014$export$ffb0004e005737fa;
var $b0480792e44c0014$export$b624eff549462981;
var $b0480792e44c0014$export$7897aa7841a5380c;
var $b0480792e44c0014$export$602eac185826482c;
var $b0480792e44c0014$export$e2c29f18771995cb;
var $b0480792e44c0014$export$5f8d39834fd61797;
var $b0480792e44c0014$export$74bf444e3cd11ea5;
var $b0480792e44c0014$export$92387174baf9b227;
var $b0480792e44c0014$export$ec112efeb987d9c6;
var $b0480792e44c0014$export$b706b080d889d2c9;
var $b0480792e44c0014$export$5be5a87408f70ddc;
var $b0480792e44c0014$export$45a5e7f76e0caa8d;
var $b0480792e44c0014$export$455c2e768291efa6;
var $b0480792e44c0014$export$9522e17588c12572;
var $b0480792e44c0014$export$2110ac352bb060b9;
var $b0480792e44c0014$export$56885ab8b9c456ab;
var $b0480792e44c0014$export$d927fcb6adf8f9de;
var $b0480792e44c0014$export$b82d16f27459e05a;
var $b0480792e44c0014$export$522c17b4f5e123e8;
var $b0480792e44c0014$export$1aabd8a0274ecfd6;
var $b0480792e44c0014$export$9b621391a187a31a;
var $b0480792e44c0014$export$f5bbd400c2f4426f;
'use strict';
var $b0480792e44c0014$var$b = "function" === typeof Symbol && Symbol.for, $b0480792e44c0014$var$c = $b0480792e44c0014$var$b ? Symbol.for("react.element") : 60103, $b0480792e44c0014$var$d = $b0480792e44c0014$var$b ? Symbol.for("react.portal") : 60106, $b0480792e44c0014$var$e = $b0480792e44c0014$var$b ? Symbol.for("react.fragment") : 60107, $b0480792e44c0014$var$f = $b0480792e44c0014$var$b ? Symbol.for("react.strict_mode") : 60108, $b0480792e44c0014$var$g = $b0480792e44c0014$var$b ? Symbol.for("react.profiler") : 60114, $b0480792e44c0014$var$h = $b0480792e44c0014$var$b ? Symbol.for("react.provider") : 60109, $b0480792e44c0014$var$k = $b0480792e44c0014$var$b ? Symbol.for("react.context") : 60110, $b0480792e44c0014$var$l = $b0480792e44c0014$var$b ? Symbol.for("react.async_mode") : 60111, $b0480792e44c0014$var$m = $b0480792e44c0014$var$b ? Symbol.for("react.concurrent_mode") : 60111, $b0480792e44c0014$var$n = $b0480792e44c0014$var$b ? Symbol.for("react.forward_ref") : 60112, $b0480792e44c0014$var$p = $b0480792e44c0014$var$b ? Symbol.for("react.suspense") : 60113, $b0480792e44c0014$var$q = $b0480792e44c0014$var$b ? Symbol.for("react.suspense_list") : 60120, $b0480792e44c0014$var$r = $b0480792e44c0014$var$b ? Symbol.for("react.memo") : 60115, $b0480792e44c0014$var$t = $b0480792e44c0014$var$b ? Symbol.for("react.lazy") : 60116, $b0480792e44c0014$var$v = $b0480792e44c0014$var$b ? Symbol.for("react.block") : 60121, $b0480792e44c0014$var$w = $b0480792e44c0014$var$b ? Symbol.for("react.fundamental") : 60117, $b0480792e44c0014$var$x = $b0480792e44c0014$var$b ? Symbol.for("react.responder") : 60118, $b0480792e44c0014$var$y = $b0480792e44c0014$var$b ? Symbol.for("react.scope") : 60119;
function $b0480792e44c0014$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $b0480792e44c0014$var$c:
                switch(a = a.type, a){
                    case $b0480792e44c0014$var$l:
                    case $b0480792e44c0014$var$m:
                    case $b0480792e44c0014$var$e:
                    case $b0480792e44c0014$var$g:
                    case $b0480792e44c0014$var$f:
                    case $b0480792e44c0014$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $b0480792e44c0014$var$k:
                            case $b0480792e44c0014$var$n:
                            case $b0480792e44c0014$var$t:
                            case $b0480792e44c0014$var$r:
                            case $b0480792e44c0014$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $b0480792e44c0014$var$d:
                return u;
        }
    }
}
function $b0480792e44c0014$var$A(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$m;
}
$b0480792e44c0014$export$2b8d127b894957b9 = $b0480792e44c0014$var$l;
$b0480792e44c0014$export$cea3a54a6425200c = $b0480792e44c0014$var$m;
$b0480792e44c0014$export$a7c73072b1a182ae = $b0480792e44c0014$var$k;
$b0480792e44c0014$export$9f27bc3417b4524d = $b0480792e44c0014$var$h;
$b0480792e44c0014$export$db77ccec0bb4ccac = $b0480792e44c0014$var$c;
$b0480792e44c0014$export$8392c0c9d3dcbd35 = $b0480792e44c0014$var$n;
$b0480792e44c0014$export$ffb0004e005737fa = $b0480792e44c0014$var$e;
$b0480792e44c0014$export$b624eff549462981 = $b0480792e44c0014$var$t;
$b0480792e44c0014$export$7897aa7841a5380c = $b0480792e44c0014$var$r;
$b0480792e44c0014$export$602eac185826482c = $b0480792e44c0014$var$d;
$b0480792e44c0014$export$e2c29f18771995cb = $b0480792e44c0014$var$g;
$b0480792e44c0014$export$5f8d39834fd61797 = $b0480792e44c0014$var$f;
$b0480792e44c0014$export$74bf444e3cd11ea5 = $b0480792e44c0014$var$p;
$b0480792e44c0014$export$92387174baf9b227 = function(a) {
    return $b0480792e44c0014$var$A(a) || $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$l;
};
$b0480792e44c0014$export$ec112efeb987d9c6 = $b0480792e44c0014$var$A;
$b0480792e44c0014$export$b706b080d889d2c9 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$k;
};
$b0480792e44c0014$export$5be5a87408f70ddc = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$h;
};
$b0480792e44c0014$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b0480792e44c0014$var$c;
};
$b0480792e44c0014$export$455c2e768291efa6 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$n;
};
$b0480792e44c0014$export$9522e17588c12572 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$e;
};
$b0480792e44c0014$export$2110ac352bb060b9 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$t;
};
$b0480792e44c0014$export$56885ab8b9c456ab = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$r;
};
$b0480792e44c0014$export$d927fcb6adf8f9de = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$d;
};
$b0480792e44c0014$export$b82d16f27459e05a = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$g;
};
$b0480792e44c0014$export$522c17b4f5e123e8 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$f;
};
$b0480792e44c0014$export$1aabd8a0274ecfd6 = function(a) {
    return $b0480792e44c0014$var$z(a) === $b0480792e44c0014$var$p;
};
$b0480792e44c0014$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $b0480792e44c0014$var$e || a === $b0480792e44c0014$var$m || a === $b0480792e44c0014$var$g || a === $b0480792e44c0014$var$f || a === $b0480792e44c0014$var$p || a === $b0480792e44c0014$var$q || "object" === typeof a && null !== a && (a.$$typeof === $b0480792e44c0014$var$t || a.$$typeof === $b0480792e44c0014$var$r || a.$$typeof === $b0480792e44c0014$var$h || a.$$typeof === $b0480792e44c0014$var$k || a.$$typeof === $b0480792e44c0014$var$n || a.$$typeof === $b0480792e44c0014$var$w || a.$$typeof === $b0480792e44c0014$var$x || a.$$typeof === $b0480792e44c0014$var$y || a.$$typeof === $b0480792e44c0014$var$v);
};
$b0480792e44c0014$export$f5bbd400c2f4426f = $b0480792e44c0014$var$z;

});

parcelRegister("eNPsz", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae; }, function (v) { return $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d; }, function (v) { return $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac; }, function (v) { return $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35; }, function (v) { return $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ac6d8f22d7a6dcc7$export$ffb0004e005737fa; }, function (v) { return $ac6d8f22d7a6dcc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ac6d8f22d7a6dcc7$export$b624eff549462981; }, function (v) { return $ac6d8f22d7a6dcc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ac6d8f22d7a6dcc7$export$7897aa7841a5380c; }, function (v) { return $ac6d8f22d7a6dcc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ac6d8f22d7a6dcc7$export$602eac185826482c; }, function (v) { return $ac6d8f22d7a6dcc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ac6d8f22d7a6dcc7$export$e2c29f18771995cb; }, function (v) { return $ac6d8f22d7a6dcc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ac6d8f22d7a6dcc7$export$5f8d39834fd61797; }, function (v) { return $ac6d8f22d7a6dcc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5; }, function (v) { return $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ac6d8f22d7a6dcc7$export$998bcd577473dd93; }, function (v) { return $ac6d8f22d7a6dcc7$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ac6d8f22d7a6dcc7$export$92387174baf9b227; }, function (v) { return $ac6d8f22d7a6dcc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6; }, function (v) { return $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ac6d8f22d7a6dcc7$export$b706b080d889d2c9; }, function (v) { return $ac6d8f22d7a6dcc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc; }, function (v) { return $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d; }, function (v) { return $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ac6d8f22d7a6dcc7$export$455c2e768291efa6; }, function (v) { return $ac6d8f22d7a6dcc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ac6d8f22d7a6dcc7$export$9522e17588c12572; }, function (v) { return $ac6d8f22d7a6dcc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ac6d8f22d7a6dcc7$export$2110ac352bb060b9; }, function (v) { return $ac6d8f22d7a6dcc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab; }, function (v) { return $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de; }, function (v) { return $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ac6d8f22d7a6dcc7$export$b82d16f27459e05a; }, function (v) { return $ac6d8f22d7a6dcc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8; }, function (v) { return $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6; }, function (v) { return $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957; }, function (v) { return $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ac6d8f22d7a6dcc7$export$9b621391a187a31a; }, function (v) { return $ac6d8f22d7a6dcc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f; }, function (v) { return $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae;
var $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d;
var $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac;
var $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35;
var $ac6d8f22d7a6dcc7$export$ffb0004e005737fa;
var $ac6d8f22d7a6dcc7$export$b624eff549462981;
var $ac6d8f22d7a6dcc7$export$7897aa7841a5380c;
var $ac6d8f22d7a6dcc7$export$602eac185826482c;
var $ac6d8f22d7a6dcc7$export$e2c29f18771995cb;
var $ac6d8f22d7a6dcc7$export$5f8d39834fd61797;
var $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5;
var $ac6d8f22d7a6dcc7$export$998bcd577473dd93;
var $ac6d8f22d7a6dcc7$export$92387174baf9b227;
var $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6;
var $ac6d8f22d7a6dcc7$export$b706b080d889d2c9;
var $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc;
var $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d;
var $ac6d8f22d7a6dcc7$export$455c2e768291efa6;
var $ac6d8f22d7a6dcc7$export$9522e17588c12572;
var $ac6d8f22d7a6dcc7$export$2110ac352bb060b9;
var $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab;
var $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de;
var $ac6d8f22d7a6dcc7$export$b82d16f27459e05a;
var $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8;
var $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6;
var $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957;
var $ac6d8f22d7a6dcc7$export$9b621391a187a31a;
var $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f;
'use strict';
var $ac6d8f22d7a6dcc7$var$b = Symbol.for("react.element"), $ac6d8f22d7a6dcc7$var$c = Symbol.for("react.portal"), $ac6d8f22d7a6dcc7$var$d = Symbol.for("react.fragment"), $ac6d8f22d7a6dcc7$var$e = Symbol.for("react.strict_mode"), $ac6d8f22d7a6dcc7$var$f = Symbol.for("react.profiler"), $ac6d8f22d7a6dcc7$var$g = Symbol.for("react.provider"), $ac6d8f22d7a6dcc7$var$h = Symbol.for("react.context"), $ac6d8f22d7a6dcc7$var$k = Symbol.for("react.server_context"), $ac6d8f22d7a6dcc7$var$l = Symbol.for("react.forward_ref"), $ac6d8f22d7a6dcc7$var$m = Symbol.for("react.suspense"), $ac6d8f22d7a6dcc7$var$n = Symbol.for("react.suspense_list"), $ac6d8f22d7a6dcc7$var$p = Symbol.for("react.memo"), $ac6d8f22d7a6dcc7$var$q = Symbol.for("react.lazy"), $ac6d8f22d7a6dcc7$var$t = Symbol.for("react.offscreen"), $ac6d8f22d7a6dcc7$var$u;
$ac6d8f22d7a6dcc7$var$u = Symbol.for("react.module.reference");
function $ac6d8f22d7a6dcc7$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $ac6d8f22d7a6dcc7$var$b:
                switch(a = a.type, a){
                    case $ac6d8f22d7a6dcc7$var$d:
                    case $ac6d8f22d7a6dcc7$var$f:
                    case $ac6d8f22d7a6dcc7$var$e:
                    case $ac6d8f22d7a6dcc7$var$m:
                    case $ac6d8f22d7a6dcc7$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ac6d8f22d7a6dcc7$var$k:
                            case $ac6d8f22d7a6dcc7$var$h:
                            case $ac6d8f22d7a6dcc7$var$l:
                            case $ac6d8f22d7a6dcc7$var$q:
                            case $ac6d8f22d7a6dcc7$var$p:
                            case $ac6d8f22d7a6dcc7$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $ac6d8f22d7a6dcc7$var$c:
                return r;
        }
    }
}
$ac6d8f22d7a6dcc7$export$a7c73072b1a182ae = $ac6d8f22d7a6dcc7$var$h;
$ac6d8f22d7a6dcc7$export$9f27bc3417b4524d = $ac6d8f22d7a6dcc7$var$g;
$ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac = $ac6d8f22d7a6dcc7$var$b;
$ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35 = $ac6d8f22d7a6dcc7$var$l;
$ac6d8f22d7a6dcc7$export$ffb0004e005737fa = $ac6d8f22d7a6dcc7$var$d;
$ac6d8f22d7a6dcc7$export$b624eff549462981 = $ac6d8f22d7a6dcc7$var$q;
$ac6d8f22d7a6dcc7$export$7897aa7841a5380c = $ac6d8f22d7a6dcc7$var$p;
$ac6d8f22d7a6dcc7$export$602eac185826482c = $ac6d8f22d7a6dcc7$var$c;
$ac6d8f22d7a6dcc7$export$e2c29f18771995cb = $ac6d8f22d7a6dcc7$var$f;
$ac6d8f22d7a6dcc7$export$5f8d39834fd61797 = $ac6d8f22d7a6dcc7$var$e;
$ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5 = $ac6d8f22d7a6dcc7$var$m;
$ac6d8f22d7a6dcc7$export$998bcd577473dd93 = $ac6d8f22d7a6dcc7$var$n;
$ac6d8f22d7a6dcc7$export$92387174baf9b227 = function() {
    return !1;
};
$ac6d8f22d7a6dcc7$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ac6d8f22d7a6dcc7$export$b706b080d889d2c9 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$h;
};
$ac6d8f22d7a6dcc7$export$5be5a87408f70ddc = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$g;
};
$ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ac6d8f22d7a6dcc7$var$b;
};
$ac6d8f22d7a6dcc7$export$455c2e768291efa6 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$l;
};
$ac6d8f22d7a6dcc7$export$9522e17588c12572 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$d;
};
$ac6d8f22d7a6dcc7$export$2110ac352bb060b9 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$q;
};
$ac6d8f22d7a6dcc7$export$56885ab8b9c456ab = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$p;
};
$ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$c;
};
$ac6d8f22d7a6dcc7$export$b82d16f27459e05a = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$f;
};
$ac6d8f22d7a6dcc7$export$522c17b4f5e123e8 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$e;
};
$ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$m;
};
$ac6d8f22d7a6dcc7$export$3d6c20d97e46b957 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$n;
};
$ac6d8f22d7a6dcc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ac6d8f22d7a6dcc7$var$d || a === $ac6d8f22d7a6dcc7$var$f || a === $ac6d8f22d7a6dcc7$var$e || a === $ac6d8f22d7a6dcc7$var$m || a === $ac6d8f22d7a6dcc7$var$n || a === $ac6d8f22d7a6dcc7$var$t || "object" === typeof a && null !== a && (a.$$typeof === $ac6d8f22d7a6dcc7$var$q || a.$$typeof === $ac6d8f22d7a6dcc7$var$p || a.$$typeof === $ac6d8f22d7a6dcc7$var$g || a.$$typeof === $ac6d8f22d7a6dcc7$var$h || a.$$typeof === $ac6d8f22d7a6dcc7$var$l || a.$$typeof === $ac6d8f22d7a6dcc7$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f = $ac6d8f22d7a6dcc7$var$v;

});

parcelRegister("cufV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9174a278f18858f9$export$2e2bcd8739ae039; });
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");

var $94bRR = parcelRequire("94bRR");

var $jCTkj = parcelRequire("jCTkj");

var $jwMYJ = parcelRequire("jwMYJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $9174a278f18858f9$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $jCTkj.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $jCTkj.N0), ")");
}
var $9174a278f18858f9$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Accelerated spin
 * 2. Stretch the spinner line
 */ var $9174a278f18858f9$var$loadIn = null;
var $9174a278f18858f9$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1ky6 _5sag9cwz _1pgl1ytf _1o51q7pw",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $9174a278f18858f9$var$useLayoutEffect = typeof window === 'undefined' ? (0, $8ZuGG.useEffect) : (0, $8ZuGG.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ var $9174a278f18858f9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $jwMYJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $9174a278f18858f9$var$getStrokeColor(appearance);
    var context = (0, $8ZuGG.useContext)((0, $94bRR.default));
    $9174a278f18858f9$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-wrapper") : 'spinner-wrapper',
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $c4hjl.default)([
            $9174a278f18858f9$var$styles.wrapperStyles,
            $9174a278f18858f9$var$styles.rotateStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none',
        className: (0, $c4hjl.default)([
            $9174a278f18858f9$var$styles.loadInStyles
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        style: {
            stroke: stroke
        },
        className: (0, $c4hjl.default)([
            $9174a278f18858f9$var$styles.circleStyles
        ])
    })));
}));
var $9174a278f18858f9$export$2e2bcd8739ae039 = $9174a278f18858f9$var$Spinner;

});
parcelRegister("c4hjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c93495a7803c838$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $8c93495a7803c838$var$ATOMIC_GROUP_LENGTH = 5;
function $8c93495a7803c838$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $8c93495a7803c838$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("94bRR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $699db175de7c3e7a$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $699db175de7c3e7a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("jCTkj", function(module, exports) {

$parcel$export(module.exports, "N0", function () { return $e49c7ba718ba051f$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $e49c7ba718ba051f$export$c39c0fe0f26207ae; });
// Reds
var $e49c7ba718ba051f$export$4b84fd0e2c617bd = '#FFEBE6';
var $e49c7ba718ba051f$export$b34b069eff244586 = '#FFBDAD';
var $e49c7ba718ba051f$export$be802dd0d8b57f35 = '#FF8F73';
var $e49c7ba718ba051f$export$60847d42f9da92a6 = '#FF7452';
var $e49c7ba718ba051f$export$4a7404f376229999 = '#FF5630';
var $e49c7ba718ba051f$export$2010d0fb4295b346 = '#DE350B';
var $e49c7ba718ba051f$export$2837b5a1a71d5c02 = '#BF2600';
var $e49c7ba718ba051f$export$8d9596b529bbb9cf = '#FFFAE6';
var $e49c7ba718ba051f$export$41060a744ab0b7ae = '#FFF0B3';
var $e49c7ba718ba051f$export$1cc05bbbf340e559 = '#FFE380';
var $e49c7ba718ba051f$export$5aae31392d72caaa = '#FFC400';
var $e49c7ba718ba051f$export$c6930421db9fa514 = '#FFAB00';
var $e49c7ba718ba051f$export$59619663aa6500fb = '#FF991F';
var $e49c7ba718ba051f$export$874739ea9e379ab6 = '#FF8B00';
var $e49c7ba718ba051f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e49c7ba718ba051f$export$69a3bf21b9686c2b = '#ABF5D1';
var $e49c7ba718ba051f$export$afbce1382ec95f73 = '#79F2C0';
var $e49c7ba718ba051f$export$747d86715d4175de = '#57D9A3';
var $e49c7ba718ba051f$export$940e1f69e873f202 = '#36B37E';
var $e49c7ba718ba051f$export$a49394138f7b8e85 = '#00875A';
var $e49c7ba718ba051f$export$6fa04827ac68a4fb = '#006644';
var $e49c7ba718ba051f$export$226de0355ed012f8 = '#DEEBFF';
var $e49c7ba718ba051f$export$8c13c2ee36917869 = '#B3D4FF';
var $e49c7ba718ba051f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e49c7ba718ba051f$export$215b7063051591f1 = '#2684FF';
var $e49c7ba718ba051f$export$e62e8919cca44969 = '#0065FF';
var $e49c7ba718ba051f$export$b3de0ae08da2ce64 = '#0052CC';
var $e49c7ba718ba051f$export$a6ee3d71bc067634 = '#0747A6';
var $e49c7ba718ba051f$export$67f15409e87642a1 = '#669DF1';
var $e49c7ba718ba051f$export$f0539dbc42dbb067 = '#8FB8F6';
var $e49c7ba718ba051f$export$363e4475840015bb = '#EAE6FF';
var $e49c7ba718ba051f$export$4b0a4417ed59760f = '#C0B6F2';
var $e49c7ba718ba051f$export$6011520a64d9a187 = '#998DD9';
var $e49c7ba718ba051f$export$a7175d4e9206bc80 = '#8777D9';
var $e49c7ba718ba051f$export$b48405b95304b5a1 = '#6554C0';
var $e49c7ba718ba051f$export$c71e4279dd54a18d = '#5243AA';
var $e49c7ba718ba051f$export$147899de772240ec = '#403294';
var $e49c7ba718ba051f$export$2cf711fe14c66f06 = '#E6FCFF';
var $e49c7ba718ba051f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e49c7ba718ba051f$export$776c9c497ef08533 = '#79E2F2';
var $e49c7ba718ba051f$export$69cb3ca10c1e330e = '#00C7E6';
var $e49c7ba718ba051f$export$9dc1ef0f3f48059b = '#00B8D9';
var $e49c7ba718ba051f$export$7c835c78b6fcdef8 = '#00A3BF';
var $e49c7ba718ba051f$export$6036577f95c3877e = '#008DA6';
var $e49c7ba718ba051f$export$29a4f05edc054374 = '#FFFFFF';
var $e49c7ba718ba051f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $e49c7ba718ba051f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e49c7ba718ba051f$export$3e51e8f1440314ba = '#EBECF0';
var $e49c7ba718ba051f$export$1ce2d1575d444ceb = '#DFE1E6';
var $e49c7ba718ba051f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e49c7ba718ba051f$export$c2e91cbeada39b8b = '#B3BAC5';
var $e49c7ba718ba051f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $e49c7ba718ba051f$export$eaa8c8a70ac22806 = '#97A0AF';
var $e49c7ba718ba051f$export$7c87d337fb91a97d = '#8993A4';
var $e49c7ba718ba051f$export$d6447c357493214f = '#7A869A';
var $e49c7ba718ba051f$export$f563ee71e9ee74cd = '#6B778C';
var $e49c7ba718ba051f$export$e2ef2124cf4024b1 = '#5E6C84';
var $e49c7ba718ba051f$export$eece5f492e429f08 = '#505F79';
var $e49c7ba718ba051f$export$c39c0fe0f26207ae = '#42526E';
var $e49c7ba718ba051f$export$7090862dc3038a9f = '#344563';
var $e49c7ba718ba051f$export$ad0bacf983b7ddaa = '#253858';
var $e49c7ba718ba051f$export$7d61b15e0da132af = '#172B4D';
var $e49c7ba718ba051f$export$fbda843f0a27fe96 = '#091E42';
var $e49c7ba718ba051f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $e49c7ba718ba051f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $e49c7ba718ba051f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $e49c7ba718ba051f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $e49c7ba718ba051f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $e49c7ba718ba051f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $e49c7ba718ba051f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $e49c7ba718ba051f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $e49c7ba718ba051f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $e49c7ba718ba051f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $e49c7ba718ba051f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $e49c7ba718ba051f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $e49c7ba718ba051f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $e49c7ba718ba051f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $e49c7ba718ba051f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $e49c7ba718ba051f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $e49c7ba718ba051f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $e49c7ba718ba051f$export$2f6319cf7d736c2a = '#E6EDFA';
var $e49c7ba718ba051f$export$95126bc8884d6634 = '#DCE5F5';
var $e49c7ba718ba051f$export$8338d8c35d44ff1 = '#CED9EB';
var $e49c7ba718ba051f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $e49c7ba718ba051f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $e49c7ba718ba051f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $e49c7ba718ba051f$export$97e81faa16a182c7 = '#8C9CB8';
var $e49c7ba718ba051f$export$bfe21c59123ecf33 = '#7988A3';
var $e49c7ba718ba051f$export$ee82aa2ea6a1558 = '#67758F';
var $e49c7ba718ba051f$export$682927c6ed76be02 = '#56637A';
var $e49c7ba718ba051f$export$91fd9994c5be9757 = '#455166';
var $e49c7ba718ba051f$export$d281fbfe3cff2df6 = '#3B475C';
var $e49c7ba718ba051f$export$3902c91d8b98a753 = '#313D52';
var $e49c7ba718ba051f$export$8e8133c1ba5845b5 = '#283447';
var $e49c7ba718ba051f$export$33ff357f6620b39 = '#202B3D';
var $e49c7ba718ba051f$export$633847cf062b69e0 = '#1B2638';
var $e49c7ba718ba051f$export$9776a6e503bdbf76 = '#121A29';
var $e49c7ba718ba051f$export$6c813d5160dff5db = '#0E1624';
var $e49c7ba718ba051f$export$3d4f271a500072a = '#0D1424';
var $e49c7ba718ba051f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $e49c7ba718ba051f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $e49c7ba718ba051f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $e49c7ba718ba051f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $e49c7ba718ba051f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $e49c7ba718ba051f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $e49c7ba718ba051f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $e49c7ba718ba051f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $e49c7ba718ba051f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $e49c7ba718ba051f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $e49c7ba718ba051f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $e49c7ba718ba051f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $e49c7ba718ba051f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $e49c7ba718ba051f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $e49c7ba718ba051f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $e49c7ba718ba051f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $e49c7ba718ba051f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $e49c7ba718ba051f$export$d2adc5dedf09fced = '#292A2E';
var $e49c7ba718ba051f$export$f51762073d2bb381 = '#94C748';
var $e49c7ba718ba051f$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("jwMYJ", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $e376ff99a5cfaeb8$export$4e9f1640bbe7a1a8; });
var $e376ff99a5cfaeb8$export$4e9f1640bbe7a1a8 = {
    xsmall: 12,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("7tB0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c735d48d28f3ba6d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseErrorPage", function () { return $c735d48d28f3ba6d$export$7ef2fc65256b3bd8; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $5UWRo = parcelRequire("5UWRo");

var $HBurV = parcelRequire("HBurV");

var $3ir1n = parcelRequire("3ir1n");
let $c735d48d28f3ba6d$var$_ = (t)=>t, $c735d48d28f3ba6d$var$t;
function $c735d48d28f3ba6d$export$2e2bcd8739ae039({ title: title, children: children }) {
    const anonymousId = (0, $3ir1n.useAnalyticsAnonymousId)();
    return /*#__PURE__*/ (0, $6rcps.jsx)($c735d48d28f3ba6d$export$7ef2fc65256b3bd8, {
        title: title,
        anonymousId: anonymousId,
        children: children
    });
}
function $c735d48d28f3ba6d$export$7ef2fc65256b3bd8({ title: title, anonymousId: anonymousId, children: children }) {
    return /*#__PURE__*/ (0, $6rcps.jsxs)($c735d48d28f3ba6d$var$ErrorContainer, {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5UWRo.AtlassianLogo), {
                size: "large",
                label: "Atlassian",
                appearance: "brand"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    height: "150",
                    alt: "",
                    className: "error-image"
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("h2", {
                className: "error-title",
                children: title
            }),
            !!children && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                className: "error-content",
                children: children
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("small", {
                className: "error-diagnostic-details",
                children: /*#__PURE__*/ (0, $6rcps.jsx)("code", {
                    children: anonymousId || "\u2014"
                })
            })
        ]
    });
}
const $c735d48d28f3ba6d$var$ErrorContainer = (0, $9Vz68.default).div($c735d48d28f3ba6d$var$t || ($c735d48d28f3ba6d$var$t = $c735d48d28f3ba6d$var$_`
  margin-right: auto;
  margin-left: auto;
  max-width: 900px;
  padding: 100px 10px 0px 10px;
  text-align: center;

  .error-image {
    padding: 24px 0px;
  }

  .error-title {
    padding-top: 0px;
  }

  .error-content {
    padding-top: 16px;
  }

  .error-action {
    padding-top: 24px;
  }

  .error-diagnostic-details {
    display: block;
    padding-top: 24px;
  }
`));

});
parcelRegister("9Vz68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73a4a9a7ee36f12a$export$2e2bcd8739ae039; });

var $jmZCk = parcelRequire("jmZCk");
parcelRequire("dLcU7");

parcelRequire("1eDRW");
parcelRequire("cUDyb");
parcelRequire("ccx1k");
parcelRequire("8ZuGG");
parcelRequire("55TnP");
var $73a4a9a7ee36f12a$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $73a4a9a7ee36f12a$export$2e2bcd8739ae039 = (0, $jmZCk.default).bind(null);
$73a4a9a7ee36f12a$var$tags.forEach(function(tagName) {
    $73a4a9a7ee36f12a$export$2e2bcd8739ae039[tagName] = $73a4a9a7ee36f12a$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("jmZCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e19fde4e1872fa07$export$2e2bcd8739ae039; });

var $6vRlT = parcelRequire("6vRlT");
parcelRequire("bl8w7");
var $3lBEi = parcelRequire("3lBEi");

var $1eDRW = parcelRequire("1eDRW");

var $cUDyb = parcelRequire("cUDyb");

var $ccx1k = parcelRequire("ccx1k");

var $8ZuGG = parcelRequire("8ZuGG");

var $55TnP = parcelRequire("55TnP");
var $e19fde4e1872fa07$var$isBrowser = typeof document !== 'undefined';
var $e19fde4e1872fa07$var$isDevelopment = false;
var $e19fde4e1872fa07$var$testOmitPropsOnStringTag = (0, $55TnP.default);
var $e19fde4e1872fa07$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $e19fde4e1872fa07$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $e19fde4e1872fa07$var$testOmitPropsOnStringTag : $e19fde4e1872fa07$var$testOmitPropsOnComponent;
};
var $e19fde4e1872fa07$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $e19fde4e1872fa07$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ccx1k.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $cUDyb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $ccx1k.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$e19fde4e1872fa07$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8ZuGG.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e19fde4e1872fa07$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $e19fde4e1872fa07$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $e19fde4e1872fa07$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $3lBEi.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8ZuGG.useContext((0, $3lBEi.T));
            }
            if (typeof props.className === 'string') className = (0, $ccx1k.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $1eDRW.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $e19fde4e1872fa07$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($e19fde4e1872fa07$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $8ZuGG.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $e19fde4e1872fa07$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $6vRlT.default)({}, options, nextOptions, {
                shouldForwardProp: $e19fde4e1872fa07$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("bl8w7", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $8418432cc6b3d0fa$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $8418432cc6b3d0fa$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $8418432cc6b3d0fa$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $8418432cc6b3d0fa$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $8418432cc6b3d0fa$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("3lBEi")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("3lBEi")).w; });

var $3lBEi = parcelRequire("3lBEi");

var $8ZuGG = parcelRequire("8ZuGG");

var $ccx1k = parcelRequire("ccx1k");

var $cUDyb = parcelRequire("cUDyb");

var $1eDRW = parcelRequire("1eDRW");
parcelRequire("c6LOE");
parcelRequire("dLcU7");
parcelRequire("9GsDX");

parcelRequire("fiQA5");
var $8418432cc6b3d0fa$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $3lBEi.h).call(props, 'css')) return $8ZuGG.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $3lBEi.E);
    createElementArgArray[1] = (0, $3lBEi.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $8ZuGG.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($8418432cc6b3d0fa$export$c8a8987d4410bf2d || ($8418432cc6b3d0fa$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $8418432cc6b3d0fa$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $3lBEi.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $1eDRW.serializeStyles)([
        styles
    ], undefined, $8ZuGG.useContext((0, $3lBEi.T)));
    if (!(0, $3lBEi.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8ZuGG.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8ZuGG.useRef();
    (0, $cUDyb.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $cUDyb.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $ccx1k.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $8418432cc6b3d0fa$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $1eDRW.serializeStyles)(args);
}
function $8418432cc6b3d0fa$export$d25ddfdf17c3ad3e() {
    var insertable = $8418432cc6b3d0fa$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $8418432cc6b3d0fa$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $8418432cc6b3d0fa$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $ccx1k.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $8418432cc6b3d0fa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $cUDyb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $ccx1k.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $3lBEi.i) && res !== undefined) rules += res;
        }
        if (!(0, $3lBEi.i)) return rules;
    });
    if (!(0, $3lBEi.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $8ZuGG.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $8418432cc6b3d0fa$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $3lBEi.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $3lBEi.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $1eDRW.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $ccx1k.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $3lBEi.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $8418432cc6b3d0fa$var$merge(cache.registered, css, $8418432cc6b3d0fa$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8ZuGG.useContext((0, $3lBEi.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($8418432cc6b3d0fa$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("3lBEi", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $27008993dd2d22c8$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $27008993dd2d22c8$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "w", function () { return $27008993dd2d22c8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $27008993dd2d22c8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $27008993dd2d22c8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $27008993dd2d22c8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $27008993dd2d22c8$export$a9c23c6ac3fc3eca; });

var $8ZuGG = parcelRequire("8ZuGG");

var $c6LOE = parcelRequire("c6LOE");

var $6vRlT = parcelRequire("6vRlT");

var $9GsDX = parcelRequire("9GsDX");

var $1BmVx = parcelRequire("1BmVx");

var $ccx1k = parcelRequire("ccx1k");

var $1eDRW = parcelRequire("1eDRW");

var $cUDyb = parcelRequire("cUDyb");
var $27008993dd2d22c8$export$407448d2b89b1813 = false;
var $27008993dd2d22c8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $27008993dd2d22c8$var$EmotionCacheContext = /* #__PURE__ */ $8ZuGG.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $c6LOE.default)({
    key: 'css'
}) : null);
var $27008993dd2d22c8$export$e7094788287c5e9b = $27008993dd2d22c8$var$EmotionCacheContext.Provider;
var $27008993dd2d22c8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8ZuGG.useContext)($27008993dd2d22c8$var$EmotionCacheContext);
};
var $27008993dd2d22c8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8ZuGG.useContext)($27008993dd2d22c8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$27008993dd2d22c8$export$23f2a1d2818174ef) $27008993dd2d22c8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8ZuGG.useContext)($27008993dd2d22c8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $c6LOE.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $8ZuGG.createElement($27008993dd2d22c8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $27008993dd2d22c8$export$971d5caa766a69d7 = /* #__PURE__ */ $8ZuGG.createContext({});
var $27008993dd2d22c8$export$3b14a55fb2447963 = function useTheme() {
    return $8ZuGG.useContext($27008993dd2d22c8$export$971d5caa766a69d7);
};
var $27008993dd2d22c8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $6vRlT.default)({}, outerTheme, theme);
};
var $27008993dd2d22c8$var$createCacheWithTheme = /* #__PURE__ */ (0, $9GsDX.default)(function(outerTheme) {
    return (0, $9GsDX.default)(function(theme) {
        return $27008993dd2d22c8$var$getTheme(outerTheme, theme);
    });
});
var $27008993dd2d22c8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $8ZuGG.useContext($27008993dd2d22c8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $27008993dd2d22c8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8ZuGG.createElement($27008993dd2d22c8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $27008993dd2d22c8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $8ZuGG.forwardRef(function render(props, ref) {
        var theme = $8ZuGG.useContext($27008993dd2d22c8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, $6vRlT.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $1BmVx.default)(WithTheme, Component);
}
var $27008993dd2d22c8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $27008993dd2d22c8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $27008993dd2d22c8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($27008993dd2d22c8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$27008993dd2d22c8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $27008993dd2d22c8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $ccx1k.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $cUDyb.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $ccx1k.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$27008993dd2d22c8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $8ZuGG.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $27008993dd2d22c8$var$Emotion = /* #__PURE__ */ $27008993dd2d22c8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$27008993dd2d22c8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $ccx1k.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $1eDRW.serializeStyles)(registeredStyles, undefined, $8ZuGG.useContext($27008993dd2d22c8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($27008993dd2d22c8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $27008993dd2d22c8$var$typePropName && !$27008993dd2d22c8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($27008993dd2d22c8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $8ZuGG.createElement(WrappedComponent, newProps));
});
var $27008993dd2d22c8$export$a9c23c6ac3fc3eca = $27008993dd2d22c8$var$Emotion;

});
parcelRegister("c6LOE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d0b22d39962c318$export$2e2bcd8739ae039; });

var $jfkHJ = parcelRequire("jfkHJ");

var $84yE1 = parcelRequire("84yE1");

var $9GsDX = parcelRequire("9GsDX");

var $knQRH = parcelRequire("knQRH");
var $8d0b22d39962c318$var$isBrowser = typeof document !== 'undefined';
var $8d0b22d39962c318$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $84yE1.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $84yE1.token)(character)) break;
        (0, $84yE1.next)();
    }
    return (0, $84yE1.slice)(begin, (0, $84yE1.position));
};
var $8d0b22d39962c318$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $84yE1.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $84yE1.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $8d0b22d39962c318$var$identifierWithPointTracking((0, $84yE1.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $84yE1.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $84yE1.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $84yE1.from)(character);
    }
    while (character = (0, $84yE1.next)());
    return parsed;
};
var $8d0b22d39962c318$var$getRules = function getRules(value, points) {
    return (0, $84yE1.dealloc)($8d0b22d39962c318$var$toRules((0, $84yE1.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $8d0b22d39962c318$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $8d0b22d39962c318$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$8d0b22d39962c318$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $8d0b22d39962c318$var$fixedElements.set(element, true);
    var points = [];
    var rules = $8d0b22d39962c318$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $8d0b22d39962c318$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $8d0b22d39962c318$var$prefix(value, length) {
    switch((0, $84yE1.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $84yE1.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $84yE1.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MOZ) + value + (0, $84yE1.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + value + value;
        // order
        case 6165:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.replace)(value, /(\w+).+(:[^]+)/, (0, $84yE1.WEBKIT) + 'box-$1$2' + (0, $84yE1.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + 'flex-item-' + (0, $84yE1.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + 'flex-line-pack' + (0, $84yE1.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $84yE1.WEBKIT) + 'box-' + (0, $84yE1.replace)(value, '-grow', '') + (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $84yE1.WEBKIT) + (0, $84yE1.replace)(value, /([^-])(transform)/g, '$1' + (0, $84yE1.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $84yE1.replace)((0, $84yE1.replace)((0, $84yE1.replace)(value, /(zoom-|grab)/, (0, $84yE1.WEBKIT) + '$1'), /(image-set)/, (0, $84yE1.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $84yE1.replace)(value, /(image-set\([^]*)/, (0, $84yE1.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $84yE1.replace)((0, $84yE1.replace)(value, /(.+:)(flex-)?(.*)/, (0, $84yE1.WEBKIT) + 'box-pack:$3' + (0, $84yE1.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $84yE1.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $84yE1.replace)(value, /(.+)-inline(.+)/, (0, $84yE1.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $84yE1.strlen)(value) - 1 - length > 6) switch((0, $84yE1.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $84yE1.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $84yE1.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $84yE1.WEBKIT) + '$2-$3' + '$1' + (0, $84yE1.MOZ) + ((0, $84yE1.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $84yE1.indexof)(value, 'stretch') ? $8d0b22d39962c318$var$prefix((0, $84yE1.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $84yE1.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $84yE1.charat)(value, (0, $84yE1.strlen)(value) - 3 - (~(0, $84yE1.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $84yE1.replace)(value, ':', ':' + (0, $84yE1.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $84yE1.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $84yE1.WEBKIT) + ((0, $84yE1.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $84yE1.WEBKIT) + '$2$3' + '$1' + (0, $84yE1.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $84yE1.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + value + value;
    }
    return value;
}
var $8d0b22d39962c318$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $84yE1.DECLARATION:
                element["return"] = $8d0b22d39962c318$var$prefix(element.value, element.length);
                break;
            case 0, $84yE1.KEYFRAMES:
                return (0, $84yE1.serialize)([
                    (0, $84yE1.copy)(element, {
                        value: (0, $84yE1.replace)(element.value, '@', '@' + (0, $84yE1.WEBKIT))
                    })
                ], callback);
            case 0, $84yE1.RULESET:
                if (element.length) return (0, $84yE1.combine)(element.props, function(value) {
                    switch((0, $84yE1.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $84yE1.serialize)([
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(read-\w+)/, ':' + (0, $84yE1.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $84yE1.serialize)([
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, ':' + (0, $84yE1.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, ':' + (0, $84yE1.MOZ) + '$1')
                                    ]
                                }),
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, (0, $84yE1.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $8d0b22d39962c318$var$getServerStylisCache = $8d0b22d39962c318$var$isBrowser ? undefined : (0, $9GsDX.default)(function() {
    return (0, $knQRH.default)(function() {
        return {};
    });
});
var $8d0b22d39962c318$var$defaultStylisPlugins = [
    $8d0b22d39962c318$var$prefixer
];
var $8d0b22d39962c318$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($8d0b22d39962c318$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $8d0b22d39962c318$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($8d0b22d39962c318$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $8d0b22d39962c318$var$compat,
        $8d0b22d39962c318$var$removeLabel
    ];
    if (!$8d0b22d39962c318$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $84yE1.stringify),
            (0, $84yE1.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $84yE1.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $84yE1.serialize)((0, $84yE1.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $84yE1.stringify)
        ];
        var _serializer = (0, $84yE1.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $84yE1.serialize)((0, $84yE1.compile)(styles), _serializer);
        };
        var serverStylisCache = $8d0b22d39962c318$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jfkHJ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jfkHJ", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $e02f7a7db424ae19$export$9d753cd7ae895cce; });
var $e02f7a7db424ae19$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e02f7a7db424ae19$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e02f7a7db424ae19$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e02f7a7db424ae19$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e02f7a7db424ae19$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e02f7a7db424ae19$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e02f7a7db424ae19$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("84yE1", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c008aa41b6750289$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c008aa41b6750289$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c008aa41b6750289$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c008aa41b6750289$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c008aa41b6750289$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c008aa41b6750289$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c008aa41b6750289$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c008aa41b6750289$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c008aa41b6750289$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c008aa41b6750289$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c008aa41b6750289$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c008aa41b6750289$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c008aa41b6750289$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c008aa41b6750289$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c008aa41b6750289$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c008aa41b6750289$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c008aa41b6750289$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c008aa41b6750289$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c008aa41b6750289$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c008aa41b6750289$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c008aa41b6750289$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c008aa41b6750289$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c008aa41b6750289$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c008aa41b6750289$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c008aa41b6750289$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c008aa41b6750289$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c008aa41b6750289$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c008aa41b6750289$export$38bcb760f1d4871c; });
var $c008aa41b6750289$export$71ad59f2e432cfe8 = "-ms-";
var $c008aa41b6750289$export$2c0f367103c8d01c = "-moz-";
var $c008aa41b6750289$export$39dfd62a25e0fe93 = "-webkit-";
var $c008aa41b6750289$export$a29989082612d0d9 = "comm";
var $c008aa41b6750289$export$aa3a2e812ca8570d = "rule";
var $c008aa41b6750289$export$527d108ccf083c2b = "decl";
var $c008aa41b6750289$export$d3d35020fa5b54f0 = "@page";
var $c008aa41b6750289$export$500415a86c544f73 = "@media";
var $c008aa41b6750289$export$a763edbf796b780a = "@import";
var $c008aa41b6750289$export$2790aeb8b4e5c826 = "@charset";
var $c008aa41b6750289$export$1cc683e23b84b133 = "@viewport";
var $c008aa41b6750289$export$9447a5efea57e862 = "@supports";
var $c008aa41b6750289$export$ef011b4e114b1fba = "@document";
var $c008aa41b6750289$export$6aad947bda0f3f46 = "@namespace";
var $c008aa41b6750289$export$b44a8529a35fcb60 = "@keyframes";
var $c008aa41b6750289$export$2c16de31893252e6 = "@font-face";
var $c008aa41b6750289$export$3d846dd52e150c6f = "@counter-style";
var $c008aa41b6750289$export$22314bfbb57653fe = "@font-feature-values";
var $c008aa41b6750289$export$d773506282b3cfe6 = "@layer";
var $c008aa41b6750289$export$2335f513bbd82c6d = Math.abs;
var $c008aa41b6750289$export$6788812c4e6611e6 = String.fromCharCode;
var $c008aa41b6750289$export$e6e34fd1f2686227 = Object.assign;
function $c008aa41b6750289$export$d6af199866bfb566(e, r) {
    return $c008aa41b6750289$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 0)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 1)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 2)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 3) : 0;
}
function $c008aa41b6750289$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c008aa41b6750289$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c008aa41b6750289$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c008aa41b6750289$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c008aa41b6750289$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c008aa41b6750289$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c008aa41b6750289$export$36776f635604f274(e) {
    return e.length;
}
function $c008aa41b6750289$export$f9084667e487ed46(e) {
    return e.length;
}
function $c008aa41b6750289$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c008aa41b6750289$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c008aa41b6750289$export$53f1d5ea8de3d7c = 1;
var $c008aa41b6750289$export$4e0c71f277ca26b3 = 1;
var $c008aa41b6750289$export$f24224f1c91d8156 = 0;
var $c008aa41b6750289$export$5880b8b5730aff45 = 0;
var $c008aa41b6750289$export$c0306caf338ac095 = 0;
var $c008aa41b6750289$export$30a86d91af8ff6e6 = "";
function $c008aa41b6750289$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c008aa41b6750289$export$53f1d5ea8de3d7c,
        column: $c008aa41b6750289$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c008aa41b6750289$export$784d13d8ee351f07(e, r) {
    return $c008aa41b6750289$export$e6e34fd1f2686227($c008aa41b6750289$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c008aa41b6750289$export$eba6f6f03b0a92e7() {
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$232faf9add678146() {
    $c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$5880b8b5730aff45 > 0 ? $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, --$c008aa41b6750289$export$5880b8b5730aff45) : 0;
    if ($c008aa41b6750289$export$4e0c71f277ca26b3--, $c008aa41b6750289$export$c0306caf338ac095 === 10) $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$53f1d5ea8de3d7c--;
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$48cfd1e771a65c4f() {
    $c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$5880b8b5730aff45 < $c008aa41b6750289$export$f24224f1c91d8156 ? $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, $c008aa41b6750289$export$5880b8b5730aff45++) : 0;
    if ($c008aa41b6750289$export$4e0c71f277ca26b3++, $c008aa41b6750289$export$c0306caf338ac095 === 10) $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$53f1d5ea8de3d7c++;
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$4d3fb11e950abb9e() {
    return $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, $c008aa41b6750289$export$5880b8b5730aff45);
}
function $c008aa41b6750289$export$e88cb2efb12ae807() {
    return $c008aa41b6750289$export$5880b8b5730aff45;
}
function $c008aa41b6750289$export$58adb3bec8346d0f(e, r) {
    return $c008aa41b6750289$export$2f35ab04d2335697($c008aa41b6750289$export$30a86d91af8ff6e6, e, r);
}
function $c008aa41b6750289$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c008aa41b6750289$export$2de70f21292aac9e(e) {
    return $c008aa41b6750289$export$53f1d5ea8de3d7c = $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$f24224f1c91d8156 = $c008aa41b6750289$export$36776f635604f274($c008aa41b6750289$export$30a86d91af8ff6e6 = e), $c008aa41b6750289$export$5880b8b5730aff45 = 0, [];
}
function $c008aa41b6750289$export$45918ac1574455b1(e) {
    return $c008aa41b6750289$export$30a86d91af8ff6e6 = "", e;
}
function $c008aa41b6750289$export$410ac95b9ec204b8(e) {
    return $c008aa41b6750289$export$87c2784dc9fc4ab($c008aa41b6750289$export$58adb3bec8346d0f($c008aa41b6750289$export$5880b8b5730aff45 - 1, $c008aa41b6750289$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c008aa41b6750289$export$660b2ee2d4fb4eff(e) {
    return $c008aa41b6750289$export$45918ac1574455b1($c008aa41b6750289$export$5f8c09e3ae6f64e1($c008aa41b6750289$export$2de70f21292aac9e(e)));
}
function $c008aa41b6750289$export$7af1228ff777d175(e) {
    while($c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$4d3fb11e950abb9e())if ($c008aa41b6750289$export$c0306caf338ac095 < 33) $c008aa41b6750289$export$48cfd1e771a65c4f();
    else break;
    return $c008aa41b6750289$export$9e1725a4cfeada27(e) > 2 || $c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c008aa41b6750289$export$5f8c09e3ae6f64e1(e) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())switch($c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$c0306caf338ac095)){
        case 0:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$c2ab62c7bf24634($c008aa41b6750289$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$410ac95b9ec204b8($c008aa41b6750289$export$c0306caf338ac095), e);
            break;
        default:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$6788812c4e6611e6($c008aa41b6750289$export$c0306caf338ac095), e);
    }
    return e;
}
function $c008aa41b6750289$export$955ba06d119e085e(e, r) {
    while(--r && $c008aa41b6750289$export$48cfd1e771a65c4f())if ($c008aa41b6750289$export$c0306caf338ac095 < 48 || $c008aa41b6750289$export$c0306caf338ac095 > 102 || $c008aa41b6750289$export$c0306caf338ac095 > 57 && $c008aa41b6750289$export$c0306caf338ac095 < 65 || $c008aa41b6750289$export$c0306caf338ac095 > 70 && $c008aa41b6750289$export$c0306caf338ac095 < 97) break;
    return $c008aa41b6750289$export$58adb3bec8346d0f(e, $c008aa41b6750289$export$e88cb2efb12ae807() + (r < 6 && $c008aa41b6750289$export$4d3fb11e950abb9e() == 32 && $c008aa41b6750289$export$48cfd1e771a65c4f() == 32));
}
function $c008aa41b6750289$export$c889f2fcc19dbf12(e) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())switch($c008aa41b6750289$export$c0306caf338ac095){
        case e:
            return $c008aa41b6750289$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c008aa41b6750289$export$c889f2fcc19dbf12($c008aa41b6750289$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c008aa41b6750289$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c008aa41b6750289$export$48cfd1e771a65c4f();
            break;
    }
    return $c008aa41b6750289$export$5880b8b5730aff45;
}
function $c008aa41b6750289$export$4254d4e2b3745c4c(e, r) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())if (e + $c008aa41b6750289$export$c0306caf338ac095 === 57) break;
    else if (e + $c008aa41b6750289$export$c0306caf338ac095 === 84 && $c008aa41b6750289$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c008aa41b6750289$export$58adb3bec8346d0f(r, $c008aa41b6750289$export$5880b8b5730aff45 - 1) + "*" + $c008aa41b6750289$export$6788812c4e6611e6(e === 47 ? e : $c008aa41b6750289$export$48cfd1e771a65c4f());
}
function $c008aa41b6750289$export$c2ab62c7bf24634(e) {
    while(!$c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$4d3fb11e950abb9e()))$c008aa41b6750289$export$48cfd1e771a65c4f();
    return $c008aa41b6750289$export$58adb3bec8346d0f(e, $c008aa41b6750289$export$5880b8b5730aff45);
}
function $c008aa41b6750289$export$ef7acd7185315e22(e) {
    return $c008aa41b6750289$export$45918ac1574455b1($c008aa41b6750289$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c008aa41b6750289$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c008aa41b6750289$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c008aa41b6750289$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c008aa41b6750289$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c008aa41b6750289$export$f8e21b1e77979a08(j += $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c008aa41b6750289$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c008aa41b6750289$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c008aa41b6750289$export$955ba06d119e085e($c008aa41b6750289$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c008aa41b6750289$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$4a34f930e789283c($c008aa41b6750289$export$4254d4e2b3745c4c($c008aa41b6750289$export$48cfd1e771a65c4f(), $c008aa41b6750289$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c008aa41b6750289$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c008aa41b6750289$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c008aa41b6750289$export$36776f635604f274(j) - l) $c008aa41b6750289$export$10d8903dec122b9d(p > 32 ? $c008aa41b6750289$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c008aa41b6750289$export$f8483753829ec8f3($c008aa41b6750289$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c008aa41b6750289$export$10d8903dec122b9d(y = $c008aa41b6750289$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c008aa41b6750289$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c008aa41b6750289$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c008aa41b6750289$export$98e6a39c04603d36(e, y, y, n && $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c008aa41b6750289$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c008aa41b6750289$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c008aa41b6750289$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c008aa41b6750289$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c008aa41b6750289$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c008aa41b6750289$export$4d3fb11e950abb9e() === 45) j += $c008aa41b6750289$export$410ac95b9ec204b8($c008aa41b6750289$export$48cfd1e771a65c4f());
                    v = $c008aa41b6750289$export$4d3fb11e950abb9e(), o = l = $c008aa41b6750289$export$36776f635604f274(g = j += $c008aa41b6750289$export$c2ab62c7bf24634($c008aa41b6750289$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c008aa41b6750289$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c008aa41b6750289$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c008aa41b6750289$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c008aa41b6750289$export$2f35ab04d2335697(e, v + 1, v = $c008aa41b6750289$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c008aa41b6750289$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c008aa41b6750289$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, s === 0 ? $c008aa41b6750289$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c008aa41b6750289$export$4a34f930e789283c(e, r, a) {
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, $c008aa41b6750289$export$a29989082612d0d9, $c008aa41b6750289$export$6788812c4e6611e6($c008aa41b6750289$export$eba6f6f03b0a92e7()), $c008aa41b6750289$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c008aa41b6750289$export$f8483753829ec8f3(e, r, a, n) {
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, $c008aa41b6750289$export$527d108ccf083c2b, $c008aa41b6750289$export$2f35ab04d2335697(e, 0, n), $c008aa41b6750289$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c008aa41b6750289$export$82e9f45cca5ba907(n, c, s) {
    switch($c008aa41b6750289$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c008aa41b6750289$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$2c0f367103c8d01c + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c008aa41b6750289$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-$1$2" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-item-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c008aa41b6750289$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-row-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-line-pack" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-pack:$3" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c008aa41b6750289$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c008aa41b6750289$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-column-align" + $c008aa41b6750289$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c008aa41b6750289$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c008aa41b6750289$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c008aa41b6750289$export$f8e21b1e77979a08(s, "span") ? $c008aa41b6750289$export$4659b591c19bdf3d(s, /\d+/) : +$c008aa41b6750289$export$4659b591c19bdf3d(s, /\d+/) - +$c008aa41b6750289$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c008aa41b6750289$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c008aa41b6750289$export$36776f635604f274(n) - 1 - c > 6) switch($c008aa41b6750289$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c008aa41b6750289$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c008aa41b6750289$export$2c0f367103c8d01c + ($c008aa41b6750289$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c008aa41b6750289$export$f8e21b1e77979a08(n, "stretch") ? $c008aa41b6750289$export$82e9f45cca5ba907($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c008aa41b6750289$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c008aa41b6750289$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c008aa41b6750289$export$a9db5e087081082d(n, c + 6) === 121) return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, ":", ":" + $c008aa41b6750289$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c008aa41b6750289$export$a9db5e087081082d(n, $c008aa41b6750289$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + ($c008aa41b6750289$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, ":", ":" + $c008aa41b6750289$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c008aa41b6750289$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c008aa41b6750289$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c008aa41b6750289$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c008aa41b6750289$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c008aa41b6750289$export$a763edbf796b780a:
        case $c008aa41b6750289$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c008aa41b6750289$export$a29989082612d0d9:
            return "";
        case $c008aa41b6750289$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c008aa41b6750289$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c008aa41b6750289$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c008aa41b6750289$export$36776f635604f274(a = $c008aa41b6750289$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c008aa41b6750289$export$5a7767152ae0305f(e) {
    var r = $c008aa41b6750289$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c008aa41b6750289$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c008aa41b6750289$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c008aa41b6750289$export$527d108ccf083c2b:
                n.return = $c008aa41b6750289$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c008aa41b6750289$export$b44a8529a35fcb60:
                return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                    $c008aa41b6750289$export$784d13d8ee351f07(n, {
                        value: $c008aa41b6750289$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c008aa41b6750289$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c008aa41b6750289$export$aa3a2e812ca8570d:
                if (n.length) return $c008aa41b6750289$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c008aa41b6750289$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c008aa41b6750289$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c008aa41b6750289$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c008aa41b6750289$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c008aa41b6750289$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c008aa41b6750289$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c008aa41b6750289$export$1be1fc439b849fdf($c008aa41b6750289$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c008aa41b6750289$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c008aa41b6750289$export$2f35ab04d2335697(r, 1, $c008aa41b6750289$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c008aa41b6750289$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c008aa41b6750289$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c008aa41b6750289$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("9GsDX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70ce414e7a98c206$export$2e2bcd8739ae039; });
var $70ce414e7a98c206$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("knQRH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6ef68b06ca0bb3$export$2e2bcd8739ae039; });
function $ed6ef68b06ca0bb3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("1BmVx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12ab07fb204bde67$export$2e2bcd8739ae039; });

var $fiQA5 = parcelRequire("fiQA5");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $12ab07fb204bde67$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(targetComponent, sourceComponent);
};

});
parcelRegister("fiQA5", function(module, exports) {
'use strict';

var $6BwFc = parcelRequire("6BwFc");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b24152f370f6b99c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b24152f370f6b99c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b24152f370f6b99c$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b24152f370f6b99c$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b24152f370f6b99c$var$TYPE_STATICS = {};
$b24152f370f6b99c$var$TYPE_STATICS[$6BwFc.ForwardRef] = $b24152f370f6b99c$var$FORWARD_REF_STATICS;
$b24152f370f6b99c$var$TYPE_STATICS[$6BwFc.Memo] = $b24152f370f6b99c$var$MEMO_STATICS;
function $b24152f370f6b99c$var$getStatics(component) {
    // React v16.11 and below
    if ($6BwFc.isMemo(component)) return $b24152f370f6b99c$var$MEMO_STATICS;
     // React v16.12 and above
    return $b24152f370f6b99c$var$TYPE_STATICS[component['$$typeof']] || $b24152f370f6b99c$var$REACT_STATICS;
}
var $b24152f370f6b99c$var$defineProperty = Object.defineProperty;
var $b24152f370f6b99c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b24152f370f6b99c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b24152f370f6b99c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b24152f370f6b99c$var$getPrototypeOf = Object.getPrototypeOf;
var $b24152f370f6b99c$var$objectPrototype = Object.prototype;
function $b24152f370f6b99c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($b24152f370f6b99c$var$objectPrototype) {
            var inheritedComponent = $b24152f370f6b99c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b24152f370f6b99c$var$objectPrototype) $b24152f370f6b99c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b24152f370f6b99c$var$getOwnPropertyNames(sourceComponent);
        if ($b24152f370f6b99c$var$getOwnPropertySymbols) keys = keys.concat($b24152f370f6b99c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $b24152f370f6b99c$var$getStatics(targetComponent);
        var sourceStatics = $b24152f370f6b99c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b24152f370f6b99c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $b24152f370f6b99c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $b24152f370f6b99c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $b24152f370f6b99c$var$hoistNonReactStatics;

});
parcelRegister("6BwFc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("f8lb0"));

});



parcelRegister("ccx1k", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $8e20382c4ad7e755$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $8e20382c4ad7e755$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $8e20382c4ad7e755$export$6f077d94b33a01aa; });
var $8e20382c4ad7e755$var$isBrowser = typeof document !== 'undefined';
function $8e20382c4ad7e755$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $8e20382c4ad7e755$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $8e20382c4ad7e755$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $8e20382c4ad7e755$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $8e20382c4ad7e755$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$8e20382c4ad7e755$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$8e20382c4ad7e755$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("1eDRW", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $0e660663d6cd411d$export$6321afa313b251b5; });

var $kGZfZ = parcelRequire("kGZfZ");

var $7Ug8O = parcelRequire("7Ug8O");

var $knQRH = parcelRequire("knQRH");
var $0e660663d6cd411d$var$isDevelopment = false;
var $0e660663d6cd411d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0e660663d6cd411d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0e660663d6cd411d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0e660663d6cd411d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $0e660663d6cd411d$var$processStyleName = /* #__PURE__ */ (0, $knQRH.default)(function(styleName) {
    return $0e660663d6cd411d$var$isCustomProperty(styleName) ? styleName : styleName.replace($0e660663d6cd411d$var$hyphenateRegex, '-$&').toLowerCase();
});
var $0e660663d6cd411d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($0e660663d6cd411d$var$animationRegex, function(match, p1, p2) {
                $0e660663d6cd411d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0e660663d6cd411d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7Ug8O.default)[key] !== 1 && !$0e660663d6cd411d$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $0e660663d6cd411d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $0e660663d6cd411d$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $0e660663d6cd411d$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0e660663d6cd411d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0e660663d6cd411d$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $0e660663d6cd411d$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $0e660663d6cd411d$var$cursor;
                var result = interpolation(mergedProps);
                $0e660663d6cd411d$var$cursor = previousCursor;
                return $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $0e660663d6cd411d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($0e660663d6cd411d$var$isProcessableValue(asString)) string += $0e660663d6cd411d$var$processStyleName(key) + ":" + $0e660663d6cd411d$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $0e660663d6cd411d$var$isDevelopment) throw new Error($0e660663d6cd411d$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($0e660663d6cd411d$var$isProcessableValue(value[_i])) string += $0e660663d6cd411d$var$processStyleName(key) + ":" + $0e660663d6cd411d$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $0e660663d6cd411d$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $0e660663d6cd411d$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $0e660663d6cd411d$var$cursor;
function $0e660663d6cd411d$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $0e660663d6cd411d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0e660663d6cd411d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $0e660663d6cd411d$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0e660663d6cd411d$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $kGZfZ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0e660663d6cd411d$var$cursor
    };
}

});
parcelRegister("kGZfZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1073f3ff7c1c66a$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $f1073f3ff7c1c66a$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("7Ug8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c1a48ae6a243c08$export$2e2bcd8739ae039; });
var $5c1a48ae6a243c08$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("cUDyb", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $966964dc232a5864$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $966964dc232a5864$export$811a713a7276cb9d; });

var $8ZuGG = parcelRequire("8ZuGG");
var $966964dc232a5864$var$isBrowser = typeof document !== 'undefined';
var $966964dc232a5864$var$syncFallback = function syncFallback(create) {
    return create();
};
var $966964dc232a5864$var$useInsertionEffect = $8ZuGG.useInsertionEffect ? $8ZuGG.useInsertionEffect : false;
var $966964dc232a5864$export$db21c7ffa21794e7 = !$966964dc232a5864$var$isBrowser ? $966964dc232a5864$var$syncFallback : $966964dc232a5864$var$useInsertionEffect || $966964dc232a5864$var$syncFallback;
var $966964dc232a5864$export$811a713a7276cb9d = $966964dc232a5864$var$useInsertionEffect || $8ZuGG.useLayoutEffect;

});


parcelRegister("dLcU7", function(module, exports) {
function $a049aca429b9d120$var$_extends() {
    return module.exports = $a049aca429b9d120$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a049aca429b9d120$var$_extends.apply(null, arguments);
}
module.exports = $a049aca429b9d120$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("55TnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b58615cfbda0159$export$2e2bcd8739ae039; });

var $knQRH = parcelRequire("knQRH");
// eslint-disable-next-line no-undef
var $3b58615cfbda0159$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3b58615cfbda0159$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $knQRH.default)(function(prop) {
    return $3b58615cfbda0159$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("5UWRo", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $44efd7201ee5a49e$export$765cacec8b0843f3; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $44efd7201ee5a49e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 198 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\">\n      <path fill=".concat(colors.iconColor, " d=\"M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"/>\n      <path fill=").concat(colors.atlassianLogoTextColor, " d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354\"/>\n    </svg>");
};
var $44efd7201ee5a49e$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $44efd7201ee5a49e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("9XpDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73fd830b04d9973a$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $6KhR5 = parcelRequire("6KhR5");

var $rG0so = parcelRequire("rG0so");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $73fd830b04d9973a$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $8ZuGG.useState)((0, $6KhR5.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        var observer = new (0, $rG0so.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $73fd830b04d9973a$export$2e2bcd8739ae039 = $73fd830b04d9973a$var$useThemeObserver;

});
parcelRegister("kg5sN", function(module, exports) {

var $lyp2R = parcelRequire("lyp2R");

var $6rVvO = parcelRequire("6rVvO");

var $2x5xA = parcelRequire("2x5xA");

var $aPRr2 = parcelRequire("aPRr2");
function $ebf98a36867d8032$var$_slicedToArray(r, e) {
    return $lyp2R(r) || $6rVvO(r, e) || $2x5xA(r, e) || $aPRr2();
}
module.exports = $ebf98a36867d8032$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lyp2R", function(module, exports) {
function $fb10335f983b8360$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $fb10335f983b8360$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6rVvO", function(module, exports) {
function $0136394bddc77a25$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $0136394bddc77a25$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2x5xA", function(module, exports) {

var $hqFoN = parcelRequire("hqFoN");
function $1d82f61c5a84e354$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $hqFoN(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $hqFoN(r, a) : void 0;
    }
}
module.exports = $1d82f61c5a84e354$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hqFoN", function(module, exports) {
function $cb04fa518a2bd634$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $cb04fa518a2bd634$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aPRr2", function(module, exports) {
function $7e381de30a43b6c0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7e381de30a43b6c0$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6KhR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e94e3a1851e6841$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $bDRHl = parcelRequire("bDRHl");

var $icabj = parcelRequire("icabj");

var $juoNE = parcelRequire("juoNE");
function $4e94e3a1851e6841$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e94e3a1851e6841$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e94e3a1851e6841$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e94e3a1851e6841$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4e94e3a1851e6841$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $icabj.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $4e94e3a1851e6841$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === 'undefined') return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $bDRHl.COLOR_MODE_ATTRIBUTE)) || '';
    var theme = element.getAttribute((0, $bDRHl.THEME_DATA_ATTRIBUTE)) || '';
    return $4e94e3a1851e6841$var$_objectSpread($4e94e3a1851e6841$var$_objectSpread({}, (0, $juoNE.themeStringToObject)(theme)), $4e94e3a1851e6841$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $4e94e3a1851e6841$export$2e2bcd8739ae039 = $4e94e3a1851e6841$var$getGlobalTheme;

});
parcelRegister("6bkHe", function(module, exports) {

var $ew1M2 = parcelRequire("ew1M2");
function $4803d2fd1087824c$var$_defineProperty(e, r, t) {
    return (r = $ew1M2(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4803d2fd1087824c$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ew1M2", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $a9156e1677ad8f90$var$_typeof = $cd8Dz.default;

var $laBp3 = parcelRequire("laBp3");
function $a9156e1677ad8f90$var$toPropertyKey(t) {
    var i = $laBp3(t, "string");
    return "symbol" == $a9156e1677ad8f90$var$_typeof(i) ? i : i + "";
}
module.exports = $a9156e1677ad8f90$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cd8Dz", function(module, exports) {
function $8e3d661f96587760$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8e3d661f96587760$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8e3d661f96587760$var$_typeof(o);
}
module.exports = $8e3d661f96587760$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("laBp3", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $f6978ba3dabac565$var$_typeof = $cd8Dz.default;
function $f6978ba3dabac565$var$toPrimitive(t, r) {
    if ("object" != $f6978ba3dabac565$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f6978ba3dabac565$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $f6978ba3dabac565$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bDRHl", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $879cfd9098b1225a$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $879cfd9098b1225a$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $879cfd9098b1225a$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $879cfd9098b1225a$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $879cfd9098b1225a$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $879cfd9098b1225a$export$9d7b58831ae93caa; });
var $879cfd9098b1225a$export$4ef52930e33717cd = 'data-theme';
var $879cfd9098b1225a$export$a00eac3f8684bcd0 = 'data-color-mode';
var $879cfd9098b1225a$export$2112803007239c61 = 'data-contrast-mode';
var $879cfd9098b1225a$export$352e418ed5b6193a = 'data-custom-theme';
var $879cfd9098b1225a$export$6f0c6fb8c80fcc92 = 'ds';
var $879cfd9098b1225a$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $879cfd9098b1225a$export$dddac1532e822863 = "--".concat($879cfd9098b1225a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $879cfd9098b1225a$export$9d7b58831ae93caa = "--".concat($879cfd9098b1225a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("icabj", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $d3f13ec9455b1634$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $d3f13ec9455b1634$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $d3f13ec9455b1634$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $d3f13ec9455b1634$export$2e2bcd8739ae039; });

var $i2LcI = parcelRequire("i2LcI");
var $d3f13ec9455b1634$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
/**
 * Contrast preferences: The system contrast preference
 */ var $d3f13ec9455b1634$var$themeContrastModes = [
    'more',
    'no-preference',
    'auto'
];
var $d3f13ec9455b1634$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'shape-rounder',
    'shape-roundest',
    'typography',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $d3f13ec9455b1634$var$themeOverrideIds = [];
var $d3f13ec9455b1634$export$92ba366331403db2 = [].concat($d3f13ec9455b1634$export$7d43e72a58e3283f, $d3f13ec9455b1634$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $d3f13ec9455b1634$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography': {
        id: 'typography',
        displayName: 'Atlassian Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-shape-rounder': {
        id: 'shape-rounder',
        displayName: 'Shape (Rounder)',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-shape-roundest': {
        id: 'shape-roundest',
        displayName: 'Shape (Roundest)',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
var $d3f13ec9455b1634$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: function typography() {
        if ((0, $i2LcI.fg)('platform-disable-default-typography')) return undefined;
        return 'typography';
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $d3f13ec9455b1634$export$2e2bcd8739ae039 = $d3f13ec9455b1634$var$themeConfig;

});
parcelRegister("i2LcI", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $d22d07a1220a8be7$export$b40ec24ac8275656; });

var $aSXOk = parcelRequire("aSXOk");
function $d22d07a1220a8be7$export$ba05d765b8392e5e(flagResolver) {
    (0, $aSXOk.setBooleanResolver)(flagResolver);
}
function $d22d07a1220a8be7$export$470e5c2be1411c89(name) {
    return (0, $aSXOk.resolveBooleanFlag)(name);
}
function $d22d07a1220a8be7$export$b40ec24ac8275656(name) {
    return (0, $aSXOk.resolveBooleanFlag)(name);
}

});
parcelRegister("aSXOk", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $7ecd57ae89f699d7$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $7ecd57ae89f699d7$export$6333b6aff9fc6275; });

var $fYaTm = parcelRequire("fYaTm");

var $3tDkq = parcelRequire("3tDkq");

var $1RdT6 = parcelRequire("1RdT6");
var $7ecd57ae89f699d7$var$pkgName = '@atlaskit/platform-feature-flags';
var $7ecd57ae89f699d7$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $7ecd57ae89f699d7$var$hasProcessEnv = typeof $1RdT6 !== 'undefined' && typeof $1RdT6.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $7ecd57ae89f699d7$var$ENV_ENABLE_PLATFORM_FF = $7ecd57ae89f699d7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $7ecd57ae89f699d7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $7ecd57ae89f699d7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $7ecd57ae89f699d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $7ecd57ae89f699d7$var$ENV_ENABLE_PLATFORM_FF || $7ecd57ae89f699d7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $7ecd57ae89f699d7$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $7ecd57ae89f699d7$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98] = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98] || $7ecd57ae89f699d7$var$DEFAULT_PFF_GLOBAL;
function $7ecd57ae89f699d7$export$f2b591175b3e424c(resolver) {
    $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $7ecd57ae89f699d7$export$6333b6aff9fc6275(flagKey) {
    if ($7ecd57ae89f699d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3tDkq.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $7ecd57ae89f699d7$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $fYaTm.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("fYaTm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba04e8824bb8dee4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("g1oWB")).CLIENT_VERSION; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $aPYJE = parcelRequire("aPYJE");

var $g1oWB = parcelRequire("g1oWB");



var $51qEW = parcelRequire("51qEW");
var $ba04e8824bb8dee4$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $ba04e8824bb8dee4$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, FeatureGates);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$ba04e8824bb8dee4$var$_FeatureGates = $ba04e8824bb8dee4$var$FeatureGates;
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "client", new (0, $aPYJE.Client)());
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$ba04e8824bb8dee4$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $ba04e8824bb8dee4$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $ba04e8824bb8dee4$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$ba04e8824bb8dee4$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $ba04e8824bb8dee4$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $ba04e8824bb8dee4$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "initializeCalled", $ba04e8824bb8dee4$var$_FeatureGates.client.initializeCalled.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "initializeCompleted", $ba04e8824bb8dee4$var$_FeatureGates.client.initializeCompleted.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "initialize", $ba04e8824bb8dee4$var$_FeatureGates.client.initialize.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "initializeWithProvider", $ba04e8824bb8dee4$var$_FeatureGates.client.initializeWithProvider.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "initializeFromValues", $ba04e8824bb8dee4$var$_FeatureGates.client.initializeFromValues.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "manuallyLogGateExposure", $ba04e8824bb8dee4$var$_FeatureGates.client.manuallyLogGateExposure.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getExperiment", $ba04e8824bb8dee4$var$_FeatureGates.client.getExperiment.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "manuallyLogExperimentExposure", $ba04e8824bb8dee4$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "manuallyLogLayerExposure", $ba04e8824bb8dee4$var$_FeatureGates.client.manuallyLogLayerExposure.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "shutdownStatsig", $ba04e8824bb8dee4$var$_FeatureGates.client.shutdownStatsig.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "overrideGate", $ba04e8824bb8dee4$var$_FeatureGates.client.overrideGate.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "clearGateOverride", $ba04e8824bb8dee4$var$_FeatureGates.client.clearGateOverride.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "overrideConfig", $ba04e8824bb8dee4$var$_FeatureGates.client.overrideConfig.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "clearConfigOverride", $ba04e8824bb8dee4$var$_FeatureGates.client.clearConfigOverride.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "setOverrides", $ba04e8824bb8dee4$var$_FeatureGates.client.setOverrides.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getOverrides", $ba04e8824bb8dee4$var$_FeatureGates.client.getOverrides.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "clearAllOverrides", $ba04e8824bb8dee4$var$_FeatureGates.client.clearAllOverrides.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "isCurrentUser", $ba04e8824bb8dee4$var$_FeatureGates.client.isCurrentUser.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "onGateUpdated", $ba04e8824bb8dee4$var$_FeatureGates.client.onGateUpdated.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "onExperimentValueUpdated", $ba04e8824bb8dee4$var$_FeatureGates.client.onExperimentValueUpdated.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "onAnyUpdated", $ba04e8824bb8dee4$var$_FeatureGates.client.onAnyUpdated.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "updateUser", $ba04e8824bb8dee4$var$_FeatureGates.client.updateUser.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "updateUserWithProvider", $ba04e8824bb8dee4$var$_FeatureGates.client.updateUserWithProvider.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "updateUserWithValues", $ba04e8824bb8dee4$var$_FeatureGates.client.updateUserWithValues.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getPackageVersion", $ba04e8824bb8dee4$var$_FeatureGates.client.getPackageVersion.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getLayer", $ba04e8824bb8dee4$var$_FeatureGates.client.getLayer.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ba04e8824bb8dee4$var$FeatureGates, "getLayerValue", $ba04e8824bb8dee4$var$_FeatureGates.client.getLayerValue.bind($ba04e8824bb8dee4$var$_FeatureGates.client));
var $ba04e8824bb8dee4$var$boundFGJS = $ba04e8824bb8dee4$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $ba04e8824bb8dee4$var$FeatureGates;
    else {
        var $ba04e8824bb8dee4$var$_boundFGJS, $ba04e8824bb8dee4$var$_boundFGJS$getPackage;
        $ba04e8824bb8dee4$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $ba04e8824bb8dee4$var$boundVersion = (($ba04e8824bb8dee4$var$_boundFGJS = $ba04e8824bb8dee4$var$boundFGJS) === null || $ba04e8824bb8dee4$var$_boundFGJS === void 0 || ($ba04e8824bb8dee4$var$_boundFGJS$getPackage = $ba04e8824bb8dee4$var$_boundFGJS.getPackageVersion) === null || $ba04e8824bb8dee4$var$_boundFGJS$getPackage === void 0 ? void 0 : $ba04e8824bb8dee4$var$_boundFGJS$getPackage.call($ba04e8824bb8dee4$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($ba04e8824bb8dee4$var$boundVersion !== (0, $g1oWB.CLIENT_VERSION)) {
            var $ba04e8824bb8dee4$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($ba04e8824bb8dee4$var$boundVersion, " when module version ").concat((0, $g1oWB.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($ba04e8824bb8dee4$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $ba04e8824bb8dee4$export$2e2bcd8739ae039 = $ba04e8824bb8dee4$var$boundFGJS;

});
parcelRegister("kD1JK", function(module, exports) {
function $f048cc14fcf93c3c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $f048cc14fcf93c3c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fhRQI", function(module, exports) {

var $ew1M2 = parcelRequire("ew1M2");
function $b21236dcd6ad9443$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ew1M2(o.key), o);
    }
}
function $b21236dcd6ad9443$var$_createClass(e, r, t) {
    return r && $b21236dcd6ad9443$var$_defineProperties(e.prototype, r), t && $b21236dcd6ad9443$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $b21236dcd6ad9443$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aPYJE", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $7e3dc7911f223ed3$export$1f2bb630327ac4b6; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $9IviU = parcelRequire("9IviU");

var $1LBry = parcelRequire("1LBry");

var $9rkul = parcelRequire("9rkul");

var $hZGkZ = parcelRequire("hZGkZ");

var $cX2CT = parcelRequire("cX2CT");

var $fHUq5 = parcelRequire("fHUq5");

var $aIaZC = parcelRequire("aIaZC");

var $8wvzC = parcelRequire("8wvzC");

var $51qEW = parcelRequire("51qEW");

var $fhjgA = parcelRequire("fhjgA");

var $g1oWB = parcelRequire("g1oWB");
var $7e3dc7911f223ed3$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $7e3dc7911f223ed3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e3dc7911f223ed3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e3dc7911f223ed3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e3dc7911f223ed3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7e3dc7911f223ed3$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $7e3dc7911f223ed3$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $7e3dc7911f223ed3$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $8wvzC.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Client);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "initWithDefaults", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "hasCheckGateErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "hasGetExperimentErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "hasGetExperimentValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "hasGetLayerErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "hasGetLayerValueErrorOccurred", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "subscriptions", new (0, $1LBry.default)());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "dataAdapter", new (0, $aIaZC.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $8wvzC.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fhjgA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $fhjgA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $fhjgA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $fhjgA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $g1oWB.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $7e3dc7911f223ed3$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $g1oWB.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $51qEW.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $fhjgA.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $fhjgA.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $fhjgA.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $fHUq5.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $9rkul.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $9rkul.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $cX2CT.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $fhjgA.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $fhjgA.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $7e3dc7911f223ed3$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $fHUq5.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $fHUq5.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $7e3dc7911f223ed3$var$_objectSpread($7e3dc7911f223ed3$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $fhjgA.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $7e3dc7911f223ed3$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $7e3dc7911f223ed3$var$_objectSpread($7e3dc7911f223ed3$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $7e3dc7911f223ed3$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $51qEW.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(newClientOptions, $7e3dc7911f223ed3$var$_excluded);
                                this.user = (0, $fhjgA.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $7e3dc7911f223ed3$var$_objectSpread($7e3dc7911f223ed3$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $9IviU.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $9IviU.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $9IviU.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $9IviU.StatsigClient)($7e3dc7911f223ed3$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $fhjgA.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $g1oWB.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $hZGkZ.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $hZGkZ.Layer).fromLayer((0, $9IviU._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("1Wcv5", function(module, exports) {

var $kaWll = parcelRequire("kaWll");
function $1694e7857a6f2566$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kaWll(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $1694e7857a6f2566$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kaWll", function(module, exports) {
function $eb01ff91cc764aae$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $eb01ff91cc764aae$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7f5qq", function(module, exports) {
function $545e247a57d186a7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $545e247a57d186a7$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $545e247a57d186a7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $545e247a57d186a7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $545e247a57d186a7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5msJs", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $3e754b711716897c$var$runtime = (parcelRequire("jwOVh"))();
module.exports = $3e754b711716897c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $3e754b711716897c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $3e754b711716897c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($3e754b711716897c$var$runtime);
}

});
parcelRegister("jwOVh", function(module, exports) {

var $lOMrs = parcelRequire("lOMrs");

var $g9nRH = parcelRequire("g9nRH");

var $c7cqw = parcelRequire("c7cqw");

var $lwdbB = parcelRequire("lwdbB");

var $04jL4 = parcelRequire("04jL4");

var $j1usU = parcelRequire("j1usU");

var $l07qd = parcelRequire("l07qd");
function $e37881b6e69c288a$var$_regeneratorRuntime() {
    "use strict";
    var r = $g9nRH(), e = r.m($e37881b6e69c288a$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $l07qd(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $e37881b6e69c288a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $lOMrs(r, e);
            },
            AsyncIterator: $04jL4,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $lwdbB : $c7cqw)(a(r), e, t, o, u);
            },
            keys: $j1usU,
            values: $l07qd
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e37881b6e69c288a$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lOMrs", function(module, exports) {
function $fe23d806ed160e02$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $fe23d806ed160e02$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g9nRH", function(module, exports) {

var $dAp5u = parcelRequire("dAp5u");
function $bc1fffb4e426f5bd$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $dAp5u(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($dAp5u(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $dAp5u(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $dAp5u(u, "constructor", GeneratorFunctionPrototype), $dAp5u(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $dAp5u(GeneratorFunctionPrototype, o, "GeneratorFunction"), $dAp5u(u), $dAp5u(u, o, "Generator"), $dAp5u(u, n, function() {
        return this;
    }), $dAp5u(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $bc1fffb4e426f5bd$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $bc1fffb4e426f5bd$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dAp5u", function(module, exports) {
function $9e42190417a17544$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $9e42190417a17544$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $9e42190417a17544$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9e42190417a17544$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $9e42190417a17544$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("c7cqw", function(module, exports) {

var $lwdbB = parcelRequire("lwdbB");
function $8d1fc72cb178a0bd$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $lwdbB(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $8d1fc72cb178a0bd$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lwdbB", function(module, exports) {

var $g9nRH = parcelRequire("g9nRH");

var $04jL4 = parcelRequire("04jL4");
function $faa6d09de1131990$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $04jL4($g9nRH().w(r, e, t, o), n || Promise);
}
module.exports = $faa6d09de1131990$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("04jL4", function(module, exports) {

var $lOMrs = parcelRequire("lOMrs");

var $dAp5u = parcelRequire("dAp5u");
function $00cfb363e9767620$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $lOMrs ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($dAp5u($00cfb363e9767620$var$AsyncIterator.prototype), $dAp5u($00cfb363e9767620$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $dAp5u(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $00cfb363e9767620$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("j1usU", function(module, exports) {
function $dd95be18a402a055$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $dd95be18a402a055$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("l07qd", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $f49f5ae374eac2f5$var$_typeof = $cd8Dz.default;
function $f49f5ae374eac2f5$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($f49f5ae374eac2f5$var$_typeof(e) + " is not iterable");
}
module.exports = $f49f5ae374eac2f5$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("9IviU", function(module, exports) {
"use strict";
var $7130816bf1706a0d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7130816bf1706a0d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7130816bf1706a0d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $g72ph = parcelRequire("g72ph");
module.exports.StatsigClient = $g72ph.default;

$7130816bf1706a0d$var$__exportStar((parcelRequire("2CW6E")), module.exports);
const $7130816bf1706a0d$var$__STATSIG__ = Object.assign((0, (parcelRequire("2CW6E"))._getStatsigGlobal)(), {
    StatsigClient: $g72ph.default
});
module.exports.default = $7130816bf1706a0d$var$__STATSIG__;

});
parcelRegister("2CW6E", function(module, exports) {
"use strict";
var $1e9c341434ce36cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e9c341434ce36cb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e9c341434ce36cb$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eLnuN")).Diagnostics;
    }
});

var $5lC3M = parcelRequire("5lC3M");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $5lC3M.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("2tPzh")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hP1zb")).Storage;
    }
});

$1e9c341434ce36cb$var$__exportStar((parcelRequire("lgxFF")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("40Fyo")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("i9oFm")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("7GI65")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("eLnuN")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("dPfq4")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("iKLyG")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("c6TKu")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("flmt2")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("949v8")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("5Ju3m")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("2tPzh")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("gmgv0")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("bHtYz")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("WaTya")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("d61wH")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("ivAjJ")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("4dV7j")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("dinFS")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("ko5WO")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("36eNM")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("92o91")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("2yYwi")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("bdQCX")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("lMuKg")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("caWLe")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("blgi1")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("5IRpf")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("91gfT")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("3GPZ4")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("lbnPI")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("iD3YE")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("hP1zb")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("bfvaX")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("7L605")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("dMblC")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("7pap6")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("eYyiU")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("dJ7Z1")), module.exports);

$1e9c341434ce36cb$var$__exportStar((parcelRequire("kDxP6")), module.exports);
Object.assign((0, (parcelRequire("lgxFF"))._getStatsigGlobal)(), {
    Log: (parcelRequire("2tPzh")).Log,
    SDK_VERSION: (parcelRequire("blgi1")).SDK_VERSION
});

});
parcelRegister("lgxFF", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $f7b535f636cda2e0$var$_a, $f7b535f636cda2e0$var$_b, $f7b535f636cda2e0$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $2tPzh = parcelRequire("2tPzh");
const $f7b535f636cda2e0$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $f7b535f636cda2e0$var$statsigGlobal;
    } catch (e) {
        return $f7b535f636cda2e0$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $f7b535f636cda2e0$var$_getStatsigGlobal;
const $f7b535f636cda2e0$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $f7b535f636cda2e0$var$_getStatsigGlobalFlag;
const $f7b535f636cda2e0$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $2tPzh.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $f7b535f636cda2e0$var$_getInstance;
const $f7b535f636cda2e0$var$GLOBAL_KEY = '__STATSIG__';
const $f7b535f636cda2e0$var$_window = typeof window !== 'undefined' ? window : {};
const $f7b535f636cda2e0$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $f7b535f636cda2e0$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $f7b535f636cda2e0$var$statsigGlobal = ($f7b535f636cda2e0$var$_c = ($f7b535f636cda2e0$var$_b = ($f7b535f636cda2e0$var$_a = $f7b535f636cda2e0$var$_window[$f7b535f636cda2e0$var$GLOBAL_KEY]) !== null && $f7b535f636cda2e0$var$_a !== void 0 ? $f7b535f636cda2e0$var$_a : $f7b535f636cda2e0$var$_global[$f7b535f636cda2e0$var$GLOBAL_KEY]) !== null && $f7b535f636cda2e0$var$_b !== void 0 ? $f7b535f636cda2e0$var$_b : $f7b535f636cda2e0$var$_globalThis[$f7b535f636cda2e0$var$GLOBAL_KEY]) !== null && $f7b535f636cda2e0$var$_c !== void 0 ? $f7b535f636cda2e0$var$_c : {
    instance: module.exports._getInstance
};
$f7b535f636cda2e0$var$_window[$f7b535f636cda2e0$var$GLOBAL_KEY] = $f7b535f636cda2e0$var$statsigGlobal;
$f7b535f636cda2e0$var$_global[$f7b535f636cda2e0$var$GLOBAL_KEY] = $f7b535f636cda2e0$var$statsigGlobal;
$f7b535f636cda2e0$var$_globalThis[$f7b535f636cda2e0$var$GLOBAL_KEY] = $f7b535f636cda2e0$var$statsigGlobal;

});
parcelRegister("2tPzh", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $1ce64a8c24f19c4b$var$DEBUG = ' DEBUG ';
const $1ce64a8c24f19c4b$var$_INFO = '  INFO ';
const $1ce64a8c24f19c4b$var$_WARN = '  WARN ';
const $1ce64a8c24f19c4b$var$ERROR = ' ERROR ';
function $1ce64a8c24f19c4b$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $1ce64a8c24f19c4b$var$Log {
    static info(...args) {
        if ($1ce64a8c24f19c4b$var$Log.level >= module.exports.LogLevel.Info) console.info($1ce64a8c24f19c4b$var$_INFO, ...$1ce64a8c24f19c4b$var$addTag(args));
    }
    static debug(...args) {
        if ($1ce64a8c24f19c4b$var$Log.level >= module.exports.LogLevel.Debug) console.debug($1ce64a8c24f19c4b$var$DEBUG, ...$1ce64a8c24f19c4b$var$addTag(args));
    }
    static warn(...args) {
        if ($1ce64a8c24f19c4b$var$Log.level >= module.exports.LogLevel.Warn) console.warn($1ce64a8c24f19c4b$var$_WARN, ...$1ce64a8c24f19c4b$var$addTag(args));
    }
    static error(...args) {
        if ($1ce64a8c24f19c4b$var$Log.level >= module.exports.LogLevel.Error) console.error($1ce64a8c24f19c4b$var$ERROR, ...$1ce64a8c24f19c4b$var$addTag(args));
    }
}
module.exports.Log = $1ce64a8c24f19c4b$var$Log;
$1ce64a8c24f19c4b$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("eLnuN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $abf7ae4069435e32$var$MARKER_MAP = new Map();
const $abf7ae4069435e32$var$ACT_START = 'start';
const $abf7ae4069435e32$var$ACT_END = 'end';
const $abf7ae4069435e32$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $abf7ae4069435e32$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker({}, $abf7ae4069435e32$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $abf7ae4069435e32$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker(data, $abf7ae4069435e32$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker(data, $abf7ae4069435e32$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker({}, $abf7ae4069435e32$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $abf7ae4069435e32$var$_addMarker(sdkKey, $abf7ae4069435e32$var$_createMarker(data, $abf7ae4069435e32$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $abf7ae4069435e32$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $abf7ae4069435e32$var$_safeGetField(e, 'code'),
            name: $abf7ae4069435e32$var$_safeGetField(e, 'name'),
            message: $abf7ae4069435e32$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $abf7ae4069435e32$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $abf7ae4069435e32$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $abf7ae4069435e32$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $abf7ae4069435e32$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $abf7ae4069435e32$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $abf7ae4069435e32$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $abf7ae4069435e32$var$MARKER_MAP.set(sdkKey, markers);
}
function $abf7ae4069435e32$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("5lC3M", function(module, exports) {
"use strict";
var $3e4c6fd26f7e0b07$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $40Fyo = parcelRequire("40Fyo");

var $949v8 = parcelRequire("949v8");

var $2tPzh = parcelRequire("2tPzh");

var $bHtYz = parcelRequire("bHtYz");

var $4dV7j = parcelRequire("4dV7j");

var $caWLe = parcelRequire("caWLe");

var $5IRpf = parcelRequire("5IRpf");

var $hP1zb = parcelRequire("hP1zb");

var $dMblC = parcelRequire("dMblC");

var $eYyiU = parcelRequire("eYyiU");
const $3e4c6fd26f7e0b07$var$DEFAULT_QUEUE_SIZE = 100;
const $3e4c6fd26f7e0b07$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $3e4c6fd26f7e0b07$var$MAX_DEDUPER_KEYS = 1000;
const $3e4c6fd26f7e0b07$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $3e4c6fd26f7e0b07$var$MAX_FAILED_LOGS = 500;
const $3e4c6fd26f7e0b07$var$QUICK_FLUSH_WINDOW_MS = 200;
const $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP = {};
const $3e4c6fd26f7e0b07$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $3e4c6fd26f7e0b07$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($3e4c6fd26f7e0b07$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $3e4c6fd26f7e0b07$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $4dV7j._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $eYyiU._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $3e4c6fd26f7e0b07$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $3e4c6fd26f7e0b07$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($3e4c6fd26f7e0b07$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $3e4c6fd26f7e0b07$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $3e4c6fd26f7e0b07$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $3e4c6fd26f7e0b07$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$3e4c6fd26f7e0b07$var$EventLogger._safeFlushAndForget(this._sdkKey), $3e4c6fd26f7e0b07$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $4dV7j._isServerEnv)()) return false;
        if (!(0, $caWLe._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $40Fyo._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $3e4c6fd26f7e0b07$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $3e4c6fd26f7e0b07$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $3e4c6fd26f7e0b07$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $eYyiU._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $2tPzh.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $2tPzh.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $3e4c6fd26f7e0b07$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$bHtYz.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $3e4c6fd26f7e0b07$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $hP1zb._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $2tPzh.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$3e4c6fd26f7e0b07$var$__awaiter(this, void 0, void 0, function*() {
                if (!$hP1zb.Storage.isReady()) yield $hP1zb.Storage.isReadyResolver();
                const events = (0, $hP1zb._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $3e4c6fd26f7e0b07$var$RetryFailedLogsTrigger.Startup) $hP1zb.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $3e4c6fd26f7e0b07$var$RetryFailedLogsTrigger.GainedFocus) $hP1zb.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $2tPzh.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $949v8._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $2tPzh.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $4dV7j._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $3e4c6fd26f7e0b07$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $3e4c6fd26f7e0b07$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $3e4c6fd26f7e0b07$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $5IRpf.LoggingEnabledOption.disabled : $5IRpf.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $2tPzh.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $3e4c6fd26f7e0b07$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $dMblC.UrlConfiguration($bHtYz.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $3e4c6fd26f7e0b07$var$EventLogger;

});
parcelRegister("40Fyo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $949v8 = parcelRequire("949v8");
function $2eb7653a9877b1cf$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $949v8._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $2eb7653a9877b1cf$var$_getUserStorageKey;
function $2eb7653a9877b1cf$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $2eb7653a9877b1cf$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $949v8._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $2eb7653a9877b1cf$var$_getStorageKey;

});
parcelRegister("949v8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $7L605 = parcelRequire("7L605");
const $699bdb7d0135e6b9$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $699bdb7d0135e6b9$var$_DJB2;
const $699bdb7d0135e6b9$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $699bdb7d0135e6b9$var$_DJB2Object;
const $699bdb7d0135e6b9$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $7L605._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $699bdb7d0135e6b9$var$_getSortedObject;

});
parcelRegister("7L605", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $5a6193bfe46ed0d2$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $5a6193bfe46ed0d2$var$_typeOf;
function $5a6193bfe46ed0d2$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $5a6193bfe46ed0d2$var$_isTypeMatch;

});



parcelRegister("bHtYz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("4dV7j", function(module, exports) {

var $1RdT6 = parcelRequire("1RdT6");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $3134ae8e853731d7$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $3134ae8e853731d7$var$_getWindowSafe;
const $3134ae8e853731d7$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $3134ae8e853731d7$var$_getDocumentSafe;
const $3134ae8e853731d7$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $1RdT6 !== 'undefined' && $1RdT6.versions != null && $1RdT6.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $3134ae8e853731d7$var$_isServerEnv;
const $3134ae8e853731d7$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $3134ae8e853731d7$var$_addWindowEventListenerSafe;
const $3134ae8e853731d7$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $3134ae8e853731d7$var$_addDocumentEventListenerSafe;
const $3134ae8e853731d7$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $3134ae8e853731d7$var$_getCurrentPageUrlSafe;
const $3134ae8e853731d7$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $3134ae8e853731d7$var$_getUnloadEvent;

});
parcelRegister("1RdT6", function(module, exports) {
// shim for using process in browser
var $15a583826a6f11e8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $15a583826a6f11e8$var$cachedSetTimeout;
var $15a583826a6f11e8$var$cachedClearTimeout;
function $15a583826a6f11e8$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $15a583826a6f11e8$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $15a583826a6f11e8$var$cachedSetTimeout = setTimeout;
        else $15a583826a6f11e8$var$cachedSetTimeout = $15a583826a6f11e8$var$defaultSetTimout;
    } catch (e) {
        $15a583826a6f11e8$var$cachedSetTimeout = $15a583826a6f11e8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $15a583826a6f11e8$var$cachedClearTimeout = clearTimeout;
        else $15a583826a6f11e8$var$cachedClearTimeout = $15a583826a6f11e8$var$defaultClearTimeout;
    } catch (e) {
        $15a583826a6f11e8$var$cachedClearTimeout = $15a583826a6f11e8$var$defaultClearTimeout;
    }
})();
function $15a583826a6f11e8$var$runTimeout(fun) {
    if ($15a583826a6f11e8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($15a583826a6f11e8$var$cachedSetTimeout === $15a583826a6f11e8$var$defaultSetTimout || !$15a583826a6f11e8$var$cachedSetTimeout) && setTimeout) {
        $15a583826a6f11e8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $15a583826a6f11e8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $15a583826a6f11e8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $15a583826a6f11e8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $15a583826a6f11e8$var$runClearTimeout(marker) {
    if ($15a583826a6f11e8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($15a583826a6f11e8$var$cachedClearTimeout === $15a583826a6f11e8$var$defaultClearTimeout || !$15a583826a6f11e8$var$cachedClearTimeout) && clearTimeout) {
        $15a583826a6f11e8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $15a583826a6f11e8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $15a583826a6f11e8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $15a583826a6f11e8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $15a583826a6f11e8$var$queue = [];
var $15a583826a6f11e8$var$draining = false;
var $15a583826a6f11e8$var$currentQueue;
var $15a583826a6f11e8$var$queueIndex = -1;
function $15a583826a6f11e8$var$cleanUpNextTick() {
    if (!$15a583826a6f11e8$var$draining || !$15a583826a6f11e8$var$currentQueue) return;
    $15a583826a6f11e8$var$draining = false;
    if ($15a583826a6f11e8$var$currentQueue.length) $15a583826a6f11e8$var$queue = $15a583826a6f11e8$var$currentQueue.concat($15a583826a6f11e8$var$queue);
    else $15a583826a6f11e8$var$queueIndex = -1;
    if ($15a583826a6f11e8$var$queue.length) $15a583826a6f11e8$var$drainQueue();
}
function $15a583826a6f11e8$var$drainQueue() {
    if ($15a583826a6f11e8$var$draining) return;
    var timeout = $15a583826a6f11e8$var$runTimeout($15a583826a6f11e8$var$cleanUpNextTick);
    $15a583826a6f11e8$var$draining = true;
    var len = $15a583826a6f11e8$var$queue.length;
    while(len){
        $15a583826a6f11e8$var$currentQueue = $15a583826a6f11e8$var$queue;
        $15a583826a6f11e8$var$queue = [];
        while(++$15a583826a6f11e8$var$queueIndex < len)if ($15a583826a6f11e8$var$currentQueue) $15a583826a6f11e8$var$currentQueue[$15a583826a6f11e8$var$queueIndex].run();
        $15a583826a6f11e8$var$queueIndex = -1;
        len = $15a583826a6f11e8$var$queue.length;
    }
    $15a583826a6f11e8$var$currentQueue = null;
    $15a583826a6f11e8$var$draining = false;
    $15a583826a6f11e8$var$runClearTimeout(timeout);
}
$15a583826a6f11e8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $15a583826a6f11e8$var$queue.push(new $15a583826a6f11e8$var$Item(fun, args));
    if ($15a583826a6f11e8$var$queue.length === 1 && !$15a583826a6f11e8$var$draining) $15a583826a6f11e8$var$runTimeout($15a583826a6f11e8$var$drainQueue);
};
// v8 likes predictible objects
function $15a583826a6f11e8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$15a583826a6f11e8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$15a583826a6f11e8$var$process.title = 'browser';
$15a583826a6f11e8$var$process.browser = true;
$15a583826a6f11e8$var$process.env = {};
$15a583826a6f11e8$var$process.argv = [];
$15a583826a6f11e8$var$process.version = ''; // empty string to avoid regexp issues
$15a583826a6f11e8$var$process.versions = {};
function $15a583826a6f11e8$var$noop() {}
$15a583826a6f11e8$var$process.on = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.addListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.once = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.off = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.removeListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.removeAllListeners = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.emit = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.prependListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.prependOnceListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.listeners = function(name) {
    return [];
};
$15a583826a6f11e8$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$15a583826a6f11e8$var$process.cwd = function() {
    return '/';
};
$15a583826a6f11e8$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$15a583826a6f11e8$var$process.umask = function() {
    return 0;
};

});


parcelRegister("caWLe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $8dd3ffdcfeb2985f$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $8dd3ffdcfeb2985f$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $8dd3ffdcfeb2985f$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $8dd3ffdcfeb2985f$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $8dd3ffdcfeb2985f$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $8dd3ffdcfeb2985f$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $8dd3ffdcfeb2985f$var$GATE_EXPOSURE_NAME || eventName === $8dd3ffdcfeb2985f$var$CONFIG_EXPOSURE_NAME || eventName === $8dd3ffdcfeb2985f$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $8dd3ffdcfeb2985f$var$_isExposureEvent;
const $8dd3ffdcfeb2985f$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $8dd3ffdcfeb2985f$var$_createExposure($8dd3ffdcfeb2985f$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $8dd3ffdcfeb2985f$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $8dd3ffdcfeb2985f$var$_createGateExposure;
function $8dd3ffdcfeb2985f$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $8dd3ffdcfeb2985f$var$_mapExposures;
const $8dd3ffdcfeb2985f$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $8dd3ffdcfeb2985f$var$_createExposure($8dd3ffdcfeb2985f$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $8dd3ffdcfeb2985f$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $8dd3ffdcfeb2985f$var$_createConfigExposure;
const $8dd3ffdcfeb2985f$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $8dd3ffdcfeb2985f$var$_createExposure($8dd3ffdcfeb2985f$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $8dd3ffdcfeb2985f$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $8dd3ffdcfeb2985f$var$_createLayerParameterExposure;
const $8dd3ffdcfeb2985f$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("5IRpf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("hP1zb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $2tPzh = parcelRequire("2tPzh");

var $4dV7j = parcelRequire("4dV7j");
const $cf986a2872b5a6a7$var$inMemoryStore = {};
const $cf986a2872b5a6a7$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$cf986a2872b5a6a7$var$inMemoryStore[key] ? $cf986a2872b5a6a7$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $cf986a2872b5a6a7$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $cf986a2872b5a6a7$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($cf986a2872b5a6a7$var$inMemoryStore)
};
let $cf986a2872b5a6a7$var$_localStorageProvider = null;
try {
    const win = (0, $4dV7j._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $cf986a2872b5a6a7$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $2tPzh.Log.warn('Failed to setup localStorageProvider.');
}
let $cf986a2872b5a6a7$var$_main = $cf986a2872b5a6a7$var$_localStorageProvider !== null && $cf986a2872b5a6a7$var$_localStorageProvider !== void 0 ? $cf986a2872b5a6a7$var$_localStorageProvider : $cf986a2872b5a6a7$var$_inMemoryProvider;
let $cf986a2872b5a6a7$var$_current = $cf986a2872b5a6a7$var$_main;
function $cf986a2872b5a6a7$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($cf986a2872b5a6a7$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === 'QuotaExceededError') {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith('statsig.'));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$cf986a2872b5a6a7$var$_current.isReady(),
    isReadyResolver: ()=>$cf986a2872b5a6a7$var$_current.isReadyResolver(),
    getProviderName: ()=>$cf986a2872b5a6a7$var$_current.getProviderName(),
    getItem: (key)=>$cf986a2872b5a6a7$var$_inMemoryBreaker(()=>$cf986a2872b5a6a7$var$_current.getItem(key)),
    setItem: (key, value)=>$cf986a2872b5a6a7$var$_inMemoryBreaker(()=>$cf986a2872b5a6a7$var$_current.setItem(key, value)),
    removeItem: (key)=>$cf986a2872b5a6a7$var$_current.removeItem(key),
    getAllKeys: ()=>$cf986a2872b5a6a7$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $cf986a2872b5a6a7$var$_main = newProvider;
        $cf986a2872b5a6a7$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $cf986a2872b5a6a7$var$_current = $cf986a2872b5a6a7$var$_inMemoryProvider;
        else $cf986a2872b5a6a7$var$_current = $cf986a2872b5a6a7$var$_main;
    }
};
function $cf986a2872b5a6a7$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $cf986a2872b5a6a7$var$_getObjectFromStorage;
function $cf986a2872b5a6a7$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $cf986a2872b5a6a7$var$_setObjectInStorage;

});

parcelRegister("dMblC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $949v8 = parcelRequire("949v8");

var $bHtYz = parcelRequire("bHtYz");
const $a0788f7e3b25a796$var$ENDPOINT_DNS_KEY_MAP = {
    [$bHtYz.Endpoint._initialize]: 'i',
    [$bHtYz.Endpoint._rgstr]: 'e',
    [$bHtYz.Endpoint._download_config_specs]: 'd'
};
class $a0788f7e3b25a796$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $949v8._DJB2)(this.customUrl + fallbacks);
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a0788f7e3b25a796$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $bHtYz.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $a0788f7e3b25a796$var$UrlConfiguration;

});

parcelRegister("eYyiU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $4dV7j = parcelRequire("4dV7j");
const $ae7147522fa24549$var$FOREGROUND = 'foreground';
const $ae7147522fa24549$var$BACKGROUND = 'background';
const $ae7147522fa24549$var$LISTENERS = [];
let $ae7147522fa24549$var$current = $ae7147522fa24549$var$FOREGROUND;
let $ae7147522fa24549$var$isUnloading = false;
const $ae7147522fa24549$var$_isCurrentlyVisible = ()=>{
    return $ae7147522fa24549$var$current === $ae7147522fa24549$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $ae7147522fa24549$var$_isCurrentlyVisible;
const $ae7147522fa24549$var$_isUnloading = ()=>$ae7147522fa24549$var$isUnloading;
module.exports._isUnloading = $ae7147522fa24549$var$_isUnloading;
const $ae7147522fa24549$var$_subscribeToVisiblityChanged = (listener)=>{
    $ae7147522fa24549$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $ae7147522fa24549$var$_subscribeToVisiblityChanged;
const $ae7147522fa24549$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $ae7147522fa24549$var$current) return;
    $ae7147522fa24549$var$current = visibility;
    $ae7147522fa24549$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $ae7147522fa24549$var$_notifyVisibilityChanged;
(0, $4dV7j._addWindowEventListenerSafe)('focus', ()=>{
    $ae7147522fa24549$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($ae7147522fa24549$var$FOREGROUND);
});
(0, $4dV7j._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($ae7147522fa24549$var$BACKGROUND));
(0, $4dV7j._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $ae7147522fa24549$var$FOREGROUND : $ae7147522fa24549$var$BACKGROUND);
});
(0, $4dV7j._addWindowEventListenerSafe)((0, $4dV7j._getUnloadEvent)(), ()=>{
    $ae7147522fa24549$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($ae7147522fa24549$var$BACKGROUND);
});

});


parcelRegister("blgi1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.24.1';
let $841e4aaa3d678bf2$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$841e4aaa3d678bf2$var$metadata,
    add: (additions)=>{
        $841e4aaa3d678bf2$var$metadata = Object.assign(Object.assign({}, $841e4aaa3d678bf2$var$metadata), additions);
    }
};

});

parcelRegister("i9oFm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7GI65", function(module, exports) {
"use strict";
var $598ea96f38a624ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $2tPzh = parcelRequire("2tPzh");

var $92o91 = parcelRequire("92o91");

var $iD3YE = parcelRequire("iD3YE");

var $hP1zb = parcelRequire("hP1zb");

var $bfvaX = parcelRequire("bfvaX");
const $598ea96f38a624ba$var$CACHE_LIMIT = 10;
class $598ea96f38a624ba$var$DataAdapterCore {
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $iD3YE._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $iD3YE._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $598ea96f38a624ba$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $92o91.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $598ea96f38a624ba$var$__awaiter(this, void 0, void 0, function*() {
            if (!$hP1zb.Storage.isReady()) yield $hP1zb.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $2tPzh.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $598ea96f38a624ba$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $iD3YE._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $598ea96f38a624ba$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $2tPzh.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $bfvaX._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $92o91.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $598ea96f38a624ba$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $598ea96f38a624ba$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $2tPzh.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $hP1zb.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($hP1zb.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $bfvaX._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $hP1zb.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $hP1zb._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $598ea96f38a624ba$var$_getEvictableKey(lastModifiedTimeMap, $598ea96f38a624ba$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $hP1zb.Storage.removeItem(evictable);
        }
        (0, $hP1zb._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $598ea96f38a624ba$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $598ea96f38a624ba$var$DataAdapterCore;
function $598ea96f38a624ba$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $iD3YE._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $598ea96f38a624ba$var$_makeDataAdapterResult;
class $598ea96f38a624ba$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $2tPzh.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $598ea96f38a624ba$var$_getEvictableKey(this._data, $598ea96f38a624ba$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $598ea96f38a624ba$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("92o91", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $40Fyo = parcelRequire("40Fyo");

var $2tPzh = parcelRequire("2tPzh");

var $4dV7j = parcelRequire("4dV7j");

var $hP1zb = parcelRequire("hP1zb");

var $7pap6 = parcelRequire("7pap6");
const $69470788a49d2bd2$var$PROMISE_MAP = {};
const $69470788a49d2bd2$var$COOKIE_ENABLED_MAP = {};
const $69470788a49d2bd2$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($69470788a49d2bd2$var$DISABLED_MAP[sdkKey]) return null;
        if ($69470788a49d2bd2$var$PROMISE_MAP[sdkKey] != null) return $69470788a49d2bd2$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $69470788a49d2bd2$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $69470788a49d2bd2$var$PROMISE_MAP[sdkKey] = stableID;
            $69470788a49d2bd2$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $69470788a49d2bd2$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $7pap6.getUUID)();
        $69470788a49d2bd2$var$_persistToStorage(stableID, sdkKey);
        $69470788a49d2bd2$var$_persistToCookie(stableID, sdkKey);
        $69470788a49d2bd2$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $69470788a49d2bd2$var$PROMISE_MAP[sdkKey] = override;
        $69470788a49d2bd2$var$_persistToStorage(override, sdkKey);
        $69470788a49d2bd2$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $69470788a49d2bd2$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $69470788a49d2bd2$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $69470788a49d2bd2$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $40Fyo._getStorageKey)(sdkKey)}`;
}
function $69470788a49d2bd2$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $69470788a49d2bd2$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $hP1zb._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $2tPzh.Log.warn('Failed to save StableID to storage');
    }
}
function $69470788a49d2bd2$var$_loadFromStorage(sdkKey) {
    const storageKey = $69470788a49d2bd2$var$_getStableIDStorageKey(sdkKey);
    return (0, $hP1zb._getObjectFromStorage)(storageKey);
}
function $69470788a49d2bd2$var$_loadFromCookie(sdkKey) {
    if (!$69470788a49d2bd2$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $4dV7j._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $69470788a49d2bd2$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $69470788a49d2bd2$var$_persistToCookie(stableID, sdkKey) {
    if (!$69470788a49d2bd2$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$69470788a49d2bd2$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $69470788a49d2bd2$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $40Fyo._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("7pap6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $5642f02c31d3e813$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $5642f02c31d3e813$var$getUUID;

});


parcelRegister("iD3YE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $949v8 = parcelRequire("949v8");

var $2tPzh = parcelRequire("2tPzh");
function $d8fef4518c240faf$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $2tPzh.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $d8fef4518c240faf$var$_normalizeUser;
function $d8fef4518c240faf$var$_getFullUserHash(user) {
    return user ? (0, $949v8._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $d8fef4518c240faf$var$_getFullUserHash;

});

parcelRegister("bfvaX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $2tPzh = parcelRequire("2tPzh");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $83094746d6bdf3b6$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $2tPzh.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $83094746d6bdf3b6$var$_typedJsonParse;

});


parcelRegister("dPfq4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iKLyG", function(module, exports) {
"use strict";
var $da7169f99d808002$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $2tPzh = parcelRequire("2tPzh");

var $dinFS = parcelRequire("dinFS");

var $blgi1 = parcelRequire("blgi1");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $da7169f99d808002$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $da7169f99d808002$var$ErrorBoundary {
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $da7169f99d808002$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $da7169f99d808002$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $2tPzh.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$da7169f99d808002$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($da7169f99d808002$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $da7169f99d808002$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $dinFS.SDKType._get(this._sdkKey);
                    const statsigMetadata = $blgi1.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $da7169f99d808002$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $da7169f99d808002$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $da7169f99d808002$var$ErrorBoundary;
function $da7169f99d808002$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $da7169f99d808002$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $da7169f99d808002$var$UNKNOWN_ERROR;
    }
}
function $da7169f99d808002$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $da7169f99d808002$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("dinFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $9adf520f4c72004f$var$SDK_CLIENT = {};
let $9adf520f4c72004f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $9adf520f4c72004f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($9adf520f4c72004f$var$suffix !== null && $9adf520f4c72004f$var$suffix !== void 0 ? $9adf520f4c72004f$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $9adf520f4c72004f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$9adf520f4c72004f$var$suffix || $9adf520f4c72004f$var$suffix === '-react') $9adf520f4c72004f$var$suffix = '-' + binding;
    }
};

});


parcelRegister("c6TKu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("flmt2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5Ju3m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("gmgv0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $be8b7fc8f2025147$var$EXIST_KEYS = new Set([]);
const $be8b7fc8f2025147$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $be8b7fc8f2025147$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($be8b7fc8f2025147$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($be8b7fc8f2025147$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $be8b7fc8f2025147$var$createMemoKey;

});

parcelRegister("WaTya", function(module, exports) {
"use strict";
var $0aedde687f33797a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $lgxFF = parcelRequire("lgxFF");

var $lgxFF = parcelRequire("lgxFF");

var $eLnuN = parcelRequire("eLnuN");

var $2tPzh = parcelRequire("2tPzh");

var $bHtYz = parcelRequire("bHtYz");

var $2ldAq = parcelRequire("2ldAq");

var $kDxP6 = parcelRequire("kDxP6");

var $dinFS = parcelRequire("dinFS");

var $4dV7j = parcelRequire("4dV7j");

var $ko5WO = parcelRequire("ko5WO");

var $92o91 = parcelRequire("92o91");

var $bdQCX = parcelRequire("bdQCX");

var $blgi1 = parcelRequire("blgi1");

var $5IRpf = parcelRequire("5IRpf");

var $eYyiU = parcelRequire("eYyiU");
const $0aedde687f33797a$var$DEFAULT_TIMEOUT_MS = 10000;
const $0aedde687f33797a$var$BACKOFF_BASE_MS = 500;
const $0aedde687f33797a$var$BACKOFF_MAX_MS = 30000;
const $0aedde687f33797a$var$RATE_LIMIT_WINDOW_MS = 1000;
const $0aedde687f33797a$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $0aedde687f33797a$var$LEAK_RATE = $0aedde687f33797a$var$RATE_LIMIT_MAX_REQ_COUNT / $0aedde687f33797a$var$RATE_LIMIT_WINDOW_MS;
const $0aedde687f33797a$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $0aedde687f33797a$var$NetworkCore {
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$0aedde687f33797a$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $0aedde687f33797a$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $0aedde687f33797a$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$0aedde687f33797a$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $2tPzh.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $eYyiU._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $0aedde687f33797a$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $0aedde687f33797a$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $0aedde687f33797a$var$_getErrorMessage(abortController, error);
                const timedOut = $0aedde687f33797a$var$_didTimeout(abortController);
                $0aedde687f33797a$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$0aedde687f33797a$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $bdQCX.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $2tPzh.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $0aedde687f33797a$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $5IRpf.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $5IRpf.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $0aedde687f33797a$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $0aedde687f33797a$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $bHtYz.Endpoint._initialize || args.urlConfig.endpoint === $bHtYz.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$bHtYz.NetworkParam.SdkKey]: args.sdkKey,
            [$bHtYz.NetworkParam.SdkType]: $dinFS.SDKType._get(args.sdkKey),
            [$bHtYz.NetworkParam.SdkVersion]: $blgi1.SDK_VERSION,
            [$bHtYz.NetworkParam.Time]: String(Date.now()),
            [$bHtYz.NetworkParam.SessionID]: $ko5WO.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $4dV7j._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $lgxFF._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$bHtYz.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $2tPzh.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $0aedde687f33797a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$0aedde687f33797a$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($2tPzh.Log.error);
                writer.close().catch($2tPzh.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$bHtYz.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $2tPzh.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $0aedde687f33797a$var$_populateRequestBody(result, args.data);
        return result;
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $0aedde687f33797a$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $2ldAq.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
}
module.exports.NetworkCore = $0aedde687f33797a$var$NetworkCore;
const $0aedde687f33797a$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $2tPzh.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $0aedde687f33797a$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $92o91.StableID.get(sdkKey);
    const sessionID = $ko5WO.SessionID.get(sdkKey);
    const sdkType = $dinFS.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $blgi1.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $0aedde687f33797a$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $lgxFF._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $kDxP6.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $5IRpf.LogEventCompressionMode.Disabled:
            return false;
        case $5IRpf.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $5IRpf.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $0aedde687f33797a$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $0aedde687f33797a$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $0aedde687f33797a$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $bHtYz.Endpoint._initialize) return;
    $eLnuN.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $0aedde687f33797a$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $bHtYz.Endpoint._initialize) return;
    $eLnuN.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $eLnuN.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $0aedde687f33797a$var$_exponentialBackoff(attempt) {
    return $0aedde687f33797a$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($0aedde687f33797a$var$BACKOFF_BASE_MS * (attempt * attempt), $0aedde687f33797a$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("2ldAq", function(module, exports) {
"use strict";
var $1b4814eb2a18b00f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $jWKmz = parcelRequire("jWKmz");

var $949v8 = parcelRequire("949v8");

var $2tPzh = parcelRequire("2tPzh");

var $hP1zb = parcelRequire("hP1zb");
const $1b4814eb2a18b00f$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $1b4814eb2a18b00f$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $1b4814eb2a18b00f$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $1b4814eb2a18b00f$var$DEFAULT_TTL_MS;
        $1b4814eb2a18b00f$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $1b4814eb2a18b00f$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $1b4814eb2a18b00f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $1b4814eb2a18b00f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$1b4814eb2a18b00f$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $1b4814eb2a18b00f$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $1b4814eb2a18b00f$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $1b4814eb2a18b00f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $1b4814eb2a18b00f$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $jWKmz._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $1b4814eb2a18b00f$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $1b4814eb2a18b00f$var$NetworkFallbackResolver;
function $1b4814eb2a18b00f$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $1b4814eb2a18b00f$var$_isDomainFailure;
function $1b4814eb2a18b00f$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $949v8._DJB2)(sdkKey)}`;
}
function $1b4814eb2a18b00f$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $1b4814eb2a18b00f$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $hP1zb.Storage.removeItem(hashKey);
        return;
    }
    $hP1zb.Storage.setItem(hashKey, JSON.stringify(info));
}
function $1b4814eb2a18b00f$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $1b4814eb2a18b00f$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $hP1zb.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $2tPzh.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $1b4814eb2a18b00f$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("jWKmz", function(module, exports) {
"use strict";
var $e85765d188de6539$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $e85765d188de6539$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $e85765d188de6539$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $e85765d188de6539$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $e85765d188de6539$var$MAX_START_LOOKUP = 200;
function $e85765d188de6539$var$_fetchTxtRecords(networkFunc) {
    return $e85765d188de6539$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($e85765d188de6539$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $e85765d188de6539$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $e85765d188de6539$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $e85765d188de6539$var$_fetchTxtRecords;
function $e85765d188de6539$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $e85765d188de6539$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $e85765d188de6539$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("kDxP6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $f061afbe7f441f77$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $f061afbe7f441f77$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $f061afbe7f441f77$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("ko5WO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $lgxFF = parcelRequire("lgxFF");

var $40Fyo = parcelRequire("40Fyo");

var $2tPzh = parcelRequire("2tPzh");

var $hP1zb = parcelRequire("hP1zb");

var $7pap6 = parcelRequire("7pap6");
const $ed7aa9966fecd7ab$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $ed7aa9966fecd7ab$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $ed7aa9966fecd7ab$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($ed7aa9966fecd7ab$var$PROMISE_MAP[sdkKey] == null) $ed7aa9966fecd7ab$var$PROMISE_MAP[sdkKey] = $ed7aa9966fecd7ab$var$_loadSession(sdkKey);
        const session = $ed7aa9966fecd7ab$var$PROMISE_MAP[sdkKey];
        return $ed7aa9966fecd7ab$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $ed7aa9966fecd7ab$var$PROMISE_MAP[sdkKey] = $ed7aa9966fecd7ab$var$_overrideSessionId(override, sdkKey);
    }
};
function $ed7aa9966fecd7ab$var$_loadSession(sdkKey) {
    let data = $ed7aa9966fecd7ab$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $7pap6.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $ed7aa9966fecd7ab$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $ed7aa9966fecd7ab$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($ed7aa9966fecd7ab$var$_isIdle(data) || $ed7aa9966fecd7ab$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $7pap6.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $ed7aa9966fecd7ab$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $ed7aa9966fecd7ab$var$_createSessionTimeout(sdkKey, $ed7aa9966fecd7ab$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $ed7aa9966fecd7ab$var$_createSessionTimeout(sdkKey, $ed7aa9966fecd7ab$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $ed7aa9966fecd7ab$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $lgxFF._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $ed7aa9966fecd7ab$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $ed7aa9966fecd7ab$var$MAX_SESSION_IDLE_TIME;
}
function $ed7aa9966fecd7ab$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $ed7aa9966fecd7ab$var$MAX_SESSION_AGE;
}
function $ed7aa9966fecd7ab$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $40Fyo._getStorageKey)(sdkKey)}`;
}
function $ed7aa9966fecd7ab$var$_persistToStorage(session, sdkKey) {
    const storageKey = $ed7aa9966fecd7ab$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $hP1zb._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $2tPzh.Log.warn('Failed to save SessionID');
    }
}
function $ed7aa9966fecd7ab$var$_loadFromStorage(sdkKey) {
    const storageKey = $ed7aa9966fecd7ab$var$_getSessionIDStorageKey(sdkKey);
    return (0, $hP1zb._getObjectFromStorage)(storageKey);
}

});

parcelRegister("bdQCX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("d61wH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("ivAjJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("36eNM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $241d69fdd21be6e9$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $241d69fdd21be6e9$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $241d69fdd21be6e9$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $241d69fdd21be6e9$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $241d69fdd21be6e9$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $241d69fdd21be6e9$var$_fastApproxSizeOf;

});

parcelRegister("2yYwi", function(module, exports) {
"use strict";
var $1dddb3c28b0978e1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $lgxFF = parcelRequire("lgxFF");

var $lgxFF = parcelRequire("lgxFF");

var $iKLyG = parcelRequire("iKLyG");

var $5lC3M = parcelRequire("5lC3M");

var $2tPzh = parcelRequire("2tPzh");

var $gmgv0 = parcelRequire("gmgv0");

var $4dV7j = parcelRequire("4dV7j");

var $ko5WO = parcelRequire("ko5WO");

var $92o91 = parcelRequire("92o91");

var $5IRpf = parcelRequire("5IRpf");

var $hP1zb = parcelRequire("hP1zb");
const $1dddb3c28b0978e1$var$MAX_MEMO_CACHE_SIZE = 3000;
class $1dddb3c28b0978e1$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $hP1zb.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $92o91.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($5IRpf.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $1dddb3c28b0978e1$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $2tPzh.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $gmgv0.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $1dddb3c28b0978e1$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($2tPzh.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $hP1zb.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $ko5WO.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $hP1zb.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $92o91.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $92o91.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $5lC3M.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $iKLyG.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $hP1zb.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $1dddb3c28b0978e1$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $1dddb3c28b0978e1$var$StatsigClientBase;
function $1dddb3c28b0978e1$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $4dV7j._isServerEnv)()) return;
    const statsigGlobal = (0, $lgxFF._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $2tPzh.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("lMuKg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("91gfT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3GPZ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $2tPzh = parcelRequire("2tPzh");

var $7L605 = parcelRequire("7L605");
function $2afd9e4bb37ee4cb$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $2afd9e4bb37ee4cb$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $2afd9e4bb37ee4cb$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $2afd9e4bb37ee4cb$var$_makeFeatureGate;
function $2afd9e4bb37ee4cb$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $2afd9e4bb37ee4cb$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $2afd9e4bb37ee4cb$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $2afd9e4bb37ee4cb$var$_makeDynamicConfig;
function $2afd9e4bb37ee4cb$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $2afd9e4bb37ee4cb$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $2afd9e4bb37ee4cb$var$_makeExperiment;
function $2afd9e4bb37ee4cb$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $2afd9e4bb37ee4cb$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $2afd9e4bb37ee4cb$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $2afd9e4bb37ee4cb$var$_makeLayer;
function $2afd9e4bb37ee4cb$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $2afd9e4bb37ee4cb$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $2afd9e4bb37ee4cb$var$_mergeOverride;
function $2afd9e4bb37ee4cb$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $7L605._isTypeMatch)(found, fallback)) {
            $2tPzh.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $2afd9e4bb37ee4cb$var$_makeTypedGet;

});

parcelRegister("lbnPI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dJ7Z1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $02943871ffa17d8f$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $02943871ffa17d8f$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("g72ph", function(module, exports) {
"use strict";
var $bbaf2ab66628af55$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CW6E = parcelRequire("2CW6E");

var $1HtkZ = parcelRequire("1HtkZ");

var $50A5X = parcelRequire("50A5X");

var $f18sC = parcelRequire("f18sC");

var $kWVVC = parcelRequire("kWVVC");
class $bbaf2ab66628af55$var$StatsigClient extends $2CW6E.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $2CW6E._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $bbaf2ab66628af55$var$StatsigClient) return instance;
        $2CW6E.Log.warn((0, $2CW6E._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $bbaf2ab66628af55$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $2CW6E.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $bbaf2ab66628af55$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $2CW6E.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $2CW6E.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $bbaf2ab66628af55$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $bbaf2ab66628af55$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $2CW6E.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $2CW6E.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $2CW6E.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $2CW6E.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($2CW6E.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $2CW6E.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $2CW6E.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $2CW6E.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $2CW6E.StatsigSession.get(this._sdkKey),
            stableID: $2CW6E.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $bbaf2ab66628af55$var$__awaiter(this, void 0, void 0, function*() {
            if (!$2CW6E.Storage.isReady()) yield $2CW6E.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $2CW6E.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $2CW6E.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $2CW6E._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $2CW6E.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $2CW6E._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $2CW6E._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $2CW6E._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $2CW6E._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $2CW6E._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $2CW6E._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $2CW6E._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $2CW6E._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $2CW6E._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $2CW6E._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $f18sC._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $f18sC._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $2CW6E.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $50A5X.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $kWVVC.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($2CW6E.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($2CW6E.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($2CW6E.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($2CW6E.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($2CW6E.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($2CW6E.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $1HtkZ.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $2CW6E.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $bbaf2ab66628af55$var$StatsigClient;

});
parcelRegister("1HtkZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CW6E = parcelRequire("2CW6E");
class $13d0907036892efe$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $2CW6E._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $2CW6E._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $2CW6E.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $2CW6E._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $2CW6E.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $2CW6E._getFullUserHash)(userForComparison) !== (0, $2CW6E._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $13d0907036892efe$var$EvaluationStore;

});

parcelRegister("50A5X", function(module, exports) {
"use strict";
var $3a58f397f9aebf4e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2CW6E = parcelRequire("2CW6E");

var $27hhD = parcelRequire("27hhD");
class $3a58f397f9aebf4e$var$StatsigNetwork extends $2CW6E.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $3a58f397f9aebf4e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $2CW6E._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $3a58f397f9aebf4e$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $27hhD._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $2CW6E.UrlConfiguration($2CW6E.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $3a58f397f9aebf4e$var$StatsigNetwork;

});
parcelRegister("27hhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $2CW6E = parcelRequire("2CW6E");
const $18a9a45cdd85ac6e$var$MAX_DELTAS_SORT_DEPTH = 2;
function $18a9a45cdd85ac6e$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $2CW6E._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $18a9a45cdd85ac6e$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $18a9a45cdd85ac6e$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $2CW6E._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $18a9a45cdd85ac6e$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $18a9a45cdd85ac6e$var$_resolveDeltasResponse;
function $18a9a45cdd85ac6e$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $18a9a45cdd85ac6e$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $18a9a45cdd85ac6e$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $18a9a45cdd85ac6e$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $18a9a45cdd85ac6e$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $18a9a45cdd85ac6e$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("f18sC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $2CW6E = parcelRequire("2CW6E");
const $aeed8318e39bf5c0$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $aeed8318e39bf5c0$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $aeed8318e39bf5c0$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $2CW6E._isTypeMatch)(value, fallback);
}
function $aeed8318e39bf5c0$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $aeed8318e39bf5c0$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $aeed8318e39bf5c0$var$_shouldLogExposure(options) ? undefined : $aeed8318e39bf5c0$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $aeed8318e39bf5c0$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $aeed8318e39bf5c0$var$_shouldLogExposure(options) ? undefined : $aeed8318e39bf5c0$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($aeed8318e39bf5c0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aeed8318e39bf5c0$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $aeed8318e39bf5c0$var$_shouldLogExposure(options) ? undefined : $aeed8318e39bf5c0$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($aeed8318e39bf5c0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aeed8318e39bf5c0$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $aeed8318e39bf5c0$var$_shouldLogExposure(options) ? undefined : $aeed8318e39bf5c0$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($aeed8318e39bf5c0$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $aeed8318e39bf5c0$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $2CW6E._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $aeed8318e39bf5c0$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $aeed8318e39bf5c0$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $aeed8318e39bf5c0$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $aeed8318e39bf5c0$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $aeed8318e39bf5c0$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $aeed8318e39bf5c0$var$_makeParamStoreGetter;

});

parcelRegister("kWVVC", function(module, exports) {
"use strict";
var $f40628cdc3e67a25$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $2CW6E = parcelRequire("2CW6E");

var $50A5X = parcelRequire("50A5X");
class $f40628cdc3e67a25$var$StatsigEvaluationsDataAdapter extends $2CW6E.DataAdapterCore {
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $50A5X.default) this._network = network;
        else this._network = new $50A5X.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $2CW6E._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $2CW6E._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $2CW6E.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $f40628cdc3e67a25$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $2CW6E._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$2CW6E.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $2CW6E._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $f40628cdc3e67a25$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("1LBry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $149739b255f52f8e$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $3WtYA = parcelRequire("3WtYA");
function $149739b255f52f8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149739b255f52f8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149739b255f52f8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149739b255f52f8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149739b255f52f8e$export$a66cbd9b2289cd78 = '@all-features';
var $149739b255f52f8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3WtYA)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($149739b255f52f8e$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($149739b255f52f8e$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($149739b255f52f8e$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $149739b255f52f8e$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("3WtYA", function(module, exports) {
'use strict';
var $2dee0a8bb10f5b2c$var$has = Object.prototype.hasOwnProperty, $2dee0a8bb10f5b2c$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $2dee0a8bb10f5b2c$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $2dee0a8bb10f5b2c$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $2dee0a8bb10f5b2c$var$Events().__proto__) $2dee0a8bb10f5b2c$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $2dee0a8bb10f5b2c$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $2dee0a8bb10f5b2c$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $2dee0a8bb10f5b2c$var$EE(fn, context || emitter, once), evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $2dee0a8bb10f5b2c$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $2dee0a8bb10f5b2c$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $2dee0a8bb10f5b2c$var$EventEmitter() {
    this._events = new $2dee0a8bb10f5b2c$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($2dee0a8bb10f5b2c$var$has.call(events, name)) names.push($2dee0a8bb10f5b2c$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $2dee0a8bb10f5b2c$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $2dee0a8bb10f5b2c$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $2dee0a8bb10f5b2c$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $2dee0a8bb10f5b2c$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $2dee0a8bb10f5b2c$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $2dee0a8bb10f5b2c$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $2dee0a8bb10f5b2c$var$prefix ? $2dee0a8bb10f5b2c$var$prefix + event : event;
        if (this._events[evt]) $2dee0a8bb10f5b2c$var$clearEvent(this, evt);
    } else {
        this._events = new $2dee0a8bb10f5b2c$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$2dee0a8bb10f5b2c$var$EventEmitter.prototype.off = $2dee0a8bb10f5b2c$var$EventEmitter.prototype.removeListener;
$2dee0a8bb10f5b2c$var$EventEmitter.prototype.addListener = $2dee0a8bb10f5b2c$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$2dee0a8bb10f5b2c$var$EventEmitter.prefixed = $2dee0a8bb10f5b2c$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$2dee0a8bb10f5b2c$var$EventEmitter.EventEmitter = $2dee0a8bb10f5b2c$var$EventEmitter;
module.exports = $2dee0a8bb10f5b2c$var$EventEmitter;

});


parcelRegister("9rkul", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $6df687448b2f5519$export$6dc24881a3d96325; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $fhjgA = parcelRequire("fhjgA");
var $6df687448b2f5519$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $fhjgA.migrateEvaluationDetails)(experiment.details), (0, $fhjgA.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("fhjgA", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $b1f763765671279f$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $b1f763765671279f$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $b1f763765671279f$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $b1f763765671279f$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $b1f763765671279f$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $b1f763765671279f$export$55fd683752d01e67; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $kDOvk = parcelRequire("kDOvk");

var $cX2CT = parcelRequire("cX2CT");

var $51qEW = parcelRequire("51qEW");
var $b1f763765671279f$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $b1f763765671279f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1f763765671279f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1f763765671279f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1f763765671279f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b1f763765671279f$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $b1f763765671279f$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $kDOvk.isFedRamp)() ? (0, $51qEW.PerimeterType).FEDRAMP_MODERATE : (0, $51qEW.PerimeterType).COMMERCIAL
    }, options);
};
var $b1f763765671279f$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $b1f763765671279f$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $b1f763765671279f$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(options, $b1f763765671279f$var$_excluded);
    return $b1f763765671279f$var$_objectSpread($b1f763765671279f$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $b1f763765671279f$var$evaluationReasonMappings = Object.entries((0, $cX2CT.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $b1f763765671279f$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $b1f763765671279f$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $cX2CT.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $b1f763765671279f$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === 'string') // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("kDOvk", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $f06ea04161c63414$export$64d6499adf9b2e51; });

var $kMdiL = parcelRequire("kMdiL");
function $f06ea04161c63414$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $kMdiL.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("kMdiL", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $f2029bc90c9382c2$export$ce553301d55c2fd8; });
var $f2029bc90c9382c2$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $f2029bc90c9382c2$export$f005e2e9f707cb5f = 'commercial';
var $f2029bc90c9382c2$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $f2029bc90c9382c2$export$a739cd5aac835909 = 'stg';
var $f2029bc90c9382c2$export$42dd0cdd351a4a9 = 'prod';
var $f2029bc90c9382c2$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("cX2CT", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $96dd083d31cc841a$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $96dd083d31cc841a$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("51qEW", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $3a81b9c044a39023$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $3a81b9c044a39023$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $3a81b9c044a39023$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $3a81b9c044a39023$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $3a81b9c044a39023$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("hZGkZ", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $d198f9819511ec02$export$936d0764594b6eb3; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $fhjgA = parcelRequire("fhjgA");
var $d198f9819511ec02$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(val) === (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $fhjgA.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $fhjgA.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $fhjgA.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("fHUq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6f6a2f5dec24b1f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $51qEW = parcelRequire("51qEW");

var $g1oWB = parcelRequire("g1oWB");

var $il9LQ = parcelRequire("il9LQ");
function $b6f6a2f5dec24b1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6f6a2f5dec24b1f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6f6a2f5dec24b1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6f6a2f5dec24b1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6f6a2f5dec24b1f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $b6f6a2f5dec24b1f$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $b6f6a2f5dec24b1f$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $b6f6a2f5dec24b1f$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $b6f6a2f5dec24b1f$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $b6f6a2f5dec24b1f$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $b6f6a2f5dec24b1f$export$4e8a0415edbfa1f7 = 'https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net';
var $b6f6a2f5dec24b1f$export$cb3cd156f70d7e94 = 'oasis-stg.com/flags';
var $b6f6a2f5dec24b1f$export$921fbc6cdfd4eee0 = 'atlassian-isolated.net/flags';
var $b6f6a2f5dec24b1f$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $b6f6a2f5dec24b1f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Fetcher);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $il9LQ.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $il9LQ.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $b6f6a2f5dec24b1f$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $51qEW.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $51qEW.FeatureGateEnvironment).Production:
                        return $b6f6a2f5dec24b1f$export$18c93900db9358a4;
                    case (0, $51qEW.FeatureGateEnvironment).Staging:
                        return $b6f6a2f5dec24b1f$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $51qEW.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $51qEW.FeatureGateEnvironment).Development:
                        return $b6f6a2f5dec24b1f$export$f058dbf75c3bc647;
                    case (0, $51qEW.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $b6f6a2f5dec24b1f$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $b6f6a2f5dec24b1f$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $b6f6a2f5dec24b1f$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $b6f6a2f5dec24b1f$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $g1oWB.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $b6f6a2f5dec24b1f$export$4e8a0415edbfa1f7.replace('%s', isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($b6f6a2f5dec24b1f$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($b6f6a2f5dec24b1f$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== 'undefined' && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("g1oWB", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $baa016bc27589a40$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $baa016bc27589a40$export$a59f8d67326bd1cb = "5.5.4";

});

parcelRegister("il9LQ", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $d5a1c468b9a2d8bd$export$286baf652d0b1206; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $3Fq9h = parcelRequire("3Fq9h");
function $d5a1c468b9a2d8bd$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $d5a1c468b9a2d8bd$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $d5a1c468b9a2d8bd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d5a1c468b9a2d8bd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d5a1c468b9a2d8bd$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ResponseError);
        return $d5a1c468b9a2d8bd$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(ResponseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));

});
parcelRegister("h2r7j", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $c677a868bff4c3dd$var$_typeof = $cd8Dz.default;

var $5T1eV = parcelRequire("5T1eV");
function $c677a868bff4c3dd$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c677a868bff4c3dd$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $5T1eV(t);
}
module.exports = $c677a868bff4c3dd$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5T1eV", function(module, exports) {
function $44930d02bcdd8f64$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $44930d02bcdd8f64$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hOtqI", function(module, exports) {
function $cf7def55664962b4$var$_getPrototypeOf(t) {
    return module.exports = $cf7def55664962b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cf7def55664962b4$var$_getPrototypeOf(t);
}
module.exports = $cf7def55664962b4$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7Ar6h", function(module, exports) {

var $5LDYA = parcelRequire("5LDYA");
function $5860eabc943f0341$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $5LDYA(t, e);
}
module.exports = $5860eabc943f0341$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5LDYA", function(module, exports) {
function $433059ffae2f1c2a$var$_setPrototypeOf(t, e) {
    return module.exports = $433059ffae2f1c2a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $433059ffae2f1c2a$var$_setPrototypeOf(t, e);
}
module.exports = $433059ffae2f1c2a$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3Fq9h", function(module, exports) {

var $hOtqI = parcelRequire("hOtqI");

var $5LDYA = parcelRequire("5LDYA");

var $c42RG = parcelRequire("c42RG");

var $eI5Z6 = parcelRequire("eI5Z6");
function $2ab97bff5a1af503$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $2ab97bff5a1af503$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$c42RG(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $eI5Z6(t, arguments, $hOtqI(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $5LDYA(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ab97bff5a1af503$var$_wrapNativeSuper(t);
}
module.exports = $2ab97bff5a1af503$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c42RG", function(module, exports) {
function $8c8814aeb2116d69$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $8c8814aeb2116d69$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eI5Z6", function(module, exports) {

var $eOnrh = parcelRequire("eOnrh");

var $5LDYA = parcelRequire("5LDYA");
function $ab59d1223c898fdf$var$_construct(t, e, r) {
    if ($eOnrh()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $5LDYA(p, r.prototype), p;
}
module.exports = $ab59d1223c898fdf$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eOnrh", function(module, exports) {
function $ac87eab59da1723b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $ac87eab59da1723b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $ac87eab59da1723b$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("aIaZC", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $7cc68a5fca93ded5$export$55fffef3474104af; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $9IviU = parcelRequire("9IviU");
function $7cc68a5fca93ded5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7cc68a5fca93ded5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7cc68a5fca93ded5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7cc68a5fca93ded5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7cc68a5fca93ded5$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $7cc68a5fca93ded5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $7cc68a5fca93ded5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7cc68a5fca93ded5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $7cc68a5fca93ded5$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $7cc68a5fca93ded5$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, NoFetchDataAdapter);
        _this = $7cc68a5fca93ded5$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(NoFetchDataAdapter, _DataAdapterCore);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $9IviU.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $7cc68a5fca93ded5$var$_objectSpread($7cc68a5fca93ded5$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $9IviU._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $7cc68a5fca93ded5$var$_objectSpread($7cc68a5fca93ded5$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $9IviU._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $9IviU._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $9IviU.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $7cc68a5fca93ded5$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $7cc68a5fca93ded5$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $9IviU.DataAdapterCore));

});
parcelRegister("c3k3z", function(module, exports) {

var $6N3CA = parcelRequire("6N3CA");
function $8c6552ab0d0f5ef7$var$_get() {
    return module.exports = $8c6552ab0d0f5ef7$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $6N3CA(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8c6552ab0d0f5ef7$var$_get.apply(null, arguments);
}
module.exports = $8c6552ab0d0f5ef7$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6N3CA", function(module, exports) {

var $hOtqI = parcelRequire("hOtqI");
function $4f1a20c9c2cc61b6$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $hOtqI(t)););
    return t;
}
module.exports = $4f1a20c9c2cc61b6$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("8wvzC", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $6349cdbc3d0d6606$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $6349cdbc3d0d6606$export$bcb28fbac1def494; });

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $2CW6E = parcelRequire("2CW6E");
function $6349cdbc3d0d6606$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6349cdbc3d0d6606$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6349cdbc3d0d6606$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6349cdbc3d0d6606$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6349cdbc3d0d6606$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6349cdbc3d0d6606$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6349cdbc3d0d6606$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6349cdbc3d0d6606$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6349cdbc3d0d6606$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6349cdbc3d0d6606$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $6349cdbc3d0d6606$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $6349cdbc3d0d6606$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $6349cdbc3d0d6606$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $6349cdbc3d0d6606$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $6349cdbc3d0d6606$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $6349cdbc3d0d6606$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PersistentOverrideAdapter);
        this._overrides = $6349cdbc3d0d6606$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $6349cdbc3d0d6606$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $6349cdbc3d0d6606$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $6349cdbc3d0d6606$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($6349cdbc3d0d6606$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($6349cdbc3d0d6606$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $6349cdbc3d0d6606$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $2CW6E._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, $6349cdbc3d0d6606$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($6349cdbc3d0d6606$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current.details), {}, {
                        reason: $6349cdbc3d0d6606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($6349cdbc3d0d6606$var$djb2MapKey((0, $2CW6E._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $6349cdbc3d0d6606$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($6349cdbc3d0d6606$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $2CW6E._makeTypedGet)(current.name, overridden),
                    details: $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current.details), {}, {
                        reason: $6349cdbc3d0d6606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($6349cdbc3d0d6606$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $2CW6E._makeTypedGet)(current.name, overridden),
                    details: $6349cdbc3d0d6606$var$_objectSpread($6349cdbc3d0d6606$var$_objectSpread({}, current.details), {}, {
                        reason: $6349cdbc3d0d6606$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("3tDkq", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $288296556e3638b5$export$1c9f709888824e05; });
var $288296556e3638b5$var$_process, $288296556e3638b5$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $288296556e3638b5$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($288296556e3638b5$var$_process = globalThis.process) === null || $288296556e3638b5$var$_process === void 0 || ($288296556e3638b5$var$_process = $288296556e3638b5$var$_process.env) === null || $288296556e3638b5$var$_process === void 0 ? void 0 : $288296556e3638b5$var$_process.JEST_WORKER_ID) !== undefined;
var $288296556e3638b5$var$DEBUG_MODE = !$288296556e3638b5$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($288296556e3638b5$var$_process2 = globalThis.process) === null || $288296556e3638b5$var$_process2 === void 0 || ($288296556e3638b5$var$_process2 = $288296556e3638b5$var$_process2.env) === null || $288296556e3638b5$var$_process2 === void 0 ? void 0 : $288296556e3638b5$var$_process2.NODE_ENV) !== 'production';
var $288296556e3638b5$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$288296556e3638b5$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("juoNE", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $e3040e69abf4c83a$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $e3040e69abf4c83a$export$62c37ab81302621a; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kg5sN = parcelRequire("kg5sN");

var $icabj = parcelRequire("icabj");
var $e3040e69abf4c83a$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
var $e3040e69abf4c83a$var$customThemeOptions = 'UNSAFE_themeOptions';
var $e3040e69abf4c83a$var$isThemeKind = function isThemeKind(themeKind) {
    return $e3040e69abf4c83a$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e3040e69abf4c83a$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $icabj.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e3040e69abf4c83a$var$isColorMode = function isColorMode(modeId) {
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
var $e3040e69abf4c83a$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(' ')// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === 'colorMode' && $e3040e69abf4c83a$var$isColorMode(id)) themeObject[kind] = id;
        if ($e3040e69abf4c83a$var$isThemeKind(kind) && $e3040e69abf4c83a$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e3040e69abf4c83a$var$customThemeOptions) try {
            themeObject[$e3040e69abf4c83a$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
var $e3040e69abf4c83a$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $e3040e69abf4c83a$var$isColorMode(id) || // custom theme state
        kind === $e3040e69abf4c83a$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === 'object' || // other theme states
        $e3040e69abf4c83a$var$isThemeKind(kind) && typeof id === 'string' && $e3040e69abf4c83a$var$isThemeIds(id)) return themeString + "".concat(themeString ? ' ' : '') + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === 'object' ? JSON.stringify(id) : id);
        return themeString;
    }, '');
};

});


parcelRegister("rG0so", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05331b5240b91af4$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $bDRHl = parcelRequire("bDRHl");

var $6KhR5 = parcelRequire("6KhR5");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $05331b5240b91af4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $6KhR5.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $bDRHl.THEME_DATA_ATTRIBUTE),
                            (0, $bDRHl.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($05331b5240b91af4$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($05331b5240b91af4$export$2e2bcd8739ae039, "callbacks", new Set());

});


parcelRegister("azw9d", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $7b261c23a21b46e2$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $7b261c23a21b46e2$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $7b261c23a21b46e2$export$793fba32aed8942a = {
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit'
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("gm61b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be835e77f0f1f2cf$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $be835e77f0f1f2cf$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $be835e77f0f1f2cf$var$CSS_VAR_COLOR = '--logo-color';
var $be835e77f0f1f2cf$var$CSS_VAR_FILL = '--logo-fill';
var $be835e77f0f1f2cf$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $be835e77f0f1f2cf$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $be835e77f0f1f2cf$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $be835e77f0f1f2cf$var$CSS_VAR_COLOR, iconColor), $be835e77f0f1f2cf$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $c4hjl.default)([
            $be835e77f0f1f2cf$var$styles.root,
            shouldApplyStopColor && $be835e77f0f1f2cf$var$styles.stop,
            size && $be835e77f0f1f2cf$var$styles[size]
        ])
    }));
};
var $be835e77f0f1f2cf$export$2e2bcd8739ae039 = $be835e77f0f1f2cf$var$Wrapper;

});

parcelRegister("iXqJJ", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $dcd27a0606e68cc9$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $dcd27a0606e68cc9$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $dcd27a0606e68cc9$export$7818df200941dbbf; });

var $jvXYr = parcelRequire("jvXYr");
var $dcd27a0606e68cc9$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $jvXYr.B400);
            iconGradientStop = (0, $jvXYr.B200);
            iconColor = (0, $jvXYr.B200);
            textColor = "var(--ds-text, ".concat((0, $jvXYr.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $jvXYr.B400);
            break;
        case 'neutral':
            iconGradientStart = (0, $jvXYr.N600);
            iconGradientStop = (0, $jvXYr.N100);
            iconColor = (0, $jvXYr.N100);
            textColor = (0, $jvXYr.N400);
            atlassianLogoTextColor = (0, $jvXYr.N400);
            break;
        case 'inverse':
            iconGradientStart = '#FFFFFF66';
            iconGradientStop = '#FFFFFF';
            iconColor = '#FFFFFF';
            textColor = '#FFFFFF';
            atlassianLogoTextColor = '#FFFFFF';
            break;
    }
    if (colorMode === 'dark' && appearance === 'inverse') {
        iconGradientStart = '#161A1D66';
        iconGradientStop = '#161A1D';
        iconColor = '#161A1D';
        textColor = '#161A1D';
        atlassianLogoTextColor = '#161A1D';
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $dcd27a0606e68cc9$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#357DE8';
            textColor = '#E2E3E4';
            atlassianLogoTextColor = '#357DE8';
            break;
        case 'neutral':
            iconColor = '#96999E';
            textColor = '#BFC1C4';
            atlassianLogoTextColor = '#96999E';
            break;
        case 'inverse':
            iconColor = '#101214';
            textColor = '#101214';
            atlassianLogoTextColor = '#101214';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#1868DB';
            textColor = '#101214';
            atlassianLogoTextColor = '#1868DB';
            break;
        case 'neutral':
            iconColor = '#6C6F77';
            textColor = '#3B3D42';
            atlassianLogoTextColor = '#6C6F77';
            break;
        case 'inverse':
            iconColor = (0, $jvXYr.N0);
            textColor = (0, $jvXYr.N0);
            atlassianLogoTextColor = (0, $jvXYr.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $dcd27a0606e68cc9$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $dcd27a0606e68cc9$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $dcd27a0606e68cc9$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === 'dark') switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#EFF0FF';
            break;
    }
    else switch(appearance){
        case 'brand':
            iconColor = '#625DF5';
            textColor = '#252434';
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("jvXYr", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $e34f6f1c6cec951b$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $e34f6f1c6cec951b$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $e34f6f1c6cec951b$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $e34f6f1c6cec951b$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $e34f6f1c6cec951b$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $e34f6f1c6cec951b$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $e34f6f1c6cec951b$export$7d61b15e0da132af; });
// Reds
var $e34f6f1c6cec951b$export$4b84fd0e2c617bd = '#FFEBE6';
var $e34f6f1c6cec951b$export$b34b069eff244586 = '#FFBDAD';
var $e34f6f1c6cec951b$export$be802dd0d8b57f35 = '#FF8F73';
var $e34f6f1c6cec951b$export$60847d42f9da92a6 = '#FF7452';
var $e34f6f1c6cec951b$export$4a7404f376229999 = '#FF5630';
var $e34f6f1c6cec951b$export$2010d0fb4295b346 = '#DE350B';
var $e34f6f1c6cec951b$export$2837b5a1a71d5c02 = '#BF2600';
var $e34f6f1c6cec951b$export$8d9596b529bbb9cf = '#FFFAE6';
var $e34f6f1c6cec951b$export$41060a744ab0b7ae = '#FFF0B3';
var $e34f6f1c6cec951b$export$1cc05bbbf340e559 = '#FFE380';
var $e34f6f1c6cec951b$export$5aae31392d72caaa = '#FFC400';
var $e34f6f1c6cec951b$export$c6930421db9fa514 = '#FFAB00';
var $e34f6f1c6cec951b$export$59619663aa6500fb = '#FF991F';
var $e34f6f1c6cec951b$export$874739ea9e379ab6 = '#FF8B00';
var $e34f6f1c6cec951b$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e34f6f1c6cec951b$export$69a3bf21b9686c2b = '#ABF5D1';
var $e34f6f1c6cec951b$export$afbce1382ec95f73 = '#79F2C0';
var $e34f6f1c6cec951b$export$747d86715d4175de = '#57D9A3';
var $e34f6f1c6cec951b$export$940e1f69e873f202 = '#36B37E';
var $e34f6f1c6cec951b$export$a49394138f7b8e85 = '#00875A';
var $e34f6f1c6cec951b$export$6fa04827ac68a4fb = '#006644';
var $e34f6f1c6cec951b$export$226de0355ed012f8 = '#DEEBFF';
var $e34f6f1c6cec951b$export$8c13c2ee36917869 = '#B3D4FF';
var $e34f6f1c6cec951b$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e34f6f1c6cec951b$export$215b7063051591f1 = '#2684FF';
var $e34f6f1c6cec951b$export$e62e8919cca44969 = '#0065FF';
var $e34f6f1c6cec951b$export$b3de0ae08da2ce64 = '#0052CC';
var $e34f6f1c6cec951b$export$a6ee3d71bc067634 = '#0747A6';
var $e34f6f1c6cec951b$export$67f15409e87642a1 = '#669DF1';
var $e34f6f1c6cec951b$export$f0539dbc42dbb067 = '#8FB8F6';
var $e34f6f1c6cec951b$export$363e4475840015bb = '#EAE6FF';
var $e34f6f1c6cec951b$export$4b0a4417ed59760f = '#C0B6F2';
var $e34f6f1c6cec951b$export$6011520a64d9a187 = '#998DD9';
var $e34f6f1c6cec951b$export$a7175d4e9206bc80 = '#8777D9';
var $e34f6f1c6cec951b$export$b48405b95304b5a1 = '#6554C0';
var $e34f6f1c6cec951b$export$c71e4279dd54a18d = '#5243AA';
var $e34f6f1c6cec951b$export$147899de772240ec = '#403294';
var $e34f6f1c6cec951b$export$2cf711fe14c66f06 = '#E6FCFF';
var $e34f6f1c6cec951b$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e34f6f1c6cec951b$export$776c9c497ef08533 = '#79E2F2';
var $e34f6f1c6cec951b$export$69cb3ca10c1e330e = '#00C7E6';
var $e34f6f1c6cec951b$export$9dc1ef0f3f48059b = '#00B8D9';
var $e34f6f1c6cec951b$export$7c835c78b6fcdef8 = '#00A3BF';
var $e34f6f1c6cec951b$export$6036577f95c3877e = '#008DA6';
var $e34f6f1c6cec951b$export$29a4f05edc054374 = '#FFFFFF';
var $e34f6f1c6cec951b$export$e655ef011c4aa1a2 = '#FAFBFC';
var $e34f6f1c6cec951b$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e34f6f1c6cec951b$export$3e51e8f1440314ba = '#EBECF0';
var $e34f6f1c6cec951b$export$1ce2d1575d444ceb = '#DFE1E6';
var $e34f6f1c6cec951b$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e34f6f1c6cec951b$export$c2e91cbeada39b8b = '#B3BAC5';
var $e34f6f1c6cec951b$export$5f71e19f3a7ad9de = '#A5ADBA';
var $e34f6f1c6cec951b$export$eaa8c8a70ac22806 = '#97A0AF';
var $e34f6f1c6cec951b$export$7c87d337fb91a97d = '#8993A4';
var $e34f6f1c6cec951b$export$d6447c357493214f = '#7A869A';
var $e34f6f1c6cec951b$export$f563ee71e9ee74cd = '#6B778C';
var $e34f6f1c6cec951b$export$e2ef2124cf4024b1 = '#5E6C84';
var $e34f6f1c6cec951b$export$eece5f492e429f08 = '#505F79';
var $e34f6f1c6cec951b$export$c39c0fe0f26207ae = '#42526E';
var $e34f6f1c6cec951b$export$7090862dc3038a9f = '#344563';
var $e34f6f1c6cec951b$export$ad0bacf983b7ddaa = '#253858';
var $e34f6f1c6cec951b$export$7d61b15e0da132af = '#172B4D';
var $e34f6f1c6cec951b$export$fbda843f0a27fe96 = '#091E42';
var $e34f6f1c6cec951b$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $e34f6f1c6cec951b$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $e34f6f1c6cec951b$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $e34f6f1c6cec951b$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $e34f6f1c6cec951b$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $e34f6f1c6cec951b$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $e34f6f1c6cec951b$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $e34f6f1c6cec951b$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $e34f6f1c6cec951b$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $e34f6f1c6cec951b$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $e34f6f1c6cec951b$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $e34f6f1c6cec951b$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $e34f6f1c6cec951b$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $e34f6f1c6cec951b$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $e34f6f1c6cec951b$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $e34f6f1c6cec951b$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $e34f6f1c6cec951b$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $e34f6f1c6cec951b$export$2f6319cf7d736c2a = '#E6EDFA';
var $e34f6f1c6cec951b$export$95126bc8884d6634 = '#DCE5F5';
var $e34f6f1c6cec951b$export$8338d8c35d44ff1 = '#CED9EB';
var $e34f6f1c6cec951b$export$5368d76ae4fbbda7 = '#B8C7E0';
var $e34f6f1c6cec951b$export$9f0a771d16ec8d36 = '#ABBBD6';
var $e34f6f1c6cec951b$export$abcf8c38338b4aa5 = '#9FB0CC';
var $e34f6f1c6cec951b$export$97e81faa16a182c7 = '#8C9CB8';
var $e34f6f1c6cec951b$export$bfe21c59123ecf33 = '#7988A3';
var $e34f6f1c6cec951b$export$ee82aa2ea6a1558 = '#67758F';
var $e34f6f1c6cec951b$export$682927c6ed76be02 = '#56637A';
var $e34f6f1c6cec951b$export$91fd9994c5be9757 = '#455166';
var $e34f6f1c6cec951b$export$d281fbfe3cff2df6 = '#3B475C';
var $e34f6f1c6cec951b$export$3902c91d8b98a753 = '#313D52';
var $e34f6f1c6cec951b$export$8e8133c1ba5845b5 = '#283447';
var $e34f6f1c6cec951b$export$33ff357f6620b39 = '#202B3D';
var $e34f6f1c6cec951b$export$633847cf062b69e0 = '#1B2638';
var $e34f6f1c6cec951b$export$9776a6e503bdbf76 = '#121A29';
var $e34f6f1c6cec951b$export$6c813d5160dff5db = '#0E1624';
var $e34f6f1c6cec951b$export$3d4f271a500072a = '#0D1424';
var $e34f6f1c6cec951b$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $e34f6f1c6cec951b$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $e34f6f1c6cec951b$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $e34f6f1c6cec951b$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $e34f6f1c6cec951b$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $e34f6f1c6cec951b$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $e34f6f1c6cec951b$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $e34f6f1c6cec951b$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $e34f6f1c6cec951b$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $e34f6f1c6cec951b$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $e34f6f1c6cec951b$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $e34f6f1c6cec951b$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $e34f6f1c6cec951b$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $e34f6f1c6cec951b$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $e34f6f1c6cec951b$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $e34f6f1c6cec951b$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $e34f6f1c6cec951b$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $e34f6f1c6cec951b$export$d2adc5dedf09fced = '#292A2E';
var $e34f6f1c6cec951b$export$f51762073d2bb381 = '#94C748';
var $e34f6f1c6cec951b$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("HBurV", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "Error.b0f67bec.svg";

});

parcelRegister("3ir1n", function(module, exports) {

$parcel$export(module.exports, "appendReferer", function () { return $ebca23e70cbbbff7$export$b75bb5b493e221ea; });
$parcel$export(module.exports, "appendReasonViewingScreen", function () { return $ebca23e70cbbbff7$export$b68d90d94a86fe33; });
$parcel$export(module.exports, "AnalyticsClientImpl", function () { return $ebca23e70cbbbff7$export$17499c710c4e1d; });
$parcel$export(module.exports, "AnalyticsClientContext", function () { return $ebca23e70cbbbff7$export$70089efe93d43959; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $ebca23e70cbbbff7$export$923054f18cb06572; });
$parcel$export(module.exports, "useAnalyticsAnonymousId", function () { return $ebca23e70cbbbff7$export$e126afa8615733f3; });
$parcel$export(module.exports, "useTrackingEvent", function () { return $ebca23e70cbbbff7$export$1397d31414038d5e; });
$parcel$export(module.exports, "usePageViewedEvent", function () { return $ebca23e70cbbbff7$export$a07d7c1ce880cd05; });
$parcel$export(module.exports, "useButtonClickedEvent", function () { return $ebca23e70cbbbff7$export$4fb7f377b48b9cbc; });
$parcel$export(module.exports, "useLinkClickedEvent", function () { return $ebca23e70cbbbff7$export$65af8b3e3ac7d8ee; });
$parcel$export(module.exports, "useFormSubmittedEvent", function () { return $ebca23e70cbbbff7$export$69c70ee0cb243a51; });
$parcel$export(module.exports, "useOperationalEvent", function () { return $ebca23e70cbbbff7$export$87ff6dcd457142b0; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");

var $gKvjl = parcelRequire("gKvjl");
var $4cW1f = parcelRequire("4cW1f");

var $fvOZR = parcelRequire("fvOZR");

var $8ZuGG = parcelRequire("8ZuGG");

var $day6I = parcelRequire("day6I");

var $kQqSk = parcelRequire("kQqSk");

var $kZj5j = parcelRequire("kZj5j");

var $fsfV4 = parcelRequire("fsfV4");
parcelRequire("62Jrh");
var $kQMDY = parcelRequire("kQMDY");

var $jtt5y = parcelRequire("jtt5y");
const $ebca23e70cbbbff7$var$tags = [
    'identity'
];
function $ebca23e70cbbbff7$var$getEnv() {
    switch(0, $lk8Tl.currentEnv){
        case 'local':
            return (0, $4cW1f.envType).LOCAL;
        case 'dev':
            return (0, $4cW1f.envType).DEV;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $4cW1f.envType).STAGING;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
            return (0, $4cW1f.envType).PROD;
        default:
            return (0, $4cW1f.envType).DEV;
    }
}
function $ebca23e70cbbbff7$export$b75bb5b493e221ea(eventAttributes) {
    try {
        const referer = new URL(document.referrer);
        referer.search = ''; // lets minimise possibility of tokens in referer by cleaning up query params
        return (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
            referer: referer.toString()
        });
    } catch (e) {
        return eventAttributes;
    }
}
function $ebca23e70cbbbff7$export$b68d90d94a86fe33(eventAttributes, userFlow) {
    if (userFlow) return (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
        reasonViewingScreen: userFlow
    });
    return eventAttributes;
}
function $ebca23e70cbbbff7$var$determinePlatform(microbranding) {
    if ((0, $day6I.isMobileOidc)(microbranding.oidcContext) || microbranding.isEmbedded) return (0, $4cW1f.platformType).MOBILE_WEB;
    return (0, $4cW1f.platformType).WEB;
}
let $ebca23e70cbbbff7$var$analyticsClient;
function $ebca23e70cbbbff7$export$77ce8f76f8d1e1d1({ microbranding: microbranding, locality: locality, tenantCloudId: tenantCloudId, userId: userId }) {
    const platform = $ebca23e70cbbbff7$var$determinePlatform(microbranding);
    const locale = locality || 'en';
    const env = $ebca23e70cbbbff7$var$getEnv();
    const apiHost = [
        'prod',
        'staging'
    ].includes((0, $lk8Tl.currentEnvType)) ? window.location.host + '/gateway/api/gasv3/api/v1' : undefined;
    if (!$ebca23e70cbbbff7$var$analyticsClient) $ebca23e70cbbbff7$var$analyticsClient = new (0, $gKvjl.default)({
        env: env,
        product: 'identity',
        origin: (0, $4cW1f.originType).WEB,
        platform: platform,
        locale: locale,
        perimeter: (0, $lk8Tl.currentPerimeter)
    }, {
        apiHost: apiHost
    });
    if (userId) $ebca23e70cbbbff7$var$analyticsClient.setUserInfo((0, $4cW1f.userType).ATLASSIAN_ACCOUNT, userId);
    if (tenantCloudId) $ebca23e70cbbbff7$var$analyticsClient.setTenantInfo((0, $4cW1f.tenantType).CLOUD_ID, tenantCloudId);
    else $ebca23e70cbbbff7$var$analyticsClient.setTenantInfo((0, $4cW1f.tenantType).NONE);
    return $ebca23e70cbbbff7$var$analyticsClient;
}
class $ebca23e70cbbbff7$export$17499c710c4e1d {
    formSubmittedEvent(page, formId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'submitted',
            subject: 'form',
            subjectId: formId,
            attributes: attributes
        });
    }
    buttonClickedEvent(page, buttonId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'button',
            subjectId: buttonId,
            attributes: attributes
        });
    }
    linkClickedEvent(page, linkId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'clicked',
            subject: 'link',
            subjectId: linkId,
            attributes: attributes
        });
    }
    checkboxChangedEvent(page, checkboxId, attributes) {
        return this.uiEvent({
            page: page,
            action: 'changed',
            subject: 'checkbox',
            subjectId: checkboxId,
            attributes: attributes
        });
    }
    trackingEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: 'tracking',
            message: `UI ${event.action} tracking event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $ty6PY._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        try {
            this.client.sendTrackEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $ebca23e70cbbbff7$var$tags
            });
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: event
            });
        }
    }
    operationalEvent(event, callback) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: 'operational',
            message: `${event.action} operational event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $ty6PY._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        try {
            this.client.sendOperationalEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $ebca23e70cbbbff7$var$tags
            }, callback);
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: event
            });
            if (callback) callback(error);
        }
    }
    async pageViewedEvent(page, eventAttributes) {
        const attributes = this.enrichAttributes(eventAttributes);
        (0, $8f2pb.addBreadcrumb)({
            category: 'pageViewed',
            message: 'Page viewed event of page id ' + page,
            data: (0, $ty6PY._)({
                source: page
            }, attributes)
        });
        try {
            const metric = (0, $kQMDY.getPageLoadMetric)(page);
            if (metric.getData().state !== 'finished') metric.stop();
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                page: page
            });
        }
        try {
            await this.client.sendScreenEvent({
                name: page,
                attributes: attributes
            });
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                page: page
            });
        }
    }
    errorShownEvent(page, subjectId, eventAttributes) {
        return this.uiEvent({
            page: page,
            action: 'shown',
            subject: 'error',
            subjectId: subjectId,
            attributes: eventAttributes
        });
    }
    uiEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: 'ui',
            message: `UI ${event.action} event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: (0, $ty6PY._)({
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId
            }, attributes)
        });
        return new Promise((resolve)=>{
            try {
                this.client.sendUIEvent({
                    source: event.page,
                    actionSubject: event.subject,
                    action: event.action,
                    actionSubjectId: event.subjectId,
                    attributes: attributes,
                    tags: $ebca23e70cbbbff7$var$tags
                }, ()=>resolve());
            } catch (error) {
                (0, $8f2pb.captureException)(error, {
                    event: event
                });
                // error is already captured, no point in putting the burden upon consumers by rejecting since they likely want to proceed
                resolve();
            }
        });
    }
    stopApdexEvent(apdexEvent) {
        try {
            this.client.stopApdexEvent(apdexEvent);
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: apdexEvent
            });
        }
    }
    stopInitialLoadApdexEvent(task) {
        this.stopApdexEvent({
            task: task,
            type: 'initialLoad',
            additionalAttributes: {
                properties: {
                    firstPaint: (0, $fsfV4.getFirstPaint)(),
                    firstContentfulPaint: (0, $fsfV4.getFirstContentfulPaint)()
                }
            }
        });
    }
    getInstance() {
        return this.client;
    }
    getAnonymousId() {
        return this.client.getAnonymousId();
    }
    setFfsId(ffsId) {
        this.ffsId = ffsId;
    }
    enrichAttributes(eventAttributes) {
        const originTracingProperties = (0, $kQqSk.default)(window.location.href, {
            mapAttribute: (value)=>typeof value === 'string' ? (0, $fvOZR.dangerouslyCreateSafeString)(value) : value
        });
        const queryParams = new URLSearchParams(window.location.search);
        const flowTraceId = queryParams.get('flowTraceId');
        const applicationData = (0, $kZj5j.lookupApplication)(this.cobranding);
        const application = applicationData ? applicationData.application : 'unknown';
        const applicationAnalyticAttributes = {
            firstProductAccessed: application,
            experience: applicationData === null || applicationData === void 0 ? void 0 : applicationData.experience
        };
        return (0, $6EnDC._)((0, $ty6PY._)((0, $6EnDC._)((0, $ty6PY._)({}, applicationAnalyticAttributes, originTracingProperties, flowTraceId && {
            flowTraceId: flowTraceId
        }), {
            isMobileApp: this.microbranding.isMobileApp
        }), eventAttributes), {
            ffsId: this.ffsId,
            isInPopup: Boolean(window.opener && window.opener !== window),
            isServedByBifrost: (0, $jtt5y.default)()
        });
    }
    constructor(args){
        const { microbranding: microbranding, cobranding: cobranding, locale: locale, tenantCloudId: tenantCloudId, userId: userId, client: client = $ebca23e70cbbbff7$export$77ce8f76f8d1e1d1({
            microbranding: microbranding,
            locality: locale,
            tenantCloudId: tenantCloudId,
            userId: userId
        }) } = args;
        try {
            (0, $8f2pb.setLocale)(locale);
            this.microbranding = microbranding;
            this.cobranding = cobranding;
            this.client = client;
        } catch (error) {
            (0, $8f2pb.captureException)(error);
        }
    }
}
const $ebca23e70cbbbff7$export$70089efe93d43959 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createContext(null);
const $ebca23e70cbbbff7$export$923054f18cb06572 = ()=>{
    const context = (0, $8ZuGG.useContext)($ebca23e70cbbbff7$export$70089efe93d43959);
    if (!context) throw new Error('useAnalyticsClient used outside of AnalyticsProvider.');
    return context;
};
const $ebca23e70cbbbff7$export$e126afa8615733f3 = ()=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return analyticsClient.getAnonymousId();
};
const $ebca23e70cbbbff7$export$1397d31414038d5e = (event)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.trackingEvent(event);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
const $ebca23e70cbbbff7$export$a07d7c1ce880cd05 = (page, eventAttributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.pageViewedEvent(page, eventAttributes);
    }, [
        page
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $ebca23e70cbbbff7$export$4fb7f377b48b9cbc = (page, buttonId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(page, buttonId, attributes);
    }, [
        analyticsClient,
        page,
        buttonId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$65af8b3e3ac7d8ee = (page, linkId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.linkClickedEvent(page, linkId, attributes);
    }, [
        analyticsClient,
        page,
        linkId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$69c70ee0cb243a51 = (page, formId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.formSubmittedEvent(page, formId, attributes);
    }, [
        analyticsClient,
        page,
        formId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$87ff6dcd457142b0 = (operationalEvent, callback)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.operationalEvent(operationalEvent, callback);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

});
parcelRegister("ty6PY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $058d2af0cd6326ef$export$71511d61b312f219; });

var $c97ZN = parcelRequire("c97ZN");
function $058d2af0cd6326ef$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $c97ZN._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("c97ZN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d7c871475ef41e6$export$71511d61b312f219; });
function $8d7c871475ef41e6$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("6EnDC", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4d78d089f77bb46c$export$71511d61b312f219; });
function $4d78d089f77bb46c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d78d089f77bb46c$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $4d78d089f77bb46c$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("lk8Tl", function(module, exports) {

$parcel$export(module.exports, "currentEnv", function () { return $00d210f41ba7523f$export$d1418d82198b4abb; });
$parcel$export(module.exports, "getCurrentEnv", function () { return $00d210f41ba7523f$export$449f077783cda297; });
$parcel$export(module.exports, "currentEnvType", function () { return $00d210f41ba7523f$export$fc28d431ec5ff0ef; });
$parcel$export(module.exports, "idacOrigin", function () { return $00d210f41ba7523f$export$7fd1ab530687106; });
$parcel$export(module.exports, "currentCloudType", function () { return $00d210f41ba7523f$export$965b3f41be601b7a; });
$parcel$export(module.exports, "currentPerimeter", function () { return $00d210f41ba7523f$export$84a0517db04c70cb; });
$parcel$export(module.exports, "getCurrentCloudType", function () { return $00d210f41ba7523f$export$35199af7a1ed7e54; });
$parcel$export(module.exports, "isFedM", function () { return $00d210f41ba7523f$export$9db7980b9f442a4c; });
$parcel$export(module.exports, "isIsolatedCloud", function () { return $00d210f41ba7523f$export$9186ccba8effc5de; });
$parcel$export(module.exports, "getConfig", function () { return $00d210f41ba7523f$export$44487a86467333c3; });
function $00d210f41ba7523f$var$inferEnvFromHostname(hostname) {
    if (hostname === 'localhost') return 'local';
    if (hostname.endsWith('.dev.internal.atlassian.com') || hostname.endsWith('.dev.atlassian.com')) return 'dev';
    if (hostname.endsWith('.stg.internal.atlassian.com') || hostname.endsWith('.stg.atlassian.com')) return 'stg';
    if (hostname.endsWith('.stg.atlassian-us-gov-mod.com')) return 'stg-fedm';
    if (hostname.endsWith('.oasis-stg.com')) return 'stg-ic';
    if (hostname.endsWith('.atlassian-us-gov-mod.com')) return 'prod-fedm';
    if (hostname.endsWith('.atlassian.com')) return 'prod';
    if (hostname.endsWith('.atlassian-isolated.net')) return 'prod-ic';
    return 'unknown';
}
const $00d210f41ba7523f$export$d1418d82198b4abb = $00d210f41ba7523f$var$inferEnvFromHostname(window.location.hostname);
const $00d210f41ba7523f$export$449f077783cda297 = ()=>$00d210f41ba7523f$var$inferEnvFromHostname(window.location.hostname);
const $00d210f41ba7523f$var$envTypes = {
    local: 'dev',
    dev: 'dev',
    stg: 'staging',
    'stg-fedm': 'staging',
    'stg-ic': 'staging',
    prod: 'prod',
    'prod-fedm': 'prod',
    'prod-ic': 'prod',
    unknown: 'unknown'
};
const $00d210f41ba7523f$export$fc28d431ec5ff0ef = $00d210f41ba7523f$var$envTypes[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$var$idacOrigins = {
    // The local proxy is created within Parcel on the frontend local step, and requests are proxied to staging
    // Using `window.location.protocol` means that we don't need to make a change here if we run using HTTPS or HTTP.
    local: `${window.location.protocol}//localhost:3000`,
    dev: 'https://id.dev.internal.atlassian.com',
    stg: 'https://id.stg.internal.atlassian.com',
    'stg-fedm': 'https://id.stg.atlassian-us-gov-mod.com',
    'stg-ic': window.location.origin,
    prod: 'https://id.atlassian.com',
    'prod-fedm': 'https://id.atlassian-us-gov-mod.com',
    'prod-ic': window.location.origin,
    unknown: 'https://id.atlassian.com'
};
const $00d210f41ba7523f$export$7fd1ab530687106 = $00d210f41ba7523f$var$idacOrigins[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$var$atlassianCloudType = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'isolated-cloud',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'isolated-cloud',
    unknown: 'commercial'
};
const $00d210f41ba7523f$var$perimeter = {
    local: 'commercial',
    dev: 'commercial',
    stg: 'commercial',
    'stg-fedm': 'fedramp-moderate',
    'stg-ic': 'commercial',
    prod: 'commercial',
    'prod-fedm': 'fedramp-moderate',
    'prod-ic': 'commercial',
    unknown: 'commercial'
};
const $00d210f41ba7523f$var$config = {
    dev: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    staging: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    },
    prod: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeLRz0kAAAAAPIWGnreLcE0BJaZ17REyxkFhM0E',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6LcjUrgpAAAAANvg2hgPsYsHNO9F21kQVCQwUPoF'
        }
    },
    unknown: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
            smsEnrollmentRecaptchaEnterpriseNewKey: '6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O'
        }
    }
};
const $00d210f41ba7523f$export$965b3f41be601b7a = $00d210f41ba7523f$var$atlassianCloudType[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$export$84a0517db04c70cb = $00d210f41ba7523f$var$perimeter[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$export$35199af7a1ed7e54 = ()=>$00d210f41ba7523f$var$atlassianCloudType[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$export$9db7980b9f442a4c = ()=>$00d210f41ba7523f$export$35199af7a1ed7e54() === 'fedramp-moderate';
const $00d210f41ba7523f$export$9186ccba8effc5de = ()=>$00d210f41ba7523f$export$35199af7a1ed7e54() === 'isolated-cloud';
const $00d210f41ba7523f$export$44487a86467333c3 = ()=>$00d210f41ba7523f$var$config[$00d210f41ba7523f$export$fc28d431ec5ff0ef];

});

parcelRegister("8f2pb", function(module, exports) {

$parcel$export(module.exports, "initClient", function () { return $b5769c9141eb31bc$export$c4b69426a5efa3b7; });
$parcel$export(module.exports, "setUserId", function () { return $b5769c9141eb31bc$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $b5769c9141eb31bc$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setLocale", function () { return $b5769c9141eb31bc$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "captureTaggedException", function () { return $b5769c9141eb31bc$export$2e97319d952475e; });
$parcel$export(module.exports, "captureTaggedReactException", function () { return $b5769c9141eb31bc$export$8d72b01fb282cc43; });
$parcel$export(module.exports, "captureException", function () { return $b5769c9141eb31bc$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureRecaptchaException", function () { return $b5769c9141eb31bc$export$ddf087afa206091f; });
$parcel$export(module.exports, "captureCobrandingException", function () { return $b5769c9141eb31bc$export$5ec83ab111bbcd41; });
$parcel$export(module.exports, "captureMalformedError", function () { return $b5769c9141eb31bc$export$b6c309bc746f6dbf; });
$parcel$export(module.exports, "captureCobrandingError", function () { return $b5769c9141eb31bc$export$2fb60ea2fe20385b; });
$parcel$export(module.exports, "captureMessage", function () { return $b5769c9141eb31bc$export$45654777c133ae80; });
$parcel$export(module.exports, "captureErrorMessage", function () { return $b5769c9141eb31bc$export$53b98cb085651af4; });
$parcel$export(module.exports, "captureRecaptchaMessage", function () { return $b5769c9141eb31bc$export$8a94d1afc2068093; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jbj5m = parcelRequire("jbj5m");
var $kalUR = parcelRequire("kalUR");
var $8Qfoa = parcelRequire("8Qfoa");
var $h7fhS = parcelRequire("h7fhS");
var $f9o3h = parcelRequire("f9o3h");
var $4YTef = parcelRequire("4YTef");

var $lk8Tl = parcelRequire("lk8Tl");

var $day6I = parcelRequire("day6I");

var $fUUus = parcelRequire("fUUus");
// Only turn on debug for non production and non test runs (i.e. Jest);
const $b5769c9141eb31bc$var$debug = (0, $lk8Tl.currentEnv) !== 'prod' && true;
// https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/3370131692/Sentry+FedRAMP+-+Getting+Started#Sentry-DSN-in-FedRAMP
const $b5769c9141eb31bc$var$fedMSentryDSN = 'https://1c864dd6ac671ce6296e7cc6710a21a0@sentry.atlassian-us-gov-mod.com/22';
const $b5769c9141eb31bc$var$commercialSentryDSN = 'https://1271fcf5ddad45a1846153219eb726bd@o55978.ingest.sentry.io/4504172801622016';
$4YTef.init({
    dsn: (0, $lk8Tl.isFedM)() ? $b5769c9141eb31bc$var$fedMSentryDSN : $b5769c9141eb31bc$var$commercialSentryDSN,
    debug: $b5769c9141eb31bc$var$debug,
    environment: (0, $lk8Tl.currentEnv),
    release: "6788-f73962a7e71600448cb684fa41475c4c3de314d6",
    enabled: (0, $lk8Tl.currentEnv) !== 'local',
    sampleRate: 0.1,
    beforeSend (event) {
        var _event_request;
        // Remove URL queryparams, they can contain PII
        if ((_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.url) {
            event.request.url = event.request.url.split('?')[0];
            delete event.request.query_string;
        }
        // Ensure we have at least some best-guess tags for which capability might be affected
        const inferredCapabilities = (0, $fUUus.inferCapabilitiesFromPathname)(window.location.pathname);
        const capabilityTags = $b5769c9141eb31bc$var$capabilitiesToTags(inferredCapabilities);
        const existingTags = event.tags || {};
        event.tags = (0, $ty6PY._)({}, capabilityTags, existingTags);
        return event;
    },
    beforeBreadcrumb (breadcrumb) {
        // Don't send breadcrumbs that may contain PII
        if ([
            'navigation',
            'fetch',
            'xhr'
        ].includes(breadcrumb.category || '')) return null;
        return breadcrumb;
    },
    denyUrls: [
        /^chrome:\/\//,
        /^chrome-extension:\/\//,
        /accounts\.google\.com/,
        /recaptcha.net/
    ],
    ignoreErrors: [
        /^null/,
        /^undefined/,
        /Loading chunk.\d+.failed/,
        /^[^.]+\w+ is not defined/,
        'Load Failed',
        'NetworkError',
        'Failed to fetch',
        'SecurityError',
        'Object Not Found Matching Id',
        'Non-Error promise rejection captured with value:',
        'ResizeObserver loop limit exceeded'
    ],
    integrations: [
        // extracts all non-native attributes from the error object and attaches them to the event as extra data
        $h7fhS.extraErrorDataIntegration()
    ]
});
function $b5769c9141eb31bc$export$c4b69426a5efa3b7(microbranding) {
    $f9o3h.getCurrentScope().setExtra('isEmbedded', microbranding.isEmbedded);
    $f9o3h.getCurrentScope().setExtra('isMobileOidc', (0, $day6I.isMobileOidc)(microbranding.oidcContext));
}
function $b5769c9141eb31bc$export$7f5abdb7f5093137(userId) {
    $f9o3h.getCurrentScope().setUser({
        id: userId
    });
}
function $b5769c9141eb31bc$export$efda9a273d7a036d(breadcrumb) {
    if (!breadcrumb.level) breadcrumb.level = 'info';
    $jbj5m.addBreadcrumb(breadcrumb);
}
function $b5769c9141eb31bc$export$c8aadf3621e41efb(locale) {
    if (locale) $f9o3h.getCurrentScope().setTag('locale', locale);
}
function $b5769c9141eb31bc$export$2e97319d952475e(ex, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $f9o3h.withScope((scope)=>{
        const capabilityTags = $b5769c9141eb31bc$var$capabilitiesToTags(capabilities);
        scope.setTags((0, $ty6PY._)({}, tags, capabilityTags));
        scope.setExtras(extraProperties);
        $kalUR.captureException(ex);
    });
}
function $b5769c9141eb31bc$export$8d72b01fb282cc43(ex, errorInfo, options) {
    const { capabilities: capabilities, tags: tags = {}, extraProperties: extraProperties = {} } = options;
    $f9o3h.withScope((scope)=>{
        const capabilityTags = $b5769c9141eb31bc$var$capabilitiesToTags(capabilities);
        const otherTags = (0, $6EnDC._)((0, $ty6PY._)({}, tags), {
            // These errors always affect rendering. Meaning that, if left unhandled, they would
            // crash the app. We always want to include this tag to designate them as such.
            errorKind: 'rendering'
        });
        scope.setTags((0, $ty6PY._)({}, otherTags, capabilityTags));
        scope.setExtras(extraProperties);
        $8Qfoa.captureReactException(ex, errorInfo);
    });
}
function $b5769c9141eb31bc$export$f5282963edea4a68(ex, payload = {}, tags) {
    if (payload) $f9o3h.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $kalUR.setTags(tags);
        $kalUR.captureException(ex);
    });
    else $kalUR.captureException(ex);
}
const $b5769c9141eb31bc$export$ddf087afa206091f = (ex, payload = {}, tag)=>{
    $b5769c9141eb31bc$export$f5282963edea4a68(ex, payload, {
        recaptcha: tag
    });
};
const $b5769c9141eb31bc$export$5ec83ab111bbcd41 = (ex, payload = {}, tag)=>{
    $b5769c9141eb31bc$export$f5282963edea4a68(ex, payload, {
        coBranding: tag
    });
};
const $b5769c9141eb31bc$export$b6c309bc746f6dbf = (ex, payload = {}, tag)=>{
    $b5769c9141eb31bc$export$f5282963edea4a68(ex, payload, {
        malformedError: tag
    });
};
const $b5769c9141eb31bc$export$2fb60ea2fe20385b = (msg, payload = {}, tag)=>{
    $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, 'error', {
        coBranding: tag
    });
};
function $b5769c9141eb31bc$export$53b98cb085651af4(msg, payload = {}) {
    $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, 'error');
}
const $b5769c9141eb31bc$export$8a94d1afc2068093 = (msg, payload = {}, tag)=>{
    $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, 'error', {
        recaptcha: tag
    });
};
function $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, severity, tags) {
    if (payload) $f9o3h.withScope((scope)=>{
        Object.entries(payload).forEach(([key, value])=>{
            scope.setExtra(key, value);
        });
        if (tags) $kalUR.setTags(tags);
        $kalUR.captureMessage(msg, severity);
    });
    else $kalUR.captureMessage(msg, severity);
}
/**
 * Sentry only allows primitives for tag values.
 *
 * Since an error may be related to more than one capability group/subgroup/name, we need the
 * option to assign multiple different capability tags.
 *
 * For example, an error during check-username could impact both password+username login as well
 * as SSO login - both cases will need to be represented with their own tag.
 *
 * i.e. we can't include an array of affected capabilities under a single tag, so we include
 * them all individually as both the key and the value, like:
 *
 * { 'capability-group:login': 'capability-group:login' };
 */ const $b5769c9141eb31bc$var$capabilitiesToTags = (capabilities)=>capabilities.reduce((acc, current)=>{
        return (0, $6EnDC._)((0, $ty6PY._)({}, acc), {
            [current]: current
        });
    }, {});

});
parcelRegister("jbj5m", function(module, exports) {

$parcel$export(module.exports, "addBreadcrumb", function () { return $df6dd95b3ecfa065$export$efda9a273d7a036d; });

var $ty6PY = parcelRequire("ty6PY");

var $f9o3h = parcelRequire("f9o3h");

var $lx6FZ = parcelRequire("lx6FZ");

var $1vrBH = parcelRequire("1vrBH");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $df6dd95b3ecfa065$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $df6dd95b3ecfa065$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $f9o3h.getClient)();
    const isolationScope = (0, $f9o3h.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $df6dd95b3ecfa065$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $1vrBH.dateTimestampInSeconds)();
    const mergedBreadcrumb = (0, $ty6PY._)({
        timestamp: timestamp
    }, breadcrumb);
    const finalBreadcrumb = beforeBreadcrumb ? (0, $lx6FZ.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}

});
parcelRegister("f9o3h", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $b07a5a7e3a7cf89f$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $b07a5a7e3a7cf89f$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $b07a5a7e3a7cf89f$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $b07a5a7e3a7cf89f$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $b07a5a7e3a7cf89f$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $b07a5a7e3a7cf89f$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $b07a5a7e3a7cf89f$export$1e83db7ee4876dc4; });

var $9tet0 = parcelRequire("9tet0");

var $hxn0A = parcelRequire("hxn0A");

var $eYhV6 = parcelRequire("eYhV6");

var $8C8xp = parcelRequire("8C8xp");
/**
 * Get the currently active scope.
 */ function $b07a5a7e3a7cf89f$export$c7be4b0125a10cba() {
    const carrier = (0, $hxn0A.getMainCarrier)();
    const acs = (0, $9tet0.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $b07a5a7e3a7cf89f$export$68f3af03034c9e90() {
    const carrier = (0, $hxn0A.getMainCarrier)();
    const acs = (0, $9tet0.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $b07a5a7e3a7cf89f$export$aa55d5ab8e05984f() {
    return (0, $hxn0A.getGlobalSingleton)('globalScope', ()=>new (0, $eYhV6.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $b07a5a7e3a7cf89f$export$ec58d9285c204497(...rest) {
    const carrier = (0, $hxn0A.getMainCarrier)();
    const acs = (0, $9tet0.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $b07a5a7e3a7cf89f$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $hxn0A.getMainCarrier)();
    const acs = (0, $9tet0.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $b07a5a7e3a7cf89f$export$6bb76d6eba7e258c() {
    return $b07a5a7e3a7cf89f$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $b07a5a7e3a7cf89f$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $8C8xp.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("9tet0", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $6e520b4e93fa12c5$export$f639b0c2752203be; });

var $hxn0A = parcelRequire("hxn0A");

var $jM8oZ = parcelRequire("jM8oZ");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $6e520b4e93fa12c5$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $hxn0A.getMainCarrier)();
    const sentry = (0, $hxn0A.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $6e520b4e93fa12c5$export$f639b0c2752203be(carrier) {
    const sentry = (0, $hxn0A.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $jM8oZ.getStackAsyncContextStrategy)();
}

});
parcelRegister("hxn0A", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $cc475dc02773c7f7$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $cc475dc02773c7f7$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $cc475dc02773c7f7$export$7e223ec222791509; });

var $64Rpl = parcelRequire("64Rpl");

var $5IYBx = parcelRequire("5IYBx");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $cc475dc02773c7f7$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $cc475dc02773c7f7$export$c8bfa33e4e8ae492((0, $5IYBx.GLOBAL_OBJ));
    return 0, $5IYBx.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $cc475dc02773c7f7$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $64Rpl.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $64Rpl.SDK_VERSION] = __SENTRY__[0, $64Rpl.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $cc475dc02773c7f7$export$7e223ec222791509(name, creator, obj = (0, $5IYBx.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $64Rpl.SDK_VERSION] = __SENTRY__[0, $64Rpl.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("64Rpl", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $46cc8b742fce7cfb$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $46cc8b742fce7cfb$export$31499a9cd224b78c = "9.39.0";

});

parcelRegister("5IYBx", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $42b01292ec4c7c28$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $42b01292ec4c7c28$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("jM8oZ", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $e659047d8e417c7b$export$329d4d4d54e42710; });

var $8s7VO = parcelRequire("8s7VO");

var $eYhV6 = parcelRequire("eYhV6");

var $cLB1r = parcelRequire("cLB1r");

var $hxn0A = parcelRequire("hxn0A");
/**
 * This is an object that holds a stack of scopes.
 */ class $e659047d8e417c7b$export$d36ec451f120cfba {
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $cLB1r.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $eYhV6.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $eYhV6.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $e659047d8e417c7b$var$getAsyncContextStack() {
    const registry = (0, $hxn0A.getMainCarrier)();
    const sentry = (0, $hxn0A.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $e659047d8e417c7b$export$d36ec451f120cfba((0, $8s7VO.getDefaultCurrentScope)(), (0, $8s7VO.getDefaultIsolationScope)());
}
function $e659047d8e417c7b$var$withScope(callback) {
    return $e659047d8e417c7b$var$getAsyncContextStack().withScope(callback);
}
function $e659047d8e417c7b$var$withSetScope(scope, callback) {
    const stack = $e659047d8e417c7b$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $e659047d8e417c7b$var$withIsolationScope(callback) {
    return $e659047d8e417c7b$var$getAsyncContextStack().withScope(()=>{
        return callback($e659047d8e417c7b$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $e659047d8e417c7b$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $e659047d8e417c7b$var$withIsolationScope,
        withScope: $e659047d8e417c7b$var$withScope,
        withSetScope: $e659047d8e417c7b$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $e659047d8e417c7b$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$e659047d8e417c7b$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$e659047d8e417c7b$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("8s7VO", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $6277174598ddbc51$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $6277174598ddbc51$export$de9862929b76bf57; });

var $hxn0A = parcelRequire("hxn0A");

var $eYhV6 = parcelRequire("eYhV6");
/** Get the default current scope. */ function $6277174598ddbc51$export$6f1b9191db9c4d5() {
    return (0, $hxn0A.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $eYhV6.Scope)());
}
/** Get the default isolation scope. */ function $6277174598ddbc51$export$de9862929b76bf57() {
    return (0, $hxn0A.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $eYhV6.Scope)());
}

});
parcelRegister("eYhV6", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $ae6491d236a56aee$export$775b6bb06e53a214; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $gy8v9 = parcelRequire("gy8v9");

var $3cIqz = parcelRequire("3cIqz");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $eVvua = parcelRequire("eVvua");

var $b4WTe = parcelRequire("b4WTe");

var $8C8xp = parcelRequire("8C8xp");

var $pv2C6 = parcelRequire("pv2C6");

var $4Xsvk = parcelRequire("4Xsvk");

var $1vrBH = parcelRequire("1vrBH");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ae6491d236a56aee$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $ae6491d236a56aee$export$775b6bb06e53a214 {
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $ae6491d236a56aee$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = (0, $ty6PY._)({}, this._tags);
        newScope._extra = (0, $ty6PY._)({}, this._extra);
        newScope._contexts = (0, $ty6PY._)({}, this._contexts);
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = (0, $ty6PY._)({}, this._sdkProcessingMetadata);
        newScope._propagationContext = (0, $ty6PY._)({}, this._propagationContext);
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $pv2C6._setSpanForScope)(newScope, (0, $pv2C6._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $3cIqz.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = (0, $ty6PY._)({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = (0, $6EnDC._)((0, $ty6PY._)({}, this._tags), {
            [key]: value
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = (0, $ty6PY._)({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = (0, $6EnDC._)((0, $ty6PY._)({}, this._extra), {
            [key]: extra
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $ae6491d236a56aee$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $cLB1r.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = (0, $ty6PY._)({}, this._tags, tags);
        this._extra = (0, $ty6PY._)({}, this._extra, extra);
        this._contexts = (0, $ty6PY._)({}, this._contexts, contexts);
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $pv2C6._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $8C8xp.generateTraceId)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $ae6491d236a56aee$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = (0, $6EnDC._)((0, $ty6PY._)({
            timestamp: (0, $1vrBH.dateTimestampInSeconds)()
        }, breadcrumb), {
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $4Xsvk.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        });
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            var _this__client;
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            (_this__client = this._client) === null || _this__client === void 0 ? void 0 : _this__client.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $pv2C6._getSpanForScope)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $eVvua.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $b4WTe.uuid4)();
        if (!this._client) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, (0, $6EnDC._)((0, $ty6PY._)({
            originalException: exception,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $b4WTe.uuid4)();
        if (!this._client) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, (0, $6EnDC._)((0, $ty6PY._)({
            originalException: message,
            syntheticException: syntheticException
        }, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = (hint === null || hint === void 0 ? void 0 : hint.event_id) || (0, $b4WTe.uuid4)();
        if (!this._client) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, (0, $6EnDC._)((0, $ty6PY._)({}, hint), {
            event_id: eventId
        }), this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $8C8xp.generateTraceId)(),
            sampleRand: Math.random()
        };
    }
}

});
parcelRegister("gy8v9", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $c0c66a8bad5b4bc3$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $c0c66a8bad5b4bc3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("3cIqz", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $2554f47899b298ac$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $2554f47899b298ac$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $2554f47899b298ac$export$56521d9ba90f62ee; });

var $b4WTe = parcelRequire("b4WTe");

var $1vrBH = parcelRequire("1vrBH");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $2554f47899b298ac$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $1vrBH.timestampInSeconds)();
    const session = {
        sid: (0, $b4WTe.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$2554f47899b298ac$var$sessionToJSON(session)
    };
    if (context) $2554f47899b298ac$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $2554f47899b298ac$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $1vrBH.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $b4WTe.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $2554f47899b298ac$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $2554f47899b298ac$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $2554f47899b298ac$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("b4WTe", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $810dbfbb50e63dd7$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $810dbfbb50e63dd7$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $810dbfbb50e63dd7$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $810dbfbb50e63dd7$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $810dbfbb50e63dd7$export$6de4ffac6a2f1098; });

var $ty6PY = parcelRequire("ty6PY");

var $1B6IC = parcelRequire("1B6IC");

var $4Xsvk = parcelRequire("4Xsvk");

var $5IYBx = parcelRequire("5IYBx");
function $810dbfbb50e63dd7$var$getCrypto() {
    const gbl = (0, $5IYBx.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $810dbfbb50e63dd7$export$19f53698e68b2496(crypto = $810dbfbb50e63dd7$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto === null || crypto === void 0 ? void 0 : crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $810dbfbb50e63dd7$var$getFirstException(event) {
    var _event_exception_values, _event_exception;
    return (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $810dbfbb50e63dd7$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $810dbfbb50e63dd7$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $810dbfbb50e63dd7$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $810dbfbb50e63dd7$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $810dbfbb50e63dd7$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $ty6PY._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = (0, $ty6PY._)({}, currentMechanism === null || currentMechanism === void 0 ? void 0 : currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $810dbfbb50e63dd7$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $810dbfbb50e63dd7$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $810dbfbb50e63dd7$export$d364f2020ab30578(input) {
    const match = input.match($810dbfbb50e63dd7$var$SEMVER_REGEXP) || [];
    const major = $810dbfbb50e63dd7$var$_parseInt(match[1]);
    const minor = $810dbfbb50e63dd7$var$_parseInt(match[2]);
    const patch = $810dbfbb50e63dd7$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $810dbfbb50e63dd7$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4Xsvk.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $4Xsvk.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4Xsvk.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $810dbfbb50e63dd7$export$6de4ffac6a2f1098(exception) {
    if ($810dbfbb50e63dd7$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1B6IC.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $810dbfbb50e63dd7$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch (e) {} // eslint-disable-line no-empty
}

});
parcelRegister("1B6IC", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $129e755732e4ad29$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $129e755732e4ad29$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $129e755732e4ad29$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $129e755732e4ad29$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $129e755732e4ad29$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $129e755732e4ad29$export$b0244d5063c0b61b; });

var $ty6PY = parcelRequire("ty6PY");

var $gy8v9 = parcelRequire("gy8v9");

var $60eF2 = parcelRequire("60eF2");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $4Xsvk = parcelRequire("4Xsvk");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $129e755732e4ad29$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $129e755732e4ad29$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch (e) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $129e755732e4ad29$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $129e755732e4ad29$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $129e755732e4ad29$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $129e755732e4ad29$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $129e755732e4ad29$export$62ff257738bf57f5(value) {
    if ((0, $cLB1r.isError)(value)) return (0, $ty6PY._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $129e755732e4ad29$var$getOwnProperties(value));
    else if ((0, $cLB1r.isEvent)(value)) {
        const newObj = (0, $ty6PY._)({
            type: value.type,
            target: $129e755732e4ad29$var$serializeEventTarget(value.target),
            currentTarget: $129e755732e4ad29$var$serializeEventTarget(value.currentTarget)
        }, $129e755732e4ad29$var$getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, $cLB1r.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $129e755732e4ad29$var$serializeEventTarget(target) {
    try {
        return (0, $cLB1r.isElement)(target) ? (0, $60eF2.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $129e755732e4ad29$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $129e755732e4ad29$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($129e755732e4ad29$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return '[object has no keys]';
    if (firstKey.length >= maxLength) return (0, $4Xsvk.truncate)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4Xsvk.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $129e755732e4ad29$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $129e755732e4ad29$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $129e755732e4ad29$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($129e755732e4ad29$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($129e755732e4ad29$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $129e755732e4ad29$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $129e755732e4ad29$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $129e755732e4ad29$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $cLB1r.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("60eF2", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $45ee1d8326eb3758$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $45ee1d8326eb3758$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $45ee1d8326eb3758$export$26727cfcc4d7e0fc; });

var $cLB1r = parcelRequire("cLB1r");

var $5IYBx = parcelRequire("5IYBx");
const $45ee1d8326eb3758$var$WINDOW = (0, $5IYBx.GLOBAL_OBJ);
const $45ee1d8326eb3758$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $45ee1d8326eb3758$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $45ee1d8326eb3758$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $45ee1d8326eb3758$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $45ee1d8326eb3758$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!(elem === null || elem === void 0 ? void 0 : elem.tagName)) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($45ee1d8326eb3758$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = (keyAttrs === null || keyAttrs === void 0 ? void 0 : keyAttrs.length) ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs === null || keyAttrPairs === void 0 ? void 0 : keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $cLB1r.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $45ee1d8326eb3758$export$1cfafeee2987818b() {
    try {
        return $45ee1d8326eb3758$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $45ee1d8326eb3758$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$45ee1d8326eb3758$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("cLB1r", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $94b697ac0d7b5b07$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $94b697ac0d7b5b07$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $94b697ac0d7b5b07$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $94b697ac0d7b5b07$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $94b697ac0d7b5b07$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $94b697ac0d7b5b07$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $94b697ac0d7b5b07$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $94b697ac0d7b5b07$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $94b697ac0d7b5b07$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $94b697ac0d7b5b07$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $94b697ac0d7b5b07$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $94b697ac0d7b5b07$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $94b697ac0d7b5b07$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $94b697ac0d7b5b07$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $94b697ac0d7b5b07$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $94b697ac0d7b5b07$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $94b697ac0d7b5b07$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$e6127cc7fe7395c3(wat) {
    switch($94b697ac0d7b5b07$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $94b697ac0d7b5b07$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$var$isBuiltin(wat, className) {
    return $94b697ac0d7b5b07$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$9f9636d330b71954(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$ef9e2056653f0c8e(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$12e869b2a583f783(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$844ec244b1367d54(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$c3825b437cbdea5c(wat) {
    return wat === null || $94b697ac0d7b5b07$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$53b83ca8eaab0383(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $94b697ac0d7b5b07$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $94b697ac0d7b5b07$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$49841c62b9eff15(wat) {
    return $94b697ac0d7b5b07$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $94b697ac0d7b5b07$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean((wat === null || wat === void 0 ? void 0 : wat.then) && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$bc2894c7158efbac(wat) {
    return $94b697ac0d7b5b07$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $94b697ac0d7b5b07$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $94b697ac0d7b5b07$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $94b697ac0d7b5b07$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("lx6FZ", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $fad1dbcd88ae19e7$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $fad1dbcd88ae19e7$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $fad1dbcd88ae19e7$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $fad1dbcd88ae19e7$export$af88d00dbe7f521; });
$parcel$export(module.exports, "debug", function () { return $fad1dbcd88ae19e7$export$1c9f709888824e05; });

var $hxn0A = parcelRequire("hxn0A");

var $gy8v9 = parcelRequire("gy8v9");

var $5IYBx = parcelRequire("5IYBx");
/** A Sentry Logger instance. */ const $fad1dbcd88ae19e7$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $fad1dbcd88ae19e7$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $fad1dbcd88ae19e7$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $fad1dbcd88ae19e7$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $5IYBx.GLOBAL_OBJ))) return callback();
    const console = (0, $5IYBx.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($fad1dbcd88ae19e7$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $fad1dbcd88ae19e7$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $fad1dbcd88ae19e7$var$enable() {
    $fad1dbcd88ae19e7$var$_getLoggerSettings().enabled = true;
}
function $fad1dbcd88ae19e7$var$disable() {
    $fad1dbcd88ae19e7$var$_getLoggerSettings().enabled = false;
}
function $fad1dbcd88ae19e7$var$isEnabled() {
    return $fad1dbcd88ae19e7$var$_getLoggerSettings().enabled;
}
function $fad1dbcd88ae19e7$var$log(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('log', ...args);
}
function $fad1dbcd88ae19e7$var$info(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('info', ...args);
}
function $fad1dbcd88ae19e7$var$warn(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('warn', ...args);
}
function $fad1dbcd88ae19e7$var$error(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('error', ...args);
}
function $fad1dbcd88ae19e7$var$_debug(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('debug', ...args);
}
function $fad1dbcd88ae19e7$var$assert(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('assert', ...args);
}
function $fad1dbcd88ae19e7$var$trace(...args) {
    $fad1dbcd88ae19e7$var$_maybeLog('trace', ...args);
}
function $fad1dbcd88ae19e7$var$_maybeLog(level, ...args) {
    if (!(0, $gy8v9.DEBUG_BUILD)) return;
    if ($fad1dbcd88ae19e7$var$isEnabled()) $fad1dbcd88ae19e7$export$cda52e2a8927a2ca(()=>{
        (0, $5IYBx.GLOBAL_OBJ).console[level](`${$fad1dbcd88ae19e7$var$PREFIX}[${level}]:`, ...args);
    });
}
function $fad1dbcd88ae19e7$var$_getLoggerSettings() {
    if (!(0, $gy8v9.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $hxn0A.getGlobalSingleton)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $fad1dbcd88ae19e7$export$af88d00dbe7f521 = {
    enable: /** Enable logging. */ $fad1dbcd88ae19e7$var$enable,
    disable: /** Disable logging. */ $fad1dbcd88ae19e7$var$disable,
    isEnabled: /** Check if logging is enabled. */ $fad1dbcd88ae19e7$var$isEnabled,
    log: /** Log a message. */ $fad1dbcd88ae19e7$var$log,
    info: /** Log level info */ $fad1dbcd88ae19e7$var$info,
    warn: /** Log a warning. */ $fad1dbcd88ae19e7$var$warn,
    error: /** Log an error. */ $fad1dbcd88ae19e7$var$error,
    /** Log a debug message. */ debug: $fad1dbcd88ae19e7$var$_debug,
    assert: /** Log an assertion. */ $fad1dbcd88ae19e7$var$assert,
    trace: /** Log a trace. */ $fad1dbcd88ae19e7$var$trace
};
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $fad1dbcd88ae19e7$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $fad1dbcd88ae19e7$var$enable,
    disable: /** Disable logging. */ $fad1dbcd88ae19e7$var$disable,
    isEnabled: /** Check if logging is enabled. */ $fad1dbcd88ae19e7$var$isEnabled,
    log: /** Log a message. */ $fad1dbcd88ae19e7$var$log,
    warn: /** Log a warning. */ $fad1dbcd88ae19e7$var$warn,
    error: /** Log an error. */ $fad1dbcd88ae19e7$var$error
};

});

parcelRegister("4Xsvk", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $39c2c876ccf6cd2c$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $39c2c876ccf6cd2c$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $39c2c876ccf6cd2c$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $39c2c876ccf6cd2c$export$a7a5ec66062ea5d; });

var $cLB1r = parcelRequire("cLB1r");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $39c2c876ccf6cd2c$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $39c2c876ccf6cd2c$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $39c2c876ccf6cd2c$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $cLB1r.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $39c2c876ccf6cd2c$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $cLB1r.isString)(value)) return false;
    if ((0, $cLB1r.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $cLB1r.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $39c2c876ccf6cd2c$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$39c2c876ccf6cd2c$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("1vrBH", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $118e19e697b2bb15$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $118e19e697b2bb15$export$ee52dced521e3e18; });

var $5IYBx = parcelRequire("5IYBx");
const $118e19e697b2bb15$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $118e19e697b2bb15$export$7740643b9eeaf0c4() {
    return Date.now() / $118e19e697b2bb15$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $118e19e697b2bb15$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $5IYBx.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!(performance === null || performance === void 0 ? void 0 : performance.now) || !performance.timeOrigin) return $118e19e697b2bb15$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $118e19e697b2bb15$var$ONE_SECOND_IN_MS;
    };
}
let $118e19e697b2bb15$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $118e19e697b2bb15$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $118e19e697b2bb15$var$_cachedTimestampInSeconds !== null && $118e19e697b2bb15$var$_cachedTimestampInSeconds !== void 0 ? $118e19e697b2bb15$var$_cachedTimestampInSeconds : $118e19e697b2bb15$var$_cachedTimestampInSeconds = $118e19e697b2bb15$var$createUnixTimestampInSecondsFunc();
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $118e19e697b2bb15$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $118e19e697b2bb15$var$getBrowserTimeOrigin() {
    var _performance_timing;
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $5IYBx.GLOBAL_OBJ);
    if (!(performance === null || performance === void 0 ? void 0 : performance.now)) return [
        undefined,
        'none'
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = (_performance_timing = performance.timing) === null || _performance_timing === void 0 ? void 0 : _performance_timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            'timeOrigin'
        ];
        else return [
            navigationStart,
            'navigationStart'
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        'dateNow'
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $118e19e697b2bb15$export$baf075a948ffc0bf() {
    if (!$118e19e697b2bb15$var$cachedTimeOrigin) $118e19e697b2bb15$var$cachedTimeOrigin = $118e19e697b2bb15$var$getBrowserTimeOrigin();
    return $118e19e697b2bb15$var$cachedTimeOrigin[0];
}

});


parcelRegister("eVvua", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $addecfee40fb861e$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ 
var $ty6PY = parcelRequire("ty6PY");
function $addecfee40fb861e$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = (0, $ty6PY._)({}, initialObj);
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $addecfee40fb861e$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("8C8xp", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $64587ec799b30be4$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $64587ec799b30be4$export$295213bc4d0c54ad; });

var $b4WTe = parcelRequire("b4WTe");
/**
 * Generate a random, valid trace ID.
 */ function $64587ec799b30be4$export$dc6d7ea554bcce10() {
    return (0, $b4WTe.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $64587ec799b30be4$export$295213bc4d0c54ad() {
    return (0, $b4WTe.uuid4)().substring(16);
}

});

parcelRegister("pv2C6", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $04ca6a0a8a469eae$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $04ca6a0a8a469eae$export$91f063ebb8eff307; });

var $1B6IC = parcelRequire("1B6IC");
const $04ca6a0a8a469eae$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $04ca6a0a8a469eae$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $1B6IC.addNonEnumerableProperty)(scope, $04ca6a0a8a469eae$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$04ca6a0a8a469eae$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $04ca6a0a8a469eae$export$91f063ebb8eff307(scope) {
    return scope[$04ca6a0a8a469eae$var$SCOPE_SPAN_FIELD];
}

});







parcelRegister("kalUR", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $eae5bde832d0032c$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $eae5bde832d0032c$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $eae5bde832d0032c$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $eae5bde832d0032c$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setTags", function () { return $eae5bde832d0032c$export$74a8fb34822092e6; });
$parcel$export(module.exports, "startSession", function () { return $eae5bde832d0032c$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $eae5bde832d0032c$export$667e7b4d445d566b; });

var $ty6PY = parcelRequire("ty6PY");

var $f9o3h = parcelRequire("f9o3h");

var $gy8v9 = parcelRequire("gy8v9");

var $3cIqz = parcelRequire("3cIqz");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $b4WTe = parcelRequire("b4WTe");

var $kvWJH = parcelRequire("kvWJH");

var $1vrBH = parcelRequire("1vrBH");

var $5IYBx = parcelRequire("5IYBx");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $eae5bde832d0032c$export$f5282963edea4a68(exception, hint) {
    return (0, $f9o3h.getCurrentScope)().captureException(exception, (0, $kvWJH.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $eae5bde832d0032c$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $f9o3h.getCurrentScope)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $eae5bde832d0032c$export$1462b974fdcf6ba2(event, hint) {
    return (0, $f9o3h.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $eae5bde832d0032c$export$2f04de43fe27971a(name, context) {
    (0, $f9o3h.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $eae5bde832d0032c$export$bb4922da0dd51b92(extras) {
    (0, $f9o3h.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $eae5bde832d0032c$export$8e8e7789d42ed61d(key, extra) {
    (0, $f9o3h.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $eae5bde832d0032c$export$74a8fb34822092e6(tags) {
    (0, $f9o3h.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $eae5bde832d0032c$export$a37d07ee78eb4569(key, value) {
    (0, $f9o3h.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $eae5bde832d0032c$export$8b6bb3dd62a01be2(user) {
    (0, $f9o3h.getIsolationScope)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $eae5bde832d0032c$export$5d4e9fd7fac8e617() {
    return (0, $f9o3h.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $eae5bde832d0032c$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $f9o3h.getCurrentScope)();
    const client = (0, $f9o3h.getClient)();
    if (!client) (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $b4WTe.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $eae5bde832d0032c$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $eae5bde832d0032c$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $1vrBH.timestampInSeconds)();
    function finishCheckIn(status) {
        $eae5bde832d0032c$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $1vrBH.timestampInSeconds)() - now
        });
    }
    return (0, $f9o3h.withIsolationScope)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $cLB1r.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $eae5bde832d0032c$export$4909b86c8034bf73(timeout) {
    const client = (0, $f9o3h.getClient)();
    if (client) return client.flush(timeout);
    (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $eae5bde832d0032c$export$8360e631d277ea4d(timeout) {
    const client = (0, $f9o3h.getClient)();
    if (client) return client.close(timeout);
    (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $eae5bde832d0032c$export$3f95c6f800b78024() {
    return !!(0, $f9o3h.getClient)();
}
/** If the SDK is initialized & enabled. */ function $eae5bde832d0032c$export$3b029eb57ac4d562() {
    const client = (0, $f9o3h.getClient)();
    return (client === null || client === void 0 ? void 0 : client.getOptions().enabled) !== false && !!(client === null || client === void 0 ? void 0 : client.getTransport());
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $eae5bde832d0032c$export$9aac0b9f77928fbf(callback) {
    (0, $f9o3h.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $eae5bde832d0032c$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $f9o3h.getIsolationScope)();
    const currentScope = (0, $f9o3h.getCurrentScope)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $5IYBx.GLOBAL_OBJ).navigator || {};
    const session = (0, $3cIqz.makeSession)((0, $ty6PY._)({
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if ((currentSession === null || currentSession === void 0 ? void 0 : currentSession.status) === 'ok') (0, $3cIqz.updateSession)(currentSession, {
        status: 'exited'
    });
    $eae5bde832d0032c$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $eae5bde832d0032c$export$17a5be43989a0bc1() {
    const isolationScope = (0, $f9o3h.getIsolationScope)();
    const currentScope = (0, $f9o3h.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $3cIqz.closeSession)(session);
    $eae5bde832d0032c$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $eae5bde832d0032c$var$_sendSessionUpdate() {
    const isolationScope = (0, $f9o3h.getIsolationScope)();
    const client = (0, $f9o3h.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $eae5bde832d0032c$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $eae5bde832d0032c$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $eae5bde832d0032c$var$_sendSessionUpdate();
}

});
parcelRegister("kvWJH", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $eef443aa60a5a050$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $eef443aa60a5a050$export$76b5f966996d1653; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $86APb = parcelRequire("86APb");

var $f9o3h = parcelRequire("f9o3h");

var $Egzya = parcelRequire("Egzya");

var $eYhV6 = parcelRequire("eYhV6");

var $9KzcU = parcelRequire("9KzcU");

var $jtTIn = parcelRequire("jtTIn");

var $b4WTe = parcelRequire("b4WTe");

var $brh4F = parcelRequire("brh4F");

var $4Xsvk = parcelRequire("4Xsvk");

var $1vrBH = parcelRequire("1vrBH");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $eef443aa60a5a050$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = (0, $6EnDC._)((0, $ty6PY._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, $b4WTe.uuid4)(),
        timestamp: event.timestamp || (0, $1vrBH.dateTimestampInSeconds)()
    });
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $eef443aa60a5a050$export$d7e04067a6fbc882(prepared, options);
    $eef443aa60a5a050$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $eef443aa60a5a050$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $eef443aa60a5a050$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $b4WTe.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $f9o3h.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $9KzcU.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $9KzcU.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $9KzcU.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $Egzya.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $eef443aa60a5a050$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $eef443aa60a5a050$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $eef443aa60a5a050$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $86APb.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request === null || request === void 0 ? void 0 : request.url) request.url = (0, $4Xsvk.truncate)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $eef443aa60a5a050$export$63042efc86f043e7(event, stackParser) {
    var _event_exception_values, _event_exception;
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $jtTIn.getFilenameToDebugIdMap)(stackParser);
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $eef443aa60a5a050$export$1be657ba8ef44ff0(event) {
    var _event_exception_values, _event_exception;
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.forEach((exception)=>{
        var _exception_stacktrace_frames, _exception_stacktrace;
        (_exception_stacktrace = exception.stacktrace) === null || _exception_stacktrace === void 0 ? void 0 : (_exception_stacktrace_frames = _exception_stacktrace.frames) === null || _exception_stacktrace_frames === void 0 ? void 0 : _exception_stacktrace_frames.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $eef443aa60a5a050$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $eef443aa60a5a050$var$normalizeEvent(event, depth, maxBreadth) {
    var _event_contexts, _event_contexts1;
    if (!event) return null;
    const normalized = (0, $ty6PY._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map((b)=>(0, $ty6PY._)({}, b, b.data && {
                data: (0, $brh4F.normalize)(b.data, depth, maxBreadth)
            }))
    }, event.user && {
        user: (0, $brh4F.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, $brh4F.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, $brh4F.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (((_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $brh4F.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return (0, $ty6PY._)({}, span, span.data && {
            data: (0, $brh4F.normalize)(span.data, depth, maxBreadth)
        });
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (((_event_contexts1 = event.contexts) === null || _event_contexts1 === void 0 ? void 0 : _event_contexts1.flags) && normalized.contexts) normalized.contexts.flags = (0, $brh4F.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $eef443aa60a5a050$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $eYhV6.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $eef443aa60a5a050$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($eef443aa60a5a050$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($eef443aa60a5a050$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $eef443aa60a5a050$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $eYhV6.Scope) || typeof hint === 'function';
}
const $eef443aa60a5a050$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $eef443aa60a5a050$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$eef443aa60a5a050$var$captureContextKeys.includes(key));
}

});
parcelRegister("86APb", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $5e6b72d9f4dae6b4$export$849dbeeeda01ae98; });
const $5e6b72d9f4dae6b4$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("Egzya", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $07909778eb38b36b$export$bf2a096c3e883e79; });

var $ty6PY = parcelRequire("ty6PY");

var $gy8v9 = parcelRequire("gy8v9");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $djSZL = parcelRequire("djSZL");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $07909778eb38b36b$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $djSZL.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor((0, $ty6PY._)({}, event), hint);
            (0, $gy8v9.DEBUG_BUILD) && processor.id && result === null && (0, $lx6FZ.debug).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $cLB1r.isThenable)(result)) result.then((final)=>$07909778eb38b36b$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $07909778eb38b36b$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("djSZL", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $9b27b596eaeeea18$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $9b27b596eaeeea18$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $9b27b596eaeeea18$export$78e43115b553f358; });

var $cLB1r = parcelRequire("cLB1r");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $9b27b596eaeeea18$var$STATE_PENDING = 0;
const $9b27b596eaeeea18$var$STATE_RESOLVED = 1;
const $9b27b596eaeeea18$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $9b27b596eaeeea18$export$1fda8aa4d135f8aa(value) {
    return new $9b27b596eaeeea18$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $9b27b596eaeeea18$export$78e43115b553f358(reason) {
    return new $9b27b596eaeeea18$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $9b27b596eaeeea18$export$6f292d4960313241 {
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $9b27b596eaeeea18$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $9b27b596eaeeea18$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $9b27b596eaeeea18$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $9b27b596eaeeea18$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $9b27b596eaeeea18$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $9b27b596eaeeea18$var$STATE_PENDING) return;
            if ((0, $cLB1r.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($9b27b596eaeeea18$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($9b27b596eaeeea18$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
    constructor(executor){
        this._state = $9b27b596eaeeea18$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
}

});


parcelRegister("9KzcU", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $7193b85df5baf3b6$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $7193b85df5baf3b6$export$25ac7e259a513db4; });

var $ty6PY = parcelRequire("ty6PY");

var $eam68 = parcelRequire("eam68");

var $eVvua = parcelRequire("eVvua");

var $gJ89I = parcelRequire("gJ89I");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $7193b85df5baf3b6$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $7193b85df5baf3b6$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $7193b85df5baf3b6$var$applySpanToEvent(event, span);
    $7193b85df5baf3b6$var$applyFingerprintToEvent(event, fingerprint);
    $7193b85df5baf3b6$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $7193b85df5baf3b6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $7193b85df5baf3b6$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $7193b85df5baf3b6$export$b1a120a2871faa46(data, 'extra', extra);
    $7193b85df5baf3b6$export$b1a120a2871faa46(data, 'tags', tags);
    $7193b85df5baf3b6$export$b1a120a2871faa46(data, 'user', user);
    $7193b85df5baf3b6$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $eVvua.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = (0, $ty6PY._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $7193b85df5baf3b6$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $eVvua.merge)(data[prop], mergeVal, 1);
}
function $7193b85df5baf3b6$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = (0, $ty6PY._)({}, extra, event.extra);
    if (Object.keys(tags).length) event.tags = (0, $ty6PY._)({}, tags, event.tags);
    if (Object.keys(user).length) event.user = (0, $ty6PY._)({}, user, event.user);
    if (Object.keys(contexts).length) event.contexts = (0, $ty6PY._)({}, contexts, event.contexts);
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $7193b85df5baf3b6$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $7193b85df5baf3b6$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, $ty6PY._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function $7193b85df5baf3b6$var$applySpanToEvent(event, span) {
    event.contexts = (0, $ty6PY._)({
        trace: (0, $gJ89I.spanToTraceContext)(span)
    }, event.contexts);
    event.sdkProcessingMetadata = (0, $ty6PY._)({
        dynamicSamplingContext: (0, $eam68.getDynamicSamplingContextFromSpan)(span)
    }, event.sdkProcessingMetadata);
    const rootSpan = (0, $gJ89I.getRootSpan)(span);
    const transactionName = (0, $gJ89I.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $7193b85df5baf3b6$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("eam68", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $a50324095a102834$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $a50324095a102834$export$a117f995597e25df; });

var $86APb = parcelRequire("86APb");

var $f9o3h = parcelRequire("f9o3h");

var $4ooEO = parcelRequire("4ooEO");

var $9WnW7 = parcelRequire("9WnW7");

var $jDmYN = parcelRequire("jDmYN");

var $5U1c8 = parcelRequire("5U1c8");

var $1B6IC = parcelRequire("1B6IC");

var $gJ89I = parcelRequire("gJ89I");

var $9zJup = parcelRequire("9zJup");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $a50324095a102834$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $a50324095a102834$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $1B6IC.addNonEnumerableProperty)(spanWithMaybeDsc, $a50324095a102834$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $a50324095a102834$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key, host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = (0, $jDmYN.extractOrgIdFromDsnHost)(host);
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $86APb.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: org_id
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $a50324095a102834$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $a50324095a102834$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $a50324095a102834$export$a117f995597e25df(span) {
    const client = (0, $f9o3h.getClient)();
    if (!client) return {};
    const rootSpan = (0, $gJ89I.getRootSpan)(span);
    const rootSpanJson = (0, $gJ89I.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    var _traceState_get, _ref;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = (_ref = (_traceState_get = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rate')) !== null && _traceState_get !== void 0 ? _traceState_get : rootSpanAttributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]) !== null && _ref !== void 0 ? _ref : rootSpanAttributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$a50324095a102834$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $9WnW7.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $a50324095a102834$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $5U1c8.hasSpansEnabled)()) {
        var // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        _getCapturedScopesOnSpan_scope;
        dsc.sampled = String((0, $gJ89I.spanIsSampled)(rootSpan));
        var // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        _traceState_get1;
        dsc.sample_rand = (_traceState_get1 = traceState === null || traceState === void 0 ? void 0 : traceState.get('sentry.sample_rand')) !== null && _traceState_get1 !== void 0 ? _traceState_get1 : (_getCapturedScopesOnSpan_scope = (0, $9zJup.getCapturedScopesOnSpan)(rootSpan).scope) === null || _getCapturedScopesOnSpan_scope === void 0 ? void 0 : _getCapturedScopesOnSpan_scope.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $a50324095a102834$export$95cf936fdacaff7b(span) {
    const dsc = $a50324095a102834$export$a117f995597e25df(span);
    return (0, $9WnW7.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("4ooEO", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $332c87b6883fe3ed$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $332c87b6883fe3ed$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function () { return $332c87b6883fe3ed$export$889fb736668e1ecc; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $332c87b6883fe3ed$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $332c87b6883fe3ed$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $332c87b6883fe3ed$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $332c87b6883fe3ed$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $332c87b6883fe3ed$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function () { return $332c87b6883fe3ed$export$be7a251980e7e946; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function () { return $332c87b6883fe3ed$export$25dfd73e0e32c6e1; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $332c87b6883fe3ed$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $332c87b6883fe3ed$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $332c87b6883fe3ed$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $332c87b6883fe3ed$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $332c87b6883fe3ed$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $332c87b6883fe3ed$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $332c87b6883fe3ed$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $332c87b6883fe3ed$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $332c87b6883fe3ed$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $332c87b6883fe3ed$export$1efec95406bbe327 = 'sentry.profile_id';
const $332c87b6883fe3ed$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $332c87b6883fe3ed$export$b016f89ac1066ec = 'cache.hit';
const $332c87b6883fe3ed$export$3110e4c3f4386399 = 'cache.key';
const $332c87b6883fe3ed$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $332c87b6883fe3ed$export$be7a251980e7e946 = 'http.request.method';
const $332c87b6883fe3ed$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $332c87b6883fe3ed$export$ff77b5fd5b2d627b = 'sentry.link.type';

});

parcelRegister("9WnW7", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $73cc191a8d326a49$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $73cc191a8d326a49$export$56766feef403f365; });

var $gy8v9 = parcelRequire("gy8v9");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");
const $73cc191a8d326a49$export$6e69537d67fa20f = 'sentry-';
const $73cc191a8d326a49$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $73cc191a8d326a49$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $73cc191a8d326a49$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $73cc191a8d326a49$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($73cc191a8d326a49$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($73cc191a8d326a49$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $73cc191a8d326a49$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$73cc191a8d326a49$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $73cc191a8d326a49$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $73cc191a8d326a49$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $cLB1r.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $73cc191a8d326a49$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $73cc191a8d326a49$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $73cc191a8d326a49$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch (e) {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        })).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $73cc191a8d326a49$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $73cc191a8d326a49$export$bdd844ddb2def819) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("jDmYN", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $e4b37c1e7dddb252$export$44d472fbb931a776; });
$parcel$export(module.exports, "extractOrgIdFromDsnHost", function () { return $e4b37c1e7dddb252$export$5914f4e7748c29c9; });
$parcel$export(module.exports, "makeDsn", function () { return $e4b37c1e7dddb252$export$128827c3562ec0cb; });

var $gy8v9 = parcelRequire("gy8v9");

var $lx6FZ = parcelRequire("lx6FZ");
/** Regular expression used to extract org ID from a DSN host. */ const $e4b37c1e7dddb252$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $e4b37c1e7dddb252$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $e4b37c1e7dddb252$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $e4b37c1e7dddb252$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $e4b37c1e7dddb252$export$b892860177f70a30(str) {
    const match = $e4b37c1e7dddb252$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $lx6FZ.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $e4b37c1e7dddb252$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $e4b37c1e7dddb252$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $e4b37c1e7dddb252$var$validateDsn(dsn) {
    if (!(0, $gy8v9.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $lx6FZ.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $lx6FZ.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$e4b37c1e7dddb252$var$isValidProtocol(protocol)) {
        (0, $lx6FZ.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $lx6FZ.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $e4b37c1e7dddb252$export$5914f4e7748c29c9(host) {
    const match = host.match($e4b37c1e7dddb252$var$ORG_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $e4b37c1e7dddb252$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $e4b37c1e7dddb252$export$b892860177f70a30(from) : $e4b37c1e7dddb252$var$dsnFromComponents(from);
    if (!components || !$e4b37c1e7dddb252$var$validateDsn(components)) return undefined;
    return components;
}

});

parcelRegister("5U1c8", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", function () { return $44c31bfad44e5e37$export$1f70765132c3c225; });

var $f9o3h = parcelRequire("f9o3h");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $44c31bfad44e5e37$export$1f70765132c3c225(maybeOptions) {
    var _getClient;
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || ((_getClient = (0, $f9o3h.getClient)()) === null || _getClient === void 0 ? void 0 : _getClient.getOptions());
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $44c31bfad44e5e37$export$5008da00b1b6dee6 = $44c31bfad44e5e37$export$1f70765132c3c225;

});

parcelRegister("gJ89I", function(module, exports) {

$parcel$export(module.exports, "spanToJSON", function () { return $c2d72cdc4fd85962$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $c2d72cdc4fd85962$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanIsSampled", function () { return $c2d72cdc4fd85962$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "getRootSpan", function () { return $c2d72cdc4fd85962$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $c2d72cdc4fd85962$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $c2d72cdc4fd85962$export$d11691ff45a3e535; });

var $ty6PY = parcelRequire("ty6PY");

var $42tc5 = parcelRequire("42tc5");

var $9tet0 = parcelRequire("9tet0");

var $hxn0A = parcelRequire("hxn0A");

var $f9o3h = parcelRequire("f9o3h");

var $4ooEO = parcelRequire("4ooEO");

var $dgabc = parcelRequire("dgabc");

var $9zJup = parcelRequire("9zJup");

var $lx6FZ = parcelRequire("lx6FZ");

var $1B6IC = parcelRequire("1B6IC");

var $8C8xp = parcelRequire("8C8xp");

var $1vrBH = parcelRequire("1vrBH");

var $3lYKT = parcelRequire("3lYKT");

var $pv2C6 = parcelRequire("pv2C6");
// These are aligned with OpenTelemetry trace flags
const $c2d72cdc4fd85962$export$208d5b368507fb8b = 0x0;
const $c2d72cdc4fd85962$export$eb571cd9b5d98de8 = 0x1;
let $c2d72cdc4fd85962$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $c2d72cdc4fd85962$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $c2d72cdc4fd85962$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $c2d72cdc4fd85962$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $c2d72cdc4fd85962$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $9zJup.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? (scope === null || scope === void 0 ? void 0 : scope.getPropagationContext().propagationSpanId) || (0, $8C8xp.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $c2d72cdc4fd85962$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $c2d72cdc4fd85962$export$5caecac1caaf3a71(span);
    return (0, $3lYKT.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $c2d72cdc4fd85962$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map((_param)=>{
        var { context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes } = _param, restContext = (0, $42tc5._)(_param.context, [
            "spanId",
            "traceId",
            "traceFlags"
        ]);
        return (0, $ty6PY._)({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $c2d72cdc4fd85962$export$eb571cd9b5d98de8,
            attributes: attributes
        }, restContext);
    });
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $c2d72cdc4fd85962$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $c2d72cdc4fd85962$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $c2d72cdc4fd85962$var$ensureTimestampInSeconds(input.getTime());
    return (0, $1vrBH.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $c2d72cdc4fd85962$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $c2d72cdc4fd85962$export$92d8c23565496537(span) {
    if ($c2d72cdc4fd85962$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($c2d72cdc4fd85962$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        var _span_parentSpanContext;
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? (_span_parentSpanContext = span.parentSpanContext) === null || _span_parentSpanContext === void 0 ? void 0 : _span_parentSpanContext.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $c2d72cdc4fd85962$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $c2d72cdc4fd85962$export$3f7581298f56c6d7(endTime) || undefined,
            status: $c2d72cdc4fd85962$export$e238a77ea3a8cd66(status),
            op: attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $c2d72cdc4fd85962$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $c2d72cdc4fd85962$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $c2d72cdc4fd85962$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $c2d72cdc4fd85962$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $c2d72cdc4fd85962$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $c2d72cdc4fd85962$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $dgabc.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $dgabc.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'unknown_error';
}
const $c2d72cdc4fd85962$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $c2d72cdc4fd85962$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $c2d72cdc4fd85962$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$c2d72cdc4fd85962$var$ROOT_SPAN_FIELD] || span;
    (0, $1B6IC.addNonEnumerableProperty)(childSpan, $c2d72cdc4fd85962$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD]) span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $1B6IC.addNonEnumerableProperty)(span, $c2d72cdc4fd85962$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $c2d72cdc4fd85962$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD]) span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $c2d72cdc4fd85962$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($c2d72cdc4fd85962$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD] ? Array.from(span[$c2d72cdc4fd85962$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $c2d72cdc4fd85962$export$c4c6a79b1260ca1b(span) {
    return span[$c2d72cdc4fd85962$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $c2d72cdc4fd85962$export$1be426a8e585c83e() {
    const carrier = (0, $hxn0A.getMainCarrier)();
    const acs = (0, $9tet0.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $pv2C6._getSpanForScope)((0, $f9o3h.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $c2d72cdc4fd85962$export$d11691ff45a3e535() {
    if (!$c2d72cdc4fd85962$var$hasShownSpanDropWarning) {
        (0, $lx6FZ.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.');
        });
        $c2d72cdc4fd85962$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $c2d72cdc4fd85962$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("42tc5", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2f0dfea2964088e7$export$71511d61b312f219; });

var $5hRpA = parcelRequire("5hRpA");
function $2f0dfea2964088e7$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $5hRpA._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("5hRpA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d97f8b911a2f993$export$71511d61b312f219; });
function $3d97f8b911a2f993$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("dgabc", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $9a74aa7441467d39$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $9a74aa7441467d39$export$58f7963109c806fc; });
const $9a74aa7441467d39$export$136e25984ba4a383 = 0;
const $9a74aa7441467d39$export$58f7963109c806fc = 1;
const $9a74aa7441467d39$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $9a74aa7441467d39$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $9a74aa7441467d39$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $9a74aa7441467d39$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $9a74aa7441467d39$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $9a74aa7441467d39$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $9a74aa7441467d39$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("9zJup", function(module, exports) {

$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $6f8aab3542fe3453$export$c08fbc656a245d03; });

var $1B6IC = parcelRequire("1B6IC");
const $6f8aab3542fe3453$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $6f8aab3542fe3453$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $6f8aab3542fe3453$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $1B6IC.addNonEnumerableProperty)(span, $6f8aab3542fe3453$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $1B6IC.addNonEnumerableProperty)(span, $6f8aab3542fe3453$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $6f8aab3542fe3453$export$c08fbc656a245d03(span) {
    return {
        scope: span[$6f8aab3542fe3453$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$6f8aab3542fe3453$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

});

parcelRegister("3lYKT", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $27127603aa77c9bc$export$f35d907436da45cf; });

var $9WnW7 = parcelRequire("9WnW7");

var $lVQv0 = parcelRequire("lVQv0");

var $8C8xp = parcelRequire("8C8xp");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $27127603aa77c9bc$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $27127603aa77c9bc$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($27127603aa77c9bc$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $27127603aa77c9bc$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $27127603aa77c9bc$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $9WnW7.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!(traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.traceId)) return {
        traceId: (0, $8C8xp.generateTraceId)(),
        sampleRand: Math.random()
    };
    const sampleRand = $27127603aa77c9bc$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $27127603aa77c9bc$export$f35d907436da45cf(traceId = (0, $8C8xp.generateTraceId)(), spanId = (0, $8C8xp.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $27127603aa77c9bc$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $lVQv0.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $lVQv0.parseSampleRate)(dsc === null || dsc === void 0 ? void 0 : dsc.sample_rate);
    if (parsedSampleRate && (traceparentData === null || traceparentData === void 0 ? void 0 : traceparentData.parentSampled) !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}

});
parcelRegister("lVQv0", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $ff77a50dc55fffa2$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $ff77a50dc55fffa2$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});





parcelRegister("jtTIn", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $03a8f78237ac06d7$export$e069fee9c632ed00; });

var $5IYBx = parcelRequire("5IYBx");
let $03a8f78237ac06d7$var$parsedStackResults;
let $03a8f78237ac06d7$var$lastKeysCount;
let $03a8f78237ac06d7$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $03a8f78237ac06d7$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $5IYBx.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($03a8f78237ac06d7$var$cachedFilenameDebugIds && debugIdKeys.length === $03a8f78237ac06d7$var$lastKeysCount) return $03a8f78237ac06d7$var$cachedFilenameDebugIds;
    $03a8f78237ac06d7$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $03a8f78237ac06d7$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$03a8f78237ac06d7$var$parsedStackResults) $03a8f78237ac06d7$var$parsedStackResults = {};
        const result = $03a8f78237ac06d7$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame === null || stackFrame === void 0 ? void 0 : stackFrame.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $03a8f78237ac06d7$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $03a8f78237ac06d7$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $03a8f78237ac06d7$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $03a8f78237ac06d7$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: 'sourcemap',
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}

});

parcelRegister("brh4F", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $853f75ec272f842c$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $853f75ec272f842c$export$23fbbb20bed71033; });

var $cLB1r = parcelRequire("cLB1r");

var $1B6IC = parcelRequire("1B6IC");

var $lIM1p = parcelRequire("lIM1p");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $853f75ec272f842c$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $853f75ec272f842c$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $853f75ec272f842c$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $853f75ec272f842c$export$a3295358bff77e(object, depth);
    if ($853f75ec272f842c$var$jsonSize(normalized) > maxSize) return $853f75ec272f842c$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $853f75ec272f842c$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $853f75ec272f842c$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $853f75ec272f842c$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $853f75ec272f842c$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $1B6IC.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $853f75ec272f842c$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $853f75ec272f842c$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $cLB1r.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $cLB1r.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $lIM1p.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $853f75ec272f842c$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $853f75ec272f842c$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === void 0 ? void 0 : prototype.constructor) ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $853f75ec272f842c$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $853f75ec272f842c$var$jsonSize(value) {
    return $853f75ec272f842c$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $853f75ec272f842c$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $853f75ec272f842c$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});
parcelRegister("lIM1p", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $fd02f52079ab8224$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $fd02f52079ab8224$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $fd02f52079ab8224$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $fd02f52079ab8224$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $fd02f52079ab8224$export$91d8ca51bd9f6a47; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $fd02f52079ab8224$var$STACKTRACE_FRAME_LIMIT = 50;
const $fd02f52079ab8224$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $fd02f52079ab8224$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $fd02f52079ab8224$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $fd02f52079ab8224$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $fd02f52079ab8224$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($fd02f52079ab8224$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $fd02f52079ab8224$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $fd02f52079ab8224$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $fd02f52079ab8224$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $fd02f52079ab8224$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $fd02f52079ab8224$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($fd02f52079ab8224$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($fd02f52079ab8224$var$STRIP_FRAME_REGEXP.test($fd02f52079ab8224$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($fd02f52079ab8224$var$STRIP_FRAME_REGEXP.test($fd02f52079ab8224$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $fd02f52079ab8224$var$STACKTRACE_FRAME_LIMIT).map((frame)=>(0, $6EnDC._)((0, $ty6PY._)({}, frame), {
            filename: frame.filename || $fd02f52079ab8224$var$getLastStackFrame(localStack).filename,
            function: frame.function || $fd02f52079ab8224$export$27c7e15d453fc0ac
        }));
}
function $fd02f52079ab8224$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $fd02f52079ab8224$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $fd02f52079ab8224$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $fd02f52079ab8224$var$defaultFunctionName;
        return fn.name || $fd02f52079ab8224$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $fd02f52079ab8224$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $fd02f52079ab8224$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}

});




parcelRegister("8Qfoa", function(module, exports) {

$parcel$export(module.exports, "captureReactException", function () { return $66ff1dee10ceb376$export$270be4195468cda9; });

var $kalUR = parcelRequire("kalUR");
var $f9o3h = parcelRequire("f9o3h");

var $cLB1r = parcelRequire("cLB1r");

var $8ZuGG = parcelRequire("8ZuGG");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $66ff1dee10ceb376$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $66ff1dee10ceb376$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $66ff1dee10ceb376$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($66ff1dee10ceb376$export$a87138b73900f5b((0, $8ZuGG.version)) && (0, $cLB1r.isError)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $66ff1dee10ceb376$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $f9o3h.withScope)((scope)=>{
        scope.setContext('react', {
            componentStack: componentStack
        });
        return (0, $kalUR.captureException)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $66ff1dee10ceb376$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $66ff1dee10ceb376$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}

});

parcelRegister("h7fhS", function(module, exports) {

$parcel$export(module.exports, "extraErrorDataIntegration", function () { return $c75ef2dc6cc5707f$export$6e0872131894301d; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $gy8v9 = parcelRequire("gy8v9");

var $k2IYY = parcelRequire("k2IYY");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $brh4F = parcelRequire("brh4F");

var $1B6IC = parcelRequire("1B6IC");

var $4Xsvk = parcelRequire("4Xsvk");
const $c75ef2dc6cc5707f$var$INTEGRATION_NAME = 'ExtraErrorData';
/**
 * Extract additional data for from original exceptions.
 */ const $c75ef2dc6cc5707f$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $c75ef2dc6cc5707f$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $c75ef2dc6cc5707f$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $c75ef2dc6cc5707f$export$6e0872131894301d = (0, $k2IYY.defineIntegration)($c75ef2dc6cc5707f$var$_extraErrorDataIntegration);
function $c75ef2dc6cc5707f$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $cLB1r.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $c75ef2dc6cc5707f$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = (0, $ty6PY._)({}, event.contexts);
        const normalizedErrorData = (0, $brh4F.normalize)(errorData, depth);
        if ((0, $cLB1r.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $1B6IC.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0, $6EnDC._)((0, $ty6PY._)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $c75ef2dc6cc5707f$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $cLB1r.isError)(value) || typeof value === 'string' ? (0, $4Xsvk.truncate)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $cLB1r.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $cLB1r.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});
parcelRegister("k2IYY", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $e976e31ea60549d8$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $e976e31ea60549d8$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $e976e31ea60549d8$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $e976e31ea60549d8$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "defineIntegration", function () { return $e976e31ea60549d8$export$2323046b9414659f; });

var $f9o3h = parcelRequire("f9o3h");

var $gy8v9 = parcelRequire("gy8v9");

var $lx6FZ = parcelRequire("lx6FZ");
const $e976e31ea60549d8$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $e976e31ea60549d8$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $e976e31ea60549d8$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $e976e31ea60549d8$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $e976e31ea60549d8$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $e976e31ea60549d8$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $e976e31ea60549d8$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration === null || integration === void 0 ? void 0 : integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $e976e31ea60549d8$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($e976e31ea60549d8$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $e976e31ea60549d8$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $e976e31ea60549d8$export$2d8f5188773bcddd(integration) {
    const client = (0, $f9o3h.getClient)();
    if (!client) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $e976e31ea60549d8$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("4YTef", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $3a079b52ef3840fe$export$2cd8252107eb640b; });

var $ty6PY = parcelRequire("ty6PY");

var $eCW4E = parcelRequire("eCW4E");
var $kalUR = parcelRequire("kalUR");

var $jc5jS = parcelRequire("jc5jS");

var $8ZuGG = parcelRequire("8ZuGG");
/**
 * Inits the React SDK
 */ function $3a079b52ef3840fe$export$2cd8252107eb640b(options) {
    const opts = (0, $ty6PY._)({}, options);
    (0, $jc5jS.applySdkMetadata)(opts, 'react');
    (0, $kalUR.setContext)('react', {
        version: $8ZuGG.version
    });
    return (0, $eCW4E.init)(opts);
}

});
parcelRegister("eCW4E", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $aa61a998187c2cbd$export$2cd8252107eb640b; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $NQmJa = parcelRequire("NQmJa");
var $7uTRG = parcelRequire("7uTRG");
var $k2IYY = parcelRequire("k2IYY");
var $lf5JU = parcelRequire("lf5JU");
var $cFkMq = parcelRequire("cFkMq");
var $lIM1p = parcelRequire("lIM1p");

var $75R9i = parcelRequire("75R9i");

var $kqdkk = parcelRequire("kqdkk");

var $eQLpK = parcelRequire("eQLpK");

var $kg3Re = parcelRequire("kg3Re");

var $afRjv = parcelRequire("afRjv");

var $g1uQi = parcelRequire("g1uQi");

var $7sLCW = parcelRequire("7sLCW");

var $5DYYW = parcelRequire("5DYYW");

var $5VhSJ = parcelRequire("5VhSJ");

var $XJEDo = parcelRequire("XJEDo");
/** Get the default integrations for the browser SDK. */ function $aa61a998187c2cbd$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $lf5JU.inboundFiltersIntegration)(),
        (0, $7uTRG.functionToStringIntegration)(),
        (0, $eQLpK.browserApiErrorsIntegration)(),
        (0, $kqdkk.breadcrumbsIntegration)(),
        (0, $afRjv.globalHandlersIntegration)(),
        (0, $7sLCW.linkedErrorsIntegration)(),
        (0, $NQmJa.dedupeIntegration)(),
        (0, $g1uQi.httpContextIntegration)(),
        (0, $kg3Re.browserSessionIntegration)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $aa61a998187c2cbd$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $XJEDo.checkAndWarnIfIsEmbeddedBrowserExtension)();
    const clientOptions = (0, $6EnDC._)((0, $ty6PY._)({}, options), {
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $lIM1p.stackParserFromStackParserOptions)(options.stackParser || (0, $5DYYW.defaultStackParser)),
        integrations: (0, $k2IYY.getIntegrationsToSetup)({
            integrations: options.integrations,
            defaultIntegrations: options.defaultIntegrations == null ? $aa61a998187c2cbd$export$5783b2920b1d62b9() : options.defaultIntegrations
        }),
        transport: options.transport || (0, $5VhSJ.makeFetchTransport)
    });
    return (0, $cFkMq.initAndBind)((0, $75R9i.BrowserClient), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $aa61a998187c2cbd$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $aa61a998187c2cbd$export$4e4d8b287d028b6b(callback) {
    callback();
}

});
parcelRegister("NQmJa", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $095d326e22bfb223$export$6d39aa44cd0c7567; });

var $gy8v9 = parcelRequire("gy8v9");

var $k2IYY = parcelRequire("k2IYY");

var $lx6FZ = parcelRequire("lx6FZ");

var $lIM1p = parcelRequire("lIM1p");
const $095d326e22bfb223$var$INTEGRATION_NAME = 'Dedupe';
const $095d326e22bfb223$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $095d326e22bfb223$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($095d326e22bfb223$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $095d326e22bfb223$export$6d39aa44cd0c7567 = (0, $k2IYY.defineIntegration)($095d326e22bfb223$var$_dedupeIntegration);
/** only exported for tests. */ function $095d326e22bfb223$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($095d326e22bfb223$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($095d326e22bfb223$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $095d326e22bfb223$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$095d326e22bfb223$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$095d326e22bfb223$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $095d326e22bfb223$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $095d326e22bfb223$var$_getExceptionFromEvent(previousEvent);
    const currentException = $095d326e22bfb223$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$095d326e22bfb223$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$095d326e22bfb223$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $095d326e22bfb223$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $lIM1p.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $lIM1p.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $095d326e22bfb223$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $095d326e22bfb223$var$_getExceptionFromEvent(event) {
    var _event_exception;
    return ((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) && event.exception.values[0];
}

});

parcelRegister("7uTRG", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $5756ab51c10fe4d4$export$7918117e9202e4fb; });

var $f9o3h = parcelRequire("f9o3h");

var $k2IYY = parcelRequire("k2IYY");

var $1B6IC = parcelRequire("1B6IC");
let $5756ab51c10fe4d4$var$originalFunctionToString;
const $5756ab51c10fe4d4$var$INTEGRATION_NAME = 'FunctionToString';
const $5756ab51c10fe4d4$var$SETUP_CLIENTS = new WeakMap();
const $5756ab51c10fe4d4$var$_functionToStringIntegration = ()=>{
    return {
        name: $5756ab51c10fe4d4$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5756ab51c10fe4d4$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $1B6IC.getOriginalFunction)(this);
                    const context = $5756ab51c10fe4d4$var$SETUP_CLIENTS.has((0, $f9o3h.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5756ab51c10fe4d4$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5756ab51c10fe4d4$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5756ab51c10fe4d4$export$7918117e9202e4fb = (0, $k2IYY.defineIntegration)($5756ab51c10fe4d4$var$_functionToStringIntegration);

});

parcelRegister("lf5JU", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $f76f736ac72fee83$export$cb3c5c2ceb9818ba; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $gy8v9 = parcelRequire("gy8v9");

var $k2IYY = parcelRequire("k2IYY");

var $ltfrl = parcelRequire("ltfrl");

var $lx6FZ = parcelRequire("lx6FZ");

var $b4WTe = parcelRequire("b4WTe");

var $4Xsvk = parcelRequire("4Xsvk");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $f76f736ac72fee83$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $f76f736ac72fee83$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $f76f736ac72fee83$export$9a84f518c163c552 = (0, $k2IYY.defineIntegration)((options = {})=>{
    let mergedOptions;
    return {
        name: $f76f736ac72fee83$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $f76f736ac72fee83$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $f76f736ac72fee83$var$_mergeOptions(options, clientOptions);
            }
            return $f76f736ac72fee83$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $f76f736ac72fee83$export$cb3c5c2ceb9818ba = (0, $k2IYY.defineIntegration)((options = {})=>{
    return (0, $6EnDC._)((0, $ty6PY._)({}, $f76f736ac72fee83$export$9a84f518c163c552(options)), {
        name: 'InboundFilters'
    });
});
function $f76f736ac72fee83$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $f76f736ac72fee83$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $f76f736ac72fee83$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($f76f736ac72fee83$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $b4WTe.getEventDescription)(event)}`);
            return true;
        }
        if ($f76f736ac72fee83$var$_isUselessError(event)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $b4WTe.getEventDescription)(event)}`);
            return true;
        }
        if ($f76f736ac72fee83$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $b4WTe.getEventDescription)(event)}.\nUrl: ${$f76f736ac72fee83$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$f76f736ac72fee83$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $b4WTe.getEventDescription)(event)}.\nUrl: ${$f76f736ac72fee83$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($f76f736ac72fee83$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $b4WTe.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $f76f736ac72fee83$var$_isIgnoredError(event, ignoreErrors) {
    if (!(ignoreErrors === null || ignoreErrors === void 0 ? void 0 : ignoreErrors.length)) return false;
    return (0, $ltfrl.getPossibleEventMessages)(event).some((message)=>(0, $4Xsvk.stringMatchesSomePattern)(message, ignoreErrors));
}
function $f76f736ac72fee83$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!(ignoreTransactions === null || ignoreTransactions === void 0 ? void 0 : ignoreTransactions.length)) return false;
    const name = event.transaction;
    return name ? (0, $4Xsvk.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $f76f736ac72fee83$var$_isDeniedUrl(event, denyUrls) {
    if (!(denyUrls === null || denyUrls === void 0 ? void 0 : denyUrls.length)) return false;
    const url = $f76f736ac72fee83$var$_getEventFilterUrl(event);
    return !url ? false : (0, $4Xsvk.stringMatchesSomePattern)(url, denyUrls);
}
function $f76f736ac72fee83$var$_isAllowedUrl(event, allowUrls) {
    if (!(allowUrls === null || allowUrls === void 0 ? void 0 : allowUrls.length)) return true;
    const url = $f76f736ac72fee83$var$_getEventFilterUrl(event);
    return !url ? true : (0, $4Xsvk.stringMatchesSomePattern)(url, allowUrls);
}
function $f76f736ac72fee83$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $f76f736ac72fee83$var$_getEventFilterUrl(event) {
    try {
        var _event_exception, _rootException_stacktrace;
        var _event_exception_values;
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...(_event_exception_values = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) !== null && _event_exception_values !== void 0 ? _event_exception_values : []
        ].reverse().find((value)=>{
            var _value_mechanism, _value_stacktrace_frames, _value_stacktrace;
            return ((_value_mechanism = value.mechanism) === null || _value_mechanism === void 0 ? void 0 : _value_mechanism.parent_id) === undefined && ((_value_stacktrace = value.stacktrace) === null || _value_stacktrace === void 0 ? void 0 : (_value_stacktrace_frames = _value_stacktrace.frames) === null || _value_stacktrace_frames === void 0 ? void 0 : _value_stacktrace_frames.length);
        });
        const frames = rootException === null || rootException === void 0 ? void 0 : (_rootException_stacktrace = rootException.stacktrace) === null || _rootException_stacktrace === void 0 ? void 0 : _rootException_stacktrace.frames;
        return frames ? $f76f736ac72fee83$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error(`Cannot extract url for event ${(0, $b4WTe.getEventDescription)(event)}`);
        return null;
    }
}
function $f76f736ac72fee83$var$_isUselessError(event) {
    var _event_exception_values, _event_exception;
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.length)) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}

});
parcelRegister("ltfrl", function(module, exports) {

$parcel$export(module.exports, "getPossibleEventMessages", function () { return $fa184876ebe5a1ae$export$d55a97c329cacfcc; });
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $fa184876ebe5a1ae$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException === null || lastException === void 0 ? void 0 : lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}

});


parcelRegister("cFkMq", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $93896ed5130c27ac$export$5333c3f1c58d9bc1; });

var $f9o3h = parcelRequire("f9o3h");

var $gy8v9 = parcelRequire("gy8v9");

var $lx6FZ = parcelRequire("lx6FZ");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $93896ed5130c27ac$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $gy8v9.DEBUG_BUILD) (0, $lx6FZ.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $lx6FZ.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $f9o3h.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $93896ed5130c27ac$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $93896ed5130c27ac$export$ecb76f41d43c0e43(client) {
    (0, $f9o3h.getCurrentScope)().setClient(client);
}

});

parcelRegister("75R9i", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $52a23a5099d9b37e$export$1df9218a526d318d; });

var $ty6PY = parcelRequire("ty6PY");

var $aYVR1 = parcelRequire("aYVR1");
var $1FDVj = parcelRequire("1FDVj");
var $jc5jS = parcelRequire("jc5jS");
var $fdgAq = parcelRequire("fdgAq");
var $6KCMW = parcelRequire("6KCMW");

var $gYl44 = parcelRequire("gYl44");

var $fk3cO = parcelRequire("fk3cO");
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ const $52a23a5099d9b37e$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $52a23a5099d9b37e$export$1df9218a526d318d extends (0, $fdgAq.Client) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $gYl44.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $gYl44.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $52a23a5099d9b37e$export$4e107b20a7f977(options);
        const sdkSource = (0, $fk3cO.WINDOW).SENTRY_SDK_SOURCE || (0, $6KCMW.getSDKSource)();
        (0, $jc5jS.applySdkMetadata)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, _experiments: _experiments } = this._options;
        const enableLogs = _experiments === null || _experiments === void 0 ? void 0 : _experiments.enableLogs;
        if ((0, $fk3cO.WINDOW).document && (sendClientReports || enableLogs)) (0, $fk3cO.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $fk3cO.WINDOW).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $aYVR1._INTERNAL_flushLogsBuffer)(this);
            }
        });
        if (enableLogs) {
            this.on('flush', ()=>{
                (0, $aYVR1._INTERNAL_flushLogsBuffer)(this);
            });
            this.on('afterCaptureLog', ()=>{
                if (this._logFlushIdleTimeout) clearTimeout(this._logFlushIdleTimeout);
                this._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $aYVR1._INTERNAL_flushLogsBuffer)(this);
                }, $52a23a5099d9b37e$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            this.on('postprocessEvent', (0, $1FDVj.addAutoIpAddressToUser));
            this.on('beforeSendSession', (0, $1FDVj.addAutoIpAddressToSession));
        }
    }
}
/** Exported only for tests. */ function $52a23a5099d9b37e$export$4e107b20a7f977(optionsArg) {
    var _WINDOW_SENTRY_RELEASE;
    return (0, $ty6PY._)({
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (_WINDOW_SENTRY_RELEASE = (0, $fk3cO.WINDOW).SENTRY_RELEASE) === null || _WINDOW_SENTRY_RELEASE === void 0 ? void 0 : _WINDOW_SENTRY_RELEASE.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true
    }, optionsArg);
}

});
parcelRegister("aYVR1", function(module, exports) {

$parcel$export(module.exports, "_INTERNAL_flushLogsBuffer", function () { return $02103323a22f5361$export$f8ed83d3b6a0b504; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $hxn0A = parcelRequire("hxn0A");

var $fdgAq = parcelRequire("fdgAq");

var $f9o3h = parcelRequire("f9o3h");

var $gy8v9 = parcelRequire("gy8v9");

var $9KzcU = parcelRequire("9KzcU");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $pv2C6 = parcelRequire("pv2C6");

var $1vrBH = parcelRequire("1vrBH");

var $2143r = parcelRequire("2143r");

var $iWqOn = parcelRequire("iWqOn");
const $02103323a22f5361$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $02103323a22f5361$export$84cb46f4adfc5d14(value) {
    switch(typeof value){
        case 'number':
            if (Number.isInteger(value)) return {
                value: value,
                type: 'integer'
            };
            return {
                value: value,
                type: 'double'
            };
        case 'boolean':
            return {
                value: value,
                type: 'boolean'
            };
        case 'string':
            return {
                value: value,
                type: 'string'
            };
        default:
            {
                let stringValue = '';
                try {
                    var _JSON_stringify;
                    stringValue = (_JSON_stringify = JSON.stringify(value)) !== null && _JSON_stringify !== void 0 ? _JSON_stringify : '';
                } catch (e) {
                // Do nothing
                }
                return {
                    value: stringValue,
                    type: 'string'
                };
            }
    }
}
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $02103323a22f5361$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $02103323a22f5361$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $02103323a22f5361$var$_getBufferMap();
    const logBuffer = $02103323a22f5361$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else {
        bufferMap.set(client, [
            ...logBuffer,
            serializedLog
        ]);
        if (logBuffer.length >= $02103323a22f5361$var$MAX_LOG_BUFFER_SIZE) $02103323a22f5361$export$f8ed83d3b6a0b504(client, logBuffer);
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $02103323a22f5361$export$3ab3d16b9eebd986(beforeLog, client = (0, $f9o3h.getClient)(), currentScope = (0, $f9o3h.getCurrentScope)(), captureSerializedLog = $02103323a22f5361$export$743ba6f7ec19225f) {
    var _client_getSdkMetadata;
    if (!client) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('No client available to capture log.');
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments !== null && _experiments !== void 0 ? _experiments : {};
    if (!enableLogs) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $fdgAq._getTraceInfoFromScope)(client, currentScope);
    const processedLogAttributes = (0, $ty6PY._)({}, beforeLog.attributes);
    const { user: { id: id, email: email, username: username } } = $02103323a22f5361$var$getMergedScopeData(currentScope);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    var _client_getSdkMetadata_sdk;
    const { name: name, version: version } = (_client_getSdkMetadata_sdk = (_client_getSdkMetadata = client.getSdkMetadata()) === null || _client_getSdkMetadata === void 0 ? void 0 : _client_getSdkMetadata.sdk) !== null && _client_getSdkMetadata_sdk !== void 0 ? _client_getSdkMetadata_sdk : {};
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const beforeLogMessage = beforeLog.message;
    if ((0, $cLB1r.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $pv2C6._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $02103323a22f5361$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span === null || span === void 0 ? void 0 : span.spanContext().spanId);
    const processedLog = (0, $6EnDC._)((0, $ty6PY._)({}, beforeLog), {
        attributes: processedLogAttributes
    });
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $lx6FZ.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $1vrBH.timestampInSeconds)(),
        level: level,
        body: message,
        trace_id: traceContext === null || traceContext === void 0 ? void 0 : traceContext.trace_id,
        severity_number: severityNumber !== null && severityNumber !== void 0 ? severityNumber : (0, $2143r.SEVERITY_TEXT_TO_SEVERITY_NUMBER)[level],
        attributes: Object.keys(attributes).reduce((acc, key)=>{
            acc[key] = $02103323a22f5361$export$84cb46f4adfc5d14(attributes[key]);
            return acc;
        }, {})
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $02103323a22f5361$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    var _ref;
    const logBuffer = (_ref = maybeLogBuffer !== null && maybeLogBuffer !== void 0 ? maybeLogBuffer : $02103323a22f5361$export$5365c9902fb9e770(client)) !== null && _ref !== void 0 ? _ref : [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $iWqOn.createLogEnvelope)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $02103323a22f5361$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $02103323a22f5361$export$5365c9902fb9e770(client) {
    return $02103323a22f5361$var$_getBufferMap().get(client);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $02103323a22f5361$var$getMergedScopeData(currentScope) {
    const scopeData = (0, $f9o3h.getGlobalScope)().getScopeData();
    (0, $9KzcU.mergeScopeData)(scopeData, (0, $f9o3h.getIsolationScope)().getScopeData());
    (0, $9KzcU.mergeScopeData)(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $02103323a22f5361$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $hxn0A.getGlobalSingleton)('clientToLogBufferMap', ()=>new WeakMap());
}

});
parcelRegister("fdgAq", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $b134efa8ad95b26f$export$1f2bb630327ac4b6; });
$parcel$export(module.exports, "_getTraceInfoFromScope", function () { return $b134efa8ad95b26f$export$fb7d833b3fdedf5f; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8Q5KP = parcelRequire("8Q5KP");

var $86APb = parcelRequire("86APb");

var $f9o3h = parcelRequire("f9o3h");

var $gy8v9 = parcelRequire("gy8v9");

var $D8DUP = parcelRequire("D8DUP");

var $k2IYY = parcelRequire("k2IYY");

var $3cIqz = parcelRequire("3cIqz");

var $eam68 = parcelRequire("eam68");

var $9Coas = parcelRequire("9Coas");

var $jDmYN = parcelRequire("jDmYN");

var $iMdSf = parcelRequire("iMdSf");

var $ltfrl = parcelRequire("ltfrl");

var $cLB1r = parcelRequire("cLB1r");

var $lx6FZ = parcelRequire("lx6FZ");

var $eVvua = parcelRequire("eVvua");

var $b4WTe = parcelRequire("b4WTe");

var $lVQv0 = parcelRequire("lVQv0");

var $kvWJH = parcelRequire("kvWJH");

var $gJ89I = parcelRequire("gJ89I");

var $djSZL = parcelRequire("djSZL");

var $kRNxT = parcelRequire("kRNxT");
/* eslint-disable max-lines */ const $b134efa8ad95b26f$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $b134efa8ad95b26f$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $b134efa8ad95b26f$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $b134efa8ad95b26f$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
function $b134efa8ad95b26f$var$_makeInternalError(message) {
    return {
        message: message,
        [$b134efa8ad95b26f$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $b134efa8ad95b26f$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$b134efa8ad95b26f$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $b134efa8ad95b26f$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $b134efa8ad95b26f$var$INTERNAL_ERROR_SYMBOL in error;
}
function $b134efa8ad95b26f$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $b134efa8ad95b26f$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $b134efa8ad95b26f$export$1f2bb630327ac4b6 {
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $b4WTe.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $b4WTe.checkOrSetAlreadyCaught)(exception)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log($b134efa8ad95b26f$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $ty6PY._)({
            event_id: eventId
        }, hint);
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = (0, $ty6PY._)({
            event_id: (0, $b4WTe.uuid4)()
        }, hint);
        const eventMessage = (0, $cLB1r.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $cLB1r.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $b4WTe.uuid4)();
        // ensure we haven't captured this very object before
        if ((hint === null || hint === void 0 ? void 0 : hint.originalException) && (0, $b4WTe.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log($b134efa8ad95b26f$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = (0, $ty6PY._)({
            event_id: eventId
        }, hint);
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $3cIqz.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $djSZL.resolvedSyncPromise)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $k2IYY.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $k2IYY.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $D8DUP.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $iMdSf.addItemToEnvelope)(env, (0, $iMdSf.createAttachmentEnvelopeItem)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $86APb.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn($b134efa8ad95b26f$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn($b134efa8ad95b26f$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $D8DUP.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error('Error while sending envelope:', reason);
            return reason;
        });
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error('Transport disabled');
        return (0, $djSZL.resolvedSyncPromise)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $k2IYY.setupIntegrations)(this, integrations);
        (0, $k2IYY.afterSetupIntegrations)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        var _event_exception;
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if ((mechanism === null || mechanism === void 0 ? void 0 : mechanism.handled) === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $3cIqz.updateSession)(session, (0, $6EnDC._)((0, $ty6PY._)({}, crashed && {
                status: 'crashed'
            }), {
                errors: session.errors || Number(errored || crashed)
            }));
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $djSZL.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && (integrations === null || integrations === void 0 ? void 0 : integrations.length)) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $kvWJH.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = (0, $ty6PY._)({
                trace: (0, $f9o3h.getTraceContextFromScope)(currentScope)
            }, evt.contexts);
            const dynamicSamplingContext = (0, $eam68.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = (0, $ty6PY._)({
                dynamicSamplingContext: dynamicSamplingContext
            }, evt.sdkProcessingMetadata);
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $f9o3h.getCurrentScope)(), isolationScope = (0, $f9o3h.getIsolationScope)()) {
        if ((0, $gy8v9.DEBUG_BUILD) && $b134efa8ad95b26f$var$isErrorEvent(event)) (0, $lx6FZ.debug).log(`Captured error event \`${(0, $ltfrl.getPossibleEventMessages)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $gy8v9.DEBUG_BUILD) {
                if ($b134efa8ad95b26f$var$_isDoNotSendEventError(reason)) (0, $lx6FZ.debug).log(reason.message);
                else if ($b134efa8ad95b26f$var$_isInternalError(reason)) (0, $lx6FZ.debug).warn(reason.message);
                else (0, $lx6FZ.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $b134efa8ad95b26f$var$isTransactionEvent(event);
        const isError = $b134efa8ad95b26f$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $lVQv0.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $djSZL.rejectedSyncPromise)($b134efa8ad95b26f$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $b134efa8ad95b26f$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $b134efa8ad95b26f$var$processBeforeSend(this, options, prepared, hint);
            return $b134efa8ad95b26f$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $b134efa8ad95b26f$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                var _processedEvent_sdkProcessingMetadata;
                const spanCountBefore = ((_processedEvent_sdkProcessingMetadata = processedEvent.sdkProcessingMetadata) === null || _processedEvent_sdkProcessingMetadata === void 0 ? void 0 : _processedEvent_sdkProcessingMetadata.spanCountBeforeProcessing) || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = (0, $6EnDC._)((0, $ty6PY._)({}, transactionInfo), {
                    source: source
                });
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($b134efa8ad95b26f$var$_isDoNotSendEventError(reason) || $b134efa8ad95b26f$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $b134efa8ad95b26f$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).log('Sending outcomes:', outcomes);
        const envelope = (0, $9Coas.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $jDmYN.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $jDmYN.makeDsn)(options.dsn);
        else (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $8Q5KP.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport((0, $6EnDC._)((0, $ty6PY._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $b134efa8ad95b26f$export$4f22f74eddb7716a = $b134efa8ad95b26f$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $b134efa8ad95b26f$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $cLB1r.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $cLB1r.isPlainObject)(event) && event !== null) throw $b134efa8ad95b26f$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $b134efa8ad95b26f$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $cLB1r.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $b134efa8ad95b26f$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $b134efa8ad95b26f$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($b134efa8ad95b26f$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($b134efa8ad95b26f$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $kRNxT.convertTransactionEventToSpanJson)(processedEvent));
            if (!processedRootSpanJson) (0, $gJ89I.showSpanDropWarning)();
            else // update event with processed root span values
            processedEvent = (0, $eVvua.merge)(event, (0, $kRNxT.convertSpanJsonToTransactionEvent)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $gJ89I.showSpanDropWarning)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = (0, $6EnDC._)((0, $ty6PY._)({}, event.sdkProcessingMetadata), {
                    spanCountBeforeProcessing: spanCountBefore
                });
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $b134efa8ad95b26f$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $b134efa8ad95b26f$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** Extract trace information from scope */ function $b134efa8ad95b26f$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $f9o3h.withScope)(scope, ()=>{
        const span = (0, $gJ89I.getActiveSpan)();
        const traceContext = span ? (0, $gJ89I.spanToTraceContext)(span) : (0, $f9o3h.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $eam68.getDynamicSamplingContextFromSpan)(span) : (0, $eam68.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}

});
parcelRegister("8Q5KP", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $66f7a4bdfd6f8a74$export$9964600bfe84e6a3; });

var $jDmYN = parcelRequire("jDmYN");
const $66f7a4bdfd6f8a74$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $66f7a4bdfd6f8a74$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $66f7a4bdfd6f8a74$var$_getIngestEndpoint(dsn) {
    return `${$66f7a4bdfd6f8a74$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $66f7a4bdfd6f8a74$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $66f7a4bdfd6f8a74$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $66f7a4bdfd6f8a74$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$66f7a4bdfd6f8a74$var$_getIngestEndpoint(dsn)}?${$66f7a4bdfd6f8a74$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $66f7a4bdfd6f8a74$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $jDmYN.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$66f7a4bdfd6f8a74$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $jDmYN.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});

parcelRegister("D8DUP", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $075a58e9a7810a39$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $075a58e9a7810a39$export$c31057337a18010f; });

var $ty6PY = parcelRequire("ty6PY");

var $eam68 = parcelRequire("eam68");

var $jDmYN = parcelRequire("jDmYN");

var $iMdSf = parcelRequire("iMdSf");

var $gJ89I = parcelRequire("gJ89I");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $075a58e9a7810a39$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $075a58e9a7810a39$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $iMdSf.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = (0, $ty6PY._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $jDmYN.dsnToString)(dsn)
    });
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $iMdSf.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $075a58e9a7810a39$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $iMdSf.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $075a58e9a7810a39$var$enhanceEventWithSdkInfo(event, metadata === null || metadata === void 0 ? void 0 : metadata.sdk);
    const envelopeHeaders = (0, $iMdSf.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $iMdSf.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $075a58e9a7810a39$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $eam68.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client === null || client === void 0 ? void 0 : client.getDsn();
    const tunnel = client === null || client === void 0 ? void 0 : client.getOptions().tunnel;
    const headers = (0, $ty6PY._)({
        sent_at: new Date().toISOString()
    }, dscHasRequiredProps(dsc) && {
        trace: dsc
    }, !!tunnel && dsn && {
        dsn: (0, $jDmYN.dsnToString)(dsn)
    });
    const beforeSendSpan = client === null || client === void 0 ? void 0 : client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $gJ89I.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $gJ89I.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $gJ89I.spanToJSON);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $iMdSf.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $iMdSf.createEnvelope)(headers, items);
}

});
parcelRegister("iMdSf", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $dab778c14e7bb915$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $dab778c14e7bb915$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $dab778c14e7bb915$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $dab778c14e7bb915$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $dab778c14e7bb915$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $dab778c14e7bb915$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $dab778c14e7bb915$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $dab778c14e7bb915$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $dab778c14e7bb915$export$92b6093782fe661b; });

var $ty6PY = parcelRequire("ty6PY");

var $hxn0A = parcelRequire("hxn0A");

var $jDmYN = parcelRequire("jDmYN");

var $brh4F = parcelRequire("brh4F");

var $5IYBx = parcelRequire("5IYBx");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $dab778c14e7bb915$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $dab778c14e7bb915$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $dab778c14e7bb915$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $dab778c14e7bb915$export$604a45d95a155e2b(envelope, types) {
    return $dab778c14e7bb915$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $dab778c14e7bb915$var$encodeUTF8(input) {
    const carrier = (0, $hxn0A.getSentryCarrier)((0, $5IYBx.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $dab778c14e7bb915$var$decodeUTF8(input) {
    const carrier = (0, $hxn0A.getSentryCarrier)((0, $5IYBx.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $dab778c14e7bb915$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $dab778c14e7bb915$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $dab778c14e7bb915$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $brh4F.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $dab778c14e7bb915$var$concatBuffers(parts);
}
function $dab778c14e7bb915$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $dab778c14e7bb915$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $dab778c14e7bb915$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($dab778c14e7bb915$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $dab778c14e7bb915$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $dab778c14e7bb915$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $dab778c14e7bb915$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $dab778c14e7bb915$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $dab778c14e7bb915$export$b11169581eeaf237(type) {
    return $dab778c14e7bb915$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $dab778c14e7bb915$export$d369f3b2758f6743(metadataOrEvent) {
    if (!(metadataOrEvent === null || metadataOrEvent === void 0 ? void 0 : metadataOrEvent.sdk)) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $dab778c14e7bb915$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    var _event_sdkProcessingMetadata;
    const dynamicSamplingContext = (_event_sdkProcessingMetadata = event.sdkProcessingMetadata) === null || _event_sdkProcessingMetadata === void 0 ? void 0 : _event_sdkProcessingMetadata.dynamicSamplingContext;
    return (0, $ty6PY._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, $jDmYN.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: dynamicSamplingContext
    });
}

});


parcelRegister("9Coas", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $700a68dd890a6daa$export$f3b9ed77c03eeb00; });

var $iMdSf = parcelRequire("iMdSf");

var $1vrBH = parcelRequire("1vrBH");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $700a68dd890a6daa$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $1vrBH.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $iMdSf.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("kRNxT", function(module, exports) {

$parcel$export(module.exports, "convertTransactionEventToSpanJson", function () { return $f30f30996c5b7960$export$d9c6b2464b0a687e; });
$parcel$export(module.exports, "convertSpanJsonToTransactionEvent", function () { return $f30f30996c5b7960$export$f2d8fce5ae150e92; });

var $ty6PY = parcelRequire("ty6PY");

var $4ooEO = parcelRequire("4ooEO");
/**
 * Converts a transaction event to a span JSON object.
 */ function $f30f30996c5b7960$export$d9c6b2464b0a687e(event) {
    var _event_contexts;
    var _event_contexts_trace;
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = (_event_contexts_trace = (_event_contexts = event.contexts) === null || _event_contexts === void 0 ? void 0 : _event_contexts.trace) !== null && _event_contexts_trace !== void 0 ? _event_contexts_trace : {};
    var _event_start_timestamp;
    return {
        data: data !== null && data !== void 0 ? data : {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id !== null && span_id !== void 0 ? span_id : '',
        start_timestamp: (_event_start_timestamp = event.start_timestamp) !== null && _event_start_timestamp !== void 0 ? _event_start_timestamp : 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id !== null && trace_id !== void 0 ? trace_id : '',
        origin: origin,
        profile_id: data === null || data === void 0 ? void 0 : data[0, $4ooEO.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data === null || data === void 0 ? void 0 : data[0, $4ooEO.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $f30f30996c5b7960$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: (0, $ty6PY._)({}, span.data, span.profile_id && {
                    [(0, $4ooEO.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                }, span.exclusive_time && {
                    [(0, $4ooEO.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                })
            }
        },
        measurements: span.measurements
    };
}

});


parcelRegister("2143r", function(module, exports) {

$parcel$export(module.exports, "SEVERITY_TEXT_TO_SEVERITY_NUMBER", function () { return $177ed1e3fcfdcbb5$export$4fb50c0840d636d1; });
/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $177ed1e3fcfdcbb5$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};

});

parcelRegister("iWqOn", function(module, exports) {

$parcel$export(module.exports, "createLogEnvelope", function () { return $dca270f93bb941ae$export$cdcd668e6516443f; });

var $jDmYN = parcelRequire("jDmYN");

var $iMdSf = parcelRequire("iMdSf");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $dca270f93bb941ae$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $dca270f93bb941ae$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata === null || metadata === void 0 ? void 0 : metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $jDmYN.dsnToString)(dsn);
    return (0, $iMdSf.createEnvelope)(headers, [
        $dca270f93bb941ae$export$efdf3b13edb1118e(logs)
    ]);
}

});


parcelRegister("1FDVj", function(module, exports) {

$parcel$export(module.exports, "addAutoIpAddressToUser", function () { return $137896b895fef718$export$3e12ad68afa434ac; });
$parcel$export(module.exports, "addAutoIpAddressToSession", function () { return $137896b895fef718$export$e8e2d07ba63e2b6c; });
// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ 
var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
function $137896b895fef718$export$3e12ad68afa434ac(objWithMaybeUser) {
    var _objWithMaybeUser_user;
    if (((_objWithMaybeUser_user = objWithMaybeUser.user) === null || _objWithMaybeUser_user === void 0 ? void 0 : _objWithMaybeUser_user.ip_address) === undefined) objWithMaybeUser.user = (0, $6EnDC._)((0, $ty6PY._)({}, objWithMaybeUser.user), {
        ip_address: '{{auto}}'
    });
}
/**
 * @internal
 */ function $137896b895fef718$export$e8e2d07ba63e2b6c(session) {
    var _session_attrs;
    if ('aggregates' in session) {
        if (((_session_attrs = session.attrs) === null || _session_attrs === void 0 ? void 0 : _session_attrs['ip_address']) === undefined) session.attrs = (0, $6EnDC._)((0, $ty6PY._)({}, session.attrs), {
            ip_address: '{{auto}}'
        });
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}

});

parcelRegister("jc5jS", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $df9343ad7e33f8b4$export$b9f95b027256052c; });

var $64Rpl = parcelRequire("64Rpl");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $df9343ad7e33f8b4$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $64Rpl.SDK_VERSION)
            })),
        version: (0, $64Rpl.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("6KCMW", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $4ea52089ef497437$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $4ea52089ef497437$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $4ea52089ef497437$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}

});

parcelRegister("gYl44", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $c5b296ec22eaa305$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $c5b296ec22eaa305$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $c5b296ec22eaa305$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $c5b296ec22eaa305$export$5425b53185d13d6c; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $b4WTe = parcelRequire("b4WTe");
var $1B6IC = parcelRequire("1B6IC");
var $f9o3h = parcelRequire("f9o3h");
var $cLB1r = parcelRequire("cLB1r");
var $brh4F = parcelRequire("brh4F");
var $djSZL = parcelRequire("djSZL");
/**
 * This function creates an exception from a JavaScript Error
 */ function $c5b296ec22eaa305$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $c5b296ec22eaa305$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $c5b296ec22eaa305$export$2e9ae379995d99e3(ex),
        value: $c5b296ec22eaa305$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $c5b296ec22eaa305$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $f9o3h.getClient)();
    const normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $c5b296ec22eaa305$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $brh4F.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $c5b296ec22eaa305$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $cLB1r.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $c5b296ec22eaa305$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $c5b296ec22eaa305$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $c5b296ec22eaa305$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $c5b296ec22eaa305$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $c5b296ec22eaa305$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $c5b296ec22eaa305$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $c5b296ec22eaa305$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $c5b296ec22eaa305$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $c5b296ec22eaa305$var$getSkipFirstStackStringLines(ex) {
    if (ex && $c5b296ec22eaa305$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $c5b296ec22eaa305$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $c5b296ec22eaa305$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $c5b296ec22eaa305$export$2e9ae379995d99e3(ex) {
    const name = ex === null || ex === void 0 ? void 0 : ex.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $c5b296ec22eaa305$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $c5b296ec22eaa305$export$86005d1b62804363(ex) {
    const message = ex === null || ex === void 0 ? void 0 : ex.message;
    if ($c5b296ec22eaa305$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $c5b296ec22eaa305$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $c5b296ec22eaa305$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b4WTe.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $djSZL.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $c5b296ec22eaa305$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || undefined;
    const event = $c5b296ec22eaa305$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint === null || hint === void 0 ? void 0 : hint.event_id) event.event_id = hint.event_id;
    return (0, $djSZL.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $c5b296ec22eaa305$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $cLB1r.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $c5b296ec22eaa305$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $cLB1r.isDOMError)(exception) || (0, $cLB1r.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $c5b296ec22eaa305$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $cLB1r.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c5b296ec22eaa305$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $b4WTe.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, $6EnDC._)((0, $ty6PY._)({}, event.tags), {
            'DOMException.code': `${domException.code}`
        });
        return event;
    }
    if ((0, $cLB1r.isError)(exception)) // we have a real Error object, do nothing
    return $c5b296ec22eaa305$var$eventFromError(stackParser, exception);
    if ((0, $cLB1r.isPlainObject)(exception) || (0, $cLB1r.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $c5b296ec22eaa305$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $b4WTe.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c5b296ec22eaa305$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $b4WTe.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $b4WTe.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c5b296ec22eaa305$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $c5b296ec22eaa305$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $b4WTe.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $cLB1r.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $c5b296ec22eaa305$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $1B6IC.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $cLB1r.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $cLB1r.isEvent)(exception)) {
        const className = $c5b296ec22eaa305$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c5b296ec22eaa305$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $c5b296ec22eaa305$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}

});

parcelRegister("fk3cO", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $b27b35de0b31bc7f$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $b27b35de0b31bc7f$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $b27b35de0b31bc7f$export$4997ffc0176396a6; });
$parcel$export(module.exports, "getHttpRequestData", function () { return $b27b35de0b31bc7f$export$a3c4a8453e8936f0; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $b4WTe = parcelRequire("b4WTe");
var $1B6IC = parcelRequire("1B6IC");
var $kalUR = parcelRequire("kalUR");
var $60eF2 = parcelRequire("60eF2");
var $5IYBx = parcelRequire("5IYBx");
var $f9o3h = parcelRequire("f9o3h");
const $b27b35de0b31bc7f$export$56d8a8a25bd48b81 = (0, $5IYBx.GLOBAL_OBJ);
let $b27b35de0b31bc7f$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b27b35de0b31bc7f$export$b79738ab10c590b2() {
    return $b27b35de0b31bc7f$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b27b35de0b31bc7f$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b27b35de0b31bc7f$var$ignoreOnError++;
    setTimeout(()=>{
        $b27b35de0b31bc7f$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b27b35de0b31bc7f$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $1B6IC.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$b27b35de0b31bc7f$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b27b35de0b31bc7f$export$1265a142ff5ba165();
            (0, $f9o3h.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $b4WTe.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $b4WTe.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, $6EnDC._)((0, $ty6PY._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, $kalUR.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (e) {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $1B6IC.markFunctionWrapped)(sentryWrapped, fn);
    (0, $1B6IC.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch (e) {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $b27b35de0b31bc7f$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $60eF2.getLocationHref)();
    const { referrer: referrer } = $b27b35de0b31bc7f$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $b27b35de0b31bc7f$export$56d8a8a25bd48b81.navigator || {};
    const headers = (0, $ty6PY._)({}, referrer && {
        Referer: referrer
    }, userAgent && {
        'User-Agent': userAgent
    });
    const request = {
        url: url,
        headers: headers
    };
    return request;
}

});


parcelRegister("kqdkk", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $ede092d01761bfd6$export$c079d904b326663a; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jbj5m = parcelRequire("jbj5m");
var $c2H4C = parcelRequire("c2H4C");
var $4vHtr = parcelRequire("4vHtr");
var $k2IYY = parcelRequire("k2IYY");
var $aZVUu = parcelRequire("aZVUu");
var $f9o3h = parcelRequire("f9o3h");
var $60eF2 = parcelRequire("60eF2");
var $b4WTe = parcelRequire("b4WTe");
var $lx6FZ = parcelRequire("lx6FZ");
var $7MCjF = parcelRequire("7MCjF");
var $4Xsvk = parcelRequire("4Xsvk");
var $6dvIL = parcelRequire("6dvIL");

var $l2Mul = parcelRequire("l2Mul");
var $6NxND = parcelRequire("6NxND");
var $ClOkW = parcelRequire("ClOkW");

var $jUFcW = parcelRequire("jUFcW");

var $fk3cO = parcelRequire("fk3cO");
/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $ede092d01761bfd6$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $ede092d01761bfd6$var$INTEGRATION_NAME = 'Breadcrumbs';
const $ede092d01761bfd6$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = (0, $ty6PY._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: $ede092d01761bfd6$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $c2H4C.addConsoleInstrumentationHandler)($ede092d01761bfd6$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $l2Mul.addClickKeypressInstrumentationHandler)($ede092d01761bfd6$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $ClOkW.addXhrInstrumentationHandler)($ede092d01761bfd6$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $4vHtr.addFetchInstrumentationHandler)($ede092d01761bfd6$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $6NxND.addHistoryInstrumentationHandler)($ede092d01761bfd6$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $ede092d01761bfd6$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $ede092d01761bfd6$export$c079d904b326663a = (0, $k2IYY.defineIntegration)($ede092d01761bfd6$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $ede092d01761bfd6$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $f9o3h.getClient)() !== client) return;
        (0, $jbj5m.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $b4WTe.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $ede092d01761bfd6$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $f9o3h.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $ede092d01761bfd6$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $jUFcW.DEBUG_BUILD) && (0, $lx6FZ.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$ede092d01761bfd6$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$ede092d01761bfd6$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $ede092d01761bfd6$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $ede092d01761bfd6$var$_isEvent(event) ? event.target : event;
            target = (0, $60eF2.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $60eF2.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $jbj5m.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $ede092d01761bfd6$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $f9o3h.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $6dvIL.severityLevelFromString)(handlerData.level),
            message: (0, $4Xsvk.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $4Xsvk.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $jbj5m.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $ede092d01761bfd6$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $f9o3h.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $ClOkW.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $aZVUu.getBreadcrumbLogLevelFromHttpStatusCode)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $jbj5m.addBreadcrumb)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $ede092d01761bfd6$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $f9o3h.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $jbj5m.addBreadcrumb)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = (0, $6EnDC._)((0, $ty6PY._)({}, handlerData.fetchData), {
                status_code: response === null || response === void 0 ? void 0 : response.status
            });
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response === null || response === void 0 ? void 0 : response.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $aZVUu.getBreadcrumbLogLevelFromHttpStatusCode)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $jbj5m.addBreadcrumb)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $ede092d01761bfd6$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $f9o3h.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $7MCjF.parseUrl)((0, $fk3cO.WINDOW).location.href);
        let parsedFrom = from ? (0, $7MCjF.parseUrl)(from) : undefined;
        const parsedTo = (0, $7MCjF.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!(parsedFrom === null || parsedFrom === void 0 ? void 0 : parsedFrom.path)) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $jbj5m.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $ede092d01761bfd6$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("c2H4C", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $8c47156c8aba54d1$export$1d6e0d073f9e6723; });

var $lx6FZ = parcelRequire("lx6FZ");

var $1B6IC = parcelRequire("1B6IC");

var $5IYBx = parcelRequire("5IYBx");

var $hT1BD = parcelRequire("hT1BD");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $8c47156c8aba54d1$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $8c47156c8aba54d1$var$instrumentConsole);
}
function $8c47156c8aba54d1$var$instrumentConsole() {
    if (!('console' in (0, $5IYBx.GLOBAL_OBJ))) return;
    (0, $lx6FZ.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $5IYBx.GLOBAL_OBJ).console)) return;
        (0, $1B6IC.fill)((0, $5IYBx.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $lx6FZ.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $hT1BD.triggerHandlers)('console', handlerData);
                const log = (0, $lx6FZ.originalConsoleMethods)[level];
                log === null || log === void 0 ? void 0 : log.apply((0, $5IYBx.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("hT1BD", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $d058d19f027d35dc$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $d058d19f027d35dc$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $d058d19f027d35dc$export$b18c893e424d3127; });

var $gy8v9 = parcelRequire("gy8v9");

var $lx6FZ = parcelRequire("lx6FZ");

var $lIM1p = parcelRequire("lIM1p");
// We keep the handlers globally
const $d058d19f027d35dc$var$handlers = {};
const $d058d19f027d35dc$var$instrumented = {};
/** Add a handler function. */ function $d058d19f027d35dc$export$a4e09611e30da72e(type, handler) {
    $d058d19f027d35dc$var$handlers[type] = $d058d19f027d35dc$var$handlers[type] || [];
    $d058d19f027d35dc$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $d058d19f027d35dc$export$b17eab759a1cb5fe() {
    Object.keys($d058d19f027d35dc$var$handlers).forEach((key)=>{
        $d058d19f027d35dc$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $d058d19f027d35dc$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$d058d19f027d35dc$var$instrumented[type]) {
        $d058d19f027d35dc$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $d058d19f027d35dc$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $d058d19f027d35dc$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $lIM1p.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("4vHtr", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $348bc7b2155c69dc$export$f75d3c772c923df0; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $cLB1r = parcelRequire("cLB1r");

var $1B6IC = parcelRequire("1B6IC");

var $gOwaU = parcelRequire("gOwaU");

var $1vrBH = parcelRequire("1vrBH");

var $5IYBx = parcelRequire("5IYBx");

var $hT1BD = parcelRequire("hT1BD");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $348bc7b2155c69dc$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, ()=>$348bc7b2155c69dc$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $348bc7b2155c69dc$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, ()=>$348bc7b2155c69dc$var$instrumentFetch($348bc7b2155c69dc$var$streamHandler));
}
function $348bc7b2155c69dc$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $gOwaU.supportsNativeFetch)()) return;
    (0, $1B6IC.fill)((0, $5IYBx.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $348bc7b2155c69dc$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $348bc7b2155c69dc$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $hT1BD.triggerHandlers)('fetch', (0, $ty6PY._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $5IYBx.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $hT1BD.triggerHandlers)('fetch', (0, $6EnDC._)((0, $ty6PY._)({}, handlerData), {
                    endTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
                    response: response
                }));
                return response;
            }, (error)=>{
                (0, $hT1BD.triggerHandlers)('fetch', (0, $6EnDC._)((0, $ty6PY._)({}, handlerData), {
                    endTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
                    error: error
                }));
                if ((0, $cLB1r.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $1B6IC.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch (e) {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $348bc7b2155c69dc$var$resolveResponse(res, onFinishedResolving) {
    if (res === null || res === void 0 ? void 0 : res.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $348bc7b2155c69dc$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch (e) {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $348bc7b2155c69dc$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $hT1BD.triggerHandlers)('fetch-body-resolved', {
            endTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $348bc7b2155c69dc$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $348bc7b2155c69dc$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($348bc7b2155c69dc$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $348bc7b2155c69dc$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $348bc7b2155c69dc$var$getUrlFromResource(url),
            method: $348bc7b2155c69dc$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $348bc7b2155c69dc$var$getUrlFromResource(arg),
        method: $348bc7b2155c69dc$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $348bc7b2155c69dc$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $cLB1r.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch (e) {
    // noop
    }
    return;
}

});
parcelRegister("gOwaU", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $c3da4620a353ff2d$export$67fc34576016d6ec; });
$parcel$export(module.exports, "isNativeFunction", function () { return $c3da4620a353ff2d$export$d5f608b368e73f38; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $c3da4620a353ff2d$export$c82d238e23c40b21; });

var $gy8v9 = parcelRequire("gy8v9");

var $lx6FZ = parcelRequire("lx6FZ");

var $5IYBx = parcelRequire("5IYBx");
const $c3da4620a353ff2d$var$WINDOW = (0, $5IYBx.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $c3da4620a353ff2d$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $c3da4620a353ff2d$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $c3da4620a353ff2d$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $c3da4620a353ff2d$export$67fc34576016d6ec() {
    return 'history' in $c3da4620a353ff2d$var$WINDOW && !!$c3da4620a353ff2d$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $c3da4620a353ff2d$export$edf3cb81fd7d2a3e = $c3da4620a353ff2d$var$_isFetchSupported;
function $c3da4620a353ff2d$var$_isFetchSupported() {
    if (!('fetch' in $c3da4620a353ff2d$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $c3da4620a353ff2d$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $c3da4620a353ff2d$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$c3da4620a353ff2d$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($c3da4620a353ff2d$export$d5f608b368e73f38($c3da4620a353ff2d$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $c3da4620a353ff2d$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var _sandbox_contentWindow;
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if ((_sandbox_contentWindow = sandbox.contentWindow) === null || _sandbox_contentWindow === void 0 ? void 0 : _sandbox_contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $c3da4620a353ff2d$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $c3da4620a353ff2d$export$531055a6c684a70a() {
    return 'ReportingObserver' in $c3da4620a353ff2d$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $c3da4620a353ff2d$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$c3da4620a353ff2d$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRegister("aZVUu", function(module, exports) {

$parcel$export(module.exports, "getBreadcrumbLogLevelFromHttpStatusCode", function () { return $801c859baf3d7421$export$b8cfcc4175694bcc; });
/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $801c859baf3d7421$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}

});

parcelRegister("7MCjF", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $5aaabce7b24ea59a$export$7a5253c0f62e0150; });

var $4ooEO = parcelRequire("4ooEO");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $5aaabce7b24ea59a$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $5aaabce7b24ea59a$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $5aaabce7b24ea59a$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase !== null && urlBase !== void 0 ? urlBase : isRelative ? $5aaabce7b24ea59a$var$DEFAULT_BASE_URL : undefined;
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch (e) {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $5aaabce7b24ea59a$export$5339fcdc8e2a427c(url) {
    if ($5aaabce7b24ea59a$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $5aaabce7b24ea59a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    var _request_method;
    var _request_method_toUpperCase;
    const method = (_request_method_toUpperCase = request === null || request === void 0 ? void 0 : (_request_method = request.method) === null || _request_method === void 0 ? void 0 : _request_method.toUpperCase()) !== null && _request_method_toUpperCase !== void 0 ? _request_method_toUpperCase : 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $5aaabce7b24ea59a$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $5aaabce7b24ea59a$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request === null || request === void 0 ? void 0 : request.method) attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$5aaabce7b24ea59a$export$e258e13805402ba7(urlObject)) {
            attributes[0, $4ooEO.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $5aaabce7b24ea59a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $5aaabce7b24ea59a$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $5aaabce7b24ea59a$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $5aaabce7b24ea59a$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = (host === null || host === void 0 ? void 0 : host.replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '')) || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("6dvIL", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $486c901eca24d4b3$export$d771ef054122c30a; });
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $486c901eca24d4b3$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}

});

parcelRegister("l2Mul", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $f51f65b0eb8b724c$export$5aeffd3db2cf9df7; });

var $hT1BD = parcelRequire("hT1BD");
var $1B6IC = parcelRequire("1B6IC");
var $b4WTe = parcelRequire("b4WTe");

var $kQsBc = parcelRequire("kQsBc");
const $f51f65b0eb8b724c$var$DEBOUNCE_DURATION = 1000;
let $f51f65b0eb8b724c$var$debounceTimerID;
let $f51f65b0eb8b724c$var$lastCapturedEventType;
let $f51f65b0eb8b724c$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f51f65b0eb8b724c$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $f51f65b0eb8b724c$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $f51f65b0eb8b724c$export$3014bbf0af0e1d4a() {
    if (!(0, $kQsBc.WINDOW).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $hT1BD.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $f51f65b0eb8b724c$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $kQsBc.WINDOW).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $kQsBc.WINDOW).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        var _globalObject_target, _proto_hasOwnProperty;
        const globalObject = (0, $kQsBc.WINDOW);
        const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
        (0, $1B6IC.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f51f65b0eb8b724c$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $1B6IC.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $f51f65b0eb8b724c$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $f51f65b0eb8b724c$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $f51f65b0eb8b724c$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $f51f65b0eb8b724c$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!(target === null || target === void 0 ? void 0 : target.tagName)) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $f51f65b0eb8b724c$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $f51f65b0eb8b724c$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($f51f65b0eb8b724c$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $1B6IC.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $1B6IC.addNonEnumerableProperty)(target, '_sentryId', (0, $b4WTe.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$f51f65b0eb8b724c$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f51f65b0eb8b724c$var$lastCapturedEventType = event.type;
            $f51f65b0eb8b724c$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($f51f65b0eb8b724c$var$debounceTimerID);
        $f51f65b0eb8b724c$var$debounceTimerID = (0, $kQsBc.WINDOW).setTimeout(()=>{
            $f51f65b0eb8b724c$var$lastCapturedEventTargetId = undefined;
            $f51f65b0eb8b724c$var$lastCapturedEventType = undefined;
        }, $f51f65b0eb8b724c$var$DEBOUNCE_DURATION);
    };
}
function $f51f65b0eb8b724c$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});
parcelRegister("kQsBc", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $f2ced921c3544778$export$56d8a8a25bd48b81; });

var $5IYBx = parcelRequire("5IYBx");
const $f2ced921c3544778$export$56d8a8a25bd48b81 = (0, $5IYBx.GLOBAL_OBJ);

});


parcelRegister("6NxND", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $4f3189912e043f18$export$3f18c56c58114e75; });

var $hT1BD = parcelRequire("hT1BD");
var $1B6IC = parcelRequire("1B6IC");
var $gOwaU = parcelRequire("gOwaU");

var $kQsBc = parcelRequire("kQsBc");
let $4f3189912e043f18$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $4f3189912e043f18$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $4f3189912e043f18$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $4f3189912e043f18$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $kQsBc.WINDOW).addEventListener('popstate', ()=>{
        const to = (0, $kQsBc.WINDOW).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $4f3189912e043f18$var$lastHref;
        $4f3189912e043f18$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $hT1BD.triggerHandlers)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $gOwaU.supportsHistory)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $4f3189912e043f18$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $4f3189912e043f18$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $4f3189912e043f18$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $hT1BD.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $1B6IC.fill)((0, $kQsBc.WINDOW).history, 'pushState', historyReplacementFunction);
    (0, $1B6IC.fill)((0, $kQsBc.WINDOW).history, 'replaceState', historyReplacementFunction);
}
function $4f3189912e043f18$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $kQsBc.WINDOW).location.origin);
        return url.toString();
    } catch (e) {
        // fallback, just do nothing
        return urlOrPath;
    }
}

});

parcelRegister("ClOkW", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $073477e94b313718$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $073477e94b313718$export$26ace48dd54c9aea; });

var $hT1BD = parcelRequire("hT1BD");
var $cLB1r = parcelRequire("cLB1r");
var $1vrBH = parcelRequire("1vrBH");

var $kQsBc = parcelRequire("kQsBc");
const $073477e94b313718$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $073477e94b313718$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $073477e94b313718$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $073477e94b313718$export$c67d533bf77cbf54() {
    if (!(0, $kQsBc.WINDOW).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $1vrBH.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $cLB1r.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $073477e94b313718$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$073477e94b313718$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$073477e94b313718$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $hT1BD.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$073477e94b313718$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $cLB1r.isString)(header) && (0, $cLB1r.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$073477e94b313718$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $1vrBH.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $hT1BD.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $073477e94b313718$var$parseXhrUrlArg(url) {
    if ((0, $cLB1r.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch (e) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("jUFcW", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $e7f33647b294c9a8$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e7f33647b294c9a8$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("eQLpK", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $acfab38773ec179d$export$59bfe9f1c76150e; });

var $ty6PY = parcelRequire("ty6PY");

var $k2IYY = parcelRequire("k2IYY");
var $1B6IC = parcelRequire("1B6IC");
var $lIM1p = parcelRequire("lIM1p");

var $fk3cO = parcelRequire("fk3cO");
const $acfab38773ec179d$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $acfab38773ec179d$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $acfab38773ec179d$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = (0, $ty6PY._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false
    }, options);
    return {
        name: $acfab38773ec179d$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $1B6IC.fill)((0, $fk3cO.WINDOW), 'setTimeout', $acfab38773ec179d$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $1B6IC.fill)((0, $fk3cO.WINDOW), 'setInterval', $acfab38773ec179d$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $1B6IC.fill)((0, $fk3cO.WINDOW), 'requestAnimationFrame', $acfab38773ec179d$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $fk3cO.WINDOW)) (0, $1B6IC.fill)(XMLHttpRequest.prototype, 'send', $acfab38773ec179d$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $acfab38773ec179d$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$acfab38773ec179d$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $acfab38773ec179d$export$59bfe9f1c76150e = (0, $k2IYY.defineIntegration)($acfab38773ec179d$var$_browserApiErrorsIntegration);
function $acfab38773ec179d$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $fk3cO.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $lIM1p.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
function $acfab38773ec179d$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $fk3cO.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $lIM1p.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $acfab38773ec179d$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $1B6IC.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $lIM1p.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $1B6IC.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $lIM1p.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $fk3cO.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $acfab38773ec179d$var$_wrapEventTarget(target, integrationOptions) {
    var _globalObject_target, _proto_hasOwnProperty;
    const globalObject = (0, $fk3cO.WINDOW);
    const proto = (_globalObject_target = globalObject[target]) === null || _globalObject_target === void 0 ? void 0 : _globalObject_target.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!(proto === null || proto === void 0 ? void 0 : (_proto_hasOwnProperty = proto.hasOwnProperty) === null || _proto_hasOwnProperty === void 0 ? void 0 : _proto_hasOwnProperty.call(proto, 'addEventListener'))) return;
    (0, $1B6IC.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($acfab38773ec179d$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $fk3cO.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $lIM1p.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (e) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $acfab38773ec179d$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $fk3cO.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $lIM1p.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $1B6IC.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $acfab38773ec179d$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $acfab38773ec179d$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}

});

parcelRegister("kg3Re", function(module, exports) {

$parcel$export(module.exports, "browserSessionIntegration", function () { return $ebf84b4a77de6e8d$export$1baa7880e357371c; });

var $kalUR = parcelRequire("kalUR");
var $k2IYY = parcelRequire("k2IYY");
var $lx6FZ = parcelRequire("lx6FZ");

var $6NxND = parcelRequire("6NxND");

var $jUFcW = parcelRequire("jUFcW");

var $fk3cO = parcelRequire("fk3cO");
/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $ebf84b4a77de6e8d$export$1baa7880e357371c = (0, $k2IYY.defineIntegration)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $fk3cO.WINDOW).document === 'undefined') {
                (0, $jUFcW.DEBUG_BUILD) && (0, $lx6FZ.logger).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $kalUR.startSession)({
                ignoreDuration: true
            });
            (0, $kalUR.captureSession)();
            // We want to create a session for every navigation as well
            (0, $6NxND.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $kalUR.startSession)({
                        ignoreDuration: true
                    });
                    (0, $kalUR.captureSession)();
                }
            });
        }
    };
});

});

parcelRegister("afRjv", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $7774a90c26a507fe$export$66acc70e8cf2b71a; });

var $ty6PY = parcelRequire("ty6PY");

var $9nCe6 = parcelRequire("9nCe6");
var $bFy9z = parcelRequire("bFy9z");
var $kalUR = parcelRequire("kalUR");
var $k2IYY = parcelRequire("k2IYY");
var $f9o3h = parcelRequire("f9o3h");
var $60eF2 = parcelRequire("60eF2");
var $cLB1r = parcelRequire("cLB1r");
var $lx6FZ = parcelRequire("lx6FZ");
var $lIM1p = parcelRequire("lIM1p");

var $jUFcW = parcelRequire("jUFcW");

var $gYl44 = parcelRequire("gYl44");

var $fk3cO = parcelRequire("fk3cO");
const $7774a90c26a507fe$var$INTEGRATION_NAME = 'GlobalHandlers';
const $7774a90c26a507fe$var$_globalHandlersIntegration = (options = {})=>{
    const _options = (0, $ty6PY._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: $7774a90c26a507fe$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $7774a90c26a507fe$var$_installGlobalOnErrorHandler(client);
                $7774a90c26a507fe$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $7774a90c26a507fe$var$_installGlobalOnUnhandledRejectionHandler(client);
                $7774a90c26a507fe$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $7774a90c26a507fe$export$66acc70e8cf2b71a = (0, $k2IYY.defineIntegration)($7774a90c26a507fe$var$_globalHandlersIntegration);
function $7774a90c26a507fe$var$_installGlobalOnErrorHandler(client) {
    (0, $9nCe6.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7774a90c26a507fe$var$getOptions();
        if ((0, $f9o3h.getClient)() !== client || (0, $fk3cO.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $7774a90c26a507fe$var$_enhanceEventWithInitialFrame((0, $gYl44.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $kalUR.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $7774a90c26a507fe$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $bFy9z.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $7774a90c26a507fe$var$getOptions();
        if ((0, $f9o3h.getClient)() !== client || (0, $fk3cO.shouldIgnoreOnError)()) return;
        const error = $7774a90c26a507fe$var$_getUnhandledRejectionError(e);
        const event = (0, $cLB1r.isPrimitive)(error) ? $7774a90c26a507fe$var$_eventFromRejectionWithPrimitive(error) : (0, $gYl44.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $kalUR.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $7774a90c26a507fe$var$_getUnhandledRejectionError(error) {
    if ((0, $cLB1r.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $7774a90c26a507fe$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $7774a90c26a507fe$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $cLB1r.isString)(url) && url.length > 0 ? url : (0, $60eF2.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $lIM1p.UNKNOWN_FUNCTION),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $7774a90c26a507fe$var$globalHandlerLog(type) {
    (0, $jUFcW.DEBUG_BUILD) && (0, $lx6FZ.logger).log(`Global Handler attached: ${type}`);
}
function $7774a90c26a507fe$var$getOptions() {
    const client = (0, $f9o3h.getClient)();
    const options = (client === null || client === void 0 ? void 0 : client.getOptions()) || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("9nCe6", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $6d43ea07c9f8a378$export$55b5c3ba2194f0c6; });

var $5IYBx = parcelRequire("5IYBx");

var $hT1BD = parcelRequire("hT1BD");
let $6d43ea07c9f8a378$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6d43ea07c9f8a378$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $6d43ea07c9f8a378$var$instrumentError);
}
function $6d43ea07c9f8a378$var$instrumentError() {
    $6d43ea07c9f8a378$var$_oldOnErrorHandler = (0, $5IYBx.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $5IYBx.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $hT1BD.triggerHandlers)('error', handlerData);
        if ($6d43ea07c9f8a378$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $6d43ea07c9f8a378$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $5IYBx.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("bFy9z", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $87ee042c6198f6f9$export$8bf4fc6858821a4e; });

var $5IYBx = parcelRequire("5IYBx");

var $hT1BD = parcelRequire("hT1BD");
let $87ee042c6198f6f9$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $87ee042c6198f6f9$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $hT1BD.addHandler)(type, handler);
    (0, $hT1BD.maybeInstrument)(type, $87ee042c6198f6f9$var$instrumentUnhandledRejection);
}
function $87ee042c6198f6f9$var$instrumentUnhandledRejection() {
    $87ee042c6198f6f9$var$_oldOnUnhandledRejectionHandler = (0, $5IYBx.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $5IYBx.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $hT1BD.triggerHandlers)('unhandledrejection', handlerData);
        if ($87ee042c6198f6f9$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $87ee042c6198f6f9$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $5IYBx.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("g1uQi", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $baa4a9ff4a6a31d9$export$1378794447170364; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $k2IYY = parcelRequire("k2IYY");

var $fk3cO = parcelRequire("fk3cO");
/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $baa4a9ff4a6a31d9$export$1378794447170364 = (0, $k2IYY.defineIntegration)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            var _event_request;
            // if none of the information we want exists, don't bother
            if (!(0, $fk3cO.WINDOW).navigator && !(0, $fk3cO.WINDOW).location && !(0, $fk3cO.WINDOW).document) return;
            const reqData = (0, $fk3cO.getHttpRequestData)();
            const headers = (0, $ty6PY._)({}, reqData.headers, (_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.headers);
            event.request = (0, $6EnDC._)((0, $ty6PY._)({}, reqData, event.request), {
                headers: headers
            });
        }
    };
});

});

parcelRegister("7sLCW", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $56f017a8543b4613$export$ebabb00eb7f3a395; });

var $iilVT = parcelRequire("iilVT");
var $k2IYY = parcelRequire("k2IYY");

var $gYl44 = parcelRequire("gYl44");
const $56f017a8543b4613$var$DEFAULT_KEY = 'cause';
const $56f017a8543b4613$var$DEFAULT_LIMIT = 5;
const $56f017a8543b4613$var$INTEGRATION_NAME = 'LinkedErrors';
const $56f017a8543b4613$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $56f017a8543b4613$var$DEFAULT_LIMIT;
    const key = options.key || $56f017a8543b4613$var$DEFAULT_KEY;
    return {
        name: $56f017a8543b4613$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $iilVT.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $gYl44.exceptionFromError), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $56f017a8543b4613$export$ebabb00eb7f3a395 = (0, $k2IYY.defineIntegration)($56f017a8543b4613$var$_linkedErrorsIntegration);

});
parcelRegister("iilVT", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $d51aebd24bdca75e$export$b91c38ed7d8ae9b2; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $cLB1r = parcelRequire("cLB1r");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $d51aebd24bdca75e$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    var _event_exception;
    if (!((_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : _event_exception.values) || !hint || !(0, $cLB1r.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $d51aebd24bdca75e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $d51aebd24bdca75e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $cLB1r.isInstanceOf)(error[key], Error)) {
        $d51aebd24bdca75e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $d51aebd24bdca75e$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $d51aebd24bdca75e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $cLB1r.isInstanceOf)(childError, Error)) {
            $d51aebd24bdca75e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $d51aebd24bdca75e$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $d51aebd24bdca75e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $d51aebd24bdca75e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $6EnDC._)((0, $ty6PY._)({}, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function $d51aebd24bdca75e$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, $6EnDC._)((0, $ty6PY._)({}, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}

});


parcelRegister("5DYYW", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $41bfe608a8962599$export$2b2b997d81bf3907; });

var $lIM1p = parcelRequire("lIM1p");
const $41bfe608a8962599$var$OPERA10_PRIORITY = 10;
const $41bfe608a8962599$var$OPERA11_PRIORITY = 20;
const $41bfe608a8962599$var$CHROME_PRIORITY = 30;
const $41bfe608a8962599$var$WINJS_PRIORITY = 40;
const $41bfe608a8962599$var$GECKO_PRIORITY = 50;
function $41bfe608a8962599$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $lIM1p.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $41bfe608a8962599$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $41bfe608a8962599$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $41bfe608a8962599$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $41bfe608a8962599$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $41bfe608a8962599$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $41bfe608a8962599$var$createFrame(filename, (0, $lIM1p.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $41bfe608a8962599$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $41bfe608a8962599$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $41bfe608a8962599$var$extractSafariExtensionDetails(parts[1] || (0, $lIM1p.UNKNOWN_FUNCTION), parts[2]);
        return $41bfe608a8962599$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $41bfe608a8962599$export$263a749fff749872 = [
    $41bfe608a8962599$var$CHROME_PRIORITY,
    $41bfe608a8962599$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $41bfe608a8962599$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $41bfe608a8962599$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $41bfe608a8962599$var$gecko = (line)=>{
    const parts = $41bfe608a8962599$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $41bfe608a8962599$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $lIM1p.UNKNOWN_FUNCTION);
        [func, filename] = $41bfe608a8962599$var$extractSafariExtensionDetails(func, filename);
        return $41bfe608a8962599$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $41bfe608a8962599$export$cdba47a5dd2804d = [
    $41bfe608a8962599$var$GECKO_PRIORITY,
    $41bfe608a8962599$var$gecko
];
const $41bfe608a8962599$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $41bfe608a8962599$var$winjs = (line)=>{
    const parts = $41bfe608a8962599$var$winjsRegex.exec(line);
    return parts ? $41bfe608a8962599$var$createFrame(parts[2], parts[1] || (0, $lIM1p.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $41bfe608a8962599$export$179460296da408e8 = [
    $41bfe608a8962599$var$WINJS_PRIORITY,
    $41bfe608a8962599$var$winjs
];
const $41bfe608a8962599$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $41bfe608a8962599$var$opera10 = (line)=>{
    const parts = $41bfe608a8962599$var$opera10Regex.exec(line);
    return parts ? $41bfe608a8962599$var$createFrame(parts[2], parts[3] || (0, $lIM1p.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $41bfe608a8962599$export$f892b52c880ffc7a = [
    $41bfe608a8962599$var$OPERA10_PRIORITY,
    $41bfe608a8962599$var$opera10
];
const $41bfe608a8962599$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $41bfe608a8962599$var$opera11 = (line)=>{
    const parts = $41bfe608a8962599$var$opera11Regex.exec(line);
    return parts ? $41bfe608a8962599$var$createFrame(parts[5], parts[3] || parts[4] || (0, $lIM1p.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $41bfe608a8962599$export$af11af13f09fb0dc = [
    $41bfe608a8962599$var$OPERA11_PRIORITY,
    $41bfe608a8962599$var$opera11
];
const $41bfe608a8962599$export$7197c0fe6554c079 = [
    $41bfe608a8962599$export$263a749fff749872,
    $41bfe608a8962599$export$cdba47a5dd2804d
];
const $41bfe608a8962599$export$2b2b997d81bf3907 = (0, $lIM1p.createStackParser)(...$41bfe608a8962599$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $41bfe608a8962599$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $lIM1p.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("5VhSJ", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $4500259635afc57a$export$b2311068c46d7cc8; });

var $ty6PY = parcelRequire("ty6PY");

var $d9Eri = parcelRequire("d9Eri");
var $djSZL = parcelRequire("djSZL");

var $jl9BR = parcelRequire("jl9BR");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $4500259635afc57a$export$b2311068c46d7cc8(options, nativeFetch = (0, $jl9BR.getNativeImplementation)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = (0, $ty6PY._)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        if (!nativeFetch) {
            (0, $jl9BR.clearCachedImplementation)('fetch');
            return (0, $djSZL.rejectedSyncPromise)('No fetch implementation available');
        }
        try {
            // Note: We do not need to suppress tracing here, becasue we are using the native fetch, instead of our wrapped one.
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $jl9BR.clearCachedImplementation)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $djSZL.rejectedSyncPromise)(e);
        }
    }
    return (0, $d9Eri.createTransport)(options, makeRequest);
}

});
parcelRegister("d9Eri", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $993b7c07bcfe3fe9$export$d09f50d9ab7f7b69; });

var $gy8v9 = parcelRequire("gy8v9");

var $iMdSf = parcelRequire("iMdSf");

var $lx6FZ = parcelRequire("lx6FZ");

var $e27UI = parcelRequire("e27UI");

var $aAAGC = parcelRequire("aAAGC");

var $djSZL = parcelRequire("djSZL");
const $993b7c07bcfe3fe9$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $993b7c07bcfe3fe9$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $e27UI.makePromiseBuffer)(options.bufferSize || $993b7c07bcfe3fe9$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $iMdSf.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $iMdSf.envelopeItemTypeToDataCategory)(type);
            if ((0, $aAAGC.isRateLimited)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $djSZL.resolvedSyncPromise)({});
        const filteredEnvelope = (0, $iMdSf.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $iMdSf.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $iMdSf.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $iMdSf.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $aAAGC.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $e27UI.SENTRY_BUFFER_FULL_ERROR)) {
                (0, $gy8v9.DEBUG_BUILD) && (0, $lx6FZ.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $djSZL.resolvedSyncPromise)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}

});
parcelRegister("e27UI", function(module, exports) {

$parcel$export(module.exports, "SENTRY_BUFFER_FULL_ERROR", function () { return $a377641816db4ff9$export$c8667f1887a128dc; });
$parcel$export(module.exports, "makePromiseBuffer", function () { return $a377641816db4ff9$export$85a4f67f852183e6; });

var $djSZL = parcelRequire("djSZL");
const $a377641816db4ff9$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $a377641816db4ff9$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $djSZL.rejectedSyncPromise)($a377641816db4ff9$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $djSZL.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $djSZL.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});

parcelRegister("aAAGC", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $7b59b95037843efc$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $7b59b95037843efc$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var $ty6PY = parcelRequire("ty6PY");
const $7b59b95037843efc$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $7b59b95037843efc$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $7b59b95037843efc$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $7b59b95037843efc$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $7b59b95037843efc$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $7b59b95037843efc$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $7b59b95037843efc$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = (0, $ty6PY._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers === null || headers === void 0 ? void 0 : headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers === null || headers === void 0 ? void 0 : headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $7b59b95037843efc$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});


parcelRegister("jl9BR", function(module, exports) {

$parcel$export(module.exports, "getNativeImplementation", function () { return $e1476ebef837a88b$export$e464f4a514ac28a8; });
$parcel$export(module.exports, "clearCachedImplementation", function () { return $e1476ebef837a88b$export$8aa36702e8c8978; });

var $gOwaU = parcelRequire("gOwaU");
var $lx6FZ = parcelRequire("lx6FZ");

var $4Sunu = parcelRequire("4Sunu");

var $kQsBc = parcelRequire("kQsBc");
/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $e1476ebef837a88b$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $e1476ebef837a88b$export$e464f4a514ac28a8(name) {
    const cached = $e1476ebef837a88b$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $kQsBc.WINDOW)[name];
    // Fast path to avoid DOM I/O
    if ((0, $gOwaU.isNativeFunction)(impl)) return $e1476ebef837a88b$var$cachedImplementations[name] = impl.bind((0, $kQsBc.WINDOW));
    const document = (0, $kQsBc.WINDOW).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $4Sunu.DEBUG_BUILD) && (0, $lx6FZ.logger).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $e1476ebef837a88b$var$cachedImplementations[name] = impl.bind((0, $kQsBc.WINDOW));
}
/** Clear a cached implementation. */ function $e1476ebef837a88b$export$8aa36702e8c8978(name) {
    $e1476ebef837a88b$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $e1476ebef837a88b$export$e7aa7bc5c1b3cfb3(...rest) {
    return $e1476ebef837a88b$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $e1476ebef837a88b$export$831dc9f2ab0a617b(...rest) {
    return $e1476ebef837a88b$export$e464f4a514ac28a8('setTimeout')(...rest);
}

});
parcelRegister("4Sunu", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $38d3c4fcbbf52487$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $38d3c4fcbbf52487$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});



parcelRegister("XJEDo", function(module, exports) {

$parcel$export(module.exports, "checkAndWarnIfIsEmbeddedBrowserExtension", function () { return $0b38ecd08c250acc$export$dc236a86065879fc; });

var $lx6FZ = parcelRequire("lx6FZ");
var $60eF2 = parcelRequire("60eF2");

var $jUFcW = parcelRequire("jUFcW");

var $fk3cO = parcelRequire("fk3cO");
/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $0b38ecd08c250acc$export$dc236a86065879fc() {
    if ($0b38ecd08c250acc$var$_isEmbeddedBrowserExtension()) {
        if (0, $jUFcW.DEBUG_BUILD) (0, $lx6FZ.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $0b38ecd08c250acc$var$_isEmbeddedBrowserExtension() {
    var _extensionObject_runtime;
    if (typeof (0, $fk3cO.WINDOW).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $fk3cO.WINDOW);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!(extensionObject === null || extensionObject === void 0 ? void 0 : (_extensionObject_runtime = extensionObject.runtime) === null || _extensionObject_runtime === void 0 ? void 0 : _extensionObject_runtime.id)) return false;
    const href = (0, $60eF2.getLocationHref)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $fk3cO.WINDOW) === (0, $fk3cO.WINDOW).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}

});



parcelRegister("day6I", function(module, exports) {

$parcel$export(module.exports, "isOidcDisplayMode", function () { return $d2de09e6652f2e8e$export$62d34b9f4d1e3978; });
$parcel$export(module.exports, "isMobileOidc", function () { return $d2de09e6652f2e8e$export$eb7f7bf9cc131875; });
function $d2de09e6652f2e8e$export$62d34b9f4d1e3978(context, ...display) {
    if (!context || !context.display) return false;
    return display.includes(context.display);
}
function $d2de09e6652f2e8e$export$eb7f7bf9cc131875(context) {
    // currently we assume that any oidc with proper display param is a mobile oidc
    return !!context && !!context.display;
}

});

parcelRegister("fUUus", function(module, exports) {

$parcel$export(module.exports, "inferCapabilitiesFromPathname", function () { return $01b7b2377fb94d60$export$6c4138d23bab6961; });
const $01b7b2377fb94d60$export$6c4138d23bab6961 = (pathname)=>{
    if (pathname.includes('login')) return [
        'capability-group--login'
    ];
    if (pathname.includes('signup')) return [
        'capability-group--signup'
    ];
    if (pathname.includes('logout')) return [
        'capability-group--logout'
    ];
    return [
        'unknown'
    ];
};

});


parcelRegister("gKvjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0325917775c78225$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $4cW1f = parcelRequire("4cW1f");

var $4l8no = parcelRequire("4l8no");

var $hYg0S = parcelRequire("hYg0S");

var $e3fMT = parcelRequire("e3fMT");

var $bpuBL = parcelRequire("bpuBL");

var $k1dMP = parcelRequire("k1dMP");

var $bhY6y = parcelRequire("bhY6y");

var $arXeP = parcelRequire("arXeP");

var $df3ME = parcelRequire("df3ME");

var $eh37k = parcelRequire("eh37k");

var $2vX01 = parcelRequire("2vX01");

var $gErWv = parcelRequire("gErWv");

var $ce60p = parcelRequire("ce60p");

var $dtn8z = parcelRequire("dtn8z");

var $dRf7A = parcelRequire("dRf7A");

var $5E2Q9 = parcelRequire("5E2Q9");

var $6QXdB = parcelRequire("6QXdB");

var $ctYUa = parcelRequire("ctYUa");

var $fBSnV = parcelRequire("fBSnV");
function $0325917775c78225$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0325917775c78225$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0325917775c78225$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0325917775c78225$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $0325917775c78225$export$5df9262e102d0c32 = '/gateway/api/gasv3/api/v1';
const $0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY = 'last.screen.event';
class $0325917775c78225$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug('Event(s) submitted to GASv3');
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Validation report for event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info('GASv3 submission failed with HTTP Status Code %d: %s', response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug('Event with message ID %s:\n', eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $0325917775c78225$export$2e2bcd8739ae039 {
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createSubproductGetter", (subproduct)=>(0, $hYg0S.default)(subproduct, 'Cannot get subproduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $hYg0S.default)(embeddedProduct, 'Cannot get embeddedProduct from the callback. Proceeding without it.'));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY) || '');
            } catch (err) {
                this._safeSessionStorage.removeItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf('measurement') === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $4cW1f.eventType).UI:
                case (0, $4cW1f.eventType).OPERATIONAL:
                case (0, $4cW1f.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $4cW1f.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $4cW1f.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    'sentWithDelay'
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== 'undefined') this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: 'landed',
                actionSubject: 'origin',
                source: 'webClient',
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error('Missing tenantIdType');
            if (tenantIdType !== (0, $4cW1f.tenantType).NONE && !tenantId) throw new Error('Missing tenantId');
            if (!(0, $4cW1f.isType)((0, $4cW1f.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $4cW1f.objectValues)((0, $4cW1f.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error('Missing orgId');
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error('Missing workspaceId');
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $k1dMP.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error('Missing aliasType');
            if (!(0, $4cW1f.isType)((0, $4cW1f.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $4cW1f.objectValues)((0, $4cW1f.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error('Missing groupType');
            if (!(0, $4cW1f.isType)((0, $4cW1f.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $4cW1f.objectValues)((0, $4cW1f.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error('Missing uiViewedAttributes');
            if (typeof uiViewedAttributes !== 'object' || Array.isArray(uiViewedAttributes)) throw new Error('Invalid uiViewedAttributes type, should be a non array object');
            this._uiViewedAttributes = $0325917775c78225$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $4cW1f.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === 'object') {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $k1dMP.validateScreenEvent)(screenName);
            (0, $k1dMP.validateContainers)(screenContainers);
            const builtEvent = (0, $e3fMT.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $0325917775c78225$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $ctYUa.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $k1dMP.validateTrackEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendUIEvent", (event, callback)=>{
            (0, $k1dMP.validateUIEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $k1dMP.validateOperationalEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $5E2Q9.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error('Missing analyticsData');
            if (!analyticsData.eventType) throw new Error('Missing analyticsData.eventType');
            if (analyticsData.eventType === (0, $4cW1f.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $4cW1f.objectValues)((0, $4cW1f.eventType))}]`);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.env) throw new Error('Missing productInfo.env');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!(0, $4cW1f.isType)((0, $4cW1f.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $4cW1f.objectValues)((0, $4cW1f.envType))}]`);
        if (productInfo.perimeter && !(0, $4cW1f.isType)((0, $4cW1f.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $4cW1f.objectValues)((0, $4cW1f.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $4cW1f.originType).WEB;
        else if (!(0, $4cW1f.isType)((0, $4cW1f.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $4cW1f.objectValues)((0, $4cW1f.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $4cW1f.originType).WEB ? (0, $4cW1f.platformType).WEB : (0, $4cW1f.platformType).DESKTOP;
        else (0, $k1dMP.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $0325917775c78225$var$_objectSpread($0325917775c78225$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $e3fMT.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $gErWv.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $eh37k.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || 'https';
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $fBSnV.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $bhY6y.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $0325917775c78225$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $df3ME.default)();
        this._tabTracking = new (0, $ce60p.default)();
        this._sessionTracking = new (0, $2vX01.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $dtn8z.default)();
        this.originTracing = new (0, $arXeP.default)();
        // Init Apdex
        this._apdexEvent = new (0, $4l8no.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === 'function' ? settings.historyReplaceFn : (0, $6QXdB.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $bpuBL.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $dRf7A.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("gaCcd", function(module, exports) {

var $9mvsX = parcelRequire("9mvsX");

var $diJJr = parcelRequire("diJJr");
function $bc5b3573e5269f31$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $9mvsX)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $diJJr(rnds);
}
module.exports = $bc5b3573e5269f31$var$v4;

});
parcelRegister("9mvsX", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $6d0e939c6bd928d4$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($6d0e939c6bd928d4$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $6d0e939c6bd928d4$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $6d0e939c6bd928d4$var$getRandomValues($6d0e939c6bd928d4$var$rnds8);
        return $6d0e939c6bd928d4$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $6d0e939c6bd928d4$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $6d0e939c6bd928d4$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $6d0e939c6bd928d4$var$rnds;
    };
}

});

parcelRegister("diJJr", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9af06e33de1a996d$var$byteToHex = [];
for(var $9af06e33de1a996d$var$i = 0; $9af06e33de1a996d$var$i < 256; ++$9af06e33de1a996d$var$i)$9af06e33de1a996d$var$byteToHex[$9af06e33de1a996d$var$i] = ($9af06e33de1a996d$var$i + 0x100).toString(16).substr(1);
function $9af06e33de1a996d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $9af06e33de1a996d$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $9af06e33de1a996d$var$bytesToUuid;

});


parcelRegister("4cW1f", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $310549d3c4ba6d2c$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $310549d3c4ba6d2c$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $310549d3c4ba6d2c$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $310549d3c4ba6d2c$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $310549d3c4ba6d2c$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $310549d3c4ba6d2c$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $310549d3c4ba6d2c$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $310549d3c4ba6d2c$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $310549d3c4ba6d2c$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $310549d3c4ba6d2c$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $310549d3c4ba6d2c$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $310549d3c4ba6d2c$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $310549d3c4ba6d2c$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $310549d3c4ba6d2c$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $310549d3c4ba6d2c$export$e73680b18d9b7c6e; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $310549d3c4ba6d2c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $310549d3c4ba6d2c$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $310549d3c4ba6d2c$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $310549d3c4ba6d2c$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $310549d3c4ba6d2c$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $310549d3c4ba6d2c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $310549d3c4ba6d2c$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $310549d3c4ba6d2c$export$809831be6c4c6227 = Object.freeze([
    $310549d3c4ba6d2c$export$6b4f396210e539f3.DESKTOP,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.MAC,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.LINUX,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.WINDOWS
]);
const $310549d3c4ba6d2c$export$19c579398ad213e7 = Object.freeze([
    $310549d3c4ba6d2c$export$6b4f396210e539f3.WEB,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.MOBILE_WEB
]);
let $310549d3c4ba6d2c$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $310549d3c4ba6d2c$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $310549d3c4ba6d2c$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $310549d3c4ba6d2c$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $310549d3c4ba6d2c$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $310549d3c4ba6d2c$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $310549d3c4ba6d2c$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("4l8no", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328f9ef61eb8ca89$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $df3ME = parcelRequire("df3ME");

var $l9txO = parcelRequire("l9txO");
function $328f9ef61eb8ca89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $328f9ef61eb8ca89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $328f9ef61eb8ca89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $328f9ef61eb8ca89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $328f9ef61eb8ca89$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $4cW1f.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $4cW1f.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $4cW1f.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== 'string') throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== 'string') throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $4cW1f.isType)((0, $4cW1f.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== 'number') throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $4cW1f.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === 'number' && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== 'number') throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== 'number') return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: 'ui',
                action: 'readyForUser',
                actionSubject: 'ui',
                attributes: $328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        if (!(pageVisibility instanceof (0, $df3ME.default))) throw new Error('Invalid pageVisibility, must be PageVisibility class');
        this._startedEvents = new Map();
        this._performance = new (0, $l9txO.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback('apdexEvent', (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("df3ME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027ce59ebd9a7a07$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");
class $027ce59ebd9a7a07$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== 'undefined') {
            if (typeof document.hidden !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = 'hidden';
                this._visibilityChange = 'visibilitychange';
            } else if (typeof document.msHidden !== 'undefined') {
                this._isHidden = document.msHidden;
                this._hidden = 'msHidden';
                this._visibilityChange = 'msvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                this._isHidden = document.webkitHidden;
                this._hidden = 'webkitHidden';
                this._visibilityChange = 'webkitvisibilitychange';
            }
            if (typeof document.addEventListener !== 'undefined' && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("l9txO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6615b1d27239a48$export$2e2bcd8739ae039; });
class $f6615b1d27239a48$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = window.performance;
    }
}

});


parcelRegister("hYg0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1547622e874d526$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $d1547622e874d526$var$isFunction = (possibleFn)=>typeof possibleFn === 'function';
var $d1547622e874d526$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($d1547622e874d526$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("e3fMT", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $a3ad9798af913352$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $a3ad9798af913352$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $a3ad9798af913352$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $a3ad9798af913352$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $a3ad9798af913352$export$7bf451af4a8e3dd9; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $ixNt4 = parcelRequire("ixNt4");
function $a3ad9798af913352$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3ad9798af913352$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3ad9798af913352$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3ad9798af913352$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a3ad9798af913352$var$libraryVersion = "4.27.1";
function $a3ad9798af913352$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $a3ad9798af913352$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $a3ad9798af913352$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $a3ad9798af913352$var$buildAliases(aliases) {
    if ($a3ad9798af913352$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $a3ad9798af913352$var$buildGroups(groups) {
    if ($a3ad9798af913352$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $a3ad9798af913352$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $a3ad9798af913352$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $a3ad9798af913352$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $a3ad9798af913352$var$getProductField(productInfo.env, overrides.env);
    const product = $a3ad9798af913352$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $a3ad9798af913352$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $a3ad9798af913352$var$getProductField(productInfo.version, overrides.version);
    const origin = $a3ad9798af913352$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $a3ad9798af913352$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a3ad9798af913352$var$isNotEmptyObject(obj) {
    return (0, $ixNt4.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $a3ad9798af913352$var$buildAttributesWithName(name, attrObject) {
    return $a3ad9798af913352$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $a3ad9798af913352$var$buildAttributes(attributes) {
    return $a3ad9798af913352$var$buildAttributesWithName('attributes', attributes);
}
function $a3ad9798af913352$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $a3ad9798af913352$export$f045f238d77c002a(containers) {
    if ($a3ad9798af913352$var$isNotEmptyObject(containers)) {
        const validContainers = $a3ad9798af913352$export$3f5115a568819c1a(containers);
        return $a3ad9798af913352$var$buildAttributesWithName('containers', validContainers);
    }
    return undefined;
}
function $a3ad9798af913352$export$655ecf7241feac42(event, actionEventType) {
    return $a3ad9798af913352$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $a3ad9798af913352$export$f045f238d77c002a(event.containers));
}
function $a3ad9798af913352$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $a3ad9798af913352$var$buildAttributesWithName('nonPrivacySafeAttributes', nonPrivacySafeAttributes);
}
function $a3ad9798af913352$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $a3ad9798af913352$var$buildProductFields(productInfo);
    const tenantFields = $a3ad9798af913352$var$buildTenantFields(tenantInfo);
    const userFields = $a3ad9798af913352$var$buildUserFields(userInfo);
    const orgFields = $a3ad9798af913352$var$buildOrgFields(orgInfo);
    const workspaceFields = $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: '',
        path: '',
        url: '',
        referrer: '',
        search: '',
        eventType: (0, $4cW1f.eventType).SCREEN
    };
    return $a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $a3ad9798af913352$var$buildAttributes(attributes)), $a3ad9798af913352$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $a3ad9798af913352$export$f045f238d77c002a(containers)), $a3ad9798af913352$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a3ad9798af913352$var$buildAliases(aliases)), $a3ad9798af913352$var$buildGroups(groups));
}
function $a3ad9798af913352$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $a3ad9798af913352$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $a3ad9798af913352$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $a3ad9798af913352$export$fbd92247fb4d6159.QUIET;
    if (environment.includes('prod')) return $a3ad9798af913352$export$fbd92247fb4d6159.QUIET;
    return $a3ad9798af913352$export$fbd92247fb4d6159.COMPLETE;
}
function $a3ad9798af913352$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: 'analytics.js',
                version: $a3ad9798af913352$var$libraryVersion
            },
            validationMode: $a3ad9798af913352$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $a3ad9798af913352$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a3ad9798af913352$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $a3ad9798af913352$var$buildProductFields(productInfo, $a3ad9798af913352$export$e3d99b4bfec06f6e(event));
    const tenantFields = $a3ad9798af913352$var$buildTenantFields(tenantInfo);
    const orgFields = $a3ad9798af913352$var$buildOrgFields(orgInfo);
    const workspaceFields = $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $a3ad9798af913352$var$buildUserFields(userInfo);
    const actionFields = $a3ad9798af913352$export$655ecf7241feac42(event, actionEventType);
    return $a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $a3ad9798af913352$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a3ad9798af913352$var$buildAliases(aliases)), $a3ad9798af913352$var$buildGroups(groups));
}

});
parcelRegister("ixNt4", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $d801ae5590779e5d$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $d801ae5590779e5d$var$isObject(val) {
    return val !== null && typeof val === 'object' && Array.isArray(val) === false;
}
function $d801ae5590779e5d$var$isObjectObject(o) {
    return $d801ae5590779e5d$var$isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
function $d801ae5590779e5d$export$53b83ca8eaab0383(o) {
    if ($d801ae5590779e5d$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($d801ae5590779e5d$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!('isPrototypeOf' in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("bpuBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e9c5a3bcd544fd$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $cquUO = parcelRequire("cquUO");

var $d5qix = parcelRequire("d5qix");

var $hgxKq = parcelRequire("hgxKq");
class $84e9c5a3bcd544fd$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startLowPriorityEventDelay", (timeout = (0, $cquUO.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $cquUO.MAX_DELAY_TIMEOUT)) : (0, $cquUO.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $hgxKq.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopLowPriorityEventDelay", (reason = (0, $hgxKq.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $d5qix.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("cquUO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $90bfe4dd5119da5e$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $90bfe4dd5119da5e$export$8575e30be0feb909; });
const $90bfe4dd5119da5e$export$cf090d5281b5ae06 = 10000;
const $90bfe4dd5119da5e$export$8575e30be0feb909 = 30000;

});

parcelRegister("d5qix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987024340dca7573$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $e3fMT = parcelRequire("e3fMT");

var $dbpk1 = parcelRequire("dbpk1");

var $6BF99 = parcelRequire("6BF99");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $987024340dca7573$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $987024340dca7573$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $987024340dca7573$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn('Failed to perform compression on the delayed analytics events. ' + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $987024340dca7573$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $987024340dca7573$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $dbpk1.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $dbpk1.equals)(group.userInfo, args.userInfo) && (0, $dbpk1.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $e3fMT.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $6BF99.default)(compressionRules);
    }
}

});
parcelRegister("dbpk1", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $998ff1dd287e0bb2$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $998ff1dd287e0bb2$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $998ff1dd287e0bb2$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $998ff1dd287e0bb2$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $998ff1dd287e0bb2$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $998ff1dd287e0bb2$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $998ff1dd287e0bb2$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $998ff1dd287e0bb2$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $998ff1dd287e0bb2$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $998ff1dd287e0bb2$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $998ff1dd287e0bb2$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $998ff1dd287e0bb2$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $998ff1dd287e0bb2$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== 'object' && typeof b !== 'object') return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$998ff1dd287e0bb2$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $998ff1dd287e0bb2$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("6BF99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf61da61b37289a$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $e3fMT = parcelRequire("e3fMT");

var $dbpk1 = parcelRequire("dbpk1");

var $eJEam = parcelRequire("eJEam");
function $4cf61da61b37289a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cf61da61b37289a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cf61da61b37289a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cf61da61b37289a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4cf61da61b37289a$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $e3fMT.buildActionFields)(event, event.eventType);
                    contextFields = (0, $dbpk1.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $dbpk1.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$4cf61da61b37289a$var$_objectSpread($4cf61da61b37289a$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn('Failed to compress some analytics events. ' + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error('Event compressors must be constructed with an array of CompressionRules');
        if (!compressionRules.every((rule)=>rule instanceof (0, $eJEam.CompressionRule))) throw new Error('Event compressors can only be constructed with instances of CompressionRule');
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("eJEam", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $aba46cca50b1b2e4$export$89b3253ddfd2e6e8; });

var $6bkHe = parcelRequire("6bkHe");

var $k1dMP = parcelRequire("k1dMP");

var $dbpk1 = parcelRequire("dbpk1");
class $aba46cca50b1b2e4$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $k1dMP.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $dbpk1.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error('No events were returned from the compression function');
            compressedEvents.forEach((event)=>{
                (0, $k1dMP.validateActionEventType)(event.eventType);
                (0, $k1dMP.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== 'function') throw new Error('Invalid predicate, must be a function that accepts an event and returns a boolean');
        if (typeof compressFn !== 'function') throw new Error('Invalid compressFn, must be a function that both accepts and returns an array of events');
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("k1dMP", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $e92e985ceb13a2f5$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $e92e985ceb13a2f5$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $e92e985ceb13a2f5$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $e92e985ceb13a2f5$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $e92e985ceb13a2f5$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $e92e985ceb13a2f5$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $e92e985ceb13a2f5$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $e92e985ceb13a2f5$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $e92e985ceb13a2f5$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $e92e985ceb13a2f5$export$801b46c35394d316; });

var $4cW1f = parcelRequire("4cW1f");

var $ixNt4 = parcelRequire("ixNt4");
const $e92e985ceb13a2f5$var$actionEventTypes = Object.freeze([
    (0, $4cW1f.eventType).OPERATIONAL,
    (0, $4cW1f.eventType).TRACK,
    (0, $4cW1f.eventType).UI
]);
function $e92e985ceb13a2f5$export$df8ff30e3c960006(container) {
    if (!(0, $ixNt4.isPlainObject)(container)) throw new Error('properties.containers must be an Object');
    if (!('id' in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== 'string') throw new Error('properties.containers.id must be of type String');
    if ('type' in container && typeof container.type !== 'string') throw new Error('properties.containers.type must be of type String');
}
function $e92e985ceb13a2f5$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error('properties.containers must be an Object');
    Object.values(containers).forEach((container)=>$e92e985ceb13a2f5$export$df8ff30e3c960006(container));
}
function $e92e985ceb13a2f5$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $4cW1f.eventType).OPERATIONAL:
        case (0, $4cW1f.eventType).TRACK:
        case (0, $4cW1f.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $e92e985ceb13a2f5$export$4a8d7476662aebcc(type) {
    if (!$e92e985ceb13a2f5$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$e92e985ceb13a2f5$var$actionEventTypes}]`);
    return true;
}
function $e92e985ceb13a2f5$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
    if (!event.action) throw new Error('Missing event.action');
    $e92e985ceb13a2f5$export$e63ea5d8477971d3(event.containers);
}
function $e92e985ceb13a2f5$export$dc993432a592dc27(name) {
    if (!name) throw new Error('Missing name');
}
function $e92e985ceb13a2f5$export$8c014fd74b0c8b99(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$39d6334da9a44984(event) {
    if (!event) throw new Error('Missing event');
    if (!event.source) throw new Error('Missing event.source');
    if (!event.actionSubject) throw new Error('Missing event.actionSubject');
}
function $e92e985ceb13a2f5$export$e5bac0930c812e90(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$1e561554275607ef(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error('Missing userIdType');
    if (!userId) throw new Error('Missing userId');
    if (!(0, $4cW1f.isType)((0, $4cW1f.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $4cW1f.objectValues)((0, $4cW1f.userType))}]`);
}
function $e92e985ceb13a2f5$export$801b46c35394d316(productInfo) {
    if (!(0, $4cW1f.isType)((0, $4cW1f.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $4cW1f.objectValues)((0, $4cW1f.platformType))}]`);
    if (productInfo.origin === (0, $4cW1f.originType).DESKTOP && !(0, $4cW1f.isType)((0, $4cW1f.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + 'must be one of [mac, linux, windows]');
    if (productInfo.origin === (0, $4cW1f.originType).WEB && !(0, $4cW1f.isType)((0, $4cW1f.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("hgxKq", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $c91e1bea4a01ea64$export$fa6e3729c21cb8f; });
let $c91e1bea4a01ea64$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("bhY6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $837fe7c84ea3bd0a$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $iqSwv = parcelRequire("iqSwv");

var $elE98 = parcelRequire("elE98");

var $gINol = parcelRequire("gINol");

var $3q4zO = parcelRequire("3q4zO");

var $8qpim = parcelRequire("8qpim");

var $bEXZy = parcelRequire("bEXZy");

var $hng8D = parcelRequire("hng8D");

var $ePQx8 = parcelRequire("ePQx8");

var $jV8Tw = parcelRequire("jV8Tw");
function $837fe7c84ea3bd0a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $837fe7c84ea3bd0a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $837fe7c84ea3bd0a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $837fe7c84ea3bd0a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $837fe7c84ea3bd0a$var$AnalyticsAPIResponse {
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
}
class $837fe7c84ea3bd0a$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $837fe7c84ea3bd0a$var$EventValidationReport {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
}
class $837fe7c84ea3bd0a$export$133650fcdde1b226 {
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
}
class $837fe7c84ea3bd0a$var$EventResponse {
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
}
class $837fe7c84ea3bd0a$var$EventValidationResult {
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
}
class $837fe7c84ea3bd0a$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).TRACK,
            properties: (0, $jV8Tw.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).PAGE,
            properties: (0, $jV8Tw.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).IDENTIFY,
            traits: (0, $jV8Tw.prepareEventProperties)(builtEvent)
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $jV8Tw.prepareEventProperties)(context);
        const segmentContext = (0, $jV8Tw.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                'Content-Type': 'text/plain'
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $gINol.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $bEXZy.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $837fe7c84ea3bd0a$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $837fe7c84ea3bd0a$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $3q4zO.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $ePQx8.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $elE98.default)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $iqSwv.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
}
class $837fe7c84ea3bd0a$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $837fe7c84ea3bd0a$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $837fe7c84ea3bd0a$export$133650fcdde1b226(success, statusCode, (0, $8qpim.HTTP_STATUS_CODE_MAP).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $8qpim.HTTP_STATUS_CODE_MAP).has(statusCode) ? (0, $8qpim.HTTP_STATUS_CODE_MAP).get(statusCode) : (0, $8qpim.HTTP_STATUS_CODE_MAP).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $837fe7c84ea3bd0a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $837fe7c84ea3bd0a$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($837fe7c84ea3bd0a$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $837fe7c84ea3bd0a$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $837fe7c84ea3bd0a$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $837fe7c84ea3bd0a$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $837fe7c84ea3bd0a$export$133650fcdde1b226(false, -1, (0, $8qpim.HTTP_STATUS_CODE_MAP).get(-1), eventResponseList);
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($837fe7c84ea3bd0a$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);

});
parcelRegister("iqSwv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b4f2dfe20a7db1$export$2e2bcd8739ae039; });

var $jywt9 = parcelRequire("jywt9");

var $d6b4f2dfe20a7db1$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $jywt9.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("jywt9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3ca61056fb55376$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $hL8CT = parcelRequire("hL8CT");
var $aoj6L = parcelRequire("aoj6L");

var $6DH9M = parcelRequire("6DH9M");
var $9zdCO = parcelRequire("9zdCO");
var $eiDyS = parcelRequire("eiDyS");

var $elE98 = parcelRequire("elE98");

var $oBsJE = parcelRequire("oBsJE");

var $6Znl6 = parcelRequire("6Znl6");
var $1td0A = parcelRequire("1td0A");

var $3aKbs = parcelRequire("3aKbs");
function $e3ca61056fb55376$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3ca61056fb55376$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3ca61056fb55376$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3ca61056fb55376$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e3ca61056fb55376$var$ONE_MINUTE = 60000;
const $e3ca61056fb55376$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $e3ca61056fb55376$var$ONE_MINUTE,
    minRetryDelay: $e3ca61056fb55376$var$ONE_MINUTE,
    maxRetryDelay: $e3ca61056fb55376$var$ONE_MINUTE
};
const $e3ca61056fb55376$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $e3ca61056fb55376$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $eiDyS.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $3aKbs.NetworkStatusEnum).OFFLINE) {
            done((0, $1td0A.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $6DH9M.CallbackProcessingErrorName)) {
                done((0, $1td0A.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $hL8CT.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $aoj6L.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $eiDyS.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: 'successful'
            };
            else return {
                status: 'partial',
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $1td0A.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error('batchFlushCallback has not been set. Call PullBatchableQueue#start first.');
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $1td0A.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $1td0A.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $e3ca61056fb55376$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $e3ca61056fb55376$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $e3ca61056fb55376$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $e3ca61056fb55376$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $e3ca61056fb55376$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $e3ca61056fb55376$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $9zdCO.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $6Znl6.default)($e3ca61056fb55376$var$_objectSpread($e3ca61056fb55376$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $6Znl6.default)($e3ca61056fb55376$var$_objectSpread($e3ca61056fb55376$var$_objectSpread({}, $e3ca61056fb55376$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $e3ca61056fb55376$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $elE98.default)();
        this.networkStatus = new (0, $oBsJE.default)((status)=>{
            if (status === (0, $3aKbs.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("hL8CT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cedd84703b62a442$export$2e2bcd8739ae039; });

var $iTucC = parcelRequire("iTucC");

var $Z6SsK = parcelRequire("Z6SsK");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $cedd84703b62a442$var$validSuffixs = Object.values((0, $iTucC.LocalStorageKeySuffix));
var $cedd84703b62a442$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== 'string' || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split('.')).filter((splitKeys)=>splitKeys.length === 3 && $cedd84703b62a442$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $iTucC.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $Z6SsK.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("iTucC", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $dc14ca9ee2ad94de$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $dc14ca9ee2ad94de$export$8bb2c1fb2b1765a9; });
let $dc14ca9ee2ad94de$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $dc14ca9ee2ad94de$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("Z6SsK", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $0b7b08557aba156e$export$8433d54f767cbec5; });

var $iTucC = parcelRequire("iTucC");
const $0b7b08557aba156e$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $iTucC.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).ACK}`,
        [(0, $iTucC.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).QUEUE}`,
        [(0, $iTucC.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $iTucC.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $iTucC.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("aoj6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790af7bf2c760041$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $iTucC = parcelRequire("iTucC");

var $Z6SsK = parcelRequire("Z6SsK");
function $790af7bf2c760041$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $790af7bf2c760041$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $790af7bf2c760041$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $790af7bf2c760041$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $790af7bf2c760041$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $790af7bf2c760041$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split('.')).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $iTucC.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join('.'));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $iTucC.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $790af7bf2c760041$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $790af7bf2c760041$var$promisedSetTimeout((0, $iTucC.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $iTucC.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimStart.');
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $790af7bf2c760041$var$promisedSetTimeout((0, $iTucC.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $iTucC.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error('Took to long to callback, reclaim abandonded. After reclaimEnd.');
    return $790af7bf2c760041$var$reclaim(options, callback);
};
const $790af7bf2c760041$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || '[]');
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || '{}');
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $790af7bf2c760041$var$_objectSpread($790af7bf2c760041$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === 'successful') $790af7bf2c760041$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === 'partial') {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $790af7bf2c760041$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $790af7bf2c760041$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $790af7bf2c760041$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== 'string' || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
    const queuesToReclaim = $790af7bf2c760041$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$790af7bf2c760041$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $Z6SsK.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === 'rejected');
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === 'fulfilled').map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("6DH9M", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $4d57dc9ec8a8480f$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $4d57dc9ec8a8480f$export$2e2bcd8739ae039; });
const $4d57dc9ec8a8480f$export$a409c8de90e11e14 = 'CallbackProcessingError';
class $4d57dc9ec8a8480f$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === 'object' && 'toString' in error && typeof error.toString === 'function' && error.toString();
        const messageFromString = typeof error === 'string' && error;
        const message = messageFromError || messageFromString || 'Argument passed to CallbackProcessingError was not an Error or string.';
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4d57dc9ec8a8480f$export$2e2bcd8739ae039.prototype);
        this.name = $4d57dc9ec8a8480f$export$a409c8de90e11e14;
    }
}

});

parcelRegister("9zdCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f71f39066bdb532$export$2e2bcd8739ae039; });

var $5hDYj = parcelRequire("5hDYj");

var $eiDyS = parcelRequire("eiDyS");

var $6DH9M = parcelRequire("6DH9M");
var $6f71f39066bdb532$export$2e2bcd8739ae039 = (0, $5hDYj.default);

});
parcelRegister("5hDYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8d8bdd5311ecc5$export$2e2bcd8739ae039; });

var $eiDyS = parcelRequire("eiDyS");

var $1RmJs = parcelRequire("1RmJs");
var $63xVP = parcelRequire("63xVP");

var $19pAq = parcelRequire("19pAq");

var $5gj4Y = parcelRequire("5gj4Y");

var $2vBjM = parcelRequire("2vBjM");
class $3d8d8bdd5311ecc5$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $19pAq.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $1RmJs.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn('Attempted to create IndexedDbResilience but failed. Using memory instead.');
            }
        }
        return new (0, $5gj4Y.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $eiDyS.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $5gj4Y.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $eiDyS.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn('Unexpected error from ResilienceDb, switching to MemoryDb');
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $2vBjM.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== 'string') throw new Error('Invalid namespace provided');
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("eiDyS", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $a6916f3457e73dad$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $a6916f3457e73dad$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $a6916f3457e73dad$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $a6916f3457e73dad$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $a6916f3457e73dad$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $a6916f3457e73dad$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $a6916f3457e73dad$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $a6916f3457e73dad$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $a6916f3457e73dad$export$7710d69e6f450f20; });
const $a6916f3457e73dad$export$d21fbb25eb37b5bf = 'namespace-timeAdded';
const $a6916f3457e73dad$export$8cad224051643259 = 'analytics-web-client';
const $a6916f3457e73dad$export$3d8420be07b276ab = 'analytics-resilience';
const $a6916f3457e73dad$export$a512a65455fce2a6 = 'timeToBeProcessedAfter';
const $a6916f3457e73dad$export$89d9c1ff8ac91862 = 'timeAdded';
const $a6916f3457e73dad$export$a37d385bcd713809 = 'retryAttempts';
const $a6916f3457e73dad$export$6d8635fed0e4b14d = 15000;
let $a6916f3457e73dad$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $a6916f3457e73dad$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("1RmJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ac5fd10b566fa7$export$2e2bcd8739ae039; });
const $15ac5fd10b566fa7$export$fc14cf6dcea0f8ed = 'NoIndexedDbError';
class $15ac5fd10b566fa7$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super('window.indexeddb is undefined.');
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $15ac5fd10b566fa7$export$2e2bcd8739ae039.prototype);
        this.name = $15ac5fd10b566fa7$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("63xVP", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $468d580908194a36$export$74101021e0969375; });

var $3DoBM = parcelRequire("3DoBM");

var $6DH9M = parcelRequire("6DH9M");

var $7Hmy4 = parcelRequire("7Hmy4");
const $468d580908194a36$export$74101021e0969375 = (error)=>{
    if (error && typeof error === 'object' && 'name' in error) {
        const errorWithName = error;
        return typeof errorWithName.name === 'string' && (errorWithName.name === (0, $3DoBM.AbandonWriteErrorName) || errorWithName.name === (0, $6DH9M.CallbackProcessingErrorName) || errorWithName.name === (0, $7Hmy4.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("3DoBM", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $2a581a58cc55b1e9$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $2a581a58cc55b1e9$export$2e2bcd8739ae039; });
const $2a581a58cc55b1e9$export$ba95206613c96b28 = 'AbandonWriteError';
class $2a581a58cc55b1e9$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2a581a58cc55b1e9$export$2e2bcd8739ae039.prototype);
        this.name = $2a581a58cc55b1e9$export$ba95206613c96b28;
    }
}

});

parcelRegister("7Hmy4", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $59ae0a3b0b4a1f8f$export$2e2bcd8739ae039; });
const $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec = 'InvalidPolicyError';
class $59ae0a3b0b4a1f8f$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("19pAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6a7aa2df9331d9$export$2e2bcd8739ae039; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $g4hTj = parcelRequire("g4hTj");

var $6DH9M = parcelRequire("6DH9M");
var $7Hmy4 = parcelRequire("7Hmy4");
var $1RmJs = parcelRequire("1RmJs");
var $63xVP = parcelRequire("63xVP");

var $9woOY = parcelRequire("9woOY");

var $2vBjM = parcelRequire("2vBjM");
const $0d6a7aa2df9331d9$var$_excluded = [
    "item"
], $0d6a7aa2df9331d9$var$_excluded2 = [
    "items"
];
function $0d6a7aa2df9331d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d6a7aa2df9331d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d6a7aa2df9331d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d6a7aa2df9331d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0d6a7aa2df9331d9$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $eiDyS.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== 'undefined') {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn('IndexedDB timed out.');
                        reject(new (0, $1RmJs.default)());
                    }, (0, $eiDyS.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $eiDyS.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error('We cannot upgrade the database. Do not do this.');
                        const db = request.result;
                        const store = db.createObjectStore((0, $eiDyS.RESILIENCE_STORE_NAME), {
                            keyPath: 'id'
                        });
                        store.createIndex((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX), (0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eiDyS.RETRY_INDEX), (0, $eiDyS.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eiDyS.TIME_ADDED_INDEX), (0, $eiDyS.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            'namespace',
                            'timeAdded'
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $1RmJs.default)());
                    };
                    try {
                        await (0, $2vBjM.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn('IndexedDB failed to initialise.', error);
                        reject(new (0, $1RmJs.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $1RmJs.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "addItem", async (item, options = {}, policy = (0, $eiDyS.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $2vBjM.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            if (policy === (0, $eiDyS.GuardPolicy).IGNORE) throw new (0, $7Hmy4.default)(policy, 'IndexedDbConnector#addItem');
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== 'string') throw new Error('Namespace not specified');
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "bulkAddItem", async (itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $0d6a7aa2df9331d9$var$_excluded);
                return (0, $2vBjM.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log('Failed to add item to table', error);
                throw new Error('Request to add item to table failed');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItems", async (count = (0, $g4hTj.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $g4hTj.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            const timeIndex = objectStore.index((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error('Failed to open cursor:', error);
                    reject('Failed to open cursor');
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $0d6a7aa2df9331d9$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $g4hTj.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $2vBjM.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $2vBjM.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $2vBjM.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readwrite');
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $2vBjM.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction('readonly');
            const timeIndex = objectStore.index((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $2vBjM.requestToPromise)(request);
            await (0, $2vBjM.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "processItems", async (processFn, count = (0, $g4hTj.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_await$this$getItems, $0d6a7aa2df9331d9$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $6DH9M.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $2vBjM.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error('Failed to delete item:', id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $eiDyS.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $eiDyS.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $2vBjM.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $1RmJs.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $9woOY.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("g4hTj", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $bb2ae5dd09334ff6$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $bb2ae5dd09334ff6$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $bb2ae5dd09334ff6$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $bb2ae5dd09334ff6$export$1188664dfff364c8; });
const $bb2ae5dd09334ff6$export$b6df3d334cec060f = 7;
const $bb2ae5dd09334ff6$export$14ef152a03a4b6ee = 60000;
const $bb2ae5dd09334ff6$export$da9ab7b2fd5998e8 = 10;
const $bb2ae5dd09334ff6$export$1188664dfff364c8 = 5000;

});

parcelRegister("9woOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eea5b29e858d614$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $3DoBM = parcelRequire("3DoBM");

var $2vBjM = parcelRequire("2vBjM");
class $6eea5b29e858d614$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $eiDyS.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eiDyS.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eiDyS.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $2vBjM.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $2vBjM.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $3DoBM.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $2vBjM.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $2vBjM.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn('Failed to delete items from indexeddb.', error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("2vBjM", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $1d3b6c97cbeab58a$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $1d3b6c97cbeab58a$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $1d3b6c97cbeab58a$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $1d3b6c97cbeab58a$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $1d3b6c97cbeab58a$export$342d941b6f724995; });

var $gaCcd = parcelRequire("gaCcd");

var $g4hTj = parcelRequire("g4hTj");
const $1d3b6c97cbeab58a$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $1d3b6c97cbeab58a$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $g4hTj.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $g4hTj.EVENT_COUNT_LIMIT)
    });
const $1d3b6c97cbeab58a$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $1d3b6c97cbeab58a$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $1d3b6c97cbeab58a$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === 'function') transaction.commit();
    } catch (error) {
        logger.error('Failed to force commit transaction:', error);
        throw error;
    }
    return $1d3b6c97cbeab58a$export$2a5213bce1720b42(transaction);
};
const $1d3b6c97cbeab58a$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn('Error thrown from request:', event);
    };
};

});



parcelRegister("5gj4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4d3f21ff20df70$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $eiDyS = parcelRequire("eiDyS");

var $g4hTj = parcelRequire("g4hTj");

var $6DH9M = parcelRequire("6DH9M");
var $7Hmy4 = parcelRequire("7Hmy4");

var $901dJ = parcelRequire("901dJ");

var $2vBjM = parcelRequire("2vBjM");
const $3d4d3f21ff20df70$var$_excluded = [
    "item"
], $3d4d3f21ff20df70$var$_excluded2 = [
    "items"
];
function $3d4d3f21ff20df70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d4d3f21ff20df70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d4d3f21ff20df70$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d4d3f21ff20df70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $3d4d3f21ff20df70$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        if (policy === (0, $eiDyS.GuardPolicy).IGNORE) throw new (0, $7Hmy4.default)(policy, 'IndexedDbConnector#addItem');
        const storedValue = (0, $2vBjM.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $3d4d3f21ff20df70$var$_excluded);
            return (0, $2vBjM.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $g4hTj.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $g4hTj.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $g4hTj.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($3d4d3f21ff20df70$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $g4hTj.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_this$synchronousGetI, $3d4d3f21ff20df70$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $6DH9M.default)(error);
        }
    }
    storeType() {
        return (0, $eiDyS.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $2vBjM.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $901dJ.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("901dJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d50f829dbfcc2b$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $3DoBM = parcelRequire("3DoBM");
class $68d50f829dbfcc2b$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3DoBM.default)((0, $eiDyS.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $eiDyS.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $eiDyS.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $eiDyS.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error('Event Limit has to be set higher than 1');
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("elE98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7222b149beef640$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $3aKbs = parcelRequire("3aKbs");
class $a7222b149beef640$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resilienceMechanism", (0, $3aKbs.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
}
let $a7222b149beef640$var$cachedMetricsClient = null;
var $a7222b149beef640$export$2e2bcd8739ae039 = ()=>{
    if (!$a7222b149beef640$var$cachedMetricsClient) $a7222b149beef640$var$cachedMetricsClient = new $a7222b149beef640$export$4b62ee5120ab50a8();
    return $a7222b149beef640$var$cachedMetricsClient;
};

});
parcelRegister("3aKbs", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $24f62168b9020486$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $24f62168b9020486$export$ee138fa712d11b84; });
let $24f62168b9020486$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $24f62168b9020486$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("oBsJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049f4d45a8004e54$export$2e2bcd8739ae039; });

var $3aKbs = parcelRequire("3aKbs");
class $049f4d45a8004e54$export$2e2bcd8739ae039 {
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $3aKbs.NetworkStatusEnum).ONLINE;
        return (0, $3aKbs.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        if (typeof window !== 'undefined') {
            window.addEventListener('offline', ()=>networkChangeCallback((0, $3aKbs.NetworkStatusEnum).OFFLINE));
            window.addEventListener('online', ()=>networkChangeCallback((0, $3aKbs.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("6Znl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516a8b4c133db775$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $94xq4 = parcelRequire("94xq4");

var $1td0A = parcelRequire("1td0A");
const $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $516a8b4c133db775$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $516a8b4c133db775$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === 'undefined') return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearTimeout", ()=>{
            if (typeof window !== 'undefined' && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $1td0A.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $1td0A.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $94xq4.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $1td0A.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $516a8b4c133db775$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $94xq4.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("94xq4", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $69ae692c29fd415b$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $69ae692c29fd415b$export$590a718599f8f8b3; });

var $6bkHe = parcelRequire("6bkHe");
let $69ae692c29fd415b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $69ae692c29fd415b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $69ae692c29fd415b$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $69ae692c29fd415b$export$ef3353088fca369c.IDLE:
            case $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT:
            case $69ae692c29fd415b$export$ef3353088fca369c.COMPLETED:
                if (event === $69ae692c29fd415b$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.RUNNING;
                break;
            case $69ae692c29fd415b$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $69ae692c29fd415b$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $69ae692c29fd415b$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === 'undefined') return;
        this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== 'undefined' && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbackStatus", $69ae692c29fd415b$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error('CallbackWithTimeout requires timeout period higher than 0');
    }
}

});

parcelRegister("1td0A", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $11229718ddc7d24c$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $11229718ddc7d24c$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("gINol", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $c2c7118957ab383c$export$c21270cab66ab290; });

var $6bkHe = parcelRequire("6bkHe");

var $hng8D = parcelRequire("hng8D");
function $c2c7118957ab383c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2c7118957ab383c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2c7118957ab383c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2c7118957ab383c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2c7118957ab383c$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hng8D.SegmentEventTypes).PAGE || item.msg.type === (0, $hng8D.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $c2c7118957ab383c$var$_objectSpread($c2c7118957ab383c$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $hng8D.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $c2c7118957ab383c$var$_objectSpread($c2c7118957ab383c$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $c2c7118957ab383c$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$c2c7118957ab383c$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("hng8D", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $ca611a65dc6359c5$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $ca611a65dc6359c5$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $ca611a65dc6359c5$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $ca611a65dc6359c5$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("3q4zO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $27d759a5d505afd1$export$9175ce0e1c95daf2; });
const $27d759a5d505afd1$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("8qpim", function(module, exports) {

$parcel$export(module.exports, "HTTP_STATUS_CODE_MAP", function () { return $62245f815727698d$export$ba118f9de1e5ac63; });
const $62245f815727698d$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        'OK'
    ],
    [
        400,
        'Bad Request'
    ],
    [
        401,
        'Unauthorized'
    ],
    [
        402,
        'Payment Required'
    ],
    [
        403,
        'Forbidden'
    ],
    [
        404,
        'Not Found'
    ],
    [
        405,
        'Method Not Allowed'
    ],
    [
        406,
        'Not Acceptable'
    ],
    [
        407,
        'Proxy Authentication Required'
    ],
    [
        408,
        'Request Timeout'
    ],
    [
        409,
        'Conflict'
    ],
    [
        410,
        'Gone'
    ],
    [
        411,
        'Length Required'
    ],
    [
        412,
        'Precondition Failed'
    ],
    [
        413,
        'Payload Too Large'
    ],
    [
        414,
        'URI Too Long'
    ],
    [
        415,
        'Unsupported Media Type'
    ],
    [
        416,
        'Requested range not satisfiable'
    ],
    [
        417,
        'Expectation Failed'
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        'Unprocessable Entity'
    ],
    [
        423,
        'Locked'
    ],
    [
        424,
        'Failed Dependency'
    ],
    [
        425,
        'Too Early'
    ],
    [
        426,
        'Upgrade Required'
    ],
    [
        428,
        'Precondition Required'
    ],
    [
        429,
        'Too Many Requests'
    ],
    [
        431,
        'Request Header Fields Too Large'
    ],
    [
        451,
        'Unavailable For Legal Reasons'
    ],
    [
        500,
        'Internal Server Error'
    ],
    [
        501,
        'Not Implemented'
    ],
    [
        502,
        'Bad Gateway'
    ],
    [
        503,
        'Service Unavailable'
    ],
    [
        504,
        'Gateway Timeout'
    ],
    [
        505,
        'HTTP Version not supported'
    ],
    [
        506,
        'Variant Also Negotiates'
    ],
    [
        507,
        'Insufficient Storage'
    ],
    [
        508,
        'Loop Detected'
    ],
    [
        509,
        'Bandwidth Limit Exceeded'
    ],
    [
        510,
        'Not Extended'
    ],
    [
        511,
        'Network Authentication Required'
    ],
    [
        -1,
        'Unknown Status'
    ]
]);

});

parcelRegister("bEXZy", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $87d1f748c0ebbe63$export$8e8f0180c1b41fad; });

var $6bkHe = parcelRequire("6bkHe");

var $tazez = parcelRequire("tazez");
function $87d1f748c0ebbe63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87d1f748c0ebbe63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87d1f748c0ebbe63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87d1f748c0ebbe63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $87d1f748c0ebbe63$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $87d1f748c0ebbe63$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $87d1f748c0ebbe63$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $87d1f748c0ebbe63$var$_objectSpread({
        method: 'POST',
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            'Content-Type': 'text/plain'
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $87d1f748c0ebbe63$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $87d1f748c0ebbe63$var$getCorsForUrl = (0, $tazez.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: 'cors',
        credentials: 'include'
    };
});

});
parcelRegister("tazez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057ae7fdf9f17f1d$export$2e2bcd8739ae039; });
var $057ae7fdf9f17f1d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $057ae7fdf9f17f1d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($057ae7fdf9f17f1d$var$safeIsNaN(first) && $057ae7fdf9f17f1d$var$safeIsNaN(second)) return true;
    return false;
}
function $057ae7fdf9f17f1d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$057ae7fdf9f17f1d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $057ae7fdf9f17f1d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $057ae7fdf9f17f1d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("ePQx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acce9427d49cc345$export$2e2bcd8739ae039; });

var $1X2vc = parcelRequire("1X2vc");

var $gaCcd = parcelRequire("gaCcd");

var $1zj8U = parcelRequire("1zj8U");
var $cGSp4 = parcelRequire("cGSp4");

var $3wkHk = parcelRequire("3wkHk");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $acce9427d49cc345$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $acce9427d49cc345$var$SAFE = 'SAFE';
const $acce9427d49cc345$var$UNSAFE = 'UNSAFE';
const $acce9427d49cc345$var$NOT_FOUND = 'NOT_FOUND';
const $acce9427d49cc345$var$COOKIE = 'COOKIE';
const $acce9427d49cc345$var$LOCAL_STORAGE = 'LOCAL_STORAGE';
class $acce9427d49cc345$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $1zj8U.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $acce9427d49cc345$var$LOCAL_STORAGE ? this.store.getItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $1zj8U.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $acce9427d49cc345$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === 'string') return {
                    type: $acce9427d49cc345$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $acce9427d49cc345$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($acce9427d49cc345$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $1X2vc.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $acce9427d49cc345$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $acce9427d49cc345$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $acce9427d49cc345$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $acce9427d49cc345$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($acce9427d49cc345$var$COOKIE);
        switch(cookieValue.type){
            case $acce9427d49cc345$var$SAFE:
            case $acce9427d49cc345$var$UNSAFE:
                this.store.setItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $acce9427d49cc345$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = new (0, $3wkHk.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $cGSp4.default)(disableCookiePersistence);
    }
}

});
parcelRegister("1X2vc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16bd3e0be5accb72$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $5TqF7 = parcelRequire("5TqF7");

var $kqhx7 = parcelRequire("kqhx7");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $16bd3e0be5accb72$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kqhx7.default)(2, arguments);
    var dateLeft = (0, $eSxdi.default)(dirtyDateLeft);
    var dateRight = (0, $eSxdi.default)(dirtyDateRight);
    var sign = $16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $5TqF7.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("eSxdi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4fdf55700979f1$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $kqhx7 = parcelRequire("kqhx7");
function $ad4fdf55700979f1$export$2e2bcd8739ae039(argument) {
    (0, $kqhx7.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $8p0zh.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("8p0zh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e119534a0b324c$export$2e2bcd8739ae039; });
function $61e119534a0b324c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $61e119534a0b324c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61e119534a0b324c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kqhx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ede3d615aefdc26d$export$2e2bcd8739ae039; });
function $ede3d615aefdc26d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

});


parcelRegister("5TqF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a6c55ab082050c$export$2e2bcd8739ae039; });

var $2EOLL = parcelRequire("2EOLL");

var $afvqM = parcelRequire("afvqM");

var $kqhx7 = parcelRequire("kqhx7");
var $44a6c55ab082050c$var$MILLISECONDS_IN_DAY = 86400000;
function $44a6c55ab082050c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kqhx7.default)(2, arguments);
    var startOfDayLeft = (0, $afvqM.default)(dirtyDateLeft);
    var startOfDayRight = (0, $afvqM.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $2EOLL.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $2EOLL.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $44a6c55ab082050c$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("2EOLL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef6b2ef7ba2174c$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1ef6b2ef7ba2174c$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("afvqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7763afa254a4bbfe$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $7763afa254a4bbfe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("1zj8U", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $1247e8a98fdc3168$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $1247e8a98fdc3168$export$d4cb17942ea57c95; });
let $1247e8a98fdc3168$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $1247e8a98fdc3168$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
}
const $1247e8a98fdc3168$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === 'https:';
    } catch (err) {
        return false;
    }
};
const $1247e8a98fdc3168$export$d4cb17942ea57c95 = {
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $1247e8a98fdc3168$var$CookieSchema('__awc_tld_test__', {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: '/'
    }),
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $1247e8a98fdc3168$var$CookieSchema('atlassian_analytics_debug', {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: '/'
    }),
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $1247e8a98fdc3168$var$CookieSchema('ajs_anonymous_id', {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: '/'
    })
};

});

parcelRegister("cGSp4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d39ba6a81c9615$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8USlx = parcelRequire("8USlx");

var $1zj8U = parcelRequire("1zj8U");

var $6lPXC = parcelRequire("6lPXC");

var $3tNVa = parcelRequire("3tNVa");
function $93d39ba6a81c9615$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93d39ba6a81c9615$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93d39ba6a81c9615$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93d39ba6a81c9615$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $93d39ba6a81c9615$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $1zj8U.AllAnalyticsCookies)[name].getKey(), value, $93d39ba6a81c9615$var$_objectSpread($93d39ba6a81c9615$var$_objectSpread({}, (0, $1zj8U.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $3tNVa.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $1zj8U.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $1zj8U.AllAnalyticsCookies)[name].getKey(), $93d39ba6a81c9615$var$_objectSpread({}, options));
    }
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $3tNVa.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))) : new (0, $6lPXC.default)();
    }
}

});
parcelRegister("8USlx", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = extend({
                path: '/'
            }, api.defaults, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = key + '=' + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === 'undefined') return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, '', extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("6lPXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fd028715114a9b$export$2e2bcd8739ae039; });

var $3wkHk = parcelRequire("3wkHk");
class $49fd028715114a9b$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = new (0, $3wkHk.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("3wkHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29046a66738f8b40$export$2e2bcd8739ae039; });

var $gukCd = parcelRequire("gukCd");

var $dRrH7 = parcelRequire("dRrH7");
class $29046a66738f8b40$export$2e2bcd8739ae039 extends (0, $dRrH7.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $gukCd.default);
        } catch (err) {
            storageToUse = (0, $gukCd.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("gukCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00f707b4bc25dd4$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");
class $c00f707b4bc25dd4$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$c00f707b4bc25dd4$export$2e2bcd8739ae039 = new $c00f707b4bc25dd4$export$90e3e001bcac59c7();

});

parcelRegister("dRrH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a175b51ed57ac6da$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $gukCd = parcelRequire("gukCd");
const $a175b51ed57ac6da$export$41c06fdd37b7e9a5 = 'awc';
const $a175b51ed57ac6da$export$770aa8bc07b3de03 = 'awcInMemoryStorageFallback';
function $a175b51ed57ac6da$export$48c17662a6902497(store) {
    const TEST_VALUE = 'test_value';
    if (!store) return false;
    try {
        const key = 'awc.storage.support';
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $a175b51ed57ac6da$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $a175b51ed57ac6da$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($a175b51ed57ac6da$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $gukCd.default) || typeof window === 'undefined') return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($a175b51ed57ac6da$export$48c17662a6902497(window[$a175b51ed57ac6da$export$770aa8bc07b3de03])) inMemoryStorage = window[$a175b51ed57ac6da$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $gukCd.default);
                if (!window[$a175b51ed57ac6da$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$a175b51ed57ac6da$export$770aa8bc07b3de03] = (0, $gukCd.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($a175b51ed57ac6da$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $4cW1f.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join('-');
        if ($a175b51ed57ac6da$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("3tNVa", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $288acdcfb2e394fa$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $288acdcfb2e394fa$export$de6821eed3d5f32d; });

var $8USlx = parcelRequire("8USlx");

var $tazez = parcelRequire("tazez");

var $1zj8U = parcelRequire("1zj8U");
const $288acdcfb2e394fa$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === 'file:' || location.protocol === 'chrome-extension:');
};
const $288acdcfb2e394fa$export$eb80e1beaa8dacf8 = (0, $1zj8U.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $288acdcfb2e394fa$export$19164982d36535d8 = 'tld_test';
const $288acdcfb2e394fa$export$de6821eed3d5f32d = (0, $tazez.default)(()=>{
    if (typeof location === 'undefined') return '';
    const { hostname: hostname } = location;
    const splitHostname = hostname.split('.');
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join('.')}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).set($288acdcfb2e394fa$export$eb80e1beaa8dacf8, $288acdcfb2e394fa$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($288acdcfb2e394fa$export$eb80e1beaa8dacf8) === $288acdcfb2e394fa$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).remove($288acdcfb2e394fa$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("jV8Tw", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $e80a3d76bbee9286$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $e80a3d76bbee9286$export$44d22e5fb02cc68e; });

var $6bkHe = parcelRequire("6bkHe");

var $8BgFy = parcelRequire("8BgFy");
function $e80a3d76bbee9286$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e80a3d76bbee9286$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e80a3d76bbee9286$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e80a3d76bbee9286$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e80a3d76bbee9286$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $e80a3d76bbee9286$var$_objectSpread($e80a3d76bbee9286$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $e80a3d76bbee9286$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $e80a3d76bbee9286$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8BgFy)))(propertiesWithoutUndefined);
};
const $e80a3d76bbee9286$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== 'object') return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $e80a3d76bbee9286$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$e80a3d76bbee9286$export$2250ccecd1e040fd(i));
            else if (typeof value === 'object' && value !== null) clone[key] = $e80a3d76bbee9286$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $e80a3d76bbee9286$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("8BgFy", function(module, exports) {
'use strict';

var $fmpz9 = parcelRequire("fmpz9");
/**
 * Expose `traverse`.
 */ module.exports = $642eb59236162e8c$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $642eb59236162e8c$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $642eb59236162e8c$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $642eb59236162e8c$var$traverseArray(input, strict);
    else if ($fmpz9.is(input, strict)) return $fmpz9.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $642eb59236162e8c$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $642eb59236162e8c$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $642eb59236162e8c$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $642eb59236162e8c$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("fmpz9", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $b2ecbdf483b1869e$export$98e6a39c04603d36; }, function (v) { return $b2ecbdf483b1869e$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $b2ecbdf483b1869e$export$226b3eccf92c9ed9; }, function (v) { return $b2ecbdf483b1869e$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $b2ecbdf483b1869e$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $b2ecbdf483b1869e$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $b2ecbdf483b1869e$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$b2ecbdf483b1869e$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $b2ecbdf483b1869e$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$b2ecbdf483b1869e$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $b2ecbdf483b1869e$var$matcher.test(string);
};

});




parcelRegister("arXeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79ba6078cb3d598f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $6QXdB = parcelRequire("6QXdB");
class $79ba6078cb3d598f$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error('Empty parameter mapping provided');
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $4cW1f.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $6QXdB.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("6QXdB", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $4fd588f4b5e1a682$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $4fd588f4b5e1a682$export$2e2bcd8739ae039; });

var $hUgeU = parcelRequire("hUgeU");

var $dbpk1 = parcelRequire("dbpk1");
const $4fd588f4b5e1a682$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, '', newUrl);
const $4fd588f4b5e1a682$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $4fd588f4b5e1a682$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== '' ? originalUrl.replace(fragmentHash, '') : originalUrl;
    const { url: url, query: query } = (0, $hUgeU.parseUrl)(removedFragmentURL);
    const captureParams = (0, $dbpk1.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $dbpk1.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $hUgeU.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $4fd588f4b5e1a682$export$2e2bcd8739ae039 = $4fd588f4b5e1a682$var$urlParamExtractor;

});
parcelRegister("hUgeU", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $035d3ae4ecba6f6b$export$f9380c9a627682d3; }, function (v) { return $035d3ae4ecba6f6b$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $035d3ae4ecba6f6b$export$98e6a39c04603d36; }, function (v) { return $035d3ae4ecba6f6b$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $035d3ae4ecba6f6b$export$fac44ee5b035f737; }, function (v) { return $035d3ae4ecba6f6b$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $035d3ae4ecba6f6b$export$7a5253c0f62e0150; }, function (v) { return $035d3ae4ecba6f6b$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $035d3ae4ecba6f6b$export$a8c1621ea79325d3; }, function (v) { return $035d3ae4ecba6f6b$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $035d3ae4ecba6f6b$export$357523c63a2253b9; }, function (v) { return $035d3ae4ecba6f6b$export$357523c63a2253b9 = v; });
var $035d3ae4ecba6f6b$export$f9380c9a627682d3;
var $035d3ae4ecba6f6b$export$98e6a39c04603d36;
var $035d3ae4ecba6f6b$export$fac44ee5b035f737;
var $035d3ae4ecba6f6b$export$7a5253c0f62e0150;
var $035d3ae4ecba6f6b$export$a8c1621ea79325d3;
var $035d3ae4ecba6f6b$export$357523c63a2253b9;
var $035d3ae4ecba6f6b$export$44c361b8ec72ef7f;
'use strict';

var $aG5yl = parcelRequire("aG5yl");

var $lPnyU = parcelRequire("lPnyU");

var $eAj7f = parcelRequire("eAj7f");

var $lREDO = parcelRequire("lREDO");
const $035d3ae4ecba6f6b$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $035d3ae4ecba6f6b$var$encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');
function $035d3ae4ecba6f6b$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            '[',
                            $035d3ae4ecba6f6b$var$encode(index, options),
                            ']=',
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            '[]=',
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'colon-list-separator':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            ':list='
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            ':list=',
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
        case 'bracket-separator':
            {
                const keyValueSep = options.arrayFormat === 'bracket-separator' ? '[]=' : '=';
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? '' : value;
                        if (result.length === 0) return [
                            [
                                $035d3ae4ecba6f6b$var$encode(key, options),
                                keyValueSep,
                                $035d3ae4ecba6f6b$var$encode(value, options)
                            ].join('')
                        ];
                        return [
                            [
                                result,
                                $035d3ae4ecba6f6b$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $035d3ae4ecba6f6b$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            '=',
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $035d3ae4ecba6f6b$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'colon-list-separator':
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $035d3ae4ecba6f6b$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $035d3ae4ecba6f6b$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$035d3ae4ecba6f6b$var$decode(item, options)) : value === null ? value : $035d3ae4ecba6f6b$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case 'bracket-separator':
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, '');
                if (!isArray) {
                    accumulator[key] = value ? $035d3ae4ecba6f6b$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$035d3ae4ecba6f6b$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $035d3ae4ecba6f6b$var$encode(value, options) {
    if (options.encode) return options.strict ? $aG5yl(value) : encodeURIComponent(value);
    return value;
}
function $035d3ae4ecba6f6b$var$decode(value, options) {
    if (options.decode) return $lPnyU(value);
    return value;
}
function $035d3ae4ecba6f6b$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $035d3ae4ecba6f6b$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $035d3ae4ecba6f6b$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $035d3ae4ecba6f6b$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $035d3ae4ecba6f6b$var$extract(input) {
    input = $035d3ae4ecba6f6b$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $035d3ae4ecba6f6b$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $035d3ae4ecba6f6b$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $035d3ae4ecba6f6b$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $eAj7f(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator',
            'bracket-separator'
        ].includes(options.arrayFormat) ? value : $035d3ae4ecba6f6b$var$decode(value, options);
        formatter($035d3ae4ecba6f6b$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $035d3ae4ecba6f6b$var$parseValue(value[k], options);
        else ret[key] = $035d3ae4ecba6f6b$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $035d3ae4ecba6f6b$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$035d3ae4ecba6f6b$export$f9380c9a627682d3 = $035d3ae4ecba6f6b$var$extract;
$035d3ae4ecba6f6b$export$98e6a39c04603d36 = $035d3ae4ecba6f6b$var$parse;
$035d3ae4ecba6f6b$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $035d3ae4ecba6f6b$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $035d3ae4ecba6f6b$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $035d3ae4ecba6f6b$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === 'bracket-separator') return $035d3ae4ecba6f6b$var$encode(key, options) + '[]';
            return value.reduce(formatter(key), []).join('&');
        }
        return $035d3ae4ecba6f6b$var$encode(key, options) + '=' + $035d3ae4ecba6f6b$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$035d3ae4ecba6f6b$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $eAj7f(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $035d3ae4ecba6f6b$var$parse($035d3ae4ecba6f6b$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $035d3ae4ecba6f6b$var$decode(hash, options)
    } : {});
};
$035d3ae4ecba6f6b$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$035d3ae4ecba6f6b$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $035d3ae4ecba6f6b$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $035d3ae4ecba6f6b$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $035d3ae4ecba6f6b$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $035d3ae4ecba6f6b$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $035d3ae4ecba6f6b$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$035d3ae4ecba6f6b$var$encodeFragmentIdentifier] ? $035d3ae4ecba6f6b$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$035d3ae4ecba6f6b$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$035d3ae4ecba6f6b$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $035d3ae4ecba6f6b$export$7a5253c0f62e0150(input, options);
    return $035d3ae4ecba6f6b$export$a8c1621ea79325d3({
        url: url,
        query: $lREDO(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$035d3ae4ecba6f6b$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $035d3ae4ecba6f6b$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("aG5yl", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("lPnyU", function(module, exports) {
'use strict';
var $fe40a35433c4412a$var$token = '%[a-f0-9]{2}';
var $fe40a35433c4412a$var$singleMatcher = new RegExp('(' + $fe40a35433c4412a$var$token + ')|([^%]+?)', 'gi');
var $fe40a35433c4412a$var$multiMatcher = new RegExp('(' + $fe40a35433c4412a$var$token + ')+', 'gi');
function $fe40a35433c4412a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $fe40a35433c4412a$var$decodeComponents(left), $fe40a35433c4412a$var$decodeComponents(right));
}
function $fe40a35433c4412a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($fe40a35433c4412a$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $fe40a35433c4412a$var$decodeComponents(tokens, i).join('');
            tokens = input.match($fe40a35433c4412a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $fe40a35433c4412a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $fe40a35433c4412a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $fe40a35433c4412a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $fe40a35433c4412a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $fe40a35433c4412a$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("eAj7f", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("lREDO", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("eh37k", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $a645123f076c2e80$export$18c0b81944902eae; });

var $4cW1f = parcelRequire("4cW1f");
const $a645123f076c2e80$var$PROD_HOST = 'as.atlassian.com/api/v1';
const $a645123f076c2e80$var$STARGATE_PROD_HOST = 'api-private.atlassian.com/gasv3/api/v1';
const $a645123f076c2e80$var$STAGING_HOST = 'as.staging.atl-paas.net/api/v1';
const $a645123f076c2e80$var$STARGATE_STAGING_HOST = 'api-private.stg.atlassian.com/gasv3/api/v1';
const $a645123f076c2e80$var$FEDRAMP_STAGING_HOST = 'as.staging.atl-paas-us-gov-mod.net/api/v1';
const $a645123f076c2e80$var$FEDRAMP_PROD_HOST = 'as.atlassian-us-gov-mod.com/api/v1';
const $a645123f076c2e80$var$STARGATE_FEDRAMP_STAGING_HOST = 'api.stg.atlassian-us-gov-mod.com/gasv3/api/v1';
const $a645123f076c2e80$var$STARGATE_FEDRAMP_PROD_HOST = 'api.atlassian-us-gov-mod.com/gasv3/api/v1';
const $a645123f076c2e80$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
const $a645123f076c2e80$var$handleFedRampStagingDirect = ()=>{
    return $a645123f076c2e80$var$FEDRAMP_STAGING_HOST;
};
const $a645123f076c2e80$var$handleFedRampStagingStargate = ()=>{
    return $a645123f076c2e80$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $a645123f076c2e80$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $4cW1f.envType).LOCAL || env === (0, $4cW1f.envType).DEV) throw Error('No LOCAL or DEV environments for FedRAMP.');
    if (env === (0, $4cW1f.envType).PROD && envOverride) throw Error('Cannot override to FedRAMP Sandbox for Prod.');
    if (!useStargate) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$FEDRAMP_PROD_HOST : $a645123f076c2e80$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$STARGATE_FEDRAMP_PROD_HOST : $a645123f076c2e80$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $a645123f076c2e80$var$STARGATE_PROXY_PATH;
};
const $a645123f076c2e80$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$PROD_HOST : $a645123f076c2e80$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$STARGATE_PROD_HOST : $a645123f076c2e80$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $a645123f076c2e80$var$STARGATE_PROXY_PATH;
};
function $a645123f076c2e80$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $4cW1f.perimeterType).FEDRAMP_MODERATE) return $a645123f076c2e80$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $a645123f076c2e80$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("2vX01", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4c3e13a419a8d3$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $3wkHk = parcelRequire("3wkHk");
const $1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY = 'session.id';
const $1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY = 'session.expiry';
const $1d4c3e13a419a8d3$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $1d4c3e13a419a8d3$export$285f6bddd927a06d = 1800000; // 30 minutes
const $1d4c3e13a419a8d3$export$a92e915d70316eb2 = 5000; // 5 seconds
const $1d4c3e13a419a8d3$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $1d4c3e13a419a8d3$export$5702a91a6f42969f = ()=>{};
class $1d4c3e13a419a8d3$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY) || '0', 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$1d4c3e13a419a8d3$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $1d4c3e13a419a8d3$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $1d4c3e13a419a8d3$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $1d4c3e13a419a8d3$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $1d4c3e13a419a8d3$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $3wkHk.default)();
    }
}

});

parcelRegister("gErWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0320df34060cc310$export$2e2bcd8739ae039; });

var $gukCd = parcelRequire("gukCd");

var $dRrH7 = parcelRequire("dRrH7");
class $0320df34060cc310$export$2e2bcd8739ae039 extends (0, $dRrH7.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $gukCd.default);
        } catch (err) {
            storageToUse = (0, $gukCd.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("ce60p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6b7369ddd5fc3f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $gErWv = parcelRequire("gErWv");
const $8e6b7369ddd5fc3f$var$STORAGE_KEY = 'tab.id';
class $8e6b7369ddd5fc3f$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($8e6b7369ddd5fc3f$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
            this._safeSessionStorage.setItem($8e6b7369ddd5fc3f$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $gErWv.default)();
    }
}

});

parcelRegister("dtn8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cefee5cfd893684$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $hUgeU = parcelRequire("hUgeU");

var $gaCcd = parcelRequire("gaCcd");

var $4cW1f = parcelRequire("4cW1f");

var $dbpk1 = parcelRequire("dbpk1");

var $gErWv = parcelRequire("gErWv");

var $6QXdB = parcelRequire("6QXdB");
function $9cefee5cfd893684$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cefee5cfd893684$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cefee5cfd893684$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cefee5cfd893684$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9cefee5cfd893684$var$STORAGE_KEY = 'taskSessions';
const $9cefee5cfd893684$var$INIT_KEY = 'taskSessionsInit';
const $9cefee5cfd893684$var$AWC_PARAM_PREFIX = 'awc.';
const $9cefee5cfd893684$var$TASK_SESSION_RELOAD_TIME = 3000;
class $9cefee5cfd893684$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($9cefee5cfd893684$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($9cefee5cfd893684$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($9cefee5cfd893684$var$INIT_KEY) || '0', 10) < currentTimestamp - $9cefee5cfd893684$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($9cefee5cfd893684$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($9cefee5cfd893684$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($9cefee5cfd893684$var$STORAGE_KEY) || '');
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($9cefee5cfd893684$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== 'string') throw new TypeError('invalid taskSessionId, must be string');
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $hUgeU.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $dbpk1.pick)(currentState, includedTaskSessions) : (0, $dbpk1.omit)(currentState, Object.values((0, $4cW1f.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $9cefee5cfd893684$var$_objectSpread($9cefee5cfd893684$var$_objectSpread({}, (0, $dbpk1.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$9cefee5cfd893684$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $hUgeU.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $dbpk1.mapKeys)((0, $6QXdB.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $gErWv.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($9cefee5cfd893684$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("dRf7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $029a83f13071ad40$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8USlx = parcelRequire("8USlx");

var $1zj8U = parcelRequire("1zj8U");
const $029a83f13071ad40$var$MAX_CACHE_SIZE = 100;
const $029a83f13071ad40$var$COOKIE_NAME = (0, $1zj8U.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $029a83f13071ad40$var$DEBUG_TAG = 'synthetic';
const $029a83f13071ad40$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($029a83f13071ad40$var$COOKIE_NAME) || 'false');
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).remove($029a83f13071ad40$var$COOKIE_NAME);
    }
    return false;
};
class $029a83f13071ad40$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bind", ()=>{
            if (typeof window === 'undefined' || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem('awc.ui.viewed.last.sent');
                        localStorage.removeItem('awc-staging.ui.viewed.last.sent');
                        localStorage.removeItem('awc-dev.ui.viewed.last.sent');
                        localStorage.removeItem('awc-local.ui.viewed.last.sent');
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_cache", (event)=>{
            if (typeof window === 'undefined') return;
            if (window.testAnalytics.eventCache.length >= $029a83f13071ad40$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($029a83f13071ad40$var$DEBUG_TAG);
                else event.tags = [
                    $029a83f13071ad40$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $029a83f13071ad40$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $029a83f13071ad40$export$2e2bcd8739ae039 = $029a83f13071ad40$var$TestingCache;

});

parcelRegister("5E2Q9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41c2e42e71f4882a$export$2e2bcd8739ae039; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $3wkHk = parcelRequire("3wkHk");
const $41c2e42e71f4882a$var$_excluded = [
    "embeddedProduct"
];
function $41c2e42e71f4882a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41c2e42e71f4882a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41c2e42e71f4882a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41c2e42e71f4882a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $41c2e42e71f4882a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $41c2e42e71f4882a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $41c2e42e71f4882a$var$DEFAULT_STORAGE_KEY = 'ui.viewed.last.sent';
class $41c2e42e71f4882a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.addEventListener('focus', this._focusListener);
                window.addEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== 'undefined') {
                window.removeEventListener('focus', this._focusListener);
                window.removeEventListener('blur', this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || '');
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $4cW1f.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_this$_getContext, $41c2e42e71f4882a$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: 'ui',
                action: 'viewed',
                actionSubject: 'ui',
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $41c2e42e71f4882a$var$_objectSpread($41c2e42e71f4882a$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $41c2e42e71f4882a$var$_objectSpread($41c2e42e71f4882a$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error('Missing productInfo');
        if (!productInfo.product) throw new Error('Missing productInfo.product');
        if (!getContext) throw new Error('Missing getContext callback');
        if (typeof getContext !== 'function') throw new Error('Invalid getContext, must be function');
        if (!onEvent) throw new Error('Missing onEvent callback');
        if (typeof onEvent !== 'function') throw new Error('Invalid onEvent, must be function');
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $41c2e42e71f4882a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $41c2e42e71f4882a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $41c2e42e71f4882a$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $3wkHk.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("ctYUa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91676fe72e7d292e$export$2e2bcd8739ae039; });
function $91676fe72e7d292e$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== 'function') return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("fBSnV", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $b5d47f6dcd743d47$export$fbe53bbbe682bcdd; });

var $h7Mqs = parcelRequire("h7Mqs");
const $b5d47f6dcd743d47$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === 'function') {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $h7Mqs.createTimeoutXid)()), (0, $h7Mqs.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $h7Mqs.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("h7Mqs", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $c778a7722e8a548b$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $c778a7722e8a548b$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $c778a7722e8a548b$export$fa341d0c750d705b; });

var $2Z6zh = parcelRequire("2Z6zh");
const $c778a7722e8a548b$export$545bcbd53afabfa3 = 5000;
const $c778a7722e8a548b$export$af4087e36d63846 = ()=>[
        {
            type: (0, $2Z6zh.XIDItemType).XC,
            state: 'TIMEOUT'
        },
        {
            type: (0, $2Z6zh.XIDItemType).UID,
            state: 'TIMEOUT'
        }
    ];
const $c778a7722e8a548b$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $2Z6zh.XIDItemType).XC,
            state: 'UNKNOWN'
        },
        {
            type: (0, $2Z6zh.XIDItemType).UID,
            state: 'UNKNOWN'
        }
    ];

});
parcelRegister("2Z6zh", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $22c65f8e00aa90a1$export$92ca0438bcb0d396; });
let $22c65f8e00aa90a1$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $22c65f8e00aa90a1$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("fvOZR", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1['default'];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, 'a', getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GAS_BULK_URL = exports.GAS_BULK_URL = 'https://mgas.prod.public.atl-paas.net/v1/events';
            var CLOUD_ANALYTICS_URL = exports.CLOUD_ANALYTICS_URL = '/rest/analytics/1.0/publish/bulk';
            var CONFLUENCE_URL_PREFIX = exports.CONFLUENCE_URL_PREFIX = '/wiki';
            var BATCH_INTERVAL_MS = exports.BATCH_INTERVAL_MS = 5000;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var SafeString = exports.SafeString = function SafeString(value) {
                var _this = this;
                _classCallCheck(this, SafeString);
                this.value = value;
                this.valueOf = this.toString = this.toJSON = function() {
                    return _this.value;
                };
            };
            /**
 * Use this when you explicitly need to collect user entered data. Such as NPS survey responses.
 * @param value
 */ var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = function dangerouslyCreateSafeString(value) {
                return new SafeString(value);
            };
            var isSafeString = exports.isSafeString = function isSafeString(value) {
                return value instanceof SafeString;
            };
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {Array} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString}
 */ var markAsSafe = exports.markAsSafe = function markAsSafe() {
                for(var _len = arguments.length, allowedStrings = Array(_len), _key = 0; _key < _len; _key++)allowedStrings[_key] = arguments[_key];
                return function(value) {
                    return allowedStrings.includes(value) ? Object.freeze(new SafeString(value)) : value;
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BaseAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _Beacon = __webpack_require__(8);
            var _PrivacySafeString = __webpack_require__(1);
            var _AnalyticsLogger = __webpack_require__(9);
            var _AnalyticsLogger2 = _interopRequireDefault(_AnalyticsLogger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var isNumberOrNumericString = function isNumberOrNumericString(value) {
                return !isNaN(value);
            };
            var isNull = function isNull(value) {
                return value === null;
            };
            var isBoolean = function isBoolean(value) {
                return value === true || value === false;
            };
            /**
 * Is of a type that will not reveal any PII
 * OR
 * is explicitly marked as being safe of PII
 * @param value
 */ var isPrivacySafe = function isPrivacySafe(value) {
                return isNull(value) || isBoolean(value) || isNumberOrNumericString(value) || (0, _PrivacySafeString.isSafeString)(value);
            };
            /**
 * Extend this to include "whitelisted" keys where the values will be deemed safe
 * @param key
 */ var isPrivacySafeAttributeKey = function isPrivacySafeAttributeKey(key) {
                return key === 'spaceKey';
            };
            /*eslint no-unused-vars: ["error", { "argsIgnorePattern": "name|properties|events" }]*/ /**
 * Abstract analytics client implementation
 */ var BaseAnalytics = exports.BaseAnalytics = function() {
                function BaseAnalytics() {
                    var _this = this;
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    _classCallCheck(this, BaseAnalytics);
                    this.eventPrefix = options.eventPrefix || '';
                    this.devMode = options.devMode;
                    this.batch_interval_ms = options.batchIntervalMs || _default.BATCH_INTERVAL_MS;
                    this.options = options;
                    this._requestQueue = [];
                    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("unload", function() {
                        _this.handlePageUnload();
                    });
                }
                _createClass(BaseAnalytics, [
                    {
                        key: 'url',
                        value: function url() {
                            throw new Error('override url()');
                        }
                    },
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            throw new Error('You must override createRequest().');
                        }
                    },
                    {
                        key: 'trigger',
                        value: function trigger(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                                immediate: false
                            };
                            if (!name) throw new Error("Name must be provided when sending an event.");
                            var eventName = '' + (this.eventPrefix ? this.eventPrefix + "." : "") + name;
                            var request = this.createRequest(eventName, this.sanitizeAnalyticsData(properties));
                            if (this.devMode) _AnalyticsLogger2.default.log(JSON.stringify(request, null, 2));
                            if (options.immediate) this.sendEventsToRemote([
                                request
                            ]);
                            else {
                                this.pushToQueue(request);
                                this.startInterval();
                            }
                        }
                    },
                    {
                        key: 'setQueue',
                        value: function setQueue(newQueue) {
                            this._requestQueue = newQueue;
                        }
                    },
                    {
                        key: 'getQueue',
                        value: function getQueue() {
                            return this._requestQueue;
                        }
                    },
                    {
                        key: 'pushToQueue',
                        value: function pushToQueue(request) {
                            this.getQueue().push(request);
                        }
                    },
                    {
                        key: 'processQueue',
                        value: function processQueue() {
                            var events = this.getQueue().splice(0);
                            if (events.length > 0) this.sendEventsToRemote(events);
                        }
                    },
                    {
                        key: 'handlePageUnload',
                        value: function handlePageUnload() {
                            this.processQueue();
                            this.stopInterval();
                        }
                    },
                    {
                        key: 'startInterval',
                        value: function startInterval() {
                            var _this2 = this;
                            if (typeof this._intervalId === "number") return;
                            this._intervalId = setInterval(function() {
                                return _this2.processQueue();
                            }, this.batch_interval_ms);
                        }
                    },
                    {
                        key: 'stopInterval',
                        value: function stopInterval() {
                            if (typeof this._intervalId === "number") {
                                clearInterval(this._intervalId);
                                this._intervalId = null;
                            }
                        }
                    },
                    {
                        key: 'emptyQueue',
                        value: function emptyQueue() {
                            this._requestQueue = [];
                        }
                    },
                    {
                        key: 'sendEventsToRemote',
                        value: function sendEventsToRemote(events) {
                            var payload = this.constructor.createPayload(events);
                            if (this.devMode) {
                                _AnalyticsLogger2.default.log('sending ' + events.length + ' events.');
                                return;
                            }
                            var successfullyQueued = false;
                            if (_Beacon.Beacon.isSupported()) successfullyQueued = _Beacon.Beacon.sendAsJson(this.url(), payload);
                            if (!successfullyQueued) this.doPost(payload);
                        }
                    },
                    {
                        key: 'doPost',
                        value: function doPost(postBody) {
                            var xhr = void 0;
                            if (typeof window !== "undefined" && window.XMLHttpRequest) // IE7+, Firefox, Chrome, Opera, Safari
                            xhr = new window.XMLHttpRequest();
                            else return;
                            xhr.open("POST", this.url(), true);
                            if (typeof xhr.setRequestHeader !== 'undefined') {
                                xhr.setRequestHeader("Content-Type", "application/json");
                                xhr.setRequestHeader("Accept", "application/json, text/javascript, */*;");
                            }
                            var decoratedPostBody = this.decorateEventsWithType(postBody);
                            xhr.send(JSON.stringify(decoratedPostBody));
                        }
                    },
                    {
                        key: 'decorateEventsWithType',
                        value: function decorateEventsWithType(postBody) {
                            return postBody.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                        }
                    },
                    {
                        key: 'sanitizeAnalyticsData',
                        value: function sanitizeAnalyticsData(data) {
                            var _this3 = this;
                            if (isNull(data) || typeof data === 'undefined') return data;
                            if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return {};
                            // return the data with privacy unsafe data filtered out
                            return Object.keys(data).reduce(function(filteredData, key) {
                                var value = data[key];
                                if (isPrivacySafeAttributeKey(key) || isPrivacySafe(value)) filteredData[key] = value;
                                else if (_this3.devMode) _AnalyticsLogger2.default.warn('Stripping out potentially privacy-unsafe analytics attribute: \'' + key + '\' -> \'' + value + '\'');
                                return filteredData;
                            }, {});
                        }
                    },
                    {
                        key: 'updateOptions',
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            throw new Error('You must override createPayload().');
                        }
                    }
                ]);
                return BaseAnalytics;
            }();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.CloudAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Common code for cloud, shared by JiraAnalytics and ConfluenceAnalytics
 */ var CloudAnalytics = exports.CloudAnalytics = function(_BaseAnalytics) {
                _inherits(CloudAnalytics, _BaseAnalytics);
                function CloudAnalytics() {
                    _classCallCheck(this, CloudAnalytics);
                    return _possibleConstructorReturn(this, (CloudAnalytics.__proto__ || Object.getPrototypeOf(CloudAnalytics)).apply(this, arguments));
                }
                _createClass(CloudAnalytics, [
                    {
                        key: 'createRequest',
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                properties: properties,
                                serverTime: Date.now()
                            };
                        }
                    }
                ], [
                    {
                        key: 'createPayload',
                        value: function createPayload(events) {
                            return this.adjustEventTimings(events);
                        }
                    },
                    {
                        key: 'adjustEventTimings',
                        value: function adjustEventTimings(events) {
                            var now = Date.now();
                            return events.map(function(event) {
                                return {
                                    name: event.name,
                                    properties: event.properties,
                                    timeDelta: event.serverTime - now
                                };
                            });
                        }
                    }
                ]);
                return CloudAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ConfluenceAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for Confluence
 * Defaults to /wiki
 */ var ConfluenceAnalytics = exports.ConfluenceAnalytics = function(_CloudAnalytics) {
                _inherits(ConfluenceAnalytics, _CloudAnalytics);
                function ConfluenceAnalytics() {
                    _classCallCheck(this, ConfluenceAnalytics);
                    return _possibleConstructorReturn(this, (ConfluenceAnalytics.__proto__ || Object.getPrototypeOf(ConfluenceAnalytics)).apply(this, arguments));
                }
                _createClass(ConfluenceAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname + _default.CONFLUENCE_URL_PREFIX;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return ConfluenceAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.GasAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for the GAS API ({@link https://extranet.atlassian.com/display/MOD/Public+Analytics+aka+GAS})
 */ var GasAnalytics = exports.GasAnalytics = function(_BaseAnalytics) {
                _inherits(GasAnalytics, _BaseAnalytics);
                /**
    * @constructor
    * @param {object} options - Required: server, product, user.
    */ function GasAnalytics(options) {
                    _classCallCheck(this, GasAnalytics);
                    var _this = _possibleConstructorReturn(this, (GasAnalytics.__proto__ || Object.getPrototypeOf(GasAnalytics)).call(this, options));
                    if (!options.server) throw new Error("You must specify a GAS server value.");
                    if (!options.product) throw new Error("You must specify a GAS product value.");
                    if (!options.user && !options.user_id) throw new Error("You must specify a GAS user or user_id value.");
                    return _this;
                }
                _createClass(GasAnalytics, [
                    {
                        key: "url",
                        value: function url() {
                            return _default.GAS_BULK_URL;
                        }
                    },
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                server: this.options.server,
                                product: this.options.product,
                                user: this.options.user,
                                serverTime: Date.now(),
                                cloud_id: this.options.cloud_id || null,
                                user_id: this.options.user_id || null,
                                user_id_type: this.options.user_id_type || null,
                                properties: properties
                            };
                        }
                    },
                    {
                        key: "decorateEventsWithType",
                        value: function decorateEventsWithType(postBody) {
                            if (!postBody.events) return;
                            postBody.events = postBody.events.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                            return postBody;
                        }
                    },
                    {
                        key: "updateOptions",
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                            this.setQueue(this.getQueue().map(function(queuedEvent) {
                                return _extends({}, queuedEvent, newOptions);
                            }));
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            return {
                                events: events
                            };
                        }
                    }
                ]);
                return GasAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.JiraAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for JIRA
 */ var JiraAnalytics = exports.JiraAnalytics = function(_CloudAnalytics) {
                _inherits(JiraAnalytics, _CloudAnalytics);
                function JiraAnalytics() {
                    _classCallCheck(this, JiraAnalytics);
                    return _possibleConstructorReturn(this, (JiraAnalytics.__proto__ || Object.getPrototypeOf(JiraAnalytics)).apply(this, arguments));
                }
                _createClass(JiraAnalytics, [
                    {
                        key: 'url',
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return JiraAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.dangerouslyCreateSafeString = exports.isSafeString = exports.markAsSafe = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _GasAnalytics = __webpack_require__(5);
            var _JiraAnalytics = __webpack_require__(6);
            var _ConfluenceAnalytics = __webpack_require__(4);
            var _PrivacySafeString = __webpack_require__(1);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * Get singleton Analytics Client that is appropriate for your product or app.
 */ var AnalyticsClientFactory = function() {
                function AnalyticsClientFactory() {
                    _classCallCheck(this, AnalyticsClientFactory);
                }
                _createClass(AnalyticsClientFactory, [
                    {
                        key: 'getGasClient',
                        /**
     * Get a Gas Analytics Client.
     * @param {object} options - {
     *  server: "String - required",
     *  product: "String - required",
     *  user: "String - required",
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {GasAnalytics}
     */ value: function getGasClient(options) {
                            if (this._gasClient) return this._gasClient;
                            return this._gasClient = new _GasAnalytics.GasAnalytics(options);
                        }
                    },
                    {
                        key: 'getJiraClient',
                        value: function getJiraClient(options) {
                            if (this._jiraClient) return this._jiraClient;
                            return this._jiraClient = new _JiraAnalytics.JiraAnalytics(options);
                        }
                    },
                    {
                        key: 'getConfluenceClient',
                        value: function getConfluenceClient(options) {
                            if (this._confluenceClient) return this._confluenceClient;
                            return this._confluenceClient = new _ConfluenceAnalytics.ConfluenceAnalytics(options);
                        }
                    }
                ]);
                return AnalyticsClientFactory;
            }();
            exports.default = new AnalyticsClientFactory();
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {...String} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString} - a function that will check if the value (argument) is in the list of allowedStrings
 */ var markAsSafe = exports.markAsSafe = _PrivacySafeString.markAsSafe;
            var isSafeString = exports.isSafeString = _PrivacySafeString.isSafeString;
            var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = _PrivacySafeString.dangerouslyCreateSafeString;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var _isSupported = null;
            /**
 * Light wrapper around navigator.sendBeacon()
 */ var Beacon = exports.Beacon = function() {
                function Beacon() {
                    _classCallCheck(this, Beacon);
                }
                _createClass(Beacon, null, [
                    {
                        key: 'sendAsJson',
                        /**
         * Send the specified object as JSON using Beacon API.
         *
         * See:
         * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
         * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
         *
         * Returns a boolean to indicate that the data was successfully queued.
         *
         * If we've exceeded our quota for sendBeacon on this page, this method
         * will return false.
         *
         * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
         *
         * @param url
         * @param object
         * @returns {boolean}
         */ value: function sendAsJson(url, object) {
                            var blob = new Blob([
                                JSON.stringify(object)
                            ], {
                                type: 'text/plain'
                            });
                            return navigator.sendBeacon(url, blob);
                        }
                    },
                    {
                        key: 'isSupported',
                        value: function isSupported() {
                            if (typeof _isSupported !== 'boolean') _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
                            return _isSupported;
                        }
                    },
                    {
                        key: 'isSendBeaconSupported',
                        value: function isSendBeaconSupported() {
                            // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
                            return 'sendBeacon' in navigator && typeof navigator.sendBeacon === 'function';
                        }
                    },
                    {
                        key: 'isBlobSupported',
                        value: function isBlobSupported() {
                            // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
                            try {
                                return new Blob(), true;
                            } catch (e) {
                                return false;
                            }
                        }
                    }
                ]);
                return Beacon;
            }();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Prettifier with a standard prefix for all log messages
 */ /*eslint no-console: 0*/ exports.default = {
                log: function log(message) {
                    console.log("%cAnalytics: " + message, "color: #0052CC; font-size: small");
                },
                warn: function warn(message) {
                    console.warn("%cAnalytics: " + message, "color: #DE350B; font-size: small");
                },
                error: function error(message) {
                    // This might not work in some browsers... but ignore this for now.
                    console.error("%cAnalytics: " + message, "color: #FF5630; font-size: small");
                }
            };
        /***/ }
    ]);
});

});

parcelRegister("kQqSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071ec5b1002c271c$export$2e2bcd8739ae039; });

var $jSnDV = parcelRequire("jSnDV");

var $kLQmS = parcelRequire("kLQmS");
const $071ec5b1002c271c$var$cache = new Map();
var $071ec5b1002c271c$export$2e2bcd8739ae039 = (url, options)=>{
    if (!$071ec5b1002c271c$var$cache.has(url)) $071ec5b1002c271c$var$cache.set(url, $071ec5b1002c271c$var$getOriginTracingAttributesFromUrl(url, options));
    return $071ec5b1002c271c$var$cache.get(url);
};
function $071ec5b1002c271c$var$getOriginTracingAttributesFromUrl(url, options) {
    let mapAttribute = (v)=>v;
    if (options && options.mapAttribute) mapAttribute = options.mapAttribute;
    let origin = (0, $kLQmS.default).createEmpty();
    try {
        const urlOrigin = (0, $kLQmS.default).fromUrl(url);
        const continueUrl = $071ec5b1002c271c$var$getQueryParam(url, 'continue');
        const continueOrigin = (0, $kLQmS.default).fromUrl(continueUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const destUrl = $071ec5b1002c271c$var$getQueryParam(continueUrl, 'dest-url');
        const destOrigin = (0, $kLQmS.default).fromUrl(destUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const nestedContinueUrl = $071ec5b1002c271c$var$getQueryParam(continueUrl, 'continue');
        const nestedContinueOrigin = (0, $kLQmS.default).fromUrl(nestedContinueUrl);
        origin = !urlOrigin.isEmpty() && urlOrigin || !continueOrigin.isEmpty() && continueOrigin || !destOrigin.isEmpty() && destOrigin || !nestedContinueOrigin.isEmpty() && nestedContinueOrigin || (0, $kLQmS.default).createEmpty();
    } catch (e) {
    //will fail only on malformed urls, we don't care about that
    }
    return origin.toAnalyticsAttributes({
        transformValue: mapAttribute
    });
}
function $071ec5b1002c271c$var$getQueryParam(url, paramName) {
    if (!url) return undefined;
    // Base is only needed for URL() to resolve relative paths. It could be arbitrary.
    const BASE = 'http://atlassian.com/';
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(new URL(url, BASE).search);
    return query[paramName] || undefined;
}

});
parcelRegister("jSnDV", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $e78566742ab5fae0$export$f9380c9a627682d3; }, function (v) { return $e78566742ab5fae0$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $e78566742ab5fae0$export$98e6a39c04603d36; }, function (v) { return $e78566742ab5fae0$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $e78566742ab5fae0$export$fac44ee5b035f737; }, function (v) { return $e78566742ab5fae0$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $e78566742ab5fae0$export$7a5253c0f62e0150; }, function (v) { return $e78566742ab5fae0$export$7a5253c0f62e0150 = v; });
var $e78566742ab5fae0$export$f9380c9a627682d3;
var $e78566742ab5fae0$export$98e6a39c04603d36;
var $e78566742ab5fae0$export$fac44ee5b035f737;
var $e78566742ab5fae0$export$7a5253c0f62e0150;
'use strict';

var $gOBOZ = parcelRequire("gOBOZ");

var $lir0C = parcelRequire("lir0C");

var $lPnyU = parcelRequire("lPnyU");
function $e78566742ab5fae0$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, index) {
                return value === null ? [
                    $e78566742ab5fae0$var$encode(key, opts),
                    '[',
                    index,
                    ']'
                ].join('') : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    '[',
                    $e78566742ab5fae0$var$encode(index, opts),
                    ']=',
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join('');
            };
        case 'bracket':
            return function(key, value) {
                return value === null ? $e78566742ab5fae0$var$encode(key, opts) : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    '[]=',
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join('');
            };
        default:
            return function(key, value) {
                return value === null ? $e78566742ab5fae0$var$encode(key, opts) : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    '=',
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join('');
            };
    }
}
function $e78566742ab5fae0$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case 'index':
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $e78566742ab5fae0$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $gOBOZ(value) : encodeURIComponent(value);
    return value;
}
function $e78566742ab5fae0$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === 'object') return $e78566742ab5fae0$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $e78566742ab5fae0$var$extract(str) {
    var queryStart = str.indexOf('?');
    if (queryStart === -1) return '';
    return str.slice(queryStart + 1);
}
function $e78566742ab5fae0$var$parse(str, opts) {
    opts = $lir0C({
        arrayFormat: 'none'
    }, opts);
    var formatter = $e78566742ab5fae0$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== 'string') return ret;
    str = str.trim().replace(/^[?#&]/, '');
    if (!str) return ret;
    str.split('&').forEach(function(param) {
        var parts = param.replace(/\+/g, ' ').split('=');
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join('=') : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $lPnyU(val);
        formatter($lPnyU(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $e78566742ab5fae0$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$e78566742ab5fae0$export$f9380c9a627682d3 = $e78566742ab5fae0$var$extract;
$e78566742ab5fae0$export$98e6a39c04603d36 = $e78566742ab5fae0$var$parse;
$e78566742ab5fae0$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: 'none'
    };
    opts = $lir0C(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $e78566742ab5fae0$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return '';
        if (val === null) return $e78566742ab5fae0$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join('&');
        }
        return $e78566742ab5fae0$var$encode(key, opts) + '=' + $e78566742ab5fae0$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join('&') : '';
};
$e78566742ab5fae0$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split('?')[0] || '',
        query: $e78566742ab5fae0$var$parse($e78566742ab5fae0$var$extract(str), opts)
    };
};

});
parcelRegister("gOBOZ", function(module, exports) {
'use strict';
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return '%' + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("lir0C", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $f8103adc227edd07$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f8103adc227edd07$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f8103adc227edd07$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f8103adc227edd07$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $f8103adc227edd07$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $f8103adc227edd07$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f8103adc227edd07$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f8103adc227edd07$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f8103adc227edd07$var$getOwnPropertySymbols) {
            symbols = $f8103adc227edd07$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f8103adc227edd07$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("kLQmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f0d1a0753c92bf$export$2e2bcd8739ae039; });

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $gaCcd = parcelRequire("gaCcd");

var $aOTJ4 = parcelRequire("aOTJ4");

var $fOkfd = parcelRequire("fOkfd");
function $f1f0d1a0753c92bf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f1f0d1a0753c92bf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, result);
    };
}
function $f1f0d1a0753c92bf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f1f0d1a0753c92bf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f1f0d1a0753c92bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1f0d1a0753c92bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1f0d1a0753c92bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1f0d1a0753c92bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1f0d1a0753c92bf$var$packageVersion = "6.1.5";
var $f1f0d1a0753c92bf$var$originParamName = 'atlOrigin';
var $f1f0d1a0753c92bf$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($f1f0d1a0753c92bf$var$packageVersion)
};
var $f1f0d1a0753c92bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $aOTJ4.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $f1f0d1a0753c92bf$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $fOkfd.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($f1f0d1a0753c92bf$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _objectSpread2;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? 'originIdGenerated' : 'originId';
                return $f1f0d1a0753c92bf$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, originIdProp, transformValue(this.id)), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError('Invalid Origin id');
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError('Missing/invalid Origin product');
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === 'string' && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                var id = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, '');
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $f1f0d1a0753c92bf$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $f1f0d1a0753c92bf$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $fOkfd.getEnv)()).URLSearchParams();
                $f1f0d1a0753c92bf$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $fOkfd.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($f1f0d1a0753c92bf$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $f1f0d1a0753c92bf$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $fOkfd.getEnv)()).URLSearchParams(queryString);
                    params.delete($f1f0d1a0753c92bf$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $aOTJ4.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
    return OriginTracer;
}();
var $f1f0d1a0753c92bf$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(EmptyOriginTracer, _OriginTracer);
    var _super = $f1f0d1a0753c92bf$var$_createSuper(EmptyOriginTracer);
    function EmptyOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, EmptyOriginTracer);
        return _super.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $f1f0d1a0753c92bf$var$_objectSpread({}, $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        }
    ]);
    return EmptyOriginTracer;
}($f1f0d1a0753c92bf$export$2e2bcd8739ae039);
var $f1f0d1a0753c92bf$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(MalformedOriginTracer, _OriginTracer2);
    var _super2 = $f1f0d1a0753c92bf$var$_createSuper(MalformedOriginTracer);
    function MalformedOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, MalformedOriginTracer);
        return _super2.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $f1f0d1a0753c92bf$var$_objectSpread({
                    originMalformed: true
                }, $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        }
    ]);
    return MalformedOriginTracer;
}($f1f0d1a0753c92bf$export$2e2bcd8739ae039);
function $f1f0d1a0753c92bf$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(_wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("aOTJ4", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $7e09cce1e858966f$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $7e09cce1e858966f$export$2f872c0f2117be69; });

var $c4OTP = parcelRequire("c4OTP");

var $fOkfd = parcelRequire("fOkfd");
var $7e09cce1e858966f$var$productShorthands = {
    confluence: 'c',
    jira: 'j',
    stride: 's',
    bitbucket: 'b',
    trello: 't'
};
function $7e09cce1e858966f$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($7e09cce1e858966f$export$4bc4b533a565aabe(originData));
    var base64 = (0, $fOkfd.getEnv)().btoa(json);
    return (0, $c4OTP.base64ToBase64Url)(base64);
}
function $7e09cce1e858966f$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $c4OTP.base64UrlToBase64)(encodedOriginString);
    var json = (0, $fOkfd.getEnv)().atob(base64);
    return $7e09cce1e858966f$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $7e09cce1e858966f$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $7e09cce1e858966f$var$productShorthands ? $7e09cce1e858966f$var$productShorthands[product] : product
    };
}
function $7e09cce1e858966f$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $7e09cce1e858966f$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $7e09cce1e858966f$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($7e09cce1e858966f$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $7e09cce1e858966f$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("c4OTP", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", function () { return $8cad57543df4384a$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $8cad57543df4384a$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $8cad57543df4384a$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return '';
    return String(base64).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
function $8cad57543df4384a$export$47c5265a25535d02(base64url) {
    if (base64url == null) return '';
    var base64 = String(base64url).replace(/-/g, '+').replace(/_/g, '/');
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = '==='.slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("fOkfd", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $b82b3aa01bd9c4ad$export$4bd44a2aa29d3d6e; });

var $bERfd = parcelRequire("bERfd");

var $b82b3aa01bd9c4ad$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === 'function' && atob.bind(undefined) || typeof (0, $bERfd.Buffer) !== 'undefined' && function(encoded) {
            return (0, $bERfd.Buffer).from(encoded, 'base64').toString();
        },
        btoa: typeof btoa === 'function' && btoa.bind(undefined) || typeof (0, $bERfd.Buffer) !== 'undefined' && function(str) {
            return (0, $bERfd.Buffer).from(str).toString('base64');
        },
        URLSearchParams: typeof URLSearchParams === 'function' && URLSearchParams || (0, (parcelRequire("jtc4e")).URLSearchParams)
    };
};
var $b82b3aa01bd9c4ad$var$env;
var $b82b3aa01bd9c4ad$export$4bd44a2aa29d3d6e = function getEnv() {
    return $b82b3aa01bd9c4ad$var$env || ($b82b3aa01bd9c4ad$var$env = $b82b3aa01bd9c4ad$var$validateEnv($b82b3aa01bd9c4ad$export$d3cd91e0fdbfdbc0()));
};
var $b82b3aa01bd9c4ad$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("bERfd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $87ccbb5a8215b715$export$a143d493d941bafc; }, function (v) { return $87ccbb5a8215b715$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $87ccbb5a8215b715$export$f99ded8fe4b79145; }, function (v) { return $87ccbb5a8215b715$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $87ccbb5a8215b715$export$a143d493d941bafc;
var $87ccbb5a8215b715$export$e4cf37d7f6fb9e0a;
var $87ccbb5a8215b715$export$f99ded8fe4b79145;
var $87ccbb5a8215b715$export$599f31c3813fae4d;
'use strict';

var $ayKrL = parcelRequire("ayKrL");

var $ego1F = parcelRequire("ego1F");
const $87ccbb5a8215b715$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$87ccbb5a8215b715$export$a143d493d941bafc = $87ccbb5a8215b715$var$Buffer;
$87ccbb5a8215b715$export$e4cf37d7f6fb9e0a = $87ccbb5a8215b715$var$SlowBuffer;
$87ccbb5a8215b715$export$f99ded8fe4b79145 = 50;
const $87ccbb5a8215b715$var$K_MAX_LENGTH = 0x7fffffff;
$87ccbb5a8215b715$export$599f31c3813fae4d = $87ccbb5a8215b715$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $87ccbb5a8215b715$var$Buffer.TYPED_ARRAY_SUPPORT = $87ccbb5a8215b715$var$typedArraySupport();
if (!$87ccbb5a8215b715$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $87ccbb5a8215b715$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($87ccbb5a8215b715$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$87ccbb5a8215b715$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($87ccbb5a8215b715$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$87ccbb5a8215b715$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $87ccbb5a8215b715$var$createBuffer(length) {
    if (length > $87ccbb5a8215b715$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $87ccbb5a8215b715$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $87ccbb5a8215b715$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $87ccbb5a8215b715$var$allocUnsafe(arg);
    }
    return $87ccbb5a8215b715$var$from(arg, encodingOrOffset, length);
}
$87ccbb5a8215b715$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $87ccbb5a8215b715$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $87ccbb5a8215b715$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $87ccbb5a8215b715$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($87ccbb5a8215b715$var$isInstance(value, ArrayBuffer) || value && $87ccbb5a8215b715$var$isInstance(value.buffer, ArrayBuffer)) return $87ccbb5a8215b715$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($87ccbb5a8215b715$var$isInstance(value, SharedArrayBuffer) || value && $87ccbb5a8215b715$var$isInstance(value.buffer, SharedArrayBuffer))) return $87ccbb5a8215b715$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $87ccbb5a8215b715$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $87ccbb5a8215b715$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $87ccbb5a8215b715$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $87ccbb5a8215b715$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $87ccbb5a8215b715$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($87ccbb5a8215b715$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($87ccbb5a8215b715$var$Buffer, Uint8Array);
function $87ccbb5a8215b715$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $87ccbb5a8215b715$var$alloc(size, fill, encoding) {
    $87ccbb5a8215b715$var$assertSize(size);
    if (size <= 0) return $87ccbb5a8215b715$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $87ccbb5a8215b715$var$createBuffer(size).fill(fill, encoding) : $87ccbb5a8215b715$var$createBuffer(size).fill(fill);
    return $87ccbb5a8215b715$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $87ccbb5a8215b715$var$Buffer.alloc = function(size, fill, encoding) {
    return $87ccbb5a8215b715$var$alloc(size, fill, encoding);
};
function $87ccbb5a8215b715$var$allocUnsafe(size) {
    $87ccbb5a8215b715$var$assertSize(size);
    return $87ccbb5a8215b715$var$createBuffer(size < 0 ? 0 : $87ccbb5a8215b715$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $87ccbb5a8215b715$var$Buffer.allocUnsafe = function(size) {
    return $87ccbb5a8215b715$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $87ccbb5a8215b715$var$Buffer.allocUnsafeSlow = function(size) {
    return $87ccbb5a8215b715$var$allocUnsafe(size);
};
function $87ccbb5a8215b715$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$87ccbb5a8215b715$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $87ccbb5a8215b715$var$byteLength(string, encoding) | 0;
    let buf = $87ccbb5a8215b715$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $87ccbb5a8215b715$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $87ccbb5a8215b715$var$checked(array.length) | 0;
    const buf = $87ccbb5a8215b715$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $87ccbb5a8215b715$var$fromArrayView(arrayView) {
    if ($87ccbb5a8215b715$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $87ccbb5a8215b715$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $87ccbb5a8215b715$var$fromArrayLike(arrayView);
}
function $87ccbb5a8215b715$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $87ccbb5a8215b715$var$Buffer.prototype);
    return buf;
}
function $87ccbb5a8215b715$var$fromObject(obj) {
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(obj)) {
        const len = $87ccbb5a8215b715$var$checked(obj.length) | 0;
        const buf = $87ccbb5a8215b715$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $87ccbb5a8215b715$var$numberIsNaN(obj.length)) return $87ccbb5a8215b715$var$createBuffer(0);
        return $87ccbb5a8215b715$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $87ccbb5a8215b715$var$fromArrayLike(obj.data);
}
function $87ccbb5a8215b715$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $87ccbb5a8215b715$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $87ccbb5a8215b715$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $87ccbb5a8215b715$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $87ccbb5a8215b715$var$Buffer.alloc(+length);
}
$87ccbb5a8215b715$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $87ccbb5a8215b715$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$87ccbb5a8215b715$var$Buffer.compare = function compare(a, b) {
    if ($87ccbb5a8215b715$var$isInstance(a, Uint8Array)) a = $87ccbb5a8215b715$var$Buffer.from(a, a.offset, a.byteLength);
    if ($87ccbb5a8215b715$var$isInstance(b, Uint8Array)) b = $87ccbb5a8215b715$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(a) || !$87ccbb5a8215b715$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$87ccbb5a8215b715$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$87ccbb5a8215b715$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $87ccbb5a8215b715$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $87ccbb5a8215b715$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($87ccbb5a8215b715$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) buf = $87ccbb5a8215b715$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $87ccbb5a8215b715$var$byteLength(string, encoding) {
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $87ccbb5a8215b715$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $87ccbb5a8215b715$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $87ccbb5a8215b715$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $87ccbb5a8215b715$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$87ccbb5a8215b715$var$Buffer.byteLength = $87ccbb5a8215b715$var$byteLength;
function $87ccbb5a8215b715$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $87ccbb5a8215b715$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $87ccbb5a8215b715$var$utf8Slice(this, start, end);
        case 'ascii':
            return $87ccbb5a8215b715$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $87ccbb5a8215b715$var$latin1Slice(this, start, end);
        case 'base64':
            return $87ccbb5a8215b715$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $87ccbb5a8215b715$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$87ccbb5a8215b715$var$Buffer.prototype._isBuffer = true;
function $87ccbb5a8215b715$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$87ccbb5a8215b715$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$87ccbb5a8215b715$var$swap(this, i, i + 1);
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $87ccbb5a8215b715$var$swap(this, i, i + 3);
        $87ccbb5a8215b715$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $87ccbb5a8215b715$var$swap(this, i, i + 7);
        $87ccbb5a8215b715$var$swap(this, i + 1, i + 6);
        $87ccbb5a8215b715$var$swap(this, i + 2, i + 5);
        $87ccbb5a8215b715$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $87ccbb5a8215b715$var$utf8Slice(this, 0, length);
    return $87ccbb5a8215b715$var$slowToString.apply(this, arguments);
};
$87ccbb5a8215b715$var$Buffer.prototype.toLocaleString = $87ccbb5a8215b715$var$Buffer.prototype.toString;
$87ccbb5a8215b715$var$Buffer.prototype.equals = function equals(b) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $87ccbb5a8215b715$var$Buffer.compare(this, b) === 0;
};
$87ccbb5a8215b715$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $87ccbb5a8215b715$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($87ccbb5a8215b715$var$customInspectSymbol) $87ccbb5a8215b715$var$Buffer.prototype[$87ccbb5a8215b715$var$customInspectSymbol] = $87ccbb5a8215b715$var$Buffer.prototype.inspect;
$87ccbb5a8215b715$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($87ccbb5a8215b715$var$isInstance(target, Uint8Array)) target = $87ccbb5a8215b715$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $87ccbb5a8215b715$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($87ccbb5a8215b715$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $87ccbb5a8215b715$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $87ccbb5a8215b715$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $87ccbb5a8215b715$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $87ccbb5a8215b715$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$87ccbb5a8215b715$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$87ccbb5a8215b715$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $87ccbb5a8215b715$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$87ccbb5a8215b715$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $87ccbb5a8215b715$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $87ccbb5a8215b715$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($87ccbb5a8215b715$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $87ccbb5a8215b715$var$utf8Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $87ccbb5a8215b715$var$asciiWrite(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$asciiToBytes(string), buf, offset, length);
}
function $87ccbb5a8215b715$var$base64Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$base64ToBytes(string), buf, offset, length);
}
function $87ccbb5a8215b715$var$ucs2Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$87ccbb5a8215b715$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $87ccbb5a8215b715$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $87ccbb5a8215b715$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $87ccbb5a8215b715$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $87ccbb5a8215b715$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $87ccbb5a8215b715$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$87ccbb5a8215b715$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $87ccbb5a8215b715$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ayKrL.fromByteArray(buf);
    else return $ayKrL.fromByteArray(buf.slice(start, end));
}
function $87ccbb5a8215b715$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $87ccbb5a8215b715$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $87ccbb5a8215b715$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $87ccbb5a8215b715$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $87ccbb5a8215b715$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $87ccbb5a8215b715$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $87ccbb5a8215b715$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $87ccbb5a8215b715$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$87ccbb5a8215b715$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $87ccbb5a8215b715$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $87ccbb5a8215b715$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$87ccbb5a8215b715$var$Buffer.prototype.readUintLE = $87ccbb5a8215b715$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUintBE = $87ccbb5a8215b715$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint8 = $87ccbb5a8215b715$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint16LE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint16BE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint32LE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint32BE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$87ccbb5a8215b715$var$Buffer.prototype.readBigUInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$87ccbb5a8215b715$var$Buffer.prototype.readBigUInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$87ccbb5a8215b715$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$87ccbb5a8215b715$var$Buffer.prototype.readBigInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$87ccbb5a8215b715$var$Buffer.prototype.readBigInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$87ccbb5a8215b715$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return $ego1F.read(this, offset, true, 23, 4);
};
$87ccbb5a8215b715$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return $ego1F.read(this, offset, false, 23, 4);
};
$87ccbb5a8215b715$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 8, this.length);
    return $ego1F.read(this, offset, true, 52, 8);
};
$87ccbb5a8215b715$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 8, this.length);
    return $ego1F.read(this, offset, false, 52, 8);
};
function $87ccbb5a8215b715$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$87ccbb5a8215b715$var$Buffer.prototype.writeUintLE = $87ccbb5a8215b715$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUintBE = $87ccbb5a8215b715$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint8 = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint16LE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint16BE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint32LE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint32BE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $87ccbb5a8215b715$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $87ccbb5a8215b715$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeBigUInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeBigUInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeBigInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeBigInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $87ccbb5a8215b715$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ego1F.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeFloat(this, value, offset, true, noAssert);
};
$87ccbb5a8215b715$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeFloat(this, value, offset, false, noAssert);
};
function $87ccbb5a8215b715$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ego1F.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeDouble(this, value, offset, true, noAssert);
};
$87ccbb5a8215b715$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$87ccbb5a8215b715$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$87ccbb5a8215b715$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$87ccbb5a8215b715$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $87ccbb5a8215b715$var$Buffer.isBuffer(val) ? val : $87ccbb5a8215b715$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $87ccbb5a8215b715$var$errors = {};
function $87ccbb5a8215b715$var$E(sym, getMessage, Base) {
    $87ccbb5a8215b715$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$87ccbb5a8215b715$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$87ccbb5a8215b715$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$87ccbb5a8215b715$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $87ccbb5a8215b715$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $87ccbb5a8215b715$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $87ccbb5a8215b715$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $87ccbb5a8215b715$var$checkBounds(buf, offset, byteLength) {
    $87ccbb5a8215b715$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $87ccbb5a8215b715$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $87ccbb5a8215b715$var$checkBounds(buf, offset, byteLength);
}
function $87ccbb5a8215b715$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $87ccbb5a8215b715$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $87ccbb5a8215b715$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $87ccbb5a8215b715$var$validateNumber(value, type);
        throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $87ccbb5a8215b715$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $87ccbb5a8215b715$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $87ccbb5a8215b715$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($87ccbb5a8215b715$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $87ccbb5a8215b715$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $87ccbb5a8215b715$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $87ccbb5a8215b715$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $87ccbb5a8215b715$var$base64ToBytes(str) {
    return $ayKrL.toByteArray($87ccbb5a8215b715$var$base64clean(str));
}
function $87ccbb5a8215b715$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $87ccbb5a8215b715$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $87ccbb5a8215b715$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $87ccbb5a8215b715$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $87ccbb5a8215b715$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $87ccbb5a8215b715$var$BufferBigIntNotDefined : fn;
}
function $87ccbb5a8215b715$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("ayKrL", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $7b011bb862b1802d$export$d622b2ad8d90c771; }, function (v) { return $7b011bb862b1802d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $7b011bb862b1802d$export$6100ba28696e12de; }, function (v) { return $7b011bb862b1802d$export$6100ba28696e12de = v; });
var $7b011bb862b1802d$export$a48f0734ac7c2329;
var $7b011bb862b1802d$export$d622b2ad8d90c771;
var $7b011bb862b1802d$export$6100ba28696e12de;
'use strict';
$7b011bb862b1802d$export$a48f0734ac7c2329 = $7b011bb862b1802d$var$byteLength;
$7b011bb862b1802d$export$d622b2ad8d90c771 = $7b011bb862b1802d$var$toByteArray;
$7b011bb862b1802d$export$6100ba28696e12de = $7b011bb862b1802d$var$fromByteArray;
var $7b011bb862b1802d$var$lookup = [];
var $7b011bb862b1802d$var$revLookup = [];
var $7b011bb862b1802d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $7b011bb862b1802d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $7b011bb862b1802d$var$i = 0, $7b011bb862b1802d$var$len = $7b011bb862b1802d$var$code.length; $7b011bb862b1802d$var$i < $7b011bb862b1802d$var$len; ++$7b011bb862b1802d$var$i){
    $7b011bb862b1802d$var$lookup[$7b011bb862b1802d$var$i] = $7b011bb862b1802d$var$code[$7b011bb862b1802d$var$i];
    $7b011bb862b1802d$var$revLookup[$7b011bb862b1802d$var$code.charCodeAt($7b011bb862b1802d$var$i)] = $7b011bb862b1802d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7b011bb862b1802d$var$revLookup['-'.charCodeAt(0)] = 62;
$7b011bb862b1802d$var$revLookup['_'.charCodeAt(0)] = 63;
function $7b011bb862b1802d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7b011bb862b1802d$var$byteLength(b64) {
    var lens = $7b011bb862b1802d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b011bb862b1802d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b011bb862b1802d$var$toByteArray(b64) {
    var tmp;
    var lens = $7b011bb862b1802d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7b011bb862b1802d$var$Arr($7b011bb862b1802d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 18 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 2 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 10 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7b011bb862b1802d$var$tripletToBase64(num) {
    return $7b011bb862b1802d$var$lookup[num >> 18 & 0x3F] + $7b011bb862b1802d$var$lookup[num >> 12 & 0x3F] + $7b011bb862b1802d$var$lookup[num >> 6 & 0x3F] + $7b011bb862b1802d$var$lookup[num & 0x3F];
}
function $7b011bb862b1802d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7b011bb862b1802d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $7b011bb862b1802d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7b011bb862b1802d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7b011bb862b1802d$var$lookup[tmp >> 2] + $7b011bb862b1802d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7b011bb862b1802d$var$lookup[tmp >> 10] + $7b011bb862b1802d$var$lookup[tmp >> 4 & 0x3F] + $7b011bb862b1802d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ego1F", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $a625325f636fb803$export$aafa59e2e03f2942; }, function (v) { return $a625325f636fb803$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $a625325f636fb803$export$68d8715fc104d294; }, function (v) { return $a625325f636fb803$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a625325f636fb803$export$aafa59e2e03f2942;
var $a625325f636fb803$export$68d8715fc104d294;
$a625325f636fb803$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a625325f636fb803$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("jtc4e", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ 'use strict';

var $CqzF9 = parcelRequire("CqzF9");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    '\''
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat(autoEscape), hostEndingChars = [
    '/',
    '?',
    '#'
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    'javascript:': true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};

var $2PCIc = parcelRequire("2PCIc");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === 'object' && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== 'string') throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2PCIc.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf('@', hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || '';
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = '/' + notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = '';
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $CqzF9.toASCII(this.hostname);
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') rest = '/' + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2PCIc.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '/';
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === 'string') obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) host += ':' + this.port;
    }
    if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) query = $2PCIc.stringify(this.query, {
        arrayFormat: 'repeat',
        addQueryPrefix: false
    });
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':') protocol += ':';
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
    } else if (!host) host = '';
    if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
    if (search && search.charAt(0) !== '?') search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === 'string') {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== 'protocol') result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = '/';
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = '';
            if (!relative.hostname) relative.hostname = '';
            if (relPath[0] !== '') relPath.unshift('');
            if (relPath.length < 2) relPath.unshift('');
            result.pathname = relPath.join('/');
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '') srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '') relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = '/' + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === '.') srcPath.splice(i, 1);
        else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift('..');
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) srcPath.unshift('');
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') srcPath.push('');
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift('');
    if (srcPath.length > 0) result.pathname = srcPath.join('/');
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("CqzF9", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2PCIc", function(module, exports) {
'use strict';

var $43tWe = parcelRequire("43tWe");

var $7qo3i = parcelRequire("7qo3i");

var $3Y0nC = parcelRequire("3Y0nC");
module.exports = {
    formats: $3Y0nC,
    parse: $7qo3i,
    stringify: $43tWe
};

});
parcelRegister("43tWe", function(module, exports) {
'use strict';

var $5qr0W = parcelRequire("5qr0W");

var $jwHUs = parcelRequire("jwHUs");

var $3Y0nC = parcelRequire("3Y0nC");
var $2f3eaa5b844f0ec5$var$has = Object.prototype.hasOwnProperty;
var $2f3eaa5b844f0ec5$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $2f3eaa5b844f0ec5$var$isArray = Array.isArray;
var $2f3eaa5b844f0ec5$var$push = Array.prototype.push;
var $2f3eaa5b844f0ec5$var$pushToArray = function(arr, valueOrArray) {
    $2f3eaa5b844f0ec5$var$push.apply(arr, $2f3eaa5b844f0ec5$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $2f3eaa5b844f0ec5$var$toISO = Date.prototype.toISOString;
var $2f3eaa5b844f0ec5$var$defaultFormat = $3Y0nC.default;
var $2f3eaa5b844f0ec5$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: $jwHUs.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $2f3eaa5b844f0ec5$var$defaultFormat,
    formatter: $3Y0nC.formatters[$2f3eaa5b844f0ec5$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $2f3eaa5b844f0ec5$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $2f3eaa5b844f0ec5$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $2f3eaa5b844f0ec5$var$sentinel = {};
var $2f3eaa5b844f0ec5$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($2f3eaa5b844f0ec5$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($2f3eaa5b844f0ec5$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $2f3eaa5b844f0ec5$var$isArray(obj)) obj = $jwHUs.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($2f3eaa5b844f0ec5$var$isNonNullishPrimitive(obj) || $jwHUs.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $2f3eaa5b844f0ec5$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $jwHUs.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($2f3eaa5b844f0ec5$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $2f3eaa5b844f0ec5$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $2f3eaa5b844f0ec5$var$isArray(obj) && obj.length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $2f3eaa5b844f0ec5$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $5qr0W();
        valueSideChannel.set($2f3eaa5b844f0ec5$var$sentinel, sideChannel);
        $2f3eaa5b844f0ec5$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $2f3eaa5b844f0ec5$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $2f3eaa5b844f0ec5$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $2f3eaa5b844f0ec5$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $2f3eaa5b844f0ec5$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $3Y0nC.default;
    if (typeof opts.format !== 'undefined') {
        if (!$2f3eaa5b844f0ec5$var$has.call($3Y0nC.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $3Y0nC.formatters[format];
    var filter = $2f3eaa5b844f0ec5$var$defaults.filter;
    if (typeof opts.filter === 'function' || $2f3eaa5b844f0ec5$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $2f3eaa5b844f0ec5$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $2f3eaa5b844f0ec5$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $2f3eaa5b844f0ec5$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $2f3eaa5b844f0ec5$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $2f3eaa5b844f0ec5$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $2f3eaa5b844f0ec5$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $2f3eaa5b844f0ec5$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $2f3eaa5b844f0ec5$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $2f3eaa5b844f0ec5$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $2f3eaa5b844f0ec5$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $2f3eaa5b844f0ec5$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $2f3eaa5b844f0ec5$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $2f3eaa5b844f0ec5$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $2f3eaa5b844f0ec5$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $2f3eaa5b844f0ec5$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($2f3eaa5b844f0ec5$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $2f3eaa5b844f0ec5$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $5qr0W();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        $2f3eaa5b844f0ec5$var$pushToArray(keys, $2f3eaa5b844f0ec5$var$stringify(value, key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("5qr0W", function(module, exports) {
'use strict';

var $awICJ = parcelRequire("awICJ");

var $7W61V = parcelRequire("7W61V");

var $9Pb08 = parcelRequire("9Pb08");

var $aENim = parcelRequire("aENim");

var $9ZgWt = parcelRequire("9ZgWt");
var $3f3455eb56ed33c9$var$makeChannel = $9ZgWt || $aENim || $9Pb08;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $awICJ('Side channel does not contain ' + $7W61V(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $3f3455eb56ed33c9$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("awICJ", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("7W61V", function(module, exports) {
var $5c72a0a07d18d12b$var$hasMap = typeof Map === 'function' && Map.prototype;
var $5c72a0a07d18d12b$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $5c72a0a07d18d12b$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $5c72a0a07d18d12b$var$mapSize = $5c72a0a07d18d12b$var$hasMap && $5c72a0a07d18d12b$var$mapSizeDescriptor && typeof $5c72a0a07d18d12b$var$mapSizeDescriptor.get === 'function' ? $5c72a0a07d18d12b$var$mapSizeDescriptor.get : null;
var $5c72a0a07d18d12b$var$mapForEach = $5c72a0a07d18d12b$var$hasMap && Map.prototype.forEach;
var $5c72a0a07d18d12b$var$hasSet = typeof Set === 'function' && Set.prototype;
var $5c72a0a07d18d12b$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $5c72a0a07d18d12b$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $5c72a0a07d18d12b$var$setSize = $5c72a0a07d18d12b$var$hasSet && $5c72a0a07d18d12b$var$setSizeDescriptor && typeof $5c72a0a07d18d12b$var$setSizeDescriptor.get === 'function' ? $5c72a0a07d18d12b$var$setSizeDescriptor.get : null;
var $5c72a0a07d18d12b$var$setForEach = $5c72a0a07d18d12b$var$hasSet && Set.prototype.forEach;
var $5c72a0a07d18d12b$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $5c72a0a07d18d12b$var$weakMapHas = $5c72a0a07d18d12b$var$hasWeakMap ? WeakMap.prototype.has : null;
var $5c72a0a07d18d12b$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $5c72a0a07d18d12b$var$weakSetHas = $5c72a0a07d18d12b$var$hasWeakSet ? WeakSet.prototype.has : null;
var $5c72a0a07d18d12b$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $5c72a0a07d18d12b$var$weakRefDeref = $5c72a0a07d18d12b$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $5c72a0a07d18d12b$var$booleanValueOf = Boolean.prototype.valueOf;
var $5c72a0a07d18d12b$var$objectToString = Object.prototype.toString;
var $5c72a0a07d18d12b$var$functionToString = Function.prototype.toString;
var $5c72a0a07d18d12b$var$$match = String.prototype.match;
var $5c72a0a07d18d12b$var$$slice = String.prototype.slice;
var $5c72a0a07d18d12b$var$$replace = String.prototype.replace;
var $5c72a0a07d18d12b$var$$toUpperCase = String.prototype.toUpperCase;
var $5c72a0a07d18d12b$var$$toLowerCase = String.prototype.toLowerCase;
var $5c72a0a07d18d12b$var$$test = RegExp.prototype.test;
var $5c72a0a07d18d12b$var$$concat = Array.prototype.concat;
var $5c72a0a07d18d12b$var$$join = Array.prototype.join;
var $5c72a0a07d18d12b$var$$arrSlice = Array.prototype.slice;
var $5c72a0a07d18d12b$var$$floor = Math.floor;
var $5c72a0a07d18d12b$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $5c72a0a07d18d12b$var$gOPS = Object.getOwnPropertySymbols;
var $5c72a0a07d18d12b$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $5c72a0a07d18d12b$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $5c72a0a07d18d12b$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $5c72a0a07d18d12b$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $5c72a0a07d18d12b$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $5c72a0a07d18d12b$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $5c72a0a07d18d12b$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $5c72a0a07d18d12b$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$5c72a0a07d18d12b$var$$floor(-num) : $5c72a0a07d18d12b$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $5c72a0a07d18d12b$var$$slice.call(str, intStr.length + 1);
            return $5c72a0a07d18d12b$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $5c72a0a07d18d12b$var$$replace.call($5c72a0a07d18d12b$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $5c72a0a07d18d12b$var$$replace.call(str, sepRegex, '$&_');
}

var $lRV8A = parcelRequire("lRV8A");
var $5c72a0a07d18d12b$var$inspectCustom = $lRV8A.custom;
var $5c72a0a07d18d12b$var$inspectSymbol = $5c72a0a07d18d12b$var$isSymbol($5c72a0a07d18d12b$var$inspectCustom) ? $5c72a0a07d18d12b$var$inspectCustom : null;
var $5c72a0a07d18d12b$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $5c72a0a07d18d12b$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($5c72a0a07d18d12b$var$has(opts, 'quoteStyle') && !$5c72a0a07d18d12b$var$has($5c72a0a07d18d12b$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($5c72a0a07d18d12b$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $5c72a0a07d18d12b$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($5c72a0a07d18d12b$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($5c72a0a07d18d12b$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $5c72a0a07d18d12b$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $5c72a0a07d18d12b$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $5c72a0a07d18d12b$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $5c72a0a07d18d12b$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $5c72a0a07d18d12b$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($5c72a0a07d18d12b$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $5c72a0a07d18d12b$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($5c72a0a07d18d12b$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$5c72a0a07d18d12b$var$isRegExp(obj)) {
        var name = $5c72a0a07d18d12b$var$nameOf(obj);
        var keys = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $5c72a0a07d18d12b$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($5c72a0a07d18d12b$var$isSymbol(obj)) {
        var symString = $5c72a0a07d18d12b$var$hasShammedSymbols ? $5c72a0a07d18d12b$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $5c72a0a07d18d12b$var$symToString.call(obj);
        return typeof obj === 'object' && !$5c72a0a07d18d12b$var$hasShammedSymbols ? $5c72a0a07d18d12b$var$markBoxed(symString) : symString;
    }
    if ($5c72a0a07d18d12b$var$isElement(obj)) {
        var s = '<' + $5c72a0a07d18d12b$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $5c72a0a07d18d12b$var$wrapQuotes($5c72a0a07d18d12b$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $5c72a0a07d18d12b$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($5c72a0a07d18d12b$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        if (indent && !$5c72a0a07d18d12b$var$singleLineValues(xs)) return '[' + $5c72a0a07d18d12b$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $5c72a0a07d18d12b$var$$join.call(xs, ', ') + ' ]';
    }
    if ($5c72a0a07d18d12b$var$isError(obj)) {
        var parts = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$5c72a0a07d18d12b$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $5c72a0a07d18d12b$var$$join.call($5c72a0a07d18d12b$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $5c72a0a07d18d12b$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($5c72a0a07d18d12b$var$inspectSymbol && typeof obj[$5c72a0a07d18d12b$var$inspectSymbol] === 'function' && $lRV8A) return $lRV8A(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($5c72a0a07d18d12b$var$isMap(obj)) {
        var mapParts = [];
        if ($5c72a0a07d18d12b$var$mapForEach) $5c72a0a07d18d12b$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $5c72a0a07d18d12b$var$collectionOf('Map', $5c72a0a07d18d12b$var$mapSize.call(obj), mapParts, indent);
    }
    if ($5c72a0a07d18d12b$var$isSet(obj)) {
        var setParts = [];
        if ($5c72a0a07d18d12b$var$setForEach) $5c72a0a07d18d12b$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $5c72a0a07d18d12b$var$collectionOf('Set', $5c72a0a07d18d12b$var$setSize.call(obj), setParts, indent);
    }
    if ($5c72a0a07d18d12b$var$isWeakMap(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf('WeakMap');
    if ($5c72a0a07d18d12b$var$isWeakSet(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf('WeakSet');
    if ($5c72a0a07d18d12b$var$isWeakRef(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf('WeakRef');
    if ($5c72a0a07d18d12b$var$isNumber(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect(Number(obj)));
    if ($5c72a0a07d18d12b$var$isBigInt(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect($5c72a0a07d18d12b$var$bigIntValueOf.call(obj)));
    if ($5c72a0a07d18d12b$var$isBoolean(obj)) return $5c72a0a07d18d12b$var$markBoxed($5c72a0a07d18d12b$var$booleanValueOf.call(obj));
    if ($5c72a0a07d18d12b$var$isString(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$5c72a0a07d18d12b$var$isDate(obj) && !$5c72a0a07d18d12b$var$isRegExp(obj)) {
        var ys = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        var isPlainObject = $5c72a0a07d18d12b$var$gPO ? $5c72a0a07d18d12b$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $5c72a0a07d18d12b$var$toStringTag && Object(obj) === obj && $5c72a0a07d18d12b$var$toStringTag in obj ? $5c72a0a07d18d12b$var$$slice.call($5c72a0a07d18d12b$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $5c72a0a07d18d12b$var$$join.call($5c72a0a07d18d12b$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $5c72a0a07d18d12b$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $5c72a0a07d18d12b$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $5c72a0a07d18d12b$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $5c72a0a07d18d12b$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $5c72a0a07d18d12b$var$quote(s) {
    return $5c72a0a07d18d12b$var$$replace.call(String(s), /"/g, '&quot;');
}
function $5c72a0a07d18d12b$var$canTrustToString(obj) {
    return !$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === 'object' && ($5c72a0a07d18d12b$var$toStringTag in obj || typeof obj[$5c72a0a07d18d12b$var$toStringTag] !== 'undefined'));
}
function $5c72a0a07d18d12b$var$isArray(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object Array]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isDate(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object Date]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isRegExp(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object RegExp]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isError(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object Error]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isString(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object String]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isNumber(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object Number]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
function $5c72a0a07d18d12b$var$isBoolean(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === '[object Boolean]' && $5c72a0a07d18d12b$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $5c72a0a07d18d12b$var$isSymbol(obj) {
    if ($5c72a0a07d18d12b$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$5c72a0a07d18d12b$var$symToString) return false;
    try {
        $5c72a0a07d18d12b$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$5c72a0a07d18d12b$var$bigIntValueOf) return false;
    try {
        $5c72a0a07d18d12b$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $5c72a0a07d18d12b$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $5c72a0a07d18d12b$var$has(obj, key) {
    return $5c72a0a07d18d12b$var$hasOwn.call(obj, key);
}
function $5c72a0a07d18d12b$var$toStr(obj) {
    return $5c72a0a07d18d12b$var$objectToString.call(obj);
}
function $5c72a0a07d18d12b$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $5c72a0a07d18d12b$var$$match.call($5c72a0a07d18d12b$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $5c72a0a07d18d12b$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $5c72a0a07d18d12b$var$isMap(x) {
    if (!$5c72a0a07d18d12b$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $5c72a0a07d18d12b$var$mapSize.call(x);
        try {
            $5c72a0a07d18d12b$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakMap(x) {
    if (!$5c72a0a07d18d12b$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $5c72a0a07d18d12b$var$weakMapHas.call(x, $5c72a0a07d18d12b$var$weakMapHas);
        try {
            $5c72a0a07d18d12b$var$weakSetHas.call(x, $5c72a0a07d18d12b$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakRef(x) {
    if (!$5c72a0a07d18d12b$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $5c72a0a07d18d12b$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isSet(x) {
    if (!$5c72a0a07d18d12b$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $5c72a0a07d18d12b$var$setSize.call(x);
        try {
            $5c72a0a07d18d12b$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakSet(x) {
    if (!$5c72a0a07d18d12b$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $5c72a0a07d18d12b$var$weakSetHas.call(x, $5c72a0a07d18d12b$var$weakSetHas);
        try {
            $5c72a0a07d18d12b$var$weakMapHas.call(x, $5c72a0a07d18d12b$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $5c72a0a07d18d12b$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $5c72a0a07d18d12b$var$inspectString($5c72a0a07d18d12b$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $5c72a0a07d18d12b$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $5c72a0a07d18d12b$var$$replace.call($5c72a0a07d18d12b$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $5c72a0a07d18d12b$var$lowbyte);
    return $5c72a0a07d18d12b$var$wrapQuotes(s, 'single', opts);
}
function $5c72a0a07d18d12b$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $5c72a0a07d18d12b$var$$toUpperCase.call(n.toString(16));
}
function $5c72a0a07d18d12b$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $5c72a0a07d18d12b$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $5c72a0a07d18d12b$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $5c72a0a07d18d12b$var$indentedJoin(entries, indent) : $5c72a0a07d18d12b$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $5c72a0a07d18d12b$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($5c72a0a07d18d12b$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $5c72a0a07d18d12b$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $5c72a0a07d18d12b$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $5c72a0a07d18d12b$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $5c72a0a07d18d12b$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $5c72a0a07d18d12b$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect) {
    var isArr = $5c72a0a07d18d12b$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $5c72a0a07d18d12b$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $5c72a0a07d18d12b$var$gOPS === 'function' ? $5c72a0a07d18d12b$var$gOPS(obj) : [];
    var symMap;
    if ($5c72a0a07d18d12b$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$5c72a0a07d18d12b$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($5c72a0a07d18d12b$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($5c72a0a07d18d12b$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $5c72a0a07d18d12b$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($5c72a0a07d18d12b$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("lRV8A", function(module, exports) {
"use strict";

});


parcelRegister("9Pb08", function(module, exports) {
'use strict';

var $7W61V = parcelRequire("7W61V");

var $awICJ = parcelRequire("awICJ");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $72716912611567ac$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $72716912611567ac$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $72716912611567ac$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $72716912611567ac$var$listSet = function(objects, key, value) {
    var node = $72716912611567ac$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $72716912611567ac$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$72716912611567ac$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $72716912611567ac$var$listDelete = function(objects, key) {
    if (objects) return $72716912611567ac$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $awICJ('Side channel does not contain ' + $7W61V(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $72716912611567ac$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $72716912611567ac$var$listGet($o, key);
        },
        has: function(key) {
            return $72716912611567ac$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $72716912611567ac$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("aENim", function(module, exports) {
'use strict';

var $5PyeX = parcelRequire("5PyeX");

var $RkYUA = parcelRequire("RkYUA");

var $7W61V = parcelRequire("7W61V");

var $awICJ = parcelRequire("awICJ");
var $7c23e0c8015f2cf6$var$$Map = $5PyeX('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $7c23e0c8015f2cf6$var$$mapGet = $RkYUA('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $7c23e0c8015f2cf6$var$$mapSet = $RkYUA('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7c23e0c8015f2cf6$var$$mapHas = $RkYUA('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $7c23e0c8015f2cf6$var$$mapDelete = $RkYUA('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $7c23e0c8015f2cf6$var$$mapSize = $RkYUA('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$7c23e0c8015f2cf6$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $awICJ('Side channel does not contain ' + $7W61V(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $7c23e0c8015f2cf6$var$$mapDelete($m, key);
                if ($7c23e0c8015f2cf6$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $7c23e0c8015f2cf6$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $7c23e0c8015f2cf6$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $7c23e0c8015f2cf6$var$$Map();
            $7c23e0c8015f2cf6$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("5PyeX", function(module, exports) {
'use strict';
var $43ec468c529faf46$var$undefined1;

var $18Bve = parcelRequire("18Bve");

var $7UHmp = parcelRequire("7UHmp");

var $7T6Bh = parcelRequire("7T6Bh");

var $ifeGt = parcelRequire("ifeGt");

var $kEzhq = parcelRequire("kEzhq");

var $laFZ2 = parcelRequire("laFZ2");

var $awICJ = parcelRequire("awICJ");

var $eIXnd = parcelRequire("eIXnd");

var $dtDoX = parcelRequire("dtDoX");

var $10xIE = parcelRequire("10xIE");

var $lzF3y = parcelRequire("lzF3y");

var $3nIuz = parcelRequire("3nIuz");

var $OrKlf = parcelRequire("OrKlf");

var $34Tzp = parcelRequire("34Tzp");

var $9GWFT = parcelRequire("9GWFT");
var $43ec468c529faf46$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $43ec468c529faf46$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $43ec468c529faf46$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $jULaB = parcelRequire("jULaB");

var $9Sh5q = parcelRequire("9Sh5q");
var $43ec468c529faf46$var$throwTypeError = function() {
    throw new $awICJ();
};
var $43ec468c529faf46$var$ThrowTypeError = $jULaB ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $43ec468c529faf46$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $jULaB(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $43ec468c529faf46$var$throwTypeError;
        }
    }
}() : $43ec468c529faf46$var$throwTypeError;

var $43ec468c529faf46$var$hasSymbols = (parcelRequire("3U9bK"))();

var $3Lkl7 = parcelRequire("3Lkl7");

var $dkH2k = parcelRequire("dkH2k");

var $aVwUH = parcelRequire("aVwUH");

var $17vHV = parcelRequire("17vHV");

var $4ntd0 = parcelRequire("4ntd0");
var $43ec468c529faf46$var$needsEval = {};
var $43ec468c529faf46$var$TypedArray = typeof Uint8Array === 'undefined' || !$3Lkl7 ? undefined : $3Lkl7(Uint8Array);
var $43ec468c529faf46$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $43ec468c529faf46$var$hasSymbols && $3Lkl7 ? $3Lkl7([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $43ec468c529faf46$var$needsEval,
    '%AsyncGenerator%': $43ec468c529faf46$var$needsEval,
    '%AsyncGeneratorFunction%': $43ec468c529faf46$var$needsEval,
    '%AsyncIteratorPrototype%': $43ec468c529faf46$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $7UHmp,
    '%eval%': eval,
    '%EvalError%': $7T6Bh,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $43ec468c529faf46$var$$Function,
    '%GeneratorFunction%': $43ec468c529faf46$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $43ec468c529faf46$var$hasSymbols && $3Lkl7 ? $3Lkl7($3Lkl7([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$43ec468c529faf46$var$hasSymbols || !$3Lkl7 ? undefined : $3Lkl7(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $18Bve,
    '%Object.getOwnPropertyDescriptor%': $jULaB,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $ifeGt,
    '%ReferenceError%': $kEzhq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$43ec468c529faf46$var$hasSymbols || !$3Lkl7 ? undefined : $3Lkl7(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $43ec468c529faf46$var$hasSymbols && $3Lkl7 ? $3Lkl7(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $43ec468c529faf46$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $laFZ2,
    '%ThrowTypeError%': $43ec468c529faf46$var$ThrowTypeError,
    '%TypedArray%': $43ec468c529faf46$var$TypedArray,
    '%TypeError%': $awICJ,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $eIXnd,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $4ntd0,
    '%Function.prototype.apply%': $17vHV,
    '%Object.defineProperty%': $9Sh5q,
    '%Object.getPrototypeOf%': $dkH2k,
    '%Math.abs%': $dtDoX,
    '%Math.floor%': $10xIE,
    '%Math.max%': $lzF3y,
    '%Math.min%': $3nIuz,
    '%Math.pow%': $OrKlf,
    '%Math.round%': $34Tzp,
    '%Math.sign%': $9GWFT,
    '%Reflect.getPrototypeOf%': $aVwUH
};
if ($3Lkl7) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $43ec468c529faf46$var$errorProto = $3Lkl7($3Lkl7(e));
    $43ec468c529faf46$var$INTRINSICS['%Error.prototype%'] = $43ec468c529faf46$var$errorProto;
}
var $43ec468c529faf46$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $43ec468c529faf46$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $43ec468c529faf46$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $43ec468c529faf46$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3Lkl7) value = $3Lkl7(gen.prototype);
    }
    $43ec468c529faf46$var$INTRINSICS[name] = value;
    return value;
};
var $43ec468c529faf46$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gKYYg = parcelRequire("gKYYg");

var $iHO7O = parcelRequire("iHO7O");
var $43ec468c529faf46$var$$concat = $gKYYg.call($4ntd0, Array.prototype.concat);
var $43ec468c529faf46$var$$spliceApply = $gKYYg.call($17vHV, Array.prototype.splice);
var $43ec468c529faf46$var$$replace = $gKYYg.call($4ntd0, String.prototype.replace);
var $43ec468c529faf46$var$$strSlice = $gKYYg.call($4ntd0, String.prototype.slice);
var $43ec468c529faf46$var$$exec = $gKYYg.call($4ntd0, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $43ec468c529faf46$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $43ec468c529faf46$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $43ec468c529faf46$var$stringToPath = function stringToPath(string) {
    var first = $43ec468c529faf46$var$$strSlice(string, 0, 1);
    var last = $43ec468c529faf46$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $laFZ2('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $laFZ2('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $43ec468c529faf46$var$$replace(string, $43ec468c529faf46$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $43ec468c529faf46$var$$replace(subString, $43ec468c529faf46$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $43ec468c529faf46$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($iHO7O($43ec468c529faf46$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $43ec468c529faf46$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($iHO7O($43ec468c529faf46$var$INTRINSICS, intrinsicName)) {
        var value = $43ec468c529faf46$var$INTRINSICS[intrinsicName];
        if (value === $43ec468c529faf46$var$needsEval) value = $43ec468c529faf46$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $awICJ('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $laFZ2('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $awICJ('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $awICJ('"allowMissing" argument must be a boolean');
    if ($43ec468c529faf46$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $laFZ2('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $43ec468c529faf46$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $43ec468c529faf46$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $43ec468c529faf46$var$$spliceApply(parts, $43ec468c529faf46$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $43ec468c529faf46$var$$strSlice(part, 0, 1);
        var last = $43ec468c529faf46$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $laFZ2('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($iHO7O($43ec468c529faf46$var$INTRINSICS, intrinsicRealName)) value = $43ec468c529faf46$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $awICJ('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($jULaB && i + 1 >= parts.length) {
                var desc = $jULaB(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $iHO7O(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $43ec468c529faf46$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("18Bve", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("7UHmp", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("7T6Bh", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ifeGt", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("kEzhq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("laFZ2", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eIXnd", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("dtDoX", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("10xIE", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("lzF3y", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("3nIuz", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("OrKlf", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("34Tzp", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("9GWFT", function(module, exports) {
'use strict';

var $4anYj = parcelRequire("4anYj");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4anYj(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4anYj", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("jULaB", function(module, exports) {
'use strict';

var $2CJ2s = parcelRequire("2CJ2s");
var $e7f7d64721d8215f$require$$gOPD = $2CJ2s;
if ($e7f7d64721d8215f$require$$gOPD) try {
    $e7f7d64721d8215f$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $e7f7d64721d8215f$require$$gOPD = null;
}
module.exports = $e7f7d64721d8215f$require$$gOPD;

});
parcelRegister("2CJ2s", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("9Sh5q", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $7306693506f9d8cb$var$$defineProperty = Object.defineProperty || false;
if ($7306693506f9d8cb$var$$defineProperty) try {
    $7306693506f9d8cb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $7306693506f9d8cb$var$$defineProperty = false;
}
module.exports = $7306693506f9d8cb$var$$defineProperty;

});

parcelRegister("3U9bK", function(module, exports) {
'use strict';
var $2d7dbab53792d100$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $3uyHl = parcelRequire("3uyHl");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $2d7dbab53792d100$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $2d7dbab53792d100$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $3uyHl();
};

});
parcelRegister("3uyHl", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3Lkl7", function(module, exports) {
'use strict';

var $aVwUH = parcelRequire("aVwUH");

var $dkH2k = parcelRequire("dkH2k");

var $hAbz1 = parcelRequire("hAbz1");
/** @type {import('.')} */ module.exports = $aVwUH ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $aVwUH(O);
} : $dkH2k ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dkH2k(O);
} : $hAbz1 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $hAbz1(O);
} : null;

});
parcelRegister("aVwUH", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("dkH2k", function(module, exports) {
'use strict';

var $18Bve = parcelRequire("18Bve");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $18Bve.getPrototypeOf || null;

});

parcelRegister("hAbz1", function(module, exports) {
'use strict';

var $6rgIt = parcelRequire("6rgIt");

var $jULaB = parcelRequire("jULaB");
var $cccec4c905f83087$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $cccec4c905f83087$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $cccec4c905f83087$var$desc = !!$cccec4c905f83087$var$hasProtoAccessor && $jULaB && $jULaB(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $cccec4c905f83087$var$$Object = Object;
var $cccec4c905f83087$var$$getPrototypeOf = $cccec4c905f83087$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $cccec4c905f83087$var$desc && typeof $cccec4c905f83087$var$desc.get === 'function' ? $6rgIt([
    $cccec4c905f83087$var$desc.get
]) : typeof $cccec4c905f83087$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $cccec4c905f83087$var$$getPrototypeOf(value == null ? value : $cccec4c905f83087$var$$Object(value));
} : false;

});
parcelRegister("6rgIt", function(module, exports) {
'use strict';

var $gKYYg = parcelRequire("gKYYg");

var $awICJ = parcelRequire("awICJ");

var $4ntd0 = parcelRequire("4ntd0");

var $3RPQn = parcelRequire("3RPQn");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $awICJ('a function is required');
    return $3RPQn($gKYYg, $4ntd0, args);
};

});
parcelRegister("gKYYg", function(module, exports) {
'use strict';

var $hh6CO = parcelRequire("hh6CO");
module.exports = Function.prototype.bind || $hh6CO;

});
parcelRegister("hh6CO", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $c93929c3e52d8951$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $c93929c3e52d8951$var$toStr = Object.prototype.toString;
var $c93929c3e52d8951$var$max = Math.max;
var $c93929c3e52d8951$var$funcType = '[object Function]';
var $c93929c3e52d8951$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $c93929c3e52d8951$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $c93929c3e52d8951$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $c93929c3e52d8951$var$toStr.apply(target) !== $c93929c3e52d8951$var$funcType) throw new TypeError($c93929c3e52d8951$var$ERROR_MESSAGE + target);
    var args = $c93929c3e52d8951$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $c93929c3e52d8951$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $c93929c3e52d8951$var$concatty(args, arguments));
    };
    var boundLength = $c93929c3e52d8951$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $c93929c3e52d8951$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4ntd0", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3RPQn", function(module, exports) {
'use strict';

var $gKYYg = parcelRequire("gKYYg");

var $17vHV = parcelRequire("17vHV");

var $4ntd0 = parcelRequire("4ntd0");

var $i9KYq = parcelRequire("i9KYq");
/** @type {import('./actualApply')} */ module.exports = $i9KYq || $gKYYg.call($4ntd0, $17vHV);

});
parcelRegister("17vHV", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("i9KYq", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("iHO7O", function(module, exports) {
'use strict';
var $d9e31ff37bfe796b$var$call = Function.prototype.call;
var $d9e31ff37bfe796b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gKYYg = parcelRequire("gKYYg");
/** @type {import('.')} */ module.exports = $gKYYg.call($d9e31ff37bfe796b$var$call, $d9e31ff37bfe796b$var$$hasOwn);

});


parcelRegister("RkYUA", function(module, exports) {
'use strict';

var $5PyeX = parcelRequire("5PyeX");

var $6rgIt = parcelRequire("6rgIt");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $0a0539d46f68a460$var$$indexOf = $6rgIt([
    $5PyeX('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $5PyeX(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $0a0539d46f68a460$var$$indexOf(name, '.prototype.') > -1) return $6rgIt(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("9ZgWt", function(module, exports) {
'use strict';

var $5PyeX = parcelRequire("5PyeX");

var $RkYUA = parcelRequire("RkYUA");

var $7W61V = parcelRequire("7W61V");

var $aENim = parcelRequire("aENim");

var $awICJ = parcelRequire("awICJ");
var $7456f3e4392c8069$var$$WeakMap = $5PyeX('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $7456f3e4392c8069$var$$weakMapGet = $RkYUA('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $7456f3e4392c8069$var$$weakMapSet = $RkYUA('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $7456f3e4392c8069$var$$weakMapHas = $RkYUA('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $7456f3e4392c8069$var$$weakMapDelete = $RkYUA('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $7456f3e4392c8069$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $awICJ('Side channel does not contain ' + $7W61V(key));
        },
        'delete': function(key) {
            if ($7456f3e4392c8069$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $7456f3e4392c8069$var$$weakMapDelete($wm, key);
            } else if ($aENim) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($7456f3e4392c8069$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $7456f3e4392c8069$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($7456f3e4392c8069$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $7456f3e4392c8069$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($7456f3e4392c8069$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $7456f3e4392c8069$var$$WeakMap();
                $7456f3e4392c8069$var$$weakMapSet($wm, key, value);
            } else if ($aENim) {
                if (!$m) $m = $aENim();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $aENim;

});


parcelRegister("jwHUs", function(module, exports) {
'use strict';

var $3Y0nC = parcelRequire("3Y0nC");
var $e37310fd4effed3f$var$has = Object.prototype.hasOwnProperty;
var $e37310fd4effed3f$var$isArray = Array.isArray;
var $e37310fd4effed3f$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $e37310fd4effed3f$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($e37310fd4effed3f$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $e37310fd4effed3f$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $e37310fd4effed3f$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($e37310fd4effed3f$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$e37310fd4effed3f$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($e37310fd4effed3f$var$isArray(target) && !$e37310fd4effed3f$var$isArray(source)) mergeTarget = $e37310fd4effed3f$var$arrayToObject(target, options);
    if ($e37310fd4effed3f$var$isArray(target) && $e37310fd4effed3f$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($e37310fd4effed3f$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($e37310fd4effed3f$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $e37310fd4effed3f$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $e37310fd4effed3f$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $e37310fd4effed3f$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $e37310fd4effed3f$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $e37310fd4effed3f$var$limit){
        var segment = string.length >= $e37310fd4effed3f$var$limit ? string.slice(j, j + $e37310fd4effed3f$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $3Y0nC.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xC0 | c >> 6] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xE0 | c >> 12] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 6 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xF0 | c >> 18] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 12 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 6 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $e37310fd4effed3f$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $e37310fd4effed3f$var$compactQueue(queue);
    return value;
};
var $e37310fd4effed3f$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $e37310fd4effed3f$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $e37310fd4effed3f$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $e37310fd4effed3f$var$maybeMap = function maybeMap(val, fn) {
    if ($e37310fd4effed3f$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $e37310fd4effed3f$var$arrayToObject,
    assign: $e37310fd4effed3f$var$assign,
    combine: $e37310fd4effed3f$var$combine,
    compact: $e37310fd4effed3f$var$compact,
    decode: $e37310fd4effed3f$var$decode,
    encode: $e37310fd4effed3f$var$encode,
    isBuffer: $e37310fd4effed3f$var$isBuffer,
    isRegExp: $e37310fd4effed3f$var$isRegExp,
    maybeMap: $e37310fd4effed3f$var$maybeMap,
    merge: $e37310fd4effed3f$var$merge
};

});
parcelRegister("3Y0nC", function(module, exports) {
'use strict';
var $2e374521000e7610$var$replace = String.prototype.replace;
var $2e374521000e7610$var$percentTwenties = /%20/g;
var $2e374521000e7610$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $2e374521000e7610$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $2e374521000e7610$var$replace.call(value, $2e374521000e7610$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $2e374521000e7610$var$Format.RFC1738,
    RFC3986: $2e374521000e7610$var$Format.RFC3986
};

});



parcelRegister("7qo3i", function(module, exports) {
'use strict';

var $jwHUs = parcelRequire("jwHUs");
var $567d9e5e51296175$var$has = Object.prototype.hasOwnProperty;
var $567d9e5e51296175$var$isArray = Array.isArray;
var $567d9e5e51296175$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $jwHUs.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $567d9e5e51296175$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $567d9e5e51296175$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $567d9e5e51296175$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $567d9e5e51296175$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $567d9e5e51296175$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $567d9e5e51296175$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $567d9e5e51296175$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $567d9e5e51296175$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $567d9e5e51296175$var$defaults.decoder, charset, 'key');
            val = $jwHUs.maybeMap($567d9e5e51296175$var$parseArrayValue(part.slice(pos + 1), options, $567d9e5e51296175$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $567d9e5e51296175$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $567d9e5e51296175$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $567d9e5e51296175$var$isArray(val) ? [
            val
        ] : val;
        var existing = $567d9e5e51296175$var$has.call(obj, key);
        if (existing && options.duplicates === 'combine') obj[key] = $jwHUs.combine(obj[key], val);
        else if (!existing || options.duplicates === 'last') obj[key] = val;
    }
    return obj;
};
var $567d9e5e51296175$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $567d9e5e51296175$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $jwHUs.combine([], leaf);
        else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $567d9e5e51296175$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $567d9e5e51296175$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $567d9e5e51296175$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        keys.push('[' + key.slice(segment.index) + ']');
    }
    return $567d9e5e51296175$var$parseObject(keys, val, options, valuesParsed);
};
var $567d9e5e51296175$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $567d9e5e51296175$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $567d9e5e51296175$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $567d9e5e51296175$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $567d9e5e51296175$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $567d9e5e51296175$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $567d9e5e51296175$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $567d9e5e51296175$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $567d9e5e51296175$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $567d9e5e51296175$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $567d9e5e51296175$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $567d9e5e51296175$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $567d9e5e51296175$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $jwHUs.isRegExp(opts.delimiter) ? opts.delimiter : $567d9e5e51296175$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $567d9e5e51296175$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $567d9e5e51296175$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $567d9e5e51296175$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $567d9e5e51296175$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $567d9e5e51296175$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $567d9e5e51296175$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $567d9e5e51296175$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $567d9e5e51296175$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $567d9e5e51296175$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $jwHUs.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $jwHUs.compact(obj);
};

});







parcelRegister("kZj5j", function(module, exports) {

$parcel$export(module.exports, "applications", function () { return $99aa4c86835578dc$export$e7ad650a602a37dc; });
$parcel$export(module.exports, "applicationSelector", function () { return $99aa4c86835578dc$export$5b2ad1bf581a1d7b; });
$parcel$export(module.exports, "lookupApplication", function () { return $99aa4c86835578dc$export$105c92f8798550c7; });
$parcel$export(module.exports, "cobrandingURLParams", function () { return $99aa4c86835578dc$export$5a5f77d52a5485dc; });
$parcel$export(module.exports, "getMicrobrandingFromUrl", function () { return $99aa4c86835578dc$export$dace4fb1afc7ad6b; });
$parcel$export(module.exports, "isTrelloDesktop", function () { return $99aa4c86835578dc$export$5824ecd2b22a2ece; });
$parcel$export(module.exports, "replaceQueryParam", function () { return $99aa4c86835578dc$export$70c3f4404feb54c5; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");
parcelRequire("6jPF3");
var $hzjk7 = parcelRequire("hzjk7");
const $99aa4c86835578dc$export$e7ad650a602a37dc = {
    admin: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    access: {
        name: 'Adminhub',
        useInLoginPrompt: false
    },
    ace: {
        name: 'Atlassian Community Events',
        useInLoginPrompt: false
    },
    atlas: {
        name: 'Atlas',
        useInLoginPrompt: true
    },
    bitbucket: {
        name: 'Bitbucket',
        useInLoginPrompt: true
    },
    community: {
        name: 'Community',
        useInLoginPrompt: true
    },
    cac: {
        name: 'Documentation',
        useInLoginPrompt: true
    },
    dac: {
        name: 'Developer Portal',
        useInLoginPrompt: true
    },
    experts: {
        name: 'Partner Program',
        useInLoginPrompt: true
    },
    'itap-uat-backend': {
        name: 'itap-uat-backend',
        useInLoginPrompt: false
    },
    jac: {
        name: 'Atlassian Bug Reporting & Feature Requests'
    },
    mpac: {
        name: 'Marketplace',
        useInLoginPrompt: true
    },
    profile: {
        name: 'Atlassian'
    },
    prt: {
        name: 'Primary Refresh Token Test'
    },
    'manage-profile': {
        name: 'Atlassian account',
        useInLoginPrompt: false
    },
    sac: {
        name: 'Support',
        useInLoginPrompt: true
    },
    teamcentral: {
        name: 'Team Central',
        useInLoginPrompt: false
    },
    trello: {
        name: 'Trello',
        useInLoginPrompt: true
    },
    mac: {
        name: 'My Atlassian',
        useInLoginPrompt: true
    },
    jira: {
        name: 'Jira',
        useInLoginPrompt: true
    },
    loom: {
        name: 'Loom',
        useInLoginPrompt: true
    },
    'jira-align': {
        name: 'Jira Align',
        useInLoginPrompt: true
    },
    confluence: {
        name: 'Confluence',
        useInLoginPrompt: true
    },
    ondemand: {
        name: 'Atlassian Cloud',
        useInLoginPrompt: false
    },
    opsgenie: {
        name: 'Opsgenie',
        useInLoginPrompt: true
    },
    rovo: {
        name: 'Rovo',
        useInLoginPrompt: false
    },
    start: {
        name: 'Start',
        useInLoginPrompt: false
    },
    megamanzero: {
        name: 'MegamanZero',
        useInLoginPrompt: false
    },
    pollinator: {
        // for functional testing
        name: 'Pollinator',
        useInLoginPrompt: false
    },
    wac: {
        name: 'Atlassian',
        useInLoginPrompt: false
    },
    compass: {
        name: 'Compass',
        useInLoginPrompt: true
    },
    sourcetree: {
        name: 'Sourcetree',
        useInLoginPrompt: false
    },
    statuspage: {
        name: 'Statuspage'
    },
    uac: {
        name: 'UAC',
        useInLoginPrompt: false
    },
    support: {
        name: 'Support',
        useInLoginPrompt: true
    }
};
const $99aa4c86835578dc$export$5b2ad1bf581a1d7b = (0, $hzjk7.createSelector)((state)=>state.cobranding, (cobranding)=>$99aa4c86835578dc$export$105c92f8798550c7(cobranding));
function $99aa4c86835578dc$export$105c92f8798550c7(cobranding) {
    const applicationFromContinue = $99aa4c86835578dc$var$applicationFromContinueUrl();
    const { application: applicationFromQueryParameter, experience: experienceFromQueryParameter } = $99aa4c86835578dc$var$applicationFromApplicationQueryParameter();
    const application = cobranding.derivedApplication || applicationFromContinue || applicationFromQueryParameter;
    const experience = cobranding.experience || experienceFromQueryParameter;
    if (application) {
        const appData = $99aa4c86835578dc$export$e7ad650a602a37dc[application];
        if (appData) return (0, $ty6PY._)({
            application: application,
            experience: experience
        }, appData);
    }
    return null;
}
const $99aa4c86835578dc$export$5a5f77d52a5485dc = (location, productHint)=>{
    const params = $jSnDV.parse(location.search);
    const allParams = productHint !== undefined && productHint !== null ? (0, $6EnDC._)((0, $ty6PY._)({}, params), {
        productHint: productHint
    }) : (0, $ty6PY._)({}, params);
    const filteredCobrandingParams = Object.keys(allParams).filter((key)=>[
            'continue',
            'application',
            'display',
            'productHint'
        ].includes(key)).reduce((o, key)=>{
        o[key] = allParams[key];
        return o;
    }, {});
    const cobrandingURLParams = filteredCobrandingParams && Object.keys(filteredCobrandingParams).length ? (0, $ty6PY._)({}, filteredCobrandingParams) : '';
    return cobrandingURLParams;
};
function $99aa4c86835578dc$export$dace4fb1afc7ad6b(location) {
    const params = $jSnDV.parse(location.search);
    return Object.keys(params).filter((key)=>[
            'application',
            'continue',
            'tenant'
        ].includes(key)).reduce((o, key)=>{
        o[key] = params[key];
        return o;
    }, {});
}
const $99aa4c86835578dc$export$ae5bd94b7585e9d5 = [
    '/admin',
    '/login',
    '/logout',
    '/impersonate',
    '/home',
    '/people',
    '/trusted-admin',
    '/forge-apps'
];
/**
 * Determine the cobranding application from the `?continue=...` URL param as a last resort.
 *
 * **This code should _only_ be relied upon for situations where passing an `?application=...`
 * param or product hint is not possible**, such as within Slack's direct initiate flow. In OIDC
 * flows applications should pass a product hint, and in all other flows applications should pass
 * an `?application=...` param to id.a.c.
 */ function $99aa4c86835578dc$var$applicationFromContinueUrl() {
    const params = $jSnDV.parse(window.location.search);
    const continueParam = params.continue;
    if (!continueParam) return null;
    try {
        const continueUrl = new URL(continueParam, window.location.origin);
        const { hostname: hostname, pathname: pathname, searchParams: searchParams } = continueUrl;
        if ([
            'bitbucket.org',
            'integration.bb-inf.net'
        ].includes(hostname)) return 'bitbucket';
        else if ([
            '.opsgenie.com',
            '.opsgeni.us'
        ].some((domain)=>hostname.endsWith(domain))) return 'opsgenie';
        else if ([
            'manage.statuspage.io',
            'manage.statuspagestaging.com'
        ].includes(hostname)) return 'statuspage';
        else if ([
            'trello.com',
            'trellis.coffee'
        ].includes(hostname)) return 'trello';
        else if ([
            'atlassian.com',
            'www.atlassian.com',
            'wac.stg.internal.atlassian.com'
        ].includes(hostname)) return 'wac';
        else if ([
            'team.atlassian.com',
            'team.stg.atlassian.com'
        ].includes(hostname)) return 'atlas';
        else if ([
            '.atlassian.net',
            'atlassian-fex.net',
            '.jira-dev.com'
        ].some((domain)=>hostname.endsWith(domain))) {
            const unwrappedContinueUrl = pathname === '/login' && searchParams.get('dest-url') ? new URL(searchParams.get('dest-url'), continueUrl) : continueUrl;
            const { pathname: unwrappedPathname } = unwrappedContinueUrl;
            if (unwrappedPathname === '/wiki' || unwrappedPathname.startsWith('/wiki/')) return 'confluence';
            else if (unwrappedPathname === '/compass' || unwrappedPathname.startsWith('/compass/')) return 'compass';
            else if (// Root could be Jira or Conflience
            unwrappedPathname !== '/' && !$99aa4c86835578dc$export$ae5bd94b7585e9d5.some((prefix)=>unwrappedPathname === prefix || unwrappedPathname.startsWith(`${prefix}/`))) return 'jira';
        }
    } catch (error) {
    // Malformed URL, ignore
    }
    return null;
}
function $99aa4c86835578dc$var$applicationFromApplicationQueryParameter() {
    try {
        var _get;
        const [application, experience] = ((_get = new URLSearchParams(window.location.search).get('application')) === null || _get === void 0 ? void 0 : _get.split('--')) || [];
        if (application && $99aa4c86835578dc$var$isValidApplication(application)) return {
            application: application,
            experience: experience
        };
    } catch (error) {
    // Malformed query parameter, ignore
    }
    return {
        application: null,
        experience: null
    };
}
function $99aa4c86835578dc$export$5824ecd2b22a2ece() {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes('TrelloDesktop');
}
const $99aa4c86835578dc$export$e248db7c9a3cd59 = (app)=>app && $99aa4c86835578dc$export$e7ad650a602a37dc[app] ? $99aa4c86835578dc$export$e7ad650a602a37dc[app].name : 'Atlassian';
const $99aa4c86835578dc$var$isValidApplication = (application)=>Object.keys($99aa4c86835578dc$export$e7ad650a602a37dc).includes(application);
function $99aa4c86835578dc$export$70c3f4404feb54c5(paramName, paramValue) {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set(paramName, paramValue);
    const queryString = queryParams.toString();
    return queryString ? `?${queryString}` : '';
}

});
parcelRegister("6jPF3", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $499c9742106f24f5$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("hzjk7")).createSelector; });

var $ePY9n = parcelRequire("ePY9n");

var $l2d2N = parcelRequire("l2d2N");

var $hzjk7 = parcelRequire("hzjk7");

var $bE8SV = parcelRequire("bE8SV");

var $1RdT6 = parcelRequire("1RdT6");
var $499c9742106f24f5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $499c9742106f24f5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $499c9742106f24f5$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $499c9742106f24f5$var$__defProp = Object.defineProperty;
var $499c9742106f24f5$var$__defProps = Object.defineProperties;
var $499c9742106f24f5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $499c9742106f24f5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $499c9742106f24f5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $499c9742106f24f5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $499c9742106f24f5$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $499c9742106f24f5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $499c9742106f24f5$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($499c9742106f24f5$var$__hasOwnProp.call(b, prop)) $499c9742106f24f5$var$__defNormalProp(a, prop, b[prop]);
    if ($499c9742106f24f5$var$__getOwnPropSymbols) for(var _i = 0, _c = $499c9742106f24f5$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($499c9742106f24f5$var$__propIsEnum.call(b, prop)) $499c9742106f24f5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $499c9742106f24f5$var$__spreadProps = function(a, b) {
    return $499c9742106f24f5$var$__defProps(a, $499c9742106f24f5$var$__getOwnPropDescs(b));
};
var $499c9742106f24f5$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $499c9742106f24f5$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $hzjk7.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $499c9742106f24f5$var$__spreadArray([
            (0, $ePY9n.isDraft)(value) ? (0, $ePY9n.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $499c9742106f24f5$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $l2d2N.compose;
    return (0, $l2d2N.compose).apply(null, arguments);
};
var $499c9742106f24f5$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $499c9742106f24f5$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $499c9742106f24f5$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $499c9742106f24f5$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $499c9742106f24f5$export$b956e38827fca970(action) {
    return $499c9742106f24f5$export$53b83ca8eaab0383(action) && "type" in action;
}
function $499c9742106f24f5$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $499c9742106f24f5$var$hasMatchFunction(action);
}
function $499c9742106f24f5$export$ebd532f9034651f3(action) {
    return $499c9742106f24f5$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($499c9742106f24f5$var$isValidKey);
}
function $499c9742106f24f5$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $499c9742106f24f5$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $499c9742106f24f5$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return "Detected an action creator with type \"" + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $499c9742106f24f5$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $499c9742106f24f5$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $499c9742106f24f5$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $499c9742106f24f5$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $499c9742106f24f5$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $499c9742106f24f5$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $499c9742106f24f5$var$freezeDraftable(val) {
    return (0, $ePY9n.isDraftable)(val) ? (0, $ePY9n.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $499c9742106f24f5$var$isProduction = true;
var $499c9742106f24f5$var$prefix = "Invariant failed";
function $499c9742106f24f5$var$invariant(condition, message) {
    if (condition) return;
    if ($499c9742106f24f5$var$isProduction) throw new Error($499c9742106f24f5$var$prefix);
    throw new Error($499c9742106f24f5$var$prefix + ": " + (message || ""));
}
function $499c9742106f24f5$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $499c9742106f24f5$var$getSerialize(serializer, decycler), indent);
}
function $499c9742106f24f5$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $499c9742106f24f5$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $499c9742106f24f5$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $499c9742106f24f5$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $499c9742106f24f5$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $499c9742106f24f5$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $499c9742106f24f5$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $499c9742106f24f5$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $499c9742106f24f5$export$53b83ca8eaab0383(val);
}
function $499c9742106f24f5$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $499c9742106f24f5$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $499c9742106f24f5$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $499c9742106f24f5$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $499c9742106f24f5$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$499c9742106f24f5$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $499c9742106f24f5$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $499c9742106f24f5$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $499c9742106f24f5$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $499c9742106f24f5$export$36c1185aeee5b0a6(options);
    };
}
function $499c9742106f24f5$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $499c9742106f24f5$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($499c9742106f24f5$var$isBoolean(thunk)) middlewareArray.push((0, $bE8SV.default));
        else middlewareArray.push((0, $bE8SV.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $499c9742106f24f5$var$IS_PRODUCTION = true;
function $499c9742106f24f5$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $499c9742106f24f5$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($499c9742106f24f5$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $l2d2N.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$499c9742106f24f5$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$499c9742106f24f5$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $l2d2N.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $l2d2N.compose);
    if (devTools) finalCompose = $499c9742106f24f5$var$composeWithDevTools($499c9742106f24f5$var$__spreadValues({
        trace: !$499c9742106f24f5$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $499c9742106f24f5$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $499c9742106f24f5$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $l2d2N.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $499c9742106f24f5$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $499c9742106f24f5$var$isStateFunction(x) {
    return typeof x === "function";
}
var $499c9742106f24f5$var$hasWarnedAboutObjectNotation = false;
function $499c9742106f24f5$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $499c9742106f24f5$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($499c9742106f24f5$var$isStateFunction(initialState)) getInitialState = function() {
        return $499c9742106f24f5$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $499c9742106f24f5$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $499c9742106f24f5$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $ePY9n.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $ePY9n.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $ePY9n.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $499c9742106f24f5$var$hasWarnedAboutObjectNotation2 = false;
function $499c9742106f24f5$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $499c9742106f24f5$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $1RdT6;
    var initialState = typeof options.initialState == "function" ? options.initialState : $499c9742106f24f5$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $499c9742106f24f5$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $499c9742106f24f5$export$309c7a02b0b0bc62(type, prepareCallback) : $499c9742106f24f5$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $499c9742106f24f5$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $499c9742106f24f5$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $499c9742106f24f5$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $499c9742106f24f5$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($499c9742106f24f5$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $499c9742106f24f5$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $499c9742106f24f5$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $499c9742106f24f5$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $499c9742106f24f5$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $499c9742106f24f5$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $499c9742106f24f5$var$createSingleArgumentStateOperator(mutator) {
    var operator = $499c9742106f24f5$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $499c9742106f24f5$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $499c9742106f24f5$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $ePY9n.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $ePY9n.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $499c9742106f24f5$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $499c9742106f24f5$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $499c9742106f24f5$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $499c9742106f24f5$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $499c9742106f24f5$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $499c9742106f24f5$var$createStateOperator(addOneMutably),
        addMany: $499c9742106f24f5$var$createStateOperator(addManyMutably),
        setOne: $499c9742106f24f5$var$createStateOperator(setOneMutably),
        setMany: $499c9742106f24f5$var$createStateOperator(setManyMutably),
        setAll: $499c9742106f24f5$var$createStateOperator(setAllMutably),
        updateOne: $499c9742106f24f5$var$createStateOperator(updateOneMutably),
        updateMany: $499c9742106f24f5$var$createStateOperator(updateManyMutably),
        upsertOne: $499c9742106f24f5$var$createStateOperator(upsertOneMutably),
        upsertMany: $499c9742106f24f5$var$createStateOperator(upsertManyMutably),
        removeOne: $499c9742106f24f5$var$createStateOperator(removeOneMutably),
        removeMany: $499c9742106f24f5$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $499c9742106f24f5$var$createSortedStateAdapter(selectId, sort) {
    var _c = $499c9742106f24f5$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($499c9742106f24f5$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $499c9742106f24f5$var$createStateOperator(addOneMutably),
        updateOne: $499c9742106f24f5$var$createStateOperator(updateOneMutably),
        upsertOne: $499c9742106f24f5$var$createStateOperator(upsertOneMutably),
        setOne: $499c9742106f24f5$var$createStateOperator(setOneMutably),
        setMany: $499c9742106f24f5$var$createStateOperator(setManyMutably),
        setAll: $499c9742106f24f5$var$createStateOperator(setAllMutably),
        addMany: $499c9742106f24f5$var$createStateOperator(addManyMutably),
        updateMany: $499c9742106f24f5$var$createStateOperator(updateManyMutably),
        upsertMany: $499c9742106f24f5$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $499c9742106f24f5$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $499c9742106f24f5$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $499c9742106f24f5$var$createInitialStateFactory();
    var selectorsFactory = $499c9742106f24f5$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $499c9742106f24f5$var$createSortedStateAdapter(selectId, sortComparer) : $499c9742106f24f5$var$createUnsortedStateAdapter(selectId);
    return $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $499c9742106f24f5$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $499c9742106f24f5$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $499c9742106f24f5$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $499c9742106f24f5$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $499c9742106f24f5$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $499c9742106f24f5$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $499c9742106f24f5$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $499c9742106f24f5$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $499c9742106f24f5$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $499c9742106f24f5$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $499c9742106f24f5$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $499c9742106f24f5$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $499c9742106f24f5$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$499c9742106f24f5$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $499c9742106f24f5$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $499c9742106f24f5$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $499c9742106f24f5$var$RejectWithValue) throw result;
                                                if (result instanceof $499c9742106f24f5$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $499c9742106f24f5$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($499c9742106f24f5$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $499c9742106f24f5$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $499c9742106f24f5$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $499c9742106f24f5$var$matches = function(matcher, action) {
    if ($499c9742106f24f5$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $499c9742106f24f5$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $499c9742106f24f5$var$matches(matcher, action);
        });
    };
}
function $499c9742106f24f5$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $499c9742106f24f5$var$matches(matcher, action);
        });
    };
}
function $499c9742106f24f5$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $499c9742106f24f5$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $499c9742106f24f5$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $499c9742106f24f5$export$9dd1fb32974da385($499c9742106f24f5$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $499c9742106f24f5$export$9dd1fb32974da385($499c9742106f24f5$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $499c9742106f24f5$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $499c9742106f24f5$var$noop = function() {};
var $499c9742106f24f5$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $499c9742106f24f5$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $499c9742106f24f5$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $499c9742106f24f5$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $499c9742106f24f5$var$task = "task";
var $499c9742106f24f5$var$listener = "listener";
var $499c9742106f24f5$var$completed = "completed";
var $499c9742106f24f5$var$cancelled = "cancelled";
var $499c9742106f24f5$var$taskCancelled = "task-" + $499c9742106f24f5$var$cancelled;
var $499c9742106f24f5$var$taskCompleted = "task-" + $499c9742106f24f5$var$completed;
var $499c9742106f24f5$var$listenerCancelled = $499c9742106f24f5$var$listener + "-" + $499c9742106f24f5$var$cancelled;
var $499c9742106f24f5$var$listenerCompleted = $499c9742106f24f5$var$listener + "-" + $499c9742106f24f5$var$completed;
var $499c9742106f24f5$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $499c9742106f24f5$var$task + " " + $499c9742106f24f5$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $499c9742106f24f5$var$validateActive = function(signal) {
    if (signal.aborted) throw new $499c9742106f24f5$export$cb1bdac908fed7f(signal.reason);
};
function $499c9742106f24f5$var$raceWithSignal(signal, promise2) {
    var cleanup = $499c9742106f24f5$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $499c9742106f24f5$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $499c9742106f24f5$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $499c9742106f24f5$var$noop;
    });
}
var $499c9742106f24f5$var$runTask = function(task2, cleanUp) {
    return $499c9742106f24f5$var$__async(void 0, null, function() {
        var value, error_1;
        return $499c9742106f24f5$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $499c9742106f24f5$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $499c9742106f24f5$var$createPause = function(signal) {
    return function(promise2) {
        return $499c9742106f24f5$var$catchRejection($499c9742106f24f5$var$raceWithSignal(signal, promise2).then(function(output) {
            $499c9742106f24f5$var$validateActive(signal);
            return output;
        }));
    };
};
var $499c9742106f24f5$var$createDelay = function(signal) {
    var pause = $499c9742106f24f5$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $499c9742106f24f5$var$assign = Object.assign;
var $499c9742106f24f5$var$INTERNAL_NIL_TOKEN = {};
var $499c9742106f24f5$var$alm = "listenerMiddleware";
var $499c9742106f24f5$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $499c9742106f24f5$var$addAbortSignalListener(parentAbortSignal, function() {
            return $499c9742106f24f5$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $499c9742106f24f5$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $499c9742106f24f5$var$runTask(function() {
            return $499c9742106f24f5$var$__async(void 0, null, function() {
                var result2;
                return $499c9742106f24f5$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $499c9742106f24f5$var$validateActive(parentAbortSignal);
                            $499c9742106f24f5$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $499c9742106f24f5$var$createPause(childAbortController.signal),
                                    delay: $499c9742106f24f5$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $499c9742106f24f5$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $499c9742106f24f5$var$abortControllerWithReason(childAbortController, $499c9742106f24f5$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $499c9742106f24f5$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $499c9742106f24f5$var$abortControllerWithReason(childAbortController, $499c9742106f24f5$var$taskCancelled);
            }
        };
    };
};
var $499c9742106f24f5$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $499c9742106f24f5$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $499c9742106f24f5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $499c9742106f24f5$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $499c9742106f24f5$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $499c9742106f24f5$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $499c9742106f24f5$var$catchRejection(take(predicate, timeout));
    };
};
var $499c9742106f24f5$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $499c9742106f24f5$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $499c9742106f24f5$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $499c9742106f24f5$var$createListenerEntry = function(options) {
    var _c = $499c9742106f24f5$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $499c9742106f24f5$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $499c9742106f24f5$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $499c9742106f24f5$var$abortControllerWithReason(controller, $499c9742106f24f5$var$listenerCancelled);
    });
};
var $499c9742106f24f5$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($499c9742106f24f5$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $499c9742106f24f5$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $499c9742106f24f5$export$f03a6b845d3fb58b = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/add");
var $499c9742106f24f5$export$b1b8022855fb2b71 = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/removeAll");
var $499c9742106f24f5$export$b03e9483f936dccb = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/remove");
var $499c9742106f24f5$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $499c9742106f24f5$var$__spreadArray([
        $499c9742106f24f5$var$alm + "/error"
    ], args));
};
function $499c9742106f24f5$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $499c9742106f24f5$var$defaultErrorHandler : _c;
    $499c9742106f24f5$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $499c9742106f24f5$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $499c9742106f24f5$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $499c9742106f24f5$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $499c9742106f24f5$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $499c9742106f24f5$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $499c9742106f24f5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $499c9742106f24f5$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $499c9742106f24f5$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $499c9742106f24f5$var$createDelay(internalTaskController.signal),
                                pause: $499c9742106f24f5$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $499c9742106f24f5$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $499c9742106f24f5$var$abortControllerWithReason(controller, $499c9742106f24f5$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $499c9742106f24f5$export$cb1bdac908fed7f)) $499c9742106f24f5$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $499c9742106f24f5$var$abortControllerWithReason(internalTaskController, $499c9742106f24f5$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $499c9742106f24f5$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$499c9742106f24f5$export$b956e38827fca970(action)) return next(action);
                if ($499c9742106f24f5$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($499c9742106f24f5$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($499c9742106f24f5$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $499c9742106f24f5$var$INTERNAL_NIL_TOKEN) throw new Error($499c9742106f24f5$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $499c9742106f24f5$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $499c9742106f24f5$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $499c9742106f24f5$export$8fb31c0f05df007b = "RTK_autoBatch";
var $499c9742106f24f5$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$499c9742106f24f5$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $499c9742106f24f5$var$promise;
var $499c9742106f24f5$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($499c9742106f24f5$var$promise || ($499c9742106f24f5$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $499c9742106f24f5$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $499c9742106f24f5$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $499c9742106f24f5$var$createQueueWithTimer(10);
var $499c9742106f24f5$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $499c9742106f24f5$var$queueMicrotaskShim : options.type === "raf" ? $499c9742106f24f5$var$rAF : options.type === "callback" ? options.queueNotification : $499c9742106f24f5$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$499c9742106f24f5$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $ePY9n.enableES5)();

});
parcelRegister("ePY9n", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $acd47caf6d999104$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(_n) {
                            void 0 !== o[_n] || u(o, _n) || (f[_n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $acd47caf6d999104$export$2e2bcd8739ae039 = fn;

});

parcelRegister("l2d2N", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $f503e72ddc215ec0$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $f503e72ddc215ec0$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $f503e72ddc215ec0$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $f503e72ddc215ec0$export$9ff26e0402cc7b7; });

var $jQssh = parcelRequire("jQssh");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f503e72ddc215ec0$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $f503e72ddc215ec0$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f503e72ddc215ec0$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $f503e72ddc215ec0$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f503e72ddc215ec0$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f503e72ddc215ec0$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f503e72ddc215ec0$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f503e72ddc215ec0$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f503e72ddc215ec0$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($f503e72ddc215ec0$var$isDate(val)) return 'date';
    if ($f503e72ddc215ec0$var$isError(val)) return 'error';
    var constructorName = $f503e72ddc215ec0$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $f503e72ddc215ec0$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $f503e72ddc215ec0$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $f503e72ddc215ec0$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $f503e72ddc215ec0$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f503e72ddc215ec0$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(1));
        return enhancer($f503e72ddc215ec0$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f503e72ddc215ec0$var$isPlainObject(action)) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f503e72ddc215ec0$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f503e72ddc215ec0$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f503e72ddc215ec0$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f503e72ddc215ec0$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f503e72ddc215ec0$export$8928921ea2d3b126 = $f503e72ddc215ec0$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f503e72ddc215ec0$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f503e72ddc215ec0$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f503e72ddc215ec0$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f503e72ddc215ec0$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $f503e72ddc215ec0$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f503e72ddc215ec0$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $f503e72ddc215ec0$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f503e72ddc215ec0$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f503e72ddc215ec0$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f503e72ddc215ec0$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f503e72ddc215ec0$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f503e72ddc215ec0$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f503e72ddc215ec0$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $f503e72ddc215ec0$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $f503e72ddc215ec0$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f503e72ddc215ec0$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f503e72ddc215ec0$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f503e72ddc215ec0$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $jQssh.default)((0, $jQssh.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("jQssh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e728f2405e04dc44$export$2e2bcd8739ae039; });

var $kSFIZ = parcelRequire("kSFIZ");
function $e728f2405e04dc44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e728f2405e04dc44$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e728f2405e04dc44$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSFIZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e728f2405e04dc44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSFIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33937734f016206$export$2e2bcd8739ae039; });

var $jxVuk = parcelRequire("jxVuk");
function $f33937734f016206$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jxVuk.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jxVuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3adb15822cb3fd3$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $lSAJ7 = parcelRequire("lSAJ7");
function $e3adb15822cb3fd3$export$2e2bcd8739ae039(t) {
    var i = (0, $lSAJ7.default)(t, "string");
    return "symbol" == (0, $8p0zh.default)(i) ? i : i + "";
}

});
parcelRegister("lSAJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fedb2148e204fbf8$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");
function $fedb2148e204fbf8$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8p0zh.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8p0zh.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("hzjk7", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $cca4b1ce389a842c$export$595d22ed68ca2841; });

var $l6ob1 = parcelRequire("l6ob1");
function $cca4b1ce389a842c$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $cca4b1ce389a842c$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $cca4b1ce389a842c$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $cca4b1ce389a842c$export$595d22ed68ca2841 = /* #__PURE__ */ $cca4b1ce389a842c$export$5943f4447f6ef248((0, $l6ob1.defaultMemoize));
var $cca4b1ce389a842c$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $cca4b1ce389a842c$export$595d22ed68ca2841;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("l6ob1", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $f5cce98200f3fd7b$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $f5cce98200f3fd7b$var$NOT_FOUND = 'NOT_FOUND';
function $f5cce98200f3fd7b$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f5cce98200f3fd7b$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $f5cce98200f3fd7b$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $f5cce98200f3fd7b$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f5cce98200f3fd7b$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f5cce98200f3fd7b$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $f5cce98200f3fd7b$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f5cce98200f3fd7b$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $f5cce98200f3fd7b$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $f5cce98200f3fd7b$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $f5cce98200f3fd7b$var$createSingletonCache(comparator) : $f5cce98200f3fd7b$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $f5cce98200f3fd7b$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("bE8SV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87aa527f68be589e$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $87aa527f68be589e$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $87aa527f68be589e$var$thunk = $87aa527f68be589e$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$87aa527f68be589e$var$thunk.withExtraArgument = $87aa527f68be589e$var$createThunkMiddleware;
var $87aa527f68be589e$export$2e2bcd8739ae039 = $87aa527f68be589e$var$thunk;

});



parcelRegister("fsfV4", function(module, exports) {

$parcel$export(module.exports, "getFirstPaint", function () { return $07a87e2b7b0395e0$export$819e7a0b13f5961; });
$parcel$export(module.exports, "getFirstContentfulPaint", function () { return $07a87e2b7b0395e0$export$3086fa1a9fb7f683; });
const $07a87e2b7b0395e0$var$perf = typeof window !== 'undefined' ? window.performance : null;
function $07a87e2b7b0395e0$export$819e7a0b13f5961() {
    try {
        if (!$07a87e2b7b0395e0$var$perf) return null;
        const fp = $07a87e2b7b0395e0$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-paint');
        return fp ? Math.round(fp.startTime) : null;
    } catch (err) {
        return null;
    }
}
function $07a87e2b7b0395e0$export$3086fa1a9fb7f683() {
    try {
        if (!$07a87e2b7b0395e0$var$perf) return null;
        const fcp = $07a87e2b7b0395e0$var$perf.getEntriesByType('paint').find(({ name: name })=>name === 'first-contentful-paint');
        return fcp ? Math.round(fcp.startTime) : null;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("62Jrh", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return (parcelRequire("HylXk")).BrowserMetricsBoundary; });
$parcel$export(module.exports, "startBrowserMetrics", function () { return (parcelRequire("2xiyk")).startBrowserMetrics; });
$parcel$export(module.exports, "getPageLoadMetric", function () { return (parcelRequire("kQMDY")).getPageLoadMetric; });
parcelRequire("HylXk");
parcelRequire("2xiyk");
parcelRequire("kQMDY");

});
parcelRegister("HylXk", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return $6ce40601bc19e9d0$export$e338054fa926c14d; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $7HBoF = parcelRequire("7HBoF");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");
const $6ce40601bc19e9d0$export$e338054fa926c14d = ({ children: children })=>{
    const prevPathname = (0, $8ZuGG.useRef)();
    const { pathname: pathname } = (0, $5WDNl.useLocation)();
    /*
   * Here we only want to capture transition page loads (i.e. clientside route changes).
   *
   * Initial page loads (with a full trip to the server) are already recorded separately,
   * by calling startPageLoad before the react app is bootstrapped.
   *
   * And if startPageLoad were called again here, that initial page load will be overridden
   * and incorrectly recorded as a transition.
   */ (0, $8ZuGG.useLayoutEffect)(()=>{
        if (!pathname) return;
        if (!prevPathname.current) {
            prevPathname.current = pathname;
            return;
        }
        // `isInitial: false` is the default, but made explicit here for clarity
        (0, $7HBoF.browserMetrics).startPageLoad({
            isInitial: false
        });
    }, [
        pathname,
        prevPathname
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};

});
parcelRegister("7HBoF", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", function () { return $59b98ecadb70c473$export$c08e7affcf78b064; });

var $6bkHe = parcelRequire("6bkHe");

var $1EyXZ = parcelRequire("1EyXZ");

var $1XCKE = parcelRequire("1XCKE");

var $5EyB3 = parcelRequire("5EyB3");

var $a3buC = parcelRequire("a3buC");

var $djDSg = parcelRequire("djDSg");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $3GjBI = parcelRequire("3GjBI");
function $59b98ecadb70c473$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59b98ecadb70c473$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59b98ecadb70c473$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59b98ecadb70c473$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59b98ecadb70c473$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $a3buC.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $djDSg.webVitalsObserver).start();
            if (config.debug) {
                (0, $1XCKE.logger).enable();
                (0, $e1hkl.submitter).setDebug(true);
                (0, $5EyB3.pageLoadMetaMetric).setDebug(true);
            }
            (0, $e1hkl.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $1EyXZ.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $eqyfk.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $5EyB3.pageLoadMetaMetric).startPageLoad($59b98ecadb70c473$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $5EyB3.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $5EyB3.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $5EyB3.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $5EyB3.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $59b98ecadb70c473$export$c08e7affcf78b064 = $59b98ecadb70c473$var$makeBrowserMetrics();

});
parcelRegister("1EyXZ", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $1344a685454f4217$export$9e87a201397ac0a9; });
var $1344a685454f4217$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $1344a685454f4217$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("1XCKE", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $16d95c5ba96729d0$export$af88d00dbe7f521; });
var $16d95c5ba96729d0$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                'BM log: '
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("5EyB3", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $010fed859e568f72$export$24b7a1a311eb05dc; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");

var $h5wBz = parcelRequire("h5wBz");
var $010fed859e568f72$var$_excluded = [
    "cancelStarted"
];
function $010fed859e568f72$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $010fed859e568f72$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $010fed859e568f72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($010fed859e568f72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $010fed859e568f72$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $010fed859e568f72$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $010fed859e568f72$var$_callSuper(this, PageLoadMetaMetric, [].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageLoadMetaMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $010fed859e568f72$var$_excluded);
                if (cancelStarted || this.state !== (0, $k6Eo3.MetricState).STARTED) $010fed859e568f72$var$_superPropGet(PageLoadMetaMetric, "startPageLoad", this, 3)([
                    startPageLoadParams
                ]);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                $010fed859e568f72$var$_superPropGet(PageLoadMetaMetric, "clear", this, 3)([]);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
}((0, $h5wBz.BasePageLoadMetric));
var $010fed859e568f72$export$24b7a1a311eb05dc = new $010fed859e568f72$export$9609608c00ea5077({
    type: (0, $3GjBI.BMEventsType).PAGE_LOAD,
    key: 'page_load_meta_metric'
});

});
parcelRegister("3GjBI", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $2ae480ec8951598f$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $2ae480ec8951598f$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $2ae480ec8951598f$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $2ae480ec8951598f$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $2ae480ec8951598f$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $2ae480ec8951598f$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $2ae480ec8951598f$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $2ae480ec8951598f$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $2ae480ec8951598f$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $2ae480ec8951598f$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $2ae480ec8951598f$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $2ae480ec8951598f$export$60c0193054fc3040; });

var $k6Eo3 = parcelRequire("k6Eo3");
var $2ae480ec8951598f$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $2ae480ec8951598f$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $2ae480ec8951598f$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $2ae480ec8951598f$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $2ae480ec8951598f$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $2ae480ec8951598f$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $2ae480ec8951598f$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $2ae480ec8951598f$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $2ae480ec8951598f$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $2ae480ec8951598f$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $2ae480ec8951598f$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $2ae480ec8951598f$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $2ae480ec8951598f$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("k6Eo3", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $ea33b232d012041d$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $ea33b232d012041d$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $ea33b232d012041d$export$2bce4ffdd840e878; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kg5sN = parcelRequire("kg5sN");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $8x86A = parcelRequire("8x86A");

var $1XCKE = parcelRequire("1XCKE");

var $a3buC = parcelRequire("a3buC");

var $ggnMj = parcelRequire("ggnMj");
function $ea33b232d012041d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea33b232d012041d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea33b232d012041d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea33b232d012041d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea33b232d012041d$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $ea33b232d012041d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $ea33b232d012041d$var$getPageVisibleState() {
    return typeof document !== 'undefined' && document.visibilityState === 'visible' ? $ea33b232d012041d$export$a12c67b37a306b13.VISIBLE : $ea33b232d012041d$export$a12c67b37a306b13.HIDDEN;
}
var $ea33b232d012041d$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "state", $ea33b232d012041d$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "pageVisibleState", $ea33b232d012041d$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $ea33b232d012041d$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, '-');
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $8x86A.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $ea33b232d012041d$var$getPageVisibleState();
                (0, $a3buC.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $a3buC.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $a3buC.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $ggnMj.UntilExperience).fromMetric(metricOrConfig) : (0, $ggnMj.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $ea33b232d012041d$var$getPageVisibleState();
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ea33b232d012041d$export$2bce4ffdd840e878, "FMP", 'fmp');

});
parcelRegister("cF8Kw", function(module, exports) {

var $5PW6D = parcelRequire("5PW6D");

var $2gzKi = parcelRequire("2gzKi");

var $2x5xA = parcelRequire("2x5xA");

var $aBSeI = parcelRequire("aBSeI");
function $938019caab71e88e$var$_toConsumableArray(r) {
    return $5PW6D(r) || $2gzKi(r) || $2x5xA(r) || $aBSeI();
}
module.exports = $938019caab71e88e$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5PW6D", function(module, exports) {

var $hqFoN = parcelRequire("hqFoN");
function $43fec9ce3ec2cc84$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $hqFoN(r);
}
module.exports = $43fec9ce3ec2cc84$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2gzKi", function(module, exports) {
function $1a68cdbc4b71ab15$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $1a68cdbc4b71ab15$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aBSeI", function(module, exports) {
function $7b976e47e7cf3fa8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7b976e47e7cf3fa8$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8x86A", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $6367b1548ca78ebd$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $6367b1548ca78ebd$export$df21d285cfcda81e; });
var $6367b1548ca78ebd$export$1d17377365286b00 = [
    'ssr'
];
var $6367b1548ca78ebd$export$df21d285cfcda81e = 7500;

});

parcelRegister("a3buC", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $7513196d4c09d629$export$13e680397ec8f3eb; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $7513196d4c09d629$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener('visibilitychange', this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener('pagehide', this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $7513196d4c09d629$export$13e680397ec8f3eb = new $7513196d4c09d629$var$VisibilityChangeObserver();

});

parcelRegister("ggnMj", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $bd7095d5b47b60e3$export$3fcc0936ee2cc852; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $bd7095d5b47b60e3$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($bd7095d5b47b60e3$export$3fcc0936ee2cc852, "FMP", 'fmp');

});



parcelRegister("h5wBz", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $c70c31f38521f58b$export$fd1447b187f590fe; });

var $cF8Kw = parcelRequire("cF8Kw");

var $siHsk = parcelRequire("siHsk");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $1XCKE = parcelRequire("1XCKE");

var $k6Eo3 = parcelRequire("k6Eo3");
function $c70c31f38521f58b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c70c31f38521f58b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c70c31f38521f58b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c70c31f38521f58b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c70c31f38521f58b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $c70c31f38521f58b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $c70c31f38521f58b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c70c31f38521f58b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c70c31f38521f58b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $c70c31f38521f58b$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, BasePageLoadMetric);
        _this = $c70c31f38521f58b$var$_callSuper(this, BasePageLoadMetric, [
            args
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(BasePageLoadMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($siHsk)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    {
                        startTime: 0
                    }
                ]);
                else $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "start", this, 3)([
                    params
                ]);
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $k6Eo3.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $1XCKE.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $k6Eo3.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(untilFmpMarks)));
                }
                $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "handleStop", this, 3)([
                    stopArguments
                ]);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "mark", this, 3)([
                    BasePageLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "getData", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "getDataToMerge", this, 3)([])), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                $c70c31f38521f58b$var$_superPropGet(BasePageLoadMetric, "clear", this, 3)([]);
            }
        }
    ]);
}((0, $k6Eo3.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c70c31f38521f58b$export$fd1447b187f590fe, "FMP", 'fmp');

});
parcelRegister("siHsk", function(module, exports) {
function $05511f0ce57ee028$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $05511f0ce57ee028$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("djDSg", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $9b1bfae904dc6b23$export$253d38dccbb37615; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");


var $9b1bfae904dc6b23$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "data", {
            'metric:ttci': null,
            'metric:ttfb': null,
            'metric:fid': null,
            'metric:fcp': null,
            'metric:lcp': null,
            'metric:cls': null
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("dxOty"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === 'cls' ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("h3CqE"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data['metric:ttci'] = typeof value === 'number' ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
}();
var $9b1bfae904dc6b23$export$253d38dccbb37615 = new $9b1bfae904dc6b23$var$WebVitalsObserver();

});
parcelRegister("dxOty", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("69GGh")).then(()=>parcelRequire('jn0m1'));

});
parcelRegister("1VTzg", function(module, exports) {
"use strict";

var $gTxUZ = parcelRequire("gTxUZ");
module.exports = $gTxUZ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("gTxUZ", function(module, exports) {
"use strict";
var $c4cc17d3e4784de9$var$cachedBundles = {};
var $c4cc17d3e4784de9$var$cachedPreloads = {};
var $c4cc17d3e4784de9$var$cachedPrefetches = {};
function $c4cc17d3e4784de9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $c4cc17d3e4784de9$var$cachedPreloads;
        case 'prefetch':
            return $c4cc17d3e4784de9$var$cachedPrefetches;
        default:
            return $c4cc17d3e4784de9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $c4cc17d3e4784de9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("h3CqE", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("38OVK")).then(()=>parcelRequire('8Kz3C'));

});


parcelRegister("eqyfk", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a80e0f0135cf4d97$export$e7b0ac011bb776c6; });
var $a80e0f0135cf4d97$export$e7b0ac011bb776c6 = {
    route: '',
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("e1hkl", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $a34e99832a236614$export$c21a25872e3f5a2b; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $cEEqZ = parcelRequire("cEEqZ");

var $3GjBI = parcelRequire("3GjBI");

var $d5QIn = parcelRequire("d5QIn");

var $6Uhl4 = parcelRequire("6Uhl4");
var $a34e99832a236614$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $6Uhl4.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $3GjBI.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $cEEqZ.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn('Submitter is not configured');
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $d5QIn.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload['event:key'],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: 'performance',
                            attributes: attributes,
                            source: 'performance',
                            action: 'measured'
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("cEEqZ", function(module, exports) {

$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $936895e14ce66993$export$4a759336b50e86e3; });

var $7f5qq = parcelRequire("7f5qq");

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $5msJs = parcelRequire("5msJs");

var $a6HGw = parcelRequire("a6HGw");

var $9HsPi = parcelRequire("9HsPi");

var $dyWhr = parcelRequire("dyWhr");

var $2MkMt = parcelRequire("2MkMt");

var $dxun7 = parcelRequire("dxun7");

var $bAdsy = parcelRequire("bAdsy");

var $gwJNC = parcelRequire("gwJNC");

var $7bV0v = parcelRequire("7bV0v");

var $iww5R = parcelRequire("iww5R");

var $bT8qz = parcelRequire("bT8qz");

var $csWGA = parcelRequire("csWGA");
function $936895e14ce66993$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $936895e14ce66993$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $936895e14ce66993$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $936895e14ce66993$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $936895e14ce66993$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $936895e14ce66993$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $936895e14ce66993$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $936895e14ce66993$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $936895e14ce66993$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $936895e14ce66993$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $936895e14ce66993$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $936895e14ce66993$export$d8f52e8f804021e8 = new (0, $csWGA.default)();
var $936895e14ce66993$var$interactionQueue = [];
var $936895e14ce66993$var$segmentCache = new Map();
var $936895e14ce66993$var$CLEANUP_TIMEOUT = 60000;
var $936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $936895e14ce66993$var$segmentObservers = [];
var $936895e14ce66993$export$2b3954d2e8509985 = (0, $7bV0v.withProfiling)(function getActiveInteraction() {
    var interactionId = (0, $gwJNC.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $bT8qz.interactions).get(interactionId.current);
});
var $936895e14ce66993$var$isPerformanceTracingEnabled = (0, $7bV0v.withProfiling)(function isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $dyWhr.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
});
var $936895e14ce66993$var$labelStackToString = (0, $7bV0v.withProfiling)(function labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join('/');
});
var $936895e14ce66993$var$labelStackToIdString = (0, $7bV0v.withProfiling)(function labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return 'segmentId' in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join('/');
});
var $936895e14ce66993$var$addSegmentObserver = (0, $7bV0v.withProfiling)(function addSegmentObserver(observer) {
    $936895e14ce66993$var$segmentObservers.push(observer);
    var _iterator = $936895e14ce66993$var$_createForOfIteratorHelper($936895e14ce66993$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
});
var $936895e14ce66993$var$removeSegmentObserver = (0, $7bV0v.withProfiling)(function removeSegmentObserver(observer) {
    var index = $936895e14ce66993$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $936895e14ce66993$var$segmentObservers.splice(index, 1);
});
var $936895e14ce66993$export$cd7f480d6b8286c3 = (0, $7bV0v.withProfiling)(function remove(interactionId) {
    (0, $bT8qz.interactions).delete(interactionId);
});
var $936895e14ce66993$export$f6f1cf5bedf83c71 = (0, $7bV0v.withProfiling)(function updatePageLoadInteractionName(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $936895e14ce66993$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== 'page_load' && interaction.type !== 'transition') return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
});
var $936895e14ce66993$export$12f2b6cb85d59904 = (0, $7bV0v.withProfiling)(function addMetadata(interactionId, data) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
});
var $936895e14ce66993$export$e4380431c2bdabee = (0, $7bV0v.withProfiling)(function addCustomData(interactionId, labelStack, data) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, i, data[i])
        });
    });
});
var $936895e14ce66993$export$27cacb7d7f3fe20a = (0, $7bV0v.withProfiling)(function addCustomTiming(interactionId, labelStack, data) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($936895e14ce66993$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
});
var $936895e14ce66993$export$728e28c22a0fba4 = (0, $7bV0v.withProfiling)(function addMark(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($936895e14ce66993$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
});
var $936895e14ce66993$export$c4b23cc624bd2fb = (0, $7bV0v.withProfiling)(function addMarkToAll(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $bT8qz.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($936895e14ce66993$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
});
var $936895e14ce66993$export$2c1d6e17cfa9bbc7 = (0, $7bV0v.withProfiling)(function addSpan(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($936895e14ce66993$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
});
var $936895e14ce66993$export$943a8b2b5d6b1809 = (0, $7bV0v.withProfiling)(function addSpanToAll(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $bT8qz.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($936895e14ce66993$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
});
var $936895e14ce66993$export$9e04fe1a58571ec = (0, $7bV0v.withProfiling)(function addPreload(moduleId, timestamp) {
    $936895e14ce66993$export$c4b23cc624bd2fb('bundle_preload', moduleId, null, timestamp);
});
var $936895e14ce66993$export$6f228d1fdc911d7 = (0, $7bV0v.withProfiling)(function addLoad(identifier, start, end) {
    $936895e14ce66993$export$943a8b2b5d6b1809('bundle_load', identifier, null, start, end - start);
});
var $936895e14ce66993$var$moduleLoadingRequests = {};
var $936895e14ce66993$export$f5a8f10de74904da = (0, $7bV0v.withProfiling)(function extractModuleName(input) {
    var result = input !== null && input !== void 0 ? input : '';
    result = result.replace(/^\.\/src\/packages\//, '');
    result = result.replace(/^\.\/node_modules\//, '');
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, '');
    return result;
});
var $936895e14ce66993$var$addHoldCriterion = (0, $7bV0v.withProfiling)(function addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $936895e14ce66993$var$labelStackToString(labelStack), name, startTime);
});
var $936895e14ce66993$var$removeHoldCriterion = (0, $7bV0v.withProfiling)(function removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
});
var $936895e14ce66993$export$7606887303596f82 = (0, $7bV0v.withProfiling)(function addHold(interactionId, labelStack, name, experimental) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    var id = (0, $a6HGw.v4)();
    if (interaction != null) {
        var _getConfig2;
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        if ((_getConfig2 = (0, $dyWhr.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled && experimental) interaction.holdExpActive.set(id, $936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        if (!experimental) interaction.holdActive.set(id, $936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, holdActive), {}, {
            start: start
        }));
        $936895e14ce66993$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if ($936895e14ce66993$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $936895e14ce66993$var$removeHoldCriterion(id);
            var currentInteraction = (0, $bT8qz.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
            }
        };
    }
    return function() {};
});
var $936895e14ce66993$export$10582acd678c213 = (0, $7bV0v.withProfiling)(function addHoldByID(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $936895e14ce66993$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
});
var $936895e14ce66993$export$4983dfbbb996f7ae = (0, $7bV0v.withProfiling)(function removeHoldByID(interactionId, id) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $bT8qz.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $936895e14ce66993$var$removeHoldCriterion(id);
        }
    }
});
var $936895e14ce66993$export$2df109852219d16e = (0, $7bV0v.withProfiling)(function getCurrentInteractionType(interactionId) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
});
var $936895e14ce66993$export$9591b52b33ccc510 = {
    onPreload: (0, $7bV0v.withProfiling)(function onPreload(moduleId, _priority) {
        $936895e14ce66993$export$9e04fe1a58571ec($936895e14ce66993$export$f5a8f10de74904da(moduleId), performance.now());
    }),
    onLoadStart: (0, $7bV0v.withProfiling)(function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $936895e14ce66993$var$moduleLoadingRequests[info.identifier] = request;
    }),
    onLoadComplete: (0, $7bV0v.withProfiling)(function onLoadComplete(info) {
        var request = $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
            $936895e14ce66993$export$6f228d1fdc911d7($936895e14ce66993$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    }),
    placeholderFallBackMounted: (0, $7bV0v.withProfiling)(function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $gwJNC.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $936895e14ce66993$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    }),
    placeholderFallBackUnmounted: (0, $7bV0v.withProfiling)(function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $gwJNC.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $936895e14ce66993$export$4983dfbbb996f7ae(currentInteractionId, id);
    })
};
var $936895e14ce66993$export$239c33984d9b1367 = (0, $7bV0v.withProfiling)(function addError(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
});
var $936895e14ce66993$export$7379c15afd3840fa = (0, $7bV0v.withProfiling)(function addErrorToAll(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $bT8qz.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
});
var $936895e14ce66993$export$53d6f611de951a13 = (0, $7bV0v.withProfiling)(function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig3;
    if ($936895e14ce66993$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig3 = (0, $dyWhr.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $936895e14ce66993$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
});
var $936895e14ce66993$var$pushToQueue = (0, $7bV0v.withProfiling)(function pushToQueue(id, data) {
    $936895e14ce66993$var$interactionQueue.push({
        id: id,
        data: data
    });
});
var $936895e14ce66993$var$handleInteraction = $936895e14ce66993$var$pushToQueue;
var $936895e14ce66993$var$callCleanUpCallbacks = (0, $7bV0v.withProfiling)(function callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
});
var $936895e14ce66993$var$finishInteraction = (0, $7bV0v.withProfiling)(function finishInteraction(id, data) {
    var _getConfig4, _getConfig5;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $bAdsy.currentFeatureFlagsAccessed));
    (0, $dxun7.clearActiveTrace)();
    $936895e14ce66993$var$callCleanUpCallbacks(data);
    if ((_getConfig4 = (0, $dyWhr.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.vc) !== null && _getConfig4 !== void 0 && _getConfig4.stopVCAtInteractionFinish) data.vc = (0, $iww5R.getVCObserver)().getVCRawData();
    if (!((_getConfig5 = (0, $dyWhr.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) $936895e14ce66993$export$cd7f480d6b8286c3(id);
    $936895e14ce66993$var$PreviousInteractionLog.name = data.ufoName || 'unknown';
    $936895e14ce66993$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $936895e14ce66993$var$handleInteraction(id, data);
    if ($936895e14ce66993$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $936895e14ce66993$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator2 = $936895e14ce66993$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step2.value, 2), _step2$value$ = _step2$value[1], labelStack = _step2$value$.labelStack, start = _step2$value$.start, end = _step2$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent('UFO_FINISH_INTERACTION', {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
});
var $936895e14ce66993$export$9e614a29a1ac213e = (0, $7bV0v.withProfiling)(function sinkInteractionHandler(sinkFn) {
    if ($936895e14ce66993$var$handleInteraction === $936895e14ce66993$var$pushToQueue) {
        $936895e14ce66993$var$handleInteraction = sinkFn;
        $936895e14ce66993$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $936895e14ce66993$var$interactionQueue.length = 0;
    }
});
var $936895e14ce66993$export$8a1ba7bef607358a = (0, $7bV0v.withProfiling)(function sinkPostInteractionLogHandler(sinkFn) {
    $936895e14ce66993$export$d8f52e8f804021e8.sinkHandler(sinkFn);
});
// a flag to prevent multiple submitting
var $936895e14ce66993$var$activeSubmitted = false;
var $936895e14ce66993$export$673be905888f8839 = (0, $7bV0v.withProfiling)(function tryComplete(interactionId, endTime) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                var _getConfig6, _getConfig8;
                var _getConfig7, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig6 = (0, $dyWhr.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.postInteractionLog) !== null && _getConfig6 !== void 0 && _getConfig6.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig7 = (0, $dyWhr.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.experimentalInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $2MkMt.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta['metric:experimental:vc90'];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $936895e14ce66993$export$d8f52e8f804021e8.onInteractionComplete($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if ((_getConfig8 = (0, $dyWhr.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.experimentalInteractionMetrics) !== null && _getConfig8 !== void 0 && _getConfig8.enabled) $936895e14ce66993$export$cd7f480d6b8286c3(interactionId);
                            $936895e14ce66993$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        if (noMoreActiveHolds) {
            if (!$936895e14ce66993$var$activeSubmitted) {
                $936895e14ce66993$var$finishInteraction(interactionId, interaction, endTime);
                $936895e14ce66993$var$activeSubmitted = true;
            }
            if (noMoreExpHolds) {
                var _getConfig9;
                if ((_getConfig9 = (0, $dyWhr.getConfig)()) !== null && _getConfig9 !== void 0 && (_getConfig9 = _getConfig9.experimentalInteractionMetrics) !== null && _getConfig9 !== void 0 && _getConfig9.enabled) (0, $2MkMt.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                postInteraction();
            }
        }
    }
});
var $936895e14ce66993$var$callCancelCallbacks = (0, $7bV0v.withProfiling)(function callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
});
var $936895e14ce66993$export$5def58af4fd46132 = (0, $7bV0v.withProfiling)(function abort(interactionId, abortReason) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig10;
        $936895e14ce66993$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
        if ((_getConfig10 = (0, $dyWhr.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.experimentalInteractionMetrics) !== null && _getConfig10 !== void 0 && _getConfig10.enabled) {
            (0, $2MkMt.onExperimentalInteractionComplete)(interactionId, interaction);
            $936895e14ce66993$export$cd7f480d6b8286c3(interactionId);
        }
    }
});
var $936895e14ce66993$export$c4a545284f55edf2 = (0, $7bV0v.withProfiling)(function abortByNewInteraction(interactionId, interactionName) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        var _getConfig11;
        $936895e14ce66993$var$callCancelCallbacks(interaction);
        interaction.abortReason = 'new_interaction';
        interaction.abortedByInteractionName = interactionName;
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
        if ((_getConfig11 = (0, $dyWhr.getConfig)()) !== null && _getConfig11 !== void 0 && (_getConfig11 = _getConfig11.experimentalInteractionMetrics) !== null && _getConfig11 !== void 0 && _getConfig11.enabled) {
            (0, $2MkMt.onExperimentalInteractionComplete)(interactionId, interaction);
            $936895e14ce66993$export$cd7f480d6b8286c3(interactionId);
        }
    }
});
var $936895e14ce66993$export$614a7af2affc5dff = (0, $7bV0v.withProfiling)(function abortAll(abortReason, abortedByInteractionName) {
    (0, $bT8qz.interactions).forEach(function(interaction, interactionId) {
        var _getConfig12;
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $936895e14ce66993$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
        if ((_getConfig12 = (0, $dyWhr.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) {
            (0, $2MkMt.onExperimentalInteractionComplete)(interactionId, interaction);
            $936895e14ce66993$export$cd7f480d6b8286c3(interactionId);
        }
    });
});
var $936895e14ce66993$export$7b9261a96cfe427b = (0, $7bV0v.withProfiling)(function addOnCancelCallback(id, cancelCallback) {
    var interaction = (0, $bT8qz.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
});
var $936895e14ce66993$export$1a1ed1e1fdb2006b = (0, $7bV0v.withProfiling)(function addNewInteraction(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig13;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig13 = (0, $dyWhr.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $936895e14ce66993$export$d8f52e8f804021e8.reset();
    var previousTime = startTime;
    var timeoutTime = $936895e14ce66993$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $936895e14ce66993$export$5def58af4fd46132(interactionId, 'timeout');
    }, $936895e14ce66993$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $936895e14ce66993$export$5def58af4fd46132(interactionId, 'timeout');
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $9HsPi.default)((0, $dyWhr.getCapabilityRate)('feature_flag_access'));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $936895e14ce66993$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $936895e14ce66993$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $bAdsy.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $bAdsy.currentFeatureFlagsAccessed).clear();
    (0, $bT8qz.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $936895e14ce66993$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $936895e14ce66993$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $dyWhr.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $936895e14ce66993$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === 'transition') {
        var _getConfig14;
        (0, $iww5R.getVCObserver)().start({
            startTime: startTime
        });
        $936895e14ce66993$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((_getConfig14 = (0, $dyWhr.getConfig)()) !== null && _getConfig14 !== void 0 && (_getConfig14 = _getConfig14.experimentalInteractionMetrics) !== null && _getConfig14 !== void 0 && _getConfig14.enabled) (0, $2MkMt.experimentalVC).start({
            startTime: startTime
        });
    }
});
var $936895e14ce66993$export$4a759336b50e86e3 = (0, $7bV0v.withProfiling)(function addBrowserMetricEvent(event) {
    var interaction = $936895e14ce66993$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === 'page_load' || interaction.type === 'transition') && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === 'PAGE_LOAD') {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
});
var $936895e14ce66993$export$ad216cc25852d44b = (0, $7bV0v.withProfiling)(function addApdexToAll(apdex) {
    (0, $bT8qz.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
});
var $936895e14ce66993$export$35220fd6cdd1b731 = (0, $7bV0v.withProfiling)(function addApdex(interactionId, apdexInfo) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === 'page_load' || interaction.type === 'transition') {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
});
var $936895e14ce66993$export$57d55b4569823d8f = (0, $7bV0v.withProfiling)(function addRequestInfo(interactionId, labelStack, requestInfo) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($936895e14ce66993$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
});
var $936895e14ce66993$var$isSegmentLabel = (0, $7bV0v.withProfiling)(function isSegmentLabel(obj) {
    return obj && typeof obj.name === 'string' && typeof obj.segmentId === 'string';
});
var $936895e14ce66993$var$getSegmentCacheKey = (0, $7bV0v.withProfiling)(function getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($936895e14ce66993$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join('|');
});
var $936895e14ce66993$export$1c43f9ac826b6462 = (0, $7bV0v.withProfiling)(function addSegment(labelStack) {
    var key = $936895e14ce66993$var$getSegmentCacheKey(labelStack);
    var existingSegment = $936895e14ce66993$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $936895e14ce66993$var$segmentCache.set(key, segmentInfo);
        $936895e14ce66993$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
});
var $936895e14ce66993$export$d0365e48b58231c3 = (0, $7bV0v.withProfiling)(function removeSegment(labelStack) {
    var key = $936895e14ce66993$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $936895e14ce66993$var$segmentCache.get(key);
    if (segmentInfo) {
        $936895e14ce66993$var$segmentCache.delete(JSON.stringify(labelStack));
        $936895e14ce66993$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
});
var $936895e14ce66993$export$bbf14d79614d9818 = (0, $7bV0v.withProfiling)(function addRedirect(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $bT8qz.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($936895e14ce66993$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
});
var $936895e14ce66993$export$6ce04c7ca6810a7e = [];
var $936895e14ce66993$var$defaultLabelStack = [
    {
        name: 'custom'
    }
];
var $936895e14ce66993$export$5342dcad19138a1c = (0, $7bV0v.withProfiling)(function addCustomSpans(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $936895e14ce66993$var$defaultLabelStack;
    var customSpan = {
        type: 'custom',
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $936895e14ce66993$export$6ce04c7ca6810a7e.push(customSpan);
});

});
parcelRegister("a6HGw", function(module, exports) {

var $2CvmD = parcelRequire("2CvmD");

var $gaCcd = parcelRequire("gaCcd");
var $75bc59d865218414$var$uuid = $gaCcd;
$75bc59d865218414$var$uuid.v1 = $2CvmD;
$75bc59d865218414$var$uuid.v4 = $gaCcd;
module.exports = $75bc59d865218414$var$uuid;

});
parcelRegister("2CvmD", function(module, exports) {

var $9mvsX = parcelRequire("9mvsX");

var $diJJr = parcelRequire("diJJr");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $1e8775a88be993f8$var$_nodeId;
var $1e8775a88be993f8$var$_clockseq;
// Previous uuid creation time
var $1e8775a88be993f8$var$_lastMSecs = 0;
var $1e8775a88be993f8$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $1e8775a88be993f8$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $1e8775a88be993f8$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $1e8775a88be993f8$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $9mvsX();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $1e8775a88be993f8$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $1e8775a88be993f8$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $1e8775a88be993f8$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $1e8775a88be993f8$var$_lastMSecs + (nsecs - $1e8775a88be993f8$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $1e8775a88be993f8$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $1e8775a88be993f8$var$_lastMSecs = msecs;
    $1e8775a88be993f8$var$_lastNSecs = nsecs;
    $1e8775a88be993f8$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $diJJr(b);
}
module.exports = $1e8775a88be993f8$var$v1;

});


parcelRegister("9HsPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70fe7d8078cc2f59$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ var $70fe7d8078cc2f59$var$coinflip = (0, $7bV0v.withProfiling)(function coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
});
var $70fe7d8078cc2f59$export$2e2bcd8739ae039 = $70fe7d8078cc2f59$var$coinflip;

});
parcelRegister("7bV0v", function(module, exports) {

$parcel$export(module.exports, "withProfiling", function () { return $53c5c7e7701db8a0$export$5fee8d7b32c0d54f; });
$parcel$export(module.exports, "markProfilingStart", function () { return $53c5c7e7701db8a0$export$32aa818f3c5feabe; });
$parcel$export(module.exports, "markProfilingEnd", function () { return $53c5c7e7701db8a0$export$293bccc5603149b4; });

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");
function $53c5c7e7701db8a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53c5c7e7701db8a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53c5c7e7701db8a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53c5c7e7701db8a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $53c5c7e7701db8a0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $53c5c7e7701db8a0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $53c5c7e7701db8a0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $53c5c7e7701db8a0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $53c5c7e7701db8a0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $53c5c7e7701db8a0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
globalThis.__ufo_self_measurements = globalThis.__ufo_self_measurements || {
    __internalState: {
        functionStack: []
    },
    runtime: {
        total: 0,
        async: 0,
        error: 0,
        byFunction: {},
        custom: {}
    }
};
function $53c5c7e7701db8a0$export$a4a352ce60895de1() {
    globalThis.__ufo_self_measurements = {
        __internalState: {
            functionStack: []
        },
        runtime: {
            total: 0,
            async: 0,
            error: 0,
            byFunction: {},
            custom: {}
        }
    };
}
function $53c5c7e7701db8a0$var$trackFunctionTimingStart(fnName) {
    var _globalThis$__ufo_sel;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $53c5c7e7701db8a0$export$a4a352ce60895de1();
    globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel === void 0 || (_globalThis$__ufo_sel = _globalThis$__ufo_sel.__internalState) === null || _globalThis$__ufo_sel === void 0 || (_globalThis$__ufo_sel = _globalThis$__ufo_sel.functionStack) === null || _globalThis$__ufo_sel === void 0 || _globalThis$__ufo_sel.push(fnName);
}
function $53c5c7e7701db8a0$var$trackFunctionTimingEnd() {
    var _globalThis$__ufo_sel2;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $53c5c7e7701db8a0$export$a4a352ce60895de1();
    globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel2 = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel2 === void 0 || (_globalThis$__ufo_sel2 = _globalThis$__ufo_sel2.__internalState) === null || _globalThis$__ufo_sel2 === void 0 || (_globalThis$__ufo_sel2 = _globalThis$__ufo_sel2.functionStack) === null || _globalThis$__ufo_sel2 === void 0 || _globalThis$__ufo_sel2.pop();
}
function $53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement() {
    var _globalThis$__ufo_sel3;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $53c5c7e7701db8a0$export$a4a352ce60895de1();
    return (globalThis === null || globalThis === void 0 || (_globalThis$__ufo_sel3 = globalThis.__ufo_self_measurements) === null || _globalThis$__ufo_sel3 === void 0 || (_globalThis$__ufo_sel3 = _globalThis$__ufo_sel3.__internalState) === null || _globalThis$__ufo_sel3 === void 0 || (_globalThis$__ufo_sel3 = _globalThis$__ufo_sel3.functionStack) === null || _globalThis$__ufo_sel3 === void 0 ? void 0 : _globalThis$__ufo_sel3.length) === 0;
}
function $53c5c7e7701db8a0$var$recordProfilerMeasurement(functionName, duration, isAsync, isError) {
    var tags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    // discard measurements that are not significant
    if (duration <= 0) return;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.__ufo_self_measurements)) $53c5c7e7701db8a0$export$a4a352ce60895de1();
    globalThis.__ufo_self_measurements.runtime.total += duration;
    if (isAsync) globalThis.__ufo_self_measurements.runtime.async += duration;
    if (isError) globalThis.__ufo_self_measurements.runtime.error += duration;
    if (functionName in globalThis.__ufo_self_measurements.runtime.byFunction) globalThis.__ufo_self_measurements.runtime.byFunction[functionName] += duration;
    else globalThis.__ufo_self_measurements.runtime.byFunction[functionName] = duration;
    var _iterator = $53c5c7e7701db8a0$var$_createForOfIteratorHelper(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var tag = _step.value;
            if (tag in globalThis.__ufo_self_measurements.runtime.custom) globalThis.__ufo_self_measurements.runtime.custom[tag] += duration;
            else globalThis.__ufo_self_measurements.runtime.custom[tag] = duration;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $53c5c7e7701db8a0$var$isPromise(value) {
    return value && typeof value.then === 'function';
}
function $53c5c7e7701db8a0$export$5fee8d7b32c0d54f(fn) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    try {
        if (!(0, $i2LcI.fg)('platform_ufo_self_timings')) return fn; // this is a NOOP wrapper if feature gate is disabled
    } catch (_unused) {
        return fn;
    }
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return fn;
    if (fn.constructor.name === 'AsyncFunction') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
        var _fn$name;
        var startTime, result, endTime, _endTime, _args = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    startTime = performance.now();
                    $53c5c7e7701db8a0$var$trackFunctionTimingStart((_fn$name = fn.name) !== null && _fn$name !== void 0 ? _fn$name : 'anonymous');
                    _context.prev = 2;
                    _context.next = 5;
                    return fn.apply(void 0, _args);
                case 5:
                    result = _context.sent;
                    endTime = performance.now();
                    $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
                    if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, false, tags);
                    return _context.abrupt("return", result);
                case 12:
                    _context.prev = 12;
                    _context.t0 = _context["catch"](2);
                    _endTime = performance.now();
                    $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
                    if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, _endTime - startTime, true, true, tags);
                    throw _context.t0;
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                12
            ]
        ]);
    }));
    return function() {
        var _fn$name2;
        var startTime = performance.now();
        $53c5c7e7701db8a0$var$trackFunctionTimingStart((_fn$name2 = fn.name) !== null && _fn$name2 !== void 0 ? _fn$name2 : 'anonymous');
        try {
            var result = fn.apply(void 0, arguments);
            if ($53c5c7e7701db8a0$var$isPromise(result)) result.then(function(value) {
                var endTime = performance.now();
                $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
                if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, false, tags);
                return value;
            }).catch(function(value) {
                var endTime = performance.now();
                $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
                if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, endTime - startTime, true, true, tags);
                return value;
            });
            else {
                var endTime = performance.now();
                $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
                if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, endTime - startTime, false, false, tags);
            }
            return result;
        } catch (error) {
            var _endTime2 = performance.now();
            $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
            if ($53c5c7e7701db8a0$var$shouldRecordProfilerMeasurement()) $53c5c7e7701db8a0$var$recordProfilerMeasurement(fn.name, _endTime2 - startTime, false, true, tags);
            throw error;
        }
    };
}
function $53c5c7e7701db8a0$export$32aa818f3c5feabe(name) {
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return {
        name: name,
        startTime: -1
    };
    $53c5c7e7701db8a0$var$trackFunctionTimingStart(name);
    return {
        name: name,
        startTime: performance.now()
    };
}
function $53c5c7e7701db8a0$export$293bccc5603149b4(_ref2) {
    var name = _ref2.name, startTime = _ref2.startTime;
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, isAsync = _ref3.isAsync, isError = _ref3.isError, tags = _ref3.tags;
    if (!(globalThis !== null && globalThis !== void 0 && globalThis.performance)) return;
    $53c5c7e7701db8a0$var$trackFunctionTimingEnd();
    if (!(0, $i2LcI.fg)('platform_ufo_self_timings')) return;
    var endTime = performance.now();
    $53c5c7e7701db8a0$var$recordProfilerMeasurement(name, endTime - startTime, isAsync, isError, tags);
}
function $53c5c7e7701db8a0$export$d3e2c82243dab73a() {
    return $53c5c7e7701db8a0$var$_objectSpread({}, globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime);
}
function $53c5c7e7701db8a0$export$898d7c11d63bc2e5() {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.total) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.total);
    return null;
}
function $53c5c7e7701db8a0$export$a7794d55eaa6800e() {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.async) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.async);
    return null;
}
function $53c5c7e7701db8a0$export$c321c81126f91d1c(functionName) {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.byFunction[functionName]) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.byFunction[functionName]);
    return null;
}
function $53c5c7e7701db8a0$export$5e3aaf097aba6e53(tag) {
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.custom[tag]) === 'number') return Math.round(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__ufo_self_measurements.runtime.custom[tag]);
    return null;
}

});


parcelRegister("dyWhr", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $9dfba891a747bf0b$export$44487a86467333c3; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $9dfba891a747bf0b$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $9dfba891a747bf0b$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "shouldHandleEditorLnv", function () { return $9dfba891a747bf0b$export$808cd22f6b703d66; });

var $7bV0v = parcelRequire("7bV0v");
var $9dfba891a747bf0b$var$config;
var $9dfba891a747bf0b$export$10d6139a8fb42158 = (0, $7bV0v.withProfiling)(function setUFOConfig(newConfig) {
    $9dfba891a747bf0b$var$config = newConfig;
});
var $9dfba891a747bf0b$export$44487a86467333c3 = (0, $7bV0v.withProfiling)(function getConfig() {
    return $9dfba891a747bf0b$var$config;
});
var $9dfba891a747bf0b$export$9466a8f085fa7d4e = (0, $7bV0v.withProfiling)(function getInteractionRate(name, interactionKind) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config = $9dfba891a747bf0b$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, 'ig');
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith('auto-generated');
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
});
var $9dfba891a747bf0b$export$563f73272328c0d = (0, $7bV0v.withProfiling)(function getExperimentalInteractionRate(name, interactionType) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config2 = $9dfba891a747bf0b$var$config, experimentalInteractionMetrics = _config2.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === 'number') return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === 'number') return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
});
var $9dfba891a747bf0b$export$1d459f020c06ae34 = (0, $7bV0v.withProfiling)(function getPostInteractionRate(name, interactionType) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config3 = $9dfba891a747bf0b$var$config, postInteractionLog = _config3.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === 'number') return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === 'number') return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
});
var $9dfba891a747bf0b$export$29b9ffb14861a1d = (0, $7bV0v.withProfiling)(function getCapabilityRate(capability) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config4 = $9dfba891a747bf0b$var$config, capabilityRate = _config4.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
});
var $9dfba891a747bf0b$var$validTypingMethods = [
    'timeout',
    'timeoutNoAlloc',
    'mutationObserver'
];
var $9dfba891a747bf0b$export$7e32aae12bf9b50f = (0, $7bV0v.withProfiling)(function getTypingPerformanceTracingMethod() {
    var defaultMethod = 'timeout';
    try {
        if (!$9dfba891a747bf0b$var$config) return defaultMethod;
        var _config5 = $9dfba891a747bf0b$var$config, typingMethod = _config5.typingMethod;
        if (typingMethod != null && $9dfba891a747bf0b$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
});
var $9dfba891a747bf0b$export$2d311b3fd18dcab1 = (0, $7bV0v.withProfiling)(function getAwaitBM3TTIList() {
    try {
        if (!$9dfba891a747bf0b$var$config) return [];
        var _config6 = $9dfba891a747bf0b$var$config, awaitBM3TTI = _config6.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
});
var $9dfba891a747bf0b$export$e2ea675800536898 = (0, $7bV0v.withProfiling)(function getRemovePageSegmentsUFOPrefixes() {
    try {
        if (!$9dfba891a747bf0b$var$config) return false;
        var _config7 = $9dfba891a747bf0b$var$config, removePageSegmentsUFOPrefixes = _config7.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
});
var $9dfba891a747bf0b$export$525ba53ca98e9db = (0, $7bV0v.withProfiling)(function getRemoveInteractionsUFOPrefixes() {
    try {
        if (!$9dfba891a747bf0b$var$config) return false;
        var _config8 = $9dfba891a747bf0b$var$config, removeInteractionsUFOPrefixes = _config8.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
});
var $9dfba891a747bf0b$export$4f4649ef27b6f5d6 = (0, $7bV0v.withProfiling)(function getUfoNameOverrides() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config9 = $9dfba891a747bf0b$var$config, ufoNameOverrides = _config9.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
});
var $9dfba891a747bf0b$export$3c170167645a0eff = (0, $7bV0v.withProfiling)(function getDoNotAbortActivePressInteraction() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config10 = $9dfba891a747bf0b$var$config, doNotAbortActivePressInteraction = _config10.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
});
var $9dfba891a747bf0b$export$d6dc9444bd15f70f = (0, $7bV0v.withProfiling)(function getDoNotAbortActivePressInteractionOnTransition() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config11 = $9dfba891a747bf0b$var$config, doNotAbortActivePressInteractionOnTransition = _config11.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
});
var $9dfba891a747bf0b$export$808cd22f6b703d66 = (0, $7bV0v.withProfiling)(function shouldHandleEditorLnv() {
    try {
        var _config$enableEditorL, _config12;
        return (_config$enableEditorL = (_config12 = $9dfba891a747bf0b$var$config) === null || _config12 === void 0 ? void 0 : _config12.enableEditorLnvHandler) !== null && _config$enableEditorL !== void 0 ? _config$enableEditorL : false;
    } catch (e) {
        return false;
    }
});

});

parcelRegister("2MkMt", function(module, exports) {

$parcel$export(module.exports, "onExperimentalInteractionComplete", function () { return $20602f202fa669aa$export$1aed449484dedf63; });
$parcel$export(module.exports, "experimentalVC", function () { return $20602f202fa669aa$export$81b28dca2587ec47; });
$parcel$export(module.exports, "getExperimentalVCMetrics", function () { return $20602f202fa669aa$export$d17d2b5c5e8d732e; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $kRzLu = parcelRequire("kRzLu");

var $7bV0v = parcelRequire("7bV0v");

var $gXYFp = parcelRequire("gXYFp");
function $20602f202fa669aa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $20602f202fa669aa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $20602f202fa669aa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $20602f202fa669aa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $20602f202fa669aa$var$interactionBuffer = [];
var $20602f202fa669aa$var$bufferInteractionData = (0, $7bV0v.withProfiling)(function bufferInteractionData(interactionId, data) {
    $20602f202fa669aa$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
});
var $20602f202fa669aa$var$clearInteractionBuffer = (0, $7bV0v.withProfiling)(function clearInteractionBuffer() {
    $20602f202fa669aa$var$interactionBuffer.length = 0;
});
var $20602f202fa669aa$var$appendInteractionData = (0, $7bV0v.withProfiling)(function appendInteractionData(interactionId, data) {
    $20602f202fa669aa$var$bufferInteractionData(interactionId, data);
});
var $20602f202fa669aa$export$c8a9e17ae62a073d = (0, $7bV0v.withProfiling)(function installInteractionSink(handler) {
    for(var _i = 0, _interactionBuffer = $20602f202fa669aa$var$interactionBuffer; _i < _interactionBuffer.length; _i++){
        var _interactionBuffer$_i = _interactionBuffer[_i], _interactionId = _interactionBuffer$_i.interactionId, data = _interactionBuffer$_i.data;
        handler(_interactionId, data);
    }
    $20602f202fa669aa$var$clearInteractionBuffer();
    $20602f202fa669aa$var$bufferInteractionData = (0, $7bV0v.withProfiling)(handler);
});
var $20602f202fa669aa$export$7aa99c40634ac65f = (0, $7bV0v.withProfiling)(function sinkExperimentalHandler(sinkFn) {
    $20602f202fa669aa$export$c8a9e17ae62a073d(sinkFn);
});
var $20602f202fa669aa$export$1aed449484dedf63 = (0, $7bV0v.withProfiling)(function onExperimentalInteractionComplete(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $20602f202fa669aa$var$appendInteractionData(interactionId, data);
        $20602f202fa669aa$var$clearInteractionBuffer();
    }
});
var $20602f202fa669aa$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ExperimentalVCMetrics);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcObserver", null);
        this.initialize = (0, $7bV0v.withProfiling)(this.initialize.bind(this));
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $gXYFp.VCObserver)($20602f202fa669aa$var$_objectSpread($20602f202fa669aa$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $20602f202fa669aa$export$81b28dca2587ec47 = new $20602f202fa669aa$export$f9a59f57e0282541();
var $20602f202fa669aa$export$d17d2b5c5e8d732e = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _getExperimentalVCMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(interaction) {
        var _interaction$apdex, prefix, result, VC, pageVisibilityUpToTTAI;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!$20602f202fa669aa$export$81b28dca2587ec47.vcObserver) {
                        _context.next = 12;
                        break;
                    }
                    prefix = 'ufo-experimental';
                    _context.next = 4;
                    return $20602f202fa669aa$export$81b28dca2587ec47.vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc
                    });
                case 4:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result['metrics:vc'];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 8;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 8:
                    pageVisibilityUpToTTAI = (0, $kRzLu.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== 'visible')) {
                        _context.next = 11;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 11:
                    return _context.abrupt("return", $20602f202fa669aa$var$_objectSpread($20602f202fa669aa$var$_objectSpread({}, result), {}, {
                        'metric:experimental:vc90': VC['90']
                    }));
                case 12:
                    return _context.abrupt("return", null);
                case 13:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function getExperimentalVCMetrics(_x) {
        return _getExperimentalVCMetrics.apply(this, arguments);
    }
    return getExperimentalVCMetrics;
}());

});
parcelRegister("kRzLu", function(module, exports) {

$parcel$export(module.exports, "getPageVisibilityState", function () { return $f304800b0ffa6c00$export$768b2008623433e1; });

var $k6Bkl = parcelRequire("k6Bkl");
var $f304800b0ffa6c00$var$timings = [];
var $f304800b0ffa6c00$var$wasHiddenFlag;
var $f304800b0ffa6c00$var$setupFlag = false;
function $f304800b0ffa6c00$var$isPageHidden() {
    if ('visibilityState' in document) return document.visibilityState === 'hidden';
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $f304800b0ffa6c00$var$SIZE = 50;
var $f304800b0ffa6c00$var$insertIndex = 0;
function $f304800b0ffa6c00$var$pushHidden(isPageHiddenFlag, time) {
    $f304800b0ffa6c00$var$timings[$f304800b0ffa6c00$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $f304800b0ffa6c00$var$insertIndex = ($f304800b0ffa6c00$var$insertIndex + 1) % $f304800b0ffa6c00$var$SIZE;
    $f304800b0ffa6c00$var$wasHiddenFlag = isPageHiddenFlag;
}
function $f304800b0ffa6c00$var$handleChange() {
    var isPageHiddenFlag = $f304800b0ffa6c00$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$f304800b0ffa6c00$var$wasHiddenFlag) $f304800b0ffa6c00$var$pushHidden(isPageHiddenFlag);
        $f304800b0ffa6c00$var$wasHiddenFlag = true;
    } else {
        if ($f304800b0ffa6c00$var$wasHiddenFlag) $f304800b0ffa6c00$var$pushHidden(isPageHiddenFlag);
        $f304800b0ffa6c00$var$wasHiddenFlag = false;
    }
}
function $f304800b0ffa6c00$var$setup() {
    (0, $k6Bkl.bind)(window, {
        type: 'pageshow',
        listener: $f304800b0ffa6c00$var$handleChange
    });
    (0, $k6Bkl.bind)(window, {
        type: 'pagehide',
        listener: $f304800b0ffa6c00$var$handleChange
    });
    (0, $k6Bkl.bind)(document, {
        type: 'visibilitychange',
        listener: $f304800b0ffa6c00$var$handleChange
    });
}
function $f304800b0ffa6c00$export$554cefe0f0373da4() {
    if (!$f304800b0ffa6c00$var$setupFlag) {
        var isPageHiddenFlag = $f304800b0ffa6c00$var$isPageHidden();
        $f304800b0ffa6c00$var$pushHidden(isPageHiddenFlag, 0);
        $f304800b0ffa6c00$var$setup();
        $f304800b0ffa6c00$var$setupFlag = true;
    }
}
function $f304800b0ffa6c00$export$768b2008623433e1(start, end) {
    // Desirable default value is visible
    if ($f304800b0ffa6c00$var$timings.length === 0) return 'visible';
    var currentSize = $f304800b0ffa6c00$var$timings.length;
    var hiddenState = 'mixed';
    var startIdx = $f304800b0ffa6c00$var$insertIndex;
    var endIdx = $f304800b0ffa6c00$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($f304800b0ffa6c00$var$insertIndex + i) % currentSize;
        if ($f304800b0ffa6c00$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($f304800b0ffa6c00$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    if (endIdx - startIdx === 0) {
        if ($f304800b0ffa6c00$var$timings[startIdx].hidden) hiddenState = 'hidden';
        else hiddenState = 'visible';
    }
    return hiddenState;
}

});
parcelRegister("k6Bkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $d4F9Q = parcelRequire("d4F9Q");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $d4F9Q.bind;
    }
});

var $4uBc4 = parcelRequire("4uBc4");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $4uBc4.bindAll;
    }
});

});
parcelRegister("d4F9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $984b932fb32c81ba$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $984b932fb32c81ba$var$bind;

});

parcelRegister("4uBc4", function(module, exports) {
"use strict";
var $3456d0a5d95794ea$var$__assign = module.exports && module.exports.__assign || function() {
    $3456d0a5d95794ea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3456d0a5d95794ea$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $d4F9Q = parcelRequire("d4F9Q");
function $3456d0a5d95794ea$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $3456d0a5d95794ea$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $3456d0a5d95794ea$var$__assign($3456d0a5d95794ea$var$__assign({}, original), {
        options: $3456d0a5d95794ea$var$__assign($3456d0a5d95794ea$var$__assign({}, $3456d0a5d95794ea$var$toOptions(sharedOptions)), $3456d0a5d95794ea$var$toOptions(original.options))
    });
    return binding;
}
function $3456d0a5d95794ea$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $3456d0a5d95794ea$var$getBinding(original, sharedOptions);
        return (0, $d4F9Q.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $3456d0a5d95794ea$var$bindAll;

});



parcelRegister("gXYFp", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $c5a137362d5a59ec$export$1f70d263701b1d01; });

var $cF8Kw = parcelRequire("cF8Kw");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $7bV0v = parcelRequire("7bV0v");

var $5fgWT = parcelRequire("5fgWT");

var $6D6Z5 = parcelRequire("6D6Z5");

var $6JLzw = parcelRequire("6JLzw");

var $5TPDd = parcelRequire("5TPDd");

var $5LoHE = parcelRequire("5LoHE");

var $cpCCh = parcelRequire("cpCCh");
var $c5a137362d5a59ec$var$_VCObserver;
var $c5a137362d5a59ec$var$_excluded = [
    "__debug__element"
];
function $c5a137362d5a59ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5a137362d5a59ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5a137362d5a59ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5a137362d5a59ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5a137362d5a59ec$var$abortReason = {
    scroll: 'scroll',
    keypress: 'keypress',
    resize: 'resize',
    error: 'error'
};
var $c5a137362d5a59ec$var$UNUSED_SECTOR = 0;
var $c5a137362d5a59ec$var$filterComponentsLog = (0, $7bV0v.withProfiling)(function filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(entry, $c5a137362d5a59ec$var$_excluded);
                return rest;
            })
        ];
    }));
}, [
    'vc'
]);
var $c5a137362d5a59ec$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "abortReason", {
            reason: null,
            info: '',
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "outOfBoundaryInfo", '');
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "multiHeatmap", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== '' ? " ".concat(_this.abortReason.info) : '';
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $c5a137362d5a59ec$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                multiHeatmap: _this.multiHeatmap,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $c5a137362d5a59ec$var$_objectSpread({}, _this.componentsLog),
                viewport: $c5a137362d5a59ec$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, multiHeatmap, isTTVCv1Disabled, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, isVCClean, revisionsData, isCalcSpeedIndexEnabled, speedIndex;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== '' ? "".concat(prefix, ":") : '';
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios, multiHeatmap = rawData.multiHeatmap;
                            if (!(abortReasonInfo !== null && abortReason.blocking)) {
                                _context.next = 10;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (e) {}
                            return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:state"), false), "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp));
                        case 10:
                            isTTVCv1Disabled = (0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1');
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $c5a137362d5a59ec$var$_objectSpread({}, componentsLog),
                                viewport: viewport
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref6) {
                                var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref6, 2), _timestamp = _ref7[0], value = _ref7[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport
                            });
                            try {
                                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                                    if (isTTVCv1Disabled) {
                                        var duration = vcNext.VC[key];
                                        if (duration !== null && duration !== undefined) {
                                            performance.measure("VC".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                            performance.measure("VC_Next".concat(key), {
                                                start: start,
                                                duration: duration
                                            });
                                        }
                                    } else {
                                        var ttvcV1duration = VC[key];
                                        if (ttvcV1duration !== null && ttvcV1duration !== undefined) performance.measure("VC".concat(key), {
                                            start: start,
                                            duration: ttvcV1duration
                                        });
                                        var ttvcV2duration = vcNext.VC[key];
                                        if (ttvcV2duration !== null && ttvcV2duration !== undefined) performance.measure("VC_Next".concat(key), {
                                            start: start,
                                            duration: ttvcV2duration
                                        });
                                    }
                                });
                            } catch (e) {
                            /* empty */ }
                            outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': VC['75'],
                                            '80': VC['80'],
                                            '85': VC['85'],
                                            '90': VC['90'],
                                            '95': VC['95'],
                                            '98': VC['98'],
                                            '99': VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            '75': vcNext.VC['75'],
                                            '80': vcNext.VC['80'],
                                            '85': vcNext.VC['85'],
                                            '90': vcNext.VC['90'],
                                            '95': vcNext.VC['95'],
                                            '98': vcNext.VC['98'],
                                            '99': vcNext.VC['99'],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent('vcReady', {
                                        detail: {
                                            log: $c5a137362d5a59ec$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                            } catch (e) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $6D6Z5.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                multiHeatmap: multiHeatmap,
                                ssr: ssr,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted
                            }); // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                            isCalcSpeedIndexEnabled = (0, $i2LcI.fg)('ufo-calc-speed-index');
                            speedIndex = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            if (!isTTVCv1Disabled) {
                                _context.next = 26;
                                break;
                            }
                            return _context.abrupt("return", $c5a137362d5a59ec$var$_objectSpread($c5a137362d5a59ec$var$_objectSpread($c5a137362d5a59ec$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), isCalcSpeedIndexEnabled ? speedIndex : {}));
                        case 26:
                            return _context.abrupt("return", $c5a137362d5a59ec$var$_objectSpread($c5a137362d5a59ec$var$_objectSpread($c5a137362d5a59ec$var$_objectSpread((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({
                                'metrics:vc': VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), (0, $i2LcI.fg)('platform_ufo_vc_observer_new') ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), (0, $i2LcI.fg)('platform_ufo_vc_observer_new') ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), isCalcSpeedIndexEnabled ? speedIndex : {}));
                        case 27:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            _this.measureStart();
            _this.legacyHandleUpdate(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue);
            if (!(0, $i2LcI.fg)('platform_ufo_vc_observer_new')) _this.onViewportChangeDetected({
                timestamp: rawTime,
                intersectionRect: intersectionRect,
                targetName: targetName,
                element: element,
                type: type,
                ignoreReason: ignoreReason,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "legacyHandleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var isTTVCv1Disabled = (0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1');
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === 'not-visible') && type !== 'attr') _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "onViewportChangeDetected", function(_ref9) {
            var element = _ref9.element, type = _ref9.type, ignoreReason = _ref9.ignoreReason, timestamp = _ref9.timestamp, targetName = _ref9.targetName, intersectionRect = _ref9.intersectionRect, attributeName = _ref9.attributeName, oldValue = _ref9.oldValue, newValue = _ref9.newValue;
            if (_this.multiHeatmap === null) return;
            // @todo add abort reason handling
            var time = Math.round(timestamp - _this.startTime);
            var revisions = (0, $cpCCh.getRevisions)();
            var revisionsClassification = revisions.map(function(revision) {
                return revision.classifier.classifyUpdate({
                    element: element,
                    type: type,
                    ignoreReason: ignoreReason
                });
            }, []);
            _this.multiHeatmap.handleUpdate({
                time: time,
                targetName: targetName,
                intersectionRect: intersectionRect,
                type: type,
                element: element,
                classification: revisionsClassification,
                onError: function onError(error) {
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.error, error.time, error.error);
                },
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === '') {
                var outOfBoundaryInfo = '';
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case 'wheel':
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.scroll, time);
                    break;
                case 'keydown':
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.keypress, time);
                    break;
                case 'resize':
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "attachAbortListeners", function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, $5fgWT.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                var _window2;
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref10) {
                    var _ref11 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref10, 2), key = _ref11[0], time = _ref11[1];
                    if (time) _this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                (_window2 = window) === null || _window2 === void 0 || delete _window2.__SSR_ABORT_LISTENERS__;
            }
            _this.unbind = unbinds;
        });
        var operationTimer = (0, $7bV0v.markProfilingStart)('VCObserver constructor');
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $5LoHE.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = (0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1') ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.multiHeatmap = new (0, $5TPDd.MultiRevisionHeatmap)({
            viewport: this.viewport,
            revisions: (0, $cpCCh.getRevisions)(),
            devToolsEnabled: this.devToolsEnabled
        });
        this.isPostInteraction = options.isPostInteraction || false;
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $7bV0v.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getAbortReasonInfo = (0, $7bV0v.withProfiling)(this.getAbortReasonInfo.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getVCRawData = (0, $7bV0v.withProfiling)(this.getVCRawData.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getIgnoredElements = (0, $7bV0v.withProfiling)(this.getIgnoredElements.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $7bV0v.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.setSSRElement = (0, $7bV0v.withProfiling)(this.setSSRElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $7bV0v.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $7bV0v.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        this.handleUpdate = (0, $7bV0v.withProfiling)(this.handleUpdate.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.legacyHandleUpdate = (0, $7bV0v.withProfiling)(this.legacyHandleUpdate.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.onViewportChangeDetected = (0, $7bV0v.withProfiling)(this.onViewportChangeDetected.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.setAbortReason = (0, $7bV0v.withProfiling)(this.setAbortReason.bind(this), [
            'vc'
        ]);
        this.resetState = (0, $7bV0v.withProfiling)(this.resetState.bind(this), [
            'vc'
        ]);
        this.setViewportSize = (0, $7bV0v.withProfiling)(this.setViewportSize.bind(this), [
            'vc'
        ]);
        this.mapPixelsToHeatmap = (0, $7bV0v.withProfiling)(this.mapPixelsToHeatmap.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.getElementRatio = (0, $7bV0v.withProfiling)(this.getElementRatio.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.applyChangesToHeatMap = (0, $7bV0v.withProfiling)(this.applyChangesToHeatMap.bind(this), [
            'vc'
        ]);
        this.abortReasonCallback = (0, $7bV0v.withProfiling)(this.abortReasonCallback.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.attachAbortListeners = (0, $7bV0v.withProfiling)(this.attachAbortListeners.bind(this), [
            'vc'
        ]); // TODO: confirm correct value of `this`
        this.detachAbortListeners = (0, $7bV0v.withProfiling)(this.detachAbortListeners.bind(this), [
            'vc'
        ]);
        this.measureStart = (0, $7bV0v.withProfiling)(this.measureStart.bind(this), [
            'vc'
        ]);
        this.measureStop = (0, $7bV0v.withProfiling)(this.measureStop.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref12) {
                var startTime = _ref12.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason('not-supported', startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref13) {
                    var ignoreReason = _ref13.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref14) {
                    var targetName = _ref14.targetName, ignoreReason = _ref14.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $c5a137362d5a59ec$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: '',
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = (0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1') ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.multiHeatmap = new (0, $5TPDd.MultiRevisionHeatmap)({
                    viewport: this.viewport,
                    revisions: (0, $cpCCh.getRevisions)(),
                    devToolsEnabled: this.devToolsEnabled
                });
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill('').map(function() {
                    return Array(_this2.arraySize).fill($c5a137362d5a59ec$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $6JLzw.getViewportWidth)();
                this.viewport.h = (0, $6JLzw.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($c5a137362d5a59ec$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($c5a137362d5a59ec$var$abortReason.error, time, 'row error');
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                this.unbind.forEach(function(fn) {
                    return fn();
                });
                this.unbind = [];
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();
$c5a137362d5a59ec$var$_VCObserver = $c5a137362d5a59ec$export$1f70d263701b1d01;
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c5a137362d5a59ec$export$1f70d263701b1d01, "VCParts", [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
]);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c5a137362d5a59ec$export$1f70d263701b1d01, "calculateVC", (0, $7bV0v.withProfiling)(function calculateVC(_ref15) {
    var heatmap = _ref15.heatmap, _ref15$ssr = _ref15.ssr, ssr = _ref15$ssr === void 0 ? $c5a137362d5a59ec$var$UNUSED_SECTOR : _ref15$ssr, componentsLog = _ref15.componentsLog, viewport = _ref15.viewport;
    var lastUpdate = {};
    var totalPainted = 0;
    if (ssr !== $c5a137362d5a59ec$var$UNUSED_SECTOR) {
        var _window$document;
        var element = {
            __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
            intersectionRect: {
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                x: 0,
                y: 0,
                width: viewport.w,
                height: viewport.h,
                toJSON: function toJSON() {
                    return {};
                }
            },
            targetName: 'SSR'
        };
        if (!componentsLog[ssr]) componentsLog[ssr] = [];
        componentsLog[ssr].push(element);
    }
    heatmap.forEach(function(line) {
        line.forEach(function(entry) {
            var rounded = Math.floor(entry === $c5a137362d5a59ec$var$UNUSED_SECTOR && ssr !== $c5a137362d5a59ec$var$UNUSED_SECTOR ? ssr : entry);
            totalPainted += rounded !== $c5a137362d5a59ec$var$UNUSED_SECTOR ? 1 : 0;
            if (rounded !== $c5a137362d5a59ec$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
        });
    });
    var entries = Object.entries(lastUpdate).map(function(a) {
        return [
            parseInt(a[0], 10),
            a[1]
        ];
    }).sort(function(a, b) {
        return a[0] > b[0] ? 1 : -1;
    });
    var VC = $c5a137362d5a59ec$var$_VCObserver.makeVCReturnObj();
    var VCBox = $c5a137362d5a59ec$var$_VCObserver.makeVCReturnObj();
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    var isCalcSpeedIndexEnabled = (0, $i2LcI.fg)('ufo-calc-speed-index');
    entries.reduce(function() {
        var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var v = arguments.length > 1 ? arguments[1] : undefined;
        var currRatio = v[1] / totalPainted;
        var VCRatio = currRatio + acc;
        var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
        var preciseAccRatio = Math.round(acc * 100);
        VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
        var time = v[0];
        $c5a137362d5a59ec$var$_VCObserver.VCParts.forEach(function(key) {
            var value = parseInt(key, 10);
            if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                var _componentsLog$time;
                VC[key] = time;
                VCBox[key] = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                    return !v.ignoreReason;
                }).map(function(v) {
                    return v.targetName;
                })));
            }
        });
        return VCRatio;
    }, 0);
    var VCEntries = entries.reduce(function(acc, _ref16, i) {
        var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
        var _ref17 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref16, 2), timestamp = _ref17[0], entryPainted = _ref17[1];
        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
        var logEntry = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
            return !v.ignoreReason;
        }).map(function(v) {
            return v.targetName;
        })));
        var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
        if (isCalcSpeedIndexEnabled) {
            var speedIndex = timestamp * ratioDelta;
            acc.speedIndex += speedIndex;
        }
        acc.abs.push([
            timestamp,
            currentlyPainted
        ]);
        acc.rel.push({
            time: timestamp,
            vc: currentlyPaintedRatio,
            elements: logEntry
        });
        return acc;
    }, {
        abs: [],
        rel: [],
        speedIndex: 0
    });
    VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
    return {
        VC: VC,
        VCBox: VCBox,
        VCEntries: VCEntries,
        totalPainted: totalPainted
    };
}, [
    'vc'
]));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c5a137362d5a59ec$export$1f70d263701b1d01, "makeVCReturnObj", (0, $7bV0v.withProfiling)(function makeVCReturnObj() {
    var vc = {};
    $c5a137362d5a59ec$var$_VCObserver.VCParts.forEach(function(v) {
        vc[v] = null;
    });
    return vc;
}, [
    'vc'
]));

});
parcelRegister("5fgWT", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $3d1b80260f375eff$export$9010aa71841a6887; });

var $k6Bkl = parcelRequire("k6Bkl");

var $4yfn0 = parcelRequire("4yfn0");

var $7bV0v = parcelRequire("7bV0v");

var $6JLzw = parcelRequire("6JLzw");
var $3d1b80260f375eff$export$9010aa71841a6887 = (0, $7bV0v.withProfiling)(function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $4yfn0.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $4yfn0.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $6JLzw.getViewportWidth)() !== initialViewPort.w || (0, $6JLzw.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $4yfn0.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}, [
    'vc'
]);

});
parcelRegister("4yfn0", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $35064292a01a1bd2$export$199edc0307b5587f; });
var $35064292a01a1bd2$export$199edc0307b5587f = {
    wheel: 'wheel',
    keydown: 'keydown',
    resize: 'resize'
};

});

parcelRegister("6JLzw", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $4e7bd8dc080c6a46$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $4e7bd8dc080c6a46$export$4f01c15d21ef9cc6; });

var $7bV0v = parcelRequire("7bV0v");
var $4e7bd8dc080c6a46$export$a497a1dcb4408212 = (0, $7bV0v.withProfiling)(function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}, [
    'vc'
]);
var $4e7bd8dc080c6a46$export$4f01c15d21ef9cc6 = (0, $7bV0v.withProfiling)(function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}, [
    'vc'
]);

});


parcelRegister("6D6Z5", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", function () { return $4d3bcd89b82fe74a$export$5c86a34c9becd6d0; });

var $6bkHe = parcelRequire("6bkHe");

var $i2LcI = parcelRequire("i2LcI");

var $kRzLu = parcelRequire("kRzLu");

var $7bV0v = parcelRequire("7bV0v");

var $cpCCh = parcelRequire("cpCCh");
var $4d3bcd89b82fe74a$var$VCParts = [
    '25',
    '50',
    '75',
    '80',
    '85',
    '90',
    '95',
    '98',
    '99'
];
var $4d3bcd89b82fe74a$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
var $4d3bcd89b82fe74a$var$createVCDetails = (0, $7bV0v.withProfiling)(function createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    for(var _i = 0, _VCParts = $4d3bcd89b82fe74a$var$VCParts; _i < _VCParts.length; _i++){
        var key = _VCParts[_i];
        details[key] = {
            t: VC[key],
            e: VCBox[key] || $4d3bcd89b82fe74a$var$READONLY_EMPTY_ARRAY
        };
    }
    return details;
}, [
    'vc'
]);
var $4d3bcd89b82fe74a$export$5c86a34c9becd6d0 = (0, $7bV0v.withProfiling)(function getVCRevisionsData(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, multiHeatmap = _ref.multiHeatmap, ssr = _ref.ssr, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext;
    if (!(0, $i2LcI.fg)('platform_ufo_vc_observer_new')) {
        if (!multiHeatmap) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:rev"), multiHeatmap === null || multiHeatmap === void 0 ? void 0 : multiHeatmap.getPayloadShapedData({
            VCParts: $4d3bcd89b82fe74a$var$VCParts.map(function(v) {
                return parseInt(v);
            }),
            VCCalculationMethods: (0, $cpCCh.getRevisions)().map(function(_ref2) {
                var classifier = _ref2.classifier;
                return classifier.VCCalculationMethod;
            }),
            filterComponentsLog: (0, $cpCCh.getRevisions)().map(function(_ref3) {
                var classifier = _ref3.classifier;
                return classifier.filterComponentsLog;
            }),
            isEventAborted: isEventAborted,
            interactionStart: interaction.start,
            ttai: interaction.end,
            ssr: ssr,
            clean: isVCClean
        }));
    }
    // Calculate these conditions once
    var pageVisibilityUpToTTAI = (0, $kRzLu.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === 'visible';
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    // Create the V2 revision object which is always needed
    var ttvcV2Revision = {
        revision: 'fy25.02',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVCNext.VC['90'] : null,
        vcDetails: $4d3bcd89b82fe74a$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
    };
    if ((0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1')) return (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:rev"), [
        ttvcV2Revision
    ]);
    // Only create ttvcV1Revision when we're actually going to use it
    var ttvcV1Revision = {
        revision: 'fy25.01',
        clean: isVCClean,
        'metric:vc90': shouldHaveVCmetric ? calculatedVC.VC['90'] : null,
        vcDetails: $4d3bcd89b82fe74a$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:rev"), [
        ttvcV1Revision,
        ttvcV2Revision
    ]);
}, [
    'vc'
]);

});
parcelRegister("cpCCh", function(module, exports) {

$parcel$export(module.exports, "getRevisions", function () { return $9095c646f3530b0d$export$3a6bcaa2795a58f8; });

var $i2LcI = parcelRequire("i2LcI");

var $7bV0v = parcelRequire("7bV0v");

var $a2kss = parcelRequire("a2kss");

var $1UghN = parcelRequire("1UghN");
var $9095c646f3530b0d$export$3a6bcaa2795a58f8 = (0, $7bV0v.withProfiling)(function getRevisions() {
    if ((0, $i2LcI.fg)('platform_ufo_disable_ttvc_v1')) return [
        {
            name: 'fy25.02',
            classifier: (0, $1UghN.revFY25_02Classifier)
        }
    ];
    return [
        {
            name: 'fy25.01',
            classifier: (0, $a2kss.revFY25_01Classifier)
        },
        {
            name: 'fy25.02',
            classifier: (0, $1UghN.revFY25_02Classifier)
        }
    ];
}, [
    'vc'
]);

});
parcelRegister("a2kss", function(module, exports) {

$parcel$export(module.exports, "FY25_01Classifier", function () { return $74e9f5d60a7fdc36$export$1287fed0f253eee5; });
$parcel$export(module.exports, "revFY25_01Classifier", function () { return $74e9f5d60a7fdc36$export$d822caadc9ee5453; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $7bV0v = parcelRequire("7bV0v");

var $bITTS = parcelRequire("bITTS");
function $74e9f5d60a7fdc36$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $74e9f5d60a7fdc36$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $74e9f5d60a7fdc36$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($74e9f5d60a7fdc36$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $74e9f5d60a7fdc36$var$legacyIgnoreReasons = [
    'image',
    'ssr-hydration',
    'editor-lazy-node-view',
    'editor-container-mutation'
];
var $74e9f5d60a7fdc36$export$1287fed0f253eee5 = /*#__PURE__*/ function(_ViewportUpdateClassi) {
    function FY25_01Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, FY25_01Classifier);
        _this = $74e9f5d60a7fdc36$var$_callSuper(this, FY25_01Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "revision", 'fy25.01');
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "types", [
            'html',
            'text'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "filters", [
            {
                name: 'default-ignore-reasons',
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !ignoreReason || !$74e9f5d60a7fdc36$var$legacyIgnoreReasons.includes(ignoreReason);
                }
            }
        ]);
        _this.mergeConfig();
        _this.VCCalculationMethod = (0, $7bV0v.withProfiling)(_this.VCCalculationMethod.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(FY25_01Classifier, _ViewportUpdateClassi);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(FY25_01Classifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_ref2) {
                var VCParts = _ref2.VCParts, entries = _ref2.entries, totalPainted = _ref2.totalPainted, componentsLog = _ref2.componentsLog;
                var VC = {};
                var VCBox = {};
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    // @todo apply fix to include small changes into accumulator
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    VCParts.forEach(function(value) {
                        if ((VC[value] === null || VC[value] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[value] = time;
                            VCBox[value] = new Set();
                            (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 || _componentsLog$time.forEach(function(v) {
                                var _VCBox$value;
                                return (_VCBox$value = VCBox[value]) === null || _VCBox$value === void 0 ? void 0 : _VCBox$value.add(v.targetName);
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                return {
                    VC: VC,
                    VCBox: VCBox
                };
            }
        }
    ]);
}((0, $bITTS.ViewportUpdateClassifier));
var $74e9f5d60a7fdc36$export$d822caadc9ee5453 = new $74e9f5d60a7fdc36$export$1287fed0f253eee5();

});
parcelRegister("bITTS", function(module, exports) {

$parcel$export(module.exports, "ViewportUpdateClassifier", function () { return $888f2a5f9a7af229$export$66a5f74f04eab7df; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $888f2a5f9a7af229$export$66a5f74f04eab7df = /*#__PURE__*/ function() {
    function ViewportUpdateClassifier() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ViewportUpdateClassifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "types", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "filters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "removedFilters", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "__combinedTypes", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "__combinedFilters", []);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ViewportUpdateClassifier, [
        {
            key: "VCCalculationMethod",
            value: function VCCalculationMethod(_) {
                return {
                    VC: {},
                    VCBox: {}
                };
            }
        },
        {
            key: "filterComponentsLog",
            value: function filterComponentsLog(_ref) {
                var componentsLog = _ref.componentsLog;
                return componentsLog;
            }
        },
        {
            key: "mergeConfig",
            value: function mergeConfig() {
                var _this = this;
                this.__combinedTypes = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.types), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))((this === null || this === void 0 ? void 0 : this.__combinedTypes) || []));
                var previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter(function(filter) {
                    return !_this.removedFilters.includes(filter.name);
                });
                this.__combinedFilters = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.filters), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(previousFilters));
            }
        },
        {
            key: "classifyUpdate",
            value: function classifyUpdate(_ref2) {
                var element = _ref2.element, type = _ref2.type, tags = _ref2.tags, ignoreReason = _ref2.ignoreReason;
                if (!this.__combinedTypes.includes(type)) return false;
                return this.__combinedFilters.every(function(_ref3) {
                    var filter = _ref3.filter, name = _ref3.name;
                    return filter({
                        type: type,
                        tags: tags,
                        ignoreReason: ignoreReason
                    });
                });
            }
        }
    ]);
}();

});


parcelRegister("1UghN", function(module, exports) {

$parcel$export(module.exports, "revFY25_02Classifier", function () { return $1637a77f91232af3$export$624b2c3760a5ab41; });

var $kg5sN = parcelRequire("kg5sN");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $7bV0v = parcelRequire("7bV0v");

var $a2kss = parcelRequire("a2kss");
function $1637a77f91232af3$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $1637a77f91232af3$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $1637a77f91232af3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1637a77f91232af3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1637a77f91232af3$export$d8e8ccb82df07b7c = /*#__PURE__*/ function(_FY25_01Classifier) {
    function FY25_02Classifier() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, FY25_02Classifier);
        _this = $1637a77f91232af3$var$_callSuper(this, FY25_02Classifier);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "revision", 'fy25.02');
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "types", [
            'attr'
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "filters", [
            {
                name: 'not-visible',
                filter: function filter(_ref) {
                    var type = _ref.type, ignoreReason = _ref.ignoreReason;
                    return !(ignoreReason !== null && ignoreReason !== void 0 && ignoreReason.includes('not-visible')) && ignoreReason !== 'non-visual-style';
                }
            }
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "removedFilters", []);
        _this.mergeConfig();
        _this.filterComponentsLog = (0, $7bV0v.withProfiling)(_this.filterComponentsLog.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(FY25_02Classifier, _FY25_01Classifier);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(FY25_02Classifier, [
        {
            key: "filterComponentsLog",
            value: // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
            function filterComponentsLog(_ref2) {
                var componentsLog = _ref2.componentsLog, ttai = _ref2.ttai;
                var _componentsLog = {};
                Object.entries(componentsLog).forEach(function(_ref3) {
                    var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 2), _timestamp = _ref4[0], value = _ref4[1];
                    var timestamp = Number(_timestamp);
                    if (Math.ceil(ttai) >= timestamp) _componentsLog[timestamp] = value;
                });
                return _componentsLog;
            }
        }
    ]);
}((0, $a2kss.FY25_01Classifier));
var $1637a77f91232af3$export$624b2c3760a5ab41 = new $1637a77f91232af3$export$d8e8ccb82df07b7c();

});



parcelRegister("5TPDd", function(module, exports) {

$parcel$export(module.exports, "MultiRevisionHeatmap", function () { return $44ba23bbb535633b$export$40923620784ea2c1; });

var $kg5sN = parcelRequire("kg5sN");

var $siHsk = parcelRequire("siHsk");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $kRzLu = parcelRequire("kRzLu");

var $7bV0v = parcelRequire("7bV0v");
var $44ba23bbb535633b$var$UNUSED_SECTOR = 0;
var $44ba23bbb535633b$export$40923620784ea2c1 = /*#__PURE__*/ function() {
    function MultiRevisionHeatmap(_ref) {
        var _this = this;
        var viewport = _ref.viewport, revisions = _ref.revisions, arraySize = _ref.arraySize, devToolsEnabled = _ref.devToolsEnabled;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, MultiRevisionHeatmap);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "arraySize", {
            w: 200,
            h: 200
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize.w);
            var t = Math.floor(top / h * _this.arraySize.h);
            var r = Math.ceil((left + width) / w * _this.arraySize.w);
            var b = Math.ceil((top + height) / h * _this.arraySize.h);
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize.w, r),
                b: Math.min(_this.arraySize.h, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize.w * _this.arraySize.h);
        });
        var operationTimer = (0, $7bV0v.markProfilingStart)('MultiRevisionHeatmap constructor');
        this.viewport = viewport;
        this.revisions = revisions;
        if (arraySize) this.arraySize = arraySize;
        this.heatmaps = new Array(revisions.length);
        this.componentsLogs = new Array(revisions.length);
        this.vcRatios = new Array(revisions.length);
        this.devToolsEnabled = devToolsEnabled || false;
        revisions.forEach(function(_ref2, i) {
            (0, (/*@__PURE__*/$parcel$interopDefault($siHsk)))(_ref2);
            _this.heatmaps[i] = _this.getCleanHeatmap();
            _this.componentsLogs[i] = {};
            _this.vcRatios[i] = {};
        });
        this.handleUpdate = (0, $7bV0v.withProfiling)(this.handleUpdate.bind(this), [
            'vc'
        ]);
        this.getData = (0, $7bV0v.withProfiling)(this.getData.bind(this), [
            'vc'
        ]);
        this.getPayloadShapedData = (0, $7bV0v.withProfiling)(this.getPayloadShapedData.bind(this), [
            'vc'
        ]);
        this.processData = (0, $7bV0v.withProfiling)(this.processData.bind(this), [
            'vc'
        ]);
        this.mapPixelsToHeatmap = (0, $7bV0v.withProfiling)(this.mapPixelsToHeatmap.bind(this), [
            'vc'
        ]);
        this.getElementRatio = (0, $7bV0v.withProfiling)(this.getElementRatio.bind(this), [
            'vc'
        ]);
        this.applyChangesToHeatMap = (0, $7bV0v.withProfiling)(this.applyChangesToHeatMap.bind(this), [
            'vc'
        ]);
        this.getIndex = (0, $7bV0v.withProfiling)(this.getIndex.bind(this), [
            'vc'
        ]);
        this.getCleanHeatmap = (0, $7bV0v.withProfiling)(this.getCleanHeatmap.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(MultiRevisionHeatmap, [
        {
            key: "handleUpdate",
            value: function handleUpdate(_ref3) {
                var _this2 = this;
                var time = _ref3.time, type = _ref3.type, classification = _ref3.classification, intersectionRect = _ref3.intersectionRect, element = _ref3.element, targetName = _ref3.targetName, ignoreReason = _ref3.ignoreReason, onError = _ref3.onError, attributeName = _ref3.attributeName, oldValue = _ref3.oldValue, newValue = _ref3.newValue;
                var mappedValues = this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                var result = this.applyChangesToHeatMap(mappedValues, time, classification);
                if (result !== true) onError(result);
                var componentRatio = this.getElementRatio(mappedValues);
                this.revisions.forEach(function(_, i) {
                    if (classification[i]) _this2.vcRatios[i][targetName] = componentRatio;
                    if (!_this2.componentsLogs[i][time]) _this2.componentsLogs[i][time] = [];
                    _this2.componentsLogs[i][time].push({
                        __debug__element: _this2.devToolsEnabled ? new WeakRef(element) : null,
                        intersectionRect: intersectionRect,
                        targetName: targetName,
                        ignoreReason: ignoreReason,
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                });
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    heatmaps: this.heatmaps
                };
            }
        },
        {
            key: "getPayloadShapedData",
            value: function getPayloadShapedData(args) {
                var pageVisibilityUpToTTAI = (0, $kRzLu.getPageVisibilityState)(args.interactionStart, args.ttai);
                var result = this.processData(args);
                var payload = this.revisions.map(function(rev, i) {
                    var _vcDetails$;
                    var vcDetails = {};
                    args.VCParts.forEach(function(VCPart) {
                        vcDetails[VCPart] = {
                            t: result[i].VC[VCPart] || 0,
                            e: Array.from(result[i].VCBox[VCPart] || [])
                        };
                    });
                    return {
                        revision: rev.name,
                        vcDetails: vcDetails,
                        clean: args.clean,
                        'metric:vc90': args.clean && !args.isEventAborted && pageVisibilityUpToTTAI === 'visible' ? vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t : null
                    };
                });
                return payload;
            }
        },
        {
            key: "processData",
            value: function processData(_ref4) {
                var _this3 = this;
                var VCParts = _ref4.VCParts, VCCalculationMethods = _ref4.VCCalculationMethods, filterComponentsLog = _ref4.filterComponentsLog, ttai = _ref4.ttai, _ref4$ssr = _ref4.ssr, ssr = _ref4$ssr === void 0 ? $44ba23bbb535633b$var$UNUSED_SECTOR : _ref4$ssr;
                return this.heatmaps.map(function(heatmap, i) {
                    var lastUpdate = {};
                    var totalPainted = 0;
                    var componentsLog = _this3.componentsLogs[i];
                    if (ssr !== $44ba23bbb535633b$var$UNUSED_SECTOR) {
                        var _window$document;
                        var element = {
                            __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                            intersectionRect: {
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                x: 0,
                                y: 0,
                                width: _this3.viewport.w,
                                height: _this3.viewport.h,
                                toJSON: function toJSON() {
                                    return {};
                                }
                            },
                            targetName: 'SSR'
                        };
                        if (!componentsLog[ssr]) componentsLog[ssr] = [];
                        componentsLog[ssr].push(element);
                    }
                    for(var _i = 0; _i < heatmap.length; _i++){
                        var rounded = Math.floor(heatmap[_i] === $44ba23bbb535633b$var$UNUSED_SECTOR && ssr !== $44ba23bbb535633b$var$UNUSED_SECTOR ? ssr : heatmap[_i]);
                        totalPainted += rounded !== $44ba23bbb535633b$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $44ba23bbb535633b$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    }
                    var entries = Object.entries(lastUpdate).map(function(a) {
                        return [
                            parseInt(a[0], 10),
                            a[1]
                        ];
                    }).sort(function(a, b) {
                        return a[0] > b[0] ? 1 : -1;
                    });
                    // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
                    componentsLog = filterComponentsLog[i]({
                        componentsLog: componentsLog,
                        ttai: ttai
                    });
                    var _VCCalculationMethods = VCCalculationMethods[i]({
                        VCParts: VCParts,
                        componentsLog: componentsLog,
                        entries: entries,
                        totalPainted: totalPainted
                    }), VC = _VCCalculationMethods.VC, VCBox = _VCCalculationMethods.VCBox;
                    var VCEntries = entries.reduce(function(acc, _ref5, i) {
                        var _acc$abs, _componentsLog$timest;
                        var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref5, 2), timestamp = _ref6[0], entryPainted = _ref6[1];
                        var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                        var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                        var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                            return v.targetName;
                        });
                        acc.abs.push([
                            timestamp,
                            currentlyPainted
                        ]);
                        acc.rel.push({
                            time: timestamp,
                            vc: currentlyPaintedRatio,
                            elements: logEntry
                        });
                        return acc;
                    }, {
                        abs: [],
                        rel: []
                    });
                    return {
                        VC: VC,
                        VCBox: VCBox,
                        VCEntries: VCEntries,
                        totalPainted: totalPainted
                    };
                });
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, classification) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var size = classification.length;
                for(var row = t; row < b; row++){
                    if (this.heatmaps[0][row] === undefined) try {
                        return {
                            error: "index - ".concat(row),
                            time: time
                        };
                    } catch (e) {
                        return {
                            error: 'row error',
                            time: time
                        };
                    }
                    else {
                        for(var heatmapIndex = 0; heatmapIndex < size; heatmapIndex++)if (classification[heatmapIndex]) this.heatmaps[heatmapIndex].fill(time, this.getIndex(l, row), this.getIndex(r, row));
                    }
                }
                return true;
            }
        },
        {
            key: "getIndex",
            value: function getIndex(x, y) {
                return x + this.arraySize.w * y;
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                return new Int32Array(this.arraySize.w * this.arraySize.h);
            }
        }
    ]);
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($44ba23bbb535633b$export$40923620784ea2c1, "makeVCReturnObj", (0, $7bV0v.withProfiling)(function makeVCReturnObj(VCParts) {
    var vc = {};
    VCParts.forEach(function(v) {
        vc[v] = null;
    });
    return vc;
}, [
    'vc'
]));

});

parcelRegister("5LoHE", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $432481128c46df98$export$b65d046240060e78; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $i2LcI = parcelRequire("i2LcI");

var $dyWhr = parcelRequire("dyWhr");

var $7bV0v = parcelRequire("7bV0v");

var $9lRp1 = parcelRequire("9lRp1");

var $9hvMu = parcelRequire("9hvMu");

var $dqsxj = parcelRequire("dqsxj");

var $4vNNx = parcelRequire("4vNNx");
function $432481128c46df98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $432481128c46df98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $432481128c46df98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $432481128c46df98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $432481128c46df98$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $432481128c46df98$var$isElementVisible = (0, $7bV0v.withProfiling)(function isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== 'function') return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}, [
    'vc'
]);
var $432481128c46df98$var$isInsideEditorContainer = (0, $7bV0v.withProfiling)(function isInsideEditorContainer(target) {
    if (!target || typeof target.closest !== 'function') return false;
    return Boolean(target.closest('.ProseMirror'));
}, [
    'vc'
]);
var $432481128c46df98$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "ssr", {
            state: $432481128c46df98$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            if ((0, $i2LcI.fg)('platform_ufo_log_attr_mutation_values')) _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
            else _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        });
        var operationTimer = (0, $7bV0v.markProfilingStart)('Observers constructor');
        this.selectorConfig = $432481128c46df98$var$_objectSpread($432481128c46df98$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $4vNNx.SSRPlaceholderHandlers)();
        this.editorLnvHandler = new (0, $9hvMu.EditorLnvHandler)();
        this.isBrowserSupported = (0, $7bV0v.withProfiling)(this.isBrowserSupported.bind(this), [
            'vc'
        ]);
        this.observe = (0, $7bV0v.withProfiling)(this.observe.bind(this), [
            'vc'
        ]);
        this.disconnect = (0, $7bV0v.withProfiling)(this.disconnect.bind(this), [
            'vc'
        ]);
        this.subscribeResults = (0, $7bV0v.withProfiling)(this.subscribeResults.bind(this), [
            'vc'
        ]);
        this.getTotalTime = (0, $7bV0v.withProfiling)(this.getTotalTime.bind(this), [
            'vc'
        ]);
        this.setReactRootElement = (0, $7bV0v.withProfiling)(this.setReactRootElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $7bV0v.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $7bV0v.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        this.observeElement = (0, $7bV0v.withProfiling)(this.observeElement.bind(this), [
            'vc'
        ]);
        this.getMutationObserver = (0, $7bV0v.withProfiling)(this.getMutationObserver.bind(this), [
            'vc'
        ]);
        this.getElementName = (0, $7bV0v.withProfiling)(this.getElementName.bind(this), [
            'vc'
        ]);
        this.getIntersectionObserver = (0, $7bV0v.withProfiling)(this.getIntersectionObserver.bind(this), [
            'vc'
        ]);
        this.measureStart = (0, $7bV0v.withProfiling)(this.measureStart.bind(this), [
            'vc'
        ]);
        this.measureStop = (0, $7bV0v.withProfiling)(this.measureStop.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === 'function' && typeof window.MutationObserver === 'function';
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $432481128c46df98$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        'hidden',
                        'style',
                        'src',
                        'class'
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
                this.editorLnvHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $432481128c46df98$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                var shouldHandleEditorLnvLocal = (0, $dyWhr.shouldHandleEditorLnv)();
                return new MutationObserver(function(mutations) {
                    var operationTimer = (0, $7bV0v.markProfilingStart)('mutationObserverCallback');
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = '';
                        if (_this2.ssr.state === $432481128c46df98$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $432481128c46df98$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = 'ssr-hydration';
                        }
                        if (_this2.ssr.state === $432481128c46df98$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = 'ssr-hydration';
                            else _this2.ssr.state = $432481128c46df98$var$state.normal;
                        }
                        if (mutation.type === 'childList') {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $9lRp1.isContainedWithinMediaWrapper)(node)) ignoreReason = 'image';
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, 'html', ignoreReason);
                                        });
                                        return;
                                    }
                                    if (shouldHandleEditorLnvLocal) {
                                        if (_this2.editorLnvHandler.shouldHandleAddedNode(node)) {
                                            _this2.editorLnvHandler.handleAddedNode(node).then(function(_ref) {
                                                var shouldIgnore = _ref.shouldIgnore;
                                                _this2.observeElement(node, mutation, 'html', shouldIgnore ? 'editor-lazy-node-view' : ignoreReason);
                                            });
                                            return;
                                        }
                                    }
                                    _this2.observeElement(node, mutation, 'html', ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, 'text', ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === 'attributes') {
                            if (mutation.target instanceof HTMLElement) {
                                var attributeName = mutation.attributeName;
                                if ((0, $i2LcI.fg)('platform_ufo_vc_ignore_same_value_mutation')) {
                                    var _mutation$oldValue;
                                    /*
                	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
                	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
                	Conceptually there is after all a mutation: there is an old value replaced with a new one,
                	and whether or not they are the same doesn't really matter.
                	And Custom elements should work the same way as MutationObserver."
                	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
                */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                    var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                    if (oldValue !== newValue) {
                                        if ((0, $dqsxj.default)(mutation)) ignoreReason = 'non-visual-style';
                                        if ((0, $i2LcI.fg)('platform_ufo_vc_fix_ignore_image_mutation')) {
                                            if ((0, $9lRp1.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                        }
                                        _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName, oldValue, newValue);
                                    }
                                } else {
                                    if ((0, $dqsxj.default)(mutation)) ignoreReason = 'non-visual-style';
                                    if ((0, $i2LcI.fg)('platform_ufo_vc_fix_ignore_image_mutation')) {
                                        if ((0, $9lRp1.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = 'image';
                                    }
                                    _this2.observeElement(mutation.target, mutation, 'attr', ignoreReason, attributeName);
                                }
                            }
                        }
                    });
                    (0, $7bV0v.markProfilingEnd)(operationTimer, {
                        tags: [
                            'vc'
                        ]
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute('data-vc');
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? "[data-vc=\"".concat(dataVCAttr, "\"]") : '';
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : '';
                    var testId = this.selectorConfig.testId ? element.getAttribute('data-testid') || element.getAttribute('data-test-id') : '';
                    testId = testId ? "[testid=".concat(testId, "]") : '';
                    var role = this.selectorConfig.role ? element.getAttribute('role') : '';
                    role = role ? "[role=".concat(role, "]") : '';
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join('.') : '';
                    classList = classList === '' ? '' : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join('');
                    var idString = '';
                    if (attrs === '' && classList === '') {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : 'unknown';
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join('');
                    return idString;
                } catch (e) {
                    return 'error';
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    var operationTimer = (0, $7bV0v.markProfilingStart)('intersectionObserverCallback');
                    _this3.measureStart();
                    entries.forEach(function(_ref2) {
                        var isIntersecting = _ref2.isIntersecting, ir = _ref2.intersectionRect, target = _ref2.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$432481128c46df98$var$isElementVisible(target)) data.ignoreReason = 'not-visible';
                            if ((0, $i2LcI.fg)('platform_editor_ed-25937_ignore_mutations_for_ttvc')) {
                                if ($432481128c46df98$var$isInsideEditorContainer(target)) data.ignoreReason = 'editor-container-mutation';
                            }
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = 'error';
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                    (0, $7bV0v.markProfilingEnd)(operationTimer, {
                        tags: [
                            'vc'
                        ]
                    });
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("9lRp1", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $6cef7fdd9ef830ed$export$f61fbc3b9c4a9019; });

var $7bV0v = parcelRequire("7bV0v");

var $fdcZO = parcelRequire("fdcZO");
var $6cef7fdd9ef830ed$export$f61fbc3b9c4a9019 = (0, $7bV0v.withProfiling)(function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $fdcZO.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
});

});
parcelRegister("fdcZO", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $b13226aa9548d6e5$export$7674290405cc25b0; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");
var $b13226aa9548d6e5$export$7674290405cc25b0 = 'data-media-vc-wrapper';
var $b13226aa9548d6e5$export$7028e9efe569888c = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $b13226aa9548d6e5$export$7674290405cc25b0, true);
function $b13226aa9548d6e5$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", $b13226aa9548d6e5$export$7028e9efe569888c, children);
}

});


parcelRegister("9hvMu", function(module, exports) {

$parcel$export(module.exports, "EditorLnvHandler", function () { return $6c1e5aa93b41989e$export$569bcb41b9a84ec8; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $7bV0v = parcelRequire("7bV0v");
var $6c1e5aa93b41989e$var$placeholderDataKey = 'editorLnvPlaceholder'; // data-editor-lnv-placeholder
var $6c1e5aa93b41989e$var$replaceDataKey = 'editorLnvPlaceholderReplace'; // data-editor-lnv-placeholder-replace
var $6c1e5aa93b41989e$export$569bcb41b9a84ec8 = /*#__PURE__*/ function() {
    function EditorLnvHandler() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, EditorLnvHandler);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "placeholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "isAddedPlaceholderMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "isAddedReplaceMatchingSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "intersectionObserverCallback", function(_ref) {
            var _target$dataset, _target$dataset2;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) return;
            var placeholderId = (_target$dataset = target.dataset) === null || _target$dataset === void 0 ? void 0 : _target$dataset[$6c1e5aa93b41989e$var$placeholderDataKey];
            if (placeholderId && _this.getSizeCallbacks.has(placeholderId)) {
                var _resolve = _this.getSizeCallbacks.get(placeholderId);
                _this.getSizeCallbacks.delete(placeholderId);
                if (!_resolve) return;
                _resolve({
                    x: boundingClientRect.x,
                    y: boundingClientRect.y,
                    width: boundingClientRect.width,
                    height: boundingClientRect.height
                });
                return;
            }
            if (placeholderId && _this.isAddedPlaceholderMatchingSizeCallbacks.has(placeholderId)) {
                var _resolve2 = _this.isAddedPlaceholderMatchingSizeCallbacks.get(placeholderId);
                _this.isAddedPlaceholderMatchingSizeCallbacks.delete(placeholderId);
                if (!_resolve2) return;
                var placeholder = _this.placeholders.get(placeholderId);
                if (!placeholder) {
                    _resolve2(false);
                    return;
                }
                _resolve2(_this.areRectsSameSize(placeholder, boundingClientRect));
                return;
            }
            var replaceId = (_target$dataset2 = target.dataset) === null || _target$dataset2 === void 0 ? void 0 : _target$dataset2[$6c1e5aa93b41989e$var$replaceDataKey];
            if (replaceId && _this.isAddedReplaceMatchingSizeCallbacks.has(replaceId)) {
                var _resolve3 = _this.isAddedReplaceMatchingSizeCallbacks.get(replaceId);
                _this.isAddedReplaceMatchingSizeCallbacks.delete(replaceId);
                if (!_resolve3) return;
                var _placeholder = _this.placeholders.get(replaceId);
                if (!_placeholder) {
                    _resolve3(false);
                    return;
                }
                _this.placeholders.delete(replaceId);
                _resolve3(_this.areRectsSameSize(_placeholder, boundingClientRect));
                return;
            }
        });
        var operationTimer = (0, $7bV0v.markProfilingStart)('EditorLnvHandler constructor');
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.shouldHandleAddedNode = (0, $7bV0v.withProfiling)(this.shouldHandleAddedNode.bind(this), [
            'vc'
        ]);
        this.handleAddedNode = (0, $7bV0v.withProfiling)(this.handleAddedNode.bind(this), [
            'vc'
        ]);
        this.clear = (0, $7bV0v.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.handleAddedPlaceholderNode = (0, $7bV0v.withProfiling)(this.handleAddedPlaceholderNode.bind(this), [
            'vc'
        ]);
        this.handleAddedReplaceNode = (0, $7bV0v.withProfiling)(this.handleAddedReplaceNode.bind(this), [
            'vc'
        ]);
        this.isExistingPlaceholder = (0, $7bV0v.withProfiling)(this.isExistingPlaceholder.bind(this), [
            'vc'
        ]);
        this.registerPlaceholder = (0, $7bV0v.withProfiling)(this.registerPlaceholder.bind(this), [
            'vc'
        ]);
        this.getSize = (0, $7bV0v.withProfiling)(this.getSize.bind(this), [
            'vc'
        ]);
        this.isAddedPlaceholderMatchingSize = (0, $7bV0v.withProfiling)(this.isAddedPlaceholderMatchingSize.bind(this), [
            'vc'
        ]);
        this.isAddedReplaceMatchingSize = (0, $7bV0v.withProfiling)(this.isAddedReplaceMatchingSize.bind(this), [
            'vc'
        ]);
        this.areRectsSameSize = (0, $7bV0v.withProfiling)(this.areRectsSameSize.bind(this), [
            'vc'
        ]);
        this.intersectionObserverCallback = (0, $7bV0v.withProfiling)(this.intersectionObserverCallback.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(EditorLnvHandler, [
        {
            key: "shouldHandleAddedNode",
            value: function shouldHandleAddedNode(el) {
                var _el$dataset, _el$dataset2;
                return ((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset[$6c1e5aa93b41989e$var$placeholderDataKey]) || ((_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2[$6c1e5aa93b41989e$var$replaceDataKey]);
            }
        },
        {
            key: "handleAddedNode",
            value: function handleAddedNode(el) {
                var _el$dataset3, _el$dataset4;
                // If it placeholder does not already exist, add it to the map
                var placeholderId = (_el$dataset3 = el.dataset) === null || _el$dataset3 === void 0 ? void 0 : _el$dataset3[$6c1e5aa93b41989e$var$placeholderDataKey];
                if (placeholderId) return this.handleAddedPlaceholderNode(el, placeholderId);
                var replaceId = (_el$dataset4 = el.dataset) === null || _el$dataset4 === void 0 ? void 0 : _el$dataset4[$6c1e5aa93b41989e$var$replaceDataKey];
                if (replaceId) return this.handleAddedReplaceNode(el, replaceId);
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.placeholders.clear();
                this.intersectionObserver.disconnect();
            }
        },
        {
            key: "handleAddedPlaceholderNode",
            value: function handleAddedPlaceholderNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedPlaceholderMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return this.registerPlaceholder(el, placeholderId).then(function() {
                    return {
                        shouldIgnore: false
                    };
                });
            }
        },
        {
            key: "handleAddedReplaceNode",
            value: function handleAddedReplaceNode(el, placeholderId) {
                if (this.isExistingPlaceholder(placeholderId)) return this.isAddedReplaceMatchingSize(el, placeholderId).then(function(isMatching) {
                    return {
                        shouldIgnore: isMatching
                    };
                });
                return Promise.resolve({
                    shouldIgnore: false
                });
            }
        },
        {
            key: "isExistingPlaceholder",
            value: function isExistingPlaceholder(placeholderId) {
                return this.placeholders.has(placeholderId);
            }
        },
        {
            key: "registerPlaceholder",
            value: function registerPlaceholder(el, placeholderId) {
                var _this2 = this;
                return this.getSize(el, placeholderId).then(function(size) {
                    _this2.placeholders.set(placeholderId, size);
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el, placeholderId) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(placeholderId, resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedPlaceholderMatchingSize",
            value: function isAddedPlaceholderMatchingSize(el, placeholderId) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    _this4.isAddedPlaceholderMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this4.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "isAddedReplaceMatchingSize",
            value: function isAddedReplaceMatchingSize(el, placeholderId) {
                var _this5 = this;
                return new Promise(function(resolve) {
                    _this5.isAddedReplaceMatchingSizeCallbacks.set(placeholderId, resolve);
                    _this5.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "areRectsSameSize",
            value: function areRectsSameSize(a, b) {
                return Math.abs(a.width - b.width) < 1 && Math.abs(a.height - b.height) < 1;
            }
        }
    ]);
}();

});

parcelRegister("dqsxj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c63d6c45cd2f424$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ var $9c63d6c45cd2f424$var$isNonVisualStyleMutation = (0, $7bV0v.withProfiling)(function isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== 'class' && attributeName !== 'style') return false;
    if (target.getAttribute('data-vc-nvs') !== 'true') return false;
    return true;
}, [
    'vc'
]);
var $9c63d6c45cd2f424$export$2e2bcd8739ae039 = $9c63d6c45cd2f424$var$isNonVisualStyleMutation;

});

parcelRegister("4vNNx", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $3490af80719fae72$export$c0102f1a1198d10f; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $7bV0v = parcelRequire("7bV0v");
var $3490af80719fae72$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $3490af80719fae72$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "EQUALITY_THRESHOLD", 1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "intersectionObserverCallback", function(_ref) {
            var _this$intersectionObs;
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || '';
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = target.getBoundingClientRect();
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = target.dataset.ssrPlaceholderReplace || '';
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = target.getBoundingClientRect();
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        var operationTimer = (0, $7bV0v.markProfilingStart)('SSRPlaceholderHandlers constructor');
        if (typeof IntersectionObserver === 'function') // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll('[data-ssr-placeholder]');
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO, _this$intersectionObs2;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
        this.clear = (0, $7bV0v.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.isPlaceholder = (0, $7bV0v.withProfiling)(this.isPlaceholder.bind(this), [
            'vc'
        ]);
        this.isPlaceholderReplacement = (0, $7bV0v.withProfiling)(this.isPlaceholderReplacement.bind(this), [
            'vc'
        ]);
        this.isPlaceholderIgnored = (0, $7bV0v.withProfiling)(this.isPlaceholderIgnored.bind(this), [
            'vc'
        ]);
        this.findNearestPlaceholderContainerIfIgnored = (0, $7bV0v.withProfiling)(this.findNearestPlaceholderContainerIfIgnored.bind(this), [
            'vc'
        ]);
        this.checkIfExistedAndSizeMatching = (0, $7bV0v.withProfiling)(this.checkIfExistedAndSizeMatching.bind(this), [
            'vc'
        ]);
        this.getSize = (0, $7bV0v.withProfiling)(this.getSize.bind(this), [
            'vc'
        ]);
        this.validateReactComponentMatchToPlaceholder = (0, $7bV0v.withProfiling)(this.validateReactComponentMatchToPlaceholder.bind(this), [
            'vc'
        ]);
        this.hasSameSizePosition = (0, $7bV0v.withProfiling)(this.hasSameSizePosition.bind(this), [
            'vc'
        ]);
        this.isDummyRect = (0, $7bV0v.withProfiling)(this.isDummyRect.bind(this), [
            'vc'
        ]);
        this.intersectionObserverCallback = (0, $7bV0v.withProfiling)(this.intersectionObserverCallback.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(element.dataset.ssrPlaceholder);
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(element.dataset.ssrPlaceholderReplace);
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return 'ssrPlaceholderIgnored' in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $3490af80719fae72$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholder || '';
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this2$intersectionOb;
                        _this2.callbacks.set(id, resolve);
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    var _this3$intersectionOb;
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || '', resolve);
                    (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholderReplace || '';
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this4$intersectionOb;
                        _this4.reactValidateCallbacks.set(id, resolve);
                        (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD || false;
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});




parcelRegister("dxun7", function(module, exports) {

$parcel$export(module.exports, "clearActiveTrace", function () { return $9db5eaa2a7fdf48e$export$17ab21d7be720b; });

var $7bV0v = parcelRequire("7bV0v");

var $i013n = parcelRequire("i013n");
var $9db5eaa2a7fdf48e$var$state = {
    context: null
};
var $9db5eaa2a7fdf48e$export$295213bc4d0c54ad = (0, $7bV0v.withProfiling)(function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join('');
});
var $9db5eaa2a7fdf48e$export$f2e521e495a88544 = (0, $7bV0v.withProfiling)(function setInteractionActiveTrace(interactionId, experienceType) {
    $9db5eaa2a7fdf48e$export$a1002be327997103(interactionId.replace(/-/g, ''), $9db5eaa2a7fdf48e$export$295213bc4d0c54ad(), experienceType);
});
var $9db5eaa2a7fdf48e$export$a1002be327997103 = (0, $7bV0v.withProfiling)(function setActiveTrace(traceId, spanId, type) {
    $9db5eaa2a7fdf48e$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
});
var $9db5eaa2a7fdf48e$export$b6ac780db3a3cc77 = (0, $7bV0v.withProfiling)(function getActiveTrace() {
    return $9db5eaa2a7fdf48e$var$state.context || undefined;
});
var $9db5eaa2a7fdf48e$export$17ab21d7be720b = (0, $7bV0v.withProfiling)(function clearActiveTrace() {
    $9db5eaa2a7fdf48e$var$state.context = null;
});
var $9db5eaa2a7fdf48e$export$6e17cce6446848f9 = (0, $7bV0v.withProfiling)(function getActiveTraceHttpRequestHeaders(_url) {
    if ($9db5eaa2a7fdf48e$var$state.context === null) return null;
    var _state$context = $9db5eaa2a7fdf48e$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $i013n.makeTraceHttpRequestHeaders)(traceId, spanId);
});
var $9db5eaa2a7fdf48e$export$a1e7396778592551 = (0, $7bV0v.withProfiling)(function getActiveTraceAsQueryParams(_url) {
    var traceHeaders = $9db5eaa2a7fdf48e$export$6e17cce6446848f9(_url);
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
});

});
parcelRegister("i013n", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $0361b1bb0f16350b$export$1115c5277eb10d5e; });

var $7bV0v = parcelRequire("7bV0v");
var $0361b1bb0f16350b$export$1115c5277eb10d5e = (0, $7bV0v.withProfiling)(function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        'X-B3-TraceId': traceId,
        'X-B3-SpanId': spanId
    };
});

});


parcelRegister("bAdsy", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $86ed7f48046c7a45$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $86ed7f48046c7a45$export$2a5c8df26bb89760; });

var $7bV0v = parcelRequire("7bV0v");

var $9AokE = parcelRequire("9AokE");
var $86ed7f48046c7a45$export$5b78c989c8db2561 = new Map();
var $86ed7f48046c7a45$export$2a5c8df26bb89760 = new Map();
var $86ed7f48046c7a45$export$47fade9662f71000 = (0, $7bV0v.withProfiling)(function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === 'function') globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $9AokE.redactValue)(featureFlagValue);
    $86ed7f48046c7a45$export$5b78c989c8db2561.set(featureFlagName, value);
    $86ed7f48046c7a45$export$2a5c8df26bb89760.set(featureFlagName, value);
});

});
parcelRegister("9AokE", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $6faa59b112917a35$export$fcc03ee4c944962f; });

var $cd8Dz = parcelRequire("cd8Dz");

var $7bV0v = parcelRequire("7bV0v");

var $9653u = parcelRequire("9653u");
var $6faa59b112917a35$var$startsAsObject = (0, $7bV0v.withProfiling)(function startsAsObject(value) {
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
});
var $6faa59b112917a35$var$isObject = (0, $7bV0v.withProfiling)(function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value) === 'object' && value.constructor === Object;
});
var $6faa59b112917a35$var$isString = (0, $7bV0v.withProfiling)(function isString(input) {
    var result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
});
var $6faa59b112917a35$export$7b4abba432e57989 = (0, $7bV0v.withProfiling)(function shouldRedactValue(value) {
    return $6faa59b112917a35$var$isString(value) && $6faa59b112917a35$var$startsAsObject(value) || $6faa59b112917a35$var$isObject(value);
});
var $6faa59b112917a35$export$fcc03ee4c944962f = (0, $7bV0v.withProfiling)(function redactValue(featureFlagValue) {
    return $6faa59b112917a35$export$7b4abba432e57989(featureFlagValue) ? (0, $9653u.NON_BOOLEAN_VALUE) : featureFlagValue;
});

});
parcelRegister("9653u", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $69f8987299d79f04$export$42f4885608027d0c; });
var $69f8987299d79f04$export$42f4885608027d0c = 'non_boolean';

});



parcelRegister("gwJNC", function(module, exports) {

$parcel$export(module.exports, "getInteractionId", function () { return $c0832945140f051f$export$37bca3107733ac1e; });

var $8ZuGG = parcelRequire("8ZuGG");
var $c0832945140f051f$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$c0832945140f051f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)($c0832945140f051f$export$3109542b68df9ba1);
var $c0832945140f051f$export$37bca3107733ac1e = function getInteractionId() {
    return $c0832945140f051f$export$3109542b68df9ba1;
};
var $c0832945140f051f$export$9f6000531b78127e = function useInteractionId() {
    return $c0832945140f051f$export$3109542b68df9ba1;
};

});

parcelRegister("iww5R", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $d7c41c3c6fb73eee$export$b3bc47985717b49e; });

var $cF8Kw = parcelRequire("cF8Kw");

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $dyWhr = parcelRequire("dyWhr");

var $7bV0v = parcelRequire("7bV0v");

var $bizkj = parcelRequire("bizkj");

var $gXYFp = parcelRequire("gXYFp");

var $dAAF0 = parcelRequire("dAAF0");

var $1RdT6 = parcelRequire("1RdT6");
var $d7c41c3c6fb73eee$var$_process;
function $d7c41c3c6fb73eee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d7c41c3c6fb73eee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d7c41c3c6fb73eee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d7c41c3c6fb73eee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d7c41c3c6fb73eee$var$VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _getConfig;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCObserverWrapper);
        var operationTimer = (0, $7bV0v.markProfilingStart)('VCObserverWrapper constructor');
        this.newVCObserver = null;
        var isNewVCObserverEnabled = (0, $i2LcI.fg)('platform_ufo_vc_observer_new') || ((_getConfig = (0, $dyWhr.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.vc) === null || _getConfig === void 0 ? void 0 : _getConfig.enableVCObserverNew);
        if (isNewVCObserverEnabled) this.newVCObserver = new (0, $dAAF0.default)({
            selectorConfig: opts.selectorConfig
        });
        this.oldVCObserver = new (0, $gXYFp.VCObserver)(opts);
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $7bV0v.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getVCRawData = (0, $7bV0v.withProfiling)(this.getVCRawData.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $7bV0v.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.setSSRElement = (0, $7bV0v.withProfiling)(this.setSSRElement.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStart = (0, $7bV0v.withProfiling)(this.setReactRootRenderStart.bind(this), [
            'vc'
        ]);
        this.setReactRootRenderStop = (0, $7bV0v.withProfiling)(this.setReactRootRenderStop.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCObserverWrapper, [
        {
            key: "start",
            value: function start(startArg) {
                var _this$oldVCObserver, _this$newVCObserver;
                (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start(startArg);
                (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                    startTime: startArg.startTime
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$oldVCObserver2, _this$newVCObserver2;
                (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _ref;
                    var oldResult, newResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 2:
                                oldResult = _context.sent;
                                _context.next = 5;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: (0, $i2LcI.fg)('platform_ufo_vc_ttai_on_paint') ? param.stop : performance.now()
                                });
                            case 5:
                                newResult = _context.sent;
                                if (!(oldResult && !newResult)) {
                                    _context.next = 8;
                                    break;
                                }
                                return _context.abrupt("return", oldResult);
                            case 8:
                                return _context.abrupt("return", $d7c41c3c6fb73eee$var$_objectSpread($d7c41c3c6fb73eee$var$_objectSpread({}, oldResult !== null && oldResult !== void 0 ? oldResult : {}), {}, {
                                    'ufo:vc:rev': [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))((_ref = oldResult === null || oldResult === void 0 ? void 0 : oldResult['ufo:vc:rev']) !== null && _ref !== void 0 ? _ref : []), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(newResult !== null && newResult !== void 0 ? newResult : []))
                                }));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
            }
        }
    ]);
}(); // Some products set this variable to indicate it is running in SSR
var $d7c41c3c6fb73eee$var$isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var $d7c41c3c6fb73eee$var$isReactSSR = typeof $1RdT6 !== 'undefined' && Boolean((($d7c41c3c6fb73eee$var$_process = $1RdT6) === null || $d7c41c3c6fb73eee$var$_process === void 0 || ($d7c41c3c6fb73eee$var$_process = $d7c41c3c6fb73eee$var$_process.env) === null || $d7c41c3c6fb73eee$var$_process === void 0 ? void 0 : $d7c41c3c6fb73eee$var$_process.REACT_SSR) || false);
var $d7c41c3c6fb73eee$export$68d57b133e88584d = (0, $7bV0v.withProfiling)(function isEnvironmentSupported() {
    // SSR environment aren't supported
    if ($d7c41c3c6fb73eee$var$isReactSSR || $d7c41c3c6fb73eee$var$isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== 'function') return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== 'function' || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== 'function') return false;
    return true;
}, [
    'vc'
]);
var $d7c41c3c6fb73eee$export$b3bc47985717b49e = (0, $7bV0v.withProfiling)(function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !$d7c41c3c6fb73eee$export$68d57b133e88584d();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $bizkj.VCObserverNOOP)() : new $d7c41c3c6fb73eee$var$VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}, [
    'vc'
]);

});
parcelRegister("bizkj", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", function () { return $839cc7482e2b01f1$export$24d07287b49da906; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");
var $839cc7482e2b01f1$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCObserverNOOP);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCObserverNOOP, [
        {
            key: "start",
            value: function start(startArg) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(param) {
                return Promise.resolve({
                    'ufo:vc:noop': true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {}
        }
    ]);
}();

});

parcelRegister("dAAF0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e4b1327da47a44d$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $sxYRL = parcelRequire("sxYRL");

var $gIzbv = parcelRequire("gIzbv");

var $daIV4 = parcelRequire("daIV4");

var $gxakF = parcelRequire("gxakF");

var $2ZBxU = parcelRequire("2ZBxU");
var $9e4b1327da47a44d$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $9e4b1327da47a44d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$selectorConfi, _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCObserverNew);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "viewportObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "windowEventObserver", null);
        var operationTimer = (0, $7bV0v.markProfilingStart)('VCObserverNew constructor');
        this.entriesTimeline = new (0, $sxYRL.default)();
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $9e4b1327da47a44d$var$DEFAULT_SELECTOR_CONFIG;
        this.viewportObserver = new (0, $gxakF.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = 'unknown';
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                _this.entriesTimeline.push({
                    time: time,
                    type: type,
                    data: {
                        elementName: elementName,
                        rect: rect,
                        previousRect: previousRect,
                        visible: visible,
                        attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName
                    }
                });
            }
        });
        this.windowEventObserver = new (0, $2ZBxU.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                _this.entriesTimeline.push({
                    time: time,
                    type: 'window:event',
                    data: {
                        eventType: type
                    }
                });
            }
        });
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $7bV0v.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        this.getVCResult = (0, $7bV0v.withProfiling)(this.getVCResult.bind(this), [
            'vc'
        ]);
        this.getElementName = (0, $7bV0v.withProfiling)(this.getElementName.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCObserverNew, [
        {
            key: "start",
            value: function start(_ref2) {
                var _this$viewportObserve, _this$windowEventObse;
                var startTime = _ref2.startTime;
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                this.entriesTimeline.clear();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse2;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.stop();
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(param) {
                    var start, stop, results, calculator_fy25_03, orderedEntries, fy25_03;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop;
                                results = [];
                                calculator_fy25_03 = new (0, $daIV4.default)();
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                _context.next = 6;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop
                                });
                            case 6:
                                fy25_03 = _context.sent;
                                if (fy25_03) results.push(fy25_03);
                                return _context.abrupt("return", results);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $gIzbv.default)(this.selectorConfig, element);
            }
        }
    ]);
}();

});
parcelRegister("sxYRL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $055cf98041f9d585$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $7bV0v = parcelRequire("7bV0v");
var $055cf98041f9d585$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, EntriesTimeline);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unorderedEntries", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sortedEntriesCache", new Map());
        var operationTimer = (0, $7bV0v.markProfilingStart)('EntriesTimeline constructor');
        this.unorderedEntries = [];
        this.push = (0, $7bV0v.withProfiling)(this.push.bind(this), [
            'vc'
        ]);
        this.getCacheKey = (0, $7bV0v.withProfiling)(this.getCacheKey.bind(this), [
            'vc'
        ]);
        this.getOrderedEntries = (0, $7bV0v.withProfiling)(this.getOrderedEntries.bind(this), [
            'vc'
        ]);
        this.clear = (0, $7bV0v.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : 'null', "_").concat(stop !== null && stop !== void 0 ? stop : 'null');
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("gIzbv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2bc0c540385ae91$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
var $c2bc0c540385ae91$var$nameCache = new WeakMap();
var $c2bc0c540385ae91$var$getElementName = (0, $7bV0v.withProfiling)(function getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    var cachedName = $c2bc0c540385ae91$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== 'function') return '';
        try {
            return encodeURIComponent(s);
        } catch (e) {
            return 'malformed_value';
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        if (element && typeof element.getAttribute !== 'function') return '';
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return '';
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, "=\"").concat(encondedAttrValue, "\"]");
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector('data-vc') : '';
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : '';
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector('data-testid') || getAttributeSelector('data-test-id') : '';
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector('role') : '';
    var classNames = Array.from(element.classList).map(encodeValue).join('.');
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : '';
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join('');
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? getElementName(selectorConfig, element.parentElement) : 'unknown';
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $c2bc0c540385ae91$var$nameCache.set(element, name);
    return name;
}, [
    'vc'
]);
var $c2bc0c540385ae91$export$2e2bcd8739ae039 = $c2bc0c540385ae91$var$getElementName;

});

parcelRegister("daIV4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $996f0d9953051850$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $7bV0v = parcelRequire("7bV0v");

var $gVdj7 = parcelRequire("gVdj7");

var $8GeAK = parcelRequire("8GeAK");
function $996f0d9953051850$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $996f0d9953051850$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $996f0d9953051850$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($996f0d9953051850$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $996f0d9953051850$var$ABORTING_WINDOW_EVENT = [
    'wheel',
    'scroll',
    'keydown',
    'resize'
];
var $996f0d9953051850$var$REVISION_NO = 'fy25.03';
var $996f0d9953051850$var$CONSIDERED_ENTRY_TYPE = [
    'mutation:child-element',
    'mutation:element',
    'mutation:attribute',
    'layout-shift',
    'window:event'
];
var $996f0d9953051850$export$98812f4e79596e2b = [
    'data-drop-target-for-element',
    'draggable'
];
var $996f0d9953051850$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCCalculator_FY25_03);
        _this = $996f0d9953051850$var$_callSuper(this, VCCalculator_FY25_03, [
            $996f0d9953051850$var$REVISION_NO
        ]);
        _this.isEntryIncluded = (0, $7bV0v.withProfiling)(_this.isEntryIncluded.bind(_this), [
            'vc'
        ]);
        _this.isVCClean = (0, $7bV0v.withProfiling)(_this.isVCClean.bind(_this), [
            'vc'
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry) {
                if (!$996f0d9953051850$var$CONSIDERED_ENTRY_TYPE.includes(entry.type)) return false;
                if (entry.type === 'mutation:attribute') {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (!attributeName || $996f0d9953051850$export$98812f4e79596e2b.includes(attributeName)) return false;
                    return true;
                }
                if ((0, $8GeAK.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "isVCClean",
            value: function isVCClean(filteredEntries) {
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.type === 'window:event') {
                        var data = entry.data;
                        if ($996f0d9953051850$var$ABORTING_WINDOW_EVENT.includes(data.eventType)) return true;
                    }
                    return false;
                });
                return !hasAbortEvent;
            }
        }
    ]);
}((0, $gVdj7.default));

});
parcelRegister("gVdj7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51c4ac970442bba$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $6E7Pd = parcelRequire("6E7Pd");

var $heRTv = parcelRequire("heRTv");

var $26GzF = parcelRequire("26GzF");
var $c51c4ac970442bba$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
        this.calculate = (0, $7bV0v.withProfiling)(this.calculate.bind(this), [
            'vc'
        ]);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(AbstractVCCalculatorBase, [
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, filteredEntries, isVCClean, vcDetails;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry);
                                });
                                isVCClean = this.isVCClean(filteredEntries);
                                if (isVCClean) {
                                    _context.next = 5;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    'metric:vc90': null,
                                    clean: false
                                });
                            case 5:
                                _context.next = 7;
                                return (0, $6E7Pd.default)({
                                    viewport: {
                                        width: (0, $26GzF.default)(),
                                        height: (0, $heRTv.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: filteredEntries,
                                    percentiles: [
                                        25,
                                        50,
                                        75,
                                        80,
                                        85,
                                        90,
                                        95,
                                        98,
                                        99
                                    ]
                                });
                            case 7:
                                vcDetails = _context.sent;
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    clean: isVCClean,
                                    'metric:vc90': (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails['90']) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null
                                });
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function calculate(_x) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("6E7Pd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d6c8c679ef487b6$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $k9eqg = parcelRequire("k9eqg");

var $fZaz2 = parcelRequire("fZaz2");

var $InHen = parcelRequire("InHen");
var $4d6c8c679ef487b6$var$calculateTTVCPercentiles = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(arg) {
        var algo, vcDetails, _vcDetails, _vcDetails2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    algo = 'canvas_heatmap';
                    if (!(algo === 'canvas_heatmap')) {
                        _context.next = 6;
                        break;
                    }
                    _context.next = 4;
                    return (0, $k9eqg.default)(arg);
                case 4:
                    vcDetails = _context.sent;
                    return _context.abrupt("return", vcDetails);
                case 6:
                    if (!(algo === 'rect_sweeping')) {
                        _context.next = 11;
                        break;
                    }
                    _context.next = 9;
                    return (0, $InHen.default)(arg);
                case 9:
                    _vcDetails = _context.sent;
                    return _context.abrupt("return", _vcDetails);
                case 11:
                    if (!(algo === 'old_heatmap')) {
                        _context.next = 16;
                        break;
                    }
                    _context.next = 14;
                    return (0, $fZaz2.default)(arg);
                case 14:
                    _vcDetails2 = _context.sent;
                    return _context.abrupt("return", _vcDetails2);
                case 16:
                    throw new Error('unexpected Error algo not chosen correctly');
                case 17:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $4d6c8c679ef487b6$export$2e2bcd8739ae039 = $4d6c8c679ef487b6$var$calculateTTVCPercentiles;

});
parcelRegister("k9eqg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eaafd5f41d0897f7$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $7bV0v = parcelRequire("7bV0v");

var $lDpw9 = parcelRequire("lDpw9");
function $eaafd5f41d0897f7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $eaafd5f41d0897f7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $eaafd5f41d0897f7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $eaafd5f41d0897f7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $eaafd5f41d0897f7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $eaafd5f41d0897f7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $eaafd5f41d0897f7$var$calculateTTVCPercentiles = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator, _step, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $lDpw9.ViewportCanvas)(viewport, (0, $i2LcI.fg)('platform_ufo_canvas_heatmap_full_precision') ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator = $eaafd5f41d0897f7$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator.s();
                case 6:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step.value;
                    if ('rect' in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $eaafd5f41d0897f7$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $eaafd5f41d0897f7$export$2e2bcd8739ae039 = $eaafd5f41d0897f7$var$calculateTTVCPercentiles;
var $eaafd5f41d0897f7$export$89c8da9b65eff678 = (0, $7bV0v.withProfiling)(function calculatePercentiles(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref2, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 1), timeA = _ref4[0];
        var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 1), timeB = _ref5[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator2 = $eaafd5f41d0897f7$var$_createForOfIteratorHelper(sortedEntries), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step2.value, 2), time = _step2$value[0], pixelCount = _step2$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}, [
    'vc'
]);

});
parcelRegister("lDpw9", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", function () { return $fc0108bbf940319c$export$3e59ac9de7402fb1; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $k8yZu = parcelRequire("k8yZu");
var $fc0108bbf940319c$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying OffscreenCanvas instance */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ViewportCanvas);
        var operationTimer = (0, $7bV0v.markProfilingStart)('ViewportCanvas constructor');
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize OffscreenCanvas with scaled dimensions
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.scaledWidth;
        this.canvas.height = this.scaledHeight;
        var ctx = this.canvas.getContext('2d', {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: 'srgb' // Use standard RGB color space
        });
        if (!ctx) throw new Error('Could not get canvas context');
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = 'source-over';
        this.clear();
        this.getScaledDimensions = (0, $7bV0v.withProfiling)(this.getScaledDimensions.bind(this), [
            'vc'
        ]);
        this.clear = (0, $7bV0v.withProfiling)(this.clear.bind(this), [
            'vc'
        ]);
        this.generateColor = (0, $7bV0v.withProfiling)(this.generateColor.bind(this), [
            'vc'
        ]);
        this.drawRect = (0, $7bV0v.withProfiling)(this.drawRect.bind(this), [
            'vc'
        ]);
        this.getPixelCounts = (0, $7bV0v.withProfiling)(this.getPixelCounts.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ViewportCanvas, [
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $fc0108bbf940319c$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $fc0108bbf940319c$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== 'number')) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $fc0108bbf940319c$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
var $fc0108bbf940319c$export$54591583ed0b20ce = (0, $7bV0v.withProfiling)(function getRGBComponents(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error('Input number must be between 0 and 16777215 (inclusive).');
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}, [
    'vc'
]);
var $fc0108bbf940319c$export$fafc9be44839f9c8 = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _calculateDrawnPixelsRaw = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(imageData, scaleFactor, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $k8yZu.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    function calculateDrawnPixelsRaw(_x, _x2, _x3) {
        return _calculateDrawnPixelsRaw.apply(this, arguments);
    }
    return calculateDrawnPixelsRaw;
}(), [
    'vc'
]);

});
parcelRegister("k8yZu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea8fb26fffcf485b$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
var $ea8fb26fffcf485b$var$taskYield = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _taskYield = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!('scheduler' in globalThis && // @ts-ignore
                    'yield' in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function taskYield() {
        return _taskYield.apply(this, arguments);
    }
    return taskYield;
}(), [
    'vc'
]);
var $ea8fb26fffcf485b$export$2e2bcd8739ae039 = $ea8fb26fffcf485b$var$taskYield;

});



parcelRegister("fZaz2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba34bf5a81f47bb1$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $8GeAK = parcelRequire("8GeAK");

var $k8yZu = parcelRequire("k8yZu");
function $ba34bf5a81f47bb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba34bf5a81f47bb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba34bf5a81f47bb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba34bf5a81f47bb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ba34bf5a81f47bb1$var$MAX_HEATMAP_SIZE = 1000;
var $ba34bf5a81f47bb1$var$createEmptyHeatmapEntry = (0, $7bV0v.withProfiling)(function createEmptyHeatmapEntry() {
    return {
        head: null,
        previousEntries: []
    };
}, [
    'vc'
]);
var $ba34bf5a81f47bb1$var$createEmptyMap = (0, $7bV0v.withProfiling)(function createEmptyMap(heatmapWidth, heatmapHeight) {
    return Array.from({
        length: heatmapHeight
    }).map(function() {
        return Array.from({
            length: heatmapWidth
        }).map($ba34bf5a81f47bb1$var$createEmptyHeatmapEntry);
    });
}, [
    'vc'
]);
var $ba34bf5a81f47bb1$var$isRectInside = (0, $7bV0v.withProfiling)(function isRectInside(a, b) {
    if (!a || !b) return false;
    // Check if all corners of rectangle a are within the bounds of rectangle b
    return a.left >= b.left && a.right <= b.right && a.top >= b.top && a.bottom <= b.bottom;
}, [
    'vc'
]);
var $ba34bf5a81f47bb1$var$Heatmap = /*#__PURE__*/ function() {
    /**
   * Heatmap Width
   */ /**
   * Heatmap Height
   */ /**
   * Heatmap Area (width * height)
   */ function Heatmap(_ref) {
        var viewport = _ref.viewport, heatmapSize = _ref.heatmapSize;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Heatmap);
        var operationTimer = (0, $7bV0v.markProfilingStart)('Heatmap constructor');
        // TODO timeOrigin? do we need? for SSR??
        this.viewport = viewport;
        var safeSize = Math.min(heatmapSize, $ba34bf5a81f47bb1$var$MAX_HEATMAP_SIZE);
        if (viewport.width === 0 || viewport.height === 0) {
            this.width = safeSize;
            this.height = safeSize;
            this.scaleX = 1;
            this.scaleY = 1;
            this.heatmapAreaSize = 0;
            this.map = $ba34bf5a81f47bb1$var$createEmptyMap(safeSize, safeSize);
            return;
        }
        var aspectRatio = viewport.width / viewport.height;
        if (aspectRatio > 1) {
            // Landscape orientation
            this.width = safeSize;
            this.height = Math.round(safeSize / aspectRatio);
        } else {
            // Portrait orientation
            this.width = safeSize;
            this.height = Math.round(safeSize * aspectRatio);
        }
        this.scaleX = this.width / viewport.width;
        this.scaleY = this.height / viewport.height;
        this.heatmapAreaSize = this.width * this.height;
        this.map = $ba34bf5a81f47bb1$var$createEmptyMap(this.width, this.height);
        this.getHeatmap = (0, $7bV0v.withProfiling)(this.getHeatmap.bind(this), [
            'vc'
        ]);
        this.getCell = (0, $7bV0v.withProfiling)(this.getCell.bind(this), [
            'vc'
        ]);
        this.mapDOMRectToHeatmap = (0, $7bV0v.withProfiling)(this.mapDOMRectToHeatmap.bind(this), [
            'vc'
        ]);
        this.getRatio = (0, $7bV0v.withProfiling)(this.getRatio.bind(this), [
            'vc'
        ]);
        this.applyEntriesToHeatmap = (0, $7bV0v.withProfiling)(this.applyEntriesToHeatmap.bind(this), [
            'vc'
        ]);
        this.getVCPercentMetrics = (0, $7bV0v.withProfiling)(this.getVCPercentMetrics.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Heatmap, [
        {
            key: "getHeatmap",
            value: function getHeatmap() {
                return this.map;
            }
        },
        {
            key: "getCell",
            value: function getCell(row, col) {
                var _this$map$row;
                return (_this$map$row = this.map[row]) === null || _this$map$row === void 0 ? void 0 : _this$map$row[col];
            }
        },
        {
            key: "mapDOMRectToHeatmap",
            value: function mapDOMRectToHeatmap(rect) {
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                return {
                    left: Math.floor(scaledX),
                    right: Math.ceil(scaledX + scaledWidth),
                    top: Math.floor(scaledY),
                    bottom: Math.ceil(scaledY + scaledHeight)
                };
            }
        },
        {
            key: "getRatio",
            value: function getRatio(rect) {
                if (this.viewport.width === 0 || this.viewport.height === 0) return 0;
                var right = rect.right, left = rect.left, bottom = rect.bottom, top = rect.top;
                var rectWidth = right - left;
                var rectHeight = bottom - top;
                var rectArea = rectWidth * rectHeight;
                var ratio = rectArea / this.heatmapAreaSize;
                if (ratio > 1) return 1;
                return ratio;
            }
        },
        {
            key: "applyEntriesToHeatmap",
            value: function() {
                var _applyEntriesToHeatmap = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(entries) {
                    var i, entry, time, type, data, rect, ratio, heatmapEntryData, roundedTop, roundedBottom, roundedLeft, roundedRight, row, col, cell, previousEntry;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                i = 0;
                            case 1:
                                if (!(i < entries.length)) {
                                    _context.next = 37;
                                    break;
                                }
                                entry = entries[i];
                                time = entry.time, type = entry.type, data = entry.data;
                                if (!(0, $8GeAK.default)(data)) {
                                    _context.next = 31;
                                    break;
                                }
                                rect = this.mapDOMRectToHeatmap(data.rect);
                                ratio = this.getRatio(rect);
                                heatmapEntryData = {
                                    time: time,
                                    elementName: data.elementName,
                                    ratio: ratio !== null && ratio !== void 0 ? ratio : null,
                                    rect: rect,
                                    source: type
                                };
                                roundedTop = Math.floor(rect.top);
                                roundedBottom = Math.min(rect.bottom, this.height);
                                roundedLeft = Math.floor(rect.left);
                                roundedRight = Math.min(rect.right, this.width);
                                row = roundedTop;
                            case 13:
                                if (!(row < roundedBottom)) {
                                    _context.next = 31;
                                    break;
                                }
                                col = roundedLeft;
                            case 15:
                                if (!(col < roundedRight)) {
                                    _context.next = 28;
                                    break;
                                }
                                cell = this.getCell(row, col);
                                if (cell) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("continue", 25);
                            case 19:
                                previousEntry = cell.head; // When elements are added at the same time
                                // we try to keep the inner element changes as the head
                                if (!((previousEntry === null || previousEntry === void 0 ? void 0 : previousEntry.time) === entry.time && $ba34bf5a81f47bb1$var$isRectInside(previousEntry.rect, heatmapEntryData.rect))) {
                                    _context.next = 23;
                                    break;
                                }
                                cell.previousEntries.push($ba34bf5a81f47bb1$var$_objectSpread($ba34bf5a81f47bb1$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: 'mutation:parent-mounted'
                                }));
                                return _context.abrupt("continue", 25);
                            case 23:
                                cell.head = $ba34bf5a81f47bb1$var$_objectSpread($ba34bf5a81f47bb1$var$_objectSpread({}, heatmapEntryData), {}, {
                                    source: heatmapEntryData.source || null
                                });
                                if (previousEntry !== null) cell.previousEntries.push(previousEntry);
                            case 25:
                                col++;
                                _context.next = 15;
                                break;
                            case 28:
                                row++;
                                _context.next = 13;
                                break;
                            case 31:
                                if (!(i % 100 === 0)) {
                                    _context.next = 34;
                                    break;
                                }
                                _context.next = 34;
                                return (0, $k8yZu.default)();
                            case 34:
                                i++;
                                _context.next = 1;
                                break;
                            case 37:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function applyEntriesToHeatmap(_x) {
                    return _applyEntriesToHeatmap.apply(this, arguments);
                }
                return applyEntriesToHeatmap;
            }()
        },
        {
            key: "getVCPercentMetrics",
            value: function() {
                var _getVCPercentMetrics = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(vcPercentCheckpoint, startTime) {
                    var sortedCheckpoints, flattenHeatmap, totalCells, timestampMap, i, _cellHead$time, _timestampMap$get, cell, cellHead, timestamp, elementName, curr, sortedTimings, totalCellPainted, result, domElementsBuffer, _i, _timestamp, timestampInfo, cellCount, domElements, currVCRatio, currVCPercent, matchesAnyCheckpoints, checkpoint, _domElements;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                sortedCheckpoints = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(vcPercentCheckpoint).sort(function(a, b) {
                                    return a - b;
                                });
                                flattenHeatmap = this.map.flat();
                                totalCells = flattenHeatmap.length;
                                timestampMap = new Map();
                                i = 0;
                            case 5:
                                if (!(i < flattenHeatmap.length)) {
                                    _context2.next = 20;
                                    break;
                                }
                                cell = flattenHeatmap[i];
                                cellHead = cell.head;
                                timestamp = Math.trunc((_cellHead$time = cellHead === null || cellHead === void 0 ? void 0 : cellHead.time) !== null && _cellHead$time !== void 0 ? _cellHead$time : 0);
                                elementName = cellHead === null || cellHead === void 0 ? void 0 : cellHead.elementName;
                                curr = (_timestampMap$get = timestampMap.get(timestamp)) !== null && _timestampMap$get !== void 0 ? _timestampMap$get : {
                                    cellCount: 0,
                                    domElements: new Set()
                                };
                                curr.cellCount += 1;
                                if (elementName) curr.domElements.add(elementName);
                                timestampMap.set(timestamp, curr);
                                // Every 10000 heatmap entries processed
                                // we give the browser the power
                                // to process any other high priority task
                                if (!(i > 10000 && i % 10000 === 0)) {
                                    _context2.next = 17;
                                    break;
                                }
                                _context2.next = 17;
                                return (0, $k8yZu.default)();
                            case 17:
                                i++;
                                _context2.next = 5;
                                break;
                            case 20:
                                sortedTimings = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(timestampMap.keys()).sort(function(a, b) {
                                    return a - b;
                                });
                                totalCellPainted = 0;
                                result = {};
                                domElementsBuffer = new Set();
                                _i = 0;
                            case 25:
                                if (!(_i < sortedTimings.length)) {
                                    _context2.next = 52;
                                    break;
                                }
                                _timestamp = sortedTimings[_i];
                                timestampInfo = timestampMap.get(_timestamp);
                                if (timestampInfo) {
                                    _context2.next = 30;
                                    break;
                                }
                                throw new Error('unexpected timestampInfo not found');
                            case 30:
                                cellCount = timestampInfo.cellCount, domElements = timestampInfo.domElements;
                                totalCellPainted += cellCount;
                                currVCRatio = totalCellPainted / totalCells;
                                currVCPercent = Math.round(currVCRatio * 100);
                                domElements.forEach(function(domElement) {
                                    domElementsBuffer.add(domElement);
                                });
                                matchesAnyCheckpoints = false;
                            case 36:
                                if (!(sortedCheckpoints.length > 0 && currVCPercent >= sortedCheckpoints[0])) {
                                    _context2.next = 45;
                                    break;
                                }
                                checkpoint = sortedCheckpoints.shift();
                                _domElements = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(domElementsBuffer);
                                if (checkpoint) {
                                    _context2.next = 41;
                                    break;
                                }
                                return _context2.abrupt("break", 45);
                            case 41:
                                matchesAnyCheckpoints = true;
                                result[checkpoint.toString()] = {
                                    t: Math.round(_timestamp - startTime),
                                    e: _domElements
                                };
                                _context2.next = 36;
                                break;
                            case 45:
                                if (matchesAnyCheckpoints) domElementsBuffer.clear();
                                if (!(_i % 500 === 0)) {
                                    _context2.next = 49;
                                    break;
                                }
                                _context2.next = 49;
                                return (0, $k8yZu.default)();
                            case 49:
                                _i++;
                                _context2.next = 25;
                                break;
                            case 52:
                                return _context2.abrupt("return", result);
                            case 53:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getVCPercentMetrics(_x2, _x3) {
                    return _getVCPercentMetrics.apply(this, arguments);
                }
                return getVCPercentMetrics;
            }()
        }
    ]);
}();
var $ba34bf5a81f47bb1$var$calculateTTVCPercentiles = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(_ref2) {
        var orderedEntries, viewport, percentiles, startTime, heatmap, vcDetails;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    orderedEntries = _ref2.orderedEntries, viewport = _ref2.viewport, percentiles = _ref2.percentiles, startTime = _ref2.startTime;
                    heatmap = new $ba34bf5a81f47bb1$var$Heatmap({
                        viewport: viewport,
                        heatmapSize: 200
                    });
                    _context3.next = 4;
                    return heatmap.applyEntriesToHeatmap(orderedEntries);
                case 4:
                    _context3.next = 6;
                    return heatmap.getVCPercentMetrics(percentiles, startTime);
                case 6:
                    vcDetails = _context3.sent;
                    return _context3.abrupt("return", vcDetails);
                case 8:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    function calculateTTVCPercentiles(_x4) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $ba34bf5a81f47bb1$export$2e2bcd8739ae039 = $ba34bf5a81f47bb1$var$calculateTTVCPercentiles;

});
parcelRegister("8GeAK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $651d9090220f0538$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
var $651d9090220f0538$var$isViewportEntryData = (0, $7bV0v.withProfiling)(function isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === 'string';
        var hasRect = typeof data.rect !== 'undefined';
        if (hasRect && hasElementName) return true;
    }
    return false;
}, [
    'vc'
]);
var $651d9090220f0538$export$2e2bcd8739ae039 = $651d9090220f0538$var$isViewportEntryData;

});


parcelRegister("InHen", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $08567dc300626ef7$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $7bV0v = parcelRequire("7bV0v");

var $8GeAK = parcelRequire("8GeAK");

var $k8yZu = parcelRequire("k8yZu");

var $7BXRO = parcelRequire("7BXRO");
var $08567dc300626ef7$var$calculateTTVCPercentiles = (0, $7bV0v.withProfiling)(/*#__PURE__*/ function() {
    var _calculateTTVCPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_ref) {
        var orderedEntries, viewport, percentiles, startTime, sortedPercentiles, viewportArea, checkpoints, activeRects, removeActiveRect, domElementsBuffer, i, iEntry, iEntryData, rect, elementName, exclusionArea, currentArea, currVCPercent, matchesAnyCheckpoints, _checkpoint, domElements;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    orderedEntries = _ref.orderedEntries, viewport = _ref.viewport, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    sortedPercentiles = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(percentiles).sort(function(a, b) {
                        return a - b;
                    });
                    viewportArea = viewport.width * viewport.height;
                    checkpoints = {};
                    activeRects = orderedEntries.filter(function(e) {
                        return (0, $8GeAK.default)(e.data);
                    }).map(function(e) {
                        return e.data.rect;
                    });
                    removeActiveRect = function removeActiveRect(rectToRemove) {
                        var index = activeRects.indexOf(rectToRemove);
                        // Check if the element exists in the array
                        if (index !== -1) // Remove the element at the found index
                        activeRects.splice(index, 1);
                    };
                    domElementsBuffer = new Set();
                    i = 0;
                case 8:
                    if (!(i < orderedEntries.length)) {
                        _context.next = 36;
                        break;
                    }
                    iEntry = orderedEntries[i];
                    iEntryData = iEntry.data;
                    if ((0, $8GeAK.default)(iEntryData)) {
                        _context.next = 13;
                        break;
                    }
                    return _context.abrupt("continue", 33);
                case 13:
                    rect = iEntryData.rect, elementName = iEntryData.elementName;
                    domElementsBuffer.add(elementName);
                    removeActiveRect(rect);
                    exclusionArea = (0, $7BXRO.default)(activeRects);
                    currentArea = viewportArea - exclusionArea;
                    currVCPercent = Math.round(currentArea / viewportArea * 100);
                    matchesAnyCheckpoints = false;
                case 20:
                    if (!(sortedPercentiles.length > 0 && currVCPercent >= sortedPercentiles[0])) {
                        _context.next = 29;
                        break;
                    }
                    _checkpoint = sortedPercentiles.shift();
                    domElements = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(domElementsBuffer);
                    if (_checkpoint) {
                        _context.next = 25;
                        break;
                    }
                    return _context.abrupt("break", 29);
                case 25:
                    matchesAnyCheckpoints = true;
                    checkpoints[_checkpoint.toString()] = {
                        t: Math.round(iEntry.time - startTime),
                        e: domElements
                    };
                    _context.next = 20;
                    break;
                case 29:
                    if (matchesAnyCheckpoints) domElementsBuffer.clear();
                    if (!(i % 500 === 0)) {
                        _context.next = 33;
                        break;
                    }
                    _context.next = 33;
                    return (0, $k8yZu.default)();
                case 33:
                    i++;
                    _context.next = 8;
                    break;
                case 36:
                    return _context.abrupt("return", checkpoints);
                case 37:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    function calculateTTVCPercentiles(_x) {
        return _calculateTTVCPercentiles.apply(this, arguments);
    }
    return calculateTTVCPercentiles;
}(), [
    'vc'
]);
var $08567dc300626ef7$export$2e2bcd8739ae039 = $08567dc300626ef7$var$calculateTTVCPercentiles;

});
parcelRegister("7BXRO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58aa6d68b2041300$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $cF8Kw = parcelRequire("cF8Kw");

var $7bV0v = parcelRequire("7bV0v");
function $58aa6d68b2041300$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $58aa6d68b2041300$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $58aa6d68b2041300$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $58aa6d68b2041300$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $58aa6d68b2041300$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $58aa6d68b2041300$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
/**
 * Calculate the union areas of all rectangles using Sweep Line Algorithm
 *
 * Reference:
 * 	https://en.wikipedia.org/wiki/Sweep_line_algorithm
 *  https://www.hackerearth.com/practice/math/geometry/line-sweep-technique/tutorial/#:~:text=A%20sweep%20line%20is%20an,order%20to%20discretize%20the%20sweep.
 *
 * @param rectangles
 * @returns
 */ var $58aa6d68b2041300$var$calculateUnionArea = (0, $7bV0v.withProfiling)(function calculateUnionArea(rectangles) {
    // Step 1: Create sweep line events
    var events = $58aa6d68b2041300$var$createSweepLineEvents(rectangles);
    // Step 2: Process events to calculate total area
    var activeIntervals = new Map();
    var totalArea = 0;
    var previousX = 0;
    var _iterator = $58aa6d68b2041300$var$_createForOfIteratorHelper(events), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var event = _step.value;
            // Calculate height at current x-position
            var currentHeight = $58aa6d68b2041300$var$calculateActiveHeight(activeIntervals);
            // Add area since last x-position
            totalArea += currentHeight * (event.x - previousX);
            // Update x-position
            previousX = event.x;
            // Update active intervals
            $58aa6d68b2041300$var$updateActiveIntervals(activeIntervals, event);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return totalArea;
}, [
    'vc'
]);
var $58aa6d68b2041300$export$2e2bcd8739ae039 = $58aa6d68b2041300$var$calculateUnionArea;
var $58aa6d68b2041300$var$createSweepLineEvents = (0, $7bV0v.withProfiling)(function createSweepLineEvents(rectangles) {
    var events = [];
    var _iterator2 = $58aa6d68b2041300$var$_createForOfIteratorHelper(rectangles), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var rect = _step2.value;
            // Create start and end events for each rectangle
            events.push({
                x: rect.left,
                type: 'start',
                top: rect.top,
                bottom: rect.bottom
            });
            events.push({
                x: rect.right,
                type: 'end',
                top: rect.top,
                bottom: rect.bottom
            });
        }
    // Sort events by x-coordinate (and type as tiebreaker)
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return events.sort(function(a, b) {
        return a.x === b.x ? a.type === 'end' ? 1 : -1 : a.x - b.x;
    });
}, [
    'vc'
]);
var $58aa6d68b2041300$var$calculateActiveHeight = (0, $7bV0v.withProfiling)(function calculateActiveHeight(intervals) {
    if (intervals.size === 0) return 0;
    // Get all unique y-coordinates
    var coordinates = [];
    var _iterator3 = $58aa6d68b2041300$var$_createForOfIteratorHelper(intervals), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _step3$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step3.value, 1), _key = _step3$value[0];
            var _key$split$map3 = _key.split(',').map(Number), _key$split$map4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_key$split$map3, 2), _start = _key$split$map4[0], _end = _key$split$map4[1];
            coordinates.push(_start, _end);
        }
    // Sort coordinates
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    var sortedCoords = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set(coordinates)).sort(function(a, b) {
        return a - b;
    });
    var totalHeight = 0;
    // Check each segment between consecutive coordinates
    for(var i = 0; i < sortedCoords.length; i++){
        var y1 = sortedCoords[i];
        var y2 = sortedCoords[i + 1];
        // Check if this segment is covered by any active interval
        var covered = false;
        var _iterator4 = $58aa6d68b2041300$var$_createForOfIteratorHelper(intervals), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _step4$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step4.value, 2), key = _step4$value[0], count = _step4$value[1];
                if (count <= 0) continue;
                var _key$split$map = key.split(',').map(Number), _key$split$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_key$split$map, 2), start = _key$split$map2[0], end = _key$split$map2[1];
                if (start <= y1 && end >= y2) {
                    covered = true;
                    break;
                }
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        if (covered) totalHeight += y2 - y1;
    }
    return totalHeight;
}, [
    'vc'
]);
var $58aa6d68b2041300$var$updateActiveIntervals = (0, $7bV0v.withProfiling)(function updateActiveIntervals(intervals, event) {
    var key = "".concat(event.top, ",").concat(event.bottom);
    if (event.type === 'start') intervals.set(key, (intervals.get(key) || 0) + 1);
    else {
        var count = intervals.get(key) || 0;
        if (count > 1) intervals.set(key, count - 1);
        else intervals.delete(key);
    }
}, [
    'vc'
]);

});



parcelRegister("heRTv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8cd8cc3ce61b0bb$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
var $c8cd8cc3ce61b0bb$var$getViewportHeight = (0, $7bV0v.withProfiling)(function getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}, [
    'vc'
]);
var $c8cd8cc3ce61b0bb$export$2e2bcd8739ae039 = $c8cd8cc3ce61b0bb$var$getViewportHeight;

});

parcelRegister("26GzF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $188d2aac9ccb24f6$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
var $188d2aac9ccb24f6$var$getViewportWidth = (0, $7bV0v.withProfiling)(function getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}, [
    'vc'
]);
var $188d2aac9ccb24f6$export$2e2bcd8739ae039 = $188d2aac9ccb24f6$var$getViewportWidth;

});



parcelRegister("gxakF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c097be347758e830$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $7bV0v = parcelRequire("7bV0v");

var $9lRp1 = parcelRequire("9lRp1");

var $dqsxj = parcelRequire("dqsxj");

var $3MYp5 = parcelRequire("3MYp5");

var $OzVEY = parcelRequire("OzVEY");

var $iZpgm = parcelRequire("iZpgm");
function $c097be347758e830$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c097be347758e830$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c097be347758e830$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c097be347758e830$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c097be347758e830$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c097be347758e830$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c097be347758e830$var$isElementVisible = (0, $7bV0v.withProfiling)(function isElementVisible(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-expect-error
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (e) {
        // there is no support for checkVisibility
        return true;
    }
}, [
    'vc'
]);
var $c097be347758e830$var$sameRectSize = (0, $7bV0v.withProfiling)(function sameRectSize(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height;
}, [
    'vc'
]);
var $c097be347758e830$var$sameRectDimensions = (0, $7bV0v.withProfiling)(function sameRectDimensions(a, b) {
    if (!a || !b) return false;
    return a.width === b.width && a.height === b.height && a.x === b.x && a.y === b.y;
}, [
    'vc'
]);
var $c097be347758e830$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ViewportObserver(_ref) {
        var _this = this;
        var _onChange = _ref.onChange;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ViewportObserver);
        var onChange = (0, $7bV0v.withProfiling)(_onChange, [
            'vc'
        ]);
        var operationTimer = (0, $7bV0v.markProfilingStart)('ViewportObserver constructor');
        this.mapVisibleNodeRects = new WeakMap();
        this.intersectionObserver = (0, $3MYp5.createIntersectionObserver)({
            onEntry: function onEntry(_ref2) {
                var target = _ref2.target, rect = _ref2.rect, time = _ref2.time, type = _ref2.type, mutationData = _ref2.mutationData;
                if (!target) return;
                var visible = $c097be347758e830$var$isElementVisible(target);
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                _this.mapVisibleNodeRects.set(target, rect);
                onChange({
                    time: time,
                    type: type,
                    elementRef: new WeakRef(target),
                    visible: visible,
                    rect: rect,
                    previousRect: lastElementRect,
                    mutationData: mutationData
                });
            }
        });
        this.mutationObserver = (0, $OzVEY.default)({
            onChildListMutation: function onChildListMutation(_ref3) {
                var _removedNodes$map;
                var addedNodes = _ref3.addedNodes, removedNodes = _ref3.removedNodes;
                var removedNodeRects = (_removedNodes$map = removedNodes === null || removedNodes === void 0 ? void 0 : removedNodes.map(function(n) {
                    return _this.mapVisibleNodeRects.get(n);
                })) !== null && _removedNodes$map !== void 0 ? _removedNodes$map : [];
                addedNodes.forEach(function(addedNode) {
                    var _this$intersectionObs3;
                    // for (const elem of addedNode.querySelectorAll('*')) {
                    // 	this.intersectionObserver?.watchAndTag(elem, 'mutation:child-element');
                    // }
                    var sameDeletedNode = removedNodes.find(function(n) {
                        return n.isEqualNode(addedNode);
                    });
                    if (sameDeletedNode) {
                        var _this$intersectionObs;
                        (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, 'mutation:remount');
                        return;
                    }
                    if ((0, $9lRp1.isContainedWithinMediaWrapper)(addedNode)) {
                        var _this$intersectionObs2;
                        (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(addedNode, 'mutation:media');
                        return;
                    }
                    (_this$intersectionObs3 = _this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.watchAndTag(addedNode, function(_ref4) {
                        var rect = _ref4.rect;
                        var wasDeleted = removedNodeRects.some(function(nr) {
                            return $c097be347758e830$var$sameRectDimensions(nr, rect);
                        });
                        if (wasDeleted) return 'mutation:element-replacement';
                        return 'mutation:element';
                    });
                });
            },
            onAttributeMutation: function onAttributeMutation(_ref5) {
                var _this$intersectionObs4;
                var target = _ref5.target, attributeName = _ref5.attributeName;
                (_this$intersectionObs4 = _this.intersectionObserver) === null || _this$intersectionObs4 === void 0 || _this$intersectionObs4.watchAndTag(target, function(_ref6) {
                    var target = _ref6.target, rect = _ref6.rect;
                    if ((0, $9lRp1.isContainedWithinMediaWrapper)(target)) return {
                        type: 'mutation:media',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    if ((0, $dqsxj.default)({
                        target: target,
                        attributeName: attributeName,
                        type: 'attributes'
                    })) return {
                        type: 'mutation:attribute:non-visual-style',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    var lastElementRect = _this.mapVisibleNodeRects.get(target);
                    if (lastElementRect && $c097be347758e830$var$sameRectSize(rect, lastElementRect)) return {
                        type: 'mutation:attribute:no-layout-shift',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                    return {
                        type: 'mutation:attribute',
                        mutationData: {
                            attributeName: attributeName
                        }
                    };
                });
            }
        });
        this.performanceObserver = (0, $iZpgm.default)({
            onLayoutShift: function onLayoutShift(_ref7) {
                var time = _ref7.time, changedRects = _ref7.changedRects;
                var _iterator = $c097be347758e830$var$_createForOfIteratorHelper(changedRects), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var changedRect = _step.value;
                        var target = changedRect.node;
                        if (target) onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: 'layout-shift'
                        });
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $7bV0v.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer, {
            tags: [
                'vc'
            ]
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ViewportObserver, [
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: 'layout-shift',
                    buffered: true,
                    // @ts-ignore-error
                    durationThreshold: 30
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs5, _this$performanceObse2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs5 = this.intersectionObserver) === null || _this$intersectionObs5 === void 0 || _this$intersectionObs5.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
            }
        }
    ]);
}();

});
parcelRegister("3MYp5", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", function () { return $2c24b5b6c01077b6$export$c3799d33e0ae80a5; });

var $7bV0v = parcelRequire("7bV0v");
var $2c24b5b6c01077b6$var$isValidEntry = (0, $7bV0v.withProfiling)(function isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}, [
    'vc'
]);
function $2c24b5b6c01077b6$export$c3799d33e0ae80a5(args) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var onEntry = (0, $7bV0v.withProfiling)(args.onEntry, [
        'vc'
    ]);
    var onObserved = typeof args.onObserved === 'function' ? (0, $7bV0v.withProfiling)(args.onObserved, [
        'vc'
    ]) : undefined;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = (0, $7bV0v.withProfiling)(function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement) || !$2c24b5b6c01077b6$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if (typeof tagOrCallback === 'function') {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = 'unknown';
                else if (typeof tagOrCallbackResult === 'string') mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === 'string') mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : 'unknown',
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    });
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: (0, $7bV0v.withProfiling)(function disconnect() {
            observer.disconnect();
        }, [
            'vc'
        ]),
        unobserve: (0, $7bV0v.withProfiling)(function unobserve(target) {
            observer.unobserve(target);
        }, [
            'vc'
        ]),
        watchAndTag: (0, $7bV0v.withProfiling)(function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }, [
            'vc'
        ])
    };
}

});

parcelRegister("OzVEY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09808a60687cfbb0$export$2e2bcd8739ae039; });

var $i2LcI = parcelRequire("i2LcI");

var $7bV0v = parcelRequire("7bV0v");
function $09808a60687cfbb0$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $09808a60687cfbb0$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $09808a60687cfbb0$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $09808a60687cfbb0$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $09808a60687cfbb0$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $09808a60687cfbb0$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $09808a60687cfbb0$var$createMutationObserver = (0, $7bV0v.withProfiling)(function createMutationObserver(props) {
    if (!window || typeof window.IntersectionObserver !== 'function') return null;
    var onAttributeMutation = (0, $7bV0v.withProfiling)(props.onAttributeMutation, [
        'vc'
    ]);
    var onChildListMutation = (0, $7bV0v.withProfiling)(props.onChildListMutation, [
        'vc'
    ]);
    var onMutationFinished = typeof props.onMutationFinished === 'function' ? (0, $7bV0v.withProfiling)(props.onMutationFinished, [
        'vc'
    ]) : undefined;
    var mutationObserverCallback = (0, $7bV0v.withProfiling)(function mutationObserverCallback(mutations) {
        var addedNodes = [];
        var removedNodes = [];
        var targets = [];
        var _iterator = $09808a60687cfbb0$var$_createForOfIteratorHelper(mutations), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) continue;
                if (mut.type === 'attributes') {
                    if ((0, $i2LcI.fg)('platform_ufo_vc_ignore_same_value_mutation')) {
                        var _mut$oldValue;
                        /*
            "MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            Conceptually there is after all a mutation: there is an old value replaced with a new one,
            and whether or not they are the same doesn't really matter.
            And Custom elements should work the same way as MutationObserver."
            https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                        var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                        if (oldValue !== newValue) {
                            var _mut$attributeName;
                            onAttributeMutation({
                                target: mut.target,
                                attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : 'unknown'
                            });
                        }
                    } else {
                        var _mut$attributeName2;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName2 = mut.attributeName) !== null && _mut$attributeName2 !== void 0 ? _mut$attributeName2 : 'unknown'
                        });
                    }
                    continue;
                } else if (mut.type === 'childList') {
                    var _mut$addedNodes, _mut$removedNodes;
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) addedNodes.push(node);
                    });
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) removedNodes.push(node);
                    });
                }
                targets.push(mut.target);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        onChildListMutation({
            addedNodes: addedNodes,
            removedNodes: removedNodes
        });
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    });
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}, [
    'vc'
]);
var $09808a60687cfbb0$export$2e2bcd8739ae039 = $09808a60687cfbb0$var$createMutationObserver;

});

parcelRegister("iZpgm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd318530a904afe1$export$2e2bcd8739ae039; });

var $7bV0v = parcelRequire("7bV0v");
function $dd318530a904afe1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $dd318530a904afe1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $dd318530a904afe1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dd318530a904afe1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dd318530a904afe1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dd318530a904afe1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $dd318530a904afe1$export$5e3f54cad8cb65e2 = (0, $7bV0v.withProfiling)(function convertPhysicalToLogicalResolution(rect) {
    if (typeof window.devicePixelRatio !== 'number') return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}, [
    'vc'
]);
var $dd318530a904afe1$var$createPerformanceObserver = (0, $7bV0v.withProfiling)(function createPerformanceObserver(args) {
    if (!window || typeof window.PerformanceObserver !== 'function') return null;
    var onLayoutShift = (0, $7bV0v.withProfiling)(args.onLayoutShift, [
        'vc'
    ]);
    var performanceObserverCallback = (0, $7bV0v.withProfiling)(function performanceObserverCallback(entries) {
        var _iterator = $dd318530a904afe1$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === 'layout-shift') {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $dd318530a904afe1$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $dd318530a904afe1$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, [
        'vc'
    ]);
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}, [
    'vc'
]);
var $dd318530a904afe1$export$2e2bcd8739ae039 = $dd318530a904afe1$var$createPerformanceObserver;

});


parcelRegister("2ZBxU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22de671dfc041ace$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $7bV0v = parcelRequire("7bV0v");
var $22de671dfc041ace$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, WindowEventObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbindFns", []);
        var operationTimer = (0, $7bV0v.markProfilingStart)('WindowEventObserver constructor');
        this.onEvent = (0, $7bV0v.withProfiling)(opts.onEvent, [
            'vc'
        ]);
        this.bindEvent = (0, $7bV0v.withProfiling)(this.bindEvent.bind(this), [
            'vc'
        ]);
        this.start = (0, $7bV0v.withProfiling)(this.start.bind(this), [
            'vc'
        ]);
        this.stop = (0, $7bV0v.withProfiling)(this.stop.bind(this), [
            'vc'
        ]);
        (0, $7bV0v.markProfilingEnd)(operationTimer);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $k6Bkl.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent('wheel');
                this.bindEvent('scroll');
                this.bindEvent('keydown');
                this.bindEvent('resize');
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("bT8qz", function(module, exports) {

$parcel$export(module.exports, "interactions", function () { return $8a7b5e4fe3fb7057$export$cc97b17ef9aeb088; });
var $8a7b5e4fe3fb7057$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("csWGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91359f589dae3d71$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $dyWhr = parcelRequire("dyWhr");

var $7bV0v = parcelRequire("7bV0v");

var $gXYFp = parcelRequire("gXYFp");
function $91359f589dae3d71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91359f589dae3d71$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91359f589dae3d71$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91359f589dae3d71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91359f589dae3d71$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $91359f589dae3d71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sinkHandlerFn", function() {});
        this.initializeVCObserver = (0, $7bV0v.withProfiling)(this.initializeVCObserver.bind(this));
        this.startVCObserver = (0, $7bV0v.withProfiling)(this.startVCObserver.bind(this));
        this.setVCObserverSSRConfig = (0, $7bV0v.withProfiling)(this.setVCObserverSSRConfig.bind(this));
        this.setLastInteractionFinishVCResult = (0, $7bV0v.withProfiling)(this.setLastInteractionFinishVCResult.bind(this));
        this.reset = (0, $7bV0v.withProfiling)(this.reset.bind(this));
        this.hasData = (0, $7bV0v.withProfiling)(this.hasData.bind(this));
        this.sendPostInteractionLog = (0, $7bV0v.withProfiling)(this.sendPostInteractionLog.bind(this));
        this.onInteractionComplete = (0, $7bV0v.withProfiling)(this.onInteractionComplete.bind(this));
        this.addProfilerTimings = (0, $7bV0v.withProfiling)(this.addProfilerTimings.bind(this));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $gXYFp.VCObserver)($91359f589dae3d71$var$_objectSpread($91359f589dae3d71$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var _this$vcObserver3, _getConfig2;
                    var _getConfig, _this$vcObserver2, postInteractionFinishVCResult, _this$vcObserver4;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                if ((_getConfig = (0, $dyWhr.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.experimentalInteractionMetrics) !== null && _getConfig !== void 0 && _getConfig.enabled) (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
                                return _context.abrupt("return");
                            case 4:
                                _context.next = 6;
                                return (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 ? void 0 : _this$vcObserver3.getVCResult($91359f589dae3d71$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: 'ufo'
                                }, this.vcObserverSSRConfig));
                            case 6:
                                postInteractionFinishVCResult = _context.sent;
                                if ((_getConfig2 = (0, $dyWhr.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.experimentalInteractionMetrics) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 || _this$vcObserver4.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                                });
                                this.reset();
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig3, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90
                };
                var timeout = ((_getConfig3 = (0, $dyWhr.getConfig)()) === null || _getConfig3 === void 0 ? void 0 : _getConfig3.timeWindowForLateMutationsInMilliseconds) || $91359f589dae3d71$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
}();

});


parcelRegister("d5QIn", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $9884a20e8cb3484c$export$896b6e121bbaec25; });

var $7f5qq = parcelRequire("7f5qq");

var $cF8Kw = parcelRequire("cF8Kw");

var $5msJs = parcelRequire("5msJs");

var $8x86A = parcelRequire("8x86A");

var $1XCKE = parcelRequire("1XCKE");

var $Bk1e4 = parcelRequire("Bk1e4");

var $gocvX = parcelRequire("gocvX");

var $e6ZnV = parcelRequire("e6ZnV");

var $9mkAi = parcelRequire("9mkAi");

var $cQNCx = parcelRequire("cQNCx");

var $kYbr3 = parcelRequire("kYbr3");

var $cpvBo = parcelRequire("cpvBo");

var $fhqC4 = parcelRequire("fhqC4");

var $5VPaW = parcelRequire("5VPaW");

var $cuNOM = parcelRequire("cuNOM");

var $77zOH = parcelRequire("77zOH");

var $4JYIi = parcelRequire("4JYIi");

var $bP9ZI = parcelRequire("bP9ZI");

var $2DojN = parcelRequire("2DojN");

var $ftaQE = parcelRequire("ftaQE");

var $i66wZ = parcelRequire("i66wZ");

var $cAwKl = parcelRequire("cAwKl");

var $eAI62 = parcelRequire("eAI62");

var $ga3Hy = parcelRequire("ga3Hy");

var $53L6N = parcelRequire("53L6N");

var $cAixy = parcelRequire("cAixy");

var $9mw2J = parcelRequire("9mw2J");

var $jBB3H = parcelRequire("jBB3H");

var $fSse0 = parcelRequire("fSse0");

var $1kXKB = parcelRequire("1kXKB");

var $5Yry2 = parcelRequire("5Yry2");

var $172aY = parcelRequire("172aY");

var $7irdm = parcelRequire("7irdm");

var $3a6EI = parcelRequire("3a6EI");

var $gFYoT = parcelRequire("gFYoT");

var $kL8Kz = parcelRequire("kL8Kz");

var $kXHg1 = parcelRequire("kXHg1");

var $e7t4r = parcelRequire("e7t4r");

var $i1AZl = parcelRequire("i1AZl");

var $3GjBI = parcelRequire("3GjBI");
function $9884a20e8cb3484c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9884a20e8cb3484c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9884a20e8cb3484c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9884a20e8cb3484c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9884a20e8cb3484c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9884a20e8cb3484c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9884a20e8cb3484c$var$defaultSet = [
    (0, $fhqC4.eventKey),
    (0, $bP9ZI.eventType),
    (0, $cuNOM.eventProduct),
    (0, $4JYIi.eventRoute),
    (0, $kYbr3.eventId),
    (0, $5VPaW.eventLocalTime),
    (0, $77zOH.eventRegion),
    (0, $gocvX.appFramework),
    (0, $e6ZnV.appVersion),
    (0, $9mkAi.bmVersion),
    (0, $7irdm.telemetryBrowser),
    (0, $3a6EI.telemetryCpu),
    (0, $gFYoT.telemetryMemory),
    (0, $kL8Kz.telemetryNetwork),
    (0, $cQNCx.customData),
    (0, $2DojN.featureFlags),
    (0, $ftaQE.hostname),
    (0, $1kXKB.productCustomData),
    (0, $kXHg1.appTimings),
    (0, $i1AZl.resourceTimings)
];
var $9884a20e8cb3484c$var$pageLoadCommon = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $cpvBo.eventInitial),
    (0, $53L6N.pageLoadMetrics),
    (0, $e7t4r.bundleEvalTimings)
]);
var $9884a20e8cb3484c$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))($9884a20e8cb3484c$var$pageLoadCommon), [
    (0, $cAwKl.initialPageLoadMetrics),
    (0, $ga3Hy.navigationMetrics),
    (0, $172aY.ssrSuccess),
    (0, $5Yry2.ssrFeatureFlags)
]);
var $9884a20e8cb3484c$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))($9884a20e8cb3484c$var$pageLoadCommon);
var $9884a20e8cb3484c$var$pageSegmentLoadSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $cAixy.pageSegmentLoadMetrics),
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $cpvBo.eventInitial),
    (0, $e7t4r.bundleEvalTimings)
]);
var $9884a20e8cb3484c$var$interactionSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $eAI62.interactionMetrics)
]);
var $9884a20e8cb3484c$var$customMetricSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $i66wZ.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $9884a20e8cb3484c$var$webVitalsMetricSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $9mw2J.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $9884a20e8cb3484c$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8x86A.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $9884a20e8cb3484c$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $1XCKE.logger).log("eventDataProcessor: Metric \"".concat(data.key, "\" start or stop are incorrect; start: ").concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && (0, $Bk1e4.isPageLoadMetricData)(data) && data.isInitial) set = $9884a20e8cb3484c$var$initialPageLoadSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && (0, $Bk1e4.isPageLoadMetricData)(data) && !data.isInitial) set = $9884a20e8cb3484c$var$spaTransitionSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD && (0, $Bk1e4.isPageSegmentLoadMetricData)(data)) set = $9884a20e8cb3484c$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).INLINE_RESULT) set = $9884a20e8cb3484c$var$interactionSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).CUSTOM) set = $9884a20e8cb3484c$var$customMetricSet;
                    if (!(data.config.type === (0, $3GjBI.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $9884a20e8cb3484c$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $9884a20e8cb3484c$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $9884a20e8cb3484c$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("Bk1e4", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $0702fc20896e96af$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $0702fc20896e96af$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $0702fc20896e96af$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $0702fc20896e96af$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $0702fc20896e96af$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $0702fc20896e96af$export$b493eb8b2ba87421; });

var $3GjBI = parcelRequire("3GjBI");
var $0702fc20896e96af$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_LOAD;
};
var $0702fc20896e96af$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $0702fc20896e96af$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_LOAD;
};
var $0702fc20896e96af$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $0702fc20896e96af$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).INLINE_RESULT;
};
var $0702fc20896e96af$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).CUSTOM;
};

});

parcelRegister("gocvX", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $bee8985109d261b2$export$e34e4529b979f74c; });
var $bee8985109d261b2$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        'app:framework:name': globalConfig.app.framework.name,
        'app:framework:version': globalConfig.app.framework.version
    };
};

});

parcelRegister("e6ZnV", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $a4613e0023f30ae3$export$82ae485178b37419; });
var $a4613e0023f30ae3$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        'app:web:version': globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData['app:ssr:version'] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("9mkAi", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $6d0622c3d2edc540$export$5cafa465fc876895; });
var $6d0622c3d2edc540$export$5cafa465fc876895 = function bmVersion() {
    return {
        'bm:version': 3
    };
};

});

parcelRegister("cQNCx", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $95b0d4ff8c73e7be$export$f7e743c7db162193; });

var $kg5sN = parcelRequire("kg5sN");
var $95b0d4ff8c73e7be$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("kYbr3", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $f4424813674ac020$export$aed28df7ac07d79a; });
var $f4424813674ac020$export$aed28df7ac07d79a = function eventId(config) {
    return {
        'event:id': config.key
    };
};

});

parcelRegister("cpvBo", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $909055616d5c162b$export$fa8e91d436b3ef8b; });

var $Bk1e4 = parcelRequire("Bk1e4");
var $909055616d5c162b$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $Bk1e4.isPageLoadMetricData)(data) && !(0, $Bk1e4.isPageSegmentLoadMetricData)(data)) return null;
    return {
        'event:initial': data.isInitial
    };
};

});

parcelRegister("fhqC4", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $b1fd1658296089dc$export$10be2d3a558d3f88; });

var $7WJZg = parcelRequire("7WJZg");
var $b1fd1658296089dc$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        'event:key': "".concat(globalConfig.product, ".fe.").concat((0, $7WJZg.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("7WJZg", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $5c919f46408fbf93$export$b334d07f11140768; });

var $3GjBI = parcelRequire("3GjBI");
var $5c919f46408fbf93$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $3GjBI.BMEventsType).CUSTOM:
            return (0, $3GjBI.StorableBMEventsType).CUSTOM;
        case (0, $3GjBI.BMEventsType).INLINE_RESULT:
            return (0, $3GjBI.StorableBMEventsType).INLINE_RESULT;
        case (0, $3GjBI.BMEventsType).PAGE_LOAD:
            return (0, $3GjBI.StorableBMEventsType).PAGE_LOAD;
        case (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $3GjBI.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $3GjBI.BMEventsType).WEB_VITALS:
            return (0, $3GjBI.StorableBMEventsType).WEB_VITALS;
        default:
            return 'unknown';
    }
};

});


parcelRegister("5VPaW", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $4519f90490e347e5$export$5219854ae7ec45da; });

var $jCQKV = parcelRequire("jCQKV");
var $4519f90490e347e5$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        'event:localHour': parseInt((0, $jCQKV.default)(new Date(), 'H'), 10),
        'event:localDayOfWeek': parseInt((0, $jCQKV.default)(new Date(), 'i'), 10)
    };
};

});
parcelRegister("jCQKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e49a7d23cacbd9d4$export$2e2bcd8739ae039; });

var $lHYNI = parcelRequire("lHYNI");

var $aFEuq = parcelRequire("aFEuq");

var $eSxdi = parcelRequire("eSxdi");

var $fvbMt = parcelRequire("fvbMt");

var $8IH0c = parcelRequire("8IH0c");

var $2EOLL = parcelRequire("2EOLL");

var $eVjVQ = parcelRequire("eVjVQ");

var $cRwqP = parcelRequire("cRwqP");

var $kqhx7 = parcelRequire("kqhx7");

var $41GN3 = parcelRequire("41GN3");

var $3KblA = parcelRequire("3KblA");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e49a7d23cacbd9d4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e49a7d23cacbd9d4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e49a7d23cacbd9d4$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e49a7d23cacbd9d4$var$doubleQuoteRegExp = /''/g;
var $e49a7d23cacbd9d4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e49a7d23cacbd9d4$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $kqhx7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3KblA.default);
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $cRwqP.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $eSxdi.default)(dirtyDate);
    if (!(0, $lHYNI.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2EOLL.default)(originalDate);
    var utcDate = (0, $aFEuq.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e49a7d23cacbd9d4$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $8IH0c.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($e49a7d23cacbd9d4$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e49a7d23cacbd9d4$var$cleanEscapedString(substring);
        var formatter = (0, $fvbMt.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eVjVQ.isProtectedWeekYearToken)(substring)) (0, $eVjVQ.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eVjVQ.isProtectedDayOfYearToken)(substring)) (0, $eVjVQ.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e49a7d23cacbd9d4$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $e49a7d23cacbd9d4$var$cleanEscapedString(input) {
    var matched = input.match($e49a7d23cacbd9d4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e49a7d23cacbd9d4$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lHYNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcdcc6e37afa7610$export$2e2bcd8739ae039; });

var $86hYx = parcelRequire("86hYx");

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $fcdcc6e37afa7610$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    if (!(0, $86hYx.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $eSxdi.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("86hYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5cd3cd3dc03531$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $kqhx7 = parcelRequire("kqhx7");
function $5e5cd3cd3dc03531$export$2e2bcd8739ae039(value) {
    (0, $kqhx7.default)(1, arguments);
    return value instanceof Date || (0, $8p0zh.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

});


parcelRegister("aFEuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c4d2426c0031a92$export$2e2bcd8739ae039; });

var $i24z8 = parcelRequire("i24z8");

var $kqhx7 = parcelRequire("kqhx7");

var $cRwqP = parcelRequire("cRwqP");
function $7c4d2426c0031a92$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kqhx7.default)(2, arguments);
    var amount = (0, $cRwqP.default)(dirtyAmount);
    return (0, $i24z8.default)(dirtyDate, -amount);
}

});
parcelRegister("i24z8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d20bf48777e67bc0$export$2e2bcd8739ae039; });

var $cRwqP = parcelRequire("cRwqP");

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $d20bf48777e67bc0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kqhx7.default)(2, arguments);
    var timestamp = (0, $eSxdi.default)(dirtyDate).getTime();
    var amount = (0, $cRwqP.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("cRwqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d3978f89c2fdc8$export$2e2bcd8739ae039; });
function $95d3978f89c2fdc8$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("fvbMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b492e3b1fd13622b$export$2e2bcd8739ae039; });

var $8RAMF = parcelRequire("8RAMF");

var $gLgJI = parcelRequire("gLgJI");

var $44Mvq = parcelRequire("44Mvq");

var $lMhfJ = parcelRequire("lMhfJ");

var $guA3V = parcelRequire("guA3V");

var $90IUR = parcelRequire("90IUR");

var $9ERJW = parcelRequire("9ERJW");
var $b492e3b1fd13622b$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $b492e3b1fd13622b$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $9ERJW.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $guA3V.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $90IUR.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $90IUR.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $44Mvq.default)(date);
        // Padding
        return (0, $90IUR.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $90IUR.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $90IUR.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $90IUR.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $9ERJW.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $90IUR.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $lMhfJ.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $90IUR.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $gLgJI.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $90IUR.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $9ERJW.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $8RAMF.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $90IUR.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $90IUR.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $90IUR.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $90IUR.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $9ERJW.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $9ERJW.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $90IUR.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $90IUR.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $9ERJW.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $9ERJW.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $9ERJW.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $b492e3b1fd13622b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $b492e3b1fd13622b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $90IUR.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $90IUR.default)(timestamp, token.length);
    }
};
function $b492e3b1fd13622b$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $90IUR.default)(minutes, 2);
}
function $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $90IUR.default)(Math.abs(offset) / 60, 2);
    }
    return $b492e3b1fd13622b$var$formatTimezone(offset, dirtyDelimiter);
}
function $b492e3b1fd13622b$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $90IUR.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $90IUR.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $b492e3b1fd13622b$export$2e2bcd8739ae039 = $b492e3b1fd13622b$var$formatters;

});
parcelRegister("8RAMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673fce7af3bbd47a$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
var $673fce7af3bbd47a$var$MILLISECONDS_IN_DAY = 86400000;
function $673fce7af3bbd47a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $673fce7af3bbd47a$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("gLgJI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33e049a71cddf32$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $6vSLh = parcelRequire("6vSLh");

var $gzZin = parcelRequire("gzZin");

var $kqhx7 = parcelRequire("kqhx7");
var $c33e049a71cddf32$var$MILLISECONDS_IN_WEEK = 604800000;
function $c33e049a71cddf32$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var diff = (0, $6vSLh.default)(date).getTime() - (0, $gzZin.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c33e049a71cddf32$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6vSLh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be01ddbb0dd69c0$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $4be01ddbb0dd69c0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $eSxdi.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gzZin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11f763762953489$export$2e2bcd8739ae039; });

var $44Mvq = parcelRequire("44Mvq");

var $6vSLh = parcelRequire("6vSLh");

var $kqhx7 = parcelRequire("kqhx7");
function $c11f763762953489$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var year = (0, $44Mvq.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $6vSLh.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("44Mvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7d2963e879dde2$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $6vSLh = parcelRequire("6vSLh");
function $2f7d2963e879dde2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6vSLh.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6vSLh.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("lMhfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdab76b0d8931cb9$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $dRAqc = parcelRequire("dRAqc");

var $hhfjv = parcelRequire("hhfjv");

var $kqhx7 = parcelRequire("kqhx7");
var $fdab76b0d8931cb9$var$MILLISECONDS_IN_WEEK = 604800000;
function $fdab76b0d8931cb9$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var diff = (0, $dRAqc.default)(date, options).getTime() - (0, $hhfjv.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $fdab76b0d8931cb9$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("dRAqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17c7a2fcf864c1f$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $a17c7a2fcf864c1f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var weekStartsOn = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $eSxdi.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("41GN3", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $2ee872afb5943c02$export$430a3269e24b912e; });
var $2ee872afb5943c02$var$defaultOptions = {};
function $2ee872afb5943c02$export$430a3269e24b912e() {
    return $2ee872afb5943c02$var$defaultOptions;
}
function $2ee872afb5943c02$export$95365be1b0704abc(newOptions) {
    $2ee872afb5943c02$var$defaultOptions = newOptions;
}

});


parcelRegister("hhfjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93fe72e225a05ce$export$2e2bcd8739ae039; });

var $guA3V = parcelRequire("guA3V");

var $kqhx7 = parcelRequire("kqhx7");

var $dRAqc = parcelRequire("dRAqc");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $c93fe72e225a05ce$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $guA3V.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $dRAqc.default)(firstWeek, options);
    return date;
}

});
parcelRegister("guA3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01b6becc08f15d6$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $dRAqc = parcelRequire("dRAqc");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $c01b6becc08f15d6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dRAqc.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dRAqc.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("90IUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68f6f48c33db0e43$export$2e2bcd8739ae039; });
function $68f6f48c33db0e43$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

});

parcelRegister("9ERJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7081891fd2f86bb4$export$2e2bcd8739ae039; });

var $90IUR = parcelRequire("90IUR");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $7081891fd2f86bb4$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $90IUR.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $90IUR.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $90IUR.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $90IUR.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $90IUR.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $90IUR.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $90IUR.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $90IUR.default)(fractionalSeconds, token.length);
    }
};
var $7081891fd2f86bb4$export$2e2bcd8739ae039 = $7081891fd2f86bb4$var$formatters;

});


parcelRegister("8IH0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6593ca2313117d01$export$2e2bcd8739ae039; });
var $6593ca2313117d01$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $6593ca2313117d01$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $6593ca2313117d01$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $6593ca2313117d01$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $6593ca2313117d01$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $6593ca2313117d01$var$timeLongFormatter(timePattern, formatLong));
};
var $6593ca2313117d01$var$longFormatters = {
    p: $6593ca2313117d01$var$timeLongFormatter,
    P: $6593ca2313117d01$var$dateTimeLongFormatter
};
var $6593ca2313117d01$export$2e2bcd8739ae039 = $6593ca2313117d01$var$longFormatters;

});

parcelRegister("eVjVQ", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $add5d99cf63fde86$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $add5d99cf63fde86$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $add5d99cf63fde86$export$8073c1ae88f0e727; });
var $add5d99cf63fde86$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $add5d99cf63fde86$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $add5d99cf63fde86$export$c6cc36aa33304772(token) {
    return $add5d99cf63fde86$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $add5d99cf63fde86$export$c6b49d6dceb604a1(token) {
    return $add5d99cf63fde86$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $add5d99cf63fde86$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("3KblA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9e784a0f833d0f$export$2e2bcd8739ae039; });

var $fN68j = parcelRequire("fN68j");
var $2b9e784a0f833d0f$export$2e2bcd8739ae039 = (0, $fN68j.default);

});
parcelRegister("fN68j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f03086d92d856b$export$2e2bcd8739ae039; });

var $3Pwbo = parcelRequire("3Pwbo");

var $d6o4i = parcelRequire("d6o4i");

var $aiDY0 = parcelRequire("aiDY0");

var $2pcC1 = parcelRequire("2pcC1");

var $1RRm6 = parcelRequire("1RRm6");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b7f03086d92d856b$var$locale = {
    code: 'en-US',
    formatDistance: (0, $3Pwbo.default),
    formatLong: (0, $d6o4i.default),
    formatRelative: (0, $aiDY0.default),
    localize: (0, $2pcC1.default),
    match: (0, $1RRm6.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b7f03086d92d856b$export$2e2bcd8739ae039 = $b7f03086d92d856b$var$locale;

});
parcelRegister("3Pwbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c9f1956570a4633$export$2e2bcd8739ae039; });
var $2c9f1956570a4633$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $2c9f1956570a4633$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2c9f1956570a4633$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $2c9f1956570a4633$export$2e2bcd8739ae039 = $2c9f1956570a4633$var$formatDistance;

});

parcelRegister("d6o4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $989e8162eb89b61a$export$2e2bcd8739ae039; });

var $dYzKH = parcelRequire("dYzKH");
var $989e8162eb89b61a$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $989e8162eb89b61a$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $989e8162eb89b61a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $989e8162eb89b61a$var$formatLong = {
    date: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $989e8162eb89b61a$export$2e2bcd8739ae039 = $989e8162eb89b61a$var$formatLong;

});
parcelRegister("dYzKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2cc9c9d2a0ad66c$export$2e2bcd8739ae039; });
function $a2cc9c9d2a0ad66c$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("aiDY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77fa9661b36ee9ee$export$2e2bcd8739ae039; });
var $77fa9661b36ee9ee$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $77fa9661b36ee9ee$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $77fa9661b36ee9ee$var$formatRelativeLocale[token];
};
var $77fa9661b36ee9ee$export$2e2bcd8739ae039 = $77fa9661b36ee9ee$var$formatRelative;

});

parcelRegister("2pcC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c07b31eca56cbac$export$2e2bcd8739ae039; });

var $67K3N = parcelRequire("67K3N");
var $1c07b31eca56cbac$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $1c07b31eca56cbac$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1c07b31eca56cbac$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $1c07b31eca56cbac$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $1c07b31eca56cbac$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $1c07b31eca56cbac$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $1c07b31eca56cbac$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $1c07b31eca56cbac$var$localize = {
    ordinalNumber: $1c07b31eca56cbac$var$ordinalNumber,
    era: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1c07b31eca56cbac$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1c07b31eca56cbac$export$2e2bcd8739ae039 = $1c07b31eca56cbac$var$localize;

});
parcelRegister("67K3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4757201ae6eb393b$export$2e2bcd8739ae039; });
function $4757201ae6eb393b$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("1RRm6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c420fbf03d303f$export$2e2bcd8739ae039; });

var $iPUN3 = parcelRequire("iPUN3");

var $gLBHn = parcelRequire("gLBHn");
var $15c420fbf03d303f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $15c420fbf03d303f$var$parseOrdinalNumberPattern = /\d+/i;
var $15c420fbf03d303f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $15c420fbf03d303f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $15c420fbf03d303f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $15c420fbf03d303f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $15c420fbf03d303f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $15c420fbf03d303f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $15c420fbf03d303f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $15c420fbf03d303f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $15c420fbf03d303f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $15c420fbf03d303f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $15c420fbf03d303f$var$match = {
    ordinalNumber: (0, $gLBHn.default)({
        matchPattern: $15c420fbf03d303f$var$matchOrdinalNumberPattern,
        parsePattern: $15c420fbf03d303f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15c420fbf03d303f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15c420fbf03d303f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15c420fbf03d303f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $15c420fbf03d303f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $15c420fbf03d303f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $15c420fbf03d303f$export$2e2bcd8739ae039 = $15c420fbf03d303f$var$match;

});
parcelRegister("iPUN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db690abe2489105d$export$2e2bcd8739ae039; });
function $db690abe2489105d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $db690abe2489105d$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $db690abe2489105d$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $db690abe2489105d$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $db690abe2489105d$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("gLBHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c34e4745ab4f0a1a$export$2e2bcd8739ae039; });
function $c34e4745ab4f0a1a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("cuNOM", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $918eee2e0119c8be$export$a7df4e8088db8843; });
var $918eee2e0119c8be$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        'event:product': "".concat(globalConfig.product)
    };
};

});

parcelRegister("77zOH", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $52f4f8543a6ce682$export$d0117b71adcdebc0; });
var $52f4f8543a6ce682$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        'event:region': "".concat(globalConfig.region)
    };
};

});

parcelRegister("4JYIi", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $373a75d784d6cb11$export$44d3627af289ca16; });
var $373a75d784d6cb11$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        'event:route': data.route
    };
};

});

parcelRegister("bP9ZI", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $89bc35d05e24abe7$export$4c045e605d532c98; });

var $7WJZg = parcelRequire("7WJZg");
var $89bc35d05e24abe7$export$4c045e605d532c98 = function eventType(config) {
    return {
        'event:type': (0, $7WJZg.mapEventType)(config.type)
    };
};

});

parcelRegister("2DojN", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $1eb2166ae740bf43$export$e62953d023125748; });

var $6bkHe = parcelRequire("6bkHe");
function $1eb2166ae740bf43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eb2166ae740bf43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eb2166ae740bf43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eb2166ae740bf43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1eb2166ae740bf43$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $1eb2166ae740bf43$var$_objectSpread($1eb2166ae740bf43$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("ftaQE", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $b431faad2a1f11e2$export$640106f6dc7d2706; });
var $b431faad2a1f11e2$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("i66wZ", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $d2cdda7518611ae3$export$cab039265c52a2e9; });

var $Bk1e4 = parcelRequire("Bk1e4");
var $d2cdda7518611ae3$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $Bk1e4.isCustomConfig)(config)) return null;
    var payload = {
        'metric:duration': Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload['metric:duration:slo'] = payload['metric:duration'] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload['metric:duration:slo:threshold'] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload['metric:duration:histogramBuckets'] = config.histogram.duration;
    else if (globalConfig.histogram) payload['metric:duration:histogramBuckets'] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("cAwKl", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $92a23f97decfbace$export$cc95aa3f6ea8e5cb; });
var $92a23f97decfbace$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType('paint').forEach(function(entry) {
        if (entry.name === 'first-paint') metrics['metric:fp'] = Math.round(entry.startTime);
        if (entry.name === 'first-contentful-paint') metrics['metric:fcp'] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("eAI62", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $a9f6a21a2eddddc5$export$86db56030b57ba34; });

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $a9f6a21a2eddddc5$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $Bk1e4.isInteractionConfig)(config)) return null;
    var result = {
        'metric:result': Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result['metric:result:histogramBuckets'] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result['metric:result:histogramBuckets'] = histogram[(0, $3GjBI.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $3GjBI.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result['metric:result:slo'] = result['metric:result'] <= config.slo.result.threshold;
        result['metric:result:slo:threshold'] = config.slo.result.threshold;
    }
    if (data.marks['feedback']) {
        var _config$histogram2;
        result['metric:response'] = Math.round((data.marks['feedback'] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result['metric:response:histogramBuckets'] = config.histogram[(0, $3GjBI.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result['metric:response:histogramBuckets'] = _histogram[(0, $3GjBI.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $3GjBI.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result['metric:response:slo'] = result['metric:response'] <= config.slo.response.threshold;
            result['metric:response:slo:threshold'] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("ga3Hy", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $bc4073919ce4d01e$export$b88d990436be0f8a; });
var $bc4073919ce4d01e$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType('navigation');
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        'metrics:navigation': metrics
    };
};

});

parcelRegister("53L6N", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $3af1c659a6659c41$export$2878bf482e539059; });

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $3af1c659a6659c41$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $3GjBI.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $3af1c659a6659c41$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $3af1c659a6659c41$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $Bk1e4.isPageLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page load data for non-page-load config');
    var fmp = data.marks[(0, $3GjBI.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $3af1c659a6659c41$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $3af1c659a6659c41$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    return result;
};

});

parcelRegister("cAixy", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $92973a8a109c40cb$export$ba86cb47f2f22db5; });

var $5EyB3 = parcelRequire("5EyB3");

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $92973a8a109c40cb$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $3GjBI.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $92973a8a109c40cb$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $92973a8a109c40cb$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $Bk1e4.isPageSegmentLoadConfig)(config)) throw new Error('Browser Metrics: cannot gather page segment load data for non-page-segment-load config');
    var fmp = data.marks[(0, $3GjBI.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        'metric:fmp': Math.round(fmp - data.start),
        'metric:tti': Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result['metric:fmp:histogramBuckets'] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result['metric:tti:histogramBuckets'] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result['metric:fmp:histogramBuckets'] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).fmp, histogram);
        result['metric:tti:histogramBuckets'] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $92973a8a109c40cb$var$getThreshold(data.isInitial, config.slo.fmp);
        result['metric:fmp:slo'] = result['metric:fmp'] <= threshold;
        result['metric:fmp:slo:threshold'] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $92973a8a109c40cb$var$getThreshold(data.isInitial, config.slo.tti);
        result['metric:tti:slo'] = result['metric:tti'] <= _threshold;
        result['metric:tti:slo:threshold'] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $3GjBI.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $3GjBI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $3GjBI.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result['pageLoad'] = {
            fmp: _fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("9mw2J", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $6d0f06325a18bb7d$export$3731db279f590f30; });

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $k6Eo3 = parcelRequire("k6Eo3");

var $a3buC = parcelRequire("a3buC");

var $djDSg = parcelRequire("djDSg");

var $fSse0 = parcelRequire("fSse0");
function $6d0f06325a18bb7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d0f06325a18bb7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d0f06325a18bb7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d0f06325a18bb7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6d0f06325a18bb7d$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $k6Eo3.PageVisibleState).MIXED;
                    };
                    (0, $a3buC.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $6d0f06325a18bb7d$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $a3buC.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $6d0f06325a18bb7d$var$_objectSpread($6d0f06325a18bb7d$var$_objectSpread({}, webVitalMetrics), {}, {
                        'pageVisible:state': pageVisibleState
                    }, (0, $fSse0.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $6d0f06325a18bb7d$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $djDSg.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $djDSg.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $djDSg.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("fSse0", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $b8f1cb066af754a0$export$177b923114656380; });

var $k6Eo3 = parcelRequire("k6Eo3");
var $3GjBI = parcelRequire("3GjBI");
var $b8f1cb066af754a0$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $3GjBI.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $k6Eo3.PageVisibleState).VISIBLE;
    return {
        'pageVisible:value': value
    };
};

});


parcelRegister("jBB3H", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $e45e3815f7cb532e$export$723b4c298aca63af; });
var $e45e3815f7cb532e$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        'pageVisible:state': data.pageVisibleState
    };
};

});

parcelRegister("1kXKB", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $0f9601ea9205a8bb$export$fa2af6e412815a74; });

var $kg5sN = parcelRequire("kg5sN");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");
var $0f9601ea9205a8bb$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("5Yry2", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $4597ecd358795bbd$export$fdbea518c19dfa8; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $3GjBI = parcelRequire("3GjBI");
var $4597ecd358795bbd$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        'ssr:featureFlags': featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $4597ecd358795bbd$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $4597ecd358795bbd$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("172aY", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $0cf821fe9da0d88c$export$a3dc8251cf55b2e0; });
var $0cf821fe9da0d88c$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        'ssr:success': true
    };
    return null;
};

});

parcelRegister("7irdm", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $54ff531318b206d9$export$386b10ac64a50b1; });

var $aP7bp = parcelRequire("aP7bp");
var $54ff531318b206d9$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($aP7bp))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($aP7bp))).getParser(window.navigator.userAgent);
    return {
        'telemetry:browser:name': browser.getBrowserName(),
        'telemetry:browser:version': browser.getBrowserVersion()
    };
};

});
parcelRegister("aP7bp", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("3a6EI", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $24d777f06af76a24$export$9f84cb359ed29139; });
var $24d777f06af76a24$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        'telemetry:cpus': navigator.hardwareConcurrency
    };
};

});

parcelRegister("gFYoT", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $c23f53f4c1304807$export$496c14d72b257e07; });
var $c23f53f4c1304807$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        'telemetry:memory': navigator.deviceMemory
    };
};

});

parcelRegister("kL8Kz", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $f1cefc0b3edf133d$export$88bf7b55f7fc4e8e; });
var $f1cefc0b3edf133d$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:effectiveType': navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:rtt': navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'telemetry:network:downlink': navigator.connection.downlink
    };
};

});

parcelRegister("kXHg1", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $f42adf5ac7f68b0b$export$e952f50a4f2d02da; });

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $dxnjK = parcelRequire("dxnjK");

var $47XSr = parcelRequire("47XSr");
function $f42adf5ac7f68b0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f42adf5ac7f68b0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f42adf5ac7f68b0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f42adf5ac7f68b0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f42adf5ac7f68b0b$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $dxnjK.customTimings)(config, data);
    var ssr = config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $47XSr.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $f42adf5ac7f68b0b$var$_objectSpread($f42adf5ac7f68b0b$var$_objectSpread($f42adf5ac7f68b0b$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        'timings:app': timingsApp
    };
};

});
parcelRegister("dxnjK", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $9db071d23450f8d8$export$6126f85083a72c6e; });

var $X0Yhh = parcelRequire("X0Yhh");
var $9db071d23450f8d8$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $9db071d23450f8d8$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $9db071d23450f8d8$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $9db071d23450f8d8$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $X0Yhh.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("X0Yhh", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $0b1643aac1c9ebdb$export$b98e411ae80c806f; });
var $0b1643aac1c9ebdb$export$b98e411ae80c806f = '/';

});


parcelRegister("47XSr", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $3016433789c0aa1c$export$130f411261a599c5; });

var $cd8Dz = parcelRequire("cd8Dz");

var $X0Yhh = parcelRequire("X0Yhh");
var $3016433789c0aa1c$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
};
var $3016433789c0aa1c$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $3016433789c0aa1c$var$SSR_PREFIX = 'ssr';
var $3016433789c0aa1c$var$mapKey = function mapKey(key) {
    if (key === 'total') return $3016433789c0aa1c$var$SSR_PREFIX;
    return "".concat($3016433789c0aa1c$var$SSR_PREFIX).concat((0, $X0Yhh.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $3016433789c0aa1c$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($3016433789c0aa1c$var$filterEntry(entry[1])) acc[$3016433789c0aa1c$var$mapKey(entry[0])] = $3016433789c0aa1c$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("e7t4r", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $a47844fa2c3096c4$export$1a2bb347935fc536; });

var $kg5sN = parcelRequire("kg5sN");
var $a47844fa2c3096c4$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType('mark').forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        'timings:bundleEval': timings
    };
};
var $a47844fa2c3096c4$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($a47844fa2c3096c4$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("i1AZl", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $d1f503255d80ddd9$export$81a7d52441a06b50; });

var $6bkHe = parcelRequire("6bkHe");
function $d1f503255d80ddd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1f503255d80ddd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1f503255d80ddd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1f503255d80ddd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d1f503255d80ddd9$var$cacheableTypes = [
    'script',
    'link'
];
var $d1f503255d80ddd9$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $d1f503255d80ddd9$var$CACHE_NETWORK = 'network';
var $d1f503255d80ddd9$var$CACHE_MEMORY = 'memory';
var $d1f503255d80ddd9$var$CACHE_DISK = 'disk';
var $d1f503255d80ddd9$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$d1f503255d80ddd9$var$cacheableTypes.includes(type)) return $d1f503255d80ddd9$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $d1f503255d80ddd9$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $d1f503255d80ddd9$var$CACHE_DISK;
    if (size === undefined) return null;
    return $d1f503255d80ddd9$var$CACHE_NETWORK;
};
var $d1f503255d80ddd9$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$d1f503255d80ddd9$var$cacheableTypes.includes(type) || url.includes('localhost') || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $d1f503255d80ddd9$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        'script',
        'link',
        'fetch',
        'xmlhttprequest'
    ];
    return [
        'script',
        'link',
        'fetch'
    ];
};
var $d1f503255d80ddd9$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $d1f503255d80ddd9$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $d1f503255d80ddd9$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $d1f503255d80ddd9$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes('localhost') || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $d1f503255d80ddd9$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $d1f503255d80ddd9$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $d1f503255d80ddd9$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $d1f503255d80ddd9$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$d1f503255d80ddd9$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($d1f503255d80ddd9$var$cacheableTypes.includes(type)) {
        var transferType = $d1f503255d80ddd9$var$calculateTransferType(type, duration, size);
        if (!transferType) return $d1f503255d80ddd9$var$_objectSpread({
            ttfb: ttfb
        }, $d1f503255d80ddd9$var$getSizeObject(size));
        if (transferType !== $d1f503255d80ddd9$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $d1f503255d80ddd9$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $d1f503255d80ddd9$var$getSizeObject(size));
    }
    return $d1f503255d80ddd9$var$_objectSpread({
        ttfb: ttfb
    }, $d1f503255d80ddd9$var$getSizeObject(size));
};
var $d1f503255d80ddd9$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType('resource').filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $d1f503255d80ddd9$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $d1f503255d80ddd9$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $d1f503255d80ddd9$var$_objectSpread($d1f503255d80ddd9$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $d1f503255d80ddd9$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $d1f503255d80ddd9$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        'timings:resource': resourceTiming
    };
};

});


parcelRegister("6Uhl4", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $50756c323b5a667d$export$5b4fb14409a2a825; });

var $7f5qq = parcelRequire("7f5qq");

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $5msJs = parcelRequire("5msJs");

var $3GjBI = parcelRequire("3GjBI");
function $50756c323b5a667d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50756c323b5a667d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50756c323b5a667d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50756c323b5a667d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50756c323b5a667d$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $50756c323b5a667d$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $50756c323b5a667d$var$_objectSpread($50756c323b5a667d$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $3GjBI.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($50756c323b5a667d$var$_objectSpread($50756c323b5a667d$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($50756c323b5a667d$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $50756c323b5a667d$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $3GjBI.BMEventsType).PAGE_LOAD, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).PAGE_LOAD])), (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD])), (0, $3GjBI.BMEventsType).INLINE_RESULT, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).INLINE_RESULT])), (0, $3GjBI.BMEventsType).CUSTOM, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).CUSTOM])), (0, $3GjBI.BMEventsType).WEB_VITALS, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS])));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});



parcelRegister("gyRZh", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", function () { return $c0e9b31393d77828$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "createBrowserRouter", function () { return $c0e9b31393d77828$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "RouterProvider", function () { return $c0e9b31393d77828$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Link", function () { return $c0e9b31393d77828$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $c0e9b31393d77828$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("5WDNl")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("5WDNl")).useNavigate; });
/**
 * React Router DOM v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $i7SlW = parcelRequire("i7SlW");parcelRequire("5WDNl");
var $i7SlW = parcelRequire("i7SlW");
var $5WDNl = parcelRequire("5WDNl");

var $i7SlW = parcelRequire("i7SlW");
function $c0e9b31393d77828$var$_extends() {
    $c0e9b31393d77828$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0e9b31393d77828$var$_extends.apply(this, arguments);
}
function $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c0e9b31393d77828$var$defaultMethod = "get";
const $c0e9b31393d77828$var$defaultEncType = "application/x-www-form-urlencoded";
function $c0e9b31393d77828$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c0e9b31393d77828$var$isButtonElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c0e9b31393d77828$var$isFormElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c0e9b31393d77828$var$isInputElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c0e9b31393d77828$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c0e9b31393d77828$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c0e9b31393d77828$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c0e9b31393d77828$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c0e9b31393d77828$var$_formDataSupportsSubmitter = null;
function $c0e9b31393d77828$var$isFormDataSubmitterSupported() {
    if ($c0e9b31393d77828$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c0e9b31393d77828$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c0e9b31393d77828$var$_formDataSupportsSubmitter = true;
    }
    return $c0e9b31393d77828$var$_formDataSupportsSubmitter;
}
const $c0e9b31393d77828$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c0e9b31393d77828$var$getFormEncType(encType) {
    if (encType != null && !$c0e9b31393d77828$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c0e9b31393d77828$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c0e9b31393d77828$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $i7SlW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $c0e9b31393d77828$var$defaultMethod;
        encType = $c0e9b31393d77828$var$getFormEncType(target.getAttribute("enctype")) || $c0e9b31393d77828$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c0e9b31393d77828$var$isButtonElement(target) || $c0e9b31393d77828$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $i7SlW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c0e9b31393d77828$var$defaultMethod;
        encType = $c0e9b31393d77828$var$getFormEncType(target.getAttribute("formenctype")) || $c0e9b31393d77828$var$getFormEncType(form.getAttribute("enctype")) || $c0e9b31393d77828$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c0e9b31393d77828$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c0e9b31393d77828$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c0e9b31393d77828$var$defaultMethod;
        action = null;
        encType = $c0e9b31393d77828$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c0e9b31393d77828$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $c0e9b31393d77828$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $c0e9b31393d77828$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c0e9b31393d77828$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c0e9b31393d77828$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c0e9b31393d77828$export$1f3f55432a00e06d(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c0e9b31393d77828$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c0e9b31393d77828$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5WDNl.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c0e9b31393d77828$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c0e9b31393d77828$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c0e9b31393d77828$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5WDNl.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c0e9b31393d77828$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c0e9b31393d77828$var$_extends({}, state, {
        errors: $c0e9b31393d77828$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c0e9b31393d77828$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $i7SlW.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c0e9b31393d77828$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8ZuGG.createContext({
    isTransitioning: false
});
const $c0e9b31393d77828$export$148fd98d095596d4 = /*#__PURE__*/ $8ZuGG.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c0e9b31393d77828$var$START_TRANSITION = "startTransition";
const $c0e9b31393d77828$var$startTransitionImpl = $8ZuGG[$c0e9b31393d77828$var$START_TRANSITION];
const $c0e9b31393d77828$var$FLUSH_SYNC = "flushSync";
const $c0e9b31393d77828$var$flushSyncImpl = $h1d60[$c0e9b31393d77828$var$FLUSH_SYNC];
const $c0e9b31393d77828$var$USE_ID = "useId";
const $c0e9b31393d77828$var$useIdImpl = $8ZuGG[$c0e9b31393d77828$var$USE_ID];
function $c0e9b31393d77828$var$startTransitionSafe(cb) {
    if ($c0e9b31393d77828$var$startTransitionImpl) $c0e9b31393d77828$var$startTransitionImpl(cb);
    else cb();
}
function $c0e9b31393d77828$var$flushSyncSafe(cb) {
    if ($c0e9b31393d77828$var$flushSyncImpl) $c0e9b31393d77828$var$flushSyncImpl(cb);
    else cb();
}
class $c0e9b31393d77828$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c0e9b31393d77828$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8ZuGG.useState(router.state);
    let [pendingState, setPendingState] = $8ZuGG.useState();
    let [vtContext, setVtContext] = $8ZuGG.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8ZuGG.useState();
    let [transition, setTransition] = $8ZuGG.useState();
    let [interruption, setInterruption] = $8ZuGG.useState();
    let fetcherData = $8ZuGG.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8ZuGG.useCallback((cb)=>{
        if (v7_startTransition) $c0e9b31393d77828$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8ZuGG.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c0e9b31393d77828$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c0e9b31393d77828$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c0e9b31393d77828$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c0e9b31393d77828$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c0e9b31393d77828$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8ZuGG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8ZuGG.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c0e9b31393d77828$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8ZuGG.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8ZuGG.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8ZuGG.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8ZuGG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8ZuGG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8ZuGG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8ZuGG.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $8ZuGG.useEffect(()=>(0, $5WDNl.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c0e9b31393d77828$var$MemoizedDataRoutes = /*#__PURE__*/ $8ZuGG.memo($c0e9b31393d77828$var$DataRoutes);
function $c0e9b31393d77828$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5WDNl.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c0e9b31393d77828$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8ZuGG.useEffect(()=>(0, $5WDNl.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c0e9b31393d77828$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8ZuGG.useEffect(()=>(0, $5WDNl.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c0e9b31393d77828$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8ZuGG.useEffect(()=>(0, $5WDNl.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c0e9b31393d77828$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c0e9b31393d77828$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c0e9b31393d77828$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8ZuGG.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref7, $c0e9b31393d77828$var$_excluded);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c0e9b31393d77828$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c0e9b31393d77828$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $i7SlW.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5WDNl.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $c0e9b31393d77828$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8ZuGG.createElement("a", $c0e9b31393d77828$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c0e9b31393d77828$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8ZuGG.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref8, $c0e9b31393d77828$var$_excluded2);
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $5WDNl.useLocation)();
    let routerState = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c0e9b31393d77828$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $i7SlW.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$a6c7ac8248d6e38a, $c0e9b31393d77828$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c0e9b31393d77828$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8ZuGG.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c0e9b31393d77828$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref9, $c0e9b31393d77828$var$_excluded3);
    let submit = $c0e9b31393d77828$export$47c85c6e3a081d3();
    let formAction = $c0e9b31393d77828$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $8ZuGG.createElement("form", $c0e9b31393d77828$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c0e9b31393d77828$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c0e9b31393d77828$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c0e9b31393d77828$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c0e9b31393d77828$var$DataRouterHook || ($c0e9b31393d77828$var$DataRouterHook = {}));
var $c0e9b31393d77828$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c0e9b31393d77828$var$DataRouterStateHook || ($c0e9b31393d77828$var$DataRouterStateHook = {}));
// Internal hooks
function $c0e9b31393d77828$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $c0e9b31393d77828$var$useDataRouterContext(hookName) {
    let ctx = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterContext));
    !ctx && (0, $i7SlW.UNSAFE_invariant)(false);
    return ctx;
}
function $c0e9b31393d77828$var$useDataRouterState(hookName) {
    let state = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterStateContext));
    !state && (0, $i7SlW.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c0e9b31393d77828$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5WDNl.useNavigate)();
    let location = (0, $5WDNl.useLocation)();
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: relative
    });
    return $8ZuGG.useCallback((event)=>{
        if ($c0e9b31393d77828$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $i7SlW.createPath)(location) === (0, $i7SlW.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c0e9b31393d77828$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8ZuGG.useRef($c0e9b31393d77828$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8ZuGG.useRef(false);
    let location = (0, $5WDNl.useLocation)();
    let searchParams = $8ZuGG.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c0e9b31393d77828$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5WDNl.useNavigate)();
    let setSearchParams = $8ZuGG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c0e9b31393d77828$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c0e9b31393d77828$var$fetcherId = 0;
let $c0e9b31393d77828$var$getUniqueFetcherId = ()=>"__" + String(++$c0e9b31393d77828$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c0e9b31393d77828$export$47c85c6e3a081d3() {
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let currentRouteId = (0, $5WDNl.UNSAFE_useRouteId)();
    return $8ZuGG.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c0e9b31393d77828$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c0e9b31393d77828$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c0e9b31393d77828$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c0e9b31393d77828$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let routeContext = $8ZuGG.useContext((0, $5WDNl.UNSAFE_RouteContext));
    !routeContext && (0, $i7SlW.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c0e9b31393d77828$var$_extends({}, (0, $5WDNl.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5WDNl.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $i7SlW.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c0e9b31393d77828$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseFetcher);
    let state = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8ZuGG.useContext($c0e9b31393d77828$export$148fd98d095596d4);
    let route = $8ZuGG.useContext((0, $5WDNl.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $i7SlW.UNSAFE_invariant)(false);
    !route && (0, $i7SlW.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $i7SlW.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c0e9b31393d77828$var$useIdImpl ? $c0e9b31393d77828$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8ZuGG.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c0e9b31393d77828$var$getUniqueFetcherId());
    // Registration/cleanup
    $8ZuGG.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8ZuGG.useCallback((href, opts)=>{
        !routeId && (0, $i7SlW.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c0e9b31393d77828$export$47c85c6e3a081d3();
    let submit = $8ZuGG.useCallback((target, opts)=>{
        submitImpl(target, $c0e9b31393d77828$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8ZuGG.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8ZuGG.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$a7fed597f4b8afd8, $c0e9b31393d77828$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $i7SlW.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8ZuGG.useMemo(()=>$c0e9b31393d77828$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c0e9b31393d77828$export$fa996778a3a31087() {
    let state = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c0e9b31393d77828$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c0e9b31393d77828$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c0e9b31393d77828$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let location = (0, $5WDNl.useLocation)();
    let matches = (0, $5WDNl.useMatches)();
    let navigation = (0, $5WDNl.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $8ZuGG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c0e9b31393d77828$var$usePageHide($8ZuGG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c0e9b31393d77828$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c0e9b31393d77828$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c0e9b31393d77828$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c0e9b31393d77828$var$_extends({}, location, {
                    pathname: (0, $i7SlW.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c0e9b31393d77828$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c0e9b31393d77828$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8ZuGG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c0e9b31393d77828$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8ZuGG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c0e9b31393d77828$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5WDNl.useBlocker)(when);
    $8ZuGG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8ZuGG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c0e9b31393d77828$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8ZuGG.useContext($c0e9b31393d77828$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $i7SlW.UNSAFE_invariant)(false);
    let { basename: basename } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $i7SlW.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $i7SlW.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $i7SlW.matchPath)(path.pathname, nextPath) != null || (0, $i7SlW.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("i7SlW", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $d3230ad07d4608b8$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $d3230ad07d4608b8$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $d3230ad07d4608b8$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $d3230ad07d4608b8$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $d3230ad07d4608b8$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $d3230ad07d4608b8$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $d3230ad07d4608b8$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $d3230ad07d4608b8$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $d3230ad07d4608b8$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $d3230ad07d4608b8$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $d3230ad07d4608b8$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $d3230ad07d4608b8$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $d3230ad07d4608b8$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $d3230ad07d4608b8$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $d3230ad07d4608b8$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $d3230ad07d4608b8$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $d3230ad07d4608b8$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $d3230ad07d4608b8$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $d3230ad07d4608b8$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $d3230ad07d4608b8$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $d3230ad07d4608b8$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d3230ad07d4608b8$var$_extends() {
    $d3230ad07d4608b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3230ad07d4608b8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d3230ad07d4608b8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d3230ad07d4608b8$export$e19cd5f9376f8cee || ($d3230ad07d4608b8$export$e19cd5f9376f8cee = {}));
const $d3230ad07d4608b8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d3230ad07d4608b8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d3230ad07d4608b8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d3230ad07d4608b8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d3230ad07d4608b8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d3230ad07d4608b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
    }
    return $d3230ad07d4608b8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d3230ad07d4608b8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d3230ad07d4608b8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d3230ad07d4608b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d3230ad07d4608b8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d3230ad07d4608b8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d3230ad07d4608b8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d3230ad07d4608b8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d3230ad07d4608b8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d3230ad07d4608b8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d3230ad07d4608b8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d3230ad07d4608b8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d3230ad07d4608b8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d3230ad07d4608b8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d3230ad07d4608b8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d3230ad07d4608b8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        let location = $d3230ad07d4608b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d3230ad07d4608b8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        let location = $d3230ad07d4608b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d3230ad07d4608b8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $d3230ad07d4608b8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d3230ad07d4608b8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d3230ad07d4608b8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d3230ad07d4608b8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d3230ad07d4608b8$var$ResultType || ($d3230ad07d4608b8$var$ResultType = {}));
const $d3230ad07d4608b8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d3230ad07d4608b8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d3230ad07d4608b8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d3230ad07d4608b8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d3230ad07d4608b8$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($d3230ad07d4608b8$var$isIndexRoute(route)) {
            let indexRoute = $d3230ad07d4608b8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d3230ad07d4608b8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d3230ad07d4608b8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $d3230ad07d4608b8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $d3230ad07d4608b8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $d3230ad07d4608b8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d3230ad07d4608b8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d3230ad07d4608b8$var$flattenRoutes(routes);
    $d3230ad07d4608b8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $d3230ad07d4608b8$export$30d21fd6d7295f52(pathname);
        matches = $d3230ad07d4608b8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $d3230ad07d4608b8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d3230ad07d4608b8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d3230ad07d4608b8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $d3230ad07d4608b8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d3230ad07d4608b8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d3230ad07d4608b8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d3230ad07d4608b8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d3230ad07d4608b8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d3230ad07d4608b8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d3230ad07d4608b8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d3230ad07d4608b8$var$paramRe = /^:[\w-]+$/;
const $d3230ad07d4608b8$var$dynamicSegmentValue = 3;
const $d3230ad07d4608b8$var$indexRouteValue = 2;
const $d3230ad07d4608b8$var$emptySegmentValue = 1;
const $d3230ad07d4608b8$var$staticSegmentValue = 10;
const $d3230ad07d4608b8$var$splatPenalty = -2;
const $d3230ad07d4608b8$var$isSplat = (s)=>s === "*";
function $d3230ad07d4608b8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d3230ad07d4608b8$var$isSplat)) initialScore += $d3230ad07d4608b8$var$splatPenalty;
    if (index) initialScore += $d3230ad07d4608b8$var$indexRouteValue;
    return segments.filter((s)=>!$d3230ad07d4608b8$var$isSplat(s)).reduce((score, segment)=>score + ($d3230ad07d4608b8$var$paramRe.test(segment) ? $d3230ad07d4608b8$var$dynamicSegmentValue : segment === "" ? $d3230ad07d4608b8$var$emptySegmentValue : $d3230ad07d4608b8$var$staticSegmentValue), initialScore);
}
function $d3230ad07d4608b8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d3230ad07d4608b8$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d3230ad07d4608b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d3230ad07d4608b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d3230ad07d4608b8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d3230ad07d4608b8$export$a5c6d149b50c1d86($d3230ad07d4608b8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d3230ad07d4608b8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $d3230ad07d4608b8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d3230ad07d4608b8$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $d3230ad07d4608b8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d3230ad07d4608b8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d3230ad07d4608b8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d3230ad07d4608b8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d3230ad07d4608b8$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $d3230ad07d4608b8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d3230ad07d4608b8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d3230ad07d4608b8$var$normalizeSearch(search),
        hash: $d3230ad07d4608b8$var$normalizeHash(hash)
    };
}
function $d3230ad07d4608b8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d3230ad07d4608b8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d3230ad07d4608b8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d3230ad07d4608b8$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $d3230ad07d4608b8$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d3230ad07d4608b8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d3230ad07d4608b8$var$_extends({}, toArg);
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d3230ad07d4608b8$var$getInvalidPathError("?", "pathname", "search", to));
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d3230ad07d4608b8$var$getInvalidPathError("#", "pathname", "hash", to));
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d3230ad07d4608b8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d3230ad07d4608b8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d3230ad07d4608b8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d3230ad07d4608b8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d3230ad07d4608b8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d3230ad07d4608b8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $d3230ad07d4608b8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d3230ad07d4608b8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d3230ad07d4608b8$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $d3230ad07d4608b8$export$4051a07651545597(data, init) {
    return new $d3230ad07d4608b8$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $d3230ad07d4608b8$export$42a99a7a4bc0e76a extends Error {
}
class $d3230ad07d4608b8$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d3230ad07d4608b8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d3230ad07d4608b8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d3230ad07d4608b8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d3230ad07d4608b8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d3230ad07d4608b8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $d3230ad07d4608b8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d3230ad07d4608b8$var$unwrapTrackedPromise(value) {
    if (!$d3230ad07d4608b8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $d3230ad07d4608b8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d3230ad07d4608b8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d3230ad07d4608b8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d3230ad07d4608b8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d3230ad07d4608b8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d3230ad07d4608b8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d3230ad07d4608b8$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $d3230ad07d4608b8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d3230ad07d4608b8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d3230ad07d4608b8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d3230ad07d4608b8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d3230ad07d4608b8$var$validMutationMethods = new Set($d3230ad07d4608b8$var$validMutationMethodsArr);
const $d3230ad07d4608b8$var$validRequestMethodsArr = [
    "get",
    ...$d3230ad07d4608b8$var$validMutationMethodsArr
];
const $d3230ad07d4608b8$var$validRequestMethods = new Set($d3230ad07d4608b8$var$validRequestMethodsArr);
const $d3230ad07d4608b8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d3230ad07d4608b8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d3230ad07d4608b8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d3230ad07d4608b8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d3230ad07d4608b8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d3230ad07d4608b8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d3230ad07d4608b8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d3230ad07d4608b8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d3230ad07d4608b8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $d3230ad07d4608b8$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $d3230ad07d4608b8$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$d3230ad07d4608b8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$d3230ad07d4608b8$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d3230ad07d4608b8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $d3230ad07d4608b8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d3230ad07d4608b8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d3230ad07d4608b8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d3230ad07d4608b8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d3230ad07d4608b8$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d3230ad07d4608b8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d3230ad07d4608b8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d3230ad07d4608b8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d3230ad07d4608b8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d3230ad07d4608b8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d3230ad07d4608b8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d3230ad07d4608b8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d3230ad07d4608b8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d3230ad07d4608b8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d3230ad07d4608b8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d3230ad07d4608b8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d3230ad07d4608b8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d3230ad07d4608b8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d3230ad07d4608b8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $d3230ad07d4608b8$var$findNearestBoundary(matches).route.id,
            {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d3230ad07d4608b8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d3230ad07d4608b8$var$isErrorResult(result) && $d3230ad07d4608b8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d3230ad07d4608b8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $d3230ad07d4608b8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d3230ad07d4608b8$var$_extends({
            matches: updatedMatches || matches
        }, $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d3230ad07d4608b8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $d3230ad07d4608b8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $d3230ad07d4608b8$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $d3230ad07d4608b8$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $d3230ad07d4608b8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $d3230ad07d4608b8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d3230ad07d4608b8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d3230ad07d4608b8$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($d3230ad07d4608b8$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $d3230ad07d4608b8$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d3230ad07d4608b8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d3230ad07d4608b8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d3230ad07d4608b8$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $d3230ad07d4608b8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $d3230ad07d4608b8$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d3230ad07d4608b8$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d3230ad07d4608b8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d3230ad07d4608b8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d3230ad07d4608b8$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d3230ad07d4608b8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $d3230ad07d4608b8$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($d3230ad07d4608b8$var$isRedirectResult(actionResult) || $d3230ad07d4608b8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($d3230ad07d4608b8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d3230ad07d4608b8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($d3230ad07d4608b8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($d3230ad07d4608b8$var$isDeferredResult(actionResult)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d3230ad07d4608b8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d3230ad07d4608b8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d3230ad07d4608b8$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $d3230ad07d4608b8$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d3230ad07d4608b8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d3230ad07d4608b8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $d3230ad07d4608b8$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) result = await $d3230ad07d4608b8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d3230ad07d4608b8$export$3e9cee6b33872309(!$d3230ad07d4608b8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $d3230ad07d4608b8$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $d3230ad07d4608b8$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $d3230ad07d4608b8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d3230ad07d4608b8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace : $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d3230ad07d4608b8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d3230ad07d4608b8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $d3230ad07d4608b8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d3230ad07d4608b8$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d3230ad07d4608b8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $d3230ad07d4608b8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $d3230ad07d4608b8$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($d3230ad07d4608b8$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $d3230ad07d4608b8$var$ResultType.redirect,
                response: $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $d3230ad07d4608b8$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $d3230ad07d4608b8$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $d3230ad07d4608b8$var$ResultType.error,
                    error: $d3230ad07d4608b8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $d3230ad07d4608b8$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $d3230ad07d4608b8$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $d3230ad07d4608b8$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d3230ad07d4608b8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d3230ad07d4608b8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d3230ad07d4608b8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d3230ad07d4608b8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d3230ad07d4608b8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d3230ad07d4608b8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d3230ad07d4608b8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d3230ad07d4608b8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d3230ad07d4608b8$export$4d0306f8f6a4585b = Symbol("deferred");
function $d3230ad07d4608b8$export$3336b097a6fbc59a(routes, opts) {
    $d3230ad07d4608b8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d3230ad07d4608b8$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $d3230ad07d4608b8$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d3230ad07d4608b8$var$createLocation("", $d3230ad07d4608b8$export$fe53371bee54353d(url), null, "default");
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d3230ad07d4608b8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($d3230ad07d4608b8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d3230ad07d4608b8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d3230ad07d4608b8$var$createLocation("", $d3230ad07d4608b8$export$fe53371bee54353d(url), null, "default");
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d3230ad07d4608b8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d3230ad07d4608b8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d3230ad07d4608b8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d3230ad07d4608b8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($d3230ad07d4608b8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d3230ad07d4608b8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $d3230ad07d4608b8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d3230ad07d4608b8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d3230ad07d4608b8$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $d3230ad07d4608b8$var$isResponse(result) ? result : $d3230ad07d4608b8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($d3230ad07d4608b8$var$isDataStrategyResult(e) && $d3230ad07d4608b8$var$isResponse(e.result)) {
                if (e.type === $d3230ad07d4608b8$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d3230ad07d4608b8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d3230ad07d4608b8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d3230ad07d4608b8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $d3230ad07d4608b8$var$_extends({}, context, {
                statusCode: $d3230ad07d4608b8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $d3230ad07d4608b8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $d3230ad07d4608b8$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d3230ad07d4608b8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d3230ad07d4608b8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $d3230ad07d4608b8$var$callDataStrategyImpl(dataStrategy || $d3230ad07d4608b8$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($d3230ad07d4608b8$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($d3230ad07d4608b8$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $d3230ad07d4608b8$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d3230ad07d4608b8$export$fec11da027c70692(routes, context, error) {
    let newContext = $d3230ad07d4608b8$var$_extends({}, context, {
        statusCode: $d3230ad07d4608b8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $d3230ad07d4608b8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d3230ad07d4608b8$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d3230ad07d4608b8$export$cae722b0cc860f13(to ? to : ".", $d3230ad07d4608b8$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $d3230ad07d4608b8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $d3230ad07d4608b8$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d3230ad07d4608b8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d3230ad07d4608b8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d3230ad07d4608b8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d3230ad07d4608b8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d3230ad07d4608b8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d3230ad07d4608b8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d3230ad07d4608b8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d3230ad07d4608b8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d3230ad07d4608b8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d3230ad07d4608b8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d3230ad07d4608b8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d3230ad07d4608b8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d3230ad07d4608b8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d3230ad07d4608b8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d3230ad07d4608b8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d3230ad07d4608b8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $d3230ad07d4608b8$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $d3230ad07d4608b8$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($d3230ad07d4608b8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d3230ad07d4608b8$var$shouldRevalidateLoader(match, $d3230ad07d4608b8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d3230ad07d4608b8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d3230ad07d4608b8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d3230ad07d4608b8$var$shouldRevalidateLoader(fetcherMatch, $d3230ad07d4608b8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d3230ad07d4608b8$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $d3230ad07d4608b8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d3230ad07d4608b8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d3230ad07d4608b8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $d3230ad07d4608b8$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$d3230ad07d4608b8$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $d3230ad07d4608b8$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$d3230ad07d4608b8$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d3230ad07d4608b8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d3230ad07d4608b8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d3230ad07d4608b8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$d3230ad07d4608b8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d3230ad07d4608b8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $d3230ad07d4608b8$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $d3230ad07d4608b8$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $d3230ad07d4608b8$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $d3230ad07d4608b8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $d3230ad07d4608b8$var$ResultType.data,
                result: undefined
            });
        };
        return $d3230ad07d4608b8$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $d3230ad07d4608b8$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d3230ad07d4608b8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d3230ad07d4608b8$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d3230ad07d4608b8$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d3230ad07d4608b8$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($d3230ad07d4608b8$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: e
            };
        }
        if (type === $d3230ad07d4608b8$var$ResultType.error) return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: new $d3230ad07d4608b8$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $d3230ad07d4608b8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $d3230ad07d4608b8$var$ResultType.error) {
        if ($d3230ad07d4608b8$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $d3230ad07d4608b8$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: new $d3230ad07d4608b8$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $d3230ad07d4608b8$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: result,
            statusCode: $d3230ad07d4608b8$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($d3230ad07d4608b8$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $d3230ad07d4608b8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($d3230ad07d4608b8$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $d3230ad07d4608b8$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $d3230ad07d4608b8$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $d3230ad07d4608b8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d3230ad07d4608b8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $d3230ad07d4608b8$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $d3230ad07d4608b8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d3230ad07d4608b8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d3230ad07d4608b8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d3230ad07d4608b8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d3230ad07d4608b8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d3230ad07d4608b8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $d3230ad07d4608b8$export$3e9cee6b33872309(!$d3230ad07d4608b8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d3230ad07d4608b8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($d3230ad07d4608b8$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d3230ad07d4608b8$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $d3230ad07d4608b8$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d3230ad07d4608b8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d3230ad07d4608b8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d3230ad07d4608b8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d3230ad07d4608b8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d3230ad07d4608b8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d3230ad07d4608b8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d3230ad07d4608b8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d3230ad07d4608b8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d3230ad07d4608b8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d3230ad07d4608b8$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $d3230ad07d4608b8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d3230ad07d4608b8$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $d3230ad07d4608b8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(path) : path;
    return $d3230ad07d4608b8$export$fe53371bee54353d($d3230ad07d4608b8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d3230ad07d4608b8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d3230ad07d4608b8$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $d3230ad07d4608b8$var$ResultType.data || result.type === $d3230ad07d4608b8$var$ResultType.error);
}
function $d3230ad07d4608b8$var$isRedirectDataStrategyResultResult(result) {
    return $d3230ad07d4608b8$var$isResponse(result.result) && $d3230ad07d4608b8$var$redirectStatusCodes.has(result.result.status);
}
function $d3230ad07d4608b8$var$isDeferredResult(result) {
    return result.type === $d3230ad07d4608b8$var$ResultType.deferred;
}
function $d3230ad07d4608b8$var$isErrorResult(result) {
    return result.type === $d3230ad07d4608b8$var$ResultType.error;
}
function $d3230ad07d4608b8$var$isRedirectResult(result) {
    return (result && result.type) === $d3230ad07d4608b8$var$ResultType.redirect;
}
function $d3230ad07d4608b8$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d3230ad07d4608b8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d3230ad07d4608b8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d3230ad07d4608b8$var$isRedirectResponse(result) {
    if (!$d3230ad07d4608b8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d3230ad07d4608b8$var$isValidMethod(method) {
    return $d3230ad07d4608b8$var$validRequestMethods.has(method.toLowerCase());
}
function $d3230ad07d4608b8$var$isMutationMethod(method) {
    return $d3230ad07d4608b8$var$validMutationMethods.has(method.toLowerCase());
}
async function $d3230ad07d4608b8$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d3230ad07d4608b8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d3230ad07d4608b8$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $d3230ad07d4608b8$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $d3230ad07d4608b8$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $d3230ad07d4608b8$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $d3230ad07d4608b8$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $d3230ad07d4608b8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d3230ad07d4608b8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d3230ad07d4608b8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d3230ad07d4608b8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d3230ad07d4608b8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d3230ad07d4608b8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d3230ad07d4608b8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d3230ad07d4608b8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d3230ad07d4608b8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d3230ad07d4608b8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d3230ad07d4608b8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d3230ad07d4608b8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d3230ad07d4608b8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d3230ad07d4608b8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d3230ad07d4608b8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d3230ad07d4608b8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("5WDNl", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $45413cf8903a2186$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $45413cf8903a2186$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $45413cf8903a2186$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $45413cf8903a2186$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $45413cf8903a2186$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $45413cf8903a2186$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $45413cf8903a2186$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $45413cf8903a2186$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $45413cf8903a2186$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "useRouteError", function () { return $45413cf8903a2186$export$ed527bf60f6e05f2; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $45413cf8903a2186$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $45413cf8903a2186$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $45413cf8903a2186$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useLoaderData", function () { return $45413cf8903a2186$export$1448a5050d252c4d; });
$parcel$export(module.exports, "useBlocker", function () { return $45413cf8903a2186$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $45413cf8903a2186$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $45413cf8903a2186$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $45413cf8903a2186$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $45413cf8903a2186$export$910ae8079b2c2852; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $45413cf8903a2186$export$52b333d321859367; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return (parcelRequire("i7SlW")).isRouteErrorResponse; });
/**
 * React Router v6.29.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $i7SlW = parcelRequire("i7SlW");
function $45413cf8903a2186$var$_extends() {
    $45413cf8903a2186$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45413cf8903a2186$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $45413cf8903a2186$export$3add0d5dce533e2e = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$145dfa71566a64dc = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$var$AwaitContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $45413cf8903a2186$export$26749e8557646306 = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$c7914228fb69b0f5 = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$9072aa6dd1f93057 = /*#__PURE__*/ $8ZuGG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $45413cf8903a2186$var$RouteErrorContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $45413cf8903a2186$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $45413cf8903a2186$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $45413cf8903a2186$export$9c954a9d03d32f4a() {
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $45413cf8903a2186$export$45d76561a5302f2b() {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $45413cf8903a2186$export$1b3f31771c5d07c() {
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $45413cf8903a2186$export$6c330e8992e8a295(pattern) {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { pathname: pathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    return $8ZuGG.useMemo(()=>(0, $i7SlW.matchPath)(pattern, (0, $i7SlW.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $45413cf8903a2186$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $45413cf8903a2186$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8ZuGG.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $45413cf8903a2186$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $45413cf8903a2186$var$useNavigateStable() : $45413cf8903a2186$var$useNavigateUnstable();
}
function $45413cf8903a2186$var$useNavigateUnstable() {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let dataRouterContext = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $8ZuGG.useRef(false);
    $45413cf8903a2186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8ZuGG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $i7SlW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $45413cf8903a2186$var$OutletContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $45413cf8903a2186$export$4138103a3ae699cc() {
    return $8ZuGG.useContext($45413cf8903a2186$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $45413cf8903a2186$export$a3be3530d8e40d0b(context) {
    let outlet = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $45413cf8903a2186$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $45413cf8903a2186$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $8ZuGG.useMemo(()=>(0, $i7SlW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $45413cf8903a2186$export$5d3fca4a98652595(routes, locationArg) {
    return $45413cf8903a2186$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $45413cf8903a2186$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { navigator: navigator, static: isStatic } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: parentMatches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $45413cf8903a2186$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $i7SlW.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $i7SlW.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $i7SlW.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $45413cf8903a2186$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $i7SlW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $i7SlW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $45413cf8903a2186$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $i7SlW.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $45413cf8903a2186$var$DefaultErrorComponent() {
    let error = $45413cf8903a2186$export$ed527bf60f6e05f2();
    let message = (0, $i7SlW.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8ZuGG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8ZuGG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $45413cf8903a2186$var$defaultErrorElement = /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$DefaultErrorComponent, null);
class $45413cf8903a2186$var$RenderErrorBoundary extends $8ZuGG.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $45413cf8903a2186$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $45413cf8903a2186$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $i7SlW.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $45413cf8903a2186$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $45413cf8903a2186$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8ZuGG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $45413cf8903a2186$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($45413cf8903a2186$var$DataRouterHook || {});
var $45413cf8903a2186$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($45413cf8903a2186$var$DataRouterStateHook || {});
function $45413cf8903a2186$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $45413cf8903a2186$var$useDataRouterContext(hookName) {
    let ctx = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    !ctx && (0, $i7SlW.UNSAFE_invariant)(false);
    return ctx;
}
function $45413cf8903a2186$var$useDataRouterState(hookName) {
    let state = $8ZuGG.useContext($45413cf8903a2186$export$145dfa71566a64dc);
    !state && (0, $i7SlW.UNSAFE_invariant)(false);
    return state;
}
function $45413cf8903a2186$var$useRouteContext(hookName) {
    let route = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    !route && (0, $i7SlW.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $45413cf8903a2186$var$useCurrentRouteId(hookName) {
    let route = $45413cf8903a2186$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $i7SlW.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $45413cf8903a2186$export$5fc8298006ad9e58() {
    return $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $45413cf8903a2186$export$d0fd4b7106de2769() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $45413cf8903a2186$export$600dc272ed516c15() {
    let dataRouterContext = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseRevalidator);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRevalidator);
    return $8ZuGG.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $45413cf8903a2186$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseMatches);
    return $8ZuGG.useMemo(()=>matches.map((m)=>(0, $i7SlW.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $45413cf8903a2186$export$1448a5050d252c4d() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $45413cf8903a2186$export$fd5d37484eab868d(routeId) {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $45413cf8903a2186$export$fdc00f3f26066d5e() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseActionData);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $45413cf8903a2186$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8ZuGG.useContext($45413cf8903a2186$var$RouteErrorContext);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRouteError);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $45413cf8903a2186$export$78a72ddb39bdd145() {
    let value = $8ZuGG.useContext($45413cf8903a2186$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $45413cf8903a2186$export$17f53340677d5831() {
    let value = $8ZuGG.useContext($45413cf8903a2186$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $45413cf8903a2186$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $45413cf8903a2186$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseBlocker);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8ZuGG.useState("");
    let blockerFunction = $8ZuGG.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $45413cf8903a2186$var$_extends({}, currentLocation, {
                pathname: (0, $i7SlW.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $45413cf8903a2186$var$_extends({}, nextLocation, {
                pathname: (0, $i7SlW.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8ZuGG.useEffect(()=>{
        let key = String(++$45413cf8903a2186$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8ZuGG.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $i7SlW.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $45413cf8903a2186$var$useNavigateStable() {
    let { router: router } = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseNavigateStable);
    let id = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8ZuGG.useRef(false);
    $45413cf8903a2186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8ZuGG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $45413cf8903a2186$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $45413cf8903a2186$var$alreadyWarned$1 = {};
function $45413cf8903a2186$var$warningOnce(key, cond, message) {
    if (!cond && !$45413cf8903a2186$var$alreadyWarned$1[key]) $45413cf8903a2186$var$alreadyWarned$1[key] = true;
}
const $45413cf8903a2186$var$alreadyWarned = {};
function $45413cf8903a2186$var$warnOnce(key, message) {}
const $45413cf8903a2186$var$logDeprecation = (flag, msg, link)=>$45413cf8903a2186$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $45413cf8903a2186$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $45413cf8903a2186$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $45413cf8903a2186$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $45413cf8903a2186$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $45413cf8903a2186$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $45413cf8903a2186$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $45413cf8903a2186$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $45413cf8903a2186$var$START_TRANSITION = "startTransition";
const $45413cf8903a2186$var$startTransitionImpl = $8ZuGG[$45413cf8903a2186$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $45413cf8903a2186$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8ZuGG.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        if (v7_startTransition && $45413cf8903a2186$var$startTransitionImpl) $45413cf8903a2186$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8ZuGG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8ZuGG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8ZuGG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8ZuGG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $8ZuGG.useEffect(()=>$45413cf8903a2186$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $45413cf8903a2186$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $45413cf8903a2186$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $45413cf8903a2186$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $45413cf8903a2186$var$startTransitionImpl ? $45413cf8903a2186$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $8ZuGG.useEffect(()=>$45413cf8903a2186$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $45413cf8903a2186$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let navigate = $45413cf8903a2186$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $i7SlW.resolveTo)(to, (0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8ZuGG.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $45413cf8903a2186$export$910ae8079b2c2852(props) {
    return $45413cf8903a2186$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $45413cf8903a2186$export$e7b0ac011bb776c6(_props) {
    (0, $i7SlW.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $45413cf8903a2186$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $i7SlW.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8ZuGG.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $45413cf8903a2186$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $i7SlW.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8ZuGG.useMemo(()=>{
        let trailingPathname = (0, $i7SlW.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $45413cf8903a2186$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $45413cf8903a2186$export$5d3fca4a98652595($45413cf8903a2186$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $45413cf8903a2186$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$ResolveAwait, null, children));
}
var $45413cf8903a2186$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($45413cf8903a2186$var$AwaitRenderStatus || {});
const $45413cf8903a2186$var$neverSettledPromise = new Promise(()=>{});
class $45413cf8903a2186$var$AwaitErrorBoundary extends $8ZuGG.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $45413cf8903a2186$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $45413cf8903a2186$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $45413cf8903a2186$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $45413cf8903a2186$var$AwaitRenderStatus.error : "_data" in promise ? $45413cf8903a2186$var$AwaitRenderStatus.success : $45413cf8903a2186$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $45413cf8903a2186$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error && promise._error instanceof (0, $i7SlW.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $45413cf8903a2186$var$neverSettledPromise;
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $45413cf8903a2186$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $45413cf8903a2186$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $45413cf8903a2186$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8ZuGG.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8ZuGG.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8ZuGG.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $45413cf8903a2186$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $45413cf8903a2186$export$e7b0ac011bb776c6) && (0, $i7SlW.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $i7SlW.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $45413cf8903a2186$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $45413cf8903a2186$export$daf73786167a7f72(matches) {
    return $45413cf8903a2186$var$_renderMatches(matches);
}
function $45413cf8903a2186$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8ZuGG.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8ZuGG.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8ZuGG.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $45413cf8903a2186$export$f30f7e456d254e83(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $45413cf8903a2186$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $45413cf8903a2186$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});



parcelRegister("2xiyk", function(module, exports) {

$parcel$export(module.exports, "startBrowserMetrics", function () { return $a958aca08a0edc84$export$7cf313435eb9a801; });

var $7HBoF = parcelRequire("7HBoF");

var $3GjBI = parcelRequire("3GjBI");

var $8ZuGG = parcelRequire("8ZuGG");

var $lk8Tl = parcelRequire("lk8Tl");

var $gV6nD = parcelRequire("gV6nD");
const $a958aca08a0edc84$export$7cf313435eb9a801 = (analyticsClient)=>{
    var _6788f73962a7e71600448cb684fa41475c4c3de314d6;
    const info = {
        app: {
            version: {
                web: (_6788f73962a7e71600448cb684fa41475c4c3de314d6 = "6788-f73962a7e71600448cb684fa41475c4c3de314d6") !== null && _6788f73962a7e71600448cb684fa41475c4c3de314d6 !== void 0 ? _6788f73962a7e71600448cb684fa41475c4c3de314d6 : 'no-version'
            },
            framework: {
                name: 'react',
                version: $8ZuGG.version
            }
        },
        product: 'identity',
        // Region is used for "Split by" in Perf Portal.
        region: 'unknown'
    };
    const endpoints = {
        eventPipelineClient: Promise.resolve(analyticsClient.getInstance())
    };
    const events = {
        [(0, $3GjBI.BMEventsType).WEB_VITALS]: {
            enabled: true
        }
    };
    const plugins = {
        featureFlags: {
            client: Promise.resolve({
                getValue: (gate)=>(0, $gV6nD.checkFeatureGate)(gate)
            })
        },
        resourceTimings: {
            /**
       * Browser Metrics track all the network calls and add them automatically to the performance events.
       * To ensure we're not recording any UGC / PII, we need to provide a sanitise method.
       */ sanitiseEndpoints: (url)=>{
                // Remove sensitive PII data (i.e. all URL params)
                return url.split('?')[0];
            },
            /**
       * Takes a URL and removes hashes, cache busting parameters, versioning, and other unique identifiers specific to the build of the app.
       * This is so that URLs that exist as a part of a browser metrics payload will not be deemed unique due to having different hashes.
       *
       * * For example, when `url` is:
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.449/static/js/login.28848bff.chunk.js`
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.450/static/js/login.66eb7699.chunk.js`
       *
       * Then both of the above should be cleaned to `login.js`, which will be treated as the same URL for reporting purposes.
       */ mapResources: (url)=>{
                // url = https://aid-frontend.prod.atl-paas.net/.../static/js/login.28848bff.chunk.js
                if (!url.includes('aid-frontend')) // This is an external URL where we can't guarantee the URL structure, therefore cannot do any mapping.
                return url;
                var _url_split_pop;
                // hashedFileName = login.28848bff.chunk.js
                const hashedFileName = (_url_split_pop = url.split('/').pop()) !== null && _url_split_pop !== void 0 ? _url_split_pop : 'unknown';
                const parts = hashedFileName.split('.');
                const ext = parts.length > 1 ? parts.pop() : 'unknown';
                // Returning login.js
                return `${parts[0]}.${ext}`;
            },
            // If url supports TimingAllowOrigin header, then BM calculates cache status of static resources:
            hasTimingHeaders: ()=>false
        }
    };
    (0, $7HBoF.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: plugins,
        events: events,
        debug: (0, $lk8Tl.currentEnvType) !== 'prod'
    });
    (0, $7HBoF.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("gV6nD", function(module, exports) {

$parcel$export(module.exports, "checkFeatureGate", function () { return $af3bde101ec9c464$export$bd360271f9be3afb; });
$parcel$export(module.exports, "checkFeatureGateOnceInitialized", function () { return $af3bde101ec9c464$export$169cc76505f776d4; });

var $fYaTm = parcelRequire("fYaTm");
parcelRequire("ie5oO");
var $4KLgf = parcelRequire("4KLgf");
const $af3bde101ec9c464$export$bd360271f9be3afb = (key)=>{
    return (0, $fYaTm.default).checkGate(key);
};
const $af3bde101ec9c464$export$169cc76505f776d4 = async (key)=>{
    await (0, $4KLgf.isFeatureGateProviderReady);
    return (0, $fYaTm.default).checkGate(key);
};

});
parcelRegister("ie5oO", function(module, exports) {
$parcel$export(module.exports, "FeatureGateProvider", function () { return (parcelRequire("4KLgf")).FeatureGateProvider; });
$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return (parcelRequire("4KLgf")).isFeatureGateProviderReady; });
parcelRequire("4KLgf");

});
parcelRegister("4KLgf", function(module, exports) {

$parcel$export(module.exports, "isFeatureGateProviderReady", function () { return $85f8cdc40076b81a$export$e64f903d3c37e234; });
$parcel$export(module.exports, "FeatureGateProvider", function () { return $85f8cdc40076b81a$export$d9e6d91f1f7e3282; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $8wTJJ = parcelRequire("8wTJJ");

var $clPQ5 = parcelRequire("clPQ5");

var $3ir1n = parcelRequire("3ir1n");

var $cufV0 = parcelRequire("cufV0");

var $iSD9t = parcelRequire("iSD9t");

var $erZlf = parcelRequire("erZlf");

var $8f2pb = parcelRequire("8f2pb");

var $2Py2O = parcelRequire("2Py2O");
/**
 * Feature Gates are currently created within React (ticket to move this outside in KIRBY-9193)
 * There are cases where FGs may be needed to used by entities outside of React components
 * The example this was written for is the react-router v6 loader function,
 * which gets called at the top-level on initialization of createBrowserRouter is called.
 */ const $85f8cdc40076b81a$var$deferredPromise = (0, $2Py2O.default)();
const $85f8cdc40076b81a$export$e64f903d3c37e234 = $85f8cdc40076b81a$var$deferredPromise.promise;
const $85f8cdc40076b81a$export$d9e6d91f1f7e3282 = ({ children: children })=>{
    const [isFeatureGatesClientReady, setIsFeatureGatesClientReady] = (0, $8ZuGG.useState)(false);
    const [dynamicConfigsClient, setDynamicConfigsCollection] = (0, $8ZuGG.useState)(undefined);
    const tenantId = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.tenantCloudId;
    });
    const atlassianAccountId = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.userId;
    });
    const ffsId = (0, $8wTJJ.getFfsId)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsAnonymousId = (0, $3ir1n.useAnalyticsAnonymousId)();
    const featureGatesIdentifiers = (0, $8ZuGG.useMemo)(()=>({
            tenantId: tenantId,
            atlassianAccountId: atlassianAccountId,
            randomizationId: ffsId,
            analyticsAnonymousId: analyticsAnonymousId
        }), [
        tenantId,
        atlassianAccountId,
        ffsId,
        analyticsAnonymousId
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        (0, $erZlf.initializeDynamicConfigs)(analyticsAnonymousId).then((dynamicConfigs)=>setDynamicConfigsCollection(dynamicConfigs));
    }, [
        analyticsAnonymousId
    ]);
    const onFeatureGatesReady = (0, $8ZuGG.useCallback)((err)=>{
        setIsFeatureGatesClientReady(true);
        $85f8cdc40076b81a$var$captureStatsigFeatureGateError(err);
        $85f8cdc40076b81a$var$deferredPromise.resolve();
    }, []);
    const areClientsReady = isFeatureGatesClientReady && !!dynamicConfigsClient;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $clPQ5.FeatureGatesInit), {
                identifiers: featureGatesIdentifiers,
                onReady: onFeatureGatesReady
            }),
            !areClientsReady && /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
                label: formatMessage({
                    id: 'statsig.clients.loading',
                    defaultMessage: 'Loading feature flags...',
                    description: 'Label text for loading spinner when Statsig clients are being initialized'
                })
            }),
            areClientsReady && /*#__PURE__*/ (0, $6rcps.jsx)((0, $erZlf.DynamicConfigsContext).Provider, {
                value: dynamicConfigsClient,
                children: children
            })
        ]
    });
};
const $85f8cdc40076b81a$var$captureStatsigFeatureGateError = (err)=>{
    if (!err) return;
    (0, $8f2pb.captureException)(err, undefined, {
        statsigFeatureGate: 'statsig_feature_gate_client_init'
    });
};

});
parcelRegister("kOqgB", function(module, exports) {

$parcel$export(module.exports, "RESET_APP_STATE", function () { return $1cb941067523c0e3$export$83323797e38f210e; });
$parcel$export(module.exports, "createAppStore", function () { return $1cb941067523c0e3$export$38e7b01cdeec369; });
$parcel$export(module.exports, "useAppDispatch", function () { return $1cb941067523c0e3$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $1cb941067523c0e3$export$a7347740d65f620b; });

var $l2d2N = parcelRequire("l2d2N");
var $6jPF3 = parcelRequire("6jPF3");

var $9JIXI = parcelRequire("9JIXI");

var $3rl5T = parcelRequire("3rl5T");
parcelRequire("iBTcr");
var $7JtuM = parcelRequire("7JtuM");
var $5Hzdz = parcelRequire("5Hzdz");
const $1cb941067523c0e3$export$83323797e38f210e = 'RESET_APP_STATE';
const $1cb941067523c0e3$var$rootReducer = (state, action)=>{
    const shouldResetAppState = action.type === $1cb941067523c0e3$export$83323797e38f210e;
    const stateToUpdate = shouldResetAppState ? action.data : state;
    return (0, $l2d2N.combineReducers)((0, $9JIXI.getReducers)())(stateToUpdate, action);
};
const $1cb941067523c0e3$export$38e7b01cdeec369 = (preloadedState = {})=>(0, $6jPF3.configureStore)({
        reducer: $1cb941067523c0e3$var$rootReducer,
        devTools: false,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $3rl5T.idAuthMfaMiddleware))
    });
const $1cb941067523c0e3$export$f51d452c10d5b956 = (0, $7JtuM.useDispatch);
const $1cb941067523c0e3$export$a7347740d65f620b = (0, $5Hzdz.useSelector);

});
parcelRegister("9JIXI", function(module, exports) {

$parcel$export(module.exports, "getReducers", function () { return $d6a8a0c44cf114bb$export$cf167d5dfe57ae0e; });

var $6pUL0 = parcelRequire("6pUL0");

var $jK8gE = parcelRequire("jK8gE");

var $8qLQj = parcelRequire("8qLQj");

var $d4mUe = parcelRequire("d4mUe");

var $4WFiR = parcelRequire("4WFiR");

var $ifeUR = parcelRequire("ifeUR");

var $21hpi = parcelRequire("21hpi");

var $aQAdX = parcelRequire("aQAdX");

var $l84x7 = parcelRequire("l84x7");

var $fI9D6 = parcelRequire("fI9D6");

var $cpoyZ = parcelRequire("cpoyZ");

var $buoUv = parcelRequire("buoUv");

var $iDHkk = parcelRequire("iDHkk");

var $3kyMd = parcelRequire("3kyMd");

var $hl8FM = parcelRequire("hl8FM");

var $9CzTs = parcelRequire("9CzTs");

var $dsaG2 = parcelRequire("dsaG2");

var $hZmDj = parcelRequire("hZmDj");

var $1hNLb = parcelRequire("1hNLb");

var $esppu = parcelRequire("esppu");

var $ahjwY = parcelRequire("ahjwY");

var $4vAET = parcelRequire("4vAET");

var $4C2Pu = parcelRequire("4C2Pu");

var $anpN3 = parcelRequire("anpN3");

var $3C3OI = parcelRequire("3C3OI");

var $bi3GK = parcelRequire("bi3GK");

var $bkO8T = parcelRequire("bkO8T");

var $54NcP = parcelRequire("54NcP");

var $8qcih = parcelRequire("8qcih");

var $dM2jK = parcelRequire("dM2jK");

var $iQMCQ = parcelRequire("iQMCQ");

var $1hbh2 = parcelRequire("1hbh2");

var $6cf1M = parcelRequire("6cf1M");

var $h0rSo = parcelRequire("h0rSo");

var $glXWv = parcelRequire("glXWv");

var $kVXtB = parcelRequire("kVXtB");

var $wWEnh = parcelRequire("wWEnh");

var $4ZYno = parcelRequire("4ZYno");
const $d6a8a0c44cf114bb$export$cf167d5dfe57ae0e = ()=>({
        appConfig: $6pUL0.default,
        csrfToken: $l84x7.csrfToken,
        hashedCsrfToken: $l84x7.hashedCsrfToken,
        globalStateLoading: $4ZYno.default,
        login: $3kyMd.default,
        logout: $hl8FM.default,
        marketingConsent: $9CzTs.default,
        mfaEnrollment: $dsaG2.default,
        mfaPromote: $hZmDj.default,
        microbranding: $1hNLb.default,
        multiFactor: $ahjwY.default,
        recovery: $4C2Pu.default,
        resetPassword: $anpN3.default,
        signup: $bkO8T.default,
        signupOnboard: $54NcP.default,
        user: $1hbh2.default,
        flags: $cpoyZ.default,
        continueAs: $21hpi.default,
        selectAccount: $3C3OI.default,
        cancelDeletion: $jK8gE.default,
        expiredPassword: $fI9D6.default,
        googleOneTap: $buoUv.default,
        changePassword: $d4mUe.default,
        changeEmail: $8qLQj.default,
        createAccount: $aQAdX.default,
        welcome: $kVXtB.default,
        context: $ifeUR.default,
        migrateConfirmation: $esppu.default,
        socialLoginRecovery: $8qcih.default,
        verifyEmail: $6cf1M.default,
        verifyEmailSent: $glXWv.default,
        serverError: $bi3GK.default,
        cobranding: $4WFiR.default,
        stepUp: $dM2jK.default,
        stepUpSso: $iQMCQ.default,
        welcomeSent: $4vAET.default,
        locale: $iDHkk.default,
        verifyEmailOtp: $h0rSo.default,
        loginConsent: $wWEnh.default
    });

});
parcelRegister("6pUL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa1948989b34767$export$2e2bcd8739ae039; });
const $9fa1948989b34767$export$49d5fc8cba920a0 = {
    googleAuthClientId: '596149463257-9oquqfivs9on8t8erq23c8qso6vk3cp1.apps.googleusercontent.com',
    isSamlEnabled: true,
    recaptchaEnable: true,
    recaptchaEnterpriseCheckboxKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    recaptchaEnterpriseScoreKeySite: '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN',
    smsEnrollmentRecaptchaEnabled: true,
    smsEnrollmentRecaptchaEnterpriseInvisibleKeySite: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
    auth0Config: {
        domain: 'auth-domain.dev.atlassian.com',
        clientId: 'RJH00Zs94cwksZuhhkM133mJvmBA0NoQ',
        callbackUrl: 'http://localhost:3000/login/callback',
        deferRules: {
            apple: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/apple/callback',
                clientId: 'EtITLqX61hS0sxFzgMEwYYWHosfYHjgY'
            },
            microsoft: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/microsoft/callback',
                clientId: '3LDSJPtWZnovKS1gMCnKmp9Hk3iXlVEZ'
            },
            slack: {
                callbackUrl: 'https://id.dev.internal.atlassian.com/login/slack/callback',
                clientId: 'zKYyRODwsh165L0h41wALWAeqVfqDs0i'
            }
        }
    },
    segmentIoKey: '',
    castlePublishableApiKey: ''
};
const $9fa1948989b34767$var$appConfig = (state = $9fa1948989b34767$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $9fa1948989b34767$export$2e2bcd8739ae039 = $9fa1948989b34767$var$appConfig;

});

parcelRegister("jK8gE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5059c1de7b8450b6$export$2e2bcd8739ae039; });
const $5059c1de7b8450b6$export$49d5fc8cba920a0 = {
    deleteOn: ''
};
const $5059c1de7b8450b6$var$cancelDeletion = (state = $5059c1de7b8450b6$export$49d5fc8cba920a0)=>{
    return state;
};
var $5059c1de7b8450b6$export$2e2bcd8739ae039 = $5059c1de7b8450b6$var$cancelDeletion;

});

parcelRegister("8qLQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a77c8fcbb3e9595$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $5a77c8fcbb3e9595$export$49d5fc8cba920a0 = {
    email: '',
    newEmail: '',
    error: null,
    isLoading: false,
    redirectTo: null
};
const $5a77c8fcbb3e9595$var$changeEmail = (state = $5a77c8fcbb3e9595$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_EMAIL_RESET_STATE':
            return $5a77c8fcbb3e9595$export$49d5fc8cba920a0;
        case 'CHANGE_EMAIL_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                isLoading: true
            });
        case 'CHANGE_EMAIL_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'CHANGE_EMAIL_REQUEST_SUCCEEDED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                redirectTo: action.redirectTo,
                isLoading: false
            });
        case 'CHANGE_EMAIL_STATE_UPDATE':
            return (0, $ty6PY._)({}, state, action.backendState);
        default:
            return state;
    }
};
var $5a77c8fcbb3e9595$export$2e2bcd8739ae039 = $5a77c8fcbb3e9595$var$changeEmail;

});

parcelRegister("d4mUe", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $8431b1ca71d9cd49$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $8431b1ca71d9cd49$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $8431b1ca71d9cd49$export$49d5fc8cba920a0 = {
    email: '',
    displayName: '',
    fieldErrors: {},
    isLoading: false
};
const $8431b1ca71d9cd49$var$changePassword = (state = $8431b1ca71d9cd49$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CHANGE_PASSWORD_REQUEST_INITIATE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                isLoading: true,
                error: undefined
            });
        case 'CHANGE_PASSWORD_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                error: undefined
            });
        case 'CHANGE_PASSWORD_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                error: action.error
            });
        case 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: action.fieldErrors
            });
        default:
            return state;
    }
};
var $8431b1ca71d9cd49$export$2e2bcd8739ae039 = $8431b1ca71d9cd49$var$changePassword;

});

parcelRegister("4WFiR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe1d0c0c8e3bbaa$export$2e2bcd8739ae039; });
const $cbe1d0c0c8e3bbaa$export$49d5fc8cba920a0 = {};
const $cbe1d0c0c8e3bbaa$var$cobranding = (state = $cbe1d0c0c8e3bbaa$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $cbe1d0c0c8e3bbaa$export$2e2bcd8739ae039 = $cbe1d0c0c8e3bbaa$var$cobranding;

});

parcelRegister("ifeUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af3c7d62fe82984e$export$2e2bcd8739ae039; });
const $af3c7d62fe82984e$export$49d5fc8cba920a0 = {
    tenantCloudId: undefined
};
const $af3c7d62fe82984e$var$appConfig = (state = $af3c7d62fe82984e$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $af3c7d62fe82984e$export$2e2bcd8739ae039 = $af3c7d62fe82984e$var$appConfig;

});

parcelRegister("21hpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f555a91bb6aa8d6$export$2e2bcd8739ae039; });
const $4f555a91bb6aa8d6$export$49d5fc8cba920a0 = {
    displayName: '',
    email: '',
    avatarUrl: '',
    continueUrl: ''
};
const $4f555a91bb6aa8d6$var$continueAs = (state = $4f555a91bb6aa8d6$export$49d5fc8cba920a0)=>{
    return state;
};
var $4f555a91bb6aa8d6$export$2e2bcd8739ae039 = $4f555a91bb6aa8d6$var$continueAs;

});

parcelRegister("aQAdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c55374ae0983c87$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $6c55374ae0983c87$export$49d5fc8cba920a0 = {
    formError: undefined,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false,
    source: undefined,
    loginType: undefined,
    displayName: undefined,
    email: undefined,
    accessToken: undefined,
    idToken: undefined,
    createNeeded: undefined,
    verifyNeeded: undefined,
    confirmationToken: undefined,
    mfaToken: undefined
};
const $6c55374ae0983c87$var$createAccount = (state = $6c55374ae0983c87$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'CONFIRMATION_RESET':
            return $6c55374ae0983c87$export$49d5fc8cba920a0;
        case 'CONFIRMATION_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                formError: undefined,
                isLoading: true
            });
        case 'CONFIRMATION_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                isLoading: false,
                redirectTo: action.redirectTo
            });
        case 'CONFIRMATION_RESEND_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'CONFIRMATION_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                formError: action.error,
                isLoading: false
            });
        case 'CONFIRMATION_SHOW_FIELD_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        case 'CONFIRMATION_STATE_UPDATE':
            return (0, $ty6PY._)({}, state, action.backendState);
        default:
            return state;
    }
};
var $6c55374ae0983c87$export$2e2bcd8739ae039 = $6c55374ae0983c87$var$createAccount;

});

parcelRegister("l84x7", function(module, exports) {

$parcel$export(module.exports, "csrfToken", function () { return $ea0d14f1bc310c0d$export$c077d53e8672d0e9; });
$parcel$export(module.exports, "hashedCsrfToken", function () { return $ea0d14f1bc310c0d$export$e9eff156dd8b992; });
const $ea0d14f1bc310c0d$export$49d5fc8cba920a0 = '';
const $ea0d14f1bc310c0d$export$c077d53e8672d0e9 = (state = $ea0d14f1bc310c0d$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'CSRF_TOKEN_UPDATE') return action.csrfToken;
    return state;
};
const $ea0d14f1bc310c0d$export$e9eff156dd8b992 = (state = $ea0d14f1bc310c0d$export$49d5fc8cba920a0, action)=>{
    if (action.type === 'HASHED_CSRF_TOKEN_UPDATE') return action.hashedCsrfToken;
    return state;
};

});

parcelRegister("fI9D6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789ae73cf2bf42e5$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $789ae73cf2bf42e5$export$49d5fc8cba920a0 = {
    error: null,
    isLoading: false,
    isComplete: false
};
const $789ae73cf2bf42e5$var$expiredPassword = (state = $789ae73cf2bf42e5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                isLoading: true,
                isComplete: false
            });
        case 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                isLoading: false,
                isComplete: true
            });
        case 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false,
                isComplete: true
            });
        default:
            return state;
    }
};
var $789ae73cf2bf42e5$export$2e2bcd8739ae039 = $789ae73cf2bf42e5$var$expiredPassword;

});

parcelRegister("cpoyZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4826b8a8b0e3d519$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $4826b8a8b0e3d519$export$49d5fc8cba920a0 = {
    flags: []
};
var $4826b8a8b0e3d519$export$2e2bcd8739ae039 = (state = $4826b8a8b0e3d519$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'FLAG_ADD':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                flags: [
                    action.flag,
                    ...state.flags
                ]
            });
        case 'FLAG_DISMISS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                flags: state.flags.slice(1)
            });
        default:
            return state;
    }
};

});

parcelRegister("buoUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e076259435b5b83a$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $e076259435b5b83a$export$49d5fc8cba920a0 = {
    dismissed: false
};
const $e076259435b5b83a$var$googleOneTap = (state = $e076259435b5b83a$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'GOOGLE_ONE_TAP_DISMISS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                dismissed: true
            });
        default:
            return state;
    }
};
var $e076259435b5b83a$export$2e2bcd8739ae039 = $e076259435b5b83a$var$googleOneTap;

});

parcelRegister("iDHkk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3883dd85449954f1$export$2e2bcd8739ae039; });
const $3883dd85449954f1$export$49d5fc8cba920a0 = 'en';
const $3883dd85449954f1$var$locale = (state = $3883dd85449954f1$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $3883dd85449954f1$export$2e2bcd8739ae039 = $3883dd85449954f1$var$locale;

});

parcelRegister("3kyMd", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $489d972a406afd03$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $489d972a406afd03$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8dHAc = parcelRequire("8dHAc");
const $489d972a406afd03$export$49d5fc8cba920a0 = {
    isUsernameChecked: false,
    isV2UsernameChecked: false,
    passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
    isCaptchaRequired: false,
    isCheckingUsername: false,
    isV2CheckingUsername: false,
    isErrorShown: false,
    fieldErrors: {},
    isLoggingIn: false,
    redirectUrl: '',
    redirectType: null,
    restrictedEmail: false,
    nextAttempt: 1,
    showResetHint: false,
    usernameExists: false,
    isSocialBlocked: false,
    rememberMeEnabled: false,
    rememberedAccounts: [],
    isRememberMeChecked: false,
    rememberedAccountsResponseCodes: [],
    v2Accounts: []
};
const $489d972a406afd03$var$login = (state = $489d972a406afd03$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'LOGIN_REQUEST_CHECK_USERNAME':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                identities: undefined
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_V2':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isV2CheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                v2Accounts: []
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_V2_SUCCEEDED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isV2CheckingUsername: false,
                isV2UsernameChecked: true,
                v2Accounts: action.accounts
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: false,
                usernameExists: true,
                redirectUrl: action.redirectUrl,
                redirectType: action.redirectType,
                passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: false,
                redirectUrl: '',
                redirectType: null,
                passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                isSocialBlocked: action.social === 'disallowed'
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: '',
                redirectType: null,
                passwordless: action.passwordless,
                identities: action.identities,
                isSocialBlocked: false
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isCheckingUsername: false,
                fieldErrors: {
                    email: action.error
                }
            });
        case 'LOGIN_REQUEST_CHECK_USERNAME_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCheckingUsername: false,
                isErrorShown: true,
                error: action.error
            });
        case 'LOGIN_RESET':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCaptchaRequired: false,
                isSocialBlocked: false,
                isUsernameChecked: false,
                usernameExists: false,
                isV2UsernameChecked: false,
                isV2CheckingUsername: false,
                isErrorShown: false,
                nextAttempt: 1,
                fieldErrors: {},
                identities: undefined,
                v2Accounts: []
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            });
        case 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            });
        case 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {}
            });
        case 'LOGIN_REDIRECT_USER':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            });
        case 'LOGIN_SHOW_LOGIN_FORM_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.errors
            });
        case 'UPDATE_LOGIN_ATTEMPT_DETAILS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                nextAttempt: action.nextAttempt
            });
        case 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isCaptchaRequired: action.isCaptchaRequired
            });
        case 'LOGIN_SET_STATE':
            var _action_state_login, _action_state_login1, _action_state_login2, _action_state_login3;
            return (0, $ty6PY._)({}, state, ((_action_state_login = action.state.login) === null || _action_state_login === void 0 ? void 0 : _action_state_login.error) && {
                error: action.state.login.error
            }, ((_action_state_login1 = action.state.login) === null || _action_state_login1 === void 0 ? void 0 : _action_state_login1.fieldErrors) && {
                fieldErrors: action.state.login.fieldErrors
            }, ((_action_state_login2 = action.state.login) === null || _action_state_login2 === void 0 ? void 0 : _action_state_login2.recoveryToken) && {
                recoveryToken: (_action_state_login3 = action.state.login) === null || _action_state_login3 === void 0 ? void 0 : _action_state_login3.recoveryToken
            });
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE':
            {
                const { accountIds: accountIds } = action.payload;
                return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                    rememberedAccounts: state.rememberedAccounts.filter((account)=>!accountIds.includes(account.accountId))
                });
            }
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS':
        case 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED':
            // Update the state based on the response from the backend, which updates the UI.
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                rememberedAccountsResponseCodes: [
                    ...state.rememberedAccountsResponseCodes || [],
                    action.payload.response
                ]
            });
        case 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                rememberedAccountsResponseCodes: []
            });
        case 'REMEMBER_ME_CHECKBOX_UPDATE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isRememberMeChecked: action.payload.enabled
            });
        case 'REMEMBER_ME_CHECKBOX_TOGGLE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isRememberMeChecked: !state.isRememberMeChecked
            });
        case 'RESET_REMEMBER_ME_STATE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isRememberMeChecked: false,
                isCheckingUsername: false,
                isUsernameChecked: false
            });
        default:
            return state;
    }
};
var $489d972a406afd03$export$2e2bcd8739ae039 = $489d972a406afd03$var$login;

});
parcelRegister("8dHAc", function(module, exports) {

$parcel$export(module.exports, "CheckUserNameRedirectType", function () { return $1c8c8623224b2159$export$8ef54b27f2e9d22a; });
$parcel$export(module.exports, "CheckUserNamePasswordlessType", function () { return $1c8c8623224b2159$export$b660b4f2246928fd; });
$parcel$export(module.exports, "SocialProvider", function () { return $1c8c8623224b2159$export$9368509e79aec5d3; });
$parcel$export(module.exports, "OidcDisplay", function () { return $1c8c8623224b2159$export$979d11be6cba8f4d; });
$parcel$export(module.exports, "VerificationType", function () { return $1c8c8623224b2159$export$ca9df54f128b4fc3; });
$parcel$export(module.exports, "VerifyOrReverifyEmailError", function () { return $1c8c8623224b2159$export$900620e02700dc8d; });
$parcel$export(module.exports, "WelcomeError", function () { return $1c8c8623224b2159$export$b3e1628b2fcac0ef; });
$parcel$export(module.exports, "WelcomeSentError", function () { return $1c8c8623224b2159$export$8681a4e3b8216bf1; });
$parcel$export(module.exports, "RedirectType", function () { return $1c8c8623224b2159$export$901f7b7cba88b6fd; });
$parcel$export(module.exports, "MfaFlow", function () { return $1c8c8623224b2159$export$dfa50caeee289030; });
$parcel$export(module.exports, "KnownRecoveryEmailErrorReasons", function () { return $1c8c8623224b2159$export$617703099de92392; });
var $1c8c8623224b2159$export$8ef54b27f2e9d22a = /*#__PURE__*/ function(CheckUserNameRedirectType) {
    CheckUserNameRedirectType["Sso"] = "sso";
    CheckUserNameRedirectType["EmailSent"] = "email_sent";
    return CheckUserNameRedirectType;
}({});
var $1c8c8623224b2159$export$b660b4f2246928fd = /*#__PURE__*/ function(CheckUserNamePasswordlessType) {
    CheckUserNamePasswordlessType["Disallowed"] = "disallowed";
    CheckUserNamePasswordlessType["Allowed"] = "allowed";
    return CheckUserNamePasswordlessType;
}({});
var $1c8c8623224b2159$export$9368509e79aec5d3 = /*#__PURE__*/ function(SocialProvider) {
    SocialProvider["Google"] = "google";
    SocialProvider["Microsoft"] = "microsoft";
    SocialProvider["Apple"] = "apple";
    SocialProvider["Slack"] = "slack";
    return SocialProvider;
}({});
var $1c8c8623224b2159$export$979d11be6cba8f4d = /*#__PURE__*/ function(OidcDisplay) {
    OidcDisplay["Login"] = "login";
    OidcDisplay["Signup"] = "signup";
    OidcDisplay["Continue"] = "continue";
    OidcDisplay["LoginWithRedirect"] = "login_with_redirect";
    OidcDisplay["Reverify"] = "reverify";
    OidcDisplay["ManageSessions"] = "manage_sessions";
    return OidcDisplay;
}({});
var $1c8c8623224b2159$export$ca9df54f128b4fc3 = /*#__PURE__*/ function(VerificationType) {
    VerificationType["Verify"] = "verify";
    VerificationType["VerifyWithSoftSession"] = "verifyWithSoftSession";
    VerificationType["Reverify"] = "reverify";
    return VerificationType;
}({});
var $1c8c8623224b2159$export$900620e02700dc8d = /*#__PURE__*/ function(VerifyOrReverifyEmailError) {
    VerifyOrReverifyEmailError["ExpiredToken"] = "expired_token_error";
    VerifyOrReverifyEmailError["InvalidToken"] = "invalid_token_error";
    VerifyOrReverifyEmailError["RateLimitExceeded"] = "ratelimit_exceeded_error";
    return VerifyOrReverifyEmailError;
}({});
var $1c8c8623224b2159$export$b3e1628b2fcac0ef = /*#__PURE__*/ function(WelcomeError) {
    WelcomeError["RateLimitExceeded"] = "rate_limit_exceeded";
    return WelcomeError;
}({});
var $1c8c8623224b2159$export$8681a4e3b8216bf1 = /*#__PURE__*/ function(WelcomeSentError) {
    WelcomeSentError["ExpiredToken"] = "expired_token";
    WelcomeSentError["InvalidToken"] = "invalid_token";
    return WelcomeSentError;
}({});
var $1c8c8623224b2159$export$901f7b7cba88b6fd = /*#__PURE__*/ function(RedirectType) {
    RedirectType["ResumeMigration"] = "resume_migration";
    RedirectType["Migration"] = "migration";
    RedirectType["Signup"] = "signup";
    RedirectType["ResumeSignup"] = "resume_signup";
    RedirectType["Invite"] = "invite";
    return RedirectType;
}({});
const $1c8c8623224b2159$export$af8c96aed1523ade = [
    'internal_server_error',
    'bad_request',
    'not_found',
    'csrf_token_mismatch'
];
function $1c8c8623224b2159$export$390d5c1cc6047864(error) {
    // Need to typecast because T[].includes(X) -> X always needs to be of type T
    return $1c8c8623224b2159$export$af8c96aed1523ade.includes(error);
}
var $1c8c8623224b2159$export$12df27b025e392f8 = /*#__PURE__*/ function(SecurityKeyAuthenticatorAttachment) {
    SecurityKeyAuthenticatorAttachment["Platform"] = "platform";
    SecurityKeyAuthenticatorAttachment["CrossPlatform"] = "cross-platform";
    return SecurityKeyAuthenticatorAttachment;
}({});
var $1c8c8623224b2159$export$dfa50caeee289030 = /*#__PURE__*/ function(MfaFlow) {
    MfaFlow["Sms"] = "sms";
    MfaFlow["Totp"] = "totp";
    MfaFlow["SecurityKey"] = "security_key";
    return MfaFlow;
}({});
const $1c8c8623224b2159$export$617703099de92392 = [
    'userNotFound',
    'userIsManaged',
    'alreadyRequested'
];

});


parcelRegister("hl8FM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d22842a4865a4fd9$export$2e2bcd8739ae039; });
const $d22842a4865a4fd9$export$49d5fc8cba920a0 = {
    autoSubmit: false
};
const $d22842a4865a4fd9$var$logout = (state = $d22842a4865a4fd9$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $d22842a4865a4fd9$export$2e2bcd8739ae039 = $d22842a4865a4fd9$var$logout;

});

parcelRegister("9CzTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04113fe52f7d911f$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $04113fe52f7d911f$export$49d5fc8cba920a0 = {
    config: undefined
};
const $04113fe52f7d911f$var$marketingConsent = (state = $04113fe52f7d911f$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'UPDATE_MARKETING_CONSENT_CONFIG':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                config: action.config
            });
        default:
            return state;
    }
};
var $04113fe52f7d911f$export$2e2bcd8739ae039 = $04113fe52f7d911f$var$marketingConsent;

});

parcelRegister("dsaG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06f8df9022125542$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8dHAc = parcelRequire("8dHAc");
const $06f8df9022125542$export$49d5fc8cba920a0 = {
    invalid: false,
    enrollStarted: false,
    enrollConfirmed: false,
    token: '',
    redirectUrl: null,
    recoveryCode: null,
    transactionToken: null,
    unsupportedCountries: []
};
var $06f8df9022125542$export$2e2bcd8739ae039 = (state = $06f8df9022125542$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'START_ENROLL':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                token: action.token,
                mfaFlow: (0, $8dHAc.MfaFlow).Totp
            });
        case 'START_ENROLL_RESPONSE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                enrollStarted: true,
                transactionToken: action.transactionToken,
                emailAddress: action.emailAddress,
                totpSecret: action.totpSecret,
                recoveryCode: action.recoveryCode,
                totpUri: action.totpUri
            });
        case 'CONFIRM_ENROLL':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                confirmingEnroll: true,
                invalid: false
            });
        case 'CONFIRM_ENROLL_RESPONSE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                enrollConfirmed: true,
                confirmingEnroll: false,
                redirectUrl: action.redirectUrl
            });
        case 'CONFIRM_ENROLL_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                confirmingEnroll: false,
                invalid: true
            });
        case 'START_SMS_ENROLL':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                token: action.token,
                phoneNumber: action.phoneNumber,
                mfaFlow: (0, $8dHAc.MfaFlow).Sms
            });
        case 'START_SMS_ENROLL_RESPONSE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                transactionToken: action.transactionToken,
                recoveryCode: action.recoveryCode,
                smsEnrollError: null,
                phoneNumber: action.phoneNumber
            });
        case 'START_SMS_ENROLL_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                smsEnrollError: action.smsEnrollError,
                transactionToken: null,
                recoveryCode: null
            });
        case 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                unsupportedCountries: action.unsupportedCountries
            });
        case 'RESET_SMS_ENROLL_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                smsEnrollError: null
            });
        case 'START_SECURITY_KEY_ENROLL':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                token: action.token,
                mfaFlow: (0, $8dHAc.MfaFlow).SecurityKey
            });
        case 'CONFIRM_SECURITY_KEY_ENROLLMENT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                recoveryCode: action.recoveryCode
            });
        default:
            return state;
    }
};

});

parcelRegister("hZmDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da8b36f53fba7ae2$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $da8b36f53fba7ae2$export$49d5fc8cba920a0 = {
    redirectTo: null
};
var $da8b36f53fba7ae2$export$2e2bcd8739ae039 = (state = $da8b36f53fba7ae2$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_PROMOTE_REDIRECT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                redirectTo: action.redirectTo
            });
        default:
            return state;
    }
};

});

parcelRegister("1hNLb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a427087b2ba04847$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $a427087b2ba04847$export$49d5fc8cba920a0 = {
    oidcContext: undefined,
    isEmbedded: false,
    isAnyMobile: false,
    isMobileApp: false,
    screenSize: 'unknown'
};
const $a427087b2ba04847$var$microbranding = (state = $a427087b2ba04847$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MICROBRANDING_UPDATE':
            return (0, $ty6PY._)({}, state, action.microbranding);
        case 'SCREEN_SIZE_UPDATED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                screenSize: action.screenSize
            });
        default:
            return state;
    }
};
var $a427087b2ba04847$export$2e2bcd8739ae039 = $a427087b2ba04847$var$microbranding;

});

parcelRegister("esppu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d63e1c3ff9f132$export$2e2bcd8739ae039; });
const $f4d63e1c3ff9f132$export$49d5fc8cba920a0 = {
    redirectTo: ''
};
const $f4d63e1c3ff9f132$var$migrateConfirmation = (state = $f4d63e1c3ff9f132$export$49d5fc8cba920a0)=>{
    return state;
};
var $f4d63e1c3ff9f132$export$2e2bcd8739ae039 = $f4d63e1c3ff9f132$var$migrateConfirmation;

});

parcelRegister("ahjwY", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $c238b5af5f606471$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $c238b5af5f606471$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $c238b5af5f606471$export$49d5fc8cba920a0 = {
    email: '',
    fieldErrors: {},
    isLoading: false,
    isManaged: true,
    isRecoveryEmailSent: false
};
var $c238b5af5f606471$export$2e2bcd8739ae039 = (state = $c238b5af5f606471$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'MFA_VERIFICATION_VERIFY':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                isLoading: true
            });
        case 'MFA_VERIFICATION_RECOVER':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                isLoading: true
            });
        case 'MFA_VERIFICATION_RECOVER_RESPONSE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                recoveryCode: action.recoveryCode
            });
        case 'MFA_VERIFICATION_VERIFY_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: {
                    otpCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            });
        case 'MFA_VERIFICATION_RECOVER_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: {
                    recoveryCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            });
        case 'RECOVERY_EMAIL_SENT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isRecoveryEmailSent: true
            });
        case 'RECOVERY_EMAIL_START':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                recoveryEmailError: undefined
            });
        case 'RECOVERY_EMAIL_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                recoveryEmailError: action.reason
            });
        case 'USER_MANAGED_STATUS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isManaged: action.isManaged
            });
        case 'MFA_RESET_OTP_INPUT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                clearInputTrigger: Date.now(),
                fieldErrors: {}
            });
        default:
            return state;
    }
};

});

parcelRegister("4vAET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $000d60a75afddc68$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $000d60a75afddc68$export$49d5fc8cba920a0 = {
    error: null,
    email: '',
    redirectType: (0, $8dHAc.RedirectType).ResumeMigration,
    showBrowserWarning: false
};
const $000d60a75afddc68$var$welcomeSent = (state = $000d60a75afddc68$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $000d60a75afddc68$export$2e2bcd8739ae039 = $000d60a75afddc68$var$welcomeSent;

});

parcelRegister("4C2Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d340bb96d5d24516$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $d340bb96d5d24516$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false
};
const $d340bb96d5d24516$var$recovery = (state = $d340bb96d5d24516$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'TSV_RECOVERY_RESET':
            return $d340bb96d5d24516$export$49d5fc8cba920a0;
        case 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: {},
                error: null,
                redirectTo: action.redirectTo,
                isLoading: true
            });
        case 'TSV_RECOVERY_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'TSV_RECOVERY_SHOW_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.error,
                isLoading: false
            });
        default:
            return state;
    }
};
var $d340bb96d5d24516$export$2e2bcd8739ae039 = $d340bb96d5d24516$var$recovery;

});

parcelRegister("anpN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f490eae4ef3e9b73$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $f490eae4ef3e9b73$export$49d5fc8cba920a0 = {
    error: undefined,
    fieldErrors: {},
    isLoading: false,
    isSent: false
};
const $f490eae4ef3e9b73$var$resetPassword = (state = $f490eae4ef3e9b73$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'RESET_PASSWORD_RESET':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: undefined,
                isLoading: false,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: undefined,
                isLoading: true,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: undefined,
                isLoading: false,
                isSent: true
            });
        case 'RESET_PASSWORD_REQUEST_LINK_REDIRECT':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: undefined,
                isLoading: true,
                isSent: false,
                redirectTo: action.redirectTo
            });
        case 'RESET_PASSWORD_ERROR':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false,
                isSent: false
            });
        case 'RESET_PASSWORD_REQUEST_LINK_FAILED_WITH_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.fieldErrors,
                isLoading: false,
                isSent: false
            });
        default:
            return state;
    }
};
var $f490eae4ef3e9b73$export$2e2bcd8739ae039 = $f490eae4ef3e9b73$var$resetPassword;

});

parcelRegister("3C3OI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0abf4fb31d475c6b$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $0abf4fb31d475c6b$export$49d5fc8cba920a0 = {
    sessions: null
};
const $0abf4fb31d475c6b$var$selectAccount = (state = $0abf4fb31d475c6b$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SESSION_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: true
            });
        default:
            return state;
    }
};
var $0abf4fb31d475c6b$export$2e2bcd8739ae039 = $0abf4fb31d475c6b$var$selectAccount;

});

parcelRegister("bi3GK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34a980e8861d21d1$export$2e2bcd8739ae039; });
const $34a980e8861d21d1$export$49d5fc8cba920a0 = null;
const $34a980e8861d21d1$var$serverErrorReducer = (state = $34a980e8861d21d1$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SERVER_ERROR_UPDATE':
            return action.error;
        default:
            return state;
    }
};
var $34a980e8861d21d1$export$2e2bcd8739ae039 = $34a980e8861d21d1$var$serverErrorReducer;

});

parcelRegister("bkO8T", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $439f074b443cfef8$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $439f074b443cfef8$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $439f074b443cfef8$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $439f074b443cfef8$var$signup = (state = $439f074b443cfef8$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_RESET':
            return $439f074b443cfef8$export$49d5fc8cba920a0;
        case 'SIGNUP_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'SIGNUP_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'SIGNUP_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'SIGNUP_SHOW_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        default:
            return state;
    }
};
var $439f074b443cfef8$export$2e2bcd8739ae039 = $439f074b443cfef8$var$signup;

});

parcelRegister("54NcP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b3c45795f25b588$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $8b3c45795f25b588$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $8b3c45795f25b588$var$signupOnboard = (state = $8b3c45795f25b588$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'SIGNUP_ONBOARD_RESET':
            return $8b3c45795f25b588$export$49d5fc8cba920a0;
        case 'SIGNUP_ONBOARD_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'SIGNUP_ONBOARD_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'SIGNUP_ONBOARD_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: action.error,
                isLoading: false
            });
        case 'SIGNUP_ONBOARD_SHOW_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        default:
            return state;
    }
};
var $8b3c45795f25b588$export$2e2bcd8739ae039 = $8b3c45795f25b588$var$signupOnboard;

});

parcelRegister("8qcih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18453f779cffef32$export$2e2bcd8739ae039; });
const $18453f779cffef32$export$49d5fc8cba920a0 = {};
const $18453f779cffef32$var$socialLoginRecovery = (state = $18453f779cffef32$export$49d5fc8cba920a0)=>state;
var $18453f779cffef32$export$2e2bcd8739ae039 = $18453f779cffef32$var$socialLoginRecovery;

});

parcelRegister("dM2jK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc8a8651526e14a6$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $fc8a8651526e14a6$export$49d5fc8cba920a0 = {
    email: '',
    mfaToken: '',
    orgName: null,
    token: null
};
const $fc8a8651526e14a6$var$stepUp = (state = $fc8a8651526e14a6$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'STEP_UP_RESEND_CODE_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'STEP_UP_SEND_CODE_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                mfaToken: action.mfaToken
            });
        case 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                mfaToken: action.mfaToken
            });
        default:
            return state;
    }
};
var $fc8a8651526e14a6$export$2e2bcd8739ae039 = $fc8a8651526e14a6$var$stepUp;

});

parcelRegister("iQMCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20bd6d3f89ee761$export$2e2bcd8739ae039; });
const $f20bd6d3f89ee761$export$49d5fc8cba920a0 = {
    ssoRedirectUrl: undefined,
    idp: {
        trusted: false,
        humanReadableRedirectLocation: undefined
    }
};
const $f20bd6d3f89ee761$var$stepUpSso = (state = $f20bd6d3f89ee761$export$49d5fc8cba920a0, _action)=>{
    return state;
};
var $f20bd6d3f89ee761$export$2e2bcd8739ae039 = $f20bd6d3f89ee761$var$stepUpSso;

});

parcelRegister("1hbh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9429e0442dc84fe8$export$2e2bcd8739ae039; });
const $9429e0442dc84fe8$export$49d5fc8cba920a0 = {
    email: ''
};
const $9429e0442dc84fe8$var$user = (state = $9429e0442dc84fe8$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $9429e0442dc84fe8$export$2e2bcd8739ae039 = $9429e0442dc84fe8$var$user;

});

parcelRegister("6cf1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae566f4d66bd0634$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $ae566f4d66bd0634$export$49d5fc8cba920a0 = {
    verificationType: (0, $8dHAc.VerificationType).Verify,
    url: '#',
    error: (0, $8dHAc.VerifyOrReverifyEmailError).ExpiredToken
};
const $ae566f4d66bd0634$var$verifyEmail = (state = $ae566f4d66bd0634$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $ae566f4d66bd0634$export$2e2bcd8739ae039 = $ae566f4d66bd0634$var$verifyEmail;

});

parcelRegister("h0rSo", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $cb0b83e3166018bc$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $cb0b83e3166018bc$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8dHAc = parcelRequire("8dHAc");
const $cb0b83e3166018bc$export$49d5fc8cba920a0 = {
    email: '',
    isLoading: false,
    redirectType: (0, $8dHAc.RedirectType).Signup
};
const $cb0b83e3166018bc$var$verifyEmailOtp = (state = $cb0b83e3166018bc$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'VERIFY_EMAIL_OTP_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: true,
                error: undefined,
                redirectTo: undefined
            });
        case 'VERIFY_EMAIL_OTP_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                redirectTo: action.redirectTo
            });
        case 'VERIFY_EMAIL_OTP_FAILURE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                error: action.error
            });
        case 'VERIFY_EMAIL_OTP_SET_STATE':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                email: action.state.email
            });
        default:
            return state;
    }
};
var $cb0b83e3166018bc$export$2e2bcd8739ae039 = $cb0b83e3166018bc$var$verifyEmailOtp;

});

parcelRegister("glXWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9dcea1146adce0$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $3c9dcea1146adce0$export$49d5fc8cba920a0 = {
    verificationType: (0, $8dHAc.VerificationType).Verify,
    showBrowserWarning: false
};
const $3c9dcea1146adce0$var$verifyEmailSent = (state = $3c9dcea1146adce0$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $3c9dcea1146adce0$export$2e2bcd8739ae039 = $3c9dcea1146adce0$var$verifyEmailSent;

});

parcelRegister("kVXtB", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $1999ac8408786e31$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $1999ac8408786e31$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8dHAc = parcelRequire("8dHAc");

var $60zme = parcelRequire("60zme");
const $1999ac8408786e31$export$49d5fc8cba920a0 = {
    error: null,
    formError: null,
    fieldErrors: {},
    isLoading: false,
    isMobile: (0, $60zme.detectClient)().atlassianMobileApp,
    redirectTo: null,
    redirectType: (0, $8dHAc.RedirectType).Migration,
    email: '',
    shouldSkipCaptcha: false
};
const $1999ac8408786e31$var$welcome = (state = $1999ac8408786e31$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 'WELCOME_SIGNUP_RESET':
            return $1999ac8408786e31$export$49d5fc8cba920a0;
        case 'WELCOME_SIGNUP_REQUEST':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                formError: null,
                fieldErrors: {},
                isLoading: true
            });
        case 'WELCOME_SIGNUP_REQUEST_SUCCESS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            });
        case 'WELCOME_SIGNUP_REQUEST_FAILED':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                error: null,
                formError: action.formError,
                isLoading: false
            });
        case 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS':
            return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                fieldErrors: action.errors,
                isLoading: false
            });
        case 'WELCOME_SIGNUP_SET_STATE':
            return (0, $ty6PY._)((0, $6EnDC._)((0, $ty6PY._)({}, state, action.state.recoveryToken && {
                recoveryToken: action.state.recoveryToken
            }), {
                redirectType: action.state.redirectType,
                shouldSkipCaptcha: action.state.shouldSkipCaptcha,
                email: action.state.email
            }), action.state.displayName && {
                displayName: action.state.displayName
            });
        default:
            return state;
    }
};
var $1999ac8408786e31$export$2e2bcd8739ae039 = $1999ac8408786e31$var$welcome;

});
parcelRegister("60zme", function(module, exports) {

$parcel$export(module.exports, "detectClient", function () { return $5ed541b2c53df5a1$export$dbd7930c526235a3; });
const $5ed541b2c53df5a1$var$userAgent = navigator.userAgent || navigator.vendor || window.opera;
const $5ed541b2c53df5a1$export$b7eb5c075a7422f3 = ()=>{
    if (/windows phone/i.test($5ed541b2c53df5a1$var$userAgent)) return 'windows phone';
    if (/android/i.test($5ed541b2c53df5a1$var$userAgent)) return 'android';
    if (/iPad|iPhone|iPod/.test($5ed541b2c53df5a1$var$userAgent) && !window.MSStream) return 'ios';
    return 'unknown';
};
const $5ed541b2c53df5a1$export$dbd7930c526235a3 = ()=>{
    return {
        platform: $5ed541b2c53df5a1$export$b7eb5c075a7422f3(),
        atlassianMobileApp: /AtlassianMobileApp/i.test($5ed541b2c53df5a1$var$userAgent)
    };
};

});


parcelRegister("wWEnh", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $a152319138357f8c$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $a152319138357f8c$export$2e2bcd8739ae039; });
const $a152319138357f8c$export$49d5fc8cba920a0 = {
    consentType: undefined
};
const $a152319138357f8c$var$loginConsent = (state = $a152319138357f8c$export$49d5fc8cba920a0)=>{
    return state;
};
var $a152319138357f8c$export$2e2bcd8739ae039 = $a152319138357f8c$var$loginConsent;

});

parcelRegister("4ZYno", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7cb8cdfb2d8018$export$2e2bcd8739ae039; });
const $bc7cb8cdfb2d8018$var$globalStateLoading = (state = false, action)=>{
    if (action.type === 'SET_GLOBAL_STATE_LOADING') return action.isLoading;
    return state;
};
var $bc7cb8cdfb2d8018$export$2e2bcd8739ae039 = $bc7cb8cdfb2d8018$var$globalStateLoading;

});


parcelRegister("3rl5T", function(module, exports) {

$parcel$export(module.exports, "idAuthMfaMiddleware", function () { return $4a0bd3d5ddd7886d$export$9c3b774af0e8f6c4; });

var $ty6PY = parcelRequire("ty6PY");

var $gyRZh = parcelRequire("gyRZh");

var $jSnDV = parcelRequire("jSnDV");

var $4yIkJ = parcelRequire("4yIkJ");

var $8f2pb = parcelRequire("8f2pb");

var $xe7jL = parcelRequire("xe7jL");

var $dZoLz = parcelRequire("dZoLz");

var $lk8Tl = parcelRequire("lk8Tl");

var $82mu7 = parcelRequire("82mu7");

var $lJ1Bt = parcelRequire("lJ1Bt");

var $kZj5j = parcelRequire("kZj5j");
const $4a0bd3d5ddd7886d$export$9c3b774af0e8f6c4 = ({ dispatch: dispatch })=>(next)=>(action)=>{
            switch(action.type){
                case 'MFA_VERIFICATION_VERIFY':
                    next(action);
                    // The action that calls fetch (/verify) and redirects
                    return dispatch($4a0bd3d5ddd7886d$export$5d2dfc489f5d5678(action));
                case 'MFA_VERIFICATION_RESEND_OTP':
                    next(action);
                    // The action that calls fetch to resend OTP code
                    // Transport (i.e. via SMS or Email) is determined by the mfa token.
                    return dispatch($4a0bd3d5ddd7886d$export$6a7404e2291306ab(action));
                case 'MFA_VERIFICATION_RECOVER':
                    next(action);
                    // The action that verifies recovery code
                    return dispatch($4a0bd3d5ddd7886d$export$d76d4fe28235a83(action));
                case 'MFA_VERIFICATION_CONFIRMED_RECOVER':
                    next(action);
                    // The action that calls /mfa/authorize and redirects
                    return dispatch($4a0bd3d5ddd7886d$export$8cfa5c421bdc24ae(action));
                case 'MFA_VERIFICATION_CHANGE_FACTOR':
                    next(action);
                    // The action that calls /mfa/change to switch MFA factors
                    return dispatch($4a0bd3d5ddd7886d$export$38c17aec706fc109(action));
                default:
                    next(action);
            }
        };
const $4a0bd3d5ddd7886d$export$6a7404e2291306ab = ({ params: params, analyticsClient: analyticsClient, navigate: navigate, mfaMethod: mfaMethod })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/resend${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                }
            });
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
            switch(response.status){
                case 200:
                    const { transactionToken: transactionToken } = await response.json();
                    navigate({
                        search: `?${new URLSearchParams({
                            transactionToken: transactionToken
                        })}`
                    }, {
                        replace: true
                    });
                    if (mfaMethod === 'email-otp') dispatch((0, $xe7jL.addFlag)('success', (0, $dZoLz.default).mfEmailResentSuccessTitle, (0, $dZoLz.default).mfEmailResentSuccessDesc));
                    else dispatch((0, $xe7jL.addFlag)('success', (0, $dZoLz.default).mfRecoverySMSResentSuccessTitle, (0, $dZoLz.default).mfRecoverySMSResentSuccessDesc));
                    break;
                case 400:
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svChallengeScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 422:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svInvalidPhoneNumber');
                    return dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfVerifyErrorTitle, (0, $dZoLz.default).mfSmsInvalidPhoneNumberDesc));
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svTooManySms');
                    $4a0bd3d5ddd7886d$var$handleError(dispatch);
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };

const $4a0bd3d5ddd7886d$export$5d2dfc489f5d5678 = ({ params: params, otpCode: otpCode, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch, getState)=>{
        try {
            const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
            const token = isCommercial ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : null;
            const response = await fetch(`/rest/mfa/verify${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify((0, $ty6PY._)({
                    otpCode: otpCode
                }, token && {
                    token: token
                }))
            });
            switch(response.status){
                case 200:
                    {
                        const { transactionToken: transactionToken } = await response.json();
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                        queryParams.transactionToken = transactionToken;
                        const authorizeResponse = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(queryParams)}`);
                        if (!authorizeResponse.ok) {
                            const error = await authorizeResponse.text();
                            throw new Error(error || authorizeResponse.statusText);
                        }
                        const { redirectUri: redirectUri } = await authorizeResponse.json();
                        maybeHardRedirect(redirectUri);
                        break;
                    }
                case 400:
                    {
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                        $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                            analyticsClient: analyticsClient,
                            page: '2svChallengeScreen',
                            subjectId: '2svIncorrectToken',
                            currentQueryParams: queryParams,
                            navigate: maybeHardRedirect
                        });
                        break;
                    }
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svIncorrectCode');
                    dispatch((0, $4yIkJ.mfaVerifyError)({
                        errorCode: 'invalid_otp',
                        message: 'invalid otp code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svUnknownError');
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
const $4a0bd3d5ddd7886d$export$d76d4fe28235a83 = ({ params: params, recoveryCode: recoveryCode, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/verify/recoverycode${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': getState().csrfToken
                },
                body: JSON.stringify({
                    recoveryCode: recoveryCode
                })
            });
            switch(response.status){
                case 200:
                    const { recoveryCode: recoveryCode1, transactionToken: transactionToken } = await response.json();
                    const newParams = {
                        continue: (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params).continue,
                        transactionToken: transactionToken.toString()
                    };
                    navigate({
                        search: `?${(0, $gyRZh.createSearchParams)(newParams)}`
                    }, {
                        replace: true
                    });
                    dispatch((0, $4yIkJ.mfaRecoverResponse)({
                        recoveryCode: recoveryCode1
                    }));
                    break;
                case 400:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svRecoveryKeyScreen',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: navigate
                    });
                    break;
                case 403:
                case 429:
                    analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svIncorrectCode');
                    dispatch((0, $4yIkJ.mfaRecoverError)({
                        errorCode: 'invalid_recovery_code',
                        message: 'invalid recovery code'
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from POST /rest/mfa/verify/recoverycode: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svRecoveryKeyScreen', '2svUnknownError');
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
const $4a0bd3d5ddd7886d$export$8cfa5c421bdc24ae = ({ params: params, analyticsClient: analyticsClient, maybeHardRedirect: maybeHardRedirect })=>async (dispatch)=>{
        try {
            const response = await fetch(`/rest/mfa/authorize${params}`);
            switch(response.status){
                case 200:
                    const { redirectUri: redirectUri } = await response.json();
                    maybeHardRedirect(redirectUri);
                    break;
                case 400:
                case 403:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: '2svSavedNewRecoveryKey',
                        subjectId: '2svIncorrectToken',
                        currentQueryParams: queryParams,
                        navigate: maybeHardRedirect
                    });
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from GET /rest/mfa/authorize: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svSavedNewRecoveryKey', '2svUnknownError');
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
const $4a0bd3d5ddd7886d$var$getSwitchMfaFactorErrorFlagMessages = (reason)=>{
    if (reason) switch(reason){
        case 'invalid_factor_type':
        case 'user_not_enrolled':
            return {
                title: (0, $dZoLz.default).mfSwitchFactorInvalidFactorTypeTitle,
                description: (0, $dZoLz.default).mfSwitchFactorInvalidFactorTypeDesc
            };
        case 'invalid_transaction_token':
            return {
                title: (0, $dZoLz.default).mfSwitchFactorInvalidTokenTitle,
                description: (0, $dZoLz.default).mfSwitchFactorInvalidTokenDesc
            };
        case 'expired_transaction_token':
            return {
                title: (0, $dZoLz.default).mfSwitchFactorTransactionExpiredTitle,
                description: (0, $dZoLz.default).mfSwitchFactorTransactionExpiredDesc
            };
    }
    return {
        title: (0, $dZoLz.default).mfSwitchFactorErrorTitle,
        description: (0, $dZoLz.default).mfSwitchFactorErrorDesc
    };
};
const $4a0bd3d5ddd7886d$export$38c17aec706fc109 = ({ params: params, factor: factor, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch)=>{
        try {
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
            const transactionToken = queryParams.transactionToken;
            if (!transactionToken) throw new Error('No transaction token found');
            const response = await fetch(`/rest/mfa/change?transactionToken=${transactionToken}&factor=${factor}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            switch(response.status){
                case 200:
                    {
                        const { token: newTransactionToken } = await response.json();
                        const updatedQueryParamString = (0, $kZj5j.replaceQueryParam)('transactionToken', newTransactionToken);
                        try {
                            const newStateResponse = await fetch(`/rest/login/mfa/state${updatedQueryParamString}`);
                            switch(newStateResponse.status){
                                case 200:
                                    {
                                        // This updates the search query params in the address bar, but does not trigger
                                        // a page reload due to the pathname remains unchanged
                                        // Setting this would ensure the user loads the page with the updated token should
                                        // they refresh (eg. F5) the page
                                        navigate({
                                            search: updatedQueryParamString
                                        });
                                        const newState = await newStateResponse.json();
                                        const transformedState = await (0, $82mu7.buildInitialState)(newState);
                                        dispatch((0, $lJ1Bt.resetAppState)(transformedState.initialStoreState));
                                        dispatch((0, $4yIkJ.resetMfaOtpInput)());
                                        break;
                                    }
                                default:
                                    throw Error(`Unexpected status code when fetching new state after switching MFA factor: ${response.status}`);
                            }
                        } catch (error) {
                            dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfSwitchFactorErrorTitle, (0, $dZoLz.default).mfSwitchFactorErrorDesc));
                            (0, $8f2pb.captureException)(error);
                        }
                        break;
                    }
                case 400:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorBadRequest');
                    try {
                        var _errorResponse_context;
                        const errorResponse = await response.json();
                        const { title: title, description: description } = $4a0bd3d5ddd7886d$var$getSwitchMfaFactorErrorFlagMessages(errorResponse === null || errorResponse === void 0 ? void 0 : (_errorResponse_context = errorResponse.context) === null || _errorResponse_context === void 0 ? void 0 : _errorResponse_context.reason);
                        dispatch((0, $xe7jL.addFlag)('error', title, description));
                    } catch (error) {
                        dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfSwitchFactorErrorTitle, (0, $dZoLz.default).mfSwitchFactorErrorDesc));
                        (0, $8f2pb.captureException)(error);
                    }
                    break;
                case 429:
                    analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorTooManyAttempts');
                    dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfSwitchFactorTooManyAttemptsTitle, (0, $dZoLz.default).mfSwitchFactorTooManyAttemptsDesc));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent('2svChallengeScreen', '2svSwitchFactorUnknownError');
            dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfSwitchFactorErrorTitle, (0, $dZoLz.default).mfSwitchFactorErrorDesc));
            (0, $8f2pb.captureException)(error);
        }
    };
function $4a0bd3d5ddd7886d$var$handleError(dispatch) {
    return dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfVerifyErrorTitle, (0, $dZoLz.default).mfVerifyErrorDesc));
}
function $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, page: page, subjectId: subjectId, currentQueryParams: currentQueryParams, navigate: navigate }) {
    analyticsClient.errorShownEvent(page, subjectId);
    delete currentQueryParams.transactionToken;
    delete currentQueryParams.errorCode;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    navigate(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`);
}

});
parcelRegister("4yIkJ", function(module, exports) {

$parcel$export(module.exports, "confirmedRecoveryCode", function () { return $4740302bde0586d8$export$9d6418e9b0c5e37; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $4740302bde0586d8$export$a5c568dd7addf7ae; });
$parcel$export(module.exports, "resendOtp", function () { return $4740302bde0586d8$export$fa0ba0eb6a79519c; });
$parcel$export(module.exports, "recoverAccount", function () { return $4740302bde0586d8$export$5e6ce816cc4182a; });
$parcel$export(module.exports, "mfaRecoverResponse", function () { return $4740302bde0586d8$export$9034102f3c89e717; });
$parcel$export(module.exports, "mfaVerifyError", function () { return $4740302bde0586d8$export$2026ab15e46bd57d; });
$parcel$export(module.exports, "mfaRecoverError", function () { return $4740302bde0586d8$export$3652b92f5dbdf874; });
$parcel$export(module.exports, "switchMfaFactor", function () { return $4740302bde0586d8$export$3c9096ff6f777303; });
$parcel$export(module.exports, "resetMfaOtpInput", function () { return $4740302bde0586d8$export$c82f9f96ca3abc9d; });
$parcel$export(module.exports, "sendRecoveryEmail", function () { return $4740302bde0586d8$export$ad7f1a4d46b544fc; });

var $8dHAc = parcelRequire("8dHAc");

var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");
const $4740302bde0586d8$export$9d6418e9b0c5e37 = (params, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_CONFIRMED_RECOVER',
        params: params,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $4740302bde0586d8$export$a5c568dd7addf7ae = (params, otpCode, analyticsClient, maybeHardRedirect)=>({
        type: 'MFA_VERIFICATION_VERIFY',
        params: params,
        otpCode: otpCode,
        analyticsClient: analyticsClient,
        maybeHardRedirect: maybeHardRedirect
    });
const $4740302bde0586d8$export$fa0ba0eb6a79519c = (params, analyticsClient, navigate, mfaMethod)=>({
        type: 'MFA_VERIFICATION_RESEND_OTP',
        params: params,
        analyticsClient: analyticsClient,
        navigate: navigate,
        mfaMethod: mfaMethod
    });
const $4740302bde0586d8$export$5e6ce816cc4182a = (params, recoveryCode, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_RECOVER',
        params: params,
        recoveryCode: recoveryCode,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $4740302bde0586d8$export$9034102f3c89e717 = ({ recoveryCode: recoveryCode })=>({
        type: 'MFA_VERIFICATION_RECOVER_RESPONSE',
        recoveryCode: recoveryCode
    });
const $4740302bde0586d8$export$2026ab15e46bd57d = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_VERIFY_ERROR',
        errorCode: errorCode,
        message: message
    });
const $4740302bde0586d8$export$3652b92f5dbdf874 = ({ errorCode: errorCode, message: message })=>({
        type: 'MFA_VERIFICATION_RECOVER_ERROR',
        errorCode: errorCode,
        message: message
    });
const $4740302bde0586d8$export$b147b2e1028c65fa = ()=>({
        type: 'RECOVERY_EMAIL_SENT'
    });
const $4740302bde0586d8$export$cc7dfbcab13c5eea = ()=>({
        type: 'RECOVERY_EMAIL_START'
    });
const $4740302bde0586d8$export$b760122b98e1a9be = (reason)=>({
        type: 'RECOVERY_EMAIL_ERROR',
        reason: reason
    });
const $4740302bde0586d8$export$3c9096ff6f777303 = (params, factor, analyticsClient, navigate)=>({
        type: 'MFA_VERIFICATION_CHANGE_FACTOR',
        params: params,
        factor: factor,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $4740302bde0586d8$export$c82f9f96ca3abc9d = ()=>({
        type: 'MFA_RESET_OTP_INPUT'
    });
const $4740302bde0586d8$export$ad7f1a4d46b544fc = (email)=>async (dispatch)=>{
        dispatch($4740302bde0586d8$export$cc7dfbcab13c5eea());
        try {
            var _body_error;
            const response = await fetch(`${(0, $lk8Tl.idacOrigin)}/rest/tsv-recovery/trigger`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email
                })
            });
            const body = await response.json();
            const errorReason = body === null || body === void 0 ? void 0 : (_body_error = body.error) === null || _body_error === void 0 ? void 0 : _body_error.reason;
            // Note that sing-in-service may return an error reason with a 200 response, in cases where
            // a non-200 response could introduce an account enumeration vulnerability.
            if (response.ok && !errorReason) dispatch($4740302bde0586d8$export$b147b2e1028c65fa());
            else {
                const narrowedReason = $4740302bde0586d8$var$narrowErrorReason(errorReason);
                dispatch($4740302bde0586d8$export$b760122b98e1a9be(narrowedReason));
            }
        } catch (e) {
            (0, $8f2pb.captureException)(e);
            dispatch($4740302bde0586d8$export$b760122b98e1a9be('unknown'));
        }
    };
const $4740302bde0586d8$var$isKnownRecoveryEmailErrorReason = (reason)=>(0, $8dHAc.KnownRecoveryEmailErrorReasons).includes(reason);
/** Maps arbitrary string returned by API to a type-safe value compatible with the redux state */ const $4740302bde0586d8$var$narrowErrorReason = (reason)=>{
    if (reason && $4740302bde0586d8$var$isKnownRecoveryEmailErrorReason(reason)) return reason;
    return 'unknown';
};

});

parcelRegister("xe7jL", function(module, exports) {

$parcel$export(module.exports, "addFlag", function () { return $44b115d1498b33eb$export$820a1da46c7a4303; });
$parcel$export(module.exports, "dismissFlag", function () { return $44b115d1498b33eb$export$900a08a292ad23cd; });

var $a6HGw = parcelRequire("a6HGw");
const $44b115d1498b33eb$export$820a1da46c7a4303 = (type, title, description)=>({
        type: 'FLAG_ADD',
        flag: {
            type: type,
            title: title,
            description: description,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($a6HGw))).v4()
        }
    });
const $44b115d1498b33eb$export$900a08a292ad23cd = ()=>({
        type: 'FLAG_DISMISS'
    });

});

parcelRegister("dZoLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ac3884d4ac2a263$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $1ac3884d4ac2a263$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    loginHeadTitle: {
        id: 'mf.login.head.title',
        defaultMessage: 'Continue with multi-factor authentication',
        description: ''
    },
    // Flags
    mfRecoveryEmailResentSuccessTitle: {
        id: 'mf.recoveryemailresentsuccess.title',
        defaultMessage: 'Recovery email resent!',
        description: ''
    },
    mfRecoveryEmailResentSuccessDesc: {
        id: 'mf.recoveryemailresentsuccess',
        defaultMessage: 'A recovery email has been resent to you!',
        description: ''
    },
    mfRecoveryEmailResentErrorTitle: {
        id: 'mf.recoveryemailresenterror.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    mfRecoveryEmailResentErrorDesc: {
        id: 'mf.recoveryemailresenterror',
        defaultMessage: "We couldn\u2019t send the recovery email. Please try again later.",
        description: ''
    },
    mfRecoverySMSResentSuccessTitle: {
        id: 'mf.recoverysmsresentsuccess.title',
        defaultMessage: 'SMS resent!',
        description: ''
    },
    mfRecoverySMSResentSuccessDesc: {
        id: 'mf.recoverysmsresentsuccess',
        defaultMessage: 'A SMS has been resent to you!',
        description: ''
    },
    mfEmailResentSuccessTitle: {
        id: 'mf.emailresentsuccess.title',
        defaultMessage: 'Email resent!',
        description: ''
    },
    mfEmailResentSuccessDesc: {
        id: 'mf.emailresentsuccess',
        defaultMessage: 'An Email has been resent to you!',
        description: ''
    },
    mfVerifyErrorTitle: {
        id: 'guardian.error.default.flag.title',
        defaultMessage: "Oops, that didn't work!"
    },
    mfVerifyErrorDesc: {
        id: 'guardian.error.default.flag.description',
        defaultMessage: 'Try that again in a moment.'
    },
    // eg. if Twilio deprecates service in the country
    mfSmsInvalidPhoneNumberDesc: {
        id: 'mf.sms.invalidphonenumber.description',
        defaultMessage: 'Unable to send verification code to the registered phone number. Try again later, or navigate to the recovery code screen and use your recovery code to continue.'
    },
    mfSwitchToSms: {
        id: 'mf.switch-to.sms',
        defaultMessage: 'Use SMS instead',
        description: 'Button text to switch to SMS verification'
    },
    mfSwitchToTotp: {
        id: 'mf.switch-to.authenticator',
        defaultMessage: 'Use authenticator app instead',
        description: 'Button text to switch to authenticator verification'
    },
    mfSwitchToSecurityKey: {
        id: 'mf.switch-to.security.key',
        defaultMessage: 'Use security key instead',
        description: 'Button text to switch to security key verification'
    },
    mfSwitchFactorInvalidFactorTypeTitle: {
        id: 'mf.switch-factor.invalid-factor-type.title',
        defaultMessage: 'Invalid method',
        description: 'Title for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidFactorTypeDesc: {
        id: 'mf.switch-factor.invalid-factor-type.description',
        defaultMessage: 'The selected verification method is not supported. Try a different option.',
        description: 'Description for invalid factor type error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenTitle: {
        id: 'mf.switch-factor.invalid-transaction-token.title',
        defaultMessage: 'Invalid request',
        description: 'Title for invalid transaction token error when switching MFA factors'
    },
    mfSwitchFactorInvalidTokenDesc: {
        id: 'mf.switch-factor.invalid-transaction-token.description',
        defaultMessage: 'Your request cannot be processed.',
        description: 'Description for invalid token error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredTitle: {
        id: 'mf.switch-factor.expired_transaction_token.title',
        defaultMessage: 'Request expired',
        description: 'Title for expired transaction error when switching MFA factors'
    },
    mfSwitchFactorTransactionExpiredDesc: {
        id: 'mf.switch-factor.expired-transaction-token.description',
        defaultMessage: 'Your login request has expired',
        description: 'Description for expired transaction when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsTitle: {
        id: 'mf.switch-factor.too-many-attempts.title',
        defaultMessage: 'Too many requests',
        description: 'Title for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorTooManyAttemptsDesc: {
        id: 'mf.switch-factor.too-many-attempts.description',
        defaultMessage: "You've reached your rate limit. Try again in a few minutes.",
        description: 'Description for reaching rate limit when switching MFA factors'
    },
    mfSwitchFactorErrorTitle: {
        id: 'mf.switch-factor.error.title',
        defaultMessage: 'Unable to change method',
        description: 'Title for generic factor switching error'
    },
    mfSwitchFactorErrorDesc: {
        id: 'mf.switch-factor.error.description',
        defaultMessage: 'We encountered an issue while changing your verification method. Try again later.',
        description: 'Description for generic factor switching error'
    },
    // recovery code
    mfSwitchToRecoveryCode: {
        id: 'mf.switch-to.recovery-code',
        defaultMessage: 'Use recovery key instead',
        description: 'Button text to switch to solving MFA challenge with recovery key'
    }
});

});
parcelRegister("3VrrU", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $2dbbfcca6e7db2d0$export$1adfeb024f5185b; });
$parcel$export(module.exports, "defineMessage", function () { return $2dbbfcca6e7db2d0$export$747d244ee58120dd; });

var $h5j41 = parcelRequire("h5j41");


var $iSD9t = parcelRequire("iSD9t");

var $4OQoZ = parcelRequire("4OQoZ");




var $gGDrC = parcelRequire("gGDrC");


function $2dbbfcca6e7db2d0$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $2dbbfcca6e7db2d0$export$747d244ee58120dd(msg) {
    return msg;
}
var $2dbbfcca6e7db2d0$export$40ae3194919d16b = (0, $h5j41.createFormattedComponent)('formatDate');
var $2dbbfcca6e7db2d0$export$5b390a54f8a846f7 = (0, $h5j41.createFormattedComponent)('formatTime');
var $2dbbfcca6e7db2d0$export$db80edc1e6b2f63d = (0, $h5j41.createFormattedComponent)('formatNumber');
var $2dbbfcca6e7db2d0$export$f52b44e459e6e71d = (0, $h5j41.createFormattedComponent)('formatList');
var $2dbbfcca6e7db2d0$export$c2336ea5aaab92fa = (0, $h5j41.createFormattedComponent)('formatDisplayName');
var $2dbbfcca6e7db2d0$export$7fdc7d2c91ce149b = (0, $h5j41.createFormattedDateTimePartsComponent)('formatDate');
var $2dbbfcca6e7db2d0$export$ec35873761676c2a = (0, $h5j41.createFormattedDateTimePartsComponent)('formatTime');

});
parcelRegister("h5j41", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $c701b101618df8e9$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $c701b101618df8e9$export$b37e14176d001dec; });

var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");
var $c701b101618df8e9$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($c701b101618df8e9$var$DisplayName || ($c701b101618df8e9$var$DisplayName = {}));
var $c701b101618df8e9$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($c701b101618df8e9$var$DisplayNameParts || ($c701b101618df8e9$var$DisplayNameParts = {}));
var $c701b101618df8e9$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $iSD9t.default)();
    var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$c701b101618df8e9$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $c701b101618df8e9$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $iSD9t.default)();
    var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$c701b101618df8e9$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $c701b101618df8e9$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $iSD9t.default)();
        var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $c701b101618df8e9$var$DisplayNameParts[name];
    return ComponentParts;
}
function $c701b101618df8e9$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $iSD9t.default)();
        var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $8ZuGG.Fragment;
        return $8ZuGG.createElement(Text, null, formattedValue);
    };
    Component.displayName = $c701b101618df8e9$var$DisplayName[name];
    return Component;
}

});
parcelRegister("67Ijb", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $4755c441f34c720a$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $4755c441f34c720a$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $4755c441f34c720a$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $4755c441f34c720a$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $4755c441f34c720a$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArray", function () { return $4755c441f34c720a$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $4755c441f34c720a$var$extendStatics = function(d, b) {
    $4755c441f34c720a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4755c441f34c720a$var$extendStatics(d, b);
};
function $4755c441f34c720a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4755c441f34c720a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4755c441f34c720a$export$18ce0697a983be9b = function() {
    $4755c441f34c720a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4755c441f34c720a$export$18ce0697a983be9b.apply(this, arguments);
};
function $4755c441f34c720a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4755c441f34c720a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4755c441f34c720a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4755c441f34c720a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4755c441f34c720a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4755c441f34c720a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4755c441f34c720a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4755c441f34c720a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4755c441f34c720a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4755c441f34c720a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4755c441f34c720a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4755c441f34c720a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4755c441f34c720a$export$45d3717a4c69092e(o, m, p);
}
function $4755c441f34c720a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4755c441f34c720a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4755c441f34c720a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4755c441f34c720a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4755c441f34c720a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4755c441f34c720a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4755c441f34c720a$export$10c90e4f7922046c(v) {
    return this instanceof $4755c441f34c720a$export$10c90e4f7922046c ? (this.v = v, this) : new $4755c441f34c720a$export$10c90e4f7922046c(v);
}
function $4755c441f34c720a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4755c441f34c720a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4755c441f34c720a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4755c441f34c720a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4755c441f34c720a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4755c441f34c720a$export$19a8beecd37a4c45 === "function" ? $4755c441f34c720a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4755c441f34c720a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4755c441f34c720a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $4755c441f34c720a$var$ownKeys = function(o) {
    $4755c441f34c720a$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $4755c441f34c720a$var$ownKeys(o);
};
function $4755c441f34c720a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $4755c441f34c720a$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $4755c441f34c720a$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $4755c441f34c720a$var$__setModuleDefault(result, mod);
    return result;
}
function $4755c441f34c720a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4755c441f34c720a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4755c441f34c720a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4755c441f34c720a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4755c441f34c720a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4755c441f34c720a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4755c441f34c720a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4755c441f34c720a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $4755c441f34c720a$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $4755c441f34c720a$export$2e2bcd8739ae039 = {
    __extends: $4755c441f34c720a$export$a8ba968b8961cb8a,
    __assign: $4755c441f34c720a$export$18ce0697a983be9b,
    __rest: $4755c441f34c720a$export$3c9a16f847548506,
    __decorate: $4755c441f34c720a$export$29e00dfd3077644b,
    __param: $4755c441f34c720a$export$d5ad3fd78186038f,
    __esDecorate: $4755c441f34c720a$export$3a84e1ae4e97e9b0,
    __runInitializers: $4755c441f34c720a$export$d831c04e792af3d,
    __propKey: $4755c441f34c720a$export$6a2a36740a146cb8,
    __setFunctionName: $4755c441f34c720a$export$d1a06452d3489bc7,
    __metadata: $4755c441f34c720a$export$f1db080c865becb9,
    __awaiter: $4755c441f34c720a$export$1050f835b63b671e,
    __generator: $4755c441f34c720a$export$67ebef60e6f28a6,
    __createBinding: $4755c441f34c720a$export$45d3717a4c69092e,
    __exportStar: $4755c441f34c720a$export$f33643c0debef087,
    __values: $4755c441f34c720a$export$19a8beecd37a4c45,
    __read: $4755c441f34c720a$export$8d051b38c9118094,
    __spread: $4755c441f34c720a$export$afc72e2116322959,
    __spreadArrays: $4755c441f34c720a$export$6388937ca91ccae8,
    __spreadArray: $4755c441f34c720a$export$1216008129fb82ed,
    __await: $4755c441f34c720a$export$10c90e4f7922046c,
    __asyncGenerator: $4755c441f34c720a$export$e427f37a30a4de9b,
    __asyncDelegator: $4755c441f34c720a$export$bbd80228419bb833,
    __asyncValues: $4755c441f34c720a$export$e3b29a3d6162315f,
    __makeTemplateObject: $4755c441f34c720a$export$4fb47efe1390b86f,
    __importStar: $4755c441f34c720a$export$c21735bcef00d192,
    __importDefault: $4755c441f34c720a$export$da59b14a69baef04,
    __classPrivateFieldGet: $4755c441f34c720a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4755c441f34c720a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4755c441f34c720a$export$81fdc39f203e4e04,
    __addDisposableResource: $4755c441f34c720a$export$88ac25d8e944e405,
    __disposeResources: $4755c441f34c720a$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $4755c441f34c720a$export$889dfb5d17574b0b
};

});

parcelRegister("iSD9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbeba3e564b77d86$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $aqUEs = parcelRequire("aqUEs");
function $dbeba3e564b77d86$export$2e2bcd8739ae039() {
    var intl = $8ZuGG.useContext((0, $aqUEs.Context));
    (0, $7tq3X.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("7tq3X", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $570f755facdf1903$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $570f755facdf1903$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $570f755facdf1903$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $570f755facdf1903$export$d36bdfa510afb180; });

var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $7K6E3 = parcelRequire("7K6E3");

var $f8XZf = parcelRequire("f8XZf");
function $570f755facdf1903$export$45c4bbf6e55bba1f(intl) {
    (0, $7K6E3.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $570f755facdf1903$export$b52f8d6fc0d47415 = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $f8XZf.DEFAULT_INTL_CONFIG)), {
    textComponent: $8ZuGG.Fragment
});
function $570f755facdf1903$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($8ZuGG.Children.toArray(parts));
    };
}
function $570f755facdf1903$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("7K6E3", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $5a31fbde7b3ca162$export$f5708dca728d7177; });

var $67Ijb = parcelRequire("67Ijb");

var $gv1Yy = parcelRequire("gv1Yy");
function $5a31fbde7b3ca162$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $5a31fbde7b3ca162$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === 'function') return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join('');
}
function $5a31fbde7b3ca162$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $5a31fbde7b3ca162$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $5a31fbde7b3ca162$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $5a31fbde7b3ca162$export$3fae2929ed23c202(map, pl, field) {
    return $5a31fbde7b3ca162$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $5a31fbde7b3ca162$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $5a31fbde7b3ca162$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === 'literal';
}
function $5a31fbde7b3ca162$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $5a31fbde7b3ca162$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $5a31fbde7b3ca162$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $5a31fbde7b3ca162$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
var $5a31fbde7b3ca162$export$a99e4aaac79eeead = (0, $gv1Yy.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $gv1Yy.strategies).variadic
});
var $5a31fbde7b3ca162$export$b479a1a2d8754359 = (0, $gv1Yy.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $gv1Yy.strategies).variadic
});
var $5a31fbde7b3ca162$export$569bb3095db8432e = (0, $gv1Yy.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $67Ijb.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $gv1Yy.strategies).variadic
});
var $5a31fbde7b3ca162$export$e124bc7d23dd0e5a = (0, $gv1Yy.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.Locale).bind.apply(_a, (0, $67Ijb.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $gv1Yy.strategies).variadic
});
var $5a31fbde7b3ca162$export$a1209f8c6068edc3 = (0, $gv1Yy.memoize)(function() {
    var _a;
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return new ((_a = Intl.ListFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
        void 0
    ], args, false)))();
}, {
    strategy: (0, $gv1Yy.strategies).variadic
});

});
parcelRegister("gv1Yy", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $c03112e7fee4dee7$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $c03112e7fee4dee7$export$c5491a8691a23b9e; });
//
// Main
//
function $c03112e7fee4dee7$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c03112e7fee4dee7$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c03112e7fee4dee7$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c03112e7fee4dee7$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c03112e7fee4dee7$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c03112e7fee4dee7$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c03112e7fee4dee7$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c03112e7fee4dee7$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c03112e7fee4dee7$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c03112e7fee4dee7$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c03112e7fee4dee7$var$monadic : $c03112e7fee4dee7$var$variadic;
    return $c03112e7fee4dee7$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c03112e7fee4dee7$var$strategyVariadic(fn, options) {
    return $c03112e7fee4dee7$var$assemble(fn, this, $c03112e7fee4dee7$var$variadic, options.cache.create(), options.serializer);
}
function $c03112e7fee4dee7$var$strategyMonadic(fn, options) {
    return $c03112e7fee4dee7$var$assemble(fn, this, $c03112e7fee4dee7$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c03112e7fee4dee7$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c03112e7fee4dee7$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c03112e7fee4dee7$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c03112e7fee4dee7$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c03112e7fee4dee7$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c03112e7fee4dee7$var$ObjectWithoutPrototypeCache();
    }
};
var $c03112e7fee4dee7$export$c5491a8691a23b9e = {
    variadic: $c03112e7fee4dee7$var$strategyVariadic,
    monadic: $c03112e7fee4dee7$var$strategyMonadic
};

});


parcelRegister("f8XZf", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $b06622817ee75087$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $b06622817ee75087$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $b06622817ee75087$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $b06622817ee75087$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $b06622817ee75087$export$4ee1db8ce44a209b; });

var $67Ijb = parcelRequire("67Ijb");
parcelRequire("jdODR");
var $ck9OU = parcelRequire("ck9OU");

var $gv1Yy = parcelRequire("gv1Yy");

var $eczN4 = parcelRequire("eczN4");
function $b06622817ee75087$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b06622817ee75087$var$defaultErrorHandler = function(error) {};
var $b06622817ee75087$var$defaultWarnHandler = function(warning) {};
var $b06622817ee75087$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b06622817ee75087$var$defaultErrorHandler,
    onWarn: $b06622817ee75087$var$defaultWarnHandler
};
function $b06622817ee75087$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b06622817ee75087$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b06622817ee75087$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b06622817ee75087$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    var getNumberFormat = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.number),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    var getPluralRules = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $gv1Yy.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $ck9OU.IntlMessageFormat)(message, locales, overrideFormats, (0, $67Ijb.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.message),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.list),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getDisplayNames: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $gv1Yy.strategies).variadic
        })
    };
}
function $b06622817ee75087$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $eczN4.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("jdODR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("f8FMY")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("f8FMY")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("gIvaJ")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("ck9OU")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $ck9OU = parcelRequire("ck9OU");
parcelRequire("f8FMY");
parcelRequire("gIvaJ");
var $dfe683a875b0f3ae$export$2e2bcd8739ae039 = (0, $ck9OU.IntlMessageFormat);

});
parcelRegister("ck9OU", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $8f8ef85f4dc8f292$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $67Ijb = parcelRequire("67Ijb");

var $gv1Yy = parcelRequire("gv1Yy");

var $c9zsJ = parcelRequire("c9zsJ");

var $gIvaJ = parcelRequire("gIvaJ");
// -- MessageFormat --------------------------------------------------------
function $8f8ef85f4dc8f292$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $8f8ef85f4dc8f292$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $8f8ef85f4dc8f292$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $67Ijb.__assign)({}, defaultConfig));
}
function $8f8ef85f4dc8f292$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $8f8ef85f4dc8f292$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.number),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getDateTimeFormat: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getPluralRules: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $gv1Yy.strategies).variadic
        })
    };
}
var $8f8ef85f4dc8f292$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $gIvaJ.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $gIvaJ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $67Ijb.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $8f8ef85f4dc8f292$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $8f8ef85f4dc8f292$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $c9zsJ.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("c9zsJ", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("9xfwH")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("9xfwH")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("9xfwH")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("9xfwH")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("9xfwH")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("9xfwH")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("9xfwH")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("9xfwH")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("9xfwH")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("9xfwH")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("9xfwH")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("9xfwH")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $8d91d56446ae4c21$export$98e6a39c04603d36; });

var $67Ijb = parcelRequire("67Ijb");

var $jfA3D = parcelRequire("jfA3D");

var $5lBAM = parcelRequire("5lBAM");

var $9xfwH = parcelRequire("9xfwH");
function $8d91d56446ae4c21$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $9xfwH.isSelectElement)(el) || (0, $9xfwH.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $8d91d56446ae4c21$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $9xfwH.isNumberElement)(el) && (0, $9xfwH.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $9xfwH.isDateElement)(el) || (0, $9xfwH.isTimeElement)(el)) && (0, $9xfwH.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $9xfwH.isTagElement)(el)) $8d91d56446ae4c21$var$pruneLocation(el.children);
    });
}
function $8d91d56446ae4c21$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $67Ijb.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5lBAM.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $jfA3D.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $8d91d56446ae4c21$var$pruneLocation(result.val);
    return result.val;
}
var $8d91d56446ae4c21$export$d3c1bfa0f7d806e9 = (0, $5lBAM.Parser);

});
parcelRegister("jfA3D", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $e03b635226fde957$export$896afd8541959ee5; });
var $e03b635226fde957$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($e03b635226fde957$export$896afd8541959ee5 || ($e03b635226fde957$export$896afd8541959ee5 = {}));

});

parcelRegister("5lBAM", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3e4c12f47abf381d$export$7acfa6ed01010e37; });

var $67Ijb = parcelRequire("67Ijb");

var $jfA3D = parcelRequire("jfA3D");

var $9xfwH = parcelRequire("9xfwH");

var $flpAn = parcelRequire("flpAn");
parcelRequire("cyIiz");
var $dD2LQ = parcelRequire("dD2LQ");
var $dHvuO = parcelRequire("dHvuO");

var $6Vsua = parcelRequire("6Vsua");
var $3e4c12f47abf381d$var$_a;
var $3e4c12f47abf381d$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $flpAn.SPACE_SEPARATOR_REGEX).source, "*"));
var $3e4c12f47abf381d$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $flpAn.SPACE_SEPARATOR_REGEX).source, "*$"));
function $3e4c12f47abf381d$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $3e4c12f47abf381d$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $3e4c12f47abf381d$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $3e4c12f47abf381d$var$hasNativeFromEntries = !!Object.fromEntries;
var $3e4c12f47abf381d$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $3e4c12f47abf381d$var$hasTrimStart = !!String.prototype.trimStart;
var $3e4c12f47abf381d$var$hasTrimEnd = !!String.prototype.trimEnd;
var $3e4c12f47abf381d$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $3e4c12f47abf381d$var$isSafeInteger = $3e4c12f47abf381d$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $3e4c12f47abf381d$var$re = $3e4c12f47abf381d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = (($3e4c12f47abf381d$var$_a = $3e4c12f47abf381d$var$re.exec('a')) === null || $3e4c12f47abf381d$var$_a === void 0 ? void 0 : $3e4c12f47abf381d$var$_a[0]) === 'a';
} catch (_) {
    $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $3e4c12f47abf381d$var$startsWith = $3e4c12f47abf381d$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $3e4c12f47abf381d$var$fromCodePoint = $3e4c12f47abf381d$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $3e4c12f47abf381d$var$fromEntries = // native
$3e4c12f47abf381d$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $3e4c12f47abf381d$var$codePointAt = $3e4c12f47abf381d$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $3e4c12f47abf381d$var$trimStart = $3e4c12f47abf381d$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($3e4c12f47abf381d$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $3e4c12f47abf381d$var$trimEnd = $3e4c12f47abf381d$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($3e4c12f47abf381d$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $3e4c12f47abf381d$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $3e4c12f47abf381d$var$matchIdentifierAtIndex;
if ($3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1 = $3e4c12f47abf381d$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $3e4c12f47abf381d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$3e4c12f47abf381d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $3e4c12f47abf381d$var$codePointAt(s, index);
        if (c === undefined || $3e4c12f47abf381d$var$_isWhiteSpace(c) || $3e4c12f47abf381d$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $3e4c12f47abf381d$var$fromCodePoint.apply(void 0, match);
};
var $3e4c12f47abf381d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $9xfwH.TYPE).pound,
                    location: $3e4c12f47abf381d$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $jfA3D.ErrorKind).UNMATCHED_CLOSING_TAG, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $3e4c12f47abf381d$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $9xfwH.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$3e4c12f47abf381d$var$_isAlpha(this.char())) return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $jfA3D.ErrorKind).UNMATCHED_CLOSING_TAG, $3e4c12f47abf381d$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $9xfwH.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $jfA3D.ErrorKind).UNCLOSED_TAG, $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $3e4c12f47abf381d$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $3e4c12f47abf381d$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $9xfwH.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$3e4c12f47abf381d$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $3e4c12f47abf381d$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $3e4c12f47abf381d$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $jfA3D.ErrorKind).EMPTY_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $jfA3D.ErrorKind).MALFORMED_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $9xfwH.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $jfA3D.ErrorKind).MALFORMED_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $3e4c12f47abf381d$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $3e4c12f47abf381d$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_TYPE, $3e4c12f47abf381d$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $3e4c12f47abf381d$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_STYLE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $3e4c12f47abf381d$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $3e4c12f47abf381d$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $3e4c12f47abf381d$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $9xfwH.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $jfA3D.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $6Vsua.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $9xfwH.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dD2LQ.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $9xfwH.TYPE).date : (0, $9xfwH.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $9xfwH.TYPE).number : argType === 'date' ? (0, $9xfwH.TYPE).date : (0, $9xfwH.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $3e4c12f47abf381d$var$createLocation(typeEndPosition_1, (0, $67Ijb.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $jfA3D.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $9xfwH.TYPE).select,
                        value: value,
                        options: $3e4c12f47abf381d$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $9xfwH.TYPE).plural,
                        value: value,
                        options: $3e4c12f47abf381d$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $jfA3D.ErrorKind).INVALID_ARGUMENT_TYPE, $3e4c12f47abf381d$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $jfA3D.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $3e4c12f47abf381d$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $dHvuO.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $jfA3D.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $9xfwH.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $dHvuO.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $jfA3D.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $jfA3D.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $jfA3D.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $jfA3D.ErrorKind).MISSING_OTHER_CLAUSE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $3e4c12f47abf381d$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$3e4c12f47abf381d$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $3e4c12f47abf381d$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($3e4c12f47abf381d$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $3e4c12f47abf381d$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $3e4c12f47abf381d$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $3e4c12f47abf381d$var$_isAlphaOrSlash(codepoint) {
    return $3e4c12f47abf381d$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $3e4c12f47abf381d$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e4c12f47abf381d$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e4c12f47abf381d$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("9xfwH", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $6f133d57d9eeaa00$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $6f133d57d9eeaa00$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $6f133d57d9eeaa00$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $6f133d57d9eeaa00$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $6f133d57d9eeaa00$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $6f133d57d9eeaa00$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $6f133d57d9eeaa00$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $6f133d57d9eeaa00$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $6f133d57d9eeaa00$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $6f133d57d9eeaa00$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $6f133d57d9eeaa00$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $6f133d57d9eeaa00$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $6f133d57d9eeaa00$export$7680c41f1a55f4cf; });
var $6f133d57d9eeaa00$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($6f133d57d9eeaa00$export$b87f371cbc396fcf || ($6f133d57d9eeaa00$export$b87f371cbc396fcf = {}));
var $6f133d57d9eeaa00$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($6f133d57d9eeaa00$export$906452485466fa53 || ($6f133d57d9eeaa00$export$906452485466fa53 = {}));
function $6f133d57d9eeaa00$export$cfa10c5697238752(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.literal;
}
function $6f133d57d9eeaa00$export$4f55724281bdfaf9(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.argument;
}
function $6f133d57d9eeaa00$export$e11187b219e191e1(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.number;
}
function $6f133d57d9eeaa00$export$32d811605da75f40(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.date;
}
function $6f133d57d9eeaa00$export$34ec46f596b1702f(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.time;
}
function $6f133d57d9eeaa00$export$dcfe1c11d168b5a1(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.select;
}
function $6f133d57d9eeaa00$export$6c796d116f0a4fbc(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.plural;
}
function $6f133d57d9eeaa00$export$c0ece297bdd0c082(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.pound;
}
function $6f133d57d9eeaa00$export$5c83de34745812b(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.tag;
}
function $6f133d57d9eeaa00$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $6f133d57d9eeaa00$export$906452485466fa53.number);
}
function $6f133d57d9eeaa00$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $6f133d57d9eeaa00$export$906452485466fa53.dateTime);
}
function $6f133d57d9eeaa00$export$f0ac572c1121c662(value) {
    return {
        type: $6f133d57d9eeaa00$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $6f133d57d9eeaa00$export$425e864b0ba114f1(value, style) {
    return {
        type: $6f133d57d9eeaa00$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("flpAn", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $b2bca9f36880188e$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $b2bca9f36880188e$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $b2bca9f36880188e$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("cyIiz", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("dD2LQ")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("dHvuO")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("dHvuO")).parseNumberSkeletonFromString; });
parcelRequire("dD2LQ");
parcelRequire("dHvuO");

});
parcelRegister("dD2LQ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $9ec111154ef35987$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $9ec111154ef35987$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $9ec111154ef35987$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($9ec111154ef35987$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("dHvuO", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $9f97b8eee5fb553f$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $9f97b8eee5fb553f$export$47c6f8480bda3e11; });

var $67Ijb = parcelRequire("67Ijb");

var $kc2K8 = parcelRequire("kc2K8");
function $9f97b8eee5fb553f$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $kc2K8.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $9f97b8eee5fb553f$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $9f97b8eee5fb553f$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $9f97b8eee5fb553f$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $9f97b8eee5fb553f$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $9f97b8eee5fb553f$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $9f97b8eee5fb553f$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $9f97b8eee5fb553f$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $9f97b8eee5fb553f$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $9f97b8eee5fb553f$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, all), $9f97b8eee5fb553f$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, all), $9f97b8eee5fb553f$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($9f97b8eee5fb553f$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), $9f97b8eee5fb553f$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), $9f97b8eee5fb553f$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $9f97b8eee5fb553f$var$parseSign(token.stem);
        if (signOpts) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $9f97b8eee5fb553f$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("kc2K8", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $eb370e5938ac123f$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $eb370e5938ac123f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("6Vsua", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $50ae2995bc40116c$export$29c5368be8904d27; });

var $8BB2d = parcelRequire("8BB2d");
function $50ae2995bc40116c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $50ae2995bc40116c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $50ae2995bc40116c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $8BB2d.timeData)[regionTag || ''] || (0, $8BB2d.timeData)[languageTag || ''] || (0, $8BB2d.timeData)["".concat(languageTag, "-001")] || (0, $8BB2d.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("8BB2d", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $643e81c68df697a3$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $643e81c68df697a3$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("gIvaJ", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $c2b8ef8a94f80586$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $c2b8ef8a94f80586$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $c2b8ef8a94f80586$export$275d4a3bb5f66fda; });
parcelRequire("c9zsJ");
var $9xfwH = parcelRequire("9xfwH");

var $f8FMY = parcelRequire("f8FMY");
var $c2b8ef8a94f80586$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c2b8ef8a94f80586$export$49694c2877b44c57 || ($c2b8ef8a94f80586$export$49694c2877b44c57 = {}));
function $c2b8ef8a94f80586$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c2b8ef8a94f80586$export$49694c2877b44c57.literal || part.type !== $c2b8ef8a94f80586$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c2b8ef8a94f80586$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $c2b8ef8a94f80586$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $9xfwH.isLiteralElement)(els[0])) return [
        {
            type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $9xfwH.isLiteralElement)(el)) {
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $9xfwH.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $f8FMY.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $9xfwH.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $c2b8ef8a94f80586$export$49694c2877b44c57.literal : $c2b8ef8a94f80586$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $9xfwH.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $9xfwH.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $9xfwH.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $9xfwH.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c2b8ef8a94f80586$export$df0c12a2d414a163(formatFn)) throw new (0, $f8FMY.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $c2b8ef8a94f80586$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $c2b8ef8a94f80586$export$49694c2877b44c57.literal : $c2b8ef8a94f80586$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $9xfwH.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $f8FMY.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c2b8ef8a94f80586$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $9xfwH.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $f8FMY.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $f8FMY.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $f8FMY.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c2b8ef8a94f80586$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c2b8ef8a94f80586$var$mergeLiteral(result);
}

});
parcelRegister("f8FMY", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $b05804c0e9d00735$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $b05804c0e9d00735$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $b05804c0e9d00735$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $b05804c0e9d00735$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $b05804c0e9d00735$export$8bfc137e4d23fdf0; });

var $67Ijb = parcelRequire("67Ijb");
var $b05804c0e9d00735$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b05804c0e9d00735$export$d4e71bc0b80dc0fb || ($b05804c0e9d00735$export$d4e71bc0b80dc0fb = {}));
var $b05804c0e9d00735$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b05804c0e9d00735$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b05804c0e9d00735$export$7369836851cc1329);
var $b05804c0e9d00735$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b05804c0e9d00735$export$7369836851cc1329);
var $b05804c0e9d00735$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b05804c0e9d00735$export$7369836851cc1329);

});




parcelRegister("eczN4", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $a56df2ead684ea09$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $a56df2ead684ea09$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $a56df2ead684ea09$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $a56df2ead684ea09$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $a56df2ead684ea09$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $a56df2ead684ea09$export$2ddcb436d0aa3688; });

var $67Ijb = parcelRequire("67Ijb");
var $a56df2ead684ea09$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($a56df2ead684ea09$export$557d6acb76e8a244 || ($a56df2ead684ea09$export$557d6acb76e8a244 = {}));
var $a56df2ead684ea09$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $a56df2ead684ea09$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($a56df2ead684ea09$export$e3b7eee1dbc44895);
var $a56df2ead684ea09$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);

});



parcelRegister("aqUEs", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $798846e583df1767$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $798846e583df1767$export$841858b892ce1f4c; });

var $67Ijb = parcelRequire("67Ijb");

var $fiQA5 = parcelRequire("fiQA5");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");
function $798846e583df1767$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $798846e583df1767$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $8ZuGG.createContext(null)) : $8ZuGG.createContext(null);
var $798846e583df1767$var$IntlConsumer = $798846e583df1767$var$IntlContext.Consumer, $798846e583df1767$var$IntlProvider = $798846e583df1767$var$IntlContext.Provider;
var $798846e583df1767$export$2881499e37b75b9a = $798846e583df1767$var$IntlProvider;
var $798846e583df1767$export$841858b892ce1f4c = $798846e583df1767$var$IntlContext;
function $798846e583df1767$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $8ZuGG.createElement($798846e583df1767$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $7tq3X.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $8ZuGG.createElement(WrappedComponent, (0, $67Ijb.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($798846e583df1767$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(// @ts-expect-error
    $8ZuGG.forwardRef(function(props, ref) {
        return $8ZuGG.createElement(WithIntl, (0, $67Ijb.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(WithIntl, WrappedComponent);
}

});



parcelRegister("4OQoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38247adf5897e304$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $aqUEs = parcelRequire("aqUEs");

var $3m0Mm = parcelRequire("3m0Mm");
function $38247adf5897e304$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $38247adf5897e304$var$IntlProvider = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $f8XZf.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $3m0Mm.createIntl)($38247adf5897e304$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $38247adf5897e304$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $38247adf5897e304$var$processIntlConfig(props);
        if (!(0, $7tq3X.shallowEqual)(prevConfig, config)) return {
            intl: (0, $3m0Mm.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $7tq3X.invariantIntlContext)(this.state.intl);
        return $8ZuGG.createElement((0, $aqUEs.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $7tq3X.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($8ZuGG.PureComponent);
var $38247adf5897e304$export$2e2bcd8739ae039 = $38247adf5897e304$var$IntlProvider;

});
parcelRegister("3m0Mm", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $271407e3c988b392$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $5Mwjf = parcelRequire("5Mwjf");
var $bjYjS = parcelRequire("bjYjS");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $gIvaJ = parcelRequire("gIvaJ");
function $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $gIvaJ.isFormatXMLElementFn)(v) ? (0, $7tq3X.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $271407e3c988b392$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $bjYjS.formatMessage).apply(void 0, (0, $67Ijb.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $8ZuGG.Children.toArray(chunks);
    return chunks;
};
var $271407e3c988b392$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $67Ijb.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $5Mwjf.createIntl)((0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $7tq3X.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, coreIntl), {
        formatMessage: $271407e3c988b392$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $271407e3c988b392$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("5Mwjf", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $435a7f698e952ae7$export$7e4cbedfdd7b4c0d; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");

var $atxLr = parcelRequire("atxLr");

var $cdU2A = parcelRequire("cdU2A");

var $dGVJ3 = parcelRequire("dGVJ3");

var $i5Sq1 = parcelRequire("i5Sq1");

var $bjYjS = parcelRequire("bjYjS");

var $ldlYY = parcelRequire("ldlYY");

var $fotED = parcelRequire("fotED");
function $435a7f698e952ae7$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $435a7f698e952ae7$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $435a7f698e952ae7$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
}
function $435a7f698e952ae7$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $f8XZf.createFormatters)(cache);
    var resolvedConfig = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $f8XZf.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $eczN4.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $eczN4.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $eczN4.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    $435a7f698e952ae7$var$verifyConfigMessages(resolvedConfig);
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $atxLr.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $atxLr.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $cdU2A.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $dGVJ3.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $dGVJ3.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $dGVJ3.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $dGVJ3.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $dGVJ3.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $i5Sq1.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $bjYjS.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $bjYjS.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $ldlYY.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $ldlYY.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $fotED.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("atxLr", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $7a06cdad1b364a81$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $7a06cdad1b364a81$export$6871080848f10b2f; });

var $eczN4 = parcelRequire("eczN4");

var $f8XZf = parcelRequire("f8XZf");
var $7a06cdad1b364a81$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $7a06cdad1b364a81$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $f8XZf.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $f8XZf.filterProps)(options, $7a06cdad1b364a81$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $7a06cdad1b364a81$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7a06cdad1b364a81$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $7a06cdad1b364a81$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7a06cdad1b364a81$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("cdU2A", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $8e622b7723ad49a6$export$b4ea3b48dcf921f6; });

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $8e622b7723ad49a6$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $8e622b7723ad49a6$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $f8XZf.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $f8XZf.filterProps)(options, $8e622b7723ad49a6$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $8e622b7723ad49a6$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $f8FMY.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    try {
        return $8e622b7723ad49a6$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});

parcelRegister("dGVJ3", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $029284071db7694b$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $029284071db7694b$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $029284071db7694b$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $029284071db7694b$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $029284071db7694b$export$af6e5d7a5c73edeb; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");
var $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $029284071db7694b$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $f8XZf.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $029284071db7694b$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $029284071db7694b$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $029284071db7694b$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $f8XZf.filterProps)(options, $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(from);
}
function $029284071db7694b$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $029284071db7694b$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("i5Sq1", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $d2c2e80a84533d3d$export$bbbd05c900f3568d; });

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");

var $f8FMY = parcelRequire("f8FMY");
var $d2c2e80a84533d3d$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $d2c2e80a84533d3d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $f8FMY.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $d2c2e80a84533d3d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("bjYjS", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $83e0424c274dd68e$export$25868d1e8e76735f; });

var $67Ijb = parcelRequire("67Ijb");

var $7K6E3 = parcelRequire("7K6E3");
parcelRequire("jdODR");
var $ck9OU = parcelRequire("ck9OU");

var $eczN4 = parcelRequire("eczN4");
parcelRequire("c9zsJ");
var $9xfwH = parcelRequire("9xfwH");
function $83e0424c274dd68e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $83e0424c274dd68e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $ck9OU.IntlMessageFormat).formats;
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, mfFormats), f1), {
        date: $83e0424c274dd68e$var$deepMergeOptions($83e0424c274dd68e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $83e0424c274dd68e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $83e0424c274dd68e$var$deepMergeOptions($83e0424c274dd68e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $83e0424c274dd68e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $83e0424c274dd68e$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $7K6E3.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $9xfwH.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, defaultRichTextElements), values || {});
    formats = $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $eczN4.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $eczN4.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $67Ijb.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $eczN4.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $eczN4.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("ldlYY", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $f71bdd240b06797b$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $f71bdd240b06797b$export$6f284aad1934db69; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $f71bdd240b06797b$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $f71bdd240b06797b$var$now = Date.now();
function $f71bdd240b06797b$var$generateToken(i) {
    return "".concat($f71bdd240b06797b$var$now, "_").concat(i, "_").concat($f71bdd240b06797b$var$now);
}
function $f71bdd240b06797b$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $f71bdd240b06797b$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $f71bdd240b06797b$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $f8FMY.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $f71bdd240b06797b$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === 'object') {
                var id = $f71bdd240b06797b$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("fotED", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $b35019a7d7691e6f$export$62fe1a4d9e891fa2; });

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $b35019a7d7691e6f$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $b35019a7d7691e6f$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $f8FMY.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $b35019a7d7691e6f$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});




parcelRegister("gGDrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c25f2a7418101254$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $iSD9t = parcelRequire("iSD9t");
function $c25f2a7418101254$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $67Ijb.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $67Ijb.__rest)(nextProps, [
        "values"
    ]);
    return (0, $7tq3X.shallowEqual)(nextValues, values) && (0, $7tq3X.shallowEqual)(otherProps, nextOtherProps);
}
function $c25f2a7418101254$var$FormattedMessage(props) {
    var intl = (0, $iSD9t.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $8ZuGG.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $8ZuGG.createElement(Component, null, $8ZuGG.Children.toArray(nodes));
    return $8ZuGG.createElement($8ZuGG.Fragment, null, nodes);
}
$c25f2a7418101254$var$FormattedMessage.displayName = 'FormattedMessage';
var $c25f2a7418101254$var$MemoizedFormattedMessage = $8ZuGG.memo($c25f2a7418101254$var$FormattedMessage, $c25f2a7418101254$var$areEqual);
$c25f2a7418101254$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $c25f2a7418101254$export$2e2bcd8739ae039 = $c25f2a7418101254$var$MemoizedFormattedMessage;

});



parcelRegister("82mu7", function(module, exports) {

$parcel$export(module.exports, "preloadAppState", function () { return $f47790f73dd9f9af$export$b2d23fea71dbec1b; });
$parcel$export(module.exports, "buildMicrobranding", function () { return $f47790f73dd9f9af$export$4cd70f9ecbebfa45; });
$parcel$export(module.exports, "buildInitialState", function () { return $f47790f73dd9f9af$export$2a115e4c5d766179; });
$parcel$export(module.exports, "createAnalyticsClient", function () { return $f47790f73dd9f9af$export$3d970ca206012d6b; });
$parcel$export(module.exports, "startupAnalyticEvent", function () { return $f47790f73dd9f9af$export$514076659add65b6; });
$parcel$export(module.exports, "pushGlobals", function () { return $f47790f73dd9f9af$export$fac9d5c57cee7357; });
$parcel$export(module.exports, "initCastle", function () { return $f47790f73dd9f9af$export$22e481f8c6e85dea; });

var $ty6PY = parcelRequire("ty6PY");

var $ihLLY = parcelRequire("ihLLY");

var $3kyMd = parcelRequire("3kyMd");

var $day6I = parcelRequire("day6I");

var $d4mUe = parcelRequire("d4mUe");

var $bkO8T = parcelRequire("bkO8T");

var $kVXtB = parcelRequire("kVXtB");

var $h0rSo = parcelRequire("h0rSo");

var $3ir1n = parcelRequire("3ir1n");

var $ahjwY = parcelRequire("ahjwY");

var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");

var $wWEnh = parcelRequire("wWEnh");
function $f47790f73dd9f9af$export$b2d23fea71dbec1b() {
    try {
        const el = document.body;
        return JSON.parse(el && el.getAttribute('data-app-state') || 'null');
    } catch (e) {
        return null;
    }
}
async function $f47790f73dd9f9af$var$fetchAppState() {
    try {
        return await Promise.race([
            fetch(`${(0, $lk8Tl.idacOrigin)}/frontend/state`, {
                mode: 'cors',
                credentials: 'include'
            }).then((res)=>{
                if (res.status === 200) return res.json();
                else throw new Error(`Failed to fetch app state: ${res.status} ${res.statusText}`);
            }),
            new Promise((_, reject)=>{
                const timeoutMs = 10000;
                setTimeout(()=>reject(new Error(`Fetching app state timed out after ${timeoutMs}ms`)), timeoutMs);
            })
        ]);
    } catch (e) {
        (0, $8f2pb.captureException)(e);
        return null;
    }
}
function $f47790f73dd9f9af$export$4cd70f9ecbebfa45(oidcContext) {
    const isEmbedded = /AtlassianMobileApp|HipChat/.test(navigator.userAgent);
    const isMobileApp = isEmbedded || (0, $day6I.isMobileOidc)(oidcContext) || false;
    return {
        isEmbedded: isEmbedded,
        isAnyMobile: (0, $ihLLY.screenSize)() === 'mobile' || isMobileApp,
        isMobileApp: isMobileApp,
        screenSize: (0, $ihLLY.screenSize)(),
        oidcContext: oidcContext
    };
}
async function $f47790f73dd9f9af$export$2a115e4c5d766179(preloaded) {
    const microbranding = $f47790f73dd9f9af$export$4cd70f9ecbebfa45(preloaded === null || preloaded === void 0 ? void 0 : preloaded.oidcContext);
    if (!preloaded) {
        const fetched = await $f47790f73dd9f9af$var$fetchAppState();
        return {
            initialStoreState: {
                csrfToken: fetched === null || fetched === void 0 ? void 0 : fetched.csrfToken,
                user: undefined,
                login: undefined,
                logout: undefined,
                appConfig: fetched === null || fetched === void 0 ? void 0 : fetched.appConfig,
                locale: fetched === null || fetched === void 0 ? void 0 : fetched.locale,
                continueAs: undefined,
                cancelDeletion: undefined,
                selectAccount: undefined,
                microbranding: $f47790f73dd9f9af$export$4cd70f9ecbebfa45(fetched === null || fetched === void 0 ? void 0 : fetched.oidcContext),
                createAccount: undefined,
                context: {
                    tenantCloudId: fetched === null || fetched === void 0 ? void 0 : fetched.tenantCloudId,
                    userId: undefined
                },
                migrateConfirmation: undefined,
                welcome: undefined,
                socialLoginRecovery: undefined,
                verifyEmail: undefined,
                verifyEmailSent: undefined,
                changeEmail: undefined,
                changePassword: undefined,
                welcomeSent: undefined,
                serverError: undefined,
                cobranding: fetched === null || fetched === void 0 ? void 0 : fetched.cobranding,
                stepUp: undefined,
                stepUpSso: undefined,
                verifyEmailOtp: undefined,
                loginConsent: undefined
            },
            cspNonce: (fetched === null || fetched === void 0 ? void 0 : fetched.cspNonce) || ''
        };
    }
    const loginState = preloaded.login && (0, $ty6PY._)({}, (0, $3kyMd.defaultState), preloaded.login);
    return {
        initialStoreState: {
            csrfToken: preloaded.csrfToken,
            hashedCsrfToken: preloaded.hashedCsrfToken,
            user: preloaded.user,
            login: loginState,
            logout: preloaded.logout,
            appConfig: preloaded.appConfig,
            locale: preloaded.locale,
            continueAs: preloaded.continueAs,
            cancelDeletion: preloaded.cancelDeletion,
            selectAccount: preloaded.selectAccount,
            microbranding: microbranding,
            createAccount: preloaded.createAccount,
            context: {
                tenantCloudId: preloaded.tenantCloudId,
                userId: preloaded.userId
            },
            migrateConfirmation: preloaded.migrateConfirmation,
            signup: (0, $ty6PY._)({}, (0, $bkO8T.defaultState), preloaded.signup),
            welcome: (0, $ty6PY._)({}, (0, $kVXtB.defaultState), preloaded.welcome),
            socialLoginRecovery: preloaded.socialLoginRecovery,
            verifyEmail: preloaded.verifyEmail,
            verifyEmailSent: preloaded.verifyEmailSent,
            changeEmail: preloaded.changeEmail,
            changePassword: (0, $ty6PY._)({}, (0, $d4mUe.defaultState), preloaded.changePassword),
            welcomeSent: preloaded.welcomeSent,
            serverError: preloaded.error,
            cobranding: preloaded.cobranding,
            multiFactor: (0, $ty6PY._)({}, (0, $ahjwY.defaultState), preloaded.multiFactor),
            stepUp: preloaded.stepUp,
            stepUpSso: preloaded.stepUpSso,
            verifyEmailOtp: (0, $ty6PY._)({}, (0, $h0rSo.defaultState), preloaded.verifyEmailOtp),
            loginConsent: (0, $ty6PY._)({}, (0, $wWEnh.defaultState), preloaded.loginConsent)
        },
        cspNonce: preloaded.cspNonce
    };
}
function $f47790f73dd9f9af$export$3d970ca206012d6b(initialState) {
    const { microbranding: microbranding, cobranding: cobranding, context: context } = initialState.initialStoreState;
    const locale = undefined;
    return new (0, $3ir1n.AnalyticsClientImpl)({
        microbranding: microbranding,
        cobranding: cobranding || {},
        locale: locale,
        tenantCloudId: context.tenantCloudId,
        userId: context.userId,
        client: undefined
    });
}
function $f47790f73dd9f9af$export$514076659add65b6(analyticsClient) {
    analyticsClient.operationalEvent({
        page: 'unknown',
        action: 'loadPage',
        subject: 'sli'
    });
}
function $f47790f73dd9f9af$export$fac9d5c57cee7357(appConfig, cspNonce) {
    window.segmentIoKey = appConfig && appConfig.segmentIoKey;
    window.cspNonce = cspNonce;
}

function $f47790f73dd9f9af$export$22e481f8c6e85dea(appConfig) {
    if ((0, $lk8Tl.currentCloudType) !== 'commercial') return; // Castle is not enabled for FedRAMP
    if (appConfig.castlePublishableApiKey) (parcelRequire("jo0uw")).then(({ configure: configure })=>{
        configure({
            pk: appConfig.castlePublishableApiKey
        });
    });
}

});
parcelRegister("ihLLY", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $6097029e68378a82$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "screenSizeMatcher", function () { return $6097029e68378a82$export$417d65d80b205866; });
$parcel$export(module.exports, "screenSize", function () { return $6097029e68378a82$export$463d066e8ee12fba; });

var $ty6PY = parcelRequire("ty6PY");

var $bl8w7 = parcelRequire("bl8w7");

var $5b7Z4 = parcelRequire("5b7Z4");
let $6097029e68378a82$var$_ = (t)=>t, $6097029e68378a82$var$t;
const $6097029e68378a82$var$mobileMaxWidth = `${(0, $5b7Z4.gridSize)() * 100}px`;
const $6097029e68378a82$var$mediaQueryCss = (query)=>(...args)=>{
        // @ts-ignore
        const inner = (0, $bl8w7.css)(...args);
        return (0, $bl8w7.css)($6097029e68378a82$var$t || ($6097029e68378a82$var$t = $6097029e68378a82$var$_`
      @media ${0} {
        ${0}
      }
    `), query, inner);
    };
const $6097029e68378a82$var$mediaQuery = {
    handheldQuery: `(max-width: ${$6097029e68378a82$var$mobileMaxWidth})`
};
const $6097029e68378a82$export$987d49ffe1b0900f = (0, $ty6PY._)({
    handheld: $6097029e68378a82$var$mediaQueryCss($6097029e68378a82$var$mediaQuery.handheldQuery)
}, $6097029e68378a82$var$mediaQuery);
const $6097029e68378a82$export$417d65d80b205866 = window.matchMedia && window.matchMedia($6097029e68378a82$export$987d49ffe1b0900f.handheldQuery);
const $6097029e68378a82$export$463d066e8ee12fba = ()=>$6097029e68378a82$export$417d65d80b205866 ? $6097029e68378a82$export$417d65d80b205866.matches ? 'mobile' : 'desktop' : 'unknown';
const $6097029e68378a82$var$maxWidth = (screenSize)=>{
    switch(screenSize){
        case 'mobile':
            return $6097029e68378a82$var$mobileMaxWidth;
        default:
            return '100%';
    }
};
const $6097029e68378a82$export$d7b7311ec04a3e8f = (screenSize, name)=>{
    const viewport = {};
    viewport[screenSize] = {
        name: name ? name : screenSize,
        styles: {
            width: $6097029e68378a82$var$maxWidth(screenSize),
            height: '100%'
        }
    };
    return viewport;
};

});
parcelRegister("5b7Z4", function(module, exports) {

$parcel$export(module.exports, "borderRadius", function () { return $3c542c43a726d225$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $3c542c43a726d225$export$6d8204c2cb2e06b8; });

var $5pPqr = parcelRequire("5pPqr");

var $kTdw7 = parcelRequire("kTdw7");
var $3c542c43a726d225$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $3c542c43a726d225$export$c93026a968943f95 = 'light';
var $3c542c43a726d225$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $3c542c43a726d225$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $3c542c43a726d225$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $3c542c43a726d225$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $kTdw7.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3c542c43a726d225$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $3c542c43a726d225$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $3c542c43a726d225$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $3c542c43a726d225$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $3c542c43a726d225$export$ba1d834b86d72a09 = $3c542c43a726d225$export$a1b3edb637fb4f35;
var $3c542c43a726d225$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $kTdw7.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $kTdw7.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $kTdw7.N30A), ")")
            }
        }
    };
};

});
parcelRegister("5pPqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f172d9224867a2e$export$2e2bcd8739ae039; });

var $4w3PY = parcelRequire("4w3PY");

var $1RdT6 = parcelRequire("1RdT6");
function $3f172d9224867a2e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4w3PY.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3f172d9224867a2e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $1RdT6;
}

});
parcelRegister("4w3PY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $349d209b7f21e263$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $349d209b7f21e263$var$printed = {};
function $349d209b7f21e263$export$2e2bcd8739ae039(message) {
    if ($349d209b7f21e263$var$printed[message]) return;
    $349d209b7f21e263$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});


parcelRegister("kTdw7", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $f3536de48c65251d$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $f3536de48c65251d$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $f3536de48c65251d$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $f3536de48c65251d$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $f3536de48c65251d$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f3536de48c65251d$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f3536de48c65251d$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $f3536de48c65251d$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $f3536de48c65251d$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $f3536de48c65251d$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $f3536de48c65251d$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $f3536de48c65251d$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $f3536de48c65251d$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $f3536de48c65251d$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $f3536de48c65251d$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $f3536de48c65251d$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $f3536de48c65251d$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $f3536de48c65251d$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $f3536de48c65251d$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $f3536de48c65251d$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $f3536de48c65251d$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $f3536de48c65251d$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f3536de48c65251d$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f3536de48c65251d$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $f3536de48c65251d$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f3536de48c65251d$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f3536de48c65251d$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f3536de48c65251d$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "B600", function () { return $f3536de48c65251d$export$67f15409e87642a1; });
$parcel$export(module.exports, "B700", function () { return $f3536de48c65251d$export$f0539dbc42dbb067; });
$parcel$export(module.exports, "P50", function () { return $f3536de48c65251d$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $f3536de48c65251d$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $f3536de48c65251d$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $f3536de48c65251d$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $f3536de48c65251d$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $f3536de48c65251d$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $f3536de48c65251d$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $f3536de48c65251d$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $f3536de48c65251d$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $f3536de48c65251d$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $f3536de48c65251d$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $f3536de48c65251d$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $f3536de48c65251d$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $f3536de48c65251d$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $f3536de48c65251d$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f3536de48c65251d$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f3536de48c65251d$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f3536de48c65251d$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $f3536de48c65251d$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $f3536de48c65251d$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $f3536de48c65251d$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $f3536de48c65251d$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $f3536de48c65251d$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $f3536de48c65251d$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $f3536de48c65251d$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $f3536de48c65251d$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $f3536de48c65251d$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $f3536de48c65251d$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f3536de48c65251d$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $f3536de48c65251d$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $f3536de48c65251d$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f3536de48c65251d$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $f3536de48c65251d$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $f3536de48c65251d$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $f3536de48c65251d$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f3536de48c65251d$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $f3536de48c65251d$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $f3536de48c65251d$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f3536de48c65251d$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $f3536de48c65251d$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $f3536de48c65251d$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $f3536de48c65251d$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $f3536de48c65251d$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $f3536de48c65251d$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $f3536de48c65251d$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $f3536de48c65251d$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $f3536de48c65251d$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $f3536de48c65251d$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $f3536de48c65251d$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $f3536de48c65251d$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $f3536de48c65251d$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $f3536de48c65251d$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $f3536de48c65251d$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $f3536de48c65251d$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $f3536de48c65251d$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $f3536de48c65251d$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $f3536de48c65251d$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $f3536de48c65251d$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $f3536de48c65251d$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $f3536de48c65251d$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $f3536de48c65251d$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $f3536de48c65251d$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $f3536de48c65251d$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $f3536de48c65251d$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $f3536de48c65251d$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $f3536de48c65251d$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $f3536de48c65251d$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $f3536de48c65251d$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $f3536de48c65251d$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $f3536de48c65251d$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $f3536de48c65251d$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $f3536de48c65251d$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $f3536de48c65251d$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $f3536de48c65251d$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $f3536de48c65251d$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $f3536de48c65251d$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $f3536de48c65251d$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $f3536de48c65251d$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $f3536de48c65251d$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $f3536de48c65251d$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $f3536de48c65251d$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $f3536de48c65251d$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $f3536de48c65251d$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $f3536de48c65251d$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $f3536de48c65251d$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $f3536de48c65251d$export$9ab70e67d6475361; });
$parcel$export(module.exports, "T30", function () { return $f3536de48c65251d$export$d2adc5dedf09fced; });
$parcel$export(module.exports, "L50", function () { return $f3536de48c65251d$export$f51762073d2bb381; });
$parcel$export(module.exports, "L75", function () { return $f3536de48c65251d$export$95e26d54def96891; });
// Reds
var $f3536de48c65251d$export$4b84fd0e2c617bd = '#FFEBE6';
var $f3536de48c65251d$export$b34b069eff244586 = '#FFBDAD';
var $f3536de48c65251d$export$be802dd0d8b57f35 = '#FF8F73';
var $f3536de48c65251d$export$60847d42f9da92a6 = '#FF7452';
var $f3536de48c65251d$export$4a7404f376229999 = '#FF5630';
var $f3536de48c65251d$export$2010d0fb4295b346 = '#DE350B';
var $f3536de48c65251d$export$2837b5a1a71d5c02 = '#BF2600';
var $f3536de48c65251d$export$8d9596b529bbb9cf = '#FFFAE6';
var $f3536de48c65251d$export$41060a744ab0b7ae = '#FFF0B3';
var $f3536de48c65251d$export$1cc05bbbf340e559 = '#FFE380';
var $f3536de48c65251d$export$5aae31392d72caaa = '#FFC400';
var $f3536de48c65251d$export$c6930421db9fa514 = '#FFAB00';
var $f3536de48c65251d$export$59619663aa6500fb = '#FF991F';
var $f3536de48c65251d$export$874739ea9e379ab6 = '#FF8B00';
var $f3536de48c65251d$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $f3536de48c65251d$export$69a3bf21b9686c2b = '#ABF5D1';
var $f3536de48c65251d$export$afbce1382ec95f73 = '#79F2C0';
var $f3536de48c65251d$export$747d86715d4175de = '#57D9A3';
var $f3536de48c65251d$export$940e1f69e873f202 = '#36B37E';
var $f3536de48c65251d$export$a49394138f7b8e85 = '#00875A';
var $f3536de48c65251d$export$6fa04827ac68a4fb = '#006644';
var $f3536de48c65251d$export$226de0355ed012f8 = '#DEEBFF';
var $f3536de48c65251d$export$8c13c2ee36917869 = '#B3D4FF';
var $f3536de48c65251d$export$ecfc1dff386a3e7a = '#4C9AFF';
var $f3536de48c65251d$export$215b7063051591f1 = '#2684FF';
var $f3536de48c65251d$export$e62e8919cca44969 = '#0065FF';
var $f3536de48c65251d$export$b3de0ae08da2ce64 = '#0052CC';
var $f3536de48c65251d$export$a6ee3d71bc067634 = '#0747A6';
var $f3536de48c65251d$export$67f15409e87642a1 = '#669DF1';
var $f3536de48c65251d$export$f0539dbc42dbb067 = '#8FB8F6';
var $f3536de48c65251d$export$363e4475840015bb = '#EAE6FF';
var $f3536de48c65251d$export$4b0a4417ed59760f = '#C0B6F2';
var $f3536de48c65251d$export$6011520a64d9a187 = '#998DD9';
var $f3536de48c65251d$export$a7175d4e9206bc80 = '#8777D9';
var $f3536de48c65251d$export$b48405b95304b5a1 = '#6554C0';
var $f3536de48c65251d$export$c71e4279dd54a18d = '#5243AA';
var $f3536de48c65251d$export$147899de772240ec = '#403294';
var $f3536de48c65251d$export$2cf711fe14c66f06 = '#E6FCFF';
var $f3536de48c65251d$export$7a8f4d33f6f9772c = '#B3F5FF';
var $f3536de48c65251d$export$776c9c497ef08533 = '#79E2F2';
var $f3536de48c65251d$export$69cb3ca10c1e330e = '#00C7E6';
var $f3536de48c65251d$export$9dc1ef0f3f48059b = '#00B8D9';
var $f3536de48c65251d$export$7c835c78b6fcdef8 = '#00A3BF';
var $f3536de48c65251d$export$6036577f95c3877e = '#008DA6';
var $f3536de48c65251d$export$29a4f05edc054374 = '#FFFFFF';
var $f3536de48c65251d$export$e655ef011c4aa1a2 = '#FAFBFC';
var $f3536de48c65251d$export$9fdfb749e33cdf97 = '#F4F5F7';
var $f3536de48c65251d$export$3e51e8f1440314ba = '#EBECF0';
var $f3536de48c65251d$export$1ce2d1575d444ceb = '#DFE1E6';
var $f3536de48c65251d$export$8754fc7e6d8b3000 = '#C1C7D0';
var $f3536de48c65251d$export$c2e91cbeada39b8b = '#B3BAC5';
var $f3536de48c65251d$export$5f71e19f3a7ad9de = '#A5ADBA';
var $f3536de48c65251d$export$eaa8c8a70ac22806 = '#97A0AF';
var $f3536de48c65251d$export$7c87d337fb91a97d = '#8993A4';
var $f3536de48c65251d$export$d6447c357493214f = '#7A869A';
var $f3536de48c65251d$export$f563ee71e9ee74cd = '#6B778C';
var $f3536de48c65251d$export$e2ef2124cf4024b1 = '#5E6C84';
var $f3536de48c65251d$export$eece5f492e429f08 = '#505F79';
var $f3536de48c65251d$export$c39c0fe0f26207ae = '#42526E';
var $f3536de48c65251d$export$7090862dc3038a9f = '#344563';
var $f3536de48c65251d$export$ad0bacf983b7ddaa = '#253858';
var $f3536de48c65251d$export$7d61b15e0da132af = '#172B4D';
var $f3536de48c65251d$export$fbda843f0a27fe96 = '#091E42';
var $f3536de48c65251d$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $f3536de48c65251d$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $f3536de48c65251d$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $f3536de48c65251d$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $f3536de48c65251d$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $f3536de48c65251d$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $f3536de48c65251d$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $f3536de48c65251d$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $f3536de48c65251d$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $f3536de48c65251d$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $f3536de48c65251d$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $f3536de48c65251d$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $f3536de48c65251d$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $f3536de48c65251d$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $f3536de48c65251d$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $f3536de48c65251d$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $f3536de48c65251d$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $f3536de48c65251d$export$2f6319cf7d736c2a = '#E6EDFA';
var $f3536de48c65251d$export$95126bc8884d6634 = '#DCE5F5';
var $f3536de48c65251d$export$8338d8c35d44ff1 = '#CED9EB';
var $f3536de48c65251d$export$5368d76ae4fbbda7 = '#B8C7E0';
var $f3536de48c65251d$export$9f0a771d16ec8d36 = '#ABBBD6';
var $f3536de48c65251d$export$abcf8c38338b4aa5 = '#9FB0CC';
var $f3536de48c65251d$export$97e81faa16a182c7 = '#8C9CB8';
var $f3536de48c65251d$export$bfe21c59123ecf33 = '#7988A3';
var $f3536de48c65251d$export$ee82aa2ea6a1558 = '#67758F';
var $f3536de48c65251d$export$682927c6ed76be02 = '#56637A';
var $f3536de48c65251d$export$91fd9994c5be9757 = '#455166';
var $f3536de48c65251d$export$d281fbfe3cff2df6 = '#3B475C';
var $f3536de48c65251d$export$3902c91d8b98a753 = '#313D52';
var $f3536de48c65251d$export$8e8133c1ba5845b5 = '#283447';
var $f3536de48c65251d$export$33ff357f6620b39 = '#202B3D';
var $f3536de48c65251d$export$633847cf062b69e0 = '#1B2638';
var $f3536de48c65251d$export$9776a6e503bdbf76 = '#121A29';
var $f3536de48c65251d$export$6c813d5160dff5db = '#0E1624';
var $f3536de48c65251d$export$3d4f271a500072a = '#0D1424';
var $f3536de48c65251d$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $f3536de48c65251d$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $f3536de48c65251d$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $f3536de48c65251d$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $f3536de48c65251d$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $f3536de48c65251d$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $f3536de48c65251d$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $f3536de48c65251d$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $f3536de48c65251d$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $f3536de48c65251d$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $f3536de48c65251d$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $f3536de48c65251d$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $f3536de48c65251d$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $f3536de48c65251d$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $f3536de48c65251d$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $f3536de48c65251d$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $f3536de48c65251d$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $f3536de48c65251d$export$d2adc5dedf09fced = '#292A2E';
var $f3536de48c65251d$export$f51762073d2bb381 = '#94C748';
var $f3536de48c65251d$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("jo0uw", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fxF5P")).then(()=>parcelRequire('f6Jfi'));

});


parcelRegister("lJ1Bt", function(module, exports) {

$parcel$export(module.exports, "resetAppState", function () { return $08b938d3f657456d$export$10d871c0f32f1a89; });

var $kOqgB = parcelRequire("kOqgB");
const $08b938d3f657456d$export$10d871c0f32f1a89 = (data)=>({
        type: (0, $kOqgB.RESET_APP_STATE),
        data: data
    });

});


parcelRegister("iBTcr", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("ittIU")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("e1hxF")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7JtuM")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5Hzdz")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hU7R8 = parcelRequire("hU7R8");

var $7H231 = parcelRequire("7H231");
parcelRequire("A0Qvp");
var $h1d60 = parcelRequire("h1d60");

var $c4bmG = parcelRequire("c4bmG");

var $5Hzdz = parcelRequire("5Hzdz");

var $ittIU = parcelRequire("ittIU");
parcelRequire("cSOXH");
(0, $5Hzdz.initializeUseSelector)((0, $7H231.useSyncExternalStoreWithSelector));
(0, $ittIU.initializeConnect)((0, $hU7R8.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $c4bmG.setBatch)((0, $h1d60.unstable_batchedUpdates));

});
parcelRegister("7H231", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hi0mu"));

});

parcelRegister("A0Qvp", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("h1d60")).unstable_batchedUpdates; });

var $h1d60 = parcelRequire("h1d60");

});

parcelRegister("c4bmG", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $8c8eac927667bb1c$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $8c8eac927667bb1c$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $8c8eac927667bb1c$var$defaultNoopBatch(callback) {
    callback();
}
let $8c8eac927667bb1c$var$batch = $8c8eac927667bb1c$var$defaultNoopBatch; // Allow injecting another batching function later
const $8c8eac927667bb1c$export$4b9874722d0da7bc = (newBatch)=>$8c8eac927667bb1c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $8c8eac927667bb1c$export$fc47d4c0ba3bd2c6 = ()=>$8c8eac927667bb1c$var$batch;

});

parcelRegister("5Hzdz", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $426c4972d699f3ad$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $426c4972d699f3ad$export$2105062e25df4afe; });

var $8ZuGG = parcelRequire("8ZuGG");

var $hIX6X = parcelRequire("hIX6X");

var $1PVdq = parcelRequire("1PVdq");

var $4I5qa = parcelRequire("4I5qa");
let $426c4972d699f3ad$var$useSyncExternalStoreWithSelector = (0, $4I5qa.notInitialized);
const $426c4972d699f3ad$export$e2e6e3f3f3b782e3 = (fn)=>{
    $426c4972d699f3ad$var$useSyncExternalStoreWithSelector = fn;
};
const $426c4972d699f3ad$var$refEquality = (a, b)=>a === b;
function $426c4972d699f3ad$export$2b53f90d2bd1cbfb(context = (0, $1PVdq.ReactReduxContext)) {
    const useReduxContext = context === (0, $1PVdq.ReactReduxContext) ? (0, $hIX6X.useReduxContext) : (0, $hIX6X.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $426c4972d699f3ad$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $8ZuGG.useRef)(true);
        const wrappedSelector = (0, $8ZuGG.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $426c4972d699f3ad$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $8ZuGG.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $426c4972d699f3ad$export$2105062e25df4afe = /*#__PURE__*/ $426c4972d699f3ad$export$2b53f90d2bd1cbfb();

});
parcelRegister("hIX6X", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $ce7466006b4afaca$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $ce7466006b4afaca$export$c1275ca9a6fd3ec5; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1PVdq = parcelRequire("1PVdq");
function $ce7466006b4afaca$export$d4d6226d5fc61558(context = (0, $1PVdq.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $8ZuGG.useContext)(context);
        return contextValue;
    };
}
const $ce7466006b4afaca$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $ce7466006b4afaca$export$d4d6226d5fc61558();

});
parcelRegister("1PVdq", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $1566efb0ddf2d2a2$export$cc80c08dc91f1c00; });

var $8ZuGG = parcelRequire("8ZuGG");
const $1566efb0ddf2d2a2$var$ContextKey = Symbol.for(`react-redux-context`);
const $1566efb0ddf2d2a2$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $1566efb0ddf2d2a2$var$getContext() {
    var _gT$ContextKey;
    if (!$8ZuGG.createContext) return {};
    const contextMap = (_gT$ContextKey = $1566efb0ddf2d2a2$var$gT[$1566efb0ddf2d2a2$var$ContextKey]) != null ? _gT$ContextKey : $1566efb0ddf2d2a2$var$gT[$1566efb0ddf2d2a2$var$ContextKey] = new Map();
    let realContext = contextMap.get($8ZuGG.createContext);
    if (!realContext) {
        realContext = $8ZuGG.createContext(null);
        contextMap.set($8ZuGG.createContext, realContext);
    }
    return realContext;
}
const $1566efb0ddf2d2a2$export$cc80c08dc91f1c00 = /*#__PURE__*/ $1566efb0ddf2d2a2$var$getContext();
var $1566efb0ddf2d2a2$export$2e2bcd8739ae039 = $1566efb0ddf2d2a2$export$cc80c08dc91f1c00;

});


parcelRegister("4I5qa", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $36df7a00ed1af54b$export$20656a4825650bd0; });
const $36df7a00ed1af54b$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("ittIU", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $d731fdd9650e34d2$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $d731fdd9650e34d2$export$2e2bcd8739ae039; });

var $6vRlT = parcelRequire("6vRlT");

var $4KVmf = parcelRequire("4KVmf");

var $fiQA5 = parcelRequire("fiQA5");

var $8ZuGG = parcelRequire("8ZuGG");

var $ejazM = parcelRequire("ejazM");

var $nkY8n = parcelRequire("nkY8n");

var $aOI60 = parcelRequire("aOI60");

var $b9plV = parcelRequire("b9plV");

var $aPse6 = parcelRequire("aPse6");

var $rlEIG = parcelRequire("rlEIG");

var $4fn4K = parcelRequire("4fn4K");

var $8LoSk = parcelRequire("8LoSk");
parcelRequire("8Hy2h");

var $1PVdq = parcelRequire("1PVdq");

var $4I5qa = parcelRequire("4I5qa");
const $d731fdd9650e34d2$var$_excluded = [
    "reactReduxForwardedRef"
];
let $d731fdd9650e34d2$var$useSyncExternalStore = (0, $4I5qa.notInitialized);
const $d731fdd9650e34d2$export$36d45daa6a4925b8 = (fn)=>{
    $d731fdd9650e34d2$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $d731fdd9650e34d2$var$EMPTY_ARRAY = [
    null,
    0
];
const $d731fdd9650e34d2$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $d731fdd9650e34d2$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $d731fdd9650e34d2$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $4fn4K.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $d731fdd9650e34d2$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $d731fdd9650e34d2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $d731fdd9650e34d2$var$initStateUpdates = ()=>$d731fdd9650e34d2$var$EMPTY_ARRAY;
function $d731fdd9650e34d2$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $d731fdd9650e34d2$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $d731fdd9650e34d2$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d731fdd9650e34d2$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8LoSk.default), areStatePropsEqual: areStatePropsEqual = (0, $8LoSk.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8LoSk.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $1PVdq.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $b9plV.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $aOI60.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $aPse6.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $8ZuGG.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $4KVmf.default)(props, $d731fdd9650e34d2$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $8ZuGG.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $ejazM.isContextConsumer)(/*#__PURE__*/ $8ZuGG.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $8ZuGG.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $8ZuGG.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $nkY8n.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $8ZuGG.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d731fdd9650e34d2$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $rlEIG.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $8ZuGG.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6vRlT.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $8ZuGG.useRef();
            const lastWrapperProps = $8ZuGG.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $8ZuGG.useRef();
            const renderIsScheduled = $8ZuGG.useRef(false);
            const isProcessingDispatch = $8ZuGG.useRef(false);
            const isMounted = $8ZuGG.useRef(false);
            const latestSubscriptionCallbackError = $8ZuGG.useRef();
            (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $8ZuGG.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $8ZuGG.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d731fdd9650e34d2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d731fdd9650e34d2$var$useIsomorphicLayoutEffectWithArgs($d731fdd9650e34d2$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d731fdd9650e34d2$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $8ZuGG.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $8ZuGG.createElement(WrappedComponent, (0, $6vRlT.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $8ZuGG.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $8ZuGG.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $8ZuGG.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $8ZuGG.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $8ZuGG.createElement(Connect, (0, $6vRlT.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d731fdd9650e34d2$export$2e2bcd8739ae039 = $d731fdd9650e34d2$var$connect;

});
parcelRegister("ejazM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eNPsz"));

});

parcelRegister("nkY8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04626a15ce2ca36c$export$2e2bcd8739ae039; });

var $4KVmf = parcelRequire("4KVmf");
parcelRequire("d4jAj");
const $04626a15ce2ca36c$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $04626a15ce2ca36c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $04626a15ce2ca36c$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $4KVmf.default)(_ref, $04626a15ce2ca36c$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $04626a15ce2ca36c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d4jAj", function(module, exports) {

var $8Hy2h = parcelRequire("8Hy2h");
function $983ad72e2e3c6a90$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $8Hy2h.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $983ad72e2e3c6a90$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $983ad72e2e3c6a90$var$verify(mapStateToProps, 'mapStateToProps');
    $983ad72e2e3c6a90$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $983ad72e2e3c6a90$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("8Hy2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $655cbda9d169540e$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $655cbda9d169540e$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("aOI60", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $7e00c76b181085d1$export$b69a785ceac019a6; });

var $1GhI8 = parcelRequire("1GhI8");

var $dQIZ0 = parcelRequire("dQIZ0");

var $8Reab = parcelRequire("8Reab");
function $7e00c76b181085d1$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $dQIZ0.wrapMapToPropsConstant)((dispatch)=>(0, $1GhI8.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $dQIZ0.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $dQIZ0.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $8Reab.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("1GhI8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $139773b4c0ddfa4a$export$2e2bcd8739ae039; });
function $139773b4c0ddfa4a$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("dQIZ0", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $a1530660b5e8cf18$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $a1530660b5e8cf18$export$8d46c7f53c8c602f; });
parcelRequire("Dt8dT");
function $a1530660b5e8cf18$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $a1530660b5e8cf18$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $a1530660b5e8cf18$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $a1530660b5e8cf18$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $a1530660b5e8cf18$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("Dt8dT", function(module, exports) {

var $fVGP0 = parcelRequire("fVGP0");

var $8Hy2h = parcelRequire("8Hy2h");
function $076a3d9153f2de76$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $fVGP0.default)(value)) (0, $8Hy2h.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("fVGP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98d655ed8ff004e$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b98d655ed8ff004e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("8Reab", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $672e4284902232d1$export$19ef7b929f7e2559; });
function $672e4284902232d1$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("b9plV", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $81e4337dc73c3d41$export$e00e93951827eda7; });

var $dQIZ0 = parcelRequire("dQIZ0");

var $8Reab = parcelRequire("8Reab");
function $81e4337dc73c3d41$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $dQIZ0.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $dQIZ0.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $8Reab.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("aPse6", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $7e2490026ce772fd$export$17457cf6fa742f84; });

var $6vRlT = parcelRequire("6vRlT");
parcelRequire("Dt8dT");

var $8Reab = parcelRequire("8Reab");
function $7e2490026ce772fd$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6vRlT.default)({}, ownProps, stateProps, dispatchProps);
}
function $7e2490026ce772fd$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7e2490026ce772fd$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$7e2490026ce772fd$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $7e2490026ce772fd$export$5b105939c84b5234(mergeProps) : (0, $8Reab.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("rlEIG", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $0523521d92a4a169$export$d567d2b9af322f8f; });

var $c4bmG = parcelRequire("c4bmG");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0523521d92a4a169$var$createListenerCollection() {
    const batch = (0, $c4bmG.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $0523521d92a4a169$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0523521d92a4a169$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $0523521d92a4a169$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0523521d92a4a169$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0523521d92a4a169$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("4fn4K", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $317a7672d50d9c88$export$700979bc83e7db82; });

var $8ZuGG = parcelRequire("8ZuGG");
const $317a7672d50d9c88$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $317a7672d50d9c88$export$700979bc83e7db82 = $317a7672d50d9c88$export$71594e8a50f746f4 ? $8ZuGG.useLayoutEffect : $8ZuGG.useEffect;

});

parcelRegister("8LoSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6616023885707955$export$2e2bcd8739ae039; });
function $6616023885707955$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $6616023885707955$export$2e2bcd8739ae039(objA, objB) {
    if ($6616023885707955$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$6616023885707955$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("cSOXH", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("e1hxF")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("ittIU")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7JtuM")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5Hzdz")).useSelector; });

var $e1hxF = parcelRequire("e1hxF");

var $ittIU = parcelRequire("ittIU");

var $1PVdq = parcelRequire("1PVdq");

var $7JtuM = parcelRequire("7JtuM");

var $5Hzdz = parcelRequire("5Hzdz");

var $g5XoR = parcelRequire("g5XoR");

var $8LoSk = parcelRequire("8LoSk");
parcelRequire("aZ6pU");

});
parcelRegister("e1hxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a34ec4300d3a80c8$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1PVdq = parcelRequire("1PVdq");

var $rlEIG = parcelRequire("rlEIG");

var $4fn4K = parcelRequire("4fn4K");
function $a34ec4300d3a80c8$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $8ZuGG.useMemo(()=>{
        const subscription = (0, $rlEIG.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $8ZuGG.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $1PVdq.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $8ZuGG.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $a34ec4300d3a80c8$export$2e2bcd8739ae039 = $a34ec4300d3a80c8$var$Provider;

});

parcelRegister("7JtuM", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $5a139d88100a3adc$export$8ad76b76a4c905f8; });

var $1PVdq = parcelRequire("1PVdq");

var $g5XoR = parcelRequire("g5XoR");
function $5a139d88100a3adc$export$bc9b55530897c558(context = (0, $1PVdq.ReactReduxContext)) {
    const useStore = context === (0, $1PVdq.ReactReduxContext) ? (0, $g5XoR.useStore) : (0, $g5XoR.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $5a139d88100a3adc$export$8ad76b76a4c905f8 = /*#__PURE__*/ $5a139d88100a3adc$export$bc9b55530897c558();

});
parcelRegister("g5XoR", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $bb7b3095e44c4ec6$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $bb7b3095e44c4ec6$export$6ccbb43953eebf8; });

var $1PVdq = parcelRequire("1PVdq");

var $hIX6X = parcelRequire("hIX6X");
function $bb7b3095e44c4ec6$export$671dba69185d0304(context = (0, $1PVdq.ReactReduxContext)) {
    const useReduxContext = context === (0, $1PVdq.ReactReduxContext) ? (0, $hIX6X.useReduxContext) : (0, $hIX6X.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $bb7b3095e44c4ec6$export$6ccbb43953eebf8 = /*#__PURE__*/ $bb7b3095e44c4ec6$export$671dba69185d0304();

});


parcelRegister("aZ6pU", function(module, exports) {

});




parcelRegister("8wTJJ", function(module, exports) {

$parcel$export(module.exports, "getFfsId", function () { return $62566de4c0747f3a$export$3b0e089e98b45efa; });

var $8USlx = parcelRequire("8USlx");
const $62566de4c0747f3a$var$FFS_ID_KEY = 'atlassian.account.ffs.id';
function $62566de4c0747f3a$export$3b0e089e98b45efa() {
    const ffsId = (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($62566de4c0747f3a$var$FFS_ID_KEY);
    return ffsId && ffsId.replace(/(^")|("$)/g, '');
}

});

parcelRegister("clPQ5", function(module, exports) {

$parcel$export(module.exports, "FeatureGatesInit", function () { return $cdf5ffe4034ca2d9$export$8bae65f5bd3fcf07; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $7Y4vx = parcelRequire("7Y4vx");

var $51qEW = parcelRequire("51qEW");

var $lk8Tl = parcelRequire("lk8Tl");

var $f81B8 = parcelRequire("f81B8");
const $cdf5ffe4034ca2d9$var$getLocalMode = ()=>(0, $lk8Tl.currentEnv) === 'local';
const $cdf5ffe4034ca2d9$var$getEnv = ()=>{
    switch(0, $lk8Tl.currentEnv){
        case 'dev':
        case 'local':
            return (0, $51qEW.FeatureGateEnvironment).Development;
        case 'stg':
        case 'stg-fedm':
        case 'stg-ic':
            return (0, $51qEW.FeatureGateEnvironment).Staging;
        case 'prod':
        case 'prod-fedm':
        case 'prod-ic':
        default:
            return (0, $51qEW.FeatureGateEnvironment).Production;
    }
};
const $cdf5ffe4034ca2d9$var$options = {
    targetApp: (0, $f81B8.statsigTargetApp),
    environment: $cdf5ffe4034ca2d9$var$getEnv(),
    apiKey: (0, $f81B8.getStatsigApiKey)(),
    localMode: $cdf5ffe4034ca2d9$var$getLocalMode()
};
const $cdf5ffe4034ca2d9$export$8bae65f5bd3fcf07 = ({ identifiers: identifiers, onReady: onReady })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7Y4vx.FeatureGatesInitialization), {
        enabled: true,
        identifiers: identifiers,
        options: $cdf5ffe4034ca2d9$var$options,
        onReady: onReady
    });
};

});
parcelRegister("7Y4vx", function(module, exports) {
"use strict";
var $5cd1a21fe9e09a3a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5cd1a21fe9e09a3a$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5cd1a21fe9e09a3a$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("f7U78")), module.exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("6XahI")), module.exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("h1gNA")), module.exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("7YQq7")), module.exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("eYpIx")), module.exports);

});
parcelRegister("f7U78", function(module, exports) {
"use strict";
var $b0330989de6a5f1f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useExperimentValue = module.exports.useFeatureGate = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $b0330989de6a5f1f$var$feature_gate_js_client_1 = $b0330989de6a5f1f$var$__importDefault((parcelRequire("boRTX")));
const $b0330989de6a5f1f$var$useFeatureGate = (gateName, options = {})=>{
    const [gate, setGate] = (0, $8ZuGG.useState)(()=>$b0330989de6a5f1f$var$feature_gate_js_client_1.default.checkGate(gateName, options));
    (0, $8ZuGG.useEffect)(()=>{
        const onGateChange = (newValue)=>setGate(newValue);
        return $b0330989de6a5f1f$var$feature_gate_js_client_1.default.onGateUpdated(gateName, onGateChange, options);
    }, [
        gateName,
        options
    ]);
    return gate;
};
module.exports.useFeatureGate = $b0330989de6a5f1f$var$useFeatureGate;
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $b0330989de6a5f1f$var$useExperimentValue = (experimentName, parameterName, defaultValue, options = {})=>{
    const [experimentValue, setExperimentValue] = (0, $8ZuGG.useState)(()=>$b0330989de6a5f1f$var$feature_gate_js_client_1.default.getExperimentValue(experimentName, parameterName, defaultValue, options));
    (0, $8ZuGG.useEffect)(()=>{
        const onExperimentValueChange = (newValue)=>setExperimentValue(newValue);
        return $b0330989de6a5f1f$var$feature_gate_js_client_1.default.onExperimentValueUpdated(experimentName, parameterName, defaultValue, onExperimentValueChange, options);
    }, [
        experimentName,
        parameterName,
        defaultValue,
        options
    ]);
    return experimentValue;
};
module.exports.useExperimentValue = $b0330989de6a5f1f$var$useExperimentValue;

});
parcelRegister("boRTX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fYaTm")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("51qEW")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("51qEW")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("g1oWB")).CLIENT_VERSION; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("9rkul")).DynamicConfig; });
$parcel$export(module.exports, "Layer", function () { return (parcelRequire("hZGkZ")).Layer; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("cX2CT")).EvaluationReason; });
parcelRequire("fYaTm");
var $g1oWB = parcelRequire("g1oWB");
var $fYaTm = parcelRequire("fYaTm");
var $51qEW = parcelRequire("51qEW");

var $9rkul = parcelRequire("9rkul");

var $hZGkZ = parcelRequire("hZGkZ");

var $cX2CT = parcelRequire("cX2CT");

});


parcelRegister("6XahI", function(module, exports) {
"use strict";
var $51003b198f03e743$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $51003b198f03e743$var$feature_gate_js_client_1 = $51003b198f03e743$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $51003b198f03e743$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $51003b198f03e743$var$feature_gate_js_client_1.default.initializeCalled() ? $51003b198f03e743$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $51003b198f03e743$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $aGsgY.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $51003b198f03e743$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("aGsgY", function(module, exports) {
"use strict";
var $7c73c20059986bcf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isClientAlreadyInCorrectState = $7c73c20059986bcf$var$isClientAlreadyInCorrectState;
module.exports.pickChildToRender = $7c73c20059986bcf$var$pickChildToRender;
module.exports.toError = $7c73c20059986bcf$var$toError;
module.exports.applyOverrides = $7c73c20059986bcf$var$applyOverrides;
module.exports.clearOverrides = $7c73c20059986bcf$var$clearOverrides;

const $7c73c20059986bcf$var$react_1 = $7c73c20059986bcf$var$__importDefault((parcelRequire("8ZuGG")));

const $7c73c20059986bcf$var$feature_gate_js_client_1 = $7c73c20059986bcf$var$__importDefault((parcelRequire("boRTX")));
let $7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport = false;
function $7c73c20059986bcf$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default)) && ((_b = $7c73c20059986bcf$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
function $7c73c20059986bcf$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $7c73c20059986bcf$var$react_1.default.createElement($7c73c20059986bcf$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $7c73c20059986bcf$var$react_1.default.createElement($7c73c20059986bcf$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
function $7c73c20059986bcf$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
function $7c73c20059986bcf$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideGate || !$7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn('Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+');
            $7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, configName, values);
    });
}
function $7c73c20059986bcf$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, configName);
    });
}

});


parcelRegister("h1gNA", function(module, exports) {
"use strict";
var $c63f8f8cecdbb984$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithProvider = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $c63f8f8cecdbb984$var$feature_gate_js_client_1 = $c63f8f8cecdbb984$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $c63f8f8cecdbb984$var$FeatureGatesInitializationWithProvider = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady, provider: provider })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options and provider, so that we can use them within the following useEffect
    // without adding options and provider as dependencies.
    // This avoids the user updating every time an option or provider is attempted to be changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    const providerRef = (0, $8ZuGG.useRef)(provider);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
        providerRef.current = provider;
    }, [
        options,
        provider
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $c63f8f8cecdbb984$var$feature_gate_js_client_1.default.initializeCalled() ? $c63f8f8cecdbb984$var$feature_gate_js_client_1.default.updateUserWithProvider(identifiers, customAttributes) : $c63f8f8cecdbb984$var$feature_gate_js_client_1.default.initializeWithProvider(options, provider, identifiers, customAttributes);
                initPromise.catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $aGsgY.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitializationWithProvider = $c63f8f8cecdbb984$var$FeatureGatesInitializationWithProvider;
module.exports.default = module.exports.FeatureGatesInitializationWithProvider;

});

parcelRegister("7YQq7", function(module, exports) {
"use strict";
var $5cf6cc996f6bccec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $5cf6cc996f6bccec$var$feature_gate_js_client_1 = $5cf6cc996f6bccec$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $5cf6cc996f6bccec$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.initializeCalled() ? $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: 'client-default-key'
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $aGsgY.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $5cf6cc996f6bccec$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("eYpIx", function(module, exports) {
"use strict";
var $ae6a9e32a43bfbea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $ae6a9e32a43bfbea$var$feature_gate_js_client_1 = $ae6a9e32a43bfbea$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ae6a9e32a43bfbea$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.initializeCalled() ? $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    (0, $aGsgY.applyOverrides)(overrides);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ae6a9e32a43bfbea$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


parcelRegister("f81B8", function(module, exports) {

$parcel$export(module.exports, "statsigTargetApp", function () { return $85cfef0e58df38df$export$c0273fbd336e77ca; });
$parcel$export(module.exports, "getStatsigApiKey", function () { return $85cfef0e58df38df$export$2f2c106effb3792; });
$parcel$export(module.exports, "getBooleanDynamicConfigValueOrDefault", function () { return $85cfef0e58df38df$export$ca7b7b70279af0; });

var $lk8Tl = parcelRequire("lk8Tl");
const $85cfef0e58df38df$export$c0273fbd336e77ca = 'aid-frontend_web';
const $85cfef0e58df38df$export$2f2c106effb3792 = ()=>{
    // Provided by https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
    switch(0, $lk8Tl.currentEnv){
        case 'dev':
        case 'local':
            return 'f0f574a2-4bcc-4049-a7d3-6a08637916e0';
        case 'stg':
        case 'stg-ic':
            return 'de816d56-15e9-402b-8d1b-09ab6175bb1c';
        case 'stg-fedm':
            return '487d67c3-d876-46d4-ac06-7a4b066e5b78';
        case 'prod-fedm':
            return 'e8a35d9c-f310-4842-9141-66e28cd0d395';
        case 'prod':
        case 'prod-ic':
        default:
            return 'af2669c5-bf1e-48d6-b37d-a8514b7073d2';
    }
};
const $85cfef0e58df38df$export$ca7b7b70279af0 = (dynamicConfigs, configKey)=>{
    const configResult = dynamicConfigs.getBoolean(configKey);
    if ('value' in configResult) return configResult.value;
    return false;
};

});


parcelRegister("erZlf", function(module, exports) {

$parcel$export(module.exports, "initializeDynamicConfigs", function () { return $dc94064655470ccc$export$d00723e9d793f99d; });
$parcel$export(module.exports, "DynamicConfigsContext", function () { return $dc94064655470ccc$export$70e7649e6de93d3; });
$parcel$export(module.exports, "useDynamicConfigs", function () { return $dc94064655470ccc$export$d18460a0831bab92; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $eVyT7 = parcelRequire("eVyT7");
var $6HOQX = parcelRequire("6HOQX");

var $lk8Tl = parcelRequire("lk8Tl");

var $f81B8 = parcelRequire("f81B8");

var $8f2pb = parcelRequire("8f2pb");
const $dc94064655470ccc$var$getDynamicConfigsClientBaseUrl = ()=>{
    // Provided by https://atlaskit.atlassian.com/packages/measurement/web-config-client
    switch((0, $lk8Tl.getCurrentEnv)()){
        case 'dev':
        case 'local':
            return 'https://api.dev.atlassian.com/flags';
        case 'stg':
        case 'stg-ic':
            return 'https://api.stg.atlassian.com/flags';
        case 'stg-fedm':
        case 'prod-fedm':
            // see https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-74313/about to track FedRAMP availability
            console.warn('Dynamic configs are not currently supported in FedRAMP environments');
            return null;
        case 'prod':
        case 'prod-ic':
        default:
            return 'https://api.atlassian.com/flags';
    }
};
const $dc94064655470ccc$export$f636ae968f78fa38 = 10000;
const $dc94064655470ccc$export$d00723e9d793f99d = async (analyticsAnonymousId)=>{
    const baseUrl = $dc94064655470ccc$var$getDynamicConfigsClientBaseUrl();
    if (baseUrl === null) return (0, $6HOQX.ConfigCollection).empty();
    try {
        return await (0, $eVyT7.ConfigClient).fetch({
            ffsBaseUrl: baseUrl,
            ffsApiKey: (0, $f81B8.getStatsigApiKey)(),
            context: {
                namespace: (0, $f81B8.statsigTargetApp),
                // this uses a subset of the identifiers that the feature gates client uses. We can add more in future if they are needed.
                identifiers: {
                    analyticsAnonymousId: analyticsAnonymousId
                },
                metadata: {}
            },
            fetch: (input, init)=>{
                var _AbortSignal_timeout, _AbortSignal;
                return fetch(input, (0, $6EnDC._)((0, $ty6PY._)({}, init), {
                    signal: (_AbortSignal = AbortSignal) === null || _AbortSignal === void 0 ? void 0 : (_AbortSignal_timeout = _AbortSignal.timeout) === null || _AbortSignal_timeout === void 0 ? void 0 : _AbortSignal_timeout.call(_AbortSignal, $dc94064655470ccc$export$f636ae968f78fa38)
                }));
            }
        });
    } catch (error) {
        (0, $8f2pb.captureException)(error);
        console.error('Error creating Statsig dynamic config collection. Falling back to empty collection.');
        return (0, $6HOQX.ConfigCollection).empty();
    }
};
const $dc94064655470ccc$export$70e7649e6de93d3 = (0, $8ZuGG.createContext)(undefined);
const $dc94064655470ccc$export$d18460a0831bab92 = ()=>{
    const context = (0, $8ZuGG.useContext)($dc94064655470ccc$export$70e7649e6de93d3);
    if (!context) throw new Error('useDynamicConfigsClient used outside of DynamicConfigsClientProvider.');
    return context;
};

});
parcelRegister("eVyT7", function(module, exports) {

$parcel$export(module.exports, "ConfigClient", function () { return $ade17398dad4f267$export$8489e2f039bfcc4c; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $6HOQX = parcelRequire("6HOQX");
var $ade17398dad4f267$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ConfigClient);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: 'POST',
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        'content-type': 'application/json',
                                        'x-api-key': options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $6HOQX.ConfigCollection).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
}();

});
parcelRegister("6HOQX", function(module, exports) {

$parcel$export(module.exports, "ConfigCollection", function () { return $4e1e34a0383b14f9$export$2be5653e4dada0a3; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $3Fq9h = parcelRequire("3Fq9h");

var $lqrCA = parcelRequire("lqrCA");
function $4e1e34a0383b14f9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $4e1e34a0383b14f9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $4e1e34a0383b14f9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4e1e34a0383b14f9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4e1e34a0383b14f9$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    function ParseError(message, cause) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ParseError);
        _this = $4e1e34a0383b14f9$var$_callSuper(this, ParseError, [
            message
        ]);
        _this.cause = cause;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(ParseError, _Error);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ParseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));
function $4e1e34a0383b14f9$var$safeParse(json) {
    try {
        return {
            data: (0, $lqrCA.AnyConfigSchema).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $4e1e34a0383b14f9$export$f9c837a54db411d('An unknown error occurred during parsing', error)
        };
    }
}
var $4e1e34a0383b14f9$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ConfigCollection);
        this.config = config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case 'standard':
                        return JSON.stringify((0, $lqrCA.mapToStandard)(this.config));
                    case 'minimal':
                        return JSON.stringify((0, $lqrCA.mapToMinimal)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $lqrCA.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'boolean') return {
                    error: (0, $lqrCA.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $lqrCA.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'string') return {
                    error: (0, $lqrCA.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $lqrCA.ConfigError).NotFound
                };
                var value = config.value;
                if (typeof value !== 'number') return {
                    error: (0, $lqrCA.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $lqrCA.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'string';
                })) return {
                    error: (0, $lqrCA.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $lqrCA.ConfigError).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === 'number';
                })) return {
                    error: (0, $lqrCA.ConfigError).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $4e1e34a0383b14f9$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $4e1e34a0383b14f9$export$f9c837a54db411d('Failed to deserialize config', result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $lqrCA.minimalToMap)(result.data) : (0, $lqrCA.standardToMap)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
}();

});
parcelRegister("lqrCA", function(module, exports) {

$parcel$export(module.exports, "ConfigError", function () { return $f99173babae80fe1$export$c5fb415882705cf4; });
$parcel$export(module.exports, "AnyConfigSchema", function () { return $f99173babae80fe1$export$960d45de79bd7d81; });
$parcel$export(module.exports, "minimalToMap", function () { return $f99173babae80fe1$export$c29ba52779f58587; });
$parcel$export(module.exports, "standardToMap", function () { return $f99173babae80fe1$export$be5b69ecb011d7cc; });
$parcel$export(module.exports, "mapToMinimal", function () { return $f99173babae80fe1$export$460f06addafd9f86; });
$parcel$export(module.exports, "mapToStandard", function () { return $f99173babae80fe1$export$9d0101ad8235e092; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kg5sN = parcelRequire("kg5sN");

var $byJly = parcelRequire("byJly");
function $f99173babae80fe1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f99173babae80fe1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f99173babae80fe1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f99173babae80fe1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f99173babae80fe1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f99173babae80fe1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f99173babae80fe1$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $f99173babae80fe1$export$e94ee64b2671e155 = (0, $byJly.z).record((0, $byJly.z).string(), (0, $byJly.z).object({
    value: (0, $byJly.z).union([
        (0, $byJly.z).boolean(),
        (0, $byJly.z).string(),
        (0, $byJly.z).number(),
        (0, $byJly.z).string().array(),
        (0, $byJly.z).number().array()
    ])
}));
var $f99173babae80fe1$export$e38f7b10db0e126a = (0, $byJly.z).tuple([
    // list of boolean configs which are on
    (0, $byJly.z).string().array(),
    // list of string config tuples
    (0, $byJly.z).array((0, $byJly.z).string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    (0, $byJly.z).array((0, $byJly.z).union([
        (0, $byJly.z).string(),
        (0, $byJly.z).number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== 'string') return false;
            if (typeof arr[i + 1] !== 'number') return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $byJly.z).array((0, $byJly.z).union([
        (0, $byJly.z).string(),
        (0, $byJly.z).string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'string';
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $byJly.z).array((0, $byJly.z).union([
        (0, $byJly.z).string(),
        (0, $byJly.z).number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== 'string') return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === 'number';
            })) return false;
        }
        return true;
    })
]);
var $f99173babae80fe1$export$960d45de79bd7d81 = (0, $byJly.z).union([
    $f99173babae80fe1$export$e94ee64b2671e155,
    $f99173babae80fe1$export$e38f7b10db0e126a
]);
var $f99173babae80fe1$export$ac2e9c88ba5d7cbb = (0, $byJly.z).map((0, $byJly.z).string(), (0, $byJly.z).object({
    value: (0, $byJly.z).union([
        (0, $byJly.z).boolean(),
        (0, $byJly.z).string(),
        (0, $byJly.z).number(),
        (0, $byJly.z).string().array(),
        (0, $byJly.z).number().array()
    ])
}));
function $f99173babae80fe1$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== 'string') throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $f99173babae80fe1$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $f99173babae80fe1$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $f99173babae80fe1$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $f99173babae80fe1$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $f99173babae80fe1$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value)){
                case 'boolean':
                    if (value) minimal[0].push(key);
                    break;
                case 'string':
                    minimal[1].push(key, value);
                    break;
                case 'number':
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === 'string';
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === 'number';
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $f99173babae80fe1$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}

});
parcelRegister("byJly", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $8cbe139e0fba169a$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
var $8cbe139e0fba169a$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($8cbe139e0fba169a$export$7debb50ef11d5e0b || ($8cbe139e0fba169a$export$7debb50ef11d5e0b = {}));
var $8cbe139e0fba169a$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return (0, $ty6PY._)({}, first, second);
    };
})($8cbe139e0fba169a$export$4aa2142c225fd5c7 || ($8cbe139e0fba169a$export$4aa2142c225fd5c7 = {}));
const $8cbe139e0fba169a$export$5716da67bfaa244d = $8cbe139e0fba169a$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $8cbe139e0fba169a$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.undefined;
        case "string":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $8cbe139e0fba169a$export$5716da67bfaa244d.nan : $8cbe139e0fba169a$export$5716da67bfaa244d.number;
        case "boolean":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.boolean;
        case "function":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.function;
        case "bigint":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $8cbe139e0fba169a$export$5716da67bfaa244d.array;
            if (data === null) return $8cbe139e0fba169a$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $8cbe139e0fba169a$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $8cbe139e0fba169a$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $8cbe139e0fba169a$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $8cbe139e0fba169a$export$5716da67bfaa244d.date;
            return $8cbe139e0fba169a$export$5716da67bfaa244d.object;
        default:
            return $8cbe139e0fba169a$export$5716da67bfaa244d.unknown;
    }
};
const $8cbe139e0fba169a$export$5ba560653e4a1035 = $8cbe139e0fba169a$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $8cbe139e0fba169a$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $8cbe139e0fba169a$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $8cbe139e0fba169a$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $8cbe139e0fba169a$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$8cbe139e0fba169a$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $8cbe139e0fba169a$export$f98dac4b251ab333(issues);
    return error;
};
const $8cbe139e0fba169a$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $8cbe139e0fba169a$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $8cbe139e0fba169a$var$overrideErrorMap = $8cbe139e0fba169a$export$341b0b6e0a6f5099;
function $8cbe139e0fba169a$export$1097a8289cfd22d7(map) {
    $8cbe139e0fba169a$var$overrideErrorMap = map;
}
function $8cbe139e0fba169a$export$32f27c719778d4c4() {
    return $8cbe139e0fba169a$var$overrideErrorMap;
}
const $8cbe139e0fba169a$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = (0, $6EnDC._)((0, $ty6PY._)({}, issueData), {
        path: fullPath
    });
    if (issueData.message !== undefined) return (0, $6EnDC._)((0, $ty6PY._)({}, issueData), {
        path: fullPath,
        message: issueData.message
    });
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return (0, $6EnDC._)((0, $ty6PY._)({}, issueData), {
        path: fullPath,
        message: errorMessage
    });
};
const $8cbe139e0fba169a$export$1526d2e05f74572 = [];
function $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $8cbe139e0fba169a$export$32f27c719778d4c4();
    const issue = $8cbe139e0fba169a$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $8cbe139e0fba169a$export$341b0b6e0a6f5099 ? undefined : $8cbe139e0fba169a$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $8cbe139e0fba169a$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $8cbe139e0fba169a$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $8cbe139e0fba169a$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $8cbe139e0fba169a$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $8cbe139e0fba169a$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $8cbe139e0fba169a$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $8cbe139e0fba169a$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $8cbe139e0fba169a$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8cbe139e0fba169a$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8cbe139e0fba169a$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $8cbe139e0fba169a$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($8cbe139e0fba169a$var$errorUtil || ($8cbe139e0fba169a$var$errorUtil = {}));
var $8cbe139e0fba169a$var$_ZodEnum_cache, $8cbe139e0fba169a$var$_ZodNativeEnum_cache;
class $8cbe139e0fba169a$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $8cbe139e0fba169a$var$handleResult = (ctx, result)=>{
    if ($8cbe139e0fba169a$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $8cbe139e0fba169a$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $8cbe139e0fba169a$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $8cbe139e0fba169a$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $8cbe139e0fba169a$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue((0, $ty6PY._)({
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.custom
                }, getIssueProperties(val)));
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $8cbe139e0fba169a$export$a60af00cc0ce2582({
            schema: this,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $8cbe139e0fba169a$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $8cbe139e0fba169a$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $8cbe139e0fba169a$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $8cbe139e0fba169a$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $8cbe139e0fba169a$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $8cbe139e0fba169a$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $8cbe139e0fba169a$export$a60af00cc0ce2582((0, $6EnDC._)((0, $ty6PY._)({}, $8cbe139e0fba169a$var$processCreateParams(this._def)), {
            schema: this,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        }));
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8cbe139e0fba169a$export$bb19b37874861e7e((0, $6EnDC._)((0, $ty6PY._)({}, $8cbe139e0fba169a$var$processCreateParams(this._def)), {
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDefault
        }));
    }
    brand() {
        return new $8cbe139e0fba169a$export$66b0c798a395271f((0, $ty6PY._)({
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBranded,
            type: this
        }, $8cbe139e0fba169a$var$processCreateParams(this._def)));
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8cbe139e0fba169a$export$75a44ec6249ac76b((0, $6EnDC._)((0, $ty6PY._)({}, $8cbe139e0fba169a$var$processCreateParams(this._def)), {
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodCatch
        }));
    }
    describe(description) {
        const This = this.constructor;
        return new This((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            description: description
        }));
    }
    pipe(target) {
        return $8cbe139e0fba169a$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $8cbe139e0fba169a$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $8cbe139e0fba169a$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $8cbe139e0fba169a$var$cuid2Regex = /^[0-9a-z]+$/;
const $8cbe139e0fba169a$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $8cbe139e0fba169a$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $8cbe139e0fba169a$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $8cbe139e0fba169a$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $8cbe139e0fba169a$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $8cbe139e0fba169a$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $8cbe139e0fba169a$var$emojiRegex;
// faster, simpler, safer
const $8cbe139e0fba169a$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $8cbe139e0fba169a$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $8cbe139e0fba169a$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $8cbe139e0fba169a$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $8cbe139e0fba169a$var$dateRegex = new RegExp(`^${$8cbe139e0fba169a$var$dateRegexSource}$`);
function $8cbe139e0fba169a$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $8cbe139e0fba169a$var$timeRegex(args) {
    return new RegExp(`^${$8cbe139e0fba169a$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $8cbe139e0fba169a$export$a4b563879add27a(args) {
    let regex = `${$8cbe139e0fba169a$var$dateRegexSource}T${$8cbe139e0fba169a$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $8cbe139e0fba169a$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $8cbe139e0fba169a$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $8cbe139e0fba169a$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $8cbe139e0fba169a$export$1230eb29b8d3b502 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$8cbe139e0fba169a$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$8cbe139e0fba169a$var$emojiRegex) $8cbe139e0fba169a$var$emojiRegex = new RegExp($8cbe139e0fba169a$var$_emojiRegex, "u");
                if (!$8cbe139e0fba169a$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$8cbe139e0fba169a$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$8cbe139e0fba169a$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$8cbe139e0fba169a$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$8cbe139e0fba169a$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$8cbe139e0fba169a$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $8cbe139e0fba169a$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $8cbe139e0fba169a$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $8cbe139e0fba169a$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$8cbe139e0fba169a$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$8cbe139e0fba169a$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$8cbe139e0fba169a$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), (0, $ty6PY._)({
            validation: validation,
            code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    email(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "email"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    url(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "url"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    emoji(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "emoji"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    uuid(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "uuid"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    nanoid(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "nanoid"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    cuid(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "cuid"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    cuid2(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "cuid2"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    ulid(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "ulid"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    base64(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "base64"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    ip(options) {
        return this._addCheck((0, $ty6PY._)({
            kind: "ip"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(options)));
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck((0, $ty6PY._)({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck((0, $ty6PY._)({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    duration(message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "duration"
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    regex(regex, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "regex",
            regex: regex
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    includes(value, options) {
        return this._addCheck((0, $ty6PY._)({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
    }
    startsWith(value, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "startsWith",
            value: value
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    endsWith(value, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "endsWith",
            value: value
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    min(minLength, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "min",
            value: minLength
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    max(maxLength, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "max",
            value: maxLength
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    length(len, message) {
        return this._addCheck((0, $ty6PY._)({
            kind: "length",
            value: len
        }, $8cbe139e0fba169a$var$errorUtil.errToObj(message)));
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $8cbe139e0fba169a$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        }));
    }
    toLowerCase() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        }));
    }
    toUpperCase() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        }));
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8cbe139e0fba169a$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $8cbe139e0fba169a$export$1230eb29b8d3b502((0, $ty6PY._)({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $8cbe139e0fba169a$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $8cbe139e0fba169a$export$5b070a55c0c43e09 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$8cbe139e0fba169a$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($8cbe139e0fba169a$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8cbe139e0fba169a$export$5b070a55c0c43e09((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8cbe139e0fba169a$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$5b070a55c0c43e09((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $8cbe139e0fba169a$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$8cbe139e0fba169a$export$5b070a55c0c43e09.create = (params)=>{
    return new $8cbe139e0fba169a$export$5b070a55c0c43e09((0, $ty6PY._)({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$67d741fd70ff98f4 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8cbe139e0fba169a$export$67d741fd70ff98f4((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8cbe139e0fba169a$var$errorUtil.toString(message)
                }
            ]
        }));
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$67d741fd70ff98f4((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$8cbe139e0fba169a$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $8cbe139e0fba169a$export$67d741fd70ff98f4((0, $ty6PY._)({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$723d146f80596191 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$723d146f80596191.create = (params)=>{
    return new $8cbe139e0fba169a$export$723d146f80596191((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$e974be33bdc55521 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_date
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$e974be33bdc55521((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            checks: [
                ...this._def.checks,
                check
            ]
        }));
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$8cbe139e0fba169a$export$e974be33bdc55521.create = (params)=>{
    return new $8cbe139e0fba169a$export$e974be33bdc55521((0, $ty6PY._)({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDate
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$bcc3b40f6b638044 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$bcc3b40f6b638044.create = (params)=>{
    return new $8cbe139e0fba169a$export$bcc3b40f6b638044((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodSymbol
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$4e780e961c30340d extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$4e780e961c30340d.create = (params)=>{
    return new $8cbe139e0fba169a$export$4e780e961c30340d((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUndefined
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$a96281f914484f2d extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$a96281f914484f2d.create = (params)=>{
    return new $8cbe139e0fba169a$export$a96281f914484f2d((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNull
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$b9d1edb536b4e4eb extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$8cbe139e0fba169a$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $8cbe139e0fba169a$export$b9d1edb536b4e4eb((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodAny
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$ef3b1bb1630977ae extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$8cbe139e0fba169a$export$ef3b1bb1630977ae.create = (params)=>{
    return new $8cbe139e0fba169a$export$ef3b1bb1630977ae((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUnknown
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$1e576a20c3ce9fb5 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
            code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
            expected: $8cbe139e0fba169a$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $8cbe139e0fba169a$export$9a105a556e65c2c0;
    }
}
$8cbe139e0fba169a$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $8cbe139e0fba169a$export$1e576a20c3ce9fb5((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNever
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$7d39f5df85f21031 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$7d39f5df85f21031.create = (params)=>{
    return new $8cbe139e0fba169a$export$7d39f5df85f21031((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodVoid
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$7acfc3e64785411 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $8cbe139e0fba169a$export$5ba560653e4a1035.too_big : $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            minLength: {
                value: minLength,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxLength, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            maxLength: {
                value: maxLength,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        }));
    }
    length(len, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            exactLength: {
                value: len,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        }));
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8cbe139e0fba169a$export$7acfc3e64785411.create = (schema, params)=>{
    return new $8cbe139e0fba169a$export$7acfc3e64785411((0, $ty6PY._)({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodArray
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
function $8cbe139e0fba169a$var$deepPartialify(schema) {
    if (schema instanceof $8cbe139e0fba169a$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $8cbe139e0fba169a$export$aa56fec1e9d629b8.create($8cbe139e0fba169a$var$deepPartialify(fieldSchema));
        }
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, schema._def), {
            shape: ()=>newShape
        }));
    } else if (schema instanceof $8cbe139e0fba169a$export$7acfc3e64785411) return new $8cbe139e0fba169a$export$7acfc3e64785411((0, $6EnDC._)((0, $ty6PY._)({}, schema._def), {
        type: $8cbe139e0fba169a$var$deepPartialify(schema.element)
    }));
    else if (schema instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8) return $8cbe139e0fba169a$export$aa56fec1e9d629b8.create($8cbe139e0fba169a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8cbe139e0fba169a$export$aaac0b8b429cef5) return $8cbe139e0fba169a$export$aaac0b8b429cef5.create($8cbe139e0fba169a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8cbe139e0fba169a$export$e2a18bb771d8e6a3) return $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$8cbe139e0fba169a$var$deepPartialify(item)));
    else return schema;
}
class $8cbe139e0fba169a$export$736315c5b55efbad extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $8cbe139e0fba169a$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $8cbe139e0fba169a$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $8cbe139e0fba169a$var$errorUtil.errToObj;
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $ty6PY._)((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            unknownKeys: "strict"
        }), message !== undefined ? {
            errorMap: (issue, ctx)=>{
                var _a, _b, _c, _d;
                const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                if (issue.code === "unrecognized_keys") return {
                    message: (_d = $8cbe139e0fba169a$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                };
                return {
                    message: defaultError
                };
            }
        } : {}));
    }
    strip() {
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            unknownKeys: "strip"
        }));
    }
    passthrough() {
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            unknownKeys: "passthrough"
        }));
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            shape: ()=>(0, $ty6PY._)({}, this._def.shape(), augmentation)
        }));
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $8cbe139e0fba169a$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>(0, $ty6PY._)({}, this._def.shape(), merging._def.shape()),
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            catchall: index
        }));
    }
    pick(mask) {
        const shape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    omit(mask) {
        const shape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            shape: ()=>shape
        }));
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $8cbe139e0fba169a$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    required(mask) {
        const newShape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            shape: ()=>newShape
        }));
    }
    keyof() {
        return $8cbe139e0fba169a$var$createZodEnum($8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$8cbe139e0fba169a$export$736315c5b55efbad.create = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $ty6PY._)({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
$8cbe139e0fba169a$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $ty6PY._)({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
$8cbe139e0fba169a$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad((0, $ty6PY._)({
        shape: shape,
        unknownKeys: "strip",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$a8b236cb5070a311 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $8cbe139e0fba169a$export$f98dac4b251ab333(result.ctx.common.issues));
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = (0, $6EnDC._)((0, $ty6PY._)({}, ctx), {
                common: (0, $6EnDC._)((0, $ty6PY._)({}, ctx.common), {
                    issues: []
                }),
                parent: null
            });
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = (0, $6EnDC._)((0, $ty6PY._)({}, ctx), {
                    common: (0, $6EnDC._)((0, $ty6PY._)({}, ctx.common), {
                        issues: []
                    }),
                    parent: null
                });
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $8cbe139e0fba169a$export$f98dac4b251ab333(issues));
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$8cbe139e0fba169a$export$a8b236cb5070a311.create = (types, params)=>{
    return new $8cbe139e0fba169a$export$a8b236cb5070a311((0, $ty6PY._)({
        options: types,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUnion
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $8cbe139e0fba169a$var$getDiscriminator = (type)=>{
    if (type instanceof $8cbe139e0fba169a$export$378d0cfce37406e6) return $8cbe139e0fba169a$var$getDiscriminator(type.schema);
    else if (type instanceof $8cbe139e0fba169a$export$a60af00cc0ce2582) return $8cbe139e0fba169a$var$getDiscriminator(type.innerType());
    else if (type instanceof $8cbe139e0fba169a$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $8cbe139e0fba169a$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $8cbe139e0fba169a$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $8cbe139e0fba169a$export$bb19b37874861e7e) return $8cbe139e0fba169a$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $8cbe139e0fba169a$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $8cbe139e0fba169a$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8) return [
        undefined,
        ...$8cbe139e0fba169a$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8cbe139e0fba169a$export$aaac0b8b429cef5) return [
        null,
        ...$8cbe139e0fba169a$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8cbe139e0fba169a$export$66b0c798a395271f) return $8cbe139e0fba169a$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8cbe139e0fba169a$export$5d1f7ef05c4e493a) return $8cbe139e0fba169a$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8cbe139e0fba169a$export$75a44ec6249ac76b) return $8cbe139e0fba169a$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $8cbe139e0fba169a$export$5ef2424805ac76a3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $8cbe139e0fba169a$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $8cbe139e0fba169a$export$5ef2424805ac76a3((0, $ty6PY._)({
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap
        }, $8cbe139e0fba169a$var$processCreateParams(params)));
    }
}
function $8cbe139e0fba169a$var$mergeValues(a, b) {
    const aType = $8cbe139e0fba169a$export$3e9057828ebd5c7a(a);
    const bType = $8cbe139e0fba169a$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.object && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
        const bKeys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = (0, $ty6PY._)({}, a, b);
        for (const key of sharedKeys){
            const sharedValue = $8cbe139e0fba169a$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.array && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $8cbe139e0fba169a$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.date && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $8cbe139e0fba169a$export$c02deaf0bb5203d4 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($8cbe139e0fba169a$export$afa861e3c5730743(parsedLeft) || $8cbe139e0fba169a$export$afa861e3c5730743(parsedRight)) return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            const merged = $8cbe139e0fba169a$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            }
            if ($8cbe139e0fba169a$export$910b6cdd390341b3(parsedLeft) || $8cbe139e0fba169a$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$8cbe139e0fba169a$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $8cbe139e0fba169a$export$c02deaf0bb5203d4((0, $ty6PY._)({
        left: left,
        right: right,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodIntersection
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$e2a18bb771d8e6a3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $8cbe139e0fba169a$export$e2a18bb771d8e6a3((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            rest: rest
        }));
    }
}
$8cbe139e0fba169a$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $8cbe139e0fba169a$export$e2a18bb771d8e6a3((0, $ty6PY._)({
        items: schemas,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodTuple,
        rest: null
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$a2acc09968cb4b7f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $8cbe139e0fba169a$export$19342e026b58ebb7) return new $8cbe139e0fba169a$export$a2acc09968cb4b7f((0, $ty6PY._)({
            keyType: first,
            valueType: second,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodRecord
        }, $8cbe139e0fba169a$var$processCreateParams(third)));
        return new $8cbe139e0fba169a$export$a2acc09968cb4b7f((0, $ty6PY._)({
            keyType: $8cbe139e0fba169a$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodRecord
        }, $8cbe139e0fba169a$var$processCreateParams(second)));
    }
}
class $8cbe139e0fba169a$export$163b6a2b712d9542 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.map) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$8cbe139e0fba169a$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $8cbe139e0fba169a$export$163b6a2b712d9542((0, $ty6PY._)({
        valueType: valueType,
        keyType: keyType,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodMap
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$977057706f816712 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.set) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $8cbe139e0fba169a$export$977057706f816712((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            minSize: {
                value: minSize,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        }));
    }
    max(maxSize, message) {
        return new $8cbe139e0fba169a$export$977057706f816712((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            maxSize: {
                value: maxSize,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        }));
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8cbe139e0fba169a$export$977057706f816712.create = (valueType, params)=>{
    return new $8cbe139e0fba169a$export$977057706f816712((0, $ty6PY._)({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodSet
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$d4602ba55673f53c extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.function) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $8cbe139e0fba169a$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8cbe139e0fba169a$export$32f27c719778d4c4(),
                    $8cbe139e0fba169a$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $8cbe139e0fba169a$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8cbe139e0fba169a$export$32f27c719778d4c4(),
                    $8cbe139e0fba169a$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $8cbe139e0fba169a$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8cbe139e0fba169a$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $8cbe139e0fba169a$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8cbe139e0fba169a$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $8cbe139e0fba169a$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $8cbe139e0fba169a$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            args: $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create(items).rest($8cbe139e0fba169a$export$ef3b1bb1630977ae.create())
        }));
    }
    returns(returnType) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c((0, $6EnDC._)((0, $ty6PY._)({}, this._def), {
            returns: returnType
        }));
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c((0, $ty6PY._)({
            args: args ? args : $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create([]).rest($8cbe139e0fba169a$export$ef3b1bb1630977ae.create()),
            returns: returns || $8cbe139e0fba169a$export$ef3b1bb1630977ae.create(),
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodFunction
        }, $8cbe139e0fba169a$var$processCreateParams(params)));
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $8cbe139e0fba169a$export$378d0cfce37406e6 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$8cbe139e0fba169a$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $8cbe139e0fba169a$export$378d0cfce37406e6((0, $ty6PY._)({
        getter: getter,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodLazy
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$7e44096782a165d3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$8cbe139e0fba169a$export$7e44096782a165d3.create = (value, params)=>{
    return new $8cbe139e0fba169a$export$7e44096782a165d3((0, $ty6PY._)({
        value: value,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodLiteral
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
function $8cbe139e0fba169a$var$createZodEnum(values, params) {
    return new $8cbe139e0fba169a$export$d325d1f0e1c20179((0, $ty6PY._)({
        values: values,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEnum
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
}
class $8cbe139e0fba169a$export$d325d1f0e1c20179 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                expected: $8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, "f")) $8cbe139e0fba169a$var$__classPrivateFieldSet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $8cbe139e0fba169a$export$d325d1f0e1c20179.create(values, (0, $ty6PY._)({}, this._def, newDef));
    }
    exclude(values, newDef = this._def) {
        return $8cbe139e0fba169a$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), (0, $ty6PY._)({}, this._def, newDef));
    }
    constructor(){
        super(...arguments);
        $8cbe139e0fba169a$var$_ZodEnum_cache.set(this, void 0);
    }
}
$8cbe139e0fba169a$var$_ZodEnum_cache = new WeakMap();
$8cbe139e0fba169a$export$d325d1f0e1c20179.create = $8cbe139e0fba169a$var$createZodEnum;
class $8cbe139e0fba169a$export$370b2e8d6d6f5c56 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.string && ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.number) {
            const expectedValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                expected: $8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, "f")) $8cbe139e0fba169a$var$__classPrivateFieldSet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, new Set($8cbe139e0fba169a$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $8cbe139e0fba169a$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$8cbe139e0fba169a$var$_ZodNativeEnum_cache = new WeakMap();
$8cbe139e0fba169a$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $8cbe139e0fba169a$export$370b2e8d6d6f5c56((0, $ty6PY._)({
        values: values,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNativeEnum
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$3f196b0127d6e50a extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$8cbe139e0fba169a$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $8cbe139e0fba169a$export$3f196b0127d6e50a((0, $ty6PY._)({
        type: schema,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodPromise
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$a60af00cc0ce2582 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$8cbe139e0fba169a$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$8cbe139e0fba169a$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$8cbe139e0fba169a$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $8cbe139e0fba169a$export$a60af00cc0ce2582((0, $ty6PY._)({
        schema: schema,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
        effect: effect
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
$8cbe139e0fba169a$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $8cbe139e0fba169a$export$a60af00cc0ce2582((0, $ty6PY._)({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$aa56fec1e9d629b8 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) return $8cbe139e0fba169a$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$aa56fec1e9d629b8((0, $ty6PY._)({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodOptional
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$aaac0b8b429cef5 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.null) return $8cbe139e0fba169a$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$aaac0b8b429cef5((0, $ty6PY._)({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNullable
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$bb19b37874861e7e extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$bb19b37874861e7e.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$bb19b37874861e7e((0, $ty6PY._)({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$75a44ec6249ac76b extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = (0, $6EnDC._)((0, $ty6PY._)({}, ctx), {
            common: (0, $6EnDC._)((0, $ty6PY._)({}, ctx.common), {
                issues: []
            })
        });
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: (0, $ty6PY._)({}, newCtx)
        });
        if ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $8cbe139e0fba169a$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $8cbe139e0fba169a$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$75a44ec6249ac76b((0, $ty6PY._)({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
class $8cbe139e0fba169a$export$26ccfa0145e8511f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$8cbe139e0fba169a$export$26ccfa0145e8511f.create = (params)=>{
    return new $8cbe139e0fba169a$export$26ccfa0145e8511f((0, $ty6PY._)({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNaN
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
const $8cbe139e0fba169a$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $8cbe139e0fba169a$export$66b0c798a395271f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $8cbe139e0fba169a$export$a3c3ef8a0e95c6da extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $8cbe139e0fba169a$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $8cbe139e0fba169a$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $8cbe139e0fba169a$export$5d1f7ef05c4e493a extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($8cbe139e0fba169a$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$5d1f7ef05c4e493a((0, $ty6PY._)({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodReadonly
    }, $8cbe139e0fba169a$var$processCreateParams(params)));
};
function $8cbe139e0fba169a$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue((0, $6EnDC._)((0, $ty6PY._)({
                code: "custom"
            }, p2), {
                fatal: _fatal
            }));
        }
    });
    return $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create();
}
const $8cbe139e0fba169a$export$1ee8ee30835eab8b = {
    object: $8cbe139e0fba169a$export$736315c5b55efbad.lazycreate
};
var $8cbe139e0fba169a$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($8cbe139e0fba169a$export$558106ce543bd011 || ($8cbe139e0fba169a$export$558106ce543bd011 = {}));
const $8cbe139e0fba169a$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$8cbe139e0fba169a$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $8cbe139e0fba169a$export$22b082955e083ec3 = $8cbe139e0fba169a$export$1230eb29b8d3b502.create;
const $8cbe139e0fba169a$export$98e628dec113755e = $8cbe139e0fba169a$export$5b070a55c0c43e09.create;
const $8cbe139e0fba169a$export$9e06de0973666692 = $8cbe139e0fba169a$export$26ccfa0145e8511f.create;
const $8cbe139e0fba169a$export$a0f65b52274bcc00 = $8cbe139e0fba169a$export$67d741fd70ff98f4.create;
const $8cbe139e0fba169a$export$4a21f16c33752377 = $8cbe139e0fba169a$export$723d146f80596191.create;
const $8cbe139e0fba169a$export$324d90190a8b822a = $8cbe139e0fba169a$export$e974be33bdc55521.create;
const $8cbe139e0fba169a$export$8f701197936bc2a6 = $8cbe139e0fba169a$export$bcc3b40f6b638044.create;
const $8cbe139e0fba169a$export$1db45310990710a5 = $8cbe139e0fba169a$export$4e780e961c30340d.create;
const $8cbe139e0fba169a$export$7b1b591b262c240 = $8cbe139e0fba169a$export$a96281f914484f2d.create;
const $8cbe139e0fba169a$export$4154a199d7d90455 = $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create;
const $8cbe139e0fba169a$export$19282c40b967aec6 = $8cbe139e0fba169a$export$ef3b1bb1630977ae.create;
const $8cbe139e0fba169a$export$b3e22bcfd64c1022 = $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create;
const $8cbe139e0fba169a$export$490e536ee7389aeb = $8cbe139e0fba169a$export$7d39f5df85f21031.create;
const $8cbe139e0fba169a$export$2f23118c22fb2630 = $8cbe139e0fba169a$export$7acfc3e64785411.create;
const $8cbe139e0fba169a$export$be5493f9613cbbe = $8cbe139e0fba169a$export$736315c5b55efbad.create;
const $8cbe139e0fba169a$export$8fb0df5f40d0b477 = $8cbe139e0fba169a$export$736315c5b55efbad.strictCreate;
const $8cbe139e0fba169a$export$971dd5b0dfd021b6 = $8cbe139e0fba169a$export$a8b236cb5070a311.create;
const $8cbe139e0fba169a$export$4b888e40c4ee26dd = $8cbe139e0fba169a$export$5ef2424805ac76a3.create;
const $8cbe139e0fba169a$export$bc86dfbf7795668c = $8cbe139e0fba169a$export$c02deaf0bb5203d4.create;
const $8cbe139e0fba169a$export$65e3907585753458 = $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create;
const $8cbe139e0fba169a$export$e5185e241753e543 = $8cbe139e0fba169a$export$a2acc09968cb4b7f.create;
const $8cbe139e0fba169a$export$871de8747c9eaa88 = $8cbe139e0fba169a$export$163b6a2b712d9542.create;
const $8cbe139e0fba169a$export$adaa4cf7ef1b65be = $8cbe139e0fba169a$export$977057706f816712.create;
const $8cbe139e0fba169a$export$44e51c8aac7c2deb = $8cbe139e0fba169a$export$d4602ba55673f53c.create;
const $8cbe139e0fba169a$export$488013bae63b21da = $8cbe139e0fba169a$export$378d0cfce37406e6.create;
const $8cbe139e0fba169a$export$c8ec6e1ec9fefcb0 = $8cbe139e0fba169a$export$7e44096782a165d3.create;
const $8cbe139e0fba169a$export$78a99c8d44d72635 = $8cbe139e0fba169a$export$d325d1f0e1c20179.create;
const $8cbe139e0fba169a$export$6fe7eca19ebe5199 = $8cbe139e0fba169a$export$370b2e8d6d6f5c56.create;
const $8cbe139e0fba169a$export$c957ef27a0ebfd4 = $8cbe139e0fba169a$export$3f196b0127d6e50a.create;
const $8cbe139e0fba169a$export$dc573d8a6576cdb3 = $8cbe139e0fba169a$export$a60af00cc0ce2582.create;
const $8cbe139e0fba169a$export$516e28dec6a4b6d4 = $8cbe139e0fba169a$export$aa56fec1e9d629b8.create;
const $8cbe139e0fba169a$export$133fc36489ac9add = $8cbe139e0fba169a$export$aaac0b8b429cef5.create;
const $8cbe139e0fba169a$export$fc37fe19dfda43ee = $8cbe139e0fba169a$export$a60af00cc0ce2582.createWithPreprocess;
const $8cbe139e0fba169a$export$43f28b24e1eb8181 = $8cbe139e0fba169a$export$a3c3ef8a0e95c6da.create;
const $8cbe139e0fba169a$export$3b3d07727c5b702c = ()=>$8cbe139e0fba169a$export$22b082955e083ec3().optional();
const $8cbe139e0fba169a$export$eb150471a61fced6 = ()=>$8cbe139e0fba169a$export$98e628dec113755e().optional();
const $8cbe139e0fba169a$export$269251733cdcbbf1 = ()=>$8cbe139e0fba169a$export$4a21f16c33752377().optional();
const $8cbe139e0fba169a$export$8c14e57e778d3873 = {
    string: (arg)=>$8cbe139e0fba169a$export$1230eb29b8d3b502.create((0, $6EnDC._)((0, $ty6PY._)({}, arg), {
            coerce: true
        })),
    number: (arg)=>$8cbe139e0fba169a$export$5b070a55c0c43e09.create((0, $6EnDC._)((0, $ty6PY._)({}, arg), {
            coerce: true
        })),
    boolean: (arg)=>$8cbe139e0fba169a$export$723d146f80596191.create((0, $6EnDC._)((0, $ty6PY._)({}, arg), {
            coerce: true
        })),
    bigint: (arg)=>$8cbe139e0fba169a$export$67d741fd70ff98f4.create((0, $6EnDC._)((0, $ty6PY._)({}, arg), {
            coerce: true
        })),
    date: (arg)=>$8cbe139e0fba169a$export$e974be33bdc55521.create((0, $6EnDC._)((0, $ty6PY._)({}, arg), {
            coerce: true
        }))
};
const $8cbe139e0fba169a$export$96c94437c95d7862 = $8cbe139e0fba169a$export$9a105a556e65c2c0;
var $8cbe139e0fba169a$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $8cbe139e0fba169a$export$341b0b6e0a6f5099,
    setErrorMap: $8cbe139e0fba169a$export$1097a8289cfd22d7,
    getErrorMap: $8cbe139e0fba169a$export$32f27c719778d4c4,
    makeIssue: $8cbe139e0fba169a$export$244a85fde9c419ed,
    EMPTY_PATH: $8cbe139e0fba169a$export$1526d2e05f74572,
    addIssueToContext: $8cbe139e0fba169a$export$db7caee60e5d514d,
    ParseStatus: $8cbe139e0fba169a$export$5b20a5c3d05c1f6f,
    INVALID: $8cbe139e0fba169a$export$9a105a556e65c2c0,
    DIRTY: $8cbe139e0fba169a$export$325a211da9693fcf,
    OK: $8cbe139e0fba169a$export$c6813a8d51f77eaf,
    isAborted: $8cbe139e0fba169a$export$afa861e3c5730743,
    isDirty: $8cbe139e0fba169a$export$910b6cdd390341b3,
    isValid: $8cbe139e0fba169a$export$1ea939691cdc45b8,
    isAsync: $8cbe139e0fba169a$export$aefee5ebe1dcfd9e,
    get util () {
        return $8cbe139e0fba169a$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $8cbe139e0fba169a$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $8cbe139e0fba169a$export$5716da67bfaa244d,
    getParsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a,
    ZodType: $8cbe139e0fba169a$export$19342e026b58ebb7,
    datetimeRegex: $8cbe139e0fba169a$export$a4b563879add27a,
    ZodString: $8cbe139e0fba169a$export$1230eb29b8d3b502,
    ZodNumber: $8cbe139e0fba169a$export$5b070a55c0c43e09,
    ZodBigInt: $8cbe139e0fba169a$export$67d741fd70ff98f4,
    ZodBoolean: $8cbe139e0fba169a$export$723d146f80596191,
    ZodDate: $8cbe139e0fba169a$export$e974be33bdc55521,
    ZodSymbol: $8cbe139e0fba169a$export$bcc3b40f6b638044,
    ZodUndefined: $8cbe139e0fba169a$export$4e780e961c30340d,
    ZodNull: $8cbe139e0fba169a$export$a96281f914484f2d,
    ZodAny: $8cbe139e0fba169a$export$b9d1edb536b4e4eb,
    ZodUnknown: $8cbe139e0fba169a$export$ef3b1bb1630977ae,
    ZodNever: $8cbe139e0fba169a$export$1e576a20c3ce9fb5,
    ZodVoid: $8cbe139e0fba169a$export$7d39f5df85f21031,
    ZodArray: $8cbe139e0fba169a$export$7acfc3e64785411,
    ZodObject: $8cbe139e0fba169a$export$736315c5b55efbad,
    ZodUnion: $8cbe139e0fba169a$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $8cbe139e0fba169a$export$5ef2424805ac76a3,
    ZodIntersection: $8cbe139e0fba169a$export$c02deaf0bb5203d4,
    ZodTuple: $8cbe139e0fba169a$export$e2a18bb771d8e6a3,
    ZodRecord: $8cbe139e0fba169a$export$a2acc09968cb4b7f,
    ZodMap: $8cbe139e0fba169a$export$163b6a2b712d9542,
    ZodSet: $8cbe139e0fba169a$export$977057706f816712,
    ZodFunction: $8cbe139e0fba169a$export$d4602ba55673f53c,
    ZodLazy: $8cbe139e0fba169a$export$378d0cfce37406e6,
    ZodLiteral: $8cbe139e0fba169a$export$7e44096782a165d3,
    ZodEnum: $8cbe139e0fba169a$export$d325d1f0e1c20179,
    ZodNativeEnum: $8cbe139e0fba169a$export$370b2e8d6d6f5c56,
    ZodPromise: $8cbe139e0fba169a$export$3f196b0127d6e50a,
    ZodEffects: $8cbe139e0fba169a$export$a60af00cc0ce2582,
    ZodTransformer: $8cbe139e0fba169a$export$a60af00cc0ce2582,
    ZodOptional: $8cbe139e0fba169a$export$aa56fec1e9d629b8,
    ZodNullable: $8cbe139e0fba169a$export$aaac0b8b429cef5,
    ZodDefault: $8cbe139e0fba169a$export$bb19b37874861e7e,
    ZodCatch: $8cbe139e0fba169a$export$75a44ec6249ac76b,
    ZodNaN: $8cbe139e0fba169a$export$26ccfa0145e8511f,
    BRAND: $8cbe139e0fba169a$export$cf2deea74cde46b4,
    ZodBranded: $8cbe139e0fba169a$export$66b0c798a395271f,
    ZodPipeline: $8cbe139e0fba169a$export$a3c3ef8a0e95c6da,
    ZodReadonly: $8cbe139e0fba169a$export$5d1f7ef05c4e493a,
    custom: $8cbe139e0fba169a$export$4c00f665f0d4b443,
    Schema: $8cbe139e0fba169a$export$19342e026b58ebb7,
    ZodSchema: $8cbe139e0fba169a$export$19342e026b58ebb7,
    late: $8cbe139e0fba169a$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $8cbe139e0fba169a$export$558106ce543bd011;
    },
    coerce: $8cbe139e0fba169a$export$8c14e57e778d3873,
    any: $8cbe139e0fba169a$export$4154a199d7d90455,
    array: $8cbe139e0fba169a$export$2f23118c22fb2630,
    bigint: $8cbe139e0fba169a$export$a0f65b52274bcc00,
    boolean: $8cbe139e0fba169a$export$4a21f16c33752377,
    date: $8cbe139e0fba169a$export$324d90190a8b822a,
    discriminatedUnion: $8cbe139e0fba169a$export$4b888e40c4ee26dd,
    effect: $8cbe139e0fba169a$export$dc573d8a6576cdb3,
    'enum': $8cbe139e0fba169a$export$78a99c8d44d72635,
    'function': $8cbe139e0fba169a$export$44e51c8aac7c2deb,
    'instanceof': $8cbe139e0fba169a$export$3d916e7c22dbd8b5,
    intersection: $8cbe139e0fba169a$export$bc86dfbf7795668c,
    lazy: $8cbe139e0fba169a$export$488013bae63b21da,
    literal: $8cbe139e0fba169a$export$c8ec6e1ec9fefcb0,
    map: $8cbe139e0fba169a$export$871de8747c9eaa88,
    nan: $8cbe139e0fba169a$export$9e06de0973666692,
    nativeEnum: $8cbe139e0fba169a$export$6fe7eca19ebe5199,
    never: $8cbe139e0fba169a$export$b3e22bcfd64c1022,
    'null': $8cbe139e0fba169a$export$7b1b591b262c240,
    nullable: $8cbe139e0fba169a$export$133fc36489ac9add,
    number: $8cbe139e0fba169a$export$98e628dec113755e,
    object: $8cbe139e0fba169a$export$be5493f9613cbbe,
    oboolean: $8cbe139e0fba169a$export$269251733cdcbbf1,
    onumber: $8cbe139e0fba169a$export$eb150471a61fced6,
    optional: $8cbe139e0fba169a$export$516e28dec6a4b6d4,
    ostring: $8cbe139e0fba169a$export$3b3d07727c5b702c,
    pipeline: $8cbe139e0fba169a$export$43f28b24e1eb8181,
    preprocess: $8cbe139e0fba169a$export$fc37fe19dfda43ee,
    promise: $8cbe139e0fba169a$export$c957ef27a0ebfd4,
    record: $8cbe139e0fba169a$export$e5185e241753e543,
    set: $8cbe139e0fba169a$export$adaa4cf7ef1b65be,
    strictObject: $8cbe139e0fba169a$export$8fb0df5f40d0b477,
    string: $8cbe139e0fba169a$export$22b082955e083ec3,
    symbol: $8cbe139e0fba169a$export$8f701197936bc2a6,
    transformer: $8cbe139e0fba169a$export$dc573d8a6576cdb3,
    tuple: $8cbe139e0fba169a$export$65e3907585753458,
    'undefined': $8cbe139e0fba169a$export$1db45310990710a5,
    union: $8cbe139e0fba169a$export$971dd5b0dfd021b6,
    unknown: $8cbe139e0fba169a$export$19282c40b967aec6,
    'void': $8cbe139e0fba169a$export$490e536ee7389aeb,
    NEVER: $8cbe139e0fba169a$export$96c94437c95d7862,
    ZodIssueCode: $8cbe139e0fba169a$export$5ba560653e4a1035,
    quotelessJson: $8cbe139e0fba169a$export$913eddeaf297cfea,
    ZodError: $8cbe139e0fba169a$export$f98dac4b251ab333
});

});





parcelRegister("2Py2O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20fac0b5f21971f1$export$2e2bcd8739ae039; });
function $20fac0b5f21971f1$export$2e2bcd8739ae039() {
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
}

});





parcelRegister("kQMDY", function(module, exports) {

$parcel$export(module.exports, "getPageLoadMetric", function () { return $359eacf0ab7b90aa$export$74b8bc7a2c5f037b; });

var $hZ7M7 = parcelRequire("hZ7M7");

var $jtt5y = parcelRequire("jtt5y");
const $359eacf0ab7b90aa$var$cachedMetrics = new Map();
const $359eacf0ab7b90aa$export$74b8bc7a2c5f037b = (pageId)=>{
    // Convert to kebab case to comply with naming convention:
    // https://hello.atlassian.net/wiki/spaces/APD/pages/1435310934/RUNBOOK+Get+the+Experience+Event+Key#Naming-conventions
    const page = pageId.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase();
    let metric = $359eacf0ab7b90aa$var$cachedMetrics.get(page);
    if (!metric) {
        metric = (0, $hZ7M7.metrics).pageLoad({
            key: page,
            custom: {
                isServedByBifrost: (0, $jtt5y.default)()
            }
        });
        $359eacf0ab7b90aa$var$cachedMetrics.set(page, metric);
    }
    return metric;
};

});
parcelRegister("hZ7M7", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $d17e2a21aa623649$export$b0c5c2fac8144e54; });

var $h5Ilp = parcelRequire("h5Ilp");

var $7t0cD = parcelRequire("7t0cD");
var $d17e2a21aa623649$export$b0c5c2fac8144e54 = {
    pageLoad: (0, $7t0cD.pageLoad),
    pageSegmentLoad: (0, $7t0cD.pageSegmentLoad),
    interaction: (0, $7t0cD.interaction),
    custom: (0, $7t0cD.custom),
    concurrent: (0, $h5Ilp.concurrent)
};

});
parcelRegister("h5Ilp", function(module, exports) {

$parcel$export(module.exports, "concurrent", function () { return $c7154d25447135d3$export$370df09ecc3de059; });

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $7t0cD = parcelRequire("7t0cD");
function $c7154d25447135d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7154d25447135d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7154d25447135d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7154d25447135d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c7154d25447135d3$var$concurrentMetrics = {};
var $c7154d25447135d3$var$getKey = function getKey(config, type) {
    return "".concat(type, "--").concat(config.key);
};
var $c7154d25447135d3$var$validateConfig = function validateConfig(config) {
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
var $c7154d25447135d3$var$ensurePath = function ensurePath(config, type) {
    var key = $c7154d25447135d3$var$getKey(config, type);
    if (!(key in $c7154d25447135d3$var$concurrentMetrics)) $c7154d25447135d3$var$concurrentMetrics[key] = {};
};
var $c7154d25447135d3$var$getMetricFromCache = function getMetricFromCache(concurrentId, config, type) {
    var concurrentKey = $c7154d25447135d3$var$getKey(config, type);
    if (concurrentKey in $c7154d25447135d3$var$concurrentMetrics && $c7154d25447135d3$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $c7154d25447135d3$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $c7154d25447135d3$var$concurrentMetrics)) $c7154d25447135d3$var$concurrentMetrics[concurrentKey] = {};
};
var $c7154d25447135d3$var$makeConcurrentMetric = function makeConcurrentMetric(concurrentId, config, type) {
    $c7154d25447135d3$var$validateConfig(config);
    $c7154d25447135d3$var$ensurePath(config, type);
    var metricFromCache = $c7154d25447135d3$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    var metricFactory = type === (0, $3GjBI.BMEventsType).INLINE_RESULT ? (0, $7t0cD.interaction) : (0, $7t0cD.custom);
    var metric = metricFactory(config);
    $c7154d25447135d3$var$concurrentMetrics[$c7154d25447135d3$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
var $c7154d25447135d3$export$370df09ecc3de059 = {
    pageSegmentLoad: function pageSegmentLoad(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD);
        };
    },
    interaction: function interaction(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).INLINE_RESULT);
        };
    },
    custom: function custom(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).CUSTOM);
        };
    }
};

});
parcelRegister("7t0cD", function(module, exports) {

$parcel$export(module.exports, "pageLoad", function () { return $56fb6620455df9e9$export$791d520f7e8058a5; });
$parcel$export(module.exports, "pageSegmentLoad", function () { return $56fb6620455df9e9$export$94114666844d5f66; });
$parcel$export(module.exports, "interaction", function () { return $56fb6620455df9e9$export$92473e6020ad89b4; });
$parcel$export(module.exports, "custom", function () { return $56fb6620455df9e9$export$4c00f665f0d4b443; });

var $6bkHe = parcelRequire("6bkHe");

var $gey0Z = parcelRequire("gey0Z");

var $ktpKo = parcelRequire("ktpKo");

var $irfSx = parcelRequire("irfSx");

var $3GjBI = parcelRequire("3GjBI");
function $56fb6620455df9e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56fb6620455df9e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56fb6620455df9e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56fb6620455df9e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56fb6620455df9e9$export$791d520f7e8058a5 = function pageLoad(config) {
    return new (0, $ktpKo.PageLoadMetric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).PAGE_LOAD
    }));
};
var $56fb6620455df9e9$export$94114666844d5f66 = function pageSegmentLoad(config) {
    return new (0, $irfSx.PageSegmentLoadMetric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD
    }));
};
var $56fb6620455df9e9$export$92473e6020ad89b4 = function interaction(config) {
    return new (0, $gey0Z.Metric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).INLINE_RESULT
    }));
};
var $56fb6620455df9e9$export$4c00f665f0d4b443 = function custom(config) {
    return new (0, $gey0Z.Metric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).CUSTOM
    }));
};

});
parcelRegister("gey0Z", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $bd1856cc44b38b75$export$efdd3e096bc27746; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $k6Eo3 = parcelRequire("k6Eo3");
function $bd1856cc44b38b75$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $bd1856cc44b38b75$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $bd1856cc44b38b75$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd1856cc44b38b75$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $bd1856cc44b38b75$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $bd1856cc44b38b75$export$efdd3e096bc27746 = /*#__PURE__*/ function(_BaseMetric) {
    function Metric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Metric);
        return $bd1856cc44b38b75$var$_callSuper(this, Metric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(Metric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Metric, [
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, startTime = _ref.startTime;
                $bd1856cc44b38b75$var$_superPropGet(Metric, "start", this, 3)([
                    {
                        startTime: startTime
                    }
                ]);
                this.route = (0, $eqyfk.Route).getRoute();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stoppedSuccessfully = $bd1856cc44b38b75$var$_superPropGet(Metric, "stop", this, 3)([
                    params
                ]);
                if (stoppedSuccessfully && !this.config.virtual) (0, $e1hkl.submitter).queue(this.getData());
                return stoppedSuccessfully;
            }
        }
    ]);
}((0, $k6Eo3.BaseMetric));

});

parcelRegister("ktpKo", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", function () { return $ee7a7cee80995e9b$export$3c51073271a9eac3; });

var $7f5qq = parcelRequire("7f5qq");

var $6bkHe = parcelRequire("6bkHe");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $5msJs = parcelRequire("5msJs");

var $1EyXZ = parcelRequire("1EyXZ");

var $1XCKE = parcelRequire("1XCKE");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $3GjBI = parcelRequire("3GjBI");

var $h5wBz = parcelRequire("h5wBz");

var $5EyB3 = parcelRequire("5EyB3");

var $lY7Rr = parcelRequire("lY7Rr");
function $ee7a7cee80995e9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee7a7cee80995e9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee7a7cee80995e9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee7a7cee80995e9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ee7a7cee80995e9b$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $ee7a7cee80995e9b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $ee7a7cee80995e9b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ee7a7cee80995e9b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ee7a7cee80995e9b$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ee7a7cee80995e9b$export$3c51073271a9eac3 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    function PageLoadMetric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageLoadMetric);
        return $ee7a7cee80995e9b$var$_callSuper(this, PageLoadMetric, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageLoadMetric, _BasePageLoadMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageLoadMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                (0, $5EyB3.pageLoadMetaMetric).startPageLoad($ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, params), {}, {
                    cancelStarted: 'startTime' in params
                }));
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stopTime = params.stopTime || window.performance.now();
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getDataToMerge();
                var metaMetricStopped = (0, $5EyB3.pageLoadMetaMetric).stop(params);
                if (!metaMetricStopped) return false;
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[(0, $h5wBz.BasePageLoadMetric).FMP]) {
                        var mark = (0, $1EyXZ.SSRGetDoneMark).getDoneMark();
                        if (mark) (0, $5EyB3.pageLoadMetaMetric).markFMP(mark);
                    } else (0, $5EyB3.pageLoadMetaMetric).markFMP(this.marks[(0, $h5wBz.BasePageLoadMetric).FMP]);
                }
                this.route = (0, $eqyfk.Route).getRoute();
                var metricStopped = this.stopPageLoad(pageLoadData, $ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, params), {}, {
                    stopTime: stopTime
                }));
                if (!metricStopped) return false;
                var data = this.getData();
                if (!this.config.virtual) (0, $e1hkl.submitter).queue(data);
                (0, $1XCKE.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
                this.enqueueWebVitals();
                return true;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                (0, $5EyB3.pageLoadMetaMetric).mark(_mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, $5EyB3.pageLoadMetaMetric).markFMP(timestamp);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var pageLoadMetaData = (0, $5EyB3.pageLoadMetaMetric).getData();
                return $ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, $ee7a7cee80995e9b$var$_superPropGet(PageLoadMetric, "getData", this, 3)([])), {}, {
                    // marks and explicitTimings are available only in pageLoadMeta
                    marks: pageLoadMetaData.marks,
                    explicitTimings: pageLoadMetaData.explicitTimings
                });
            }
        },
        {
            key: "enqueueWebVitals",
            value: function() {
                var _enqueueWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var _configChunk$BMEvents;
                    var configChunk, webVitalMetric;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(this.config.virtual || !this.isInitial)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.next = 4;
                                return (0, $e1hkl.submitter).config.configChunk;
                            case 4:
                                configChunk = _context.sent;
                                if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $3GjBI.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                                    _context.next = 7;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 7:
                                webVitalMetric = new (0, $lY7Rr.WebVitalsMetric)({
                                    key: this.config.key,
                                    route: this.route,
                                    startTime: this.startTime,
                                    stopTime: this.stopTime,
                                    pageVisibleState: this.pageVisibleState
                                });
                                (0, $e1hkl.submitter).queue(webVitalMetric.getData());
                                (0, $1XCKE.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
                                return _context.abrupt("return", true);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function enqueueWebVitals() {
                    return _enqueueWebVitals.apply(this, arguments);
                }
                return enqueueWebVitals;
            }()
        }
    ]);
}((0, $h5wBz.BasePageLoadMetric));

});
parcelRegister("lY7Rr", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", function () { return $ffe54c9d8566e3f6$export$dc0d85d4d6503cd7; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");
function $ffe54c9d8566e3f6$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $ffe54c9d8566e3f6$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $ffe54c9d8566e3f6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ffe54c9d8566e3f6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ffe54c9d8566e3f6$export$dc0d85d4d6503cd7 = /*#__PURE__*/ function(_BaseMetric) {
    function WebVitalsMetric(_ref) {
        var _this;
        var key = _ref.key, route = _ref.route, startTime = _ref.startTime, stopTime = _ref.stopTime, pageVisibleState = _ref.pageVisibleState;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, WebVitalsMetric);
        _this = $ffe54c9d8566e3f6$var$_callSuper(this, WebVitalsMetric, [
            {
                type: (0, $3GjBI.BMEventsType).WEB_VITALS,
                key: key
            }
        ]);
        _this.route = route;
        _this.startTime = startTime;
        _this.stopTime = stopTime;
        _this.state = (0, $k6Eo3.MetricState).FINISHED;
        _this.pageVisibleState = pageVisibleState;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(WebVitalsMetric, _BaseMetric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(WebVitalsMetric);
}((0, $k6Eo3.BaseMetric));

});


parcelRegister("irfSx", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", function () { return $d6c710ca3497cde9$export$24c8bfcd77494cc1; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $1EyXZ = parcelRequire("1EyXZ");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");

var $gey0Z = parcelRequire("gey0Z");

var $5EyB3 = parcelRequire("5EyB3");
function $d6c710ca3497cde9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6c710ca3497cde9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6c710ca3497cde9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6c710ca3497cde9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d6c710ca3497cde9$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $d6c710ca3497cde9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $d6c710ca3497cde9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d6c710ca3497cde9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $d6c710ca3497cde9$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $d6c710ca3497cde9$export$24c8bfcd77494cc1 = /*#__PURE__*/ function(_Metric) {
    function PageSegmentLoadMetric(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageSegmentLoadMetric);
        _this = $d6c710ca3497cde9$var$_callSuper(this, PageSegmentLoadMetric, [
            config
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "isInitial", true);
        _this.config = config;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageSegmentLoadMetric, _Metric);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageSegmentLoadMetric, [
        {
            key: "startFromPageLoad",
            value: function startFromPageLoad() {
                var _pageLoadMetaData$sta;
                var pageLoadMetaData = (0, $5EyB3.pageLoadMetaMetric).getData();
                this.start({
                    startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
                });
                this.isInitial = pageLoadMetaData.isInitial;
                this.pageVisibleState = pageLoadMetaData.pageVisibleState;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === PageSegmentLoadMetric.FMP) return;
                $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    _mark,
                    timestamp
                ]);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "mark", this, 3)([
                    PageSegmentLoadMetric.FMP,
                    timestamp
                ]);
            }
        },
        {
            key: "getPageSegmentLoadData",
            value: function getPageSegmentLoadData() {
                return {
                    isInitial: this.isInitial
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "getData", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "getDataToMerge", this, 3)([])), this.getPageSegmentLoadData());
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "merge", this, 3)([
                    mergeData
                ]);
                this.isInitial = mergeData.isInitial;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr, _this2 = this;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[PageSegmentLoadMetric.FMP]) {
                        var mark = (0, $1EyXZ.SSRGetDoneMark).getDoneMark();
                        if (mark) this.markFMP(mark);
                    }
                }
                if (this.config.includePageLoadTimings !== (0, $3GjBI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $k6Eo3.MetricState).FINISHED) return $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "stop", this, 3)([
                    params
                ]);
                var now = performance.now();
                if (pageLoadData.state === (0, $k6Eo3.MetricState).STARTED) (0, $5EyB3.pageLoadMetaMetric).onStop(function() {
                    $d6c710ca3497cde9$var$_superPropGet(PageSegmentLoadMetric, "stop", _this2, 3)([
                        $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, params), {}, {
                            stopTime: params.stopTime || now
                        })
                    ]);
                }, function() {
                    _this2.cancel();
                });
                return true;
            }
        }
    ]);
}((0, $gey0Z.Metric));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($d6c710ca3497cde9$export$24c8bfcd77494cc1, "FMP", 'fmp');

});




parcelRegister("jtt5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1a4baa2ba97a8e3$export$2e2bcd8739ae039; });
const $e1a4baa2ba97a8e3$var$EMPTY_APP_STATE_VALUE = '{{data_app_state}}';
const $e1a4baa2ba97a8e3$var$hasNoInjectedServerState = ()=>{
    const data = document.body.getAttribute('data-app-state');
    const dataNotInjectedDueToTestContext = data === null;
    return data === $e1a4baa2ba97a8e3$var$EMPTY_APP_STATE_VALUE || dataNotInjectedDueToTestContext;
};
var $e1a4baa2ba97a8e3$export$2e2bcd8739ae039 = $e1a4baa2ba97a8e3$var$hasNoInjectedServerState;

});





parcelRegister("9ek8N", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ftyoZ")).then(()=>parcelRequire('ktL5S'));

});

parcelRegister("imyZ9", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("61GGu")).then(()=>parcelRequire('KoVn5'));

});

parcelRegister("41CBD", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2lNCA")).then(()=>parcelRequire('bw2HW'));

});

parcelRegister("hQLzx", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("buCkT")).then(()=>parcelRequire('5KDON'));

});

parcelRegister("2n6QC", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fZ5pR")).then(()=>parcelRequire('jQnR7'));

});

parcelRegister("jgIFg", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9YoXx")).then(()=>parcelRequire('krGT6'));

});

parcelRegister("eQS3o", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lJivj")).then(()=>parcelRequire('b3UdK'));

});

parcelRegister("d8wgI", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ilWCw")).then(()=>parcelRequire('c1UFv'));

});

parcelRegister("g4zfV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4C5B7")).then(()=>parcelRequire('WMHLj'));

});

parcelRegister("3uRuL", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("agqiQ")).then(()=>parcelRequire('hsbBZ'));

});

parcelRegister("b6QhV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("cbcf1")).then(()=>parcelRequire('7jMwu'));

});

parcelRegister("4MwDy", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("assWM")).then(()=>parcelRequire('g7gTB'));

});

parcelRegister("2zMlh", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("et9BZ")).then(()=>parcelRequire('3Y4oi'));

});

parcelRegister("2TaUl", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fOCIn")).then(()=>parcelRequire('hzvGc'));

});

parcelRegister("bfqCY", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fgQyO")).then(()=>parcelRequire('8yAUO'));

});

parcelRegister("lEJ78", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7po9d")).then(()=>parcelRequire('1Wtav'));

});

parcelRegister("gqK4f", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("iSFDb")).then(()=>parcelRequire('ePQpV'));

});

parcelRegister("3omAS", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("eN5Fq")).then(()=>parcelRequire('bHhaD'));

});

parcelRegister("7yvG1", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1bASk")).then(()=>parcelRequire('9zdUx'));

});

parcelRegister("e7JDz", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("johxQ")).then(()=>parcelRequire('5WIli'));

});

parcelRegister("gQVR5", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1ec6N")).then(()=>parcelRequire('b1JLi'));

});

parcelRegister("4R2AC", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("a4TDP")).then(()=>parcelRequire('8hQfv'));

});

parcelRegister("jrFLZ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("GXJZ8")).then(()=>parcelRequire('4wsGs'));

});

parcelRegister("b05HP", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e6XXT")).then(()=>parcelRequire('clMSz'));

});

parcelRegister("2FOdn", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ajfHd")).then(()=>parcelRequire('jNJtd'));

});

parcelRegister("ckFNI", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $8fa7c70feb8ab890$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $8fa7c70feb8ab890$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $8fa7c70feb8ab890$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $8fa7c70feb8ab890$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $8fa7c70feb8ab890$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $8fa7c70feb8ab890$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $8fa7c70feb8ab890$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $8fa7c70feb8ab890$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $8fa7c70feb8ab890$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $8fa7c70feb8ab890$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $8fa7c70feb8ab890$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $8fa7c70feb8ab890$export$34d09c4a771c46ef(r, g, b) {
    return '#' + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $8fa7c70feb8ab890$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $8fa7c70feb8ab890$export$b36dbdb4f463f05c(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $8fa7c70feb8ab890$export$1212645cf40ebf71(hex)
    ];
}
function $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var c;
    c = hex.substring(1).split('');
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = '0x' + c.join('');
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $8fa7c70feb8ab890$export$47ea145a83f50dc0(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error('Invalid HEX');
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = '0x' + hex[1] + hex[1];
        g = '0x' + hex[2] + hex[2];
        b = '0x' + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = '0x' + hex[1] + hex[2];
        g = '0x' + hex[3] + hex[4];
        b = '0x' + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $8fa7c70feb8ab890$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $8fa7c70feb8ab890$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $8fa7c70feb8ab890$export$d061e26956a60b0a(foreground, background) {
    if (!$8fa7c70feb8ab890$var$isValidHex(foreground) || !$8fa7c70feb8ab890$var$isValidHex(background)) throw new Error('Invalid HEX');
    var foregroundRgb = $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $8fa7c70feb8ab890$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $8fa7c70feb8ab890$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $8fa7c70feb8ab890$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $8fa7c70feb8ab890$var$rgbToLab(rgbA);
    var labB = $8fa7c70feb8ab890$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $8fa7c70feb8ab890$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("5S9Ox", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $44699bc9120bb840$export$d6af199866bfb566; });
var $44699bc9120bb840$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});

parcelRegister("kHYoq", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5RhAq")).then(()=>parcelRequire('5La7Y'));

});

parcelRegister("gpRk8", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gK1Yq")).then(()=>parcelRequire('kwQvi'));

});

parcelRegister("c8RbB", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9gbDH")).then(()=>parcelRequire('aJEBV'));

});

parcelRegister("isrGv", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4Oijb")).then(()=>parcelRequire('b5Mom'));

});

parcelRegister("5dwxv", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("j2dhL")).then(()=>parcelRequire('kakn5'));

});

parcelRegister("kKMbx", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("95iyH")).then(()=>parcelRequire('5RNcl'));

});

parcelRegister("rYlZ2", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("f6mth")).then(()=>parcelRequire('kpJ9q'));

});

parcelRegister("5TU7G", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("02w4q")).then(()=>parcelRequire('buee9'));

});

parcelRegister("iTurb", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lTbXm")).then(()=>parcelRequire('aPPua'));

});

parcelRegister("7Vi5R", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("80IXv")).then(()=>parcelRequire('cyBNn'));

});

parcelRegister("8FkoG", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("3XOdM")).then(()=>parcelRequire('iiwWs'));

});

parcelRegister("hnVYZ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("bd7QQ")).then(()=>parcelRequire('2ha2L'));

});

parcelRegister("8cU1D", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7PqAR")).then(()=>parcelRequire('bbGni'));

});

parcelRegister("Jp6ag", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fwQFC")).then(()=>parcelRequire('4TDNT'));

});

parcelRegister("briFb", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("dKPoJ")).then(()=>parcelRequire('bUpS3'));

});

parcelRegister("c7EWG", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("jP2fr")).then(()=>parcelRequire('24dUH'));

});

parcelRegister("aeCsz", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aMC4s")).then(()=>parcelRequire('aoFOn'));

});

parcelRegister("4asKf", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("6Amvt")).then(()=>parcelRequire('4ASg8'));

});

parcelRegister("9TV3v", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $735582283b5cccb2$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $735582283b5cccb2$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $735582283b5cccb2$export$e673f367da2ff23e; });

var $kg5sN = parcelRequire("kg5sN");

var $cF8Kw = parcelRequire("cF8Kw");

var $aBY8N = parcelRequire("aBY8N");

var $bDRHl = parcelRequire("bDRHl");

var $5S9Ox = parcelRequire("5S9Ox");
function $735582283b5cccb2$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $5S9Ox.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === 'auto' ? [
        'light',
        'dark'
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), "=\"").concat(uniqueId, "\"][").concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]"));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $735582283b5cccb2$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.from(document.head.querySelectorAll("style[".concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $735582283b5cccb2$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $aBY8N.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === 'string' ? value : themeRamp[value], ";") : acc;
    }, '');
}

});
parcelRegister("aBY8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9c02d3484ec41e$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a8feb13ecf105e7fd6247cb4d1a99b01>>
 * @codegenCommand yarn build tokens
 */ var $7b9c02d3484ec41e$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.radius': '--ds-border-radius',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $7b9c02d3484ec41e$export$2e2bcd8739ae039 = $7b9c02d3484ec41e$var$tokens;

});


parcelRegister("7ckqH", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e0PVZ")).then(()=>parcelRequire('bJxb0'));

});

parcelRegister("3o9o3", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $277ae50bc9fd00a3$export$dcef8f9bb9a41431; }, function (v) { return $277ae50bc9fd00a3$export$dcef8f9bb9a41431 = v; });
$parcel$export(module.exports, "default", function () { return $277ae50bc9fd00a3$export$2e2bcd8739ae039; }, function (v) { return $277ae50bc9fd00a3$export$2e2bcd8739ae039 = v; });
var $277ae50bc9fd00a3$export$1e511d4a378977f5;
var $277ae50bc9fd00a3$export$dcef8f9bb9a41431;
var $277ae50bc9fd00a3$export$2e2bcd8739ae039;
$277ae50bc9fd00a3$export$1e511d4a378977f5 = true;
$277ae50bc9fd00a3$export$dcef8f9bb9a41431 = undefined;
var $277ae50bc9fd00a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $277ae50bc9fd00a3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8ZuGG = parcelRequire("8ZuGG");
var $277ae50bc9fd00a3$var$_react2 = $277ae50bc9fd00a3$var$_interopRequireDefault($8ZuGG);

var $6CJPF = parcelRequire("6CJPF");
var $277ae50bc9fd00a3$var$_propTypes2 = $277ae50bc9fd00a3$var$_interopRequireDefault($6CJPF);

var $hy2Kv = parcelRequire("hy2Kv");
var $277ae50bc9fd00a3$var$_reactSideEffect2 = $277ae50bc9fd00a3$var$_interopRequireDefault($hy2Kv);

var $7Vn6y = parcelRequire("7Vn6y");
var $277ae50bc9fd00a3$var$_reactFastCompare2 = $277ae50bc9fd00a3$var$_interopRequireDefault($7Vn6y);

var $7qvS0 = parcelRequire("7qvS0");

var $d2KJI = parcelRequire("d2KJI");
function $277ae50bc9fd00a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $277ae50bc9fd00a3$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $277ae50bc9fd00a3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $277ae50bc9fd00a3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $277ae50bc9fd00a3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $277ae50bc9fd00a3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $277ae50bc9fd00a3$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $277ae50bc9fd00a3$var$_classCallCheck(this, HelmetWrapper);
            return $277ae50bc9fd00a3$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $277ae50bc9fd00a3$var$_reactFastCompare2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $d2KJI.TAG_NAMES.SCRIPT:
                case $d2KJI.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $d2KJI.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $277ae50bc9fd00a3$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $277ae50bc9fd00a3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $d2KJI.TAG_NAMES.TITLE:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $277ae50bc9fd00a3$var$_extends({}, newChildProps), _extends3));
                case $d2KJI.TAG_NAMES.BODY:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, {
                        bodyAttributes: $277ae50bc9fd00a3$var$_extends({}, newChildProps)
                    });
                case $d2KJI.TAG_NAMES.HTML:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, {
                        htmlAttributes: $277ae50bc9fd00a3$var$_extends({}, newChildProps)
                    });
            }
            return $277ae50bc9fd00a3$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $277ae50bc9fd00a3$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $277ae50bc9fd00a3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $277ae50bc9fd00a3$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $277ae50bc9fd00a3$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $277ae50bc9fd00a3$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $7qvS0.convertReactPropstoHtmlAttributes)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $d2KJI.TAG_NAMES.LINK:
                    case $d2KJI.TAG_NAMES.META:
                    case $d2KJI.TAG_NAMES.NOSCRIPT:
                    case $d2KJI.TAG_NAMES.SCRIPT:
                    case $d2KJI.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $277ae50bc9fd00a3$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $277ae50bc9fd00a3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $277ae50bc9fd00a3$var$_react2.default.createElement(Component, newProps);
        };
        $277ae50bc9fd00a3$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($277ae50bc9fd00a3$var$_react2.default.Component), _class.propTypes = {
        base: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        bodyAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        children: $277ae50bc9fd00a3$var$_propTypes2.default.oneOfType([
            $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.node),
            $277ae50bc9fd00a3$var$_propTypes2.default.node
        ]),
        defaultTitle: $277ae50bc9fd00a3$var$_propTypes2.default.string,
        defer: $277ae50bc9fd00a3$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $277ae50bc9fd00a3$var$_propTypes2.default.bool,
        htmlAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        link: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        meta: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        noscript: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        onChangeClientState: $277ae50bc9fd00a3$var$_propTypes2.default.func,
        script: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        style: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        title: $277ae50bc9fd00a3$var$_propTypes2.default.string,
        titleAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        titleTemplate: $277ae50bc9fd00a3$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $7qvS0.mapStateOnServer)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $277ae50bc9fd00a3$var$NullComponent = function NullComponent() {
    return null;
};
var $277ae50bc9fd00a3$var$HelmetSideEffects = (0, $277ae50bc9fd00a3$var$_reactSideEffect2.default)($7qvS0.reducePropsToState, $7qvS0.handleClientStateChange, $7qvS0.mapStateOnServer)($277ae50bc9fd00a3$var$NullComponent);
var $277ae50bc9fd00a3$var$HelmetExport = $277ae50bc9fd00a3$var$Helmet($277ae50bc9fd00a3$var$HelmetSideEffects);
$277ae50bc9fd00a3$var$HelmetExport.renderStatic = $277ae50bc9fd00a3$var$HelmetExport.rewind;
$277ae50bc9fd00a3$export$dcef8f9bb9a41431 = $277ae50bc9fd00a3$var$HelmetExport;
$277ae50bc9fd00a3$export$2e2bcd8739ae039 = $277ae50bc9fd00a3$var$HelmetExport;

});
parcelRegister("6CJPF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d29d80e7041a0e5$var$ReactIs, $4d29d80e7041a0e5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9fskv"))();

});
parcelRegister("9fskv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $9rdNz = parcelRequire("9rdNz");
function $6bbb7d7d00cbcfd9$var$emptyFunction() {}
function $6bbb7d7d00cbcfd9$var$emptyFunctionWithReset() {}
$6bbb7d7d00cbcfd9$var$emptyFunctionWithReset.resetWarningCache = $6bbb7d7d00cbcfd9$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $9rdNz) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6bbb7d7d00cbcfd9$var$emptyFunctionWithReset,
        resetWarningCache: $6bbb7d7d00cbcfd9$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("9rdNz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $6df156ca640c7829$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $6df156ca640c7829$var$ReactPropTypesSecret;

});



parcelRegister("hy2Kv", function(module, exports) {
'use strict';
function $cc67be915ef1ace6$var$_interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var $8ZuGG = parcelRequire("8ZuGG");
var $cc67be915ef1ace6$var$React__default = $cc67be915ef1ace6$var$_interopDefault($8ZuGG);

var $cc67be915ef1ace6$var$shallowEqual = $cc67be915ef1ace6$var$_interopDefault((parcelRequire("lA2Ha")));
function $cc67be915ef1ace6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc67be915ef1ace6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $cc67be915ef1ace6$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $cc67be915ef1ace6$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== 'function') throw new Error('Expected reducePropsToState to be a function.');
    if (typeof handleStateChangeOnClient !== 'function') throw new Error('Expected handleStateChangeOnClient to be a function.');
    if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') throw new Error('Expected mapStateOnServer to either be undefined or a function.');
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== 'function') throw new Error('Expected WrappedComponent to be a React component.');
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $cc67be915ef1ace6$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$cc67be915ef1ace6$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $cc67be915ef1ace6$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($8ZuGG.Component);
        $cc67be915ef1ace6$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $cc67be915ef1ace6$var$_defineProperty(SideEffect, "canUseDOM", $cc67be915ef1ace6$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $cc67be915ef1ace6$var$withSideEffect;

});
parcelRegister("lA2Ha", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("7Vn6y", function(module, exports) {
'use strict';
var $5c4fc768550e8635$var$isArray = Array.isArray;
var $5c4fc768550e8635$var$keyList = Object.keys;
var $5c4fc768550e8635$var$hasProp = Object.prototype.hasOwnProperty;
var $5c4fc768550e8635$var$hasElementType = typeof Element !== 'undefined';
function $5c4fc768550e8635$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $5c4fc768550e8635$var$isArray(a), arrB = $5c4fc768550e8635$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$5c4fc768550e8635$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $5c4fc768550e8635$var$keyList(a);
        length = keys.length;
        if (length !== $5c4fc768550e8635$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$5c4fc768550e8635$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($5c4fc768550e8635$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$5c4fc768550e8635$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $5c4fc768550e8635$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7qvS0", function(module, exports) {

$parcel$export(module.exports, "reducePropsToState", function () { return $5683aed557661a44$export$bfed3b07ff81c934; }, function (v) { return $5683aed557661a44$export$bfed3b07ff81c934 = v; });
$parcel$export(module.exports, "mapStateOnServer", function () { return $5683aed557661a44$export$971402543ca2bd1d; }, function (v) { return $5683aed557661a44$export$971402543ca2bd1d = v; });
$parcel$export(module.exports, "handleClientStateChange", function () { return $5683aed557661a44$export$8e0854f6f2040fff; }, function (v) { return $5683aed557661a44$export$8e0854f6f2040fff = v; });
$parcel$export(module.exports, "convertReactPropstoHtmlAttributes", function () { return $5683aed557661a44$export$8f437c7c6568a694; }, function (v) { return $5683aed557661a44$export$8f437c7c6568a694 = v; });
var $5683aed557661a44$export$1e511d4a378977f5;
var $5683aed557661a44$export$c106dd0671a0fc2d;
var $5683aed557661a44$export$6cb2c4c0a22909c0;
var $5683aed557661a44$export$bfed3b07ff81c934;
var $5683aed557661a44$export$971402543ca2bd1d;
var $5683aed557661a44$export$8e0854f6f2040fff;
var $5683aed557661a44$export$8f437c7c6568a694;
$5683aed557661a44$export$1e511d4a378977f5 = true;
$5683aed557661a44$export$c106dd0671a0fc2d = $5683aed557661a44$export$6cb2c4c0a22909c0 = $5683aed557661a44$export$bfed3b07ff81c934 = $5683aed557661a44$export$971402543ca2bd1d = $5683aed557661a44$export$8e0854f6f2040fff = $5683aed557661a44$export$8f437c7c6568a694 = undefined;
var $5683aed557661a44$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5683aed557661a44$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8ZuGG = parcelRequire("8ZuGG");
var $5683aed557661a44$var$_react2 = $5683aed557661a44$var$_interopRequireDefault($8ZuGG);

var $lir0C = parcelRequire("lir0C");
var $5683aed557661a44$var$_objectAssign2 = $5683aed557661a44$var$_interopRequireDefault($lir0C);

var $d2KJI = parcelRequire("d2KJI");
function $5683aed557661a44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5683aed557661a44$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $5683aed557661a44$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.TAG_NAMES.TITLE);
    var innermostTemplate = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $5683aed557661a44$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $5683aed557661a44$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $5683aed557661a44$var$_extends({}, tagAttrs, current);
    }, {});
};
var $5683aed557661a44$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$d2KJI.TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$d2KJI.TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $5683aed557661a44$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $5683aed557661a44$var$warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + $5683aed557661a44$var$_typeof(props[tagName]) + "\"");
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $d2KJI.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $d2KJI.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $d2KJI.TAG_PROPERTIES.INNER_HTML || attributeKey === $d2KJI.TAG_PROPERTIES.CSS_TEXT || attributeKey === $d2KJI.TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $5683aed557661a44$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $5683aed557661a44$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $5683aed557661a44$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $5683aed557661a44$var$getBaseTagFromPropsList([
            $d2KJI.TAG_PROPERTIES.HREF
        ], propsList),
        bodyAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.BODY, propsList),
        defer: $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.DEFER),
        encode: $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.LINK, [
            $d2KJI.TAG_PROPERTIES.REL,
            $d2KJI.TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.META, [
            $d2KJI.TAG_PROPERTIES.NAME,
            $d2KJI.TAG_PROPERTIES.CHARSET,
            $d2KJI.TAG_PROPERTIES.HTTPEQUIV,
            $d2KJI.TAG_PROPERTIES.PROPERTY,
            $d2KJI.TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.NOSCRIPT, [
            $d2KJI.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $5683aed557661a44$var$getOnChangeClientState(propsList),
        scriptTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.SCRIPT, [
            $d2KJI.TAG_PROPERTIES.SRC,
            $d2KJI.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.STYLE, [
            $d2KJI.TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $5683aed557661a44$var$getTitleFromPropsList(propsList),
        titleAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $5683aed557661a44$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $5683aed557661a44$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $5683aed557661a44$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $5683aed557661a44$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $5683aed557661a44$var$rafPolyfill : $parcel$global.requestAnimationFrame || $5683aed557661a44$var$rafPolyfill;
var $5683aed557661a44$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $5683aed557661a44$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $5683aed557661a44$var$cafPolyfill;
var $5683aed557661a44$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $5683aed557661a44$var$_helmetCallback = null;
var $5683aed557661a44$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($5683aed557661a44$var$_helmetCallback) $5683aed557661a44$var$cancelAnimationFrame($5683aed557661a44$var$_helmetCallback);
    if (newState.defer) $5683aed557661a44$var$_helmetCallback = $5683aed557661a44$var$requestAnimationFrame(function() {
        $5683aed557661a44$var$commitTagChanges(newState, function() {
            $5683aed557661a44$var$_helmetCallback = null;
        });
    });
    else {
        $5683aed557661a44$var$commitTagChanges(newState);
        $5683aed557661a44$var$_helmetCallback = null;
    }
};
var $5683aed557661a44$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.BODY, bodyAttributes);
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.HTML, htmlAttributes);
    $5683aed557661a44$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.BASE, baseTag),
        linkTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.LINK, linkTags),
        metaTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.META, metaTags),
        noscriptTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $5683aed557661a44$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $5683aed557661a44$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $5683aed557661a44$var$flattenArray(title);
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.TITLE, attributes);
};
var $5683aed557661a44$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($d2KJI.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($d2KJI.HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($d2KJI.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($d2KJI.HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $5683aed557661a44$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($d2KJI.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $d2KJI.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $d2KJI.TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($d2KJI.HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $5683aed557661a44$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $5683aed557661a44$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $5683aed557661a44$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $5683aed557661a44$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + $5683aed557661a44$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + "=\"true\">" + $5683aed557661a44$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $5683aed557661a44$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $d2KJI.TAG_PROPERTIES.INNER_HTML || attribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + $5683aed557661a44$var$encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $d2KJI.SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $5683aed557661a44$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$d2KJI.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $5683aed557661a44$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$d2KJI.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $5683aed557661a44$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$d2KJI.HELMET_ATTRIBUTE] = true, _initProps);
    var props = $5683aed557661a44$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $5683aed557661a44$var$_react2.default.createElement($d2KJI.TAG_NAMES.TITLE, props, title)
    ];
};
var $5683aed557661a44$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$d2KJI.HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $d2KJI.REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $d2KJI.TAG_PROPERTIES.INNER_HTML || mappedAttribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $5683aed557661a44$var$_react2.default.createElement(type, mappedTag);
    });
};
var $5683aed557661a44$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $d2KJI.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $d2KJI.ATTRIBUTE_NAMES.BODY:
        case $d2KJI.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $5683aed557661a44$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $5683aed557661a44$var$getMethodsForTag($d2KJI.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $5683aed557661a44$var$getMethodsForTag($d2KJI.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.LINK, linkTags, encode),
        meta: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.META, metaTags, encode),
        noscript: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.STYLE, styleTags, encode),
        title: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$5683aed557661a44$export$8f437c7c6568a694 = $5683aed557661a44$var$convertReactPropstoHtmlAttributes;
$5683aed557661a44$export$8e0854f6f2040fff = $5683aed557661a44$var$handleClientStateChange;
$5683aed557661a44$export$971402543ca2bd1d = $5683aed557661a44$var$mapStateOnServer;
$5683aed557661a44$export$bfed3b07ff81c934 = $5683aed557661a44$var$reducePropsToState;
$5683aed557661a44$export$6cb2c4c0a22909c0 = $5683aed557661a44$var$requestAnimationFrame;
$5683aed557661a44$export$c106dd0671a0fc2d = $5683aed557661a44$var$warn;

});
parcelRegister("d2KJI", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE_NAMES", function () { return $97efb7253686f530$export$8b4d23abccee6cc2; }, function (v) { return $97efb7253686f530$export$8b4d23abccee6cc2 = v; });
$parcel$export(module.exports, "TAG_NAMES", function () { return $97efb7253686f530$export$7e674a85a2656dce; }, function (v) { return $97efb7253686f530$export$7e674a85a2656dce = v; });
$parcel$export(module.exports, "TAG_PROPERTIES", function () { return $97efb7253686f530$export$55a55363959ee034; }, function (v) { return $97efb7253686f530$export$55a55363959ee034 = v; });
$parcel$export(module.exports, "REACT_TAG_MAP", function () { return $97efb7253686f530$export$f5ab464b3d67ea9c; }, function (v) { return $97efb7253686f530$export$f5ab464b3d67ea9c = v; });
$parcel$export(module.exports, "HELMET_PROPS", function () { return $97efb7253686f530$export$6bb0645fb3f2618c; }, function (v) { return $97efb7253686f530$export$6bb0645fb3f2618c = v; });
$parcel$export(module.exports, "HTML_TAG_MAP", function () { return $97efb7253686f530$export$3fedf55cd3a4e6fa; }, function (v) { return $97efb7253686f530$export$3fedf55cd3a4e6fa = v; });
$parcel$export(module.exports, "SELF_CLOSING_TAGS", function () { return $97efb7253686f530$export$7f7c530a82f07f20; }, function (v) { return $97efb7253686f530$export$7f7c530a82f07f20 = v; });
$parcel$export(module.exports, "HELMET_ATTRIBUTE", function () { return $97efb7253686f530$export$1f547d7d8e831b2b; }, function (v) { return $97efb7253686f530$export$1f547d7d8e831b2b = v; });
var $97efb7253686f530$export$1e511d4a378977f5;
var $97efb7253686f530$export$8b4d23abccee6cc2;
var $97efb7253686f530$export$7e674a85a2656dce;
var $97efb7253686f530$export$7a7b396eb62fa0f9;
var $97efb7253686f530$export$55a55363959ee034;
var $97efb7253686f530$export$f5ab464b3d67ea9c;
var $97efb7253686f530$export$6bb0645fb3f2618c;
var $97efb7253686f530$export$3fedf55cd3a4e6fa;
var $97efb7253686f530$export$7f7c530a82f07f20;
var $97efb7253686f530$export$1f547d7d8e831b2b;
$97efb7253686f530$export$1e511d4a378977f5 = true;
var $97efb7253686f530$var$ATTRIBUTE_NAMES = $97efb7253686f530$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $97efb7253686f530$var$TAG_NAMES = $97efb7253686f530$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $97efb7253686f530$var$VALID_TAG_NAMES = $97efb7253686f530$export$7a7b396eb62fa0f9 = Object.keys($97efb7253686f530$var$TAG_NAMES).map(function(name) {
    return $97efb7253686f530$var$TAG_NAMES[name];
});
var $97efb7253686f530$var$TAG_PROPERTIES = $97efb7253686f530$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $97efb7253686f530$var$REACT_TAG_MAP = $97efb7253686f530$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $97efb7253686f530$var$HELMET_PROPS = $97efb7253686f530$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $97efb7253686f530$var$HTML_TAG_MAP = $97efb7253686f530$export$3fedf55cd3a4e6fa = Object.keys($97efb7253686f530$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$97efb7253686f530$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $97efb7253686f530$var$SELF_CLOSING_TAGS = $97efb7253686f530$export$7f7c530a82f07f20 = [
    $97efb7253686f530$var$TAG_NAMES.NOSCRIPT,
    $97efb7253686f530$var$TAG_NAMES.SCRIPT,
    $97efb7253686f530$var$TAG_NAMES.STYLE
];
var $97efb7253686f530$var$HELMET_ATTRIBUTE = $97efb7253686f530$export$1f547d7d8e831b2b = "data-react-helmet";

});



parcelRegister("cugIF", function(module, exports) {

$parcel$export(module.exports, "SimpleCobranding", function () { return $bf1386dd22286070$export$d04480ee89603948; });
$parcel$export(module.exports, "AdvancedCobranding", function () { return $bf1386dd22286070$export$6e3d039ab597dde7; });
$parcel$export(module.exports, "isSimpleCobranding", function () { return $bf1386dd22286070$export$4289c1cc8b535433; });
$parcel$export(module.exports, "isAdvancedCobranding", function () { return $bf1386dd22286070$export$4d91d2f372f755c7; });
$parcel$export(module.exports, "getCurrentCobranding", function () { return $bf1386dd22286070$export$7a6337ee64e317c4; });
$parcel$export(module.exports, "CobrandingProvider", function () { return $bf1386dd22286070$export$c5b813538c5440a9; });
$parcel$export(module.exports, "useCobranding", function () { return $bf1386dd22286070$export$808c37e33518fa32; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kZj5j = parcelRequire("kZj5j");

var $2O78M = parcelRequire("2O78M");
var $bf1386dd22286070$export$d04480ee89603948 = /*#__PURE__*/ function(SimpleCobranding) {
    SimpleCobranding["NO_COBRANDING"] = "no-cobranding";
    SimpleCobranding["BITBUCKET"] = "bitbucket";
    SimpleCobranding["COMPASS"] = "compass";
    SimpleCobranding["CONFLUENCE"] = "confluence";
    SimpleCobranding["COMMUNITY"] = "community";
    SimpleCobranding["JIRA"] = "jira";
    SimpleCobranding["OPSGENIE"] = "opsgenie";
    SimpleCobranding["STATUSPAGE"] = "statuspage";
    SimpleCobranding["TRELLO"] = "trello";
    SimpleCobranding["WAC"] = "wac";
    SimpleCobranding["ATLAS"] = "atlas";
    SimpleCobranding["LOOM"] = "loom";
    SimpleCobranding["JIRA_ALIGN"] = "jira-align";
    SimpleCobranding["ADMIN"] = "admin";
    SimpleCobranding["ROVO"] = "rovo";
    SimpleCobranding["PRT"] = "prt";
    SimpleCobranding["SUPPORT"] = "support";
    return SimpleCobranding;
}({});
var $bf1386dd22286070$export$6e3d039ab597dde7 = /*#__PURE__*/ function(AdvancedCobranding) {
    AdvancedCobranding["DEMO"] = "demo";
    AdvancedCobranding["PRT_DEMO"] = "prt-demo";
    AdvancedCobranding["ATLAS_66195"] = "atlas-66195";
    AdvancedCobranding["CFIND_2409"] = "cfind-2409";
    AdvancedCobranding["CFIND_3856"] = "cfind-3856";
    AdvancedCobranding["JIRA_ATLAS_75650"] = "jira-atlas-75650";
    AdvancedCobranding["CONFLUENCE_ATLAS_75650"] = "confluence-atlas-75650";
    AdvancedCobranding["LOOM"] = "default";
    AdvancedCobranding["ACCOUNT_LINKING"] = "account-linking";
    AdvancedCobranding["ENTRY_AUTH"] = "entry-auth";
    AdvancedCobranding["WAC_LOOM"] = "loom-cobranding";
    AdvancedCobranding["WAC_JPD"] = "jpd";
    AdvancedCobranding["WAC_JSM"] = "jsm";
    AdvancedCobranding["SERVICE_COLLECTION"] = "service-collection";
    AdvancedCobranding["TEAMWORK_COLLECTION"] = "teamwork-collection";
    AdvancedCobranding["ISOLATED_CLOUD"] = "ic";
    return AdvancedCobranding;
}({});
const $bf1386dd22286070$export$4289c1cc8b535433 = (value)=>Object.values($bf1386dd22286070$export$d04480ee89603948).includes(value);
const $bf1386dd22286070$export$4d91d2f372f755c7 = (value)=>Object.values($bf1386dd22286070$export$6e3d039ab597dde7).includes(value);
const $bf1386dd22286070$var$getDisabledApplicationKeys = (dynamicConfigs)=>{
    const disabledApplicationKeys = dynamicConfigs.getStringList((0, $2O78M.AidFrontendDynamicConfig).DISABLED_COBRANDING_APPLICATION_KEYS);
    if ('value' in disabledApplicationKeys) return disabledApplicationKeys.value;
    return [];
};
const $bf1386dd22286070$var$getApplicationKey = (applicationData)=>{
    return `${applicationData.application}${applicationData.experience ? `--${applicationData.experience}` : ''}`;
};
function $bf1386dd22286070$export$7a6337ee64e317c4(cobranding, dynamicConfigs) {
    const applicationData = (0, $kZj5j.lookupApplication)(cobranding);
    if (applicationData) {
        const disabledApplicationKeys = $bf1386dd22286070$var$getDisabledApplicationKeys(dynamicConfigs);
        const applicationKey = $bf1386dd22286070$var$getApplicationKey(applicationData);
        if (disabledApplicationKeys.includes(applicationKey)) {
            console.log(`Cobranding disabled for application: ${applicationKey}`);
            return "no-cobranding";
        }
        switch(applicationData.application){
            case 'admin':
                switch(applicationData.experience){
                    case 'jira-atlas-75650':
                        return "jira-atlas-75650";
                    case 'confluence-atlas-75650':
                        return "confluence-atlas-75650";
                    default:
                        return "no-cobranding";
                }
            case 'atlas':
                return "atlas";
            case 'bitbucket':
                return "bitbucket";
            case 'community':
                if (applicationData.experience === 'account-linking') return "account-linking";
                if (applicationData.experience === 'entry-auth') return "entry-auth";
                return "community";
            case 'compass':
                return "compass";
            case 'confluence':
                return "confluence";
            case 'jira':
                return "jira";
            case 'loom':
                switch(applicationData.experience){
                    case 'default':
                        return "default";
                    default:
                        return "loom";
                }
            case 'jira-align':
                return "jira-align";
            case 'opsgenie':
                return "opsgenie";
            case 'rovo':
                return "rovo";
            case 'statuspage':
                return "statuspage";
            case 'trello':
                return "trello";
            case 'wac':
                switch(applicationData.experience){
                    case 'otp-jira':
                    case 'atlas-66195':
                        return "atlas-66195";
                    case 'otp-confluence':
                    case 'cfind-2409':
                        return "cfind-2409";
                    case 'loom':
                        return "loom-cobranding";
                    case 'jpd':
                        return "jpd";
                    case 'jsm':
                        return "jsm";
                    case 'service-collection':
                        return "service-collection";
                    case 'teamwork-collection':
                        return "teamwork-collection";
                    case 'cfind-3856':
                        return "cfind-3856";
                    default:
                        return "no-cobranding";
                }
            case 'support':
                switch(applicationData.experience){
                    case 'ic':
                        return "ic";
                    default:
                        return "no-cobranding";
                }
            case 'pollinator':
                if (applicationData.experience) {
                    if (applicationData.experience.startsWith('jira')) return "jira";
                    if (applicationData.experience.startsWith('confluence')) return "confluence";
                    if (applicationData.experience === 'demo') return "demo";
                }
                return "no-cobranding";
            case 'prt':
                if (applicationData.experience === 'demo') return "prt-demo";
                return "prt";
        }
    }
    return "no-cobranding";
}
const $bf1386dd22286070$var$CobrandingContext = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    cobranding: "no-cobranding",
    isMobileApp: false
});
const $bf1386dd22286070$export$c5b813538c5440a9 = $bf1386dd22286070$var$CobrandingContext.Provider;
const $bf1386dd22286070$export$b9c89a068720407f = $bf1386dd22286070$var$CobrandingContext.Consumer;
const $bf1386dd22286070$export$808c37e33518fa32 = ()=>(0, $8ZuGG.useContext)($bf1386dd22286070$var$CobrandingContext);

});
parcelRegister("2O78M", function(module, exports) {

$parcel$export(module.exports, "AidFrontendDynamicConfig", function () { return $21067df3bfaef431$export$72c0add96dbeed4e; });
var $21067df3bfaef431$export$72c0add96dbeed4e = /*#__PURE__*/ function(AidFrontendDynamicConfig) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_disabled_cobranding_application_keys
    AidFrontendDynamicConfig["DISABLED_COBRANDING_APPLICATION_KEYS"] = "aid-frontend_disabled_cobranding_application_keys";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/google_login_outage_advisory
    AidFrontendDynamicConfig["GOOGLE_LOGIN_OUTAGE_ADVISORY"] = "google_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_apple_login_outage_advisory
    AidFrontendDynamicConfig["APPLE_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_apple_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_slack_login_outage_advisory
    AidFrontendDynamicConfig["SLACK_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_slack_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_microsoft_login_outage_advisory
    AidFrontendDynamicConfig["MICROSOFT_LOGIN_OUTAGE_ADVISORY"] = "aid-frontend_microsoft_login_outage_advisory";
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_google_one_tap_kill_switch
    AidFrontendDynamicConfig["GOOGLE_ONE_TAP_KILL_SWITCH"] = "aid-frontend_google_one_tap_kill_switch";
    return AidFrontendDynamicConfig;
}({});

});


parcelRegister("bT1Ur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a764fef12a56ed3$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $8a764fef12a56ed3$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});

parcelRegister("1Muvn", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $14c1efccd710ba20$export$a4687b0234b40e28; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $gvAuA = parcelRequire("gvAuA");

var $gCnIo = parcelRequire("gCnIo");
function $14c1efccd710ba20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14c1efccd710ba20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14c1efccd710ba20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14c1efccd710ba20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14c1efccd710ba20$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gCnIo.useTrackedRef)(analyticsData);
    var fnRef = (0, $gCnIo.useTrackedRef)(fn);
    var handler = (0, $8ZuGG.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $14c1efccd710ba20$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gvAuA", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c04bd93a7d607136$export$5bf35293e545f20c; });

var $bzd3R = parcelRequire("bzd3R");

var $ky16a = parcelRequire("ky16a");

var $ltvlR = parcelRequire("ltvlR");
function $c04bd93a7d607136$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ltvlR.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $bzd3R.useCallbackOne)(function(payload) {
        return new (0, $ky16a.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("bzd3R", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $86bd18475f5e9458$export$33752cf3ee811995; });

var $8ZuGG = parcelRequire("8ZuGG");
function $86bd18475f5e9458$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $86bd18475f5e9458$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $8ZuGG.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $8ZuGG.useRef)(true);
    var committed = (0, $8ZuGG.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $86bd18475f5e9458$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $8ZuGG.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $86bd18475f5e9458$export$33752cf3ee811995(callback, inputs) {
    return $86bd18475f5e9458$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $86bd18475f5e9458$export$1538c33de8887b59 = $86bd18475f5e9458$export$b6feb8998cd9b342;
var $86bd18475f5e9458$export$35808ee640e87ca7 = $86bd18475f5e9458$export$33752cf3ee811995;

});

parcelRegister("ky16a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef57d5c6bc88c36e$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $9zGER = parcelRequire("9zGER");
function $ef57d5c6bc88c36e$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $ef57d5c6bc88c36e$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $ef57d5c6bc88c36e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ef57d5c6bc88c36e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ef57d5c6bc88c36e$var$_superPropGet(t, o, e, r) {
    var p = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $ef57d5c6bc88c36e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ef57d5c6bc88c36e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $ef57d5c6bc88c36e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, UIAnalyticsEvent);
        _this = $ef57d5c6bc88c36e$var$_callSuper(this, UIAnalyticsEvent, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler(_this, channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(UIAnalyticsEvent, _AnalyticsEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return $ef57d5c6bc88c36e$var$_superPropGet(UIAnalyticsEvent, "update", this, 3)([
                    updater
                ]);
            }
        }
    ]);
}((0, $9zGER.default));

});
parcelRegister("9zGER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f8878f698fcbfe6$export$2e2bcd8739ae039; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
function $6f8878f698fcbfe6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f8878f698fcbfe6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f8878f698fcbfe6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f8878f698fcbfe6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f8878f698fcbfe6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6f8878f698fcbfe6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $6f8878f698fcbfe6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6f8878f698fcbfe6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(updater) === 'object') this.payload = $6f8878f698fcbfe6$var$_objectSpread($6f8878f698fcbfe6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
}();

});


parcelRegister("ltvlR", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $fa24a0320ce6fa73$export$d1f587f82ad51c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $akh0H = parcelRequire("akh0H");
var $fa24a0320ce6fa73$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $8ZuGG.useContext)((0, $akh0H.default));
};

});
parcelRegister("akh0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7848f785188f7358$export$2e2bcd8739ae039; });

var $3V24g = parcelRequire("3V24g");
var $7848f785188f7358$export$2e2bcd8739ae039 = (0, $3V24g.default);

});
parcelRegister("3V24g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da84c99bab289db$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $2da84c99bab289db$var$AnalyticsNextContext = (0, $8ZuGG.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2da84c99bab289db$export$2e2bcd8739ae039 = $2da84c99bab289db$var$AnalyticsNextContext;

});




parcelRegister("gCnIo", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $031f448105c6bcc9$export$1d27a74659855e44; });

var $8ZuGG = parcelRequire("8ZuGG");
var $031f448105c6bcc9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $8ZuGG.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5AVd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $412cb13d53fa6229$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $412cb13d53fa6229$export$2e2bcd8739ae039() {}

});

parcelRegister("5VQjR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $451adc2c0095248f$export$2e2bcd8739ae039; });
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $1S0T5 = parcelRequire("1S0T5");

var $bmth4 = parcelRequire("bmth4");

var $4P9CQ = parcelRequire("4P9CQ");

var $1RdT6 = parcelRequire("1RdT6");
var $451adc2c0095248f$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $451adc2c0095248f$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
var $451adc2c0095248f$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $451adc2c0095248f$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ var $451adc2c0095248f$var$useColor = function useColor(colorProp) {
    var surface = (0, $bmth4.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $1S0T5.inverseColorMap).hasOwnProperty(surface)) return (0, $1S0T5.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $451adc2c0095248f$var$Heading = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    var children = props.children, size = props.size, id = props.id, testId = props.testId, as = props.as, colorProp = props.color;
    typeof $1RdT6;
    var _useHeading = (0, $4P9CQ.useHeading)($451adc2c0095248f$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    var color = $451adc2c0095248f$var$useColor(colorProp);
    return /*#__PURE__*/ $8ZuGG.createElement(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $c4hjl.default)([
            $451adc2c0095248f$var$styles.reset,
            size && $451adc2c0095248f$var$headingSizeStylesMap[size],
            $451adc2c0095248f$var$headingColorStylesMap[color]
        ])
    }, children);
});
var $451adc2c0095248f$export$2e2bcd8739ae039 = $451adc2c0095248f$var$Heading;

});
parcelRegister("1S0T5", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $15cb85ce99dd9824$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $15cb85ce99dd9824$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $15cb85ce99dd9824$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $15cb85ce99dd9824$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $15cb85ce99dd9824$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $15cb85ce99dd9824$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $15cb85ce99dd9824$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $15cb85ce99dd9824$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $15cb85ce99dd9824$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $15cb85ce99dd9824$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $15cb85ce99dd9824$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $15cb85ce99dd9824$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "fontMap", function () { return $15cb85ce99dd9824$export$6ffa317d5e70375; });
$parcel$export(module.exports, "fontWeightMap", function () { return $15cb85ce99dd9824$export$303e322c6b1ed114; });
$parcel$export(module.exports, "fontFamilyMap", function () { return $15cb85ce99dd9824$export$3c7e9587132614b4; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $15cb85ce99dd9824$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $15cb85ce99dd9824$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $15cb85ce99dd9824$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $15cb85ce99dd9824$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "textSizeStylesMap", function () { return $15cb85ce99dd9824$export$219d364c0da35ae4; });
$parcel$export(module.exports, "textWeightStylesMap", function () { return $15cb85ce99dd9824$export$38845ca010b93505; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $15cb85ce99dd9824$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $15cb85ce99dd9824$export$5e65a44e5b6ecadb; });

var $6bkHe = parcelRequire("6bkHe");

var $bl8w7 = parcelRequire("bl8w7");

var $bDRHl = parcelRequire("bDRHl");
function $15cb85ce99dd9824$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15cb85ce99dd9824$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15cb85ce99dd9824$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15cb85ce99dd9824$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $15cb85ce99dd9824$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $15cb85ce99dd9824$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $15cb85ce99dd9824$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $15cb85ce99dd9824$export$632685d741f3dbbf = $15cb85ce99dd9824$var$_objectSpread($15cb85ce99dd9824$var$_objectSpread({}, $15cb85ce99dd9824$export$958d0ae7f2977ae4), $15cb85ce99dd9824$export$d2dc61f58390201c);
var $15cb85ce99dd9824$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $15cb85ce99dd9824$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $15cb85ce99dd9824$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $15cb85ce99dd9824$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $15cb85ce99dd9824$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $15cb85ce99dd9824$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $15cb85ce99dd9824$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
var $15cb85ce99dd9824$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $15cb85ce99dd9824$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $15cb85ce99dd9824$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    // @deprecated
    'border.width.0': "var(--ds-border-width-0, 0px)",
    // @deprecated
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    // @deprecated
    'border.width.outline': "var(--ds-border-width-outline, 2px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
var $15cb85ce99dd9824$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)",
    // @deprecated
    'border.radius': "var(--ds-border-radius, 3px)",
    // @deprecated
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    // @deprecated
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    // @deprecated
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    // @deprecated
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    // @deprecated
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    // @deprecated
    'border.radius.circle': "var(--ds-border-radius-circle, 9999px)"
};
var $15cb85ce99dd9824$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.large': "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.medium': "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.metric.small': "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $15cb85ce99dd9824$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $15cb85ce99dd9824$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $15cb85ce99dd9824$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
var $15cb85ce99dd9824$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $15cb85ce99dd9824$export$b805719bc8cb376 = {
    large: "var(--ds-font-metric-large, normal 653 28px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-metric-medium, normal 653 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-metric-small, normal 653 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $15cb85ce99dd9824$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $15cb85ce99dd9824$export$ca0f9c2de39ffed7 = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = (0, $bl8w7.css)((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $15cb85ce99dd9824$export$e615f061ca585a6c = $15cb85ce99dd9824$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $15cb85ce99dd9824$export$ca0f9c2de39ffed7(spacingProperty, $15cb85ce99dd9824$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $15cb85ce99dd9824$export$bf46c3f9eeafc71f = $15cb85ce99dd9824$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $15cb85ce99dd9824$export$ca0f9c2de39ffed7(spacingProperty, $15cb85ce99dd9824$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $15cb85ce99dd9824$export$e7af83bafe7f9e63 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('backgroundColor', $15cb85ce99dd9824$export$d1d79bf68ac056bd);
var $15cb85ce99dd9824$export$3a1bcba60b23d7f0 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('color', $15cb85ce99dd9824$export$8473307aa00d6ea1);
var $15cb85ce99dd9824$export$45f3f4fe16f9f7d5 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('fontWeight', $15cb85ce99dd9824$export$303e322c6b1ed114);
var $15cb85ce99dd9824$export$68cc305da27dbaa4 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('fontFamily', $15cb85ce99dd9824$export$3c7e9587132614b4);
var $15cb85ce99dd9824$export$128f10c238242f83 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('font', $15cb85ce99dd9824$export$6ffa317d5e70375);
var $15cb85ce99dd9824$export$219d364c0da35ae4 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('font', $15cb85ce99dd9824$export$236bfe3a33ef1292);
var $15cb85ce99dd9824$export$38845ca010b93505 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('fontWeight', $15cb85ce99dd9824$export$855cfd311192d666);
var $15cb85ce99dd9824$export$ff257d957d48c421 = $15cb85ce99dd9824$export$ca0f9c2de39ffed7((0, $bDRHl.CURRENT_SURFACE_CSS_VAR), $15cb85ce99dd9824$export$41a358c9c2356760);
var $15cb85ce99dd9824$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $15cb85ce99dd9824$export$41a358c9c2356760[color] !== undefined;
};
var $15cb85ce99dd9824$export$7001ce64d9ff7c7f = $15cb85ce99dd9824$export$ca0f9c2de39ffed7('font', $15cb85ce99dd9824$export$b805719bc8cb376);

});

parcelRegister("bmth4", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $8458750d16414e7f$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $8458750d16414e7f$export$1aeb4f6b93c4540d; });

var $8ZuGG = parcelRequire("8ZuGG");
var $8458750d16414e7f$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $8ZuGG.createContext)('elevation.surface');
var $8458750d16414e7f$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $8ZuGG.useContext)($8458750d16414e7f$export$1ca2a26fecb070ae);
};
$8458750d16414e7f$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("4P9CQ", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $38336448c75ff1b4$export$97a37b1befbbf9b1; });

var $8ZuGG = parcelRequire("8ZuGG");
// Allows support for heading levels 1-9 via aria-level
var $38336448c75ff1b4$var$HeadingLevelContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ var $38336448c75ff1b4$var$useHeadingLevel = function useHeadingLevel() {
    return (0, $8ZuGG.useContext)($38336448c75ff1b4$var$HeadingLevelContext);
};
var $38336448c75ff1b4$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $38336448c75ff1b4$var$useHeadingLevel();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $38336448c75ff1b4$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $38336448c75ff1b4$var$useHeadingLevel();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($38336448c75ff1b4$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $38336448c75ff1b4$export$2e2bcd8739ae039 = $38336448c75ff1b4$var$HeadingLevelContextProvider;

});


parcelRegister("72wHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52021532d00c1bc2$export$2e2bcd8739ae039; });
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $bmth4 = parcelRequire("bmth4");
var $52021532d00c1bc2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $52021532d00c1bc2$var$_excluded2 = [
    "className"
];
// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $52021532d00c1bc2$var$baseStyles = null;
var $52021532d00c1bc2$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
var $52021532d00c1bc2$var$CURRENT_SURFACE_CSS_VAR = "--ds-elevation-surface-current";
var $52021532d00c1bc2$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
var $52021532d00c1bc2$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
var $52021532d00c1bc2$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
var $52021532d00c1bc2$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
var $52021532d00c1bc2$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ var $52021532d00c1bc2$var$Box = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, _ref$paddingBlock = _ref.paddingBlock, paddingBlock = _ref$paddingBlock === void 0 ? padding : _ref$paddingBlock, _ref$paddingBlockStar = _ref.paddingBlockStart, paddingBlockStart = _ref$paddingBlockStar === void 0 ? paddingBlock : _ref$paddingBlockStar, _ref$paddingBlockEnd = _ref.paddingBlockEnd, paddingBlockEnd = _ref$paddingBlockEnd === void 0 ? paddingBlock : _ref$paddingBlockEnd, _ref$paddingInline = _ref.paddingInline, paddingInline = _ref$paddingInline === void 0 ? padding : _ref$paddingInline, _ref$paddingInlineSta = _ref.paddingInlineStart, paddingInlineStart = _ref$paddingInlineSta === void 0 ? paddingInline : _ref$paddingInlineSta, _ref$paddingInlineEnd = _ref.paddingInlineEnd, paddingInlineEnd = _ref$paddingInlineEnd === void 0 ? paddingInline : _ref$paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $52021532d00c1bc2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $52021532d00c1bc2$var$_excluded2);
    var node = /*#__PURE__*/ $8ZuGG.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        style: style,
        ref: ref,
        className: (0, $c4hjl.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $52021532d00c1bc2$var$backgroundColorMap[backgroundColor],
            backgroundColor && $52021532d00c1bc2$var$isSurfaceToken(backgroundColor) && $52021532d00c1bc2$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $52021532d00c1bc2$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $52021532d00c1bc2$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $52021532d00c1bc2$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $52021532d00c1bc2$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ])
    }, safeHtmlAttributes, {
        "data-testid": testId
    }), children);
    if (backgroundColor) return /*#__PURE__*/ $8ZuGG.createElement((0, $bmth4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node);
    return node;
});
var $52021532d00c1bc2$export$2e2bcd8739ae039 = $52021532d00c1bc2$var$Box;
function $52021532d00c1bc2$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $52021532d00c1bc2$var$setSurfaceTokenMap;
}

});

parcelRegister("fkdQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2837596ba0bf327$export$2e2bcd8739ae039; });
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $25i4M = parcelRequire("25i4M");

var $9Ud6y = parcelRequire("9Ud6y");
var $b2837596ba0bf327$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "shouldWrap",
    "spread",
    "grow",
    "space",
    "rowSpace",
    "separator",
    "xcss",
    "testId",
    "role",
    "children"
];
var $b2837596ba0bf327$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
var $b2837596ba0bf327$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            $b2837596ba0bf327$var$styles.separator
        ])
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $b2837596ba0bf327$var$Inline = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $b2837596ba0bf327$var$_excluded);
    var separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ $8ZuGG.createElement($b2837596ba0bf327$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $8ZuGG.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $9Ud6y.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, ariaAttributes, {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $25i4M.cx)(grow === 'hug' && $b2837596ba0bf327$var$styles.hug, grow === 'fill' && $b2837596ba0bf327$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$b2837596ba0bf327$var$Inline.displayName = 'Inline';
var $b2837596ba0bf327$export$2e2bcd8739ae039 = $b2837596ba0bf327$var$Inline;

});
parcelRegister("25i4M", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $184a11ed6653f292$export$a274e22fb40f762e; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("8ZuGG");


var $67x2X = parcelRequire("67x2X");
var $184a11ed6653f292$var$_createStrictAPI = (0, $67x2X.createStrictAPI)(), $184a11ed6653f292$var$XCSSProp = $184a11ed6653f292$var$_createStrictAPI.XCSSProp, $184a11ed6653f292$export$dbf350e5966cf602 = $184a11ed6653f292$var$_createStrictAPI.css, $184a11ed6653f292$export$eb1ecd84a24ee424 = $184a11ed6653f292$var$_createStrictAPI.cssMap, $184a11ed6653f292$export$a274e22fb40f762e = $184a11ed6653f292$var$_createStrictAPI.cx;
 // This is to mitigate local TS error TS2315: Type 'StrictXCSSProp' is not generic.
 // Currently for some reason tsc is generating malformed .d.ts in local dev environment, below change fixes it
 /**
 * ## StrictXCSSProp
 *
 * Declare styles your component takes with all other styles marked as violations
 * by the TypeScript compiler. There are two primary use cases for xcss prop:
 *
 * - safe style overrides
 * - inverting style declarations
 *
 * Interverting style declarations is interesting for platform teams as
 * it means apps only pay for styles they use as they're now the ones who declare
 * the styles!
 *
 * The {@link StrictXCSSProp} type has generics two of which must be defined — use to explicitly
 * set what you want to maintain as API. Use {@link XCSSAllProperties} and {@link XCSSAllPseudos}
 * to enable all properties and pseudos.
 *
 * The third generic is used to declare what properties and pseudos should be required.
 *
 * ```tsx
 * interface MyComponentProps {
 *   // Color is accepted, all other properties / pseudos are considered violations.
 *   xcss?: StrictXCSSProp<'color', never>;
 *
 *   // Only background color and hover pseudo are accepted.
 *   xcss?: StrictXCSSProp<'backgroundColor', '&:hover'>;
 *
 *   // All properties are accepted, all pseudos are considered violations.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, never>;
 *
 *   // All properties are accepted, only the hover pseudo is accepted.
 *   xcss?: StrictXCSSProp<XCSSAllProperties, '&:hover'>;
 *
 *   // The xcss prop is required as well as the color property. No pseudos are required.
 *   xcss: StrictXCSSProp<
 *     XCSSAllProperties,
 *     '&:hover',
 *     { requiredProperties: 'color', requiredPseudos: never }
 *   >;
 * }
 *
 * function MyComponent({ xcss }: MyComponentProps) {
 *   return <div css={{ color: 'var(--ds-text-danger)' }} className={xcss} />
 * }
 * ```
 *
 * The xcss prop works with static inline objects and the [cssMap](https://compiledcssinjs.com/docs/api-cssmap) API.
 *
 * ```jsx
 * // Declared as an inline object
 * <Component xcss={{ color: 'var(--ds-text)' }} />
 *
 * // Declared with the cssMap API
 * const styles = cssMap({ text: { color: 'var(--ds-text)' } });
 * <Component xcss={styles.text} />
 * ```
 *
 * To concatenate and conditonally apply styles use the {@link cssMap} and {@link cx} functions.
 */ 
});
parcelRegister("67x2X", function(module, exports) {

$parcel$export(module.exports, "createStrictAPI", function () { return $474d07e98ccb11e7$export$39716b4af53f4ad; });

var $eT9aM = parcelRequire("eT9aM");

var $4vuwT = parcelRequire("4vuwT");
function $474d07e98ccb11e7$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $eT9aM.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $eT9aM.createStrictSetupError)();
        },
        cx: $4vuwT.cx,
        XCSSProp () {
            throw (0, $eT9aM.createStrictSetupError)();
        }
    };
}

});
parcelRegister("eT9aM", function(module, exports) {

$parcel$export(module.exports, "createStrictSetupError", function () { return $ad6d514f14e88ae6$export$c4df1cb0c2b4d77c; });
const $ad6d514f14e88ae6$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $ad6d514f14e88ae6$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("4vuwT", function(module, exports) {

$parcel$export(module.exports, "cx", function () { return $3481bd2e0960f831$export$a274e22fb40f762e; });

var $c4hjl = parcelRequire("c4hjl");
const $3481bd2e0960f831$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $c4hjl.default)(actualStyles);
};

});



parcelRegister("9Ud6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7363825d3c2d074f$export$2e2bcd8739ae039; });
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $7363825d3c2d074f$var$_excluded = [
    "as",
    "role",
    "alignItems",
    "justifyContent",
    "gap",
    "columnGap",
    "rowGap",
    "children",
    "testId",
    "direction",
    "wrap",
    "xcss"
];
var $7363825d3c2d074f$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
var $7363825d3c2d074f$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
var $7363825d3c2d074f$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
var $7363825d3c2d074f$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
var $7363825d3c2d074f$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
var $7363825d3c2d074f$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
var $7363825d3c2d074f$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $7363825d3c2d074f$var$Flex = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $7363825d3c2d074f$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, ariaAttributes, {
        role: role,
        className: (0, $c4hjl.default)([
            $7363825d3c2d074f$var$styles.root,
            gap && $7363825d3c2d074f$var$columnGapMap[gap],
            columnGap && $7363825d3c2d074f$var$columnGapMap[columnGap],
            gap && $7363825d3c2d074f$var$rowGapMap[gap],
            rowGap && $7363825d3c2d074f$var$rowGapMap[rowGap],
            alignItems && $7363825d3c2d074f$var$alignItemsMap[alignItems],
            direction && $7363825d3c2d074f$var$flexDirectionMap[direction],
            justifyContent && $7363825d3c2d074f$var$justifyContentMap[justifyContent],
            wrap && $7363825d3c2d074f$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref
    }), children);
}));
$7363825d3c2d074f$var$Flex.displayName = 'Flex';
var $7363825d3c2d074f$export$2e2bcd8739ae039 = $7363825d3c2d074f$var$Flex;

});


parcelRegister("aDzos", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7be90050051d346f$export$2e2bcd8739ae039; });
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $25i4M = parcelRequire("25i4M");

var $9Ud6y = parcelRequire("9Ud6y");
var $7be90050051d346f$var$_excluded = [
    "as",
    "alignInline",
    "alignBlock",
    "spread",
    "grow",
    "space",
    "children",
    "testId",
    "xcss",
    "role"
];
var $7be90050051d346f$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $7be90050051d346f$var$Stack = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, ariaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $7be90050051d346f$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $9Ud6y.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, ariaAttributes, {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $25i4M.cx)(grow === 'hug' && $7be90050051d346f$var$styles.hug, grow === 'fill' && $7be90050051d346f$var$styles.fill, xcss),
        testId: testId,
        ref: ref
    }), children);
}));
$7be90050051d346f$var$Stack.displayName = 'Stack';
var $7be90050051d346f$export$2e2bcd8739ae039 = $7be90050051d346f$var$Stack;

});

parcelRegister("73a5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5220a4e678d1b2dd$export$2e2bcd8739ae039; });
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $5220a4e678d1b2dd$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $5220a4e678d1b2dd$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $c4hjl.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ])
    }, children);
};
var $5220a4e678d1b2dd$export$2e2bcd8739ae039 = $5220a4e678d1b2dd$var$VisuallyHidden;

});

parcelRegister("ftN8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b44fadf4acb00509$var$_react = $b44fadf4acb00509$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $b44fadf4acb00509$var$_baseNew = $b44fadf4acb00509$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $b44fadf4acb00509$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b44fadf4acb00509$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $b44fadf4acb00509$var$_react.default.createElement($b44fadf4acb00509$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$b44fadf4acb00509$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $b44fadf4acb00509$var$_default = module.exports.default = $b44fadf4acb00509$var$StatusErrorIcon;

});
parcelRegister("eLcgU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("gnmLg")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("gnmLg")).Icon; });

var $gnmLg = parcelRequire("gnmLg");

});
parcelRegister("gnmLg", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $bec0733d481550fa$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $bec0733d481550fa$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $bec0733d481550fa$var$svgStyles = null;
var $bec0733d481550fa$var$iconStyles = null;
var $bec0733d481550fa$var$utilityIconStyles = null;
var $bec0733d481550fa$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $bec0733d481550fa$var$baseHcmStyles = null;
var $bec0733d481550fa$var$scaleSize = null;
var $bec0733d481550fa$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bec0733d481550fa$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bec0733d481550fa$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $bec0733d481550fa$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $bec0733d481550fa$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $bec0733d481550fa$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $bec0733d481550fa$var$baseSizeMap[type];
    var viewBoxPadding = $bec0733d481550fa$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $bec0733d481550fa$var$utilSizes[spacing] : size === 'small' ? $bec0733d481550fa$var$coreSizeSmall[spacing] : $bec0733d481550fa$var$coreSizeMedium[spacing]
        ])
    }));
});
var $bec0733d481550fa$export$2e2bcd8739ae039 = $bec0733d481550fa$export$f04a61298a47a40f;

});



parcelRegister("9FI1U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $70aa18cb5cf5ddf8$var$_react = $70aa18cb5cf5ddf8$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $70aa18cb5cf5ddf8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $70aa18cb5cf5ddf8$var$ErrorIcon = (props)=>/*#__PURE__*/ $70aa18cb5cf5ddf8$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$70aa18cb5cf5ddf8$var$ErrorIcon.displayName = 'ErrorIcon';
var $70aa18cb5cf5ddf8$var$_default = module.exports.default = $70aa18cb5cf5ddf8$var$ErrorIcon;

});
parcelRegister("drb15", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $9c86579f4c9810ce$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $9c86579f4c9810ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c86579f4c9810ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c86579f4c9810ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c86579f4c9810ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $9c86579f4c9810ce$var$iconStyles = null;
var $9c86579f4c9810ce$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $9c86579f4c9810ce$var$baseHcmStyles = null;
var $9c86579f4c9810ce$var$primaryEqualsSecondaryHcmStyles = null;
var $9c86579f4c9810ce$var$secondaryTransparentHcmStyles = null;
var $9c86579f4c9810ce$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $9c86579f4c9810ce$var$_objectSpread($9c86579f4c9810ce$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $9c86579f4c9810ce$var$sizeStyles[size]
        ])
    }));
});
var $9c86579f4c9810ce$export$2e2bcd8739ae039 = $9c86579f4c9810ce$export$f04a61298a47a40f;

});


parcelRegister("1lZld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fc755b43eb5e282$var$_react = $0fc755b43eb5e282$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $0fc755b43eb5e282$var$_baseNew = $0fc755b43eb5e282$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $0fc755b43eb5e282$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fc755b43eb5e282$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $0fc755b43eb5e282$var$_react.default.createElement($0fc755b43eb5e282$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$0fc755b43eb5e282$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $0fc755b43eb5e282$var$_default = module.exports.default = $0fc755b43eb5e282$var$StatusInformationIcon;

});

parcelRegister("EjRAH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $079324fe4c4a50a4$var$_react = $079324fe4c4a50a4$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $079324fe4c4a50a4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $079324fe4c4a50a4$var$InfoIcon = (props)=>/*#__PURE__*/ $079324fe4c4a50a4$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$079324fe4c4a50a4$var$InfoIcon.displayName = 'InfoIcon';
var $079324fe4c4a50a4$var$_default = module.exports.default = $079324fe4c4a50a4$var$InfoIcon;

});

parcelRegister("giUvX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bdea2a6489b34ca9$var$_react = $bdea2a6489b34ca9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $bdea2a6489b34ca9$var$_baseNew = $bdea2a6489b34ca9$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $bdea2a6489b34ca9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bdea2a6489b34ca9$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $bdea2a6489b34ca9$var$_react.default.createElement($bdea2a6489b34ca9$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$bdea2a6489b34ca9$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $bdea2a6489b34ca9$var$_default = module.exports.default = $bdea2a6489b34ca9$var$StatusSuccessIcon;

});

parcelRegister("chIZR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f19f9f9a4040cc4$var$_react = $8f19f9f9a4040cc4$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $8f19f9f9a4040cc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8f19f9f9a4040cc4$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $8f19f9f9a4040cc4$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$8f19f9f9a4040cc4$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $8f19f9f9a4040cc4$var$_default = module.exports.default = $8f19f9f9a4040cc4$var$CheckCircleIcon;

});

parcelRegister("gATjA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $031e1c8e72a6999a$var$_react = $031e1c8e72a6999a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $031e1c8e72a6999a$var$_baseNew = $031e1c8e72a6999a$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $031e1c8e72a6999a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $031e1c8e72a6999a$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $031e1c8e72a6999a$var$_react.default.createElement($031e1c8e72a6999a$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$031e1c8e72a6999a$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $031e1c8e72a6999a$var$_default = module.exports.default = $031e1c8e72a6999a$var$StatusWarningIcon;

});

parcelRegister("6wKXL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c0a2915a75b3653$var$_react = $4c0a2915a75b3653$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $4c0a2915a75b3653$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4c0a2915a75b3653$var$WarningIcon = (props)=>/*#__PURE__*/ $4c0a2915a75b3653$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$4c0a2915a75b3653$var$WarningIcon.displayName = 'WarningIcon';
var $4c0a2915a75b3653$var$_default = module.exports.default = $4c0a2915a75b3653$var$WarningIcon;

});

parcelRegister("8dRDh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fc923ef89826cee$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $aBqr2 = parcelRequire("aBqr2");

var $5AVd4 = parcelRequire("5AVd4");

var $6EZrI = parcelRequire("6EZrI");

var $4R4Uu = parcelRequire("4R4Uu");

var $k4ILS = parcelRequire("k4ILS");

var $9cyTu = parcelRequire("9cyTu");
var $gWxJe = parcelRequire("gWxJe");

var $i2LcI = parcelRequire("i2LcI");

var $gz4oj = parcelRequire("gz4oj");

var $jTcCE = parcelRequire("jTcCE");

var $5Ksgw = parcelRequire("5Ksgw");

var $lVuW2 = parcelRequire("lVuW2");

var $2a45H = parcelRequire("2a45H");

var $4CAn8 = parcelRequire("4CAn8");

var $lyndE = parcelRequire("lyndE");

var $gluu2 = parcelRequire("gluu2");
function $5fc923ef89826cee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fc923ef89826cee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fc923ef89826cee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fc923ef89826cee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5fc923ef89826cee$var$tooltipZIndex = (0, $5Ksgw.layers).tooltip();
var $5fc923ef89826cee$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "0.0.0-development"
};
// Inverts motion direction
var $5fc923ef89826cee$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param placement - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $5fc923ef89826cee$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
/**
 * __Tooltip__
 *
 * A tooltip is a floating, non-actionable label used to explain a user interface element or feature.
 */ function $5fc923ef89826cee$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $lyndE.default) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $5AVd4.default) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $5AVd4.default) : _ref$onHide, canAppear = _ref.canAppear, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$ignoreTooltipPoi = _ref.ignoreTooltipPointerEvents, ignoreTooltipPointerEvents = _ref$ignoreTooltipPoi === void 0 ? false : _ref$ignoreTooltipPoi, _ref$isScreenReaderAn = _ref.isScreenReaderAnnouncementDisabled, isScreenReaderAnnouncementDisabled = _ref$isScreenReaderAn === void 0 ? false : _ref$isScreenReaderAn;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $aBqr2.usePlatformLeafSyntheticEventHandler)($5fc923ef89826cee$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $5fc923ef89826cee$var$analyticsAttributes));
    var onHideHandler = (0, $aBqr2.usePlatformLeafSyntheticEventHandler)($5fc923ef89826cee$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $5fc923ef89826cee$var$analyticsAttributes));
    var apiRef = (0, $8ZuGG.useRef)(null);
    var _useState = (0, $8ZuGG.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $8ZuGG.useRef)(null);
    var containerRef = (0, $8ZuGG.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $8ZuGG.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var stableState = (0, $4R4Uu.default)(state);
    // These props are placed in separate refs instead of a single object to reduce memory usage.
    // Placing them in the same object previously caused an increase in the number of JavaScript event listeners
    // before garbage collection.
    var onShowHandlerStable = (0, $4R4Uu.default)(onShowHandler);
    var onHideHandlerStable = (0, $4R4Uu.default)(onHideHandler);
    var delayStable = (0, $4R4Uu.default)(delay);
    var canAppearStable = (0, $4R4Uu.default)(canAppear);
    var hasCalledShowHandler = (0, $8ZuGG.useRef)(false);
    var start = (0, $8ZuGG.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $8ZuGG.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, [
        onHideHandlerStable
    ]);
    var abort = (0, $8ZuGG.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) onHideHandlerStable.current();
        // @ts-ignore
        apiRef.current = null;
    }, [
        onHideHandlerStable
    ]);
    (0, $8ZuGG.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $8ZuGG.useRef)(false);
    (0, $8ZuGG.useEffect)(function() {
        return (0, $lVuW2.register)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var tryShowTooltip = (0, $8ZuGG.useCallback)(function(source) {
        var _canAppearStable$curr;
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        // Another tooltip is has been active but we still have the old `api`
        // around. We need to finish up the last usage.
        // Note: just being safe - this should not happen
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // This tooltip is already active, we can exit
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        /**
     * Check if tooltip is allowed to show.
     *
     * Once a tooltip has started, or has scheduled to start
     * we won't be checking `canAppear` again.
     *
     * - We don't want tooltips to disappear once they are shown
     * - For consistency, we start after a single positive `canAppear`.
     *   Otherwise the amount of times we ask consumers would depend on
     *   how many times we get a "mousemove", which _could_ lead to situations
     *   where moving the mouse could result in a different outcome to if
     *   the mouse was not moved.
     */ if (canAppearStable.current && !((_canAppearStable$curr = canAppearStable.current) !== null && _canAppearStable$curr !== void 0 && _canAppearStable$curr.call(canAppearStable))) return;
        var entry = {
            source: source,
            delay: delayStable.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    onShowHandlerStable.current();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $2a45H.show)(entry);
        start(api);
    }, [
        canAppearStable,
        delayStable,
        done,
        start,
        abort,
        onShowHandlerStable
    ]);
    var hideTooltipOnEsc = (0, $8ZuGG.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $6EZrI.default)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $8ZuGG.useEffect)(function() {
        if (state === 'hide') return 0, $5AVd4.default;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $k6Bkl.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $8ZuGG.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $8ZuGG.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $8ZuGG.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $gluu2.getMousePosition)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        tryShowTooltip(source);
    }, [
        position,
        tryShowTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $8ZuGG.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $gluu2.getMousePosition)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $8ZuGG.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $8ZuGG.useCallback)(function(e) {
        // Check if focus-visible
        // Prevents tooltips from showing when focus is not visible,
        // i.e., when focus is moved onto tooltip trigger inside a popup on open
        try {
            if (!e.target.matches(':focus-visible') && (0, $i2LcI.fg)('platform-tooltip-focus-visible-new')) return;
        } catch (_) {
        // Ignore errors from environments that don't support :focus-visible
        }
        // TODO: this does not play well with `hideTooltipOnMouseDown`
        // as "focus" will occur after the "mousedown".
        tryShowTooltip({
            type: 'keyboard'
        });
    }, [
        tryShowTooltip
    ]);
    var onBlur = (0, $8ZuGG.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $8ZuGG.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && stableState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, [
        stableState
    ]);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipPopup = state !== 'hide' && Boolean(content);
    var shouldRenderHiddenContent = !isScreenReaderAnnouncementDisabled && shouldRenderTooltipPopup;
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var handleOpenLayerObserverCloseSignal = (0, $8ZuGG.useCallback)(function() {
        var _apiRef$current4;
        (_apiRef$current4 = apiRef.current) === null || _apiRef$current4 === void 0 || _apiRef$current4.requestHide({
            isImmediate: true
        });
    }, []);
    (0, $k4ILS.useNotifyOpenLayerObserver)({
        // Layer is only visually open if both the tooltip popup (container) and children are rendered.
        isOpen: shouldRenderTooltipPopup && shouldRenderTooltipChildren,
        /**
     * We don't strictly need to provide an onClose callback at this time, as there is
     * already code that handles hiding the tooltip when a drag is started (and the only
     * usage right now is closing all layers when the user resizes the side nav).
     *
     * However, for future-proofing and semantic reasons, it makes sense to close the tooltip
     * whenever the open layer observer requests a close.
     */ onClose: handleOpenLayerObserverCloseSignal
    });
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current5;
        if (position === 'mouse' && (_apiRef$current5 = apiRef.current) !== null && _apiRef$current5 !== void 0 && _apiRef$current5.mousePosition) {
            var _apiRef$current6;
            return (_apiRef$current6 = apiRef.current) === null || _apiRef$current6 === void 0 ? void 0 : _apiRef$current6.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipIdForHiddenContent = (0, $4CAn8.default)('tooltip', shouldRenderHiddenContent);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    var isChildrenAFunction = typeof children === 'function';
    (0, $8ZuGG.useEffect)(function() {
        if (isChildrenAFunction) return;
        // If `children` is _not_ a function, we are stepping outside of the public
        // API to add a `aria-describedby` attribute.
        var target = targetRef.current;
        if (!target || !tooltipIdForHiddenContent) return;
        target.setAttribute('aria-describedby', tooltipIdForHiddenContent);
        return function() {
            return target.removeAttribute('aria-describedby');
        };
    }, [
        isChildrenAFunction,
        tooltipIdForHiddenContent
    ]);
    var hiddenContent = shouldRenderHiddenContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipIdForHiddenContent
    }, typeof content === 'function' ? content({}) : content) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children($5fc923ef89826cee$var$_objectSpread($5fc923ef89826cee$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipIdForHiddenContent,
        ref: setDirectRef
    })), hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, hiddenContent), shouldRenderTooltipPopup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $jTcCE.default), {
        zIndex: $5fc923ef89826cee$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gz4oj.Popper), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $5fc923ef89826cee$var$invertedDirection[$5fc923ef89826cee$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9cyTu.default), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gWxJe.default), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state !== 'show-immediate' ? 'medium' : 'none'
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: $5fc923ef89826cee$var$_objectSpread($5fc923ef89826cee$var$_objectSpread({}, style), ignoreTooltipPointerEvents && {
                    pointerEvents: 'none'
                }),
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
var $5fc923ef89826cee$export$2e2bcd8739ae039 = $5fc923ef89826cee$var$Tooltip;

});
parcelRegister("aBqr2", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", function () { return $7b81dd8b953a5f02$export$1a04351537078b55; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $gvAuA = parcelRequire("gvAuA");

var $gCnIo = parcelRequire("gCnIo");
function $7b81dd8b953a5f02$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b81dd8b953a5f02$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b81dd8b953a5f02$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b81dd8b953a5f02$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7b81dd8b953a5f02$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gCnIo.useTrackedRef)(analyticsData);
    var fnRef = (0, $gCnIo.useTrackedRef)(fn);
    var handler = (0, $8ZuGG.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7b81dd8b953a5f02$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("6EZrI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d962468360ee0ea$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $i2LcI = parcelRequire("i2LcI");

var $hwZMN = parcelRequire("hwZMN");
function $4d962468360ee0ea$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $8ZuGG.useRef)(false);
    var onKeyDown = (0, $8ZuGG.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $hwZMN.ESCAPE)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $8ZuGG.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $8ZuGG.useEffect)(function() {
        // Don't attach document event listeners if the hook is disabled
        if (isDisabled && (0, $i2LcI.fg)('platform_only_attach_escape_handler_on_view')) return;
        return (0, $k6Bkl.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp,
        isDisabled
    ]);
}

});
parcelRegister("hwZMN", function(module, exports) {

$parcel$export(module.exports, "KEY_UP", function () { return $cc355a3ff8fc0773$export$390330c10ff2b9a1; });
$parcel$export(module.exports, "KEY_DOWN", function () { return $cc355a3ff8fc0773$export$a80636c6f41931fe; });
$parcel$export(module.exports, "KEY_HOME", function () { return $cc355a3ff8fc0773$export$4af703091671bc; });
$parcel$export(module.exports, "KEY_END", function () { return $cc355a3ff8fc0773$export$e2bc30913faa5db7; });
$parcel$export(module.exports, "KEY_TAB", function () { return $cc355a3ff8fc0773$export$10f6869ed0a7d75b; });
$parcel$export(module.exports, "KEY_ENTER", function () { return $cc355a3ff8fc0773$export$8152f929a25a0ff4; });
$parcel$export(module.exports, "KEY_SPACE", function () { return $cc355a3ff8fc0773$export$e51a3576c045c8d5; });
$parcel$export(module.exports, "ESCAPE", function () { return $cc355a3ff8fc0773$export$2bb790b9008907b4; });
/**
 * Character key codes which can be used in keyboard events.
 */ var $cc355a3ff8fc0773$export$390330c10ff2b9a1 = 'ArrowUp';
var $cc355a3ff8fc0773$export$a80636c6f41931fe = 'ArrowDown';
var $cc355a3ff8fc0773$export$4af703091671bc = 'Home';
var $cc355a3ff8fc0773$export$e2bc30913faa5db7 = 'End';
var $cc355a3ff8fc0773$export$10f6869ed0a7d75b = 'Tab';
var $cc355a3ff8fc0773$export$8152f929a25a0ff4 = 'Enter';
var $cc355a3ff8fc0773$export$e51a3576c045c8d5 = 'Space';
var $cc355a3ff8fc0773$export$2bb790b9008907b4 = 'Escape';

});


parcelRegister("4R4Uu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $388febbac4e6c5d1$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
function $388febbac4e6c5d1$export$2e2bcd8739ae039(value) {
    var ref = (0, $8ZuGG.useRef)(value);
    (0, $8ZuGG.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}

});

parcelRegister("k4ILS", function(module, exports) {

$parcel$export(module.exports, "useNotifyOpenLayerObserver", function () { return $e9d6e8fd13136561$export$469bb693f11edc7f; });

var $8ZuGG = parcelRequire("8ZuGG");

var $gOEqa = parcelRequire("gOEqa");

var $jHqWq = parcelRequire("jHqWq");
function $e9d6e8fd13136561$export$469bb693f11edc7f(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    var context = (0, $8ZuGG.useContext)((0, $gOEqa.OpenLayerObserverContext));
    var namespace = (0, $jHqWq.useOpenLayerObserverNamespace)();
    (0, $8ZuGG.useEffect)(function() {
        /**
     * Registers the `onClose` callback with the OpenLayerObserver.
     */ if (context === null) return;
        if (!isOpen) /**
       * If the layer is not open, we are not registering the `onClose` callback.
       * This is important to prevent the `onClose` from being called for layers that
       * are not open.
       *
       * Some consumers mistakenly pass "toggle" functions to `onClose` callbacks for
       * layer components, as Popup, e.g. `onClose={() => setIsOpen(!isOpen)}`.
       */ return;
        return context.onClose(onClose, {
            namespace: namespace
        });
    }, [
        context,
        isOpen,
        namespace,
        onClose
    ]);
}

});
parcelRegister("gOEqa", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverContext", function () { return $c3e0aba1a31ef4af$export$5fbf4d7fae6cdc00; });

var $8ZuGG = parcelRequire("8ZuGG");
var $c3e0aba1a31ef4af$export$5fbf4d7fae6cdc00 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("jHqWq", function(module, exports) {

$parcel$export(module.exports, "useOpenLayerObserverNamespace", function () { return $e576ee776afa9822$export$1d57e79091cc3046; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1Npwc = parcelRequire("1Npwc");
function $e576ee776afa9822$export$1d57e79091cc3046() {
    var namespace = (0, $8ZuGG.useContext)((0, $1Npwc.OpenLayerObserverNamespaceContext));
    return namespace;
}

});
parcelRegister("1Npwc", function(module, exports) {

$parcel$export(module.exports, "OpenLayerObserverNamespaceContext", function () { return $14ee29771079b8e3$export$644a49f3b8c50fcd; });

var $8ZuGG = parcelRequire("8ZuGG");
var $14ee29771079b8e3$export$644a49f3b8c50fcd = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});



parcelRegister("9cyTu", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", function () { return $6b304d4909b95572$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $6b304d4909b95572$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");
/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $6b304d4909b95572$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ var $6b304d4909b95572$var$ExitingContext = /*#__PURE__*/ (0, $8ZuGG.createContext)($6b304d4909b95572$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $6b304d4909b95572$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6b304d4909b95572$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6b304d4909b95572$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $6b304d4909b95572$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $8ZuGG.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $6b304d4909b95572$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $6b304d4909b95572$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $6b304d4909b95572$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $6b304d4909b95572$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMapKeys.has(_key)) missing.add(_key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $6b304d4909b95572$var$ExitingPersistence = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $8ZuGG.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $8ZuGG.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $8ZuGG.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === 'boolean') return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = $6b304d4909b95572$var$childrenToArray(previousChildren);
    var current = $6b304d4909b95572$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $6b304d4909b95572$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $6b304d4909b95572$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return $6b304d4909b95572$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return $6b304d4909b95572$var$wrapChildWithContextProvider(child, defaultContext);
    });
    return visibleChildren;
});
var $6b304d4909b95572$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $8ZuGG.useContext)($6b304d4909b95572$var$ExitingContext);
};
$6b304d4909b95572$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $6b304d4909b95572$export$2e2bcd8739ae039 = $6b304d4909b95572$var$ExitingPersistence;

});

parcelRegister("gWxJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55c39ede663614e$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1pve = parcelRequire("k1pve");
var $c55c39ede663614e$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c55c39ede663614e$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection !== undefined ? $c55c39ede663614e$var$invertedDirection[entranceDirection] : undefined;
    var isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? "fade-out-from-".concat(exitDirection || invertedEntranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-out';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $k1pve.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? "fade-in-from-".concat(entranceDirection).concat(distance === 'proportional' ? '' : '-constant') : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c55c39ede663614e$export$2e2bcd8739ae039 = $c55c39ede663614e$var$FadeIn;

});
parcelRegister("k1pve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e937aefa53328e39$export$2e2bcd8739ae039; });
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $cbGWw = parcelRequire("cbGWw");

var $9tcFo = parcelRequire("9tcFo");

var $7gmhW = parcelRequire("7gmhW");

var $9cyTu = parcelRequire("9cyTu");

var $9pDEZ = parcelRequire("9pDEZ");
var $e937aefa53328e39$var$zoomIn = null;
var $e937aefa53328e39$var$zoomOut = null;
var $e937aefa53328e39$var$fadeIn = null;
var $e937aefa53328e39$var$fadeOut = null;
var $e937aefa53328e39$var$fadeInFromTop = null;
var $e937aefa53328e39$var$fadeOutFromTop = null;
var $e937aefa53328e39$var$fadeInFromLeft = null;
var $e937aefa53328e39$var$fadeOutFromLeft = null;
var $e937aefa53328e39$var$fadeInFromBottom = null;
var $e937aefa53328e39$var$fadeOutFromBottom = null;
var $e937aefa53328e39$var$fadeInFromRight = null;
var $e937aefa53328e39$var$fadeOutFromRight = null;
var $e937aefa53328e39$var$fadeInFromTopConstant = null;
var $e937aefa53328e39$var$fadeOutFromTopConstant = null;
var $e937aefa53328e39$var$fadeInFromLeftConstant = null;
var $e937aefa53328e39$var$fadeOutFromLeftConstant = null;
var $e937aefa53328e39$var$fadeInFromBottomConstant = null;
var $e937aefa53328e39$var$fadeOutFromBottomConstant = null;
var $e937aefa53328e39$var$fadeInFromRightConstant = null;
var $e937aefa53328e39$var$fadeOutFromRightConstant = null;
var $e937aefa53328e39$var$slideInFromTop = null;
var $e937aefa53328e39$var$slideOutFromTop = null;
var $e937aefa53328e39$var$slideInFromRight = null;
var $e937aefa53328e39$var$slideOutFromRight = null;
var $e937aefa53328e39$var$slideInFromBottom = null;
var $e937aefa53328e39$var$slideOutFromBottom = null;
var $e937aefa53328e39$var$slideInFromLeft = null;
var $e937aefa53328e39$var$slideOutFromLeft = null;
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $e937aefa53328e39$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, _ref$animationTimingF = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF === void 0 ? animationTimingFunction : _ref$animationTimingF, enteringAnimation = _ref.enteringAnimation, _ref$exitingAnimation = _ref.exitingAnimation, exitingAnimation = _ref$exitingAnimation === void 0 ? enteringAnimation : _ref$exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'large' : _ref$duration;
    var staggered = (0, $9pDEZ.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $9cyTu.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $7gmhW.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $8ZuGG.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ var onAnimationEnd = function onAnimationEnd() {
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished === null || onExitFinished === void 0 || onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion === null || onFinishMotion === void 0 || onFinishMotion(state);
        };
        if ((0, $cbGWw.isReducedMotion)()) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $9tcFo.exitingDurations)[duration] : (0, $9tcFo.durations)[duration] + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $c4hjl.default)([
            (0, $c4hjl.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $c4hjl.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $c4hjl.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $c4hjl.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $c4hjl.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $c4hjl.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $c4hjl.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $c4hjl.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $c4hjl.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $c4hjl.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $c4hjl.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $c4hjl.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-40-out' && (0, $c4hjl.default)([
                "_1pgl5y64"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-60-out' && (0, $c4hjl.default)([
                "_1pgl1ddy"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-80-out' && (0, $c4hjl.default)([
                "_1pglannl"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $c4hjl.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $c4hjl.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $c4hjl.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $c4hjl.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-40-out' && (0, $c4hjl.default)([
                "_1pgl5y64"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-60-out' && (0, $c4hjl.default)([
                "_1pgl1ddy"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-80-out' && (0, $c4hjl.default)([
                "_1pglannl"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $c4hjl.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $c4hjl.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $c4hjl.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $c4hjl.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $c4hjl.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $c4hjl.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $c4hjl.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $c4hjl.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $c4hjl.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $c4hjl.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $c4hjl.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $c4hjl.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $c4hjl.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $c4hjl.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $c4hjl.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $c4hjl.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $c4hjl.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $c4hjl.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $c4hjl.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $c4hjl.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $c4hjl.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $c4hjl.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $c4hjl.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $c4hjl.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $c4hjl.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $c4hjl.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $c4hjl.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $c4hjl.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $c4hjl.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: "".concat(delay, "ms")
        }
    }, state);
};
var $e937aefa53328e39$export$2e2bcd8739ae039 = $e937aefa53328e39$var$EnteringMotion;

});
parcelRegister("cbGWw", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $8df7d2b2be5f5d04$export$b7baf7667a68d87c; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");
var $8df7d2b2be5f5d04$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $8df7d2b2be5f5d04$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$8df7d2b2be5f5d04$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $8df7d2b2be5f5d04$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $8ZuGG.useState)($8df7d2b2be5f5d04$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        if (!$8df7d2b2be5f5d04$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $k6Bkl.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $8df7d2b2be5f5d04$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $8df7d2b2be5f5d04$export$ff7706047246b98b = function prefersReducedMotion() {
    return $8df7d2b2be5f5d04$export$f0f789643ba5a83c;
};

});

parcelRegister("9tcFo", function(module, exports) {

$parcel$export(module.exports, "durations", function () { return $6e50a5d13d2e5a45$export$38b928a7167ce124; });
$parcel$export(module.exports, "exitingDurations", function () { return $6e50a5d13d2e5a45$export$30fa1a2e62ae150c; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $6e50a5d13d2e5a45$export$368bacef0dacbe05 = 25;
var $6e50a5d13d2e5a45$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ var $6e50a5d13d2e5a45$var$EXITING_MOTION_MULTIPLIER = 0.5;
var $6e50a5d13d2e5a45$export$30fa1a2e62ae150c = {
    none: $6e50a5d13d2e5a45$export$38b928a7167ce124.none,
    small: $6e50a5d13d2e5a45$export$38b928a7167ce124.small * $6e50a5d13d2e5a45$var$EXITING_MOTION_MULTIPLIER,
    medium: $6e50a5d13d2e5a45$export$38b928a7167ce124.medium * $6e50a5d13d2e5a45$var$EXITING_MOTION_MULTIPLIER,
    large: $6e50a5d13d2e5a45$export$38b928a7167ce124.large * $6e50a5d13d2e5a45$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("7gmhW", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $549b5105b658323a$export$4f34107a2b00f39c; });

var $8ZuGG = parcelRequire("8ZuGG");
var $549b5105b658323a$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $549b5105b658323a$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $8ZuGG.useRef)([]);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $549b5105b658323a$var$getHookDeps(opts));
    return (0, $8ZuGG.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $549b5105b658323a$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $8ZuGG.useRef)([]);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $549b5105b658323a$var$getHookDeps(opts));
    return (0, $8ZuGG.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("9pDEZ", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $6da53681a021116b$export$25c7213fc07ec080; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $5AVd4 = parcelRequire("5AVd4");

var $9F3xO = parcelRequire("9F3xO");

var $iJdss = parcelRequire("iJdss");
var $6da53681a021116b$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $5AVd4.default)
    };
});
var $6da53681a021116b$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $iJdss.useUniqueId)();
    var context = (0, $8ZuGG.useContext)($6da53681a021116b$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $6da53681a021116b$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $8ZuGG.useRef)([]);
    var indexes = [];
    var _useState = (0, $8ZuGG.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $9F3xO.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6da53681a021116b$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $6da53681a021116b$export$2e2bcd8739ae039 = $6da53681a021116b$var$StaggeredEntrance;

});
parcelRegister("9F3xO", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $708ab13d71506390$export$e5c5a5f917a5871c; });

var $8ZuGG = parcelRequire("8ZuGG");
var $708ab13d71506390$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $8ZuGG.useEffect) : (0, $8ZuGG.useLayoutEffect);

});

parcelRegister("iJdss", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $da26de6f207f22f0$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $8ZuGG = parcelRequire("8ZuGG");
function $da26de6f207f22f0$export$c485849f2e393253() {
    var identifier = (0, $8ZuGG.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("gz4oj", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $c0f352389ea887a5$export$badac9ada3a0bdf9; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $1xM4i = parcelRequire("1xM4i");

var $8IyoI = parcelRequire("8IyoI");

// Export types from PopperJS / React Popper
var $c0f352389ea887a5$var$viewportPadding = 5;
var $c0f352389ea887a5$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $c0f352389ea887a5$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $c0f352389ea887a5$var$defaultChildrenFn() {
    return null;
}
var $c0f352389ea887a5$var$defaultOffset = [
    0,
    8
];
function $c0f352389ea887a5$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $c0f352389ea887a5$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $c0f352389ea887a5$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy, _ref$shouldFitViewpor = _ref.shouldFitViewport, shouldFitViewport = _ref$shouldFitViewpor === void 0 ? false : _ref$shouldFitViewpor;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    var internalModifiers = (0, $8ZuGG.useMemo)(function() {
        var preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $c0f352389ea887a5$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        var maxSizeModifiers = shouldFitViewport ? (0, $8IyoI.getMaxSizeModifiers)({
            viewportPadding: $c0f352389ea887a5$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [].concat($c0f352389ea887a5$var$constantModifiers, [
            preventOverflowModifier,
            offsetModifier
        ], (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(maxSizeModifiers));
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $8ZuGG.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1xM4i.Popper), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}

});
parcelRegister("1xM4i", function(module, exports) {

$parcel$export(module.exports, "Popper", function () { return $11fe28e333623fc8$export$badac9ada3a0bdf9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $fsHSh = parcelRequire("fsHSh");

var $36O7l = parcelRequire("36O7l");

var $156bM = parcelRequire("156bM");
var $11fe28e333623fc8$var$NOOP = function NOOP() {
    return void 0;
};
var $11fe28e333623fc8$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $11fe28e333623fc8$var$EMPTY_MODIFIERS = [];
function $11fe28e333623fc8$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $11fe28e333623fc8$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $8ZuGG.useContext((0, $fsHSh.ManagerReferenceNodeContext));
    var _React$useState = $8ZuGG.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $8ZuGG.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $8ZuGG.useEffect(function() {
        (0, $36O7l.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $8ZuGG.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $156bM.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $8ZuGG.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $11fe28e333623fc8$var$NOOP,
            update: update || $11fe28e333623fc8$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $36O7l.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("fsHSh", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", function () { return $b41b811fcde541d8$export$3dbd3405086fec7b; });
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", function () { return $b41b811fcde541d8$export$cbabb21c2529b130; });
$parcel$export(module.exports, "Manager", function () { return $b41b811fcde541d8$export$d0d38e7dec7a1a61; });

var $8ZuGG = parcelRequire("8ZuGG");
var $b41b811fcde541d8$export$3dbd3405086fec7b = $8ZuGG.createContext();
var $b41b811fcde541d8$export$cbabb21c2529b130 = $8ZuGG.createContext();
function $b41b811fcde541d8$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $8ZuGG.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $8ZuGG.useRef(false);
    $8ZuGG.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $8ZuGG.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $8ZuGG.createElement($b41b811fcde541d8$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $8ZuGG.createElement($b41b811fcde541d8$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("36O7l", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", function () { return $2438cee74801c79e$export$f52c55943429c8b6; });
$parcel$export(module.exports, "safeInvoke", function () { return $2438cee74801c79e$export$3dfa7c28635fe028; });
$parcel$export(module.exports, "setRef", function () { return $2438cee74801c79e$export$4bb192c7cacf928f; });
$parcel$export(module.exports, "fromEntries", function () { return $2438cee74801c79e$export$5150077fc2e7c662; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $2438cee74801c79e$export$700979bc83e7db82; });

var $8ZuGG = parcelRequire("8ZuGG");
var $2438cee74801c79e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $2438cee74801c79e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $2438cee74801c79e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $2438cee74801c79e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $2438cee74801c79e$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $2438cee74801c79e$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $8ZuGG.useLayoutEffect : $8ZuGG.useEffect;

});

parcelRegister("156bM", function(module, exports) {

$parcel$export(module.exports, "usePopper", function () { return $0c9b0f1978c1b3b0$export$f4d5bf230a36dd6e; });

var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $eUZDz = parcelRequire("eUZDz");

var $kKjsX = parcelRequire("kKjsX");

var $36O7l = parcelRequire("36O7l");
var $0c9b0f1978c1b3b0$var$EMPTY_MODIFIERS = [];
var $0c9b0f1978c1b3b0$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $8ZuGG.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0c9b0f1978c1b3b0$var$EMPTY_MODIFIERS
    };
    var _React$useState = $8ZuGG.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $8ZuGG.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $h1d60.flushSync(function() {
                    setState({
                        styles: (0, $36O7l.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $36O7l.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $8ZuGG.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($kKjsX)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $8ZuGG.useRef();
    (0, $36O7l.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $36O7l.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $eUZDz.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("eUZDz", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $adc61b875daf1f10$export$8f7491d57c8f97a9; });

var $lRPCp = parcelRequire("lRPCp");

var $4afQ2 = parcelRequire("4afQ2");

var $1aq9C = parcelRequire("1aq9C");

var $gXipR = parcelRequire("gXipR");

var $dESnV = parcelRequire("dESnV");

var $eT5Uy = parcelRequire("eT5Uy");

var $e7LSF = parcelRequire("e7LSF");

var $dA9qE = parcelRequire("dA9qE");

var $586qm = parcelRequire("586qm");

var $6J5j8 = parcelRequire("6J5j8");


var $adc61b875daf1f10$export$d34966752335dd47 = [
    (0, $4afQ2.default),
    (0, $1aq9C.default),
    (0, $gXipR.default),
    (0, $dESnV.default),
    (0, $eT5Uy.default),
    (0, $e7LSF.default),
    (0, $dA9qE.default),
    (0, $586qm.default),
    (0, $6J5j8.default)
];
var $adc61b875daf1f10$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $lRPCp.popperGenerator)({
    defaultModifiers: $adc61b875daf1f10$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("lRPCp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $feb69695f7e4d28e$export$ed5e13716264f202; });

var $2DovD = parcelRequire("2DovD");

var $itKo5 = parcelRequire("itKo5");

var $dBQjv = parcelRequire("dBQjv");

var $6oeaG = parcelRequire("6oeaG");

var $9vkQH = parcelRequire("9vkQH");

var $3QvA6 = parcelRequire("3QvA6");

var $fqyjG = parcelRequire("fqyjG");


var $7MHrY = parcelRequire("7MHrY");
var $feb69695f7e4d28e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $feb69695f7e4d28e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $feb69695f7e4d28e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $feb69695f7e4d28e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $feb69695f7e4d28e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $7MHrY.isElement)(reference) ? (0, $dBQjv.default)(reference) : reference.contextElement ? (0, $dBQjv.default)(reference.contextElement) : [],
                    popper: (0, $dBQjv.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $9vkQH.default)((0, $fqyjG.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$feb69695f7e4d28e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $2DovD.default)(reference, (0, $6oeaG.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $itKo5.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $3QvA6.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$feb69695f7e4d28e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $feb69695f7e4d28e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $feb69695f7e4d28e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("2DovD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eb23c4d26ebcfa6$export$2e2bcd8739ae039; });

var $2fFpe = parcelRequire("2fFpe");

var $9MJE0 = parcelRequire("9MJE0");

var $arVTF = parcelRequire("arVTF");

var $7MHrY = parcelRequire("7MHrY");

var $7n7ty = parcelRequire("7n7ty");

var $hpceZ = parcelRequire("hpceZ");

var $bMD7X = parcelRequire("bMD7X");

var $hXkRX = parcelRequire("hXkRX");
function $1eb23c4d26ebcfa6$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hXkRX.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hXkRX.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1eb23c4d26ebcfa6$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $7MHrY.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $7MHrY.isHTMLElement)(offsetParent) && $1eb23c4d26ebcfa6$var$isElementScaled(offsetParent);
    var documentElement = (0, $hpceZ.default)(offsetParent);
    var rect = (0, $2fFpe.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $arVTF.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $bMD7X.default)(documentElement)) scroll = (0, $9MJE0.default)(offsetParent);
        if ((0, $7MHrY.isHTMLElement)(offsetParent)) {
            offsets = (0, $2fFpe.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $7n7ty.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("2fFpe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3d19de4b1f9240$export$2e2bcd8739ae039; });

var $7MHrY = parcelRequire("7MHrY");

var $hXkRX = parcelRequire("hXkRX");

var $ib2pf = parcelRequire("ib2pf");

var $hjze3 = parcelRequire("hjze3");
function $1a3d19de4b1f9240$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $7MHrY.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hXkRX.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hXkRX.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $7MHrY.isElement)(element) ? (0, $ib2pf.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $hjze3.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("7MHrY", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $5aaeb86b9953a262$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $5aaeb86b9953a262$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $5aaeb86b9953a262$export$af51f0f06c0f328a; });

var $ib2pf = parcelRequire("ib2pf");
function $5aaeb86b9953a262$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $ib2pf.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $5aaeb86b9953a262$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $ib2pf.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $5aaeb86b9953a262$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $ib2pf.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("ib2pf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3bb1eeb1718b5e0$export$2e2bcd8739ae039; });
function $d3bb1eeb1718b5e0$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("hXkRX", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $d128228afb1ba49b$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $d128228afb1ba49b$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $d128228afb1ba49b$export$2077e0241d6afd3c; });
var $d128228afb1ba49b$export$8960430cfd85939f = Math.max;
var $d128228afb1ba49b$export$96ec731ed4dcb222 = Math.min;
var $d128228afb1ba49b$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("hjze3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9af891fe403f037$export$2e2bcd8739ae039; });

var $6nPCE = parcelRequire("6nPCE");
function $c9af891fe403f037$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6nPCE.default)());
}

});
parcelRegister("6nPCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a5cef361571db6a$export$2e2bcd8739ae039; });
function $4a5cef361571db6a$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("9MJE0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71fc00bf77db34b8$export$2e2bcd8739ae039; });

var $2cb4V = parcelRequire("2cb4V");

var $ib2pf = parcelRequire("ib2pf");

var $7MHrY = parcelRequire("7MHrY");

var $1VhMk = parcelRequire("1VhMk");
function $71fc00bf77db34b8$export$2e2bcd8739ae039(node) {
    if (node === (0, $ib2pf.default)(node) || !(0, $7MHrY.isHTMLElement)(node)) return (0, $2cb4V.default)(node);
    else return (0, $1VhMk.default)(node);
}

});
parcelRegister("2cb4V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19954bb0666c7d9f$export$2e2bcd8739ae039; });

var $ib2pf = parcelRequire("ib2pf");
function $19954bb0666c7d9f$export$2e2bcd8739ae039(node) {
    var win = (0, $ib2pf.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("1VhMk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1668e7c1cdb13b2c$export$2e2bcd8739ae039; });
function $1668e7c1cdb13b2c$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("arVTF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79b9561796ef2912$export$2e2bcd8739ae039; });
function $79b9561796ef2912$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("7n7ty", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55e07ae83c8dbf73$export$2e2bcd8739ae039; });

var $2fFpe = parcelRequire("2fFpe");

var $hpceZ = parcelRequire("hpceZ");

var $2cb4V = parcelRequire("2cb4V");
function $55e07ae83c8dbf73$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2fFpe.default)((0, $hpceZ.default)(element)).left + (0, $2cb4V.default)(element).scrollLeft;
}

});
parcelRegister("hpceZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cabe44361252fdeb$export$2e2bcd8739ae039; });

var $7MHrY = parcelRequire("7MHrY");
function $cabe44361252fdeb$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $7MHrY.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("bMD7X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89428743a0c51e8f$export$2e2bcd8739ae039; });

var $4emMt = parcelRequire("4emMt");
function $89428743a0c51e8f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $4emMt.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("4emMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $314a24089caeeabe$export$2e2bcd8739ae039; });

var $ib2pf = parcelRequire("ib2pf");
function $314a24089caeeabe$export$2e2bcd8739ae039(element) {
    return (0, $ib2pf.default)(element).getComputedStyle(element);
}

});



parcelRegister("itKo5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d73eeaff82cd0355$export$2e2bcd8739ae039; });

var $2fFpe = parcelRequire("2fFpe");
function $d73eeaff82cd0355$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2fFpe.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("dBQjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e874f77dbfd91a6$export$2e2bcd8739ae039; });

var $12H9X = parcelRequire("12H9X");

var $boEjx = parcelRequire("boEjx");

var $ib2pf = parcelRequire("ib2pf");

var $bMD7X = parcelRequire("bMD7X");
function $9e874f77dbfd91a6$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $12H9X.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $ib2pf.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $bMD7X.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($9e874f77dbfd91a6$export$2e2bcd8739ae039((0, $boEjx.default)(target)));
}

});
parcelRegister("12H9X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c2774f85692835e$export$2e2bcd8739ae039; });

var $boEjx = parcelRequire("boEjx");

var $bMD7X = parcelRequire("bMD7X");

var $arVTF = parcelRequire("arVTF");

var $7MHrY = parcelRequire("7MHrY");
function $0c2774f85692835e$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $arVTF.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $7MHrY.isHTMLElement)(node) && (0, $bMD7X.default)(node)) return node;
    return $0c2774f85692835e$export$2e2bcd8739ae039((0, $boEjx.default)(node));
}

});
parcelRegister("boEjx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84c13528525f3454$export$2e2bcd8739ae039; });

var $arVTF = parcelRequire("arVTF");

var $hpceZ = parcelRequire("hpceZ");

var $7MHrY = parcelRequire("7MHrY");
function $84c13528525f3454$export$2e2bcd8739ae039(element) {
    if ((0, $arVTF.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $7MHrY.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $hpceZ.default)(element) // fallback
    );
}

});



parcelRegister("6oeaG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a6ffa167dca05c5$export$2e2bcd8739ae039; });

var $ib2pf = parcelRequire("ib2pf");

var $arVTF = parcelRequire("arVTF");

var $4emMt = parcelRequire("4emMt");

var $7MHrY = parcelRequire("7MHrY");

var $eOPkD = parcelRequire("eOPkD");

var $boEjx = parcelRequire("boEjx");

var $6nPCE = parcelRequire("6nPCE");
function $4a6ffa167dca05c5$var$getTrueOffsetParent(element) {
    if (!(0, $7MHrY.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $4emMt.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $4a6ffa167dca05c5$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6nPCE.default)());
    var isIE = /Trident/i.test((0, $6nPCE.default)());
    if (isIE && (0, $7MHrY.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $4emMt.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $boEjx.default)(element);
    if ((0, $7MHrY.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $7MHrY.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $arVTF.default)(currentNode)) < 0){
        var css = (0, $4emMt.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $4a6ffa167dca05c5$export$2e2bcd8739ae039(element) {
    var window = (0, $ib2pf.default)(element);
    var offsetParent = $4a6ffa167dca05c5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $eOPkD.default)(offsetParent) && (0, $4emMt.default)(offsetParent).position === 'static')offsetParent = $4a6ffa167dca05c5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $arVTF.default)(offsetParent) === 'html' || (0, $arVTF.default)(offsetParent) === 'body' && (0, $4emMt.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $4a6ffa167dca05c5$var$getContainingBlock(element) || window;
}

});
parcelRegister("eOPkD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac9d8d9dc4e2bc79$export$2e2bcd8739ae039; });

var $arVTF = parcelRequire("arVTF");
function $ac9d8d9dc4e2bc79$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $arVTF.default)(element)) >= 0;
}

});


parcelRegister("9vkQH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eb72e780e0b4ae8$export$2e2bcd8739ae039; });

var $gWDY3 = parcelRequire("gWDY3");
function $6eb72e780e0b4ae8$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $6eb72e780e0b4ae8$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $6eb72e780e0b4ae8$var$order(modifiers); // order based on phase
    return (0, $gWDY3.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("gWDY3", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $c56110dda1a23438$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $c56110dda1a23438$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $c56110dda1a23438$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $c56110dda1a23438$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $c56110dda1a23438$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $c56110dda1a23438$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $c56110dda1a23438$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $c56110dda1a23438$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $c56110dda1a23438$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $c56110dda1a23438$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $c56110dda1a23438$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $c56110dda1a23438$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $c56110dda1a23438$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $c56110dda1a23438$export$803cd8101b6c182b; });
$parcel$export(module.exports, "modifierPhases", function () { return $c56110dda1a23438$export$d087d3878fdf71d5; });
var $c56110dda1a23438$export$1e95b668f3b82d = 'top';
var $c56110dda1a23438$export$40e543e69a8b3fbb = 'bottom';
var $c56110dda1a23438$export$79ffe56a765070d2 = 'right';
var $c56110dda1a23438$export$eabcd2c8791e7bf4 = 'left';
var $c56110dda1a23438$export$dfb5619354ba860 = 'auto';
var $c56110dda1a23438$export$aec2ce47c367b8c3 = [
    $c56110dda1a23438$export$1e95b668f3b82d,
    $c56110dda1a23438$export$40e543e69a8b3fbb,
    $c56110dda1a23438$export$79ffe56a765070d2,
    $c56110dda1a23438$export$eabcd2c8791e7bf4
];
var $c56110dda1a23438$export$b3571188c770cc5a = 'start';
var $c56110dda1a23438$export$bd5df0f255a350f8 = 'end';
var $c56110dda1a23438$export$390fd549c5303b4d = 'clippingParents';
var $c56110dda1a23438$export$d7b7311ec04a3e8f = 'viewport';
var $c56110dda1a23438$export$ae5ab1c730825774 = 'popper';
var $c56110dda1a23438$export$ca50aac9f3ba507f = 'reference';
var $c56110dda1a23438$export$368f9a87e87fa4e1 = /*#__PURE__*/ $c56110dda1a23438$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $c56110dda1a23438$export$b3571188c770cc5a,
        placement + "-" + $c56110dda1a23438$export$bd5df0f255a350f8
    ]);
}, []);
var $c56110dda1a23438$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($c56110dda1a23438$export$aec2ce47c367b8c3, [
    $c56110dda1a23438$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $c56110dda1a23438$export$b3571188c770cc5a,
        placement + "-" + $c56110dda1a23438$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $c56110dda1a23438$export$421679a7c3d56e = 'beforeRead';
var $c56110dda1a23438$export$aafa59e2e03f2942 = 'read';
var $c56110dda1a23438$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $c56110dda1a23438$export$c65e99957a05207c = 'beforeMain';
var $c56110dda1a23438$export$f22da7240b7add18 = 'main';
var $c56110dda1a23438$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $c56110dda1a23438$export$8d4d2d70e7d46032 = 'beforeWrite';
var $c56110dda1a23438$export$68d8715fc104d294 = 'write';
var $c56110dda1a23438$export$70a6e5159acce2e6 = 'afterWrite';
var $c56110dda1a23438$export$d087d3878fdf71d5 = [
    $c56110dda1a23438$export$421679a7c3d56e,
    $c56110dda1a23438$export$aafa59e2e03f2942,
    $c56110dda1a23438$export$6964f6c886723980,
    $c56110dda1a23438$export$c65e99957a05207c,
    $c56110dda1a23438$export$f22da7240b7add18,
    $c56110dda1a23438$export$bab79516f2d662fe,
    $c56110dda1a23438$export$8d4d2d70e7d46032,
    $c56110dda1a23438$export$68d8715fc104d294,
    $c56110dda1a23438$export$70a6e5159acce2e6
];

});


parcelRegister("3QvA6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cceb9cf0155d025$export$2e2bcd8739ae039; });
function $2cceb9cf0155d025$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("fqyjG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3b3e73cc23abb03$export$2e2bcd8739ae039; });
function $b3b3e73cc23abb03$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("4afQ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $308461bf79a329e6$export$2e2bcd8739ae039; });

var $ib2pf = parcelRequire("ib2pf");
var $308461bf79a329e6$var$passive = {
    passive: true
};
function $308461bf79a329e6$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $ib2pf.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $308461bf79a329e6$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $308461bf79a329e6$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $308461bf79a329e6$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $308461bf79a329e6$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $308461bf79a329e6$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $308461bf79a329e6$var$effect,
    data: {}
};

});

parcelRegister("1aq9C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d9b0343394410d5$export$2e2bcd8739ae039; });

var $ieVgR = parcelRequire("ieVgR");
function $0d9b0343394410d5$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $ieVgR.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0d9b0343394410d5$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0d9b0343394410d5$var$popperOffsets,
    data: {}
};

});
parcelRegister("ieVgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $036d41e5b6676c15$export$2e2bcd8739ae039; });

var $8ii3V = parcelRequire("8ii3V");

var $kqapD = parcelRequire("kqapD");

var $183fg = parcelRequire("183fg");

var $gWDY3 = parcelRequire("gWDY3");
function $036d41e5b6676c15$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $8ii3V.default)(placement) : null;
    var variation = placement ? (0, $kqapD.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $gWDY3.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $gWDY3.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $gWDY3.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $gWDY3.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $183fg.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $gWDY3.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $gWDY3.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("8ii3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $609e03fdd57f8edd$export$2e2bcd8739ae039; });

function $609e03fdd57f8edd$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("kqapD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $edde500c7f5b9107$export$2e2bcd8739ae039; });
function $edde500c7f5b9107$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("183fg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d290e3d7dca1f3a$export$2e2bcd8739ae039; });
function $0d290e3d7dca1f3a$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("gXipR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c580711385b179ed$export$2e2bcd8739ae039; });

var $gWDY3 = parcelRequire("gWDY3");

var $6oeaG = parcelRequire("6oeaG");

var $ib2pf = parcelRequire("ib2pf");

var $hpceZ = parcelRequire("hpceZ");

var $4emMt = parcelRequire("4emMt");

var $8ii3V = parcelRequire("8ii3V");

var $kqapD = parcelRequire("kqapD");

var $hXkRX = parcelRequire("hXkRX");
var $c580711385b179ed$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c580711385b179ed$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hXkRX.round)(x * dpr) / dpr || 0,
        y: (0, $hXkRX.round)(y * dpr) / dpr || 0
    };
}
function $c580711385b179ed$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $gWDY3.left);
    var sideY = (0, $gWDY3.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $6oeaG.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $ib2pf.default)(popper)) {
            offsetParent = (0, $hpceZ.default)(popper);
            if ((0, $4emMt.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $gWDY3.top) || (placement === (0, $gWDY3.left) || placement === (0, $gWDY3.right)) && variation === (0, $gWDY3.end)) {
            sideY = (0, $gWDY3.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $gWDY3.left) || (placement === (0, $gWDY3.top) || placement === (0, $gWDY3.bottom)) && variation === (0, $gWDY3.end)) {
            sideX = (0, $gWDY3.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c580711385b179ed$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c580711385b179ed$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $ib2pf.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c580711385b179ed$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $8ii3V.default)(state.placement),
        variation: (0, $kqapD.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c580711385b179ed$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c580711385b179ed$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c580711385b179ed$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c580711385b179ed$var$computeStyles,
    data: {}
};

});

parcelRegister("dESnV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f193285668e89f9$export$2e2bcd8739ae039; });

var $arVTF = parcelRequire("arVTF");

var $7MHrY = parcelRequire("7MHrY");
// and applies them to the HTMLElements such as popper and arrow
function $9f193285668e89f9$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $7MHrY.isHTMLElement)(element) || !(0, $arVTF.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $9f193285668e89f9$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $7MHrY.isHTMLElement)(element) || !(0, $arVTF.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $9f193285668e89f9$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $9f193285668e89f9$var$applyStyles,
    effect: $9f193285668e89f9$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("eT5Uy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad6ac98fb5094b70$export$2e2bcd8739ae039; });

var $8ii3V = parcelRequire("8ii3V");

var $gWDY3 = parcelRequire("gWDY3");
function $ad6ac98fb5094b70$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $8ii3V.default)(placement);
    var invertDistance = [
        (0, $gWDY3.left),
        (0, $gWDY3.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $gWDY3.left),
        (0, $gWDY3.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ad6ac98fb5094b70$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $gWDY3.placements).reduce(function(acc, placement) {
        acc[placement] = $ad6ac98fb5094b70$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ad6ac98fb5094b70$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ad6ac98fb5094b70$var$offset
};

});

parcelRegister("e7LSF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a486dc4385122a0f$export$2e2bcd8739ae039; });

var $2gXzD = parcelRequire("2gXzD");

var $8ii3V = parcelRequire("8ii3V");

var $hqDb5 = parcelRequire("hqDb5");

var $1PzlJ = parcelRequire("1PzlJ");

var $aOq01 = parcelRequire("aOq01");

var $gWDY3 = parcelRequire("gWDY3");

var $kqapD = parcelRequire("kqapD");
function $a486dc4385122a0f$var$getExpandedFallbackPlacements(placement) {
    if ((0, $8ii3V.default)(placement) === (0, $gWDY3.auto)) return [];
    var oppositePlacement = (0, $2gXzD.default)(placement);
    return [
        (0, $hqDb5.default)(placement),
        oppositePlacement,
        (0, $hqDb5.default)(oppositePlacement)
    ];
}
function $a486dc4385122a0f$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $8ii3V.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2gXzD.default)(preferredPlacement)
    ] : $a486dc4385122a0f$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $8ii3V.default)(placement) === (0, $gWDY3.auto) ? (0, $aOq01.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $8ii3V.default)(placement);
        var isStartVariation = (0, $kqapD.default)(placement) === (0, $gWDY3.start);
        var isVertical = [
            (0, $gWDY3.top),
            (0, $gWDY3.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $1PzlJ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $gWDY3.right) : (0, $gWDY3.left) : isStartVariation ? (0, $gWDY3.bottom) : (0, $gWDY3.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2gXzD.default)(mainVariationSide);
        var altVariationSide = (0, $2gXzD.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a486dc4385122a0f$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a486dc4385122a0f$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("2gXzD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a7b49802e517242$export$2e2bcd8739ae039; });
var $1a7b49802e517242$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $1a7b49802e517242$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $1a7b49802e517242$var$hash[matched];
    });
}

});

parcelRegister("hqDb5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cb0341472c7a7283$export$2e2bcd8739ae039; });
var $cb0341472c7a7283$var$hash = {
    start: 'end',
    end: 'start'
};
function $cb0341472c7a7283$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $cb0341472c7a7283$var$hash[matched];
    });
}

});

parcelRegister("1PzlJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1555f98b7d9dbced$export$2e2bcd8739ae039; });

var $7WJQR = parcelRequire("7WJQR");

var $hpceZ = parcelRequire("hpceZ");

var $2fFpe = parcelRequire("2fFpe");

var $ieVgR = parcelRequire("ieVgR");

var $2ieFP = parcelRequire("2ieFP");

var $gWDY3 = parcelRequire("gWDY3");

var $7MHrY = parcelRequire("7MHrY");

var $a1pb2 = parcelRequire("a1pb2");

var $iKnKz = parcelRequire("iKnKz");
function $1555f98b7d9dbced$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $gWDY3.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $gWDY3.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $gWDY3.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $a1pb2.default)(typeof padding !== 'number' ? padding : (0, $iKnKz.default)(padding, (0, $gWDY3.basePlacements)));
    var altContext = elementContext === (0, $gWDY3.popper) ? (0, $gWDY3.reference) : (0, $gWDY3.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $7WJQR.default)((0, $7MHrY.isElement)(element) ? element : element.contextElement || (0, $hpceZ.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2fFpe.default)(state.elements.reference);
    var popperOffsets = (0, $ieVgR.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2ieFP.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $gWDY3.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $gWDY3.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $gWDY3.right),
                (0, $gWDY3.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $gWDY3.top),
                (0, $gWDY3.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("7WJQR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c9184580d48b8f3$export$2e2bcd8739ae039; });

var $gWDY3 = parcelRequire("gWDY3");

var $c9Qth = parcelRequire("c9Qth");

var $9HQgh = parcelRequire("9HQgh");

var $dBQjv = parcelRequire("dBQjv");

var $6oeaG = parcelRequire("6oeaG");

var $hpceZ = parcelRequire("hpceZ");

var $4emMt = parcelRequire("4emMt");

var $7MHrY = parcelRequire("7MHrY");

var $2fFpe = parcelRequire("2fFpe");

var $boEjx = parcelRequire("boEjx");

var $gN4pB = parcelRequire("gN4pB");

var $arVTF = parcelRequire("arVTF");

var $2ieFP = parcelRequire("2ieFP");

var $hXkRX = parcelRequire("hXkRX");
function $5c9184580d48b8f3$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2fFpe.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $5c9184580d48b8f3$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $gWDY3.viewport) ? (0, $2ieFP.default)((0, $c9Qth.default)(element, strategy)) : (0, $7MHrY.isElement)(clippingParent) ? $5c9184580d48b8f3$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2ieFP.default)((0, $9HQgh.default)((0, $hpceZ.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $5c9184580d48b8f3$var$getClippingParents(element) {
    var clippingParents = (0, $dBQjv.default)((0, $boEjx.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $4emMt.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $7MHrY.isHTMLElement)(element) ? (0, $6oeaG.default)(element) : element;
    if (!(0, $7MHrY.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $7MHrY.isElement)(clippingParent) && (0, $gN4pB.default)(clippingParent, clipperElement) && (0, $arVTF.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $5c9184580d48b8f3$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $5c9184580d48b8f3$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $5c9184580d48b8f3$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hXkRX.max)(rect.top, accRect.top);
        accRect.right = (0, $hXkRX.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hXkRX.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hXkRX.max)(rect.left, accRect.left);
        return accRect;
    }, $5c9184580d48b8f3$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("c9Qth", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d9f06fa74f07601$export$2e2bcd8739ae039; });

var $ib2pf = parcelRequire("ib2pf");

var $hpceZ = parcelRequire("hpceZ");

var $7n7ty = parcelRequire("7n7ty");

var $hjze3 = parcelRequire("hjze3");
function $8d9f06fa74f07601$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $ib2pf.default)(element);
    var html = (0, $hpceZ.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $hjze3.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $7n7ty.default)(element),
        y: y
    };
}

});

parcelRegister("9HQgh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7110ab41f28b7850$export$2e2bcd8739ae039; });

var $hpceZ = parcelRequire("hpceZ");

var $4emMt = parcelRequire("4emMt");

var $7n7ty = parcelRequire("7n7ty");

var $2cb4V = parcelRequire("2cb4V");

var $hXkRX = parcelRequire("hXkRX");
function $7110ab41f28b7850$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $hpceZ.default)(element);
    var winScroll = (0, $2cb4V.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hXkRX.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hXkRX.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $7n7ty.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $4emMt.default)(body || html).direction === 'rtl') x += (0, $hXkRX.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("gN4pB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c394a510c10c8210$export$2e2bcd8739ae039; });

var $7MHrY = parcelRequire("7MHrY");
function $c394a510c10c8210$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $7MHrY.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("2ieFP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ab8a517facb1c9a$export$2e2bcd8739ae039; });
function $1ab8a517facb1c9a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("a1pb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74bd87040fad8499$export$2e2bcd8739ae039; });

var $40aay = parcelRequire("40aay");
function $74bd87040fad8499$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $40aay.default)(), paddingObject);
}

});
parcelRegister("40aay", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e9f0cee1bc8afe0$export$2e2bcd8739ae039; });
function $2e9f0cee1bc8afe0$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("iKnKz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da5ef224a1a16a68$export$2e2bcd8739ae039; });
function $da5ef224a1a16a68$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("aOq01", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7df2bdcf17f3daa0$export$2e2bcd8739ae039; });

var $kqapD = parcelRequire("kqapD");

var $gWDY3 = parcelRequire("gWDY3");

var $1PzlJ = parcelRequire("1PzlJ");

var $8ii3V = parcelRequire("8ii3V");
function $7df2bdcf17f3daa0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $gWDY3.placements) : _options$allowedAutoP;
    var variation = (0, $kqapD.default)(placement);
    var placements = variation ? flipVariations ? (0, $gWDY3.variationPlacements) : (0, $gWDY3.variationPlacements).filter(function(placement) {
        return (0, $kqapD.default)(placement) === variation;
    }) : (0, $gWDY3.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $1PzlJ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $8ii3V.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("dA9qE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e35f38215b7bf2c$export$2e2bcd8739ae039; });

var $gWDY3 = parcelRequire("gWDY3");

var $8ii3V = parcelRequire("8ii3V");

var $183fg = parcelRequire("183fg");

var $bdyza = parcelRequire("bdyza");

var $dOcgz = parcelRequire("dOcgz");

var $itKo5 = parcelRequire("itKo5");

var $6oeaG = parcelRequire("6oeaG");

var $1PzlJ = parcelRequire("1PzlJ");

var $kqapD = parcelRequire("kqapD");

var $40aay = parcelRequire("40aay");

var $hXkRX = parcelRequire("hXkRX");
function $9e35f38215b7bf2c$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $1PzlJ.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $8ii3V.default)(state.placement);
    var variation = (0, $kqapD.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $183fg.default)(basePlacement);
    var altAxis = (0, $bdyza.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $gWDY3.top) : (0, $gWDY3.left);
        var altSide = mainAxis === 'y' ? (0, $gWDY3.bottom) : (0, $gWDY3.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $gWDY3.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $gWDY3.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $itKo5.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $40aay.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $dOcgz.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $6oeaG.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $dOcgz.within)(tether ? (0, $hXkRX.min)(min, tetherMin) : min, offset, tether ? (0, $hXkRX.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $gWDY3.top) : (0, $gWDY3.left);
        var _altSide = mainAxis === 'x' ? (0, $gWDY3.bottom) : (0, $gWDY3.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $gWDY3.top),
            (0, $gWDY3.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $dOcgz.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $dOcgz.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9e35f38215b7bf2c$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9e35f38215b7bf2c$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("bdyza", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $82abb8be2b29533b$export$2e2bcd8739ae039; });
function $82abb8be2b29533b$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("dOcgz", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $a0d975b852678fd7$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $a0d975b852678fd7$export$86c8af6d3ef0b4a; });

var $hXkRX = parcelRequire("hXkRX");
function $a0d975b852678fd7$export$f28d906d67a997f3(min, value, max) {
    return (0, $hXkRX.max)(min, (0, $hXkRX.min)(value, max));
}
function $a0d975b852678fd7$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $a0d975b852678fd7$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("586qm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3bc2aecf74b04524$export$2e2bcd8739ae039; });

var $8ii3V = parcelRequire("8ii3V");

var $itKo5 = parcelRequire("itKo5");

var $gN4pB = parcelRequire("gN4pB");

var $6oeaG = parcelRequire("6oeaG");

var $183fg = parcelRequire("183fg");

var $dOcgz = parcelRequire("dOcgz");

var $a1pb2 = parcelRequire("a1pb2");

var $iKnKz = parcelRequire("iKnKz");

var $gWDY3 = parcelRequire("gWDY3");
var $3bc2aecf74b04524$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $a1pb2.default)(typeof padding !== 'number' ? padding : (0, $iKnKz.default)(padding, (0, $gWDY3.basePlacements)));
};
function $3bc2aecf74b04524$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $8ii3V.default)(state.placement);
    var axis = (0, $183fg.default)(basePlacement);
    var isVertical = [
        (0, $gWDY3.left),
        (0, $gWDY3.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $3bc2aecf74b04524$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $itKo5.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $gWDY3.top) : (0, $gWDY3.left);
    var maxProp = axis === 'y' ? (0, $gWDY3.bottom) : (0, $gWDY3.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $6oeaG.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $dOcgz.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $3bc2aecf74b04524$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $gN4pB.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $3bc2aecf74b04524$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $3bc2aecf74b04524$var$arrow,
    effect: $3bc2aecf74b04524$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("6J5j8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e5b100acf4b35cc$export$2e2bcd8739ae039; });

var $gWDY3 = parcelRequire("gWDY3");

var $1PzlJ = parcelRequire("1PzlJ");
function $4e5b100acf4b35cc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $4e5b100acf4b35cc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $gWDY3.top),
        (0, $gWDY3.right),
        (0, $gWDY3.bottom),
        (0, $gWDY3.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $4e5b100acf4b35cc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $1PzlJ.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $1PzlJ.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $4e5b100acf4b35cc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $4e5b100acf4b35cc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $4e5b100acf4b35cc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $4e5b100acf4b35cc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $4e5b100acf4b35cc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $4e5b100acf4b35cc$var$hide
};

});


parcelRegister("kKjsX", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $f1a73414d6aa5d18$var$hasElementType = typeof Element !== 'undefined';
var $f1a73414d6aa5d18$var$hasMap = typeof Map === 'function';
var $f1a73414d6aa5d18$var$hasSet = typeof Set === 'function';
var $f1a73414d6aa5d18$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $f1a73414d6aa5d18$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$f1a73414d6aa5d18$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($f1a73414d6aa5d18$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$f1a73414d6aa5d18$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($f1a73414d6aa5d18$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($f1a73414d6aa5d18$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($f1a73414d6aa5d18$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$f1a73414d6aa5d18$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $f1a73414d6aa5d18$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("8IyoI", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", function () { return $658d1d769ba7ba5e$export$6d8c2b45c99d6e3f; });

var $kg5sN = parcelRequire("kg5sN");
function $658d1d769ba7ba5e$export$6d8c2b45c99d6e3f(_ref) {
    var viewportPadding = _ref.viewportPadding;
    return [
        {
            /**
     * Performing DOM measurements in the 'read' phase,
     * which is the convention for popper modifiers
     */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn: function fn(_ref2) {
                var state = _ref2.state, name = _ref2.name;
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
     * Applying max size CSS
     */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn: function fn(_ref3) {
                var _data$viewport, _data$viewport2, _state$modifiersData$2, _state$modifiersData;
                var state = _ref3.state;
                var data = state.modifiersData.maxSizeData;
                if (typeof (data === null || data === void 0 || (_data$viewport = data.viewport) === null || _data$viewport === void 0 ? void 0 : _data$viewport.width) !== 'number' || typeof (data === null || data === void 0 || (_data$viewport2 = data.viewport) === null || _data$viewport2 === void 0 ? void 0 : _data$viewport2.height) !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                var viewport = data.viewport;
                var _state$modifiersData$ = state.modifiersData.popperOffsets, popperOffsets = _state$modifiersData$ === void 0 ? {
                    x: 0,
                    y: 0
                } : _state$modifiersData$;
                var _state$placement$spli = state.placement.split('-'), _state$placement$spli2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_state$placement$spli, 1), basePlacement = _state$placement$spli2[0];
                var placementOffset = (_state$modifiersData$2 = (_state$modifiersData = state.modifiersData) === null || _state$modifiersData === void 0 || (_state$modifiersData = _state$modifiersData.offset) === null || _state$modifiersData === void 0 ? void 0 : _state$modifiersData[state.placement]) !== null && _state$modifiersData$2 !== void 0 ? _state$modifiersData$2 : {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                var maxWidth = viewport.width - 2 * viewportPadding;
                var maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = "".concat(maxWidth, "px");
                state.styles.popper.maxHeight = "".concat(maxHeight, "px");
            }
        }
    ];
}

});


parcelRegister("jTcCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7acf1ee56512abd$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");

var $2HBmw = parcelRequire("2HBmw");

var $dOP4L = parcelRequire("dOP4L");

var $fYjmY = parcelRequire("fYjmY");

var $kbQtp = parcelRequire("kbQtp");
function $e7acf1ee56512abd$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $fYjmY.default)(mountStrategy);
    (0, $kbQtp.default)(zIndex);
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    return !(0, $i2LcI.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2HBmw.default), {
        zIndex: zIndex
    }, children) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dOP4L.default), {
        zIndex: zIndex
    }, children);
}

});
parcelRegister("2HBmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7c944f08970b20$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $btYQT = parcelRequire("btYQT");
function $1f7c944f08970b20$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $8ZuGG.useMemo)(function() {
        return (0, $btYQT.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $btYQT.appendPortalContainerIfNotAppended)(container);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            (0, $btYQT.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $h1d60.createPortal)(children, container);
}

});
parcelRegister("btYQT", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $85c19b1bb9332718$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $85c19b1bb9332718$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $85c19b1bb9332718$export$c582005add11e141; });
$parcel$export(module.exports, "createAtlaskitPortal", function () { return $85c19b1bb9332718$export$fef014d7cef9e543; });
$parcel$export(module.exports, "createPortalParent", function () { return $85c19b1bb9332718$export$95029ca7aca2989e; });

var $cXGef = parcelRequire("cXGef");
var $85c19b1bb9332718$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $cXGef.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $85c19b1bb9332718$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $85c19b1bb9332718$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $cXGef.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement('div');
        parent.className = (0, $cXGef.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        (_getBody = $85c19b1bb9332718$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $85c19b1bb9332718$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $85c19b1bb9332718$var$getPortalParent().removeChild(container);
};
var $85c19b1bb9332718$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $85c19b1bb9332718$var$getPortalParent().appendChild(container);
};
var $85c19b1bb9332718$var$isDocumentDefined = function isDocumentDefined() {
    return document !== undefined;
};
var $85c19b1bb9332718$export$fef014d7cef9e543 = function createAtlaskitPortal(zIndex) {
    //atlaskit-portal div
    if ($85c19b1bb9332718$var$isDocumentDefined()) {
        var atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $cXGef.portalClassName);
        atlaskitportal.style.zIndex = "".concat(zIndex);
        return atlaskitportal;
    }
};
var $85c19b1bb9332718$export$95029ca7aca2989e = function createPortalParent() {
    //atlaskit-portal-container div
    if ($85c19b1bb9332718$var$isDocumentDefined()) {
        var parentElement = document.querySelector((0, $cXGef.portalParentSelector));
        if (!parentElement) {
            var _getBody2;
            var parent = document.createElement('div');
            parent.className = (0, $cXGef.portalParentClassName);
            parent.style.display = 'flex';
            (_getBody2 = $85c19b1bb9332718$var$getBody()) === null || _getBody2 === void 0 || _getBody2.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
parcelRegister("cXGef", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $96fbc07ae52e1999$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $96fbc07ae52e1999$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $96fbc07ae52e1999$export$13f57c02915787b3; });
var $96fbc07ae52e1999$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $96fbc07ae52e1999$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $96fbc07ae52e1999$export$13f57c02915787b3 = 'atlaskit-portal';

});



parcelRegister("dOP4L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0f790778030a3d5$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $4SntX = parcelRequire("4SntX");

var $btYQT = parcelRequire("btYQT");
function $a0f790778030a3d5$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var _useState = (0, $8ZuGG.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), atlaskitPortal = _useState2[0], setAtlaskitPortal = _useState2[1];
    (0, $4SntX.useIsomorphicLayoutEffect)(function() {
        var tempPortalContainer = (0, $btYQT.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        var portalParent = (0, $btYQT.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return function() {
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
   * We wrap portal children with a Suspense boundary because in React 18 concurrent,
   * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
   * our portal gets in an infinite loop of rendering.
   */ var suspendedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Suspense), {
        fallback: null
    }, children);
    return atlaskitPortal ? /*#__PURE__*/ (0, $h1d60.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("4SntX", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $38ce6baade87f434$export$700979bc83e7db82; });

var $8ZuGG = parcelRequire("8ZuGG");
var $38ce6baade87f434$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $8ZuGG.useLayoutEffect) : (0, $8ZuGG.useEffect);

});


parcelRegister("fYjmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0b7c03a242df8c$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $4SntX = parcelRequire("4SntX");
var $ba0b7c03a242df8c$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $4SntX.useIsomorphicLayoutEffect) : (0, $8ZuGG.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ba0b7c03a242df8c$export$2e2bcd8739ae039 = $ba0b7c03a242df8c$var$useIsSubsequentRender;

});

parcelRegister("kbQtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb2d89d7e979aa86$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9apqF = parcelRequire("9apqF");

var $hPCFC = parcelRequire("hPCFC");
var $eb2d89d7e979aa86$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $8ZuGG.useEffect)(function() {
        (0, $hPCFC.default)((0, $9apqF.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hPCFC.default)((0, $9apqF.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $eb2d89d7e979aa86$export$2e2bcd8739ae039 = $eb2d89d7e979aa86$var$useFirePortalEvent;

});
parcelRegister("9apqF", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $6ac8c5eb586fe3f0$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $6ac8c5eb586fe3f0$export$80816bd900e5bd00; });
var $6ac8c5eb586fe3f0$export$ed5835cc67e87f72 = 'akPortalMount';
var $6ac8c5eb586fe3f0$export$80816bd900e5bd00 = 'akPortalUnmount';

});

parcelRegister("hPCFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfb53235835b7bd2$export$2e2bcd8739ae039; });
var $cfb53235835b7bd2$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cfb53235835b7bd2$var$getLayerName = function getLayerName(zIndex) {
    return $cfb53235835b7bd2$var$zIndexToName.hasOwnProperty(zIndex) ? $cfb53235835b7bd2$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cfb53235835b7bd2$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cfb53235835b7bd2$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cfb53235835b7bd2$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cfb53235835b7bd2$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("5Ksgw", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $42f72c8fbd7f8ea9$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $gCwDs = parcelRequire("gCwDs");
var $42f72c8fbd7f8ea9$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $42f72c8fbd7f8ea9$export$c93026a968943f95 = 'light';
var $42f72c8fbd7f8ea9$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $42f72c8fbd7f8ea9$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $42f72c8fbd7f8ea9$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $gCwDs.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $42f72c8fbd7f8ea9$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $42f72c8fbd7f8ea9$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $42f72c8fbd7f8ea9$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $42f72c8fbd7f8ea9$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $42f72c8fbd7f8ea9$export$ba1d834b86d72a09 = $42f72c8fbd7f8ea9$export$a1b3edb637fb4f35;
var $42f72c8fbd7f8ea9$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $gCwDs.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $gCwDs.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $gCwDs.N30A), ")")
            }
        }
    };
};

});
parcelRegister("gCwDs", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $c19982af2c067044$export$215b7063051591f1; });
$parcel$export(module.exports, "N0", function () { return $c19982af2c067044$export$29a4f05edc054374; });
$parcel$export(module.exports, "N800", function () { return $c19982af2c067044$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $c19982af2c067044$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c19982af2c067044$export$920c0d5c49070351; });
// Reds
var $c19982af2c067044$export$4b84fd0e2c617bd = '#FFEBE6';
var $c19982af2c067044$export$b34b069eff244586 = '#FFBDAD';
var $c19982af2c067044$export$be802dd0d8b57f35 = '#FF8F73';
var $c19982af2c067044$export$60847d42f9da92a6 = '#FF7452';
var $c19982af2c067044$export$4a7404f376229999 = '#FF5630';
var $c19982af2c067044$export$2010d0fb4295b346 = '#DE350B';
var $c19982af2c067044$export$2837b5a1a71d5c02 = '#BF2600';
var $c19982af2c067044$export$8d9596b529bbb9cf = '#FFFAE6';
var $c19982af2c067044$export$41060a744ab0b7ae = '#FFF0B3';
var $c19982af2c067044$export$1cc05bbbf340e559 = '#FFE380';
var $c19982af2c067044$export$5aae31392d72caaa = '#FFC400';
var $c19982af2c067044$export$c6930421db9fa514 = '#FFAB00';
var $c19982af2c067044$export$59619663aa6500fb = '#FF991F';
var $c19982af2c067044$export$874739ea9e379ab6 = '#FF8B00';
var $c19982af2c067044$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c19982af2c067044$export$69a3bf21b9686c2b = '#ABF5D1';
var $c19982af2c067044$export$afbce1382ec95f73 = '#79F2C0';
var $c19982af2c067044$export$747d86715d4175de = '#57D9A3';
var $c19982af2c067044$export$940e1f69e873f202 = '#36B37E';
var $c19982af2c067044$export$a49394138f7b8e85 = '#00875A';
var $c19982af2c067044$export$6fa04827ac68a4fb = '#006644';
var $c19982af2c067044$export$226de0355ed012f8 = '#DEEBFF';
var $c19982af2c067044$export$8c13c2ee36917869 = '#B3D4FF';
var $c19982af2c067044$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c19982af2c067044$export$215b7063051591f1 = '#2684FF';
var $c19982af2c067044$export$e62e8919cca44969 = '#0065FF';
var $c19982af2c067044$export$b3de0ae08da2ce64 = '#0052CC';
var $c19982af2c067044$export$a6ee3d71bc067634 = '#0747A6';
var $c19982af2c067044$export$67f15409e87642a1 = '#669DF1';
var $c19982af2c067044$export$f0539dbc42dbb067 = '#8FB8F6';
var $c19982af2c067044$export$363e4475840015bb = '#EAE6FF';
var $c19982af2c067044$export$4b0a4417ed59760f = '#C0B6F2';
var $c19982af2c067044$export$6011520a64d9a187 = '#998DD9';
var $c19982af2c067044$export$a7175d4e9206bc80 = '#8777D9';
var $c19982af2c067044$export$b48405b95304b5a1 = '#6554C0';
var $c19982af2c067044$export$c71e4279dd54a18d = '#5243AA';
var $c19982af2c067044$export$147899de772240ec = '#403294';
var $c19982af2c067044$export$2cf711fe14c66f06 = '#E6FCFF';
var $c19982af2c067044$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c19982af2c067044$export$776c9c497ef08533 = '#79E2F2';
var $c19982af2c067044$export$69cb3ca10c1e330e = '#00C7E6';
var $c19982af2c067044$export$9dc1ef0f3f48059b = '#00B8D9';
var $c19982af2c067044$export$7c835c78b6fcdef8 = '#00A3BF';
var $c19982af2c067044$export$6036577f95c3877e = '#008DA6';
var $c19982af2c067044$export$29a4f05edc054374 = '#FFFFFF';
var $c19982af2c067044$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c19982af2c067044$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c19982af2c067044$export$3e51e8f1440314ba = '#EBECF0';
var $c19982af2c067044$export$1ce2d1575d444ceb = '#DFE1E6';
var $c19982af2c067044$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c19982af2c067044$export$c2e91cbeada39b8b = '#B3BAC5';
var $c19982af2c067044$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c19982af2c067044$export$eaa8c8a70ac22806 = '#97A0AF';
var $c19982af2c067044$export$7c87d337fb91a97d = '#8993A4';
var $c19982af2c067044$export$d6447c357493214f = '#7A869A';
var $c19982af2c067044$export$f563ee71e9ee74cd = '#6B778C';
var $c19982af2c067044$export$e2ef2124cf4024b1 = '#5E6C84';
var $c19982af2c067044$export$eece5f492e429f08 = '#505F79';
var $c19982af2c067044$export$c39c0fe0f26207ae = '#42526E';
var $c19982af2c067044$export$7090862dc3038a9f = '#344563';
var $c19982af2c067044$export$ad0bacf983b7ddaa = '#253858';
var $c19982af2c067044$export$7d61b15e0da132af = '#172B4D';
var $c19982af2c067044$export$fbda843f0a27fe96 = '#091E42';
var $c19982af2c067044$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c19982af2c067044$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c19982af2c067044$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c19982af2c067044$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c19982af2c067044$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c19982af2c067044$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c19982af2c067044$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c19982af2c067044$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c19982af2c067044$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c19982af2c067044$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c19982af2c067044$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c19982af2c067044$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c19982af2c067044$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c19982af2c067044$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c19982af2c067044$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c19982af2c067044$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c19982af2c067044$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c19982af2c067044$export$2f6319cf7d736c2a = '#E6EDFA';
var $c19982af2c067044$export$95126bc8884d6634 = '#DCE5F5';
var $c19982af2c067044$export$8338d8c35d44ff1 = '#CED9EB';
var $c19982af2c067044$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c19982af2c067044$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c19982af2c067044$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c19982af2c067044$export$97e81faa16a182c7 = '#8C9CB8';
var $c19982af2c067044$export$bfe21c59123ecf33 = '#7988A3';
var $c19982af2c067044$export$ee82aa2ea6a1558 = '#67758F';
var $c19982af2c067044$export$682927c6ed76be02 = '#56637A';
var $c19982af2c067044$export$91fd9994c5be9757 = '#455166';
var $c19982af2c067044$export$d281fbfe3cff2df6 = '#3B475C';
var $c19982af2c067044$export$3902c91d8b98a753 = '#313D52';
var $c19982af2c067044$export$8e8133c1ba5845b5 = '#283447';
var $c19982af2c067044$export$33ff357f6620b39 = '#202B3D';
var $c19982af2c067044$export$633847cf062b69e0 = '#1B2638';
var $c19982af2c067044$export$9776a6e503bdbf76 = '#121A29';
var $c19982af2c067044$export$6c813d5160dff5db = '#0E1624';
var $c19982af2c067044$export$3d4f271a500072a = '#0D1424';
var $c19982af2c067044$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c19982af2c067044$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c19982af2c067044$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c19982af2c067044$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c19982af2c067044$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c19982af2c067044$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c19982af2c067044$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c19982af2c067044$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c19982af2c067044$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c19982af2c067044$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c19982af2c067044$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c19982af2c067044$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c19982af2c067044$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c19982af2c067044$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c19982af2c067044$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c19982af2c067044$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c19982af2c067044$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c19982af2c067044$export$d2adc5dedf09fced = '#292A2E';
var $c19982af2c067044$export$f51762073d2bb381 = '#94C748';
var $c19982af2c067044$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("lVuW2", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ff66eae64d8e2911$export$6503ec6e8aabbaf; });
/* eslint-disable @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop */ /**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every app.
 *
 * We can reconsider this choice in the future.
 */ 
var $k6Bkl = parcelRequire("k6Bkl");
var $ff66eae64d8e2911$var$registrations = new Set();
var $ff66eae64d8e2911$var$cleanupEndEventListeners = null;
function $ff66eae64d8e2911$var$onDragStart() {
    if ($ff66eae64d8e2911$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $ff66eae64d8e2911$var$cleanupEndEventListeners = (0, $k6Bkl.bindAll)(window, [
        {
            type: 'dragend',
            listener: $ff66eae64d8e2911$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $ff66eae64d8e2911$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $ff66eae64d8e2911$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($ff66eae64d8e2911$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $ff66eae64d8e2911$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $ff66eae64d8e2911$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $ff66eae64d8e2911$var$cleanupEndEventListeners = null;
    var clone = Array.from($ff66eae64d8e2911$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $ff66eae64d8e2911$var$bindStartEvents() {
    return (0, $k6Bkl.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $ff66eae64d8e2911$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $ff66eae64d8e2911$var$onDragStart
        }
    ]);
}
var $ff66eae64d8e2911$var$cleanupStartEventListeners = null;
function $ff66eae64d8e2911$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$ff66eae64d8e2911$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $ff66eae64d8e2911$var$cleanupStartEventListeners = $ff66eae64d8e2911$var$bindStartEvents();
    $ff66eae64d8e2911$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $ff66eae64d8e2911$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $ff66eae64d8e2911$var$registrations.delete(registration);
        if ($ff66eae64d8e2911$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $ff66eae64d8e2911$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $ff66eae64d8e2911$var$cleanupStartEventListeners = null;
        }
    };
}

});

parcelRegister("2a45H", function(module, exports) {

$parcel$export(module.exports, "show", function () { return $192fb05548d32981$export$57bf213be019eeb0; });

var $h0ev8 = parcelRequire("h0ev8");
// This file is a singleton for managing tooltips
var $192fb05548d32981$var$active = null;
function $192fb05548d32981$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($192fb05548d32981$var$active && $192fb05548d32981$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $h0ev8.clearScheduled)();
            $192fb05548d32981$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $h0ev8.clearScheduled)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $h0ev8.clearScheduled)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $h0ev8.scheduleTimeout)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($192fb05548d32981$var$active && $192fb05548d32981$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($192fb05548d32981$var$active) {
            (0, $h0ev8.clearScheduled)();
            $192fb05548d32981$var$active.entry.hide({
                isImmediate: true
            });
            $192fb05548d32981$var$active.entry.done();
            $192fb05548d32981$var$active = null;
        }
        // this tooltip is now the active tooltip
        $192fb05548d32981$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $h0ev8.scheduleTimeout)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}

});
parcelRegister("h0ev8", function(module, exports) {

$parcel$export(module.exports, "clearScheduled", function () { return $c60daf5e18d1c53a$export$eaf678f6f93f5250; });
$parcel$export(module.exports, "scheduleTimeout", function () { return $c60daf5e18d1c53a$export$5f4d6617421d489b; });
var $c60daf5e18d1c53a$var$delayId = null;
function $c60daf5e18d1c53a$export$eaf678f6f93f5250() {
    if ($c60daf5e18d1c53a$var$delayId != null) {
        window.clearTimeout($c60daf5e18d1c53a$var$delayId);
        $c60daf5e18d1c53a$var$delayId = null;
    }
}
function $c60daf5e18d1c53a$export$5f4d6617421d489b(fn, delay) {
    $c60daf5e18d1c53a$export$eaf678f6f93f5250();
    $c60daf5e18d1c53a$var$delayId = window.setTimeout(function() {
        $c60daf5e18d1c53a$var$delayId = null;
        fn();
    }, delay);
}

});


parcelRegister("4CAn8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35d6ecc26f0e87e5$export$2e2bcd8739ae039; });

var $iNlvH = parcelRequire("iNlvH");
function $35d6ecc26f0e87e5$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $iNlvH.useIdSeed)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}

});
parcelRegister("iNlvH", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $daed7d1a3eb51120$export$f680877a34711e37; });
$parcel$export(module.exports, "useIdSeed", function () { return $daed7d1a3eb51120$export$6ee17796e3d70de2; });

var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $6LGXo = parcelRequire("6LGXo");

var $i2LcI = parcelRequire("i2LcI");
var $daed7d1a3eb51120$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $daed7d1a3eb51120$var$react18UseId = ($daed7d1a3eb51120$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useId) !== null && $daed7d1a3eb51120$var$_React$useId !== void 0 ? $daed7d1a3eb51120$var$_React$useId : undefined;
function $daed7d1a3eb51120$export$f680877a34711e37() {
    if ($daed7d1a3eb51120$var$react18UseId && (0, $i2LcI.fg)('platform-dst-react-18-use-id')) return $daed7d1a3eb51120$var$react18UseId();
    return "uid".concat((0, $6LGXo.useUID)());
}
var $daed7d1a3eb51120$export$6be90bcb437e928f = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($daed7d1a3eb51120$export$f680877a34711e37()).concat(postfix);
    (0, $8ZuGG.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $daed7d1a3eb51120$export$6ee17796e3d70de2() {
    if ($daed7d1a3eb51120$var$react18UseId && (0, $i2LcI.fg)('platform-dst-react-18-use-id')) {
        var uid = $daed7d1a3eb51120$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6LGXo.useUIDSeed)();
}

});
parcelRegister("6LGXo", function(module, exports) {

$parcel$export(module.exports, "useUID", function () { return $4ed874380ae278f3$export$87d05f07e65211f1; });
$parcel$export(module.exports, "useUIDSeed", function () { return $4ed874380ae278f3$export$bb5ca5fba6fb4f1f; });

var $8ZuGG = parcelRequire("8ZuGG");

var $inFr0 = parcelRequire("inFr0");
var $4ed874380ae278f3$var$generateUID = function(context) {
    var quartz = context || (0, $inFr0.counter);
    var prefix = (0, $inFr0.getPrefix)(quartz);
    var id = (0, $inFr0.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $4ed874380ae278f3$var$useUIDState = function() {
    var context = (0, $8ZuGG.useContext)((0, $inFr0.source));
    var uid = (0, $8ZuGG.useState)(function() {
        return $4ed874380ae278f3$var$generateUID(context);
    })[0];
    return uid;
};
var $4ed874380ae278f3$export$87d05f07e65211f1 = function() {
    var uid = $4ed874380ae278f3$var$useUIDState().uid;
    return uid;
};
var $4ed874380ae278f3$export$bb5ca5fba6fb4f1f = function() {
    var gen = $4ed874380ae278f3$var$useUIDState().gen;
    return gen;
};

});
parcelRegister("inFr0", function(module, exports) {

$parcel$export(module.exports, "counter", function () { return $d61a83ffb8a00065$export$e575061ef2a070eb; });
$parcel$export(module.exports, "source", function () { return $d61a83ffb8a00065$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "getId", function () { return $d61a83ffb8a00065$export$218c8c3169c024d2; });
$parcel$export(module.exports, "getPrefix", function () { return $d61a83ffb8a00065$export$36e24695f02d4503; });

var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");
var $d61a83ffb8a00065$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $ihgai.generateUID)()
    };
};
var $d61a83ffb8a00065$export$e575061ef2a070eb = $d61a83ffb8a00065$export$1921362e86c73c88();
var $d61a83ffb8a00065$export$b4d5da5f34fb77ad = $8ZuGG.createContext($d61a83ffb8a00065$export$1921362e86c73c88());
var $d61a83ffb8a00065$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $d61a83ffb8a00065$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};

});
parcelRegister("ihgai", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $d4e65a8e39796d95$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $d4e65a8e39796d95$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $d4e65a8e39796d95$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $d4e65a8e39796d95$export$e2a22331486dcca0 = $d4e65a8e39796d95$export$bdbb4cbb3078e58d();

});





parcelRegister("lyndE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0ec8cd10fdb3e1$export$2e2bcd8739ae039; });
/* tooltip-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $gCwDs = parcelRequire("gCwDs");

var $ikuFE = parcelRequire("ikuFE");
function $fb0ec8cd10fdb3e1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb0ec8cd10fdb3e1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb0ec8cd10fdb3e1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb0ec8cd10fdb3e1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fb0ec8cd10fdb3e1$var$baseStyles = null;
var $fb0ec8cd10fdb3e1$var$truncateStyles = null;
/**
 * Used as the default tooltip container component for the exported `Tooltip` component.
 * Adds some styles to the tooltip primitive.
 */ var $fb0ec8cd10fdb3e1$var$TooltipContainer = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $ikuFE.default), {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c4hjl.default)([
            "_2rkofajl _11c8dcr7 _vchhusvi _p12fp3fh _bfhkpioe _syaz1i9p _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna",
            truncate && "_1reo15vq _18m915vq _p12f1pna _1bto1l2s _o5721q9c",
            className
        ]),
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        style: $fb0ec8cd10fdb3e1$var$_objectSpread($fb0ec8cd10fdb3e1$var$_objectSpread({}, style), {}, {
            "--_yr7xfv": (0, $bT1Ur.default)("var(--ds-background-neutral-bold, ".concat((0, $gCwDs.N800), ")")),
            "--_ywovvi": (0, $bT1Ur.default)("var(--ds-text-inverse, ".concat((0, $gCwDs.N0), ")"))
        })
    }, children);
});
$fb0ec8cd10fdb3e1$var$TooltipContainer.displayName = 'TooltipContainer';
var $fb0ec8cd10fdb3e1$export$2e2bcd8739ae039 = $fb0ec8cd10fdb3e1$var$TooltipContainer;

});
parcelRegister("ikuFE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d581e2d6312c59b1$export$2e2bcd8739ae039; });
/* tooltip-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $d581e2d6312c59b1$var$primitiveStyles = null;
/**
 * The lower level component for rendering a tooltip.
 */ var $d581e2d6312c59b1$var$TooltipPrimitive = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        ref: ref,
        style: style,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        role: "tooltip",
        className: (0, $c4hjl.default)([
            "_80om73ad",
            className
        ]),
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$d581e2d6312c59b1$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $d581e2d6312c59b1$export$2e2bcd8739ae039 = $d581e2d6312c59b1$var$TooltipPrimitive;

});


parcelRegister("gluu2", function(module, exports) {

$parcel$export(module.exports, "getMousePosition", function () { return $be6640e050308039$export$642213d516a9b928; });
function $be6640e050308039$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}

});


parcelRegister("4lDUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32a815a6592ecc61$export$2e2bcd8739ae039; });
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $4vuwT = parcelRequire("4vuwT");

var $1Muvn = parcelRequire("1Muvn");

var $bJl4r = parcelRequire("bJl4r");

var $5AVd4 = parcelRequire("5AVd4");

var $2fda0 = parcelRequire("2fda0");

var $dBxAn = parcelRequire("dBxAn");
var $32a815a6592ecc61$var$_excluded = [
    "children",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss",
    "tabIndex"
], $32a815a6592ecc61$var$_excluded2 = [
    "className"
];
var $32a815a6592ecc61$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $32a815a6592ecc61$var$Pressable = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5AVd4.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, tabIndex = _ref.tabIndex, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $32a815a6592ecc61$var$_excluded);
    var interactionContext = (0, $8ZuGG.useContext)((0, $2fda0.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $32a815a6592ecc61$var$_excluded2);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $dBxAn.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        as: "button",
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : (0, $bJl4r.isSafari)() && !isDisabled ? 0 : undefined,
        style: style
    }, safeHtmlAttributes, {
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $4vuwT.cx)($32a815a6592ecc61$var$styles.root, isDisabled && $32a815a6592ecc61$var$styles.disabled, xcss),
        testId: testId,
        ref: ref
    }), children);
});
var $32a815a6592ecc61$export$2e2bcd8739ae039 = $32a815a6592ecc61$var$Pressable;

});
parcelRegister("bJl4r", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $88a43de2e78de33d$export$95df08bae54cb4df; });
$parcel$export(module.exports, "isAppleDevice", function () { return $88a43de2e78de33d$export$e1865c3bedcd822b; });
function $88a43de2e78de33d$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? //@ts-expect-error ignore userAgentData type issue
    re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $88a43de2e78de33d$var$isIPhone() {
    return $88a43de2e78de33d$var$testPlatform(/^iPhone/i);
}
function $88a43de2e78de33d$var$isMac() {
    return $88a43de2e78de33d$var$testPlatform(/^Mac/i);
}
function $88a43de2e78de33d$var$isIPad() {
    return $88a43de2e78de33d$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $88a43de2e78de33d$var$isMac() && navigator.maxTouchPoints > 1;
}
function $88a43de2e78de33d$var$isIOS() {
    return $88a43de2e78de33d$var$isIPhone() || $88a43de2e78de33d$var$isIPad();
}
function $88a43de2e78de33d$export$95df08bae54cb4df() {
    if (typeof window !== 'undefined' && window.navigator != null) {
        var _window$navigator$use2;
        var ua = (_window$navigator$use2 = window.navigator.userAgent) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.toLowerCase();
        return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
    }
    return false;
}
function $88a43de2e78de33d$export$e1865c3bedcd822b() {
    return $88a43de2e78de33d$var$isMac() || $88a43de2e78de33d$var$isIOS();
}

});

parcelRegister("2fda0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a2730dc5600b678$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $1a2730dc5600b678$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("dBxAn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e78c88220e975ef$export$2e2bcd8739ae039; });
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");
var $9e78c88220e975ef$var$_excluded = [
    "as",
    "children",
    "isInset",
    "testId",
    "style",
    "xcss"
], $9e78c88220e975ef$var$_excluded2 = [
    "className"
];
function $9e78c88220e975ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e78c88220e975ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e78c88220e975ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e78c88220e975ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e78c88220e975ef$var$focusRingStyles = null;
var $9e78c88220e975ef$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ var $9e78c88220e975ef$var$Focusable = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'button' : _ref$as, children = _ref.children, isInset = _ref.isInset, testId = _ref.testId, style = _ref.style, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $9e78c88220e975ef$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $9e78c88220e975ef$var$_excluded2);
    return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, safeHtmlAttributes, {
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $c4hjl.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah3115h _2mwq115h",
            xcss
        ]),
        "data-testid": testId,
        style: $9e78c88220e975ef$var$_objectSpread($9e78c88220e975ef$var$_objectSpread({}, style), {}, {
            "--_1203r2w": (0, $bT1Ur.default)("calc(0px - ".concat("var(--ds-border-width-outline, 2px)", ")"))
        })
    }), children);
});
var $9e78c88220e975ef$export$2e2bcd8739ae039 = $9e78c88220e975ef$var$Focusable;

});


parcelRegister("aQG1A", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e5f5be58c466167$var$_react = $7e5f5be58c466167$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7e5f5be58c466167$var$_baseNew = $7e5f5be58c466167$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $7e5f5be58c466167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e5f5be58c466167$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $7e5f5be58c466167$var$_react.default.createElement($7e5f5be58c466167$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$7e5f5be58c466167$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $7e5f5be58c466167$var$_default = module.exports.default = $7e5f5be58c466167$var$ChevronDownIcon;

});

parcelRegister("8mTPQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $617bb08967ade500$var$_react = $617bb08967ade500$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $617bb08967ade500$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $617bb08967ade500$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $617bb08967ade500$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props));
$617bb08967ade500$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $617bb08967ade500$var$_default = module.exports.default = $617bb08967ade500$var$HipchatChevronDownIcon;

});

parcelRegister("kequO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b6f832dcdc2d7a1f91afd5e9b90e10b9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eba9aafdbda505c1$var$_react = $eba9aafdbda505c1$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $eba9aafdbda505c1$var$_baseNew = $eba9aafdbda505c1$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $eba9aafdbda505c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eba9aafdbda505c1$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $eba9aafdbda505c1$var$_react.default.createElement($eba9aafdbda505c1$var$_baseNew.default, Object.assign({
        name: "ChevronUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 9.97-6-6a.75.75 0 0 0-1.004-.052l-.056.052-6 6 1.06 1.06L8 5.56l5.47 5.47z"/>`
    }, props));
$eba9aafdbda505c1$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $eba9aafdbda505c1$var$_default = module.exports.default = $eba9aafdbda505c1$var$ChevronUpIcon;

});

parcelRegister("eHrg6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab3a39ded12b718d$var$_react = $ab3a39ded12b718d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $ab3a39ded12b718d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ab3a39ded12b718d$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $ab3a39ded12b718d$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props));
$ab3a39ded12b718d$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $ab3a39ded12b718d$var$_default = module.exports.default = $ab3a39ded12b718d$var$HipchatChevronUpIcon;

});

parcelRegister("eyzuw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a98fc57e7edd0bc1$var$_react = $a98fc57e7edd0bc1$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $a98fc57e7edd0bc1$var$_baseNew = $a98fc57e7edd0bc1$var$_interopRequireDefault((parcelRequire("eLcgU")));
function $a98fc57e7edd0bc1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a98fc57e7edd0bc1$var$CrossIcon = (props)=>/*#__PURE__*/ $a98fc57e7edd0bc1$var$_react.default.createElement($a98fc57e7edd0bc1$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$a98fc57e7edd0bc1$var$CrossIcon.displayName = 'CrossIcon';
var $a98fc57e7edd0bc1$var$_default = module.exports.default = $a98fc57e7edd0bc1$var$CrossIcon;

});

parcelRegister("lzAm7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb491154278cfc84$var$_react = $fb491154278cfc84$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $drb15 = parcelRequire("drb15");
function $fb491154278cfc84$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb491154278cfc84$var$CrossIcon = (props)=>/*#__PURE__*/ $fb491154278cfc84$var$_react.default.createElement($drb15.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$fb491154278cfc84$var$CrossIcon.displayName = 'CrossIcon';
var $fb491154278cfc84$var$_default = module.exports.default = $fb491154278cfc84$var$CrossIcon;

});

parcelRegister("dlpYS", function(module, exports) {

$parcel$export(module.exports, "IconFacade", function () { return $9b7163c90cd74bc3$export$3cfb73f70dfca966; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");

var $k71RP = parcelRequire("k71RP");
var $9b7163c90cd74bc3$var$_excluded = [
    "dangerouslySetGlyph",
    "size"
];
var $9b7163c90cd74bc3$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
var $9b7163c90cd74bc3$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $8ZuGG.memo)(function IconFacade(_ref) {
    var dangerouslySetGlyph = _ref.dangerouslySetGlyph, size = _ref.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $9b7163c90cd74bc3$var$_excluded);
    var NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    var iconSize = size !== null && size !== void 0 ? size : 'medium';
    var useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $i2LcI.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (iconSize === 'small' || iconSize === 'medium') && !(0, $i2LcI.fg)('platform-visual-refresh-icons-facade-removal')) {
        if (props.iconType === 'utility') {
            var Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Icon, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, {
                spacing: (0, $i2LcI.fg)('platform-visual-refresh-icons-facade-button-fix') ? $9b7163c90cd74bc3$var$sizeSpacingMap['utility'][iconSize] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        } else {
            var _Icon = NewIcon;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(_Icon, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, {
                size: iconSize,
                spacing: $9b7163c90cd74bc3$var$sizeSpacingMap['core'][iconSize],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $k71RP.Icon), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        dangerouslySetGlyph: dangerouslySetGlyph,
        size: size
    }, props));
});

});
parcelRegister("k71RP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ea45e8e592f86faf$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $ea45e8e592f86faf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea45e8e592f86faf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea45e8e592f86faf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea45e8e592f86faf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ea45e8e592f86faf$var$iconStyles = null;
var $ea45e8e592f86faf$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $ea45e8e592f86faf$var$baseHcmStyles = null;
var $ea45e8e592f86faf$var$primaryEqualsSecondaryHcmStyles = null;
var $ea45e8e592f86faf$var$secondaryTransparentHcmStyles = null;
var $ea45e8e592f86faf$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $ea45e8e592f86faf$var$_objectSpread($ea45e8e592f86faf$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $ea45e8e592f86faf$var$sizeStyles[size]
        ])
    }));
});
var $ea45e8e592f86faf$export$2e2bcd8739ae039 = $ea45e8e592f86faf$export$f04a61298a47a40f;

});


parcelRegister("gYYrH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8cc756abdbbefcea85e2842ee2eda39e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c5d1232edb3ac506$var$_react = $c5d1232edb3ac506$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $c5d1232edb3ac506$var$_baseNew = $c5d1232edb3ac506$var$_interopRequireDefault((parcelRequire("d9We0")));
function $c5d1232edb3ac506$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c5d1232edb3ac506$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $c5d1232edb3ac506$var$_react.default.createElement($c5d1232edb3ac506$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$c5d1232edb3ac506$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $c5d1232edb3ac506$var$_default = module.exports.default = $c5d1232edb3ac506$var$StatusSuccessIcon;

});
parcelRegister("d9We0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("9ou0s")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("9ou0s")).Icon; });

var $9ou0s = parcelRequire("9ou0s");

});
parcelRegister("9ou0s", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $6d6da196b19e253b$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $6d6da196b19e253b$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $6d6da196b19e253b$var$svgStyles = null;
var $6d6da196b19e253b$var$iconStyles = null;
var $6d6da196b19e253b$var$utilityIconStyles = null;
var $6d6da196b19e253b$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $6d6da196b19e253b$var$baseHcmStyles = null;
var $6d6da196b19e253b$var$scaleSize = null;
var $6d6da196b19e253b$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6d6da196b19e253b$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6d6da196b19e253b$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $6d6da196b19e253b$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $6d6da196b19e253b$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $6d6da196b19e253b$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'size' in props && props.size !== undefined && // This prevents invalid sizes being passed in, which is required
    // for handling unsupported legacy icon sizes which can
    // cause errors.
    (props.size === 'small' || props.size === 'medium') ? props.size : 'medium';
    var baseSize = $6d6da196b19e253b$var$baseSizeMap[type];
    var viewBoxPadding = $6d6da196b19e253b$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $6d6da196b19e253b$var$utilSizes[spacing] : size === 'small' ? $6d6da196b19e253b$var$coreSizeSmall[spacing] : $6d6da196b19e253b$var$coreSizeMedium[spacing]
        ])
    }));
});
var $6d6da196b19e253b$export$2e2bcd8739ae039 = $6d6da196b19e253b$export$f04a61298a47a40f;

});



parcelRegister("7lAAA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5596e0610de8ab1f$var$_react = $5596e0610de8ab1f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $5596e0610de8ab1f$var$_statusError = $5596e0610de8ab1f$var$_interopRequireDefault((parcelRequire("kxv8y")));
function $5596e0610de8ab1f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5596e0610de8ab1f$var$ErrorIcon = (props)=>/*#__PURE__*/ $5596e0610de8ab1f$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $5596e0610de8ab1f$var$_statusError.default
    }));
$5596e0610de8ab1f$var$ErrorIcon.displayName = 'ErrorIcon';
var $5596e0610de8ab1f$var$_default = module.exports.default = $5596e0610de8ab1f$var$ErrorIcon;

});
parcelRegister("kxv8y", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f99ea99a006a4f29d6a537b27790dcf5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef3f0ae03502c991$var$_react = $ef3f0ae03502c991$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $ef3f0ae03502c991$var$_baseNew = $ef3f0ae03502c991$var$_interopRequireDefault((parcelRequire("d9We0")));
function $ef3f0ae03502c991$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef3f0ae03502c991$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $ef3f0ae03502c991$var$_react.default.createElement($ef3f0ae03502c991$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$ef3f0ae03502c991$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $ef3f0ae03502c991$var$_default = module.exports.default = $ef3f0ae03502c991$var$StatusErrorIcon;

});


parcelRegister("3wlJ5", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7GeoT")).then(()=>parcelRequire('89s2O'));

});

parcelRegister("78gHK", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gxhbY")).then(()=>parcelRequire('1Ix2R'));

});

parcelRegister("kNf8F", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1gsC9")).then(()=>parcelRequire('hL11L'));

});

parcelRegister("b86ZF", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1b58t")).then(()=>parcelRequire('d3VRQ'));

});

parcelRegister("8WKkQ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("iAwwt")).then(()=>parcelRequire('9N9Ys'));

});

parcelRegister("h6W4e", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fJ1OD")).then(()=>parcelRequire('pAsnm'));

});

parcelRegister("lm9T8", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gRQp7")).then(()=>parcelRequire('aiiz9'));

});

parcelRegister("l8RSV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5Ycje")).then(()=>parcelRequire('ghg9H'));

});

parcelRegister("iPFs9", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ldkNR")).then(()=>parcelRequire('9mUVE'));

});

parcelRegister("eU26f", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2LWIJ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1xGEb"))
]).then(()=>parcelRequire('f1MY9'));

});

parcelRegister("9nSYJ", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("59bCS")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2LWIJ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("jQoZC"))
]).then(()=>parcelRequire('aJ3om'));

});

parcelRegister("aRu6s", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("59bCS")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2LWIJ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("bRVWW"))
]).then(()=>parcelRequire('8xCdd'));

});

parcelRegister("7mFlE", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("59bCS")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2LWIJ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2GE3c"))
]).then(()=>parcelRequire('fQlcd'));

});

parcelRegister("3MEVA", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2QftC")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("59bCS")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2LWIJ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("d7q9g"))
]).then(()=>parcelRequire('eHaka'));

});

parcelRegister("k57v9", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hn1ai")).then(()=>parcelRequire('dqtvQ'));

});

parcelRegister("ewjgJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2QftC")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hGrAk"))
]).then(()=>parcelRequire('aMT1C'));

});

parcelRegister("zMfzK", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("Ou8I6")).then(()=>parcelRequire('7VpeL'));

});

parcelRegister("3lCKO", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hIuXM")).then(()=>parcelRequire('WiklM'));

});

parcelRegister("bjXav", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hExuV")).then(()=>parcelRequire('nInul'));

});

parcelRegister("eIShq", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("3q3uM")).then(()=>parcelRequire('cqhyt'));

});

parcelRegister("7YVtY", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("i6HCB")).then(()=>parcelRequire('8GH1V'));

});

parcelRegister("agqas", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("kQdzn")).then(()=>parcelRequire('8UYrY'));

});

parcelRegister("4knI7", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4aatB")).then(()=>parcelRequire('4aVut'));

});

parcelRegister("4LoG9", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fzp2b")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("6Bi4f")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4KusB"))
]).then(()=>parcelRequire('6BYEn'));

});

parcelRegister("8xW40", function(module, exports) {

$parcel$export(module.exports, "useGlobalPageState", function () { return $2ca216e8880b2fc2$export$c0c5e20150fdb34a; });
$parcel$export(module.exports, "fetchFast5GlobalPageState", function () { return $2ca216e8880b2fc2$export$ad35c91c010f31a8; });
$parcel$export(module.exports, "isRedirect", function () { return $2ca216e8880b2fc2$export$4cb830d4f7e56898; });
$parcel$export(module.exports, "fetchPageState", function () { return $2ca216e8880b2fc2$export$8d3833b13cc689f5; });
$parcel$export(module.exports, "usePageStateLoader", function () { return $2ca216e8880b2fc2$export$b176e7ce17921f38; });

var $kOqgB = parcelRequire("kOqgB");

var $lJ1Bt = parcelRequire("lJ1Bt");

var $5WDNl = parcelRequire("5WDNl");parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $82mu7 = parcelRequire("82mu7");

var $8ZuGG = parcelRequire("8ZuGG");

var $jtt5y = parcelRequire("jtt5y");

var $1ddmc = parcelRequire("1ddmc");

var $8f2pb = parcelRequire("8f2pb");

var $bt8eu = parcelRequire("bt8eu");

var $1uBrV = parcelRequire("1uBrV");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $9NVnN = parcelRequire("9NVnN");

var $7AZRg = parcelRequire("7AZRg");
const $2ca216e8880b2fc2$var$SAS_FAST_FIVE_FETCH_HEADER = 'sas-fast-five-fetch';
const $2ca216e8880b2fc2$var$EXCLUDED_PATHS = {
    existingSasMilestone2StateRoutes: [
        '/login',
        '/signup/welcome',
        '/signup/verify-email/otp/'
    ],
    previousReduxStore: [
        '/2step/enrollment/',
        '/signup/welcome/p/loom-create-workspace'
    ]
};
const $2ca216e8880b2fc2$export$c0c5e20150fdb34a = ()=>{
    const location = (0, $5WDNl.useLocation)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8ZuGG.useEffect)(()=>{
        const fetchData = async ()=>{
            if (await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return;
            // For non-bifrost pages (i.e. injected state from sign-in-service), use the existing non-sas
            // behaviour. This could mean we may have old injected state which doesn't get
            // refreshed from here on page navigation, but that matches existing behaviour
            const hasInjectedServerState = !(0, $jtt5y.default)();
            if (hasInjectedServerState) return;
            const alreadyFetchesStateSpecificToRoute = (0, $1uBrV.isSasStateEndpointEnabled)() && $2ca216e8880b2fc2$var$EXCLUDED_PATHS.existingSasMilestone2StateRoutes.some((path)=>location.pathname === path);
            const requiresStateFromPreviousReduxStore = $2ca216e8880b2fc2$var$EXCLUDED_PATHS.previousReduxStore.some((path)=>location.pathname.startsWith(path));
            if (requiresStateFromPreviousReduxStore || alreadyFetchesStateSpecificToRoute) return;
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: true
            });
            try {
                const url = location.pathname + location.search;
                const data = await $2ca216e8880b2fc2$export$ad35c91c010f31a8(url);
                if ($2ca216e8880b2fc2$export$4cb830d4f7e56898(data)) {
                    navigate(data.redirectTo);
                    return;
                }
                const fullState = await (0, $82mu7.buildInitialState)(data);
                dispatch((0, $lJ1Bt.resetAppState)(fullState.initialStoreState));
            } catch (error) {
                let errorType = {
                    type: 'internal_server_error'
                };
                if (error instanceof (0, $1ddmc.ServerErrorException)) {
                    errorType = error.errorType;
                    (0, $8f2pb.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
                } else (0, $8f2pb.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
                dispatch((0, $bt8eu.setServerError)(errorType));
            }
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: false
            });
        };
        fetchData();
    // re-fetch whenever we change page, i.e. the fixed route
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
};
const $2ca216e8880b2fc2$export$4cb830d4f7e56898 = (data)=>Boolean(data && 'redirectTo' in data);
const $2ca216e8880b2fc2$export$ad35c91c010f31a8 = async (fullPageUrl)=>{
    const headers = {
        [$2ca216e8880b2fc2$var$SAS_FAST_FIVE_FETCH_HEADER]: 'true'
    };
    const response = await (0, $1ddmc.fetchApi)(fullPageUrl, headers);
    const data = await response.json();
    return data;
};
const $2ca216e8880b2fc2$export$8d3833b13cc689f5 = async (restStateEndpoint, request, tags)=>{
    const url = new URL(request.url);
    const queryParams = url.searchParams.size > 0 ? `?${url.searchParams.toString()}` : '';
    const response = await (0, $1ddmc.fetchApi)(restStateEndpoint + queryParams);
    if (response.status === 404 || response.status >= 500) (0, $8f2pb.captureTaggedException)('Error fetching page state', {
        capabilities: tags.capabilities,
        extraProperties: {
            restStateEndpoint: restStateEndpoint,
            responseStatus: response.status
        }
    });
    return await response.json();
};
const $2ca216e8880b2fc2$export$b176e7ce17921f38 = (opts)=>{
    const location = (0, $5WDNl.useLocation)();
    const previousLocation = (0, $7AZRg.usePrevious)(location.pathname);
    const data = (0, $5WDNl.useLoaderData)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    (0, $8ZuGG.useLayoutEffect)(()=>{
        if (previousLocation === location.pathname) // Component re-renders can cause this hook to reset the Redux app state unnecessarily.
        // This condition ensures we only ever fetch state and reset Redux when only the pathname
        // and not the search, nor other route states, changes.
        return;
        // No data should mean Feature Gate is disabled and useGlobalPageState is handling the state
        if (!data) // If Feature Gate is enabled but there is no data, we should log to Sentry?
        // TODO: throw descriptive error here for handling in fine-grained error boundaries KIRBY-9124
        return;
        if ($2ca216e8880b2fc2$export$4cb830d4f7e56898(data)) {
            if (opts === null || opts === void 0 ? void 0 : opts.skipRedirect) return;
            window.location.assign(data.redirectTo);
            dispatch({
                type: 'SET_GLOBAL_STATE_LOADING',
                isLoading: true
            });
            return;
        }
        (0, $82mu7.buildInitialState)(data).then((fullState)=>{
            dispatch((0, $lJ1Bt.resetAppState)(fullState.initialStoreState));
        }).catch((error)=>{
            let errorType = {
                type: 'internal_server_error'
            };
            if (error instanceof (0, $1ddmc.ServerErrorException)) {
                errorType = error.errorType;
                (0, $8f2pb.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
            } else (0, $8f2pb.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
            dispatch((0, $bt8eu.setServerError)(errorType));
        });
    }, [
        data,
        dispatch,
        location.pathname,
        previousLocation,
        opts === null || opts === void 0 ? void 0 : opts.skipRedirect
    ]);
};

});
parcelRegister("1ddmc", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $a1c35d651506ef1d$export$adb4bb4243526aef; });
$parcel$export(module.exports, "ServerErrorException", function () { return $a1c35d651506ef1d$export$173e0be89ecf9709; });

var $ty6PY = parcelRequire("ty6PY");

var $8f2pb = parcelRequire("8f2pb");
const $a1c35d651506ef1d$export$adb4bb4243526aef = async (url, headers)=>{
    const response = await fetch(url, {
        headers: (0, $ty6PY._)({
            'Content-Type': 'application/json'
        }, headers)
    });
    if (response.status >= 500) {
        const data = await response.json();
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const errorType = (data === null || data === void 0 ? void 0 : data.error) || {
            error: 'internal_server_error'
        };
        (0, $8f2pb.captureErrorMessage)(message, data);
        throw new $a1c35d651506ef1d$export$173e0be89ecf9709(message, response.status, errorType);
    }
    return response;
};
class $a1c35d651506ef1d$export$173e0be89ecf9709 extends Error {
    constructor(message, status, errorType){
        super(message), this.message = message, this.status = status, this.errorType = errorType;
        this.name = 'ServerErrorException';
    }
}

});

parcelRegister("bt8eu", function(module, exports) {

$parcel$export(module.exports, "setServerError", function () { return $2c333acc9661c15e$export$222f8d3ac9d63890; });
const $2c333acc9661c15e$export$222f8d3ac9d63890 = (error)=>({
        type: 'SERVER_ERROR_UPDATE',
        error: error
    });

});

parcelRegister("1uBrV", function(module, exports) {

$parcel$export(module.exports, "isSasStateEndpointEnabled", function () { return $d92a283854d1de0e$export$ae2c1d86ed68b3d4; });
$parcel$export(module.exports, "usePageState", function () { return $d92a283854d1de0e$export$d2bdb7c20492cc5; });
$parcel$export(module.exports, "isPageStateResult", function () { return $d92a283854d1de0e$export$e76aa5e66969f2de; });
$parcel$export(module.exports, "isRedirectResult", function () { return $d92a283854d1de0e$export$72263c6e24ee9e46; });

var $kvYHH = parcelRequire("kvYHH");

var $1ddmc = parcelRequire("1ddmc");

var $lk8Tl = parcelRequire("lk8Tl");

var $gyRZh = parcelRequire("gyRZh");

var $kOqgB = parcelRequire("kOqgB");

var $8ZuGG = parcelRequire("8ZuGG");

var $imnta = parcelRequire("imnta");
const $d92a283854d1de0e$export$ae2c1d86ed68b3d4 = ()=>false;
const $d92a283854d1de0e$export$d2bdb7c20492cc5 = (path, options = {
    enabled: true
})=>{
    const { enabled: enabled } = options;
    const [searchParams] = (0, $gyRZh.useSearchParams)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { data: data, isLoading: isLoading, isError: isError, isSuccess: isSuccess, error: error } = (0, $kvYHH.useQuery)({
        queryKey: [
            path
        ],
        refetchOnWindowFocus: false,
        queryFn: async ()=>{
            const params = searchParams.size > 0 ? `?${searchParams.toString()}` : '';
            const response = await (0, $1ddmc.fetchApi)(`${(0, $lk8Tl.idacOrigin)}${path}${params}`);
            return await response.json();
        },
        enabled: enabled
    });
    (0, $8ZuGG.useEffect)(()=>{
        if ($d92a283854d1de0e$export$e76aa5e66969f2de(data)) {
            const { csrfToken: csrfToken, hashedCsrfToken: hashedCsrfToken } = data;
            if (csrfToken) dispatch((0, $imnta.updateCsrfToken)(csrfToken));
            if (hashedCsrfToken) dispatch((0, $imnta.updateHashedCsrfToken)(hashedCsrfToken));
        }
    }, [
        isSuccess,
        data,
        dispatch
    ]);
    return {
        state: data,
        isLoading: isLoading,
        isError: isError,
        isSuccess: isSuccess,
        error: error
    };
};
const $d92a283854d1de0e$export$72263c6e24ee9e46 = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === 'redirect';
};
const $d92a283854d1de0e$export$e76aa5e66969f2de = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === 'page-state';
};

});
parcelRegister("kvYHH", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $eef5ca6b7ea14356$export$dd0a697e1782aedd; });

var $eyuWU = parcelRequire("eyuWU");
var $koVIV = parcelRequire("koVIV");

var $i8LmD = parcelRequire("i8LmD");
'use client';
function $eef5ca6b7ea14356$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $i8LmD.useBaseQuery)(parsedOptions, (0, $koVIV.QueryObserver));
}

});
parcelRegister("eyuWU", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $a98c3f89471fbd4b$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $a98c3f89471fbd4b$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $a98c3f89471fbd4b$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $a98c3f89471fbd4b$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $a98c3f89471fbd4b$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $a98c3f89471fbd4b$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseMutationArgs", function () { return $a98c3f89471fbd4b$export$b646c531ea475334; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $a98c3f89471fbd4b$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $a98c3f89471fbd4b$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $a98c3f89471fbd4b$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $a98c3f89471fbd4b$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $a98c3f89471fbd4b$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $a98c3f89471fbd4b$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $a98c3f89471fbd4b$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $a98c3f89471fbd4b$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $a98c3f89471fbd4b$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $a98c3f89471fbd4b$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $a98c3f89471fbd4b$export$17619bac5b909b23; });
// TYPES
// UTILS

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
const $a98c3f89471fbd4b$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $a98c3f89471fbd4b$export$8793edee2d425525() {
    return undefined;
}
function $a98c3f89471fbd4b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $a98c3f89471fbd4b$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $a98c3f89471fbd4b$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $a98c3f89471fbd4b$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $a98c3f89471fbd4b$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $a98c3f89471fbd4b$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $6EnDC._)((0, $ty6PY._)({}, arg3), {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $6EnDC._)((0, $ty6PY._)({}, arg2), {
        queryKey: arg1
    });
}
function $a98c3f89471fbd4b$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $6EnDC._)((0, $ty6PY._)({}, arg3), {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $6EnDC._)((0, $ty6PY._)({}, arg2), {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $6EnDC._)((0, $ty6PY._)({}, arg2), {
        mutationFn: arg1
    });
    return (0, $ty6PY._)({}, arg1);
}
function $a98c3f89471fbd4b$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1) ? [
        (0, $6EnDC._)((0, $ty6PY._)({}, arg2), {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $a98c3f89471fbd4b$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1) ? [
        (0, $6EnDC._)((0, $ty6PY._)({}, arg2), {
            mutationKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $a98c3f89471fbd4b$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $a98c3f89471fbd4b$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$a98c3f89471fbd4b$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $a98c3f89471fbd4b$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($a98c3f89471fbd4b$export$5fcb678681417b54(mutation.options.mutationKey) !== $a98c3f89471fbd4b$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$a98c3f89471fbd4b$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $a98c3f89471fbd4b$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $a98c3f89471fbd4b$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $a98c3f89471fbd4b$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$a98c3f89471fbd4b$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $a98c3f89471fbd4b$export$2f07189bb9fa26a7(a, b) {
    return $a98c3f89471fbd4b$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $a98c3f89471fbd4b$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$a98c3f89471fbd4b$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $a98c3f89471fbd4b$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $a98c3f89471fbd4b$export$7a8558113332b71e(a) && $a98c3f89471fbd4b$export$7a8558113332b71e(b);
    if (array || $a98c3f89471fbd4b$export$53b83ca8eaab0383(a) && $a98c3f89471fbd4b$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $a98c3f89471fbd4b$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $a98c3f89471fbd4b$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a98c3f89471fbd4b$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $a98c3f89471fbd4b$export$53b83ca8eaab0383(o) {
    if (!$a98c3f89471fbd4b$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$a98c3f89471fbd4b$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $a98c3f89471fbd4b$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $a98c3f89471fbd4b$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $a98c3f89471fbd4b$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $a98c3f89471fbd4b$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $a98c3f89471fbd4b$export$4304cb76768ca134(callback) {
    $a98c3f89471fbd4b$export$e772c8ff12451969(0).then(callback);
}
function $a98c3f89471fbd4b$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $a98c3f89471fbd4b$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $a98c3f89471fbd4b$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("koVIV", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $eda2d33ae64a8fec$export$a06cf8c0066f0d4c; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $eyuWU = parcelRequire("eyuWU");

var $7iBIE = parcelRequire("7iBIE");

var $efras = parcelRequire("efras");

var $4QQ45 = parcelRequire("4QQ45");

var $hGQfz = parcelRequire("hGQfz");
class $eda2d33ae64a8fec$export$a06cf8c0066f0d4c extends (0, $4QQ45.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($eda2d33ae64a8fec$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $eda2d33ae64a8fec$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $eda2d33ae64a8fec$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $eyuWU.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $eda2d33ae64a8fec$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($eda2d33ae64a8fec$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch(_param = {}) {
        var { refetchPage: refetchPage } = _param, options = (0, $42tc5._)(_param, [
            "refetchPage"
        ]);
        return this.fetch((0, $6EnDC._)((0, $ty6PY._)({}, options), {
            meta: {
                refetchPage: refetchPage
            }
        }));
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch((0, $6EnDC._)((0, $ty6PY._)({}, fetchOptions), {
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        })).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $eyuWU.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $eyuWU.isServer) || this.currentResult.isStale || !(0, $eyuWU.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $eyuWU.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $eyuWU.isServer) || this.options.enabled === false || !(0, $eyuWU.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $efras.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $eda2d33ae64a8fec$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $eda2d33ae64a8fec$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $hGQfz.canFetch)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $eyuWU.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $eyuWU.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $eda2d33ae64a8fec$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $eyuWU.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify((0, $ty6PY._)({}, defaultNotifyOptions, notifyOptions));
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $hGQfz.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $7iBIE.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $eda2d33ae64a8fec$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $eda2d33ae64a8fec$var$shouldFetchOnMount(query, options) {
    return $eda2d33ae64a8fec$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $eda2d33ae64a8fec$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $eda2d33ae64a8fec$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $eda2d33ae64a8fec$var$isStale(query, options);
    }
    return false;
}
function $eda2d33ae64a8fec$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $eda2d33ae64a8fec$var$isStale(query, options);
}
function $eda2d33ae64a8fec$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $eda2d33ae64a8fec$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $eyuWU.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});
parcelRegister("7iBIE", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $5507791a01626ec5$export$520687f44db6e1ab; });

var $eyuWU = parcelRequire("eyuWU");
function $5507791a01626ec5$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $eyuWU.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $eyuWU.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $5507791a01626ec5$export$520687f44db6e1ab = $5507791a01626ec5$export$316a8efd03cd1458();

});

parcelRegister("efras", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $a5f78a54d3e37753$export$6bf54661be5b02cf; });

var $4QQ45 = parcelRequire("4QQ45");

var $eyuWU = parcelRequire("eyuWU");
class $a5f78a54d3e37753$export$86f1af424b2ca4de extends (0, $4QQ45.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $eyuWU.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
}
const $a5f78a54d3e37753$export$6bf54661be5b02cf = new $a5f78a54d3e37753$export$86f1af424b2ca4de();

});
parcelRegister("4QQ45", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $388467bc05d5b41d$export$d26086b469ecdbcc; });
class $388467bc05d5b41d$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

});


parcelRegister("hGQfz", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $ce0ee3b74b0b248e$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $ce0ee3b74b0b248e$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $ce0ee3b74b0b248e$export$2cbd00fe8a2c8d85; });

var $efras = parcelRequire("efras");

var $gF9Ao = parcelRequire("gF9Ao");

var $eyuWU = parcelRequire("eyuWU");
function $ce0ee3b74b0b248e$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $ce0ee3b74b0b248e$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $gF9Ao.onlineManager).isOnline() : true;
}
class $ce0ee3b74b0b248e$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $ce0ee3b74b0b248e$export$986cc6445c1d323(value) {
    return value instanceof $ce0ee3b74b0b248e$export$a8430ed4188f35a9;
}
function $ce0ee3b74b0b248e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $ce0ee3b74b0b248e$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $efras.focusManager).isFocused() || config.networkMode !== 'always' && !(0, $gF9Ao.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $ce0ee3b74b0b248e$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $eyuWU.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($ce0ee3b74b0b248e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("gF9Ao", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $c217e93a8595470f$export$b113e788b2dd3fdc; });

var $4QQ45 = parcelRequire("4QQ45");

var $eyuWU = parcelRequire("eyuWU");
const $c217e93a8595470f$var$onlineEvents = [
    'online',
    'offline'
];
class $c217e93a8595470f$export$58774fb55d5ff7fc extends (0, $4QQ45.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $eyuWU.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $c217e93a8595470f$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $c217e93a8595470f$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $c217e93a8595470f$export$b113e788b2dd3fdc = new $c217e93a8595470f$export$58774fb55d5ff7fc();

});



parcelRegister("i8LmD", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $d34db6e290374250$export$fff0865807e996c5; });

var $8ZuGG = parcelRequire("8ZuGG");

var $7iBIE = parcelRequire("7iBIE");

var $cxhPV = parcelRequire("cxhPV");

var $5fBdi = parcelRequire("5fBdi");

var $6b5zr = parcelRequire("6b5zr");

var $eqWCb = parcelRequire("eqWCb");

var $2N9lk = parcelRequire("2N9lk");

var $hg7gb = parcelRequire("hg7gb");
'use client';
function $d34db6e290374250$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $6b5zr.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $eqWCb.useIsRestoring)();
    const errorResetBoundary = (0, $5fBdi.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $hg7gb.ensureStaleTime)(defaultedOptions);
    (0, $2N9lk.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2N9lk.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $8ZuGG.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $cxhPV.useSyncExternalStore)($8ZuGG.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $7iBIE.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $8ZuGG.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $hg7gb.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $hg7gb.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2N9lk.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("cxhPV", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $9206670e189bd477$export$306c0aa65ff9ec16; });

var $hU7R8 = parcelRequire("hU7R8");
'use client';
const $9206670e189bd477$export$306c0aa65ff9ec16 = (0, $hU7R8.useSyncExternalStore);

});

parcelRegister("5fBdi", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $3d2b384b20b10766$export$50dfac555130cafd; });

var $8ZuGG = parcelRequire("8ZuGG");
'use client';
function $3d2b384b20b10766$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $3d2b384b20b10766$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $8ZuGG.createContext($3d2b384b20b10766$var$createValue()); // HOOK
const $3d2b384b20b10766$export$50dfac555130cafd = ()=>$8ZuGG.useContext($3d2b384b20b10766$var$QueryErrorResetBoundaryContext); // COMPONENT
const $3d2b384b20b10766$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $8ZuGG.useState(()=>$3d2b384b20b10766$var$createValue());
    return /*#__PURE__*/ $8ZuGG.createElement($3d2b384b20b10766$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};

});

parcelRegister("6b5zr", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $47f8175e7e84905b$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $47f8175e7e84905b$export$45604f0cc8ae667b; });

var $8ZuGG = parcelRequire("8ZuGG");
'use client';
const $47f8175e7e84905b$export$2fba198b5b2e37fa = /*#__PURE__*/ $8ZuGG.createContext(undefined);
const $47f8175e7e84905b$var$QueryClientSharingContext = /*#__PURE__*/ $8ZuGG.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $47f8175e7e84905b$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $47f8175e7e84905b$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $47f8175e7e84905b$export$2fba198b5b2e37fa;
}
const $47f8175e7e84905b$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $8ZuGG.useContext($47f8175e7e84905b$var$getQueryClientContext(context, $8ZuGG.useContext($47f8175e7e84905b$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $47f8175e7e84905b$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $8ZuGG.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $47f8175e7e84905b$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $8ZuGG.createElement($47f8175e7e84905b$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $8ZuGG.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("eqWCb", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $a820f613d277ea97$export$4da0178d6b5f553; });

var $8ZuGG = parcelRequire("8ZuGG");
'use client';
const $a820f613d277ea97$var$IsRestoringContext = /*#__PURE__*/ $8ZuGG.createContext(false);
const $a820f613d277ea97$export$4da0178d6b5f553 = ()=>$8ZuGG.useContext($a820f613d277ea97$var$IsRestoringContext);
const $a820f613d277ea97$export$593807d4e94f9621 = $a820f613d277ea97$var$IsRestoringContext.Provider;

});

parcelRegister("2N9lk", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $208767ad9723015c$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $208767ad9723015c$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $208767ad9723015c$export$1fbcf724762d607; });

var $8ZuGG = parcelRequire("8ZuGG");

var $jYVec = parcelRequire("jYVec");
'use client';
const $208767ad9723015c$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $208767ad9723015c$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $8ZuGG.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $208767ad9723015c$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $jYVec.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("jYVec", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $e8c0033a9931b9e4$export$2072f68e6c3507cf; });
function $e8c0033a9931b9e4$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("hg7gb", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $c9098ffa7e492c22$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $c9098ffa7e492c22$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $c9098ffa7e492c22$export$defdc11a9c9acfcf; });
/**
 * Ensures minimum staleTime and cacheTime values when suspense is enabled.
 * Despite the name, this function guards both staleTime and cacheTime to prevent
 * infinite re-render loops with synchronous queries.
 *
 * @deprecated in v5 - replaced by ensureSuspenseTimers
 */ const $c9098ffa7e492c22$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
        if (typeof defaultedOptions.cacheTime === 'number') defaultedOptions.cacheTime = Math.max(defaultedOptions.cacheTime, 1000);
    }
};
const $c9098ffa7e492c22$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $c9098ffa7e492c22$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $c9098ffa7e492c22$export$e0a3f29513afe430(result, isRestoring);
const $c9098ffa7e492c22$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("imnta", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $2b92f6952af08793$export$527f2c21586e0a0e; });
$parcel$export(module.exports, "updateHashedCsrfToken", function () { return $2b92f6952af08793$export$32d195f109b250f4; });
const $2b92f6952af08793$export$527f2c21586e0a0e = (csrfToken)=>({
        type: 'CSRF_TOKEN_UPDATE',
        csrfToken: csrfToken
    });
const $2b92f6952af08793$export$32d195f109b250f4 = (hashedCsrfToken)=>({
        type: 'HASHED_CSRF_TOKEN_UPDATE',
        hashedCsrfToken: hashedCsrfToken
    });

});


parcelRegister("gjw2g", function(module, exports) {

$parcel$export(module.exports, "AidFrontendFeatureGate", function () { return $f7fc6a0b911c7319$export$e2b0cf8c8e2eb757; });
var $f7fc6a0b911c7319$export$e2b0cf8c8e2eb757 = /*#__PURE__*/ function(AidFrontendFeatureGate) {
    // https://switcheroo.atlassian.com/ui/gates/c2e09b58-639a-4260-89de-4b390ac2b746/key/identity-aid-frontend-sms-enrollment-new-captcha
    // https://hello.atlassian.net/wiki/spaces/I/pages/4492639544/22-11-2025+Current+State+of+UniCAPTCHA+rollout
    AidFrontendFeatureGate["SMS_ENROLLMENT_UNICAPTCHA"] = "identity-aid-frontend-sms-enrollment-new-captcha";
    // !! IMPORTANT !! Make sure to update integration test mocks to use the new endpoints when this is updated/removed/added
    // https://switcheroo.atlassian.com/ui/gates/fc7e9434-0ffa-46ba-9831-43c4cba66cdc/key/id-frontend-use-state-data-loaders
    AidFrontendFeatureGate["USE_STATE_DATA_LOADERS"] = "id-frontend-use-state-data-loaders";
    // https://switcheroo.atlassian.com/ui/gates/e2f249e8-68ad-46fe-8617-c903b90bf375/key/kirby-7873_new_json_endpoint_for_verify-email
    AidFrontendFeatureGate["ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL"] = "kirby-7873_new_json_endpoint_for_verify-email";
    // https://switcheroo.atlassian.com/ui/gates/535b1c04-bb61-421f-9629-44f35bae8fca/key/loom-idac-enable-suggested-workspaces
    AidFrontendFeatureGate["ENABLE_LOOM_SUGGESTED_WORKSPACES"] = "loom-idac-enable-suggested-workspaces";
    // https://switcheroo.atlassian.com/ui/gates/de628605-5ad1-426a-b60e-d46d6f161a8f/key/idzero-7285-passkey-auth
    AidFrontendFeatureGate["ENABLE_PASSKEY_AUTH"] = "idzero-7285-passkey-auth";
    // https://switcheroo.atlassian.com/ui/gates/4ad43fc9-48c7-4c44-94b4-67f9607aea3d/key/id-frontend_replace_email_id_with_testid
    AidFrontendFeatureGate["REPLACE_EMAIL_ID_WITH_TEST_ID"] = "id-frontend_replace_email_id_with_testid";
    // https://switcheroo.atlassian.com/ui/gates/edfa7312-8edf-47da-b61c-eb2592ecf173/key/id-frontend-enable-new-v2-check-username-ic-flow
    AidFrontendFeatureGate["ENABLE_NEW_V2_CHECK_USERNAME_IC_FLOW"] = "id-frontend-enable-new-v2-check-username-ic-flow";
    // https://switcheroo.atlassian.com/ui/gates/5594ad08-15ae-4171-9ab7-2a93ae797488/key/id-frontend_use_new_typography
    AidFrontendFeatureGate["USE_NEW_TYPOGRAPHY"] = "id-frontend-use-new-typography";
    return AidFrontendFeatureGate;
}({});

});

parcelRegister("9NVnN", function(module, exports) {

$parcel$export(module.exports, "useNavigateSoftOrHard", function () { return $d7d585d5a45c81e0$export$51346bfefbea0096; });

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $i7SlW = parcelRequire("i7SlW");

var $fHARP = parcelRequire("fHARP");
const $d7d585d5a45c81e0$var$isToExternalHost = (to)=>{
    try {
        const url = new URL(to);
        return url.hostname !== window.location.hostname;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        return false;
    }
};
// react-router breaks if it is provided with domain information (e.g. https://id.atlassian.com:443)
// so we need to remove it
const $d7d585d5a45c81e0$var$removeDomainInformation = (to)=>{
    let pathname;
    try {
        const url = new URL(to);
        pathname = url.pathname + url.search + url.hash;
    } catch (e) {
        // "to" can also validly be a path without a hostname
        pathname = to;
    }
    return pathname;
};
// this is needed because the parameters of Partial<Path> are a subset of URL, but if we
// pass a URL to react-router's navigate function, it may break.
const $d7d585d5a45c81e0$var$stringifyIfUrl = (to)=>{
    if (to instanceof URL) return to.toString();
    return to;
};
const $d7d585d5a45c81e0$export$51346bfefbea0096 = ()=>{
    const softNavigate = (0, $5WDNl.useNavigate)();
    return (0, $8ZuGG.useCallback)((to, options)=>{
        const destination = $d7d585d5a45c81e0$var$stringifyIfUrl(to);
        if (typeof destination === 'number') return softNavigate(destination);
        if (typeof destination !== 'string') // destination is a Partial<Path>
        return softNavigate(destination, options);
        if (options) return softNavigate(destination, options);
        if ($d7d585d5a45c81e0$var$isToExternalHost(destination)) return window.location.assign(destination);
        const pathname = $d7d585d5a45c81e0$var$removeDomainInformation(destination);
        // if the pathname matches the frontend App router then we can soft navigate
        const routeMatches = (0, $i7SlW.matchRoutes)((0, $fHARP.router).routes, pathname);
        if (routeMatches && routeMatches.length > 0) return softNavigate(pathname);
        return window.location.assign(destination);
    }, [
        softNavigate
    ]);
};

});
parcelRegister("fHARP", function(module, exports) {

$parcel$export(module.exports, "router", function () { return $04eb85c0779770b7$export$5375cda95f0b0eb4; });

var $6rcps = parcelRequire("6rcps");


var $l9koH = parcelRequire("l9koH");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $iSD9t = parcelRequire("iSD9t");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");parcelRequire("5WDNl");
var $i7SlW = parcelRequire("i7SlW");
var $5WDNl = parcelRequire("5WDNl");

var $gsUOH = parcelRequire("gsUOH");

var $kOqgB = parcelRequire("kOqgB");

var $lJ1Bt = parcelRequire("lJ1Bt");

var $cugIF = parcelRequire("cugIF");

var $3cuyW = parcelRequire("3cuyW");

var $jYFWd = parcelRequire("jYFWd");

var $aQwfp = parcelRequire("aQwfp");

var $lk8Tl = parcelRequire("lk8Tl");

var $22H0J = parcelRequire("22H0J");

var $8xW40 = parcelRequire("8xW40");

var $9NVnN = parcelRequire("9NVnN");

var $82mu7 = parcelRequire("82mu7");

var $erZlf = parcelRequire("erZlf");

var $knXCB = parcelRequire("knXCB");

var $7gtNi = parcelRequire("7gtNi");

var $jApGI = parcelRequire("jApGI");
parcelRequire("62Jrh");
var $HylXk = parcelRequire("HylXk");

var $9Li6K = parcelRequire("9Li6K");

var $3ir1n = parcelRequire("3ir1n");

var $jqdIA = parcelRequire("jqdIA");

var $aSgj5 = parcelRequire("aSgj5");

var $lvSNx = parcelRequire("lvSNx");

var $30C6j = parcelRequire("30C6j");

var $9GYqm = parcelRequire("9GYqm");

var $gjxi0 = parcelRequire("gjxi0");

var $lFKa2 = parcelRequire("lFKa2");

var $cJaD4 = parcelRequire("cJaD4");

var $c8zx1 = parcelRequire("c8zx1");

var $4GJDT = parcelRequire("4GJDT");

var $lGfVq = parcelRequire("lGfVq");

var $hWM0L = parcelRequire("hWM0L");

var $e0qo2 = parcelRequire("e0qo2");

var $lJpee = parcelRequire("lJpee");

var $889Xg = parcelRequire("889Xg");

var $5S2Pz = parcelRequire("5S2Pz");

var $akKks = parcelRequire("akKks");

var $gEsch = parcelRequire("gEsch");

var $50Ge8 = parcelRequire("50Ge8");

var $jY1fP = parcelRequire("jY1fP");

var $4sO9M = parcelRequire("4sO9M");

var $4RcrL = parcelRequire("4RcrL");

var $aPeXX = parcelRequire("aPeXX");

var $9kNno = parcelRequire("9kNno");

var $aZgOq = parcelRequire("aZgOq");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $7Y4vx = parcelRequire("7Y4vx");
function $04eb85c0779770b7$export$86fbec116b87613f() {
    const useNewTypography = (0, $7Y4vx.useFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).USE_NEW_TYPOGRAPHY);
    (0, $8ZuGG.useLayoutEffect)(()=>{
        (0, $l9koH.default)({
            colorMode: 'light',
            typography: useNewTypography ? 'typography' : 'typography-modernized'
        });
    }, [
        useNewTypography
    ]);
    (0, $8xW40.useGlobalPageState)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const defaultTitle = formatMessage((0, $3cuyW.default).headTitle);
    const microbranding = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const dynamicConfigs = (0, $erZlf.useDynamicConfigs)();
    const isGlobalStateLoading = (0, $kOqgB.useAppSelector)((state)=>state.globalStateLoading);
    if (isGlobalStateLoading) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $knXCB.FullScreenSpinnerWrapper), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $knXCB.LoadingSpinner), {
            testId: "global-state-loading-spinner"
        })
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.default), {
        analyticsClient: analyticsClient,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $7gtNi.default), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jApGI.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $HylXk.BrowserMetricsBoundary), {
                    children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8ZuGG.Suspense), {
                        fallback: /*#__PURE__*/ (0, $6rcps.jsx)((0, $knXCB.LoadingSpinner), {
                            testId: "suspense-loading-spinner"
                        }),
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                                defaultTitle: defaultTitle,
                                titleTemplate: `%s - ${defaultTitle}`
                            }, "helmet"),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $22H0J.default), {}),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $cugIF.CobrandingProvider), {
                                value: {
                                    cobranding: (0, $cugIF.getCurrentCobranding)(cobranding, dynamicConfigs),
                                    isMobileApp: microbranding.isMobileApp
                                },
                                children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $gsUOH.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Outlet), {}),
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $jYFWd.default), {})
                                    ]
                                }, "screenSizeListener")
                            })
                        ]
                    })
                })
            })
        })
    });
}
const $04eb85c0779770b7$var$TemporaryRedirectHandler = ()=>{
    const data = (0, $5WDNl.useLoaderData)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigateSoftOrHard = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8ZuGG.useLayoutEffect)(()=>{
        if (!data) return;
        if ((0, $8xW40.isRedirect)(data)) {
            navigateSoftOrHard(data.redirectTo);
            return;
        }
        (0, $82mu7.buildInitialState)(data).then((fullState)=>{
            dispatch((0, $lJ1Bt.resetAppState)(fullState.initialStoreState));
        }).catch((error)=>{
            console.error('Failed to build initial state in TemporaryRedirectHandler:', error);
        });
    }, [
        data,
        dispatch,
        navigateSoftOrHard
    ]);
    return null;
};
/**
 * Temporary loader to handle edge cases for paths that always redirect to a different path.
 * Currently SIS returns the redirects to the different path.
 * In the future these will be removed when idproxy directs traffic directly to SIS (as opposed to id-frontend first)
 * to return a redirect to those paths.
 */ const $04eb85c0779770b7$var$temporaryRedirectLoader = async ({ request: request })=>{
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchFast5GlobalPageState)(request.url);
};
const $04eb85c0779770b7$export$5375cda95f0b0eb4 = (0, $gyRZh.createBrowserRouter)([
    {
        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$export$86fbec116b87613f, {}),
        errorElement: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$RouterErrorElement, {}),
        children: [
            {
                path: '/2step',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MfaAppsPage), {})
                    },
                    {
                        path: 'enrollment',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MfaEnrollmentPage), {})
                            },
                            {
                                path: '1-get-app',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ChooseMethodPage), {})
                            },
                            {
                                path: '2-configure-app',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ConfigureAppPage), {})
                            },
                            {
                                path: '2-configure-phone',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ConfigurePhonePage), {})
                            },
                            {
                                path: '2-register-security-key',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.RegisterSecurityKeyPage), {})
                            },
                            {
                                path: '3-connect-phone',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ConfigureAppPage), {
                                    isConnectPhone: true
                                })
                            },
                            {
                                path: '4-save-recovery-key',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SaveRecoveryKeyPage), {})
                            },
                            {
                                path: 'add',
                                // These pages are for enrolling multiple methods of MFA
                                // for now these are dummy pages, and is subject to move (path, content, and/or location)
                                children: [
                                    {
                                        path: 'security-key',
                                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MultiMfaEnrollmentAddSecurityKeyPage), {})
                                    },
                                    {
                                        path: 'authenticator',
                                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MultiMfaEnrollmentAddAuthenticatorPage), {})
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: 'recover',
                        children: [
                            {
                                index: true,
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.RecoveryPage), {}),
                                loader: (0, $9GYqm.recoverLoader)
                            },
                            {
                                path: 'expired',
                                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MultiFactorPage), {
                                    isExpired: true
                                }),
                                loader: (0, $cJaD4.recoverExpiredLoader)
                            }
                        ]
                    }
                ]
            },
            {
                path: '/error',
                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.AuthCallbackErrorPage), {})
            },
            {
                path: '/login',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.LoginPage), {}),
                        loader: (0, $aSgj5.loginLoader)
                    },
                    {
                        path: 'cancel-account-deletion',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.CancelAccountDeletionPage), {}),
                        loader: (0, $30C6j.cancelAccountDeletionLoader)
                    },
                    {
                        path: 'changepassword',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ChangePasswordPage), {}),
                        loader: (0, $hWM0L.changePasswordLoader)
                    },
                    {
                        path: 'changepassword/p/*',
                        // Used for deeplinking for auth on the mobile apps
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ChangePasswordPage), {}),
                        loader: (0, $hWM0L.changePasswordLoader)
                    },
                    {
                        path: 'consent',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.LoginConsentNoticePage), {}),
                        loader: (0, $lJpee.consentLoader)
                    },
                    {
                        path: 'continue-as',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ContinueAsPage), {}),
                        loader: (0, $e0qo2.continueAsLoader)
                    },
                    {
                        path: 'deletion-request-confirmation',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.DeletionRequestConfirmationPage), {})
                    },
                    {
                        path: 'inactive',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.InactiveAccountPage), {})
                    },
                    {
                        path: 'mfa',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MultiFactorPage), {
                            isExpired: false
                        }),
                        loader: (0, $cJaD4.mfaLoader)
                    },
                    {
                        path: 'pending-deletion',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.PendingDeletionPage), {})
                    },
                    {
                        path: 'remove-account',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.RemoveAccountPage), {}),
                        loader: (0, $50Ge8.removeAccountLoader)
                    },
                    {
                        path: 'resetexpiredpassword',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ExpiredPasswordPage), {}),
                        loader: (0, $4sO9M.resetExpiredPasswordLoader)
                    },
                    {
                        path: 'resetpassword',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.ResetPasswordPage), {})
                    },
                    {
                        path: 'select-account',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SelectAccountPage), {}),
                        loader: (0, $889Xg.selectAccountLoader)
                    },
                    {
                        path: 'security-screen',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MfaPromotePage), {}),
                        loader: (0, $gEsch.securityScreenLoader)
                    },
                    {
                        path: 'social/confirmation',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.CreateAccountConfirmationPage), {}),
                        loader: (0, $jY1fP.socialConfirmationLoader)
                    }
                ]
            },
            {
                path: '/logout',
                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.LogoutPage), {}),
                loader: (0, $lFKa2.logoutLoader)
            },
            {
                path: '/mf',
                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MultiFactorPage), {
                    isExpired: false
                })
            },
            {
                path: '/security',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$NavigateToLogin, {})
                    },
                    {
                        // KIRBY-7724: This endpoint doesn't render anything,
                        // but we need to call the backend to get a redirect.
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'auth-alert-action',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$TemporaryRedirectHandler, {}),
                        loader: $04eb85c0779770b7$var$temporaryRedirectLoader
                    },
                    {
                        path: 'expiredlink',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SecurityExpiredLinkPage), {})
                    },
                    {
                        path: 'successfulreset',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SecuritySuccessPage), {
                            successType: "password-reset"
                        })
                    },
                    {
                        path: 'successfulverification',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SecuritySuccessPage), {
                            successType: "verification"
                        })
                    }
                ]
            },
            {
                path: '/signup',
                children: [
                    {
                        index: true,
                        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$SignupCommercial, {}),
                        loader: (0, $lvSNx.signupLoader)
                    },
                    {
                        path: 'onboard',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$SignupOnboardCommercial, {})
                    },
                    {
                        // KIRBY-7259: SIS redirects /signup/invite/* to /signup/welcome/*
                        // This is a temporary fix to handle the redirect for SAS Fast5
                        // This will be replaced with logic in idproxy to handle the redirect of requests to this path
                        // directly to SIS (to immediately return the redirect result) instead of id-frontend as it's being handled now.
                        path: 'invite/*',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$TemporaryRedirectHandler, {}),
                        loader: $04eb85c0779770b7$var$temporaryRedirectLoader
                    },
                    {
                        path: 'migrate-confirmation',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.MigrateAccountConfirmationPage), {}),
                        loader: (0, $4RcrL.migrateConfirmationLoader)
                    },
                    {
                        path: 'welcome',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.WelcomePage), {}),
                        loader: (0, $9kNno.welcomeLoader)
                    },
                    /**
     * The standalone `/welcome/p/loom-create-workspace` page is a step in Loom's signup
     * flow where an existing Atlassian user creates a Loom workspace when creating a new Loom account.
     * In the more common Loom signup flow path where a user is new to Atlassian and Loom,
     * the workspace creation step is shown on the `/welcome` route after a user fills in their name and password.
     * If a user is new to Loom but already exists in Atlassian, this step needs to be hosted
     * on its own page since the login flow requires a redirect.
     *
     * This page will be moved to be hosted on Loom and removed from IDAC once Loom has integrated
     * with Atlassian Identity and can make authenticated requests via Edge Authenticator.
     * See epic: https://useloom.atlassian.net/browse/ID-256
     */ {
                        path: 'welcome/p/loom-create-workspace',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.AuthenticatedLoomWorkspaceCreationPage), {}),
                        // Loom's custom page relies on some page state from the general welcome page
                        loader: (0, $9kNno.welcomeLoader)
                    },
                    {
                        path: 'welcome/p/*',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.WelcomePage), {}),
                        loader: (0, $9kNno.welcomeLoader)
                    },
                    // Used for deeplinking for auth on the mobile apps
                    {
                        path: 'welcome/sent',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.WelcomeSentPage), {}),
                        loader: (0, $aZgOq.welcomeSentLoader)
                    },
                    {
                        path: 'verify-email/otp',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.VerifyEmailOtpPage), {}),
                        loader: (0, $aPeXX.signupVerifyEmailOtpLoader)
                    }
                ]
            },
            {
                path: '/social/recovery',
                element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SocialLoginRecoveryPage), {}),
                loader: (0, $gjxi0.socialRecoveryLoader)
            },
            {
                path: '/step-up',
                children: [
                    {
                        path: 'start',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.StepUpStartPage), {}),
                        loader: (0, $4GJDT.stepUpStartLoader)
                    },
                    {
                        path: 'sso',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.StepUpSsoPage), {}),
                        loader: (0, $lGfVq.stepUpSsoLoader)
                    }
                ]
            },
            {
                path: '/verify-email/*',
                children: [
                    {
                        path: 'change-email',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.EmailConfirmationPage), {}),
                        loader: (0, $c8zx1.changeEmailLoader)
                    },
                    {
                        path: 'sent',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.VerifyOrReverifyEmailSentPage), {}),
                        loader: (0, $akKks.verifyEmailSentLoader)
                    },
                    {
                        path: '*',
                        element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.VerifyOrReverifyEmailErrorPage), {}),
                        loader: (0, $5S2Pz.verifyEmailLoader)
                    }
                ]
            }
        ]
    }
], {
    future: (0, $jqdIA.reactRouterFutureFlags)
});
function $04eb85c0779770b7$var$SignupCommercial() {
    if ((0, $lk8Tl.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SignupPage), {});
    return /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$NavigateToLogin, {});
}
function $04eb85c0779770b7$var$SignupOnboardCommercial() {
    if ((0, $lk8Tl.getCurrentCloudType)() === 'commercial') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aQwfp.SignupOnboardPage), {});
    return /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$NavigateToLogin, {});
}
function $04eb85c0779770b7$var$NavigateToLogin() {
    const { search: search } = (0, $5WDNl.useLocation)();
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Navigate), {
        to: {
            pathname: '/login',
            search: search
        },
        replace: true
    });
}
function $04eb85c0779770b7$var$RouterErrorElement() {
    const error = (0, $5WDNl.useRouteError)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    if ((0, $i7SlW.isRouteErrorResponse)(error) && error.status === 404) {
        analyticsClient.trackingEvent({
            page: 'RouterErrorElement',
            action: 'error',
            subject: 'routeNotFound'
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)($04eb85c0779770b7$var$NavigateToLogin, {});
    }
    // rethrow to let the parent error boundary handle it
    throw error;
}

});
parcelRegister("l9koH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65a42b83c2581ee$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $icabj = parcelRequire("icabj");

var $ckFNI = parcelRequire("ckFNI");

var $4hbFz = parcelRequire("4hbFz");

var $9TV3v = parcelRequire("9TV3v");

var $i6I7h = parcelRequire("i6I7h");

var $lcCMu = parcelRequire("lcCMu");
function $f65a42b83c2581ee$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f65a42b83c2581ee$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f65a42b83c2581ee$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f65a42b83c2581ee$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f65a42b83c2581ee$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f65a42b83c2581ee$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $f65a42b83c2581ee$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $icabj.themeStateDefaults)['colorMode'] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $icabj.themeStateDefaults)['contrastMode'] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $icabj.themeStateDefaults)['dark'] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $icabj.themeStateDefaults)['light'] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $icabj.themeStateDefaults)['shape'] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $icabj.themeStateDefaults)['spacing'] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $icabj.themeStateDefaults)['typography']() : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $icabj.themeStateDefaults)['UNSAFE_themeOptions'] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $i2LcI.fg)('platform_increased-contrast-themes')) {
                        if (light === 'light-increased-contrast') light = 'light';
                        if (dark === 'dark-increased-contrast') dark = 'dark';
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $i6I7h.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $lcCMu.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $ckFNI.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $icabj.themeStateDefaults)['colorMode'];
                        attrOfMissingCustomStyles = (0, $9TV3v.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("7ckqH"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? 'auto' : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $i6I7h.getThemeOverridePreferences)(themeState);
                    _iterator = $f65a42b83c2581ee$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $4hbFz.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $f65a42b83c2581ee$export$2e2bcd8739ae039 = $f65a42b83c2581ee$var$setGlobalTheme;

});
parcelRegister("4hbFz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d1cd45d26c9b78$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $i2LcI = parcelRequire("i2LcI");

var $bDlvL = parcelRequire("bDlvL");

var $jodS5 = parcelRequire("jodS5");

var $6wkMV = parcelRequire("6wkMV");
function $31d1cd45d26c9b78$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === 'auto') {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $jodS5.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $jodS5.default).bind();
    } else (0, $jodS5.default).unbind();
    if ((0, $i2LcI.fg)('platform_increased-contrast-themes')) {
        if (themeState.contrastMode === 'auto') {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $6wkMV.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $6wkMV.default).bind();
        } else (0, $6wkMV.default).unbind();
    }
    var themeAttributes = (0, $bDlvL.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $jodS5.default).unbind();
        if ((0, $i2LcI.fg)('platform_increased-contrast-themes')) (0, $6wkMV.default).unbind();
    };
}

});
parcelRegister("bDlvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878405ec9d471670$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $i2LcI = parcelRequire("i2LcI");

var $bDRHl = parcelRequire("bDRHl");

var $icabj = parcelRequire("icabj");

var $juoNE = parcelRequire("juoNE");

var $ckFNI = parcelRequire("ckFNI");

var $5S9Ox = parcelRequire("5S9Ox");
function $878405ec9d471670$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $878405ec9d471670$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $878405ec9d471670$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $878405ec9d471670$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $878405ec9d471670$var$defaultColorMode = 'light';
var $878405ec9d471670$var$defaultContrastMode = 'no-preference';
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $878405ec9d471670$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $icabj.themeStateDefaults)['colorMode'] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $icabj.themeStateDefaults)['dark'] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $icabj.themeStateDefaults)['light'] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $icabj.themeStateDefaults)['contrastMode'] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $icabj.themeStateDefaults)['shape'] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $icabj.themeStateDefaults)['spacing'] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $icabj.themeStateDefaults)['typography']() : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $icabj.themeStateDefaults)['UNSAFE_themeOptions'] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $juoNE.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $bDRHl.THEME_DATA_ATTRIBUTE), themeAttribute), (0, $bDRHl.COLOR_MODE_ATTRIBUTE), colorMode === 'auto' ? $878405ec9d471670$var$defaultColorMode : colorMode);
    if ((0, $i2LcI.fg)('platform_increased-contrast-themes')) result = $878405ec9d471670$var$_objectSpread($878405ec9d471670$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $bDRHl.CONTRAST_MODE_ATTRIBUTE), contrastMode === 'auto' ? $878405ec9d471670$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $ckFNI.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $5S9Ox.hash)(optionString);
        result[0, $bDRHl.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $878405ec9d471670$export$2e2bcd8739ae039 = $878405ec9d471670$var$getThemeHtmlAttrs;

});

parcelRegister("jodS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1db04c1e1f7c628$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $bDRHl = parcelRequire("bDRHl");

var $lcCMu = parcelRequire("lcCMu");
var $e1db04c1e1f7c628$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $e1db04c1e1f7c628$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $bDRHl.COLOR_MODE_ATTRIBUTE), e.matches ? 'dark' : 'light');
}
var $e1db04c1e1f7c628$var$darkModeMql = $e1db04c1e1f7c628$var$isMatchMediaAvailable && window.matchMedia((0, $lcCMu.darkModeMediaQuery));
var $e1db04c1e1f7c628$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbindThemeChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$e1db04c1e1f7c628$var$darkModeMql) return 'light';
                return $e1db04c1e1f7c628$var$darkModeMql !== null && $e1db04c1e1f7c628$var$darkModeMql !== void 0 && $e1db04c1e1f7c628$var$darkModeMql.matches ? 'dark' : 'light';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($e1db04c1e1f7c628$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $k6Bkl.bind)($e1db04c1e1f7c628$var$darkModeMql, {
                    type: 'change',
                    listener: $e1db04c1e1f7c628$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $e1db04c1e1f7c628$var$SingletonColorModeObserver = new $e1db04c1e1f7c628$var$ColorModeObserver();
var $e1db04c1e1f7c628$export$2e2bcd8739ae039 = $e1db04c1e1f7c628$var$SingletonColorModeObserver;

});
parcelRegister("lcCMu", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $f6f8cd14966b02ee$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $f6f8cd14966b02ee$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $f6f8cd14966b02ee$export$8662df6937d86fcb; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $6xyVI = parcelRequire("6xyVI");

var $bDRHl = parcelRequire("bDRHl");
var $f6f8cd14966b02ee$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), "=\"").concat(themeId, "\"]:not([").concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $f6f8cd14966b02ee$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement('style');
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $f6f8cd14966b02ee$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === 'light' || themeId === 'dark') && (0, $i2LcI.fg)('platform-component-visual-refresh')) themeId += '-brand-refresh';
                    _context2.next = 3;
                    return (0, $6xyVI.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $f6f8cd14966b02ee$export$bb1e815119d30f8b = '(prefers-color-scheme: dark)';
var $f6f8cd14966b02ee$export$8662df6937d86fcb = '(prefers-contrast: more)';

});
parcelRegister("6xyVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c30eb7a1dd45237$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::3db020c00d91d31fe8e413b082708618>>
 * @codegenCommand yarn build tokens
 */ 

















var $4c30eb7a1dd45237$var$themeImportsMap = {
    'light': function light() {
        return (parcelRequire("kHYoq"));
    },
    'light-future': function lightFuture() {
        return (parcelRequire("gpRk8"));
    },
    'light-increased-contrast': function lightIncreasedContrast() {
        return (parcelRequire("c8RbB"));
    },
    'dark': function dark() {
        return (parcelRequire("isrGv"));
    },
    'dark-future': function darkFuture() {
        return (parcelRequire("5dwxv"));
    },
    'dark-increased-contrast': function darkIncreasedContrast() {
        return (parcelRequire("kKMbx"));
    },
    'legacy-light': function legacyLight() {
        return (parcelRequire("rYlZ2"));
    },
    'legacy-dark': function legacyDark() {
        return (parcelRequire("5TU7G"));
    },
    'spacing': function spacing() {
        return (parcelRequire("iTurb"));
    },
    'typography': function typography() {
        return (parcelRequire("7Vi5R"));
    },
    'typography-adg3': function typographyAdg3() {
        return (parcelRequire("8FkoG"));
    },
    'shape': function shape() {
        return (parcelRequire("hnVYZ"));
    },
    'shape-rounder': function shapeRounder() {
        return (parcelRequire("8cU1D"));
    },
    'shape-roundest': function shapeRoundest() {
        return (parcelRequire("Jp6ag"));
    },
    'typography-modernized': function typographyModernized() {
        return (parcelRequire("briFb"));
    },
    'typography-refreshed': function typographyRefreshed() {
        return (parcelRequire("c7EWG"));
    },
    'light-brand-refresh': function lightBrandRefresh() {
        return (parcelRequire("aeCsz"));
    },
    'dark-brand-refresh': function darkBrandRefresh() {
        return (parcelRequire("4asKf"));
    }
};
var $4c30eb7a1dd45237$export$2e2bcd8739ae039 = $4c30eb7a1dd45237$var$themeImportsMap;

});



parcelRegister("6wkMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf5db56eda62f9b$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $bDRHl = parcelRequire("bDRHl");

var $lcCMu = parcelRequire("lcCMu");
var $4bf5db56eda62f9b$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $4bf5db56eda62f9b$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $bDRHl.CONTRAST_MODE_ATTRIBUTE), e.matches ? 'more' : 'no-preference');
}
var $4bf5db56eda62f9b$var$contrastModeMql = $4bf5db56eda62f9b$var$isMatchMediaAvailable && window.matchMedia((0, $lcCMu.moreContrastMediaQuery));
var $4bf5db56eda62f9b$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbindContrastChangeListener", null);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$4bf5db56eda62f9b$var$contrastModeMql) return 'no-preference';
                return $4bf5db56eda62f9b$var$contrastModeMql !== null && $4bf5db56eda62f9b$var$contrastModeMql !== void 0 && $4bf5db56eda62f9b$var$contrastModeMql.matches ? 'more' : 'no-preference';
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($4bf5db56eda62f9b$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $k6Bkl.bind)($4bf5db56eda62f9b$var$contrastModeMql, {
                    type: 'change',
                    listener: $4bf5db56eda62f9b$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $4bf5db56eda62f9b$var$SingletonContrastModeObserver = new $4bf5db56eda62f9b$var$ContrastModeObserver();
var $4bf5db56eda62f9b$export$2e2bcd8739ae039 = $4bf5db56eda62f9b$var$SingletonContrastModeObserver;

});


parcelRegister("i6I7h", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $d2eb021c005a43dc$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $d2eb021c005a43dc$export$5d76d7014f4a5d08; });

var $cF8Kw = parcelRequire("cF8Kw");

var $i2LcI = parcelRequire("i2LcI");

var $6C7Th = parcelRequire("6C7Th");
var $d2eb021c005a43dc$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === 'auto') {
        if (contrastMode !== 'no-preference' && (0, $i2LcI.fg)('platform_increased-contrast-themes')) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $6C7Th.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== 'no-preference' && (0, $i2LcI.fg)('platform_increased-contrast-themes')) {
            var increasedContrastTheme = (0, $6C7Th.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set(themePreferences));
};
var $d2eb021c005a43dc$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set(themeOverridePreferences));
};

});
parcelRegister("6C7Th", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d0c6993b17e563a$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $icabj = parcelRequire("icabj");
function $4d0c6993b17e563a$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $icabj.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});



parcelRegister("gsUOH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e75b92d5ce2de9e1$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $9Vz68 = parcelRequire("9Vz68");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("iBTcr");
var $ittIU = parcelRequire("ittIU");

var $ihLLY = parcelRequire("ihLLY");

var $dWlIQ = parcelRequire("dWlIQ");
let $e75b92d5ce2de9e1$var$_ = (t)=>t, $e75b92d5ce2de9e1$var$t;
const $e75b92d5ce2de9e1$var$FullHeightContainer = (0, $9Vz68.default).div($e75b92d5ce2de9e1$var$t || ($e75b92d5ce2de9e1$var$t = $e75b92d5ce2de9e1$var$_`
  height: 100%;
`));
const $e75b92d5ce2de9e1$var$DeviceTypeListener = ({ dispatch: dispatch, children: children })=>{
    (0, $8ZuGG.useEffect)(()=>{
        if (!(0, $ihLLY.screenSizeMatcher)) return;
        const onScreenSizeUpdated = ({ matches: matches })=>{
            dispatch((0, $dWlIQ.screenSizeUpdated)(matches ? 'mobile' : 'desktop'));
        };
        try {
            /**
       * Improved API but supported by only ~94.2% of browsers
       * https://caniuse.com/mdn-api_mediaquerylist_change_event
       */ (0, $ihLLY.screenSizeMatcher).addEventListener('change', onScreenSizeUpdated);
            return ()=>(0, $ihLLY.screenSizeMatcher).removeEventListener('change', onScreenSizeUpdated);
        } catch (e) {
            /**
       * These methods are deprecated but needed as fallbacks for browsers older than:
       * - Edge 79 (released 2020-01)
       * - Safari 14 (released 2020-09)
       * - Safari on iOS 14 (released 2020-09)
       *
       * All other browsers have had support since 2014-2017.
       * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
       */ (0, $ihLLY.screenSizeMatcher).addListener(onScreenSizeUpdated);
            return ()=>(0, $ihLLY.screenSizeMatcher).removeListener(onScreenSizeUpdated);
        }
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($e75b92d5ce2de9e1$var$FullHeightContainer, {
        children: children
    });
};
var $e75b92d5ce2de9e1$export$2e2bcd8739ae039 = (0, $ittIU.default)()($e75b92d5ce2de9e1$var$DeviceTypeListener);

});
parcelRegister("dWlIQ", function(module, exports) {

$parcel$export(module.exports, "screenSizeUpdated", function () { return $f98abd6680cb5f12$export$92b52f782097f1e7; });
const $f98abd6680cb5f12$export$92b52f782097f1e7 = (screenSize)=>({
        type: 'SCREEN_SIZE_UPDATED',
        screenSize: screenSize
    });

});


parcelRegister("3cuyW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $178059c9f52b5bc2$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $178059c9f52b5bc2$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'default.head.title',
        defaultMessage: 'Log in with Atlassian account'
    }
});

});

parcelRegister("jYFWd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1438b5f8e1df0e8a$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $hZLXX = parcelRequire("hZLXX");
var $3Hvr7 = parcelRequire("3Hvr7");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $5BHjB = parcelRequire("5BHjB");

var $7lAAA = parcelRequire("7lAAA");

var $iSD9t = parcelRequire("iSD9t");

var $xe7jL = parcelRequire("xe7jL");

var $kOqgB = parcelRequire("kOqgB");
let $1438b5f8e1df0e8a$var$_ = (t)=>t, $1438b5f8e1df0e8a$var$t;
// We need to wrap the flag in a div to apply responsive styles so
// the flag are always visible on smaller viewports.
const $1438b5f8e1df0e8a$var$ResponsiveFlagWrapper = (0, $9Vz68.default).div($1438b5f8e1df0e8a$var$t || ($1438b5f8e1df0e8a$var$t = $1438b5f8e1df0e8a$var$_`
  [role='alert'] {
    max-width: calc(100vw - ${0}px);
  }
`), (0, $5b7Z4.gridSize)() * 11);
const $1438b5f8e1df0e8a$export$1fe549a730923236 = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const flags = (0, $kOqgB.useAppSelector)((state)=>state.flags.flags);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const toFlagComponent = (flag)=>{
        const icon = flag.type === 'success' ? /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5BHjB))), {
            label: "Success",
            primaryColor: (0, $kTdw7).G300
        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7lAAA))), {
            label: "Error",
            primaryColor: (0, $kTdw7).R300
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)($1438b5f8e1df0e8a$var$ResponsiveFlagWrapper, {
            id: flag.id,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $hZLXX.default), {
                id: flag.id || '',
                title: formatMessage(flag.title),
                description: formatMessage(flag.description),
                icon: icon,
                onDismissed: ()=>dispatch((0, $xe7jL.dismissFlag)())
            })
        }, flag.id);
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $3Hvr7.default), {
        children: flags.map(toFlagComponent)
    });
};
var $1438b5f8e1df0e8a$export$2e2bcd8739ae039 = $1438b5f8e1df0e8a$export$1fe549a730923236;

});
parcelRegister("hZLXX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d19d5736b40472d8$export$2e2bcd8739ae039; });
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");

var $5VQjR = parcelRequire("5VQjR");

var $72wHg = parcelRequire("72wHg");
var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $73a5X = parcelRequire("73a5X");

var $4sph8 = parcelRequire("4sph8");

var $Zkn75 = parcelRequire("Zkn75");

var $3Hvr7 = parcelRequire("3Hvr7");

var $5EPVc = parcelRequire("5EPVc");
var $28rOu = parcelRequire("28rOu");

var $dfOpk = parcelRequire("dfOpk");
function $d19d5736b40472d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d19d5736b40472d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d19d5736b40472d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d19d5736b40472d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d19d5736b40472d8$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkofajl _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
var $d19d5736b40472d8$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
var $d19d5736b40472d8$var$descriptionStyles = null;
var $d19d5736b40472d8$var$iconWrapperStyles = null;
var $d19d5736b40472d8$var$flagWrapperStyles = null;
var $d19d5736b40472d8$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "@atlaskit/flag",
    packageVersion: "17.4.1"
};
var $d19d5736b40472d8$var$transitionStyles = null;
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $d19d5736b40472d8$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $4sph8.DEFAULT_APPEARANCE) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $5AVd4.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $5AVd4.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $5AVd4.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $3Hvr7.useFlagGroup)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $8ZuGG.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $8ZuGG.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var isBold = appearance !== (0, $4sph8.DEFAULT_APPEARANCE);
    var toggleExpand = (0, $8ZuGG.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $8ZuGG.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $8ZuGG.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var onBlurAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $dfOpk.flagTextColor)[appearance];
    var iconColor = (0, $dfOpk.flagIconColor)[appearance];
    var iconGlyph = (0, $dfOpk.flagIconGlyph)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ $8ZuGG.createElement((0, $73a5X.default), null, title, description) : undefined;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        role: "alert",
        "data-testid": testId
    }, autoDismissProps, {
        className: (0, $c4hjl.default)([
            "_1bsb1osq"
        ])
    }), /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        padding: "space.200",
        backgroundColor: (0, $dfOpk.flagBackgroundColor)[appearance],
        xcss: $d19d5736b40472d8$var$styles.flag
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        alignBlock: "start",
        space: "space.200"
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId && "".concat(testId, "-icon-container"),
        className: (0, $c4hjl.default)([
            "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz16r9"
        ]),
        style: $d19d5736b40472d8$var$_objectSpread($d19d5736b40472d8$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $d19d5736b40472d8$var$CSS_VAR_ICON_COLOR, iconColor)), {}, {
            "--_11v68d2": (0, $bT1Ur.default)("var(".concat($d19d5736b40472d8$var$CSS_VAR_ICON_COLOR, ")"))
        })
    }, icon || iconGlyph), /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            "_v5641hdc _16jlkb7n"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $aDzos.default), {
        space: shouldRenderGap ? 'space.100' : 'space.0' // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $d19d5736b40472d8$var$styles.overflowWrap
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5VQjR.default), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, /*#__PURE__*/ $8ZuGG.createElement("span", {
        /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce
    }, title))), isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ $8ZuGG.createElement((0, $5EPVc.default), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), /*#__PURE__*/ $8ZuGG.createElement((0, $28rOu.default), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && /*#__PURE__*/ $8ZuGG.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $dfOpk.flagTextColorToken)[appearance]
        },
        "data-testid": testId && "".concat(testId, "-description"),
        "aria-hidden": isDelayToAnnounce,
        className: (0, $c4hjl.default)([
            "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
        ])
    }, description), /*#__PURE__*/ $8ZuGG.createElement((0, $Zkn75.default), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $d19d5736b40472d8$export$2e2bcd8739ae039 = $d19d5736b40472d8$var$Flag;

});
parcelRegister("4sph8", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_APPEARANCE", function () { return $33ed62187a2b812a$export$d6830277b06edd6; });
var $33ed62187a2b812a$export$d6830277b06edd6 = 'normal';

});

parcelRegister("Zkn75", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b858008b256776a$export$2e2bcd8739ae039; });
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $2HALZ = parcelRequire("2HALZ");

var $fkdQ8 = parcelRequire("fkdQ8");

var $4sph8 = parcelRequire("4sph8");

var $dfOpk = parcelRequire("dfOpk");
function $0b858008b256776a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0b858008b256776a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0b858008b256776a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0b858008b256776a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0b858008b256776a$var$buttonStyles = null;
var $0b858008b256776a$var$fontStyles = null;
var $0b858008b256776a$var$appearanceNormalButtonStyles = null;
var $0b858008b256776a$var$appearanceNormalActionsContainerStyles = null;
var $0b858008b256776a$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $4sph8.DEFAULT_APPEARANCE) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $4sph8.DEFAULT_APPEARANCE);
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            !isBold && "_1g4l107e _y8dn107e",
            "_11c82smr"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ $8ZuGG.createElement((0, $2HALZ.default), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? 'default' : 'link',
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            className: (0, $c4hjl.default)([
                "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk69tn6 _1wy69tn6 _b3g39tn6 _eqps9tn6 _ow071r31 _1p6b1r31 _8dbm1r31 _77mc1r31 _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                appearance === (0, $4sph8.DEFAULT_APPEARANCE) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
            ]),
            style: $0b858008b256776a$var$_objectSpread($0b858008b256776a$var$_objectSpread({}, {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                '--color': (0, $dfOpk.actionTextColor)[appearance],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color': (0, $dfOpk.actionBackgroundColor)[appearance].default,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-hover': (0, $dfOpk.actionBackgroundColor)[appearance].pressed,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--bg-color-active': (0, $dfOpk.actionBackgroundColor)[appearance].active
            }), {}, {
                "--_zkfc5e": (0, $bT1Ur.default)("var(--ds-space-100, 8px)".concat(" !important"))
            })
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b858008b256776a$export$2e2bcd8739ae039 = $0b858008b256776a$var$FlagActions;

});
parcelRegister("2HALZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7c1f473431d3ba$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $4hzr4 = parcelRequire("4hzr4");

var $hU0Cl = parcelRequire("hU0Cl");

var $7yjH4 = parcelRequire("7yjH4");

var $7GSOz = parcelRequire("7GSOz");

var $bwz7O = parcelRequire("bwz7O");
var $1f7c1f473431d3ba$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $1f7c1f473431d3ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f7c1f473431d3ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f7c1f473431d3ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f7c1f473431d3ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1f7c1f473431d3ba$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $1f7c1f473431d3ba$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $1f7c1f473431d3ba$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $bwz7O.defaultThemeFn) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $1f7c1f473431d3ba$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $1f7c1f473431d3ba$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $8ZuGG.useState)($1f7c1f473431d3ba$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bwz7O.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4hzr4.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bwz7O.default).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            mode: mode,
            state: $1f7c1f473431d3ba$var$getInteractionState($1f7c1f473431d3ba$var$_objectSpread($1f7c1f473431d3ba$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $7yjH4.default)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hU0Cl.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7GSOz.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $bwz7O.getSpecifiers)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$1f7c1f473431d3ba$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $1f7c1f473431d3ba$export$2e2bcd8739ae039 = $1f7c1f473431d3ba$var$CustomThemeButton;

});
parcelRegister("4hzr4", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $31e43cbc6202146a$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $31e43cbc6202146a$export$2e2bcd8739ae039; });

var $3Mk2r = parcelRequire("3Mk2r");
// Create default global light theme
var $31e43cbc6202146a$var$_createTheme = (0, $3Mk2r.createTheme)(function() {
    return {
        mode: 'light'
    };
}), $31e43cbc6202146a$var$Provider = $31e43cbc6202146a$var$_createTheme.Provider, $31e43cbc6202146a$var$Consumer = $31e43cbc6202146a$var$_createTheme.Consumer, $31e43cbc6202146a$export$7692396083754928 = $31e43cbc6202146a$var$_createTheme.useTheme;
var $31e43cbc6202146a$var$Theme = {
    Provider: $31e43cbc6202146a$var$Provider,
    Consumer: $31e43cbc6202146a$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$31e43cbc6202146a$export$2e2bcd8739ae039 = $31e43cbc6202146a$var$Theme;

});
parcelRegister("3Mk2r", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $2c056602d66fd4d4$export$25d302a5b900a763; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");
var $2c056602d66fd4d4$var$_excluded = [
    "children"
];
function $2c056602d66fd4d4$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $8ZuGG.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $2c056602d66fd4d4$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $8ZuGG.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $8ZuGG.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("hU0Cl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0882544ffca4318$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");

var $c7GPs = parcelRequire("c7GPs");

var $c3Xui = parcelRequire("c3Xui");

var $32ztx = parcelRequire("32ztx");

var $gN3Go = parcelRequire("gN3Go");

var $epZNN = parcelRequire("epZNN");

var $2itye = parcelRequire("2itye");

var $bJJt2 = parcelRequire("bJJt2");
var $d0882544ffca4318$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d0882544ffca4318$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $d0882544ffca4318$var$iconBeforeSpacingFixStyle = (0, $bl8w7.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d0882544ffca4318$var$iconAfterSpacingFixStyle = (0, $bl8w7.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d0882544ffca4318$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d0882544ffca4318$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $bl8w7.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d0882544ffca4318$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $5AVd4.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $5AVd4.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $d0882544ffca4318$var$_excluded);
    var ourRef = (0, $8ZuGG.useRef)();
    var setRef = (0, $8ZuGG.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $c7GPs.default)(ourRef, autoFocus);
    var interactionContext = (0, $8ZuGG.useContext)((0, $32ztx.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "23.4.6",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $8ZuGG.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $bl8w7.css)((0, $2itye.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $gN3Go.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $gN3Go.N500), ")"), " !important")
        }
    };
    return (0, $bl8w7.jsx)((0, $c3Xui.default), null, (0, $bl8w7.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d0882544ffca4318$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $epZNN.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $bl8w7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2itye.getIconStyle)({
                spacing: spacing
            }),
            $d0882544ffca4318$var$getSpacingFix(children, $d0882544ffca4318$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d0882544ffca4318$var$getChildren(children, [
        fadeStyles,
        (0, $2itye.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $bl8w7.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $2itye.getIconStyle)({
                spacing: spacing
            }),
            $d0882544ffca4318$var$getSpacingFix(children, $d0882544ffca4318$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $bl8w7.jsx)("span", {
        css: [
            (0, $2itye.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d0882544ffca4318$export$2e2bcd8739ae039 = $d0882544ffca4318$var$ButtonBase;

});
parcelRegister("c7GPs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d375c6a35c21f31$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
function $8d375c6a35c21f31$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $8ZuGG.useRef)(true);
    (0, $8ZuGG.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("c3Xui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c83e8df1da8eed5$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");
var $8c83e8df1da8eed5$var$BORDER_WIDTH = 2;
var $8c83e8df1da8eed5$var$baseFocusOutsideStyles = (0, $bl8w7.css)({
    outline: "".concat($8c83e8df1da8eed5$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $8c83e8df1da8eed5$var$BORDER_WIDTH
});
var $8c83e8df1da8eed5$var$baseInsetStyles = (0, $bl8w7.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$8c83e8df1da8eed5$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $8c83e8df1da8eed5$var$focusRingStyles = (0, $bl8w7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $8c83e8df1da8eed5$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $8c83e8df1da8eed5$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $8c83e8df1da8eed5$var$insetFocusRingStyles = (0, $bl8w7.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $8c83e8df1da8eed5$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $8c83e8df1da8eed5$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $8c83e8df1da8eed5$var$FocusRing = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $8c83e8df1da8eed5$var$baseInsetStyles : $8c83e8df1da8eed5$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $8c83e8df1da8eed5$var$insetFocusRingStyles : $8c83e8df1da8eed5$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $bl8w7.jsx)((0, $bl8w7.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $8ZuGG.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $8ZuGG.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$8c83e8df1da8eed5$var$FocusRing.displayName = 'FocusRing';
var $8c83e8df1da8eed5$export$2e2bcd8739ae039 = $8c83e8df1da8eed5$var$FocusRing;

});

parcelRegister("32ztx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $236d13b305c2e621$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $236d13b305c2e621$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("gN3Go", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $c39414400ec87a3f$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $c39414400ec87a3f$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $c39414400ec87a3f$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y200", function () { return $c39414400ec87a3f$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $c39414400ec87a3f$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $c39414400ec87a3f$export$59619663aa6500fb; });
$parcel$export(module.exports, "B50", function () { return $c39414400ec87a3f$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $c39414400ec87a3f$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $c39414400ec87a3f$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $c39414400ec87a3f$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $c39414400ec87a3f$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $c39414400ec87a3f$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $c39414400ec87a3f$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "N0", function () { return $c39414400ec87a3f$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $c39414400ec87a3f$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N70", function () { return $c39414400ec87a3f$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N90", function () { return $c39414400ec87a3f$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N200", function () { return $c39414400ec87a3f$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N400", function () { return $c39414400ec87a3f$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $c39414400ec87a3f$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $c39414400ec87a3f$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $c39414400ec87a3f$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $c39414400ec87a3f$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $c39414400ec87a3f$export$920c0d5c49070351; });
$parcel$export(module.exports, "DN400", function () { return $c39414400ec87a3f$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $c39414400ec87a3f$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN100", function () { return $c39414400ec87a3f$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN70", function () { return $c39414400ec87a3f$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $c39414400ec87a3f$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN30", function () { return $c39414400ec87a3f$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN0", function () { return $c39414400ec87a3f$export$3d4f271a500072a; });
// Reds
var $c39414400ec87a3f$export$4b84fd0e2c617bd = '#FFEBE6';
var $c39414400ec87a3f$export$b34b069eff244586 = '#FFBDAD';
var $c39414400ec87a3f$export$be802dd0d8b57f35 = '#FF8F73';
var $c39414400ec87a3f$export$60847d42f9da92a6 = '#FF7452';
var $c39414400ec87a3f$export$4a7404f376229999 = '#FF5630';
var $c39414400ec87a3f$export$2010d0fb4295b346 = '#DE350B';
var $c39414400ec87a3f$export$2837b5a1a71d5c02 = '#BF2600';
var $c39414400ec87a3f$export$8d9596b529bbb9cf = '#FFFAE6';
var $c39414400ec87a3f$export$41060a744ab0b7ae = '#FFF0B3';
var $c39414400ec87a3f$export$1cc05bbbf340e559 = '#FFE380';
var $c39414400ec87a3f$export$5aae31392d72caaa = '#FFC400';
var $c39414400ec87a3f$export$c6930421db9fa514 = '#FFAB00';
var $c39414400ec87a3f$export$59619663aa6500fb = '#FF991F';
var $c39414400ec87a3f$export$874739ea9e379ab6 = '#FF8B00';
var $c39414400ec87a3f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c39414400ec87a3f$export$69a3bf21b9686c2b = '#ABF5D1';
var $c39414400ec87a3f$export$afbce1382ec95f73 = '#79F2C0';
var $c39414400ec87a3f$export$747d86715d4175de = '#57D9A3';
var $c39414400ec87a3f$export$940e1f69e873f202 = '#36B37E';
var $c39414400ec87a3f$export$a49394138f7b8e85 = '#00875A';
var $c39414400ec87a3f$export$6fa04827ac68a4fb = '#006644';
var $c39414400ec87a3f$export$226de0355ed012f8 = '#DEEBFF';
var $c39414400ec87a3f$export$8c13c2ee36917869 = '#B3D4FF';
var $c39414400ec87a3f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c39414400ec87a3f$export$215b7063051591f1 = '#2684FF';
var $c39414400ec87a3f$export$e62e8919cca44969 = '#0065FF';
var $c39414400ec87a3f$export$b3de0ae08da2ce64 = '#0052CC';
var $c39414400ec87a3f$export$a6ee3d71bc067634 = '#0747A6';
var $c39414400ec87a3f$export$67f15409e87642a1 = '#669DF1';
var $c39414400ec87a3f$export$f0539dbc42dbb067 = '#8FB8F6';
var $c39414400ec87a3f$export$363e4475840015bb = '#EAE6FF';
var $c39414400ec87a3f$export$4b0a4417ed59760f = '#C0B6F2';
var $c39414400ec87a3f$export$6011520a64d9a187 = '#998DD9';
var $c39414400ec87a3f$export$a7175d4e9206bc80 = '#8777D9';
var $c39414400ec87a3f$export$b48405b95304b5a1 = '#6554C0';
var $c39414400ec87a3f$export$c71e4279dd54a18d = '#5243AA';
var $c39414400ec87a3f$export$147899de772240ec = '#403294';
var $c39414400ec87a3f$export$2cf711fe14c66f06 = '#E6FCFF';
var $c39414400ec87a3f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c39414400ec87a3f$export$776c9c497ef08533 = '#79E2F2';
var $c39414400ec87a3f$export$69cb3ca10c1e330e = '#00C7E6';
var $c39414400ec87a3f$export$9dc1ef0f3f48059b = '#00B8D9';
var $c39414400ec87a3f$export$7c835c78b6fcdef8 = '#00A3BF';
var $c39414400ec87a3f$export$6036577f95c3877e = '#008DA6';
var $c39414400ec87a3f$export$29a4f05edc054374 = '#FFFFFF';
var $c39414400ec87a3f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c39414400ec87a3f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c39414400ec87a3f$export$3e51e8f1440314ba = '#EBECF0';
var $c39414400ec87a3f$export$1ce2d1575d444ceb = '#DFE1E6';
var $c39414400ec87a3f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c39414400ec87a3f$export$c2e91cbeada39b8b = '#B3BAC5';
var $c39414400ec87a3f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c39414400ec87a3f$export$eaa8c8a70ac22806 = '#97A0AF';
var $c39414400ec87a3f$export$7c87d337fb91a97d = '#8993A4';
var $c39414400ec87a3f$export$d6447c357493214f = '#7A869A';
var $c39414400ec87a3f$export$f563ee71e9ee74cd = '#6B778C';
var $c39414400ec87a3f$export$e2ef2124cf4024b1 = '#5E6C84';
var $c39414400ec87a3f$export$eece5f492e429f08 = '#505F79';
var $c39414400ec87a3f$export$c39c0fe0f26207ae = '#42526E';
var $c39414400ec87a3f$export$7090862dc3038a9f = '#344563';
var $c39414400ec87a3f$export$ad0bacf983b7ddaa = '#253858';
var $c39414400ec87a3f$export$7d61b15e0da132af = '#172B4D';
var $c39414400ec87a3f$export$fbda843f0a27fe96 = '#091E42';
var $c39414400ec87a3f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c39414400ec87a3f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c39414400ec87a3f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c39414400ec87a3f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c39414400ec87a3f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c39414400ec87a3f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c39414400ec87a3f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c39414400ec87a3f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c39414400ec87a3f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c39414400ec87a3f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c39414400ec87a3f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c39414400ec87a3f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c39414400ec87a3f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c39414400ec87a3f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c39414400ec87a3f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c39414400ec87a3f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c39414400ec87a3f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c39414400ec87a3f$export$2f6319cf7d736c2a = '#E6EDFA';
var $c39414400ec87a3f$export$95126bc8884d6634 = '#DCE5F5';
var $c39414400ec87a3f$export$8338d8c35d44ff1 = '#CED9EB';
var $c39414400ec87a3f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c39414400ec87a3f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c39414400ec87a3f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c39414400ec87a3f$export$97e81faa16a182c7 = '#8C9CB8';
var $c39414400ec87a3f$export$bfe21c59123ecf33 = '#7988A3';
var $c39414400ec87a3f$export$ee82aa2ea6a1558 = '#67758F';
var $c39414400ec87a3f$export$682927c6ed76be02 = '#56637A';
var $c39414400ec87a3f$export$91fd9994c5be9757 = '#455166';
var $c39414400ec87a3f$export$d281fbfe3cff2df6 = '#3B475C';
var $c39414400ec87a3f$export$3902c91d8b98a753 = '#313D52';
var $c39414400ec87a3f$export$8e8133c1ba5845b5 = '#283447';
var $c39414400ec87a3f$export$33ff357f6620b39 = '#202B3D';
var $c39414400ec87a3f$export$633847cf062b69e0 = '#1B2638';
var $c39414400ec87a3f$export$9776a6e503bdbf76 = '#121A29';
var $c39414400ec87a3f$export$6c813d5160dff5db = '#0E1624';
var $c39414400ec87a3f$export$3d4f271a500072a = '#0D1424';
var $c39414400ec87a3f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c39414400ec87a3f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c39414400ec87a3f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c39414400ec87a3f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c39414400ec87a3f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c39414400ec87a3f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c39414400ec87a3f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c39414400ec87a3f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c39414400ec87a3f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c39414400ec87a3f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c39414400ec87a3f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c39414400ec87a3f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c39414400ec87a3f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c39414400ec87a3f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c39414400ec87a3f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c39414400ec87a3f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c39414400ec87a3f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c39414400ec87a3f$export$d2adc5dedf09fced = '#292A2E';
var $c39414400ec87a3f$export$f51762073d2bb381 = '#94C748';
var $c39414400ec87a3f$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("epZNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f3571866e8690a$export$2e2bcd8739ae039; });
function $a7f3571866e8690a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $a7f3571866e8690a$var$tabKeyCode = 9;
function $a7f3571866e8690a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $a7f3571866e8690a$var$tabKeyCode) return;
    $a7f3571866e8690a$var$abort(event);
}
var $a7f3571866e8690a$var$block = {
    onMouseDownCapture: $a7f3571866e8690a$var$abort,
    onMouseUpCapture: $a7f3571866e8690a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $a7f3571866e8690a$var$onKey,
    onKeyUpCapture: $a7f3571866e8690a$var$onKey,
    onTouchStartCapture: $a7f3571866e8690a$var$abort,
    onTouchEndCapture: $a7f3571866e8690a$var$abort,
    onPointerDownCapture: $a7f3571866e8690a$var$abort,
    onPointerUpCapture: $a7f3571866e8690a$var$abort,
    onClickCapture: $a7f3571866e8690a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $a7f3571866e8690a$var$abort
};
var $a7f3571866e8690a$var$doNotBlock = {};
function $a7f3571866e8690a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $a7f3571866e8690a$var$doNotBlock : $a7f3571866e8690a$var$block;
}

});

parcelRegister("2itye", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $1ac42f70122712cf$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $1ac42f70122712cf$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $1ac42f70122712cf$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $1ac42f70122712cf$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $1ac42f70122712cf$export$1a9fe1b84c876bb5; });

var $6bkHe = parcelRequire("6bkHe");

var $bl8w7 = parcelRequire("bl8w7");

var $i2LcI = parcelRequire("i2LcI");

var $8Bhge = parcelRequire("8Bhge");

var $lSyBF = parcelRequire("lSyBF");
function $1ac42f70122712cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ac42f70122712cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ac42f70122712cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ac42f70122712cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ac42f70122712cf$var$gridSize = (0, $8Bhge.gridSize)();
var $1ac42f70122712cf$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $1ac42f70122712cf$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: 'auto'
};
var $1ac42f70122712cf$var$lineHeights = {
    default: $1ac42f70122712cf$var$heights.default,
    compact: $1ac42f70122712cf$var$heights.compact,
    none: 'inherit'
};
var $1ac42f70122712cf$var$padding = {
    // 10px gutter
    default: "0 ".concat($1ac42f70122712cf$var$gridSize + $1ac42f70122712cf$var$gridSize / 4, "px"),
    compact: "0 ".concat($1ac42f70122712cf$var$gridSize + $1ac42f70122712cf$var$gridSize / 4, "px"),
    none: '0'
};
var $1ac42f70122712cf$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    default: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    none: '0'
};
var $1ac42f70122712cf$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $1ac42f70122712cf$var$innerMargin = {
    content: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    icon: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px")
};
var $1ac42f70122712cf$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
var $1ac42f70122712cf$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&::after': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
var $1ac42f70122712cf$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
var $1ac42f70122712cf$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
var $1ac42f70122712cf$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
var $1ac42f70122712cf$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
var $1ac42f70122712cf$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
var $1ac42f70122712cf$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
var $1ac42f70122712cf$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $1ac42f70122712cf$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $1ac42f70122712cf$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $1ac42f70122712cf$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $1ac42f70122712cf$var$getColor({
            group: (0, $lSyBF.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($1ac42f70122712cf$var$getColor({
            group: (0, $lSyBF.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $1ac42f70122712cf$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $1ac42f70122712cf$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, !(0, $i2LcI.fg)('platform-component-visual-refresh') && baseColors), {}, {
        cursor: 'pointer',
        height: $1ac42f70122712cf$var$heights[spacing],
        lineHeight: $1ac42f70122712cf$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $1ac42f70122712cf$var$singleIconPadding[spacing] : $1ac42f70122712cf$var$padding[spacing],
        verticalAlign: $1ac42f70122712cf$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center'
    }, !(0, $i2LcI.fg)('platform-component-visual-refresh') && $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        '&:visited': $1ac42f70122712cf$var$_objectSpread({}, baseColors),
        '&:hover': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        })
    }, $1ac42f70122712cf$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        }))
    })), (0, $i2LcI.fg)('platform-component-visual-refresh') && (isSelected ? $1ac42f70122712cf$var$selectedStyles : $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, appearance === 'default' && $1ac42f70122712cf$var$defaultStyles), appearance === 'primary' && $1ac42f70122712cf$var$primaryStyles), appearance === 'link' && $1ac42f70122712cf$var$linkStyles), appearance === 'subtle' && $1ac42f70122712cf$var$subtleStyles), appearance === 'subtle-link' && $1ac42f70122712cf$var$subtleLinkStyles), appearance === 'warning' && $1ac42f70122712cf$var$warningStyles), appearance === 'danger' && $1ac42f70122712cf$var$dangerStyles), {}, {
        '&[disabled]': {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $1ac42f70122712cf$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
            cursor: 'not-allowed',
            textDecoration: 'none',
            '&:hovered': {
                backgroundColor: $1ac42f70122712cf$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            },
            '&:active': {
                backgroundColor: $1ac42f70122712cf$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
            }
        }
    }, $1ac42f70122712cf$var$hasOverlayStyles))), {}, {
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $1ac42f70122712cf$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $bl8w7.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $1ac42f70122712cf$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $1ac42f70122712cf$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $bl8w7.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $1ac42f70122712cf$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $1ac42f70122712cf$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $bl8w7.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $1ac42f70122712cf$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("8Bhge", function(module, exports) {

$parcel$export(module.exports, "gridSize", function () { return $642f2b17663b61ab$export$6d8204c2cb2e06b8; });

var $5pPqr = parcelRequire("5pPqr");

var $gN3Go = parcelRequire("gN3Go");
var $642f2b17663b61ab$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $642f2b17663b61ab$export$c93026a968943f95 = 'light';
var $642f2b17663b61ab$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $642f2b17663b61ab$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $642f2b17663b61ab$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $gN3Go.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $642f2b17663b61ab$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $642f2b17663b61ab$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $642f2b17663b61ab$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $642f2b17663b61ab$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $642f2b17663b61ab$export$ba1d834b86d72a09 = $642f2b17663b61ab$export$a1b3edb637fb4f35;
var $642f2b17663b61ab$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $gN3Go.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $gN3Go.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $gN3Go.N30A), ")")
            }
        }
    };
};

});

parcelRegister("lSyBF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fed97c43eb5a3952$export$2e2bcd8739ae039; });

var $gN3Go = parcelRequire("gN3Go");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $fed97c43eb5a3952$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $fed97c43eb5a3952$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($gN3Go.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($gN3Go.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($gN3Go.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($gN3Go.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($fed97c43eb5a3952$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($gN3Go.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($gN3Go.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($gN3Go.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($gN3Go.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($gN3Go.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($gN3Go.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($gN3Go.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($gN3Go.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($gN3Go.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($gN3Go.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($gN3Go.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($gN3Go.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($gN3Go.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($gN3Go.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($gN3Go.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($gN3Go.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($gN3Go.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($gN3Go.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($gN3Go.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($gN3Go.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($gN3Go.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($gN3Go.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($gN3Go.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($gN3Go.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($gN3Go.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($gN3Go.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($gN3Go.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($gN3Go.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($gN3Go.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($fed97c43eb5a3952$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($gN3Go.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.DN0, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($gN3Go.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($gN3Go.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($gN3Go.N500, ")"),
                dark: "var(--ds-text, ".concat($gN3Go.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($gN3Go.B400, ")"),
                dark: "var(--ds-text, ".concat($gN3Go.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($gN3Go.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($gN3Go.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($gN3Go.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($gN3Go.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($gN3Go.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($gN3Go.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($gN3Go.B400, ")"),
                dark: "var(--ds-link, ".concat($gN3Go.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($gN3Go.B300, ")"),
                dark: "var(--ds-link, ".concat($gN3Go.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($gN3Go.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($gN3Go.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($gN3Go.N500, ")"),
                dark: "var(--ds-text, ".concat($gN3Go.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($gN3Go.B400, ")"),
                dark: "var(--ds-text, ".concat($gN3Go.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($gN3Go.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($gN3Go.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($gN3Go.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($gN3Go.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($gN3Go.N400, ")"),
                dark: "var(--ds-text, ".concat($gN3Go.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($gN3Go.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($gN3Go.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($gN3Go.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($gN3Go.DN400, ")")
            }
        }
    }
};
var $fed97c43eb5a3952$export$2e2bcd8739ae039 = $fed97c43eb5a3952$var$values;

});


parcelRegister("bJJt2", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $88b72a924d2c352b$export$20bbd2efb0d734c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $73a5X = parcelRequire("73a5X");
var $88b72a924d2c352b$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $8ZuGG.isValidElement)(children) && children.type === (0, $73a5X.default);
};

});


parcelRegister("7yjH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fafc2857d60eef$export$2e2bcd8739ae039; });

var $bJJt2 = parcelRequire("bJJt2");
function $57fafc2857d60eef$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("7GSOz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5996f9b04030c224$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $cufV0 = parcelRequire("cufV0");
function $5996f9b04030c224$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5996f9b04030c224$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cufV0.default), {
        size: size,
        label: ", Loading",
        appearance: $5996f9b04030c224$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("bwz7O", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", function () { return $863dedf3265abd30$export$643db0b8d8778e; });
$parcel$export(module.exports, "defaultThemeFn", function () { return $863dedf3265abd30$export$437a7f77d13d7916; });
$parcel$export(module.exports, "default", function () { return $863dedf3265abd30$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $3Mk2r = parcelRequire("3Mk2r");

var $2itye = parcelRequire("2itye");
function $863dedf3265abd30$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $863dedf3265abd30$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $863dedf3265abd30$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $863dedf3265abd30$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $863dedf3265abd30$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $863dedf3265abd30$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $2itye.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $863dedf3265abd30$var$stateToSelectorMap[state];
    if (selector) result = $863dedf3265abd30$var$_objectSpread($863dedf3265abd30$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $863dedf3265abd30$var$_objectSpread($863dedf3265abd30$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $863dedf3265abd30$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $863dedf3265abd30$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $863dedf3265abd30$var$Theme = (0, $3Mk2r.createTheme)(function(themeProps) {
    return {
        buttonStyles: $863dedf3265abd30$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$863dedf3265abd30$export$2e2bcd8739ae039 = $863dedf3265abd30$var$Theme;

});


parcelRegister("dfOpk", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", function () { return $9a63c6f93d170bef$export$59e42969c95d314; });
$parcel$export(module.exports, "flagIconColor", function () { return $9a63c6f93d170bef$export$7f70afe2167f8235; });
$parcel$export(module.exports, "flagIconGlyph", function () { return $9a63c6f93d170bef$export$73f08aee70487cd4; });
$parcel$export(module.exports, "flagTextColor", function () { return $9a63c6f93d170bef$export$f50075b2584087f; });
$parcel$export(module.exports, "flagTextColorToken", function () { return $9a63c6f93d170bef$export$13b42cd9d596bfe0; });
$parcel$export(module.exports, "actionBackgroundColor", function () { return $9a63c6f93d170bef$export$81ba6b63eedb299f; });
$parcel$export(module.exports, "actionTextColor", function () { return $9a63c6f93d170bef$export$7bcfe3cca4dd78b6; });

var $8ZuGG = parcelRequire("8ZuGG");

var $csm6Z = parcelRequire("csm6Z");

var $ki55E = parcelRequire("ki55E");

var $7uAQ0 = parcelRequire("7uAQ0");

var $4ESQ1 = parcelRequire("4ESQ1");

var $fDysZ = parcelRequire("fDysZ");
var $9a63c6f93d170bef$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
var $9a63c6f93d170bef$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
var $9a63c6f93d170bef$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($csm6Z))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $fDysZ.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ki55E))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $fDysZ.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ki55E))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-subtle, ".concat((0, $fDysZ.N500), ")"),
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7uAQ0))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-inverse, ".concat((0, $fDysZ.N0), ")"),
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ESQ1))), {
        label: "",
        LEGACY_primaryColor: "var(--ds-icon-warning-inverse, ".concat((0, $fDysZ.N700), ")"),
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
var $9a63c6f93d170bef$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
var $9a63c6f93d170bef$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $fDysZ.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $fDysZ.N700), ")")
};
var $9a63c6f93d170bef$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $fDysZ.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $fDysZ.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $fDysZ.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $fDysZ.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $fDysZ.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $fDysZ.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $fDysZ.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $fDysZ.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $fDysZ.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $fDysZ.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $fDysZ.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $fDysZ.N30A), ")")
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
var $9a63c6f93d170bef$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $fDysZ.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $fDysZ.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $fDysZ.B400), ")")
};

});
parcelRegister("csm6Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $911940829178476e$var$_react = $911940829178476e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $911940829178476e$var$_statusError = $911940829178476e$var$_interopRequireDefault((parcelRequire("ftN8x")));

var $911940829178476e$var$_error = $911940829178476e$var$_interopRequireDefault((parcelRequire("9FI1U")));
function $911940829178476e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $911940829178476e$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $911940829178476e$var$_react.default.createElement($911940829178476e$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $911940829178476e$var$_error.default
    }, props));
$911940829178476e$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $911940829178476e$var$_default = module.exports.default = $911940829178476e$var$StatusErrorIcon;

});

parcelRegister("ki55E", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec596fe5d48a7eef$var$_react = $ec596fe5d48a7eef$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $ec596fe5d48a7eef$var$_statusInformation = $ec596fe5d48a7eef$var$_interopRequireDefault((parcelRequire("1lZld")));

var $ec596fe5d48a7eef$var$_info = $ec596fe5d48a7eef$var$_interopRequireDefault((parcelRequire("EjRAH")));
function $ec596fe5d48a7eef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec596fe5d48a7eef$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $ec596fe5d48a7eef$var$_react.default.createElement($ec596fe5d48a7eef$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $ec596fe5d48a7eef$var$_info.default
    }, props));
$ec596fe5d48a7eef$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $ec596fe5d48a7eef$var$_default = module.exports.default = $ec596fe5d48a7eef$var$StatusInformationIcon;

});

parcelRegister("7uAQ0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5747e8f9a30acf36$var$_react = $5747e8f9a30acf36$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5747e8f9a30acf36$var$_statusSuccess = $5747e8f9a30acf36$var$_interopRequireDefault((parcelRequire("giUvX")));

var $5747e8f9a30acf36$var$_checkCircle = $5747e8f9a30acf36$var$_interopRequireDefault((parcelRequire("chIZR")));
function $5747e8f9a30acf36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5747e8f9a30acf36$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $5747e8f9a30acf36$var$_react.default.createElement($5747e8f9a30acf36$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $5747e8f9a30acf36$var$_checkCircle.default
    }, props));
$5747e8f9a30acf36$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $5747e8f9a30acf36$var$_default = module.exports.default = $5747e8f9a30acf36$var$StatusSuccessIcon;

});

parcelRegister("4ESQ1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36456f8c8030a2ef$var$_react = $36456f8c8030a2ef$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $36456f8c8030a2ef$var$_statusWarning = $36456f8c8030a2ef$var$_interopRequireDefault((parcelRequire("gATjA")));

var $36456f8c8030a2ef$var$_warning = $36456f8c8030a2ef$var$_interopRequireDefault((parcelRequire("6wKXL")));
function $36456f8c8030a2ef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $36456f8c8030a2ef$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $36456f8c8030a2ef$var$_react.default.createElement($36456f8c8030a2ef$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $36456f8c8030a2ef$var$_warning.default
    }, props));
$36456f8c8030a2ef$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $36456f8c8030a2ef$var$_default = module.exports.default = $36456f8c8030a2ef$var$StatusWarningIcon;

});

parcelRegister("fDysZ", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $b6253be17f02dfb7$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $b6253be17f02dfb7$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $b6253be17f02dfb7$export$29a4f05edc054374; });
$parcel$export(module.exports, "N500", function () { return $b6253be17f02dfb7$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N700", function () { return $b6253be17f02dfb7$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $b6253be17f02dfb7$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N20A", function () { return $b6253be17f02dfb7$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $b6253be17f02dfb7$export$920c0d5c49070351; });
// Reds
var $b6253be17f02dfb7$export$4b84fd0e2c617bd = '#FFEBE6';
var $b6253be17f02dfb7$export$b34b069eff244586 = '#FFBDAD';
var $b6253be17f02dfb7$export$be802dd0d8b57f35 = '#FF8F73';
var $b6253be17f02dfb7$export$60847d42f9da92a6 = '#FF7452';
var $b6253be17f02dfb7$export$4a7404f376229999 = '#FF5630';
var $b6253be17f02dfb7$export$2010d0fb4295b346 = '#DE350B';
var $b6253be17f02dfb7$export$2837b5a1a71d5c02 = '#BF2600';
var $b6253be17f02dfb7$export$8d9596b529bbb9cf = '#FFFAE6';
var $b6253be17f02dfb7$export$41060a744ab0b7ae = '#FFF0B3';
var $b6253be17f02dfb7$export$1cc05bbbf340e559 = '#FFE380';
var $b6253be17f02dfb7$export$5aae31392d72caaa = '#FFC400';
var $b6253be17f02dfb7$export$c6930421db9fa514 = '#FFAB00';
var $b6253be17f02dfb7$export$59619663aa6500fb = '#FF991F';
var $b6253be17f02dfb7$export$874739ea9e379ab6 = '#FF8B00';
var $b6253be17f02dfb7$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $b6253be17f02dfb7$export$69a3bf21b9686c2b = '#ABF5D1';
var $b6253be17f02dfb7$export$afbce1382ec95f73 = '#79F2C0';
var $b6253be17f02dfb7$export$747d86715d4175de = '#57D9A3';
var $b6253be17f02dfb7$export$940e1f69e873f202 = '#36B37E';
var $b6253be17f02dfb7$export$a49394138f7b8e85 = '#00875A';
var $b6253be17f02dfb7$export$6fa04827ac68a4fb = '#006644';
var $b6253be17f02dfb7$export$226de0355ed012f8 = '#DEEBFF';
var $b6253be17f02dfb7$export$8c13c2ee36917869 = '#B3D4FF';
var $b6253be17f02dfb7$export$ecfc1dff386a3e7a = '#4C9AFF';
var $b6253be17f02dfb7$export$215b7063051591f1 = '#2684FF';
var $b6253be17f02dfb7$export$e62e8919cca44969 = '#0065FF';
var $b6253be17f02dfb7$export$b3de0ae08da2ce64 = '#0052CC';
var $b6253be17f02dfb7$export$a6ee3d71bc067634 = '#0747A6';
var $b6253be17f02dfb7$export$67f15409e87642a1 = '#669DF1';
var $b6253be17f02dfb7$export$f0539dbc42dbb067 = '#8FB8F6';
var $b6253be17f02dfb7$export$363e4475840015bb = '#EAE6FF';
var $b6253be17f02dfb7$export$4b0a4417ed59760f = '#C0B6F2';
var $b6253be17f02dfb7$export$6011520a64d9a187 = '#998DD9';
var $b6253be17f02dfb7$export$a7175d4e9206bc80 = '#8777D9';
var $b6253be17f02dfb7$export$b48405b95304b5a1 = '#6554C0';
var $b6253be17f02dfb7$export$c71e4279dd54a18d = '#5243AA';
var $b6253be17f02dfb7$export$147899de772240ec = '#403294';
var $b6253be17f02dfb7$export$2cf711fe14c66f06 = '#E6FCFF';
var $b6253be17f02dfb7$export$7a8f4d33f6f9772c = '#B3F5FF';
var $b6253be17f02dfb7$export$776c9c497ef08533 = '#79E2F2';
var $b6253be17f02dfb7$export$69cb3ca10c1e330e = '#00C7E6';
var $b6253be17f02dfb7$export$9dc1ef0f3f48059b = '#00B8D9';
var $b6253be17f02dfb7$export$7c835c78b6fcdef8 = '#00A3BF';
var $b6253be17f02dfb7$export$6036577f95c3877e = '#008DA6';
var $b6253be17f02dfb7$export$29a4f05edc054374 = '#FFFFFF';
var $b6253be17f02dfb7$export$e655ef011c4aa1a2 = '#FAFBFC';
var $b6253be17f02dfb7$export$9fdfb749e33cdf97 = '#F4F5F7';
var $b6253be17f02dfb7$export$3e51e8f1440314ba = '#EBECF0';
var $b6253be17f02dfb7$export$1ce2d1575d444ceb = '#DFE1E6';
var $b6253be17f02dfb7$export$8754fc7e6d8b3000 = '#C1C7D0';
var $b6253be17f02dfb7$export$c2e91cbeada39b8b = '#B3BAC5';
var $b6253be17f02dfb7$export$5f71e19f3a7ad9de = '#A5ADBA';
var $b6253be17f02dfb7$export$eaa8c8a70ac22806 = '#97A0AF';
var $b6253be17f02dfb7$export$7c87d337fb91a97d = '#8993A4';
var $b6253be17f02dfb7$export$d6447c357493214f = '#7A869A';
var $b6253be17f02dfb7$export$f563ee71e9ee74cd = '#6B778C';
var $b6253be17f02dfb7$export$e2ef2124cf4024b1 = '#5E6C84';
var $b6253be17f02dfb7$export$eece5f492e429f08 = '#505F79';
var $b6253be17f02dfb7$export$c39c0fe0f26207ae = '#42526E';
var $b6253be17f02dfb7$export$7090862dc3038a9f = '#344563';
var $b6253be17f02dfb7$export$ad0bacf983b7ddaa = '#253858';
var $b6253be17f02dfb7$export$7d61b15e0da132af = '#172B4D';
var $b6253be17f02dfb7$export$fbda843f0a27fe96 = '#091E42';
var $b6253be17f02dfb7$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $b6253be17f02dfb7$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $b6253be17f02dfb7$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $b6253be17f02dfb7$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $b6253be17f02dfb7$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $b6253be17f02dfb7$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $b6253be17f02dfb7$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $b6253be17f02dfb7$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $b6253be17f02dfb7$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $b6253be17f02dfb7$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $b6253be17f02dfb7$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $b6253be17f02dfb7$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $b6253be17f02dfb7$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $b6253be17f02dfb7$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $b6253be17f02dfb7$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $b6253be17f02dfb7$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $b6253be17f02dfb7$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $b6253be17f02dfb7$export$2f6319cf7d736c2a = '#E6EDFA';
var $b6253be17f02dfb7$export$95126bc8884d6634 = '#DCE5F5';
var $b6253be17f02dfb7$export$8338d8c35d44ff1 = '#CED9EB';
var $b6253be17f02dfb7$export$5368d76ae4fbbda7 = '#B8C7E0';
var $b6253be17f02dfb7$export$9f0a771d16ec8d36 = '#ABBBD6';
var $b6253be17f02dfb7$export$abcf8c38338b4aa5 = '#9FB0CC';
var $b6253be17f02dfb7$export$97e81faa16a182c7 = '#8C9CB8';
var $b6253be17f02dfb7$export$bfe21c59123ecf33 = '#7988A3';
var $b6253be17f02dfb7$export$ee82aa2ea6a1558 = '#67758F';
var $b6253be17f02dfb7$export$682927c6ed76be02 = '#56637A';
var $b6253be17f02dfb7$export$91fd9994c5be9757 = '#455166';
var $b6253be17f02dfb7$export$d281fbfe3cff2df6 = '#3B475C';
var $b6253be17f02dfb7$export$3902c91d8b98a753 = '#313D52';
var $b6253be17f02dfb7$export$8e8133c1ba5845b5 = '#283447';
var $b6253be17f02dfb7$export$33ff357f6620b39 = '#202B3D';
var $b6253be17f02dfb7$export$633847cf062b69e0 = '#1B2638';
var $b6253be17f02dfb7$export$9776a6e503bdbf76 = '#121A29';
var $b6253be17f02dfb7$export$6c813d5160dff5db = '#0E1624';
var $b6253be17f02dfb7$export$3d4f271a500072a = '#0D1424';
var $b6253be17f02dfb7$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $b6253be17f02dfb7$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $b6253be17f02dfb7$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $b6253be17f02dfb7$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $b6253be17f02dfb7$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $b6253be17f02dfb7$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $b6253be17f02dfb7$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $b6253be17f02dfb7$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $b6253be17f02dfb7$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $b6253be17f02dfb7$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $b6253be17f02dfb7$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $b6253be17f02dfb7$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $b6253be17f02dfb7$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $b6253be17f02dfb7$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $b6253be17f02dfb7$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $b6253be17f02dfb7$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $b6253be17f02dfb7$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $b6253be17f02dfb7$export$d2adc5dedf09fced = '#292A2E';
var $b6253be17f02dfb7$export$f51762073d2bb381 = '#94C748';
var $b6253be17f02dfb7$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("3Hvr7", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", function () { return $2b1dc5e26d0b22ea$export$e91ea202abb66350; });
$parcel$export(module.exports, "default", function () { return $2b1dc5e26d0b22ea$export$2e2bcd8739ae039; });
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $5AVd4 = parcelRequire("5AVd4");

var $9cyTu = parcelRequire("9cyTu");
var $7zMT4 = parcelRequire("7zMT4");

var $jTcCE = parcelRequire("jTcCE");

var $h1GZm = parcelRequire("h1GZm");

var $73a5X = parcelRequire("73a5X");
var $2b1dc5e26d0b22ea$export$1eee5ddc4f6d41c5 = 400;
var $2b1dc5e26d0b22ea$var$defaultFlagGroupContext = {
    onDismissed: (0, $5AVd4.default),
    isDismissAllowed: false
};
var $2b1dc5e26d0b22ea$export$c57ba665aaa722be = /*#__PURE__*/ (0, $8ZuGG.createContext)($2b1dc5e26d0b22ea$var$defaultFlagGroupContext);
function $2b1dc5e26d0b22ea$export$e91ea202abb66350() {
    return (0, $8ZuGG.useContext)($2b1dc5e26d0b22ea$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $2b1dc5e26d0b22ea$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $2b1dc5e26d0b22ea$var$dismissAllowedStyles = null;
var $2b1dc5e26d0b22ea$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $2b1dc5e26d0b22ea$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? 'Flag notifications' : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? 'h2' : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $5AVd4.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $8ZuGG.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(children) === 'object' ? (0, $8ZuGG.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return /*#__PURE__*/ $8ZuGG.createElement((0, $7zMT4.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in"
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return /*#__PURE__*/ $8ZuGG.createElement("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $c4hjl.default)([
                        $2b1dc5e26d0b22ea$var$groupStyles.root,
                        index === 0 && $2b1dc5e26d0b22ea$var$groupStyles.first,
                        index === 1 && $2b1dc5e26d0b22ea$var$groupStyles.second,
                        index >= 1 && $2b1dc5e26d0b22ea$var$groupStyles.nth,
                        index >= 2 && $2b1dc5e26d0b22ea$var$groupStyles.hidden,
                        isDismissAllowed && "_12a7luct",
                        className
                    ]),
                    ref: ref
                }, /*#__PURE__*/ $8ZuGG.createElement($2b1dc5e26d0b22ea$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $2b1dc5e26d0b22ea$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = /*#__PURE__*/ $8ZuGG.createElement("div", {
        id: id,
        className: (0, $c4hjl.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ])
    }, hasFlags ? /*#__PURE__*/ $8ZuGG.createElement((0, $73a5X.default), null, /*#__PURE__*/ $8ZuGG.createElement(LabelTag, null, label)) : null, /*#__PURE__*/ $8ZuGG.createElement((0, $9cyTu.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : /*#__PURE__*/ $8ZuGG.createElement((0, $jTcCE.default), {
        zIndex: (0, $h1GZm.layers).flag()
    }, flags);
};
var $2b1dc5e26d0b22ea$export$2e2bcd8739ae039 = $2b1dc5e26d0b22ea$var$FlagGroup;

});
parcelRegister("7zMT4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5841b9425df56f89$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1pve = parcelRequire("k1pve");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $5841b9425df56f89$var$SlideIn = function SlideIn(_ref) {
    var children = _ref.children, enterFrom = _ref.enterFrom, exitTo = _ref.exitTo, _ref$fade = _ref.fade, fade = _ref$fade === void 0 ? 'none' : _ref$fade, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 'medium' : _ref$duration, isPaused = _ref.isPaused, onFinish = _ref.onFinish, _ref$animationTimingF = _ref.animationTimingFunction, animationTimingFunction = _ref$animationTimingF === void 0 ? 'ease-out' : _ref$animationTimingF, _ref$animationTimingF2 = _ref.animationTimingFunctionExiting, animationTimingFunctionExiting = _ref$animationTimingF2 === void 0 ? 'ease-in' : _ref$animationTimingF2;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $k1pve.default), {
        duration: duration,
        enteringAnimation: "slide-in-from-".concat(enterFrom),
        exitingAnimation: "slide-out-from-".concat(exitTo || enterFrom),
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $5841b9425df56f89$export$2e2bcd8739ae039 = $5841b9425df56f89$var$SlideIn;

});

parcelRegister("h1GZm", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $c653e04ea85a9038$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $fDysZ = parcelRequire("fDysZ");
var $c653e04ea85a9038$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $c653e04ea85a9038$export$c93026a968943f95 = 'light';
var $c653e04ea85a9038$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $c653e04ea85a9038$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $c653e04ea85a9038$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $fDysZ.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $c653e04ea85a9038$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $c653e04ea85a9038$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $c653e04ea85a9038$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $c653e04ea85a9038$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $c653e04ea85a9038$export$ba1d834b86d72a09 = $c653e04ea85a9038$export$a1b3edb637fb4f35;
var $c653e04ea85a9038$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $fDysZ.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $fDysZ.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $fDysZ.N30A), ")")
            }
        }
    };
};

});


parcelRegister("5EPVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41e8f6b60a267fb7$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $1fdMd = parcelRequire("1fdMd");

var $fERIl = parcelRequire("fERIl");

var $hmIVj = parcelRequire("hmIVj");

var $cn07l = parcelRequire("cn07l");

var $dfOpk = parcelRequire("dfOpk");
var $41e8f6b60a267fb7$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cn07l)));
    var buttonLabel = 'Dismiss';
    var size = 'small';
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($hmIVj))) : (0, (/*@__PURE__*/$parcel$interopDefault($fERIl)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1fdMd.default), {
        icon: function icon(iconProps) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ButtonIcon, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, iconProps, {
                LEGACY_size: size,
                size: "small",
                label: "",
                color: (0, $dfOpk.flagTextColorToken)[appearance]
            }));
        },
        appearance: "subtle",
        spacing: "compact",
        label: buttonLabel,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    });
};
var $41e8f6b60a267fb7$var$DismissButton = /*#__PURE__*/ (0, $8ZuGG.memo)($41e8f6b60a267fb7$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$41e8f6b60a267fb7$export$2e2bcd8739ae039 = $41e8f6b60a267fb7$var$DismissButton;

});
parcelRegister("1fdMd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e81e0f036ca7a7a$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $30M5w = parcelRequire("30M5w");

var $8dRDh = parcelRequire("8dRDh");

var $73a5X = parcelRequire("73a5X");

var $f8m11 = parcelRequire("f8m11");

var $53JDY = parcelRequire("53JDY");

var $1Shg4 = parcelRequire("1Shg4");
var $0e81e0f036ca7a7a$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "analyticsContext",
    "appearance",
    "autoFocus",
    "icon",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isTooltipDisabled",
    "label",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shape",
    "spacing",
    "testId",
    "tooltip",
    "type"
], $0e81e0f036ca7a7a$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ var $0e81e0f036ca7a7a$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Button(_ref, ref) {
    var _tooltip$content;
    var preventedAriaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, autoFocus = _ref.autoFocus, icon = _ref.icon, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, _ref$isTooltipDisable = _ref.isTooltipDisabled, isTooltipDisabled = _ref$isTooltipDisable === void 0 ? true : _ref$isTooltipDisable, label = _ref.label, _onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shape = _ref.shape, spacing = _ref.spacing, testId = _ref.testId, tooltip = _ref.tooltip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $0e81e0f036ca7a7a$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(unsafeRest, $0e81e0f036ca7a7a$var$_excluded2);
    if (isTooltipDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $f8m11.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, saferRest, {
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: _onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $53JDY.default), {
        type: "icon",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1Shg4.default), {
        icon: icon
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $73a5X.default), null, label)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8dRDh.default), {
        content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
        testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
        position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
        delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
        onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
        onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
        mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
        analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
        strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
        tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
        truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
        component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
        hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip === null || tooltip === void 0 ? void 0 : tooltip.ignoreTooltipPointerEvents
    }, function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $f8m11.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, saferRest, {
            appearance: appearance,
            autoFocus: autoFocus,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isSelected: isSelected,
            isIconButton: true,
            isCircle: shape === 'circle',
            hasIconBefore: false,
            spacing: spacing,
            ariaLabelledBy: ariaLabelledBy,
            onClick: function onClick(e, analyticsEvent) {
                var _triggerProps$onClick;
                _onClick === null || _onClick === void 0 || _onClick(e, analyticsEvent);
                (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, e);
            },
            onMouseOver: function onMouseOver(e) {
                var _triggerProps$onMouse, _saferRest$onMouseOve;
                (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                (_saferRest$onMouseOve = saferRest.onMouseOver) === null || _saferRest$onMouseOve === void 0 || _saferRest$onMouseOve.call(saferRest, e);
            },
            onMouseOut: function onMouseOut(e) {
                var _triggerProps$onMouse2, _saferRest$onMouseOut;
                (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                (_saferRest$onMouseOut = saferRest.onMouseOut) === null || _saferRest$onMouseOut === void 0 || _saferRest$onMouseOut.call(saferRest, e);
            },
            onMouseMove: function onMouseMove(e) {
                var _triggerProps$onMouse3, _saferRest$onMouseMov;
                (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                (_saferRest$onMouseMov = saferRest.onMouseMove) === null || _saferRest$onMouseMov === void 0 || _saferRest$onMouseMov.call(saferRest, e);
            },
            onMouseDown: function onMouseDown(e) {
                var _triggerProps$onMouse4, _saferRest$onMouseDow;
                (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                (_saferRest$onMouseDow = saferRest.onMouseDown) === null || _saferRest$onMouseDow === void 0 || _saferRest$onMouseDow.call(saferRest, e);
            },
            onFocus: function onFocus(e) {
                var _triggerProps$onFocus, _saferRest$onFocus;
                (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                (_saferRest$onFocus = saferRest.onFocus) === null || _saferRest$onFocus === void 0 || _saferRest$onFocus.call(saferRest, e);
            },
            onBlur: function onBlur(e) {
                var _triggerProps$onBlur, _saferRest$onBlur;
                (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                (_saferRest$onBlur = saferRest.onBlur) === null || _saferRest$onBlur === void 0 || _saferRest$onBlur.call(saferRest, e);
            },
            ref: (0, $30M5w.default)([
                ref,
                triggerProps === null || triggerProps === void 0 ? void 0 : triggerProps.ref
            ].filter(Boolean)),
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture,
            type: type,
            testId: testId,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "IconButton"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $53JDY.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1Shg4.default), {
            icon: icon
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $73a5X.default), null, label)));
    });
}));
$0e81e0f036ca7a7a$var$IconButton.displayName = 'IconButton';
var $0e81e0f036ca7a7a$export$2e2bcd8739ae039 = $0e81e0f036ca7a7a$var$IconButton;

});
parcelRegister("30M5w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2316ac74cc2a468e$export$2e2bcd8739ae039; });
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $2316ac74cc2a468e$export$2e2bcd8739ae039(refs) {
    // TODO: could this be wrapped in `useCallback` so we get a stable function?
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("f8m11", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b048ae2d0399dc62$export$2e2bcd8739ae039; });
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");

var $25i4M = parcelRequire("25i4M");

var $30M5w = parcelRequire("30M5w");

var $c7GPs = parcelRequire("c7GPs");

var $iNlvH = parcelRequire("iNlvH");

var $i2LcI = parcelRequire("i2LcI");

var $4lDUI = parcelRequire("4lDUI");

var $73a5X = parcelRequire("73a5X");

var $bEhZN = parcelRequire("bEhZN");

var $dtpQx = parcelRequire("dtpQx");

var $6paHj = parcelRequire("6paHj");
var $b048ae2d0399dc62$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isLoading",
    "isSelected",
    "isIconButton",
    "isCircle",
    "hasIconBefore",
    "hasIconAfter",
    "shouldFitContainer",
    "spacing",
    "ariaLabel",
    "ariaLabelledBy",
    "children",
    "interactionName",
    "onClick",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onClickCapture",
    "testId",
    "analyticsContext",
    "componentName",
    "role",
    "onMouseOver",
    "onMouseOut",
    "onFocus",
    "onBlur",
    "onMouseMove",
    "type"
], $b048ae2d0399dc62$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $b048ae2d0399dc62$var$LOADING_LABEL = ', Loading';
var $b048ae2d0399dc62$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1lh4 _30l31lh4 _9h8h1lh4",
    sharedDisabled: "_bfhk1fvb _irr31fvb _1di61fvb",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
var $b048ae2d0399dc62$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr3yw9d _30l310s3 _1di6ih13 _9h8h10s3",
    interactiveRefreshed: "_irr3166n _30l31gjq _1di61dty _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $b048ae2d0399dc62$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $b048ae2d0399dc62$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _9h8hal3n",
    interactive: "_30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $b048ae2d0399dc62$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $b048ae2d0399dc62$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $b048ae2d0399dc62$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _30l310s3 _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1gjq _30l31gjq _9h8h1gjq",
    interactive: "_irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    interactiveRefreshed: "_irr34mfv _30l31gjq _1di619qy _9h8h1gjq",
    disabledRefreshed: "_bfhk1j28 _8l3m13gt _irr31j28 _1di61j28"
};
var $b048ae2d0399dc62$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _30l31pke _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3t71w _30l31pke _1di6yssv _9h8h1pke",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __button base__
 *
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ var $b048ae2d0399dc62$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function(_ref, ref) {
    var propAppearance = _ref.appearance, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, _ref$isDisabled = _ref.isDisabled, propIsDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isSelected = _ref.isSelected, propIsSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isIconButton = _ref.isIconButton, isIconButton = _ref$isIconButton === void 0 ? false : _ref$isIconButton, _ref$isCircle = _ref.isCircle, isCircle = _ref$isCircle === void 0 ? false : _ref$isCircle, _ref$hasIconBefore = _ref.hasIconBefore, hasIconBefore = _ref$hasIconBefore === void 0 ? false : _ref$hasIconBefore, _ref$hasIconAfter = _ref.hasIconAfter, hasIconAfter = _ref$hasIconAfter === void 0 ? false : _ref$hasIconAfter, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, propSpacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, ariaLabel = _ref.ariaLabel, ariaLabelledBy = _ref.ariaLabelledBy, children = _ref.children, interactionName = _ref.interactionName, onClick = _ref.onClick, onMouseDown = _ref.onMouseDown, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUp = _ref.onMouseUp, onMouseUpCapture = _ref.onMouseUpCapture, onKeyDown = _ref.onKeyDown, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUp = _ref.onKeyUp, onKeyUpCapture = _ref.onKeyUpCapture, onTouchStart = _ref.onTouchStart, onTouchStartCapture = _ref.onTouchStartCapture, onTouchEnd = _ref.onTouchEnd, onTouchEndCapture = _ref.onTouchEndCapture, onPointerDown = _ref.onPointerDown, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUp = _ref.onPointerUp, onPointerUpCapture = _ref.onPointerUpCapture, onClickCapture = _ref.onClickCapture, testId = _ref.testId, analyticsContext = _ref.analyticsContext, componentName = _ref.componentName, role = _ref.role, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onMouseMove = _ref.onMouseMove, type = _ref.type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $b048ae2d0399dc62$var$_excluded);
    var localRef = (0, $8ZuGG.useRef)(null);
    var splitButtonContext = (0, $bEhZN.useSplitButtonContext)();
    var loadingLabelId = (0, $iNlvH.useId)();
    var isSplitButton = Boolean(splitButtonContext);
    var isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    var isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    var appearance = isDefaultAppearanceSplitButton && (0, $i2LcI.fg)('platform-component-visual-refresh') ? 'subtle' : propAppearance || (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || 'default';
    var spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    var isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    var isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    var isEffectivelyDisabled = isDisabled || isLoading;
    var isSelected = propIsSelected && !isDisabled;
    (0, $c7GPs.default)(localRef, autoFocus);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(unsafeRest, $b048ae2d0399dc62$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4lDUI.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, saferRest, {
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $30M5w.default)([
            localRef,
            ref
        ]),
        xcss: (0, $25i4M.cx)($b048ae2d0399dc62$var$styles.base, appearance === 'default' && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$defaultStyles.rootRefreshed : $b048ae2d0399dc62$var$defaultStyles.root), appearance === 'default' && isInteractive && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$defaultStyles.interactiveRefreshed : $b048ae2d0399dc62$var$defaultStyles.interactive), appearance === 'primary' && $b048ae2d0399dc62$var$primaryStyles.root, appearance === 'primary' && isInteractive && $b048ae2d0399dc62$var$primaryStyles.interactive, appearance === 'warning' && $b048ae2d0399dc62$var$warningStyles.root, appearance === 'warning' && isInteractive && $b048ae2d0399dc62$var$warningStyles.interactive, appearance === 'danger' && $b048ae2d0399dc62$var$dangerStyles.root, appearance === 'danger' && isInteractive && $b048ae2d0399dc62$var$dangerStyles.interactive, appearance === 'discovery' && $b048ae2d0399dc62$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $b048ae2d0399dc62$var$discoveryStyles.interactive, appearance === 'subtle' && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$subtleStyles.rootRefreshed : $b048ae2d0399dc62$var$subtleStyles.root), appearance === 'subtle' && isInteractive && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$subtleStyles.interactiveRefreshed : $b048ae2d0399dc62$var$subtleStyles.interactive), $b048ae2d0399dc62$var$styles.linkDecorationUnset, isSelected && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$selectedStyles.rootRefreshed : $b048ae2d0399dc62$var$selectedStyles.root), isSelected && isSplitButton && $b048ae2d0399dc62$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $b048ae2d0399dc62$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $b048ae2d0399dc62$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $b048ae2d0399dc62$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $b048ae2d0399dc62$var$selectedStyles.discovery, isDisabled && $b048ae2d0399dc62$var$styles.disabled, isDisabled && (!(0, $i2LcI.fg)('platform-component-visual-refresh') || appearance !== 'default' && appearance !== 'subtle') && $b048ae2d0399dc62$var$styles.sharedDisabled, isDisabled && appearance === 'default' && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $b048ae2d0399dc62$var$defaultStyles.disabledRefreshed : $b048ae2d0399dc62$var$defaultStyles.disabled), isCircle && !isSplitButton && $b048ae2d0399dc62$var$styles.circle, spacing === 'compact' && $b048ae2d0399dc62$var$styles.spacingCompact, hasIconBefore && $b048ae2d0399dc62$var$styles.buttonIconBefore, shouldFitContainer && $b048ae2d0399dc62$var$styles.fullWidth, hasIconAfter && $b048ae2d0399dc62$var$styles.buttonIconAfter, isIconButton && $b048ae2d0399dc62$var$styles.iconButton, isIconButton && spacing === 'compact' && $b048ae2d0399dc62$var$styles.iconButtonCompact, isLoading && $b048ae2d0399dc62$var$styles.loading, isSplitButton && $b048ae2d0399dc62$var$styles.splitButton, isNavigationSplitButton && $b048ae2d0399dc62$var$styles.navigationSplitButton),
        isDisabled: isEffectivelyDisabled,
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? "".concat(ariaLabel, " ").concat($b048ae2d0399dc62$var$LOADING_LABEL) : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(loadingLabelId) : ariaLabelledBy,
        onClick: onClick
    }, (0, $dtpQx.default)(isEffectivelyDisabled, {
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture
    }), {
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bEhZN.SplitButtonContext).Provider, {
        value: undefined
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        className: (0, $c4hjl.default)([
            $b048ae2d0399dc62$var$styles.loadingOverlay
        ])
    }, (0, $6paHj.default)({
        spacing: spacing,
        appearance: appearance,
        isDisabled: isDisabled,
        isSelected: isSelected,
        testId: testId
    })), isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $73a5X.default), {
        id: loadingLabelId
    }, $b048ae2d0399dc62$var$LOADING_LABEL)));
});
var $b048ae2d0399dc62$export$2e2bcd8739ae039 = $b048ae2d0399dc62$var$ButtonBase;

});
parcelRegister("bEhZN", function(module, exports) {

$parcel$export(module.exports, "SplitButtonContext", function () { return $87b163b39b1df387$export$4b86304b2c0d7e71; });
$parcel$export(module.exports, "useSplitButtonContext", function () { return $87b163b39b1df387$export$47e2c6fdb142d947; });

var $8ZuGG = parcelRequire("8ZuGG");
var $87b163b39b1df387$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
var $87b163b39b1df387$export$47e2c6fdb142d947 = function useSplitButtonContext() {
    var context = (0, $8ZuGG.useContext)($87b163b39b1df387$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        var newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    var splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("dtpQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cf2085f7d6366de$export$2e2bcd8739ae039; });
function $9cf2085f7d6366de$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $9cf2085f7d6366de$var$tabKeyCode = 9;
function $9cf2085f7d6366de$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $9cf2085f7d6366de$var$tabKeyCode) return;
    $9cf2085f7d6366de$var$abort(event);
}
function $9cf2085f7d6366de$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $9cf2085f7d6366de$var$abort,
        onMouseUpCapture: $9cf2085f7d6366de$var$abort,
        onKeyDownCapture: $9cf2085f7d6366de$var$onKey,
        onKeyUpCapture: $9cf2085f7d6366de$var$onKey,
        onTouchStartCapture: $9cf2085f7d6366de$var$abort,
        onTouchEndCapture: $9cf2085f7d6366de$var$abort,
        onPointerDownCapture: $9cf2085f7d6366de$var$abort,
        onPointerUpCapture: $9cf2085f7d6366de$var$abort,
        onClickCapture: $9cf2085f7d6366de$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $9cf2085f7d6366de$var$abort
    } : events;
}

});

parcelRegister("6paHj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a9d602b293f818b$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $cufV0 = parcelRequire("cufV0");
function $4a9d602b293f818b$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $4a9d602b293f818b$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $4a9d602b293f818b$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, spacing = _ref2.spacing, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cufV0.default), {
        size: $4a9d602b293f818b$var$getIconSpacing(spacing),
        appearance: $4a9d602b293f818b$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? "".concat(testId, "--loading-spinner") : undefined
    });
}

});


parcelRegister("53JDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3af0a37165fff968$export$2e2bcd8739ae039; });
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");
var $3af0a37165fff968$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ var $3af0a37165fff968$var$Content = function Content(_ref) {
    var children = _ref.children, _ref$type = _ref.type, type = _ref$type === void 0 ? 'text' : _ref$type, isLoading = _ref.isLoading, position = _ref.position;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        className: (0, $c4hjl.default)([
            $3af0a37165fff968$var$styles.common,
            type === 'text' && $3af0a37165fff968$var$styles.text,
            type === 'icon' && $3af0a37165fff968$var$styles.icon,
            isLoading && $3af0a37165fff968$var$styles.fade,
            position === 'before' && $3af0a37165fff968$var$styles.beforeIcon,
            position === 'after' && $3af0a37165fff968$var$styles.afterIcon
        ])
    }, children);
};
var $3af0a37165fff968$export$2e2bcd8739ae039 = $3af0a37165fff968$var$Content;

});

parcelRegister("1Shg4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15d838b737a0556a$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");
function $15d838b737a0556a$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ var $15d838b737a0556a$var$IconRenderer = function IconRenderer(_ref) {
    var Icon = _ref.icon;
    var isRenderProp = $15d838b737a0556a$var$isIconRenderProp(Icon);
    var iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $i2LcI.fg)('platform_dst_button_chevron_sizing') ? function(iconName) {
            return iconName.startsWith('Chevron') ? 'small' : 'medium';
        } : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Icon, iconProps));
};
var $15d838b737a0556a$export$2e2bcd8739ae039 = $15d838b737a0556a$var$IconRenderer;

});


parcelRegister("fERIl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::119fcb233ad7d2568bcc63888dfec4d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b66441f878ed2c9c$var$_react = $b66441f878ed2c9c$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $b66441f878ed2c9c$var$_chevronDown = $b66441f878ed2c9c$var$_interopRequireDefault((parcelRequire("aQG1A")));

var $b66441f878ed2c9c$var$_chevronDown2 = $b66441f878ed2c9c$var$_interopRequireDefault((parcelRequire("8mTPQ")));
function $b66441f878ed2c9c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b66441f878ed2c9c$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $b66441f878ed2c9c$var$_react.default.createElement($b66441f878ed2c9c$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $b66441f878ed2c9c$var$_chevronDown2.default
    }, props));
$b66441f878ed2c9c$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $b66441f878ed2c9c$var$_default = module.exports.default = $b66441f878ed2c9c$var$ChevronDownIcon;

});

parcelRegister("hmIVj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9122dabf5a4e80a209ec2f5b7da6e804>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca47569b527d9876$var$_react = $ca47569b527d9876$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $ca47569b527d9876$var$_chevronUp = $ca47569b527d9876$var$_interopRequireDefault((parcelRequire("kequO")));

var $ca47569b527d9876$var$_chevronUp2 = $ca47569b527d9876$var$_interopRequireDefault((parcelRequire("eHrg6")));
function $ca47569b527d9876$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca47569b527d9876$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $ca47569b527d9876$var$_react.default.createElement($ca47569b527d9876$var$_chevronUp.default, Object.assign({
        name: "ChevronUpIcon",
        LEGACY_fallbackIcon: $ca47569b527d9876$var$_chevronUp2.default
    }, props));
$ca47569b527d9876$var$ChevronUpIcon.displayName = 'ChevronUpIconMigration';
var $ca47569b527d9876$var$_default = module.exports.default = $ca47569b527d9876$var$ChevronUpIcon;

});

parcelRegister("cn07l", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9017b95df78aee80$var$_react = $9017b95df78aee80$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $9017b95df78aee80$var$_cross = $9017b95df78aee80$var$_interopRequireDefault((parcelRequire("eyzuw")));

var $9017b95df78aee80$var$_cross2 = $9017b95df78aee80$var$_interopRequireDefault((parcelRequire("lzAm7")));
function $9017b95df78aee80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9017b95df78aee80$var$CrossIcon = (props)=>/*#__PURE__*/ $9017b95df78aee80$var$_react.default.createElement($9017b95df78aee80$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $9017b95df78aee80$var$_cross2.default
    }, props));
$9017b95df78aee80$var$CrossIcon.displayName = 'CrossIconMigration';
var $9017b95df78aee80$var$_default = module.exports.default = $9017b95df78aee80$var$CrossIcon;

});


parcelRegister("28rOu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18e1e747f2b1528c$export$2e2bcd8739ae039; });
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");


var $9cyTu = parcelRequire("9cyTu");
var $gWxJe = parcelRequire("gWxJe");

var $72wHg = parcelRequire("72wHg");
var $aDzos = parcelRequire("aDzos");
var $18e1e747f2b1528c$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
var $18e1e747f2b1528c$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        xcss: $18e1e747f2b1528c$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $9cyTu.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ $8ZuGG.createElement((0, $gWxJe.default), null, function(props) {
        return /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            xcss: $18e1e747f2b1528c$var$styles.container
        }, props), /*#__PURE__*/ $8ZuGG.createElement((0, $aDzos.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18e1e747f2b1528c$export$2e2bcd8739ae039 = $18e1e747f2b1528c$var$Expander;

});


parcelRegister("5BHjB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $415201f0f55b2c23$var$_react = $415201f0f55b2c23$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $415201f0f55b2c23$var$_statusSuccess = $415201f0f55b2c23$var$_interopRequireDefault((parcelRequire("gYYrH")));
function $415201f0f55b2c23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $415201f0f55b2c23$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $415201f0f55b2c23$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $415201f0f55b2c23$var$_statusSuccess.default
    }));
$415201f0f55b2c23$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $415201f0f55b2c23$var$_default = module.exports.default = $415201f0f55b2c23$var$CheckCircleIcon;

});


parcelRegister("aQwfp", function(module, exports) {

$parcel$export(module.exports, "MfaAppsPage", function () { return $9086fb644175d6ad$export$f8df0673716775fc; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $9086fb644175d6ad$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "MfaEnrollmentPage", function () { return $9086fb644175d6ad$export$1feb78d7c7eef8e6; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $9086fb644175d6ad$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $9086fb644175d6ad$export$d5523937d2306712; });
$parcel$export(module.exports, "LoginConsentNoticePage", function () { return $9086fb644175d6ad$export$68f39a5ef8cea54d; });
$parcel$export(module.exports, "CancelAccountDeletionPage", function () { return $9086fb644175d6ad$export$ffebed914bd6a6c9; });
$parcel$export(module.exports, "InactiveAccountPage", function () { return $9086fb644175d6ad$export$ad79d74b0908a012; });
$parcel$export(module.exports, "PendingDeletionPage", function () { return $9086fb644175d6ad$export$40b885b03094ae2d; });
$parcel$export(module.exports, "DeletionRequestConfirmationPage", function () { return $9086fb644175d6ad$export$467fb294f057077d; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $9086fb644175d6ad$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $9086fb644175d6ad$export$ee564d35600efee8; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $9086fb644175d6ad$export$980c3b624c0da509; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $9086fb644175d6ad$export$647c199e9f3e1159; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $9086fb644175d6ad$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "LogoutPage", function () { return $9086fb644175d6ad$export$ae5920452e7cb547; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $9086fb644175d6ad$export$61fae207a78c2e53; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $9086fb644175d6ad$export$e561dacd818ab41; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $9086fb644175d6ad$export$98b365c355bab28e; });
$parcel$export(module.exports, "AuthCallbackErrorPage", function () { return $9086fb644175d6ad$export$beb41ed376add573; });
$parcel$export(module.exports, "SecurityExpiredLinkPage", function () { return $9086fb644175d6ad$export$f5edf646533475ec; });
$parcel$export(module.exports, "SecuritySuccessPage", function () { return $9086fb644175d6ad$export$8d7d33e241ae6c52; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $9086fb644175d6ad$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $9086fb644175d6ad$export$134466789cb44107; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $9086fb644175d6ad$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $9086fb644175d6ad$export$3432bb22f729c42b; });
$parcel$export(module.exports, "RecoveryPage", function () { return $9086fb644175d6ad$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "ChooseMethodPage", function () { return $9086fb644175d6ad$export$d137eda0ebcc3948; });
$parcel$export(module.exports, "ConfigurePhonePage", function () { return $9086fb644175d6ad$export$717e3b31ee3d8960; });
$parcel$export(module.exports, "ConfigureAppPage", function () { return $9086fb644175d6ad$export$d316ce63fb222131; });
$parcel$export(module.exports, "SaveRecoveryKeyPage", function () { return $9086fb644175d6ad$export$70105507d801662a; });
$parcel$export(module.exports, "RegisterSecurityKeyPage", function () { return $9086fb644175d6ad$export$bfd6201eae0d5333; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddAuthenticatorPage", function () { return $9086fb644175d6ad$export$db2cf97d4f19249; });
$parcel$export(module.exports, "MultiMfaEnrollmentAddSecurityKeyPage", function () { return $9086fb644175d6ad$export$6e18f48b7564d95d; });
$parcel$export(module.exports, "LoginPage", function () { return $9086fb644175d6ad$export$f14c0e3f98d164c0; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $9086fb644175d6ad$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "WelcomePage", function () { return $9086fb644175d6ad$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $9086fb644175d6ad$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "ResetPasswordPage", function () { return $9086fb644175d6ad$export$da4433e8d8a5678; });
$parcel$export(module.exports, "SignupPage", function () { return $9086fb644175d6ad$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "SignupOnboardPage", function () { return $9086fb644175d6ad$export$1c7442c86b06b50c; });
$parcel$export(module.exports, "AuthenticatedLoomWorkspaceCreationPage", function () { return $9086fb644175d6ad$export$f296423b4e837594; });

var $8ZuGG = parcelRequire("8ZuGG");

const $9086fb644175d6ad$export$f8df0673716775fc = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3wlJ5")));

const $9086fb644175d6ad$export$8860bd3f7903e57e = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("04Sj4"))));

const $9086fb644175d6ad$export$357c630eb6814495 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("3rMgh"))));

const $9086fb644175d6ad$export$f8dc9833cdc832ea = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("4sO9M"))));

const $9086fb644175d6ad$export$1feb78d7c7eef8e6 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("78gHK")));

const $9086fb644175d6ad$export$84ed94b8c66e0057 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("gEsch"))));

const $9086fb644175d6ad$export$d5523937d2306712 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("cJaD4"))));

const $9086fb644175d6ad$export$68f39a5ef8cea54d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("kNf8F")));

const $9086fb644175d6ad$export$ffebed914bd6a6c9 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("30C6j"))));

const $9086fb644175d6ad$export$ad79d74b0908a012 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("b86ZF")));

const $9086fb644175d6ad$export$40b885b03094ae2d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("8WKkQ")));

const $9086fb644175d6ad$export$467fb294f057077d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("h6W4e")));

const $9086fb644175d6ad$export$8ec0fb1e4323236d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("hWM0L"))));

const $9086fb644175d6ad$export$ee564d35600efee8 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("gjxi0"))));

const $9086fb644175d6ad$export$980c3b624c0da509 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("akKks"))));

const $9086fb644175d6ad$export$647c199e9f3e1159 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("5S2Pz"))));

const $9086fb644175d6ad$export$9feca1f6b3b10306 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("aZgOq"))));

const $9086fb644175d6ad$export$ae5920452e7cb547 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("lFKa2"))));

const $9086fb644175d6ad$export$61fae207a78c2e53 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("lGfVq"))));

const $9086fb644175d6ad$export$e561dacd818ab41 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("4GJDT"))));

const $9086fb644175d6ad$export$98b365c355bab28e = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("c8zx1"))));

const $9086fb644175d6ad$export$beb41ed376add573 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("lm9T8")));

const $9086fb644175d6ad$export$f5edf646533475ec = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("l8RSV")));

const $9086fb644175d6ad$export$8d7d33e241ae6c52 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("iPFs9")));

const $9086fb644175d6ad$export$66bcaaca6b1eddac = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("50Ge8"))));

const $9086fb644175d6ad$export$134466789cb44107 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("889Xg"))));

const $9086fb644175d6ad$export$a4ce1932d7e73468 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("e0qo2"))));

const $9086fb644175d6ad$export$3432bb22f729c42b = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("4RcrL"))));

const $9086fb644175d6ad$export$280a36f5ba1cc19f = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>Promise.resolve((parcelRequire("9GYqm"))));

const $9086fb644175d6ad$export$d137eda0ebcc3948 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("eU26f")));

const $9086fb644175d6ad$export$717e3b31ee3d8960 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("9nSYJ")));

const $9086fb644175d6ad$export$d316ce63fb222131 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("aRu6s")));

const $9086fb644175d6ad$export$70105507d801662a = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("7mFlE")));

const $9086fb644175d6ad$export$bfd6201eae0d5333 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3MEVA")));

const $9086fb644175d6ad$export$db2cf97d4f19249 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("k57v9")));

const $9086fb644175d6ad$export$6e18f48b7564d95d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("ewjgJ")));

const $9086fb644175d6ad$export$f14c0e3f98d164c0 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("zMfzK")));

const $9086fb644175d6ad$export$74ab7a9a192e1a7a = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3lCKO")));

const $9086fb644175d6ad$export$630ad10f0e1a953d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("bjXav")));

const $9086fb644175d6ad$export$a16cb21d1f9bc820 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("eIShq")));

const $9086fb644175d6ad$export$da4433e8d8a5678 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("7YVtY")));

const $9086fb644175d6ad$export$a2f4b65ede167ce5 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("agqas")));

const $9086fb644175d6ad$export$1c7442c86b06b50c = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("4knI7")));

const $9086fb644175d6ad$export$f296423b4e837594 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("4LoG9")));

});
parcelRegister("04Sj4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "VerifyEmailSentPage", function () { return $c3b72d0357ef6c1b$export$8860bd3f7903e57e; });
$parcel$export(module.exports, "default", function () { return $c3b72d0357ef6c1b$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $3o9o3 = parcelRequire("3o9o3");

var $jHLOy = parcelRequire("jHLOy");

var $jSnDV = parcelRequire("jSnDV");

var $xe7jL = parcelRequire("xe7jL");

var $kZj5j = parcelRequire("kZj5j");

var $9OvaU = parcelRequire("9OvaU");

var $hX7Rq = parcelRequire("hX7Rq");

var $1fJfd = parcelRequire("1fJfd");

var $7CMue = parcelRequire("7CMue");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");
const $c3b72d0357ef6c1b$var$pageId = 'verifyEmailScreen';
const $c3b72d0357ef6c1b$export$8860bd3f7903e57e = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const location = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const dispatchAddFlag = (flag)=>{
        dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description));
    };
    const email = (0, $kOqgB.useAppSelector)((state)=>state.user.email);
    const showBrowserWarning = (0, $kOqgB.useAppSelector)((state)=>state.verifyEmailSent.showBrowserWarning);
    (0, $3ir1n.usePageViewedEvent)($c3b72d0357ef6c1b$var$pageId, {
        browserWarningMessageShown: showBrowserWarning
    });
    const handleResendVerificationEmail = async ()=>{
        analyticsClient.buttonClickedEvent($c3b72d0357ef6c1b$var$pageId, 'resendVerificationEmail');
        try {
            const response = await fetch(`/rest/resend-email${location.search}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        } catch (e) {
            addErrorFlag();
        }
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.buttonClickedEvent($c3b72d0357ef6c1b$var$pageId, 'verifyEmailReturnLoginLink');
    };
    const addSuccessFlag = ()=>{
        dispatchAddFlag({
            type: 'success',
            title: (0, $1fJfd.default).verifyEmailFlagSuccessTitle,
            description: (0, $1fJfd.default).verifyEmailFlagSuccessDesc
        });
    };
    const addErrorFlag = ()=>{
        dispatchAddFlag({
            type: 'error',
            title: (0, $1fJfd.default).verifyEmailFlagErrorTitle,
            description: (0, $1fJfd.default).verifyEmailFlagErrorDesc
        });
    };
    const renderWhiteboxFooter = ()=>{
        const returnLoginLink = `/login?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify((0, $6EnDC._)((0, $ty6PY._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search)), {
            email: email
        }))}`;
        const returnToLoginLink = (0, $kZj5j.isTrelloDesktop)() ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
            id: "return-login-button",
            to: returnLoginLink,
            onClick: handleReturnToLogin,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "return.to.log.in",
                defaultMessage: "Return to log in"
            })
        }) : null;
        return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                            id: "send-validation-submit",
                            spacing: "none",
                            className: "link-color-override",
                            onClick: handleResendVerificationEmail,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "verify.email.resend.signup.link",
                                defaultMessage: "Resend signup link"
                            })
                        })
                    })
                }),
                returnToLoginLink && /*#__PURE__*/ (0, $6rcps.jsx)("ul", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                        children: returnToLoginLink
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        // @ts-ignore no id
        id: "email-sent-page",
        pageId: $c3b72d0357ef6c1b$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "verify.email.title",
            tagName: "h5",
            defaultMessage: "Check your inbox to finish signup"
        }),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $1fJfd.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "verify.email.sent.signup.link",
                    tagName: "p",
                    defaultMessage: "We sent a signup link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $1fJfd.default).browserWarning)
                })
            })
        ]
    });
};
var $c3b72d0357ef6c1b$export$2e2bcd8739ae039 = $c3b72d0357ef6c1b$export$8860bd3f7903e57e;

});
parcelRegister("jHLOy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5871f6dcba0521a$export$2e2bcd8739ae039; });
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $1fdMd = parcelRequire("1fdMd");

var $5VQjR = parcelRequire("5VQjR");

var $8Dol2 = parcelRequire("8Dol2");

var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $hDqjp = parcelRequire("hDqjp");
var $e5871f6dcba0521a$var$sectionMessageStyles = {
    container: "_2rko12b0 _1rjcpxbi _18zrpxbi _1nmz1hna",
    iconContainer: "_1mou1i6y _1e0c1txw",
    contentContainer: "_16jlkb7n",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr",
    dismissButtonContainer: "_19pk1i6y"
};
var $e5871f6dcba0521a$var$appearanceStyles = {
    information: "_bfhk33gi",
    warning: "_bfhk1tzq",
    error: "_bfhk1gly",
    success: "_bfhkmv6i",
    discovery: "_bfhk1nvp"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $e5871f6dcba0521a$var$SectionMessage = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'information' : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, isDismissible = _ref.isDismissible, onDismiss = _ref.onDismiss, testId = _ref.testId;
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), dismissed = _useState2[0], setDismissed = _useState2[1];
    var handleDismiss = (0, $8ZuGG.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 || onDismiss();
        setDismissed(true);
    }, [
        onDismiss
    ]);
    var _getAppearanceIconSty = (0, $hDqjp.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, $8ZuGG.Fragment) ? actions.props.children : actions;
    var actionsArray = (0, $8ZuGG.Children).toArray(actionElements);
    return isDismissible && dismissed ? null : /*#__PURE__*/ $8ZuGG.createElement("section", {
        "data-testid": testId,
        ref: ref,
        className: (0, $c4hjl.default)([
            $e5871f6dcba0521a$var$sectionMessageStyles.container,
            $e5871f6dcba0521a$var$appearanceStyles[appearance]
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $e5871f6dcba0521a$var$sectionMessageStyles.iconContainer
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        LEGACY_size: "medium",
        color: primaryColor,
        spacing: "spacious"
    })), /*#__PURE__*/ $8ZuGG.createElement((0, $aDzos.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content"),
        xcss: $e5871f6dcba0521a$var$sectionMessageStyles.contentContainer
    }, !!title && /*#__PURE__*/ $8ZuGG.createElement((0, $5VQjR.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $e5871f6dcba0521a$var$sectionMessageStyles.content
        ])
    }, children), actionsArray.length > 0 && /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xB7",
        space: "space.100",
        rowSpace: "space.0",
        role: actionsArray.length > 1 ? 'list' : undefined,
        xcss: $e5871f6dcba0521a$var$sectionMessageStyles.actionsContainer
    }, actionsArray.map(function(action, id) {
        return(/*#__PURE__*/ // Only use a listitem role if more than one action is present
        $8ZuGG.createElement((0, $fkdQ8.default), {
            role: actionsArray.length > 1 ? 'listitem' : undefined,
            key: id
        }, action));
    }))), isDismissible && /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $e5871f6dcba0521a$var$sectionMessageStyles.dismissButtonContainer
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $1fdMd.default), {
        testId: testId && "".concat(testId, "--dismiss-button"),
        label: "Dismiss",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8Dol2))),
        appearance: "subtle",
        onClick: handleDismiss,
        spacing: "compact"
    }))));
});
$e5871f6dcba0521a$var$SectionMessage.displayName = 'SectionMessage';
var $e5871f6dcba0521a$export$2e2bcd8739ae039 = $e5871f6dcba0521a$var$SectionMessage;

});
parcelRegister("8Dol2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6494d857167e62a7$var$_react = $6494d857167e62a7$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $6494d857167e62a7$var$_cross = $6494d857167e62a7$var$_interopRequireDefault((parcelRequire("kgUUk")));

var $6494d857167e62a7$var$_cross2 = $6494d857167e62a7$var$_interopRequireDefault((parcelRequire("5kjFx")));
function $6494d857167e62a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6494d857167e62a7$var$CrossIcon = (props)=>/*#__PURE__*/ $6494d857167e62a7$var$_react.default.createElement($6494d857167e62a7$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $6494d857167e62a7$var$_cross2.default
    }, props));
$6494d857167e62a7$var$CrossIcon.displayName = 'CrossIconMigration';
var $6494d857167e62a7$var$_default = module.exports.default = $6494d857167e62a7$var$CrossIcon;

});
parcelRegister("kgUUk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec2171e960cf52b8$var$_react = $ec2171e960cf52b8$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $ec2171e960cf52b8$var$_baseNew = $ec2171e960cf52b8$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $ec2171e960cf52b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ec2171e960cf52b8$var$CrossIcon = (props)=>/*#__PURE__*/ $ec2171e960cf52b8$var$_react.default.createElement($ec2171e960cf52b8$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$ec2171e960cf52b8$var$CrossIcon.displayName = 'CrossIcon';
var $ec2171e960cf52b8$var$_default = module.exports.default = $ec2171e960cf52b8$var$CrossIcon;

});
parcelRegister("dnzQ9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("fySQH")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("fySQH")).Icon; });

var $fySQH = parcelRequire("fySQH");

});
parcelRegister("fySQH", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $b54493da854ee0b3$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $b54493da854ee0b3$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $b54493da854ee0b3$var$svgStyles = null;
var $b54493da854ee0b3$var$iconStyles = null;
var $b54493da854ee0b3$var$utilityIconStyles = null;
var $b54493da854ee0b3$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $b54493da854ee0b3$var$baseHcmStyles = null;
var $b54493da854ee0b3$var$scaleSize = null;
var $b54493da854ee0b3$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b54493da854ee0b3$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b54493da854ee0b3$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $b54493da854ee0b3$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $b54493da854ee0b3$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $b54493da854ee0b3$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $b54493da854ee0b3$var$baseSizeMap[type];
    var viewBoxPadding = $b54493da854ee0b3$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $b54493da854ee0b3$var$utilSizes[spacing] : size === 'small' ? $b54493da854ee0b3$var$coreSizeSmall[spacing] : $b54493da854ee0b3$var$coreSizeMedium[spacing]
        ])
    }));
});
var $b54493da854ee0b3$export$2e2bcd8739ae039 = $b54493da854ee0b3$export$f04a61298a47a40f;

});



parcelRegister("5kjFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e0e13da7a065233$var$_react = $3e0e13da7a065233$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $3e0e13da7a065233$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e0e13da7a065233$var$CrossIcon = (props)=>/*#__PURE__*/ $3e0e13da7a065233$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$3e0e13da7a065233$var$CrossIcon.displayName = 'CrossIcon';
var $3e0e13da7a065233$var$_default = module.exports.default = $3e0e13da7a065233$var$CrossIcon;

});
parcelRegister("5ZgTJ", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $45bfc1d39c7a9090$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $45bfc1d39c7a9090$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45bfc1d39c7a9090$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45bfc1d39c7a9090$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45bfc1d39c7a9090$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $45bfc1d39c7a9090$var$iconStyles = null;
var $45bfc1d39c7a9090$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $45bfc1d39c7a9090$var$baseHcmStyles = null;
var $45bfc1d39c7a9090$var$primaryEqualsSecondaryHcmStyles = null;
var $45bfc1d39c7a9090$var$secondaryTransparentHcmStyles = null;
var $45bfc1d39c7a9090$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $45bfc1d39c7a9090$var$_objectSpread($45bfc1d39c7a9090$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $45bfc1d39c7a9090$var$sizeStyles[size]
        ])
    }));
});
var $45bfc1d39c7a9090$export$2e2bcd8739ae039 = $45bfc1d39c7a9090$export$f04a61298a47a40f;

});



parcelRegister("hDqjp", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $cd6a7d31cfae26f1$export$e9b82d2e21ac0c1f; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $9CHbJ = parcelRequire("9CHbJ");

var $NEmRl = parcelRequire("NEmRl");

var $043kR = parcelRequire("043kR");

var $jGZ9a = parcelRequire("jGZ9a");

var $adbgy = parcelRequire("adbgy");

var $7y8qD = parcelRequire("7y8qD");

var $i2LcI = parcelRequire("i2LcI");

var $b7g0p = parcelRequire("b7g0p");
function $cd6a7d31cfae26f1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd6a7d31cfae26f1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd6a7d31cfae26f1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd6a7d31cfae26f1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cd6a7d31cfae26f1$var$appearanceIconSchema = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $b7g0p.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jGZ9a))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $b7g0p.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $b7g0p.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($7y8qD))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $b7g0p.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $b7g0p.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($043kR))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $b7g0p.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $b7g0p.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($adbgy))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $b7g0p.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $b7g0p.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($NEmRl))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $b7g0p.P500), ")")
    },
    discoveryUpdated: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $b7g0p.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9CHbJ))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $b7g0p.P500), ")")
    }
};
function $cd6a7d31cfae26f1$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $cd6a7d31cfae26f1$var$appearanceIconSchema[appearance === 'discovery' && (0, $i2LcI.fg)('platform_dst_section_message_discovery_icon') ? 'discoveryUpdated' : appearance] || $cd6a7d31cfae26f1$var$appearanceIconSchema.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $cd6a7d31cfae26f1$var$_objectSpread($cd6a7d31cfae26f1$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("9CHbJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5501f2ec2c7fc2907a8ddc6771935d76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701929f81333cba4$var$_react = $701929f81333cba4$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $701929f81333cba4$var$_discovery = $701929f81333cba4$var$_interopRequireDefault((parcelRequire("lfXIn")));

var $701929f81333cba4$var$_note = $701929f81333cba4$var$_interopRequireDefault((parcelRequire("1eVPc")));
function $701929f81333cba4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DiscoveryIcon.
 * This component is DiscoveryIcon, with `UNSAFE_fallbackIcon` set to "EditorNoteIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701929f81333cba4$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $701929f81333cba4$var$_react.default.createElement($701929f81333cba4$var$_discovery.default, Object.assign({
        name: "DiscoveryIcon",
        LEGACY_fallbackIcon: $701929f81333cba4$var$_note.default
    }, props));
$701929f81333cba4$var$DiscoveryIcon.displayName = 'DiscoveryIconMigration';
var $701929f81333cba4$var$_default = module.exports.default = $701929f81333cba4$var$DiscoveryIcon;

});
parcelRegister("lfXIn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84ac540d37aa7b8e7ab349dbbb474c30>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f79951c5ebcd8750$var$_react = $f79951c5ebcd8750$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $f79951c5ebcd8750$var$_baseNew = $f79951c5ebcd8750$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $f79951c5ebcd8750$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Discovery".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for discovery statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f79951c5ebcd8750$var$DiscoveryIcon = (props)=>/*#__PURE__*/ $f79951c5ebcd8750$var$_react.default.createElement($f79951c5ebcd8750$var$_baseNew.default, Object.assign({
        name: "DiscoveryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13 1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h6v-4.75C9 9.56 9.56 9 10.25 9H15V3a2 2 0 0 0-2-2M4 5.5h7V4H4zM4 9h3V7.5H4z" clip-rule="evenodd"/><path fill="currentcolor" d="M11.25 10.5a.75.75 0 0 0-.75.75v3.81l4.56-4.56z"/>`
    }, props));
$f79951c5ebcd8750$var$DiscoveryIcon.displayName = 'DiscoveryIcon';
var $f79951c5ebcd8750$var$_default = module.exports.default = $f79951c5ebcd8750$var$DiscoveryIcon;

});

parcelRegister("1eVPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e73f407d95c7bd9$var$_react = $0e73f407d95c7bd9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $0e73f407d95c7bd9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0e73f407d95c7bd9$var$EditorNoteIcon = (props)=>/*#__PURE__*/ $0e73f407d95c7bd9$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2m1.5 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm0 4a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props));
$0e73f407d95c7bd9$var$EditorNoteIcon.displayName = 'EditorNoteIcon';
var $0e73f407d95c7bd9$var$_default = module.exports.default = $0e73f407d95c7bd9$var$EditorNoteIcon;

});


parcelRegister("NEmRl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62c47233d9edbba3b204e8a396289dde>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0953e3e6f70dded9$var$_react = $0953e3e6f70dded9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $0953e3e6f70dded9$var$_questionCircle = $0953e3e6f70dded9$var$_interopRequireDefault((parcelRequire("ce059")));

var $0953e3e6f70dded9$var$_questionCircle2 = $0953e3e6f70dded9$var$_interopRequireDefault((parcelRequire("kwSti")));
function $0953e3e6f70dded9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for QuestionCircleIcon.
 * This component is QuestionCircleIcon, with `UNSAFE_fallbackIcon` set to "QuestionCircleIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0953e3e6f70dded9$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $0953e3e6f70dded9$var$_react.default.createElement($0953e3e6f70dded9$var$_questionCircle.default, Object.assign({
        name: "QuestionCircleIcon",
        LEGACY_fallbackIcon: $0953e3e6f70dded9$var$_questionCircle2.default
    }, props));
$0953e3e6f70dded9$var$QuestionCircleIcon.displayName = 'QuestionCircleIconMigration';
var $0953e3e6f70dded9$var$_default = module.exports.default = $0953e3e6f70dded9$var$QuestionCircleIcon;

});
parcelRegister("ce059", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8e66db23c2eb952c$var$_react = $8e66db23c2eb952c$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $8e66db23c2eb952c$var$_baseNew = $8e66db23c2eb952c$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $8e66db23c2eb952c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8e66db23c2eb952c$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $8e66db23c2eb952c$var$_react.default.createElement($8e66db23c2eb952c$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$8e66db23c2eb952c$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $8e66db23c2eb952c$var$_default = module.exports.default = $8e66db23c2eb952c$var$QuestionCircleIcon;

});

parcelRegister("kwSti", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef210cb9adde4984$var$_react = $ef210cb9adde4984$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $ef210cb9adde4984$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ef210cb9adde4984$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $ef210cb9adde4984$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="18" r="1" fill="inherit"/><path fill="inherit" d="M15.89 9.05a3.98 3.98 0 0 0-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.99.99 0 0 0 .982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 0 1 4.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 0 0-1 .987v2.014a1.001 1.001 0 0 0 2.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0 0 15.89 9.05"/></g></svg>`
    }, props));
$ef210cb9adde4984$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $ef210cb9adde4984$var$_default = module.exports.default = $ef210cb9adde4984$var$QuestionCircleIcon;

});


parcelRegister("043kR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00c2f630fc6c3801$var$_react = $00c2f630fc6c3801$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $00c2f630fc6c3801$var$_statusError = $00c2f630fc6c3801$var$_interopRequireDefault((parcelRequire("hVxoC")));

var $00c2f630fc6c3801$var$_error = $00c2f630fc6c3801$var$_interopRequireDefault((parcelRequire("iLEWK")));
function $00c2f630fc6c3801$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00c2f630fc6c3801$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $00c2f630fc6c3801$var$_react.default.createElement($00c2f630fc6c3801$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $00c2f630fc6c3801$var$_error.default
    }, props));
$00c2f630fc6c3801$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $00c2f630fc6c3801$var$_default = module.exports.default = $00c2f630fc6c3801$var$StatusErrorIcon;

});
parcelRegister("hVxoC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0d1aa5022a70ef7$var$_react = $d0d1aa5022a70ef7$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $d0d1aa5022a70ef7$var$_baseNew = $d0d1aa5022a70ef7$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $d0d1aa5022a70ef7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d0d1aa5022a70ef7$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $d0d1aa5022a70ef7$var$_react.default.createElement($d0d1aa5022a70ef7$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$d0d1aa5022a70ef7$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $d0d1aa5022a70ef7$var$_default = module.exports.default = $d0d1aa5022a70ef7$var$StatusErrorIcon;

});

parcelRegister("iLEWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $da9c60ee9e6d2352$var$_react = $da9c60ee9e6d2352$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $da9c60ee9e6d2352$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $da9c60ee9e6d2352$var$ErrorIcon = (props)=>/*#__PURE__*/ $da9c60ee9e6d2352$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$da9c60ee9e6d2352$var$ErrorIcon.displayName = 'ErrorIcon';
var $da9c60ee9e6d2352$var$_default = module.exports.default = $da9c60ee9e6d2352$var$ErrorIcon;

});


parcelRegister("jGZ9a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e5615f093d933152$var$_react = $e5615f093d933152$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $e5615f093d933152$var$_statusInformation = $e5615f093d933152$var$_interopRequireDefault((parcelRequire("ciInC")));

var $e5615f093d933152$var$_info = $e5615f093d933152$var$_interopRequireDefault((parcelRequire("je338")));
function $e5615f093d933152$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e5615f093d933152$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $e5615f093d933152$var$_react.default.createElement($e5615f093d933152$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $e5615f093d933152$var$_info.default
    }, props));
$e5615f093d933152$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $e5615f093d933152$var$_default = module.exports.default = $e5615f093d933152$var$StatusInformationIcon;

});
parcelRegister("ciInC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f499768150fd80e$var$_react = $8f499768150fd80e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $8f499768150fd80e$var$_baseNew = $8f499768150fd80e$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $8f499768150fd80e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f499768150fd80e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $8f499768150fd80e$var$_react.default.createElement($8f499768150fd80e$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$8f499768150fd80e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $8f499768150fd80e$var$_default = module.exports.default = $8f499768150fd80e$var$StatusInformationIcon;

});

parcelRegister("je338", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff1b0b018e6124e$var$_react = $dff1b0b018e6124e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $dff1b0b018e6124e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dff1b0b018e6124e$var$InfoIcon = (props)=>/*#__PURE__*/ $dff1b0b018e6124e$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$dff1b0b018e6124e$var$InfoIcon.displayName = 'InfoIcon';
var $dff1b0b018e6124e$var$_default = module.exports.default = $dff1b0b018e6124e$var$InfoIcon;

});


parcelRegister("adbgy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76f3db7a5500f7b2$var$_react = $76f3db7a5500f7b2$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $76f3db7a5500f7b2$var$_statusSuccess = $76f3db7a5500f7b2$var$_interopRequireDefault((parcelRequire("877o8")));

var $76f3db7a5500f7b2$var$_checkCircle = $76f3db7a5500f7b2$var$_interopRequireDefault((parcelRequire("cOqh5")));
function $76f3db7a5500f7b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76f3db7a5500f7b2$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $76f3db7a5500f7b2$var$_react.default.createElement($76f3db7a5500f7b2$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $76f3db7a5500f7b2$var$_checkCircle.default
    }, props));
$76f3db7a5500f7b2$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $76f3db7a5500f7b2$var$_default = module.exports.default = $76f3db7a5500f7b2$var$StatusSuccessIcon;

});
parcelRegister("877o8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e84b55ba3eed598$var$_react = $5e84b55ba3eed598$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5e84b55ba3eed598$var$_baseNew = $5e84b55ba3eed598$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $5e84b55ba3eed598$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e84b55ba3eed598$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $5e84b55ba3eed598$var$_react.default.createElement($5e84b55ba3eed598$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$5e84b55ba3eed598$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $5e84b55ba3eed598$var$_default = module.exports.default = $5e84b55ba3eed598$var$StatusSuccessIcon;

});

parcelRegister("cOqh5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $953e892007e019b8$var$_react = $953e892007e019b8$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $953e892007e019b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $953e892007e019b8$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $953e892007e019b8$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$953e892007e019b8$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $953e892007e019b8$var$_default = module.exports.default = $953e892007e019b8$var$CheckCircleIcon;

});


parcelRegister("7y8qD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57f23f24d61bebdc$var$_react = $57f23f24d61bebdc$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $57f23f24d61bebdc$var$_statusWarning = $57f23f24d61bebdc$var$_interopRequireDefault((parcelRequire("WXOPA")));

var $57f23f24d61bebdc$var$_warning = $57f23f24d61bebdc$var$_interopRequireDefault((parcelRequire("m1moI")));
function $57f23f24d61bebdc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $57f23f24d61bebdc$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $57f23f24d61bebdc$var$_react.default.createElement($57f23f24d61bebdc$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $57f23f24d61bebdc$var$_warning.default
    }, props));
$57f23f24d61bebdc$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $57f23f24d61bebdc$var$_default = module.exports.default = $57f23f24d61bebdc$var$StatusWarningIcon;

});
parcelRegister("WXOPA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b13d1ac4811071c$var$_react = $0b13d1ac4811071c$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $0b13d1ac4811071c$var$_baseNew = $0b13d1ac4811071c$var$_interopRequireDefault((parcelRequire("dnzQ9")));
function $0b13d1ac4811071c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0b13d1ac4811071c$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $0b13d1ac4811071c$var$_react.default.createElement($0b13d1ac4811071c$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$0b13d1ac4811071c$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $0b13d1ac4811071c$var$_default = module.exports.default = $0b13d1ac4811071c$var$StatusWarningIcon;

});

parcelRegister("m1moI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04231c4e60599895$var$_react = $04231c4e60599895$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5ZgTJ = parcelRequire("5ZgTJ");
function $04231c4e60599895$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $04231c4e60599895$var$WarningIcon = (props)=>/*#__PURE__*/ $04231c4e60599895$var$_react.default.createElement($5ZgTJ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$04231c4e60599895$var$WarningIcon.displayName = 'WarningIcon';
var $04231c4e60599895$var$_default = module.exports.default = $04231c4e60599895$var$WarningIcon;

});


parcelRegister("b7g0p", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $817cc383f44c6348$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R500", function () { return $817cc383f44c6348$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $817cc383f44c6348$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y500", function () { return $817cc383f44c6348$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $817cc383f44c6348$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G500", function () { return $817cc383f44c6348$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $817cc383f44c6348$export$226de0355ed012f8; });
$parcel$export(module.exports, "B500", function () { return $817cc383f44c6348$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $817cc383f44c6348$export$363e4475840015bb; });
$parcel$export(module.exports, "P500", function () { return $817cc383f44c6348$export$147899de772240ec; });
// Reds
var $817cc383f44c6348$export$4b84fd0e2c617bd = '#FFEBE6';
var $817cc383f44c6348$export$b34b069eff244586 = '#FFBDAD';
var $817cc383f44c6348$export$be802dd0d8b57f35 = '#FF8F73';
var $817cc383f44c6348$export$60847d42f9da92a6 = '#FF7452';
var $817cc383f44c6348$export$4a7404f376229999 = '#FF5630';
var $817cc383f44c6348$export$2010d0fb4295b346 = '#DE350B';
var $817cc383f44c6348$export$2837b5a1a71d5c02 = '#BF2600';
var $817cc383f44c6348$export$8d9596b529bbb9cf = '#FFFAE6';
var $817cc383f44c6348$export$41060a744ab0b7ae = '#FFF0B3';
var $817cc383f44c6348$export$1cc05bbbf340e559 = '#FFE380';
var $817cc383f44c6348$export$5aae31392d72caaa = '#FFC400';
var $817cc383f44c6348$export$c6930421db9fa514 = '#FFAB00';
var $817cc383f44c6348$export$59619663aa6500fb = '#FF991F';
var $817cc383f44c6348$export$874739ea9e379ab6 = '#FF8B00';
var $817cc383f44c6348$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $817cc383f44c6348$export$69a3bf21b9686c2b = '#ABF5D1';
var $817cc383f44c6348$export$afbce1382ec95f73 = '#79F2C0';
var $817cc383f44c6348$export$747d86715d4175de = '#57D9A3';
var $817cc383f44c6348$export$940e1f69e873f202 = '#36B37E';
var $817cc383f44c6348$export$a49394138f7b8e85 = '#00875A';
var $817cc383f44c6348$export$6fa04827ac68a4fb = '#006644';
var $817cc383f44c6348$export$226de0355ed012f8 = '#DEEBFF';
var $817cc383f44c6348$export$8c13c2ee36917869 = '#B3D4FF';
var $817cc383f44c6348$export$ecfc1dff386a3e7a = '#4C9AFF';
var $817cc383f44c6348$export$215b7063051591f1 = '#2684FF';
var $817cc383f44c6348$export$e62e8919cca44969 = '#0065FF';
var $817cc383f44c6348$export$b3de0ae08da2ce64 = '#0052CC';
var $817cc383f44c6348$export$a6ee3d71bc067634 = '#0747A6';
var $817cc383f44c6348$export$67f15409e87642a1 = '#669DF1';
var $817cc383f44c6348$export$f0539dbc42dbb067 = '#8FB8F6';
var $817cc383f44c6348$export$363e4475840015bb = '#EAE6FF';
var $817cc383f44c6348$export$4b0a4417ed59760f = '#C0B6F2';
var $817cc383f44c6348$export$6011520a64d9a187 = '#998DD9';
var $817cc383f44c6348$export$a7175d4e9206bc80 = '#8777D9';
var $817cc383f44c6348$export$b48405b95304b5a1 = '#6554C0';
var $817cc383f44c6348$export$c71e4279dd54a18d = '#5243AA';
var $817cc383f44c6348$export$147899de772240ec = '#403294';
var $817cc383f44c6348$export$2cf711fe14c66f06 = '#E6FCFF';
var $817cc383f44c6348$export$7a8f4d33f6f9772c = '#B3F5FF';
var $817cc383f44c6348$export$776c9c497ef08533 = '#79E2F2';
var $817cc383f44c6348$export$69cb3ca10c1e330e = '#00C7E6';
var $817cc383f44c6348$export$9dc1ef0f3f48059b = '#00B8D9';
var $817cc383f44c6348$export$7c835c78b6fcdef8 = '#00A3BF';
var $817cc383f44c6348$export$6036577f95c3877e = '#008DA6';
var $817cc383f44c6348$export$29a4f05edc054374 = '#FFFFFF';
var $817cc383f44c6348$export$e655ef011c4aa1a2 = '#FAFBFC';
var $817cc383f44c6348$export$9fdfb749e33cdf97 = '#F4F5F7';
var $817cc383f44c6348$export$3e51e8f1440314ba = '#EBECF0';
var $817cc383f44c6348$export$1ce2d1575d444ceb = '#DFE1E6';
var $817cc383f44c6348$export$8754fc7e6d8b3000 = '#C1C7D0';
var $817cc383f44c6348$export$c2e91cbeada39b8b = '#B3BAC5';
var $817cc383f44c6348$export$5f71e19f3a7ad9de = '#A5ADBA';
var $817cc383f44c6348$export$eaa8c8a70ac22806 = '#97A0AF';
var $817cc383f44c6348$export$7c87d337fb91a97d = '#8993A4';
var $817cc383f44c6348$export$d6447c357493214f = '#7A869A';
var $817cc383f44c6348$export$f563ee71e9ee74cd = '#6B778C';
var $817cc383f44c6348$export$e2ef2124cf4024b1 = '#5E6C84';
var $817cc383f44c6348$export$eece5f492e429f08 = '#505F79';
var $817cc383f44c6348$export$c39c0fe0f26207ae = '#42526E';
var $817cc383f44c6348$export$7090862dc3038a9f = '#344563';
var $817cc383f44c6348$export$ad0bacf983b7ddaa = '#253858';
var $817cc383f44c6348$export$7d61b15e0da132af = '#172B4D';
var $817cc383f44c6348$export$fbda843f0a27fe96 = '#091E42';
var $817cc383f44c6348$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $817cc383f44c6348$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $817cc383f44c6348$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $817cc383f44c6348$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $817cc383f44c6348$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $817cc383f44c6348$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $817cc383f44c6348$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $817cc383f44c6348$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $817cc383f44c6348$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $817cc383f44c6348$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $817cc383f44c6348$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $817cc383f44c6348$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $817cc383f44c6348$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $817cc383f44c6348$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $817cc383f44c6348$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $817cc383f44c6348$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $817cc383f44c6348$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $817cc383f44c6348$export$2f6319cf7d736c2a = '#E6EDFA';
var $817cc383f44c6348$export$95126bc8884d6634 = '#DCE5F5';
var $817cc383f44c6348$export$8338d8c35d44ff1 = '#CED9EB';
var $817cc383f44c6348$export$5368d76ae4fbbda7 = '#B8C7E0';
var $817cc383f44c6348$export$9f0a771d16ec8d36 = '#ABBBD6';
var $817cc383f44c6348$export$abcf8c38338b4aa5 = '#9FB0CC';
var $817cc383f44c6348$export$97e81faa16a182c7 = '#8C9CB8';
var $817cc383f44c6348$export$bfe21c59123ecf33 = '#7988A3';
var $817cc383f44c6348$export$ee82aa2ea6a1558 = '#67758F';
var $817cc383f44c6348$export$682927c6ed76be02 = '#56637A';
var $817cc383f44c6348$export$91fd9994c5be9757 = '#455166';
var $817cc383f44c6348$export$d281fbfe3cff2df6 = '#3B475C';
var $817cc383f44c6348$export$3902c91d8b98a753 = '#313D52';
var $817cc383f44c6348$export$8e8133c1ba5845b5 = '#283447';
var $817cc383f44c6348$export$33ff357f6620b39 = '#202B3D';
var $817cc383f44c6348$export$633847cf062b69e0 = '#1B2638';
var $817cc383f44c6348$export$9776a6e503bdbf76 = '#121A29';
var $817cc383f44c6348$export$6c813d5160dff5db = '#0E1624';
var $817cc383f44c6348$export$3d4f271a500072a = '#0D1424';
var $817cc383f44c6348$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $817cc383f44c6348$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $817cc383f44c6348$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $817cc383f44c6348$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $817cc383f44c6348$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $817cc383f44c6348$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $817cc383f44c6348$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $817cc383f44c6348$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $817cc383f44c6348$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $817cc383f44c6348$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $817cc383f44c6348$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $817cc383f44c6348$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $817cc383f44c6348$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $817cc383f44c6348$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $817cc383f44c6348$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $817cc383f44c6348$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $817cc383f44c6348$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $817cc383f44c6348$export$d2adc5dedf09fced = '#292A2E';
var $817cc383f44c6348$export$f51762073d2bb381 = '#94C748';
var $817cc383f44c6348$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("9OvaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae64e2bf233577a$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $iRVQ8 = parcelRequire("iRVQ8");

var $9Vz68 = parcelRequire("9Vz68");
parcelRequire("8ZuGG");
let $eae64e2bf233577a$var$_ = (t)=>t, $eae64e2bf233577a$var$t;
const $eae64e2bf233577a$var$StyledButton = (0, $9Vz68.default)((0, $iRVQ8.default))($eae64e2bf233577a$var$t || ($eae64e2bf233577a$var$t = $eae64e2bf233577a$var$_`
  span {
    font-weight: 400;
  }
`));
const $eae64e2bf233577a$var$ButtonLink = (props)=>{
    const { appearance: appearance } = props, rest = (0, $42tc5._)(props, [
        "appearance"
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($eae64e2bf233577a$var$StyledButton, (0, $ty6PY._)({
        appearance: appearance || 'link'
    }, rest));
};
var $eae64e2bf233577a$export$2e2bcd8739ae039 = $eae64e2bf233577a$var$ButtonLink;

});
parcelRegister("iRVQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbca0b098c0d3c0d$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $5AVd4 = parcelRequire("5AVd4");

var $4hzr4 = parcelRequire("4hzr4");

var $hU0Cl = parcelRequire("hU0Cl");

var $2itye = parcelRequire("2itye");

var $7yjH4 = parcelRequire("7yjH4");
var $dbca0b098c0d3c0d$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $dbca0b098c0d3c0d$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ var $dbca0b098c0d3c0d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $5AVd4.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $5AVd4.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $dbca0b098c0d3c0d$var$_excluded);
    var _useGlobalTheme = (0, $4hzr4.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $7yjH4.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($dbca0b098c0d3c0d$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $8ZuGG.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($dbca0b098c0d3c0d$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $8ZuGG.useMemo)(function() {
        return (0, $2itye.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hU0Cl.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$dbca0b098c0d3c0d$var$Button.displayName = 'Button';
var $dbca0b098c0d3c0d$export$2e2bcd8739ae039 = $dbca0b098c0d3c0d$var$Button;

});


parcelRegister("hX7Rq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50a224c621ba890e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $aICMQ = parcelRequire("aICMQ");

var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");
let $50a224c621ba890e$var$_ = (t)=>t, $50a224c621ba890e$var$t, $50a224c621ba890e$var$t1, $50a224c621ba890e$var$t2, $50a224c621ba890e$var$t3;
const $50a224c621ba890e$var$imgHeight = 88;
const $50a224c621ba890e$var$EmailSentImageContainer = (0, $9Vz68.default).div($50a224c621ba890e$var$t || ($50a224c621ba890e$var$t = $50a224c621ba890e$var$_`
  background: url(${0}) no-repeat center bottom;
  height: ${0}px;
  margin: ${0}px 0 ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($aICMQ))), $50a224c621ba890e$var$imgHeight, (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)() * 2);
const $50a224c621ba890e$var$EmailSentDescriptionContainer = (0, $9Vz68.default).div($50a224c621ba890e$var$t1 || ($50a224c621ba890e$var$t1 = $50a224c621ba890e$var$_`
  text-align: left;
`));
const $50a224c621ba890e$var$EmailWarningContainer = (0, $9Vz68.default).div($50a224c621ba890e$var$t2 || ($50a224c621ba890e$var$t2 = $50a224c621ba890e$var$_`
  text-align: left;
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $50a224c621ba890e$var$Email = (0, $9Vz68.default).p($50a224c621ba890e$var$t3 || ($50a224c621ba890e$var$t3 = $50a224c621ba890e$var$_`
  font: ${0};
  text-align: left;
  overflow-wrap: break-word;
  & {
    margin-top: ${0}px;
  }
`), (0, $g5rao.default)('font.heading.small'), (0, $5b7Z4.gridSize)());
function $50a224c621ba890e$export$2e2bcd8739ae039(props) {
    const { children: children, email: email, message: message, warningMessage: warningMessage, onRender: onRender, withEmailSentImage: withEmailSentImage = true } = props;
    (0, $8ZuGG.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        id: "email-sent-page",
        children: [
            withEmailSentImage && /*#__PURE__*/ (0, $6rcps.jsx)($50a224c621ba890e$var$EmailSentImageContainer, {}),
            /*#__PURE__*/ (0, $6rcps.jsx)($50a224c621ba890e$var$EmailSentDescriptionContainer, {
                children: message
            }),
            email && /*#__PURE__*/ (0, $6rcps.jsx)($50a224c621ba890e$var$Email, {
                children: email
            }),
            warningMessage && /*#__PURE__*/ (0, $6rcps.jsx)($50a224c621ba890e$var$EmailWarningContainer, {
                children: warningMessage
            }),
            children
        ]
    });
}

});
parcelRegister("aICMQ", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "check-your-email-open-letter.58fc87ea.svg";

});

parcelRegister("g5rao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb622fb74f57fb5b$export$2e2bcd8739ae039; });



var $aBY8N = parcelRequire("aBY8N");

var $bDRHl = parcelRequire("bDRHl");

var $1RdT6 = parcelRequire("1RdT6");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $bb622fb74f57fb5b$var$token(path, fallback) {
    var token = (0, $aBY8N.default)[path];
    typeof $1RdT6;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $bDRHl.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $bb622fb74f57fb5b$export$2e2bcd8739ae039 = $bb622fb74f57fb5b$var$token;

});


parcelRegister("1fJfd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6af7bcbcd6e7f19$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $d6af7bcbcd6e7f19$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    // Flags
    verifyEmailFlagSuccessTitle: {
        id: 'verify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!",
        description: ''
    },
    verifyEmailFlagSuccessDesc: {
        id: 'verify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!',
        description: ''
    },
    verifyEmailFlagErrorTitle: {
        id: 'verify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    verifyEmailFlagErrorDesc: {
        id: 'verify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'verify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    },
    migrationVerifyHeader: {
        id: 'migration.welcome.sent.title',
        defaultMessage: 'Check your inbox to log in',
        description: 'Informing the user to check their inbox to login.'
    },
    migrationVerifyMessage: {
        id: 'migration.welcome.sent.signup.link',
        defaultMessage: "To complete setup and log in, click the verification link in the email we\u2019ve sent to",
        description: 'Informing user that another welcome email has been sent for migration.'
    },
    resumeMigrationVerifyMessage: {
        id: 'resume.migration.welcome.sent.signup.link',
        defaultMessage: 'Your {product} account now requires you to log in with your new Atlassian account.',
        description: 'Informing migrating user that they need to log in with their Atlassian account'
    },
    button: {
        id: 'welcome.sent.resend.signup.link',
        defaultMessage: 'Resend verification email',
        description: 'Text telling the user that they can resend the welcome email again for migration.'
    },
    browserWarning: {
        id: 'welcome.email.sent.browser.warning',
        defaultMessage: 'Make sure to verify your email on this device and browser.',
        description: 'Telling the user to open the verification email sent by this page on the same device and browser'
    }
});

});

parcelRegister("7CMue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba9957b1ef14ebb$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $8EIEv = parcelRequire("8EIEv");

var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");

var $1ZDja = parcelRequire("1ZDja");

var $bIbAv = parcelRequire("bIbAv");

var $cugIF = parcelRequire("cugIF");

var $hB9Ab = parcelRequire("hB9Ab");

var $yrE6A = parcelRequire("yrE6A");

var $b2Jk5 = parcelRequire("b2Jk5");

var $cDJ3z = parcelRequire("cDJ3z");

var $knXCB = parcelRequire("knXCB");
let $aba9957b1ef14ebb$var$_ = (t)=>t, $aba9957b1ef14ebb$var$t, $aba9957b1ef14ebb$var$t1, $aba9957b1ef14ebb$var$t2, $aba9957b1ef14ebb$var$t3, $aba9957b1ef14ebb$var$t4;
const $aba9957b1ef14ebb$export$bad5896fb5d45c0b = (0, $9Vz68.default).div($aba9957b1ef14ebb$var$t || ($aba9957b1ef14ebb$var$t = $aba9957b1ef14ebb$var$_`
  color: ${0};
  margin-top: ${0}px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;

  ${0}
`), (0, $g5rao.default)('color.text.subtle'), (0, $5b7Z4.gridSize)() * 3, (0, $b2Jk5.listStyles));
const $aba9957b1ef14ebb$export$ba9d4abe45514a38 = (0, $9Vz68.default).footer($aba9957b1ef14ebb$var$t1 || ($aba9957b1ef14ebb$var$t1 = $aba9957b1ef14ebb$var$_`
  color: ${0};
  padding-top: ${0}px;
  font-size: 11px;
  text-align: center;
  line-height: 14px;

  ${0}
`), (0, $g5rao.default)('color.text.subtle'), (0, $5b7Z4.gridSize)() * 2, (0, $b2Jk5.listStyles));
const $aba9957b1ef14ebb$var$Whitebox = (0, $9Vz68.default).div($aba9957b1ef14ebb$var$t2 || ($aba9957b1ef14ebb$var$t2 = $aba9957b1ef14ebb$var$_`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: ${0};
  padding: ${0}px ${0}px;

  background: ${0};
  border-radius: ${0}px;
  box-shadow: ${0};
  box-sizing: border-box;
  color: ${0};

  ${0} {
    padding: ${0}px ${0}px;
    background: transparent;
    box-shadow: none;
    min-height: 100%;
    width: ${0};
  }

  ${0} {
    padding: ${0}px ${0}px;
  }
`), ({ width: width })=>width || (0, $b2Jk5.whiteboxWidthDesktop), (0, $5b7Z4.gridSize)() * 4, (0, $5b7Z4.gridSize)() * 5, (0, $bIbAv.colorPalette).primaryWhite, (0, $5b7Z4.borderRadius)(), ({ noBorder: noBorder })=>noBorder ? 'none' : '0 0 10px rgba(0, 0, 0, 0.1)', (0, $g5rao.default)('color.text.subtle'), (0, $1ZDja.media).below.sm, (0, $5b7Z4.gridSize)() * 4, (0, $5b7Z4.gridSize)() * 2, (0, $b2Jk5.whiteboxWidthHandheld), (0, $1ZDja.media).below.xs, (0, $5b7Z4.gridSize)() * 2, (0, $5b7Z4.gridSize)() * 2);
const $aba9957b1ef14ebb$var$Container = (0, $9Vz68.default).div($aba9957b1ef14ebb$var$t3 || ($aba9957b1ef14ebb$var$t3 = $aba9957b1ef14ebb$var$_`
  min-height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 0;

  ${0} {
    height: 100%;
    margin: 0;
    justify-content: flex-start;
  }
`), (0, $1ZDja.media).below.sm);
const $aba9957b1ef14ebb$var$FooterSpacer = (0, $9Vz68.default).div($aba9957b1ef14ebb$var$t4 || ($aba9957b1ef14ebb$var$t4 = $aba9957b1ef14ebb$var$_`
  ${0} {
    margin: auto;
  }
`), (0, $1ZDja.media).below.sm);
const $aba9957b1ef14ebb$export$c0881a38d60c6658 = ({ header: header, children: children, footer: footer, whiteboxFooter: whiteboxFooter, isLoading: isLoading, pageId: pageId, noCobranding: noCobranding })=>{
    const { cobranding: cobranding, isMobileApp: isMobileApp } = (0, $cugIF.useCobranding)();
    const resolvedCobranding = noCobranding ? (0, $cugIF.SimpleCobranding).NO_COBRANDING : cobranding;
    const { background: Background, logo: logo, footerProducts: footerProducts, whiteboxWidth: whiteboxWidth, hideWhiteboxBorder: hideWhiteboxBorder } = (0, $hB9Ab.getCobrandedComponents)(resolvedCobranding);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8EIEv.default), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)(Background, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$Container, {
                id: "WhiteboxContainer",
                children: /*#__PURE__*/ (0, $6rcps.jsxs)($aba9957b1ef14ebb$var$Whitebox, {
                    width: whiteboxWidth,
                    noBorder: hideWhiteboxBorder,
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)("section", {
                            role: "main",
                            children: isLoading ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $knXCB.LoadingSpinner), {
                                testId: "whitebox-loading-spinner"
                            }) : /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $yrE6A.ProductHeading), {
                                        suffix: header,
                                        children: logo && (0, $b2Jk5.renderProductLogo)(logo)
                                    }),
                                    children,
                                    whiteboxFooter && /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$export$bad5896fb5d45c0b, {
                                        children: whiteboxFooter
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$FooterSpacer, {}),
                        /*#__PURE__*/ (0, $6rcps.jsxs)($aba9957b1ef14ebb$export$ba9d4abe45514a38, {
                            children: [
                                footerProducts && /*#__PURE__*/ (0, $6rcps.jsx)((0, $cDJ3z.default), {
                                    renderText: !isMobileApp,
                                    pageId: pageId,
                                    footerProducts: footerProducts
                                }),
                                footer
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $aba9957b1ef14ebb$export$2e2bcd8739ae039 = $aba9957b1ef14ebb$export$c0881a38d60c6658;

});
parcelRegister("8EIEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d4b232eb4edaee$export$2e2bcd8739ae039; });

var $81Vbb = parcelRequire("81Vbb");

var $2tdac = parcelRequire("2tdac");

var $k9Z8Q = parcelRequire("k9Z8Q");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$64d4b232eb4edaee$export$2e2bcd8739ae039 = (0, $81Vbb.default);

});
parcelRegister("81Vbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8ac55a16f22269$export$2e2bcd8739ae039; });
/* page.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $k1kY3 = parcelRequire("k1kY3");
var $5d8ac55a16f22269$var$styles = {
    banner: "_1bsb1osq _kqsw1n9t",
    bannerContainer: "_16jlkb7n _1o9zidpf _i0dl1wug _v564evma _1bsb1osq _kqswh2mm _1pby11wp",
    pageContent: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _kqswh2mm _1pbykb7n",
    wrapper: "_1e0c1txw _1bsb1osq _1tke1osq _2lx21bp4",
    mainContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw",
    navigation: "_kqswh2mm _1pbycs5v"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $5d8ac55a16f22269$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $k1kY3.defaultBannerHeight) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.wrapper
        ])
    }, banner ? /*#__PURE__*/ $8ZuGG.createElement("div", {
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined,
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.bannerContainer
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.banner
        ])
    }, banner)) : null, /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.mainContainer
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.navigation
        ])
    }, navigation), /*#__PURE__*/ $8ZuGG.createElement("div", {
        className: (0, $c4hjl.default)([
            $5d8ac55a16f22269$var$styles.pageContent
        ])
    }, children)));
};
var $5d8ac55a16f22269$export$2e2bcd8739ae039 = $5d8ac55a16f22269$var$Page;

});
parcelRegister("k1kY3", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", function () { return $e9342a612e689295$export$74797698e12f8baa; });
$parcel$export(module.exports, "spacingMapping", function () { return $e9342a612e689295$export$2a89a65a43bab52d; });
$parcel$export(module.exports, "defaultSpacing", function () { return $e9342a612e689295$export$8ec7372efd74b753; });
$parcel$export(module.exports, "defaultBannerHeight", function () { return $e9342a612e689295$export$d77f83c3d17a7b8a; });
$parcel$export(module.exports, "defaultMedium", function () { return $e9342a612e689295$export$f8725d21f81f3e01; });
$parcel$export(module.exports, "defaultLayout", function () { return $e9342a612e689295$export$2303d2bd9eeff99a; });
var $e9342a612e689295$var$defaultGridSize = 8;
var $e9342a612e689295$export$74797698e12f8baa = 12;
var $e9342a612e689295$export$b8241a1616ab1b96 = $e9342a612e689295$var$defaultGridSize * 10;
var $e9342a612e689295$export$2a89a65a43bab52d = {
    comfortable: $e9342a612e689295$var$defaultGridSize * 5,
    cosy: $e9342a612e689295$var$defaultGridSize * 2,
    compact: $e9342a612e689295$var$defaultGridSize * 0.5
};
var $e9342a612e689295$export$8ec7372efd74b753 = 'cosy';
var $e9342a612e689295$export$d77f83c3d17a7b8a = 52;
var $e9342a612e689295$export$f8725d21f81f3e01 = 0;
var $e9342a612e689295$export$2303d2bd9eeff99a = 'fixed';
var $e9342a612e689295$export$9ddc3632bbfb8966 = '--ds-columns-num';
var $e9342a612e689295$export$8b7e31f391e6e681 = '--ds-column-span';
var $e9342a612e689295$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("2tdac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc88034a9248267$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1kY3 = parcelRequire("k1kY3");

var $aDRO1 = parcelRequire("aDRO1");

var $k9Z8Q = parcelRequire("k9Z8Q");

var $cjoER = parcelRequire("cjoER");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $1cc88034a9248267$var$GridWrapper = function GridWrapper(_ref) {
    var _ref2, _ref3, _theme$isNestedGrid;
    var spacingProp = _ref.spacing, columnsProp = _ref.columns, layout = _ref.layout, testId = _ref.testId, children = _ref.children, theme = _ref.theme;
    /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */ var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), isRoot = _useContext.isRoot;
    var _useContext2 = (0, $8ZuGG.useContext)((0, $k9Z8Q.GridColumnContext)), medium = _useContext2.medium;
    /**
   * The colspan of the current containing GridColumn provides
   * the default amount of columns in a nested grid.
   */ var defaultColumns = medium > 0 ? medium : (0, $k1kY3.defaultGridColumns);
    /**
   * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
   * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
   */ var spacing = (_ref2 = spacingProp !== null && spacingProp !== void 0 ? spacingProp : theme === null || theme === void 0 ? void 0 : theme.spacing) !== null && _ref2 !== void 0 ? _ref2 : (0, $k1kY3.defaultSpacing);
    var columns = (_ref3 = columnsProp !== null && columnsProp !== void 0 ? columnsProp : theme === null || theme === void 0 ? void 0 : theme.columns) !== null && _ref3 !== void 0 ? _ref3 : defaultColumns;
    var isNested = (_theme$isNestedGrid = theme === null || theme === void 0 ? void 0 : theme.isNestedGrid) !== null && _theme$isNestedGrid !== void 0 ? _theme$isNestedGrid : !isRoot;
    var contextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        };
    }, [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cjoER.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDRO1.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $1cc88034a9248267$export$2e2bcd8739ae039 = $1cc88034a9248267$var$GridWrapper;

});
parcelRegister("aDRO1", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $7bf748a03bd7bacf$export$ef2184bd89960b14; });
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $k1kY3 = parcelRequire("k1kY3");

var $cjoER = parcelRequire("cjoER");
var $7bf748a03bd7bacf$var$defaultGridColumnWidth = 80;
/**
 * The number of available columns in each row.
 */ var $7bf748a03bd7bacf$var$varColumnsNum = '--ds-columns-num';
/**
 * The spacing (in `px`) between each column.
 */ var $7bf748a03bd7bacf$var$varGridSpacing = '--ds-grid-spacing';
var $7bf748a03bd7bacf$var$styles = {
    grid: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _ca0qidpf _u5f3wx3y _n3tdidpf _19bvwx3y _1e0c1txw _kqswh2mm _4cvr1y6m _1n261g80",
    nestedGrid: "_19pkidpf _2hwx1un2 _otyridpf _18u01un2"
};
var $7bf748a03bd7bacf$var$gridLayoutMapStyles = {
    fixed: "_p12fgkkb",
    fluid: "_p12f1osq"
};
var $7bf748a03bd7bacf$export$ef2184bd89960b14 = function Grid(_ref) {
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? (0, $k1kY3.defaultLayout) : _ref$layout, testId = _ref.testId, children = _ref.children;
    var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), isNested = _useContext.isNested, columns = _useContext.columns, spacing = _useContext.spacing;
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $7bf748a03bd7bacf$var$varColumnsNum, columns), $7bf748a03bd7bacf$var$varGridSpacing, "".concat((0, $k1kY3.spacingMapping)[spacing], "px")),
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $7bf748a03bd7bacf$var$styles.grid,
            $7bf748a03bd7bacf$var$gridLayoutMapStyles[layout],
            isNested && $7bf748a03bd7bacf$var$styles.nestedGrid
        ])
    }, children);
};

});
parcelRegister("cjoER", function(module, exports) {

$parcel$export(module.exports, "GridContext", function () { return $8f6a62f6792d79c1$export$11cae3e04ab99fae; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1kY3 = parcelRequire("k1kY3");
var $8f6a62f6792d79c1$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $k1kY3.defaultSpacing),
    columns: (0, $k1kY3.defaultGridColumns)
});

});


parcelRegister("k9Z8Q", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", function () { return $ead4135dcdd62c08$export$1229ad7112b989f5; });
$parcel$export(module.exports, "default", function () { return $ead4135dcdd62c08$export$2e2bcd8739ae039; });
/* grid-column.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $k1kY3 = parcelRequire("k1kY3");

var $cjoER = parcelRequire("cjoER");
/**
 * Determines the method by which column width is calculated.
 */ var $ead4135dcdd62c08$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($ead4135dcdd62c08$var$ColumnVariant || {});
/**
 * The spacing (in `px`) between each column.
 */ var $ead4135dcdd62c08$var$varGridSpacing = '--ds-grid-spacing';
/**
 * The number of columns that a `GridColumn` covers.
 */ var $ead4135dcdd62c08$var$varColumnSpan = '--ds-column-span';
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $ead4135dcdd62c08$var$singleColumnWidth = "(99.9999% / var(--ds-columns-num))";
var $ead4135dcdd62c08$var$styles = {
    gridColumn: "_19pkidpf _2hwxwx3y _otyridpf _18u0wx3y _1ul9hrtj _16jlkb7n _1o9zidpf _slp31hna"
};
var $ead4135dcdd62c08$var$gridColumnWidthMapStyles = {
    auto: "_p12f1ho1 _i0dl1wug",
    bounded: "_p12fpg3g _i0dl1osq",
    fullWidth: "_p12f1ho1 _i0dl1osq"
};
var $ead4135dcdd62c08$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $k1kY3.defaultMedium)) return $ead4135dcdd62c08$var$ColumnVariant.Auto;
    else if (medium < columns) return $ead4135dcdd62c08$var$ColumnVariant.Bounded;
    return $ead4135dcdd62c08$var$ColumnVariant.FullWidth;
};
var $ead4135dcdd62c08$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    medium: (0, $k1kY3.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $ead4135dcdd62c08$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $k1kY3.defaultMedium) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), columns = _useContext.columns;
    var contextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $ead4135dcdd62c08$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ $8ZuGG.createElement($ead4135dcdd62c08$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $ead4135dcdd62c08$var$varColumnSpan, variant === $ead4135dcdd62c08$var$ColumnVariant.Auto ? 'auto' : colSpan),
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $ead4135dcdd62c08$var$styles.gridColumn,
            $ead4135dcdd62c08$var$gridColumnWidthMapStyles[variant]
        ])
    }, children));
};
var $ead4135dcdd62c08$export$2e2bcd8739ae039 = $ead4135dcdd62c08$var$GridColumn;

});



parcelRegister("1ZDja", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $1739fabd10f507ab$export$987d49ffe1b0900f; });
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ var $1739fabd10f507ab$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};

});

parcelRegister("bIbAv", function(module, exports) {

$parcel$export(module.exports, "colorPalette", function () { return $cf3b96607083b7a8$export$569885e57444f84a; });

var $kTdw7 = parcelRequire("kTdw7");
const $cf3b96607083b7a8$export$569885e57444f84a = {
    primaryNavy: (0, $kTdw7).N800,
    primaryBlue: (0, $kTdw7).B500,
    primaryWhite: (0, $kTdw7).N0,
    secondaryRed: (0, $kTdw7).R300,
    secondaryYellow: (0, $kTdw7).Y300,
    secondaryGreen: (0, $kTdw7).G300,
    secondaryCyan: (0, $kTdw7).P300,
    secondaryPurple: (0, $kTdw7).T300
};

});

parcelRegister("hB9Ab", function(module, exports) {

$parcel$export(module.exports, "getCobrandedComponents", function () { return $63370adffb00ee7e$export$7f88f5c61e80b9ef; });

var $cugIF = parcelRequire("cugIF");

var $g1Kgy = parcelRequire("g1Kgy");

var $astB0 = parcelRequire("astB0");

var $1Szkf = parcelRequire("1Szkf");

var $gUezr = parcelRequire("gUezr");

var $d8SB0 = parcelRequire("d8SB0");

var $2erun = parcelRequire("2erun");

var $7lF7s = parcelRequire("7lF7s");

var $gAd27 = parcelRequire("gAd27");

var $ccCNm = parcelRequire("ccCNm");

var $lw2Cv = parcelRequire("lw2Cv");

var $3b3Yv = parcelRequire("3b3Yv");

var $4YCdO = parcelRequire("4YCdO");

var $8liMg = parcelRequire("8liMg");

var $cXTHL = parcelRequire("cXTHL");

var $f0poS = parcelRequire("f0poS");

var $528n8 = parcelRequire("528n8");
const $63370adffb00ee7e$var$cobrandingMap = {
    [(0, $cugIF.SimpleCobranding).NO_COBRANDING]: (0, $g1Kgy.default),
    [(0, $cugIF.SimpleCobranding).BITBUCKET]: (0, $astB0.default),
    [(0, $cugIF.SimpleCobranding).COMPASS]: (0, $1Szkf.default),
    [(0, $cugIF.SimpleCobranding).CONFLUENCE]: (0, $gUezr.default),
    [(0, $cugIF.SimpleCobranding).COMMUNITY]: (0, $d8SB0.default),
    [(0, $cugIF.SimpleCobranding).JIRA]: (0, $2erun.default),
    [(0, $cugIF.SimpleCobranding).LOOM]: (0, $4YCdO.default),
    [(0, $cugIF.SimpleCobranding).JIRA_ALIGN]: (0, $8liMg.default),
    [(0, $cugIF.SimpleCobranding).OPSGENIE]: (0, $7lF7s.default),
    [(0, $cugIF.SimpleCobranding).STATUSPAGE]: (0, $gAd27.default),
    [(0, $cugIF.SimpleCobranding).TRELLO]: (0, $ccCNm.default),
    [(0, $cugIF.SimpleCobranding).WAC]: (0, $lw2Cv.default),
    [(0, $cugIF.SimpleCobranding).ATLAS]: (0, $3b3Yv.default),
    [(0, $cugIF.SimpleCobranding).ADMIN]: (0, $g1Kgy.default),
    [(0, $cugIF.SimpleCobranding).ROVO]: (0, $528n8.default),
    [(0, $cugIF.SimpleCobranding).PRT]: (0, $g1Kgy.default),
    [(0, $cugIF.SimpleCobranding).SUPPORT]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).JIRA_ATLAS_75650]: (0, $cXTHL.default),
    [(0, $cugIF.AdvancedCobranding).CONFLUENCE_ATLAS_75650]: (0, $f0poS.default),
    [(0, $cugIF.AdvancedCobranding).DEMO]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).ATLAS_66195]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).CFIND_2409]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).CFIND_3856]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).WAC_LOOM]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).WAC_JPD]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).WAC_JSM]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).ACCOUNT_LINKING]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).ENTRY_AUTH]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).SERVICE_COLLECTION]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).TEAMWORK_COLLECTION]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).PRT_DEMO]: (0, $g1Kgy.default),
    [(0, $cugIF.AdvancedCobranding).ISOLATED_CLOUD]: (0, $g1Kgy.default),
    default: (0, $g1Kgy.default)
};
const $63370adffb00ee7e$export$7f88f5c61e80b9ef = (cobranding)=>{
    if ((0, $cugIF.isSimpleCobranding)(cobranding) || (0, $cugIF.isAdvancedCobranding)(cobranding)) return $63370adffb00ee7e$var$cobrandingMap[cobranding];
    else {
        console.warn(`[COBRANDING] ${cobranding} is globally configured for advanced-cobranding but corresponding configuration for ${window.location.pathname} was not provided. Loading SimpleCobranding.NO_BRANDING as fallback.`);
        return $63370adffb00ee7e$var$cobrandingMap[(0, $cugIF.SimpleCobranding).NO_COBRANDING];
    }
};

});
parcelRegister("g1Kgy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1846838c2bc9e83f$export$2e2bcd8739ae039; });

var $5UWRo = parcelRequire("5UWRo");

var $b2Jk5 = parcelRequire("b2Jk5");

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");
const $1846838c2bc9e83f$export$f2683fd6d2de1a37 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $1846838c2bc9e83f$var$DefaultCobranding = {
    background: $1846838c2bc9e83f$export$f2683fd6d2de1a37,
    logo: {
        component: (0, $5UWRo.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $1846838c2bc9e83f$export$2e2bcd8739ae039 = $1846838c2bc9e83f$var$DefaultCobranding;

});
parcelRegister("b2Jk5", function(module, exports) {

$parcel$export(module.exports, "whiteboxWidthDesktop", function () { return $03e1c506857a731b$export$4dacb4c23fc28876; });
$parcel$export(module.exports, "whiteboxWidthHandheld", function () { return $03e1c506857a731b$export$6bfb439877eddd98; });
$parcel$export(module.exports, "linkStyles", function () { return $03e1c506857a731b$export$4ea5976125a01ffa; });
$parcel$export(module.exports, "listStyles", function () { return $03e1c506857a731b$export$f9b6c540022859c0; });
$parcel$export(module.exports, "DefaultBackground", function () { return $03e1c506857a731b$export$cffd0b81d0e051b1; });
$parcel$export(module.exports, "backgroundWithSideImages", function () { return $03e1c506857a731b$export$c9af51660ef2db22; });
$parcel$export(module.exports, "backgroundWithImage", function () { return $03e1c506857a731b$export$860f6dae4486c905; });
$parcel$export(module.exports, "renderProductLogo", function () { return $03e1c506857a731b$export$390d73d0230797c4; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $ihLLY = parcelRequire("ihLLY");

var $bIbAv = parcelRequire("bIbAv");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
let $03e1c506857a731b$var$_ = (t)=>t, $03e1c506857a731b$var$t, $03e1c506857a731b$var$t1, $03e1c506857a731b$var$t2, $03e1c506857a731b$var$t3, $03e1c506857a731b$var$t4, $03e1c506857a731b$var$t5, $03e1c506857a731b$var$t6, $03e1c506857a731b$var$t7, $03e1c506857a731b$var$t8, $03e1c506857a731b$var$t9;
const $03e1c506857a731b$export$4dacb4c23fc28876 = `${(0, $5b7Z4.gridSize)() * 50}px`;
const $03e1c506857a731b$export$6bfb439877eddd98 = `${(0, $5b7Z4.gridSize)() * 40}px`;
const $03e1c506857a731b$export$7970b24609d80d2d = (0, $9Vz68.default).div($03e1c506857a731b$var$t1 || ($03e1c506857a731b$var$t1 = $03e1c506857a731b$var$_`
  ${0};
`), (0, $ihLLY.media).handheld($03e1c506857a731b$var$t || ($03e1c506857a731b$var$t = $03e1c506857a731b$var$_`
    display: none;
  `)));
const $03e1c506857a731b$export$97b346657ff4770f = (0, $9Vz68.default).div($03e1c506857a731b$var$t3 || ($03e1c506857a731b$var$t3 = $03e1c506857a731b$var$_`
  display: none;

  ${0};
`), (0, $ihLLY.media).handheld($03e1c506857a731b$var$t2 || ($03e1c506857a731b$var$t2 = $03e1c506857a731b$var$_`
    display: inline-block;
  `)));
const $03e1c506857a731b$export$4ea5976125a01ffa = (color)=>`
   a {
      color: ${color};

      &:hover {
        color: ${color};
      }
      &.hover {
        color: ${color};
      }
      &.primary-action {
        color: ${color};
      }
   }
`;
const $03e1c506857a731b$export$f9b6c540022859c0 = `
    ul {
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
    }
`;
const $03e1c506857a731b$export$cffd0b81d0e051b1 = (0, $9Vz68.default).div($03e1c506857a731b$var$t5 || ($03e1c506857a731b$var$t5 = $03e1c506857a731b$var$_`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: ${0};
  ${0}
`), (0, $kTdw7).N10, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t4 || ($03e1c506857a731b$var$t4 = $03e1c506857a731b$var$_`
    background: ${0};
    color: ${0};
  `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
function $03e1c506857a731b$export$c9af51660ef2db22(leftImageSrc, rightImageSrc) {
    const scalingImagesMaxWidth = `${(0, $5b7Z4.gridSize)() * 150}px`; //50 grid size for whitebox + 2 * 50 grid size for images
    const widescreenBackgroundImageSize = `calc((100vw - ${$03e1c506857a731b$export$4dacb4c23fc28876})/2 - ${(0, $5b7Z4.gridSize)() * 4}px) auto`;
    return (0, $9Vz68.default)($03e1c506857a731b$export$cffd0b81d0e051b1)($03e1c506857a731b$var$t7 || ($03e1c506857a731b$var$t7 = $03e1c506857a731b$var$_`
    background-image: url(${0}), url(${0});
    background-repeat: no-repeat, no-repeat;
    background-attachment: fixed, fixed;
    background-size: ${0}px auto, ${0}px auto;
    background-position: left bottom, right bottom;

    @media (max-width: ${0}) {
      background-size: ${0}, ${0}, cover;
    }

    ${0}
  `), leftImageSrc, rightImageSrc, (0, $5b7Z4.gridSize)() * 46, (0, $5b7Z4.gridSize)() * 46, scalingImagesMaxWidth, widescreenBackgroundImageSize, widescreenBackgroundImageSize, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t6 || ($03e1c506857a731b$var$t6 = $03e1c506857a731b$var$_`
      background: ${0};
      color: ${0};
    `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
}
function $03e1c506857a731b$export$860f6dae4486c905(bgImageSrc) {
    return (0, $9Vz68.default)($03e1c506857a731b$export$cffd0b81d0e051b1)($03e1c506857a731b$var$t9 || ($03e1c506857a731b$var$t9 = $03e1c506857a731b$var$_`
    background-image: url(${0});
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    ${0}
  `), bgImageSrc, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t8 || ($03e1c506857a731b$var$t8 = $03e1c506857a731b$var$_`
      background: ${0};
      color: ${0};
    `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
}
const $03e1c506857a731b$export$390d73d0230797c4 = (props)=>{
    if ('renderLogo' in props) // is a custom logo
    return props.renderLogo();
    const { component: AtlaskitLogo } = props;
    return /*#__PURE__*/ (0, $6rcps.jsx)(AtlaskitLogo, {
        appearance: "brand",
        size: "large",
        shouldUseNewLogoDesign: true
    });
};

});

parcelRegister("cx88G", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "default_left.dfc31853.svg";

});

parcelRegister("1CA01", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "default_right.a801c0cc.svg";

});


parcelRegister("astB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b699deb75020641c$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $iOGBn = parcelRequire("iOGBn");
const $b699deb75020641c$var$BitbucketCobranding = {
    background: (0, $iOGBn.BitbucketBackground),
    logo: {
        component: (0, $l8yrb.BitbucketLogo)
    },
    footerProducts: 'Bitbucket, Jira, Confluence'
};
var $b699deb75020641c$export$2e2bcd8739ae039 = $b699deb75020641c$var$BitbucketCobranding;

});
parcelRegister("l8yrb", function(module, exports) {

$parcel$export(module.exports, "HomeLogo", function () { return $f6350ee01f5a23f4$export$d5648119d5b68e90; });
$parcel$export(module.exports, "BitbucketLogo", function () { return $f6350ee01f5a23f4$export$bd40525f5333524b; });
$parcel$export(module.exports, "CompassLogo", function () { return $f6350ee01f5a23f4$export$eb7d748e4f9c9676; });
$parcel$export(module.exports, "ConfluenceIcon", function () { return $f6350ee01f5a23f4$export$68f3db7f6af48bcb; });
$parcel$export(module.exports, "ConfluenceLogo", function () { return $f6350ee01f5a23f4$export$1b2e4fe6ef471556; });
$parcel$export(module.exports, "JiraAlignLogo", function () { return $f6350ee01f5a23f4$export$ee11e928d3d045fd; });
$parcel$export(module.exports, "JiraIcon", function () { return $f6350ee01f5a23f4$export$c4b5b1f965d8b3eb; });
$parcel$export(module.exports, "JiraLogo", function () { return $f6350ee01f5a23f4$export$17d3acb0b4379d02; });
$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $f6350ee01f5a23f4$export$21bfbeb62fdcce8d; });
$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $f6350ee01f5a23f4$export$c49a2b642fe9eef4; });
$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $f6350ee01f5a23f4$export$3c6158790f5e01c4; });
$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $f6350ee01f5a23f4$export$dabef2be6cd28c20; });
$parcel$export(module.exports, "LoomLogo", function () { return $f6350ee01f5a23f4$export$94e206806e36c2ec; });
$parcel$export(module.exports, "OpsgenieLogo", function () { return $f6350ee01f5a23f4$export$a1c6484cdecc2c4b; });
$parcel$export(module.exports, "StatuspageLogo", function () { return $f6350ee01f5a23f4$export$bb4ae5b41b43be04; });
$parcel$export(module.exports, "TrelloLogo", function () { return $f6350ee01f5a23f4$export$60e26212f3b61a28; });
$parcel$export(module.exports, "RovoIcon", function () { return $f6350ee01f5a23f4$export$e23ae35269442b4f; });
$parcel$export(module.exports, "RovoLogo", function () { return $f6350ee01f5a23f4$export$a0f6cb8061290bbb; });

var $7rGcv = parcelRequire("7rGcv");
var $iwnjp = parcelRequire("iwnjp");

var $d0t0D = parcelRequire("d0t0D");
var $etvMV = parcelRequire("etvMV");

var $dCCse = parcelRequire("dCCse");
var $8noz9 = parcelRequire("8noz9");

var $bxLJ6 = parcelRequire("bxLJ6");
var $f9IM6 = parcelRequire("f9IM6");

var $cEiIr = parcelRequire("cEiIr");
var $i634e = parcelRequire("i634e");

var $1CEtF = parcelRequire("1CEtF");
var $iTq8Z = parcelRequire("iTq8Z");

var $9wFae = parcelRequire("9wFae");
var $c1VXe = parcelRequire("c1VXe");

var $iMZic = parcelRequire("iMZic");
var $epHQB = parcelRequire("epHQB");

var $cwlpA = parcelRequire("cwlpA");
var $8NXfU = parcelRequire("8NXfU");

var $irY9o = parcelRequire("irY9o");
var $ufx0P = parcelRequire("ufx0P");

var $3ncYX = parcelRequire("3ncYX");
var $6fOEt = parcelRequire("6fOEt");

var $r2pbj = parcelRequire("r2pbj");
var $dve7z = parcelRequire("dve7z");

var $jSKh9 = parcelRequire("jSKh9");
var $c7Z6l = parcelRequire("c7Z6l");

var $8K2ON = parcelRequire("8K2ON");
var $9Uf6W = parcelRequire("9Uf6W");

var $fn1L3 = parcelRequire("fn1L3");
var $h7bvr = parcelRequire("h7bvr");

var $9KKA8 = parcelRequire("9KKA8");
var $bfkCH = parcelRequire("bfkCH");

var $jfVmm = parcelRequire("jfVmm");
var $jSDw1 = parcelRequire("jSDw1");

var $hyog7 = parcelRequire("hyog7");
var $clhkW = parcelRequire("clhkW");

var $cOomS = parcelRequire("cOomS");
var $dzVJy = parcelRequire("dzVJy");

var $4QIyn = parcelRequire("4QIyn");
var $d6RjL = parcelRequire("d6RjL");

var $grMtb = parcelRequire("grMtb");
var $f3vBF = parcelRequire("f3vBF");

var $dnSYQ = parcelRequire("dnSYQ");
var $2deKN = parcelRequire("2deKN");

var $4y9J3 = parcelRequire("4y9J3");
var $bHojE = parcelRequire("bHojE");

var $jNxKr = parcelRequire("jNxKr");
var $3aaXm = parcelRequire("3aaXm");

var $7hGmK = parcelRequire("7hGmK");

var $fDu6v = parcelRequire("fDu6v");
var $18jyN = parcelRequire("18jyN");

var $kjgk3 = parcelRequire("kjgk3");
var $eUNIY = parcelRequire("eUNIY");

var $bShAr = parcelRequire("bShAr");
var $35rAG = parcelRequire("35rAG");

var $1t4IN = parcelRequire("1t4IN");
var $9kTpK = parcelRequire("9kTpK");

var $ipNof = parcelRequire("ipNof");
var $5Fmp3 = parcelRequire("5Fmp3");

var $28o9P = parcelRequire("28o9P");
var $d0mzZ = parcelRequire("d0mzZ");

var $3LlsA = parcelRequire("3LlsA");
var $8tIgu = parcelRequire("8tIgu");

var $fWDFh = parcelRequire("fWDFh");
var $4PqXH = parcelRequire("4PqXH");

var $ksx0g = parcelRequire("ksx0g");
var $iwtyt = parcelRequire("iwtyt");

var $68M1J = parcelRequire("68M1J");
var $httlh = parcelRequire("httlh");

var $bPFG7 = parcelRequire("bPFG7");
var $jPufg = parcelRequire("jPufg");

var $9eGYF = parcelRequire("9eGYF");
var $kBV2S = parcelRequire("kBV2S");

var $jnM1h = parcelRequire("jnM1h");
var $e98Of = parcelRequire("e98Of");

var $9veJa = parcelRequire("9veJa");
var $bm32A = parcelRequire("bm32A");

var $ijdoi = parcelRequire("ijdoi");
var $2PkYH = parcelRequire("2PkYH");

var $hO5zU = parcelRequire("hO5zU");
var $4XgN9 = parcelRequire("4XgN9");

var $4HCDk = parcelRequire("4HCDk");
var $4r6TV = parcelRequire("4r6TV");

var $4rAbO = parcelRequire("4rAbO");
var $kN3d4 = parcelRequire("kN3d4");

var $h1quS = parcelRequire("h1quS");
var $iHTRV = parcelRequire("iHTRV");

var $6zLvw = parcelRequire("6zLvw");
var $8BZ2B = parcelRequire("8BZ2B");

var $6wGRj = parcelRequire("6wGRj");
var $5JSZh = parcelRequire("5JSZh");

var $9xRvp = parcelRequire("9xRvp");
var $llqgg = parcelRequire("llqgg");

var $9TWYe = parcelRequire("9TWYe");
var $DaC3M = parcelRequire("DaC3M");

var $5fnJd = parcelRequire("5fnJd");
var $33EnL = parcelRequire("33EnL");

var $7sXPa = parcelRequire("7sXPa");
var $lms1E = parcelRequire("lms1E");

var $cMF7I = parcelRequire("cMF7I");
var $6r8l9 = parcelRequire("6r8l9");

var $2DG6T = parcelRequire("2DG6T");
var $bzKCl = parcelRequire("bzKCl");

var $84G8H = parcelRequire("84G8H");
var $5G51F = parcelRequire("5G51F");





var $5UWRo = parcelRequire("5UWRo");


var $8CqxZ = parcelRequire("8CqxZ");
var $f6350ee01f5a23f4$export$ef8e5f836dd989d3 = (0, $8CqxZ.tempSizeWrapper)((0, $7rGcv.AdminIcon));
var $f6350ee01f5a23f4$export$ebcd30672e67406 = (0, $8CqxZ.tempSizeWrapper)((0, $iwnjp.AdminLogoCS));
var $f6350ee01f5a23f4$export$af3460f51ce3602a = (0, $8CqxZ.tempSizeWrapper)((0, $dCCse.AnalyticsIcon));
var $f6350ee01f5a23f4$export$c8415b6abe4a8587 = (0, $8CqxZ.tempSizeWrapper)((0, $8noz9.AnalyticsLogoCS));
var $f6350ee01f5a23f4$export$d89497e7f33ca6f5 = (0, $8CqxZ.tempSizeWrapper)((0, $bxLJ6.AssetsIcon));
var $f6350ee01f5a23f4$export$48ca930f3071e3e4 = (0, $8CqxZ.tempSizeWrapper)((0, $f9IM6.AssetsLogoCS));
var $f6350ee01f5a23f4$export$52cd484a7ef4f2b9 = (0, $8CqxZ.tempSizeWrapper)((0, $iMZic.ChatIcon));
var $f6350ee01f5a23f4$export$9ca9881809919df8 = (0, $8CqxZ.tempSizeWrapper)((0, $epHQB.ChatLogoCS));
var $f6350ee01f5a23f4$export$6da5aa77c402ba0f = (0, $8CqxZ.tempSizeWrapper)((0, $jSKh9.CustomerServiceManagementIcon));
var $f6350ee01f5a23f4$export$abc95e6180bb1d88 = (0, $8CqxZ.tempSizeWrapper)((0, $c7Z6l.CustomerServiceManagementLogoCS));
var $f6350ee01f5a23f4$export$9eb74917ea768ed4 = (0, $8CqxZ.tempSizeWrapper)((0, $fn1L3.GoalsIcon));
var $f6350ee01f5a23f4$export$d2577aa28451395f = (0, $8CqxZ.tempSizeWrapper)((0, $h7bvr.GoalsLogoCS));
var $f6350ee01f5a23f4$export$92c8767b874048d = (0, $8CqxZ.tempSizeWrapper)((0, $jfVmm.HomeIcon));
var $f6350ee01f5a23f4$export$d5648119d5b68e90 = (0, $8CqxZ.tempSizeWrapper)((0, $jSDw1.HomeLogoCS));
var $f6350ee01f5a23f4$export$80b8b269d8b5014e = (0, $8CqxZ.tempSizeWrapper)((0, $hyog7.HubIcon));
var $f6350ee01f5a23f4$export$fc9bd6687b80fe3b = (0, $8CqxZ.tempSizeWrapper)((0, $clhkW.HubLogoCS));
var $f6350ee01f5a23f4$export$5ed3e1bb3b04fc02 = (0, $8CqxZ.tempSizeWrapper)((0, $bShAr.ProjectsIcon));
var $f6350ee01f5a23f4$export$aeefab651bcf2338 = (0, $8CqxZ.tempSizeWrapper)((0, $35rAG.ProjectsLogoCS));
var $f6350ee01f5a23f4$export$82eafebb825fc23f = (0, $8CqxZ.tempSizeWrapper)((0, $ipNof.SearchIcon));
var $f6350ee01f5a23f4$export$e4c5487c9a8ae3b1 = (0, $8CqxZ.tempSizeWrapper)((0, $5Fmp3.SearchLogoCS));
var $f6350ee01f5a23f4$export$290a0f24614cde9f = (0, $8CqxZ.tempSizeWrapper)((0, $3LlsA.StudioIcon));
var $f6350ee01f5a23f4$export$8aceb78c659789b6 = (0, $8CqxZ.tempSizeWrapper)((0, $8tIgu.StudioLogoCS));
var $f6350ee01f5a23f4$export$4b05688514531169 = (0, $8CqxZ.tempSizeWrapper)((0, $fWDFh.TalentIcon));
var $f6350ee01f5a23f4$export$4f6453e012279f89 = (0, $8CqxZ.tempSizeWrapper)((0, $4PqXH.TalentLogoCS));
var $f6350ee01f5a23f4$export$1bcbc9c337da86da = (0, $8CqxZ.tempSizeWrapper)((0, $ksx0g.TeamsIcon));
var $f6350ee01f5a23f4$export$9b1a0a0c574cec2a = (0, $8CqxZ.tempSizeWrapper)((0, $iwtyt.TeamsLogoCS));
var $f6350ee01f5a23f4$export$e812398311cab9a3 = (0, $8CqxZ.tempSizeWrapper)((0, $cEiIr.BambooIcon));
var $f6350ee01f5a23f4$export$765f5afcc1a5a7e3 = (0, $8CqxZ.tempSizeWrapper)((0, $i634e.BambooLogoCS));
var $f6350ee01f5a23f4$export$d3ab16bbf4f954ee = (0, $8CqxZ.tempSizeWrapper)((0, $9wFae.BitbucketDataCenterIcon));
var $f6350ee01f5a23f4$export$36044946916e84a0 = (0, $8CqxZ.tempSizeWrapper)((0, $c1VXe.BitbucketDataCenterLogoCS));
var $f6350ee01f5a23f4$export$53305f1f2855d3be = (0, $8CqxZ.tempSizeWrapper)((0, $3ncYX.ConfluenceDataCenterIcon));
var $f6350ee01f5a23f4$export$5e06396bce773a3 = (0, $8CqxZ.tempSizeWrapper)((0, $6fOEt.ConfluenceDataCenterLogoCS));
var $f6350ee01f5a23f4$export$eaf73f391f7103bd = (0, $8CqxZ.tempSizeWrapper)((0, $r2pbj.CrowdIcon));
var $f6350ee01f5a23f4$export$6128b385660fd3c6 = (0, $8CqxZ.tempSizeWrapper)((0, $dve7z.CrowdLogoCS));
var $f6350ee01f5a23f4$export$f8455b5667a3ee0c = (0, $8CqxZ.tempSizeWrapper)((0, $4QIyn.JiraDataCenterIcon));
var $f6350ee01f5a23f4$export$eb152ab3801b2ae3 = (0, $8CqxZ.tempSizeWrapper)((0, $d6RjL.JiraDataCenterLogoCS));
var $f6350ee01f5a23f4$export$65fae0eaf343f2ca = (0, $8CqxZ.tempSizeWrapper)((0, $4y9J3.JiraServiceManagementDataCenterIcon));
var $f6350ee01f5a23f4$export$fffc0d480fb1ebf1 = (0, $8CqxZ.tempSizeWrapper)((0, $bHojE.JiraServiceManagementDataCenterLogoCS));
var $f6350ee01f5a23f4$export$74517ed253186308 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $9eGYF.AtlassianAdministrationIcon), (0, $7rGcv.AdminIcon));
var $f6350ee01f5a23f4$export$833abe6c2ce5ebfd = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $kBV2S.AtlassianAdministrationLogo), (0, $iwnjp.AdminLogoCS));
var $f6350ee01f5a23f4$export$84109e099492cb5f = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $bPFG7.AtlassianAdminIcon), (0, $7rGcv.AdminIcon));
var $f6350ee01f5a23f4$export$f845d9b9254f0541 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $jPufg.AtlassianAdminLogo), (0, $iwnjp.AdminLogoCS));
var $f6350ee01f5a23f4$export$c42ad8a0b925c762 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $jnM1h.AtlassianAnalyticsIcon), (0, $dCCse.AnalyticsIcon));
var $f6350ee01f5a23f4$export$e6470bfc39010cc4 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $e98Of.AtlassianAnalyticsLogo), (0, $8noz9.AnalyticsLogoCS));
var $f6350ee01f5a23f4$export$5fc1066e677788d4 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $9veJa.BitbucketIcon), (0, $1CEtF.BitbucketIcon));
var $f6350ee01f5a23f4$export$bd40525f5333524b = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $bm32A.BitbucketLogo), (0, $iTq8Z.BitbucketLogoCS));
var $f6350ee01f5a23f4$export$f7857fe64d7161d9 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $ijdoi.CompassIcon), (0, $cwlpA.CompassIcon));
var $f6350ee01f5a23f4$export$eb7d748e4f9c9676 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $2PkYH.CompassLogo), (0, $8NXfU.CompassLogoCS));
var $f6350ee01f5a23f4$export$68f3db7f6af48bcb = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $hO5zU.ConfluenceIcon), (0, $irY9o.ConfluenceIcon));
var $f6350ee01f5a23f4$export$1b2e4fe6ef471556 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $4XgN9.ConfluenceLogo), (0, $ufx0P.ConfluenceLogoCS));
var $f6350ee01f5a23f4$export$70a0c2f5862937b6 = (0, $8CqxZ.tempSizeWrapper)((0, $d0t0D.AlignIcon));
var $f6350ee01f5a23f4$export$1b8596b4b0ef673b = (0, $8CqxZ.tempSizeWrapper)((0, $etvMV.AlignLogoCS));
var $f6350ee01f5a23f4$export$407687b2dd89cc68 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $6zLvw.JiraAlignIcon), (0, $d0t0D.AlignIcon));
var $f6350ee01f5a23f4$export$ee11e928d3d045fd = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $8BZ2B.JiraAlignLogo), (0, $etvMV.AlignLogoCS));
var $f6350ee01f5a23f4$export$c4b5b1f965d8b3eb = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $h1quS.JiraIcon), (0, $cOomS.JiraIcon));
var $f6350ee01f5a23f4$export$17d3acb0b4379d02 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $iHTRV.JiraLogo), (0, $dzVJy.JiraLogoCS));
var $f6350ee01f5a23f4$export$21bfbeb62fdcce8d = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $6wGRj.JiraProductDiscoveryIcon), (0, $grMtb.JiraProductDiscoveryIcon));
var $f6350ee01f5a23f4$export$c49a2b642fe9eef4 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $5JSZh.JiraProductDiscoveryLogo), (0, $f3vBF.JiraProductDiscoveryLogoCS));
var $f6350ee01f5a23f4$export$3c6158790f5e01c4 = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $9xRvp.JiraServiceManagementIcon), (0, $dnSYQ.JiraServiceManagementIcon));
var $f6350ee01f5a23f4$export$dabef2be6cd28c20 = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $llqgg.JiraServiceManagementLogo), (0, $2deKN.JiraServiceManagementLogoCS));
var $f6350ee01f5a23f4$export$8d789f76fde3e05 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $9TWYe.LoomIcon), (0, $jNxKr.LoomIcon));
var $f6350ee01f5a23f4$export$94e206806e36c2ec = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $DaC3M.LoomLogo), (0, $3aaXm.LoomLogoCS));
var $f6350ee01f5a23f4$export$1bf47cdade1a9fcb = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $5fnJd.LoomAttributionIcon), (0, $jNxKr.LoomIcon));
var $f6350ee01f5a23f4$export$6e87ce8d41eda665 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $33EnL.LoomAttributionLogo), (0, $7hGmK.LoomAttributionLogoCS));
var $f6350ee01f5a23f4$export$e84e925618e0e5bc = (0, $8CqxZ.tempSizeWrapper)((0, $18jyN.LoomInternalLogoCS));
var $f6350ee01f5a23f4$export$1940ba72c868b663 = (0, $8CqxZ.tempSizeWrapper)((0, $fDu6v.LoomInternalIcon));
var $f6350ee01f5a23f4$export$eeccc49dc7a12d9f = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $7sXPa.OpsgenieIcon), (0, $kjgk3.OpsgenieIcon));
var $f6350ee01f5a23f4$export$a1c6484cdecc2c4b = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $lms1E.OpsgenieLogo), (0, $eUNIY.OpsgenieLogoCS));
var $f6350ee01f5a23f4$export$f3f5aa321d88adf9 = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $2DG6T.StatuspageIcon), (0, $28o9P.StatuspageIcon));
var $f6350ee01f5a23f4$export$bb4ae5b41b43be04 = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $bzKCl.StatuspageLogo), (0, $d0mzZ.StatuspageLogoCS));
var $f6350ee01f5a23f4$export$4384da9b8b140bf4 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $84G8H.TrelloIcon), (0, $68M1J.TrelloIcon));
var $f6350ee01f5a23f4$export$60e26212f3b61a28 = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $5G51F.TrelloLogo), (0, $httlh.TrelloLogoCS));
var $f6350ee01f5a23f4$export$e23ae35269442b4f = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $cMF7I.RovoIcon), (0, $1t4IN.RovoIcon));
var $f6350ee01f5a23f4$export$a0f6cb8061290bbb = (0, $8CqxZ.createFeatureFlaggedServiceCollectionComponent)((0, $6r8l9.RovoLogo), (0, $9kTpK.RovoLogoCS));
var $f6350ee01f5a23f4$export$3f95fcfdc25a741d = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $4rAbO.GuardIcon), (0, $9KKA8.GuardIcon));
var $f6350ee01f5a23f4$export$a4a891d202775deb = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $kN3d4.GuardLogo), (0, $bfkCH.GuardLogoCS));
var $f6350ee01f5a23f4$export$1e02e7298035a77c = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $4HCDk.FocusIcon), (0, $8K2ON.FocusIcon));
var $f6350ee01f5a23f4$export$33908560ea1b226d = (0, $8CqxZ.createFeatureFlaggedComponent)((0, $4r6TV.FocusLogo), (0, $9Uf6W.FocusLogoCS));

});
parcelRegister("7rGcv", function(module, exports) {

$parcel$export(module.exports, "AdminIcon", function () { return $56bbca37304f6a59$export$ef8e5f836dd989d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1b4c2b482d26b1be8309fdd18226deba>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $56bbca37304f6a59$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $56bbca37304f6a59$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $56bbca37304f6a59$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("2JOTk", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", function () { return $1fe742b0d07537be$export$be58b4326e23250f; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $9XpDE = parcelRequire("9XpDE");
var $1fe742b0d07537be$var$styles = {
    root: "_1e0c1o8l"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1fe742b0d07537be$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1fe742b0d07537be$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1fe742b0d07537be$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1fe742b0d07537be$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $1fe742b0d07537be$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    '12': "_4t3i1crf",
    '16': "_4t3i7vkz",
    '20': "_4t3igktf",
    '24': "_4t3i1tcg",
    '32': "_4t3izwfg"
};
function $1fe742b0d07537be$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? '20' : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, customIconColor = _ref.iconColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $c4hjl.default)([
            $1fe742b0d07537be$var$styles.root,
            $1fe742b0d07537be$var$sizeMap[size],
            isDataCenter ? colorMode === 'dark' ? $1fe742b0d07537be$var$dataCenterDarkAppearanceMap[appearance] : $1fe742b0d07537be$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $1fe742b0d07537be$var$cloudDarkAppearanceMap[appearance] : $1fe742b0d07537be$var$cloudLightAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("iwnjp", function(module, exports) {

$parcel$export(module.exports, "AdminLogoCS", function () { return $d7bd4c6d547a427f$export$61afcb38c001e19; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ecce23f80806781db9edeff944632b7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d7bd4c6d547a427f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d7bd4c6d547a427f$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Admin' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $d7bd4c6d547a427f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});
parcelRegister("eY6vy", function(module, exports) {

$parcel$export(module.exports, "LogoWrapper", function () { return $ae5bb79cba1cdee0$export$f827d3c5a9c3f644; });
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $9XpDE = parcelRequire("9XpDE");
var $ae5bb79cba1cdee0$var$styles = {
    root: "_1e0c1o8l _vwz4idpf"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $ae5bb79cba1cdee0$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $ae5bb79cba1cdee0$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$textLightAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$textDarkAppearanceMap = {
    brand: "_1wyc1fxt",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $ae5bb79cba1cdee0$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
function $ae5bb79cba1cdee0$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? 'small' : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isDataCenter = _ref.isDataCenter, isDataCenter = _ref$isDataCenter === void 0 ? false : _ref$isDataCenter;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor === 'inherit' ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-text-color': customTextColor || 'inherit'
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $c4hjl.default)([
            $ae5bb79cba1cdee0$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $ae5bb79cba1cdee0$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : 'light'],
            $ae5bb79cba1cdee0$var$sizeMap[size],
            colorMode === 'dark' ? $ae5bb79cba1cdee0$var$textDarkAppearanceMap[appearance] : $ae5bb79cba1cdee0$var$textLightAppearanceMap[appearance],
            isDataCenter ? colorMode === 'dark' ? $ae5bb79cba1cdee0$var$dataCenterDarkAppearanceMap[appearance] : $ae5bb79cba1cdee0$var$dataCenterLightAppearanceMap[appearance] : colorMode === 'dark' ? $ae5bb79cba1cdee0$var$cloudDarkAppearanceMap[appearance] : $ae5bb79cba1cdee0$var$cloudLightAppearanceMap[appearance]
        ])
    });
}

});


parcelRegister("d0t0D", function(module, exports) {

$parcel$export(module.exports, "AlignIcon", function () { return $9781c711cfa86f3c$export$70a0c2f5862937b6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::267cad59c76b16aeee5f58cfa4a1f733>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9781c711cfa86f3c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z\"/>\n</svg>\n";
function $9781c711cfa86f3c$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $9781c711cfa86f3c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("etvMV", function(module, exports) {

$parcel$export(module.exports, "AlignLogoCS", function () { return $a89c6e92207a5089$export$8b5103382c06639c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56bacfcde6f81799eb41bc2261641230>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a89c6e92207a5089$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z\"/>\n</svg>\n";
function $a89c6e92207a5089$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Align' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $a89c6e92207a5089$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dCCse", function(module, exports) {

$parcel$export(module.exports, "AnalyticsIcon", function () { return $9eaca7342f216898$export$af3460f51ce3602a; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62d7ed5486f2fde4ab85bad091e6130c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9eaca7342f216898$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z\"/>\n</svg>\n";
function $9eaca7342f216898$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $9eaca7342f216898$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8noz9", function(module, exports) {

$parcel$export(module.exports, "AnalyticsLogoCS", function () { return $619386ffc252417f$export$f0bac2b7ac3e3504; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c346421b23be4892d11f5300b3f9b8f0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $619386ffc252417f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 161 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z\"/>\n</svg>\n";
function $619386ffc252417f$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Analytics' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $619386ffc252417f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bxLJ6", function(module, exports) {

$parcel$export(module.exports, "AssetsIcon", function () { return $8677cc3d580c982c$export$d89497e7f33ca6f5; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7e353680649504e5005ac163dde6655>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8677cc3d580c982c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z\"/>\n</svg>\n";
var $8677cc3d580c982c$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729\"/>\n</svg>\n";
function $8677cc3d580c982c$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $8677cc3d580c982c$var$svg,
        customThemeSvg: $8677cc3d580c982c$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f9IM6", function(module, exports) {

$parcel$export(module.exports, "AssetsLogoCS", function () { return $b08a6d9e0660b648$export$81c47abe19675c4c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b2c2f81dcecc713953841df3ebcde68>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b08a6d9e0660b648$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25\" clip-rule=\"evenodd\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z\"/>\n</svg>\n";
function $b08a6d9e0660b648$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Assets' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $b08a6d9e0660b648$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cEiIr", function(module, exports) {

$parcel$export(module.exports, "BambooIcon", function () { return $9357bd0ac450d0ee$export$e812398311cab9a3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e235764598011d7e6fcb75b2257be900>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9357bd0ac450d0ee$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z\"/>\n</svg>\n";
function $9357bd0ac450d0ee$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $9357bd0ac450d0ee$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("i634e", function(module, exports) {

$parcel$export(module.exports, "BambooLogoCS", function () { return $d2cb2aa2ff6d5be5$export$7c51958462d750e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4be588a359814839f3a38a10b8622b63>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d2cb2aa2ff6d5be5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 154 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z\"/>\n</svg>\n";
function $d2cb2aa2ff6d5be5$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bamboo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $d2cb2aa2ff6d5be5$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1CEtF", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $12e8bd0f4aa3c86e$export$5fc1066e677788d4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a48cd0ac1ce9dea97cb133dca9e33de4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $12e8bd0f4aa3c86e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582\"/>\n</svg>\n";
var $12e8bd0f4aa3c86e$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z\"/>\n</svg>\n";
function $12e8bd0f4aa3c86e$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $12e8bd0f4aa3c86e$var$svg,
        customThemeSvg: $12e8bd0f4aa3c86e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iTq8Z", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogoCS", function () { return $dc11a4ad22a005ed$export$f7ef5e5488e4b430; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d54637b0b2f479c52492d2d0abf8bb82>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $dc11a4ad22a005ed$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771\"/>\n</svg>\n";
function $dc11a4ad22a005ed$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $dc11a4ad22a005ed$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9wFae", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterIcon", function () { return $6ef7088679477719$export$d3ab16bbf4f954ee; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b1a960d2db34ca3f44ef8828b3815ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $6ef7088679477719$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578\"/>\n</svg>\n";
function $6ef7088679477719$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $6ef7088679477719$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c1VXe", function(module, exports) {

$parcel$export(module.exports, "BitbucketDataCenterLogoCS", function () { return $8c22888ca748c7b8$export$cc55e2a4c4b40552; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d6df504ec1dfd9f26a50f8d7e45924c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8c22888ca748c7b8$var$svg = "<svg height=\"100%\" viewBox=\"0 0 166 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771\"/>\n</svg>\n";
function $8c22888ca748c7b8$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Bitbucket Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $8c22888ca748c7b8$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iMZic", function(module, exports) {

$parcel$export(module.exports, "ChatIcon", function () { return $0387ae7823b5b190$export$52cd484a7ef4f2b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae2d6061a51a6b69522551138415fa2a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0387ae7823b5b190$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $0387ae7823b5b190$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $0387ae7823b5b190$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("epHQB", function(module, exports) {

$parcel$export(module.exports, "ChatLogoCS", function () { return $a7e569a6d8f487ce$export$a529e78951cd6709; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f10c9ed117b987aa620e842ad4c67da2>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $a7e569a6d8f487ce$var$svg = "<svg height=\"100%\" viewBox=\"0 0 102 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $a7e569a6d8f487ce$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Chat' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $a7e569a6d8f487ce$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cwlpA", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $91d915157b4b6e1d$export$f7857fe64d7161d9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ec19b3c26d91498312286db03f0eb4ea>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $91d915157b4b6e1d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z\"/>\n</svg>\n";
function $91d915157b4b6e1d$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $91d915157b4b6e1d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8NXfU", function(module, exports) {

$parcel$export(module.exports, "CompassLogoCS", function () { return $6690dd436222bafa$export$a16f50a81d183ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5bc93a13860fb0293d95e675d91c82c4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6690dd436222bafa$var$svg = "<svg height=\"100%\" viewBox=\"0 0 162 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#94c748)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z\"/>\n</svg>\n";
function $6690dd436222bafa$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Compass' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $6690dd436222bafa$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("irY9o", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $d6e9683d5967f431$export$68f3db7f6af48bcb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d74d7ecef16716d9233a75661d1c4ae>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d6e9683d5967f431$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673\"/>\n</svg>\n";
var $d6e9683d5967f431$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135\"/>\n</svg>\n";
function $d6e9683d5967f431$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $d6e9683d5967f431$var$svg,
        customThemeSvg: $d6e9683d5967f431$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ufx0P", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogoCS", function () { return $05aed9ae4c102045$export$a88b0b0da9ef63ce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dddd2bd68cfa97eb485c03553f4e24d7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $05aed9ae4c102045$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823\"/>\n</svg>\n";
function $05aed9ae4c102045$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $05aed9ae4c102045$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3ncYX", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterIcon", function () { return $274d970d5129eec2$export$53305f1f2855d3be; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a14a00c887df7cd127b285246b99735>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $274d970d5129eec2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617\"/>\n</svg>\n";
function $274d970d5129eec2$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $274d970d5129eec2$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("6fOEt", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDataCenterLogoCS", function () { return $48db6f2a099ab929$export$b3e508cb103e1f93; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::247f612d885273d5ec9340d29cd5314f>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $48db6f2a099ab929$var$svg = "<svg height=\"100%\" viewBox=\"0 0 188 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823\"/>\n</svg>\n";
function $48db6f2a099ab929$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Confluence Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $48db6f2a099ab929$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("r2pbj", function(module, exports) {

$parcel$export(module.exports, "CrowdIcon", function () { return $0514635814c3cf54$export$eaf73f391f7103bd; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::737475caba8467007ea15db78e7ae272>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $0514635814c3cf54$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433\"/>\n</svg>\n";
function $0514635814c3cf54$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $0514635814c3cf54$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dve7z", function(module, exports) {

$parcel$export(module.exports, "CrowdLogoCS", function () { return $9d491fc4bb3f201a$export$3c371bdbcdfcdce; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c40fab6689e9bdd9624e2a214b20ab71>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9d491fc4bb3f201a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 126 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577\"/>\n</svg>\n";
function $9d491fc4bb3f201a$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Crowd' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $9d491fc4bb3f201a$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jSKh9", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementIcon", function () { return $e796f4d24501ea11$export$6da5aa77c402ba0f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf714453512d29992419d0b1472039ec>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e796f4d24501ea11$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z\"/>\n</svg>\n";
var $e796f4d24501ea11$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5\"/>\n</svg>\n";
function $e796f4d24501ea11$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $e796f4d24501ea11$var$svg,
        customThemeSvg: $e796f4d24501ea11$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("c7Z6l", function(module, exports) {

$parcel$export(module.exports, "CustomerServiceManagementLogoCS", function () { return $8d4588f24d12b281$export$f597f0f7fadce0b9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8071dd02178137151c85fefeeccfbf6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8d4588f24d12b281$var$svg = "<svg height=\"100%\" viewBox=\"0 0 456 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z\"/>\n</svg>\n";
function $8d4588f24d12b281$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Customer Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $8d4588f24d12b281$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8K2ON", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $65d4ce457e501b2c$export$1e02e7298035a77c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc3eeb7d4cfaf5ff93494f75e1a18082>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $65d4ce457e501b2c$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z\"/>\n</svg>\n";
function $65d4ce457e501b2c$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $65d4ce457e501b2c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9Uf6W", function(module, exports) {

$parcel$export(module.exports, "FocusLogoCS", function () { return $736510c0060ffdb6$export$3a6e8b37e069a69d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fde58bf2e05397b9d002acff853fdc38>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $736510c0060ffdb6$var$svg = "<svg height=\"100%\" viewBox=\"0 0 117 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z\"/>\n</svg>\n";
function $736510c0060ffdb6$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Focus' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $736510c0060ffdb6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fn1L3", function(module, exports) {

$parcel$export(module.exports, "GoalsIcon", function () { return $b30a5e12e8becb66$export$9eb74917ea768ed4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::396f70864944722c3ba43a8857b797aa>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b30a5e12e8becb66$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b30a5e12e8becb66$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $b30a5e12e8becb66$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("h7bvr", function(module, exports) {

$parcel$export(module.exports, "GoalsLogoCS", function () { return $c75c03fc10329b11$export$c527a545aa426db3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0681058b5d17f20f830a057d776b5aa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c75c03fc10329b11$var$svg = "<svg height=\"100%\" viewBox=\"0 0 116 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $c75c03fc10329b11$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Goals' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $c75c03fc10329b11$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9KKA8", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $719c8b18dcbe4d96$export$3f95fcfdc25a741d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9cb16fe47b2bb06a618d6f42235f4d0b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $719c8b18dcbe4d96$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649\"/>\n</svg>\n";
function $719c8b18dcbe4d96$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $719c8b18dcbe4d96$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bfkCH", function(module, exports) {

$parcel$export(module.exports, "GuardLogoCS", function () { return $830117c566e8f9ab$export$2b896c4d595a4331; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f601744ebb3feb381ec2bc379ecb922e>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $830117c566e8f9ab$var$svg = "<svg height=\"100%\" viewBox=\"0 0 120 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778\"/>\n</svg>\n";
function $830117c566e8f9ab$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Guard' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $830117c566e8f9ab$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jfVmm", function(module, exports) {

$parcel$export(module.exports, "HomeIcon", function () { return $e04be9747fa363df$export$92c8767b874048d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f4789b6ef9b66e17e85ce46edd0e20b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e04be9747fa363df$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z\"/>\n</svg>\n";
function $e04be9747fa363df$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $e04be9747fa363df$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jSDw1", function(module, exports) {

$parcel$export(module.exports, "HomeLogoCS", function () { return $e791b665c8eff094$export$8b6b7f1b1b2367d3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f31fca5cffff624ab8dfe2f380f4c6a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e791b665c8eff094$var$svg = "<svg height=\"100%\" viewBox=\"0 0 121 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z\"/>\n</svg>\n";
function $e791b665c8eff094$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Home' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $e791b665c8eff094$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("hyog7", function(module, exports) {

$parcel$export(module.exports, "HubIcon", function () { return $cc786df9ad8867a0$export$80b8b269d8b5014e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::826142130c83ecce3a55557ab8c9ff78>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $cc786df9ad8867a0$var$svg = "<svg height=\"100%\" viewBox=\"0 0 32 32\">\n    <g clip-path=\"url(#clip0_95164_16219)\">\n        <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n        <g clip-path=\"url(#clip1_95164_16219)\">\n            <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id=\"clip0_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M0 0h32v32H0z\"/>\n        </clipPath>\n        <clipPath id=\"clip1_95164_16219\">\n            <path fill=\"var(--icon-color, white)\" d=\"M2 2h28v28H2z\"/>\n        </clipPath>\n    </defs>\n</svg>\n";
function $cc786df9ad8867a0$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $cc786df9ad8867a0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("clhkW", function(module, exports) {

$parcel$export(module.exports, "HubLogoCS", function () { return $8fc4e4ee62d5309e$export$7a38180641471460; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::742f94652f61dfd860aacb3fafe2261c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8fc4e4ee62d5309e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 95 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $8fc4e4ee62d5309e$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Hub' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $8fc4e4ee62d5309e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("cOomS", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $953d0e84ec26d10a$export$c4b5b1f965d8b3eb; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::349400291f8d779d7f120565198fb274>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $953d0e84ec26d10a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z\"/>\n</svg>\n";
var $953d0e84ec26d10a$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z\"/>\n</svg>\n";
function $953d0e84ec26d10a$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $953d0e84ec26d10a$var$svg,
        customThemeSvg: $953d0e84ec26d10a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dzVJy", function(module, exports) {

$parcel$export(module.exports, "JiraLogoCS", function () { return $9e2b53fbe7846a9a$export$bf4c5f97b468e8d6; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e76e8b0984e9a10157b3a2965f276eb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9e2b53fbe7846a9a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $9e2b53fbe7846a9a$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $9e2b53fbe7846a9a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4QIyn", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterIcon", function () { return $387e941efef202c5$export$f8455b5667a3ee0c; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be11a29c939ff0f2a727a12285a62df7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $387e941efef202c5$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z\"/>\n</svg>\n";
function $387e941efef202c5$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $387e941efef202c5$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d6RjL", function(module, exports) {

$parcel$export(module.exports, "JiraDataCenterLogoCS", function () { return $98b531af0bc807d3$export$3224b07bc93ef23e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2149e3bf372f0515252a5e78dec7c590>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $98b531af0bc807d3$var$svg = "<svg height=\"100%\" viewBox=\"0 0 83 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z\"/>\n</svg>\n";
function $98b531af0bc807d3$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $98b531af0bc807d3$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("grMtb", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $bf94c403ca674c38$export$21bfbeb62fdcce8d; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4986587aa74e2199c5aaa284b753e478>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $bf94c403ca674c38$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z\"/>\n</svg>\n";
var $bf94c403ca674c38$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228\"/>\n</svg>\n";
function $bf94c403ca674c38$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $bf94c403ca674c38$var$svg,
        customThemeSvg: $bf94c403ca674c38$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("f3vBF", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogoCS", function () { return $af5fa734380aa212$export$602140a6a10b02bf; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::21e7556cd73294fd9a2b8ada6433a2bb>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $af5fa734380aa212$var$svg = "<svg height=\"100%\" viewBox=\"0 0 327 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#c97cf4)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z\"/>\n</svg>\n";
function $af5fa734380aa212$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Product Discovery' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $af5fa734380aa212$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("dnSYQ", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $9be8124f836f8471$export$3c6158790f5e01c4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a167626b0cdea243238150a218b626f1>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $9be8124f836f8471$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z\"/>\n</svg>\n";
var $9be8124f836f8471$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z\"/>\n</svg>\n";
function $9be8124f836f8471$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $9be8124f836f8471$var$svg,
        customThemeSvg: $9be8124f836f8471$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("2deKN", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogoCS", function () { return $19c83d730f818a69$export$de148263c75d2bc1; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e9309f3b1cc7fb1643e1f60f1ab07da>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $19c83d730f818a69$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $19c83d730f818a69$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $19c83d730f818a69$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4y9J3", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterIcon", function () { return $3501e1b1c6fb15cf$export$65fae0eaf343f2ca; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::785b520448be5254a616c00701ca6073>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $3501e1b1c6fb15cf$var$svg = "<svg height=\"100%\" viewBox=\"0 0 25 24\">\n    <path fill=\"var(--tile-color, white)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" d=\"M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z\"/>\n</svg>\n";
function $3501e1b1c6fb15cf$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $3501e1b1c6fb15cf$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bHojE", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementDataCenterLogoCS", function () { return $8846927fa59ef86d$export$f64bc7a7f04428d0; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf181e1edfa57dcb5b7463f70781d820>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $8846927fa59ef86d$var$svg = "<svg height=\"100%\" viewBox=\"0 0 372 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4\"/>\n    <path fill=\"var(--tile-color, white)\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667\"/>\n    <path fill=\"none\" stroke=\"var(--border-color, #dddee1)\" stroke-width=\"1.333\" d=\"M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z\"/>\n    <path fill=\"var(--icon-color, #1868db)\" d=\"M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z\"/>\n</svg>\n";
function $8846927fa59ef86d$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Jira Service Management Data Center' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $8846927fa59ef86d$var$svg,
        label: label,
        isDataCenter: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("jNxKr", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $e69cc59603225963$export$8d789f76fde3e05; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55187565d76d0ab70107b394d5174d9a>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $e69cc59603225963$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $e69cc59603225963$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $e69cc59603225963$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3aaXm", function(module, exports) {

$parcel$export(module.exports, "LoomLogoCS", function () { return $24dacdfce7925058$export$78c0b4d8be34c9b2; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad3119cedd34de3d960e5ccfcb794468>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $24dacdfce7925058$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $24dacdfce7925058$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $24dacdfce7925058$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("7hGmK", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogoCS", function () { return $54dafbefddbfb627$export$68d7391318cdef11; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e1ee46dc9ada114b6751598218ceaa3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $54dafbefddbfb627$var$svg = "<svg height=\"100%\" viewBox=\"0 0 100 32\">\n    <path fill=\"var(--icon-color, #101214)\" d=\"M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68\"/>\n</svg>\n";
function $54dafbefddbfb627$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $54dafbefddbfb627$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fDu6v", function(module, exports) {

$parcel$export(module.exports, "LoomInternalIcon", function () { return $b621d9912c5cc556$export$38c7b37a3e5e8d70; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c3dabecb5c666d4b59916374e96299a4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b621d9912c5cc556$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302\"/>\n</svg>\n";
function $b621d9912c5cc556$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $b621d9912c5cc556$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("18jyN", function(module, exports) {

$parcel$export(module.exports, "LoomInternalLogoCS", function () { return $0d35b611d3b3dcf2$export$71743a944cb62e48; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa2c5f0b3386bcf846320a0b87a8366d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0d35b611d3b3dcf2$var$svg = "<svg height=\"100%\" viewBox=\"0 0 103 32\">\n    <path fill=\"var(--tile-color,#625df5)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593\"/>\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19\"/>\n</svg>\n";
function $0d35b611d3b3dcf2$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $0d35b611d3b3dcf2$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("kjgk3", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $ec923e521e4d0192$export$eeccc49dc7a12d9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::579928a7702ff0666940203a9d4c2681>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ec923e521e4d0192$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848\"/>\n</svg>\n";
function $ec923e521e4d0192$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $ec923e521e4d0192$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("eUNIY", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogoCS", function () { return $adbcdde6fb63ec8f$export$a5b9122e89b32ad3; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a5a07e9eb7981952db2c58f3810afe1d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $adbcdde6fb63ec8f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 164 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001\"/>\n</svg>\n";
function $adbcdde6fb63ec8f$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Opsgenie' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $adbcdde6fb63ec8f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bShAr", function(module, exports) {

$parcel$export(module.exports, "ProjectsIcon", function () { return $8a52613dcd997a8f$export$5ed3e1bb3b04fc02; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae4772cca6d16bf931ca75f21c37faa7>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $8a52613dcd997a8f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $8a52613dcd997a8f$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $8a52613dcd997a8f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("35rAG", function(module, exports) {

$parcel$export(module.exports, "ProjectsLogoCS", function () { return $23f73da94560bb81$export$e3d1678155aaab99; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c130a24674470d1e95cd4899b5e3ca4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $23f73da94560bb81$var$svg = "<svg height=\"100%\" viewBox=\"0 0 145 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $23f73da94560bb81$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Projects' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $23f73da94560bb81$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("1t4IN", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $111c2972e7ba9257$export$e23ae35269442b4f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::07c05c6e89f5723f7d7ed853987d71b5>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $111c2972e7ba9257$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691\"/>\n</svg>\n";
function $111c2972e7ba9257$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $111c2972e7ba9257$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("9kTpK", function(module, exports) {

$parcel$export(module.exports, "RovoLogoCS", function () { return $6cc0f773811c0d54$export$b0e15f0a1c9f4c55; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f364ea0f6c471d2cbba8f708f2339a3>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6cc0f773811c0d54$var$svg = "<svg height=\"100%\" viewBox=\"0 0 106 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26\"/>\n    <path fill=\"var(--tile-color,#1868db)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1\"/>\n</svg>\n";
function $6cc0f773811c0d54$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Rovo' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $6cc0f773811c0d54$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ipNof", function(module, exports) {

$parcel$export(module.exports, "SearchIcon", function () { return $d680df9e9151afe1$export$82eafebb825fc23f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71c7de2e30885b9e09669c8ade78e25c>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $d680df9e9151afe1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $d680df9e9151afe1$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $d680df9e9151afe1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("5Fmp3", function(module, exports) {

$parcel$export(module.exports, "SearchLogoCS", function () { return $420228e54f03af5e$export$fa08cbfe393f2a68; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::517d90ad09bfbbd541d369d01d058e01>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $420228e54f03af5e$var$svg = "<svg height=\"100%\" viewBox=\"0 0 130 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $420228e54f03af5e$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Search' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $420228e54f03af5e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("28o9P", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $18df11553ca8a37f$export$f3f5aa321d88adf9; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d9b6abfb98a7cc46c15cd5bb68394677>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $18df11553ca8a37f$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68\"/>\n</svg>\n";
function $18df11553ca8a37f$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $18df11553ca8a37f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("d0mzZ", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogoCS", function () { return $977cca3d6a7c0f73$export$2bc88a281410ffa7; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::336995adb994a3066957c7690d8c9207>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $977cca3d6a7c0f73$var$svg = "<svg height=\"100%\" viewBox=\"0 0 192 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#ffc716)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927\"/>\n</svg>\n";
function $977cca3d6a7c0f73$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Statuspage' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $977cca3d6a7c0f73$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("3LlsA", function(module, exports) {

$parcel$export(module.exports, "StudioIcon", function () { return $2bd66864e4a7ea45$export$290a0f24614cde9f; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::44318da2d694177bf3151a9c722c2f2d>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $2bd66864e4a7ea45$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.7 11.222V19h7.8v-7.778z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z\"/>\n</svg>\n";
function $2bd66864e4a7ea45$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $2bd66864e4a7ea45$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("8tIgu", function(module, exports) {

$parcel$export(module.exports, "StudioLogoCS", function () { return $62c35e43ae074895$export$273fd56580e523ae; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a3132618c94e271e59382f742ada531>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $62c35e43ae074895$var$svg = "<svg height=\"100%\" viewBox=\"0 0 124 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M14.125 14.125V24.75H24.75V14.125z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z\"/>\n</svg>\n";
function $62c35e43ae074895$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Studio' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $62c35e43ae074895$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("fWDFh", function(module, exports) {

$parcel$export(module.exports, "TalentIcon", function () { return $b9bb0a63d7763bba$export$4b05688514531169; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46e5325ca16a481422af5c181121030b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $b9bb0a63d7763bba$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" fill-rule=\"evenodd\" d=\"m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786\" clip-rule=\"evenodd\"/>\n</svg>\n";
function $b9bb0a63d7763bba$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $b9bb0a63d7763bba$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("4PqXH", function(module, exports) {

$parcel$export(module.exports, "TalentLogoCS", function () { return $3840d6e7191acb21$export$1b3979d995ebbc6e; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8453468a68143782cf5c56d6264718dc>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3840d6e7191acb21$var$svg = "<svg height=\"100%\" viewBox=\"0 0 122 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#fb9700)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714\"/>\n</svg>\n";
function $3840d6e7191acb21$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Talent' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $3840d6e7191acb21$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("ksx0g", function(module, exports) {

$parcel$export(module.exports, "TeamsIcon", function () { return $ee5005eabc0cf667$export$1bcbc9c337da86da; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46ca108d2593b6c24c5abbf971640ec4>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $ee5005eabc0cf667$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63\"/>\n</svg>\n";
function $ee5005eabc0cf667$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $ee5005eabc0cf667$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("iwtyt", function(module, exports) {

$parcel$export(module.exports, "TeamsLogoCS", function () { return $d7c22429de70497a$export$bfd8d1c4da84ce71; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a85bb219158de09803b052bf9eb845b>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $d7c22429de70497a$var$svg = "<svg height=\"100%\" viewBox=\"0 0 127 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#dddee1)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, #101214)\" d=\"M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08\"/>\n</svg>\n";
function $d7c22429de70497a$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Teams' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $d7c22429de70497a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("68M1J", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $4788be92ae5d4206$export$4384da9b8b140bf4; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::05385a6d8a6e0950a657f507588ba895>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2JOTk = parcelRequire("2JOTk");
// `height` is set to 100% to allow the SVG to scale with the parent element
var $4788be92ae5d4206$var$svg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z\"/>\n</svg>\n";
var $4788be92ae5d4206$var$customThemeSvg = "<svg height=\"100%\" viewBox=\"0 0 24 24\">\n    <path fill=\"var(--themed-icon-color, currentcolor)\" d=\"M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z\"/>\n</svg>\n";
function $4788be92ae5d4206$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2JOTk.IconWrapper), {
        svg: $4788be92ae5d4206$var$svg,
        customThemeSvg: $4788be92ae5d4206$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("httlh", function(module, exports) {

$parcel$export(module.exports, "TrelloLogoCS", function () { return $0348733944ed04e1$export$1b13139dfc0336af; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e1b148b0e17835d1d6cc0b45cfa57fe0>>
 * @codegenCommand yarn workspace @atlaskit/temp-nav-app-icons build-temp-logos
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eY6vy = parcelRequire("eY6vy");
// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0348733944ed04e1$var$svg = "<svg height=\"100%\" viewBox=\"0 0 113 32\">\n    <path fill=\"var(--text-color, #1e1f21)\" d=\"M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z\"/>\n    <path fill=\"var(--tile-color,#1558bc)\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"/>\n    <path fill=\"var(--icon-color, white)\" d=\"M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z\"/>\n</svg>\n";
function $0348733944ed04e1$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'brand' : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Trello' : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eY6vy.LogoWrapper), {
        svg: $0348733944ed04e1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

});

parcelRegister("bPFG7", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminIcon", function () { return $89d4c9955c313535$export$84109e099492cb5f; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $89d4c9955c313535$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $89d4c9955c313535$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        svg: $89d4c9955c313535$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jPufg", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdminLogo", function () { return $e6fa3dcc44a4eb28$export$f845d9b9254f0541; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $e6fa3dcc44a4eb28$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 295 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $e6fa3dcc44a4eb28$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Admin' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $e6fa3dcc44a4eb28$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9eGYF", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationIcon", function () { return $6b96c24c234d0836$export$74517ed253186308; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $6b96c24c234d0836$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $6b96c24c234d0836$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        svg: $6b96c24c234d0836$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kBV2S", function(module, exports) {

$parcel$export(module.exports, "AtlassianAdministrationLogo", function () { return $f013835ab212b1a2$export$833abe6c2ce5ebfd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $f013835ab212b1a2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 404 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369\"\n        fill=\"".concat(colors.textColor, "\"\n      />\n      <path\n        d=\"M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z\"\n        fill=\"").concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $f013835ab212b1a2$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Administration' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f013835ab212b1a2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("jnM1h", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsIcon", function () { return $e1c569fd4ae686b4$export$c42ad8a0b925c762; });

var $8ZuGG = parcelRequire("8ZuGG");

var $iNlvH = parcelRequire("iNlvH");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $e1c569fd4ae686b4$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "<svg height=\"32\" viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"12.595\" x2=\"12.595\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient id=\"").concat(id, "-b\" x1=\"28.595\" x2=\"28.595\" y1=\"40\" y2=\"27\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-c\" x1=\"20.595\" x2=\"20.595\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-b\" id=\"").concat(id, "-d\" x1=\"36.595\" x2=\"36.595\" y2=\"20\"/>\n  </defs>\n  <path d=\"M10.595 30h4v10h-4z\" fill=\"url(#").concat(id, "-a)\"/>\n  <path d=\"M26.595 27h4v13h-4z\" fill=\"url(#").concat(id, "-b)\"/>\n  <path d=\"M18.595 22h4v18h-4z\" fill=\"url(#").concat(id, "-c)\"/>\n  <path d=\"M34.595 20h4v20h-4z\" fill=\"url(#").concat(id, "-d)\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\" />\n</svg>");
};
var $e1c569fd4ae686b4$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $iNlvH.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $e1c569fd4ae686b4$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

});

parcelRegister("e98Of", function(module, exports) {

$parcel$export(module.exports, "AtlassianAnalyticsLogo", function () { return $a4c8bd516ea4f09d$export$e6470bfc39010cc4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $iNlvH = parcelRequire("iNlvH");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $a4c8bd516ea4f09d$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return "\n  <svg height=\"32\" viewBox=\"0 0 477 48\" xmlns=\"http://www.w3.org/2000/svg\">\n  <defs>\n    <linearGradient id=\"".concat(id, "-a\" x1=\"447.285\" x2=\"447.285\" y1=\"40\" y2=\"30\" gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0\" stop-color=\"").concat(colors.iconGradientStart, "\"/>\n      <stop offset=\"1\" stop-color=\"").concat(colors.iconGradientStop, "\"/>\n    </linearGradient>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-b\" x1=\"463.285\" x2=\"463.285\" y2=\"27\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-c\" x1=\"455.285\" x2=\"455.285\" y2=\"22\"/>\n    <linearGradient xlink:href=\"#").concat(id, "-a\" id=\"").concat(id, "-d\" x1=\"471.285\" x2=\"471.285\" y2=\"20\"/>\n  </defs>\n  <g fill=\"").concat(colors.atlassianLogoTextColor, "\">\n    <path d=\"M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z\"/>\n  </g>\n  <g fill=\"").concat(colors.textColor, "\">\n    <path d=\"m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z\"/>\n  </g>\n  <path fill=\"url(#").concat(id, "-a)\" d=\"M445.285 30h4v10h-4z\"/>\n  <path fill=\"url(#").concat(id, "-b)\" d=\"M461.285 27h4v13h-4z\"/>\n  <path fill=\"url(#").concat(id, "-c)\" d=\"M453.285 22h4v18h-4z\"/>\n  <path fill=\"url(#").concat(id, "-d)\" d=\"M469.285 20h4v20h-4z\"/>\n  <path fill=\"").concat(colors.iconColor, "\" d=\"m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z\"/>\n</svg>");
};
var $a4c8bd516ea4f09d$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian Analytics' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $iNlvH.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $a4c8bd516ea4f09d$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9veJa", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", function () { return $6eb26ee16c9c6519$export$5fc1066e677788d4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $6eb26ee16c9c6519$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95\"/>\n    </svg>");
};
var $6eb26ee16c9c6519$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $6eb26ee16c9c6519$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bm32A", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $84441ba19256df36$export$bd40525f5333524b; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $84441ba19256df36$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 158 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path fill=".concat(colors.iconColor, " d=\"m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95\"/>\n        <path fill=").concat(colors.textColor, " d=\"M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z\"/>\n      </svg>");
};
var $84441ba19256df36$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Bitbucket' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $84441ba19256df36$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("ijdoi", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", function () { return $d5446383492f962b$export$f7857fe64d7161d9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $d5446383492f962b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z\"/>\n      </svg>\n    ");
};
var $d5446383492f962b$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $d5446383492f962b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2PkYH", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $20f09dfaffcaf00e$export$eb7d748e4f9c9676; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $20f09dfaffcaf00e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 155 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path fill=".concat(colors.iconColor, " d=\"M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z\"/>\n    <path fill=\"").concat(colors.textColor, "\" d=\"M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n  </svg>");
};
var $20f09dfaffcaf00e$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Compass' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $20f09dfaffcaf00e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("hO5zU", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", function () { return $cf6b6edfa594357c$export$68f3db7f6af48bcb; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $cf6b6edfa594357c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098\"/>\n    </svg>");
};
var $cf6b6edfa594357c$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $cf6b6edfa594357c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4XgN9", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", function () { return $39b9b298b7439902$export$1b2e4fe6ef471556; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $39b9b298b7439902$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 180 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227\"/>\n    </svg>\n    ");
};
var $39b9b298b7439902$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Confluence' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $39b9b298b7439902$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4HCDk", function(module, exports) {

$parcel$export(module.exports, "FocusIcon", function () { return $36c9255eab34355c$export$1e02e7298035a77c; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $36c9255eab34355c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 48 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z\"/>\n\t\t</svg>\n\t\t");
};
var $36c9255eab34355c$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $36c9255eab34355c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4r6TV", function(module, exports) {

$parcel$export(module.exports, "FocusLogo", function () { return $33af096b410f28a8$export$33908560ea1b226d; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $33af096b410f28a8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 168 48\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t<path fill=\"".concat(colors.iconColor, "\" d=\"M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z\"/>\n\t\t<path fill=\"").concat(colors.textColor, "\" d=\"M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z\"/>\n\t\t</svg>\n\t\t");
};
var $33af096b410f28a8$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Focus' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $33af096b410f28a8$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("4rAbO", function(module, exports) {

$parcel$export(module.exports, "GuardIcon", function () { return $33c5c1890b611488$export$3f95fcfdc25a741d; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $33c5c1890b611488$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n    </svg>");
};
var $33c5c1890b611488$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        svg: $33c5c1890b611488$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("kN3d4", function(module, exports) {

$parcel$export(module.exports, "GuardLogo", function () { return $f22adfacb466b44f$export$a4a891d202775deb; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $f22adfacb466b44f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 114 32\" focusable=\"false\" aria-hidden=\"true\">\n      <path\n        d=\"M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $f22adfacb466b44f$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Guard' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f22adfacb466b44f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("h1quS", function(module, exports) {

$parcel$export(module.exports, "JiraIcon", function () { return $c647156aae819f58$export$c4b5b1f965d8b3eb; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $c647156aae819f58$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n    </svg>");
};
var $c647156aae819f58$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $c647156aae819f58$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iHTRV", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", function () { return $d9e79488058f3957$export$17d3acb0b4379d02; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $d9e79488058f3957$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 77 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404\"/>\n    </svg>");
};
var $d9e79488058f3957$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $d9e79488058f3957$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6zLvw", function(module, exports) {

$parcel$export(module.exports, "JiraAlignIcon", function () { return $4c9adcf5837caefb$export$407687b2dd89cc68; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $4c9adcf5837caefb$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n      fill=\"".concat(colors.iconColor, "\"\n      d=\"M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\"\n    />\n  </svg>");
};
var $4c9adcf5837caefb$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $4c9adcf5837caefb$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8BZ2B", function(module, exports) {

$parcel$export(module.exports, "JiraAlignLogo", function () { return $645120e564e3bf44$export$ee11e928d3d045fd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $645120e564e3bf44$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg viewBox=\"0 0 146 32\" focusable=\"false\" aria-hidden=\"true\" height=\"32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z\" fill=\"".concat(colors.iconColor, "\"/>\n      <path d=\"M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" fill=\"").concat(colors.textColor, "\"/>\n    </svg>\n  ");
};
var $645120e564e3bf44$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Align' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $645120e564e3bf44$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6wGRj", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryIcon", function () { return $4c06fa2393c64d1e$export$21bfbeb62fdcce8d; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $4c06fa2393c64d1e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z\"/>\n    </svg>");
};
var $4c06fa2393c64d1e$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $4c06fa2393c64d1e$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5JSZh", function(module, exports) {

$parcel$export(module.exports, "JiraProductDiscoveryLogo", function () { return $42dbcf0e3e49d663$export$c49a2b642fe9eef4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $42dbcf0e3e49d663$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 318 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $42dbcf0e3e49d663$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Product Discovery' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $42dbcf0e3e49d663$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9xRvp", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementIcon", function () { return $6f30b33554814bfd$export$3c6158790f5e01c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $6f30b33554814bfd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z\"/>\n    </svg>");
};
var $6f30b33554814bfd$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $6f30b33554814bfd$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("llqgg", function(module, exports) {

$parcel$export(module.exports, "JiraServiceManagementLogo", function () { return $f89fee13169eec9e$export$dabef2be6cd28c20; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $f89fee13169eec9e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 362 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " d=\"M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z\" />\n      <path fill=").concat(colors.textColor, " d=\"M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404\" />\n    </svg>");
};
var $f89fee13169eec9e$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Jira Service Management' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f89fee13169eec9e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("9TWYe", function(module, exports) {

$parcel$export(module.exports, "LoomIcon", function () { return $7356fe67abb63d75$export$8d789f76fde3e05; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $7356fe67abb63d75$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n    fill=\"none\"\n    height=\"32\"\n    viewBox=\"0 0 32 32\"\n    xmlns=\"http://www.w3.org/2000/svg\"\n    focusable=\"false\"\n    aria-hidden=\"true\"\n  >\n    <path\n      d=\"M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884\"\n      fill=\"".concat(colors.iconColor, "\"\n    />\n  </svg>");
};
var $7356fe67abb63d75$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $7356fe67abb63d75$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("DaC3M", function(module, exports) {

$parcel$export(module.exports, "LoomLogo", function () { return $075be020d7ac6c26$export$94e206806e36c2ec; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $075be020d7ac6c26$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n      fill=\"none\"\n      height=\"32\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      viewBox=\"0 0 98 32\"\n      focusable=\"false\"\n      aria-hidden=\"true\"\n    >\n      <path\n        d=\"M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006\"\n        fill=\"".concat(colors.iconColor, "\"\n      />\n      <path\n        d=\"M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $075be020d7ac6c26$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $075be020d7ac6c26$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5fnJd", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionIcon", function () { return $3d20c264da97dff3$export$1bf47cdade1a9fcb; });

var $8ZuGG = parcelRequire("8ZuGG");

var $azw9d = parcelRequire("azw9d");

var $9TWYe = parcelRequire("9TWYe");
var $3d20c264da97dff3$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9TWYe.LoomIcon), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};

});

parcelRegister("33EnL", function(module, exports) {

$parcel$export(module.exports, "LoomAttributionLogo", function () { return $23a0f9ff7882b4e3$export$6e87ce8d41eda665; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $23a0f9ff7882b4e3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsForLoom)(appearance, colorMode);
    return "<svg\n\t\tfill=\"none\"\n\t\theight=\"32\"\n\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\tfocusable=\"false\"\n\t\taria-hidden=\"true\"\n\t\tviewBox=\"0 0 88 32\"\n\t>\n\t\t<path\n\t\t\td=\"M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058\"\n\t\t\tfill=\"".concat(colors.iconColor, "\"\n\t\t/>\n\t\t<path\n\t\t\td=\"M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z\"\n\t\t\tfill=\"").concat(colors.textColor, "\"\n\t\t/>\n\t</svg>");
};
var $23a0f9ff7882b4e3$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Loom Attribution' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $23a0f9ff7882b4e3$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("7sXPa", function(module, exports) {

$parcel$export(module.exports, "OpsgenieIcon", function () { return $56f98dcd507738f9$export$eeccc49dc7a12d9f; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $56f98dcd507738f9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n    </svg>");
};
var $56f98dcd507738f9$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        svg: $56f98dcd507738f9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("lms1E", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogo", function () { return $f8d1645733cb4e4c$export$a1c6484cdecc2c4b; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $f8d1645733cb4e4c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 154 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697\" />\n    </svg>");
};
var $f8d1645733cb4e4c$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Opsgenie' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $f8d1645733cb4e4c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("cMF7I", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $94e9ddf9ff780995$export$e23ae35269442b4f; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $94e9ddf9ff780995$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\">\n    <g fill=\"".concat(colors.iconColor, "\" fill-rule=\"evenodd\">\n      <path d=\"M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z\"/>\n      <path d=\"m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z\"/>\n    </g>\n  </svg>");
};
var $94e9ddf9ff780995$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        svg: $94e9ddf9ff780995$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6r8l9", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", function () { return $4afbbbdbfcc285f1$export$a0f6cb8061290bbb; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $4afbbbdbfcc285f1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 100 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path\n        d=\"M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z\"\n        fill=\"".concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z\"\n        fill=\"").concat(colors.iconColor, "\"\n        fillRule=\"evenodd\"\n      />\n      <path\n        d=\"M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z\"\n        fill=\"").concat(colors.textColor, "\"\n      />\n    </svg>");
};
var $4afbbbdbfcc285f1$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Rovo' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $4afbbbdbfcc285f1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("2DG6T", function(module, exports) {

$parcel$export(module.exports, "StatuspageIcon", function () { return $1ebfe37ec5a9e78b$export$f3f5aa321d88adf9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $1ebfe37ec5a9e78b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063\"/>\n    </svg>");
};
var $1ebfe37ec5a9e78b$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $1ebfe37ec5a9e78b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bzKCl", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogo", function () { return $86d71fdf3d6aee51$export$bb4ae5b41b43be04; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $86d71fdf3d6aee51$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 188 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" d=\"M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063\" />\n      <path fill=\"").concat(colors.textColor, "\" d=\"M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072\" />\n    </svg>");
};
var $86d71fdf3d6aee51$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Statuspage' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $86d71fdf3d6aee51$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("84G8H", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", function () { return $0184608e485c6694$export$4384da9b8b140bf4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $0184608e485c6694$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 32 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=".concat(colors.iconColor, " clip-rule=\"evenodd\" d=\"M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z\" fill-rule=\"evenodd\"/>\n    </svg>");
};
var $0184608e485c6694$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $0184608e485c6694$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("5G51F", function(module, exports) {

$parcel$export(module.exports, "TrelloLogo", function () { return $4224c60bc8ef6b3e$export$60e26212f3b61a28; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $gm61b = parcelRequire("gm61b");

var $iXqJJ = parcelRequire("iXqJJ");
var $4224c60bc8ef6b3e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $iXqJJ.getColorsFromAppearance)(appearance, colorMode);
    return "<svg fill=\"none\" height=\"32\" viewBox=\"0 0 106 32\" focusable=\"false\" aria-hidden=\"true\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path fill=\"".concat(colors.iconColor, "\" clip-rule=\"evenodd\" d=\"M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z\" fill-rule=\"evenodd\"/>\n      <path fill=\"").concat(colors.textColor, "\" d=\"M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z\"/>\n    </svg>");
};
var $4224c60bc8ef6b3e$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Trello' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $4224c60bc8ef6b3e$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("8CqxZ", function(module, exports) {

$parcel$export(module.exports, "createFeatureFlaggedComponent", function () { return $6466770ac55f8d29$export$e30d2ddc605f6bb; });
$parcel$export(module.exports, "createFeatureFlaggedServiceCollectionComponent", function () { return $6466770ac55f8d29$export$436fcf6e31fbacea; });
$parcel$export(module.exports, "tempSizeWrapper", function () { return $6466770ac55f8d29$export$667425256e2e7296; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");
var $6466770ac55f8d29$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $6466770ac55f8d29$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $6466770ac55f8d29$var$_excluded3 = [
    "size"
];
var $6466770ac55f8d29$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $6466770ac55f8d29$var$_excluded);
        if ((0, $i2LcI.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            size: size
        }, props));
    };
};
var $6466770ac55f8d29$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $6466770ac55f8d29$var$_excluded2);
        if ((0, $i2LcI.fg)('platform-logo-rebrand-servco') || (0, $i2LcI.fg)('platform-logo-rebrand') || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            size: size || 'medium'
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(LegacyComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            size: size
        }, props));
    };
};
var $6466770ac55f8d29$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref3) {
        var size = _ref3.size, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref3, $6466770ac55f8d29$var$_excluded3);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(NewComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            size: size || 'medium'
        }, props));
    };
};
var $6466770ac55f8d29$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: 'atlassian',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-access',
        type: 'legacy',
        category: 'program'
    },
    {
        name: 'atlassian-marketplace',
        type: 'legacy',
        category: 'program'
    },
    // Home collection
    {
        name: 'home',
        type: 'new',
        category: 'app'
    },
    {
        name: 'hub',
        type: 'new',
        category: 'app'
    },
    // Teamwork collection
    {
        name: 'confluence',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'jira',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'loom-blurple',
        type: 'new',
        category: 'app',
        skipExample: true
    },
    {
        name: 'loom-attribution',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'rovo',
        type: 'migration',
        category: 'app'
    },
    // Strategy collection
    {
        name: 'align',
        type: 'new',
        category: 'app'
    },
    {
        name: 'focus',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'talent',
        type: 'new',
        category: 'app'
    },
    // App collection
    {
        name: 'jira-product-discovery',
        type: 'migration',
        category: 'app'
    },
    // Dev collection
    {
        name: 'bitbucket',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'compass',
        type: 'migration',
        category: 'app'
    },
    // Customer collection
    {
        name: 'jira-service-management',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'assets',
        type: 'new',
        category: 'app'
    },
    {
        name: 'customer-service-management',
        type: 'new',
        category: 'app'
    },
    {
        name: 'opsgenie',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'statuspage',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'trello',
        type: 'migration',
        category: 'app'
    },
    // Platform Collection
    {
        name: 'admin',
        type: 'new',
        category: 'app'
    },
    {
        name: 'analytics',
        type: 'new',
        category: 'app'
    },
    {
        name: 'chat',
        type: 'new',
        category: 'app'
    },
    {
        name: 'goals',
        type: 'new',
        category: 'app'
    },
    {
        name: 'guard',
        type: 'migration',
        category: 'app'
    },
    {
        name: 'projects',
        type: 'new',
        category: 'app'
    },
    {
        name: 'search',
        type: 'new',
        category: 'app'
    },
    {
        name: 'studio',
        type: 'new',
        category: 'app'
    },
    {
        name: 'teams',
        type: 'new',
        category: 'app'
    },
    // Data Center
    {
        name: 'jira-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'jira-service-management-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'confluence-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bitbucket-data-center',
        type: 'new',
        category: 'app'
    },
    {
        name: 'bamboo',
        type: 'new',
        category: 'app'
    },
    {
        name: 'crowd',
        type: 'new',
        category: 'app'
    },
    // Deprecated
    {
        name: 'atlassian-administration',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-admin',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlassian-analytics',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'atlas',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-align',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-software',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    },
    {
        name: 'jira-work-management',
        type: 'legacy',
        category: 'app',
        skipExample: true,
        deprecated: true
    }
];
var $6466770ac55f8d29$export$62e1212796a86b1b = $6466770ac55f8d29$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'program' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $6466770ac55f8d29$export$e0dee4a765830f4d = $6466770ac55f8d29$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === 'app' && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $6466770ac55f8d29$export$516fce44c502c1d3 = $6466770ac55f8d29$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'legacy';
});
var $6466770ac55f8d29$export$b805fae8e798ed39 = $6466770ac55f8d29$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'migration';
});
var $6466770ac55f8d29$export$3f9abd26214cd85f = $6466770ac55f8d29$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === 'new';
});

});


parcelRegister("iOGBn", function(module, exports) {

$parcel$export(module.exports, "BitbucketBackground", function () { return $db2df15c0f2661e8$export$7a8deb158bc23a3c; });

var $8ZuGG = parcelRequire("8ZuGG");

var $hkiBI = parcelRequire("hkiBI");

var $5GyOg = parcelRequire("5GyOg");
var $db2df15c0f2661e8$export$7a8deb158bc23a3c = function BitbucketBackground(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: (0, $hkiBI.BitbucketLightTheme)
    }, children);
};

});
parcelRegister("hkiBI", function(module, exports) {

$parcel$export(module.exports, "BitbucketLightTheme", function () { return $c9d2bcf6106a5376$export$880f50d5c5924242; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $8eNaA = parcelRequire("8eNaA");

var $4tjeQ = parcelRequire("4tjeQ");

var $c0yO5 = parcelRequire("c0yO5");

var $g800D = parcelRequire("g800D");

var $lWA6j = parcelRequire("lWA6j");

var $6AYcA = parcelRequire("6AYcA");

var $bMmao = parcelRequire("bMmao");

var $epoDP = parcelRequire("epoDP");
var $c9d2bcf6106a5376$export$880f50d5c5924242 = function BitbucketLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": "testId-bitbucket-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8eNaA.Background), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4tjeQ.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $6AYcA.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bMmao.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lWA6j.PageHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $c0yO5.PageActions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $g800D.PageContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $epoDP.Sidebar), null));
};

});
parcelRegister("8eNaA", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $5ff5c5a666b5858d$export$668799e4797757a8; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9Vz68 = parcelRequire("9Vz68");
var $5ff5c5a666b5858d$export$668799e4797757a8 = (0, $9Vz68.default).div({
    position: 'fixed',
    background: '#fff',
    height: '100%',
    width: '100%'
});
var $5ff5c5a666b5858d$export$ede4ebd46660008d = (0, $9Vz68.default).div({
    position: 'fixed',
    background: '#2c333a',
    width: '100%',
    height: '100%'
});

});

parcelRegister("4tjeQ", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $3418cb3531fc71cb$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $4FJSc = parcelRequire("4FJSc");
var $3418cb3531fc71cb$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4FJSc.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($3418cb3531fc71cb$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4FJSc.Line), null));
};
var $3418cb3531fc71cb$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1440,
        height: 56,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M52 16h120v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#253858",
        d: "M77.445 20.2h6.523c3.18 0 4.717 1.51 4.717 3.935 0 1.825-.863 2.946-2.615 3.337 2.291.364 3.45 1.59 3.45 3.727 0 2.398-1.67 4.066-5.175 4.066h-6.9V20.2Zm2.156 6.437h4.097c2.022 0 2.857-.886 2.857-2.346s-.89-2.163-2.857-2.163h-4.097v4.51Zm0 1.851v4.692h4.852c2.048 0 2.965-.704 2.965-2.215 0-1.617-.89-2.477-3.019-2.477h-4.798Zm13.423-9.097c.836 0 1.429.495 1.429 1.382 0 .86-.593 1.381-1.429 1.381-.835 0-1.428-.495-1.428-1.381 0-.887.593-1.382 1.428-1.382Zm-1.05 4.405h2.048v11.47h-2.049v-11.47Zm9.81 9.619c.486 0 .917-.105 1.294-.157v1.903c-.35.104-.754.183-1.374.183-2.534 0-3.774-1.434-3.774-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.995v2.424h3.153v1.825h-3.153v6.073c0 1.017.62 1.72 1.859 1.72Zm5.93-.183v2.007h-2.048V19h2.048v6.855c.755-1.511 2.184-2.293 4.016-2.293 3.154 0 4.744 2.58 4.744 5.969 0 3.232-1.671 5.969-4.986 5.969-1.725 0-3.046-.756-3.774-2.268Zm3.477-7.82c-1.833 0-3.45 1.121-3.45 3.676V30c0 2.554 1.483 3.675 3.235 3.675 2.291 0 3.477-1.46 3.477-4.118-.027-2.79-1.159-4.145-3.262-4.145Zm7.413-1.616h2.048v6.934c0 2.06.863 2.971 2.804 2.971 1.886 0 3.207-1.225 3.207-3.545v-6.36h2.049v11.47h-2.049v-1.877c-.755 1.355-2.156 2.111-3.747 2.111-2.722 0-4.285-1.825-4.285-4.979v-6.725h-.027Zm21.536 11.157c-.701.364-1.806.52-2.884.52-4.232 0-6.199-2.475-6.199-5.994 0-3.467 1.967-5.944 6.199-5.944 1.078 0 1.887.13 2.83.548v1.825c-.754-.34-1.563-.548-2.668-.548-3.073 0-4.34 1.877-4.34 4.119 0 2.241 1.294 4.118 4.394 4.118 1.213 0 1.967-.156 2.695-.417v1.773h-.027Zm2.318.312V19h2.049v10.166l5.094-5.37h2.669l-5.58 5.63 5.822 5.84h-2.776l-5.229-5.37v5.37h-2.049Zm16.793.235c-4.448 0-6.388-2.476-6.388-5.995 0-3.467 1.994-5.943 5.606-5.943 3.666 0 5.121 2.45 5.121 5.943v.886h-8.652c.297 1.955 1.59 3.206 4.394 3.206 1.374 0 2.533-.26 3.612-.625v1.824c-.971.522-2.48.704-3.693.704Zm-4.34-6.803h6.631c-.108-2.138-1.105-3.337-3.154-3.337-2.156 0-3.261 1.356-3.477 3.337Zm15.795 4.718c.485 0 .917-.105 1.294-.157v1.903c-.35.104-.755.183-1.375.183-2.533 0-3.773-1.434-3.773-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.994v2.424H172v1.825h-3.154v6.073c0 1.017.62 1.72 1.86 1.72Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M52.54 20.642c-.324 0-.594.287-.54.6l2.291 13.424c.054.339.35.6.728.6h10.97c.27 0 .486-.183.54-.444l2.29-13.58c.054-.313-.188-.6-.539-.6H52.54Zm9.649 9.697h-3.504l-.944-4.796h5.31l-.862 4.796Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#c)",
        d: "M68.092 25.543h-5.068l-.835 4.796h-3.504l-4.151 4.744s.188.182.485.182h10.97c.27 0 .485-.182.54-.443l1.563-9.28Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M196 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 203.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M290 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        width: 71,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M384 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 71,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M478 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 56,
        height: 6,
        x: 486,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#e)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M548 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#344563",
        fillRule: "evenodd",
        d: "M548.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#0052CC",
        d: "M482 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 61,
        height: 32,
        x: 289.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 44,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 61,
        height: 32,
        x: 383.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 44,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 61,
        height: 32,
        x: 580,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 44,
        height: 6,
        x: 588,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#A5ADBA",
        fillRule: "evenodd",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M52 0h589v56H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M52 16h120v24H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M192 0h449v56H192z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M548 18h8v20h-8z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "c",
        x1: 69.254,
        x2: 61.106,
        y1: 26.89,
        y2: 33.467,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.176,
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    }))));
};

});
parcelRegister("4FJSc", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $366e9338509df292$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "Line", function () { return $366e9338509df292$export$17d680238e50603e; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $366e9338509df292$export$e6dfd72ab29f8598 = (0, $9Vz68.default).div({
    position: 'fixed',
    top: 0,
    left: 0,
    '@media (min-width: 1200px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'visible'
        }
    },
    '@media (min-width: 1000px) and (max-width: 1200px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'visible'
        }
    },
    '@media (max-width: 1000px)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.medium, path.medium': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.large, path.large': {
            visibility: 'hidden'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'rect.small, path.small': {
            visibility: 'visible'
        }
    }
});
var $366e9338509df292$export$17d680238e50603e = (0, $9Vz68.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    left: 0,
    height: '2px',
    width: '100%',
    background: '#dfe1e6',
    zIndex: 1
});
var $366e9338509df292$export$e7439992f3f52d0 = (0, $9Vz68.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    left: 0,
    height: '2px',
    width: '100%',
    background: '#454f59',
    zIndex: 1
});

});
parcelRegister("145Wl", function(module, exports) {

$parcel$export(module.exports, "HEADER_HEIGHT", function () { return $0c6ac5c2229cbe36$export$cdb7fd9d999c7168; });
$parcel$export(module.exports, "SECONDARY_NAV_WIDTH", function () { return $0c6ac5c2229cbe36$export$6cfc56c8a5804224; });
$parcel$export(module.exports, "SIDEBAR_WIDTH", function () { return $0c6ac5c2229cbe36$export$780035d9fe48eb32; });
var $0c6ac5c2229cbe36$export$cdb7fd9d999c7168 = 56;
var $0c6ac5c2229cbe36$export$6cfc56c8a5804224 = 240;
var $0c6ac5c2229cbe36$export$780035d9fe48eb32 = 333;

});



parcelRegister("c0yO5", function(module, exports) {

$parcel$export(module.exports, "PageActions", function () { return $8be07c092066b364$export$a9e583a1195b23df; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $8be07c092066b364$export$a9e583a1195b23df = function PageActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($8be07c092066b364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($8be07c092066b364$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $8be07c092066b364$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $145Wl.SIDEBAR_WIDTH), "px"),
    background: '#fff'
});
var $8be07c092066b364$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "292",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageActionsA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "32",
        x: "24",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "104",
        height: "6",
        x: "32",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "80",
        height: "32",
        x: "150",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "64",
        height: "6",
        x: "158",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "236",
        y: "56",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M240 60h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        d: "M245 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM252 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM259 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageActionsA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M24 56h244v32H24z"
    }))));
};

});

parcelRegister("g800D", function(module, exports) {

$parcel$export(module.exports, "PageContent", function () { return $bbdd668c1d8b71af$export$16800ac069904dff; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $bbdd668c1d8b71af$export$16800ac069904dff = function PageContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $bbdd668c1d8b71af$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT) + 150, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $145Wl.SECONDARY_NAV_WIDTH) + 24, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $145Wl.SIDEBAR_WIDTH) + 24, "px"),
    minHeight: '661px'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $bbdd668c1d8b71af$var$ImageWrapper = (0, $9Vz68.default).div({
    display: 'flex',
    justifyContent: 'center'
});
var $bbdd668c1d8b71af$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "820",
        height: "619",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "M24.466 25.316ZM17.472 30.51l.026-.105.023-.095-1.26.653 1.308-.87c.018-.098.029-.195.026-.29a.653.653 0 0 0-.059-.256c-.115-.038-.202-.168-.205-.33-.002-.197.118-.358.267-.363.084 0 .156.046.207.123.223.148.343.435.374.711l3.67-2.442c1.862-.822 2.445-1.505 2.607-1.935h.005-.005c.117-.31.018-.487.018-.487-.136-1.2-.799-1.85-1.587-2.191-1.01.602-2.494 1.093-3.07.632l.036.497c.015.023.054.066.105.12l.025.028c.07.075.151.167.22.251.09.113.152.215.113.256-.171.085-.343.18-.512.287-1.664 1.03-3.228 2.908-3.725 3.558-.028-.02-.069-.053-.12-.094-.576-.74-2.13-2.563-3.76-3.53a5.293 5.293 0 0 0-.62-.32c-.008-.013-.013-.026-.02-.039a.234.234 0 0 1 .074-.077c.002 0 .005-.005.01-.007l.059-.039c.15-.084.358-.15.407-.228l.118-1.54s-.008 0-.02-.006c-.006.264-.024.556-.057.873-.566.476-2.056-.015-3.072-.617-.78.343-1.439.988-1.572 2.184 0 0-.102.179.02.491-1.251.4-2.521.873-3.417 1.38a15.954 15.954 0 0 0 10.056 5.192c-.029-.482-.093-.906-.203-1.226l-.035-.1c-.085-.236-.18-.502-.17-.791 0-.029.006-.057.01-.085L6.355 25.87c.397-.151.812-.295 1.229-.433.228.43.865 1.063 2.547 1.805l3.679 2.253c.056-.17.156-.328.297-.448a.387.387 0 0 1 .358-.213c.213.005.379.167.374.364-.005.197-.18.353-.392.348h-.008a.426.426 0 0 0-.092.243v.036l1.452.888s.005.013.01.02l-1.441-.739c.025.118.066.238.112.366l.039.105c.138.4.215.911.24 1.475.41.03.825.053 1.245.053.468 0 .931-.025 1.39-.064-.031-.555-.01-1.052.082-1.426l-.003.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "M18.181 29.97c-.015.205-.064.397-.11.581l-.026.102c-.076.313-.094.738-.069 1.222a15.969 15.969 0 0 0 9.92-5.177 13.857 13.857 0 0 0-1.815-.822l-7.897 4.094h-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#PageContentB)",
        d: "M20.2 24.164c-.068-.085-.15-.174-.22-.251a.155.155 0 0 1-.015-.013c-.002 0-.007-.01-.01-.013a1.6 1.6 0 0 1-.105-.12l-.036-.497-.012-.007a12.55 12.55 0 0 1-.057-.817c-.005-.033-.005-.064-.008-.092-.04-.522-.076-1.1-.104-1.626-.59.569-1.411 1.13-2.57 1.582a2.062 2.062 0 0 1-.748.154h-1.08c-.262 0-.512-.061-.748-.154-.952-.37-1.677-.816-2.232-1.28-.013.382-.031.781-.052 1.16V22.39c.013 0-.094 1.543-.094 1.543-.049.077-.256.144-.407.228l-.06.039c-.002 0-.004.005-.01.007a.263.263 0 0 0-.074.077c.008.013.013.026.02.039.208.092.413.2.62.32 1.631.967 3.185 2.787 3.761 3.53l.12.095c.497-.653 2.061-2.53 3.725-3.559.17-.105.34-.2.512-.287.039-.04-.023-.14-.113-.256l-.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0747A6",
        d: "M14.48 30.367a2.964 2.964 0 0 1-.113-.366l1.441.74-.01-.021-1.452-.888v-.036a.42.42 0 0 1 .092-.243h.008c.213.005.387-.151.392-.349.005-.197-.164-.358-.374-.363a.387.387 0 0 0-.358.212.962.962 0 0 0-.297.448L10.13 27.25c-1.682-.743-2.32-1.372-2.547-1.805-.417.138-.832.281-1.229.433l7.414 3.814c-.003.028-.008.056-.01.084-.01.29.084.556.169.791l.035.1c.11.318.177.745.203 1.226.197.024.396.041.596.057-.026-.566-.102-1.075-.24-1.475l-.039-.105-.003-.002ZM18.045 30.653l.026-.102c.049-.187.095-.379.11-.581l7.898-4.093c-.52-.2-1.068-.387-1.61-.561h-.011c-.164.43-.745 1.113-2.606 1.935l-3.67 2.442c-.029-.279-.152-.563-.375-.711-.05-.075-.125-.126-.207-.123-.151.005-.271.166-.266.363.002.164.09.292.205.33.03.062.056.15.058.257 0 .094-.007.19-.025.289l-1.308.87 1.26-.652c-.009.03-.016.06-.024.094l-.025.105c-.093.374-.113.868-.082 1.426.197-.018.391-.038.586-.061-.023-.482-.008-.91.069-1.221l-.003-.006Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#172B4D",
        d: "M12.145 23.26c.036-.317.05-.61.056-.873V22.188c.02-.38.038-.779.051-1.16-1.779-1.485-1.797-3.149-1.797-3.149-.008-.08-.015-.154-.02-.23h-.082c-.5-2.128-.855-3.91-.031-3.828a.81.81 0 0 1 .24.062c.034-.036.267-.512.423-.812a.684.684 0 0 1 .39-.338c.836-.286 1.453-.15 1.453-.15.044-.2.103-.387.172-.564.156-.32.396-.763.722-1.18a4.685 4.685 0 0 1 1.51-1.131c.077-.021.156-.036.236-.047 1.812.067 4.669 2.517 5.273 4.053.123.31.305.261.484.125.171-.13.335-.343.433-.391.035.023.074.046.105.074.34.673.291 1.564.048 2.57-.051.18-.1.34-.146.474-.21.601-.302.937-.55 1.042a9.71 9.71 0 0 1-.026.274s-.015 1.449-1.459 2.849a69.25 69.25 0 0 0 .113 1.718 12.744 12.744 0 0 0 .056.817l.013.007c.576.463 2.06-.03 3.07-.632.647-.387 1.1-.814.987-1.065a2.796 2.796 0 0 1-.166-.52c-.03-.535-.064-1.093-.102-1.664.025-1.556.156-3.63-.745-6.438-.057-.295-.113-.592-.177-.884-.274-1.236-.793-2.516-1.602-3.591a6.662 6.662 0 0 0-5.464-2.852c-2.82 0-5.232 1.759-6.215 4.247a9.924 9.924 0 0 0-.755 2.196c-.228 1.027-.3 2.084-.308 3.141-.53 3.037.32 5.051-.268 6.367-.113.251.345.684 1 1.07 1.017.602 2.504 1.093 3.073.617l.005-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#A96935",
        d: "M21.12 17.603c.248-.108.34-.443.55-1.042.047-.13.098-.295.146-.474.244-1.006.292-1.897-.048-2.57a.512.512 0 0 0-.105-.074c-.097.048-.261.26-.433.391.023.305.036.615.036.924 0 1.05-.059 1.905-.146 2.845ZM10.325 13.816c-.822-.08-.469 1.7.03 3.827.026.003.054 0 .082 0a30.21 30.21 0 0 1-.148-2.89c0-.317.013-.632.036-.942v.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C4743D",
        d: "M15.237 22.461h1.08c.262 0 .512-.061.748-.153 1.157-.45 1.982-1.011 2.57-1.582 1.447-1.398 1.46-2.85 1.46-2.85.007-.092.017-.184.025-.273.087-.943.146-1.795.146-2.845 0-.312-.013-.62-.036-.924-.177.136-.36.185-.484-.125-.604-1.539-3.463-3.989-5.273-4.053-.08.01-.159.026-.236.046-.26.12-.93.469-1.51 1.132-.323.417-.566.86-.722 1.18-.07.177-.126.364-.172.563 0 0-.617-.135-1.454.151a.684.684 0 0 0-.389.338c-.156.3-.392.776-.422.812a.921.921 0 0 0-.24-.062c-.024.31-.037.625-.037.942 0 1.068.062 1.93.149 2.89l.02.231s.016 1.667 1.797 3.149c.556.463 1.28.909 2.233 1.28.235.092.489.153.747.153Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "160",
        height: "32",
        x: "40",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "6",
        x: "48",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M171 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M179.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "208",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M212 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M223.793 9.793a.993.993 0 0 0-.217 1.09c.05.121.124.231.217.324L227.586 15H218a1 1 0 1 0 0 2h9.586l-3.793 3.793a.994.994 0 0 0-.217 1.09 1.002 1.002 0 0 0 1.632.324l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.995.995 0 0 0-.293-.678l-5.499-5.5a.997.997 0 0 0-1.09-.217.997.997 0 0 0-.325.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "100",
        height: "32",
        x: "248",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "60",
        height: "6",
        x: "256",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M319 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M327.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "99",
        height: "32",
        x: "720",
        fill: "#B3D4FF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "59",
        height: "6",
        x: "728",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M790 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M798.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "14",
        x: "40",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "44",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "206",
        height: "6",
        x: "108",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M0 106h77v2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        x: "77",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M77 106h77v2H77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        x: "154",
        y: "90",
        fill: "#4C9AFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#4C9AFF",
        d: "M154 106h77v2h-77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M231 106h589v2H231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "160",
        height: "32",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "6",
        x: "8",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M131 136h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M139.292 146.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FAFBFC",
        d: "M268 230h62v389h-62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "295",
        y: "344",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3",
        transform: "rotate(-180 295 344)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M268 188h551v42H268z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M280 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M288.292 207.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "312",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "676",
        y: "204",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "48",
        height: "6",
        x: "695",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M751 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M765 201.187a10.734 10.734 0 0 0-2-.187c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.031.164.033a.52.52 0 0 0 .429-.231.516.516 0 0 0 .045-.485v-.002s-1.563-2.26-.766-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-.171-.006-.342-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229v-2.045Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M770 202a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0v-4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M771 203h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M783 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M795 211a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122A1.503 1.503 0 0 1 795 211Zm-4.5 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Zm9 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 228h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "240",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "75",
        height: "6",
        x: "370",
        y: "237",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 250h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 254h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 259.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "257",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 288h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "300",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "209",
        height: "6",
        x: "370",
        y: "297",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 308h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "320",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "317",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFEBE6",
        d: "M330 330h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "6",
        height: "2",
        x: "347",
        y: "339",
        fill: "#D9D9D9",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "83",
        height: "6",
        x: "370",
        y: "337",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 350h489v100H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 354h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 359.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "357",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M344 374h465v68H344z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C0B6F2",
        d: "M375.904 393.998c0-6.574-5.33-11.904-11.904-11.904s-11.904 5.33-11.904 11.904 5.33 11.904 11.904 11.904 11.904-5.33 11.904-11.904Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#998DD9",
        d: "M369.098 403.32a3.41 3.41 0 0 1-2.116-3.151 3.324 3.324 0 0 1 1.171-2.565c4.694-3.942 1.782-11.574-4.276-11.453-5.935.102-8.634 7.592-4.03 11.453a3.324 3.324 0 0 1 1.171 2.565 3.408 3.408 0 0 1-2.116 3.151c-.368.153-.731.322-1.088.505-.098.051-.194.109-.292.165a11.85 11.85 0 0 0 6.476 1.918c2.391 0 4.616-.709 6.482-1.922a15.005 15.005 0 0 0-.518-.271 12.696 12.696 0 0 0-.866-.393l.002-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "119",
        height: "6",
        x: "388",
        y: "391",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "303.948",
        height: "6",
        x: "352",
        y: "414",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "191.135",
        height: "6",
        x: "352",
        y: "428",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentH)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 448h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "460",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "457",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentI)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 488h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "500",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "105",
        height: "6",
        x: "370",
        y: "497",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M268.5 188.5h550v430h-550z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "80",
        height: "32",
        x: "739",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "64",
        height: "6",
        x: "747",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 196h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 206.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "205",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 236h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 246.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "245",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "184",
        height: "20",
        x: "48",
        y: "278",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "79",
        height: "6",
        x: "80",
        y: "285",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M46 276h24v24H46z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M54.292 286.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 316h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 326.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "325",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 356h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 366.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "365",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 396h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 406.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "405",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 436h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 446.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "445",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 476h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 486.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "485",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M.5 188.5h239v430H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M268 188h551v431H268z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 230h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 290h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 310h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentG"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M352 382h24v24h-24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentH"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 450h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 490h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "PageContentB",
        x1: "15.944",
        x2: "15.944",
        y1: "35.84",
        y2: "20.992",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#C4743D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".43",
        stopColor: "#BB703A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#A96935"
    }))));
};

});

parcelRegister("lWA6j", function(module, exports) {

$parcel$export(module.exports, "PageHeader", function () { return $ff9b04a156353dec$export$53f1cd6809577fc5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $ff9b04a156353dec$export$53f1cd6809577fc5 = function PageHeader() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($ff9b04a156353dec$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($ff9b04a156353dec$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $ff9b04a156353dec$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $145Wl.SECONDARY_NAV_WIDTH), "px")
});
var $ff9b04a156353dec$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "467",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "100",
        height: "6",
        x: "24",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "54",
        height: "6",
        x: "137",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#6B778C",
        d: "m129.372 49.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "419.328",
        height: "20",
        x: "24",
        y: "68",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }));
};

});

parcelRegister("6AYcA", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $4cd4cdbaee315eb6$export$4b85d3515bd863a5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");
var $4cd4cdbaee315eb6$export$4b85d3515bd863a5 = function Search() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($4cd4cdbaee315eb6$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($4cd4cdbaee315eb6$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $4cd4cdbaee315eb6$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    top: 0,
    right: 0
});
var $4cd4cdbaee315eb6$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "412",
        height: "56",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M356 12h32v32h-32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SearchA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M386.93 27.996c0-8.246-6.685-14.931-14.931-14.931-8.247 0-14.932 6.685-14.932 14.931 0 8.247 6.685 14.932 14.932 14.932 8.246 0 14.931-6.685 14.931-14.932Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M378.394 39.69a4.277 4.277 0 0 1-2.655-3.95 4.172 4.172 0 0 1 1.471-3.218c5.888-4.944 2.235-14.518-5.364-14.364-7.444.127-10.831 9.523-5.054 14.364a4.178 4.178 0 0 1 1.471 3.218 4.27 4.27 0 0 1-2.654 3.95c-.463.192-.917.406-1.366.632-.125.064-.242.139-.365.206a14.862 14.862 0 0 0 8.124 2.407c3 0 5.792-.888 8.129-2.41a16.828 16.828 0 0 0-1.735-.835h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SearchB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "238",
        height: "32",
        x: "25",
        y: "12",
        fill: "#F4F5F7",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M46 27a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.89a6 6 0 1 1 1.414-1.414l2.816 2.817a1 1 0 0 1-1.414 1.414l-2.816-2.816Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M274 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M280.485 33.669a2 2 0 0 0 2.829 0l-2.829-2.83a2.004 2.004 0 0 0-.434 2.18c.101.244.248.464.434.65Zm4.897-12.191-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.046 5.046 0 0 0 .64-6.356 1.01 1.01 0 1 0-1.354-1.494c-.023.025-.046.049-.066.075a5.044 5.044 0 0 0-4.72-.457 5.03 5.03 0 0 0-1.638 1.095v.001Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M314 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M336 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-7.172-4.84a3.97 3.97 0 0 1 1.062 1.89 3.988 3.988 0 0 1-2.536 4.698.507.507 0 0 0-.35.472v.782a1.005 1.005 0 0 1-1.002 1.002A1.003 1.003 0 0 1 325 31.002v-2.014a.998.998 0 0 1 1-.987h-.007a2.004 2.004 0 0 0 2.003-2 2.003 2.003 0 0 0-3.405-1.386 2 2 0 0 0-.602 1.388c-.002.551-.45.998-1.002.998a.993.993 0 0 1-.982-.904L322 25.95c.017-2.504 2.321-4.436 4.933-3.842a3.973 3.973 0 0 1 1.895 1.052ZM327 34a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SearchA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M357 13h30v30h-30z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SearchB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M24 11h314v34H24z"
    }))));
};

});

parcelRegister("bMmao", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $89355f41a2509b9e$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $7nGig = parcelRequire("7nGig");
var $89355f41a2509b9e$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($89355f41a2509b9e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($89355f41a2509b9e$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $89355f41a2509b9e$var$Wrapper = (0, $9Vz68.default)((0, $7nGig.SecondaryNavWrapper))({
    borderRight: '24px solid #fff'
});
var $89355f41a2509b9e$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "775",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M0 0h240v775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SecondaryNavA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 88h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "84",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "96",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "124",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "136",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 168h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "164",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "176",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "208",
        height: "40",
        x: "16",
        y: "200",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 208h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "204",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "216",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "244",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "256",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "284",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "296",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "12",
        x: "74",
        y: "38",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "40",
        height: "40",
        x: "18",
        y: "24",
        fill: "#DEEBFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SecondaryNavA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M16 80h208v240H16z"
    }))));
};

});
parcelRegister("7nGig", function(module, exports) {

$parcel$export(module.exports, "SecondaryNavWrapper", function () { return $55fb7d02a76e27d4$export$fd2a3539d2004332; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $55fb7d02a76e27d4$export$fd2a3539d2004332 = function SecondaryNavWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($55fb7d02a76e27d4$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($55fb7d02a76e27d4$var$Wrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $55fb7d02a76e27d4$var$Background = (0, $9Vz68.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    left: 0,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $145Wl.SECONDARY_NAV_WIDTH), "px"),
    background: '#f4f5f7'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $55fb7d02a76e27d4$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    left: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $145Wl.SECONDARY_NAV_WIDTH), "px")
});

});


parcelRegister("epoDP", function(module, exports) {

$parcel$export(module.exports, "Sidebar", function () { return $a7d683c73ea113ce$export$1ba59dacbcbf90fe; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $145Wl = parcelRequire("145Wl");
var $a7d683c73ea113ce$export$1ba59dacbcbf90fe = function Sidebar() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $a7d683c73ea113ce$var$Background = (0, $9Vz68.default).div({
    display: 'inline-block',
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    right: 0,
    height: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $145Wl.SIDEBAR_WIDTH) - 2, "px"),
    background: '#fafbfc',
    borderLeft: '2px solid #dfe1e6'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $a7d683c73ea113ce$var$Wrapper = (0, $9Vz68.default).div({
    position: 'fixed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $145Wl.HEADER_HEIGHT), "px"),
    right: 0,
    borderLeft: '24px solid #fff'
});
var $a7d683c73ea113ce$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "333",
        height: "776",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "SidebarH",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 0h333v776H0V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FAFBFC",
        d: "M0 0h333v776H0V0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "32",
        y: "40",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 70h269v175H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "81",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "78",
        height: "6",
        x: "80",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 81h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 91.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 117h269v-1H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SidebarB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M71.944 135.997c0-6.597-5.348-11.945-11.945-11.945s-11.945 5.348-11.945 11.945 5.348 11.945 11.945 11.945 11.945-5.348 11.945-11.945Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M65.115 145.352a3.421 3.421 0 0 1-2.124-3.16 3.338 3.338 0 0 1 1.177-2.575c4.71-3.955 1.788-11.614-4.29-11.491-5.957.102-8.666 7.619-4.044 11.491a3.344 3.344 0 0 1 1.177 2.575 3.416 3.416 0 0 1-2.124 3.16c-.37.154-.733.325-1.092.505-.1.052-.194.112-.292.165a11.882 11.882 0 0 0 6.499 1.926c2.4 0 4.633-.71 6.503-1.928a13.607 13.607 0 0 0-1.388-.668h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "133",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SidebarC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M72 176c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M65.12 185.395a3.43 3.43 0 0 1-1.77-1.648l3.01.006c.719.004 1.212-.818.853-1.448a5.53 5.53 0 0 1-.622-2.561v-4.867a6.833 6.833 0 0 0-1.758-4.662c-3.493-3.825-9.956-2.25-11.202 2.838-.44 1.194-.196 5.357-.253 6.666a5.478 5.478 0 0 1-.628 2.561.983.983 0 0 0 .854 1.452l3.015.006a3.431 3.431 0 0 1-1.776 1.658c-.292.125-.586.252-.87.396-.175.084-.346.177-.515.269a11.943 11.943 0 0 0 6.544 1.943c2.407 0 4.646-.711 6.524-1.932a10.607 10.607 0 0 0-.538-.28 13.187 13.187 0 0 0-.87-.396l.003-.001Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "173",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M48 204h24v24H48z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M61 215v-7.007a.996.996 0 0 0-1-.993c-.556 0-1 .445-1 .993V215h-7.007a.999.999 0 0 0-.993 1c0 .557.445 1 .993 1H59v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V217h7.007a.998.998 0 0 0 .993-1c0-.556-.445-1-.993-1H61Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "90",
        height: "6",
        x: "80",
        y: "213",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 261h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "281",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M218 292a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 272h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 282.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 307.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 335a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "170",
        height: "6",
        x: "80",
        y: "324",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 375a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "139",
        height: "6",
        x: "80",
        y: "364",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M50 397h20v20H50z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#36B37E",
        fillRule: "evenodd",
        d: "M68.333 407a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Zm-10.514-.776a.833.833 0 0 1 .27.187l1.078 1.077 2.744-2.744a.847.847 0 0 1 .27-.187.846.846 0 0 1 .645-.005.838.838 0 0 1 .517.778.837.837 0 0 1-.254.593l-3.333 3.333a.834.834 0 0 1-1.179 0l-1.666-1.667a.84.84 0 0 1-.255-.592.834.834 0 0 1 1.163-.773Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "194",
        height: "6",
        x: "80",
        y: "404",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 452h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "472",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 463h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 473.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 498.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "512",
        fill: "#0052CC",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M57.207 515.793a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "515",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "552",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "553",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "76",
        y: "555",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "592",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "593",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "595",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 643h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "654",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "663",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 678v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 669.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 707h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "718",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "727",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 742v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 733.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M2 776V0h-4v776h4Z",
        mask: "url(#SidebarH)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarA",
        width: "271",
        height: "179",
        x: "31",
        y: "68",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarD",
        width: "271",
        height: "178",
        x: "31",
        y: "259",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarE",
        width: "271",
        height: "178",
        x: "31",
        y: "450",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarF",
        width: "271",
        height: "52",
        x: "31",
        y: "641",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarG",
        width: "271",
        height: "52",
        x: "31",
        y: "705",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SidebarB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M48 124h24v24H48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SidebarC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M48 164h24v24H48z"
    }))));
};

});


parcelRegister("5GyOg", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $423be07f465abaef$export$5e40b6732fa22ace; });
$parcel$export(module.exports, "useMatchMedia", function () { return $423be07f465abaef$export$dd42f485803cd57d; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $yS2bK = parcelRequire("yS2bK");

var $i2LcI = parcelRequire("i2LcI");

var $1ZDja = parcelRequire("1ZDja");
var $423be07f465abaef$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    var isAboveSmallScreen = $423be07f465abaef$export$dd42f485803cd57d((0, $1ZDja.media).above.sm);
    if ((0, $i2LcI.fg)('tblz-2487_fix_product_wireframe_child_rerender')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, isAboveSmallScreen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $yS2bK.default), {
        isTinted: isAboveSmallScreen
    }, children));
    return isAboveSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $yS2bK.default), {
        isTinted: true
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children);
};
var $423be07f465abaef$export$dd42f485803cd57d = function useMatchMedia(mediaQuery) {
    var query = mediaQuery.replace('@media', '').trim();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useState(function() {
        return window.matchMedia(query).matches;
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_React$useState, 2), matches = _React$useState2[0], setMatches = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useLayoutEffect(function() {
        var screen = window.matchMedia(query);
        var unbind = (0, $k6Bkl.bind)(screen, {
            type: 'change',
            listener: function listener(e) {
                setMatches(e.matches);
            }
        });
        return unbind;
    }, [
        query
    ]);
    return matches;
};

});
parcelRegister("yS2bK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $068d172d20cdada2$export$2e2bcd8739ae039; });
/* blanket.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $1Muvn = parcelRequire("1Muvn");

var $iS4Km = parcelRequire("iS4Km");

var $e1SaG = parcelRequire("e1SaG");

function $068d172d20cdada2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $068d172d20cdada2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $068d172d20cdada2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $068d172d20cdada2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $068d172d20cdada2$var$packageName = "@atlaskit/blanket";
var $068d172d20cdada2$var$packageVersion = "15.0.3";
var $068d172d20cdada2$var$analyticsAttributes = {
    componentName: 'blanket',
    packageName: $068d172d20cdada2$var$packageName,
    packageVersion: $068d172d20cdada2$var$packageVersion
};
var $068d172d20cdada2$var$baseStyles = null;
var $068d172d20cdada2$var$shouldAllowClickThroughStyles = null;
var $068d172d20cdada2$var$invisibleStyles = null;
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $068d172d20cdada2$var$Blanket = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $iS4Km.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $8ZuGG.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($068d172d20cdada2$var$_objectSpread({
        fn: onBlanketClicked,
        action: 'clicked',
        analyticsData: analyticsContext
    }, $068d172d20cdada2$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $8ZuGG.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $8ZuGG.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        role: "presentation",
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref,
        className: (0, $c4hjl.default)([
            "_1r04idpf _kqsw1n9t _1pbybfng _bfhk705f _18m91wug _lcxv1wug",
            shouldAllowClickThrough && "_lcxvglyw",
            !isTinted && "_bfhk1j28"
        ]),
        style: {
            "--_10avjlk": (0, $bT1Ur.default)("var(--ds-blanket, ".concat((0, $e1SaG.N100A), ")"))
        }
    }, children);
}));
$068d172d20cdada2$var$Blanket.displayName = 'Blanket';
var $068d172d20cdada2$export$2e2bcd8739ae039 = $068d172d20cdada2$var$Blanket;

});
parcelRegister("iS4Km", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbd0f3c3d791cada$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $dbd0f3c3d791cada$export$2e2bcd8739ae039() {}

});

parcelRegister("e1SaG", function(module, exports) {

$parcel$export(module.exports, "N100A", function () { return $a36b2dff15cb36d3$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $a36b2dff15cb36d3$export$4b84fd0e2c617bd = '#FFEBE6';
var $a36b2dff15cb36d3$export$b34b069eff244586 = '#FFBDAD';
var $a36b2dff15cb36d3$export$be802dd0d8b57f35 = '#FF8F73';
var $a36b2dff15cb36d3$export$60847d42f9da92a6 = '#FF7452';
var $a36b2dff15cb36d3$export$4a7404f376229999 = '#FF5630';
var $a36b2dff15cb36d3$export$2010d0fb4295b346 = '#DE350B';
var $a36b2dff15cb36d3$export$2837b5a1a71d5c02 = '#BF2600';
var $a36b2dff15cb36d3$export$8d9596b529bbb9cf = '#FFFAE6';
var $a36b2dff15cb36d3$export$41060a744ab0b7ae = '#FFF0B3';
var $a36b2dff15cb36d3$export$1cc05bbbf340e559 = '#FFE380';
var $a36b2dff15cb36d3$export$5aae31392d72caaa = '#FFC400';
var $a36b2dff15cb36d3$export$c6930421db9fa514 = '#FFAB00';
var $a36b2dff15cb36d3$export$59619663aa6500fb = '#FF991F';
var $a36b2dff15cb36d3$export$874739ea9e379ab6 = '#FF8B00';
var $a36b2dff15cb36d3$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $a36b2dff15cb36d3$export$69a3bf21b9686c2b = '#ABF5D1';
var $a36b2dff15cb36d3$export$afbce1382ec95f73 = '#79F2C0';
var $a36b2dff15cb36d3$export$747d86715d4175de = '#57D9A3';
var $a36b2dff15cb36d3$export$940e1f69e873f202 = '#36B37E';
var $a36b2dff15cb36d3$export$a49394138f7b8e85 = '#00875A';
var $a36b2dff15cb36d3$export$6fa04827ac68a4fb = '#006644';
var $a36b2dff15cb36d3$export$226de0355ed012f8 = '#DEEBFF';
var $a36b2dff15cb36d3$export$8c13c2ee36917869 = '#B3D4FF';
var $a36b2dff15cb36d3$export$ecfc1dff386a3e7a = '#4C9AFF';
var $a36b2dff15cb36d3$export$215b7063051591f1 = '#2684FF';
var $a36b2dff15cb36d3$export$e62e8919cca44969 = '#0065FF';
var $a36b2dff15cb36d3$export$b3de0ae08da2ce64 = '#0052CC';
var $a36b2dff15cb36d3$export$a6ee3d71bc067634 = '#0747A6';
var $a36b2dff15cb36d3$export$67f15409e87642a1 = '#669DF1';
var $a36b2dff15cb36d3$export$f0539dbc42dbb067 = '#8FB8F6';
var $a36b2dff15cb36d3$export$363e4475840015bb = '#EAE6FF';
var $a36b2dff15cb36d3$export$4b0a4417ed59760f = '#C0B6F2';
var $a36b2dff15cb36d3$export$6011520a64d9a187 = '#998DD9';
var $a36b2dff15cb36d3$export$a7175d4e9206bc80 = '#8777D9';
var $a36b2dff15cb36d3$export$b48405b95304b5a1 = '#6554C0';
var $a36b2dff15cb36d3$export$c71e4279dd54a18d = '#5243AA';
var $a36b2dff15cb36d3$export$147899de772240ec = '#403294';
var $a36b2dff15cb36d3$export$2cf711fe14c66f06 = '#E6FCFF';
var $a36b2dff15cb36d3$export$7a8f4d33f6f9772c = '#B3F5FF';
var $a36b2dff15cb36d3$export$776c9c497ef08533 = '#79E2F2';
var $a36b2dff15cb36d3$export$69cb3ca10c1e330e = '#00C7E6';
var $a36b2dff15cb36d3$export$9dc1ef0f3f48059b = '#00B8D9';
var $a36b2dff15cb36d3$export$7c835c78b6fcdef8 = '#00A3BF';
var $a36b2dff15cb36d3$export$6036577f95c3877e = '#008DA6';
var $a36b2dff15cb36d3$export$29a4f05edc054374 = '#FFFFFF';
var $a36b2dff15cb36d3$export$e655ef011c4aa1a2 = '#FAFBFC';
var $a36b2dff15cb36d3$export$9fdfb749e33cdf97 = '#F4F5F7';
var $a36b2dff15cb36d3$export$3e51e8f1440314ba = '#EBECF0';
var $a36b2dff15cb36d3$export$1ce2d1575d444ceb = '#DFE1E6';
var $a36b2dff15cb36d3$export$8754fc7e6d8b3000 = '#C1C7D0';
var $a36b2dff15cb36d3$export$c2e91cbeada39b8b = '#B3BAC5';
var $a36b2dff15cb36d3$export$5f71e19f3a7ad9de = '#A5ADBA';
var $a36b2dff15cb36d3$export$eaa8c8a70ac22806 = '#97A0AF';
var $a36b2dff15cb36d3$export$7c87d337fb91a97d = '#8993A4';
var $a36b2dff15cb36d3$export$d6447c357493214f = '#7A869A';
var $a36b2dff15cb36d3$export$f563ee71e9ee74cd = '#6B778C';
var $a36b2dff15cb36d3$export$e2ef2124cf4024b1 = '#5E6C84';
var $a36b2dff15cb36d3$export$eece5f492e429f08 = '#505F79';
var $a36b2dff15cb36d3$export$c39c0fe0f26207ae = '#42526E';
var $a36b2dff15cb36d3$export$7090862dc3038a9f = '#344563';
var $a36b2dff15cb36d3$export$ad0bacf983b7ddaa = '#253858';
var $a36b2dff15cb36d3$export$7d61b15e0da132af = '#172B4D';
var $a36b2dff15cb36d3$export$fbda843f0a27fe96 = '#091E42';
var $a36b2dff15cb36d3$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $a36b2dff15cb36d3$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $a36b2dff15cb36d3$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $a36b2dff15cb36d3$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $a36b2dff15cb36d3$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $a36b2dff15cb36d3$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $a36b2dff15cb36d3$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $a36b2dff15cb36d3$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $a36b2dff15cb36d3$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $a36b2dff15cb36d3$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $a36b2dff15cb36d3$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $a36b2dff15cb36d3$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $a36b2dff15cb36d3$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $a36b2dff15cb36d3$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $a36b2dff15cb36d3$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $a36b2dff15cb36d3$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $a36b2dff15cb36d3$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $a36b2dff15cb36d3$export$2f6319cf7d736c2a = '#E6EDFA';
var $a36b2dff15cb36d3$export$95126bc8884d6634 = '#DCE5F5';
var $a36b2dff15cb36d3$export$8338d8c35d44ff1 = '#CED9EB';
var $a36b2dff15cb36d3$export$5368d76ae4fbbda7 = '#B8C7E0';
var $a36b2dff15cb36d3$export$9f0a771d16ec8d36 = '#ABBBD6';
var $a36b2dff15cb36d3$export$abcf8c38338b4aa5 = '#9FB0CC';
var $a36b2dff15cb36d3$export$97e81faa16a182c7 = '#8C9CB8';
var $a36b2dff15cb36d3$export$bfe21c59123ecf33 = '#7988A3';
var $a36b2dff15cb36d3$export$ee82aa2ea6a1558 = '#67758F';
var $a36b2dff15cb36d3$export$682927c6ed76be02 = '#56637A';
var $a36b2dff15cb36d3$export$91fd9994c5be9757 = '#455166';
var $a36b2dff15cb36d3$export$d281fbfe3cff2df6 = '#3B475C';
var $a36b2dff15cb36d3$export$3902c91d8b98a753 = '#313D52';
var $a36b2dff15cb36d3$export$8e8133c1ba5845b5 = '#283447';
var $a36b2dff15cb36d3$export$33ff357f6620b39 = '#202B3D';
var $a36b2dff15cb36d3$export$633847cf062b69e0 = '#1B2638';
var $a36b2dff15cb36d3$export$9776a6e503bdbf76 = '#121A29';
var $a36b2dff15cb36d3$export$6c813d5160dff5db = '#0E1624';
var $a36b2dff15cb36d3$export$3d4f271a500072a = '#0D1424';
var $a36b2dff15cb36d3$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $a36b2dff15cb36d3$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $a36b2dff15cb36d3$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $a36b2dff15cb36d3$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $a36b2dff15cb36d3$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $a36b2dff15cb36d3$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $a36b2dff15cb36d3$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $a36b2dff15cb36d3$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $a36b2dff15cb36d3$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $a36b2dff15cb36d3$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $a36b2dff15cb36d3$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $a36b2dff15cb36d3$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $a36b2dff15cb36d3$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $a36b2dff15cb36d3$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $a36b2dff15cb36d3$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $a36b2dff15cb36d3$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $a36b2dff15cb36d3$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $a36b2dff15cb36d3$export$d2adc5dedf09fced = '#292A2E';
var $a36b2dff15cb36d3$export$f51762073d2bb381 = '#94C748';
var $a36b2dff15cb36d3$export$95e26d54def96891 = '#B3DF72';

});





parcelRegister("1Szkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65abeb54cec403dc$export$2e2bcd8739ae039; });

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");
const $65abeb54cec403dc$export$a882740fcd1752cc = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $65abeb54cec403dc$var$CompassCobranding = {
    background: $65abeb54cec403dc$export$a882740fcd1752cc,
    logo: {
        component: (0, $l8yrb.CompassLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $65abeb54cec403dc$export$2e2bcd8739ae039 = $65abeb54cec403dc$var$CompassCobranding;

});

parcelRegister("gUezr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1c5f42528db2859$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $36vhv = parcelRequire("36vhv");
const $f1c5f42528db2859$var$ConfluenceCobranding = {
    background: (0, $36vhv.ConfluenceBackground),
    logo: {
        component: (0, $l8yrb.ConfluenceLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $f1c5f42528db2859$export$2e2bcd8739ae039 = $f1c5f42528db2859$var$ConfluenceCobranding;

});
parcelRegister("36vhv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBackground", function () { return $242a327ae309efbc$export$b0d291b61d581ffd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $6KhR5 = parcelRequire("6KhR5");

var $bHkgo = parcelRequire("bHkgo");

var $e1ZEO = parcelRequire("e1ZEO");

var $5GyOg = parcelRequire("5GyOg");
var $242a327ae309efbc$export$b0d291b61d581ffd = function ConfluenceBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $6KhR5.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $bHkgo.ConfluenceDarkTheme) : (0, $e1ZEO.ConfluenceLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("bHkgo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDarkTheme", function () { return $88436dbc4af8af29$export$42b780ab52e6a23f; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $7CwwF = parcelRequire("7CwwF");

var $gvCV1 = parcelRequire("gvCV1");

var $gZXgw = parcelRequire("gZXgw");

var $kenFm = parcelRequire("kenFm");

var $5bjfi = parcelRequire("5bjfi");

var $2aYn8 = parcelRequire("2aYn8");

var $gHSL3 = parcelRequire("gHSL3");

var $8Zxn4 = parcelRequire("8Zxn4");
var $88436dbc4af8af29$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $88436dbc4af8af29$export$42b780ab52e6a23f = function ConfluenceDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gvCV1.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gZXgw.TopNav), {
        product: (0, $7CwwF.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8Zxn4.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDzos.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $88436dbc4af8af29$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5bjfi.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kenFm.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2aYn8.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gHSL3.FloatingActions), null));
};

});
parcelRegister("7CwwF", function(module, exports) {

$parcel$export(module.exports, "Products", function () { return $58c54ffd6cf84e66$export$92e44ea1079b9ec6; });
var $58c54ffd6cf84e66$export$92e44ea1079b9ec6 = {
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_SERVICE_MANAGEMENT: 'jira-service-management'
};

});

parcelRegister("gvCV1", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $c04dbb0adac03bfb$export$668799e4797757a8; });
/* background.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $aDzos = parcelRequire("aDzos");
var $c04dbb0adac03bfb$var$styles = {
    background: "_bfhkvuon _1tke1osq"
};
var $c04dbb0adac03bfb$export$668799e4797757a8 = function Background(_ref) {
    var children = _ref.children, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDzos.default), {
        xcss: $c04dbb0adac03bfb$var$styles.background,
        testId: testId
    }, children);
};

});

parcelRegister("gZXgw", function(module, exports) {

$parcel$export(module.exports, "TopNav", function () { return $c60050be50dd6bbf$export$41d0d88a6b0e456f; });
/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");


var $8ZuGG = parcelRequire("8ZuGG");

var $8XiZe = parcelRequire("8XiZe");

var $8bIRB = parcelRequire("8bIRB");

var $fNMcO = parcelRequire("fNMcO");

var $2IceQ = parcelRequire("2IceQ");

var $9Z8tr = parcelRequire("9Z8tr");

var $8shit = parcelRequire("8shit");

var $cCJR4 = parcelRequire("cCJR4");

var $l8yrb = parcelRequire("l8yrb");

var $72wHg = parcelRequire("72wHg");
var $fkdQ8 = parcelRequire("fkdQ8");
var $1ZDja = parcelRequire("1ZDja");

var $5GyOg = parcelRequire("5GyOg");

var $7CwwF = parcelRequire("7CwwF");
var $c60050be50dd6bbf$var$styles = {
    wrapper: "_18zrv47k _n7zl7r9e _4t3ickbl _1bsb1osq",
    search: "_195goahv _1bsb1osq",
    searchBar: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
    createButton: "_2rkoiti9 _4t3izwfg _1bsbys9h _bfhk4v9p",
    createButtonText: "_2rkoiti9 _4t3ii2wt _1bsb1ady",
    chatButton: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsbcae7",
    chatButtonText: "_2rkoiti9 _4t3ii2wt _1bsbzwfg"
};
var $c60050be50dd6bbf$var$ProductLogos = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $7CwwF.Products).JIRA, (0, $l8yrb.JiraLogo)), (0, $7CwwF.Products).CONFLUENCE, (0, $l8yrb.ConfluenceLogo)), (0, $7CwwF.Products).JIRA_PRODUCT_DISCOVERY, (0, $l8yrb.JiraProductDiscoveryLogo)), (0, $7CwwF.Products).JIRA_SERVICE_MANAGEMENT, (0, $l8yrb.JiraServiceManagementLogo));
var $c60050be50dd6bbf$var$ProductIcons = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $7CwwF.Products).JIRA, (0, $l8yrb.JiraIcon)), (0, $7CwwF.Products).CONFLUENCE, (0, $l8yrb.ConfluenceIcon)), (0, $7CwwF.Products).JIRA_PRODUCT_DISCOVERY, (0, $l8yrb.JiraProductDiscoveryIcon)), (0, $7CwwF.Products).JIRA_SERVICE_MANAGEMENT, (0, $l8yrb.JiraServiceManagementIcon));
var $c60050be50dd6bbf$export$41d0d88a6b0e456f = function TopNav(_ref) {
    var product = _ref.product;
    var isAboveMediumScreen = (0, $5GyOg.useMatchMedia)((0, $1ZDja.media).above.md);
    var Logo = $c60050be50dd6bbf$var$ProductLogos[product];
    var Icon = $c60050be50dd6bbf$var$ProductIcons[product];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $c60050be50dd6bbf$var$styles.wrapper,
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cCJR4))), {
        label: "Sidebar collapse",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8XiZe))), {
        label: "App switcher",
        color: "var(--ds-icon-subtle, #626F86)"
    }), isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Logo, {
        appearance: "brand",
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Icon, {
        appearance: "brand",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $c60050be50dd6bbf$var$styles.search,
        alignInline: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $c60050be50dd6bbf$var$styles.searchBar,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Z8tr))), {
        label: "Search",
        color: "var(--ds-icon-subtle, #626F86)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $c60050be50dd6bbf$var$styles.createButton,
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $c60050be50dd6bbf$var$styles.createButtonText,
        backgroundColor: "color.background.accent.blue.subtler.hovered"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $c60050be50dd6bbf$var$styles.chatButton,
        alignBlock: "center",
        alignInline: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $l8yrb.RovoIcon), {
        size: "xxsmall",
        appearance: "neutral"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $c60050be50dd6bbf$var$styles.chatButtonText,
        backgroundColor: "color.background.accent.gray.subtlest.hovered"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8bIRB))), {
        label: "Notifications",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2IceQ))), {
        label: "Help",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8shit))), {
        label: "Settings",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fNMcO))), {
        label: "User",
        color: "var(--ds-icon-subtle, #626F86)"
    })));
};

});
parcelRegister("8XiZe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e96a69f97519443fff2bdbab242b00d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68528fc126df2422$var$_react = $68528fc126df2422$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $68528fc126df2422$var$_baseNew = $68528fc126df2422$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $68528fc126df2422$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AppSwitcher".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68528fc126df2422$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $68528fc126df2422$var$_react.default.createElement($68528fc126df2422$var$_baseNew.default, Object.assign({
        name: "AppSwitcherIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM9 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM1 11a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm6 .5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$68528fc126df2422$var$AppSwitcherIcon.displayName = 'AppSwitcherIcon';
var $68528fc126df2422$var$_default = module.exports.default = $68528fc126df2422$var$AppSwitcherIcon;

});
parcelRegister("jJ7Gf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("h3lWU")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("h3lWU")).Icon; });

var $h3lWU = parcelRequire("h3lWU");

});
parcelRegister("h3lWU", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c6a3be1981089c98$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $c6a3be1981089c98$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $c6a3be1981089c98$var$svgStyles = null;
var $c6a3be1981089c98$var$iconStyles = null;
var $c6a3be1981089c98$var$utilityIconStyles = null;
var $c6a3be1981089c98$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $c6a3be1981089c98$var$baseHcmStyles = null;
var $c6a3be1981089c98$var$scaleSize = null;
var $c6a3be1981089c98$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c6a3be1981089c98$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c6a3be1981089c98$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $c6a3be1981089c98$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $c6a3be1981089c98$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $c6a3be1981089c98$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $c6a3be1981089c98$var$baseSizeMap[type];
    var viewBoxPadding = $c6a3be1981089c98$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $c6a3be1981089c98$var$utilSizes[spacing] : size === 'small' ? $c6a3be1981089c98$var$coreSizeSmall[spacing] : $c6a3be1981089c98$var$coreSizeMedium[spacing]
        ])
    }));
});
var $c6a3be1981089c98$export$2e2bcd8739ae039 = $c6a3be1981089c98$export$f04a61298a47a40f;

});



parcelRegister("8bIRB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5050b53f23a98f3c4135467aadfbb06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f6226c2adab1da5$var$_react = $5f6226c2adab1da5$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5f6226c2adab1da5$var$_baseNew = $5f6226c2adab1da5$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $5f6226c2adab1da5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notification".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for notifications within global product navigation and within product screens.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5f6226c2adab1da5$var$NotificationIcon = (props)=>/*#__PURE__*/ $5f6226c2adab1da5$var$_react.default.createElement($5f6226c2adab1da5$var$_baseNew.default, Object.assign({
        name: "NotificationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 5a5 5 0 0 1 10 0v3.535l1.788 2.861a1.375 1.375 0 0 1-1.166 2.104h-2.459a3.251 3.251 0 0 1-6.326 0h-2.46a1.375 1.375 0 0 1-1.165-2.104L3 8.535zm3.418 8.5a1.75 1.75 0 0 0 3.164 0zM8 1.5A3.5 3.5 0 0 0 4.5 5v3.636c0 .215-.06.426-.175.608L2.603 12h10.794l-1.723-2.756a1.15 1.15 0 0 1-.174-.608V5A3.5 3.5 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$5f6226c2adab1da5$var$NotificationIcon.displayName = 'NotificationIcon';
var $5f6226c2adab1da5$var$_default = module.exports.default = $5f6226c2adab1da5$var$NotificationIcon;

});

parcelRegister("fNMcO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5a2b32fe863ac429d199dc8b174e3b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b810d3428c6a963a$var$_react = $b810d3428c6a963a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $b810d3428c6a963a$var$_baseNew = $b810d3428c6a963a$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $b810d3428c6a963a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b810d3428c6a963a$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $b810d3428c6a963a$var$_react.default.createElement($b810d3428c6a963a$var$_baseNew.default, Object.assign({
        name: "PersonAvatarIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$b810d3428c6a963a$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $b810d3428c6a963a$var$_default = module.exports.default = $b810d3428c6a963a$var$PersonAvatarIcon;

});

parcelRegister("2IceQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bb31d7b8eb39bae440b5a0002b7aa63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f992f24041c9e5b$var$_react = $1f992f24041c9e5b$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $1f992f24041c9e5b$var$_baseNew = $1f992f24041c9e5b$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $1f992f24041c9e5b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "QuestionCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: help, tip.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f992f24041c9e5b$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $1f992f24041c9e5b$var$_react.default.createElement($1f992f24041c9e5b$var$_baseNew.default, Object.assign({
        name: "QuestionCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$1f992f24041c9e5b$var$QuestionCircleIcon.displayName = 'QuestionCircleIcon';
var $1f992f24041c9e5b$var$_default = module.exports.default = $1f992f24041c9e5b$var$QuestionCircleIcon;

});

parcelRegister("9Z8tr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0ed30ba2fe598b1c691c4159780db191>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7450624fc6e11ad0$var$_react = $7450624fc6e11ad0$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7450624fc6e11ad0$var$_baseNew = $7450624fc6e11ad0$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $7450624fc6e11ad0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Search".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for searching objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7450624fc6e11ad0$var$SearchIcon = (props)=>/*#__PURE__*/ $7450624fc6e11ad0$var$_react.default.createElement($7450624fc6e11ad0$var$_baseNew.default, Object.assign({
        name: "SearchIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 2.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9M1 7a6 6 0 1 1 10.74 3.68l3.29 3.29-1.06 1.06-3.29-3.29A6 6 0 0 1 1 7" clip-rule="evenodd"/>`
    }, props));
$7450624fc6e11ad0$var$SearchIcon.displayName = 'SearchIcon';
var $7450624fc6e11ad0$var$_default = module.exports.default = $7450624fc6e11ad0$var$SearchIcon;

});

parcelRegister("8shit", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6207a690a69d1b6395dc313a9a74c2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $627e5b15b021b2bd$var$_react = $627e5b15b021b2bd$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $627e5b15b021b2bd$var$_baseNew = $627e5b15b021b2bd$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $627e5b15b021b2bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Settings".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for any object or user settings.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $627e5b15b021b2bd$var$SettingsIcon = (props)=>/*#__PURE__*/ $627e5b15b021b2bd$var$_react.default.createElement($627e5b15b021b2bd$var$_baseNew.default, Object.assign({
        name: "SettingsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.058.462A.75.75 0 0 1 6.75 0h2.5a.75.75 0 0 1 .692.462l1.026 2.462 2.578-.374a.75.75 0 0 1 .757.367l1.25 2.166a.75.75 0 0 1-.049.824L13.937 8l1.567 2.093c.18.24.2.565.05.825l-1.25 2.165a.75.75 0 0 1-.758.367l-2.578-.374-1.026 2.463A.75.75 0 0 1 9.25 16h-2.5a.75.75 0 0 1-.692-.461l-1.026-2.463-2.578.374a.75.75 0 0 1-.757-.367l-1.25-2.165a.75.75 0 0 1 .049-.825L2.063 8 .496 5.907a.75.75 0 0 1-.05-.824l1.25-2.166a.75.75 0 0 1 .758-.367l2.578.374zM7.25 1.5l-.871 2.09c-.242.58-.845.923-1.467.833l-2.17-.315-.749 1.296L3.32 7.176c.366.488.366 1.16 0 1.648l-1.327 1.772.749 1.296 2.17-.315a1.375 1.375 0 0 1 1.467.832L7.25 14.5h1.5l.871-2.09c.242-.58.845-.923 1.467-.833l2.17.315.749-1.296-1.327-1.772a1.375 1.375 0 0 1 0-1.648l1.327-1.772-.749-1.296-2.17.315A1.375 1.375 0 0 1 9.62 3.59L8.75 1.5zm.75 5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$627e5b15b021b2bd$var$SettingsIcon.displayName = 'SettingsIcon';
var $627e5b15b021b2bd$var$_default = module.exports.default = $627e5b15b021b2bd$var$SettingsIcon;

});

parcelRegister("cCJR4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7c03d2728886be26240ae9af453c127>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $930c9a7d3b792942$var$_react = $930c9a7d3b792942$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $930c9a7d3b792942$var$_baseNew = $930c9a7d3b792942$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $930c9a7d3b792942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SidebarCollapse".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for collapsing the navigation sidebar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $930c9a7d3b792942$var$SidebarCollapseIcon = (props)=>/*#__PURE__*/ $930c9a7d3b792942$var$_react.default.createElement($930c9a7d3b792942$var$_baseNew.default, Object.assign({
        name: "SidebarCollapseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2v-11zm3.5 0v11H14a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM0 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm7.97 4.47 2.5-2.5 1.06 1.06L9.56 8l1.97 1.97-1.06 1.06-2.5-2.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$930c9a7d3b792942$var$SidebarCollapseIcon.displayName = 'SidebarCollapseIcon';
var $930c9a7d3b792942$var$_default = module.exports.default = $930c9a7d3b792942$var$SidebarCollapseIcon;

});


parcelRegister("kenFm", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $eba7790df8d00850$export$b52183d5cfb26dc9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $eba7790df8d00850$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($eba7790df8d00850$var$Image, null));
};
var $eba7790df8d00850$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_211_10675)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#454F59",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#738496"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_10675)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "path-7-inside-1_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-7-inside-1_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "path-12-inside-2_211_10675",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        mask: "url(#path-12-inside-2_211_10675)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2198C279.756 8.68423 282.245 8.68423 283.781 10.2198C285.316 11.7553 285.316 14.2449 283.781 15.7804L281.531 18.0304L280.47 16.9698L282.72 14.7198C283.67 13.77 283.67 12.2302 282.72 11.2804C281.77 10.3307 280.23 10.3307 279.281 11.2804L277.031 13.5304L275.97 12.4698L278.22 10.2198ZM281.281 13.7804L275.781 19.2804L274.72 18.2198L280.22 12.7198L281.281 13.7804ZM272.22 16.2198L274.47 13.9698L275.531 15.0304L273.281 17.2804C272.331 18.2302 272.331 19.77 273.281 20.7198C274.23 21.6695 275.77 21.6695 276.72 20.7198L278.97 18.4698L280.031 19.5304L277.781 21.7804C276.245 23.316 273.756 23.316 272.22 21.7804C270.684 20.2449 270.684 17.7553 272.22 16.2198Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern1_211_10675",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image1_211_10675",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip0_211_10675"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 331,
        height: 32,
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image1_211_10675",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("5bjfi", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $3c5ce8a0ebf7b0d6$export$2dc68d50d56fbbd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $3c5ce8a0ebf7b0d6$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($3c5ce8a0ebf7b0d6$var$Image, null));
};
var $3c5ce8a0ebf7b0d6$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("2aYn8", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $195b589a966107db$export$7c6e2c02157bb7d2; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $195b589a966107db$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($195b589a966107db$var$Image, null));
};
var $195b589a966107db$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 762,
        height: 618,
        viewBox: "0 0 762 618",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_211_10701)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 60,
        width: 192,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 48,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_211_10701)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 100,
        width: 760,
        height: 86,
        rx: 5,
        fill: "#1C2B41"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 126,
        width: 659,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 148,
        width: 325,
        height: 12,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 228,
        width: 143,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 314,
        width: 290,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 350,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 378,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 406,
        width: 343,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 578,
        width: 730,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 606,
        width: 522,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_211_10701",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_211_10701",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip0_211_10701"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 192,
        height: 6,
        fill: "white",
        transform: "translate(46 60)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_211_10701",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,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"
    })));
};

});

parcelRegister("gHSL3", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $c29b23483aa3838e$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $c29b23483aa3838e$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $c29b23483aa3838e$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $c29b23483aa3838e$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c29b23483aa3838e$var$Image, null));
};
var $c29b23483aa3838e$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#filter0_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#0055CC",
        stroke: "#1D2125",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#filter1_dd_211_10747)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "#22272B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#738496"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "filter0_dd_211_10747",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "filter1_dd_211_10747",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0117647 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_10747",
        result: "effect2_dropShadow_211_10747"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_10747",
        result: "shape"
    }))));
};

});

parcelRegister("8Zxn4", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $68bde80ea4d07515$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $1ZDja = parcelRequire("1ZDja");

var $5GyOg = parcelRequire("5GyOg");
var $68bde80ea4d07515$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $68bde80ea4d07515$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $5GyOg.useMatchMedia)((0, $1ZDja.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $68bde80ea4d07515$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($68bde80ea4d07515$var$Image, null)) : null;
};
var $68bde80ea4d07515$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#A1BDD9",
        fillOpacity: 0.08,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#22272B",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#05C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#454F59",
        rx: 3.99
    }));
};

});


parcelRegister("e1ZEO", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLightTheme", function () { return $a370fc88734709e9$export$d4cbd1e5e91e64ff; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $7CwwF = parcelRequire("7CwwF");

var $gvCV1 = parcelRequire("gvCV1");

var $gZXgw = parcelRequire("gZXgw");

var $cJznY = parcelRequire("cJznY");

var $ihQgU = parcelRequire("ihQgU");

var $0zzHJ = parcelRequire("0zzHJ");

var $1SAix = parcelRequire("1SAix");

var $1aJZo = parcelRequire("1aJZo");
var $a370fc88734709e9$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q"
};
var $a370fc88734709e9$export$d4cbd1e5e91e64ff = function ConfluenceLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gvCV1.Background), {
        testId: "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gZXgw.TopNav), {
        product: (0, $7CwwF.Products).CONFLUENCE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1aJZo.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDzos.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $a370fc88734709e9$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $ihQgU.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cJznY.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $0zzHJ.Content), null)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1SAix.FloatingActions), null));
};

});
parcelRegister("cJznY", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $945522dcbdb149f1$export$b52183d5cfb26dc9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $945522dcbdb149f1$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($945522dcbdb149f1$var$Image, null));
};
var $945522dcbdb149f1$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 331,
        height: 32,
        viewBox: "0 0 331 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.5858 8.85361C12.3668 8.07256 13.6332 8.07256 14.4142 8.85361L15.1464 9.58584C15.9275 10.3669 15.9275 11.6332 15.1464 12.4143L10.0094 17.5513C9.76903 17.7917 9.47141 17.9668 9.1446 18.0602L5.95604 18.9712C5.69415 19.046 5.41227 18.973 5.21967 18.7804C5.02707 18.5878 4.95403 18.3059 5.02886 18.044L5.93987 14.8555C6.03325 14.5286 6.20837 14.231 6.44871 13.9907L11.5858 8.85361ZM13.3536 9.91427C13.1583 9.71901 12.8417 9.71901 12.6464 9.91427L12.0607 10.5001L13.5 11.9394L14.0858 11.3536C14.281 11.1583 14.281 10.8418 14.0858 10.6465L13.3536 9.91427ZM12.4393 13.0001L11 11.5607L7.50937 15.0513C7.44928 15.1114 7.4055 15.1858 7.38216 15.2675L6.84202 17.158L8.73251 16.6179C8.81422 16.5946 8.88862 16.5508 8.94871 16.4907L12.4393 13.0001ZM3 10.5012C2.72386 10.5012 2.5 10.725 2.5 11.0012V21.0012C2.5 21.2773 2.72386 21.5012 3 21.5012H13C13.2761 21.5012 13.5 21.2773 13.5 21.0012V18.0001H15V21.0012C15 22.1057 14.1046 23.0012 13 23.0012H3C1.89543 23.0012 1 22.1057 1 21.0012V11.0012C1 9.89659 1.89543 9.00115 3 9.00115H6V10.5012H3Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 131,
        y: 3,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#DCDFE4",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M140.566 21V19.9746L143.848 16.5225C144.281 16.0667 144.618 15.693 144.859 15.4014C145.105 15.1051 145.276 14.8408 145.372 14.6084C145.472 14.3714 145.522 14.1208 145.522 13.8564V13.8359C145.522 13.5124 145.452 13.2253 145.311 12.9746C145.169 12.7194 144.969 12.5189 144.709 12.373C144.449 12.2227 144.137 12.1475 143.772 12.1475C143.403 12.1475 143.08 12.2249 142.802 12.3799C142.524 12.5303 142.307 12.7422 142.152 13.0156C141.997 13.2845 141.92 13.6012 141.92 13.9658L141.913 13.9863L140.491 13.9795L140.478 13.9658C140.482 13.3643 140.628 12.8333 140.915 12.373C141.202 11.9128 141.599 11.5527 142.104 11.293C142.615 11.0286 143.201 10.8965 143.861 10.8965C144.467 10.8965 145.01 11.0173 145.488 11.2588C145.971 11.4958 146.35 11.8262 146.623 12.25C146.901 12.6693 147.04 13.1501 147.04 13.6924V13.7129C147.04 14.082 146.972 14.4421 146.835 14.793C146.698 15.1439 146.464 15.529 146.131 15.9482C145.798 16.3675 145.331 16.8757 144.729 17.4727L142.241 19.9678L142.631 19.2842V19.9678L142.241 19.708H147.197V21H140.566Z",
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 122,
        cy: 16,
        r: 13,
        fill: "url(#pattern0_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 100,
        cy: 16,
        r: 13,
        fill: "url(#pattern1_211_9747)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "path-7-inside-1_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M176 4C176 1.79086 177.791 0 180 0H262V32H180C177.791 32 176 30.2091 176 28V4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M175 4C175 1.23858 177.239 -1 180 -1H262V1H180C178.343 1 177 2.34315 177 4H175ZM262 33H180C177.239 33 175 30.7614 175 28H177C177 29.6569 178.343 31 180 31H262V33ZM180 33C177.239 33 175 30.7614 175 28V4C175 1.23858 177.239 -1 180 -1V1C178.343 1 177 2.34315 177 4V28C177 29.6569 178.343 31 180 31V33ZM262 0V32V0Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-7-inside-1_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M196 9.5C194.619 9.5 193.5 10.6193 193.5 12V15H200C201.105 15 202 15.8954 202 17V22C202 23.1046 201.105 24 200 24H192C190.895 24 190 23.1046 190 22V17C190 15.8954 190.895 15 192 15V12C192 9.79086 193.791 8 196 8C198.209 8 200 9.79086 200 12H198.5C198.5 10.6193 197.381 9.5 196 9.5ZM192 16.5C191.724 16.5 191.5 16.7239 191.5 17V22C191.5 22.2761 191.724 22.5 192 22.5H200C200.276 22.5 200.5 22.2761 200.5 22V17C200.5 16.7239 200.276 16.5 200 16.5H192Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 210,
        y: 13,
        width: 40,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M262 32V0H263V32H262Z",
        fill: "#091E42",
        fillOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "path-12-inside-2_211_9747",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M263 0H291C293.209 0 295 1.79086 295 4V28C295 30.2091 293.209 32 291 32H263V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M263 -1H291C293.761 -1 296 1.23858 296 4H294C294 2.34315 292.657 1 291 1H263V-1ZM296 28C296 30.7614 293.761 33 291 33H263V31H291C292.657 31 294 29.6569 294 28H296ZM263 32V0V32ZM291 -1C293.761 -1 296 1.23858 296 4V28C296 30.7614 293.761 33 291 33V31C292.657 31 294 29.6569 294 28V4C294 2.34315 292.657 1 291 1V-1Z",
        fill: "#091E42",
        fillOpacity: 0.06,
        mask: "url(#path-12-inside-2_211_9747)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M278.22 10.2196C279.756 8.68411 282.245 8.68411 283.781 10.2196C285.316 11.7552 285.316 14.2448 283.781 15.7803L281.531 18.0303L280.47 16.9696L282.72 14.7196C283.67 13.7699 283.67 12.2301 282.72 11.2803C281.77 10.3306 280.23 10.3306 279.281 11.2803L277.031 13.5303L275.97 12.4696L278.22 10.2196ZM281.281 13.7803L275.781 19.2803L274.72 18.2196L280.22 12.7196L281.281 13.7803ZM272.22 16.2196L274.47 13.9696L275.531 15.0303L273.281 17.2803C272.331 18.2301 272.331 19.7699 273.281 20.7196C274.23 21.6694 275.77 21.6694 276.72 20.7196L278.97 18.4696L280.031 19.5303L277.781 21.7803C276.245 23.3158 273.756 23.3158 272.22 21.7803C270.684 20.2448 270.684 17.7552 272.22 16.2196Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 299,
        width: 32,
        height: 32,
        rx: 3,
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M307 16C307 15.1716 307.672 14.5 308.5 14.5C309.328 14.5 310 15.1716 310 16C310 16.8284 309.328 17.5 308.5 17.5C307.672 17.5 307 16.8284 307 16ZM313.5 16C313.5 15.1716 314.172 14.5 315 14.5C315.828 14.5 316.5 15.1716 316.5 16C316.5 16.8284 315.828 17.5 315 17.5C314.172 17.5 313.5 16.8284 313.5 16ZM320 16C320 15.1716 320.672 14.5 321.5 14.5C322.328 14.5 323 15.1716 323 16C323 16.8284 322.328 17.5 321.5 17.5C320.672 17.5 320 16.8284 320 16Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern1_211_9747",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image1_211_9747",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image1_211_9747",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("ihQgU", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $d5025c992363f1c8$export$2dc68d50d56fbbd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $d5025c992363f1c8$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($d5025c992363f1c8$var$Image, null));
};
var $d5025c992363f1c8$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 203,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#6B778C",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M195 2a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.381 2.818 1.25 4.662a.748.748 0 0 1-1.148.813L195 14.159l-3.951 2.71a.75.75 0 0 1-1.148-.813l1.25-4.662-3.381-2.818a.749.749 0 0 1 .423-1.324l4.402-.338L194.3 2.48A.75.75 0 0 1 195 2Zm0 2.84-1.345 3.496-3.506.27 2.7 2.25-.973 3.627L195 12.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27L195 4.84Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("0zzHJ", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $001b98a199073d98$export$7c6e2c02157bb7d2; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $001b98a199073d98$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($001b98a199073d98$var$Image, null));
};
var $001b98a199073d98$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 612,
        height: 562,
        viewBox: "0 0 612 562",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        width: 503,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 40,
        y: 60,
        width: 155,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 40,
        y: 48,
        width: 96,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 18,
        cy: 60,
        r: 17,
        fill: "url(#pattern0_138_18776)",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 100,
        width: 605,
        height: 86,
        rx: 5,
        fill: "#E9F2FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(18 116)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 128C18 121.373 23.3726 116 30 116C36.6274 116 42 121.373 42 128C42 134.627 36.6274 140 30 140C23.3726 140 18 134.627 18 128ZM27.75 126.125H30C30.6213 126.125 31.125 126.629 31.125 127.25V134.75H28.875V128.375H27.75V126.125ZM30 124.25C30.8284 124.25 31.5 123.578 31.5 122.75C31.5 121.922 30.8284 121.25 30 121.25C29.1716 121.25 28.5 121.922 28.5 122.75C28.5 123.578 29.1716 124.25 30 124.25Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 126,
        width: 529,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 148,
        width: 261,
        height: 12,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 218,
        width: 32,
        height: 32,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 228,
        width: 115,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M14.7402 278.6C11.2129 278.6 8.97754 276.385 8.97754 272.898V272.885C8.97754 269.508 11.2744 267.19 14.624 267.19C17.8574 267.19 20.1064 269.255 20.1064 272.215V272.229C20.1064 274.45 19.1084 275.865 17.5361 275.865C16.75 275.865 16.1484 275.421 16.0391 274.758L16.0322 274.717H15.9229C15.6289 275.414 15.0137 275.804 14.2139 275.804C12.792 275.804 11.835 274.635 11.835 272.905V272.892C11.835 271.237 12.8125 270.075 14.2139 270.075C14.9316 270.075 15.5469 270.444 15.8135 271.039H15.9229V270.205H16.9551V274.218C16.9551 274.696 17.2354 274.977 17.7275 274.977C18.5889 274.977 19.1426 273.89 19.1426 272.215V272.201C19.1426 269.74 17.2695 268.052 14.5352 268.052C11.8623 268.052 9.94141 270.089 9.94141 272.926V272.939C9.94141 275.852 11.8281 277.731 14.7539 277.731C15.6904 277.731 16.6133 277.602 17.0439 277.403V278.265C16.4287 278.477 15.6016 278.6 14.7402 278.6ZM14.3711 274.84C15.3076 274.84 15.9092 274.095 15.9092 272.933V272.919C15.9092 271.757 15.3145 271.019 14.3848 271.019C13.4688 271.019 12.9287 271.729 12.9287 272.919V272.933C12.9287 274.115 13.4756 274.84 14.3711 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 23.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 108.5,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M121.24 278.6C117.713 278.6 115.478 276.385 115.478 272.898V272.885C115.478 269.508 117.774 267.19 121.124 267.19C124.357 267.19 126.606 269.255 126.606 272.215V272.229C126.606 274.45 125.608 275.865 124.036 275.865C123.25 275.865 122.648 275.421 122.539 274.758L122.532 274.717H122.423C122.129 275.414 121.514 275.804 120.714 275.804C119.292 275.804 118.335 274.635 118.335 272.905V272.892C118.335 271.237 119.312 270.075 120.714 270.075C121.432 270.075 122.047 270.444 122.313 271.039H122.423V270.205H123.455V274.218C123.455 274.696 123.735 274.977 124.228 274.977C125.089 274.977 125.643 273.89 125.643 272.215V272.201C125.643 269.74 123.77 268.052 121.035 268.052C118.362 268.052 116.441 270.089 116.441 272.926V272.939C116.441 275.852 118.328 277.731 121.254 277.731C122.19 277.731 123.113 277.602 123.544 277.403V278.265C122.929 278.477 122.102 278.6 121.24 278.6ZM120.871 274.84C121.808 274.84 122.409 274.095 122.409 272.933V272.919C122.409 271.757 121.814 271.019 120.885 271.019C119.969 271.019 119.429 271.729 119.429 272.919V272.933C119.429 274.115 119.976 274.84 120.871 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 130,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 215,
        y: 262,
        width: 98.5,
        height: 20,
        rx: 10,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M227.74 278.6C224.213 278.6 221.978 276.385 221.978 272.898V272.885C221.978 269.508 224.274 267.19 227.624 267.19C230.857 267.19 233.106 269.255 233.106 272.215V272.229C233.106 274.45 232.108 275.865 230.536 275.865C229.75 275.865 229.148 275.421 229.039 274.758L229.032 274.717H228.923C228.629 275.414 228.014 275.804 227.214 275.804C225.792 275.804 224.835 274.635 224.835 272.905V272.892C224.835 271.237 225.812 270.075 227.214 270.075C227.932 270.075 228.547 270.444 228.813 271.039H228.923V270.205H229.955V274.218C229.955 274.696 230.235 274.977 230.728 274.977C231.589 274.977 232.143 273.89 232.143 272.215V272.201C232.143 269.74 230.27 268.052 227.535 268.052C224.862 268.052 222.941 270.089 222.941 272.926V272.939C222.941 275.852 224.828 277.731 227.754 277.731C228.69 277.731 229.613 277.602 230.044 277.403V278.265C229.429 278.477 228.602 278.6 227.74 278.6ZM227.371 274.84C228.308 274.84 228.909 274.095 228.909 272.933V272.919C228.909 271.757 228.314 271.019 227.385 271.019C226.469 271.019 225.929 271.729 225.929 272.919V272.933C225.929 274.115 226.476 274.84 227.371 274.84Z",
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 236.5,
        y: 269,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#B3B9C4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 314,
        width: 234,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 350,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 378,
        width: 590,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 2,
        y: 406,
        width: 277,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 444H28C29.1046 444 30 444.895 30 446V454C30 455.105 29.1046 456 28 456H20C18.8954 456 18 455.105 18 454V446C18 444.895 18.8954 444 20 444ZM21.3824 449.069C21.5044 449.121 21.6148 449.198 21.707 449.293L23 450.586L26.293 447.293C26.3852 447.198 26.4956 447.121 26.6176 447.069C26.7396 447.017 26.8708 446.989 27.0036 446.988C27.1364 446.987 27.2681 447.012 27.391 447.062C27.5139 447.112 27.6255 447.187 27.7194 447.281C27.8133 447.375 27.8875 447.486 27.9378 447.609C27.9881 447.732 28.0134 447.864 28.0123 447.996C28.0111 448.129 27.9835 448.26 27.9311 448.382C27.8787 448.504 27.8025 448.615 27.707 448.707L23.707 452.707C23.5195 452.894 23.2652 453 23 453C22.7348 453 22.4805 452.894 22.293 452.707L20.293 450.707C20.1975 450.615 20.1213 450.504 20.0689 450.382C20.0165 450.26 19.9889 450.129 19.9878 449.996C19.9866 449.864 20.0119 449.732 20.0622 449.609C20.1125 449.486 20.1867 449.375 20.2806 449.281C20.3745 449.187 20.4862 449.112 20.609 449.062C20.7319 449.012 20.8636 448.987 20.9964 448.988C21.1292 448.989 21.2604 449.017 21.3824 449.069Z",
        fill: "#0C66E4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 447,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 476,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 479,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 508,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 511,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 18,
        y: 540,
        width: 12,
        height: 12,
        rx: 6,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 38,
        y: 543,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_138_18776",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_138_18776",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_138_18776",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABQACBAYHAwj/xAAtEAABAwMDAwIEBwAAAAAAAAABAgMEAAURBhIhMUFRBxNhgaHBFDJCcZGx8P/EABcBAAMBAAAAAAAAAAAAAAAAAAQGBwX/xAAtEQABBAECAwQLAAAAAAAAAAABAAIDEQQhMQYSEyJBsfEFFBUyQlFxkcHh8P/aAAwDAQACEQMRAD8AKUqVBNX3ZdotBdYwJDqvbbJ/SepPyFOz3BjS4qIY8D8iVsUe5NIrIlx42PxL7LOenuLCf7pzD7UhG5h1t1PlCgofSsQeccfdU68tTjijkqWck/OnRJL8N9L0V1bLieikHFAev6+7om48JdjSXtfTTxW40qr+kL+LzFUh8JTMZA3gcBQ7KH3FWCj2PD28zUpZONJiymGUUQlUaLbGr9rTT1tcYVIQ28qVITtylLQSRlXwKsCpNV+53u66Q1HGv9rSlxlbQjSW1pylSQrdg+M9j5obP5jA4M3Wtw2I/aMZkNAX962W1r9NtHOOlxWnYG4nJASQP4BxQnWPpdpybpyei1WSNHuKWVKjLjjYr3AMpHXBBPHPmrrYrtDvtoi3K2uh2LIRvQodR5B8EHgjyK63SfFtVukTp7yWYkdBcccV0AH3+FJokkDtzashjjIuhS8h6RiT7Xq2PHmxZEV1aFpU282UHGD2PxFabQCHqSXrbV8y8TghDcVr2IrSRj20KUTz5Vgcmj9OGAHdEF3epDxS9js8tZ8IA/PgUqiXWKJttkxi4Gw6goKyM7Qe+KlEgAk9BzQSVJW+s5JCM8Jot5FUVhwNdzhzTVarTfQ6xOWTTcrE1UiNIkFxoEABOBhXGe5H0ot6sWM37RUuKZKmENqQ+ojHIQckc/7ismtF6uNnWpVuluMbvzJHKVfuDxXW8ahut4QEXCY462DkN8JTnzgcUvu9GPOR1ARV3/eaoUfFEYwui4OMlVem/wA/1SGaa081Z3nHo0115DqdqkqQAD4PHerBQGO+theUHjuOxo4hQWhKk9CMit6INaOVqQs2SWaTqymye/yX/9k="
    })));
};

});

parcelRegister("1SAix", function(module, exports) {

$parcel$export(module.exports, "FloatingActions", function () { return $15e6fd9ca52b5b3c$export$babdd492df2e202d; });
/* floating-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $15e6fd9ca52b5b3c$var$styles = {
    wrapper: "_kqsw1n9t _94n512x7 _1xi212x7"
};
var $15e6fd9ca52b5b3c$export$babdd492df2e202d = function FloatingActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $15e6fd9ca52b5b3c$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($15e6fd9ca52b5b3c$var$Image, null));
};
var $15e6fd9ca52b5b3c$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 63,
        height: 339,
        viewBox: "0 0 63 339",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#filter0_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M8 80C8 66.7452 18.7452 56 32 56C45.2548 56 56 66.7452 56 80V253C56 266.255 45.2548 277 32 277C18.7452 277 8 266.255 8 253V80Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 75.125C24 73.6753 25.1753 72.5 26.625 72.5H37.375C38.8247 72.5 40 73.6753 40 75.125V83.375C40 84.8247 38.8247 86 37.375 86H28.4492L25.1221 87.9012C24.89 88.0338 24.6048 88.0329 24.3736 87.8987C24.1423 87.7645 24 87.5174 24 87.25V75.125ZM26.625 74C26.0037 74 25.5 74.5037 25.5 75.125V85.9576L28.0508 84.5H37.375C37.9963 84.5 38.5 83.9963 38.5 83.375V75.125C38.5 74.5037 37.9963 74 37.375 74H26.625ZM36.0002 78.4998H28.0002V76.9998H36.0002V78.4998ZM33.0002 81.4998H28.0002V79.9998H33.0002V81.4998Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 41,
        cy: 72,
        r: 5,
        fill: "#85B8FF",
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M39 115.5L25 115.5L25 114L39 114L39 115.5ZM39 120.75L25 120.75L25 119.25L39 119.25L39 120.75ZM32 126L25 126L25 124.5L32 124.5L32 126Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 20,
        y: 146,
        width: 24,
        height: 1,
        fill: "#0B1228",
        fillOpacity: 0.14
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26 168.5C25.7239 168.5 25.5 168.724 25.5 169V177C25.5 177.276 25.7239 177.5 26 177.5H34C34.2761 177.5 34.5 177.276 34.5 177V169C34.5 168.724 34.2761 168.5 34 168.5H26ZM24 169C24 167.895 24.8954 167 26 167H34C35.1046 167 36 167.895 36 169V169.786L38.191 168.691C39.0221 168.275 40 168.88 40 169.809V176.191C40 177.12 39.0221 177.725 38.191 177.309L36 176.214V177C36 178.105 35.1046 179 34 179H26C24.8954 179 24 178.105 24 177V169ZM36 174.536L38.5 175.786V170.214L36 171.464V174.536Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.3774 205.102C34.6716 205.273 34.8136 205.621 34.723 205.949L32.9849 212.25H37.25C37.5534 212.25 37.8268 212.433 37.9429 212.713C38.059 212.993 37.9949 213.316 37.7804 213.53L30.5304 220.78C30.2896 221.021 29.9169 221.069 29.6226 220.898C29.3284 220.727 29.1865 220.379 29.277 220.051L31.0151 213.75H26.75C26.4467 213.75 26.1732 213.567 26.0571 213.287C25.941 213.007 26.0052 212.684 26.2197 212.47L33.4697 205.22C33.7104 204.979 34.0832 204.931 34.3774 205.102ZM31.4289 212.25L32.5216 208.289L28.5607 212.25H31.4289ZM32.5711 213.75L31.4785 217.711L35.4394 213.75H32.5711Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 248C25 246.895 25.8954 246 27 246H29C30.1046 246 31 246.895 31 248V250C31 251.105 30.1046 252 29 252H27C25.8954 252 25 251.105 25 250V248ZM27 247.5C26.7239 247.5 26.5 247.724 26.5 248V250C26.5 250.276 26.7239 250.5 27 250.5H29C29.2761 250.5 29.5 250.276 29.5 250V248C29.5 247.724 29.2761 247.5 29 247.5H27ZM33 248C33 246.895 33.8954 246 35 246H37C38.1046 246 39 246.895 39 248V250C39 251.105 38.1046 252 37 252H35C33.8954 252 33 251.105 33 250V248ZM35 247.5C34.7239 247.5 34.5 247.724 34.5 248V250C34.5 250.276 34.7239 250.5 35 250.5H37C37.2761 250.5 37.5 250.276 37.5 250V248C37.5 247.724 37.2761 247.5 37 247.5H35ZM25 256C25 254.895 25.8954 254 27 254H29C30.1046 254 31 254.895 31 256V258C31 259.105 30.1046 260 29 260H27C25.8954 260 25 259.105 25 258V256ZM27 255.5C26.7239 255.5 26.5 255.724 26.5 256V258C26.5 258.276 26.7239 258.5 27 258.5H29C29.2761 258.5 29.5 258.276 29.5 258V256C29.5 255.724 29.2761 255.5 29 255.5H27ZM35.25 256.25V254H36.75V256.25H39V257.75H36.75V260H35.25V257.75H33V256.25H35.25Z",
        fill: "#091E42",
        fillOpacity: 0.31
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#filter1_dd_211_9818)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 8,
        y: 285,
        width: 48,
        height: 48,
        rx: 24,
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31.25 305V302H32.75V305H31.25ZM29.4697 307.53L25.4697 303.53L26.5303 302.47L30.5303 306.47L29.4697 307.53ZM33.4697 306.47L37.4697 302.47L38.5303 303.53L34.5303 307.53L33.4697 306.47ZM25 308.25H28V309.75H25V308.25ZM36 308.25H39V309.75H36V308.25ZM25.4697 314.47L29.4697 310.47L30.5303 311.53L26.5303 315.53L25.4697 314.47ZM37.4697 315.53L33.4697 311.53L34.5303 310.47L38.5303 314.47L37.4697 315.53ZM31.25 316V313H32.75V316H31.25Z",
        fill: "#8590A2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "filter0_dd_211_9818",
        x: 7,
        y: 55,
        width: 50,
        height: 224,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "filter1_dd_211_9818",
        x: 7,
        y: 284,
        width: 50,
        height: 51,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: 0.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_211_9818",
        result: "effect2_dropShadow_211_9818"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_211_9818",
        result: "shape"
    }))));
};

});

parcelRegister("1aJZo", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $0daa661be2109611$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $1ZDja = parcelRequire("1ZDja");

var $5GyOg = parcelRequire("5GyOg");
var $0daa661be2109611$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $0daa661be2109611$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $5GyOg.useMatchMedia)((0, $1ZDja.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $0daa661be2109611$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($0daa661be2109611$var$Image, null)) : null;
};
var $0daa661be2109611$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 308,
        height: 705,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 177.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 181,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 189.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m7.94 236.5-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 24,
        y: 232.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 263.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 279.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 279a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 279Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 279a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 279A1.667 1.667 0 1 1 24 279a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 279a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 279a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "a",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 301h308v404H0V301Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.06,
        d: "M0 302h308v-2H0v2Z",
        mask: "url(#a)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 306.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 361.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 365,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 373.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 404.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 408.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 416.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 421.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 420.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 420.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 270,
        height: 32,
        x: 13,
        y: 450,
        fill: "#fff",
        stroke: "#091E42",
        strokeOpacity: 0.06,
        strokeWidth: 1.5,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M34 465a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.891a6 6 0 1 1 1.414-1.414l2.816 2.816a1 1 0 1 1-1.414 1.414l-2.816-2.816ZM27.94 511.5l-3.97-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.97-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 507.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m22.03 552.47 3.97 3.969 3.97-3.969 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5 1.06-1.06Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 550.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 279,
        height: 43,
        x: 17,
        y: 576,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 37,
        cy: 597.5,
        r: 2,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 61,
        y: 593.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#1868DB",
        d: "M17 589h2.66v15.96H17z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 36,
        cy: 640.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 636.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 36,
        cy: 683.5,
        r: 2,
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 60,
        y: 679.5,
        fill: "#DCDFE4",
        rx: 3.99
    }));
};

});




parcelRegister("d8SB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8f0388b6efb22f$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $b2Jk5 = parcelRequire("b2Jk5");

var $l41uZ = parcelRequire("l41uZ");

var $5UWRo = parcelRequire("5UWRo");
const $4b8f0388b6efb22f$var$logoWrapperStyles = {
    display: 'flex',
    gap: '8px'
};
const $4b8f0388b6efb22f$var$CommunityCobranding = {
    background: (0, $b2Jk5.DefaultBackground),
    logo: {
        renderLogo: ()=>/*#__PURE__*/ (0, $6rcps.jsxs)("span", {
                style: $4b8f0388b6efb22f$var$logoWrapperStyles,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $5UWRo.AtlassianLogo), {
                        appearance: "brand",
                        size: "medium"
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)("span", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $l41uZ.CommunityLogo), {})
                    })
                ]
            })
    },
    footerProducts: 'Community, Jira, Confluence'
};
var $4b8f0388b6efb22f$export$2e2bcd8739ae039 = $4b8f0388b6efb22f$var$CommunityCobranding;

});
parcelRegister("l41uZ", function(module, exports) {

$parcel$export(module.exports, "CommunityLogo", function () { return $ad7cc8737b3b475d$export$311e5e9ca09eea69; });
/* CommunityLogo.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");
const $ad7cc8737b3b475d$export$311e5e9ca09eea69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "127",
        height: "24",
        viewBox: "0 0 127 24",
        fill: "none",
        className: (0, $c4hjl.default)([
            "_1bsb1osq _4t3i1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M119.728 17.303H118.315L113.75 5.33594H116.07L120.106 16.2801L124.141 5.33594H126.462L121.695 17.7121C120.282 21.3687 119.475 23.2609 116.272 23.2609C115.188 23.2609 114.582 23.1586 113.952 22.9029V21.0107C114.683 21.2408 115.516 21.3176 116.146 21.3176C117.912 21.3176 118.693 20.0902 119.728 17.303Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M109.789 14.1534C109.789 15.2785 110.444 16.0457 111.781 16.0457C112.286 16.0457 112.765 15.9434 113.143 15.8667V17.989C112.765 18.0913 112.336 18.1936 111.68 18.1936C108.981 18.1936 107.67 16.5826 107.67 14.2046V7.37722H105.627V5.33158H107.67V2.62109H109.789V5.33158H113.143V7.37722H109.789V14.1534Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M100.939 1.96002C100.939 0.988335 101.57 0.425781 102.453 0.425781C103.336 0.425781 103.966 0.988335 103.966 1.96002C103.966 2.9317 103.336 3.49425 102.453 3.49425C101.57 3.49425 100.939 2.9317 100.939 1.96002ZM101.343 18.1206V5.33533H103.512V18.1206H101.343Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M98.3189 10.6269V18.1191H96.1498V10.3968C96.1498 8.09545 95.2419 7.07263 93.1737 7.07263C91.1559 7.07263 89.7687 8.42787 89.7687 11.0105V18.1191H87.5996V5.33383H89.7687V7.43062C90.5758 5.92195 92.0639 5.07812 93.7538 5.07812C96.6543 5.07812 98.3189 7.0982 98.3189 10.6269Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M73.6016 12.8281V5.33594H75.7707V13.0583C75.7707 15.3596 76.6786 16.3824 78.7468 16.3824C80.7646 16.3824 82.1518 15.0272 82.1518 12.4446V5.33594H84.3209V18.1212H82.1518V16.0244C81.3447 17.5331 79.8566 18.3769 78.1667 18.3769C75.2662 18.3769 73.6016 16.3569 73.6016 12.8281Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M62.2838 11.0105V18.1191H60.1147V10.3968C60.1147 8.09545 59.2067 7.07263 57.1385 7.07263C55.1207 7.07263 53.7335 8.42787 53.7335 11.0105V18.1191H51.5645V5.33383H53.7335V7.43062C54.5406 5.92195 56.0287 5.07812 57.7186 5.07812C59.8625 5.07812 61.3253 6.17766 61.9559 8.19774C62.6621 6.2288 64.352 5.07812 66.4454 5.07812C69.2703 5.07812 70.834 7.02149 70.834 10.6269V18.1191H68.6649V11.0105C68.6649 8.37673 67.7569 7.07263 65.6887 7.07263C63.671 7.07263 62.2838 8.42787 62.2838 11.0105Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M39.9928 11.0105V18.1191H37.8237V10.3968C37.8237 8.09545 36.9157 7.07263 34.8475 7.07263C32.8297 7.07263 31.4425 8.42787 31.4425 11.0105V18.1191H29.2734V5.33383H31.4425V7.43062C32.2496 5.92195 33.7377 5.07812 35.4276 5.07812C37.5715 5.07812 39.0343 6.17766 39.6649 8.19774C40.3711 6.2288 42.061 5.07812 44.1544 5.07812C46.9792 5.07812 48.543 7.02149 48.543 10.6269V18.1191H46.3739V11.0105C46.3739 8.37673 45.4659 7.07263 43.3977 7.07263C41.38 7.07263 39.9928 8.42787 39.9928 11.0105Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M20.7997 18.3748C17.0164 18.3748 14.7969 15.5365 14.7969 11.7009C14.7969 7.86532 17.0164 5.07812 20.7997 5.07812C24.5578 5.07812 26.7521 7.86532 26.7521 11.7009C26.7521 15.5365 24.5578 18.3748 20.7997 18.3748ZM20.7997 7.12377C18.1009 7.12377 16.9155 9.2717 16.9155 11.7009C16.9155 14.1301 18.1009 16.3292 20.7997 16.3292C23.4732 16.3292 24.6334 14.1301 24.6334 11.7009C24.6334 9.2717 23.4732 7.12377 20.7997 7.12377Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M13.2066 15.1558V17.3804C12.1725 18.0708 10.5331 18.3777 8.81798 18.3777C3.37004 18.3777 0.292969 15.0535 0.292969 9.76041C0.292969 4.64629 3.37004 1.06641 8.76754 1.06641C10.3817 1.06641 11.9959 1.37325 13.1814 2.24265V4.46729C11.9959 3.70018 10.6844 3.29105 8.76754 3.29105C4.88336 3.29105 2.56294 5.89925 2.56294 9.76041C2.56294 13.6216 4.95903 16.1786 8.89365 16.1786C10.634 16.1786 11.9959 15.7695 13.2066 15.1558Z",
        fill: "#101214"
    }));
const $ad7cc8737b3b475d$var$svgStyles = null;

});


parcelRegister("2erun", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $106fc7647dc66f9d$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $3cer2 = parcelRequire("3cer2");
const $106fc7647dc66f9d$var$JiraCobranding = {
    background: (0, $3cer2.JiraBackground),
    logo: {
        component: (0, $l8yrb.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $106fc7647dc66f9d$export$2e2bcd8739ae039 = $106fc7647dc66f9d$var$JiraCobranding;

});
parcelRegister("3cer2", function(module, exports) {

$parcel$export(module.exports, "JiraBackground", function () { return $253db0961c95205f$export$2ccb200c5de09b24; });

var $8ZuGG = parcelRequire("8ZuGG");

var $6KhR5 = parcelRequire("6KhR5");

var $gaYY3 = parcelRequire("gaYY3");

var $67Oxm = parcelRequire("67Oxm");

var $5GyOg = parcelRequire("5GyOg");
var $253db0961c95205f$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    var isDarkMode = (0, $6KhR5.default)().colorMode === 'dark';
    var Background = isDarkMode ? (0, $gaYY3.JiraDarkTheme) : (0, $67Oxm.JiraLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("gaYY3", function(module, exports) {

$parcel$export(module.exports, "JiraDarkTheme", function () { return $bc6cdf6c5b8be6cb$export$24eb0206407d5744; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $7CwwF = parcelRequire("7CwwF");

var $gvCV1 = parcelRequire("gvCV1");

var $gZXgw = parcelRequire("gZXgw");

var $11HzU = parcelRequire("11HzU");

var $aSMbY = parcelRequire("aSMbY");

var $cQH9R = parcelRequire("cQH9R");

var $9f7mD = parcelRequire("9f7mD");

var $4bJiS = parcelRequire("4bJiS");
var $bc6cdf6c5b8be6cb$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $bc6cdf6c5b8be6cb$export$24eb0206407d5744 = function JiraDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gvCV1.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gZXgw.TopNav), {
        product: (0, $7CwwF.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4bJiS.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDzos.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $bc6cdf6c5b8be6cb$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aSMbY.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $11HzU.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $bc6cdf6c5b8be6cb$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cQH9R.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9f7mD.DetailsPanel), null)))));
};

});
parcelRegister("11HzU", function(module, exports) {

$parcel$export(module.exports, "Actions", function () { return $0bf7b024d283b117$export$b52183d5cfb26dc9; });

var $8ZuGG = parcelRequire("8ZuGG");

var $ieuIB = parcelRequire("ieuIB");

var $3JF9s = parcelRequire("3JF9s");

var $17Vdo = parcelRequire("17Vdo");

var $ifoiy = parcelRequire("ifoiy");

var $8uVY2 = parcelRequire("8uVY2");

var $fkdQ8 = parcelRequire("fkdQ8");
var $0bf7b024d283b117$export$b52183d5cfb26dc9 = function Actions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3JF9s))), {
        label: "Lock Unlocked",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ieuIB))), {
        label: "Eye Open",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8uVY2))), {
        label: "Thumbs Up",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($17Vdo))), {
        label: "Share",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ifoiy))), {
        label: "Show More Horizontal",
        color: "var(--ds-icon-subtle, #626F86)"
    }));
};

});
parcelRegister("ieuIB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4381d46d56f0396feef6421a091c8f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4615cd9a75737af$var$_react = $d4615cd9a75737af$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $d4615cd9a75737af$var$_baseNew = $d4615cd9a75737af$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $d4615cd9a75737af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4615cd9a75737af$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $d4615cd9a75737af$var$_react.default.createElement($d4615cd9a75737af$var$_baseNew.default, Object.assign({
        name: "EyeOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$d4615cd9a75737af$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $d4615cd9a75737af$var$_default = module.exports.default = $d4615cd9a75737af$var$EyeOpenIcon;

});

parcelRegister("3JF9s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5c5d989acf678b87189f6f5a97917ee9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2b857ee7c2c06e41$var$_react = $2b857ee7c2c06e41$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $2b857ee7c2c06e41$var$_baseNew = $2b857ee7c2c06e41$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $2b857ee7c2c06e41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2b857ee7c2c06e41$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $2b857ee7c2c06e41$var$_react.default.createElement($2b857ee7c2c06e41$var$_baseNew.default, Object.assign({
        name: "LockUnlockedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$2b857ee7c2c06e41$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $2b857ee7c2c06e41$var$_default = module.exports.default = $2b857ee7c2c06e41$var$LockUnlockedIcon;

});

parcelRegister("17Vdo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0eee459540e5ec28215a3b80df0172>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d22d3956472f97a$var$_react = $0d22d3956472f97a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $0d22d3956472f97a$var$_baseNew = $0d22d3956472f97a$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $0d22d3956472f97a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0d22d3956472f97a$var$ShareIcon = (props)=>/*#__PURE__*/ $0d22d3956472f97a$var$_react.default.createElement($0d22d3956472f97a$var$_baseNew.default, Object.assign({
        name: "ShareIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$0d22d3956472f97a$var$ShareIcon.displayName = 'ShareIcon';
var $0d22d3956472f97a$var$_default = module.exports.default = $0d22d3956472f97a$var$ShareIcon;

});

parcelRegister("ifoiy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2a789640350a4d3b29556a43626f35de>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d48c79cffc9ef83e$var$_react = $d48c79cffc9ef83e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $d48c79cffc9ef83e$var$_baseNew = $d48c79cffc9ef83e$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $d48c79cffc9ef83e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ShowMoreHorizontal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for more action menus.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d48c79cffc9ef83e$var$ShowMoreHorizontalIcon = (props)=>/*#__PURE__*/ $d48c79cffc9ef83e$var$_react.default.createElement($d48c79cffc9ef83e$var$_baseNew.default, Object.assign({
        name: "ShowMoreHorizontalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0" clip-rule="evenodd"/>`
    }, props));
$d48c79cffc9ef83e$var$ShowMoreHorizontalIcon.displayName = 'ShowMoreHorizontalIcon';
var $d48c79cffc9ef83e$var$_default = module.exports.default = $d48c79cffc9ef83e$var$ShowMoreHorizontalIcon;

});

parcelRegister("8uVY2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0bf82c15bca1a56d27012abd5cecbc7a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $62fe172c7b82a31a$var$_react = $62fe172c7b82a31a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $62fe172c7b82a31a$var$_baseNew = $62fe172c7b82a31a$var$_interopRequireDefault((parcelRequire("jJ7Gf")));
function $62fe172c7b82a31a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $62fe172c7b82a31a$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $62fe172c7b82a31a$var$_react.default.createElement($62fe172c7b82a31a$var$_baseNew.default, Object.assign({
        name: "ThumbsUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$62fe172c7b82a31a$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $62fe172c7b82a31a$var$_default = module.exports.default = $62fe172c7b82a31a$var$ThumbsUpIcon;

});


parcelRegister("aSMbY", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $7ec45479d5720311$export$2dc68d50d56fbbd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $7ec45479d5720311$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($7ec45479d5720311$var$Image, null));
};
var $7ec45479d5720311$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#738496",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("cQH9R", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $95abd1a87c5092d0$export$7c6e2c02157bb7d2; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $95abd1a87c5092d0$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($95abd1a87c5092d0$var$Image, null));
};
var $95abd1a87c5092d0$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_7702)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern1_233_7702",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image1_233_7702",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image1_233_7702",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("9f7mD", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $6bab3a22955ae122$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $6bab3a22955ae122$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $6bab3a22955ae122$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $6bab3a22955ae122$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6bab3a22955ae122$var$Image, null));
};
var $6bab3a22955ae122$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#09326C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#0055CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "#1D2125"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#A1BDD9",
        strokeOpacity: 0.08
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#BFDBF8",
        fillOpacity: 0.28
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "#282E33",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_7667)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_233_7667",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_233_7667",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_233_7667",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("4bJiS", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $30cb54d4a70a06fe$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $1ZDja = parcelRequire("1ZDja");

var $5GyOg = parcelRequire("5GyOg");
var $30cb54d4a70a06fe$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $30cb54d4a70a06fe$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $5GyOg.useMatchMedia)((0, $1ZDja.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $30cb54d4a70a06fe$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($30cb54d4a70a06fe$var$Image, null)) : null;
};
var $30cb54d4a70a06fe$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#596773",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#1C2B41",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#05C",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#38414A",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#454F59",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.333 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#BFDBF8",
        fillOpacity: 0.28,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#454F59",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});


parcelRegister("67Oxm", function(module, exports) {

$parcel$export(module.exports, "JiraLightTheme", function () { return $475a991fad819cab$export$8e2414c6a082747f; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $fkdQ8 = parcelRequire("fkdQ8");
var $aDzos = parcelRequire("aDzos");

var $7CwwF = parcelRequire("7CwwF");

var $gvCV1 = parcelRequire("gvCV1");

var $gZXgw = parcelRequire("gZXgw");

var $11HzU = parcelRequire("11HzU");

var $4W3kb = parcelRequire("4W3kb");

var $9is28 = parcelRequire("9is28");

var $aIddl = parcelRequire("aIddl");

var $2X2I0 = parcelRequire("2X2I0");
var $475a991fad819cab$var$styles = {
    actions: "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q",
    content: "_19bvxy5q"
};
var $475a991fad819cab$export$8e2414c6a082747f = function JiraLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gvCV1.Background), {
        testId: "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gZXgw.TopNav), {
        product: (0, $7CwwF.Products).JIRA
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        alignBlock: "stretch",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2X2I0.SideNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDzos.default), {
        grow: "fill",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $475a991fad819cab$var$styles.actions,
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4W3kb.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $11HzU.Actions), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fkdQ8.default), {
        xcss: $475a991fad819cab$var$styles.content,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9is28.Content), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aIddl.DetailsPanel), null)))));
};

});
parcelRegister("4W3kb", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", function () { return $397f2862baeaebaf$export$2dc68d50d56fbbd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $397f2862baeaebaf$export$2dc68d50d56fbbd = function Breadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($397f2862baeaebaf$var$Image, null));
};
var $397f2862baeaebaf$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 167,
        height: 20,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 100,
        height: 6,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 54,
        height: 6,
        x: 113,
        y: 7,
        fill: "#DCDFE4",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#8590A2",
        d: "m108.701 4.664-3.014 12.81h-1.395l3.015-12.81h1.394Z"
    }));
};

});

parcelRegister("9is28", function(module, exports) {

$parcel$export(module.exports, "Content", function () { return $6c4b8a5bb0c42643$export$7c6e2c02157bb7d2; });

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $6c4b8a5bb0c42643$export$7c6e2c02157bb7d2 = function Content() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6c4b8a5bb0c42643$var$Image, null));
};
var $6c4b8a5bb0c42643$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 640,
        height: 427,
        viewBox: "0 0 640 427",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 640,
        height: 20,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 40,
        width: 60,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 8,
        y: 53,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 68,
        y: 40,
        width: 99,
        height: 32,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 76,
        y: 53,
        width: 59,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(138 44)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M146.292 54.2929C146.105 54.4818 146 54.7368 146 55.0024C146 55.2681 146.105 55.523 146.292 55.7119L149.231 58.6769C149.449 58.8919 149.731 58.9989 150.01 58.9989C150.289 58.9989 150.566 58.8919 150.779 58.6769L153.709 55.7219C153.895 55.5329 154 55.278 154 55.0124C154 54.7469 153.895 54.492 153.709 54.3029C153.617 54.2098 153.507 54.1358 153.387 54.0853C153.266 54.0347 153.136 54.0087 153.006 54.0087C152.875 54.0087 152.745 54.0347 152.625 54.0853C152.504 54.1358 152.394 54.2098 152.303 54.3029L150.005 56.6199L147.698 54.2929C147.606 54.2001 147.496 54.1264 147.375 54.0762C147.255 54.0259 147.125 54 146.995 54C146.864 54 146.734 54.0259 146.614 54.0762C146.493 54.1264 146.384 54.2001 146.292 54.2929Z",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 92,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 120,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 148,
        width: 640,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 200,
        width: 180,
        height: 12,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 4,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 60,
        y: 232,
        width: 85,
        height: 20,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 64,
        y: 239,
        width: 77,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 153,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 157,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 213,
        y: 232,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 217,
        y: 239,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#091E42",
        fillOpacity: 0.13
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 14,
        y: 282,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 27,
        cy: 295,
        r: 12,
        fill: "url(#pattern0_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 46,
        y: 279,
        width: 591,
        height: 40,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 54,
        y: 295,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 385,
        width: 425.66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 403,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44.2764,
        y: 421,
        width: 267.673,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 44,
        y: 356,
        width: 119,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 10,
        y: 346,
        width: 26,
        height: 26,
        rx: 13,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 23,
        cy: 359,
        r: 12,
        fill: "url(#pattern1_233_6340)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern1_233_6340",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image1_233_6340",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgMBAQEAAAAAAAAAAAAAAwYCBAUACAf/xAAuEAACAQMCBAQGAgMAAAAAAAABAgMABAUGERITITEHQVFhFCJCcYGRMuFiobH/xAAXAQEBAQEAAAAAAAAAAAAAAAAGBwUE/8QAKREAAQMDAgQGAwAAAAAAAAAAAgEDEQAEEgVBBiExURMUInGB8JGx0f/aAAwDAQACEQMRAD8ASqjI6xozuwVFG5J7AVKlzWN0UghtkO3MPE32HYfv/lWK9uUtWCeXb91PrZlX3EbTeoXmqArlbOEMo+uQ7b/ioW2qX4wLq3Xg9Yz1H4NYWNsbrJ5C3sbCB57u4cRxRIN2ZjVrUuEvdOZy7xOUi5d3bPwsPJh5Mp81I6g0IXW7xTnP4hIpMmmW+EY/NO9tcRXUCywOHjbsRRaT9IXTR3z2xPySqSB/kP6pwplp155xhHYhei+9HLy38u6obbV1A0Tp4as8UbS0vbZp8VDKi3Q3IUJwkhSR1HEw26Uesu3z2R0dqqHK4925EskUk0X0y8tgeE/72+5rN4lBwrP0bL/a7NFIBufX2r1tpvR2ndNMz4LD2dlKw2aSNN3I9OI7nb80bUGl8HqJUGcxNnfFBsjTRAso9A3cfurGn8zY6gw1rlMVMJrO5QOjDuPVT6EHoR6irl1cQ2ltLcXUqQwRKXkkc7Kigbkk+QqVqpZSvWqCgjjy6V5R8btI22kddY+4wdktriZ0iAWMnhWXdgy9Tv1A3/dUfOh651bca913PNA8gwlvMHt4yNhwoOEOfdup28t6JVN4VbcG2JT3WgmvGBPogdq6g3VrFewmCZONW8vPf296MASQB1Jp1xOKhso1dlDXBHVj9J9BW/cuAAQaTO1ZDQkpSKxFNfgBgMlp7Tt/zpX+FurkSwROOoAXZiR7nb9VreNmFympdES2ljMUCTJNNGvTmRrvuO/XqQdj6VgYrMX2LLfBTlFbqyEBlP4NFyueyOUj5d3PvF35aKFU/fbvU+c0NwrzxhjCZjn07fVpeGsNpa+EqLlETy/P1K+N2eOjxkZt442Rgfn4v5E+9WKe8jjoL+MiRQJNvlcdx/VIsiFHZG6MpIP3p/aOAQYAkRtRF4SyyJZmv//Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image1_233_6340",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAQUBAQAAAAAAAAAAAAAABAADBQYHAQL/xAApEAABAwMDAwQCAwAAAAAAAAABAgMEAAUREiFBBlFxBzFCYROBkdHh/8QAFwEBAQEBAAAAAAAAAAAAAAAABgcEBf/EACkRAAEDAwIFAwUAAAAAAAAAAAECAxEABCEFEgYxUXGRIjLRQaHB4fD/2gAMAwEAAhEDEQA/AH6VKirXCXcJzUds4KjursOTTRa0tpK1GAKizTS3lpbbEqJgdzQoBJwASfquqSUnCgQfsVp9ut0a3tBEZoA8rIypXk07LiMTGi3JaS4k9xuPB4o2eJUb4DZ29Zz4/dO08BulqVPAL6RjzP4rKqVSV/thtc4tglTSxqbUe3Y/YqNpGy6l5AcQZBoPc2zlq6pl0QpJg0qs3QjeZ8hzAwlvT/J/yqzRMCfJt7inIa0pWRjChkHyKz6gwt+3W03zNbdFumrO+bfe9qT9O3zWp0qpULrV+54j2qzuv3FIy60t1KUIA98H3O/1XuR1m9anvxdQ2h6GtadTQacS7qHY+2Kn5tHQdsZ6SJ8VbhdNEbgcdcx5ojr1GY8RzHspSc+QP6qm0dc7vKuykrkANoGShofAHgnk/dA070q3Xb2qW3OfzmozxFeNXuoOPM8sDvAie2KVMyX0x2itW/AA5p6oqfAdWsuNrLmfio7jxW9ZIGK47SUqV6jFWprpJi8QIlwizFRZimxqWydSc/ogg42O9e4/RsS3OG4Xq5KfLe4U5skHjJJJOO1A+mocavT6XVuNthknQThKjkDcc131LbccvEb8LjjqFM50A5SggkbDjNFF2dyq5LZUdpzMfaqa1rVo3p6XEoG9MJiegif7zUew8h9GtB2zinaioEB1Cw44st4+KTufNStK0EkZqZupSFek1//Z"
    })));
};

});

parcelRegister("aIddl", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $7cc84388dfc9ed6d$export$e54a7f2505304e20; });
/* details-panel.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $7cc84388dfc9ed6d$var$styles = {
    wrapper: "_kqsw1n9t _1xi2ze3t _19bvutpp _u5f3xy5q"
};
var $7cc84388dfc9ed6d$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $7cc84388dfc9ed6d$var$styles.wrapper,
        backgroundColor: "elevation.surface"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($7cc84388dfc9ed6d$var$Image, null));
};
var $7cc84388dfc9ed6d$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: 328,
        height: 597,
        viewBox: "0 0 328 597",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 80,
        height: 32,
        rx: 3,
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 17,
        y: 13,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#85B8FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 52C0 47.5817 3.58172 44 8 44H320C324.418 44 328 47.5817 328 52V597H0V52Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0.5 52C0.5 47.8579 3.85786 44.5 8 44.5H320C324.142 44.5 327.5 47.8579 327.5 52V596.5H0.5V52Z",
        stroke: "#091E42",
        strokeOpacity: 0.06
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 77,
        width: 253,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(280 68)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M288.292 78.2929C288.105 78.4818 288 78.7368 288 79.0024C288 79.2681 288.105 79.523 288.292 79.7119L291.231 82.6769C291.449 82.8919 291.731 82.9989 292.01 82.9989C292.289 82.9989 292.566 82.8919 292.779 82.6769L295.709 79.7219C295.895 79.5329 296 79.278 296 79.0124C296 78.7469 295.895 78.492 295.709 78.3029C295.617 78.2098 295.507 78.1358 295.387 78.0853C295.266 78.0347 295.136 78.0087 295.006 78.0087C294.875 78.0087 294.745 78.0347 294.625 78.0853C294.504 78.1358 294.394 78.2098 294.303 78.3029L292.005 80.6199L289.698 78.2929C289.606 78.2001 289.496 78.1264 289.375 78.0762C289.255 78.0259 289.125 78 288.995 78C288.864 78 288.734 78.0259 288.614 78.0762C288.493 78.1264 288.384 78.2001 288.292 78.2929Z",
        fill: "#091E42",
        fillOpacity: 0.31
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 121,
        width: 79,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 159,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 197,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 235,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 273,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 311,
        width: 110,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 349,
        width: 100,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 387,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 425,
        width: 114,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 24,
        y: 463,
        width: 95,
        height: 6,
        rx: 3,
        fill: "#8590A2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        transform: "translate(178 112)",
        fill: "white",
        fillOpacity: 0.01
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 131.853L190.625 131.781L195.625 127.781C196.056 127.436 196.126 126.807 195.781 126.375C195.462 125.977 194.902 125.887 194.478 126.147L194.375 126.219L190 129.72L185.625 126.219C185.227 125.901 184.66 125.936 184.304 126.282L184.219 126.375C183.901 126.773 183.936 127.34 184.282 127.696L184.375 127.781L189.375 131.781C189.707 132.046 190.166 132.071 190.522 131.853Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 126.853L190.625 126.781L195.625 122.781C196.056 122.436 196.126 121.807 195.781 121.375C195.462 120.977 194.902 120.887 194.478 121.147L194.375 121.219L190 124.72L185.625 121.219C185.227 120.901 184.66 120.936 184.304 121.282L184.219 121.375C183.901 121.773 183.936 122.34 184.282 122.696L184.375 122.781L189.375 126.781C189.707 127.046 190.166 127.071 190.522 126.853Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M190.522 121.853L190.625 121.781L195.625 117.781C196.056 117.436 196.126 116.807 195.781 116.375C195.462 115.977 194.902 115.887 194.478 116.147L194.375 116.219L190 119.72L185.625 116.219C185.227 115.901 184.66 115.936 184.304 116.282L184.219 116.375C183.901 116.773 183.936 117.34 184.282 117.696L184.375 117.781L189.375 121.781C189.707 122.046 190.166 122.071 190.522 121.853Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 210,
        y: 121,
        width: 66,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 159,
        width: 98,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 188,
        width: 52,
        height: 20,
        rx: 3,
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 182,
        y: 195,
        width: 44,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: 0.8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 177,
        y: 230,
        width: 18,
        height: 18,
        rx: 9,
        stroke: "white",
        strokeWidth: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: 186,
        cy: 239,
        r: 8,
        fill: "url(#pattern0_233_6342)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 202,
        y: 236,
        width: 71,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 273,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 311,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 349,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 387,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 425,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: 178,
        y: 463,
        width: 126,
        height: 6,
        rx: 3,
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("pattern", {
        id: "pattern0_233_6342",
        patternContentUnits: "objectBoundingBox",
        width: 1,
        height: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("use", {
        xlinkHref: "#image0_233_6342",
        transform: "scale(0.0025)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("image", {
        id: "image0_233_6342",
        width: 400,
        height: 400,
        preserveAspectRatio: "none",
        xlinkHref: "data:image/jpeg;base64,/9j/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAwADADASIAAhEBAxEB/8QAGwAAAgIDAQAAAAAAAAAAAAAAAAcDBgQFCAH/xAAsEAABAwMCBQMDBQAAAAAAAAABAgMEAAURBiESEzFBUQeBkSJhcRQVMjOh/8QAFwEBAQEBAAAAAAAAAAAAAAAABwYEBf/EACkRAAEEAQIFBAIDAAAAAAAAAAECAwQRAAVREyExYYEGEnGhB0GisfD/2gAMAwEAAhEDEQA/AKVRRWXa4S7hObjt7FR3PgdzTLIkNxmlPvGkpBJOwHXDtllb7iWmxalGgO5zFSCo4SCT4FCkKQcKSUn7jFOpnRMqzx0CLDS4CASto8Sj+e9TtaQm3VBblREIaPeQMfA60YufktYlcJuEoo3ujW9VX8vOXSPRCSxxFyUhW1cvi7v68YjaK3GqLOqz3JbIyWiTw57YOCPatPSTAnM6hHRKjm0KFj/bg8j3yJlxXIbymHhSk9cKYXo9ZjOvBlvI4oqFBk468WOLf7fT/tL2rHorVc3S9wDkdQVFcUnntKGeJIO+PBxnesevQXJ8ByM11VXX9gEEjyBWatIlIiS0POdBf9EA+M6foqKLIalRmpEdYcZdQFoUOikkZBqU0QkEGjiMCCLGJj1ss/JImR0HlBaVOE9ApeRt7ppSVd/U3WMjUF1fhsOj9qju4aSkf2EbcZPffOPtVIpV9M6e5p0BLLnKyVVt7jdfeH+uzETJZcRsBe9csK9QlS1hKElSj0AGSakiR1ypTTDQytxQSKY9stsa3NBMdAC8fU4f5K9660mUlgVVk5zmWC78YxPTX9XC0Xa2ZjauMIKglWykpKiQPgitzfHJEu0TY8RPA86wtCFZ34ikgVW7Xq3ltJbuDKnCnbmN4yfyKnnawZ5ZEGMsuHop3AA9h1otf0+Y5KU57OZUT25m8v2Z0REcI93QV36VnO8iO9GcLchpbTg2KVpII+ajpqXdhF35huA5q1nJX3B8jxSzuEVUKa9HXuW1Yz5HY/FKESXxxShSsgZDHCNg2M//2Q=="
    })));
};

});

parcelRegister("2X2I0", function(module, exports) {

$parcel$export(module.exports, "SideNav", function () { return $2263315ddd787a90$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $1ZDja = parcelRequire("1ZDja");

var $5GyOg = parcelRequire("5GyOg");
var $2263315ddd787a90$var$styles = {
    background: "_1s7z7r9e _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};
var $2263315ddd787a90$export$1a35787d6353cf6a = function SideNav() {
    var isAboveMediumScreen = (0, $5GyOg.useMatchMedia)((0, $1ZDja.media).above.md);
    return isAboveMediumScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        xcss: $2263315ddd787a90$var$styles.background
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($2263315ddd787a90$var$Image, null)) : null;
};
var $2263315ddd787a90$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 296,
        height: 473,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 5.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 9,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 17.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 48.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 52.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 60.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 64.5-3.969-3.97 1.06-1.06 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 91.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 95.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 103.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 107.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 134.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 138.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 146.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M265.25 151.25v4.25h1.5v-4.25H271v-1.5h-4.25v-4.25h-1.5v4.25H261v1.5h4.25ZM285.25 150.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M285.5 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM290.25 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM295 150.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 72,
        height: 9,
        x: 20,
        y: 189,
        fill: "#B3B9C4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 278,
        height: 43,
        x: 18,
        y: 215,
        fill: "#E9F2FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 220.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 224,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#1868DB",
        d: "M18 229h2.66v15.96H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 232.5,
        fill: "#85B8FF",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M259.25 237.25v4.25h1.5v-4.25H265v-1.5h-4.25v-4.25h-1.5v4.25H255v1.5h4.25ZM279.25 236.75a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm6 .25a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.25-.25a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M279.5 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM284.25 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0ZM289 236.5a.25.25 0 1 1-.5 0 .25.25 0 0 1 .5 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 263.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 267,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 275.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M22 306.5h32v32H22z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 26,
        y: 310,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 66,
        y: 318.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M20 349.5h32v32H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M39 360.5H25V359h14v1.5Zm0 5.25H25v-1.5h14v1.5ZM32 371h-7v-1.5h7v1.5Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 64,
        y: 361.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 392.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 24,
        height: 24,
        x: 4,
        y: 396.96,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 112,
        height: 8,
        x: 44,
        y: 404.5,
        fill: "#DCDFE4",
        rx: 3.99
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "m283.939 408.5-3.969-3.97 1.06-1.06 4.5 4.5a.749.749 0 0 1 0 1.06l-4.5 4.5-1.06-1.06 3.969-3.97Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M0 435.5h32v32H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        fillRule: "evenodd",
        d: "M9.667 451.333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM8 451a1.667 1.667 0 1 1 3.335 0A1.667 1.667 0 0 1 8 451Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM14.333 451a1.667 1.667 0 1 1 3.335 0 1.667 1.667 0 0 1-3.335 0Zm8 .333a.333.333 0 1 0 0-.666.333.333 0 0 0 0 .666ZM20.667 451A1.667 1.667 0 1 1 24 451a1.667 1.667 0 0 1-3.334 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.31,
        d: "M10 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM16.333 451a.333.333 0 1 1-.666 0 .333.333 0 0 1 .666 0ZM22.667 451a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 60,
        height: 8,
        x: 44,
        y: 447.5,
        fill: "#DCDFE4",
        rx: 3.99
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h296v473H0z"
    }))));
};

});




parcelRegister("7lF7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a8b0e9f29199c84$export$2e2bcd8739ae039; });

var $dyyb1 = parcelRequire("dyyb1");

var $ebKJK = parcelRequire("ebKJK");

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");
const $6a8b0e9f29199c84$export$29decb186c8152a6 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($dyyb1))), (0, (/*@__PURE__*/$parcel$interopDefault($ebKJK))));
const $6a8b0e9f29199c84$var$OpsgenieCobranding = {
    background: $6a8b0e9f29199c84$export$29decb186c8152a6,
    logo: {
        component: (0, $l8yrb.OpsgenieLogo)
    },
    footerProducts: 'Opsgenie, Jira, Confluence'
};
var $6a8b0e9f29199c84$export$2e2bcd8739ae039 = $6a8b0e9f29199c84$var$OpsgenieCobranding;

});
parcelRegister("dyyb1", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "opsgenie-left.49c0f64b.svg";

});

parcelRegister("ebKJK", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "opsgenie-right.77c52ee2.svg";

});


parcelRegister("gAd27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f614cb07a327d8e$export$2e2bcd8739ae039; });

var $2NBqT = parcelRequire("2NBqT");

var $2YZQ2 = parcelRequire("2YZQ2");

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");
const $2f614cb07a327d8e$export$f35613b2e8bb1b7f = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($2NBqT))), (0, (/*@__PURE__*/$parcel$interopDefault($2YZQ2))));
const $2f614cb07a327d8e$var$StatuspageCobranding = {
    background: $2f614cb07a327d8e$export$f35613b2e8bb1b7f,
    logo: {
        component: (0, $l8yrb.StatuspageLogo)
    },
    footerProducts: 'Statuspage, Jira, Confluence'
};
var $2f614cb07a327d8e$export$2e2bcd8739ae039 = $2f614cb07a327d8e$var$StatuspageCobranding;

});
parcelRegister("2NBqT", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "statuspage-left.6c5cd6d4.svg";

});

parcelRegister("2YZQ2", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "statuspage-right.447da08b.svg";

});


parcelRegister("ccCNm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42015addf7646723$export$2e2bcd8739ae039; });

var $7vwSj = parcelRequire("7vwSj");

var $3TR98 = parcelRequire("3TR98");

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");
const $42015addf7646723$export$7995c4de8f2b3003 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($7vwSj))), (0, (/*@__PURE__*/$parcel$interopDefault($3TR98))));
const $42015addf7646723$var$TrelloCobranding = {
    background: $42015addf7646723$export$7995c4de8f2b3003,
    logo: {
        component: (0, $l8yrb.TrelloLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $42015addf7646723$export$2e2bcd8739ae039 = $42015addf7646723$var$TrelloCobranding;

});
parcelRegister("7vwSj", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "trello-left.4f52d13c.svg";

});

parcelRegister("3TR98", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "trello-right.e6e102c7.svg";

});


parcelRegister("lw2Cv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673f1f94d690ee0f$export$2e2bcd8739ae039; });

var $5UWRo = parcelRequire("5UWRo");

var $dwjLE = parcelRequire("dwjLE");

var $b2Jk5 = parcelRequire("b2Jk5");
const $673f1f94d690ee0f$export$911a80ac761af24c = (0, $b2Jk5.backgroundWithImage)((0, (/*@__PURE__*/$parcel$interopDefault($dwjLE))));
const $673f1f94d690ee0f$var$WacCobranding = {
    background: $673f1f94d690ee0f$export$911a80ac761af24c,
    logo: {
        component: (0, $5UWRo.AtlassianLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $673f1f94d690ee0f$export$2e2bcd8739ae039 = $673f1f94d690ee0f$var$WacCobranding;

});
parcelRegister("dwjLE", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "wac.92a80da2.svg";

});


parcelRegister("3b3Yv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bf80ab84606e9e9$export$2e2bcd8739ae039; });

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");
const $5bf80ab84606e9e9$export$14ae77d7d7e2d26f = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $5bf80ab84606e9e9$var$AtlasCobranding = {
    background: $5bf80ab84606e9e9$export$14ae77d7d7e2d26f,
    logo: {
        component: (0, $l8yrb.HomeLogo)
    },
    footerProducts: 'Trello, Jira, Confluence'
};
var $5bf80ab84606e9e9$export$2e2bcd8739ae039 = $5bf80ab84606e9e9$var$AtlasCobranding;

});

parcelRegister("4YCdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d7c853b442e7ea8$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");

var $9Vz68 = parcelRequire("9Vz68");
let $0d7c853b442e7ea8$var$_ = (t)=>t, $0d7c853b442e7ea8$var$t;
const $0d7c853b442e7ea8$export$4fcb21def34701d = (0, $9Vz68.default)((0, $b2Jk5.DefaultBackground))($0d7c853b442e7ea8$var$t || ($0d7c853b442e7ea8$var$t = $0d7c853b442e7ea8$var$_`
  background-color: #fff;
`));
const $0d7c853b442e7ea8$var$LoomCobranding = {
    background: $0d7c853b442e7ea8$export$4fcb21def34701d,
    logo: {
        component: (0, $l8yrb.LoomLogo)
    },
    footerProducts: 'Loom, Confluence, Jira'
};
var $0d7c853b442e7ea8$export$2e2bcd8739ae039 = $0d7c853b442e7ea8$var$LoomCobranding;

});

parcelRegister("8liMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364c4443fd92ea03$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $b2Jk5 = parcelRequire("b2Jk5");

var $9Vz68 = parcelRequire("9Vz68");
let $364c4443fd92ea03$var$_ = (t)=>t, $364c4443fd92ea03$var$t;
const $364c4443fd92ea03$export$69d75365d6a52225 = (0, $9Vz68.default)((0, $b2Jk5.DefaultBackground))($364c4443fd92ea03$var$t || ($364c4443fd92ea03$var$t = $364c4443fd92ea03$var$_`
  background-color: #fff;
`));
const $364c4443fd92ea03$var$JiraAlignCobranding = {
    background: $364c4443fd92ea03$export$69d75365d6a52225,
    logo: {
        component: (0, $l8yrb.JiraAlignLogo)
    },
    footerProducts: 'Jira Align, Confluence, Jira'
};
var $364c4443fd92ea03$export$2e2bcd8739ae039 = $364c4443fd92ea03$var$JiraAlignCobranding;

});

parcelRegister("cXTHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cccda450bd33d7dd$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $3cer2 = parcelRequire("3cer2");
const $cccda450bd33d7dd$var$AdminExperimentForJira = {
    background: (0, $3cer2.JiraBackground),
    logo: {
        component: (0, $l8yrb.JiraLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $cccda450bd33d7dd$export$2e2bcd8739ae039 = $cccda450bd33d7dd$var$AdminExperimentForJira;

});

parcelRegister("f0poS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a651dd00052db553$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $36vhv = parcelRequire("36vhv");
const $a651dd00052db553$var$AdminExperimentForConfluence = {
    background: (0, $36vhv.ConfluenceBackground),
    logo: {
        component: (0, $l8yrb.ConfluenceLogo)
    },
    footerProducts: 'Jira, Confluence, Trello'
};
var $a651dd00052db553$export$2e2bcd8739ae039 = $a651dd00052db553$var$AdminExperimentForConfluence;

});

parcelRegister("528n8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a502637aab8061d$export$2e2bcd8739ae039; });

var $l8yrb = parcelRequire("l8yrb");

var $36vhv = parcelRequire("36vhv");
const $4a502637aab8061d$var$RovoCobranding = {
    background: (0, $36vhv.ConfluenceBackground),
    logo: {
        component: (0, $l8yrb.RovoLogo)
    },
    footerProducts: 'Confluence, Jira, Trello'
};
var $4a502637aab8061d$export$2e2bcd8739ae039 = $4a502637aab8061d$var$RovoCobranding;

});


parcelRegister("yrE6A", function(module, exports) {

$parcel$export(module.exports, "ProductHeading", function () { return $fc811189c809365b$export$bb672d3ab4980938; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
let $fc811189c809365b$var$_ = (t)=>t, $fc811189c809365b$var$t, $fc811189c809365b$var$t1;
const $fc811189c809365b$export$6fe455b424bdaa07 = (0, $9Vz68.default).div($fc811189c809365b$var$t || ($fc811189c809365b$var$t = $fc811189c809365b$var$_`
  display: flex;
  flex-direction: column;
  padding-top: ${0}px;
  align-items: center;

  h5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${0};
  }
`), (0, $5b7Z4.gridSize)() * 3, (0, $kTdw7).N800);
const $fc811189c809365b$var$ProductHeadingWrapper = (0, $9Vz68.default).div($fc811189c809365b$var$t1 || ($fc811189c809365b$var$t1 = $fc811189c809365b$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $fc811189c809365b$export$bb672d3ab4980938 = ({ suffix: suffix, children: children })=>{
    return /*#__PURE__*/ (0, $6rcps.jsxs)($fc811189c809365b$var$ProductHeadingWrapper, {
        "data-testid": "header",
        id: "ProductHeading",
        children: [
            children,
            /*#__PURE__*/ (0, $6rcps.jsx)($fc811189c809365b$export$6fe455b424bdaa07, {
                "data-testid": "header-suffix",
                id: "ProductHeadingSuffix",
                children: suffix
            })
        ]
    });
};

});

parcelRegister("cDJ3z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2cf7fd3e4b6981d$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $ihLLY = parcelRequire("ihLLY");

var $gGDrC = parcelRequire("gGDrC");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $5UWRo = parcelRequire("5UWRo");

var $b2Jk5 = parcelRequire("b2Jk5");

var $pO9YU = parcelRequire("pO9YU");

var $3ir1n = parcelRequire("3ir1n");
let $e2cf7fd3e4b6981d$var$_ = (t)=>t, $e2cf7fd3e4b6981d$var$t, $e2cf7fd3e4b6981d$var$t1, $e2cf7fd3e4b6981d$var$t2;
const $e2cf7fd3e4b6981d$var$PageFooter = (0, $9Vz68.default).div($e2cf7fd3e4b6981d$var$t1 || ($e2cf7fd3e4b6981d$var$t1 = $e2cf7fd3e4b6981d$var$_`
  background: transparent;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  flex-direction: column;
  margin: 0 auto;
  border-top: 1px solid ${0};
  padding-top: ${0}px;
  font-size: 11px;
  color: ${0};
  ${0}
  ${0}

  ${0}
`), (0, $kTdw7).N50, (0, $5b7Z4.gridSize)() * 3, (props)=>props.footerMessageTextColor, (props)=>(0, $b2Jk5.linkStyles)(props.textColor), (0, $b2Jk5.listStyles), (0, $ihLLY.media).handheld($e2cf7fd3e4b6981d$var$t || ($e2cf7fd3e4b6981d$var$t = $e2cf7fd3e4b6981d$var$_`
     line-height: inherit;
     background-color: transparent;
  `)));
const $e2cf7fd3e4b6981d$var$SubText = (0, $9Vz68.default).div($e2cf7fd3e4b6981d$var$t2 || ($e2cf7fd3e4b6981d$var$t2 = $e2cf7fd3e4b6981d$var$_`
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $e2cf7fd3e4b6981d$var$FooterComponent = ({ renderText: renderText, footerProducts: footerProducts, pageId: pageId })=>{
    const onLinkClicked = (0, $3ir1n.useButtonClickedEvent)(pageId, 'learnMoreAtlassianAccount');
    return /*#__PURE__*/ (0, $6rcps.jsxs)($e2cf7fd3e4b6981d$var$PageFooter, {
        "data-testid": "page-footer",
        textColor: (0, $kTdw7).B400,
        footerMessageTextColor: (0, $kTdw7).N800,
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5UWRo.AtlassianLogo), {
                appearance: "neutral",
                size: "small"
            }),
            renderText && /*#__PURE__*/ (0, $6rcps.jsx)($e2cf7fd3e4b6981d$var$SubText, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "footer.cobranding.text",
                    defaultMessage: "One account for {products} and {link}.",
                    description: "{products} is a comma-separated list of products. {link} is a hyperlink that will be filled with a separately translated string: more",
                    values: {
                        products: footerProducts,
                        link: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.LearnMoreAboutAtlassianAccountLink), {
                            onClick: onLinkClicked
                        })
                    }
                })
            })
        ]
    });
};
var $e2cf7fd3e4b6981d$export$2e2bcd8739ae039 = $e2cf7fd3e4b6981d$var$FooterComponent;

});
parcelRegister("pO9YU", function(module, exports) {

$parcel$export(module.exports, "SELF_SERVICE_LINK_URL", function () { return $c708b5cc270ed46d$export$86be5cde852cdd25; });
$parcel$export(module.exports, "SelfServiceLink", function () { return $c708b5cc270ed46d$export$a817dad308d44854; });
$parcel$export(module.exports, "SupportLink", function () { return $c708b5cc270ed46d$export$a6b83d54334dba9f; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL_MOBILE", function () { return $c708b5cc270ed46d$export$e6483b6b5710900e; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL", function () { return $c708b5cc270ed46d$export$30786e8ac20c09d8; });
$parcel$export(module.exports, "PrivacyPolicyLink", function () { return $c708b5cc270ed46d$export$fdd773f48aebb8ab; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL_MOBILE", function () { return $c708b5cc270ed46d$export$4f1e847a8e64f5b; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL", function () { return $c708b5cc270ed46d$export$b6aa5b30b55e4e21; });
$parcel$export(module.exports, "UserNoticeLink", function () { return $c708b5cc270ed46d$export$afb6ca8138b3e5a3; });
$parcel$export(module.exports, "LearnMoreAboutAtlassianAccountLink", function () { return $c708b5cc270ed46d$export$694937257991c79; });
$parcel$export(module.exports, "RequestAccessLink", function () { return $c708b5cc270ed46d$export$5ce617bd6fde7ab8; });
$parcel$export(module.exports, "PASSWORD_LEAKED_LINK", function () { return $c708b5cc270ed46d$export$4b69c758417d5b1b; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9OvaU = parcelRequire("9OvaU");

var $5mHsu = parcelRequire("5mHsu");

var $lk8Tl = parcelRequire("lk8Tl");
const $c708b5cc270ed46d$export$86be5cde852cdd25 = 'https://support.atlassian.com/atlassian-account/docs/troubleshoot-login-issues-with-your-atlassian-account/';
function $c708b5cc270ed46d$export$a817dad308d44854(props) {
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        href: $c708b5cc270ed46d$export$86be5cde852cdd25,
        id: "self-service-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "resetpassword.self.service",
            defaultMessage: "Login help"
        })
    });
}
const $c708b5cc270ed46d$export$56321425bd50535f = 'https://support.atlassian.com/';
function $c708b5cc270ed46d$export$a6b83d54334dba9f(props) {
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        href: $c708b5cc270ed46d$export$56321425bd50535f,
        id: "support-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "resetpassword.support",
            defaultMessage: "Contact Support"
        })
    });
}
const $c708b5cc270ed46d$export$e6483b6b5710900e = 'https://www.atlassian.com/legal/privacy-policy/mobile';
const $c708b5cc270ed46d$export$30786e8ac20c09d8 = 'https://www.atlassian.com/legal/privacy-policy';
function $c708b5cc270ed46d$export$fdd773f48aebb8ab(props) {
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const privacyPolicyUrl = props.isMobileLink ? $c708b5cc270ed46d$export$e6483b6b5710900e : $c708b5cc270ed46d$export$30786e8ac20c09d8;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        href: privacyPolicyUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.privacy.policy.link.aria.label',
            defaultMessage: 'Atlassian Privacy Policy',
            description: "Aria label for link to let users learn more about Atlassian's Privacy Policy."
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.privacy.policy",
            defaultMessage: "Privacy Policy"
        })
    });
}
const $c708b5cc270ed46d$export$4f1e847a8e64f5b = 'https://www.atlassian.com/legal/customer-agreement/mobile';
const $c708b5cc270ed46d$export$b6aa5b30b55e4e21 = 'https://www.atlassian.com/legal/cloud-terms-of-service';
const $c708b5cc270ed46d$export$5e45d5d0eb34696e = 'https://www.atlassian.com/legal/user-notice/mobile';
const $c708b5cc270ed46d$export$b6eec8592d48b4f1 = 'https://www.atlassian.com/legal/user-notice';
function $c708b5cc270ed46d$export$afb6ca8138b3e5a3(props) {
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const userNoticeUrl = props.isMobileLink ? $c708b5cc270ed46d$export$5e45d5d0eb34696e : $c708b5cc270ed46d$export$b6eec8592d48b4f1;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        href: userNoticeUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        "aria-label": formatMessage({
            id: 'common.atlassian.user.notice.link.aria.label',
            defaultMessage: 'Atlassian User Notice',
            description: "Aria label for link to let users learn more about Atlassian's User Notice."
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.user.notice",
            defaultMessage: "User Notice",
            description: "Link that takes users to the Atlassian User Notice"
        })
    });
}
function $c708b5cc270ed46d$export$694937257991c79(props) {
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: props.onClick,
        "aria-label": formatMessage({
            id: 'cobranding.footer.learn.more.about.atlassian.account.link.aria.label',
            defaultMessage: 'Learn more about Atlassian Account',
            description: 'Aria label for short link to let users learn more about what an Atlassian Account is.'
        }),
        href: "https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "cobranding.footer.learn.more.about.atlassian.account.link",
            defaultMessage: "more",
            description: "Short link to let users learn more about using one account for multiple products. e.g. One account for {products} and more."
        })
    });
}
function $c708b5cc270ed46d$export$5ce617bd6fde7ab8(props) {
    const { destUrl: destUrl, applicationDestination: applicationDestination } = props;
    const continueUrl = encodeURIComponent(`https://${applicationDestination.destinationHostname}/login?application=${applicationDestination.applicationName.toLowerCase()}` + '&permission-violation=true' + '&preferred-redirect=request-access' + (destUrl ? `&dest-url=${encodeURIComponent(destUrl)}` : ''));
    const redirectUrl = `${(0, $lk8Tl.idacOrigin)}/login?continue=${continueUrl}`;
    const buttonText = /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "select.account.request.access.to.product",
        defaultMessage: "Request access to {productName}",
        values: {
            productName: applicationDestination.applicationName
        }
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
        id: "redirect-to-request-access",
        href: redirectUrl,
        onClick: props.onClick,
        children: buttonText
    });
}
const $c708b5cc270ed46d$export$4b69c758417d5b1b = 'https://support.atlassian.com/atlassian-account/docs/protect-your-atlassian-account/';

});
parcelRegister("5mHsu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e80b7c156262fd2$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $25i4M = parcelRequire("25i4M");

var $i2LcI = parcelRequire("i2LcI");

var $c5jvf = parcelRequire("c5jvf");
var $72wHg = parcelRequire("72wHg");
var $3e80b7c156262fd2$var$_excluded = [
    "children",
    "testId",
    "appearance",
    "newWindowLabel",
    "target",
    "className",
    "style"
];
var $3e80b7c156262fd2$var$styles = {
    visitedLink: "_ect41gqc _1053w7te _1ienw7te _n0fxw7te _1vhvg3x0",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz14q2 _ect41gqc _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj14q2 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l314q2 _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h16c2",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _ect41gqc _syaz1gjq _1a3b1r31 _4fprglyw _5goinqa1 _f8pj1gjq _9oik1r31 _1bnx8stv _jf4cnqa1 _30l31gjq _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8h1fxt",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _ect41gqc _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
var $3e80b7c156262fd2$var$iconStyles = null;
var $3e80b7c156262fd2$var$LinkWithoutRef = function LinkWithoutRef(_ref, ref) {
    var children = _ref.children, testId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, newWindowLabel = _ref.newWindowLabel, target = _ref.target, preventedClassName = _ref.className, preventedStyle = _ref.style, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $3e80b7c156262fd2$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $c5jvf.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, htmlAttributes, {
        target: target,
        ref: ref,
        xcss: (0, $25i4M.cx)(appearance === 'default' && $3e80b7c156262fd2$var$styles.defaultAppearance, appearance === 'subtle' && $3e80b7c156262fd2$var$styles.subtleAppearance, appearance === 'inverse' && $3e80b7c156262fd2$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $3e80b7c156262fd2$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }), children, target === '_blank' && /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        as: "span",
        xcss: $3e80b7c156262fd2$var$styles.iconWrapper,
        testId: testId && "".concat(testId, "__icon")
    }, "\uFEFF", (0, $i2LcI.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $8ZuGG.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $c4hjl.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    })) : /*#__PURE__*/ $8ZuGG.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        className: (0, $c4hjl.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("path", {
        d: "M17.5715 3.95926L10.7587 10.772C10.5546 10.9692 10.2811 11.0784 9.99723 11.0759C9.71338 11.0734 9.44185 10.9596 9.24113 10.7589C9.04041 10.5581 8.92655 10.2866 8.92409 10.0027C8.92162 9.7189 9.03074 9.44543 9.22794 9.24125L16.0407 2.4285H14.3237C14.0366 2.4285 13.7613 2.31444 13.5582 2.11142C13.3552 1.90839 13.2411 1.63303 13.2411 1.34591C13.2411 1.05879 13.3552 0.783424 13.5582 0.580399C13.7613 0.377373 14.0366 0.263314 14.3237 0.263314H18.4981C18.5509 0.254962 18.6043 0.250507 18.658 0.250041C18.8017 0.248792 18.9443 0.276183 19.0773 0.330617C19.2104 0.385051 19.3313 0.465437 19.4329 0.567084C19.5346 0.668732 19.6149 0.789606 19.6694 0.922652C19.7238 1.0557 19.7512 1.19825 19.75 1.342C19.7495 1.3956 19.7451 1.44896 19.7367 1.50165V5.67628C19.7367 5.9634 19.6227 6.23877 19.4196 6.44179C19.2166 6.64482 18.9412 6.75888 18.6541 6.75888C18.367 6.75888 18.0916 6.64482 17.8886 6.44179C17.6856 6.23877 17.5715 5.9634 17.5715 5.67628V3.95926Z"
    }), /*#__PURE__*/ $8ZuGG.createElement("path", {
        d: "M2.41519 17.5848V2.4285H8.91076V0.263314H2.41194C1.22001 0.263314 0.25 1.23007 0.25 2.42201V17.5913C0.250574 18.1638 0.47834 18.7127 0.883283 19.1175C1.28823 19.5222 1.83724 19.7497 2.40978 19.75H17.5769C17.8608 19.7499 18.1418 19.6938 18.404 19.585C18.6662 19.4762 18.9044 19.3168 19.105 19.116C19.3055 18.9151 19.4646 18.6767 19.573 18.4143C19.6814 18.152 19.737 17.8708 19.7367 17.587V11.0893H17.5715V17.5848H2.41519Z"
    }))));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ var $3e80b7c156262fd2$var$Link = /*#__PURE__*/ (0, $8ZuGG.forwardRef)($3e80b7c156262fd2$var$LinkWithoutRef);
var $3e80b7c156262fd2$export$2e2bcd8739ae039 = $3e80b7c156262fd2$var$Link;

});
parcelRegister("c5jvf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cc514899ad78455$export$2e2bcd8739ae039; });
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $cd8Dz = parcelRequire("cd8Dz");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $4vuwT = parcelRequire("4vuwT");

var $1RZ27 = parcelRequire("1RZ27");

var $1Muvn = parcelRequire("1Muvn");

var $5yYIk = parcelRequire("5yYIk");

var $5AVd4 = parcelRequire("5AVd4");

var $iNlvH = parcelRequire("iNlvH");

var $2fda0 = parcelRequire("2fda0");

var $i2LcI = parcelRequire("i2LcI");

var $73a5X = parcelRequire("73a5X");

var $dBxAn = parcelRequire("dBxAn");
var $8cc514899ad78455$var$_excluded = [
    "href",
    "children",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "aria-label",
    "aria-labelledby",
    "style",
    "target",
    "testId",
    "xcss",
    "newWindowLabel"
], $8cc514899ad78455$var$_excluded2 = [
    "className"
];
var $8cc514899ad78455$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
var $8cc514899ad78455$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $8cc514899ad78455$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8cc514899ad78455$var$AnchorNoRef = function AnchorNoRef(_ref, ref) {
    var href = _ref.href, children = _ref.children, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5AVd4.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], style = _ref.style, target = _ref.target, testId = _ref.testId, xcss = _ref.xcss, _ref$newWindowLabel = _ref.newWindowLabel, newWindowLabel = _ref$newWindowLabel === void 0 ? '(opens new window)' : _ref$newWindowLabel, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $8cc514899ad78455$var$_excluded);
    var interactionContext = (0, $8ZuGG.useContext)((0, $2fda0.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var opensNewWindowLabelId = (0, $iNlvH.useId)();
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "0.0.0-development",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $8cc514899ad78455$var$_excluded2);
    var RouterLink = (0, $5yYIk.default)();
    var isExternal = typeof href === 'string' && $8cc514899ad78455$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $8cc514899ad78455$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ var isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    var hrefObjectUsedWithoutRouterLink = RouterLink === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(href) === 'object';
    (0, $1RZ27.default)(!hrefObjectUsedWithoutRouterLink, "@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider");
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $8ZuGG.createElement((0, $dBxAn.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        as: Component,
        className: xcss,
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? "".concat(ariaLabel, " , ").concat(newWindowLabel) : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? "".concat(ariaLabelledBy, " ").concat(opensNewWindowLabelId) : ariaLabelledBy,
        xcss: (0, $4vuwT.cx)($8cc514899ad78455$var$styles.root, (0, $i2LcI.fg)('platform_design-system-team_anchor-positioning') ? $8cc514899ad78455$var$styles.position : undefined, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ $8ZuGG.createElement((0, $73a5X.default), {
        id: opensNewWindowLabelId
    }, ", ".concat(newWindowLabel)));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ var $8cc514899ad78455$var$Anchor = /*#__PURE__*/ (0, $8ZuGG.forwardRef)($8cc514899ad78455$var$AnchorNoRef);
var $8cc514899ad78455$export$2e2bcd8739ae039 = $8cc514899ad78455$var$Anchor;

});
parcelRegister("1RZ27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ca159f505517df$export$2e2bcd8739ae039; });
var $15ca159f505517df$var$isProduction = true;
var $15ca159f505517df$var$prefix = 'Invariant failed';
function $15ca159f505517df$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($15ca159f505517df$var$isProduction) throw new Error($15ca159f505517df$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($15ca159f505517df$var$prefix, ": ").concat(provided) : $15ca159f505517df$var$prefix;
    throw new Error(value);
}

});

parcelRegister("5yYIk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40cf3940d9d31856$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9P7k6 = parcelRequire("9P7k6");
/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ var $40cf3940d9d31856$var$useRouterLink = function useRouterLink() {
    var _useContext = (0, $8ZuGG.useContext)((0, $9P7k6.RouterLinkProviderContext)), routerLinkComponent = _useContext.routerLinkComponent;
    if (routerLinkComponent) return routerLinkComponent;
};
var $40cf3940d9d31856$export$2e2bcd8739ae039 = $40cf3940d9d31856$var$useRouterLink;

});
parcelRegister("9P7k6", function(module, exports) {

$parcel$export(module.exports, "RouterLinkProviderContext", function () { return $726e8ebdc3bb61e9$export$2931e0ee690eee88; });
$parcel$export(module.exports, "default", function () { return $726e8ebdc3bb61e9$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $726e8ebdc3bb61e9$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $8ZuGG.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ var $726e8ebdc3bb61e9$var$RouterLinkProvider = function RouterLinkProvider(_ref) {
    var routerLinkComponent = _ref.routerLinkComponent, children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($726e8ebdc3bb61e9$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var $726e8ebdc3bb61e9$export$2e2bcd8739ae039 = $726e8ebdc3bb61e9$var$RouterLinkProvider;

});






parcelRegister("knXCB", function(module, exports) {

$parcel$export(module.exports, "FullScreenSpinnerWrapper", function () { return $4270cc3e92962851$export$439279e039f7af42; });
$parcel$export(module.exports, "LoadingSpinner", function () { return $4270cc3e92962851$export$b08b517936747730; });

var $6rcps = parcelRequire("6rcps");

var $cufV0 = parcelRequire("cufV0");

var $5b7Z4 = parcelRequire("5b7Z4");

var $9Vz68 = parcelRequire("9Vz68");
parcelRequire("8ZuGG");
let $4270cc3e92962851$var$_ = (t)=>t, $4270cc3e92962851$var$t, $4270cc3e92962851$var$t1;
const $4270cc3e92962851$export$439279e039f7af42 = (0, $9Vz68.default).div($4270cc3e92962851$var$t || ($4270cc3e92962851$var$t = $4270cc3e92962851$var$_`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`));
const $4270cc3e92962851$var$SpinnerContainer = (0, $9Vz68.default).div($4270cc3e92962851$var$t1 || ($4270cc3e92962851$var$t1 = $4270cc3e92962851$var$_`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${0}px;
`), (0, $5b7Z4.gridSize)() * 3);
const $4270cc3e92962851$export$b08b517936747730 = ({ testId: testId })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)($4270cc3e92962851$var$SpinnerContainer, {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
            testId: testId,
            size: "large"
        })
    });
};

});



parcelRegister("3rMgh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ReverifyEmailSentPage", function () { return $4844d85f0b3bacf7$export$357c630eb6814495; });
$parcel$export(module.exports, "default", function () { return $4844d85f0b3bacf7$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $hX7Rq = parcelRequire("hX7Rq");

var $9OvaU = parcelRequire("9OvaU");

var $xe7jL = parcelRequire("xe7jL");

var $GlVY9 = parcelRequire("GlVY9");

var $7CMue = parcelRequire("7CMue");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $5VQjR = parcelRequire("5VQjR");
const $4844d85f0b3bacf7$var$pageId = 'reverifyEmailSentScreen';
const $4844d85f0b3bacf7$export$357c630eb6814495 = ()=>{
    const email = (0, $kOqgB.useAppSelector)((state)=>state.user.email);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const location = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    (0, $3ir1n.usePageViewedEvent)($4844d85f0b3bacf7$var$pageId);
    const addSuccessFlag = ()=>{
        const flag = {
            type: 'success',
            title: (0, $GlVY9.default).reverifyEmailFlagSuccessTitle,
            description: (0, $GlVY9.default).reverifyEmailFlagSuccessDesc
        };
        dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description));
    };
    const addErrorFlag = ()=>{
        const flag = {
            type: 'error',
            title: (0, $GlVY9.default).reverifyEmailFlagErrorTitle,
            description: (0, $GlVY9.default).reverifyEmailFlagErrorDesc
        };
        dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description));
    };
    const handleResendVerificationEmail = ()=>{
        analyticsClient.buttonClickedEvent($4844d85f0b3bacf7$var$pageId, 'resendReverificationEmail');
        return fetch(`/rest/resend-email${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (response.status === 204) addSuccessFlag();
            else addErrorFlag();
        }).catch(()=>{
            addErrorFlag();
        });
    };
    const header = ()=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "reverify.email.title",
                defaultMessage: "Check your inbox to verify your email"
            })
        });
    const whiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "verify.email.resend.reverification.link",
                defaultMessage: "Resend verification link"
            })
        });
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        // @ts-ignore no id
        id: "reverify-email-sent-page",
        pageId: $4844d85f0b3bacf7$var$pageId,
        header: header(),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $GlVY9.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "reverify.email.sent.verification.link",
                    tagName: "p",
                    defaultMessage: "We sent a verification link to:",
                    description: "Telling user that a verification link has been sent. This message is followed by the user's email address on the next line."
                })
            })
        ]
    });
};
var $4844d85f0b3bacf7$export$2e2bcd8739ae039 = $4844d85f0b3bacf7$export$357c630eb6814495;

});
parcelRegister("GlVY9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6dc80f9c0ee3168$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $d6dc80f9c0ee3168$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    // Flags
    reverifyEmailFlagSuccessTitle: {
        id: 'reverify.email.sent.flag.success.title',
        defaultMessage: "We've sent you an email!"
    },
    reverifyEmailFlagSuccessDesc: {
        id: 'reverify.email.sent.flag.success.description',
        defaultMessage: 'The verification email is on its way!'
    },
    reverifyEmailFlagErrorTitle: {
        id: 'reverify.email.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    reverifyEmailFlagErrorDesc: {
        id: 'reverify.email.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    headTitle: {
        id: 'reverify.email.sent.head.title',
        defaultMessage: 'Verify your email'
    }
});

});


parcelRegister("4sO9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "resetExpiredPasswordLoader", function () { return $38796a5f4575d769$export$92394b370142461a; });
$parcel$export(module.exports, "ExpiredPasswordPage", function () { return $38796a5f4575d769$export$f8dc9833cdc832ea; });
$parcel$export(module.exports, "default", function () { return $38796a5f4575d769$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $jSnDV = parcelRequire("jSnDV");

var $lCS4q = parcelRequire("lCS4q");

var $eMSRC = parcelRequire("eMSRC");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $5bkyn = parcelRequire("5bkyn");

var $xe7jL = parcelRequire("xe7jL");

var $7CMue = parcelRequire("7CMue");

var $3ir1n = parcelRequire("3ir1n");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");

var $8xW40 = parcelRequire("8xW40");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
const $38796a5f4575d769$var$pageId = 'expiredpassword';
async function $38796a5f4575d769$export$92394b370142461a({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/resetexpiredpassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--reset-password'
        ]
    });
}
const $38796a5f4575d769$export$f8dc9833cdc832ea = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const location = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const email = (0, $kOqgB.useAppSelector)((state)=>state.user.email);
    const { error: error, isLoading: isLoading, isComplete: isComplete } = (0, $kOqgB.useAppSelector)((state)=>state.expiredPassword);
    const dispatchResetPassword = (0, $8ZuGG.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
        dispatch((0, $5bkyn.requestResetExpiredPassword)(token || ''));
    }, [
        dispatch,
        location.search
    ]);
    const previousIsComplete = (0, $7AZRg.usePrevious)(isComplete);
    (0, $3ir1n.usePageViewedEvent)($38796a5f4575d769$var$pageId, {
        redirectReason: 'adminForcedReset'
    });
    (0, $8ZuGG.useEffect)(()=>{
        if (!previousIsComplete && isComplete) switch(error){
            case null:
                dispatch((0, $xe7jL.addFlag)('success', (0, $eMSRC.default).emailSentFlagSuccessTitle, (0, $eMSRC.default).emailSentFlagSuccessDesc));
                break;
            case 'invalid_token':
                navigate(`/login?email=${encodeURIComponent(email)}`);
                dispatch((0, $xe7jL.addFlag)('error', (0, $eMSRC.default).emailSentFlagFailedTitle, (0, $eMSRC.default).emailSentFlagFailedDesc));
                break;
            case 'too_many_requests':
                dispatch((0, $xe7jL.addFlag)('error', (0, $eMSRC.default).emailSentFlagFailedTitle, (0, $eMSRC.default).emailSentFlagTooManyEmailsDesc));
                break;
            default:
                dispatch((0, $xe7jL.addFlag)('error', (0, $eMSRC.default).emailSentFlagFailedTitle, (0, $eMSRC.default).emailSentFlagFailedDesc));
                break;
        }
    }, [
        dispatch,
        email,
        error,
        isComplete,
        previousIsComplete,
        navigate
    ]);
    (0, $8xW40.usePageStateLoader)();
    const headerMessage = formatMessage((0, $eMSRC.default).title);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        // @ts-ignore no id
        id: "expired-password-page",
        pageId: $38796a5f4575d769$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)("h5", {
            children: headerMessage
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $eMSRC.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $lCS4q.default), {
                header: formatMessage((0, $eMSRC.default).headTitle),
                message: formatMessage((0, $eMSRC.default).contentText),
                email: email
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "send-password-reset-email",
                    type: "submit",
                    isFullWidth: true,
                    isLoading: isLoading,
                    onClick: ()=>{
                        dispatchResetPassword();
                        analyticsClient.buttonClickedEvent($38796a5f4575d769$var$pageId, 'resetExpiredPasswordButton');
                    },
                    children: formatMessage((0, $eMSRC.default).sendResetEmailButton)
                })
            })
        ]
    });
};
var $38796a5f4575d769$export$2e2bcd8739ae039 = $38796a5f4575d769$export$f8dc9833cdc832ea;

});
parcelRegister("lCS4q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f64ecb92781810d$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");

var $eDndD = parcelRequire("eDndD");
let $8f64ecb92781810d$var$_ = (t)=>t, $8f64ecb92781810d$var$t, $8f64ecb92781810d$var$t1, $8f64ecb92781810d$var$t2, $8f64ecb92781810d$var$t3;
const $8f64ecb92781810d$var$imgHeight = 92;
const $8f64ecb92781810d$var$PasswordExpiredContainer = (0, $9Vz68.default).div($8f64ecb92781810d$var$t || ($8f64ecb92781810d$var$t = $8f64ecb92781810d$var$_`
  background: url(${0}) no-repeat center top;
  background-size: 50% 50%;
  padding-top: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($eDndD))), $8f64ecb92781810d$var$imgHeight + (0, $5b7Z4.gridSize)() * 8);
const $8f64ecb92781810d$var$Header = (0, $9Vz68.default).h5($8f64ecb92781810d$var$t1 || ($8f64ecb92781810d$var$t1 = $8f64ecb92781810d$var$_`
  font: ${0};
  color: ${0};
  text-align: left;
`), (0, $g5rao.default)('font.heading.small'), (0, $kTdw7).N300);
const $8f64ecb92781810d$var$Message = (0, $9Vz68.default).p($8f64ecb92781810d$var$t2 || ($8f64ecb92781810d$var$t2 = $8f64ecb92781810d$var$_`
  margin: ${0}px 0;
`), (0, $5b7Z4.gridSize)());
const $8f64ecb92781810d$var$Email = (0, $9Vz68.default).p($8f64ecb92781810d$var$t3 || ($8f64ecb92781810d$var$t3 = $8f64ecb92781810d$var$_`
  font: ${0};
  margin-top: ${0}px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $g5rao.default)('font.heading.small'), (0, $5b7Z4.gridSize)());
const $8f64ecb92781810d$var$PasswordExpiredNotice = (props)=>{
    const { header: header, children: children, email: email, message: message } = props;
    return /*#__PURE__*/ (0, $6rcps.jsxs)($8f64ecb92781810d$var$PasswordExpiredContainer, {
        id: "password-expired-notice",
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)($8f64ecb92781810d$var$Header, {
                id: "password-expired-header",
                children: header
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)($8f64ecb92781810d$var$Message, {
                id: "password-expired-message",
                children: message
            }),
            email && /*#__PURE__*/ (0, $6rcps.jsx)($8f64ecb92781810d$var$Email, {
                children: email
            }),
            children
        ]
    });
};
var $8f64ecb92781810d$export$2e2bcd8739ae039 = $8f64ecb92781810d$var$PasswordExpiredNotice;

});
parcelRegister("eDndD", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "trust-and-security.2e60671c.svg";

});


parcelRegister("eMSRC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a19b26081ce04c32$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $a19b26081ce04c32$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    title: {
        id: 'expired.password.title',
        defaultMessage: 'Reset your password'
    },
    headTitle: {
        id: 'expired.password.head.title',
        defaultMessage: 'Security request from your admin'
    },
    contentText: {
        id: 'expired.password.email.content',
        defaultMessage: 'Your admin wants you to set a new password before you log back in. We will send the password reset link to your email address:'
    },
    sendResetEmailButton: {
        id: 'expired.password.button.send',
        defaultMessage: 'Send password reset email'
    },
    emailSentFlagFailedTitle: {
        id: 'expired.password.email.flag.error.title',
        defaultMessage: 'Unable to send email'
    },
    emailSentFlagFailedDesc: {
        id: 'expired.password.email.flag.general.error.desc',
        defaultMessage: 'Something went wrong when we tried to send the password reset link. Try again.'
    },
    emailSentFlagTooManyEmailsDesc: {
        id: 'expired.password.email.flag.toomanyemails.error.desc',
        defaultMessage: "We've sent too many emails, please try again later."
    },
    emailSentFlagSuccessTitle: {
        id: 'expired.password.email.flag.success.title',
        defaultMessage: 'Email successfully sent'
    },
    emailSentFlagSuccessDesc: {
        id: 'expired.password.email.flag.success.desc',
        defaultMessage: 'Check your email for the password reset link.'
    }
});

});

parcelRegister("1SvOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93efe20d23b19eb8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "TallLinkButton", function () { return $93efe20d23b19eb8$export$549de15399e8aa5a; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $9Vz68 = parcelRequire("9Vz68");

var $8iNm9 = parcelRequire("8iNm9");

var $cKQGL = parcelRequire("cKQGL");
parcelRequire("8ZuGG");
let $93efe20d23b19eb8$var$_ = (t)=>t, $93efe20d23b19eb8$var$t, $93efe20d23b19eb8$var$t1;
const $93efe20d23b19eb8$var$StyledButton = (0, $9Vz68.default)((0, $8iNm9.default))($93efe20d23b19eb8$var$t || ($93efe20d23b19eb8$var$t = $93efe20d23b19eb8$var$_`
  height: 40px !important;
  line-height: 40px !important;

  div,
  span {
    display: flex !important;
    justify-content: center;
  }
`));
const $93efe20d23b19eb8$var$StyledLinkButtonWrapper = (0, $9Vz68.default).div($93efe20d23b19eb8$var$t1 || ($93efe20d23b19eb8$var$t1 = $93efe20d23b19eb8$var$_`
  a {
    height: 40px !important;
    line-height: 40px !important;
  }
`));
function $93efe20d23b19eb8$export$2e2bcd8739ae039(props) {
    const { isFullWidth: isFullWidth } = props, rest = (0, $42tc5._)(props, [
        "isFullWidth"
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($93efe20d23b19eb8$var$StyledButton, (0, $6EnDC._)((0, $ty6PY._)({}, rest), {
        shouldFitContainer: isFullWidth
    }));
}
const $93efe20d23b19eb8$export$549de15399e8aa5a = (props)=>{
    const { isFullWidth: isFullWidth } = props, rest = (0, $42tc5._)(props, [
        "isFullWidth"
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($93efe20d23b19eb8$var$StyledLinkButtonWrapper, {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cKQGL.default), (0, $6EnDC._)((0, $ty6PY._)({}, rest), {
            shouldFitContainer: isFullWidth
        }))
    });
};

});
parcelRegister("8iNm9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60b64a4d2bfea2d8$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $iRVQ8 = parcelRequire("iRVQ8");

var $7GSOz = parcelRequire("7GSOz");
var $60b64a4d2bfea2d8$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $60b64a4d2bfea2d8$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $60b64a4d2bfea2d8$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $iRVQ8.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7GSOz.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$60b64a4d2bfea2d8$var$LoadingButton.displayName = 'LoadingButton';
var $60b64a4d2bfea2d8$export$2e2bcd8739ae039 = $60b64a4d2bfea2d8$var$LoadingButton;

});

parcelRegister("cKQGL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9492a6c84ffcd0a2$export$2e2bcd8739ae039; });
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $25i4M = parcelRequire("25i4M");

var $30M5w = parcelRequire("30M5w");

var $c7GPs = parcelRequire("c7GPs");

var $i2LcI = parcelRequire("i2LcI");

var $c5jvf = parcelRequire("c5jvf");

var $53JDY = parcelRequire("53JDY");

var $1Shg4 = parcelRequire("1Shg4");
var $9492a6c84ffcd0a2$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "href",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId"
], $9492a6c84ffcd0a2$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
var $9492a6c84ffcd0a2$var$styles = {
    base: "_2rkofajl _11c82smr _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhksyzs _syaz1lh4 _aetrglyw _irr3syzs _30l31lh4 _1di6syzs _9h8h1lh4",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
var $9492a6c84ffcd0a2$var$defaultStyles = {
    root: "_bfhk1j54 _syaz10s3 _105310s3 _f8pj10s3 _irr3yw9d _30l310s3 _1di6ip91 _9h8h10s3",
    rootRefreshed: "_bfhksm61 _syaz1gjq _8l3mmuej _aetrb3bt _10531gjq _f8pj1gjq _irr3166n _30l31gjq _1di61dty _9h8h1gjq"
};
var $9492a6c84ffcd0a2$var$primaryStyles = {
    root: "_bfhkomb0 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31wqm _9h8h15cr _1di617hq"
};
var $9492a6c84ffcd0a2$var$warningStyles = {
    root: "_bfhk1ikc _syazal3n _1053al3n _f8pjal3n _30l3al3n _irr31j43 _9h8hal3n _1di6h4op"
};
var $9492a6c84ffcd0a2$var$dangerStyles = {
    root: "_bfhk1v7l _syaz15cr _105315cr _f8pj15cr _30l315cr _irr31rwk _9h8h15cr _1di6yycf"
};
var $9492a6c84ffcd0a2$var$discoveryStyles = {
    root: "_bfhk1vbi _syaz15cr _105315cr _f8pj15cr _30l315cr _irr37gr8 _9h8h15cr _1di61wu2"
};
var $9492a6c84ffcd0a2$var$subtleStyles = {
    root: "_bfhkqtfy _syaz10s3 _105310s3 _f8pj10s3 _irr34mfv _30l310s3 _1di619qy _9h8h10s3",
    rootRefreshed: "_bfhkqtfy _syaz1gjq _10531gjq _f8pj1mjl _irr34mfv _30l31gjq _1di619qy _9h8h1gjq"
};
var $9492a6c84ffcd0a2$var$selectedStyles = {
    root: "_bfhk7btw _syaz1pke _10531pke _f8pj1pke _irr3i1yw _30l31pke _1di619ru _9h8h1pke",
    rootRefreshed: "_bfhkfg4m _syaz1ldt _8l3mcoux _aetrb3bt _10531ldt _f8pj1ldt _30l31ldt _9h8h1ldt",
    warning: "_bfhkvdtc _syaz16q2 _30l31pke _irr3vdtc _9h8h1pke _1di6vdtc",
    danger: "_bfhkbeib _syaz1pke _30l31pke _irr3beib _9h8h1pke _1di6beib",
    discovery: "_bfhk1g49 _syaz1pke _30l31pke _irr31g49 _9h8h1pke _1di61g49"
};
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $9492a6c84ffcd0a2$var$LinkButtonBase = function LinkButtonBase(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, href = _ref.href, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $9492a6c84ffcd0a2$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(unsafeRest, $9492a6c84ffcd0a2$var$_excluded2);
    var hasIconAfter = Boolean(iconAfter);
    var hasIconBefore = Boolean(iconBefore);
    var localRef = (0, $8ZuGG.useRef)(null);
    (0, $c7GPs.default)(localRef, autoFocus);
    var combinedRef = (0, $30M5w.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $c5jvf.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        analyticsContext: analyticsContext,
        ref: combinedRef,
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName
    }, saferRest, {
        xcss: (0, $25i4M.cx)($9492a6c84ffcd0a2$var$styles.base, appearance === 'default' && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $9492a6c84ffcd0a2$var$defaultStyles.rootRefreshed : $9492a6c84ffcd0a2$var$defaultStyles.root), appearance === 'primary' && $9492a6c84ffcd0a2$var$primaryStyles.root, appearance === 'warning' && $9492a6c84ffcd0a2$var$warningStyles.root, appearance === 'danger' && $9492a6c84ffcd0a2$var$dangerStyles.root, appearance === 'discovery' && $9492a6c84ffcd0a2$var$discoveryStyles.root, appearance === 'subtle' && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $9492a6c84ffcd0a2$var$subtleStyles.rootRefreshed : $9492a6c84ffcd0a2$var$subtleStyles.root), $9492a6c84ffcd0a2$var$styles.linkDecorationUnset, isSelected && ((0, $i2LcI.fg)('platform-component-visual-refresh') ? $9492a6c84ffcd0a2$var$selectedStyles.rootRefreshed : $9492a6c84ffcd0a2$var$selectedStyles.root), // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $9492a6c84ffcd0a2$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $9492a6c84ffcd0a2$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $9492a6c84ffcd0a2$var$selectedStyles.discovery, isDisabled && $9492a6c84ffcd0a2$var$styles.disabled, spacing === 'compact' && $9492a6c84ffcd0a2$var$styles.spacingCompact, hasIconBefore && $9492a6c84ffcd0a2$var$styles.buttonIconBefore, hasIconAfter && $9492a6c84ffcd0a2$var$styles.buttonIconAfter, shouldFitContainer && $9492a6c84ffcd0a2$var$styles.fullWidth)
    }), iconBefore && /*#__PURE__*/ $8ZuGG.createElement((0, $53JDY.default), {
        type: "icon",
        position: "before",
        isLoading: false
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $1Shg4.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ $8ZuGG.createElement((0, $53JDY.default), {
        isLoading: false
    }, children), iconAfter && /*#__PURE__*/ $8ZuGG.createElement((0, $53JDY.default), {
        type: "icon",
        position: "after",
        isLoading: false
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $1Shg4.default), {
        icon: iconAfter
    })));
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ var $9492a6c84ffcd0a2$var$LinkButton = /*#__PURE__*/ (0, $8ZuGG.forwardRef)($9492a6c84ffcd0a2$var$LinkButtonBase);
$9492a6c84ffcd0a2$var$LinkButton.displayName = 'LinkButton';
var $9492a6c84ffcd0a2$export$2e2bcd8739ae039 = $9492a6c84ffcd0a2$var$LinkButton;

});


parcelRegister("gJFTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7770daab1be6a9cb$export$2e2bcd8739ae039; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $7770daab1be6a9cb$var$_ = (t)=>t, $7770daab1be6a9cb$var$t;
const $7770daab1be6a9cb$var$ButtonContainer = (0, $9Vz68.default).div($7770daab1be6a9cb$var$t || ($7770daab1be6a9cb$var$t = $7770daab1be6a9cb$var$_`
  width: 100%;
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
var $7770daab1be6a9cb$export$2e2bcd8739ae039 = $7770daab1be6a9cb$var$ButtonContainer;

});

parcelRegister("5bkyn", function(module, exports) {

$parcel$export(module.exports, "requestResetExpiredPassword", function () { return $5c753c0fb321345f$export$21fe95b80217f58c; });

var $8f2pb = parcelRequire("8f2pb");
const $5c753c0fb321345f$export$2cd8252107eb640b = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_INITIATE'
    });
const $5c753c0fb321345f$export$4098f8ed622a8e6c = ()=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS'
    });
const $5c753c0fb321345f$export$7ee4ab4cd9f42c10 = (error)=>({
        type: 'EXPIRED_PASSWORD_RESET_REQUEST_FAILED',
        error: error
    });
const $5c753c0fb321345f$export$21fe95b80217f58c = (token)=>(dispatch)=>{
        dispatch($5c753c0fb321345f$export$2cd8252107eb640b());
        return fetch('/rest/resetexpiredpassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            return Promise.reject(new Error(response.status.toString()));
        }).then(({ isSuccessful: isSuccessful })=>{
            if (isSuccessful === true) dispatch($5c753c0fb321345f$export$4098f8ed622a8e6c());
            else dispatch($5c753c0fb321345f$export$7ee4ab4cd9f42c10('invalid_token'));
        }).catch((error)=>{
            switch(error.message){
                case '401':
                    dispatch($5c753c0fb321345f$export$7ee4ab4cd9f42c10('invalid_token'));
                    break;
                case '429':
                    dispatch($5c753c0fb321345f$export$7ee4ab4cd9f42c10('too_many_requests'));
                    break;
                default:
                    dispatch($5c753c0fb321345f$export$7ee4ab4cd9f42c10('generic_error'));
                    (0, $8f2pb.captureException)(error);
                    break;
            }
        });
    };

});

parcelRegister("f2IKy", function(module, exports) {
$parcel$export(module.exports, "useForceRedirect", function () { return (parcelRequire("gsGhI")).useForceRedirect; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("7AZRg")).usePrevious; });
$parcel$export(module.exports, "useGoogleLoginHandler", function () { return (parcelRequire("bbCID")).useGoogleLoginHandler; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return (parcelRequire("bbCID")).useSocialLoginHandlers; });
$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return (parcelRequire("geQuT")).useRecaptchaChallengeObserver; });
parcelRequire("gsGhI");
parcelRequire("53FhD");
parcelRequire("7AZRg");
parcelRequire("bbCID");
parcelRequire("geQuT");

});
parcelRegister("gsGhI", function(module, exports) {

$parcel$export(module.exports, "useForceRedirect", function () { return $95e8746bcd318f23$export$20eacf679bc57a60; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9NVnN = parcelRequire("9NVnN");
const $95e8746bcd318f23$export$20eacf679bc57a60 = ({ redirectTo: redirectTo })=>{
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8ZuGG.useEffect)(()=>{
        if (redirectTo) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
            console.log('Caught error while trying to redirect...');
            console.log(e);
        }
    }, [
        redirectTo,
        navigate
    ]);
};

});

parcelRegister("53FhD", function(module, exports) {

var $8ZuGG = parcelRequire("8ZuGG");
const $f18194bce5b5c66a$export$820558710db2d9c6 = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8ZuGG.useEffect)(()=>callback(), []);
};

});

parcelRegister("7AZRg", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $1f961a6a8b26b1a9$export$5cae361ad82dce8b; });

var $8ZuGG = parcelRequire("8ZuGG");
function $1f961a6a8b26b1a9$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $8ZuGG.useRef)();
    (0, $8ZuGG.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});

parcelRegister("bbCID", function(module, exports) {

$parcel$export(module.exports, "useGoogleLoginHandler", function () { return $b11be6055d881a02$export$c5e89b4acf71d8e2; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return $b11be6055d881a02$export$3388df9a8c5125bf; });

var $8ZuGG = parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $fT7xM = parcelRequire("fT7xM");
const $b11be6055d881a02$export$c5e89b4acf71d8e2 = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(pageId, 'googleLoginButton', {
            redirectType: redirectType
        });
        (0, $fT7xM.redirectToGoogleLogin)(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
};
const $b11be6055d881a02$export$3388df9a8c5125bf = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const handleSocialLogin = (0, $8ZuGG.useCallback)((redirectFn, buttonId)=>{
        analyticsClient.buttonClickedEvent(pageId, buttonId, {
            redirectType: redirectType
        });
        redirectFn(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
    const handleMicrosoftLogin = (0, $8ZuGG.useCallback)(()=>handleSocialLogin((0, $fT7xM.redirectToMicrosoftLogin), 'microsoftLoginButton'), [
        handleSocialLogin
    ]);
    const handleAppleLogin = (0, $8ZuGG.useCallback)(()=>handleSocialLogin((0, $fT7xM.redirectToAppleLogin), 'appleLoginButton'), [
        handleSocialLogin
    ]);
    const handleSlackLogin = (0, $8ZuGG.useCallback)(()=>handleSocialLogin((0, $fT7xM.redirectToSlackLogin), 'slackLoginButton'), [
        handleSocialLogin
    ]);
    return {
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});
parcelRegister("fT7xM", function(module, exports) {

$parcel$export(module.exports, "LoginType", function () { return $787897fc004fdebc$export$7ecae1a0f094da22; });
$parcel$export(module.exports, "buildState", function () { return $787897fc004fdebc$export$13c6022a038eeeb6; });
$parcel$export(module.exports, "redirectToGoogleLogin", function () { return $787897fc004fdebc$export$d6e924a711e9e261; });
$parcel$export(module.exports, "redirectToMicrosoftLogin", function () { return $787897fc004fdebc$export$a2375491e360a04f; });
$parcel$export(module.exports, "redirectToAppleLogin", function () { return $787897fc004fdebc$export$be4d35cbb0c7d143; });
$parcel$export(module.exports, "isAppleHiddenEmail", function () { return $787897fc004fdebc$export$3fed42f6cd70c2bc; });
$parcel$export(module.exports, "redirectToSlackLogin", function () { return $787897fc004fdebc$export$bdab6d1697fcd9e9; });
$parcel$export(module.exports, "isGoogleLoginOutageAdvisoryEnabled", function () { return $787897fc004fdebc$export$20fa47fc379f30f3; });
$parcel$export(module.exports, "isAppleLoginOutageAdvisoryEnabled", function () { return $787897fc004fdebc$export$2fcd6c2fe8f717c4; });
$parcel$export(module.exports, "isMicrosoftLoginOutageAdvisoryEnabled", function () { return $787897fc004fdebc$export$9c936482818cd3df; });
$parcel$export(module.exports, "isSlackLoginOutageAdvisoryEnabled", function () { return $787897fc004fdebc$export$94fcb0c439ca8c06; });
/* eslint-disable max-params */ 
var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");

var $9rleF = parcelRequire("9rleF");

var $2O78M = parcelRequire("2O78M");

var $f81B8 = parcelRequire("f81B8");
var $787897fc004fdebc$export$7ecae1a0f094da22 = /*#__PURE__*/ function(LoginType) {
    LoginType["Apple"] = "appleLogin";
    LoginType["Slack"] = "slackLogin";
    LoginType["Microsoft"] = "microsoftLogin";
    LoginType["GoogleButton"] = "googleButton";
    LoginType["GoogleOneTap"] = "googleYolo";
    LoginType["SSO"] = "ssoLogin";
    return LoginType;
}({});
const $787897fc004fdebc$export$13c6022a038eeeb6 = ({ location: location, csrfToken: csrfToken, source: source, loginType: loginType, anonymousId: anonymousId, userFlow: userFlow, recoveryOptions: recoveryOptions })=>(0, $9rleF.Base64).encode(JSON.stringify({
        csrfToken: csrfToken,
        query: location.search || undefined,
        source: source,
        loginType: loginType,
        anonymousId: anonymousId,
        userFlow: userFlow,
        expects: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.expectedEmail,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken
    }));
const $787897fc004fdebc$export$d6e924a711e9e261 = ({ location: location, source: source, recoveryOptions: recoveryOptions })=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
    const filteredParams = Object.fromEntries(Object.entries(searchParams).filter(([key])=>key !== 'login_hint'));
    const { userFlow: userFlow } = filteredParams;
    const params = (0, $6EnDC._)((0, $ty6PY._)({}, filteredParams), {
        prompt: 'select_account',
        source: source,
        loginType: "googleButton",
        userFlow: userFlow,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken
    });
    location.assign(`${location.protocol}//${location.host}/login/initiate/google?` + (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(params));
};
const $787897fc004fdebc$var$redirectToSocialLoginInitiate = ({ location: location, source: source, recoveryOptions: recoveryOptions, loginType: loginType, loginHint: loginHint })=>{
    const initiateParams = (0, $6EnDC._)((0, $ty6PY._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search)), {
        loginType: loginType,
        source: source,
        recovery: recoveryOptions === null || recoveryOptions === void 0 ? void 0 : recoveryOptions.recoveryToken,
        prompt: 'select_account',
        login_hint: loginHint
    });
    let initiateUriSuffix;
    switch(loginType){
        case "appleLogin":
            initiateUriSuffix = 'apple';
            break;
        case "microsoftLogin":
            initiateUriSuffix = 'microsoft';
            break;
        case "slackLogin":
            initiateUriSuffix = 'slack';
            break;
    }
    location.assign(`${location.protocol}//${location.host}/login/initiate/${initiateUriSuffix}?` + (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(initiateParams));
};
const $787897fc004fdebc$export$a2375491e360a04f = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $787897fc004fdebc$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "microsoftLogin",
        loginHint: email
    });
};
const $787897fc004fdebc$export$be4d35cbb0c7d143 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $787897fc004fdebc$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "appleLogin",
        loginHint: email
    });
};
const $787897fc004fdebc$export$3fed42f6cd70c2bc = (email)=>{
    if (!email) return false;
    // Hidden email as defined by <unique-alphanumeric-string>@privaterelay.appleid.com
    const hiddenEmailDomainIdentifier = 'privaterelay.appleid.com';
    const [domain] = email.split('@').slice(-1);
    return domain === hiddenEmailDomainIdentifier;
};
const $787897fc004fdebc$export$bdab6d1697fcd9e9 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions } = params;
    $787897fc004fdebc$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "slackLogin",
        // Slack's OIDC implementation expects login_hint to be a JWT and blows up if it's not. If
        // Slack ever supports using an email as the login_hint (like other OIDC providers) then we
        // should remove this line.
        loginHint: undefined
    });
};
const $787897fc004fdebc$export$20fa47fc379f30f3 = (dynamicConfigs)=>(0, $f81B8.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $2O78M.AidFrontendDynamicConfig).GOOGLE_LOGIN_OUTAGE_ADVISORY);
const $787897fc004fdebc$export$2fcd6c2fe8f717c4 = (dynamicConfigs)=>(0, $f81B8.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $2O78M.AidFrontendDynamicConfig).APPLE_LOGIN_OUTAGE_ADVISORY);
const $787897fc004fdebc$export$9c936482818cd3df = (dynamicConfigs)=>(0, $f81B8.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $2O78M.AidFrontendDynamicConfig).MICROSOFT_LOGIN_OUTAGE_ADVISORY);
const $787897fc004fdebc$export$94fcb0c439ca8c06 = (dynamicConfigs)=>(0, $f81B8.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $2O78M.AidFrontendDynamicConfig).SLACK_LOGIN_OUTAGE_ADVISORY);

});
parcelRegister("9rleF", function(module, exports) {
(function(global1, factory) {
    module.exports = factory(global1);
})(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : module.exports, function(global1) {
    'use strict';
    // existing version for noConflict()
    global1 = global1 || {};
    var _Base64 = global1.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    var b64tab = function(bin) {
        var t = {};
        for(var i = 0, l = bin.length; i < l; i++)t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [
            0,
            2,
            1
        ][ccc.length % 3], ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0), chars = [
            b64chars.charAt(ord >>> 18),
            b64chars.charAt(ord >>> 12 & 63),
            padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63),
            padlen >= 1 ? '=' : b64chars.charAt(ord & 63)
        ];
        return chars.join('');
    };
    var btoa = global1.btoa && typeof global1.btoa == 'function' ? function(b) {
        return global1.btoa(b);
    } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function(b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == '+' ? '-' : '_';
        }).replace(/=/g, '');
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global1.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = '';
        for(var i = 0, l = a.length; i < l; i += 3){
            var a0 = a[i], a1 = a[i + 1], a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length){
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length, padlen = len % 4, n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0), chars = [
            fromCharCode(n >>> 16),
            fromCharCode(n >>> 8 & 0xff),
            fromCharCode(n & 0xff)
        ];
        chars.length -= [
            0,
            0,
            2,
            1
        ][padlen];
        return chars.join('');
    };
    var _atob = global1.atob && typeof global1.atob == 'function' ? function(a) {
        return global1.atob(a);
    } : function(a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };
    var _decode = function(a) {
        return btou(_atob(a));
    };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == '-' ? '+' : '/';
        }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };
    var decode = function(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global1.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base641 = global1.Base64;
        global1.Base64 = _Base64;
        return Base641;
    };
    // export Base64
    global1.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === 'function') {
        var noEnum = function(v) {
            return {
                value: v,
                enumerable: false,
                writable: true,
                configurable: true
            };
        };
        global1.Base64.extendString = function() {
            Object.defineProperty(String.prototype, 'fromBase64', noEnum(function() {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, 'toBase64', noEnum(function(urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function() {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global1['Meteor']) Base64 = global1.Base64;
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (0, module.exports) module.exports.Base64 = global1.Base64;
    else if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return global1.Base64;
    });
    // that's it!
    return {
        Base64: global1.Base64
    };
});

});



parcelRegister("geQuT", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return $1d2d868fa1e26509$export$4cc6b1f2fa5dc3f4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");
const $1d2d868fa1e26509$var$recaptchaIframeTitle = 'recaptcha challenge';
const $1d2d868fa1e26509$export$4cc6b1f2fa5dc3f4 = (pageId)=>{
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const bodyObserver = (0, $8ZuGG.useRef)();
    const attributeObserver = (0, $8ZuGG.useRef)();
    (0, $8ZuGG.useEffect)(()=>{
        /*
      To determine if user has been presented with a Google reCAPTCHA challenge, we need to listen to DOM events and check if an <iframe> was injected.
      Said <iframe> will have 'src' attribute containing 'google.com/recaptcha/api2/bframe'. Unfortunately, that is not enough
      because Google will inject the <iframe> even if they're not gonna show the challenge. So we attach another observer,
      looking for a change on the 'style' attribute of the outmost containing <div>. If style.target.visibility is 'visible',
      then we send analytics event.
    */ const outerContainerAttributeObserver = ()=>{
            return new MutationObserver((records)=>{
                const visibleEvent = Array.from(records).find((mutation)=>mutation.attributeName === 'style' && mutation.target.style.visibility === 'visible');
                if (visibleEvent) {
                    var _attributeObserver_current;
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'challenge',
                        subject: 'googleRecaptcha'
                    });
                    (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
                }
            });
        };
        if (window.MutationObserver) {
            var _bodyObserver_current;
            bodyObserver.current = new MutationObserver((records)=>{
                records.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        if (!(node instanceof Element)) return;
                        const recaptchaIframe = node.querySelector(`iframe[title*='${$1d2d868fa1e26509$var$recaptchaIframeTitle}']`);
                        if (recaptchaIframe) {
                            var _bodyObserver_current, _recaptchaIframe_parentNode;
                            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
                            const recaptchaOuterDiv = (_recaptchaIframe_parentNode = recaptchaIframe.parentNode) === null || _recaptchaIframe_parentNode === void 0 ? void 0 : _recaptchaIframe_parentNode.parentNode;
                            if (recaptchaOuterDiv) {
                                var _attributeObserver_current;
                                attributeObserver.current = outerContainerAttributeObserver();
                                (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.observe(recaptchaOuterDiv, {
                                    attributes: true
                                });
                            }
                        }
                    });
                });
            });
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.observe(window.document.body, {
                childList: true
            });
        }
        return ()=>{
            var _bodyObserver_current, _attributeObserver_current;
            (_bodyObserver_current = bodyObserver.current) === null || _bodyObserver_current === void 0 ? void 0 : _bodyObserver_current.disconnect();
            (_attributeObserver_current = attributeObserver.current) === null || _attributeObserver_current === void 0 ? void 0 : _attributeObserver_current.disconnect();
        };
    }, [
        analyticsClient,
        pageId
    ]);
};

});



parcelRegister("gEsch", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "securityScreenLoader", function () { return $86518b097f246fc1$export$a4b1a0446670c4d3; });
$parcel$export(module.exports, "MfaPromotePage", function () { return $86518b097f246fc1$export$84ed94b8c66e0057; });
$parcel$export(module.exports, "default", function () { return $86518b097f246fc1$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $JMbKX = parcelRequire("JMbKX");

var $5b7Z4 = parcelRequire("5b7Z4");

var $9Vz68 = parcelRequire("9Vz68");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $9OvaU = parcelRequire("9OvaU");

var $gGDrC = parcelRequire("gGDrC");

var $3ir1n = parcelRequire("3ir1n");

var $4wf7o = parcelRequire("4wf7o");

var $6XygG = parcelRequire("6XygG");
parcelRequire("f2IKy");
var $gsGhI = parcelRequire("gsGhI");

var $8xW40 = parcelRequire("8xW40");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $86518b097f246fc1$var$_ = (t)=>t, $86518b097f246fc1$var$t, $86518b097f246fc1$var$t1, $86518b097f246fc1$var$t2;
const $86518b097f246fc1$var$MfaPromoteContainer = (0, $9Vz68.default).div($86518b097f246fc1$var$t || ($86518b097f246fc1$var$t = $86518b097f246fc1$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $86518b097f246fc1$var$MfaImg = (0, $9Vz68.default).img($86518b097f246fc1$var$t1 || ($86518b097f246fc1$var$t1 = $86518b097f246fc1$var$_`
  height: ${0}px;
  display: block;
  margin: 0 auto;
  padding: ${0}px 0;
`), (0, $5b7Z4.gridSize)() * 14, (0, $5b7Z4.gridSize)());
const $86518b097f246fc1$var$ContentBody = (0, $9Vz68.default).p($86518b097f246fc1$var$t2 || ($86518b097f246fc1$var$t2 = $86518b097f246fc1$var$_`
  margin: ${0}px 0;
`), (0, $5b7Z4.gridSize)());
const $86518b097f246fc1$var$pageId = 'mfaPromotePage';
async function $86518b097f246fc1$export$a4b1a0446670c4d3({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/security-screen/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-promote'
        ]
    });
}
const $86518b097f246fc1$export$84ed94b8c66e0057 = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const redirectTo = (0, $kOqgB.useAppSelector)((state)=>state.mfaPromote.redirectTo);
    (0, $gsGhI.useForceRedirect)({
        redirectTo: redirectTo
    });
    (0, $3ir1n.usePageViewedEvent)($86518b097f246fc1$var$pageId);
    (0, $8xW40.usePageStateLoader)();
    (0, $3ir1n.useOperationalEvent)({
        page: $86518b097f246fc1$var$pageId,
        action: `loadMfaPromotePageSuccessful`,
        subject: 'sli'
    });
    const { search: search } = (0, $5WDNl.useLocation)();
    const trackContinueButtonClicked = (0, $3ir1n.useButtonClickedEvent)($86518b097f246fc1$var$pageId, 'MfaPromoteContinue');
    const trackDismissButtonClicked = (0, $3ir1n.useButtonClickedEvent)($86518b097f246fc1$var$pageId, 'MfaPromoteDismiss');
    const trackLeanMoreLinkClicked = (0, $3ir1n.useButtonClickedEvent)($86518b097f246fc1$var$pageId, 'MfaPromoteLearnMore');
    const onContinueButtonClicked = ()=>{
        trackContinueButtonClicked();
        dispatch((0, $6XygG.handleMfaPromoteUserSelection)('edit_mfa', search));
    };
    const onDismissButtonClicked = ()=>{
        trackDismissButtonClicked();
        dispatch((0, $6XygG.handleMfaPromoteUserSelection)('dismiss', search));
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: "mfaPromotePage",
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4wf7o.default).promoteMfaHeader))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "mfa-promote-learn-more",
            onClick: trackLeanMoreLinkClicked,
            href: "https://support.atlassian.com/atlassian-account/docs/manage-two-step-verification-for-your-atlassian-account/",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4wf7o.default).promoteMfaLearnMore))
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsxs)($86518b097f246fc1$var$MfaPromoteContainer, {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($86518b097f246fc1$var$MfaImg, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($JMbKX)))
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)($86518b097f246fc1$var$ContentBody, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4wf7o.default).promoteMfaMessageBody))
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        appearance: "primary",
                        id: "mfa-promote-continue",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onContinueButtonClicked,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4wf7o.default).promoteMfaContinue))
                    })
                }, "mfa.promote.continue.container"),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        appearance: "default",
                        id: "mfa-promote-dismiss",
                        testId: "mfa-promote-dismiss-idf-testid",
                        type: "submit",
                        isFullWidth: true,
                        onClick: onDismissButtonClicked,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4wf7o.default).promoteMfaDismiss))
                    })
                }, "mfa.promote.dismiss.container")
            ]
        })
    });
};
var $86518b097f246fc1$export$2e2bcd8739ae039 = $86518b097f246fc1$export$84ed94b8c66e0057;

});
parcelRegister("JMbKX", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "mfa-enable.f2e108a8.png";

});

parcelRegister("4wf7o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce8612ff447d009f$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $ce8612ff447d009f$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    promoteMfaHeader: {
        id: 'mfa.promote.header',
        defaultMessage: 'Enable two-step verification',
        description: 'Header to promote two-step verification'
    },
    promoteMfaMessageBody: {
        id: 'mfa.promote.message',
        defaultMessage: 'To keep your account secure, you can enable two-step verification. This adds a second login step for extra protection.',
        description: 'Main message to promote two-step verification'
    },
    promoteMfaLearnMore: {
        id: 'mfa.promote.learn',
        defaultMessage: 'Learn more about two-step verification',
        description: 'Text on link to learn more about two-step verification'
    },
    promoteMfaContinue: {
        id: 'mfa.promote.continue',
        defaultMessage: 'Enable two-step verification',
        description: 'Button text for continue to setup two-step verification'
    },
    promoteMfaDismiss: {
        id: 'mfa.promote.dismiss',
        defaultMessage: 'Continue without two-step verification',
        description: 'Button text for continuing without setting up two-step verification'
    }
});

});

parcelRegister("6XygG", function(module, exports) {

$parcel$export(module.exports, "handleMfaPromoteUserSelection", function () { return $9d658a20fa38d084$export$7eaa2fa4de4c2034; });
const $9d658a20fa38d084$export$7eaa2fa4de4c2034 = (choice, queryParams)=>(dispatch)=>{
        const loginPathWithErrorMessage = ()=>{
            const params = new URLSearchParams({
                errorCode: 'invalid.session.token',
                prompt: 'true'
            }).toString();
            return `/login?${params}`;
        };
        return fetch(`/v2/mfa/promote${queryParams || ''}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                choice: choice
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw new Error(`${response.status} ${response.statusText}: /v2/mfa/promote`);
        }).then((body)=>{
            const redirectUrl = (body === null || body === void 0 ? void 0 : body.redirectTo) || loginPathWithErrorMessage();
            dispatch($9d658a20fa38d084$export$d184870662dd3111(redirectUrl));
        }).catch(()=>{
            dispatch($9d658a20fa38d084$export$d184870662dd3111(loginPathWithErrorMessage()));
        });
    };
const $9d658a20fa38d084$export$d184870662dd3111 = (redirectTo)=>({
        type: 'MFA_PROMOTE_REDIRECT',
        redirectTo: redirectTo
    });

});


parcelRegister("cJaD4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "mfaLoader", function () { return $03b448b02646578d$export$8902dd3d9caf7997; });
$parcel$export(module.exports, "recoverExpiredLoader", function () { return $03b448b02646578d$export$bd26e265ac7ee3e1; });
$parcel$export(module.exports, "MultiFactorPage", function () { return $03b448b02646578d$export$d5523937d2306712; });
$parcel$export(module.exports, "default", function () { return $03b448b02646578d$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $5VQjR = parcelRequire("5VQjR");

var $xe7jL = parcelRequire("xe7jL");

var $4yIkJ = parcelRequire("4yIkJ");

var $9IXaN = parcelRequire("9IXaN");

var $aupLj = parcelRequire("aupLj");

var $8Gs9h = parcelRequire("8Gs9h");

var $lPS1q = parcelRequire("lPS1q");

var $9hHTk = parcelRequire("9hHTk");

var $9OvaU = parcelRequire("9OvaU");

var $pO9YU = parcelRequire("pO9YU");

var $7CMue = parcelRequire("7CMue");

var $bceLx = parcelRequire("bceLx");

var $dZoLz = parcelRequire("dZoLz");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $8bNLi = parcelRequire("8bNLi");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");

var $bbINW = parcelRequire("bbINW");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $2WEoo = parcelRequire("2WEoo");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $aSbwi = parcelRequire("aSbwi");
const $03b448b02646578d$var$pageId = 'multiFactorPage';
const $03b448b02646578d$var$challengeId = '2svChallengeScreen';
const $03b448b02646578d$var$expireId = '2svRecoveryLinkExpiredScreen';
const $03b448b02646578d$var$emergencyRecoveryKey = '2svRecoveryKeyScreen';
const $03b448b02646578d$var$saveNewRecoveryKey = '2svSaveNewRecoveryKey';
const $03b448b02646578d$var$accountRecovery = '2svAccountRecoveryScreen';
const $03b448b02646578d$var$recoveryEmailSent = '2svRecoveryEmailSentScreen';
async function $03b448b02646578d$export$8902dd3d9caf7997({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/mfa/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
async function $03b448b02646578d$export$bd26e265ac7ee3e1({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/2step/recover/expired/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $03b448b02646578d$export$d5523937d2306712 = ({ isExpired: isExpired })=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { isExecuting: isExecuting, executeWithTracking: executeWithTracking } = (0, $2WEoo.useExecutionTracker)();
    const isEmbedded = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.isEmbedded);
    const { method: multifactorMethod, phoneNumber: phoneNumber, isLoading: isLoading, isManaged: isManaged, isRecoveryEmailSent: isRecoveryEmailSent, recoveryEmailError: recoveryEmailError, fieldErrors: fieldErrors, recoveryCode: recoveryCode, clearInputTrigger: clearInputTrigger } = (0, $kOqgB.useAppSelector)((state)=>state.multiFactor);
    const email = (0, $kOqgB.useAppSelector)((state)=>{
        const mfEmail = state.multiFactor.email;
        const userEmail = state.user.email;
        return mfEmail && mfEmail.length > 0 ? mfEmail : userEmail;
    });
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    (0, $3ir1n.usePageViewedEvent)($03b448b02646578d$var$pageId);
    (0, $3ir1n.useOperationalEvent)({
        page: $03b448b02646578d$var$pageId,
        action: `loadMultiFactorPageSuccessful`,
        subject: 'sli'
    });
    const isInitialRender = (0, $8ZuGG.useRef)(true);
    const mfaEventAttributes = (0, $8ZuGG.useMemo)(()=>({
            multifactorMethod: multifactorMethod
        }), [
        multifactorMethod
    ]);
    // User will initially be prompted for the challenged factor, but can switch to the "Recovery code" screen,
    // or futher from there, the "Account recovery" screen.
    // This mode is to keep track of which screen the user is on.
    const [mode, setMode] = (0, $8ZuGG.useState)('CHALLENGED_FACTOR');
    const previousMode = (0, $7AZRg.usePrevious)(mode);
    (0, $8ZuGG.useEffect)(()=>{
        // After initial render, whenever the mode changes we want to trigger pageViewedEvents:
        if (isInitialRender.current) return;
        isInitialRender.current = false;
        if (mode !== previousMode) switch(mode){
            case 'RECOVERY_EMAIL':
                analyticsClient.pageViewedEvent($03b448b02646578d$var$accountRecovery);
                break;
            case 'RECOVERY_CODE':
                analyticsClient.pageViewedEvent($03b448b02646578d$var$emergencyRecoveryKey, mfaEventAttributes);
                break;
            case 'CHALLENGED_FACTOR':
                analyticsClient.pageViewedEvent($03b448b02646578d$var$challengeId, mfaEventAttributes);
                break;
        }
    }, [
        mode,
        analyticsClient,
        multifactorMethod,
        mfaEventAttributes,
        previousMode
    ]);
    const trackConfirmedRecoveryCode = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$saveNewRecoveryKey, '2svSavedNewRecoveryKey');
    const dispatchConfirmedRecoveryCode = (0, $8ZuGG.useCallback)(()=>{
        trackConfirmedRecoveryCode();
        dispatch((0, $4yIkJ.confirmedRecoveryCode)(search, analyticsClient, navigate));
    }, [
        trackConfirmedRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyOtpCode = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$challengeId, '2svChallengeLogin', mfaEventAttributes);
    const dispatchVerifyOtpCode = (0, $8ZuGG.useCallback)((otpCode)=>{
        trackVerifyOtpCode();
        dispatch((0, $4yIkJ.verifyOtpCode)(search, otpCode, analyticsClient, navigate));
    }, [
        trackVerifyOtpCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackVerifyRecoveryCode = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$emergencyRecoveryKey, '2svRecoveryKeyLogin', mfaEventAttributes);
    const verifyRecoveryCode = (0, $8ZuGG.useCallback)((recoveryCode)=>{
        trackVerifyRecoveryCode();
        dispatch((0, $4yIkJ.recoverAccount)(search, recoveryCode, analyticsClient, navigate));
    }, [
        trackVerifyRecoveryCode,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const trackResendSms = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$challengeId, '2svResendSms');
    const resendOtpSms = (0, $8ZuGG.useCallback)(()=>{
        trackResendSms();
        dispatch((0, $4yIkJ.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendSms,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackResendEmailOtp = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$challengeId, '2svResendEmailOtp');
    const resendOtpEmail = (0, $8ZuGG.useCallback)(()=>{
        trackResendEmailOtp();
        dispatch((0, $4yIkJ.resendOtp)(search, analyticsClient, navigate, multifactorMethod));
    }, [
        trackResendEmailOtp,
        dispatch,
        search,
        analyticsClient,
        navigate,
        multifactorMethod
    ]);
    const trackUseOtpCode = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$emergencyRecoveryKey, 'usePhone', mfaEventAttributes);
    const trackUseSecurityKey = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$emergencyRecoveryKey, 'useSecurityKey', mfaEventAttributes);
    const useOtpCode = (0, $8ZuGG.useCallback)(()=>{
        trackUseOtpCode();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseOtpCode
    ]);
    const useSecurityKey = (0, $8ZuGG.useCallback)(()=>{
        trackUseSecurityKey();
        setMode('CHALLENGED_FACTOR');
    }, [
        trackUseSecurityKey
    ]);
    const trackUseRecoveryCode = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$accountRecovery, '2svAccountRecoveryScreen');
    const trackCantUsePhone = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$challengeId, 'cantUsePhone');
    const trackCantUseSecurityKey = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$challengeId, 'cantUseSecurityKey');
    const useRecoveryCode = (0, $8ZuGG.useCallback)(()=>{
        switch(mode){
            case 'RECOVERY_EMAIL':
                trackUseRecoveryCode();
                break;
            case 'CHALLENGED_FACTOR':
                if (multifactorMethod === 'security-key') trackCantUseSecurityKey();
                else trackCantUsePhone();
                break;
        }
        setMode('RECOVERY_CODE');
    }, [
        trackUseRecoveryCode,
        trackCantUsePhone,
        trackCantUseSecurityKey,
        mode,
        multifactorMethod
    ]);
    const trackUseRecoveryEmail = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$emergencyRecoveryKey, 'noRecoveryKey');
    const useRecoveryEmail = (0, $8ZuGG.useCallback)(()=>{
        trackUseRecoveryEmail();
        setMode('RECOVERY_EMAIL');
    }, [
        trackUseRecoveryEmail
    ]);
    const navigateToLogin = (0, $8bNLi.useNavigateToLoginPrompt)();
    const trackReturnToLogin = (0, $3ir1n.useLinkClickedEvent)($03b448b02646578d$var$pageId, 'returnToLogin');
    const handleReturnToLogin = (0, $8ZuGG.useCallback)(()=>{
        trackReturnToLogin();
        navigateToLogin();
    }, [
        trackReturnToLogin,
        navigateToLogin
    ]);
    const renderMainContentFooter = ()=>{
        if (mode === 'RECOVERY_EMAIL' && !isRecoveryEmailSent && !isExpired) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "two-step-verification-enter-back-recovery-key",
            onClick: useRecoveryCode,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.backtouserecoverycode",
                defaultMessage: "Enter your recovery key"
            })
        });
        else if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "two-step-verification-switch-challenge-type",
            onClick: resendEmail,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.resendrecoveryemail",
                defaultMessage: "Resend recovery email"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbwi.default), {
                        screenId: $03b448b02646578d$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        id: "two-step-verification-switch-challenge-type-1",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $dZoLz.default).mfSwitchToRecoveryCode))
                    })
                ]
            });
            else if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbwi.default), {
                        screenId: $03b448b02646578d$var$challengeId,
                        isSwitching: isExecuting,
                        switchWithTracking: executeWithTracking
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        id: "two-step-verification-switch-challenge-type",
                        testId: "two-step-verification-switch-challenge-type-idf-testid",
                        onClick: useRecoveryCode,
                        isDisabled: isExecuting,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $dZoLz.default).mfSwitchToRecoveryCode))
                    })
                ]
            });
            else // email-otp should never call this function
            return null;
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
            children: [
                !isManaged && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        id: "two-step-verification-switch-challenge-type",
                        onClick: useRecoveryEmail,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.userecoveryemail",
                            defaultMessage: "Can't find your recovery key?"
                        })
                    })
                }),
                multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        onClick: useSecurityKey,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.useyoursecuritykey",
                            defaultMessage: "Use your security key"
                        })
                    })
                }) : /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        onClick: useOtpCode,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.backtouseotpcode",
                            defaultMessage: "Use your phone"
                        })
                    })
                })
            ]
        });
        else if (!isEmbedded) return /*#__PURE__*/ (0, $6rcps.jsx)("a", {
            href: "https://confluence.atlassian.com/cloud/secure-your-account-with-two-step-verification-939505063.html#Secureyouraccountwithtwo-stepverification-Recoveryouraccount",
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.gethelp",
                defaultMessage: "Help for two-step verification"
            })
        });
    };
    const renderFooter = ()=>{
        if (!isEmbedded) return /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const renderHeader = ()=>{
        if (isExpired) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "login.title.recoverylinkexpired",
                defaultMessage: "Your recovery link expired"
            })
        });
        else if (mode === 'CHALLENGED_FACTOR' || mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "continue.with.two.step.verification",
                defaultMessage: "Continue with two-step verification"
            })
        });
        else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.title.norecoverycode",
                defaultMessage: "Recover your account"
            })
        });
    };
    const trackSendRecoveryEmail = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$accountRecovery, 'sendRecoveryEmail');
    const sendEmail = (0, $8ZuGG.useCallback)(()=>{
        trackSendRecoveryEmail();
        dispatch((0, $4yIkJ.sendRecoveryEmail)(email));
    }, [
        trackSendRecoveryEmail,
        dispatch,
        email
    ]);
    const trackResendEmail = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$recoveryEmailSent, 'resendEmail');
    const trackResendEmailExpired = (0, $3ir1n.useButtonClickedEvent)($03b448b02646578d$var$expireId, 'resendEmail');
    const resendEmail = (0, $8ZuGG.useCallback)(()=>{
        sendEmail();
        if (isExpired) trackResendEmailExpired();
        else trackResendEmail();
        if (isRecoveryEmailSent) dispatch((0, $xe7jL.addFlag)('success', (0, $dZoLz.default).mfRecoveryEmailResentSuccessTitle, (0, $dZoLz.default).mfRecoveryEmailResentSuccessDesc));
        else dispatch((0, $xe7jL.addFlag)('error', (0, $dZoLz.default).mfRecoveryEmailResentErrorTitle, (0, $dZoLz.default).mfRecoveryEmailResentErrorDesc));
    }, [
        sendEmail,
        isExpired,
        isRecoveryEmailSent,
        trackResendEmailExpired,
        trackResendEmail,
        dispatch
    ]);
    const renderWhiteboxPageContent = ()=>{
        if (isRecoveryEmailSent || isExpired) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8Gs9h.default), {
            email: email,
            isExpired: isExpired,
            expirePageId: $03b448b02646578d$var$expireId,
            emailSentPageId: $03b448b02646578d$var$recoveryEmailSent
        });
        if (mode === 'CHALLENGED_FACTOR') {
            if (multifactorMethod === 'sms' || multifactorMethod === 'otp') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9IXaN.default), {
                verifyOtpCode: dispatchVerifyOtpCode,
                resendOtp: resendOtpSms,
                isLoading: isLoading,
                otpError: fieldErrors.otpCode,
                multifactorMethod: multifactorMethod,
                phoneNumber: phoneNumber,
                clearInputTrigger: clearInputTrigger
            });
            if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9IXaN.default), {
                isLoading: isLoading,
                multifactorMethod: multifactorMethod,
                clearInputTrigger: clearInputTrigger
            });
        } else if (mode === 'RECOVERY_CODE') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $lPS1q.default), {
            recoverAccount: verifyRecoveryCode,
            isLoading: isLoading,
            multifactorMethod: multifactorMethod,
            recoveryError: fieldErrors.recoveryCode
        });
        else if (mode === 'RECOVERY_EMAIL') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aupLj.default), {
            email: email,
            sendEmail: sendEmail,
            recoveryEmailError: recoveryEmailError
        });
    };
    const renderGenericExperience = ()=>{
        return !recoveryCode ? /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
            pageId: $03b448b02646578d$var$pageId,
            header: renderHeader(),
            whiteboxFooter: renderMainContentFooter(),
            footer: renderFooter(),
            noCobranding: true,
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)("title", {
                        children: formatMessage((0, $dZoLz.default).loginHeadTitle)
                    })
                }),
                renderWhiteboxPageContent()
            ]
        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $9hHTk.default), {
            recoveryCode: recoveryCode,
            onComplete: dispatchConfirmedRecoveryCode,
            isEmbedded: isEmbedded
        });
    };
    const verifyEmailOtpErrorCodeMapping = {
        invalid_otp: 'invalid_otp',
        invalid_token: 'invalid_token',
        invalid_otp_format: 'invalid_otp_length'
    };
    const renderEmailOtpExperience = ()=>{
        var _fieldErrors_otpCode;
        const otpErrorCode = fieldErrors === null || fieldErrors === void 0 ? void 0 : (_fieldErrors_otpCode = fieldErrors.otpCode) === null || _fieldErrors_otpCode === void 0 ? void 0 : _fieldErrors_otpCode.errorCode;
        const verifyEmailOtpErrorCode = !otpErrorCode ? undefined : verifyEmailOtpErrorCodeMapping[otpErrorCode] || 'unexpected_error';
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $bbINW.default), {
            pageId: $03b448b02646578d$var$pageId,
            flow: "login-challenge",
            email: email,
            isLoading: isLoading,
            errorCode: verifyEmailOtpErrorCode,
            onVerifyEmailOtp: dispatchVerifyOtpCode,
            onResendEmailOtp: resendOtpEmail,
            additionalWhiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                id: "two-step-verification-return-to-login",
                onClick: handleReturnToLogin,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.emailotp.return.to.login",
                    defaultMessage: "Log in to a different account"
                })
            })
        });
    };
    (0, $8xW40.usePageStateLoader)();
    if (multifactorMethod === 'email-otp') return renderEmailOtpExperience();
    else return renderGenericExperience();
};
var $03b448b02646578d$export$2e2bcd8739ae039 = $03b448b02646578d$export$d5523937d2306712;

});
parcelRegister("9IXaN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af7591ed78bbe7e9$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $dMtGq = parcelRequire("dMtGq");

var $5b7Z4 = parcelRequire("5b7Z4");

var $iRVQ8 = parcelRequire("iRVQ8");

var $lk7yL = parcelRequire("lk7yL");

var $1SvOA = parcelRequire("1SvOA");

var $1Acyk = parcelRequire("1Acyk");

var $a3fkM = parcelRequire("a3fkM");

var $hX7Rq = parcelRequire("hX7Rq");

var $eQyyj = parcelRequire("eQyyj");

var $jBQFl = parcelRequire("jBQFl");
let $af7591ed78bbe7e9$var$_ = (t)=>t, $af7591ed78bbe7e9$var$t, $af7591ed78bbe7e9$var$t1;
const $af7591ed78bbe7e9$var$ButtonContainer = (0, $9Vz68.default).div($af7591ed78bbe7e9$var$t || ($af7591ed78bbe7e9$var$t = $af7591ed78bbe7e9$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $af7591ed78bbe7e9$var$ResendButton = (0, $9Vz68.default)((0, $iRVQ8.default))($af7591ed78bbe7e9$var$t1 || ($af7591ed78bbe7e9$var$t1 = $af7591ed78bbe7e9$var$_`
  span {
    text-align: left;
    white-space: normal;
  }
`));
const $af7591ed78bbe7e9$var$MultiFactorForm = ({ email: email, isLoading: isLoading, multifactorMethod: multifactorMethod, otpError: otpError, phoneNumber: phoneNumber, resendOtp: resendOtp, verifyOtpCode: verifyOtpCode, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const helpTooltip = (method, phoneNumber, email)=>{
        if (method === 'sms') {
            const resendButton = /*#__PURE__*/ (0, $6rcps.jsx)($af7591ed78bbe7e9$var$ResendButton, {
                id: "resend-sms",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.mfform.sms.resend",
                    defaultMessage: "Resend the text message."
                })
            });
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.mfform.getsms.tooltip",
                tagName: "p",
                defaultMessage: "We've sent a text message (SMS) with the verification code to {mobileNumber}. Didn't get it? {resendButton}",
                values: {
                    mobileNumber: /*#__PURE__*/ (0, $6rcps.jsx)("b", {
                        children: phoneNumber
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'email-otp') {
            const resendButton = /*#__PURE__*/ (0, $6rcps.jsx)($af7591ed78bbe7e9$var$ResendButton, {
                id: "resend-email-otp",
                appearance: "link",
                onClick: resendOtp,
                spacing: "none",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.mfform.emailotp.resend",
                    defaultMessage: "Resend the verification code."
                })
            });
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.mfform.emailotp.tooltip",
                tagName: "p",
                defaultMessage: "We've sent the verification code to {email}. Didn't get it? {resendButton}",
                values: {
                    email: /*#__PURE__*/ (0, $6rcps.jsx)("b", {
                        children: email
                    }),
                    resendButton: resendButton
                }
            });
        }
        if (method === 'security-key') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "mf.mfform.securitykey.tooltip",
            tagName: "p",
            defaultMessage: "Use any security key you registered with Atlassian"
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "mf.mfform.getcode.tooltip",
            tagName: "p",
            defaultMessage: "Open the verification app on your phone to get your verification code."
        });
    };
    const handleInputChange = (0, $8ZuGG.useCallback)((e)=>{
        if (e.target && !!e.target.maxLength && e.target.value.length === e.target.maxLength) verifyOtpCode === null || verifyOtpCode === void 0 ? void 0 : verifyOtpCode(e.target.value);
    }, [
        verifyOtpCode
    ]);
    const handleFormSubmit = (0, $8ZuGG.useCallback)((e)=>{
        e.preventDefault();
        const target = e.target;
        verifyOtpCode === null || verifyOtpCode === void 0 ? void 0 : verifyOtpCode(target.otpCode.value);
    }, [
        verifyOtpCode
    ]);
    const otpPromptMessage = (0, $8ZuGG.useMemo)(()=>{
        switch(multifactorMethod){
            case 'sms':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $jBQFl.default).mfSmsPrompt));
            case 'otp':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $jBQFl.default).mfTotpPrompt));
            case 'email-otp':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $jBQFl.default).mfEmailPrompt));
            default:
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.mfform.getcode",
                    defaultMessage: "Enter your verification code to continue."
                });
        }
    }, [
        multifactorMethod
    ]);
    const renderOtpForm = (codeLength, codeType)=>{
        return /*#__PURE__*/ (0, $6rcps.jsxs)("form", {
            autoComplete: "off",
            onSubmit: handleFormSubmit,
            children: [
                /*#__PURE__*/ (0, $6rcps.jsxs)((0, $a3fkM.InputMessage), {
                    children: [
                        otpPromptMessage,
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.InlineMessageContainer), {
                            "data-testid": "mfform-tooltip-icon",
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dMtGq.default), {
                                appearance: "info",
                                placement: "bottom-end",
                                iconLabel: formatMessage({
                                    id: 'mf.mfform.getcode.tooltip.icon.label',
                                    defaultMessage: 'More info',
                                    description: 'Icon label for the help tooltip'
                                }),
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.StyledMessage), {
                                    children: helpTooltip(multifactorMethod, phoneNumber, email)
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $lk7yL.default), {
                    id: "two-step-verification-otp-code-input",
                    disabled: isLoading,
                    fieldErrorFromParent: otpError,
                    onChange: handleInputChange,
                    codeLength: codeLength,
                    codeType: codeType,
                    clearInputTrigger: clearInputTrigger
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)($af7591ed78bbe7e9$var$ButtonContainer, {
                    id: "two-step-verification-submit",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        appearance: "primary",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "common.login",
                            defaultMessage: "Log in"
                        })
                    })
                })
            ]
        });
    };
    if (multifactorMethod === 'email-otp') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
        children: renderOtpForm(6, 'alphanumeric')
    });
    else if (multifactorMethod === 'security-key') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $eQyyj.default), {});
    else {
        const securityWallStyle = multifactorMethod === 'otp' ? 'totp' : 'default';
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $1Acyk.SecurityWall), {
            id: "two-step-verification-form",
            securityWallStyle: securityWallStyle,
            children: renderOtpForm(6, 'numeric')
        });
    }
};
var $af7591ed78bbe7e9$export$2e2bcd8739ae039 = $af7591ed78bbe7e9$var$MultiFactorForm;

});
parcelRegister("dMtGq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a086c88e85186ad4$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $iNlvH = parcelRequire("iNlvH");

var $47npt = parcelRequire("47npt");

var $72wHg = parcelRequire("72wHg");
var $fkdQ8 = parcelRequire("fkdQ8");
var $4lDUI = parcelRequire("4lDUI");
var $2VWCX = parcelRequire("2VWCX");


var $g17mV = parcelRequire("g17mV");
var $a086c88e85186ad4$var$_excluded = [
    "ref"
];
var $a086c88e85186ad4$var$styles = {
    contentStyles: "_bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _nt751r31 _49pcnqa1 _1hvwt94y",
    pressableStyles: "_11c82smr _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syaz1gjq _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
var $a086c88e85186ad4$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ var $a086c88e85186ad4$var$InlineMessage = function InlineMessage(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$secondaryText = _ref.secondaryText, secondaryText = _ref$secondaryText === void 0 ? '' : _ref$secondaryText, _ref$title = _ref.title, title = _ref$title === void 0 ? '' : _ref$title, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'connectivity' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'spacious' : _ref$spacing, children = _ref.children, testId = _ref.testId, iconLabel = _ref.iconLabel, fallbackPlacements = _ref.fallbackPlacements;
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var id = (0, $iNlvH.useId)();
    var toggleDialog = (0, $8ZuGG.useCallback)(function() {
        setIsOpen(function(oldState) {
            return !oldState;
        });
    }, [
        setIsOpen
    ]);
    var onCloseDialog = (0, $8ZuGG.useCallback)(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $a086c88e85186ad4$var$styles.rootStyles,
            $a086c88e85186ad4$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $47npt.default), {
        onClose: onCloseDialog,
        content: function content() {
            return /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
                xcss: $a086c88e85186ad4$var$styles.contentStyles
            }, children);
        },
        isOpen: isOpen,
        placement: placement,
        testId: testId && "".concat(testId, "--popup"),
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        shouldDisableFocusLock: true,
        autoFocus: false,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, triggerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $a086c88e85186ad4$var$_excluded);
            return /*#__PURE__*/ $8ZuGG.createElement((0, $4lDUI.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, triggerProps, {
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && "".concat(testId, "--button"),
                xcss: $a086c88e85186ad4$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }), /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $8ZuGG.createElement((0, $g17mV.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $8ZuGG.createElement((0, $2VWCX.default), {
                weight: "medium",
                testId: testId && "".concat(testId, "--title")
            }, title), secondaryText && /*#__PURE__*/ $8ZuGG.createElement((0, $2VWCX.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && "".concat(testId, "--text")
            }, secondaryText))));
        }
    }));
};
var $a086c88e85186ad4$export$2e2bcd8739ae039 = $a086c88e85186ad4$var$InlineMessage;

});
parcelRegister("47npt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ff9f98f2253b58a$export$2e2bcd8739ae039; });

var $aUJum = parcelRequire("aUJum");
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2ff9f98f2253b58a$export$2e2bcd8739ae039 = (0, $aUJum.Popup);

});
parcelRegister("aUJum", function(module, exports) {

$parcel$export(module.exports, "Popup", function () { return $7f226b7918724d70$export$129a32eedafa97c5; });
/* popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");


var $6gKtn = parcelRequire("6gKtn");

var $8fZ6c = parcelRequire("8fZ6c");

var $k4ILS = parcelRequire("k4ILS");

var $i2LcI = parcelRequire("i2LcI");

var $fsHSh = parcelRequire("fsHSh");
var $4EPzJ = parcelRequire("4EPzJ");

var $jTcCE = parcelRequire("jTcCE");

var $72wHg = parcelRequire("72wHg");

var $6u3S7 = parcelRequire("6u3S7");

var $49bH0 = parcelRequire("49bH0");

var $e4sLc = parcelRequire("e4sLc");

var $3YbX8 = parcelRequire("3YbX8");
var $7f226b7918724d70$var$defaultLayer = 400;
var $7f226b7918724d70$var$wrapperStyles = {
    root: "_kqswh2mm"
};
var $7f226b7918724d70$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var xcss = _ref.xcss, _ref$appearance = _ref.appearance, inAppearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, isOpen = _ref.isOpen, providedId = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $7f226b7918724d70$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, inShouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldDisableFoc = _ref.shouldDisableFocusLock, shouldDisableFocusLock = _ref$shouldDisableFoc === void 0 ? false : _ref$shouldDisableFoc, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport;
    var _useState = (0, $8ZuGG.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    var getMergedTriggerRef = (0, $e4sLc.useGetMemoizedMergedTriggerRef)();
    var getMergedTriggerRefNew = (0, $3YbX8.useGetMemoizedMergedTriggerRefNew)();
    var generatedId = (0, $6gKtn.useId)();
    var _usePopupAppearance = (0, $49bH0.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    }), appearance = _usePopupAppearance.appearance, shouldRenderToParent = _usePopupAppearance.shouldRenderToParent;
    var id = providedId || generatedId;
    var handleOpenLayerObserverCloseSignal = (0, $8ZuGG.useCallback)(function() {
        onClose === null || onClose === void 0 || onClose(null);
    }, [
        onClose
    ]);
    (0, $k4ILS.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    var renderPopperWrapper = /*#__PURE__*/ $8ZuGG.createElement((0, $8fZ6c.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $6u3S7.default), {
        xcss: xcss,
        appearance: appearance,
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
        shouldFitContainer: shouldFitContainer,
        shouldDisableFocusLock: shouldDisableFocusLock,
        shouldReturnFocus: shouldReturnFocus,
        triggerRef: triggerRef,
        strategy: shouldFitContainer ? 'absolute' : strategy,
        role: role,
        label: label,
        titleId: titleId,
        modifiers: modifiers,
        shouldFitViewport: shouldFitViewport
    }));
    var popupContent = /*#__PURE__*/ $8ZuGG.createElement((0, $fsHSh.Manager), null, /*#__PURE__*/ $8ZuGG.createElement((0, $4EPzJ.Reference), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: !(0, $i2LcI.fg)('platform-design-system-popup-ref') ? getMergedTriggerRef(ref, setTriggerRef, isOpen) : getMergedTriggerRefNew(ref, setTriggerRef),
            'aria-controls': isOpen ? id : undefined,
            'aria-expanded': isOpen,
            'aria-haspopup': role === 'dialog' && (0, $i2LcI.fg)('platform_dst_popup-disable-focuslock') ? 'dialog' : true
        });
    }), isOpen && (shouldRenderToParent || shouldFitContainer ? renderPopperWrapper : /*#__PURE__*/ $8ZuGG.createElement((0, $jTcCE.default), {
        zIndex: zIndex
    }, renderPopperWrapper)));
    if (shouldFitContainer) return /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        xcss: $7f226b7918724d70$var$wrapperStyles.root
    }, popupContent);
    return popupContent;
});

});
parcelRegister("6gKtn", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $4908493f0dc9794f$export$f680877a34711e37; });

var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $6LGXo = parcelRequire("6LGXo");

var $i2LcI = parcelRequire("i2LcI");
var $4908493f0dc9794f$var$_React$useId;
// Type copied from https://github.com/thearnica/react-uid/blob/0f507fbbdb1ab84acf477ec32698afe3d2191e49/src/hooks.ts#L12
// Copied rather than inferred to make the type transparent
// @ts-ignore - useId is not accessible in React 16
var $4908493f0dc9794f$var$react18UseId = ($4908493f0dc9794f$var$_React$useId = (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useId) !== null && $4908493f0dc9794f$var$_React$useId !== void 0 ? $4908493f0dc9794f$var$_React$useId : undefined;
function $4908493f0dc9794f$export$f680877a34711e37() {
    if ($4908493f0dc9794f$var$react18UseId && (0, $i2LcI.fg)('platform-dst-react-18-use-id')) return $4908493f0dc9794f$var$react18UseId();
    return "uid".concat((0, $6LGXo.useUID)());
}
var $4908493f0dc9794f$export$6be90bcb437e928f = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? '' : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? '' : _ref$prefix;
    var id = "".concat(prefix).concat($4908493f0dc9794f$export$f680877a34711e37()).concat(postfix);
    (0, $8ZuGG.useEffect)(function() {
        if (!ref) return;
        switch((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(ref)){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error("Unreachable case for unsupported type of ref \"".concat((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(ref), "\""));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, typeof children === 'function' ? children({
        id: id
    }) : children);
});
function $4908493f0dc9794f$export$6ee17796e3d70de2() {
    if ($4908493f0dc9794f$var$react18UseId && (0, $i2LcI.fg)('platform-dst-react-18-use-id')) {
        var uid = $4908493f0dc9794f$var$react18UseId();
        return function(id) {
            return "".concat(uid, "-").concat(id.toString());
        };
    }
    return (0, $6LGXo.useUIDSeed)();
}

});

parcelRegister("8fZ6c", function(module, exports) {

$parcel$export(module.exports, "LevelContext", function () { return $602f1e6d3ef10501$export$650d12d3c2ddb8fc; });
$parcel$export(module.exports, "LevelNodeContext", function () { return $602f1e6d3ef10501$export$18f4d8b5b3a77f59; });
$parcel$export(module.exports, "RootNodeContext", function () { return $602f1e6d3ef10501$export$fa973f110e8f6ca8; });
$parcel$export(module.exports, "TopLevelContext", function () { return $602f1e6d3ef10501$export$48b383b280e20440; });
$parcel$export(module.exports, "Layering", function () { return $602f1e6d3ef10501$export$7c885f891c940977; });

var $8ZuGG = parcelRequire("8ZuGG");

var $btqBI = parcelRequire("btqBI");

var $510aG = parcelRequire("510aG");

var $g0G6s = parcelRequire("g0G6s");
var $602f1e6d3ef10501$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $8ZuGG.createContext)(0);
var $602f1e6d3ef10501$export$18f4d8b5b3a77f59 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    current: null
});
var $602f1e6d3ef10501$export$fa973f110e8f6ca8 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    current: null
});
var $602f1e6d3ef10501$export$48b383b280e20440 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    topLevelRef: {
        current: null
    },
    layerList: {
        current: null
    },
    setTopLevel: (0, $btqBI.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $602f1e6d3ef10501$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel, levelNode = _ref.node;
    (0, $8ZuGG.useEffect)(function() {
        var levelNodeSafe = levelNode.current;
        var parentNode = levelNodeSafe.parent;
        parentNode === null || parentNode === void 0 || parentNode.addChild(levelNodeSafe);
        return function() {
            parentNode === null || parentNode === void 0 || parentNode.removeChild(levelNodeSafe);
        };
    }, [
        levelNode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$export$18f4d8b5b3a77f59.Provider, {
        value: levelNode
    }, children));
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $602f1e6d3ef10501$var$LevelProviderOld = function LevelProviderOld(_ref2) {
    var children = _ref2.children, currentLevel = _ref2.currentLevel;
    var _useContext = (0, $8ZuGG.useContext)($602f1e6d3ef10501$export$48b383b280e20440), layerList = _useContext.layerList;
    // This is not unstable, it will run once for ref creation.
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var id = (0, $8ZuGG.useRef)(Math.random().toString(36));
    (0, $8ZuGG.useEffect)(function() {
        var safeLayerList = layerList === null || layerList === void 0 ? void 0 : layerList.current;
        var safeId = id.current;
        if (!safeLayerList) return;
        safeLayerList.push(safeId);
        return function() {
            var index = safeLayerList.indexOf(safeId);
            if (index > -1) safeLayerList.splice(index, 1);
        };
    }, [
        layerList,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal @deprecated
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $602f1e6d3ef10501$var$LayeringProvider = function LayeringProvider(_ref3) {
    var children = _ref3.children;
    var topLevelRef = (0, $8ZuGG.useRef)(0);
    var layerList = (0, $8ZuGG.useRef)([]);
    var value = (0, $8ZuGG.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            },
            layerList: layerList
        };
    }, [
        topLevelRef,
        layerList
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
/**
 *
 * @deprecated
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $602f1e6d3ef10501$var$LayeringOld = function LayeringOld(_ref4) {
    var children = _ref4.children, _ref4$isDisabled = _ref4.isDisabled, isDisabled = _ref4$isDisabled === void 0 ? true : _ref4$isDisabled;
    var currentLevel = (0, $8ZuGG.useContext)($602f1e6d3ef10501$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$var$LevelProviderOld, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$var$LayeringProvider, null, content);
};
/**
 *
 * @important the component is toggled by isDisabled props, the default isDisabled is true
 *
 * Layering component is a wrapper to let children to consume layer contexts and hooks.
 *
 */ var $602f1e6d3ef10501$var$LayeringNew = function LayeringNew(_ref5) {
    var children = _ref5.children, _ref5$isDisabled = _ref5.isDisabled, isDisabled = _ref5$isDisabled === void 0 ? true : _ref5$isDisabled;
    var currentLevel = (0, $8ZuGG.useContext)($602f1e6d3ef10501$export$650d12d3c2ddb8fc);
    var parentNode = (0, $8ZuGG.useContext)($602f1e6d3ef10501$export$18f4d8b5b3a77f59);
    // eslint-disable-next-line  @repo/internal/react/disallow-unstable-values
    var newNode = (0, $8ZuGG.useRef)(new (0, $g0G6s.LayerNode)(Math.random().toString(36), parentNode.current));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$var$LevelProvider, {
        currentLevel: currentLevel + 1,
        node: newNode
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($602f1e6d3ef10501$export$fa973f110e8f6ca8.Provider, {
        value: newNode
    }, content);
};
var $602f1e6d3ef10501$export$7c885f891c940977 = (0, $510aG.componentWithFG)('layering-tree-graph', $602f1e6d3ef10501$var$LayeringNew, $602f1e6d3ef10501$var$LayeringOld);

});
parcelRegister("btqBI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85a70ad1a445f0d2$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $85a70ad1a445f0d2$export$2e2bcd8739ae039() {}

});

parcelRegister("510aG", function(module, exports) {

$parcel$export(module.exports, "componentWithFG", function () { return $3a6d2dbd65541c45$export$cf56d0f54cfcce4; });

var $i2LcI = parcelRequire("i2LcI");

var $aoIsE = parcelRequire("aoIsE");
var $3a6d2dbd65541c45$export$cf56d0f54cfcce4 = function componentWithFG(featureFlagName, ComponentTrue, ComponentFalse) {
    return (0, $aoIsE.componentWithCondition)(function() {
        return (0, $i2LcI.fg)(featureFlagName);
    }, ComponentTrue, ComponentFalse);
};

});
parcelRegister("aoIsE", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", function () { return $791ea2543d569d04$export$6e8ea24b15199873; });

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");
function $791ea2543d569d04$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    var ComponentWithCondition = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
        return condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ComponentTrue, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, {
            ref: ref
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ComponentFalse, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, {
            ref: ref
        }));
    });
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = "ComponentWithCondition[".concat(condition.name, "]");
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});


parcelRegister("g0G6s", function(module, exports) {

$parcel$export(module.exports, "LayerNode", function () { return $ba7d4e36b2d3c998$export$da4f61fd78d35243; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");
var $ba7d4e36b2d3c998$export$da4f61fd78d35243 = /*#__PURE__*/ function() {
    function LayerNode(id, parent) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, LayerNode);
        this.id = id;
        this.childNodes = [];
        this.parent = parent;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(LayerNode, [
        {
            key: "addChild",
            value: function addChild(node) {
                this.childNodes.push(node);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(node) {
                this.childNodes = this.childNodes.filter(function(child) {
                    return child.id !== node.id;
                });
            }
        },
        {
            key: "getLevel",
            value: function getLevel() {
                if (!this.parent) return 1;
                return this.parent.getLevel() + 1;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                if (this.childNodes.length === 0) return 1;
                return Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.childNodes.map(function(child) {
                    return child.getHeight();
                }))) + 1;
            }
        }
    ]);
}();

});


parcelRegister("4EPzJ", function(module, exports) {

$parcel$export(module.exports, "Reference", function () { return $3642e7a19848cc1c$export$e0be378c32fb70a7; });

var $8ZuGG = parcelRequire("8ZuGG");

var $j7xWV = parcelRequire("j7xWV");

var $fsHSh = parcelRequire("fsHSh");

var $36O7l = parcelRequire("36O7l");
function $3642e7a19848cc1c$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $8ZuGG.useContext((0, $fsHSh.ManagerReferenceNodeSetterContext));
    var refHandler = $8ZuGG.useCallback(function(node) {
        (0, $36O7l.setRef)(innerRef, node);
        (0, $36O7l.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $8ZuGG.useEffect(function() {
        return function() {
            return (0, $36O7l.setRef)(innerRef, null);
        };
    }, []);
    $8ZuGG.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($j7xWV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $36O7l.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("j7xWV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $deb901651109fd21$var$__DEV__ = false;
var $deb901651109fd21$var$warning = function() {};
if ($deb901651109fd21$var$__DEV__) {
    var $deb901651109fd21$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $deb901651109fd21$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $deb901651109fd21$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $deb901651109fd21$var$warning;

});


parcelRegister("6u3S7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b888c48c61834a0$export$2e2bcd8739ae039; });
/* popper-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cF8Kw = parcelRequire("cF8Kw");

var $kg5sN = parcelRequire("kg5sN");

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $lDjMh = parcelRequire("lDjMh");

var $i2LcI = parcelRequire("i2LcI");

var $gz4oj = parcelRequire("gz4oj");

var $6DZ3r = parcelRequire("6DZ3r");

var $aYK2f = parcelRequire("aYK2f");

var $2CUAV = parcelRequire("2CUAV");
var $4b888c48c61834a0$var$_excluded = [
    "shouldRenderToParent",
    "shouldFitContainer",
    "children",
    "appearance",
    "className",
    "isReferenceHidden"
];
var $4b888c48c61834a0$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $4b888c48c61834a0$var$fullWidthStyles = null;
var $4b888c48c61834a0$var$wrapperStyles = {
    root: "_2rkoglpi _1e0c1ule _vchhusvi _1pby1nn1 _bfhk1bhr _16qs1cd0 _syaz1fxt _1q1l1bhr _nt751r31 _49pcglyw _1hvw1o36"
};
var $4b888c48c61834a0$var$scrollableStyles = null;
var $4b888c48c61834a0$var$blanketStyles = null;
var $4b888c48c61834a0$var$modalStyles = null;
var $4b888c48c61834a0$var$focusRingStyles = {
    root: "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y"
};
var $4b888c48c61834a0$var$DefaultPopupComponent = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, shouldFitContainer = props.shouldFitContainer, children = props.children, appearance = props.appearance, className = props.className, isReferenceHidden = props.isReferenceHidden, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $4b888c48c61834a0$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4hjl.default)([
            $4b888c48c61834a0$var$wrapperStyles.root,
            appearance === 'UNSAFE_modal-below-sm' && "_dk5d1b66 _c71ldtre _kqsw1n9t _152t1b66",
            !shouldRenderToParent && "_1reo1wug _18m91wug",
            shouldFitContainer && "_1bsb1osq",
            className
        ])
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $4b888c48c61834a0$var$PopperWrapper(_ref) {
    var xcss = _ref.xcss, isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $4b888c48c61834a0$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent, shouldFitContainer = _ref.shouldFitContainer, shouldDisableFocusLock = _ref.shouldDisableFocusLock, _ref$shouldReturnFocu = _ref.shouldReturnFocus, shouldReturnFocus = _ref$shouldReturnFocu === void 0 ? true : _ref$shouldReturnFocu, strategy = _ref.strategy, role = _ref.role, label = _ref.label, titleId = _ref.titleId, modifiers = _ref.modifiers, shouldFitViewport = _ref.shouldFitViewport, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance;
    var _useState = (0, $8ZuGG.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    // We have cases where we need to close the Popup on Tab press, e.g. DropdownMenu
    var shouldCloseOnTab = shouldRenderToParent && shouldDisableFocusLock;
    var shouldDisableFocusTrap = role !== 'dialog';
    (0, $2CUAV.useFocusManager)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef,
        shouldCloseOnTab: shouldCloseOnTab,
        triggerRef: triggerRef,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldReturnFocus: shouldReturnFocus
    });
    (0, $aYK2f.useCloseManager)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldCloseOnTab: shouldCloseOnTab,
        autoFocus: autoFocus,
        shouldDisableFocusTrap: shouldDisableFocusTrap,
        shouldRenderToParent: shouldRenderToParent
    });
    var _useLayering = (0, $lDjMh.useLayering)(), currentLevel = _useLayering.currentLevel;
    var mergedModifiers = (0, $8ZuGG.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(modifiers || []));
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements,
        modifiers
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $gz4oj.Popper), {
        placement: placement,
        offset: offset,
        modifiers: mergedModifiers,
        strategy: strategy,
        shouldFitViewport: shouldFitViewport
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update, isReferenceHidden = _ref2.isReferenceHidden;
        var popupContainer = /*#__PURE__*/ $8ZuGG.createElement(PopupContainer, {
            className: (0, $c4hjl.default)([
                xcss,
                // @ts-expect-error: `ax` is not typed correctly
                !initialFocusRef && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $i2LcI.fg)('platform-design-system-apply-popup-wrapper-focus') && $4b888c48c61834a0$var$focusRingStyles.root
            ]),
            appearance: appearance,
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            role: role,
            "aria-label": label,
            "aria-labelledby": titleId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: appearance === 'UNSAFE_modal-below-sm' ? {} : style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent,
            shouldFitContainer: shouldFitContainer,
            isReferenceHidden: isReferenceHidden
        }, /*#__PURE__*/ $8ZuGG.createElement((0, $6DZ3r.RepositionOnUpdate), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
        return /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, popupContainer, appearance === 'UNSAFE_modal-below-sm' && /*#__PURE__*/ $8ZuGG.createElement("div", {
            className: (0, $c4hjl.default)([
                "_1r04idpf _kqsw1n9t _bfhk10xm"
            ])
        }));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b888c48c61834a0$export$2e2bcd8739ae039 = $4b888c48c61834a0$var$PopperWrapper;

});
parcelRegister("lDjMh", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", function () { return $fbfc94eda90a2588$export$4a4bf067ea9e7886; });
$parcel$export(module.exports, "useLayering", function () { return $fbfc94eda90a2588$export$c8b4d54e03dee6ed; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $i2LcI = parcelRequire("i2LcI");

var $8fZ6c = parcelRequire("8fZ6c");
var $fbfc94eda90a2588$var$ESCAPE = 'Escape';
function $fbfc94eda90a2588$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $8ZuGG.useRef)(false);
    var _useLayering = $fbfc94eda90a2588$export$c8b4d54e03dee6ed(), isLayerDisabled = _useLayering.isLayerDisabled;
    var onKeyDown = (0, $8ZuGG.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $fbfc94eda90a2588$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $8ZuGG.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $8ZuGG.useEffect)(function() {
        return (0, $k6Bkl.bindAll)(window, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $fbfc94eda90a2588$export$c8b4d54e03dee6ed() {
    var currentLevel = (0, $8ZuGG.useContext)((0, $8fZ6c.LevelContext));
    // Remove TopLevelContext on FG cleanup layering-tree-graph
    var _useContext = (0, $8ZuGG.useContext)((0, $8fZ6c.TopLevelContext)), topLevelRef = _useContext.topLevelRef, layerList = _useContext.layerList;
    var layerNode;
    var rootNode;
    if ((0, $i2LcI.fg)('layering-tree-graph')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        layerNode = (0, $8ZuGG.useContext)((0, $8fZ6c.LevelNodeContext));
        // eslint-disable-next-line react-hooks/rules-of-hooks
        rootNode = (0, $8ZuGG.useContext)((0, $8fZ6c.RootNodeContext));
    }
    var isLayerDisabled = (0, $8ZuGG.useCallback)(function() {
        var _layerList$current$le, _layerList$current;
        if ((0, $i2LcI.fg)('layering-tree-graph')) {
            var _layerNode, _rootNode;
            // This is an impossible case, added for type safety
            if (!((_layerNode = layerNode) !== null && _layerNode !== void 0 && _layerNode.current) || !((_rootNode = rootNode) !== null && _rootNode !== void 0 && _rootNode.current)) return false;
            return layerNode.current.getLevel() < rootNode.current.getHeight();
        }
        return ((_layerList$current$le = layerList === null || layerList === void 0 || (_layerList$current = layerList.current) === null || _layerList$current === void 0 ? void 0 : _layerList$current.length) !== null && _layerList$current$le !== void 0 ? _layerList$current$le : 0) !== currentLevel;
    }, [
        currentLevel,
        layerList,
        layerNode,
        rootNode
    ]);
    var getTopLevel = (0, $8ZuGG.useCallback)(function() {
        var _rootNode2;
        return (_rootNode2 = rootNode) !== null && _rootNode2 !== void 0 && _rootNode2.current ? rootNode.current.getHeight() : null;
    }, [
        rootNode
    ]);
    return (0, $i2LcI.fg)('layering-tree-graph') ? {
        currentLevel: currentLevel,
        isLayerDisabled: isLayerDisabled,
        getTopLevel: getTopLevel
    } : {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled,
        layerList: layerList
    };
}

});

parcelRegister("6DZ3r", function(module, exports) {

$parcel$export(module.exports, "RepositionOnUpdate", function () { return $4d65beb90e3c6386$export$51eddd7655ca235a; });

var $8ZuGG = parcelRequire("8ZuGG");
var $4d65beb90e3c6386$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $8ZuGG.useRef)(true);
    (0, $8ZuGG.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Fragment), null, children);
};

});

parcelRegister("aYK2f", function(module, exports) {

$parcel$export(module.exports, "useCloseManager", function () { return $7fe337a148a157a0$export$92dae2778ae88f9d; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $hCEX5 = parcelRequire("hCEX5");

var $lDjMh = parcelRequire("lDjMh");

var $i2LcI = parcelRequire("i2LcI");

var $kRuDs = parcelRequire("kRuDs");

var $7P9XC = parcelRequire("7P9XC");
var $7fe337a148a157a0$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, capture = _ref.shouldUseCaptureOnOutsideClick, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useLayering = (0, $lDjMh.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled, currentLevel = _useLayering.currentLevel;
    var _useAnimationFrame = (0, $7P9XC.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    (0, $8ZuGG.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $hCEX5.default;
        var inIframe = window && window.self !== window.top && (0, $i2LcI.fg)('fix-dropdown-close-outside-iframe');
        var closePopup = function closePopup(event) {
            if (onClose) {
                var _currentLevel = null;
                if (event.target instanceof HTMLElement) {
                    var _event$target$closest;
                    _currentLevel = (_event$target$closest = event.target.closest("[data-ds--level]")) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-ds--level');
                }
                _currentLevel ? onClose(event, Number(_currentLevel)) : onClose(event);
            }
            if (shouldDisableFocusTrap && (0, $i2LcI.fg)('platform_dst_popup-disable-focuslock')) // Restoring the normal focus order for trigger.
            requestFrame(function() {
                triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '0');
                if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '0');
            });
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist && !inIframe) return;
            if (isLayerDisabled()) {
                if (target instanceof HTMLElement) {
                    var _target$closest;
                    var layeredElement = (_target$closest = target.closest) === null || _target$closest === void 0 ? void 0 : _target$closest.call(target, "[data-ds--level]");
                    if (layeredElement) {
                        var closeType = layeredElement.getAttribute('[data-ds--close--type]');
                        if (closeType === 'single') // if the close type is single, we won't close other disabled layers when clicking outside
                        return;
                        var levelOfClickedLayer = layeredElement.getAttribute('data-ds--level');
                        if (levelOfClickedLayer && Number(levelOfClickedLayer) > currentLevel) // won't trigger onClick event when we click in a higher layer.
                        return;
                    }
                }
            }
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) {
                closePopup(event);
                // If there was an outside click on a non-interactive element, the focus should be on the trigger.
                if (document.activeElement && !(0, $kRuDs.isInteractiveElement)(document.activeElement) && (0, $i2LcI.fg)('platform_dst_popup-disable-focuslock')) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
            }
        };
        var onKeyDown = function onKeyDown(event) {
            if ((0, $i2LcI.fg)('platform_dst_popup-disable-focuslock')) {
                var key = event.key, shiftKey = event.shiftKey;
                if (shiftKey && key === 'Tab' && !shouldRenderToParent) {
                    if (isLayerDisabled()) return;
                    // We need to move the focus to the popup trigger when the popup is displayed in React.Portal.
                    requestFrame(function() {
                        var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                        if (isPopupFocusOut) {
                            closePopup(event);
                            if (currentLevel === 1) triggerRef === null || triggerRef === void 0 || triggerRef.focus();
                        }
                    });
                    return;
                }
                if (key === 'Tab') {
                    var _document$activeEleme;
                    // We have cases where we need to close the Popup on Tab press.
                    // Example: DropdownMenu
                    if (shouldCloseOnTab) {
                        if (isLayerDisabled()) return;
                        closePopup(event);
                        return;
                    }
                    if (isLayerDisabled() && (_document$activeEleme = document.activeElement) !== null && _document$activeEleme !== void 0 && _document$activeEleme.closest('[aria-modal]')) return;
                    if (shouldDisableFocusTrap) {
                        if (shouldRenderToParent) // We need to move the focus to the previous interactive element before popup trigger
                        requestFrame(function() {
                            var isPopupFocusOut = popupRef && !popupRef.contains(document.activeElement);
                            if (isPopupFocusOut) closePopup(event);
                        });
                        else requestFrame(function() {
                            if (!document.hasFocus()) closePopup(event);
                        });
                        return;
                    }
                }
                if (isLayerDisabled()) return;
                if (key === 'Escape' || key === 'Esc') {
                    if (triggerRef && autoFocus) triggerRef.focus();
                    closePopup(event);
                }
            } else {
                if (isLayerDisabled()) return;
                var _key = event.key;
                if (_key === 'Escape' || _key === 'Esc' || shouldCloseOnTab && _key === 'Tab') closePopup(event);
            }
        };
        var parentUnbind;
        // if the popup is inside iframe, we want to listen to click events outside iframe,
        // to close the popup correctly in the iframe.
        if (inIframe && isOpen) parentUnbind = (0, $k6Bkl.bind)(window.parent.window, {
            type: 'click',
            listener: onClick,
            options: {
                capture: capture
            }
        });
        var unbind = (0, $hCEX5.default);
        if ((0, $i2LcI.fg)('popup-onclose-fix')) setTimeout(function() {
            unbind = (0, $k6Bkl.bindAll)(window, [
                {
                    type: 'click',
                    listener: onClick,
                    options: {
                        capture: capture
                    }
                },
                {
                    type: 'keydown',
                    listener: onKeyDown
                }
            ]);
        }, 0);
        else unbind = (0, $k6Bkl.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        // bind onBlur event listener to fix popup not close when clicking on iframe outside
        var unbindBlur = (0, $hCEX5.default);
        unbindBlur = (0, $k6Bkl.bind)(window, {
            type: 'blur',
            listener: function onBlur(e) {
                if (isLayerDisabled() || !(document.activeElement instanceof HTMLIFrameElement)) return;
                closePopup(e);
            }
        });
        return function() {
            var _parentUnbind;
            if ((0, $i2LcI.fg)('popup-onclose-fix')) setTimeout(function() {
                unbind();
            }, 0);
            else unbind();
            cancelAllFrames();
            (_parentUnbind = parentUnbind) === null || _parentUnbind === void 0 || _parentUnbind();
            unbindBlur();
        };
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        autoFocus,
        shouldDisableFocusTrap,
        capture,
        isLayerDisabled,
        shouldCloseOnTab,
        currentLevel,
        shouldRenderToParent,
        requestFrame,
        cancelAllFrames
    ]);
};

});
parcelRegister("hCEX5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd45c0815762c962$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ function $cd45c0815762c962$export$2e2bcd8739ae039() {}

});

parcelRegister("kRuDs", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", function () { return $f300856bbfa8050b$export$3dee5e4542c672d9; });
var $f300856bbfa8050b$var$interactiveTags = [
    'button',
    'a',
    'input',
    'select',
    'textarea'
];
var $f300856bbfa8050b$export$3dee5e4542c672d9 = function isInteractiveElement(element) {
    if ($f300856bbfa8050b$var$interactiveTags.includes(element.tagName.toLowerCase())) return true;
    if (element.getAttribute('tabindex') !== null || element.hasAttribute('contenteditable')) return true;
    return false;
};

});

parcelRegister("7P9XC", function(module, exports) {

$parcel$export(module.exports, "useAnimationFrame", function () { return $5b2505cdb3b7f164$export$641fa9c94086b46e; });

var $8ZuGG = parcelRequire("8ZuGG");
var $5b2505cdb3b7f164$export$641fa9c94086b46e = function useAnimationFrame() {
    var animationsRef = (0, $8ZuGG.useRef)([]);
    var requestFrame = (0, $8ZuGG.useCallback)(function(callback) {
        var id = requestAnimationFrame(callback);
        animationsRef.current.push(id);
        return id;
    }, []);
    var cancelFrame = (0, $8ZuGG.useCallback)(function(id) {
        cancelAnimationFrame(id);
        animationsRef.current = animationsRef.current.filter(function(frameId) {
            return frameId !== id;
        });
    }, []);
    var cancelAllFrames = (0, $8ZuGG.useCallback)(function() {
        animationsRef.current.forEach(function(id) {
            return cancelAnimationFrame(id);
        });
        animationsRef.current = [];
    }, []);
    return {
        requestFrame: requestFrame,
        cancelFrame: cancelFrame,
        cancelAllFrames: cancelAllFrames
    };
};

});


parcelRegister("2CUAV", function(module, exports) {

$parcel$export(module.exports, "useFocusManager", function () { return $1e9b07db958a558b$export$10c5169755ce7bd7; });

var $8ZuGG = parcelRequire("8ZuGG");

var $eEaSu = parcelRequire("eEaSu");

var $hCEX5 = parcelRequire("hCEX5");

var $lDjMh = parcelRequire("lDjMh");

var $i2LcI = parcelRequire("i2LcI");

var $7P9XC = parcelRequire("7P9XC");
var $1e9b07db958a558b$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, autoFocus = _ref.autoFocus, shouldCloseOnTab = _ref.shouldCloseOnTab, shouldDisableFocusTrap = _ref.shouldDisableFocusTrap, shouldReturnFocus = _ref.shouldReturnFocus, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useAnimationFrame = (0, $7P9XC.useAnimationFrame)(), requestFrame = _useAnimationFrame.requestFrame, cancelAllFrames = _useAnimationFrame.cancelAllFrames;
    var _useLayering = (0, $lDjMh.useLayering)(), currentLevel = _useLayering.currentLevel;
    (0, $8ZuGG.useEffect)(function() {
        if (!popupRef || shouldCloseOnTab) return 0, $hCEX5.default;
        if (shouldDisableFocusTrap && (0, $i2LcI.fg)('platform_dst_popup-disable-focuslock')) {
            var isDropdown = popupRef.matches('[id^=ds--dropdown--]');
            var popups = document.querySelectorAll("[data-ds--level=\"".concat(currentLevel - 1, "\"]"));
            if (!(popups[popups.length - 1] && !shouldRenderToParent && isDropdown)) {
                // Plucking trigger & popup content container from the tab order so that
                // when we Shift+Tab, the focus moves to the element before trigger
                requestFrame(function() {
                    triggerRef === null || triggerRef === void 0 || triggerRef.setAttribute('tabindex', '-1');
                    if (popupRef && autoFocus) popupRef.setAttribute('tabindex', '-1');
                    (initialFocusRef || popupRef).focus();
                });
                return 0, $hCEX5.default;
            }
        }
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: shouldReturnFocus
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($eEaSu)))(popupRef, trapConfig);
        // Wait for the popup to reposition itself before we focus
        requestFrame(function() {
            focusTrap.activate();
        });
        return function() {
            cancelAllFrames();
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        triggerRef,
        autoFocus,
        initialFocusRef,
        shouldCloseOnTab,
        shouldDisableFocusTrap,
        requestFrame,
        cancelAllFrames,
        shouldReturnFocus,
        shouldRenderToParent,
        currentLevel
    ]);
};

});
parcelRegister("eEaSu", function(module, exports) {

var $3LKNc = parcelRequire("3LKNc");
var $aa9d3d3bced3b577$var$listeningFocusTrap = null;
function $aa9d3d3bced3b577$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $aa9d3d3bced3b577$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($aa9d3d3bced3b577$var$listeningFocusTrap) $aa9d3d3bced3b577$var$listeningFocusTrap.pause();
        $aa9d3d3bced3b577$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $aa9d3d3bced3b577$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $aa9d3d3bced3b577$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $aa9d3d3bced3b577$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $aa9d3d3bced3b577$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $aa9d3d3bced3b577$var$tryFocus(lastTabbableNode);
            return $aa9d3d3bced3b577$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $aa9d3d3bced3b577$var$tryFocus(firstTabbableNode);
        $aa9d3d3bced3b577$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $3LKNc(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $aa9d3d3bced3b577$var$tryFocus(lastTabbableNode);
        $aa9d3d3bced3b577$var$tryFocus(firstTabbableNode);
    }
}
function $aa9d3d3bced3b577$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $aa9d3d3bced3b577$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $aa9d3d3bced3b577$var$focusTrap;

});
parcelRegister("3LKNc", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $2bea0ee4c0ebe41d$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $2bea0ee4c0ebe41d$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});




parcelRegister("49bH0", function(module, exports) {

$parcel$export(module.exports, "usePopupAppearance", function () { return $305112a0f254e4aa$export$4065aef1d79a5730; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $8BnTN = parcelRequire("8BnTN");
function $305112a0f254e4aa$export$4065aef1d79a5730(_ref) {
    var _appearance = _ref.appearance, _shouldRenderToParent = _ref.shouldRenderToParent;
    var mq = (0, $8BnTN.UNSAFE_useMediaQuery)('below.sm', function(e) {
        setIsSmallViewport(!!e.matches);
    });
    var _useState = (0, $8ZuGG.useState)(!!(mq !== null && mq !== void 0 && mq.matches)), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isSmallViewport = _useState2[0], setIsSmallViewport = _useState2[1];
    var appearance = _appearance === 'UNSAFE_modal-below-sm' && isSmallViewport ? 'UNSAFE_modal-below-sm' : 'default';
    var shouldRenderToParent = _shouldRenderToParent && appearance === 'default';
    return {
        appearance: appearance,
        shouldRenderToParent: shouldRenderToParent
    };
}

});
parcelRegister("8BnTN", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", function () { return $6434514852998ea7$export$49e55ae2c03d6045; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $1ZDja = parcelRequire("1ZDja");
var $6434514852998ea7$var$_window, $6434514852998ea7$var$_window$matchMedia, $6434514852998ea7$var$_window2, $6434514852998ea7$var$_window2$matchMedia, $6434514852998ea7$var$_window3, $6434514852998ea7$var$_window3$matchMedia, $6434514852998ea7$var$_window4, $6434514852998ea7$var$_window4$matchMedia, $6434514852998ea7$var$_window5, $6434514852998ea7$var$_window5$matchMedia, $6434514852998ea7$var$_window6, $6434514852998ea7$var$_window6$matchMedia, $6434514852998ea7$var$_window7, $6434514852998ea7$var$_window7$matchMedia, $6434514852998ea7$var$_window8, $6434514852998ea7$var$_window8$matchMedia, $6434514852998ea7$var$_window9, $6434514852998ea7$var$_window9$matchMedia, $6434514852998ea7$var$_window0, $6434514852998ea7$var$_window0$matchMedia, $6434514852998ea7$var$_window1, $6434514852998ea7$var$_window1$matchMedia;
var $6434514852998ea7$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window = window) === null || $6434514852998ea7$var$_window === void 0 || ($6434514852998ea7$var$_window$matchMedia = $6434514852998ea7$var$_window.matchMedia) === null || $6434514852998ea7$var$_window$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window$matchMedia.call($6434514852998ea7$var$_window, (0, $1ZDja.media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window2 = window) === null || $6434514852998ea7$var$_window2 === void 0 || ($6434514852998ea7$var$_window2$matchMedia = $6434514852998ea7$var$_window2.matchMedia) === null || $6434514852998ea7$var$_window2$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window2$matchMedia.call($6434514852998ea7$var$_window2, (0, $1ZDja.media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window3 = window) === null || $6434514852998ea7$var$_window3 === void 0 || ($6434514852998ea7$var$_window3$matchMedia = $6434514852998ea7$var$_window3.matchMedia) === null || $6434514852998ea7$var$_window3$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window3$matchMedia.call($6434514852998ea7$var$_window3, (0, $1ZDja.media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window4 = window) === null || $6434514852998ea7$var$_window4 === void 0 || ($6434514852998ea7$var$_window4$matchMedia = $6434514852998ea7$var$_window4.matchMedia) === null || $6434514852998ea7$var$_window4$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window4$matchMedia.call($6434514852998ea7$var$_window4, (0, $1ZDja.media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window5 = window) === null || $6434514852998ea7$var$_window5 === void 0 || ($6434514852998ea7$var$_window5$matchMedia = $6434514852998ea7$var$_window5.matchMedia) === null || $6434514852998ea7$var$_window5$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window5$matchMedia.call($6434514852998ea7$var$_window5, (0, $1ZDja.media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window6 = window) === null || $6434514852998ea7$var$_window6 === void 0 || ($6434514852998ea7$var$_window6$matchMedia = $6434514852998ea7$var$_window6.matchMedia) === null || $6434514852998ea7$var$_window6$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window6$matchMedia.call($6434514852998ea7$var$_window6, (0, $1ZDja.media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window7 = window) === null || $6434514852998ea7$var$_window7 === void 0 || ($6434514852998ea7$var$_window7$matchMedia = $6434514852998ea7$var$_window7.matchMedia) === null || $6434514852998ea7$var$_window7$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window7$matchMedia.call($6434514852998ea7$var$_window7, (0, $1ZDja.media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window8 = window) === null || $6434514852998ea7$var$_window8 === void 0 || ($6434514852998ea7$var$_window8$matchMedia = $6434514852998ea7$var$_window8.matchMedia) === null || $6434514852998ea7$var$_window8$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window8$matchMedia.call($6434514852998ea7$var$_window8, (0, $1ZDja.media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window9 = window) === null || $6434514852998ea7$var$_window9 === void 0 || ($6434514852998ea7$var$_window9$matchMedia = $6434514852998ea7$var$_window9.matchMedia) === null || $6434514852998ea7$var$_window9$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window9$matchMedia.call($6434514852998ea7$var$_window9, (0, $1ZDja.media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window0 = window) === null || $6434514852998ea7$var$_window0 === void 0 || ($6434514852998ea7$var$_window0$matchMedia = $6434514852998ea7$var$_window0.matchMedia) === null || $6434514852998ea7$var$_window0$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window0$matchMedia.call($6434514852998ea7$var$_window0, (0, $1ZDja.media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($6434514852998ea7$var$_window1 = window) === null || $6434514852998ea7$var$_window1 === void 0 || ($6434514852998ea7$var$_window1$matchMedia = $6434514852998ea7$var$_window1.matchMedia) === null || $6434514852998ea7$var$_window1$matchMedia === void 0 ? void 0 : $6434514852998ea7$var$_window1$matchMedia.call($6434514852998ea7$var$_window1, (0, $1ZDja.media).below.xl.replace('@media ', '').trim())
};
var $6434514852998ea7$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $8ZuGG.useRef)(listener);
    (0, $8ZuGG.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $6434514852998ea7$var$queries[queryString];
    (0, $8ZuGG.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $k6Bkl.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});


parcelRegister("e4sLc", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRef", function () { return $a3e7bf9c3803c041$export$7cc5c058dd769dff; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $tazez = parcelRequire("tazez");
var $a3e7bf9c3803c041$export$7cc5c058dd769dff = function useGetMemoizedMergedTriggerRef() {
    var _useState = (0, $8ZuGG.useState)(function() {
        return (0, $tazez.default)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 1), getMemoizedMergedTriggerRef = _useState2[0];
    return getMemoizedMergedTriggerRef;
};

});

parcelRegister("3YbX8", function(module, exports) {

$parcel$export(module.exports, "useGetMemoizedMergedTriggerRefNew", function () { return $2e403f3fa8773add$export$5d3a2de79e07b376; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $tazez = parcelRequire("tazez");
var $2e403f3fa8773add$export$5d3a2de79e07b376 = function useGetMemoizedMergedTriggerRefNew() {
    var _useState = (0, $8ZuGG.useState)(function() {
        return (0, $tazez.default)(function(ref, setTriggerRef) {
            return function(node) {
                if (node) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 1), getMemoizedMergedTriggerRefNew = _useState2[0];
    return getMemoizedMergedTriggerRefNew;
};

});



parcelRegister("2VWCX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222e61d255ed8501$export$2e2bcd8739ae039; });
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $1RZ27 = parcelRequire("1RZ27");

var $209ZD = parcelRequire("209ZD");

var $bmth4 = parcelRequire("bmth4");
var $222e61d255ed8501$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $222e61d255ed8501$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bmth4.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($222e61d255ed8501$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $222e61d255ed8501$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
var $222e61d255ed8501$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
var $222e61d255ed8501$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
var $222e61d255ed8501$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
var $222e61d255ed8501$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
var $222e61d255ed8501$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $222e61d255ed8501$var$Text = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, xcss = _ref.xcss, children = _ref.children;
    (0, $1RZ27.default)($222e61d255ed8501$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $209ZD.useHasTextAncestor)();
    var color = $222e61d255ed8501$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = /*#__PURE__*/ $8ZuGG.createElement(Component, {
        id: id,
        className: (0, $c4hjl.default)([
            $222e61d255ed8501$var$styles.root,
            size && $222e61d255ed8501$var$fontSizeMap[size],
            color && $222e61d255ed8501$var$textColorMap[color],
            maxLines && $222e61d255ed8501$var$styles.truncation,
            maxLines === 1 && $222e61d255ed8501$var$styles.breakAll,
            align && $222e61d255ed8501$var$styles["textAlign.".concat(align)],
            weight && $222e61d255ed8501$var$fontWeightMap[weight],
            Component === 'em' && $222e61d255ed8501$var$styles['as.em'],
            Component === 'strong' && $222e61d255ed8501$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref
    }, children);
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $209ZD.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $222e61d255ed8501$export$2e2bcd8739ae039 = $222e61d255ed8501$var$Text;

});
parcelRegister("209ZD", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", function () { return $175355479882286b$export$9322276ec105d055; });
$parcel$export(module.exports, "HasTextAncestorProvider", function () { return $175355479882286b$export$ae933c6cbe5643ad; });

var $8ZuGG = parcelRequire("8ZuGG");
var $175355479882286b$var$HasTextAncestorContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(false);
var $175355479882286b$export$9322276ec105d055 = function useHasTextAncestor() {
    return (0, $8ZuGG.useContext)($175355479882286b$var$HasTextAncestorContext);
};
var $175355479882286b$export$ae933c6cbe5643ad = $175355479882286b$var$HasTextAncestorContext.Provider;

});


parcelRegister("g17mV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba92749f7b242c89$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");


var $9cIs8 = parcelRequire("9cIs8");
var $ba92749f7b242c89$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
var $ba92749f7b242c89$var$iconWrapperStyles = null;
var $ba92749f7b242c89$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ var $ba92749f7b242c89$var$SelectedIcon = function SelectedIcon(_ref) {
    var appearance = _ref.appearance, isOpen = _ref.isOpen, label = _ref.label, spacing = _ref.spacing;
    var _typesMapping$appeara = (0, $9cIs8.typesMapping)[appearance], Icon = _typesMapping$appeara.icon, defaultLabel = _typesMapping$appeara.defaultLabel;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $c4hjl.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $ba92749f7b242c89$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        LEGACY_size: "medium",
        spacing: spacing
    }));
};
var $ba92749f7b242c89$export$2e2bcd8739ae039 = $ba92749f7b242c89$var$SelectedIcon;

});
parcelRegister("9cIs8", function(module, exports) {

$parcel$export(module.exports, "typesMapping", function () { return $6b37b771ddfad8ad$export$4d111645c0b39d5d; });

var $6MpMs = parcelRequire("6MpMs");

var $aLGCQ = parcelRequire("aLGCQ");

var $9JVgc = parcelRequire("9JVgc");

var $bFuo4 = parcelRequire("bFuo4");
var $6b37b771ddfad8ad$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFuo4))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9JVgc))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aLGCQ))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bFuo4))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6MpMs))),
        defaultLabel: 'error inline message'
    }
};

});
parcelRegister("6MpMs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4efb3944b1b08f6c$var$_react = $4efb3944b1b08f6c$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $4efb3944b1b08f6c$var$_statusError = $4efb3944b1b08f6c$var$_interopRequireDefault((parcelRequire("8Bu5q")));

var $4efb3944b1b08f6c$var$_error = $4efb3944b1b08f6c$var$_interopRequireDefault((parcelRequire("c6PdW")));
function $4efb3944b1b08f6c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4efb3944b1b08f6c$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $4efb3944b1b08f6c$var$_react.default.createElement($4efb3944b1b08f6c$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $4efb3944b1b08f6c$var$_error.default
    }, props));
$4efb3944b1b08f6c$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $4efb3944b1b08f6c$var$_default = module.exports.default = $4efb3944b1b08f6c$var$StatusErrorIcon;

});
parcelRegister("8Bu5q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64391e0071406d4d$var$_react = $64391e0071406d4d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $64391e0071406d4d$var$_baseNew = $64391e0071406d4d$var$_interopRequireDefault((parcelRequire("bxtOK")));
function $64391e0071406d4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64391e0071406d4d$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $64391e0071406d4d$var$_react.default.createElement($64391e0071406d4d$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$64391e0071406d4d$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $64391e0071406d4d$var$_default = module.exports.default = $64391e0071406d4d$var$StatusErrorIcon;

});
parcelRegister("bxtOK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("jREeF")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("jREeF")).Icon; });

var $jREeF = parcelRequire("jREeF");

});
parcelRegister("jREeF", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $e7622d8146a9bed3$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $e7622d8146a9bed3$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $e7622d8146a9bed3$var$svgStyles = null;
var $e7622d8146a9bed3$var$iconStyles = null;
var $e7622d8146a9bed3$var$utilityIconStyles = null;
var $e7622d8146a9bed3$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $e7622d8146a9bed3$var$baseHcmStyles = null;
var $e7622d8146a9bed3$var$scaleSize = null;
var $e7622d8146a9bed3$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e7622d8146a9bed3$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e7622d8146a9bed3$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $e7622d8146a9bed3$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $e7622d8146a9bed3$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $e7622d8146a9bed3$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $e7622d8146a9bed3$var$baseSizeMap[type];
    var viewBoxPadding = $e7622d8146a9bed3$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $e7622d8146a9bed3$var$utilSizes[spacing] : size === 'small' ? $e7622d8146a9bed3$var$coreSizeSmall[spacing] : $e7622d8146a9bed3$var$coreSizeMedium[spacing]
        ])
    }));
});
var $e7622d8146a9bed3$export$2e2bcd8739ae039 = $e7622d8146a9bed3$export$f04a61298a47a40f;

});



parcelRegister("c6PdW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d0dc794a0d6ea58$var$_react = $8d0dc794a0d6ea58$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $kPj4x = parcelRequire("kPj4x");
function $8d0dc794a0d6ea58$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d0dc794a0d6ea58$var$ErrorIcon = (props)=>/*#__PURE__*/ $8d0dc794a0d6ea58$var$_react.default.createElement($kPj4x.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$8d0dc794a0d6ea58$var$ErrorIcon.displayName = 'ErrorIcon';
var $8d0dc794a0d6ea58$var$_default = module.exports.default = $8d0dc794a0d6ea58$var$ErrorIcon;

});
parcelRegister("kPj4x", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $f2975d67fb03214f$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $f2975d67fb03214f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f2975d67fb03214f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f2975d67fb03214f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f2975d67fb03214f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $f2975d67fb03214f$var$iconStyles = null;
var $f2975d67fb03214f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $f2975d67fb03214f$var$baseHcmStyles = null;
var $f2975d67fb03214f$var$primaryEqualsSecondaryHcmStyles = null;
var $f2975d67fb03214f$var$secondaryTransparentHcmStyles = null;
var $f2975d67fb03214f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $f2975d67fb03214f$var$_objectSpread($f2975d67fb03214f$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $f2975d67fb03214f$var$sizeStyles[size]
        ])
    }));
});
var $f2975d67fb03214f$export$2e2bcd8739ae039 = $f2975d67fb03214f$export$f04a61298a47a40f;

});



parcelRegister("aLGCQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::750ecc162e36259ef90344888c589176>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6f5bb1a88e2efc$var$_react = $7d6f5bb1a88e2efc$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7d6f5bb1a88e2efc$var$_statusInformation = $7d6f5bb1a88e2efc$var$_interopRequireDefault((parcelRequire("jXECH")));

var $7d6f5bb1a88e2efc$var$_info = $7d6f5bb1a88e2efc$var$_interopRequireDefault((parcelRequire("lAzIY")));
function $7d6f5bb1a88e2efc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusInformationIcon.
 * This component is StatusInformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7d6f5bb1a88e2efc$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $7d6f5bb1a88e2efc$var$_react.default.createElement($7d6f5bb1a88e2efc$var$_statusInformation.default, Object.assign({
        name: "StatusInformationIcon",
        LEGACY_fallbackIcon: $7d6f5bb1a88e2efc$var$_info.default
    }, props));
$7d6f5bb1a88e2efc$var$StatusInformationIcon.displayName = 'StatusInformationIconMigration';
var $7d6f5bb1a88e2efc$var$_default = module.exports.default = $7d6f5bb1a88e2efc$var$StatusInformationIcon;

});
parcelRegister("jXECH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::456639fbdc991aefe1af05acf697365d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e88309edba25617e$var$_react = $e88309edba25617e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $e88309edba25617e$var$_baseNew = $e88309edba25617e$var$_interopRequireDefault((parcelRequire("bxtOK")));
function $e88309edba25617e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusInformation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e88309edba25617e$var$StatusInformationIcon = (props)=>/*#__PURE__*/ $e88309edba25617e$var$_react.default.createElement($e88309edba25617e$var$_baseNew.default, Object.assign({
        name: "StatusInformationIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.5 6.75v1.5h.75v4.25h1.5v-5A.75.75 0 0 0 8 6.75zM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$e88309edba25617e$var$StatusInformationIcon.displayName = 'StatusInformationIcon';
var $e88309edba25617e$var$_default = module.exports.default = $e88309edba25617e$var$StatusInformationIcon;

});

parcelRegister("lAzIY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb78abe627b47f4d$var$_react = $fb78abe627b47f4d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $kPj4x = parcelRequire("kPj4x");
function $fb78abe627b47f4d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fb78abe627b47f4d$var$InfoIcon = (props)=>/*#__PURE__*/ $fb78abe627b47f4d$var$_react.default.createElement($kPj4x.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props));
$fb78abe627b47f4d$var$InfoIcon.displayName = 'InfoIcon';
var $fb78abe627b47f4d$var$_default = module.exports.default = $fb78abe627b47f4d$var$InfoIcon;

});


parcelRegister("9JVgc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f966e8890debb57eaf4e6f167681f98b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7174bbba65f3b637$var$_react = $7174bbba65f3b637$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7174bbba65f3b637$var$_statusSuccess = $7174bbba65f3b637$var$_interopRequireDefault((parcelRequire("2G1sL")));

var $7174bbba65f3b637$var$_checkCircle = $7174bbba65f3b637$var$_interopRequireDefault((parcelRequire("azPe6")));
function $7174bbba65f3b637$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7174bbba65f3b637$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $7174bbba65f3b637$var$_react.default.createElement($7174bbba65f3b637$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $7174bbba65f3b637$var$_checkCircle.default
    }, props));
$7174bbba65f3b637$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $7174bbba65f3b637$var$_default = module.exports.default = $7174bbba65f3b637$var$StatusSuccessIcon;

});
parcelRegister("2G1sL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f30a37f78a337a9$var$_react = $1f30a37f78a337a9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $1f30a37f78a337a9$var$_baseNew = $1f30a37f78a337a9$var$_interopRequireDefault((parcelRequire("bxtOK")));
function $1f30a37f78a337a9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f30a37f78a337a9$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $1f30a37f78a337a9$var$_react.default.createElement($1f30a37f78a337a9$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$1f30a37f78a337a9$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $1f30a37f78a337a9$var$_default = module.exports.default = $1f30a37f78a337a9$var$StatusSuccessIcon;

});

parcelRegister("azPe6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7b34e8cb23c7aa43$var$_react = $7b34e8cb23c7aa43$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $kPj4x = parcelRequire("kPj4x");
function $7b34e8cb23c7aa43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7b34e8cb23c7aa43$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7b34e8cb23c7aa43$var$_react.default.createElement($kPj4x.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props));
$7b34e8cb23c7aa43$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7b34e8cb23c7aa43$var$_default = module.exports.default = $7b34e8cb23c7aa43$var$CheckCircleIcon;

});


parcelRegister("bFuo4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87eb184e8532a956$var$_react = $87eb184e8532a956$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $87eb184e8532a956$var$_statusWarning = $87eb184e8532a956$var$_interopRequireDefault((parcelRequire("55Cv3")));

var $87eb184e8532a956$var$_warning = $87eb184e8532a956$var$_interopRequireDefault((parcelRequire("7XoHy")));
function $87eb184e8532a956$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87eb184e8532a956$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $87eb184e8532a956$var$_react.default.createElement($87eb184e8532a956$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $87eb184e8532a956$var$_warning.default
    }, props));
$87eb184e8532a956$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $87eb184e8532a956$var$_default = module.exports.default = $87eb184e8532a956$var$StatusWarningIcon;

});
parcelRegister("55Cv3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b4b48ac8f8df435$var$_react = $3b4b48ac8f8df435$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $3b4b48ac8f8df435$var$_baseNew = $3b4b48ac8f8df435$var$_interopRequireDefault((parcelRequire("bxtOK")));
function $3b4b48ac8f8df435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b4b48ac8f8df435$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $3b4b48ac8f8df435$var$_react.default.createElement($3b4b48ac8f8df435$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$3b4b48ac8f8df435$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $3b4b48ac8f8df435$var$_default = module.exports.default = $3b4b48ac8f8df435$var$StatusWarningIcon;

});

parcelRegister("7XoHy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5cb134478ef010f2$var$_react = $5cb134478ef010f2$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $kPj4x = parcelRequire("kPj4x");
function $5cb134478ef010f2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5cb134478ef010f2$var$WarningIcon = (props)=>/*#__PURE__*/ $5cb134478ef010f2$var$_react.default.createElement($kPj4x.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$5cb134478ef010f2$var$WarningIcon.displayName = 'WarningIcon';
var $5cb134478ef010f2$var$_default = module.exports.default = $5cb134478ef010f2$var$WarningIcon;

});





parcelRegister("lk7yL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a03a067da55a05b7$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $dZRKj = parcelRequire("dZRKj");

var $gJFTu = parcelRequire("gJFTu");

var $1SvOA = parcelRequire("1SvOA");

var $3pP7q = parcelRequire("3pP7q");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
const $a03a067da55a05b7$var$getAcceptableCharsRegex = (codeType)=>{
    switch(codeType){
        case 'numeric':
            return '\\d';
        case 'alphanumeric':
            return '[A-Za-z\\d]';
        default:
            return '.';
    }
};
const $a03a067da55a05b7$var$sanitizeInput = (input, acceptableCharsRegex)=>{
    var _input_match;
    return ((_input_match = input.match(new RegExp(acceptableCharsRegex, 'g'))) === null || _input_match === void 0 ? void 0 : _input_match.join('')) || '';
};
const $a03a067da55a05b7$var$getInputValidation = (codeType, codeLength, acceptableCharsRegex, formatMessage)=>{
    if (codeLength === undefined) return {
        label: formatMessage((0, $3pP7q.default).mfFormLabel),
        pattern: `${acceptableCharsRegex}+`,
        maxLength: undefined
    };
    else {
        const descriptor = codeType == 'numeric' ? (0, $3pP7q.default).mfFormLabelNDigits : (0, $3pP7q.default).mfFormLabelNCharacters;
        return {
            label: formatMessage(descriptor, {
                codeLength: codeLength
            }),
            pattern: `${acceptableCharsRegex}{${codeLength}}`,
            maxLength: codeLength
        };
    }
};
const $a03a067da55a05b7$var$OtpCodeField = ({ codeLength: codeLength, codeType: codeType, disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, id: id, onChange: onChange, clearInputTrigger: clearInputTrigger })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const fieldTextRef = (0, $8ZuGG.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $8ZuGG.useState)('');
    const [fieldError, setFieldError] = (0, $8ZuGG.useState)(fieldErrorFromParent);
    const previousFieldErrorFromParent = (0, $7AZRg.usePrevious)(fieldErrorFromParent);
    const previousFieldValue = (0, $7AZRg.usePrevious)(fieldValue);
    const previousClearInputTrigger = (0, $7AZRg.usePrevious)(clearInputTrigger);
    const acceptableCharsRegex = $a03a067da55a05b7$var$getAcceptableCharsRegex(codeType);
    const { maxLength: maxLength, pattern: pattern, label: label } = $a03a067da55a05b7$var$getInputValidation(codeType, codeLength, acceptableCharsRegex, formatMessage);
    (0, $8ZuGG.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (clearInputTrigger && clearInputTrigger !== previousClearInputTrigger) {
            setFieldValue('');
            setFieldError(undefined);
        }
    }, [
        clearInputTrigger,
        previousClearInputTrigger
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const handlePaste = (0, $8ZuGG.useCallback)((e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const clipboardData = (e.clipboardData || window.clipboardData).getData('text/plain');
        const sanitized = $a03a067da55a05b7$var$sanitizeInput(clipboardData, acceptableCharsRegex);
        const middle = codeLength === undefined ? sanitized : sanitized.substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    }, [
        codeLength,
        acceptableCharsRegex
    ]);
    const handleChange = (0, $8ZuGG.useCallback)((e)=>{
        setFieldValue($a03a067da55a05b7$var$sanitizeInput(e.currentTarget.value, acceptableCharsRegex));
        setFieldError(undefined);
    }, [
        acceptableCharsRegex
    ]);
    const handleInvalid = (0, $8ZuGG.useCallback)((e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    }, []);
    (0, $8ZuGG.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, [
        handleInvalid,
        handlePaste
    ]);
    const errorContent = (error)=>{
        switch(error && error.errorCode){
            case 'invalid_otp':
                return formatMessage((0, $3pP7q.default).errorsInvalidOtp);
            case 'invalid_otp_format':
                return formatMessage((0, $3pP7q.default).errorsInvalidOtpFormat);
            case 'invalid_otp_pattern':
                return formatMessage((0, $3pP7q.default).errorsInvalidOtpPattern, {
                    codeLength: codeLength
                });
            case 'expired_otp':
                return formatMessage((0, $3pP7q.default).errorsExpiredOtp);
            case 'too_many_requests':
                return formatMessage((0, $3pP7q.default).errorsInvalidOtp);
            case 'unknown':
                return formatMessage((0, $3pP7q.default).errorsUnknown);
            case 'invalid_token':
                return /*#__PURE__*/ (0, $6rcps.jsxs)("form", {
                    onSubmit: ()=>window.location.reload(),
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.mfform.errors.invalid_token",
                            defaultMessage: "Your session has expired. Please refresh the page and try again."
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                                type: "submit",
                                isFullWidth: true,
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "common.refresh",
                                    defaultMessage: "Refresh"
                                })
                            })
                        })
                    ]
                });
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
        id: id,
        name: "otpCode",
        type: codeType === 'numeric' ? 'tel' : 'text',
        label: label,
        autoFocus: true,
        maxLength: maxLength,
        pattern: pattern,
        onChange: handleChange,
        isInvalid: !!fieldError,
        invalidMessage: !disabled && fieldError && errorContent(fieldError),
        value: fieldValue,
        isDisabled: disabled,
        isRequired: true,
        ref: fieldTextRef
    });
};
var $a03a067da55a05b7$export$2e2bcd8739ae039 = $a03a067da55a05b7$var$OtpCodeField;

});
parcelRegister("dZRKj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa6f56f48f3f9639$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $cT1nw = parcelRequire("cT1nw");

var $jjRCi = parcelRequire("jjRCi");
var $2iPY4 = parcelRequire("2iPY4");

var $7SrF8 = parcelRequire("7SrF8");
const $fa6f56f48f3f9639$var$FormTextField = (_param, ref)=>{
    var { name: name, label: label, isLabelHidden: isLabelHidden, invalidMessage: invalidMessage, testId: testId, isRequired: isRequired, elemAfterInput: elemAfterInput } = _param, props = (0, $42tc5._)(_param, [
        "name",
        "label",
        "isLabelHidden",
        "invalidMessage",
        "testId",
        "isRequired",
        "elemAfterInput"
    ]);
    const ariaDescribedBy = (fieldProps)=>{
        const invalidMessageError = invalidMessage ? `${fieldProps.id}-error` : '';
        var _props_ariadescribedby;
        const ariaDescribedByMessage = (_props_ariadescribedby = props['aria-describedby']) !== null && _props_ariadescribedby !== void 0 ? _props_ariadescribedby : '';
        return invalidMessageError.concat(' ', ariaDescribedByMessage);
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $2iPY4.default), {
        name: name,
        label: !isLabelHidden && label,
        isRequired: isRequired,
        "aria-required": isRequired,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $6rcps.jsxs)((0, $8ZuGG.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $7SrF8.default), {
                        alignBlock: "center",
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cT1nw.default), (0, $6EnDC._)((0, $ty6PY._)({}, fieldProps, props), {
                            isInvalid: !!invalidMessage,
                            "aria-describedby": ariaDescribedBy(fieldProps),
                            testId: testId,
                            ref: ref,
                            elemAfterInput: elemAfterInput
                        }))
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $jjRCi.MessageWrapper), {
                        children: invalidMessage && /*#__PURE__*/ (0, $6rcps.jsx)((0, $jjRCi.ErrorMessage), {
                            testId: "form-text-field--input-invalid-error-message-field--idf-testid",
                            children: invalidMessage
                        })
                    })
                ]
            })
    });
};
var $fa6f56f48f3f9639$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef($fa6f56f48f3f9639$var$FormTextField);

});
parcelRegister("cT1nw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $961bb0cfbce36a46$export$2e2bcd8739ae039; });
/* text-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $cd8Dz = parcelRequire("cd8Dz");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $8ZuGG = parcelRequire("8ZuGG");

var $1Muvn = parcelRequire("1Muvn");

var $i2LcI = parcelRequire("i2LcI");
var $961bb0cfbce36a46$var$_excluded = [
    "appearance",
    "className",
    "elemAfterInput",
    "elemBeforeInput",
    "isCompact",
    "isDisabled",
    "isInvalid",
    "isMonospaced",
    "isReadOnly",
    "isRequired",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseDown",
    "placeholder",
    "testId",
    "width"
];
function $961bb0cfbce36a46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $961bb0cfbce36a46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $961bb0cfbce36a46$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $961bb0cfbce36a46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $961bb0cfbce36a46$var$containerMedia = {
    invalid: "_msj6gir2",
    disabled: "_6up518qt"
};
var $961bb0cfbce36a46$var$inputMediaDisabled = null;
var $961bb0cfbce36a46$var$analyticsParams = {
    componentName: 'textField',
    packageName: "@atlaskit/textfield",
    packageVersion: "8.0.9"
};
var $961bb0cfbce36a46$var$disabledStyle = {
    standard: "_1h6dsyzs _bfhksyzs _syaz1lh4 _80om13gf",
    subtle: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf",
    none: "_1h6d1j28 _bfhk1j28 _syaz1lh4 _80om13gf"
};
var $961bb0cfbce36a46$var$invalidStyle = null;
var $961bb0cfbce36a46$var$focusWithinStyle = {
    standard: "_1p9x1p6i _qao9r01l _q433q049",
    subtle: "_1p9x1p6i _qao9r01l _q433q049",
    none: "_1p9x1j28 _qao91j28 _q4333sij"
};
var $961bb0cfbce36a46$var$hoverStyle = {
    standard: "_4cvx1elr _irr31d5g",
    subtle: "_4cvx1elr _irr31d5g",
    none: "_4cvx1j28 _irr31j28"
};
var $961bb0cfbce36a46$var$getContainerTextBgAndBorderColor = {
    standard: "_1h6d1elr _1dqonqa1 _syaz1fxt _80om1kdv _bfhk1j9a _msj6gir2",
    subtle: "_1h6d1j28 _1dqonqa1 _syaz1fxt _80om1kdv _16hg1j28 _msj6gir2",
    none: "_1h6d1j28 _1dqoglyw _syaz1fxt _80om1kdv _16hg1j28 _msj6gir2"
};
var $961bb0cfbce36a46$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
var $961bb0cfbce36a46$var$getMaxWidth = function getMaxWidth(width) {
    return !width ? "100%" : width in $961bb0cfbce36a46$var$widthMap ? "".concat($961bb0cfbce36a46$var$widthMap[width], "px") : "".concat(+width, "px");
};
var $961bb0cfbce36a46$var$containerStyleAppearance = {
    standard: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    subtle: "_1dqonqa1 _1q51e4h9 _85i5e4h9 _bozgidpf _y4tiidpf",
    none: "_1dqoglyw"
};
var $961bb0cfbce36a46$var$containerStyles = null;
var $961bb0cfbce36a46$var$inputDisabledStyle = null;
var $961bb0cfbce36a46$var$inputCompactStyleWithFg = null;
var $961bb0cfbce36a46$var$inputCompactStyle = null;
var $961bb0cfbce36a46$var$inputMonospacedStyle = null;
var $961bb0cfbce36a46$var$inputFontStyleWithFG = null;
var $961bb0cfbce36a46$var$inputStyleMonospacedWithFg = null;
var $961bb0cfbce36a46$var$inputStyleNotDataCompactWithFG = null;
var $961bb0cfbce36a46$var$inputStyle = null;
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ var $961bb0cfbce36a46$var$Textfield = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'standard' : _props$appearance, className = props.className, elemAfterInput = props.elemAfterInput, elemBeforeInput = props.elemBeforeInput, _props$isCompact = props.isCompact, isCompact = _props$isCompact === void 0 ? false : _props$isCompact, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isInvalid = props.isInvalid, isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid, _props$isMonospaced = props.isMonospaced, isMonospaced = _props$isMonospaced === void 0 ? false : _props$isMonospaced, _props$isReadOnly = props.isReadOnly, isReadOnly = _props$isReadOnly === void 0 ? false : _props$isReadOnly, _props$isRequired = props.isRequired, isRequired = _props$isRequired === void 0 ? false : _props$isRequired, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, onMouseDown = props.onMouseDown, placeholder = props.placeholder, testId = props.testId, width = props.width, spreadProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $961bb0cfbce36a46$var$_excluded);
    var inputRef = (0, $8ZuGG.useRef)(null);
    var handleOnFocus = (0, $1Muvn.usePlatformLeafEventHandler)($961bb0cfbce36a46$var$_objectSpread({
        fn: function fn(event) {
            onFocus && onFocus(event);
        },
        action: 'focused'
    }, $961bb0cfbce36a46$var$analyticsParams));
    var handleOnBlur = (0, $1Muvn.usePlatformLeafEventHandler)($961bb0cfbce36a46$var$_objectSpread({
        fn: function fn(event) {
            onBlur && onBlur(event);
        },
        action: 'blurred'
    }, $961bb0cfbce36a46$var$analyticsParams));
    var handleOnMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        var target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    var setInputRef = (0, $8ZuGG.useCallback)(function(inputElement) {
        inputRef.current = inputElement;
        if (!ref) return;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(ref) === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && "".concat(testId, "-container"),
        onMouseDown: handleOnMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c4hjl.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _11c82smr _1reo15vq _18m915vq _v564r5cv _189ee4h9 _1e0c1txw _vchhusvi _4cvr1h6o _1bah1yb4 _lcxv1wug _s7n4jp4b _slp31hna _1tnq1l7b",
            $961bb0cfbce36a46$var$getContainerTextBgAndBorderColor[appearance],
            $961bb0cfbce36a46$var$containerStyleAppearance[appearance],
            !isDisabled && $961bb0cfbce36a46$var$focusWithinStyle[appearance],
            !isDisabled && $961bb0cfbce36a46$var$hoverStyle[appearance],
            isDisabled && $961bb0cfbce36a46$var$containerMedia.disabled,
            isDisabled && $961bb0cfbce36a46$var$disabledStyle[appearance],
            isInvalid && $961bb0cfbce36a46$var$containerMedia.invalid,
            isInvalid && "_1h6d1bqt _4cvx1bqt _16qs13x5 _1dbz13x5 _uk1sr01l",
            className
        ]),
        style: {
            maxWidth: "".concat($961bb0cfbce36a46$var$getMaxWidth(width)),
            "--_x5k4n9": (0, $bT1Ur.default)("inset 0 0 0 ".concat("var(--ds-border-width, 1px)", " ", "var(--ds-border-danger, #E2483D)"))
        }
    }, elemBeforeInput, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, spreadProps, {
        "aria-invalid": isInvalid ? isInvalid : undefined,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired,
        className: (0, $c4hjl.default)([
            "_19itidpf _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _vchhusvi _1bsb1osq _1ul9idpf _bfhk1j28 _syaz1kw7 _80om1kw7 _14jiu2gc _olc6u2gc _1kod12x7 _7ba012x7 _1goxglyw _13xeglyw _1n7e1l2s _1idr131l",
            isMonospaced && "_ect41odn",
            isCompact && "_85i51b66 _1q511b66 _y4ti12x7 _bozg12x7",
            isDisabled && "_syaz1lh4 _1idr1lh4",
            isDisabled && "_1fnx18qt",
            !isCompact && (0, $i2LcI.fg)('platform_design_system_team_safari_input_fix') && "_14ji12x7 _olc612x7 _1kod12x7 _7ba012x7 _l9oiu2gc _549yu2gc _1h5w12x7 _124212x7",
            (0, $i2LcI.fg)('platform_design_system_team_safari_input_fix') && "_11c81ixg _1tn22smr",
            isCompact && (0, $i2LcI.fg)('platform_design_system_team_safari_input_fix') && "_11zpv77o _1l02v77o _daj712x7 _141f12x7 _1srd1b66 _oi9h1b66 _1e3012x7 _1txv12x7",
            isMonospaced && (0, $i2LcI.fg)('platform_design_system_team_safari_input_fix') && "_ect41odn _14md1odn"
        ])
    })), elemAfterInput);
});
var $961bb0cfbce36a46$export$2e2bcd8739ae039 = $961bb0cfbce36a46$var$Textfield;

});

parcelRegister("jjRCi", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", function () { return $e10961d509e08de9$export$915e9e7bd4f0f96d; });
$parcel$export(module.exports, "MessageWrapper", function () { return $e10961d509e08de9$export$ec445f12f63100a5; });
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $li0PD = parcelRequire("li0PD");

var $1Gcmm = parcelRequire("1Gcmm");

var $i2LcI = parcelRequire("i2LcI");

var $ku294 = parcelRequire("ku294");
/**
 * API for the internal `<Message />` component. This is not public API.
 */ /**
 * Public API of the various message components.
 */ var $e10961d509e08de9$var$messageStyles = null;
var $e10961d509e08de9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
var $e10961d509e08de9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
var $e10961d509e08de9$var$IconWrapper = function IconWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            $e10961d509e08de9$var$iconWrapperStyles.root
        ])
    }, children);
};
var $e10961d509e08de9$var$messageIcons = {
    error: /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($li0PD))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Gcmm))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success",
        size: "small"
    })
};
var $e10961d509e08de9$var$Message = function Message(_ref2) {
    var children = _ref2.children, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, fieldId = _ref2.fieldId, testId = _ref2.testId;
    var icon = $e10961d509e08de9$var$messageIcons[appearance];
    var isFeatureFlagEnabled = (0, $i2LcI.fg)('platform_dst_form_screenreader_message_fix');
    var _useContext = (0, $8ZuGG.useContext)($e10961d509e08de9$var$MessageWrapperContext), isWrapper = _useContext.isWrapper;
    var _useState = (0, $8ZuGG.useState)(isWrapper), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), shouldRenderContent = _useState2[0], setShouldRenderContent = _useState2[1];
    // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
    var messageRef = (0, $8ZuGG.useRef)(null);
    var _useState3 = (0, $8ZuGG.useState)(isWrapper), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), hasMessageWrapper = _useState4[0], setHasMessageWrapper = _useState4[1];
    (0, $8ZuGG.useEffect)(function() {
        if (isFeatureFlagEnabled) {
            if (!isWrapper) {
                // Delay rendering to ensure aria-live announcements work on first render if there is no wrapper
                var timer = setTimeout(function() {
                    setShouldRenderContent(true);
                }, 10);
                return function() {
                    return clearTimeout(timer);
                };
            } else // When using MessageWrapper, render content immediately since the wrapper handles aria-live
            setShouldRenderContent(true);
        } else // TODO: DSP-23603 - To clean up when removing "platform_dst_form_screenreader_message_fix" feature flag
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper,
        isFeatureFlagEnabled
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ var content = typeof children === 'string' ? children : /*#__PURE__*/ $8ZuGG.createElement("span", null, children);
    var childrenToRender = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, icon && /*#__PURE__*/ $8ZuGG.createElement($e10961d509e08de9$var$IconWrapper, null, icon), content);
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $c4hjl.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $e10961d509e08de9$var$messageAppearanceStyles[appearance]
        ])
    }, isFeatureFlagEnabled ? shouldRenderContent && childrenToRender : childrenToRender);
};
var $e10961d509e08de9$export$8fbe3c7d0ed2c683 = function HelperMessage(_ref3) {
    var children = _ref3.children, testId = _ref3.testId;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $ku294.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $8ZuGG.createElement($e10961d509e08de9$var$Message, {
            fieldId: fieldId ? "".concat(fieldId, "-helper") : undefined,
            testId: testId
        }, children);
    });
};
var $e10961d509e08de9$export$915e9e7bd4f0f96d = function ErrorMessage(_ref4) {
    var children = _ref4.children, testId = _ref4.testId;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $ku294.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $8ZuGG.createElement($e10961d509e08de9$var$Message, {
            appearance: "error",
            fieldId: fieldId ? "".concat(fieldId, "-error") : undefined,
            testId: testId
        }, children);
    });
};
var $e10961d509e08de9$export$5505afb209a532c8 = function ValidMessage(_ref5) {
    var children = _ref5.children, testId = _ref5.testId;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $ku294.FieldId).Consumer, null, function(fieldId) {
        return /*#__PURE__*/ $8ZuGG.createElement($e10961d509e08de9$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? "".concat(fieldId, "-valid") : undefined,
            testId: testId
        }, children);
    });
};
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ var $e10961d509e08de9$var$MessageWrapperContext = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    isWrapper: false
});
var $e10961d509e08de9$export$ec445f12f63100a5 = function MessageWrapper(_ref6) {
    var children = _ref6.children;
    var contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ $8ZuGG.createElement($e10961d509e08de9$var$MessageWrapperContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ $8ZuGG.createElement("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("li0PD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7fbec93f8e3a48e$var$_react = $f7fbec93f8e3a48e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $f7fbec93f8e3a48e$var$_statusError = $f7fbec93f8e3a48e$var$_interopRequireDefault((parcelRequire("tPJfu")));

var $f7fbec93f8e3a48e$var$_error = $f7fbec93f8e3a48e$var$_interopRequireDefault((parcelRequire("ajFEr")));
function $f7fbec93f8e3a48e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7fbec93f8e3a48e$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $f7fbec93f8e3a48e$var$_react.default.createElement($f7fbec93f8e3a48e$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $f7fbec93f8e3a48e$var$_error.default
    }, props));
$f7fbec93f8e3a48e$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $f7fbec93f8e3a48e$var$_default = module.exports.default = $f7fbec93f8e3a48e$var$StatusErrorIcon;

});
parcelRegister("tPJfu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $059ad5d07cd7b425$var$_react = $059ad5d07cd7b425$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $059ad5d07cd7b425$var$_baseNew = $059ad5d07cd7b425$var$_interopRequireDefault((parcelRequire("6Q8XB")));
function $059ad5d07cd7b425$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $059ad5d07cd7b425$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $059ad5d07cd7b425$var$_react.default.createElement($059ad5d07cd7b425$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$059ad5d07cd7b425$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $059ad5d07cd7b425$var$_default = module.exports.default = $059ad5d07cd7b425$var$StatusErrorIcon;

});
parcelRegister("6Q8XB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("1MAry")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("1MAry")).Icon; });

var $1MAry = parcelRequire("1MAry");

});
parcelRegister("1MAry", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $14c68b0be2909fad$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $14c68b0be2909fad$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $14c68b0be2909fad$var$svgStyles = null;
var $14c68b0be2909fad$var$iconStyles = null;
var $14c68b0be2909fad$var$utilityIconStyles = null;
var $14c68b0be2909fad$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $14c68b0be2909fad$var$baseHcmStyles = null;
var $14c68b0be2909fad$var$scaleSize = null;
var $14c68b0be2909fad$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $14c68b0be2909fad$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $14c68b0be2909fad$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $14c68b0be2909fad$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $14c68b0be2909fad$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $14c68b0be2909fad$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $14c68b0be2909fad$var$baseSizeMap[type];
    var viewBoxPadding = $14c68b0be2909fad$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $14c68b0be2909fad$var$utilSizes[spacing] : size === 'small' ? $14c68b0be2909fad$var$coreSizeSmall[spacing] : $14c68b0be2909fad$var$coreSizeMedium[spacing]
        ])
    }));
});
var $14c68b0be2909fad$export$2e2bcd8739ae039 = $14c68b0be2909fad$export$f04a61298a47a40f;

});



parcelRegister("ajFEr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $782bfccad0cd682e$var$_react = $782bfccad0cd682e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7EQIS = parcelRequire("7EQIS");
function $782bfccad0cd682e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $782bfccad0cd682e$var$ErrorIcon = (props)=>/*#__PURE__*/ $782bfccad0cd682e$var$_react.default.createElement($7EQIS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$782bfccad0cd682e$var$ErrorIcon.displayName = 'ErrorIcon';
var $782bfccad0cd682e$var$_default = module.exports.default = $782bfccad0cd682e$var$ErrorIcon;

});
parcelRegister("7EQIS", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $59352a781691ec21$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $59352a781691ec21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59352a781691ec21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59352a781691ec21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59352a781691ec21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $59352a781691ec21$var$iconStyles = null;
var $59352a781691ec21$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $59352a781691ec21$var$baseHcmStyles = null;
var $59352a781691ec21$var$primaryEqualsSecondaryHcmStyles = null;
var $59352a781691ec21$var$secondaryTransparentHcmStyles = null;
var $59352a781691ec21$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $59352a781691ec21$var$_objectSpread($59352a781691ec21$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $59352a781691ec21$var$sizeStyles[size]
        ])
    }));
});
var $59352a781691ec21$export$2e2bcd8739ae039 = $59352a781691ec21$export$f04a61298a47a40f;

});



parcelRegister("1Gcmm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::849e146248de3896aa5effb6cb325c8d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $13934d1451f4ae8f$var$_react = $13934d1451f4ae8f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $13934d1451f4ae8f$var$_statusSuccess = $13934d1451f4ae8f$var$_interopRequireDefault((parcelRequire("dZn4i")));

var $13934d1451f4ae8f$var$_success = $13934d1451f4ae8f$var$_interopRequireDefault((parcelRequire("3fr9d")));
function $13934d1451f4ae8f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusSuccessIcon.
 * This component is StatusSuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $13934d1451f4ae8f$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $13934d1451f4ae8f$var$_react.default.createElement($13934d1451f4ae8f$var$_statusSuccess.default, Object.assign({
        name: "StatusSuccessIcon",
        LEGACY_fallbackIcon: $13934d1451f4ae8f$var$_success.default
    }, props));
$13934d1451f4ae8f$var$StatusSuccessIcon.displayName = 'StatusSuccessIconMigration';
var $13934d1451f4ae8f$var$_default = module.exports.default = $13934d1451f4ae8f$var$StatusSuccessIcon;

});
parcelRegister("dZn4i", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::174472a7e38932dc7a97866e0be8034a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2f2ddc515abc179$var$_react = $a2f2ddc515abc179$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $a2f2ddc515abc179$var$_baseNew = $a2f2ddc515abc179$var$_interopRequireDefault((parcelRequire("6Q8XB")));
function $a2f2ddc515abc179$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for success statuses and messaging. Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a2f2ddc515abc179$var$StatusSuccessIcon = (props)=>/*#__PURE__*/ $a2f2ddc515abc179$var$_react.default.createElement($a2f2ddc515abc179$var$_baseNew.default, Object.assign({
        name: "StatusSuccessIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0l5-6-1.152-.96z" clip-rule="evenodd"/>`
    }, props));
$a2f2ddc515abc179$var$StatusSuccessIcon.displayName = 'StatusSuccessIcon';
var $a2f2ddc515abc179$var$_default = module.exports.default = $a2f2ddc515abc179$var$StatusSuccessIcon;

});

parcelRegister("3fr9d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25d7d4c019b386a5$var$_react = $25d7d4c019b386a5$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $7EQIS = parcelRequire("7EQIS");
function $25d7d4c019b386a5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25d7d4c019b386a5$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $25d7d4c019b386a5$var$_react.default.createElement($7EQIS.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props));
$25d7d4c019b386a5$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $25d7d4c019b386a5$var$_default = module.exports.default = $25d7d4c019b386a5$var$EditorSuccessIcon;

});


parcelRegister("ku294", function(module, exports) {

$parcel$export(module.exports, "FieldId", function () { return $ee984601402f6cdc$export$3c4232819458a302; });

var $8ZuGG = parcelRequire("8ZuGG");
var $ee984601402f6cdc$export$3c4232819458a302 = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);

});


parcelRegister("2iPY4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ad592ede3a3b188$export$2e2bcd8739ae039; });
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $iNlvH = parcelRequire("iNlvH");

var $ku294 = parcelRequire("ku294");

var $iPnAZ = parcelRequire("iPnAZ");

var $elF0p = parcelRequire("elF0p");

var $1VVi7 = parcelRequire("1VVi7");
function $1ad592ede3a3b188$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ad592ede3a3b188$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ad592ede3a3b188$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ad592ede3a3b188$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ad592ede3a3b188$var$fieldWrapperStyles = null;
function $1ad592ede3a3b188$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $1ad592ede3a3b188$var$isFunction(x) {
    return typeof x === 'function';
}
// Must be exported to satisfy error TS4023 from Jira builds
// src/packages/servicedesk/virtual-agent/common/src/ui/base-text-field/index.tsx(10,14):
// error TS4023: Exported variable `BaseTextField` has or is using name
// `FieldComponentProps` from external module
// `/opt/atlassian/pipelines/agent/build/jira/tsDist/@atlaskit__form/app/src/field`
// but cannot be named.
function $1ad592ede3a3b188$var$usePreviousRef(current) {
    var ref = (0, $8ZuGG.useRef)(current);
    // will be updated on the next render
    (0, $8ZuGG.useEffect)(function() {
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $1ad592ede3a3b188$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(previousValue) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(currentValue) === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $1ad592ede3a3b188$export$2e2bcd8739ae039(props) {
    var _getCurrentValue;
    var _useContext = (0, $8ZuGG.useContext)((0, $iPnAZ.FormContext)), registerField = _useContext.registerField, getCurrentValue = _useContext.getCurrentValue;
    var isDisabled = (0, $8ZuGG.useContext)((0, $iPnAZ.IsDisabledContext)) || props.isDisabled || false;
    var defaultValue = $1ad592ede3a3b188$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    var latestPropsRef = $1ad592ede3a3b188$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ var isDefaultValueChanged = !$1ad592ede3a3b188$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    var _useState = (0, $8ZuGG.useState)({
        fieldProps: {
            onChange: function onChange() {},
            onBlur: function onBlur() {},
            onFocus: function onFocus() {},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
         * effectively made it an optional prop to external consumers of Field. However the
         * prop types defined defaultValue as required, so inside the component it was not
         * valid for defaultValue to be undefined. We need to suppress the error
         * after changing defaultValue to explicitly be an optional prop.
         * If default value has changed we are using new default value.
         * Otherwise we need to check if we already have value for this field
         * (because we are using changing key prop to re-run field level validation, and that
         * cause the component re-mounting) to not override the actual value with the default value.
         */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : (_getCurrentValue = getCurrentValue(props.name)) !== null && _getCurrentValue !== void 0 ? _getCurrentValue : defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var latestStateRef = $1ad592ede3a3b188$var$usePreviousRef(state);
    (0, $8ZuGG.useEffect)(function() {
        function fieldStateToMeta() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        var unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $1ad592ede3a3b188$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, function(fieldState) {
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ var modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ var modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ var modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            var modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ var modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($1ad592ede3a3b188$var$isEvent(eventOrValue)) {
                    var currentTarget = eventOrValue.currentTarget;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: function onChange(e) {
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: function getValidator() {
                return function validate(value, formState, fieldState) {
                    var supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                };
            }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    var uid = (0, $iNlvH.useId)();
    var fieldId = (0, $8ZuGG.useMemo)(function() {
        return props.id ? props.id : "".concat(props.name, "-").concat(uid);
    }, [
        props.id,
        props.name,
        uid
    ]);
    var getDescribedBy = function getDescribedBy() {
        var value = '';
        if (state.error) value += "".concat(fieldId, "-error ");
        if (state.valid) value += "".concat(fieldId, "-valid ");
        return "".concat(value).concat(fieldId, "-helper");
    };
    var extendedFieldProps = $1ad592ede3a3b188$var$_objectSpread($1ad592ede3a3b188$var$_objectSpread({}, state.fieldProps), {}, {
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': "".concat(fieldId, "-label"),
        id: fieldId
    });
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": props.testId,
        className: (0, $c4hjl.default)([
            "_1pfhu2gc"
        ])
    }, props.label && /*#__PURE__*/ $8ZuGG.createElement((0, $elF0p.Label), {
        htmlFor: fieldId,
        id: "".concat(fieldId, "-label"),
        testId: props.testId && "".concat(props.testId, "--label")
    }, props.label, props.isRequired && /*#__PURE__*/ $8ZuGG.createElement((0, $1VVi7.default), null), props.elementAfterLabel), /*#__PURE__*/ $8ZuGG.createElement((0, $ku294.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("iPnAZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", function () { return $db4f4b00c243d969$export$c24727297075ec6a; });
$parcel$export(module.exports, "IsDisabledContext", function () { return $db4f4b00c243d969$export$c17cf6b332a82dbc; });
$parcel$export(module.exports, "default", function () { return $db4f4b00c243d969$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $kzxJM = parcelRequire("kzxJM");

var $2BdO3 = parcelRequire("2BdO3");

var $8rEue = parcelRequire("8rEue");

var $i2LcI = parcelRequire("i2LcI");

var $2T93J = parcelRequire("2T93J");
var $db4f4b00c243d969$export$c24727297075ec6a = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    registerField: function registerField() {
        return function() {};
    },
    getCurrentValue: function getCurrentValue() {
        return undefined;
    },
    subscribe: function subscribe() {
        return function() {};
    }
});
var $db4f4b00c243d969$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $8ZuGG.createContext)(false);
function $db4f4b00c243d969$export$2e2bcd8739ae039(props) {
    var userProvidedFormProps = props.formProps, onSubmit = props.onSubmit;
    var formRef = (0, $8ZuGG.useRef)(null);
    var onSubmitRef = (0, $8ZuGG.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    var _useState = (0, $8ZuGG.useState)(function() {
        // Types here would break the existing API
        var finalForm = (0, $kzxJM.createForm)({
            onSubmit: function onSubmit() {
                return onSubmitRef.current.apply(onSubmitRef, arguments);
            },
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: function setDefaultValue(_ref, state) {
                    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), name = _ref2[0], defaultValue = _ref2[1];
                    if (state.formState.initialValues) {
                        var initialValues = state.formState.initialValues;
                        var values = state.formState.values;
                        var _value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($8rEue)))(initialValues, name, _value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($8rEue)))(values, name, _value);
                    }
                }
            }
        });
        (0, $2BdO3.default)(function() {
            return formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [];
        }, (0, $i2LcI.fg)('platform-form-field-error-focus') ? (0, $2T93J.getFirstErrorField) : undefined)(finalForm);
        return finalForm;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 1), form = _useState2[0];
    var _useState3 = (0, $8ZuGG.useState)({
        dirty: false,
        submitting: false
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), state = _useState4[0], setState = _useState4[1];
    (0, $8ZuGG.useEffect)(function() {
        var unsubscribe = form.subscribe(function(_ref3) {
            var dirty = _ref3.dirty, submitting = _ref3.submitting;
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    var registerField = (0, $8ZuGG.useCallback)(function(name, defaultValue, subscriber, subscription, config) {
        form.pauseValidation();
        var unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    var handleSubmit = function handleSubmit(e) {
        if (e) e.preventDefault();
        form.submit();
    };
    var handleReset = function handleReset(initialValues) {
        form.reset(initialValues);
    };
    var handleKeyDown = function handleKeyDown(e) {
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            var submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    var _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, children = props.children;
    var dirty = state.dirty, submitting = state.submitting;
    /**
   * This method is needed in FormContext to use it on the field level
   * to check the current value of the field in case of the component re-mounting.
   */ var getCurrentValue = (0, $8ZuGG.useCallback)(function(name) {
        var formState = form.getState();
        return (formState === null || formState === void 0 ? void 0 : formState.values[name]) || undefined;
    }, [
        form
    ]);
    var FormContextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    // Abstracting so we can use the same for both rendering patterns
    var formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: formRef
    };
    var childrenContent = function() {
        if (typeof children === 'function') {
            var result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: function getState() {
                    return form.getState();
                },
                getValues: function getValues() {
                    return form.getState().values;
                },
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        } else return (0, $i2LcI.fg)('platform_design-system-team_form-upgrade') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("form", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, formProps, userProvidedFormProps), children) : children;
    }();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($db4f4b00c243d969$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($db4f4b00c243d969$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, childrenContent));
}

});
parcelRegister("kzxJM", function(module, exports) {

$parcel$export(module.exports, "getIn", function () { return $efa13f13745d759f$export$c52e5867d5879e24; });
$parcel$export(module.exports, "createForm", function () { return $efa13f13745d759f$export$f681a8129d2e9d28; });

var $6vRlT = parcelRequire("6vRlT");

var $4KVmf = parcelRequire("4KVmf");
//      
var $efa13f13745d759f$var$charCodeOfDot = ".".charCodeAt(0);
var $efa13f13745d759f$var$reEscapeChar = /\\(\\)?/g;
var $efa13f13745d759f$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $efa13f13745d759f$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $efa13f13745d759f$var$charCodeOfDot) result.push("");
    string.replace($efa13f13745d759f$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($efa13f13745d759f$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $efa13f13745d759f$var$keysCache = {};
var $efa13f13745d759f$var$keysRegex = /[.[\]]+/;
var $efa13f13745d759f$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($efa13f13745d759f$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $efa13f13745d759f$var$keysCache[key] = key.split($efa13f13745d759f$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $efa13f13745d759f$var$keysCache[key] = $efa13f13745d759f$var$stringToPath(key);
    }
    return $efa13f13745d759f$var$keysCache[key];
};
//      
var $efa13f13745d759f$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $efa13f13745d759f$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $efa13f13745d759f$var$_toPropertyKey(arg) {
    var key = $efa13f13745d759f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $efa13f13745d759f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $efa13f13745d759f$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $4KVmf.default)(current, [
                key
            ].map($efa13f13745d759f$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $6vRlT.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $efa13f13745d759f$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $efa13f13745d759f$var$setInRecursor(state, 0, $efa13f13745d759f$var$toPath(key), value1, destroyArrays);
};
var $efa13f13745d759f$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $efa13f13745d759f$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $efa13f13745d759f$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $efa13f13745d759f$export$c52e5867d5879e24(values, name);
    var error = $efa13f13745d759f$export$c52e5867d5879e24(errors, name);
    if (error && error[$efa13f13745d759f$export$735bebc8ffabf28a]) error = error[$efa13f13745d759f$export$735bebc8ffabf28a];
    var submitError = submitErrors && $efa13f13745d759f$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $efa13f13745d759f$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($efa13f13745d759f$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $efa13f13745d759f$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $efa13f13745d759f$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $efa13f13745d759f$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$efa13f13745d759f$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $efa13f13745d759f$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $efa13f13745d759f$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $efa13f13745d759f$var$subscriptionFilter(result, state, previousState, subscription, $efa13f13745d759f$export$41e855cb628c1b55, $efa13f13745d759f$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $efa13f13745d759f$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $efa13f13745d759f$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $efa13f13745d759f$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $efa13f13745d759f$var$subscriptionFilter(result, state, previousState, subscription, $efa13f13745d759f$export$f1ff97b9d1c7a3c3, $efa13f13745d759f$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $efa13f13745d759f$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$efa13f13745d759f$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $efa13f13745d759f$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $efa13f13745d759f$export$83d89fbfd8236492 = "4.20.10";
var $efa13f13745d759f$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $efa13f13745d759f$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $efa13f13745d759f$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $efa13f13745d759f$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $efa13f13745d759f$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $efa13f13745d759f$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $efa13f13745d759f$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $efa13f13745d759f$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($efa13f13745d759f$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $efa13f13745d759f$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $6vRlT.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $6vRlT.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $efa13f13745d759f$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $6vRlT.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $6vRlT.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $6vRlT.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $efa13f13745d759f$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $efa13f13745d759f$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $efa13f13745d759f$export$e6bdf135a54e021b,
                    shallowEqual: $efa13f13745d759f$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $6vRlT.default)({}, state.formState.values)); // clone to avoid writing
            if ($efa13f13745d759f$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($efa13f13745d759f$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $efa13f13745d759f$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $efa13f13745d759f$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $6vRlT.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $6vRlT.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $efa13f13745d759f$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $efa13f13745d759f$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $efa13f13745d759f$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$efa13f13745d759f$export$735bebc8ffabf28a]) {
                    var existing = $efa13f13745d759f$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$efa13f13745d759f$export$735bebc8ffabf28a] = error[$efa13f13745d759f$export$735bebc8ffabf28a];
                    merged = $efa13f13745d759f$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$efa13f13745d759f$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$efa13f13745d759f$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $6vRlT.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $efa13f13745d759f$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $efa13f13745d759f$var$notify(fieldSubscriber, fieldState, lastFieldState, $efa13f13745d759f$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $efa13f13745d759f$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $6vRlT.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($efa13f13745d759f$export$c52e5867d5879e24(formState.values, key), $efa13f13745d759f$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($efa13f13745d759f$export$c52e5867d5879e24(formState.values, key), $efa13f13745d759f$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$efa13f13745d759f$var$hasAnyError(formState.errors) && !(formState.submitErrors && $efa13f13745d759f$var$hasAnyError(formState.submitErrors));
        var nextFormState = $efa13f13745d759f$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $efa13f13745d759f$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $efa13f13745d759f$var$notify(state.subscribers, nextFormState, lastFormState, $efa13f13745d759f$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $6vRlT.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($efa13f13745d759f$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $6vRlT.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $6vRlT.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($efa13f13745d759f$export$c52e5867d5879e24(formState.values, key), $efa13f13745d759f$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $efa13f13745d759f$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $efa13f13745d759f$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $efa13f13745d759f$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $efa13f13745d759f$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $efa13f13745d759f$export$c52e5867d5879e24(state.formState.values, name) === $efa13f13745d759f$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $efa13f13745d759f$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $efa13f13745d759f$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $6vRlT.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $6vRlT.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $6vRlT.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $efa13f13745d759f$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$efa13f13745d759f$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $6vRlT.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $efa13f13745d759f$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $efa13f13745d759f$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $efa13f13745d759f$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $efa13f13745d759f$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("2BdO3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e49bf224e4132ab$export$2e2bcd8739ae039; });

var $kzxJM = parcelRequire("kzxJM");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $1e49bf224e4132ab$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $1e49bf224e4132ab$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($1e49bf224e4132ab$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $1e49bf224e4132ab$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $kzxJM.getIn)(errors, input.name);
    });
};
//      
var $1e49bf224e4132ab$var$noop = function noop() {};
var $1e49bf224e4132ab$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $1e49bf224e4132ab$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $1e49bf224e4132ab$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $1e49bf224e4132ab$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $1e49bf224e4132ab$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($1e49bf224e4132ab$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$1e49bf224e4132ab$export$2e2bcd8739ae039 = $1e49bf224e4132ab$var$createDecorator;

});

parcelRegister("8rEue", function(module, exports) {

var $aainr = parcelRequire("aainr");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $6260402b2c3cd441$var$set(object, path, value) {
    return object == null ? object : $aainr(object, path, value);
}
module.exports = $6260402b2c3cd441$var$set;

});
parcelRegister("aainr", function(module, exports) {

var $7kTLi = parcelRequire("7kTLi");

var $4AEPk = parcelRequire("4AEPk");

var $63N0J = parcelRequire("63N0J");

var $afeb3 = parcelRequire("afeb3");

var $9AU0a = parcelRequire("9AU0a");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $766917d72361e1a3$var$baseSet(object, path, value, customizer) {
    if (!$afeb3(object)) return object;
    path = $4AEPk(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $9AU0a(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $afeb3(objValue) ? objValue : $63N0J(path[index + 1]) ? [] : {};
        }
        $7kTLi(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $766917d72361e1a3$var$baseSet;

});
parcelRegister("7kTLi", function(module, exports) {

var $iPs7M = parcelRequire("iPs7M");

var $lsEFg = parcelRequire("lsEFg");
/** Used for built-in method references. */ var $5575a7d10f820681$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5575a7d10f820681$var$hasOwnProperty = $5575a7d10f820681$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5575a7d10f820681$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($5575a7d10f820681$var$hasOwnProperty.call(object, key) && $lsEFg(objValue, value)) || value === undefined && !(key in object)) $iPs7M(object, key, value);
}
module.exports = $5575a7d10f820681$var$assignValue;

});
parcelRegister("iPs7M", function(module, exports) {

var $2MEcT = parcelRequire("2MEcT");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $db52ce549b83a0dc$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $2MEcT) $2MEcT(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $db52ce549b83a0dc$var$baseAssignValue;

});
parcelRegister("2MEcT", function(module, exports) {

var $hAZ8T = parcelRequire("hAZ8T");
var $206f40bcdb7d1076$var$defineProperty = function() {
    try {
        var func = $hAZ8T(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $206f40bcdb7d1076$var$defineProperty;

});
parcelRegister("hAZ8T", function(module, exports) {

var $1InBm = parcelRequire("1InBm");

var $ihVQJ = parcelRequire("ihVQJ");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ccf53a115a52b0b4$var$getNative(object, key) {
    var value = $ihVQJ(object, key);
    return $1InBm(value) ? value : undefined;
}
module.exports = $ccf53a115a52b0b4$var$getNative;

});
parcelRegister("1InBm", function(module, exports) {

var $a0PyB = parcelRequire("a0PyB");

var $h09K1 = parcelRequire("h09K1");

var $afeb3 = parcelRequire("afeb3");

var $hJu0d = parcelRequire("hJu0d");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $13fc3543c2da06e0$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $13fc3543c2da06e0$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $13fc3543c2da06e0$var$funcProto = Function.prototype, $13fc3543c2da06e0$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $13fc3543c2da06e0$var$funcToString = $13fc3543c2da06e0$var$funcProto.toString;
/** Used to check objects for own properties. */ var $13fc3543c2da06e0$var$hasOwnProperty = $13fc3543c2da06e0$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $13fc3543c2da06e0$var$reIsNative = RegExp('^' + $13fc3543c2da06e0$var$funcToString.call($13fc3543c2da06e0$var$hasOwnProperty).replace($13fc3543c2da06e0$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $13fc3543c2da06e0$var$baseIsNative(value) {
    if (!$afeb3(value) || $h09K1(value)) return false;
    var pattern = $a0PyB(value) ? $13fc3543c2da06e0$var$reIsNative : $13fc3543c2da06e0$var$reIsHostCtor;
    return pattern.test($hJu0d(value));
}
module.exports = $13fc3543c2da06e0$var$baseIsNative;

});
parcelRegister("a0PyB", function(module, exports) {

var $iTwfH = parcelRequire("iTwfH");

var $afeb3 = parcelRequire("afeb3");
/** `Object#toString` result references. */ var $74a1e5a50e096b0e$var$asyncTag = '[object AsyncFunction]', $74a1e5a50e096b0e$var$funcTag = '[object Function]', $74a1e5a50e096b0e$var$genTag = '[object GeneratorFunction]', $74a1e5a50e096b0e$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $74a1e5a50e096b0e$var$isFunction(value) {
    if (!$afeb3(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $iTwfH(value);
    return tag == $74a1e5a50e096b0e$var$funcTag || tag == $74a1e5a50e096b0e$var$genTag || tag == $74a1e5a50e096b0e$var$asyncTag || tag == $74a1e5a50e096b0e$var$proxyTag;
}
module.exports = $74a1e5a50e096b0e$var$isFunction;

});
parcelRegister("iTwfH", function(module, exports) {

var $fMMfk = parcelRequire("fMMfk");

var $q3ZN2 = parcelRequire("q3ZN2");

var $eXpW1 = parcelRequire("eXpW1");
/** `Object#toString` result references. */ var $dc1661a82bba3eea$var$nullTag = '[object Null]', $dc1661a82bba3eea$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $dc1661a82bba3eea$var$symToStringTag = $fMMfk ? $fMMfk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $dc1661a82bba3eea$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $dc1661a82bba3eea$var$undefinedTag : $dc1661a82bba3eea$var$nullTag;
    return $dc1661a82bba3eea$var$symToStringTag && $dc1661a82bba3eea$var$symToStringTag in Object(value) ? $q3ZN2(value) : $eXpW1(value);
}
module.exports = $dc1661a82bba3eea$var$baseGetTag;

});
parcelRegister("fMMfk", function(module, exports) {

var $dOXAb = parcelRequire("dOXAb");
/** Built-in value references. */ var $b7e0c36da962d05e$var$Symbol = $dOXAb.Symbol;
module.exports = $b7e0c36da962d05e$var$Symbol;

});
parcelRegister("dOXAb", function(module, exports) {

var $1YI2h = parcelRequire("1YI2h");
/** Detect free variable `self`. */ var $a0fe29be23d36498$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a0fe29be23d36498$var$root = $1YI2h || $a0fe29be23d36498$var$freeSelf || Function('return this')();
module.exports = $a0fe29be23d36498$var$root;

});
parcelRegister("1YI2h", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $170d8da0a24e1e8a$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $170d8da0a24e1e8a$var$freeGlobal;

});



parcelRegister("q3ZN2", function(module, exports) {

var $fMMfk = parcelRequire("fMMfk");
/** Used for built-in method references. */ var $04e58744ade59fb1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $04e58744ade59fb1$var$hasOwnProperty = $04e58744ade59fb1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $04e58744ade59fb1$var$nativeObjectToString = $04e58744ade59fb1$var$objectProto.toString;
/** Built-in value references. */ var $04e58744ade59fb1$var$symToStringTag = $fMMfk ? $fMMfk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $04e58744ade59fb1$var$getRawTag(value) {
    var isOwn = $04e58744ade59fb1$var$hasOwnProperty.call(value, $04e58744ade59fb1$var$symToStringTag), tag = value[$04e58744ade59fb1$var$symToStringTag];
    try {
        value[$04e58744ade59fb1$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $04e58744ade59fb1$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$04e58744ade59fb1$var$symToStringTag] = tag;
        else delete value[$04e58744ade59fb1$var$symToStringTag];
    }
    return result;
}
module.exports = $04e58744ade59fb1$var$getRawTag;

});

parcelRegister("eXpW1", function(module, exports) {
/** Used for built-in method references. */ var $ae3ab17e0f690fa9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ae3ab17e0f690fa9$var$nativeObjectToString = $ae3ab17e0f690fa9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $ae3ab17e0f690fa9$var$objectToString(value) {
    return $ae3ab17e0f690fa9$var$nativeObjectToString.call(value);
}
module.exports = $ae3ab17e0f690fa9$var$objectToString;

});


parcelRegister("afeb3", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $77564d693a5c2509$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $77564d693a5c2509$var$isObject;

});


parcelRegister("h09K1", function(module, exports) {

var $fszNA = parcelRequire("fszNA");
/** Used to detect methods masquerading as native. */ var $c609fe2857808558$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($fszNA && $fszNA.keys && $fszNA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c609fe2857808558$var$isMasked(func) {
    return !!$c609fe2857808558$var$maskSrcKey && $c609fe2857808558$var$maskSrcKey in func;
}
module.exports = $c609fe2857808558$var$isMasked;

});
parcelRegister("fszNA", function(module, exports) {

var $dOXAb = parcelRequire("dOXAb");
/** Used to detect overreaching core-js shims. */ var $b4153d74cb498d5d$var$coreJsData = $dOXAb["__core-js_shared__"];
module.exports = $b4153d74cb498d5d$var$coreJsData;

});


parcelRegister("hJu0d", function(module, exports) {
/** Used for built-in method references. */ var $ce8de983506f5c5d$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce8de983506f5c5d$var$funcToString = $ce8de983506f5c5d$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $ce8de983506f5c5d$var$toSource(func) {
    if (func != null) {
        try {
            return $ce8de983506f5c5d$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $ce8de983506f5c5d$var$toSource;

});


parcelRegister("ihVQJ", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d506b03648183b0d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d506b03648183b0d$var$getValue;

});




parcelRegister("lsEFg", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $f9fbc1a5e4b65019$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $f9fbc1a5e4b65019$var$eq;

});


parcelRegister("4AEPk", function(module, exports) {

var $4HVAs = parcelRequire("4HVAs");

var $aYeXg = parcelRequire("aYeXg");

var $iYgOR = parcelRequire("iYgOR");

var $loNo4 = parcelRequire("loNo4");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $357a31922ac0d29b$var$castPath(value, object) {
    if ($4HVAs(value)) return value;
    return $aYeXg(value, object) ? [
        value
    ] : $iYgOR($loNo4(value));
}
module.exports = $357a31922ac0d29b$var$castPath;

});
parcelRegister("4HVAs", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $36d7d928ce9e09f7$var$isArray = Array.isArray;
module.exports = $36d7d928ce9e09f7$var$isArray;

});

parcelRegister("aYeXg", function(module, exports) {

var $4HVAs = parcelRequire("4HVAs");

var $3kX7H = parcelRequire("3kX7H");
/** Used to match property names within property paths. */ var $7fcb1bb23f0c60de$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $7fcb1bb23f0c60de$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $7fcb1bb23f0c60de$var$isKey(value, object) {
    if ($4HVAs(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $3kX7H(value)) return true;
    return $7fcb1bb23f0c60de$var$reIsPlainProp.test(value) || !$7fcb1bb23f0c60de$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $7fcb1bb23f0c60de$var$isKey;

});
parcelRegister("3kX7H", function(module, exports) {

var $iTwfH = parcelRequire("iTwfH");

var $guoyT = parcelRequire("guoyT");
/** `Object#toString` result references. */ var $26e119fd05f72a42$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $26e119fd05f72a42$var$isSymbol(value) {
    return typeof value == 'symbol' || $guoyT(value) && $iTwfH(value) == $26e119fd05f72a42$var$symbolTag;
}
module.exports = $26e119fd05f72a42$var$isSymbol;

});
parcelRegister("guoyT", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c01280293b9b392d$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $c01280293b9b392d$var$isObjectLike;

});



parcelRegister("iYgOR", function(module, exports) {

var $jlfCj = parcelRequire("jlfCj");
/** Used to match property names within property paths. */ var $dcfae08e4113552c$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $dcfae08e4113552c$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $dcfae08e4113552c$var$stringToPath = $jlfCj(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($dcfae08e4113552c$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($dcfae08e4113552c$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $dcfae08e4113552c$var$stringToPath;

});
parcelRegister("jlfCj", function(module, exports) {

var $5T4Di = parcelRequire("5T4Di");
/** Used as the maximum memoize cache size. */ var $e14c17b4bca4bf0e$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $e14c17b4bca4bf0e$var$memoizeCapped(func) {
    var result = $5T4Di(func, function(key) {
        if (cache.size === $e14c17b4bca4bf0e$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $e14c17b4bca4bf0e$var$memoizeCapped;

});
parcelRegister("5T4Di", function(module, exports) {

var $9xZ2Y = parcelRequire("9xZ2Y");
/** Error message constants. */ var $4495aecd01941efd$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4495aecd01941efd$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($4495aecd01941efd$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($4495aecd01941efd$var$memoize.Cache || $9xZ2Y);
    return memoized;
}
// Expose `MapCache`.
$4495aecd01941efd$var$memoize.Cache = $9xZ2Y;
module.exports = $4495aecd01941efd$var$memoize;

});
parcelRegister("9xZ2Y", function(module, exports) {

var $iBAaZ = parcelRequire("iBAaZ");

var $eIjFv = parcelRequire("eIjFv");

var $93Xlp = parcelRequire("93Xlp");

var $2D49W = parcelRequire("2D49W");

var $Eahly = parcelRequire("Eahly");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6f368cc8396b7ecb$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$6f368cc8396b7ecb$var$MapCache.prototype.clear = $iBAaZ;
$6f368cc8396b7ecb$var$MapCache.prototype['delete'] = $eIjFv;
$6f368cc8396b7ecb$var$MapCache.prototype.get = $93Xlp;
$6f368cc8396b7ecb$var$MapCache.prototype.has = $2D49W;
$6f368cc8396b7ecb$var$MapCache.prototype.set = $Eahly;
module.exports = $6f368cc8396b7ecb$var$MapCache;

});
parcelRegister("iBAaZ", function(module, exports) {

var $kFvBQ = parcelRequire("kFvBQ");

var $a6cMT = parcelRequire("a6cMT");

var $euxQb = parcelRequire("euxQb");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $d8b7be887f81d301$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $kFvBQ,
        'map': new ($euxQb || $a6cMT),
        'string': new $kFvBQ
    };
}
module.exports = $d8b7be887f81d301$var$mapCacheClear;

});
parcelRegister("kFvBQ", function(module, exports) {

var $da8IX = parcelRequire("da8IX");

var $erwSJ = parcelRequire("erwSJ");

var $5IG5H = parcelRequire("5IG5H");

var $h6Fd3 = parcelRequire("h6Fd3");

var $2ujw0 = parcelRequire("2ujw0");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f0c027f0ecab7614$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$f0c027f0ecab7614$var$Hash.prototype.clear = $da8IX;
$f0c027f0ecab7614$var$Hash.prototype['delete'] = $erwSJ;
$f0c027f0ecab7614$var$Hash.prototype.get = $5IG5H;
$f0c027f0ecab7614$var$Hash.prototype.has = $h6Fd3;
$f0c027f0ecab7614$var$Hash.prototype.set = $2ujw0;
module.exports = $f0c027f0ecab7614$var$Hash;

});
parcelRegister("da8IX", function(module, exports) {

var $cVD31 = parcelRequire("cVD31");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $9952f9f32a1f75e9$var$hashClear() {
    this.__data__ = $cVD31 ? $cVD31(null) : {};
    this.size = 0;
}
module.exports = $9952f9f32a1f75e9$var$hashClear;

});
parcelRegister("cVD31", function(module, exports) {

var $hAZ8T = parcelRequire("hAZ8T");
/* Built-in method references that are verified to be native. */ var $969918fc4da67055$var$nativeCreate = $hAZ8T(Object, 'create');
module.exports = $969918fc4da67055$var$nativeCreate;

});


parcelRegister("erwSJ", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a83d17eebbc1a8a0$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $a83d17eebbc1a8a0$var$hashDelete;

});

parcelRegister("5IG5H", function(module, exports) {

var $cVD31 = parcelRequire("cVD31");
/** Used to stand-in for `undefined` hash values. */ var $42a1b62adcfa0e23$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $42a1b62adcfa0e23$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $42a1b62adcfa0e23$var$hasOwnProperty = $42a1b62adcfa0e23$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $42a1b62adcfa0e23$var$hashGet(key) {
    var data = this.__data__;
    if ($cVD31) {
        var result = data[key];
        return result === $42a1b62adcfa0e23$var$HASH_UNDEFINED ? undefined : result;
    }
    return $42a1b62adcfa0e23$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $42a1b62adcfa0e23$var$hashGet;

});

parcelRegister("h6Fd3", function(module, exports) {

var $cVD31 = parcelRequire("cVD31");
/** Used for built-in method references. */ var $c742f696d8f92f29$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c742f696d8f92f29$var$hasOwnProperty = $c742f696d8f92f29$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c742f696d8f92f29$var$hashHas(key) {
    var data = this.__data__;
    return $cVD31 ? data[key] !== undefined : $c742f696d8f92f29$var$hasOwnProperty.call(data, key);
}
module.exports = $c742f696d8f92f29$var$hashHas;

});

parcelRegister("2ujw0", function(module, exports) {

var $cVD31 = parcelRequire("cVD31");
/** Used to stand-in for `undefined` hash values. */ var $1cfd85726f9313ba$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $1cfd85726f9313ba$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $cVD31 && value === undefined ? $1cfd85726f9313ba$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $1cfd85726f9313ba$var$hashSet;

});


parcelRegister("a6cMT", function(module, exports) {

var $58xZg = parcelRequire("58xZg");

var $7adme = parcelRequire("7adme");

var $bo4fS = parcelRequire("bo4fS");

var $e6N0c = parcelRequire("e6N0c");

var $8dsdM = parcelRequire("8dsdM");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $75a4624292deb0ed$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$75a4624292deb0ed$var$ListCache.prototype.clear = $58xZg;
$75a4624292deb0ed$var$ListCache.prototype['delete'] = $7adme;
$75a4624292deb0ed$var$ListCache.prototype.get = $bo4fS;
$75a4624292deb0ed$var$ListCache.prototype.has = $e6N0c;
$75a4624292deb0ed$var$ListCache.prototype.set = $8dsdM;
module.exports = $75a4624292deb0ed$var$ListCache;

});
parcelRegister("58xZg", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3bd8103bb3d2416b$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $3bd8103bb3d2416b$var$listCacheClear;

});

parcelRegister("7adme", function(module, exports) {

var $iskks = parcelRequire("iskks");
/** Used for built-in method references. */ var $5373d422175a2117$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $5373d422175a2117$var$splice = $5373d422175a2117$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5373d422175a2117$var$listCacheDelete(key) {
    var data = this.__data__, index = $iskks(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $5373d422175a2117$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $5373d422175a2117$var$listCacheDelete;

});
parcelRegister("iskks", function(module, exports) {

var $lsEFg = parcelRequire("lsEFg");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $d6fa9c6f5676ab0d$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($lsEFg(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $d6fa9c6f5676ab0d$var$assocIndexOf;

});


parcelRegister("bo4fS", function(module, exports) {

var $iskks = parcelRequire("iskks");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $84a53c97a16f7666$var$listCacheGet(key) {
    var data = this.__data__, index = $iskks(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $84a53c97a16f7666$var$listCacheGet;

});

parcelRegister("e6N0c", function(module, exports) {

var $iskks = parcelRequire("iskks");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a457a30f52d16298$var$listCacheHas(key) {
    return $iskks(this.__data__, key) > -1;
}
module.exports = $a457a30f52d16298$var$listCacheHas;

});

parcelRegister("8dsdM", function(module, exports) {

var $iskks = parcelRequire("iskks");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $5fb56dc1b7896e2a$var$listCacheSet(key, value) {
    var data = this.__data__, index = $iskks(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $5fb56dc1b7896e2a$var$listCacheSet;

});


parcelRegister("euxQb", function(module, exports) {

var $hAZ8T = parcelRequire("hAZ8T");

var $dOXAb = parcelRequire("dOXAb");
/* Built-in method references that are verified to be native. */ var $a8ce1e0fde337edf$var$Map = $hAZ8T($dOXAb, 'Map');
module.exports = $a8ce1e0fde337edf$var$Map;

});


parcelRegister("eIjFv", function(module, exports) {

var $eXBPo = parcelRequire("eXBPo");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ab646e7fac2da42a$var$mapCacheDelete(key) {
    var result = $eXBPo(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $ab646e7fac2da42a$var$mapCacheDelete;

});
parcelRegister("eXBPo", function(module, exports) {

var $fj3EO = parcelRequire("fj3EO");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $ae43eb3bfb5d74b0$var$getMapData(map, key) {
    var data = map.__data__;
    return $fj3EO(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $ae43eb3bfb5d74b0$var$getMapData;

});
parcelRegister("fj3EO", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b24b779be72c3acf$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $b24b779be72c3acf$var$isKeyable;

});



parcelRegister("93Xlp", function(module, exports) {

var $eXBPo = parcelRequire("eXBPo");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $69926d6aead3183b$var$mapCacheGet(key) {
    return $eXBPo(this, key).get(key);
}
module.exports = $69926d6aead3183b$var$mapCacheGet;

});

parcelRegister("2D49W", function(module, exports) {

var $eXBPo = parcelRequire("eXBPo");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1ea2733f029c4ed0$var$mapCacheHas(key) {
    return $eXBPo(this, key).has(key);
}
module.exports = $1ea2733f029c4ed0$var$mapCacheHas;

});

parcelRegister("Eahly", function(module, exports) {

var $eXBPo = parcelRequire("eXBPo");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $078bb5b19f0e4097$var$mapCacheSet(key, value) {
    var data = $eXBPo(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $078bb5b19f0e4097$var$mapCacheSet;

});





parcelRegister("loNo4", function(module, exports) {

var $jLZFH = parcelRequire("jLZFH");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f9422620d94d0a61$var$toString(value) {
    return value == null ? '' : $jLZFH(value);
}
module.exports = $f9422620d94d0a61$var$toString;

});
parcelRegister("jLZFH", function(module, exports) {

var $fMMfk = parcelRequire("fMMfk");

var $cL3KE = parcelRequire("cL3KE");

var $4HVAs = parcelRequire("4HVAs");

var $3kX7H = parcelRequire("3kX7H");
/** Used as references for various `Number` constants. */ var $e6523eceb28af1ab$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $e6523eceb28af1ab$var$symbolProto = $fMMfk ? $fMMfk.prototype : undefined, $e6523eceb28af1ab$var$symbolToString = $e6523eceb28af1ab$var$symbolProto ? $e6523eceb28af1ab$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $e6523eceb28af1ab$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($4HVAs(value)) // Recursively convert values (susceptible to call stack limits).
    return $cL3KE(value, $e6523eceb28af1ab$var$baseToString) + '';
    if ($3kX7H(value)) return $e6523eceb28af1ab$var$symbolToString ? $e6523eceb28af1ab$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$e6523eceb28af1ab$var$INFINITY ? '-0' : result;
}
module.exports = $e6523eceb28af1ab$var$baseToString;

});
parcelRegister("cL3KE", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $949cc8cd22515dbe$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $949cc8cd22515dbe$var$arrayMap;

});




parcelRegister("63N0J", function(module, exports) {
/** Used as references for various `Number` constants. */ var $46990a687df460d7$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $46990a687df460d7$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $46990a687df460d7$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $46990a687df460d7$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $46990a687df460d7$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $46990a687df460d7$var$isIndex;

});

parcelRegister("9AU0a", function(module, exports) {

var $3kX7H = parcelRequire("3kX7H");
/** Used as references for various `Number` constants. */ var $6fc2ea9948495145$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $6fc2ea9948495145$var$toKey(value) {
    if (typeof value == 'string' || $3kX7H(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$6fc2ea9948495145$var$INFINITY ? '-0' : result;
}
module.exports = $6fc2ea9948495145$var$toKey;

});



parcelRegister("2T93J", function(module, exports) {

$parcel$export(module.exports, "getFirstErrorField", function () { return $21a7beccc706773f$export$fc06342dc8588d3b; });

var $kzxJM = parcelRequire("kzxJM");
var $21a7beccc706773f$export$fc06342dc8588d3b = function getFirstErrorField(inputs, errors) {
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    var htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $kzxJM.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $kzxJM.getIn)(errors, input.name);
    });
};

});


parcelRegister("elF0p", function(module, exports) {

$parcel$export(module.exports, "Label", function () { return $a722d5b96c6ceb70$export$b04be29aa201d4f5; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $a722d5b96c6ceb70$var$fieldsetLabelStyles = null;
var $a722d5b96c6ceb70$export$b04be29aa201d4f5 = function Label(_ref) {
    var children = _ref.children, htmlFor = _ref.htmlFor, id = _ref.id, testId = _ref.testId;
    return /*#__PURE__*/ $8ZuGG.createElement("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};
var $a722d5b96c6ceb70$export$ed247974535929c7 = function Legend(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ $8ZuGG.createElement("legend", {
        className: (0, $c4hjl.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ])
    }, children);
};

});

parcelRegister("1VVi7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16878e2e32d8d144$export$2e2bcd8739ae039; });
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $16878e2e32d8d144$var$requiredIndicatorStyles = null;
function $16878e2e32d8d144$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $c4hjl.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ])
    }, "*");
}

});


parcelRegister("7SrF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc308bcf175da79$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $57fzU = parcelRequire("57fzU");

var $ld7ev = parcelRequire("ld7ev");
var $5bc308bcf175da79$var$flexGrowMap = {
    hug: (0, $57fzU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $57fzU.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
var $5bc308bcf175da79$var$separatorStyles = (0, $bl8w7.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $5bc308bcf175da79$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $bl8w7.jsx)("span", {
        css: $5bc308bcf175da79$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5bc308bcf175da79$var$Inline = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, id = _ref2.id, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $bl8w7.jsx)($5bc308bcf175da79$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $8ZuGG.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $bl8w7.jsx)((0, $8ZuGG.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $5bc308bcf175da79$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $bl8w7.jsx)((0, $ld7ev.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$5bc308bcf175da79$var$Inline.displayName = 'Inline';
var $5bc308bcf175da79$export$2e2bcd8739ae039 = $5bc308bcf175da79$var$Inline;

});
parcelRegister("57fzU", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $3b99b0b8f0b63277$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $3b99b0b8f0b63277$export$f6c783d06584602c; });

var $cF8Kw = parcelRequire("cF8Kw");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $cd8Dz = parcelRequire("cd8Dz");

var $bl8w7 = parcelRequire("bl8w7");

var $1S0T5 = parcelRequire("1S0T5");

var $1RdT6 = parcelRequire("1RdT6");
function $3b99b0b8f0b63277$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3b99b0b8f0b63277$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3b99b0b8f0b63277$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3b99b0b8f0b63277$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3b99b0b8f0b63277$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3b99b0b8f0b63277$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $3b99b0b8f0b63277$export$9a199fbafee0014e = {
    backgroundColor: (0, $1S0T5.backgroundColorMap),
    blockSize: (0, $1S0T5.dimensionMap),
    borderBlockColor: (0, $1S0T5.borderColorMap),
    borderBlockEndColor: (0, $1S0T5.borderColorMap),
    borderBlockEndWidth: (0, $1S0T5.borderWidthMap),
    borderBlockStartColor: (0, $1S0T5.borderColorMap),
    borderBlockStartWidth: (0, $1S0T5.borderWidthMap),
    borderBlockWidth: (0, $1S0T5.borderWidthMap),
    borderBottomColor: (0, $1S0T5.borderColorMap),
    borderBottomLeftRadius: (0, $1S0T5.borderRadiusMap),
    borderBottomRightRadius: (0, $1S0T5.borderRadiusMap),
    borderBottomWidth: (0, $1S0T5.borderWidthMap),
    borderColor: (0, $1S0T5.borderColorMap),
    borderEndEndRadius: (0, $1S0T5.borderRadiusMap),
    borderEndStartRadius: (0, $1S0T5.borderRadiusMap),
    borderInlineColor: (0, $1S0T5.borderColorMap),
    borderInlineEndColor: (0, $1S0T5.borderColorMap),
    borderInlineEndWidth: (0, $1S0T5.borderWidthMap),
    borderInlineStartColor: (0, $1S0T5.borderColorMap),
    borderInlineStartWidth: (0, $1S0T5.borderWidthMap),
    borderInlineWidth: (0, $1S0T5.borderWidthMap),
    borderLeftColor: (0, $1S0T5.borderColorMap),
    borderLeftWidth: (0, $1S0T5.borderWidthMap),
    borderRadius: (0, $1S0T5.borderRadiusMap),
    borderRightColor: (0, $1S0T5.borderColorMap),
    borderRightWidth: (0, $1S0T5.borderWidthMap),
    borderStartEndRadius: (0, $1S0T5.borderRadiusMap),
    borderStartStartRadius: (0, $1S0T5.borderRadiusMap),
    borderTopColor: (0, $1S0T5.borderColorMap),
    borderTopLeftRadius: (0, $1S0T5.borderRadiusMap),
    borderTopRightRadius: (0, $1S0T5.borderRadiusMap),
    borderTopWidth: (0, $1S0T5.borderWidthMap),
    borderWidth: (0, $1S0T5.borderWidthMap),
    bottom: (0, $1S0T5.allSpaceMap),
    boxShadow: (0, $1S0T5.shadowMap),
    color: (0, $1S0T5.textColorMap),
    columnGap: (0, $1S0T5.positiveSpaceMap),
    font: (0, $1S0T5.fontMap),
    fontFamily: (0, $1S0T5.fontFamilyMap),
    fontWeight: (0, $1S0T5.fontWeightMap),
    gap: (0, $1S0T5.positiveSpaceMap),
    height: (0, $1S0T5.dimensionMap),
    inlineSize: (0, $1S0T5.dimensionMap),
    inset: (0, $1S0T5.allSpaceMap),
    insetBlock: (0, $1S0T5.allSpaceMap),
    insetBlockEnd: (0, $1S0T5.allSpaceMap),
    insetBlockStart: (0, $1S0T5.allSpaceMap),
    insetInline: (0, $1S0T5.allSpaceMap),
    insetInlineEnd: (0, $1S0T5.allSpaceMap),
    insetInlineStart: (0, $1S0T5.allSpaceMap),
    left: (0, $1S0T5.allSpaceMap),
    margin: (0, $1S0T5.allSpaceMap),
    marginBlock: (0, $1S0T5.allSpaceMap),
    marginBlockEnd: (0, $1S0T5.allSpaceMap),
    marginBlockStart: (0, $1S0T5.allSpaceMap),
    marginBottom: (0, $1S0T5.allSpaceMap),
    marginInline: (0, $1S0T5.allSpaceMap),
    marginInlineEnd: (0, $1S0T5.allSpaceMap),
    marginInlineStart: (0, $1S0T5.allSpaceMap),
    marginLeft: (0, $1S0T5.allSpaceMap),
    marginRight: (0, $1S0T5.allSpaceMap),
    marginTop: (0, $1S0T5.allSpaceMap),
    maxBlockSize: (0, $1S0T5.dimensionMap),
    maxHeight: (0, $1S0T5.dimensionMap),
    maxInlineSize: (0, $1S0T5.dimensionMap),
    maxWidth: (0, $1S0T5.dimensionMap),
    minBlockSize: (0, $1S0T5.dimensionMap),
    minHeight: (0, $1S0T5.dimensionMap),
    minInlineSize: (0, $1S0T5.dimensionMap),
    minWidth: (0, $1S0T5.dimensionMap),
    opacity: (0, $1S0T5.opacityMap),
    outlineColor: (0, $1S0T5.borderColorMap),
    outlineOffset: (0, $1S0T5.allSpaceMap),
    outlineWidth: (0, $1S0T5.borderWidthMap),
    padding: (0, $1S0T5.positiveSpaceMap),
    paddingBlock: (0, $1S0T5.positiveSpaceMap),
    paddingBlockEnd: (0, $1S0T5.positiveSpaceMap),
    paddingBlockStart: (0, $1S0T5.positiveSpaceMap),
    paddingBottom: (0, $1S0T5.positiveSpaceMap),
    paddingInline: (0, $1S0T5.positiveSpaceMap),
    paddingInlineEnd: (0, $1S0T5.positiveSpaceMap),
    paddingInlineStart: (0, $1S0T5.positiveSpaceMap),
    paddingLeft: (0, $1S0T5.positiveSpaceMap),
    paddingRight: (0, $1S0T5.positiveSpaceMap),
    paddingTop: (0, $1S0T5.positiveSpaceMap),
    right: (0, $1S0T5.allSpaceMap),
    rowGap: (0, $1S0T5.positiveSpaceMap),
    top: (0, $1S0T5.allSpaceMap),
    width: (0, $1S0T5.dimensionMap),
    zIndex: (0, $1S0T5.layerMap)
};
var $3b99b0b8f0b63277$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $3b99b0b8f0b63277$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $1RdT6 === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))($1RdT6)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))($1RdT6.env) === 'object' && false;
};
var $3b99b0b8f0b63277$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3b99b0b8f0b63277$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3b99b0b8f0b63277$var$_transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($3b99b0b8f0b63277$var$_transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value) === 'object' && $3b99b0b8f0b63277$var$safeSelectors.test(key)) {
            styleObj[key] = $3b99b0b8f0b63277$var$_transformStyles(value);
            return;
        }
        if ($3b99b0b8f0b63277$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3b99b0b8f0b63277$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3b99b0b8f0b63277$export$9a199fbafee0014e)) return;
        var tokenValue = $3b99b0b8f0b63277$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3b99b0b8f0b63277$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3b99b0b8f0b63277$var$_transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $3b99b0b8f0b63277$var$uniqueSymbol, (0, $bl8w7.css)(transformedStyles));
};
/**
 * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
 * to supported both Emotion and Compiled styles until we've fully migrated
 * to Compiled.
 *
 * @private
 * @deprecated
 */ var $3b99b0b8f0b63277$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3b99b0b8f0b63277$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = $3b99b0b8f0b63277$export$a9c84988c8f81f2d(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3b99b0b8f0b63277$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3b99b0b8f0b63277$export$f6c783d06584602c(style) {
    return $3b99b0b8f0b63277$var$baseXcss(style);
}

});

parcelRegister("ld7ev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7106c2ddd2d47fb$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $1S0T5 = parcelRequire("1S0T5");

var $57fzU = parcelRequire("57fzU");
var $f7106c2ddd2d47fb$var$justifyContentMap = {
    start: (0, $bl8w7.css)({
        justifyContent: 'start'
    }),
    center: (0, $bl8w7.css)({
        justifyContent: 'center'
    }),
    end: (0, $bl8w7.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $bl8w7.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $bl8w7.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $bl8w7.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $bl8w7.css)({
        justifyContent: 'stretch'
    })
};
var $f7106c2ddd2d47fb$var$flexDirectionMap = {
    column: (0, $bl8w7.css)({
        flexDirection: 'column'
    }),
    row: (0, $bl8w7.css)({
        flexDirection: 'row'
    })
};
var $f7106c2ddd2d47fb$var$flexWrapMap = {
    wrap: (0, $bl8w7.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $bl8w7.css)({
        flexWrap: 'nowrap'
    })
};
var $f7106c2ddd2d47fb$var$alignItemsMap = {
    start: (0, $bl8w7.css)({
        alignItems: 'start'
    }),
    center: (0, $bl8w7.css)({
        alignItems: 'center'
    }),
    baseline: (0, $bl8w7.css)({
        alignItems: 'baseline'
    }),
    end: (0, $bl8w7.css)({
        alignItems: 'end'
    }),
    stretch: (0, $bl8w7.css)({
        alignItems: 'stretch'
    })
};
var $f7106c2ddd2d47fb$var$baseStyles = (0, $bl8w7.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $f7106c2ddd2d47fb$var$Flex = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss, id = _ref.id;
    var resolvedStyles = (0, $57fzU.parseXcss)(xcss);
    return (0, $bl8w7.jsx)(Component, {
        id: id,
        role: role,
        className: resolvedStyles.static,
        css: [
            $f7106c2ddd2d47fb$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $1S0T5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $1S0T5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $1S0T5.spaceStylesMap).rowGap[rowGap],
            alignItems && $f7106c2ddd2d47fb$var$alignItemsMap[alignItems],
            direction && $f7106c2ddd2d47fb$var$flexDirectionMap[direction],
            justifyContent && $f7106c2ddd2d47fb$var$justifyContentMap[justifyContent],
            wrap && $f7106c2ddd2d47fb$var$flexWrapMap[wrap]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(resolvedStyles.emotion || [])),
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f7106c2ddd2d47fb$var$Flex.displayName = 'Flex';
var $f7106c2ddd2d47fb$export$2e2bcd8739ae039 = $f7106c2ddd2d47fb$var$Flex;

});



parcelRegister("3pP7q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3783f102c0ff162f$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $3783f102c0ff162f$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    mfFormLabel: {
        id: 'mf.mfform.placeholder.generic',
        defaultMessage: 'Verification code',
        description: 'Placeholder hint for the verification code textfield when the expected code length is unknown'
    },
    mfFormLabelNDigits: {
        id: 'mf.mfform.placeholder.ndigits',
        defaultMessage: '{codeLength}-digit verification code',
        description: ''
    },
    mfFormLabelNCharacters: {
        id: 'mf.mfform.placeholder.ncharacters',
        defaultMessage: '{codeLength, plural, one {# character} other {# characters}} verification code',
        description: ''
    },
    errorsInvalidOtp: {
        id: 'mf.mfform.errors.invalid_otp',
        defaultMessage: 'You entered an incorrect verification code.'
    },
    errorsInvalidOtpFormat: {
        id: 'mf.mfform.errors.invalid_otp_format',
        defaultMessage: 'You entered an invalid verification code.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.mfform.errors.invalid_otp_pattern',
        defaultMessage: 'Your verification code needs to be {codeLength, plural, one {# character} other {# characters}}.'
    },
    errorsExpiredOtp: {
        id: 'mf.mfform.errors.expired_otp',
        defaultMessage: 'Your verification code has expired.'
    },
    errorsUnknown: {
        id: 'mf.mfform.errors.unknown',
        defaultMessage: 'Unknown error occurred. Please try again.'
    }
});

});


parcelRegister("1Acyk", function(module, exports) {

$parcel$export(module.exports, "SecurityWall", function () { return $a8b4e2cda7d92643$export$4584cd3084bcd78; });

var $6rcps = parcelRequire("6rcps");

var $9Vz68 = parcelRequire("9Vz68");

var $dO9Oy = parcelRequire("dO9Oy");

var $JMbKX = parcelRequire("JMbKX");

var $ihLLY = parcelRequire("ihLLY");

var $5b7Z4 = parcelRequire("5b7Z4");

var $8ZuGG = parcelRequire("8ZuGG");
let $a8b4e2cda7d92643$var$_ = (t)=>t, $a8b4e2cda7d92643$var$t, $a8b4e2cda7d92643$var$t1, $a8b4e2cda7d92643$var$t2, $a8b4e2cda7d92643$var$t3, $a8b4e2cda7d92643$var$t4;
const $a8b4e2cda7d92643$var$DefaultSecurityWallContainer = (0, $9Vz68.default).div($a8b4e2cda7d92643$var$t1 || ($a8b4e2cda7d92643$var$t1 = $a8b4e2cda7d92643$var$_`
  background: url(${0}) no-repeat center 0 / ${0}px;
  min-width: 100%;
  margin-top: ${0}px;
  padding-top: ${0}px;
  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($dO9Oy))), (0, $5b7Z4.gridSize)() * 14.5, (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)() * 18, (0, $ihLLY.media).handheld($a8b4e2cda7d92643$var$t || ($a8b4e2cda7d92643$var$t = $a8b4e2cda7d92643$var$_`
    background: 0;
    padding: 0;
  `)));
const $a8b4e2cda7d92643$var$TotpChallengeContainer = (0, $9Vz68.default).div($a8b4e2cda7d92643$var$t3 || ($a8b4e2cda7d92643$var$t3 = $a8b4e2cda7d92643$var$_`
  background: url(${0}) no-repeat center 0 / ${0}px;
  min-width: 100%;
  margin-top: ${0}px;
  padding-top: ${0}px;
  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($JMbKX))), (0, $5b7Z4.gridSize)() * 30, (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)() * 18, (0, $ihLLY.media).handheld($a8b4e2cda7d92643$var$t2 || ($a8b4e2cda7d92643$var$t2 = $a8b4e2cda7d92643$var$_`
    background: none;
    padding: 0;
  `)));
const $a8b4e2cda7d92643$var$SuccessfulResetSecurityWallContainer = (0, $9Vz68.default).div($a8b4e2cda7d92643$var$t4 || ($a8b4e2cda7d92643$var$t4 = $a8b4e2cda7d92643$var$_`
  background: url(${0}) no-repeat center;
  height: ${0}px;
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($dO9Oy))), (0, $5b7Z4.gridSize)() * 14.5, (0, $5b7Z4.gridSize)() * 1, (0, $5b7Z4.gridSize)() * 1.5);
const $a8b4e2cda7d92643$export$4584cd3084bcd78 = ({ children: children, id: id, securityWallStyle: securityWallStyle })=>{
    const WallComponent = (0, $8ZuGG.useMemo)(()=>{
        switch(securityWallStyle){
            case 'password-reset':
                return $a8b4e2cda7d92643$var$SuccessfulResetSecurityWallContainer;
            case 'totp':
                return $a8b4e2cda7d92643$var$TotpChallengeContainer;
            default:
                return $a8b4e2cda7d92643$var$DefaultSecurityWallContainer;
        }
    }, [
        securityWallStyle
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)(WallComponent, {
        id: id,
        children: children
    });
};

});
parcelRegister("dO9Oy", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "security-wall.788bd489.svg";

});


parcelRegister("a3fkM", function(module, exports) {

$parcel$export(module.exports, "InlineMessageContainer", function () { return $7fa3f7a2416d5fca$export$327fb3a223d00cf3; });
$parcel$export(module.exports, "StyledMessage", function () { return $7fa3f7a2416d5fca$export$ca8581ef51d2f0a9; });
$parcel$export(module.exports, "InputMessage", function () { return $7fa3f7a2416d5fca$export$d2966f371054ad4a; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $7fa3f7a2416d5fca$var$_ = (t)=>t, $7fa3f7a2416d5fca$var$t, $7fa3f7a2416d5fca$var$t1, $7fa3f7a2416d5fca$var$t2;
const $7fa3f7a2416d5fca$export$327fb3a223d00cf3 = (0, $9Vz68.default).div($7fa3f7a2416d5fca$var$t || ($7fa3f7a2416d5fca$var$t = $7fa3f7a2416d5fca$var$_`
  margin-left: 4px;
  display: inline-block;
  vertical-align: middle;
`));
const $7fa3f7a2416d5fca$export$ca8581ef51d2f0a9 = (0, $9Vz68.default).div($7fa3f7a2416d5fca$var$t1 || ($7fa3f7a2416d5fca$var$t1 = $7fa3f7a2416d5fca$var$_`
  width: calc(50vw - ${0}px);
  max-width: ${0}px;
  margin-left: -${0}px;
  margin-right: -${0}px;
`), (0, $5b7Z4.gridSize)() * 6, (0, $5b7Z4.gridSize)() * 34, (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)());
const $7fa3f7a2416d5fca$export$d2966f371054ad4a = (0, $9Vz68.default).div($7fa3f7a2416d5fca$var$t2 || ($7fa3f7a2416d5fca$var$t2 = $7fa3f7a2416d5fca$var$_`
  display: flex;
  justify-content: space-between;
  align-items: center;
`));

});

parcelRegister("eQyyj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e9217e5e120e7c9e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("4pCpP");
var $btxlE = parcelRequire("btxlE");

var $gf1BP = parcelRequire("gf1BP");

var $a3fkM = parcelRequire("a3fkM");

var $dMtGq = parcelRequire("dMtGq");

var $jHLOy = parcelRequire("jHLOy");

var $1SvOA = parcelRequire("1SvOA");

var $kfd93 = parcelRequire("kfd93");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $g5rao = parcelRequire("g5rao");

var $9Vz68 = parcelRequire("9Vz68");

var $4Jkx8 = parcelRequire("4Jkx8");

var $9NVnN = parcelRequire("9NVnN");
let $e9217e5e120e7c9e$var$_ = (t)=>t, $e9217e5e120e7c9e$var$t;
const $e9217e5e120e7c9e$var$baseSpacing = (0, $g5rao.default)('space.100');
const $e9217e5e120e7c9e$var$PAGE_ID = 'MfaChallengeSecurityKey';
const $e9217e5e120e7c9e$var$ErrorMessageWrapper = (0, $9Vz68.default).div($e9217e5e120e7c9e$var$t || ($e9217e5e120e7c9e$var$t = $e9217e5e120e7c9e$var$_`
  margin: calc(${0} * 2) 0;
`), $e9217e5e120e7c9e$var$baseSpacing);
const $e9217e5e120e7c9e$var$MfaChallengeSecurityKey = ()=>{
    const [errorMessage, setErrorMessage] = (0, $8ZuGG.useState)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const challengeErrorMessages = (0, $8ZuGG.useMemo)(()=>({
            // WebAuthn errors
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported]: formatMessage((0, $gf1BP.default).webauthnNotSupportedMessage),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).InvalidRequestOptions]: formatMessage((0, $gf1BP.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).Aborted]: formatMessage((0, $gf1BP.default).webAuthnAborted),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).NotAllowed]: formatMessage((0, $gf1BP.default).webAuthnAuthenticationIncomplete // eg. timeout, user cancelled
            ),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).InvalidDomain]: formatMessage((0, $gf1BP.default).webAuthnInvalidDomain),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).InvalidRpId]: formatMessage((0, $gf1BP.default).webAuthnMalformedConfiguration // server returned bad options?
            ),
            [(0, $4Jkx8.WebAuthnAuthenticationErrorCode).UnknownError]: formatMessage((0, $gf1BP.default).webauthnAuthenticationFailed),
            // API errors
            [(0, $btxlE.ChallengeApiError).tooManyRequests]: formatMessage((0, $gf1BP.default).securityKeyTooManyAttemptsMessage),
            [(0, $btxlE.ChallengeApiError).transactionTokenNotFound]: formatMessage((0, $gf1BP.default).failedToUseKeyMessage),
            [(0, $btxlE.ChallengeApiError).challengeFailure]: formatMessage((0, $gf1BP.default).failedToUseKeyMessage)
        }), [
        formatMessage
    ]);
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { challengeSecurityKey: challengeSecurityKey, authenticating: authenticating } = (0, $btxlE.useChallengeSecurityKey)($e9217e5e120e7c9e$var$PAGE_ID, (responseData)=>{
        const redirectUri = responseData.redirectUri;
        navigate(redirectUri.toString());
    }, (error)=>{
        setErrorMessage(challengeErrorMessages[error] || formatMessage((0, $gf1BP.default).failedToUseKeyMessage));
    });
    const invokeChallengeSecurityKey = ()=>{
        setErrorMessage(undefined);
        challengeSecurityKey();
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $kfd93.SecurityKey), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $a3fkM.InputMessage), {
                style: {
                    margin: `${$e9217e5e120e7c9e$var$baseSpacing} 0`
                },
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "mf.mfform.securitykey.authenticate",
                        defaultMessage: "Use your security key to continue."
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.InlineMessageContainer), {
                        "data-testid": "mfform-tooltip-icon",
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dMtGq.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.StyledMessage), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.mfform.securitykey.tooltip",
                                    defaultMessage: "Use any security key you registered with Atlassian"
                                })
                            })
                        })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $6rcps.jsx)($e9217e5e120e7c9e$var$ErrorMessageWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
                    appearance: "warning",
                    children: errorMessage
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                id: "challenge-security-key",
                appearance: "primary",
                isFullWidth: true,
                onClick: invokeChallengeSecurityKey,
                isLoading: authenticating,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.mfform.securitykey",
                    defaultMessage: "Log in"
                })
            })
        ]
    });
};
var $e9217e5e120e7c9e$export$2e2bcd8739ae039 = $e9217e5e120e7c9e$var$MfaChallengeSecurityKey;

});
parcelRegister("4pCpP", function(module, exports) {
$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return (parcelRequire("2tVDe")).useCreateAccountConfirmationPageState; });
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("btxlE")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("btxlE")).useChallengeSecurityKey; });
parcelRequire("2tVDe");
parcelRequire("dWpg8");
parcelRequire("bbuZ2");

});
parcelRegister("2tVDe", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageState", function () { return $997bbca9959edf42$export$9d9b63d777a078f3; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("6jPF3");
var $hzjk7 = parcelRequire("hzjk7");
const $997bbca9959edf42$var$selectMarketingConsent = (state)=>state.marketingConsent;
const $997bbca9959edf42$var$selectHashedCsrfToken = (state)=>state.hashedCsrfToken;
const $997bbca9959edf42$var$selectMicrobranding = (state)=>state.microbranding;
const $997bbca9959edf42$var$selectAppConfig = (state)=>state.appConfig;
const $997bbca9959edf42$var$selectCreateAccount = (state)=>state.createAccount;
const $997bbca9959edf42$export$9d9b63d777a078f3 = ()=>{
    return (0, $kOqgB.useAppSelector)((0, $hzjk7.createSelector)([
        $997bbca9959edf42$var$selectMarketingConsent,
        $997bbca9959edf42$var$selectHashedCsrfToken,
        $997bbca9959edf42$var$selectMicrobranding,
        $997bbca9959edf42$var$selectAppConfig,
        $997bbca9959edf42$var$selectCreateAccount
    ], (marketingConsent, hashedCsrfToken, microbranding, appConfig, createAccount)=>{
        const { config: marketingConsentConfig } = marketingConsent;
        const { recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite } = appConfig;
        const { formError: formError, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = createAccount;
        const { isEmbedded: isEmbedded, oidcContext: oidcContext } = microbranding;
        const baseState = {
            formError: formError,
            fieldErrors: fieldErrors,
            marketingConsentConfig: marketingConsentConfig,
            redirectTo: redirectTo,
            isLoading: isLoading,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext,
            recaptchaEnterpriseInvisibleKeySite: recaptchaEnterpriseInvisibleKeySite
        };
        const { loginType: loginType, displayName: displayName, email: email, userFlow: userFlow, confirmationToken: confirmationToken, mfaToken: mfaToken, createNeeded: createNeeded, verifyNeeded: verifyNeeded } = createAccount;
        return (0, $6EnDC._)((0, $ty6PY._)({}, baseState), {
            loginType: loginType,
            displayName: displayName,
            email: email,
            createNeeded: createNeeded,
            verifyNeeded: verifyNeeded,
            userFlow: userFlow,
            confirmationToken: confirmationToken,
            mfaToken: mfaToken,
            hashedCsrfToken: hashedCsrfToken
        });
    }));
};

});

parcelRegister("dWpg8", function(module, exports) {
$parcel$export(module.exports, "EnrollApiErrorType", function () { return (parcelRequire("4IVe2")).EnrollApiErrorType; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return (parcelRequire("4IVe2")).useEnrollSecurityKey; });
parcelRequire("4IVe2");

});
parcelRegister("4IVe2", function(module, exports) {

$parcel$export(module.exports, "EnrollApiErrorType", function () { return $99691ecac8e86768$export$ed8612e4d0d57df6; });
$parcel$export(module.exports, "useEnrollSecurityKey", function () { return $99691ecac8e86768$export$b31ee8addd49a620; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $kMcLn = parcelRequire("kMcLn");

var $lDnug = parcelRequire("lDnug");

var $3ir1n = parcelRequire("3ir1n");

var $8f2pb = parcelRequire("8f2pb");

var $4Jkx8 = parcelRequire("4Jkx8");

var $jSnDV = parcelRequire("jSnDV");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $9NVnN = parcelRequire("9NVnN");
const $99691ecac8e86768$var$X_CSRF_TOKEN_HEADER = 'X-CSRF-TOKEN';
class $99691ecac8e86768$var$EnrollError extends Error {
    constructor(message, type){
        super(message);
        this.type = type;
    }
}
var $99691ecac8e86768$export$ed8612e4d0d57df6 = /*#__PURE__*/ function(EnrollApiErrorType) {
    EnrollApiErrorType["deviceNameLengthError"] = "deviceNameLengthError";
    EnrollApiErrorType["rateLimitedError"] = "rateLimited";
    EnrollApiErrorType["enrollFailure"] = "enrollFailure";
    return EnrollApiErrorType;
}({});
const $99691ecac8e86768$var$initialize = async ({ deviceName: deviceName, csrfToken: csrfToken, token: token })=>{
    try {
        const response = await fetch(`/manage/rest/two-step-verification/start-security-key?token=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$99691ecac8e86768$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify({
                deviceName: deviceName
            })
        });
        switch(response.status){
            case 200:
                return response.json();
            case 400:
                const errorResponse = await response.json();
                const errorType = errorResponse.type === 'invalid-device-name' ? "deviceNameLengthError" : "enrollFailure";
                throw new $99691ecac8e86768$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, errorType);
            case 429:
                throw new $99691ecac8e86768$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $99691ecac8e86768$var$EnrollError(`/manage/rest/two-step-verification/start-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $99691ecac8e86768$var$EnrollError) throw error;
        throw new $99691ecac8e86768$var$EnrollError(error.message, "enrollFailure");
    }
};
const $99691ecac8e86768$var$createCredentialsOnAuthenticator = async (securityKeyEnrollmentDetails)=>{
    try {
        const options = (0, $kMcLn.parseCreationOptionsFromJSON)({
            publicKey: (0, $6EnDC._)((0, $ty6PY._)({}, securityKeyEnrollmentDetails.creationOptions), {
                timeout: 60000
            })
        });
        try {
            const securityKeyCredential = await (0, $kMcLn.create)(options);
            return securityKeyCredential.toJSON();
        } catch (error) {
            (0, $8f2pb.captureErrorMessage)('Security key credential creation failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $4Jkx8.translateRegistrationError)({
                error: error,
                options: options
            });
            throw new $99691ecac8e86768$var$EnrollError(`Failed to create credentials on authenticator: ${error.message}`, errorCode);
        }
    } catch (error) {
        if (error instanceof $99691ecac8e86768$var$EnrollError) throw error;
        (0, $8f2pb.captureErrorMessage)('Failed to parse creation options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        throw new $99691ecac8e86768$var$EnrollError(`Failed to parse creation options: ${error.message}`, (0, $4Jkx8.WebAuthnRegistrationErrorCode).InvalidCreationOptions);
    }
};
const $99691ecac8e86768$var$confirm = async (_param)=>{
    var { transactionToken: transactionToken, csrfToken: csrfToken, token: token, continueUrl: continueUrl } = _param, attestationJson = (0, $42tc5._)(_param, [
        "transactionToken",
        "csrfToken",
        "token",
        "continueUrl"
    ]);
    const clientExtensionResultsJsonString = JSON.stringify(attestationJson.clientExtensionResults);
    try {
        const confirmUrl = `/manage/rest/two-step-verification/confirm-security-key?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify({
            transactionToken: transactionToken,
            token: token,
            continue: continueUrl
        })}`;
        const response = await fetch(confirmUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                [$99691ecac8e86768$var$X_CSRF_TOKEN_HEADER]: csrfToken
            },
            body: JSON.stringify((0, $6EnDC._)((0, $ty6PY._)({}, attestationJson), {
                clientExtensionResults: clientExtensionResultsJsonString
            }))
        });
        switch(response.status){
            case 200:
                {
                    const body = await response.json();
                    const { enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl } = body;
                    if (enrollmentActionType === 'added') {
                        // `added` - user is enrolling security key as addition factor
                        // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
                        // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
                        // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
                        // which is only valid for first MFA factor enrollment.
                        // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
                        //       user to `continueUrl`, and will not be return as part of the `added` call.
                        const url = continueUrl || '/manage-profile/security/two-step-verification';
                        return {
                            redirectUrl: url,
                            immediateRedirect: true
                        };
                    } else // `created` - user is enrolling security key as their first MFA factor
                    // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
                    return {
                        redirectUrl: redirectUrl,
                        immediateRedirect: false
                    };
                }
            case 429:
                throw new $99691ecac8e86768$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "rateLimited");
            default:
                throw new $99691ecac8e86768$var$EnrollError(`/manage/rest/two-step-verification/confirm-security key retruns unexpected status code ${response.status}`, "enrollFailure");
        }
    } catch (error) {
        if (error instanceof $99691ecac8e86768$var$EnrollError) throw error;
        throw new $99691ecac8e86768$var$EnrollError(error.message, "enrollFailure");
    }
};
const $99691ecac8e86768$export$b31ee8addd49a620 = (analyticsPageId, onSuccess, onError)=>{
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const token = (0, $kOqgB.useAppSelector)((state)=>state.mfaEnrollment.token) || '';
    const isSupported = (0, $4Jkx8.isWebAuthnSupported)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const location = (0, $5WDNl.useLocation)();
    const search = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
    const [confirmingEnrollment, setConfirmingEnrollment] = (0, $8ZuGG.useState)(false);
    const enrollSecurityKey = (0, $8ZuGG.useCallback)(async (deviceName)=>{
        analyticsClient.trackingEvent({
            page: analyticsPageId,
            subject: '2svEnrolRegisterSecurityKey',
            action: 'started'
        });
        if (!isSupported) {
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                action: 'failed',
                subject: '2svEnrolRegisterSecurityKey',
                attributes: {
                    reason: (0, $4Jkx8.WebAuthnRegistrationErrorCode).WebAuthnNotSupported
                }
            });
            return onError((0, $4Jkx8.WebAuthnRegistrationErrorCode).WebAuthnNotSupported);
        }
        try {
            setConfirmingEnrollment(true);
            const securityKeyEnrollmentDetails = await $99691ecac8e86768$var$initialize({
                deviceName: deviceName,
                csrfToken: csrfToken,
                token: token
            });
            dispatch((0, $lDnug.confirmSecurityKeyEnrollment)(securityKeyEnrollmentDetails.recoveryCode));
            const securityKeyCredentialJson = await $99691ecac8e86768$var$createCredentialsOnAuthenticator(securityKeyEnrollmentDetails);
            const { immediateRedirect: immediateRedirect, redirectUrl: redirectUrl } = await $99691ecac8e86768$var$confirm((0, $ty6PY._)({
                transactionToken: securityKeyEnrollmentDetails.transactionToken,
                csrfToken: csrfToken,
                token: token,
                continueUrl: search.continue
            }, securityKeyCredentialJson));
            if (immediateRedirect) navigate(redirectUrl);
            else dispatch((0, $lDnug.confirmEnrollResponse)(redirectUrl));
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'succeeded'
            });
            return onSuccess();
        } catch (e) {
            setConfirmingEnrollment(false);
            analyticsClient.trackingEvent({
                page: analyticsPageId,
                subject: '2svEnrolRegisterSecurityKey',
                action: 'failed',
                attributes: {
                    reason: e.type || "enrollFailure"
                }
            });
            return onError(e.type || "enrollFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onError,
        dispatch,
        onSuccess,
        csrfToken,
        search.continue,
        token,
        analyticsPageId,
        navigate
    ]);
    return {
        enrollSecurityKey: enrollSecurityKey,
        confirmingEnrollment: confirmingEnrollment
    };
};

});
parcelRegister("kMcLn", function(module, exports) {

$parcel$export(module.exports, "parseCreationOptionsFromJSON", function () { return $f20230d9b86de350$export$edb10dc0152a1b65; });
$parcel$export(module.exports, "parseRequestOptionsFromJSON", function () { return $f20230d9b86de350$export$c89152b37af49fa1; });
$parcel$export(module.exports, "create", function () { return $f20230d9b86de350$export$185802fd694ee1f5; });
$parcel$export(module.exports, "get", function () { return $f20230d9b86de350$export$3988ae62b71be9a3; });
// src/webauthn-json/base64url.ts
function $f20230d9b86de350$var$base64urlToBuffer(baseurl64String) {
    const padding = "==".slice(0, (4 - baseurl64String.length % 4) % 4);
    const base64String = baseurl64String.replace(/-/g, "+").replace(/_/g, "/") + padding;
    const str = atob(base64String);
    const buffer = new ArrayBuffer(str.length);
    const byteView = new Uint8Array(buffer);
    for(let i = 0; i < str.length; i++)byteView[i] = str.charCodeAt(i);
    return buffer;
}
function $f20230d9b86de350$var$bufferToBase64url(buffer) {
    const byteView = new Uint8Array(buffer);
    let str = "";
    for (const charCode of byteView)str += String.fromCharCode(charCode);
    const base64String = btoa(str);
    const base64urlString = base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
    return base64urlString;
}
// src/webauthn-json/convert.ts
var $f20230d9b86de350$var$copyValue = "copy";
var $f20230d9b86de350$var$convertValue = "convert";
function $f20230d9b86de350$var$convert(conversionFn, schema, input) {
    if (schema === $f20230d9b86de350$var$copyValue) return input;
    if (schema === $f20230d9b86de350$var$convertValue) return conversionFn(input);
    if (schema instanceof Array) return input.map((v)=>$f20230d9b86de350$var$convert(conversionFn, schema[0], v));
    if (schema instanceof Object) {
        const output = {};
        for (const [key, schemaField] of Object.entries(schema)){
            if (schemaField.derive) {
                const v = schemaField.derive(input);
                if (v !== void 0) input[key] = v;
            }
            if (!(key in input)) {
                if (schemaField.required) throw new Error(`Missing key: ${key}`);
                continue;
            }
            if (input[key] == null) {
                output[key] = null;
                continue;
            }
            output[key] = $f20230d9b86de350$var$convert(conversionFn, schemaField.schema, input[key]);
        }
        return output;
    }
}
function $f20230d9b86de350$var$derived(schema, derive) {
    return {
        required: true,
        schema: schema,
        derive: derive
    };
}
function $f20230d9b86de350$var$required(schema) {
    return {
        required: true,
        schema: schema
    };
}
function $f20230d9b86de350$var$optional(schema) {
    return {
        required: false,
        schema: schema
    };
}
// src/webauthn-json/basic/schema.ts
var $f20230d9b86de350$var$publicKeyCredentialDescriptorSchema = {
    type: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
    id: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
    transports: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue)
};
var $f20230d9b86de350$var$simplifiedExtensionsSchema = {
    appid: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    appidExclude: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    credProps: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue)
};
var $f20230d9b86de350$var$simplifiedClientExtensionResultsSchema = {
    appid: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    appidExclude: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    credProps: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue)
};
var $f20230d9b86de350$var$credentialCreationOptions = {
    publicKey: $f20230d9b86de350$var$required({
        rp: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
        user: $f20230d9b86de350$var$required({
            id: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
            name: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
            displayName: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue)
        }),
        challenge: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        pubKeyCredParams: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
        timeout: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        excludeCredentials: $f20230d9b86de350$var$optional([
            $f20230d9b86de350$var$publicKeyCredentialDescriptorSchema
        ]),
        authenticatorSelection: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        attestation: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        extensions: $f20230d9b86de350$var$optional($f20230d9b86de350$var$simplifiedExtensionsSchema)
    }),
    signal: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue)
};
var $f20230d9b86de350$var$publicKeyCredentialWithAttestation = {
    type: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
    id: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
    rawId: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
    authenticatorAttachment: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    response: $f20230d9b86de350$var$required({
        clientDataJSON: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        attestationObject: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        transports: $f20230d9b86de350$var$derived($f20230d9b86de350$var$copyValue, (response)=>{
            var _a;
            return ((_a = response.getTransports) == null ? void 0 : _a.call(response)) || [];
        })
    }),
    clientExtensionResults: $f20230d9b86de350$var$derived($f20230d9b86de350$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
var $f20230d9b86de350$var$credentialRequestOptions = {
    mediation: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    publicKey: $f20230d9b86de350$var$required({
        challenge: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        timeout: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        rpId: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        allowCredentials: $f20230d9b86de350$var$optional([
            $f20230d9b86de350$var$publicKeyCredentialDescriptorSchema
        ]),
        userVerification: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
        extensions: $f20230d9b86de350$var$optional($f20230d9b86de350$var$simplifiedExtensionsSchema)
    }),
    signal: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue)
};
var $f20230d9b86de350$var$publicKeyCredentialWithAssertion = {
    type: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
    id: $f20230d9b86de350$var$required($f20230d9b86de350$var$copyValue),
    rawId: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
    authenticatorAttachment: $f20230d9b86de350$var$optional($f20230d9b86de350$var$copyValue),
    response: $f20230d9b86de350$var$required({
        clientDataJSON: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        authenticatorData: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        signature: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue),
        userHandle: $f20230d9b86de350$var$required($f20230d9b86de350$var$convertValue)
    }),
    clientExtensionResults: $f20230d9b86de350$var$derived($f20230d9b86de350$var$simplifiedClientExtensionResultsSchema, (pkc)=>pkc.getClientExtensionResults())
};
// src/webauthn-json/basic/api.ts
function $f20230d9b86de350$export$edb10dc0152a1b65(requestJSON) {
    return $f20230d9b86de350$var$convert($f20230d9b86de350$var$base64urlToBuffer, $f20230d9b86de350$var$credentialCreationOptions, requestJSON);
}
function $f20230d9b86de350$var$createResponseToJSON(credential) {
    return $f20230d9b86de350$var$convert($f20230d9b86de350$var$bufferToBase64url, $f20230d9b86de350$var$publicKeyCredentialWithAttestation, credential);
}
function $f20230d9b86de350$export$c89152b37af49fa1(requestJSON) {
    return $f20230d9b86de350$var$convert($f20230d9b86de350$var$base64urlToBuffer, $f20230d9b86de350$var$credentialRequestOptions, requestJSON);
}
function $f20230d9b86de350$var$getResponseToJSON(credential) {
    return $f20230d9b86de350$var$convert($f20230d9b86de350$var$bufferToBase64url, $f20230d9b86de350$var$publicKeyCredentialWithAssertion, credential);
}
// src/webauthn-json/basic/supported.ts
function $f20230d9b86de350$export$5f747a46dc0eb6ee() {
    return !!(navigator.credentials && navigator.credentials.create && navigator.credentials.get && window.PublicKeyCredential);
}
// src/webauthn-json/browser-ponyfill.ts
async function $f20230d9b86de350$export$185802fd694ee1f5(options) {
    const response = await navigator.credentials.create(options);
    response.toJSON = ()=>$f20230d9b86de350$var$createResponseToJSON(response);
    return response;
}
async function $f20230d9b86de350$export$3988ae62b71be9a3(options) {
    const response = await navigator.credentials.get(options);
    response.toJSON = ()=>$f20230d9b86de350$var$getResponseToJSON(response);
    return response;
}

});

parcelRegister("lDnug", function(module, exports) {

$parcel$export(module.exports, "startEnroll", function () { return $6223782f6faf9f04$export$7c9dff46f0231dac; });
$parcel$export(module.exports, "confirmEnrollResponse", function () { return $6223782f6faf9f04$export$d0b229b11a2b0436; });
$parcel$export(module.exports, "confirmEnroll", function () { return $6223782f6faf9f04$export$d7fcff46f05bc313; });
$parcel$export(module.exports, "resetSmsEnrollError", function () { return $6223782f6faf9f04$export$11470e604dac27df; });
$parcel$export(module.exports, "startSmsEnroll", function () { return $6223782f6faf9f04$export$cc095becfa9fc392; });
$parcel$export(module.exports, "fetchUnsupportedCountries", function () { return $6223782f6faf9f04$export$275825b5052968f8; });
$parcel$export(module.exports, "smsEnrollmentCaptchaFailure", function () { return $6223782f6faf9f04$export$5d71d66cd3287216; });
$parcel$export(module.exports, "startSecurityKeyEnroll", function () { return $6223782f6faf9f04$export$a68b4a7d4e20cc56; });
$parcel$export(module.exports, "confirmSecurityKeyEnrollment", function () { return $6223782f6faf9f04$export$8adf731e4230fb01; });

var $jSnDV = parcelRequire("jSnDV");

var $8f2pb = parcelRequire("8f2pb");
const $6223782f6faf9f04$export$31554e24efe6c842 = (transactionToken, emailAddress, totpSecret, recoveryCode, totpUri)=>({
        type: 'START_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        emailAddress: emailAddress,
        totpSecret: totpSecret,
        recoveryCode: recoveryCode,
        totpUri: totpUri
    });
const $6223782f6faf9f04$export$90c618a494cc13d3 = (token)=>({
        type: 'START_ENROLL',
        token: token
    });
const $6223782f6faf9f04$export$7c9dff46f0231dac = (token)=>(dispatch, getState)=>{
        dispatch($6223782f6faf9f04$export$90c618a494cc13d3(token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify({
            token: token
        })}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) return data;
                else throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll`);
            })).then(({ transactionToken: transactionToken, emailAddress: emailAddress, totpSecret: totpSecret, recoveryCode: recoveryCode, totpUri: totpUri })=>{
            dispatch($6223782f6faf9f04$export$31554e24efe6c842(transactionToken, emailAddress, totpSecret, recoveryCode, totpUri));
        });
    };
const $6223782f6faf9f04$export$d0b229b11a2b0436 = (redirectUrl)=>({
        type: 'CONFIRM_ENROLL_RESPONSE',
        redirectUrl: redirectUrl
    });
const $6223782f6faf9f04$export$5727292bf8b89d3 = ()=>({
        type: 'CONFIRM_ENROLL_ERROR'
    });
const $6223782f6faf9f04$export$3c756426338d3bb7 = (otpCode, continueUrl)=>({
        type: 'CONFIRM_ENROLL',
        otpCode: otpCode,
        continueUrl: continueUrl
    });
const $6223782f6faf9f04$export$d7fcff46f05bc313 = (otpCode, continueUrl, navigate)=>(dispatch, getState)=>{
        dispatch($6223782f6faf9f04$export$3c756426338d3bb7(otpCode, continueUrl));
        const { csrfToken: csrfToken, mfaEnrollment: mfaEnrollment } = getState();
        return fetch(`/manage/rest/two-step-verification/confirm-enroll?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify({
            token: mfaEnrollment.token,
            continue: continueUrl
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                transactionToken: mfaEnrollment.transactionToken,
                otpCode: otpCode
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                case 204:
                    return Promise.resolve({
                        redirectUrl: null
                    });
                default:
                    throw response;
            }
        }).then(({ enrollmentActionType: enrollmentActionType, redirectUrl: redirectUrl })=>{
            if (enrollmentActionType === 'added') // `added` - user is enrolling TOTP as addition factor
            // This action is called by the enrollment wizard which is designed only for enrolling the first MFA factor.
            // If a user manually visit the url of the wizard while already have MFA enabled, the enrollment may succeed.
            // In that case, we want to redirect them directly to the continue URL instead of showing the recovery code,
            // which is only valid for first MFA factor enrollment.
            // Note: `redirectUrl` is the url to `idac/login/authorize` to force session rotation before redirecting the
            //       user to `continueUrl`, and will not be return as part of the `added` call.
            navigate(continueUrl || '/manage-profile/security/two-step-verification');
            else // `created` - user is enrolling TOTP as their first MFA factor
            // Show recovery page with button to redirect to `redirectUrl` at `idac/login/authorize` to force session rotation.
            dispatch($6223782f6faf9f04$export$d0b229b11a2b0436(redirectUrl));
        }, (response)=>{
            dispatch($6223782f6faf9f04$export$5727292bf8b89d3());
            throw new Error(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/confirm-enroll`);
        });
    };
const $6223782f6faf9f04$export$854ee8e5ea8056b6 = (transactionToken, recoveryCode, phoneNumber)=>({
        type: 'START_SMS_ENROLL_RESPONSE',
        transactionToken: transactionToken,
        recoveryCode: recoveryCode,
        phoneNumber: phoneNumber
    });
const $6223782f6faf9f04$export$4586154d8ae4818b = (smsEnrollError)=>({
        type: 'START_SMS_ENROLL_ERROR',
        smsEnrollError: smsEnrollError
    });
const $6223782f6faf9f04$export$11470e604dac27df = ()=>({
        type: 'RESET_SMS_ENROLL_ERROR'
    });
const $6223782f6faf9f04$export$3b42004cef4b7302 = (phoneNumber, token)=>({
        type: 'START_SMS_ENROLL',
        token: token,
        phoneNumber: phoneNumber
    });
const $6223782f6faf9f04$export$cc095becfa9fc392 = (phoneNumber, token, captchaToken)=>(dispatch, getState)=>{
        dispatch($6223782f6faf9f04$export$3b42004cef4b7302(phoneNumber, token));
        const { csrfToken: csrfToken } = getState();
        return fetch(`/manage/rest/two-step-verification/start-enroll-sms?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify({
            token: token
        })}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                phoneNumber: phoneNumber,
                captchaToken: captchaToken
            }),
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    throw response;
            }
        }).then(({ transactionToken: transactionToken, recoveryCode: recoveryCode })=>{
            dispatch($6223782f6faf9f04$export$854ee8e5ea8056b6(transactionToken, recoveryCode, phoneNumber));
        }, async (response)=>{
            const errorFromBadRequest = (response)=>response.json().then((body)=>{
                    switch(body.type){
                        case 'invalidPhoneNumber':
                            return 'invalid_phone_number';
                        case 'phoneNumberNotEligible':
                            return 'phone_number_not_eligible';
                        default:
                            return 'generic_error';
                    }
                }).catch(()=>'generic_error');
            const error = (response)=>{
                switch(response.status){
                    case 400:
                        return errorFromBadRequest(response);
                    case 429:
                        return 'too_many_sms';
                    default:
                        return 'generic_error';
                }
            };
            const errorLabel = await error(response);
            dispatch($6223782f6faf9f04$export$4586154d8ae4818b(errorLabel));
            if (errorLabel === 'generic_error') (0, $8f2pb.captureErrorMessage)(`${response.status} ${response.statusText}: /manage/rest/two-step-verification/start-enroll-sms`);
        });
    };
const $6223782f6faf9f04$export$d6651cd2d476e6a1 = (unsupportedCountries = [])=>({
        type: 'UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES',
        unsupportedCountries: unsupportedCountries
    });
const $6223782f6faf9f04$export$275825b5052968f8 = ()=>(dispatch)=>{
        return fetch(`/v2/mfa/enroll-sms/countries`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin'
        }).then((response)=>{
            switch(response.status){
                case 200:
                    return response.json();
                default:
                    return [];
            }
        }).then((body)=>{
            dispatch($6223782f6faf9f04$export$d6651cd2d476e6a1(body.unsupportedCountries || []));
        }, ()=>{
            dispatch($6223782f6faf9f04$export$d6651cd2d476e6a1([]));
        });
    };
const $6223782f6faf9f04$export$5d71d66cd3287216 = (isOnline)=>$6223782f6faf9f04$export$4586154d8ae4818b(isOnline ? 'captcha' : 'generic_error');
const $6223782f6faf9f04$export$a68b4a7d4e20cc56 = (token)=>({
        type: 'START_SECURITY_KEY_ENROLL',
        token: token
    });
const $6223782f6faf9f04$export$8adf731e4230fb01 = (recoveryCode)=>({
        type: 'CONFIRM_SECURITY_KEY_ENROLLMENT',
        recoveryCode: recoveryCode
    });

});

parcelRegister("4Jkx8", function(module, exports) {

$parcel$export(module.exports, "WebAuthnRegistrationErrorCode", function () { return $c86e479ee32e3f3b$export$99a3b8eef897cf04; });
$parcel$export(module.exports, "WebAuthnAuthenticationErrorCode", function () { return $c86e479ee32e3f3b$export$d73d3e8fcbb706b6; });
$parcel$export(module.exports, "isWebAuthnSupported", function () { return $c86e479ee32e3f3b$export$b48b2572c8b3a543; });
$parcel$export(module.exports, "translateRegistrationError", function () { return $c86e479ee32e3f3b$export$b31dc4fbcb20b129; });
$parcel$export(module.exports, "translateAuthenticationError", function () { return $c86e479ee32e3f3b$export$dafd1cf90bfb0daf; });
$parcel$export(module.exports, "challengeWithAuthenticator", function () { return $c86e479ee32e3f3b$export$70714cff41fa01ec; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $kMcLn = parcelRequire("kMcLn");

var $8f2pb = parcelRequire("8f2pb");
var $c86e479ee32e3f3b$export$99a3b8eef897cf04 = /*#__PURE__*/ function(WebAuthnRegistrationErrorCode) {
    WebAuthnRegistrationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnRegistrationErrorCode["InvalidCreationOptions"] = "invalid_creation_options";
    WebAuthnRegistrationErrorCode["Aborted"] = "aborted";
    WebAuthnRegistrationErrorCode["DiscoverableCredentialSupportRequired"] = "discoverable_credential_support_required";
    WebAuthnRegistrationErrorCode["UserVerificationSupportRequired"] = "user_verification_support_required";
    WebAuthnRegistrationErrorCode["PreviouslyRegistered"] = "previously_registered";
    WebAuthnRegistrationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnRegistrationErrorCode["MalformedPubKeyCredParams"] = "malformed_pub_key_cred_params";
    WebAuthnRegistrationErrorCode["NoSupportedPubKeyCredParamsAlgorithm"] = "no_supported_pub_key_cred_params_algorithm";
    WebAuthnRegistrationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnRegistrationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnRegistrationErrorCode["InvalidUserIdLength"] = "invalid_user_id_length";
    WebAuthnRegistrationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnRegistrationErrorCode;
}({});
var $c86e479ee32e3f3b$export$d73d3e8fcbb706b6 = /*#__PURE__*/ function(WebAuthnAuthenticationErrorCode) {
    WebAuthnAuthenticationErrorCode["WebAuthnNotSupported"] = "webauthn_not_supported";
    WebAuthnAuthenticationErrorCode["InvalidRequestOptions"] = "invalid_request_options";
    WebAuthnAuthenticationErrorCode["Aborted"] = "aborted";
    WebAuthnAuthenticationErrorCode["NotAllowed"] = "not_allowed";
    WebAuthnAuthenticationErrorCode["InvalidDomain"] = "invalid_domain";
    WebAuthnAuthenticationErrorCode["InvalidRpId"] = "invalid_rp_id";
    WebAuthnAuthenticationErrorCode["UnknownError"] = "unknown_error";
    return WebAuthnAuthenticationErrorCode;
}({});
const $c86e479ee32e3f3b$export$b48b2572c8b3a543 = ()=>!!window.PublicKeyCredential;
/**
 * Source: https://github.com/MasterKale/SimpleWebAuthn/blob/master/packages/browser/src/helpers/isValidDomain.ts
 *
 * A simple test to determine if a hostname is a properly-formatted domain name
 *
 * Regex sourced from here:
 * https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s15.html
 *
 * This regex is checking if a given string is a valid domain name.
 * It should start with a series of alphanumeric characters (can be separated by hyphens), followed by one or more dots, and end with a top-level domain of at least two alphabetic characters.
 */ const $c86e479ee32e3f3b$var$isValidDomain = (hostname)=>hostname === 'localhost' || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname);
const $c86e479ee32e3f3b$export$b31dc4fbcb20b129 = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_creation_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'ConstraintError':
            var _publicKey_authenticatorSelection, _publicKey_authenticatorSelection1;
            if (((_publicKey_authenticatorSelection = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection === void 0 ? void 0 : _publicKey_authenticatorSelection.requireResidentKey) === true) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 4)
            return "discoverable_credential_support_required";
            if (((_publicKey_authenticatorSelection1 = publicKey.authenticatorSelection) === null || _publicKey_authenticatorSelection1 === void 0 ? void 0 : _publicKey_authenticatorSelection1.userVerification) === 'required') // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 5)
            return "user_verification_support_required";
            break;
        case 'InvalidStateError':
            // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 20)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 3)
            return "previously_registered";
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            // https://stackoverflow.com/questions/77448336/handling-user-cancellation-when-creating-credentials-with-webauthn-api
            return "not_allowed";
        case 'NotSupportedError':
            const hasValidPubKeyCredParams = publicKey.pubKeyCredParams.some((param)=>param.type === 'public-key') || false;
            if (!hasValidPubKeyCredParams) // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "malformed_pub_key_cred_params";
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 2)
            return "no_supported_pub_key_cred_params_algorithm";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$c86e479ee32e3f3b$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 7)
            return "invalid_domain";
            if (publicKey.rp.id !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 8)
            return "invalid_rp_id";
            break;
        case 'TypeError':
            if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 5)
            return "invalid_user_id_length";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-make-cred (Step 8)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
const $c86e479ee32e3f3b$export$dafd1cf90bfb0daf = ({ error: error, options: options })=>{
    const { publicKey: publicKey } = options;
    if (!publicKey) return "invalid_request_options";
    switch(error.name){
        case 'AbortError':
            if (options.signal instanceof AbortSignal) // https://www.w3.org/TR/webauthn-2/#sctn-createCredential (Step 16)
            return "aborted";
            break;
        case 'NotAllowedError':
            // Platforms are overloading this error beyond what the spec defines
            return "not_allowed";
        case 'SecurityError':
            const effectiveDomain = window.location.hostname;
            if (!$c86e479ee32e3f3b$var$isValidDomain(effectiveDomain)) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 5)
            return "invalid_domain";
            if (publicKey.rpId !== effectiveDomain) // https://www.w3.org/TR/webauthn-2/#sctn-discover-from-external-source (Step 6)
            return "invalid_rp_id";
            break;
        case 'UnknownError':
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 1)
            // https://www.w3.org/TR/webauthn-2/#sctn-op-get-assertion (Step 12)
            return "unknown_error";
    }
    // for anything else, return unknown error
    return "unknown_error";
};
const $c86e479ee32e3f3b$export$70714cff41fa01ec = async (requestOptions)=>{
    try {
        const options = (0, $kMcLn.parseRequestOptionsFromJSON)({
            publicKey: (0, $6EnDC._)((0, $ty6PY._)({}, requestOptions), {
                timeout: 60000
            })
        });
        try {
            const securityKeyCredential = await (0, $kMcLn.get)(options);
            return {
                success: true,
                data: securityKeyCredential.toJSON()
            };
        } catch (error) {
            (0, $8f2pb.captureErrorMessage)('Authentication failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = $c86e479ee32e3f3b$export$dafd1cf90bfb0daf({
                error: error,
                options: options
            });
            return {
                success: false,
                error: errorCode
            };
        }
    } catch (error) {
        (0, $8f2pb.captureErrorMessage)('Failed to parse authenticate options for webauthn', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        return {
            success: false,
            error: "invalid_request_options"
        };
    }
};

});



parcelRegister("bbuZ2", function(module, exports) {
$parcel$export(module.exports, "ChallengeApiError", function () { return (parcelRequire("btxlE")).ChallengeApiError; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return (parcelRequire("btxlE")).useChallengeSecurityKey; });
parcelRequire("btxlE");

});
parcelRegister("btxlE", function(module, exports) {

$parcel$export(module.exports, "ChallengeApiError", function () { return $1fa5472cbe257c27$export$eba107851027d37; });
$parcel$export(module.exports, "useChallengeSecurityKey", function () { return $1fa5472cbe257c27$export$9b0f7f7d25e7c579; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $kMcLn = parcelRequire("kMcLn");

var $3ir1n = parcelRequire("3ir1n");

var $jSnDV = parcelRequire("jSnDV");

var $4Jkx8 = parcelRequire("4Jkx8");

var $8f2pb = parcelRequire("8f2pb");

var $9NVnN = parcelRequire("9NVnN");

var $kZj5j = parcelRequire("kZj5j");
const $1fa5472cbe257c27$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengeSecurityKey';
var $1fa5472cbe257c27$export$eba107851027d37 = /*#__PURE__*/ function(ChallengeApiError) {
    ChallengeApiError["transactionTokenNotFound"] = "transactionTokenNotFound";
    ChallengeApiError["challengeFailure"] = "challengeFailure";
    ChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return ChallengeApiError;
}({});
const $1fa5472cbe257c27$var$challenge = async ({ transactionToken: transactionToken })=>{
    try {
        const response = await fetch(`/v2/mfa/security-key/challenge?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/mfa/security-key/challenge`);
    }
};
const $1fa5472cbe257c27$var$authorize = async ({ transactionToken: transactionToken })=>{
    try {
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
        queryParams.transactionToken = transactionToken;
        const response = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(queryParams)}`);
        switch(response.status){
            case 200:
                const authorizeResponse = await response.json();
                return {
                    success: true,
                    data: authorizeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /rest/mfa/authorize`);
    }
};
const $1fa5472cbe257c27$var$challengeWithAuthenticator = async (requestOptions)=>{
    try {
        const options = (0, $kMcLn.parseRequestOptionsFromJSON)({
            publicKey: (0, $6EnDC._)((0, $ty6PY._)({}, requestOptions), {
                timeout: 60000
            })
        });
        try {
            const securityKeyCredential = await (0, $kMcLn.get)(options);
            return {
                success: true,
                data: securityKeyCredential.toJSON()
            };
        } catch (error) {
            (0, $8f2pb.captureErrorMessage)('Security key authentication failed', {
                webauthnError: {
                    name: error.name,
                    message: JSON.stringify(error.message)
                }
            });
            const errorCode = (0, $4Jkx8.translateAuthenticationError)({
                error: error,
                options: options
            });
            return {
                success: false,
                error: errorCode
            };
        }
    } catch (error) {
        (0, $8f2pb.captureErrorMessage)('Failed to parse authenticate options for security key', {
            webauthnError: {
                name: error.name,
                message: JSON.stringify(error.message)
            }
        });
        return {
            success: false,
            error: (0, $4Jkx8.WebAuthnAuthenticationErrorCode).InvalidRequestOptions
        };
    }
};
const $1fa5472cbe257c27$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, analyticsClient: analyticsClient, pageId: pageId })=>{
    try {
        const clientExtensionResultsJsonString = JSON.stringify(assertionJson.clientExtensionResults);
        const response = await fetch(`/v2/mfa/security-key/verify?transactionToken=${transactionToken}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify((0, $6EnDC._)((0, $ty6PY._)({}, assertionJson), {
                clientExtensionResults: clientExtensionResultsJsonString
            }))
        });
        switch(response.status){
            case 200:
                {
                    const { transactionToken: transactionToken } = await response.json();
                    const verifyResponseResult = await $1fa5472cbe257c27$var$authorize({
                        transactionToken: transactionToken
                    });
                    if (!verifyResponseResult.success) switch(verifyResponseResult.error){
                        case 'too_many_requests':
                            return {
                                success: false,
                                error: 'too_many_requests'
                            };
                        default:
                            throw new Error('error during verification of security key');
                    }
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'succeeded',
                        subject: $1fa5472cbe257c27$var$ANALYTIC_EVENT_SUBJECT_ID
                    });
                    return {
                        success: true,
                        data: verifyResponseResult.data
                    };
                }
            case 400:
                {
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
                    const redirectUri = $1fa5472cbe257c27$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        pageId: pageId,
                        currentQueryParams: queryParams
                    });
                    return {
                        success: true,
                        data: {
                            redirectUri: redirectUri
                        }
                    };
                }
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of security key`);
    }
};
const $1fa5472cbe257c27$export$9b0f7f7d25e7c579 = (pageId, onSuccess, onError)=>{
    const isSupported = (0, $4Jkx8.isWebAuthnSupported)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [authenticating, setAuthenticating] = (0, $8ZuGG.useState)(false);
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const onErrorWithTrackingAnalytics = (0, $8ZuGG.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'failed',
            subject: $1fa5472cbe257c27$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
        onError(error);
    }, [
        analyticsClient,
        onError,
        pageId
    ]);
    const challengeSecurityKey = (0, $8ZuGG.useCallback)(async ()=>{
        analyticsClient.trackingEvent({
            page: pageId,
            action: 'started',
            subject: $1fa5472cbe257c27$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) return onErrorWithTrackingAnalytics((0, $4Jkx8.WebAuthnAuthenticationErrorCode).WebAuthnNotSupported);
        const transactionToken = new URLSearchParams(window.location.search).get('transactionToken');
        if (!transactionToken) return onErrorWithTrackingAnalytics("transactionTokenNotFound");
        try {
            setAuthenticating(true);
            const securityKeyChallengeResponseResult = await $1fa5472cbe257c27$var$challenge({
                transactionToken: transactionToken
            });
            if (!securityKeyChallengeResponseResult.success) {
                setAuthenticating(false);
                switch(securityKeyChallengeResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            const { requestOptions: requestOptions, transactionToken: newTransactionToken } = securityKeyChallengeResponseResult.data;
            // This updates the search query params in the address bar, but does not trigger
            // a page reload due to the pathname remains unchanged
            // Setting this would ensure the user loads the page with the updated token should
            // they refresh (eg. F5) the page
            navigate({
                search: (0, $kZj5j.replaceQueryParam)('transactionToken', newTransactionToken)
            });
            const authenticatorChallengeResult = await $1fa5472cbe257c27$var$challengeWithAuthenticator(requestOptions);
            if (!authenticatorChallengeResult.success) {
                setAuthenticating(false);
                return onErrorWithTrackingAnalytics(authenticatorChallengeResult.error);
            }
            const securityKeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $1fa5472cbe257c27$var$verify({
                transactionToken: newTransactionToken,
                assertionJson: securityKeyCredentialJson,
                analyticsClient: analyticsClient,
                pageId: pageId
            });
            if (!verifyResponseResult.success) {
                setAuthenticating(false);
                switch(verifyResponseResult.error){
                    case 'too_many_requests':
                        return onErrorWithTrackingAnalytics("tooManyRequests");
                    default:
                        return onErrorWithTrackingAnalytics("challengeFailure");
                }
            }
            return onSuccess(verifyResponseResult.data);
        } catch (e) {
            setAuthenticating(false);
            return onErrorWithTrackingAnalytics("challengeFailure");
        }
    }, [
        isSupported,
        analyticsClient,
        onSuccess,
        pageId,
        onErrorWithTrackingAnalytics,
        navigate
    ]);
    return {
        challengeSecurityKey: challengeSecurityKey,
        authenticating: authenticating
    };
};
function $1fa5472cbe257c27$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, pageId: pageId, currentQueryParams: currentQueryParams }) {
    analyticsClient.trackingEvent({
        page: pageId,
        subject: $1fa5472cbe257c27$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: 'login_redirect_invalid_token'
        }
    });
    delete currentQueryParams.transactionToken;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === '' ? '' : `&${currentQueryString}`;
    return new URL(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`, window.location.origin);
}

});



parcelRegister("gf1BP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0bd04ce8c5bd74f$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $d0bd04ce8c5bd74f$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    failedToUseKeyMessage: {
        id: 'mfa.challenge.securitykey.failedtousekey.label',
        defaultMessage: "We\u2019re not sure what went wrong. Try again. If this keeps happening, contact support."
    },
    securityKeyTooManyAttemptsMessage: {
        id: 'mfa.challenge.securitykey.toomanyattempts.label',
        defaultMessage: "You\u2019ve reached your rate limit. Try again in a few minutes."
    },
    webauthnNotSupportedMessage: {
        id: 'mfa.challenge.securitykey.not-supported.label',
        defaultMessage: "We\u2019re unable to verify your security key. Make sure your browser supports WebAuthn."
    },
    webAuthnMalformedConfiguration: {
        id: 'mfa.challenge.webauthn.malformed-configuration.label',
        defaultMessage: "We\u2019re unable to authenticate with your security key. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to failure to initiate the security key challenge process due to invalid configurations passed to the WebAuthN API and authenticator.'
    },
    webAuthnAborted: {
        id: 'mfa.challenge.webauthn.aborted.label',
        defaultMessage: "We\u2019re unable to detect your authentication signal. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the WebAuthn authentication ceremony receiving an abort signal'
    },
    webAuthnAuthenticationIncomplete: {
        id: 'mfa.challenge.webauthn.authentication-incomplete.label',
        defaultMessage: 'You did not complete the authentication process. Try again.',
        description: 'Error message displayed when security key challenge failed due to failure to complete the process. This is commonly seen if the user cancel out of the authentication, or the process went timeout.'
    },
    webAuthnInvalidDomain: {
        id: 'mfa.challenge.webauthn.invalid-domain.label',
        defaultMessage: 'Your domain does not match the Atlassian domain.',
        description: 'Error message displayed when security key challenge failed due to the current domain the user is on is invalid'
    },
    webauthnAuthenticationFailed: {
        id: 'mfa.challenge.webauthn.authenticaton-failed.label',
        defaultMessage: "Your security key couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support.",
        description: 'Error message displayed when security key challenge failed due to the authenticator failed to complete the authentication step for unidentifiable reasons'
    }
});

});

parcelRegister("kfd93", function(module, exports) {

$parcel$export(module.exports, "SecurityKey", function () { return $4d4f905a89fca67b$export$9dccf97bc0beb20b; });

var $6rcps = parcelRequire("6rcps");

var $9Vz68 = parcelRequire("9Vz68");

var $7UIb1 = parcelRequire("7UIb1");

var $ihLLY = parcelRequire("ihLLY");
parcelRequire("8ZuGG");

var $g5rao = parcelRequire("g5rao");
let $4d4f905a89fca67b$var$_ = (t)=>t, $4d4f905a89fca67b$var$t, $4d4f905a89fca67b$var$t1;
const $4d4f905a89fca67b$var$baseSpacing = (0, $g5rao.default)('space.100');
const $4d4f905a89fca67b$var$DefaultSecurityKeyContainer = (0, $9Vz68.default).div($4d4f905a89fca67b$var$t1 || ($4d4f905a89fca67b$var$t1 = $4d4f905a89fca67b$var$_`
  background: url(${0}) no-repeat center 0 / calc(${0} * 14.5);
  min-width: 100%;
  margin-top: ${0};
  padding-top: calc(${0} * 18);

  box-sizing: border-box;

  ${0}
`), (0, (/*@__PURE__*/$parcel$interopDefault($7UIb1))), $4d4f905a89fca67b$var$baseSpacing, $4d4f905a89fca67b$var$baseSpacing, $4d4f905a89fca67b$var$baseSpacing, (0, $ihLLY.media).handheld($4d4f905a89fca67b$var$t || ($4d4f905a89fca67b$var$t = $4d4f905a89fca67b$var$_`
    background: 0;
    padding: 0;
  `)));
const $4d4f905a89fca67b$export$9dccf97bc0beb20b = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)($4d4f905a89fca67b$var$DefaultSecurityKeyContainer, {
        id: id,
        children: children
    });
};

});
parcelRegister("7UIb1", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "lock-closed.59f9256b.svg";

});



parcelRegister("jBQFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8482370d73ec17a3$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $8482370d73ec17a3$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    mfTotpPrompt: {
        id: 'mf.totp.prompt',
        defaultMessage: 'Enter the code from your authenticator app.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code from their authenticator app'
    },
    mfSmsPrompt: {
        id: 'mf.sms.prompt',
        defaultMessage: 'Enter the code you received by SMS.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their SMS'
    },
    mfEmailPrompt: {
        id: 'mf.email.prompt',
        defaultMessage: 'Enter the code from your email.',
        description: 'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their email'
    }
});

});


parcelRegister("aupLj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8c8acd23d294b39$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $gJFTu = parcelRequire("gJFTu");

var $1SvOA = parcelRequire("1SvOA");

var $1Acyk = parcelRequire("1Acyk");
let $b8c8acd23d294b39$var$_ = (t)=>t, $b8c8acd23d294b39$var$t;
const $b8c8acd23d294b39$var$ErrorMessage = (0, $9Vz68.default).div($b8c8acd23d294b39$var$t || ($b8c8acd23d294b39$var$t = $b8c8acd23d294b39$var$_`
  color: ${0};
  margin-bottom: ${0}px;
`), (0, $kTdw7).R500, (0, $5b7Z4.gridSize)() * 2);
const $b8c8acd23d294b39$var$RecoveryEmailForm = ({ email: email, recoveryEmailError: recoveryEmailError, sendEmail: sendEmail })=>{
    const [loading, setLoading] = (0, $8ZuGG.useState)(false);
    const sendRecoveryEmail = ()=>{
        setLoading(true);
        sendEmail();
    };
    (0, $8ZuGG.useEffect)(()=>{
        if (recoveryEmailError) setLoading(false);
    }, [
        recoveryEmailError
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $1Acyk.SecurityWall), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.recoveryemailform.desc",
                tagName: "p",
                defaultMessage: "We'll email you at {email} with instructions for how to recover access to your account.",
                values: {
                    email: /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: email
                    })
                }
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "mf.recoveryemailform.security.desc",
                tagName: "p",
                defaultMessage: "For security reasons, this process will take some time to complete, and you may be contacted by our Support team for verification."
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $gJFTu.default), {
                children: [
                    recoveryEmailError && /*#__PURE__*/ (0, $6rcps.jsx)($b8c8acd23d294b39$var$RecoveryEmailErrorMessage, {
                        recoveryEmailError: recoveryEmailError
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        id: "send-recovery-email-button",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: sendRecoveryEmail,
                        isDisabled: loading,
                        isLoading: loading,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.recoveryemailform.sendemail",
                            defaultMessage: "Send recovery email"
                        })
                    })
                ]
            })
        ]
    });
};
const $b8c8acd23d294b39$var$RecoveryEmailErrorMessage = ({ recoveryEmailError: recoveryEmailError })=>{
    if (!recoveryEmailError) return null;
    switch(recoveryEmailError){
        case 'alreadyRequested':
            return /*#__PURE__*/ (0, $6rcps.jsx)($b8c8acd23d294b39$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.recoveryemailform.error.alreadyRequested",
                    defaultMessage: "You have already requested account recovery instructions. If the account exists, these instructions will be sent to your email address. Note that this may take some time to complete."
                })
            });
        case 'userIsManaged':
        case 'userNotFound':
            return /*#__PURE__*/ (0, $6rcps.jsx)($b8c8acd23d294b39$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.recoveryemailform.error.genericExpected",
                    defaultMessage: "Your recovery request can't be processed. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
        case 'unknown':
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)($b8c8acd23d294b39$var$ErrorMessage, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "mf.recoveryemailform.error.unknown",
                    defaultMessage: "Unexpected error happened. Please <support-link>contact support</support-link>.",
                    values: {
                        'support-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                                href: 'https://www.atlassian.com/company/contact/general-inquiries',
                                children: chunks
                            })
                    }
                })
            });
    }
};
var $b8c8acd23d294b39$export$2e2bcd8739ae039 = $b8c8acd23d294b39$var$RecoveryEmailForm;

});

parcelRegister("8Gs9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae7f5dfb133ee33c$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $bRtXr = parcelRequire("bRtXr");

var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");

var $3ir1n = parcelRequire("3ir1n");
let $ae7f5dfb133ee33c$var$_ = (t)=>t, $ae7f5dfb133ee33c$var$t, $ae7f5dfb133ee33c$var$t1, $ae7f5dfb133ee33c$var$t2;
const $ae7f5dfb133ee33c$var$EmailSentImg = (0, $9Vz68.default).img($ae7f5dfb133ee33c$var$t || ($ae7f5dfb133ee33c$var$t = $ae7f5dfb133ee33c$var$_`
  height: ${0}px;
  display: block;
  margin: ${0}px auto ${0}px;
`), (0, $5b7Z4.gridSize)() * 16, (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)() * 2);
const $ae7f5dfb133ee33c$var$Email = (0, $9Vz68.default).p($ae7f5dfb133ee33c$var$t1 || ($ae7f5dfb133ee33c$var$t1 = $ae7f5dfb133ee33c$var$_`
  font: ${0};
  margin-top: ${0}px;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $g5rao.default)('font.heading.small'), (0, $5b7Z4.gridSize)());
const $ae7f5dfb133ee33c$var$TextWrapper = (0, $9Vz68.default).div($ae7f5dfb133ee33c$var$t2 || ($ae7f5dfb133ee33c$var$t2 = $ae7f5dfb133ee33c$var$_`
  p {
    margin: 0;
  }
`));
const $ae7f5dfb133ee33c$var$RecoveryEmailSent = ({ email: email, emailSentPageId: emailSentPageId, expirePageId: expirePageId, isExpired: isExpired })=>{
    (0, $3ir1n.usePageViewedEvent)(isExpired ? expirePageId : emailSentPageId);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)($ae7f5dfb133ee33c$var$EmailSentImg, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($bRtXr)))
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($ae7f5dfb133ee33c$var$TextWrapper, {
                children: [
                    isExpired && /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "mf.recoveryemailsent.expired",
                        tagName: "p",
                        defaultMessage: "Your recovery link expired."
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "mf.recoveryemailsent",
                        tagName: "p",
                        defaultMessage: "We've emailed instructions to:"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)($ae7f5dfb133ee33c$var$Email, {
                children: email
            })
        ]
    });
};
var $ae7f5dfb133ee33c$export$2e2bcd8739ae039 = $ae7f5dfb133ee33c$var$RecoveryEmailSent;

});
parcelRegister("bRtXr", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "check-your-email.39bc0dca.svg";

});


parcelRegister("lPS1q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4b5197b61d771ce$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $dZRKj = parcelRequire("dZRKj");

var $dMtGq = parcelRequire("dMtGq");

var $5b7Z4 = parcelRequire("5b7Z4");

var $8PH8E = parcelRequire("8PH8E");

var $1SvOA = parcelRequire("1SvOA");

var $fawLu = parcelRequire("fawLu");

var $1Acyk = parcelRequire("1Acyk");

var $a3fkM = parcelRequire("a3fkM");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
let $c4b5197b61d771ce$var$_ = (t)=>t, $c4b5197b61d771ce$var$t, $c4b5197b61d771ce$var$t1;
const $c4b5197b61d771ce$var$ButtonContainer = (0, $9Vz68.default).div($c4b5197b61d771ce$var$t || ($c4b5197b61d771ce$var$t = $c4b5197b61d771ce$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $c4b5197b61d771ce$var$MessageWrapper = (0, $9Vz68.default).div($c4b5197b61d771ce$var$t1 || ($c4b5197b61d771ce$var$t1 = $c4b5197b61d771ce$var$_`
  padding-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 1.5);
const $c4b5197b61d771ce$var$RecoveryCodeField = ({ disabled: disabled, fieldErrorFromParent: fieldErrorFromParent, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const fieldTextRef = (0, $8ZuGG.useRef)(null);
    const [fieldValue, setFieldValue] = (0, $8ZuGG.useState)('');
    const [fieldError, setFieldError] = (0, $8ZuGG.useState)(fieldErrorFromParent);
    const previousFieldValue = (0, $7AZRg.usePrevious)(fieldValue);
    const previousFieldErrorFromParent = (0, $7AZRg.usePrevious)(fieldErrorFromParent);
    const handlePaste = (e)=>{
        const target = e.target;
        const selectionStart = target.selectionStart || 0;
        const selectionEnd = target.selectionEnd || target.value.length;
        const start = target.value.substr(0, selectionStart);
        const middle = (e.clipboardData || window.clipboardData).getData('text/plain').replace(/\W/g, '').substr(0, target.maxLength - target.value.length - selectionStart + selectionEnd);
        const end = target.value.substr(selectionEnd);
        //timeout to allow input update UI
        setTimeout(()=>setFieldValue(start + middle + end));
    };
    const handleChange = (e)=>{
        setFieldValue(e.currentTarget.value.replace(/\W/g, '').toUpperCase());
        setFieldError(null);
    };
    const handleInvalid = (e)=>{
        e.preventDefault();
        setFieldError({
            errorCode: 'invalid_otp_pattern'
        });
    };
    (0, $8ZuGG.useEffect)(()=>{
        const input = fieldTextRef.current;
        if (input) {
            input.addEventListener('invalid', handleInvalid);
            input.addEventListener('paste', handlePaste);
        }
        return ()=>{
            if (input) {
                input.removeEventListener('invalid', handleInvalid);
                input.removeEventListener('paste', handlePaste);
            }
        };
    }, []);
    (0, $8ZuGG.useEffect)(()=>{
        if (!previousFieldErrorFromParent && fieldErrorFromParent) {
            setFieldError(fieldErrorFromParent);
            fieldTextRef.current && fieldTextRef.current.select();
        }
    }, [
        fieldErrorFromParent,
        previousFieldErrorFromParent
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (fieldValue !== previousFieldValue) onChange && onChange({
            target: fieldTextRef.current
        });
    }, [
        fieldValue,
        previousFieldValue,
        onChange
    ]);
    const errorContent = (error)=>{
        const errorMessages = {
            invalid_recovery_code: formatMessage((0, $fawLu.default).errorsInvalidRecoverCode),
            invalid_recovery_code_format: formatMessage((0, $fawLu.default).errorsInvalidRecoveryCodeFormat),
            field_required: formatMessage((0, $fawLu.default).errorsNoRecoveryCode),
            invalid_token: /*#__PURE__*/ (0, $6rcps.jsxs)("form", {
                onSubmit: ()=>window.location.reload(),
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "mf.mfform.errors.invalid_token",
                        defaultMessage: "Your session has expired. Please refresh the page and try again."
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)($c4b5197b61d771ce$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            type: "submit",
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "common.refresh",
                                defaultMessage: "Refresh"
                            })
                        })
                    })
                ]
            }),
            invalid_otp_pattern: formatMessage((0, $fawLu.default).errorsInvalidOtpPattern)
        };
        return error && // @ts-ignore genuine TypeScript screw up, need to turn RecoveryCodeFieldError into a genuine discriminated union
        (errorMessages[error.errorCode] || error.message && typeof error.message === 'string');
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
            name: "recoveryCode",
            type: "text",
            label: formatMessage((0, $fawLu.default).mfRecoveryFormPlaceholder),
            autoFocus: true,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: !disabled && fieldError && errorContent(fieldError),
            value: fieldValue,
            isDisabled: disabled,
            pattern: "\\w{24}",
            maxLength: 24,
            isRequired: true,
            ref: fieldTextRef
        })
    });
};
const $c4b5197b61d771ce$var$RecoveryForm = ({ isLoading: isLoading, recoverAccount: recoverAccount, multifactorMethod: multifactorMethod, recoveryError: recoveryError })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const handleInputChange = (e)=>{
        const target = e.target;
        if (target && target.value.length === target.maxLength) recoverAccount(target.value);
    };
    const handleFormSubmit = (e)=>{
        e.preventDefault();
        // @ts-ignore check that recoveryCode is actually on the target
        recoverAccount(e.target.recoveryCode.value);
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $1Acyk.SecurityWall), {
        id: "two-step-verification-recovery-form",
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $a3fkM.InputMessage), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($c4b5197b61d771ce$var$MessageWrapper, {
                        children: multifactorMethod === 'security-key' ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.recoveryform.usekey.securitykey",
                            defaultMessage: "If you can't use your security key, log in with your emergency recovery key."
                        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.recoveryform.usekey",
                            defaultMessage: "If you can't use your phone, log in with your emergency recovery key."
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.InlineMessageContainer), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dMtGq.default), {
                            appearance: "info",
                            placement: "bottom-end",
                            iconLabel: formatMessage({
                                id: 'mf.recoveryform.help.inline-message.button.label',
                                defaultMessage: 'More info',
                                description: 'Icon button label for the inline message'
                            }),
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $a3fkM.StyledMessage), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.recoveryform.help",
                                    defaultMessage: "We asked you to save your emergency recovery key when you enabled two-step verification. You might have saved it in a local file or printed it out."
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)("form", {
                autoComplete: "off",
                onSubmit: handleFormSubmit,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($c4b5197b61d771ce$var$RecoveryCodeField, {
                        disabled: isLoading,
                        fieldErrorFromParent: recoveryError,
                        onChange: handleInputChange
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)($c4b5197b61d771ce$var$ButtonContainer, {
                        id: "two-step-verification-recovery-submit",
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "common.login",
                                defaultMessage: "Log in"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $c4b5197b61d771ce$export$2e2bcd8739ae039 = $c4b5197b61d771ce$var$RecoveryForm;

});
parcelRegister("8PH8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939f23b7f10a5d95$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $939f23b7f10a5d95$var$_ = (t)=>t, $939f23b7f10a5d95$var$t;
const $939f23b7f10a5d95$var$FieldGroupStyled = (0, $9Vz68.default).div($939f23b7f10a5d95$var$t || ($939f23b7f10a5d95$var$t = $939f23b7f10a5d95$var$_`
  margin-top: ${0}px;
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-top, opacity, transform;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;

  /* Offset @atlaskit/form/Field margin-top */
  &:first-of-type {
    margin-top: ${0}px;
  }

  &.hidden {
    height: 0;
    margin-top: 0;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    overflow: hidden;
  }
`), (0, $5b7Z4.gridSize)(), -(0, $5b7Z4.gridSize)());
function $939f23b7f10a5d95$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $6rcps.jsx)($939f23b7f10a5d95$var$FieldGroupStyled, (0, $6EnDC._)((0, $ty6PY._)({}, props), {
        className: `${props.className ? props.className : ''} ${props.isHidden ? 'hidden' : ''}`
    }));
}

});

parcelRegister("fawLu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4766e9a4a7486085$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $4766e9a4a7486085$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    mfRecoveryFormPlaceholder: {
        id: 'mf.recoveryform.placeholder',
        defaultMessage: '24-character emergency recovery key',
        description: ''
    },
    errorsInvalidRecoverCode: {
        id: 'mf.recoveryform.errors.invalid_recovery_code',
        defaultMessage: 'You entered an incorrect emergency recovery key.'
    },
    errorsInvalidRecoveryCodeFormat: {
        id: 'mf.recoveryform.errors.invalid_recovery_code_format',
        defaultMessage: 'You entered an invalid emergency recovery key.'
    },
    errorsNoRecoveryCode: {
        id: 'mf.recoveryform.errors.no_recovery_code',
        defaultMessage: 'Please enter your emergency recovery key.'
    },
    errorsInvalidOtpPattern: {
        id: 'mf.recoveryform.errors.invalid_otp_pattern',
        defaultMessage: 'Your emergency recovery key needs to be 24 characters.'
    }
});

});


parcelRegister("9hHTk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00b9dc14fdaf356d$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $bl8w7 = parcelRequire("bl8w7");

var $iRVQ8 = parcelRequire("iRVQ8");

var $8EIEv = parcelRequire("8EIEv");

var $bKhzR = parcelRequire("bKhzR");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");

var $gJFTu = parcelRequire("gJFTu");

var $c8pR8 = parcelRequire("c8pR8");

var $1SvOA = parcelRequire("1SvOA");

var $9bZmd = parcelRequire("9bZmd");

var $ihLLY = parcelRequire("ihLLY");

var $xe7jL = parcelRequire("xe7jL");

var $aeLyl = parcelRequire("aeLyl");

var $4ezqB = parcelRequire("4ezqB");
var $7z2f3 = parcelRequire("7z2f3");
var $1x0MG = parcelRequire("1x0MG");

var $lunc5 = parcelRequire("lunc5");

var $kOqgB = parcelRequire("kOqgB");
let $00b9dc14fdaf356d$var$_ = (t)=>t, $00b9dc14fdaf356d$var$t, $00b9dc14fdaf356d$var$t1, $00b9dc14fdaf356d$var$t2, $00b9dc14fdaf356d$var$t3, $00b9dc14fdaf356d$var$t4, $00b9dc14fdaf356d$var$t5, $00b9dc14fdaf356d$var$t6, $00b9dc14fdaf356d$var$t7, $00b9dc14fdaf356d$var$t8, $00b9dc14fdaf356d$var$t9, $00b9dc14fdaf356d$var$t10, $00b9dc14fdaf356d$var$t11, $00b9dc14fdaf356d$var$t12, $00b9dc14fdaf356d$var$t13, $00b9dc14fdaf356d$var$t14, $00b9dc14fdaf356d$var$t15, $00b9dc14fdaf356d$var$t16, $00b9dc14fdaf356d$var$t17, $00b9dc14fdaf356d$var$t18, $00b9dc14fdaf356d$var$t19, $00b9dc14fdaf356d$var$t20, $00b9dc14fdaf356d$var$t21, $00b9dc14fdaf356d$var$t22, $00b9dc14fdaf356d$var$t23, $00b9dc14fdaf356d$var$t24;
const $00b9dc14fdaf356d$var$imageWidth = 359;
const $00b9dc14fdaf356d$var$Container = (0, $9Vz68.default).div($00b9dc14fdaf356d$var$t1 || ($00b9dc14fdaf356d$var$t1 = $00b9dc14fdaf356d$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  width: ${0}px;
  min-height: ${0}px;
  height: calc(100vh - ${0}px);
  background: url(${0}) bottom center/ ${0}px no-repeat;

  ${0}
`), (0, $5b7Z4.gridSize)() * 82, (0, $5b7Z4.gridSize)() * 80, (0, $5b7Z4.gridSize)(), (0, (/*@__PURE__*/$parcel$interopDefault($9bZmd))), $00b9dc14fdaf356d$var$imageWidth, (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t || ($00b9dc14fdaf356d$var$t = $00b9dc14fdaf356d$var$_`
    width: ${0}px;
    background: none;
    padding-bottom: 0;
  `), (0, $5b7Z4.gridSize)() * 44));
const $00b9dc14fdaf356d$var$Subcontainer = (0, $9Vz68.default).div($00b9dc14fdaf356d$var$t3 || ($00b9dc14fdaf356d$var$t3 = $00b9dc14fdaf356d$var$_`
  display: flex;
  flex-direction: column;
  width: ${0}px;

  ${0}
`), (0, $5b7Z4.gridSize)() * 52, (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t2 || ($00b9dc14fdaf356d$var$t2 = $00b9dc14fdaf356d$var$_`
    width: ${0}px;
  `), (0, $5b7Z4.gridSize)() * 44));
const $00b9dc14fdaf356d$var$Heading = (0, $9Vz68.default).h2($00b9dc14fdaf356d$var$t5 || ($00b9dc14fdaf356d$var$t5 = $00b9dc14fdaf356d$var$_`
  display: flex;
  justify-content: center;
  margin-top: ${0}px !important;

  ${0}
`), (0, $5b7Z4.gridSize)() * 5, (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t4 || ($00b9dc14fdaf356d$var$t4 = $00b9dc14fdaf356d$var$_`
    display: none;
  `)));
const $00b9dc14fdaf356d$var$Subheading = (0, $9Vz68.default).h3($00b9dc14fdaf356d$var$t6 || ($00b9dc14fdaf356d$var$t6 = $00b9dc14fdaf356d$var$_`
  display: flex;
  align-items: center;
  margin-top: ${0}px !important;

  &::before {
    counter-increment: counter;
    content: counter(counter) '. ';
    margin-right: ${0}px;
  }
`), (0, $5b7Z4.gridSize)() * 3.5, (0, $5b7Z4.gridSize)() * 0.5);
const $00b9dc14fdaf356d$var$DesktopSubheading = (0, $9Vz68.default)($00b9dc14fdaf356d$var$Subheading)($00b9dc14fdaf356d$var$t8 || ($00b9dc14fdaf356d$var$t8 = $00b9dc14fdaf356d$var$_`
  ${0}
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t7 || ($00b9dc14fdaf356d$var$t7 = $00b9dc14fdaf356d$var$_`
    display: none;
  `)));
const $00b9dc14fdaf356d$var$MobileSubheading = (0, $9Vz68.default)($00b9dc14fdaf356d$var$Subheading)($00b9dc14fdaf356d$var$t10 || ($00b9dc14fdaf356d$var$t10 = $00b9dc14fdaf356d$var$_`
  display: none;
  justify-content: center;
  font-size: 16px;

  ${0}

  &::before {
    content: '';
    margin: 0;
  }
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t9 || ($00b9dc14fdaf356d$var$t9 = $00b9dc14fdaf356d$var$_`
    display: flex;
  `)));
const $00b9dc14fdaf356d$var$RecoveryCode = (0, $9Vz68.default).div($00b9dc14fdaf356d$var$t12 || ($00b9dc14fdaf356d$var$t12 = $00b9dc14fdaf356d$var$_`
  display: flex;
  justify-content: space-between;
  font: ${0};
  font-size: 24px;
  font-weight: bold;
  color: ${0};
  margin-top: ${0}px;

  ${0}
`), (0, $g5rao.default)('font.code'), (0, $kTdw7).N300, (0, $5b7Z4.gridSize)() * 2, (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t11 || ($00b9dc14fdaf356d$var$t11 = $00b9dc14fdaf356d$var$_`
    display: none;
  `)));
const $00b9dc14fdaf356d$var$MobileRecoveryCode = (0, $9Vz68.default)((0, $c8pR8.default))($00b9dc14fdaf356d$var$t14 || ($00b9dc14fdaf356d$var$t14 = $00b9dc14fdaf356d$var$_`
  display: none;
  text-align: center;
  font: ${0};
  font-size: 20px;
  color: ${0};
  margin-top: ${0}px;

  ${0}
`), (0, $g5rao.default)('font.code'), (0, $kTdw7).N300, (0, $5b7Z4.gridSize)() * 2, (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t13 || ($00b9dc14fdaf356d$var$t13 = $00b9dc14fdaf356d$var$_`
    display: block;
  `)));
const $00b9dc14fdaf356d$var$DropdownMenuContainer = (0, $9Vz68.default).div($00b9dc14fdaf356d$var$t16 || ($00b9dc14fdaf356d$var$t16 = $00b9dc14fdaf356d$var$_`
  display: flex;
  justify-content: flex-end;

  ${0}
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t15 || ($00b9dc14fdaf356d$var$t15 = $00b9dc14fdaf356d$var$_`
    display: none;
  `)));
const $00b9dc14fdaf356d$var$StyledButton = (0, $9Vz68.default)((0, $iRVQ8.default))($00b9dc14fdaf356d$var$t17 || ($00b9dc14fdaf356d$var$t17 = $00b9dc14fdaf356d$var$_`
  font-size: 14px !important;
  margin-left: auto !important;
  padding: 0 16px !important;
`));
const $00b9dc14fdaf356d$var$MobileButtonContainer = (0, $9Vz68.default)((0, $gJFTu.default))($00b9dc14fdaf356d$var$t19 || ($00b9dc14fdaf356d$var$t19 = $00b9dc14fdaf356d$var$_`
  display: none;

  ${0}
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t18 || ($00b9dc14fdaf356d$var$t18 = $00b9dc14fdaf356d$var$_`
    display: block;
  `)));
const $00b9dc14fdaf356d$var$DesktopParagraph = (0, $9Vz68.default).p($00b9dc14fdaf356d$var$t21 || ($00b9dc14fdaf356d$var$t21 = $00b9dc14fdaf356d$var$_`
  ${0}
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t20 || ($00b9dc14fdaf356d$var$t20 = $00b9dc14fdaf356d$var$_`
    display: none;
  `)));
const $00b9dc14fdaf356d$var$MobileParagraph = (0, $9Vz68.default).p($00b9dc14fdaf356d$var$t23 || ($00b9dc14fdaf356d$var$t23 = $00b9dc14fdaf356d$var$_`
  display: none;

  ${0}
`), (0, $ihLLY.media).handheld($00b9dc14fdaf356d$var$t22 || ($00b9dc14fdaf356d$var$t22 = $00b9dc14fdaf356d$var$_`
    display: block;
  `)));
const $00b9dc14fdaf356d$var$RecoveryPage = ({ isEmbedded: isEmbedded, recoveryCode: recoveryCode, onComplete: onComplete })=>{
    const [newCodeSaved, setNewCodeSaved] = (0, $8ZuGG.useState)(false);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    (0, $8ZuGG.useEffect)(()=>{
        window.onbeforeunload = null;
    }, []);
    const onClickOnRecovery = (0, $8ZuGG.useCallback)(()=>{
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($bKhzR)))(recoveryCode);
        if (success) {
            const flag = {
                type: 'success',
                title: (0, $aeLyl.default).mfRecoveryCopiedTitle,
                description: (0, $aeLyl.default).mfRecoveryCopiedDesc
            };
            dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description));
            setNewCodeSaved(true);
        }
    }, [
        dispatch,
        recoveryCode
    ]);
    const onRecoveryPrint = (0, $8ZuGG.useCallback)(()=>{
        // Invocation of this method will freeze the page in React 16 in development mode.
        // It does not affect production mode. The development mode bug is fixed in React 17:
        // https://github.com/facebook/react/issues/16734
        setTimeout(window.print);
        setNewCodeSaved(true);
    }, []);
    const onRecoverySkip = (0, $8ZuGG.useCallback)(()=>{
        setNewCodeSaved(true);
    }, []);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8EIEv.default), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $bl8w7.Global), {
                styles: (0, $bl8w7.css)($00b9dc14fdaf356d$var$t24 || ($00b9dc14fdaf356d$var$t24 = $00b9dc14fdaf356d$var$_`
          body {
            counter-reset: counter;
          }
        `))
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($00b9dc14fdaf356d$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$Heading, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "mf.recovery.heading",
                            defaultMessage: "We created a new emergency recovery key for you"
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsxs)($00b9dc14fdaf356d$var$Subcontainer, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$DesktopSubheading, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.recovery.savekey",
                                    defaultMessage: "Save this emergency recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$MobileSubheading, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.recovery.savekey.mobile",
                                    defaultMessage: "Save recovery key"
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$DesktopParagraph, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.recovery.savekey.desc",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without this key. Print, copy or write down this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$MobileParagraph, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "mf.recovery.savekey.desc.mobile",
                                    defaultMessage: "If you lose access to your phone, you won't be able to log in to your account without the key. Save this key without letting anyone see it."
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$RecoveryCode, {
                                id: "recovery-code",
                                children: (recoveryCode.match(/.{4}/g) || []).map((item, index)=>/*#__PURE__*/ (0, $6rcps.jsx)("span", {
                                        children: item
                                    }, index))
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)("input", {
                                id: "recovery-code-assistive",
                                className: "assistive",
                                value: recoveryCode,
                                readOnly: true
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$MobileRecoveryCode, {
                                value: (recoveryCode.match(/.{4}/g) || []).join(' ')
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$DropdownMenuContainer, {
                                id: "mf-save-options",
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $4ezqB.default), {
                                    trigger: (_param)=>{
                                        var { triggerRef: triggerRef } = _param, props = (0, $42tc5._)(_param, [
                                            "triggerRef"
                                        ]);
                                        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), (0, $6EnDC._)((0, $ty6PY._)({}, props), {
                                            ref: triggerRef,
                                            iconAfter: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lunc5))), {
                                                label: ""
                                            }),
                                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                                id: "mf.recovery.saveoptions",
                                                defaultMessage: "Save options"
                                            })
                                        }));
                                    },
                                    children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $1x0MG.default), {
                                        children: [
                                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $7z2f3.default), {
                                                onClick: onClickOnRecovery,
                                                children: /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                                                    id: "mf-copy-key",
                                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                                        id: "mf.recovery.copy",
                                                        defaultMessage: "Copy to clipboard"
                                                    })
                                                })
                                            }),
                                            !isEmbedded && /*#__PURE__*/ (0, $6rcps.jsx)((0, $7z2f3.default), {
                                                onClick: onRecoveryPrint,
                                                children: /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                                                    id: "mf-print-key",
                                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                                        id: "mf.recovery.print",
                                                        defaultMessage: "Print"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $7z2f3.default), {
                                                onClick: onRecoverySkip,
                                                children: /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                                                    id: "mf-wrote-key",
                                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                                        id: "mf.recovery.skip",
                                                        defaultMessage: "I wrote it down"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsxs)($00b9dc14fdaf356d$var$DesktopSubheading, {
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                        id: "mf.recovery.seriously",
                                        defaultMessage: "Seriously, save this key!"
                                    }),
                                    /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$StyledButton, {
                                        id: "two-step-verification-save-recovery-code-continue",
                                        isDisabled: !newCodeSaved,
                                        onClick: onComplete,
                                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                            id: "mf.recovery.saved",
                                            defaultMessage: "Saved, let's go"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($00b9dc14fdaf356d$var$MobileButtonContainer, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                                    appearance: "primary",
                                    isFullWidth: true,
                                    onClick: onComplete,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                        id: "mf.recovery.saved",
                                        defaultMessage: "Saved, let's go"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $00b9dc14fdaf356d$export$2e2bcd8739ae039 = $00b9dc14fdaf356d$var$RecoveryPage;

});
parcelRegister("bKhzR", function(module, exports) {
"use strict";

var $4neoe = parcelRequire("4neoe");
var $88d1a01a8814b95e$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $88d1a01a8814b95e$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $88d1a01a8814b95e$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $88d1a01a8814b95e$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $4neoe();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $88d1a01a8814b95e$var$clipboardToIE11Formatting[options.format] || $88d1a01a8814b95e$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $88d1a01a8814b95e$var$format("message" in options ? options.message : $88d1a01a8814b95e$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = $88d1a01a8814b95e$var$copy;

});
parcelRegister("4neoe", function(module, exports) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

});


parcelRegister("c8pR8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47175a913ea3cc4e$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");
let $47175a913ea3cc4e$var$_ = (t)=>t, $47175a913ea3cc4e$var$t;
const $47175a913ea3cc4e$var$StyledInput = (0, $9Vz68.default).input($47175a913ea3cc4e$var$t || ($47175a913ea3cc4e$var$t = $47175a913ea3cc4e$var$_`
  border: 0;
  padding: 0;
  font-size: 16px;
  width: 100%;
`));
const $47175a913ea3cc4e$var$handleClick = (e)=>{
    e.target.select(); // HTMLInputElement.setSelectionRange() doesn't work in some desktop browsers
    e.target.setSelectionRange(0, e.target.value.length); // HTMLInputElement.select() doesn't work on iOS
};
var $47175a913ea3cc4e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $6rcps.jsx)($47175a913ea3cc4e$var$StyledInput, (0, $6EnDC._)((0, $ty6PY._)({}, props), {
        readOnly: true,
        onClick: $47175a913ea3cc4e$var$handleClick
    }));

});

parcelRegister("9bZmd", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "save-recovery-key.57011d69.svg";

});

parcelRegister("aeLyl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3f9a58fd1fb9b42$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $d3f9a58fd1fb9b42$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    // Flags
    mfRecoveryCopiedTitle: {
        id: 'mf.recovery.copied',
        defaultMessage: 'Emergency recovery key is in your clipboard',
        description: ''
    },
    mfRecoveryCopiedDesc: {
        id: 'mf.recovery.copied.desc',
        defaultMessage: 'Paste it into a text file and save.',
        description: ''
    }
});

});

parcelRegister("4ezqB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3153f384b3c5a7be$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $05e3b = parcelRequire("05e3b");

var $hwZMN = parcelRequire("hwZMN");

var $30M5w = parcelRequire("30M5w");

var $5AVd4 = parcelRequire("5AVd4");

var $ky75z = parcelRequire("ky75z");

var $jBBpz = parcelRequire("jBBpz");

var $8AOBQ = parcelRequire("8AOBQ");

var $lDjMh = parcelRequire("lDjMh");

var $i2LcI = parcelRequire("i2LcI");

var $47npt = parcelRequire("47npt");

var $aWCUB = parcelRequire("aWCUB");

var $gtS9b = parcelRequire("gtS9b");

var $eeRBG = parcelRequire("eeRBG");

var $5b2Da = parcelRequire("5b2Da");

var $VgcbT = parcelRequire("VgcbT");

var $hWYZJ = parcelRequire("hWYZJ");
var $3153f384b3c5a7be$var$_excluded = [
    "ref",
    "aria-controls",
    "aria-expanded",
    "aria-haspopup"
];
function $3153f384b3c5a7be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3153f384b3c5a7be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3153f384b3c5a7be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3153f384b3c5a7be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3153f384b3c5a7be$var$MAX_HEIGHT = "calc(100vh - 16px)";
var $3153f384b3c5a7be$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
var $3153f384b3c5a7be$var$getFallbackPlacements = function getFallbackPlacements(placement) {
    var placementPieces = placement.split('-');
    var mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        var crossAxis = placementPieces[1];
        return [
            "".concat(mainAxis),
            "".concat(mainAxis, "-").concat($3153f384b3c5a7be$var$opposites[crossAxis]),
            "".concat($3153f384b3c5a7be$var$opposites[mainAxis], "-").concat(crossAxis),
            "".concat($3153f384b3c5a7be$var$opposites[mainAxis]),
            "".concat($3153f384b3c5a7be$var$opposites[mainAxis], "-").concat($3153f384b3c5a7be$var$opposites[crossAxis]),
            'auto'
        ];
    } else return [
        "".concat(mainAxis, "-start"),
        "".concat(mainAxis, "-end"),
        "".concat($3153f384b3c5a7be$var$opposites[mainAxis]),
        "".concat($3153f384b3c5a7be$var$opposites[mainAxis], "-start"),
        "".concat($3153f384b3c5a7be$var$opposites[mainAxis], "-end"),
        "auto"
    ];
};
function $3153f384b3c5a7be$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ var $3153f384b3c5a7be$var$DropdownMenu = function DropdownMenu(_ref) {
    var _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus, children = _ref.children, _ref$defaultOpen = _ref.defaultOpen, defaultOpen = _ref$defaultOpen === void 0 ? false : _ref$defaultOpen, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isOpen = _ref.isOpen, _ref$onOpenChange = _ref.onOpenChange, onOpenChange = _ref$onOpenChange === void 0 ? (0, $5AVd4.default) : _ref$onOpenChange, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa, returnFocusRef = _ref.returnFocusRef, spacing = _ref.spacing, statusLabel = _ref.statusLabel, testId = _ref.testId, _trigger = _ref.trigger, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? (0, $aWCUB.layers).modal() : _ref$zIndex, label = _ref.label, interactionName = _ref.interactionName, strategy = _ref.strategy, menuLabel = _ref.menuLabel;
    var _useControlledState = (0, $ky75z.default)(isOpen, function() {
        return defaultOpen;
    }), _useControlledState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useControlledState, 2), isLocalOpen = _useControlledState2[0], setLocalIsOpen = _useControlledState2[1];
    var triggerRef = (0, $8ZuGG.useRef)(null);
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isTriggeredUsingKeyboard = _useState2[0], setTriggeredUsingKeyboard = _useState2[1];
    var id = (0, $hWYZJ.default)();
    var itemRef = (0, $VgcbT.default)();
    var _useLayering = (0, $lDjMh.useLayering)(), currentLevel = _useLayering.currentLevel;
    var fallbackPlacements = (0, $8ZuGG.useMemo)(function() {
        return $3153f384b3c5a7be$var$getFallbackPlacements(placement);
    }, [
        placement
    ]);
    var handleTriggerClicked = (0, $8ZuGG.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    function(event) {
        var newValue = !isLocalOpen;
        var clientX = event.clientX, clientY = event.clientY, type = event.type, detail = event.detail;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            var _itemRef$current;
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef === null || itemRef === void 0 || (_itemRef$current = itemRef.current) === null || _itemRef$current === void 0 || _itemRef$current.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    var handleOnClose = (0, $8ZuGG.useCallback)(function(event, currentLevel) {
        var _event$target$closest, _event$target;
        var isTabOrEscapeKey = $3153f384b3c5a7be$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape');
        if (event !== null && !isTabOrEscapeKey && event.target instanceof HTMLElement && (_event$target$closest = (_event$target = event.target).closest) !== null && _event$target$closest !== void 0 && _event$target$closest.call(_event$target, "[id^=".concat((0, $hWYZJ.PREFIX), "] [aria-haspopup]"))) {
            var _itemRef$current2;
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            var toCloseLevel = (_itemRef$current2 = itemRef.current) === null || _itemRef$current2 === void 0 ? void 0 : _itemRef$current2.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(function() {
            var _returnFocusRef$curre;
            (_returnFocusRef$curre = returnFocusRef.current) === null || _returnFocusRef$curre === void 0 || _returnFocusRef$curre.focus();
        });
        else if ($3153f384b3c5a7be$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape')) requestAnimationFrame(function() {
            var _itemRef$current3;
            (_itemRef$current3 = itemRef.current) === null || _itemRef$current3 === void 0 || _itemRef$current3.focus();
        });
        else if (triggerRef.current) {
            var _event$target$closest2, _event$target2;
            // Don't focus the trigger if the click was outside of the menu
            var isClickOutsideMenu = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && ((_event$target$closest2 = (_event$target2 = event.target).closest) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.call(_event$target2, '[role="menu"]')) === null;
            var shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(function() {
                var _triggerRef$current;
                (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 || _triggerRef$current.focus();
            });
        }
        var newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]);
    var _useFocus = (0, $jBBpz.default)(), isFocused = _useFocus.isFocused, bindFocus = _useFocus.bindFocus;
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $8ZuGG.useEffect)(function() {
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5AVd4.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5AVd4.default;
        return (0, $k6Bkl.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                var isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest("[id^=".concat((0, $hWYZJ.PREFIX), "] [aria-haspopup]"));
                if (e.key === (0, $hwZMN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $hwZMN.KEY_SPACE) || e.key === (0, $hwZMN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $hwZMN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ var conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5b2Da.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $47npt.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 && (0, $i2LcI.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && "".concat(testId, "--content"),
        shouldUseCaptureOnOutsideClick: true
    }, conditionalProps, {
        shouldDisableFocusLock: true,
        trigger: function trigger(_ref2) {
            var ref = _ref2.ref, ariaControls = _ref2['aria-controls'], ariaExpanded = _ref2['aria-expanded'], ariaHasPopup = _ref2['aria-haspopup'], rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $3153f384b3c5a7be$var$_excluded);
            if (typeof _trigger === 'function') return _trigger($3153f384b3c5a7be$var$_objectSpread($3153f384b3c5a7be$var$_objectSpread($3153f384b3c5a7be$var$_objectSpread({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }, rest), bindFocus), {}, {
                triggerRef: (0, $30M5w.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger")
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $05e3b.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, bindFocus, {
                ref: (0, $30M5w.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: function iconAfter(iconProps) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8AOBQ))), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, iconProps, {
                        size: "small"
                    }));
                },
                onClick: handleTriggerClicked,
                testId: testId && "".concat(testId, "--trigger"),
                "aria-label": label,
                interactionName: interactionName
            }), _trigger);
        },
        content: function content(_ref3) {
            var setInitialFocusRef = _ref3.setInitialFocusRef, update = _ref3.update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gtS9b.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eeRBG.default), {
                spacing: spacing,
                maxHeight: $3153f384b3c5a7be$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && "".concat(testId, "--menu-wrapper"),
                menuLabel: menuLabel
            }, children));
        }
    })));
};
var $3153f384b3c5a7be$export$2e2bcd8739ae039 = $3153f384b3c5a7be$var$DropdownMenu;

});
parcelRegister("05e3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00fb5ddc091b715c$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $f8m11 = parcelRequire("f8m11");

var $53JDY = parcelRequire("53JDY");

var $1Shg4 = parcelRequire("1Shg4");
var $00fb5ddc091b715c$var$_excluded = [
    "analyticsContext",
    "appearance",
    "aria-label",
    "aria-labelledby",
    "autoFocus",
    "children",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isLoading",
    "isSelected",
    "onClick",
    "onClickCapture",
    "onKeyDownCapture",
    "onKeyUpCapture",
    "onMouseDownCapture",
    "onMouseUpCapture",
    "onPointerDownCapture",
    "onPointerUpCapture",
    "onTouchEndCapture",
    "onTouchStartCapture",
    "shouldFitContainer",
    "spacing",
    "testId",
    "type"
], $00fb5ddc091b715c$var$_excluded2 = [
    "className",
    "css",
    "as",
    "style"
];
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $00fb5ddc091b715c$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Button(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, appearance = _ref.appearance, ariaLabel = _ref['aria-label'], ariaLabelledBy = _ref['aria-labelledby'], autoFocus = _ref.autoFocus, children = _ref.children, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, interactionName = _ref.interactionName, isDisabled = _ref.isDisabled, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, isSelected = _ref.isSelected, onClick = _ref.onClick, onClickCapture = _ref.onClickCapture, onKeyDownCapture = _ref.onKeyDownCapture, onKeyUpCapture = _ref.onKeyUpCapture, onMouseDownCapture = _ref.onMouseDownCapture, onMouseUpCapture = _ref.onMouseUpCapture, onPointerDownCapture = _ref.onPointerDownCapture, onPointerUpCapture = _ref.onPointerUpCapture, onTouchEndCapture = _ref.onTouchEndCapture, onTouchStartCapture = _ref.onTouchStartCapture, shouldFitContainer = _ref.shouldFitContainer, spacing = _ref.spacing, testId = _ref.testId, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, unsafeRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $00fb5ddc091b715c$var$_excluded);
    // @ts-expect-error
    var _className = unsafeRest.className, _css = unsafeRest.css, _as = unsafeRest.as, _style = unsafeRest.style, saferRest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(unsafeRest, $00fb5ddc091b715c$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $f8m11.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName
    }, saferRest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $53JDY.default), {
        type: "icon",
        position: "before",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1Shg4.default), {
        icon: iconBefore
    })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $53JDY.default), {
        isLoading: isLoading
    }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $53JDY.default), {
        type: "icon",
        position: "after",
        isLoading: isLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1Shg4.default), {
        icon: iconAfter
    }))));
}));
$00fb5ddc091b715c$var$Button.displayName = 'Button';
var $00fb5ddc091b715c$export$2e2bcd8739ae039 = $00fb5ddc091b715c$var$Button;

});

parcelRegister("ky75z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef5c7b53c5ddbe64$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");
function $ef5c7b53c5ddbe64$export$2e2bcd8739ae039(propValue) {
    var getDefaultPropValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
        return propValue;
    };
    var isControlled = propValue !== undefined;
    var _useState = (0, $8ZuGG.useState)(getDefaultPropValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), valueState = _useState2[0], setValue = _useState2[1];
    var isControlledRef = (0, $8ZuGG.useRef)(isControlled);
    (0, $8ZuGG.useEffect)(function() {
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    var value = isControlled ? propValue : valueState;
    var setValueIfUncontrolled = (0, $8ZuGG.useCallback)(function(newValue) {
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("jBBpz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e45e7e26d7fd01df$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");
function $e45e7e26d7fd01df$export$2e2bcd8739ae039() {
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
    // ensure bindFocus has a stable ref
    var bindFocus = (0, $8ZuGG.useRef)({
        onFocus: function onFocus() {
            return setIsFocused(true);
        },
        onBlur: function onBlur() {
            return setIsFocused(false);
        }
    });
    (0, $8ZuGG.useEffect)(function() {
        // handle the case where a component might
        // unmount while being focused.
        return function() {
            return setIsFocused(false);
        };
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("8AOBQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6418f178f543f2f8$var$_react = $6418f178f543f2f8$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $6418f178f543f2f8$var$_chevronDown = $6418f178f543f2f8$var$_interopRequireDefault((parcelRequire("ew9cZ")));

var $6418f178f543f2f8$var$_chevronDown2 = $6418f178f543f2f8$var$_interopRequireDefault((parcelRequire("dOvMP")));
function $6418f178f543f2f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6418f178f543f2f8$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6418f178f543f2f8$var$_react.default.createElement($6418f178f543f2f8$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $6418f178f543f2f8$var$_chevronDown2.default
    }, props));
$6418f178f543f2f8$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $6418f178f543f2f8$var$_default = module.exports.default = $6418f178f543f2f8$var$ChevronDownIcon;

});
parcelRegister("ew9cZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a91b3275347cd3f9$var$_react = $a91b3275347cd3f9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $a91b3275347cd3f9$var$_baseNew = $a91b3275347cd3f9$var$_interopRequireDefault((parcelRequire("jWdEc")));
function $a91b3275347cd3f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a91b3275347cd3f9$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a91b3275347cd3f9$var$_react.default.createElement($a91b3275347cd3f9$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$a91b3275347cd3f9$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $a91b3275347cd3f9$var$_default = module.exports.default = $a91b3275347cd3f9$var$ChevronDownIcon;

});
parcelRegister("jWdEc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("aB79L")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("aB79L")).Icon; });

var $aB79L = parcelRequire("aB79L");

});
parcelRegister("aB79L", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $7b72e936db23126d$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $7b72e936db23126d$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $7b72e936db23126d$var$svgStyles = null;
var $7b72e936db23126d$var$iconStyles = null;
var $7b72e936db23126d$var$utilityIconStyles = null;
var $7b72e936db23126d$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $7b72e936db23126d$var$baseHcmStyles = null;
var $7b72e936db23126d$var$scaleSize = null;
var $7b72e936db23126d$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $7b72e936db23126d$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $7b72e936db23126d$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $7b72e936db23126d$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $7b72e936db23126d$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $7b72e936db23126d$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $7b72e936db23126d$var$baseSizeMap[type];
    var viewBoxPadding = $7b72e936db23126d$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $7b72e936db23126d$var$utilSizes[spacing] : size === 'small' ? $7b72e936db23126d$var$coreSizeSmall[spacing] : $7b72e936db23126d$var$coreSizeMedium[spacing]
        ])
    }));
});
var $7b72e936db23126d$export$2e2bcd8739ae039 = $7b72e936db23126d$export$f04a61298a47a40f;

});



parcelRegister("dOvMP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0e89a0adab1b401$var$_react = $a0e89a0adab1b401$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dqUS6 = parcelRequire("dqUS6");
function $a0e89a0adab1b401$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a0e89a0adab1b401$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $a0e89a0adab1b401$var$_react.default.createElement($dqUS6.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$a0e89a0adab1b401$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $a0e89a0adab1b401$var$_default = module.exports.default = $a0e89a0adab1b401$var$ChevronDownIcon;

});
parcelRegister("dqUS6", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $9c79d19316f27f66$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $9c79d19316f27f66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9c79d19316f27f66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9c79d19316f27f66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9c79d19316f27f66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $9c79d19316f27f66$var$iconStyles = null;
var $9c79d19316f27f66$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $9c79d19316f27f66$var$baseHcmStyles = null;
var $9c79d19316f27f66$var$primaryEqualsSecondaryHcmStyles = null;
var $9c79d19316f27f66$var$secondaryTransparentHcmStyles = null;
var $9c79d19316f27f66$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $9c79d19316f27f66$var$_objectSpread($9c79d19316f27f66$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $9c79d19316f27f66$var$sizeStyles[size]
        ])
    }));
});
var $9c79d19316f27f66$export$2e2bcd8739ae039 = $9c79d19316f27f66$export$f04a61298a47a40f;

});



parcelRegister("aWCUB", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $7f7d814197d1751a$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $2qySq = parcelRequire("2qySq");
var $7f7d814197d1751a$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $7f7d814197d1751a$export$c93026a968943f95 = 'light';
var $7f7d814197d1751a$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $7f7d814197d1751a$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $7f7d814197d1751a$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $2qySq.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7f7d814197d1751a$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $7f7d814197d1751a$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $7f7d814197d1751a$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $7f7d814197d1751a$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $7f7d814197d1751a$export$ba1d834b86d72a09 = $7f7d814197d1751a$export$a1b3edb637fb4f35;
var $7f7d814197d1751a$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $2qySq.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $2qySq.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $2qySq.N30A), ")")
            }
        }
    };
};

});
parcelRegister("2qySq", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $1c49104b286a5aaa$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $1c49104b286a5aaa$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $1c49104b286a5aaa$export$920c0d5c49070351; });
// Reds
var $1c49104b286a5aaa$export$4b84fd0e2c617bd = '#FFEBE6';
var $1c49104b286a5aaa$export$b34b069eff244586 = '#FFBDAD';
var $1c49104b286a5aaa$export$be802dd0d8b57f35 = '#FF8F73';
var $1c49104b286a5aaa$export$60847d42f9da92a6 = '#FF7452';
var $1c49104b286a5aaa$export$4a7404f376229999 = '#FF5630';
var $1c49104b286a5aaa$export$2010d0fb4295b346 = '#DE350B';
var $1c49104b286a5aaa$export$2837b5a1a71d5c02 = '#BF2600';
var $1c49104b286a5aaa$export$8d9596b529bbb9cf = '#FFFAE6';
var $1c49104b286a5aaa$export$41060a744ab0b7ae = '#FFF0B3';
var $1c49104b286a5aaa$export$1cc05bbbf340e559 = '#FFE380';
var $1c49104b286a5aaa$export$5aae31392d72caaa = '#FFC400';
var $1c49104b286a5aaa$export$c6930421db9fa514 = '#FFAB00';
var $1c49104b286a5aaa$export$59619663aa6500fb = '#FF991F';
var $1c49104b286a5aaa$export$874739ea9e379ab6 = '#FF8B00';
var $1c49104b286a5aaa$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1c49104b286a5aaa$export$69a3bf21b9686c2b = '#ABF5D1';
var $1c49104b286a5aaa$export$afbce1382ec95f73 = '#79F2C0';
var $1c49104b286a5aaa$export$747d86715d4175de = '#57D9A3';
var $1c49104b286a5aaa$export$940e1f69e873f202 = '#36B37E';
var $1c49104b286a5aaa$export$a49394138f7b8e85 = '#00875A';
var $1c49104b286a5aaa$export$6fa04827ac68a4fb = '#006644';
var $1c49104b286a5aaa$export$226de0355ed012f8 = '#DEEBFF';
var $1c49104b286a5aaa$export$8c13c2ee36917869 = '#B3D4FF';
var $1c49104b286a5aaa$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1c49104b286a5aaa$export$215b7063051591f1 = '#2684FF';
var $1c49104b286a5aaa$export$e62e8919cca44969 = '#0065FF';
var $1c49104b286a5aaa$export$b3de0ae08da2ce64 = '#0052CC';
var $1c49104b286a5aaa$export$a6ee3d71bc067634 = '#0747A6';
var $1c49104b286a5aaa$export$67f15409e87642a1 = '#669DF1';
var $1c49104b286a5aaa$export$f0539dbc42dbb067 = '#8FB8F6';
var $1c49104b286a5aaa$export$363e4475840015bb = '#EAE6FF';
var $1c49104b286a5aaa$export$4b0a4417ed59760f = '#C0B6F2';
var $1c49104b286a5aaa$export$6011520a64d9a187 = '#998DD9';
var $1c49104b286a5aaa$export$a7175d4e9206bc80 = '#8777D9';
var $1c49104b286a5aaa$export$b48405b95304b5a1 = '#6554C0';
var $1c49104b286a5aaa$export$c71e4279dd54a18d = '#5243AA';
var $1c49104b286a5aaa$export$147899de772240ec = '#403294';
var $1c49104b286a5aaa$export$2cf711fe14c66f06 = '#E6FCFF';
var $1c49104b286a5aaa$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1c49104b286a5aaa$export$776c9c497ef08533 = '#79E2F2';
var $1c49104b286a5aaa$export$69cb3ca10c1e330e = '#00C7E6';
var $1c49104b286a5aaa$export$9dc1ef0f3f48059b = '#00B8D9';
var $1c49104b286a5aaa$export$7c835c78b6fcdef8 = '#00A3BF';
var $1c49104b286a5aaa$export$6036577f95c3877e = '#008DA6';
var $1c49104b286a5aaa$export$29a4f05edc054374 = '#FFFFFF';
var $1c49104b286a5aaa$export$e655ef011c4aa1a2 = '#FAFBFC';
var $1c49104b286a5aaa$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1c49104b286a5aaa$export$3e51e8f1440314ba = '#EBECF0';
var $1c49104b286a5aaa$export$1ce2d1575d444ceb = '#DFE1E6';
var $1c49104b286a5aaa$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1c49104b286a5aaa$export$c2e91cbeada39b8b = '#B3BAC5';
var $1c49104b286a5aaa$export$5f71e19f3a7ad9de = '#A5ADBA';
var $1c49104b286a5aaa$export$eaa8c8a70ac22806 = '#97A0AF';
var $1c49104b286a5aaa$export$7c87d337fb91a97d = '#8993A4';
var $1c49104b286a5aaa$export$d6447c357493214f = '#7A869A';
var $1c49104b286a5aaa$export$f563ee71e9ee74cd = '#6B778C';
var $1c49104b286a5aaa$export$e2ef2124cf4024b1 = '#5E6C84';
var $1c49104b286a5aaa$export$eece5f492e429f08 = '#505F79';
var $1c49104b286a5aaa$export$c39c0fe0f26207ae = '#42526E';
var $1c49104b286a5aaa$export$7090862dc3038a9f = '#344563';
var $1c49104b286a5aaa$export$ad0bacf983b7ddaa = '#253858';
var $1c49104b286a5aaa$export$7d61b15e0da132af = '#172B4D';
var $1c49104b286a5aaa$export$fbda843f0a27fe96 = '#091E42';
var $1c49104b286a5aaa$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $1c49104b286a5aaa$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $1c49104b286a5aaa$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $1c49104b286a5aaa$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $1c49104b286a5aaa$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $1c49104b286a5aaa$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $1c49104b286a5aaa$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $1c49104b286a5aaa$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $1c49104b286a5aaa$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $1c49104b286a5aaa$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $1c49104b286a5aaa$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $1c49104b286a5aaa$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $1c49104b286a5aaa$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $1c49104b286a5aaa$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $1c49104b286a5aaa$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $1c49104b286a5aaa$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $1c49104b286a5aaa$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $1c49104b286a5aaa$export$2f6319cf7d736c2a = '#E6EDFA';
var $1c49104b286a5aaa$export$95126bc8884d6634 = '#DCE5F5';
var $1c49104b286a5aaa$export$8338d8c35d44ff1 = '#CED9EB';
var $1c49104b286a5aaa$export$5368d76ae4fbbda7 = '#B8C7E0';
var $1c49104b286a5aaa$export$9f0a771d16ec8d36 = '#ABBBD6';
var $1c49104b286a5aaa$export$abcf8c38338b4aa5 = '#9FB0CC';
var $1c49104b286a5aaa$export$97e81faa16a182c7 = '#8C9CB8';
var $1c49104b286a5aaa$export$bfe21c59123ecf33 = '#7988A3';
var $1c49104b286a5aaa$export$ee82aa2ea6a1558 = '#67758F';
var $1c49104b286a5aaa$export$682927c6ed76be02 = '#56637A';
var $1c49104b286a5aaa$export$91fd9994c5be9757 = '#455166';
var $1c49104b286a5aaa$export$d281fbfe3cff2df6 = '#3B475C';
var $1c49104b286a5aaa$export$3902c91d8b98a753 = '#313D52';
var $1c49104b286a5aaa$export$8e8133c1ba5845b5 = '#283447';
var $1c49104b286a5aaa$export$33ff357f6620b39 = '#202B3D';
var $1c49104b286a5aaa$export$633847cf062b69e0 = '#1B2638';
var $1c49104b286a5aaa$export$9776a6e503bdbf76 = '#121A29';
var $1c49104b286a5aaa$export$6c813d5160dff5db = '#0E1624';
var $1c49104b286a5aaa$export$3d4f271a500072a = '#0D1424';
var $1c49104b286a5aaa$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $1c49104b286a5aaa$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $1c49104b286a5aaa$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $1c49104b286a5aaa$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $1c49104b286a5aaa$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $1c49104b286a5aaa$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $1c49104b286a5aaa$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $1c49104b286a5aaa$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $1c49104b286a5aaa$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $1c49104b286a5aaa$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $1c49104b286a5aaa$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $1c49104b286a5aaa$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $1c49104b286a5aaa$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $1c49104b286a5aaa$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $1c49104b286a5aaa$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $1c49104b286a5aaa$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $1c49104b286a5aaa$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $1c49104b286a5aaa$export$d2adc5dedf09fced = '#292A2E';
var $1c49104b286a5aaa$export$f51762073d2bb381 = '#94C748';
var $1c49104b286a5aaa$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("gtS9b", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", function () { return $bff95b46d9032945$export$f18c1d4fc7326096; });
$parcel$export(module.exports, "default", function () { return $bff95b46d9032945$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $5AVd4 = parcelRequire("5AVd4");

var $lDjMh = parcelRequire("lDjMh");

var $flFI6 = parcelRequire("flFI6");
var $bff95b46d9032945$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5AVd4.default)
});
/**
 * Focus manager logic.
 */ var $bff95b46d9032945$var$FocusManager = function FocusManager(_ref) {
    var children = _ref.children, onClose = _ref.onClose;
    var menuItemRefs = (0, $8ZuGG.useRef)([]);
    // Used to force a re-render only
    var _useState = (0, $8ZuGG.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), refresh = _useState2[0], setRefresh = _useState2[1];
    var registerMode = (0, $8ZuGG.useRef)('ordered');
    registerMode.current = 'ordered';
    var registerRef = (0, $8ZuGG.useCallback)(function(ref) {
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error("Unexpected case of ".concat(registerMode.current));
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    var _useLayering = (0, $lDjMh.useLayering)(), isLayerDisabled = _useLayering.isLayerDisabled;
    // Intentionally rebinding on each render
    (0, $8ZuGG.useEffect)(function() {
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $8ZuGG.useEffect)(function() {
        return (0, $k6Bkl.bind)(window, {
            type: 'keydown',
            listener: (0, $flFI6.default)(menuItemRefs, isLayerDisabled, onClose)
        });
    }, [
        isLayerDisabled,
        onClose
    ]);
    var contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bff95b46d9032945$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $bff95b46d9032945$export$2e2bcd8739ae039 = $bff95b46d9032945$var$FocusManager;

});
parcelRegister("flFI6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2c92bfb1dbbff6e$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $hwZMN = parcelRequire("hwZMN");

var $i2LcI = parcelRequire("i2LcI");

var $hWYZJ = parcelRequire("hWYZJ");
var $b2c92bfb1dbbff6e$var$actionMap = (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $hwZMN.KEY_DOWN), 'next'), (0, $hwZMN.KEY_UP), 'prev'), (0, $hwZMN.KEY_HOME), 'first'), (0, $hwZMN.KEY_END), 'last');
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ var $b2c92bfb1dbbff6e$var$getNextFocusableElement = function getNextFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ var $b2c92bfb1dbbff6e$var$getPrevFocusableElement = function getPrevFocusableElement(refs, currentFocusedIdx) {
    for(var i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        var element = refs[currentFocusedIdx].current;
        var isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
};
function $b2c92bfb1dbbff6e$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return function(e) {
        var _refs$current;
        var currentRefs = (_refs$current = refs.current) !== null && _refs$current !== void 0 ? _refs$current : [];
        var currentFocusedIdx = currentRefs.findIndex(function(_ref) {
            var _document$activeEleme;
            var el = _ref.current;
            return el && ((_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 ? void 0 : _document$activeEleme.isSameNode(el));
        });
        if ((0, $i2LcI.fg)('platform_dst_popup-disable-focuslock')) {
            var _document$activeEleme2;
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            var isNestedDropdown = !!((_document$activeEleme2 = document.activeElement) !== null && _document$activeEleme2 !== void 0 && _document$activeEleme2.closest("[id^=".concat((0, $hWYZJ.PREFIX), "]")));
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $hwZMN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $hwZMN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        var action = $b2c92bfb1dbbff6e$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var nextFocusableElement = $b2c92bfb1dbbff6e$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement === null || nextFocusableElement === void 0 || nextFocusableElement.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                var prevFocusableElement = $b2c92bfb1dbbff6e$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement === null || prevFocusableElement === void 0 || prevFocusableElement.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                var firstFocusableElement = $b2c92bfb1dbbff6e$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement === null || firstFocusableElement === void 0 || firstFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                var lastFocusableElement = $b2c92bfb1dbbff6e$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement === null || lastFocusableElement === void 0 || lastFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});
parcelRegister("hWYZJ", function(module, exports) {

$parcel$export(module.exports, "PREFIX", function () { return $d1172ab6b81a5812$export$8a682ae47622dbb9; });
$parcel$export(module.exports, "default", function () { return $d1172ab6b81a5812$export$2e2bcd8739ae039; });

var $iNlvH = parcelRequire("iNlvH");
var $d1172ab6b81a5812$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $d1172ab6b81a5812$export$2e2bcd8739ae039() {
    var id = (0, $iNlvH.useId)();
    return "".concat($d1172ab6b81a5812$export$8a682ae47622dbb9).concat(id);
}

});



parcelRegister("eeRBG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5dbf4ae48437f6e$export$2e2bcd8739ae039; });
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");


var $9508v = parcelRequire("9508v");

var $72wHg = parcelRequire("72wHg");

var $cufV0 = parcelRequire("cufV0");

var $5DvR4 = parcelRequire("5DvR4");

var $d39k6 = parcelRequire("d39k6");

var $gtS9b = parcelRequire("gtS9b");
var $a5dbf4ae48437f6e$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k"
};
var $a5dbf4ae48437f6e$var$LoadingIndicator = function LoadingIndicator(_ref) {
    var _ref$statusLabel = _ref.statusLabel, statusLabel = _ref$statusLabel === void 0 ? 'Loading' : _ref$statusLabel, testId = _ref.testId;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $72wHg.default), {
        xcss: $a5dbf4ae48437f6e$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $cufV0.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ var $a5dbf4ae48437f6e$var$MenuWrapper = function MenuWrapper(_ref2) {
    var children = _ref2.children, isLoading = _ref2.isLoading, maxHeight = _ref2.maxHeight, maxWidth = _ref2.maxWidth, onClose = _ref2.onClose, onUpdate = _ref2.onUpdate, statusLabel = _ref2.statusLabel, setInitialFocusRef = _ref2.setInitialFocusRef, shouldRenderToParent = _ref2.shouldRenderToParent, spacing = _ref2.spacing, testId = _ref2.testId, isTriggeredUsingKeyboard = _ref2.isTriggeredUsingKeyboard, autoFocus = _ref2.autoFocus, menuLabel = _ref2.menuLabel;
    var _useContext = (0, $8ZuGG.useContext)((0, $gtS9b.FocusManagerContext)), menuItemRefs = _useContext.menuItemRefs;
    var closeOnMenuItemClick = function closeOnMenuItemClick(e) {
        var isTargetMenuItemOrDescendant = menuItemRefs.some(function(menuItemRef) {
            var menuItem = menuItemRef.current;
            if (!menuItem) return false;
            var isCheckboxOrRadio = (0, $5DvR4.default)(menuItem) || (0, $d39k6.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $8ZuGG.useLayoutEffect)(function() {
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $8ZuGG.useEffect)(function() {
        var _menuItemRefs$map$fin;
        var firstFocusableRef = (_menuItemRefs$map$fin = menuItemRefs.map(function(_ref3) {
            var current = _ref3.current;
            return current;
        }).find(function(el) {
            return !!el && !el.hasAttribute('disabled');
        })) !== null && _menuItemRefs$map$fin !== void 0 ? _menuItemRefs$map$fin : null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef === null || firstFocusableRef === void 0 || firstFocusableRef.focus();
        setInitialFocusRef === null || setInitialFocusRef === void 0 || setInitialFocusRef(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $9508v.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && "".concat(testId, "--menu-group"),
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $8ZuGG.createElement($a5dbf4ae48437f6e$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && "".concat(testId, "--loading-indicator")
    }) : children);
};
var $a5dbf4ae48437f6e$export$2e2bcd8739ae039 = $a5dbf4ae48437f6e$var$MenuWrapper;

});
parcelRegister("9508v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69c4afbdee724371$export$2e2bcd8739ae039; });
/* menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $dsJt9 = parcelRequire("dsJt9");
var $69c4afbdee724371$var$_excluded = [
    "isLoading",
    "maxWidth",
    "minWidth",
    "minHeight",
    "maxHeight",
    "testId",
    "role",
    "spacing",
    "menuLabel",
    "className"
];
var $69c4afbdee724371$var$baseStyles = null;
/**
 * __Menu group__
 *
 * A menu group includes all the actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/menu-group)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $69c4afbdee724371$var$MenuGroup = function MenuGroup(_ref) {
    var isLoading = _ref.isLoading, maxWidth = _ref.maxWidth, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, testId = _ref.testId, role = _ref.role, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'cozy' : _ref$spacing, menuLabel = _ref.menuLabel, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $69c4afbdee724371$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $dsJt9.SpacingContext).Provider, {
        value: spacing
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $dsJt9.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "border"
    }, /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "aria-busy": isLoading,
        style: {
            minWidth: minWidth,
            maxWidth: maxWidth,
            minHeight: minHeight,
            maxHeight: maxHeight
        },
        "data-testid": testId,
        role: role,
        className: (0, $c4hjl.default)([
            "_1reo1wug _18m91wug _1e0c1txw _kqswpfqs _2lx21bp4",
            UNSAFE_className
        ]),
        "aria-label": menuLabel
    }, rest))));
};
var $69c4afbdee724371$export$2e2bcd8739ae039 = $69c4afbdee724371$var$MenuGroup;

});
parcelRegister("dsJt9", function(module, exports) {

$parcel$export(module.exports, "SpacingContext", function () { return $9cd129219751c5ce$export$443076ec7ebce042; });
$parcel$export(module.exports, "SELECTION_STYLE_CONTEXT_DO_NOT_USE", function () { return $9cd129219751c5ce$export$9ca534b70725964d; });

var $8ZuGG = parcelRequire("8ZuGG");
var $9cd129219751c5ce$export$443076ec7ebce042 = /*#__PURE__*/ (0, $8ZuGG.createContext)('cozy');
var $9cd129219751c5ce$export$9ca534b70725964d = /*#__PURE__*/ (0, $8ZuGG.createContext)('border');

});


parcelRegister("5DvR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a94e05074ffdcf$export$2e2bcd8739ae039; });
function $41a94e05074ffdcf$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("d39k6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9802c991cb15e65f$export$2e2bcd8739ae039; });
function $9802c991cb15e65f$export$2e2bcd8739ae039(element) {
    var role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("5b2Da", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c500538b50d6bd1$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $5AVd4 = parcelRequire("5AVd4");
var $3c500538b50d6bd1$export$756f795847463ebd = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    setItemState: (0, $5AVd4.default),
    getItemState: function getItemState() {
        return undefined;
    },
    setGroupState: (0, $5AVd4.default),
    getGroupState: function getGroupState() {
        return {};
    }
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ var $3c500538b50d6bd1$var$SelectionStore = function SelectionStore(props) {
    var children = props.children;
    var store = (0, $8ZuGG.useRef)({});
    var context = (0, $8ZuGG.useMemo)(function() {
        return {
            setItemState: function setItemState(group, id, value) {
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: function getItemState(group, id) {
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: function setGroupState(group, value) {
                store.current[group] = value;
            },
            getGroupState: function getGroupState(group) {
                return store.current[group] || {};
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($3c500538b50d6bd1$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $3c500538b50d6bd1$export$2e2bcd8739ae039 = $3c500538b50d6bd1$var$SelectionStore;

});

parcelRegister("VgcbT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ac1e319a29524d4$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");

var $gtS9b = parcelRequire("gtS9b");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $0ac1e319a29524d4$var$useRegisterItemWithFocusManager() {
    var hasPopup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var _useContext = (0, $8ZuGG.useContext)((0, $gtS9b.FocusManagerContext)), registerRef = _useContext.registerRef;
    var itemRef = (0, $8ZuGG.useRef)(null);
    (0, $8ZuGG.useEffect)(function() {
        if (hasPopup && (0, $i2LcI.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $0ac1e319a29524d4$export$2e2bcd8739ae039 = $0ac1e319a29524d4$var$useRegisterItemWithFocusManager;

});


parcelRegister("7z2f3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $581d8a7795a0fd4c$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $30M5w = parcelRequire("30M5w");

var $d5W6x = parcelRequire("d5W6x");

var $dXYD0 = parcelRequire("dXYD0");

var $2xzZO = parcelRequire("2xzZO");

var $VgcbT = parcelRequire("VgcbT");
var $581d8a7795a0fd4c$var$_excluded = [
    "children",
    "component",
    "description",
    "elemAfter",
    "elemBefore",
    "href",
    "isDisabled",
    "isSelected",
    "onClick",
    "rel",
    "shouldDescriptionWrap",
    "shouldTitleWrap",
    "target",
    "testId",
    "UNSAFE_shouldDisableRouterLink",
    "returnFocusRef",
    "interactionName",
    "role"
];
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ var $581d8a7795a0fd4c$var$DropdownMenuItem = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, component = _ref.component, description = _ref.description, elemAfter = _ref.elemAfter, elemBefore = _ref.elemBefore, href = _ref.href, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, onClick = _ref.onClick, rel = _ref.rel, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? true : _ref$shouldDescriptio, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? true : _ref$shouldTitleWrap, target = _ref.target, testId = _ref.testId, UNSAFE_shouldDisableRouterLink = _ref.UNSAFE_shouldDisableRouterLink, returnFocusRef = _ref.returnFocusRef, interactionName = _ref.interactionName, role = _ref.role, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $581d8a7795a0fd4c$var$_excluded);
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    var itemRef = (0, $VgcbT.default)(!!rest['aria-haspopup']);
    var handleItemClick = (0, $8ZuGG.useCallback)(function(event) {
        if (returnFocusRef !== null && returnFocusRef !== void 0 && returnFocusRef.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dXYD0.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $30M5w.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2xzZO.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $30M5w.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName
    }, rest), children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $d5W6x.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $30M5w.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        target: target,
        rel: rel,
        interactionName: interactionName
    }, rest), children);
});
var $581d8a7795a0fd4c$export$2e2bcd8739ae039 = $581d8a7795a0fd4c$var$DropdownMenuItem;

});
parcelRegister("d5W6x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9888d04fb8330bd0$export$2e2bcd8739ae039; });
/* button-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $gqcal = parcelRequire("gqcal");

var $5g2AO = parcelRequire("5g2AO");
var $9888d04fb8330bd0$var$_excluded = [
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "interactionName"
];
/**
 * __Button item__
 *
 * A button item is used to populate a menu with items that are buttons.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/button-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $9888d04fb8330bd0$var$ButtonItem = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    var children = props.children, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $9888d04fb8330bd0$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $8ZuGG.useContext)((0, $gqcal.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5g2AO.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        className: UNSAFE_className
    }, rest, {
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isDisabled: isDisabled,
        isSelected: isSelected,
        isTitleHeading: false,
        description: description,
        title: children,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $8ZuGG.createElement("button", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            "data-testid": testId,
            "aria-current": isSelected ? 'true' : undefined
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref,
            disabled: isDisabled,
            onClick: handleClick,
            onMouseDown: onMouseDownHandler,
            type: "button"
        }), children);
    });
}));
var $9888d04fb8330bd0$export$2e2bcd8739ae039 = $9888d04fb8330bd0$var$ButtonItem;

});
parcelRegister("gqcal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf4882f48944af4e$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $bf4882f48944af4e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("5g2AO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4075410741e7b5$export$2e2bcd8739ae039; });
/* menu-item-primitive.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");

var $fkdQ8 = parcelRequire("fkdQ8");

var $dsJt9 = parcelRequire("dsJt9");
var $3d4075410741e7b5$var$renderTitle = function renderTitle(Component, props) {
    return(/*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    $8ZuGG.createElement(Component, props));
};
var $3d4075410741e7b5$var$styles = {
    root: "_19itidpf _12ji1r31 _1qu2glyw _12y3idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _kqswh2mm _1e0c1txw _vchhusvi _1bsb1osq _1tke1ylp _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _4cvr1h6o _uiztglyw _80omtlke _ymio1r31 _ypr0glyw _zcxs1o36 _nt75194a _mizu194a _1bg411pw _1ah311pw _49pcnqa1 _ra3xnqa1 _1hvw1bk5 _128m1bk5 _9oik1r31 _1bnxglyw _jf4cnqa1 _1cvmnqa1 _4davt94y",
    beforeAfterElement: "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf",
    content: "_12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _1bah1h6o _16jlkb7n _y3gn1e5h",
    truncate: "_1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c",
    title: "_11c82smr",
    wordBreak: "_1nmz1hna",
    description: "_11c8dcr7 _syaz1wmz",
    disabledDescription: "_syaz2oi6",
    unselected: "_bfhkqtfy _syaz1r31 _10531r31 _irr31dko _30l31r31 _1di61dko _9h8h1r31",
    disabled: "_80om13gf _bfhkqtfy _syaz2oi6 _irr3qtfy _30l32oi6 _1di6qtfy _9h8h2oi6",
    selectedBorder: "_1mp4yh40 _1cs8stnw _1rus67is _1kt9b3bt _1fkrze3t _iajmze3t _z5wtze3t",
    selectedNotch: "_rfx3bx74 _1mp41y44 _1cs8stnw _1rus67is _1kt9b3bt _1fkrutpp _iajmutpp _z5wtze3t",
    selected: "_bfhk1q4k _syazhu5v _1053hu5v _irr32seo _30l316ov _1di6guph _9h8hhu5v",
    selectedOld: "_30l3hu5v"
};
var $3d4075410741e7b5$var$spacingMapStyles = {
    cozy: "_1rjcu2gc _18zrpxbi",
    compact: "_1rjc1b66 _18zrutpp _1tkezwfg"
};
var $3d4075410741e7b5$var$gapMap = {
    compact: 'space.100',
    cozy: 'space.150'
};
/**
 * __Menu item primitive__
 *
 * Menu item primitive contains all the styles for menu items,
 * including support for selected, disabled, and interaction states.
 *
 * Using children as function prop you wire up this to your own host element.
 *
 * ```jsx
 * <MenuItemPrimitive>
 *   {({ children, ...props }) => <button {...props}>{children}</button>}
 * </MenuItemPrimitive>
 * ```
 */ var $3d4075410741e7b5$var$MenuItemPrimitive = function MenuItemPrimitive(_ref) {
    var children = _ref.children, title = _ref.title, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, UNSAFE_externalClassName = _ref.className, _ref$shouldTitleWrap = _ref.shouldTitleWrap, shouldTitleWrap = _ref$shouldTitleWrap === void 0 ? false : _ref$shouldTitleWrap, _ref$shouldDescriptio = _ref.shouldDescriptionWrap, shouldDescriptionWrap = _ref$shouldDescriptio === void 0 ? false : _ref$shouldDescriptio, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, testId = _ref.testId;
    var spacing = (0, $8ZuGG.useContext)((0, $dsJt9.SpacingContext));
    var selectionStyle = (0, $8ZuGG.useContext)((0, $dsJt9.SELECTION_STYLE_CONTEXT_DO_NOT_USE));
    var UNSAFE_className = UNSAFE_externalClassName;
    return function() {
        return children({
            className: (0, $c4hjl.default)([
                (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.root,
                    $3d4075410741e7b5$var$spacingMapStyles[spacing],
                    !isDisabled && !isSelected && $3d4075410741e7b5$var$styles.unselected,
                    !isDisabled && isSelected && $3d4075410741e7b5$var$styles.selected,
                    !(0, $i2LcI.fg)('platform_fix_a11y_selected_and_hovered_state_color') && !isDisabled && isSelected && $3d4075410741e7b5$var$styles.selectedOld,
                    !isDisabled && isSelected && selectionStyle === 'border' && $3d4075410741e7b5$var$styles.selectedBorder,
                    !isDisabled && isSelected && selectionStyle === 'notch' && $3d4075410741e7b5$var$styles.selectedNotch,
                    isDisabled && $3d4075410741e7b5$var$styles.disabled
                ]),
                UNSAFE_className
            ]),
            children: /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
                as: "span",
                spread: "space-between",
                alignBlock: "center",
                space: $3d4075410741e7b5$var$gapMap[spacing],
                grow: "fill",
                testId: testId && "".concat(testId, "--container")
            }, iconBefore && /*#__PURE__*/ $8ZuGG.createElement("span", {
                "data-item-elem-before": true,
                "data-testid": testId && "".concat(testId, "--icon-before"),
                className: (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.beforeAfterElement
                ])
            }, iconBefore), title && /*#__PURE__*/ $8ZuGG.createElement("div", {
                className: (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.content
                ])
            }, $3d4075410741e7b5$var$renderTitle(isTitleHeading ? 'h2' : 'span', {
                children: title,
                className: (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.title,
                    shouldTitleWrap ? $3d4075410741e7b5$var$styles.wordBreak : $3d4075410741e7b5$var$styles.truncate
                ]),
                'data-item-title': true
            }), description && /*#__PURE__*/ $8ZuGG.createElement("span", {
                "data-item-description": true,
                className: (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.description,
                    isDisabled && $3d4075410741e7b5$var$styles.disabledDescription,
                    shouldDescriptionWrap && $3d4075410741e7b5$var$styles.wordBreak,
                    !shouldDescriptionWrap && $3d4075410741e7b5$var$styles.truncate
                ])
            }, description)), iconAfter && /*#__PURE__*/ $8ZuGG.createElement("span", {
                "data-item-elem-after": true,
                "data-testid": testId && "".concat(testId, "--icon-after"),
                className: (0, $c4hjl.default)([
                    $3d4075410741e7b5$var$styles.beforeAfterElement
                ])
            }, iconAfter))
        });
    }();
};
var $3d4075410741e7b5$export$2e2bcd8739ae039 = $3d4075410741e7b5$var$MenuItemPrimitive;

});


parcelRegister("dXYD0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2afd08b9380d3b8$export$2e2bcd8739ae039; });
/* custom-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $gqcal = parcelRequire("gqcal");

var $5g2AO = parcelRequire("5g2AO");
var $a2afd08b9380d3b8$var$_excluded = [
    "component",
    "isDisabled",
    "isSelected",
    "isTitleHeading",
    "onClick",
    "testId",
    "children",
    "description",
    "iconAfter",
    "iconBefore",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $a2afd08b9380d3b8$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
// Dirty hack to get generics working with forward ref [1/2]
/**
 * __Custom item__
 *
 * A custom item is used to populate a menu with items that can be any element.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/custom-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $a2afd08b9380d3b8$var$CustomItem = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var Component = _ref.component, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isTitleHeading = _ref.isTitleHeading, isTitleHeading = _ref$isTitleHeading === void 0 ? false : _ref$isTitleHeading, onClick = _ref.onClick, testId = _ref.testId, children = _ref.children, description = _ref.description, iconAfter = _ref.iconAfter, iconBefore = _ref.iconBefore, onMouseDown = _ref.onMouseDown, shouldTitleWrap = _ref.shouldTitleWrap, shouldDescriptionWrap = _ref.shouldDescriptionWrap, UNSAFE_className = _ref.className, UNSAFE_isDraggable = _ref.UNSAFE_isDraggable, interactionName = _ref.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $a2afd08b9380d3b8$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var interactionContext = (0, $8ZuGG.useContext)((0, $gqcal.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5g2AO.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        className: UNSAFE_className
    }, rest, {
        description: description,
        iconAfter: iconAfter,
        title: children,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: isTitleHeading,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref2) {
        var children = _ref2.children, className = _ref2.className;
        return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            "data-testid": testId
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ref: ref
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $a2afd08b9380d3b8$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $a2afd08b9380d3b8$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $a2afd08b9380d3b8$var$preventEvent : handleClick,
            tabIndex: isDisabled ? -1 : undefined,
            "aria-disabled": isDisabled
        }), children);
    });
}));
var $a2afd08b9380d3b8$export$2e2bcd8739ae039 = $a2afd08b9380d3b8$var$CustomItem;

});

parcelRegister("2xzZO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d9a95de95d29940$export$2e2bcd8739ae039; });
/* link-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");


var $5yYIk = parcelRequire("5yYIk");

var $gqcal = parcelRequire("gqcal");

var $5g2AO = parcelRequire("5g2AO");
var $1d9a95de95d29940$var$_excluded = [
    "children",
    "href",
    "description",
    "iconAfter",
    "iconBefore",
    "isDisabled",
    "isSelected",
    "onClick",
    "testId",
    "onMouseDown",
    "shouldTitleWrap",
    "shouldDescriptionWrap",
    "className",
    "UNSAFE_shouldDisableRouterLink",
    "UNSAFE_isDraggable",
    "interactionName"
];
var $1d9a95de95d29940$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
var $1d9a95de95d29940$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
var $1d9a95de95d29940$var$preventEvent = function preventEvent(e) {
    e.preventDefault();
};
/**
 * __Link item__
 *
 * A link item is used to populate a menu with items that are links.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/link-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $1d9a95de95d29940$var$LinkItem = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    var children = props.children, href = props.href, description = props.description, iconAfter = props.iconAfter, iconBefore = props.iconBefore, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onClick = props.onClick, testId = props.testId, onMouseDown = props.onMouseDown, shouldTitleWrap = props.shouldTitleWrap, shouldDescriptionWrap = props.shouldDescriptionWrap, UNSAFE_className = props.className, UNSAFE_shouldDisableRouterLink = props.UNSAFE_shouldDisableRouterLink, UNSAFE_isDraggable = props.UNSAFE_isDraggable, interactionName = props.interactionName, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $1d9a95de95d29940$var$_excluded);
    var onMouseDownHandler = onMouseDown;
    var RouterLink = (0, $5yYIk.default)();
    var interactionContext = (0, $8ZuGG.useContext)((0, $gqcal.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e) {
        interactionContext === null || interactionContext === void 0 || interactionContext.tracePress(interactionName, e.timeStamp);
        onClick === null || onClick === void 0 || onClick(e);
    }, [
        onClick,
        interactionContext,
        interactionName
    ]);
    if (!children) return null;
    var isExternal = typeof href === 'string' && $1d9a95de95d29940$var$IS_EXTERNAL_LINK_REGEX.test(href);
    var isNonHttpBased = typeof href === 'string' && $1d9a95de95d29940$var$IS_NON_HTTP_BASED.test(href);
    var isEmptyHref = href == null || href === '';
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.)
   * - it doesn't have an empty href (e.g. href="" or href={undefined})
   */ var isRouterLink = !UNSAFE_shouldDisableRouterLink && RouterLink && !isExternal && !isNonHttpBased && !isEmptyHref;
    var Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5g2AO.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: UNSAFE_className,
        iconBefore: iconBefore,
        iconAfter: iconAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        isTitleHeading: false,
        description: description,
        shouldTitleWrap: shouldTitleWrap,
        shouldDescriptionWrap: shouldDescriptionWrap,
        title: children,
        testId: testId && "".concat(testId, "--primitive")
    }), function(_ref) {
        var children = _ref.children, className = _ref.className;
        return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            "data-testid": testId,
            "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
            "data-vc": "link-item"
        }, rest, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            href: isDisabled ? undefined : href
        }, UNSAFE_isDraggable ? {} : {
            draggable: false,
            onDragStart: $1d9a95de95d29940$var$preventEvent
        }, {
            onMouseDown: isDisabled ? $1d9a95de95d29940$var$preventEvent : onMouseDownHandler,
            onClick: isDisabled ? $1d9a95de95d29940$var$preventEvent : handleClick,
            "aria-current": isSelected ? 'page' : undefined,
            "aria-disabled": isDisabled,
            ref: ref
        }), children);
    });
}));
var $1d9a95de95d29940$export$2e2bcd8739ae039 = $1d9a95de95d29940$var$LinkItem;

});


parcelRegister("1x0MG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11d97b3df3f85dca$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $iNlvH = parcelRequire("iNlvH");

var $eOq5N = parcelRequire("eOq5N");

var $a8e9s = parcelRequire("a8e9s");
var $11d97b3df3f85dca$var$_excluded = [
    "children",
    "id",
    "isList",
    "isScrollable",
    "title",
    "testId",
    "hasSeparator"
];
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ var $11d97b3df3f85dca$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, id = _ref.id, isList = _ref.isList, isScrollable = _ref.isScrollable, title = _ref.title, testId = _ref.testId, hasSeparator = _ref.hasSeparator, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $11d97b3df3f85dca$var$_excluded);
    var uid = (0, $iNlvH.useId)();
    var titleId = "dropdown-menu-item-group-title-".concat(uid);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eOq5N.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $a8e9s.default), {
        id: titleId,
        title: title
    }), children);
});
var $11d97b3df3f85dca$export$2e2bcd8739ae039 = $11d97b3df3f85dca$var$DropdownMenuItemGroup;

});
parcelRegister("eOq5N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac89f99988855f10$export$2e2bcd8739ae039; });
/* section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $ktSxI = parcelRequire("ktSxI");
var $ac89f99988855f10$var$_excluded = [
    "children",
    "title",
    "titleId",
    "testId",
    "isScrollable",
    "hasSeparator",
    "id",
    "isList",
    "isSideNavSection",
    "className"
];
var $ac89f99988855f10$var$itemHeadingTopMargin = 20;
var $ac89f99988855f10$var$itemHeadingBottomMargin = 6;
// Skeleton content is slightly shorter than the real content.
// Because of that we slightly increase the top margin to offset this so the
// containing size both real and skeleton always equal approx 30px.
var $ac89f99988855f10$var$itemHeadingContentHeight = 16; // Originally headingSizes.h100.lineHeight from '@atlaskit/theme/typography'
var $ac89f99988855f10$var$skeletonHeadingHeight = 8;
var $ac89f99988855f10$var$skeletonHeadingMarginOffset = 3;
var $ac89f99988855f10$var$skeletonHeadingTopMargin = $ac89f99988855f10$var$itemHeadingTopMargin + ($ac89f99988855f10$var$itemHeadingContentHeight - $ac89f99988855f10$var$skeletonHeadingHeight) - $ac89f99988855f10$var$skeletonHeadingMarginOffset;
var $ac89f99988855f10$var$sectionPaddingTopBottom = 6;
var $ac89f99988855f10$var$styles = {
    root: "_1ywu1ule _cfu11ule _1qdgi2wt _kfgti2wt _aetrb3bt _1kt9b3bt _1p3hi2wt _1l6bgktf _osbldlk8 _auo4rdoj _hp2110yn _1mfv8jkm _1bg41n1a",
    scrollable: "_1reo1wug _18m91wug _1o9zkb7n",
    unscrollable: "_1o9zidpf",
    thinSeparator: "_mqm21imm",
    noSeparator: "_n7cnyjp0",
    sideNavSectionHeading: "_18zru2gc"
};
/**
 * __Section__
 *
 * A section includes related actions or items in a menu.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/section)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $ac89f99988855f10$var$Section = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, title = _ref.title, titleId = _ref.titleId, testId = _ref.testId, isScrollable = _ref.isScrollable, hasSeparator = _ref.hasSeparator, id = _ref.id, _ref$isList = _ref.isList, isList = _ref$isList === void 0 ? false : _ref$isList, _ref$isSideNavSection = _ref.isSideNavSection, isSideNavSection = _ref$isSideNavSection === void 0 ? false : _ref$isSideNavSection, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $ac89f99988855f10$var$_excluded);
    var content = isList ? /*#__PURE__*/ $8ZuGG.createElement("ul", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: 0
        }
    }, (0, $8ZuGG.Children).map((0, $8ZuGG.Children).toArray(children), function(child, index) {
        return /*#__PURE__*/ $8ZuGG.createElement("li", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                listStyleType: 'none',
                margin: 0,
                padding: 0
            },
            key: index
        }, child);
    })) : children;
    var childrenMarkup = title !== undefined ? /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement((0, $ktSxI.default), {
        testId: testId && "".concat(testId, "--heading"),
        "aria-hidden": true,
        className: (0, $c4hjl.default)([
            isSideNavSection && $ac89f99988855f10$var$styles.sideNavSectionHeading
        ])
    }, title), content) : /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, content);
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $c4hjl.default)([
            $ac89f99988855f10$var$styles.root,
            isScrollable ? $ac89f99988855f10$var$styles.scrollable : $ac89f99988855f10$var$styles.unscrollable,
            hasSeparator ? $ac89f99988855f10$var$styles.thinSeparator : $ac89f99988855f10$var$styles.noSeparator,
            UNSAFE_className
        ]),
        id: id,
        "aria-label": title,
        "aria-labelledby": titleId,
        "data-testid": testId,
        role: "group",
        "data-section": true,
        ref: ref
    }), childrenMarkup);
});
var $ac89f99988855f10$export$2e2bcd8739ae039 = $ac89f99988855f10$var$Section;

});
parcelRegister("ktSxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee90d3209f362fcd$export$2e2bcd8739ae039; });
/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $7i3kT = parcelRequire("7i3kT");
var $ee90d3209f362fcd$var$_excluded = [
    "children",
    "testId",
    "headingLevel",
    "id",
    "className"
];
var $ee90d3209f362fcd$var$headingStyles = null;
/**
 * __Heading item__
 *
 * A heading item is used to describe sibling menu items.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/heading-item)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
 */ var $ee90d3209f362fcd$var$HeadingItem = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var children = _ref.children, testId = _ref.testId, _ref$headingLevel = _ref.headingLevel, headingLevel = _ref$headingLevel === void 0 ? 2 : _ref$headingLevel, id = _ref.id, UNSAFE_className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $ee90d3209f362fcd$var$_excluded);
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        role: "heading",
        "aria-level": headingLevel,
        "data-testid": testId,
        "data-ds--menu--heading-item": true,
        id: id,
        className: (0, $c4hjl.default)([
            "_11c81vhk _1rjcze3t _18zrpxbi _syaz1vvm",
            UNSAFE_className
        ])
    }, rest, {
        style: {
            "--_bbz764": (0, $bT1Ur.default)("var(--ds-text-subtle, ".concat((0, $7i3kT.N300), ")"))
        }
    }), children);
});
var $ee90d3209f362fcd$export$2e2bcd8739ae039 = $ee90d3209f362fcd$var$HeadingItem;

});
parcelRegister("7i3kT", function(module, exports) {

$parcel$export(module.exports, "N300", function () { return $54eccd4880a17889$export$e2ef2124cf4024b1; });
// Reds
var $54eccd4880a17889$export$4b84fd0e2c617bd = '#FFEBE6';
var $54eccd4880a17889$export$b34b069eff244586 = '#FFBDAD';
var $54eccd4880a17889$export$be802dd0d8b57f35 = '#FF8F73';
var $54eccd4880a17889$export$60847d42f9da92a6 = '#FF7452';
var $54eccd4880a17889$export$4a7404f376229999 = '#FF5630';
var $54eccd4880a17889$export$2010d0fb4295b346 = '#DE350B';
var $54eccd4880a17889$export$2837b5a1a71d5c02 = '#BF2600';
var $54eccd4880a17889$export$8d9596b529bbb9cf = '#FFFAE6';
var $54eccd4880a17889$export$41060a744ab0b7ae = '#FFF0B3';
var $54eccd4880a17889$export$1cc05bbbf340e559 = '#FFE380';
var $54eccd4880a17889$export$5aae31392d72caaa = '#FFC400';
var $54eccd4880a17889$export$c6930421db9fa514 = '#FFAB00';
var $54eccd4880a17889$export$59619663aa6500fb = '#FF991F';
var $54eccd4880a17889$export$874739ea9e379ab6 = '#FF8B00';
var $54eccd4880a17889$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $54eccd4880a17889$export$69a3bf21b9686c2b = '#ABF5D1';
var $54eccd4880a17889$export$afbce1382ec95f73 = '#79F2C0';
var $54eccd4880a17889$export$747d86715d4175de = '#57D9A3';
var $54eccd4880a17889$export$940e1f69e873f202 = '#36B37E';
var $54eccd4880a17889$export$a49394138f7b8e85 = '#00875A';
var $54eccd4880a17889$export$6fa04827ac68a4fb = '#006644';
var $54eccd4880a17889$export$226de0355ed012f8 = '#DEEBFF';
var $54eccd4880a17889$export$8c13c2ee36917869 = '#B3D4FF';
var $54eccd4880a17889$export$ecfc1dff386a3e7a = '#4C9AFF';
var $54eccd4880a17889$export$215b7063051591f1 = '#2684FF';
var $54eccd4880a17889$export$e62e8919cca44969 = '#0065FF';
var $54eccd4880a17889$export$b3de0ae08da2ce64 = '#0052CC';
var $54eccd4880a17889$export$a6ee3d71bc067634 = '#0747A6';
var $54eccd4880a17889$export$67f15409e87642a1 = '#669DF1';
var $54eccd4880a17889$export$f0539dbc42dbb067 = '#8FB8F6';
var $54eccd4880a17889$export$363e4475840015bb = '#EAE6FF';
var $54eccd4880a17889$export$4b0a4417ed59760f = '#C0B6F2';
var $54eccd4880a17889$export$6011520a64d9a187 = '#998DD9';
var $54eccd4880a17889$export$a7175d4e9206bc80 = '#8777D9';
var $54eccd4880a17889$export$b48405b95304b5a1 = '#6554C0';
var $54eccd4880a17889$export$c71e4279dd54a18d = '#5243AA';
var $54eccd4880a17889$export$147899de772240ec = '#403294';
var $54eccd4880a17889$export$2cf711fe14c66f06 = '#E6FCFF';
var $54eccd4880a17889$export$7a8f4d33f6f9772c = '#B3F5FF';
var $54eccd4880a17889$export$776c9c497ef08533 = '#79E2F2';
var $54eccd4880a17889$export$69cb3ca10c1e330e = '#00C7E6';
var $54eccd4880a17889$export$9dc1ef0f3f48059b = '#00B8D9';
var $54eccd4880a17889$export$7c835c78b6fcdef8 = '#00A3BF';
var $54eccd4880a17889$export$6036577f95c3877e = '#008DA6';
var $54eccd4880a17889$export$29a4f05edc054374 = '#FFFFFF';
var $54eccd4880a17889$export$e655ef011c4aa1a2 = '#FAFBFC';
var $54eccd4880a17889$export$9fdfb749e33cdf97 = '#F4F5F7';
var $54eccd4880a17889$export$3e51e8f1440314ba = '#EBECF0';
var $54eccd4880a17889$export$1ce2d1575d444ceb = '#DFE1E6';
var $54eccd4880a17889$export$8754fc7e6d8b3000 = '#C1C7D0';
var $54eccd4880a17889$export$c2e91cbeada39b8b = '#B3BAC5';
var $54eccd4880a17889$export$5f71e19f3a7ad9de = '#A5ADBA';
var $54eccd4880a17889$export$eaa8c8a70ac22806 = '#97A0AF';
var $54eccd4880a17889$export$7c87d337fb91a97d = '#8993A4';
var $54eccd4880a17889$export$d6447c357493214f = '#7A869A';
var $54eccd4880a17889$export$f563ee71e9ee74cd = '#6B778C';
var $54eccd4880a17889$export$e2ef2124cf4024b1 = '#5E6C84';
var $54eccd4880a17889$export$eece5f492e429f08 = '#505F79';
var $54eccd4880a17889$export$c39c0fe0f26207ae = '#42526E';
var $54eccd4880a17889$export$7090862dc3038a9f = '#344563';
var $54eccd4880a17889$export$ad0bacf983b7ddaa = '#253858';
var $54eccd4880a17889$export$7d61b15e0da132af = '#172B4D';
var $54eccd4880a17889$export$fbda843f0a27fe96 = '#091E42';
var $54eccd4880a17889$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $54eccd4880a17889$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $54eccd4880a17889$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $54eccd4880a17889$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $54eccd4880a17889$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $54eccd4880a17889$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $54eccd4880a17889$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $54eccd4880a17889$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $54eccd4880a17889$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $54eccd4880a17889$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $54eccd4880a17889$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $54eccd4880a17889$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $54eccd4880a17889$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $54eccd4880a17889$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $54eccd4880a17889$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $54eccd4880a17889$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $54eccd4880a17889$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $54eccd4880a17889$export$2f6319cf7d736c2a = '#E6EDFA';
var $54eccd4880a17889$export$95126bc8884d6634 = '#DCE5F5';
var $54eccd4880a17889$export$8338d8c35d44ff1 = '#CED9EB';
var $54eccd4880a17889$export$5368d76ae4fbbda7 = '#B8C7E0';
var $54eccd4880a17889$export$9f0a771d16ec8d36 = '#ABBBD6';
var $54eccd4880a17889$export$abcf8c38338b4aa5 = '#9FB0CC';
var $54eccd4880a17889$export$97e81faa16a182c7 = '#8C9CB8';
var $54eccd4880a17889$export$bfe21c59123ecf33 = '#7988A3';
var $54eccd4880a17889$export$ee82aa2ea6a1558 = '#67758F';
var $54eccd4880a17889$export$682927c6ed76be02 = '#56637A';
var $54eccd4880a17889$export$91fd9994c5be9757 = '#455166';
var $54eccd4880a17889$export$d281fbfe3cff2df6 = '#3B475C';
var $54eccd4880a17889$export$3902c91d8b98a753 = '#313D52';
var $54eccd4880a17889$export$8e8133c1ba5845b5 = '#283447';
var $54eccd4880a17889$export$33ff357f6620b39 = '#202B3D';
var $54eccd4880a17889$export$633847cf062b69e0 = '#1B2638';
var $54eccd4880a17889$export$9776a6e503bdbf76 = '#121A29';
var $54eccd4880a17889$export$6c813d5160dff5db = '#0E1624';
var $54eccd4880a17889$export$3d4f271a500072a = '#0D1424';
var $54eccd4880a17889$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $54eccd4880a17889$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $54eccd4880a17889$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $54eccd4880a17889$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $54eccd4880a17889$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $54eccd4880a17889$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $54eccd4880a17889$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $54eccd4880a17889$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $54eccd4880a17889$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $54eccd4880a17889$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $54eccd4880a17889$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $54eccd4880a17889$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $54eccd4880a17889$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $54eccd4880a17889$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $54eccd4880a17889$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $54eccd4880a17889$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $54eccd4880a17889$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $54eccd4880a17889$export$d2adc5dedf09fced = '#292A2E';
var $54eccd4880a17889$export$f51762073d2bb381 = '#94C748';
var $54eccd4880a17889$export$95e26d54def96891 = '#B3DF72';

});



parcelRegister("a8e9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7605a0eac930ec20$export$2e2bcd8739ae039; });
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 

var $8ZuGG = parcelRequire("8ZuGG");

var $72wHg = parcelRequire("72wHg");
var $7605a0eac930ec20$var$styles = {
    heading: "_11c81vhk _1rjcze3t _18zrpxbi _syaz1gjq"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ var $7605a0eac930ec20$var$GroupTitle = function GroupTitle(_ref) {
    var id = _ref.id, title = _ref.title;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $72wHg.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $7605a0eac930ec20$var$styles.heading
    }, title);
};
var $7605a0eac930ec20$export$2e2bcd8739ae039 = $7605a0eac930ec20$var$GroupTitle;

});


parcelRegister("lunc5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa4e642b4d1b57c7$var$_react = $fa4e642b4d1b57c7$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $fa4e642b4d1b57c7$var$_chevronDown = $fa4e642b4d1b57c7$var$_interopRequireDefault((parcelRequire("7uo2C")));
function $fa4e642b4d1b57c7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa4e642b4d1b57c7$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $fa4e642b4d1b57c7$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props, {
        newIcon: $fa4e642b4d1b57c7$var$_chevronDown.default
    }));
$fa4e642b4d1b57c7$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $fa4e642b4d1b57c7$var$_default = module.exports.default = $fa4e642b4d1b57c7$var$ChevronDownIcon;

});
parcelRegister("7uo2C", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $573dfbdac1d70ae1$var$_react = $573dfbdac1d70ae1$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $573dfbdac1d70ae1$var$_baseNew = $573dfbdac1d70ae1$var$_interopRequireDefault((parcelRequire("d9We0")));
function $573dfbdac1d70ae1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $573dfbdac1d70ae1$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $573dfbdac1d70ae1$var$_react.default.createElement($573dfbdac1d70ae1$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$573dfbdac1d70ae1$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $573dfbdac1d70ae1$var$_default = module.exports.default = $573dfbdac1d70ae1$var$ChevronDownIcon;

});



parcelRegister("bceLx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $21aef6a96df02852$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");
let $21aef6a96df02852$var$_ = (t)=>t, $21aef6a96df02852$var$t;
const $21aef6a96df02852$var$SeparatorContainer = (0, $9Vz68.default).li($21aef6a96df02852$var$t || ($21aef6a96df02852$var$t = $21aef6a96df02852$var$_`
  margin: 0px 8px;

  + li {
    margin-top: 0px;
  }
`));
const $21aef6a96df02852$var$Bull = ()=>/*#__PURE__*/ (0, $6rcps.jsx)($21aef6a96df02852$var$SeparatorContainer, {
        role: "presentation",
        children: "\u2022"
    });
var $21aef6a96df02852$export$2e2bcd8739ae039 = $21aef6a96df02852$var$Bull;

});

parcelRegister("8bNLi", function(module, exports) {

$parcel$export(module.exports, "useNavigateToLoginPrompt", function () { return $1f0056300ec58eb3$export$87a5fad76d200f12; });

var $hTZm6 = parcelRequire("hTZm6");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $8ZuGG = parcelRequire("8ZuGG");

var $9NVnN = parcelRequire("9NVnN");
const $1f0056300ec58eb3$export$87a5fad76d200f12 = ()=>{
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const loginHint = (0, $hTZm6.useLoginHint)();
    const queryParams = (0, $8ZuGG.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    return (0, $8ZuGG.useCallback)(()=>{
        // Remove MFA transaction token
        queryParams.delete('transactionToken');
        // Remove inverted login hint
        if ((loginHint === null || loginHint === void 0 ? void 0 : loginHint.type) === (0, $hTZm6.LoginHintType).NotEmailAddress) queryParams.delete('login_hint');
        return navigate({
            pathname: '/login',
            search: `prompt=login&${queryParams}`
        });
    }, [
        loginHint === null || loginHint === void 0 ? void 0 : loginHint.type,
        navigate,
        queryParams
    ]);
};

});
parcelRegister("hTZm6", function(module, exports) {

$parcel$export(module.exports, "LoginHintType", function () { return $3be53da9aa4cdd4b$export$39d1212c3512cb3a; });
$parcel$export(module.exports, "useLoginHint", function () { return $3be53da9aa4cdd4b$export$76b5c17694a141a; });
$parcel$export(module.exports, "getEmailFromLoginHint", function () { return $3be53da9aa4cdd4b$export$a738b9016987c561; });

var $8ZuGG = parcelRequire("8ZuGG");

var $5WDNl = parcelRequire("5WDNl");
var $3be53da9aa4cdd4b$export$39d1212c3512cb3a = /*#__PURE__*/ function(LoginHintType) {
    LoginHintType["EmailAddress"] = "email-address";
    LoginHintType["NotEmailAddress"] = "not-email-address";
    return LoginHintType;
}({});
const $3be53da9aa4cdd4b$var$NEGATED_EMAIL_PREFIX = 'not:';
function $3be53da9aa4cdd4b$var$parseLoginHint(loginHint) {
    if (!loginHint) return undefined;
    if (loginHint.startsWith($3be53da9aa4cdd4b$var$NEGATED_EMAIL_PREFIX)) return {
        type: "not-email-address",
        value: loginHint.substring($3be53da9aa4cdd4b$var$NEGATED_EMAIL_PREFIX.length)
    };
    return {
        type: "email-address",
        value: loginHint
    };
}
const $3be53da9aa4cdd4b$export$76b5c17694a141a = ()=>{
    const { search: search } = (0, $5WDNl.useLocation)();
    return (0, $8ZuGG.useMemo)(()=>{
        const loginHint = new URLSearchParams(search).get('login_hint');
        return $3be53da9aa4cdd4b$var$parseLoginHint(loginHint);
    }, [
        search
    ]);
};
const $3be53da9aa4cdd4b$export$a738b9016987c561 = (loginHint)=>{
    if ((loginHint === null || loginHint === void 0 ? void 0 : loginHint.type) === "email-address") return loginHint.value;
};

});


parcelRegister("bbINW", function(module, exports) {

$parcel$export(module.exports, "VerifyEmailOtp", function () { return $666f9d458e7b437c$export$fce66dd1dcb31ce2; });
$parcel$export(module.exports, "default", function () { return $666f9d458e7b437c$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $9OvaU = parcelRequire("9OvaU");

var $hX7Rq = parcelRequire("hX7Rq");

var $7lAAA = parcelRequire("7lAAA");

var $8I44a = parcelRequire("8I44a");

var $8ZuGG = parcelRequire("8ZuGG");

var $1SvOA = parcelRequire("1SvOA");

var $7CMue = parcelRequire("7CMue");

var $IGnl6 = parcelRequire("IGnl6");

var $9Vz68 = parcelRequire("9Vz68");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $8Ji6M = parcelRequire("8Ji6M");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $8f2pb = parcelRequire("8f2pb");
let $666f9d458e7b437c$var$_ = (t)=>t, $666f9d458e7b437c$var$t, $666f9d458e7b437c$var$t1;
const $666f9d458e7b437c$var$OtpError = (0, $9Vz68.default).div($666f9d458e7b437c$var$t || ($666f9d458e7b437c$var$t = $666f9d458e7b437c$var$_`
  margin-top: 4px;
  margin-bottom: 0;
  display: inline-flex;
  align-items: center;
  font-size: 12px !important;
  color: ${0};
`), (0, $kTdw7).R500);
const $666f9d458e7b437c$var$OtpInputWrapper = (0, $9Vz68.default).div($666f9d458e7b437c$var$t1 || ($666f9d458e7b437c$var$t1 = $666f9d458e7b437c$var$_`
  display: flex;
  align-content: center;
  justify-content: center;
  padding: ${0}px 0 0 0;
`), (0, $5b7Z4.gridSize)() * 3);
const $666f9d458e7b437c$var$EMPTY_OTP_STATE = ' '.repeat((0, $8Ji6M.OTP_CODE_FULL_LENGTH));
const $666f9d458e7b437c$var$removePlaceholders = (otp)=>otp.replace(/ /g, '');
const $666f9d458e7b437c$export$fce66dd1dcb31ce2 = ({ pageId: pageId, flow: flow, email: email, isLoading: isLoading, errorCode: errorCode, additionalWhiteboxFooter: footer, onVerifyEmailOtp: onVerifyEmailOtp, onResendEmailOtp: onResendEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength })=>{
    const [otp, setOtp] = (0, $8ZuGG.useState)($666f9d458e7b437c$var$EMPTY_OTP_STATE);
    const [isInvalidOtpLength, setInvalidOtpLength] = (0, $8ZuGG.useState)(false);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const handleOtpChange = (otp)=>{
        setOtp(otp);
        const sanitisedOtp = $666f9d458e7b437c$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $8Ji6M.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        }
    };
    const handleSubmit = ()=>{
        const sanitisedOtp = $666f9d458e7b437c$var$removePlaceholders(otp);
        if (sanitisedOtp.length === (0, $8Ji6M.OTP_CODE_FULL_LENGTH)) {
            setInvalidOtpLength(false);
            onVerifyEmailOtp(sanitisedOtp);
        } else {
            setInvalidOtpLength(true);
            onInvalidEmailOtpLength === null || onInvalidEmailOtpLength === void 0 ? void 0 : onInvalidEmailOtpLength(sanitisedOtp);
        }
    };
    const otpMessageDescriptor = (0, $8ZuGG.useMemo)(()=>{
        switch(flow){
            case 'sign-up':
                return (0, $IGnl6.default).signUpOtpMessage;
            case 'login-challenge':
                return (0, $IGnl6.default).loginChallengeOtpMessage;
            default:
                (0, $8f2pb.captureErrorMessage)(`No OTP message defined for VerifyEmailOtp flow "${flow}", falling back to default message`);
                return (0, $IGnl6.default).defaultOtpMessage;
        }
    }, [
        flow
    ]);
    const errorMessageDescriptor = (0, $8ZuGG.useMemo)(()=>{
        if (isInvalidOtpLength) return (0, $IGnl6.default).invalidOtpLengthErrorMessage;
        if (!errorCode) return undefined;
        switch(errorCode){
            case 'invalid_otp':
                return (0, $IGnl6.default).invalidOtpErrorMessage;
            case 'invalid_otp_length':
                return (0, $IGnl6.default).invalidOtpLengthErrorMessage;
            case 'invalid_token':
                return (0, $IGnl6.default).invalidTokenErrorMessage;
            case 'expired_token':
                return (0, $IGnl6.default).expiredTokenErrorMessage;
            case 'rate_limited':
                return (0, $IGnl6.default).rateLimitedErrorMessage;
            case 'unexpected_error':
                return (0, $IGnl6.default).unexpectedErrorErrorMessage;
            default:
                return (0, $IGnl6.default).unexpectedErrorErrorMessage;
        }
    }, [
        errorCode,
        isInvalidOtpLength
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (errorCode === 'invalid_otp') setOtp($666f9d458e7b437c$var$EMPTY_OTP_STATE);
    }, [
        errorCode
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({
            tagName: "h2"
        }, (0, $IGnl6.default).headOtpTitle)),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                    id: "otp-resend",
                    spacing: "none",
                    onClick: onResendEmailOtp,
                    children: formatMessage((0, $IGnl6.default).resendOtpButton)
                }),
                footer
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.Helmet), {
                title: formatMessage((0, $IGnl6.default).headOtpTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                email: email,
                message: formatMessage(otpMessageDescriptor),
                withEmailSentImage: false
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)($666f9d458e7b437c$var$OtpInputWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $8I44a.default), {
                    otpCodeFullLength: (0, $8Ji6M.OTP_CODE_FULL_LENGTH),
                    onChange: handleOtpChange,
                    otp: otp,
                    isLoading: isLoading,
                    isError: !!errorCode
                })
            }),
            !!errorMessageDescriptor && /*#__PURE__*/ (0, $6rcps.jsxs)($666f9d458e7b437c$var$OtpError, {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7lAAA))), {
                        label: 'Error message icon',
                        size: 'small'
                    }),
                    formatMessage(errorMessageDescriptor)
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                id: "otp-submit",
                appearance: 'primary',
                type: "submit",
                isFullWidth: true,
                style: {
                    marginTop: '30px'
                },
                onClick: handleSubmit,
                isLoading: isLoading,
                children: formatMessage((0, $IGnl6.default).submitButton)
            })
        ]
    });
};
var $666f9d458e7b437c$export$2e2bcd8739ae039 = $666f9d458e7b437c$export$fce66dd1dcb31ce2;

});
parcelRegister("8I44a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $028a9b8c871cfb3a$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $cT1nw = parcelRequire("cT1nw");

var $9Vz68 = parcelRequire("9Vz68");

var $8f2pb = parcelRequire("8f2pb");

var $5b7Z4 = parcelRequire("5b7Z4");
let $028a9b8c871cfb3a$var$_ = (t)=>t, $028a9b8c871cfb3a$var$t;
const $028a9b8c871cfb3a$export$a21f0385582d981d = [
    ' ',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
const $028a9b8c871cfb3a$var$InputWrapper = (0, $9Vz68.default).div($028a9b8c871cfb3a$var$t || ($028a9b8c871cfb3a$var$t = $028a9b8c871cfb3a$var$_`
  display: flex;
  gap: ${0}px;

  input {
    text-align: center;
    font-size: 20px;
  }
`), (0, $5b7Z4.gridSize)());
const $028a9b8c871cfb3a$var$OtpInput = ({ otp: otp, otpCodeFullLength: otpCodeFullLength, onChange: onChange, isLoading: isLoading, isError: isError })=>{
    const [focusedInputIndex, setFocusedInputIndex] = (0, $8ZuGG.useState)(0);
    const inputRefs = (0, $8ZuGG.useRef)([]);
    const otpCodeArray = $028a9b8c871cfb3a$var$parseOtp(otp);
    (0, $8ZuGG.useEffect)(()=>{
        inputRefs.current = inputRefs.current.slice(0, otpCodeFullLength);
    }, [
        otpCodeFullLength
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        var _inputRefs_current_;
        (_inputRefs_current_ = inputRefs.current[0]) === null || _inputRefs_current_ === void 0 ? void 0 : _inputRefs_current_.focus();
    }, []);
    const isInputValueValid = (value)=>value.trim().length === 1 && $028a9b8c871cfb3a$var$isOtpCodeCharacter(value);
    const handleChange = (event)=>{
        const value = event.target.value.toUpperCase();
        if (isInputValueValid(value)) {
            changeOtpCodeAtFocus(value);
            focusInput(focusedInputIndex + 1);
        } else {
            const { nativeEvent: nativeEvent } = event;
            // @ts-expect-error - This was added previosly to handle and edge case
            // for dealing with keyCode "229 Unidentified" on Android. Check if this is
            // still needed.
            if (nativeEvent.data === null && nativeEvent.inputType === 'deleteContentBackward') {
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                focusInput(focusedInputIndex - 1);
            }
        }
    };
    const handleFocus = (index)=>(event)=>{
            focusInput(index);
            event.target.select();
        };
    const handleBlur = ()=>{
        setFocusedInputIndex(focusedInputIndex - 1);
    };
    const handleBackspace = (event)=>{
        event.preventDefault();
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = event.target;
        if (selectionStart === 0 && selectionEnd === 0) {
            if (focusedInputIndex > 0) {
                const newFocusedIndex = focusedInputIndex - 1;
                focusInput(newFocusedIndex);
                changeOtpCodeAtIndex(newFocusedIndex, ' ');
            }
        } else changeOtpCodeAtFocus(' ');
    };
    const handleKeyDown = (event)=>{
        switch(event.key){
            case 'Delete':
                event.preventDefault();
                changeOtpCodeAtFocus(' ');
                break;
            case 'Backspace':
                handleBackspace(event);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                focusInput(focusedInputIndex - 1);
                break;
            case 'ArrowRight':
                event.preventDefault();
                focusInput(focusedInputIndex + 1);
                break;
            case 'Space':
            case 'Spacebar':
            case 'ArrowUp':
            case 'ArrowDown':
                event.preventDefault();
                break;
            default:
                // React does not trigger onChange when the same value is entered
                // again. So we need to focus the next input manually in this case.
                if (event.key === otpCodeArray[focusedInputIndex]) {
                    event.preventDefault();
                    focusInput(focusedInputIndex + 1);
                }
        }
    };
    const focusInput = (index)=>{
        var _inputRefs_current_indexToFocusInput, _inputRefs_current_indexToFocusInput1;
        const indexToFocusInput = Math.max(Math.min(otpCodeFullLength - 1, index), 0);
        (_inputRefs_current_indexToFocusInput = inputRefs.current[indexToFocusInput]) === null || _inputRefs_current_indexToFocusInput === void 0 ? void 0 : _inputRefs_current_indexToFocusInput.focus();
        (_inputRefs_current_indexToFocusInput1 = inputRefs.current[indexToFocusInput]) === null || _inputRefs_current_indexToFocusInput1 === void 0 ? void 0 : _inputRefs_current_indexToFocusInput1.select();
        setFocusedInputIndex(indexToFocusInput);
    };
    const changeOtpCodeAtIndex = (index, value)=>{
        otpCodeArray[index] = value;
        onChange($028a9b8c871cfb3a$var$otpCodeArrayToString(otpCodeArray));
    };
    const changeOtpCodeAtFocus = (value)=>changeOtpCodeAtIndex(focusedInputIndex, value);
    const handlePaste = (event)=>{
        event.preventDefault();
        // Get dataToPaste in an array of max size (num of inputs - current position)
        const dataToPaste = event.clipboardData.getData('text/plain').slice(0, otpCodeFullLength - focusedInputIndex).toUpperCase().split('');
        // Prevent pasting if the clipboard data contains non-alphanumeric values for number inputs
        if (dataToPaste.some((value)=>!$028a9b8c871cfb3a$var$isOtpCodeCharacter(value))) return;
        // Paste data from focused input onwards
        let indexToPaste = focusedInputIndex;
        while(indexToPaste < otpCodeFullLength && dataToPaste.length > 0){
            otpCodeArray[indexToPaste] = dataToPaste.shift();
            indexToPaste++;
        }
        focusInput(indexToPaste);
        onChange($028a9b8c871cfb3a$var$otpCodeArrayToString(otpCodeArray));
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)($028a9b8c871cfb3a$var$InputWrapper, {
        children: otpCodeArray.map((otpCodeDigitValue, index)=>/*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cT1nw.default), {
                    isDisabled: isLoading,
                    isInvalid: isError,
                    value: otpCodeDigitValue === ' ' ? '' : otpCodeDigitValue,
                    ref: (element)=>inputRefs.current[index] = element,
                    onChange: handleChange,
                    onFocus: handleFocus(index),
                    onBlur: handleBlur,
                    onKeyDown: handleKeyDown,
                    onPaste: handlePaste,
                    autoComplete: "off",
                    maxLength: 1,
                    "aria-label": `Please enter OTP character ${index + 1}`,
                    type: "text",
                    testId: `otp-input-index-${index}`
                })
            }, `otp-div-index-${index}`))
    });
};
const $028a9b8c871cfb3a$var$isOtpCodeCharacter = (c)=>$028a9b8c871cfb3a$export$a21f0385582d981d.includes(c);
const $028a9b8c871cfb3a$var$parseOtp = (otp)=>{
    const otpCodeArray = otp.split('').filter($028a9b8c871cfb3a$var$isOtpCodeCharacter);
    if (otp.length !== otpCodeArray.length) (0, $8f2pb.captureErrorMessage)('Error parsing OTP - received invalid OTP character', {
        otp: otp
    });
    return otpCodeArray;
};
const $028a9b8c871cfb3a$var$otpCodeArrayToString = (otpCodeArray)=>otpCodeArray.join('');
var $028a9b8c871cfb3a$export$2e2bcd8739ae039 = $028a9b8c871cfb3a$var$OtpInput;

});

parcelRegister("IGnl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77bad1d852e99de0$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $77bad1d852e99de0$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    defaultOtpMessage: {
        id: 'verify.email.sent.body.otp.default.message',
        defaultMessage: "To proceed, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed to the next step'
    },
    signUpOtpMessage: {
        id: 'verify.email.sent.body.otp.sign-up.message',
        defaultMessage: "To complete your account setup, enter the code we've sent to:",
        description: 'Text telling the user to enter the OTP sent to their email to verify their account and complete account setup'
    },
    loginChallengeOtpMessage: {
        id: 'verify.email.sent.body.otp.login-challenge.message',
        defaultMessage: 'We require additional verification to protect your account. Check your email to continue:',
        description: 'Text telling the user to enter the OTP sent to their email to verify their account to proceed with the login'
    },
    invalidOtpErrorMessage: {
        id: 'verify.email.error-message.invalid-otp',
        defaultMessage: 'Provided verification code is invalid',
        description: 'Error message informing the user that the OTP code they have entered is incorrect'
    },
    invalidOtpLengthErrorMessage: {
        id: 'verify.email.error-message.invalid-otp-length',
        defaultMessage: 'Complete the verification code',
        description: 'Error message informing the user that the OTP code they have entered is of an incorrect length'
    },
    invalidTokenErrorMessage: {
        id: 'verify.email.error-message.invalid-token',
        defaultMessage: 'Invalid token',
        description: 'Error message returned when the token associated with the verification transaction is invalid'
    },
    expiredTokenErrorMessage: {
        id: 'verify.email.error-message.expired-token',
        defaultMessage: 'Token expired',
        description: 'Error message returned when the token associated with the verification transaction is expired'
    },
    rateLimitedErrorMessage: {
        id: 'verify.email.error-message.rate-limited',
        defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.',
        description: 'Error message returned when rate limited due to too many requests'
    },
    unexpectedErrorErrorMessage: {
        id: 'verify.email.error-message.unexpected',
        defaultMessage: 'Unexpected error',
        description: 'Error message returned when there is an unexpected error'
    },
    emailOtpVerifyHeader: {
        id: 'verify.email.otp.sent.title',
        defaultMessage: `We've sent you an email!`,
        description: 'Title of the component that lets them input the code to verify their email'
    },
    resendOtpButton: {
        id: 'welcome.sent.resend.signup.otp',
        defaultMessage: `Didn't receive an email? Resend email`,
        description: 'Text telling the user that they can resend the welcome OTP email again for verification.'
    },
    headOtpTitle: {
        id: 'verify.email.sent.otp.head.title',
        defaultMessage: `We've emailed you a code`,
        description: 'Text telling the user that they were sent an email with an OTP'
    },
    submitButton: {
        id: 'verify.email.signup.submit',
        defaultMessage: 'Verify',
        description: 'Text used for the button that submits the OTP for verification.'
    }
});

});

parcelRegister("8Ji6M", function(module, exports) {

$parcel$export(module.exports, "OTP_CODE_FULL_LENGTH", function () { return $2a8f6d61b2995075$export$d9c80c0582b65520; });
const $2a8f6d61b2995075$export$d9c80c0582b65520 = 6;

});


parcelRegister("2WEoo", function(module, exports) {

$parcel$export(module.exports, "useExecutionTracker", function () { return $bc7ba86fafed60aa$export$a5531e57774c1d12; });

var $8ZuGG = parcelRequire("8ZuGG");
const $bc7ba86fafed60aa$export$a5531e57774c1d12 = ()=>{
    const [isExecuting, setIsExecuting] = (0, $8ZuGG.useState)(false);
    const executeWithTracking = (0, $8ZuGG.useCallback)(async (asyncOperation)=>{
        setIsExecuting(true);
        try {
            return await asyncOperation();
        } finally{
            setIsExecuting(false);
        }
    }, []);
    return {
        isExecuting: isExecuting,
        executeWithTracking: executeWithTracking
    };
};

});

parcelRegister("aSbwi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f34bdd60b1597c9d$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $4yIkJ = parcelRequire("4yIkJ");

var $9OvaU = parcelRequire("9OvaU");

var $dZoLz = parcelRequire("dZoLz");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $9NVnN = parcelRequire("9NVnN");
const $f34bdd60b1597c9d$export$cf34b8e1c360d82b = ({ screenId: screenId, isSwitching: isSwitching, switchWithTracking: switchWithTracking })=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { method: multifactorMethod, additionalMfaFactors: additionalMfaFactors } = (0, $kOqgB.useAppSelector)((state)=>state.multiFactor);
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const trackSwitchToSms = (0, $3ir1n.useButtonClickedEvent)(screenId, 'switchToSms');
    const trackSwitchToTotp = (0, $3ir1n.useButtonClickedEvent)(screenId, 'switchToTotp');
    const trackSwitchToSecurityKey = (0, $3ir1n.useButtonClickedEvent)(screenId, 'switchToSecurityKey');
    const onSwitchToSms = (0, $8ZuGG.useCallback)(()=>{
        trackSwitchToSms();
        switchWithTracking(async ()=>await dispatch((0, $4yIkJ.switchMfaFactor)(search, 'SMS', analyticsClient, navigate)));
    }, [
        trackSwitchToSms,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToTotp = (0, $8ZuGG.useCallback)(()=>{
        trackSwitchToTotp();
        switchWithTracking(async ()=>await dispatch((0, $4yIkJ.switchMfaFactor)(search, 'TOTP', analyticsClient, navigate)));
    }, [
        trackSwitchToTotp,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const onSwitchToSecurityKey = (0, $8ZuGG.useCallback)(()=>{
        trackSwitchToSecurityKey();
        switchWithTracking(async ()=>await dispatch((0, $4yIkJ.switchMfaFactor)(search, 'SecurityKey', analyticsClient, navigate)));
    }, [
        trackSwitchToSecurityKey,
        switchWithTracking,
        dispatch,
        search,
        analyticsClient,
        navigate
    ]);
    const switchableFactors = (0, $8ZuGG.useMemo)(()=>[
            {
                method: 'security-key',
                buttonLabel: (0, $dZoLz.default).mfSwitchToSecurityKey,
                onClick: onSwitchToSecurityKey
            },
            {
                method: 'otp',
                buttonLabel: (0, $dZoLz.default).mfSwitchToTotp,
                onClick: onSwitchToTotp
            },
            {
                method: 'sms',
                buttonLabel: (0, $dZoLz.default).mfSwitchToSms,
                onClick: onSwitchToSms
            }
        ], [
        onSwitchToSecurityKey,
        onSwitchToTotp,
        onSwitchToSms
    ]);
    if (!additionalMfaFactors || additionalMfaFactors.length === 0) return null;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                tagName: "p",
                id: "mf.switch-to-other-factor-help-text",
                defaultMessage: "Use alternate method",
                description: "Text indicating the purposes the buttons to switch factor when being challenged on login"
            }),
            switchableFactors.flatMap((factor)=>{
                if (!additionalMfaFactors.includes(factor.method) || factor.method === multifactorMethod) return [];
                else return [
                    /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                            id: `two-step-verification-switch-factor-${factor.method}`,
                            testId: `two-step-verification-switch-factor-${factor.method}`,
                            onClick: factor.onClick,
                            isDisabled: isSwitching,
                            children: formatMessage(factor.buttonLabel)
                        })
                    }, `switch-factor-${factor.method}-wrapper`)
                ];
            })
        ]
    });
};
var $f34bdd60b1597c9d$export$2e2bcd8739ae039 = $f34bdd60b1597c9d$export$cf34b8e1c360d82b;

});


parcelRegister("30C6j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "cancelAccountDeletionLoader", function () { return $95c5afda293b5255$export$bb55274e034e60c0; });
$parcel$export(module.exports, "CancelAccountDeletionPageComponent", function () { return $95c5afda293b5255$export$429c4af0f87478e0; });
$parcel$export(module.exports, "default", function () { return $95c5afda293b5255$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $gJFTu = parcelRequire("gJFTu");

var $jSnDV = parcelRequire("jSnDV");

var $1SvOA = parcelRequire("1SvOA");

var $3o9o3 = parcelRequire("3o9o3");

var $gkOgT = parcelRequire("gkOgT");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $xe7jL = parcelRequire("xe7jL");

var $f6y2N = parcelRequire("f6y2N");

var $2leiB = parcelRequire("2leiB");

var $7CMue = parcelRequire("7CMue");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $95c5afda293b5255$var$_ = (t)=>t, $95c5afda293b5255$var$t;
const $95c5afda293b5255$var$SubtleLinkWrapper = (0, $9Vz68.default).div($95c5afda293b5255$var$t || ($95c5afda293b5255$var$t = $95c5afda293b5255$var$_`
  margin-top: ${0}px;
  a {
    color: ${0};

    &:hover {
      color: ${0};
    }
  }
`), (0, $5b7Z4.gridSize)(), (0, $kTdw7).N800, (0, $kTdw7).N800);
const $95c5afda293b5255$var$pageId = 'cancelAccountDeletionPage';
async function $95c5afda293b5255$export$bb55274e034e60c0({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/cancel-account-deletion/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--cancel-account-deletion'
        ]
    });
}
const $95c5afda293b5255$export$429c4af0f87478e0 = ()=>{
    const { search: search } = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8xW40.usePageStateLoader)();
    const deleteOn = (0, $kOqgB.useAppSelector)((state)=>state.cancelDeletion.deleteOn);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const cancelDeletion = (0, $8ZuGG.useCallback)(()=>{
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(search);
        return fetch(`/rest/cancel-account-deletion${search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 200) return response.json();
            else throw response;
        }).then(({ redirectTo: redirectTo })=>{
            navigate(redirectTo);
        }).catch(()=>{
            const flag = {
                type: 'error',
                title: (0, $f6y2N.default).cancelAccountDeletionFlagErrorTitle,
                description: (0, $f6y2N.default).cancelAccountDeletionFlagErrorDesc
            };
            dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description));
        });
    }, [
        dispatch,
        search,
        navigate
    ]);
    const signupLink = '/signup' + search;
    const loginLink = '/login' + search;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $95c5afda293b5255$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $f6y2N.default).headTitle))
        }),
        footer: /*#__PURE__*/ (0, $6rcps.jsx)($95c5afda293b5255$var$SubtleLinkWrapper, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
                id: "signup-for-new-account",
                to: signupLink,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $f6y2N.default).cancelAccountDeletionSignupMessage))
            })
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
            to: loginLink,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $f6y2N.default).cancelAccountDeletionLogout))
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $f6y2N.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gkOgT.default), {
                message: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $f6y2N.default).cancelAccountDeletionInfo), {
                    tagName: "p",
                    values: {
                        deleteOn: (0, (/*@__PURE__*/$parcel$interopDefault($2leiB)))(deleteOn).format('DD MMMM YYYY')
                    }
                }))
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "login-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: cancelDeletion,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $f6y2N.default).cancelAccountDeletionButton))
                })
            })
        ]
    });
};
var $95c5afda293b5255$export$2e2bcd8739ae039 = $95c5afda293b5255$export$429c4af0f87478e0;

});
parcelRegister("gkOgT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $784d830d31da10f2$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kZGwD = parcelRequire("kZGwD");

var $5b7Z4 = parcelRequire("5b7Z4");
let $784d830d31da10f2$var$_ = (t)=>t, $784d830d31da10f2$var$t;
const $784d830d31da10f2$var$imgHeight = 150;
const $784d830d31da10f2$var$CancelDeletionContainer = (0, $9Vz68.default).div($784d830d31da10f2$var$t || ($784d830d31da10f2$var$t = $784d830d31da10f2$var$_`
  background: url(${0}) no-repeat center top;
  background-size: auto ${0}px;
  padding-top: ${0}px;
  margin-top: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($kZGwD))), $784d830d31da10f2$var$imgHeight, $784d830d31da10f2$var$imgHeight + (0, $5b7Z4.gridSize)() * 2, (0, $5b7Z4.gridSize)());
const $784d830d31da10f2$var$CancelDeletion = ({ children: children, message: message })=>/*#__PURE__*/ (0, $6rcps.jsxs)($784d830d31da10f2$var$CancelDeletionContainer, {
        id: "cancel-account-deletion-page",
        children: [
            message,
            children
        ]
    });
var $784d830d31da10f2$export$2e2bcd8739ae039 = $784d830d31da10f2$var$CancelDeletion;

});
parcelRegister("kZGwD", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "cancel-deletion-hourglass.714e127f.svg";

});


parcelRegister("f6y2N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07539857f4499e14$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $07539857f4499e14$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    // Flags
    cancelAccountDeletionFlagErrorTitle: {
        id: 'cancel.account.deletion.flag.error.title',
        defaultMessage: 'Something went wrong.',
        description: ''
    },
    cancelAccountDeletionFlagErrorDesc: {
        id: 'cancel.account.deletion.flag.error.description',
        defaultMessage: 'Please try again later.',
        description: ''
    },
    headTitle: {
        id: 'cancel.account.deletion.title',
        defaultMessage: 'Cancel the deletion of your account',
        description: ''
    },
    cancelAccountDeletionSignupMessage: {
        id: 'cancel.account.deletion.signup',
        defaultMessage: 'Sign up for a new account',
        description: 'Button text for signing up for a new account'
    },
    cancelAccountDeletionInfo: {
        id: 'cancel.account.deletion.info',
        defaultMessage: 'Your account will be permanently deleted. You can cancel the deletion before {deleteOn}.',
        description: 'Deletion info in the text box'
    },
    cancelAccountDeletionButton: {
        id: 'cancel.account.deletion.button',
        defaultMessage: 'Cancel deletion',
        description: 'Text for cancel deletion button'
    },
    cancelAccountDeletionLogout: {
        id: 'cancel.account.deletion.log.out',
        defaultMessage: 'Log out (and delete your account as scheduled)',
        description: 'Text for log out button'
    }
});

});

parcelRegister("2leiB", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});


parcelRegister("hWM0L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changePasswordLoader", function () { return $09d6ddfcbb6ea4b5$export$86843e04562221a8; });
$parcel$export(module.exports, "ChangePasswordPage", function () { return $09d6ddfcbb6ea4b5$export$8ec0fb1e4323236d; });
$parcel$export(module.exports, "default", function () { return $09d6ddfcbb6ea4b5$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $jSnDV = parcelRequire("jSnDV");

var $9Vz68 = parcelRequire("9Vz68");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $5b7Z4 = parcelRequire("5b7Z4");

var $cZOfY = parcelRequire("cZOfY");

var $1SvOA = parcelRequire("1SvOA");

var $8f2pb = parcelRequire("8f2pb");

var $7CMue = parcelRequire("7CMue");

var $4JKmU = parcelRequire("4JKmU");

var $idats = parcelRequire("idats");

var $8PH8E = parcelRequire("8PH8E");

var $6RoHK = parcelRequire("6RoHK");

var $pO9YU = parcelRequire("pO9YU");

var $kZj5j = parcelRequire("kZj5j");

var $eDndD = parcelRequire("eDndD");

var $bceLx = parcelRequire("bceLx");

var $lp6gZ = parcelRequire("lp6gZ");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $97pBx = parcelRequire("97pBx");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $09d6ddfcbb6ea4b5$var$_ = (t)=>t, $09d6ddfcbb6ea4b5$var$t, $09d6ddfcbb6ea4b5$var$t1;
const $09d6ddfcbb6ea4b5$var$TRANSITION_DURATION = 400;
const $09d6ddfcbb6ea4b5$var$SecurityContainer = (0, $9Vz68.default).div($09d6ddfcbb6ea4b5$var$t || ($09d6ddfcbb6ea4b5$var$t = $09d6ddfcbb6ea4b5$var$_`
  background: url(${0}) no-repeat center;
  height: ${0}px;
  transition: visibility ${0}ms;
  margin-bottom: ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($eDndD))), (0, $5b7Z4.gridSize)() * 14.5, $09d6ddfcbb6ea4b5$var$TRANSITION_DURATION, (0, $5b7Z4.gridSize)() * 1.5);
const $09d6ddfcbb6ea4b5$var$Form = (0, $9Vz68.default).form($09d6ddfcbb6ea4b5$var$t1 || ($09d6ddfcbb6ea4b5$var$t1 = $09d6ddfcbb6ea4b5$var$_`
  margin-top: 0;
`));
const $09d6ddfcbb6ea4b5$var$knownMessageKeys = [
    'change_email',
    'security_wasme_reset',
    'security_wasnotme_reset'
];
function $09d6ddfcbb6ea4b5$var$chooseTitle(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $cZOfY.default).securityResetTitle;
        case 'security_wasnotme_reset':
            return (0, $cZOfY.default).securityResetTitle;
        default:
            return (0, $cZOfY.default).title;
    }
}
function $09d6ddfcbb6ea4b5$var$chooseButtonText(message) {
    switch(message){
        case 'security_wasme_reset':
            return (0, $cZOfY.default).button;
        case 'security_wasnotme_reset':
            return (0, $cZOfY.default).button;
        default:
            return (0, $cZOfY.default).button;
    }
}
function $09d6ddfcbb6ea4b5$var$chooseAnalyticsEventName(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'suspiciousWasUser';
        case 'security_wasnotme_reset':
            return 'suspiciousWasNotUser';
        case 'change_email':
            return 'changeEmail';
        default:
            return 'userRequest';
    }
}
function $09d6ddfcbb6ea4b5$var$chooseChangePasswordType(message) {
    switch(message){
        case 'security_wasme_reset':
            return 'security-password-reset';
        case 'security_wasnotme_reset':
            return 'security-password-reset';
        default:
            return 'password-reset';
    }
}
const $09d6ddfcbb6ea4b5$var$pageId = 'setNewPasswordScreen';
async function $09d6ddfcbb6ea4b5$export$86843e04562221a8({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/changepassword/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-password'
        ]
    });
}
const $09d6ddfcbb6ea4b5$export$8ec0fb1e4323236d = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const email = (0, $kOqgB.useAppSelector)((state)=>state.changePassword.email);
    const displayName = (0, $kOqgB.useAppSelector)((state)=>state.changePassword.displayName);
    const isLoading = (0, $kOqgB.useAppSelector)((state)=>state.changePassword.isLoading);
    const error = (0, $kOqgB.useAppSelector)((state)=>state.changePassword.error);
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const intl = (0, $iSD9t.default)();
    const passwordFieldError = (0, $kOqgB.useAppSelector)((state)=>state.changePassword.fieldErrors.password);
    const translatedPasswordFieldError = (0, $97pBx.useTranslateFormErrorIfAvailable)(passwordFieldError);
    const location = (0, $5WDNl.useLocation)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const passwordInputRef = (0, $8ZuGG.useRef)(null);
    const query = (0, $8ZuGG.useMemo)(()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
    }, [
        location.search
    ]);
    (0, $3ir1n.usePageViewedEvent)($09d6ddfcbb6ea4b5$var$pageId, {
        origin: $09d6ddfcbb6ea4b5$var$chooseAnalyticsEventName(query.message)
    });
    (0, $8ZuGG.useEffect)(()=>{
        if (query.message && !$09d6ddfcbb6ea4b5$var$knownMessageKeys.includes(query.message)) (0, $8f2pb.captureErrorMessage)('change_password_missing_error_message', {
            key: query.message
        });
    }, [
        query.message
    ]);
    const renderPasswordChangeError = (error)=>{
        switch(error){
            case 'unknown':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.unknown",
                    defaultMessage: "Something went wrong while attempting to change your password. Please try again."
                });
            case 'request_error':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.request_error",
                    defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
                });
            case 'passwordLeaked':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changepassword.password.leaked.paragraph.xml",
                    defaultMessage: "<p>This password has appeared in an external data breach. To continue, enter another password. <learn-more-link>Learn more</learn-more-link></p>",
                    tagName: "p",
                    values: {
                        p: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                children: chunks
                            }),
                        'learn-more-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                                href: (0, $pO9YU.PASSWORD_LEAKED_LINK),
                                children: chunks
                            })
                    }
                });
            case 'passwordCommon':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordCommon",
                    defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
                });
            case 'invalidPassword':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.invalidPassword",
                    defaultMessage: "Invalid password"
                });
            case 'passwordCaseError':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordCaseError",
                    defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
                });
            case 'passwordDigitOrSpecialError':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordDigitOrSpecialError",
                    defaultMessage: "Your password must contain at least one digit or special character."
                });
            case 'passwordLengthError':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordLengthError",
                    defaultMessage: "Your password must be between 8 and 72 characters long."
                });
            case 'passwordUsedBefore':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordUsedBefore",
                    defaultMessage: "You've used that password before. Please choose a different one."
                });
            case 'passwordStrengthErrorWeak':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordStrengthErrorWeak",
                    defaultMessage: "Your password must have a minimum strength of weak."
                });
            case 'passwordStrengthErrorFair':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordStrengthErrorFair",
                    defaultMessage: "Your password must have a minimum strength of fair."
                });
            case 'passwordStrengthErrorGood':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordStrengthErrorGood",
                    defaultMessage: "Your password must have a minimum strength of good."
                });
            case 'passwordStrengthErrorStrong':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordStrengthErrorStrong",
                    defaultMessage: "Your password must have a minimum strength of strong."
                });
            case 'passwordStrengthErrorVeryStrong':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.error.passwordStrengthErrorVeryStrong",
                    defaultMessage: "Your password must have a minimum strength of very strong."
                });
            default:
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changePassword.form.random.error",
                    defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                    values: {
                        error: error
                    }
                });
        }
    };
    const renderWhiteboxFooter = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)("a", {
            id: "changepassword-selfservice-link",
            href: (0, $pO9YU.SELF_SERVICE_LINK_URL),
            onClick: ()=>analyticsClient.linkClickedEvent($09d6ddfcbb6ea4b5$var$pageId, 'stillHavingTroubleLogin'),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "changepassword.self.service",
                defaultMessage: "Still having trouble logging in?"
            })
        });
    };
    const renderFooter = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.SupportLink), {})
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                        isMobileLink: false
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                        isMobileLink: false
                    })
                })
            ]
        });
    };
    const handlePasswordChange = (0, $8ZuGG.useCallback)((e)=>{
        setPassword(e.currentTarget.value);
    }, [
        setPassword
    ]);
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const handleSubmit = (0, $8ZuGG.useCallback)((e)=>{
        e.preventDefault();
        const { signature: signature, message: message } = query;
        analyticsClient.buttonClickedEvent($09d6ddfcbb6ea4b5$var$pageId, 'continueToSetNewPassword', {
            origin: $09d6ddfcbb6ea4b5$var$chooseAnalyticsEventName(message)
        });
        dispatch((0, $6RoHK.requestChangePassword)({
            signature: signature || '',
            csrfToken: csrfToken,
            password: password,
            resetType: $09d6ddfcbb6ea4b5$var$chooseChangePasswordType(message),
            microbranding: (0, $kZj5j.getMicrobrandingFromUrl)(location),
            intl: intl,
            analyticsClient: analyticsClient
        }, navigate));
    }, [
        query,
        analyticsClient,
        dispatch,
        csrfToken,
        password,
        location,
        intl,
        navigate
    ]);
    const { formatMessage: formatMessage } = intl;
    const { message: message } = query;
    const title = formatMessage($09d6ddfcbb6ea4b5$var$chooseTitle(message));
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $09d6ddfcbb6ea4b5$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: title
        }),
        footer: renderFooter(),
        whiteboxFooter: renderWhiteboxFooter(),
        children: [
            (message === 'security_wasme_reset' || message === 'security_wasnotme_reset') && /*#__PURE__*/ (0, $6rcps.jsx)($09d6ddfcbb6ea4b5$var$SecurityContainer, {}),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage($09d6ddfcbb6ea4b5$var$chooseTitle(message))
            }),
            error && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.SectionError), {
                children: renderPasswordChangeError(error)
            }),
            message === 'security_wasme_reset' && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                id: "security-wasme-reset-message",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changepassword.security.wasme.reset.paragraph.xml",
                    defaultMessage: "<p>Thanks for helping us keep your account secure.</p><p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account:</p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            message === 'security_wasnotme_reset' && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                id: "security-wasnotme-reset-message",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "changepassword.security.wasnotme.reset.paragraph.xml",
                    defaultMessage: "<p>To prevent unauthorized access to your account, your password has been invalidated.</p><p>Create a new, unique password to access your account: </p><p-email>{email}</p-email>",
                    values: {
                        email: email,
                        p: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                children: chunks
                            }),
                        'p-email': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                },
                                children: /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                    children: chunks
                                })
                            })
                    }
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($09d6ddfcbb6ea4b5$var$Form, {
                autoComplete: "on",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8PH8E.default), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $4JKmU.default), {
                                id: "password",
                                testId: "password" // used in pollinators
                                ,
                                name: "password",
                                autoComplete: "new-password",
                                "aria-describedby": (0, $idats.passwordStrengthMessageId),
                                placeholder: formatMessage((0, $cZOfY.default).passwordPlaceholder),
                                label: formatMessage((0, $cZOfY.default).passwordLabel),
                                isInvalid: !!translatedPasswordFieldError,
                                invalidMessage: translatedPasswordFieldError,
                                onChange: handlePasswordChange,
                                value: password,
                                ref: passwordInputRef,
                                smallPlaceholder: true
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $idats.PasswordStrengthMeter), {
                                password: password,
                                email: email,
                                displayName: displayName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        appearance: "primary",
                        id: "change-password",
                        type: "submit",
                        isFullWidth: true,
                        isLoading: isLoading,
                        children: formatMessage($09d6ddfcbb6ea4b5$var$chooseButtonText(message))
                    })
                ]
            })
        ]
    });
};
var $09d6ddfcbb6ea4b5$export$2e2bcd8739ae039 = $09d6ddfcbb6ea4b5$export$8ec0fb1e4323236d;

});
parcelRegister("cZOfY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbd6db399ac89d7b$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $dbd6db399ac89d7b$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    title: {
        id: 'changepassword.title',
        defaultMessage: 'Choose a new password'
    },
    button: {
        id: 'changepassword.button',
        defaultMessage: 'Continue'
    },
    passwordPlaceholder: {
        id: 'changepassword.password.placeholder',
        defaultMessage: 'Enter new password'
    },
    passwordLabel: {
        id: 'changepassword.password.label',
        defaultMessage: 'Password'
    },
    errorMessage: {
        id: 'changepassword.error.message',
        defaultMessage: 'Something went wrong while attempting to change your password. Please try again.'
    },
    emptyPasswordErrorMessage: {
        id: 'changepassword.error.password.empty.message',
        defaultMessage: 'Please enter a password'
    },
    securityResetTitle: {
        id: 'changepassword.security.reset.title',
        defaultMessage: 'Reset your password'
    }
});

});

parcelRegister("4JKmU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $313c97699a59d9ce$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $dZRKj = parcelRequire("dZRKj");

var $9Vz68 = parcelRequire("9Vz68");

var $bn3V9 = parcelRequire("bn3V9");

var $buB7W = parcelRequire("buB7W");

var $1fdMd = parcelRequire("1fdMd");

var $iSD9t = parcelRequire("iSD9t");
let $313c97699a59d9ce$var$_ = (t)=>t, $313c97699a59d9ce$var$t, $313c97699a59d9ce$var$t1;
const $313c97699a59d9ce$export$d25f95f50a0dfdf9 = (0, $9Vz68.default).div($313c97699a59d9ce$var$t || ($313c97699a59d9ce$var$t = $313c97699a59d9ce$var$_`
  padding: 3px;
  margin-left: -1px;
`));
const $313c97699a59d9ce$var$StyledDiv = (0, $9Vz68.default).div($313c97699a59d9ce$var$t1 || ($313c97699a59d9ce$var$t1 = $313c97699a59d9ce$var$_`
  input {
    ${0}
  }
`), (props)=>props.smallPlaceholder && 'font-size: 14px !important;');
const $313c97699a59d9ce$var$PasswordField = (props, ref)=>{
    const inputRef = (0, $8ZuGG.useRef)(null);
    const [type, setType] = (0, $8ZuGG.useState)('password');
    (0, $8ZuGG.useImperativeHandle)(ref, ()=>inputRef.current, []);
    const handleVisibilityToggle = ()=>{
        var _inputRef_current;
        setType(type === 'password' ? 'text' : 'password');
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    };
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    return /*#__PURE__*/ (0, $6rcps.jsx)("div", {
        children: /*#__PURE__*/ (0, $6rcps.jsx)($313c97699a59d9ce$var$StyledDiv, {
            smallPlaceholder: props.smallPlaceholder,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), (0, $6EnDC._)((0, $ty6PY._)({}, props), {
                type: type,
                autoComplete: type === 'password' ? props.autoComplete || 'off' : 'off',
                spellCheck: false,
                ref: inputRef,
                elemAfterInput: /*#__PURE__*/ (0, $6rcps.jsx)($313c97699a59d9ce$export$d25f95f50a0dfdf9, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1fdMd.default), {
                        appearance: "subtle",
                        icon: type === 'text' ? (0, (/*@__PURE__*/$parcel$interopDefault($buB7W))) : (0, (/*@__PURE__*/$parcel$interopDefault($bn3V9))),
                        label: type === 'text' ? formatMessage({
                            id: 'password.field.password.hide',
                            defaultMessage: 'Hide password'
                        }) : formatMessage({
                            id: 'password.field.password.show',
                            defaultMessage: 'Show password'
                        }),
                        onClick: handleVisibilityToggle
                    })
                })
            }))
        })
    });
};
var $313c97699a59d9ce$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef($313c97699a59d9ce$var$PasswordField);

});
parcelRegister("bn3V9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8474e24d0f16bad6$var$_react = $8474e24d0f16bad6$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $8474e24d0f16bad6$var$_eyeOpen = $8474e24d0f16bad6$var$_interopRequireDefault((parcelRequire("bPm2r")));
function $8474e24d0f16bad6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8474e24d0f16bad6$var$WatchIcon = (props)=>/*#__PURE__*/ $8474e24d0f16bad6$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.978 13.984c-1.104 0-2-.897-2-2s.896-2 2-2c1.103 0 2 .897 2 2s-.897 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.793 4 4 4 4-1.794 4-4-1.794-4-4-4"/></g></svg>`
    }, props, {
        newIcon: $8474e24d0f16bad6$var$_eyeOpen.default
    }));
$8474e24d0f16bad6$var$WatchIcon.displayName = 'WatchIcon';
var $8474e24d0f16bad6$var$_default = module.exports.default = $8474e24d0f16bad6$var$WatchIcon;

});
parcelRegister("bPm2r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89c58d7c93da1c2d$var$_react = $89c58d7c93da1c2d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $89c58d7c93da1c2d$var$_baseNew = $89c58d7c93da1c2d$var$_interopRequireDefault((parcelRequire("d9We0")));
function $89c58d7c93da1c2d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $89c58d7c93da1c2d$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $89c58d7c93da1c2d$var$_react.default.createElement($89c58d7c93da1c2d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$89c58d7c93da1c2d$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $89c58d7c93da1c2d$var$_default = module.exports.default = $89c58d7c93da1c2d$var$EyeOpenIcon;

});


parcelRegister("buB7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85df4bb4124a8c11$var$_react = $85df4bb4124a8c11$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $85df4bb4124a8c11$var$_eyeOpenFilled = $85df4bb4124a8c11$var$_interopRequireDefault((parcelRequire("41cSg")));
function $85df4bb4124a8c11$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85df4bb4124a8c11$var$WatchFilledIcon = (props)=>/*#__PURE__*/ $85df4bb4124a8c11$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.983 15.984a4.005 4.005 0 0 1-4.002-4c0-2.206 1.795-4 4.002-4a4.005 4.005 0 0 1 4.002 4c0 2.206-1.795 4-4.002 4M12 4C6.48 4 2 8.84 2 12c0 3.086 4.577 8 10 8s10-4.914 10-8c0-3.16-4.481-8-10-8"/><circle cx="12" cy="12" r="2"/></g></svg>`
    }, props, {
        newIcon: $85df4bb4124a8c11$var$_eyeOpenFilled.default
    }));
$85df4bb4124a8c11$var$WatchFilledIcon.displayName = 'WatchFilledIcon';
var $85df4bb4124a8c11$var$_default = module.exports.default = $85df4bb4124a8c11$var$WatchFilledIcon;

});
parcelRegister("41cSg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::895be44c60961cd5e7ff3bf0ce94ca85>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ed13dfd364da0fb$var$_react = $2ed13dfd364da0fb$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $2ed13dfd364da0fb$var$_baseNew = $2ed13dfd364da0fb$var$_interopRequireDefault((parcelRequire("d9We0")));
function $2ed13dfd364da0fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpenFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watched pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ed13dfd364da0fb$var$EyeOpenFilledIcon = (props)=>/*#__PURE__*/ $2ed13dfd364da0fb$var$_react.default.createElement($2ed13dfd364da0fb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M8 2C4.433 2 1.319 4.232.167 7.38c-.146.4-.146.84 0 1.24C1.32 11.768 4.433 14 8 14c3.566 0 6.681-2.232 7.833-5.38.146-.4.146-.84 0-1.24C14.68 4.232 11.566 2 8 2m0 2.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5" clip-rule="evenodd"/>`
    }, props));
$2ed13dfd364da0fb$var$EyeOpenFilledIcon.displayName = 'EyeOpenFilledIcon';
var $2ed13dfd364da0fb$var$_default = module.exports.default = $2ed13dfd364da0fb$var$EyeOpenFilledIcon;

});



parcelRegister("idats", function(module, exports) {

$parcel$export(module.exports, "passwordStrengthMessageId", function () { return $ef004fa0c55abdde$export$2609c3dd954de874; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return $ef004fa0c55abdde$export$eebfb7c0549090; });
/* PasswordStrengthMeter.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $6rcps = parcelRequire("6rcps");

var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");

var $7mhBV = parcelRequire("7mhBV");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9aU91 = parcelRequire("9aU91");

var $73a5X = parcelRequire("73a5X");

var $6m9zh = parcelRequire("6m9zh");
var $brQ4n = parcelRequire("brQ4n");
let $ef004fa0c55abdde$var$_ = (t)=>t, $ef004fa0c55abdde$var$t, $ef004fa0c55abdde$var$t1, $ef004fa0c55abdde$var$t2;
const $ef004fa0c55abdde$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $ef004fa0c55abdde$var$Wrapper = (0, $9Vz68.default).div($ef004fa0c55abdde$var$t || ($ef004fa0c55abdde$var$t = $ef004fa0c55abdde$var$_`
  margin-bottom: ${0};
`), "var(--ds-space-100, 8px)");
const $ef004fa0c55abdde$var$textStyles = null;
const $ef004fa0c55abdde$export$2609c3dd954de874 = 'password-strength-meter';
const $ef004fa0c55abdde$var$Bar = (0, $9Vz68.default).div($ef004fa0c55abdde$var$t1 || ($ef004fa0c55abdde$var$t1 = $ef004fa0c55abdde$var$_`
  background: ${0};
  height: 2px;
  margin-top: 5px;
  position: relative;

  &::before {
    background: ${0};
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${0};
  }
`), "var(--ds-border, #091E4224)", (props)=>props.score === null ? "var(--ds-border, #091E4224)" : $ef004fa0c55abdde$var$barColours[props.score], (props)=>props.score === null ? 0 : $ef004fa0c55abdde$var$barWidths[props.score]);
const $ef004fa0c55abdde$var$barColours = [
    "var(--ds-border, #091E4224)",
    (0, $kTdw7).R500,
    (0, $kTdw7).R300,
    (0, $kTdw7).Y300,
    (0, $kTdw7).G300,
    (0, $kTdw7).G400
];
const $ef004fa0c55abdde$var$Container = (props)=>/*#__PURE__*/ (0, $6rcps.jsx)($ef004fa0c55abdde$var$Wrapper, {
        children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6m9zh.default), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($ef004fa0c55abdde$var$Bar, {
                    score: props.score,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)($ef004fa0c55abdde$var$Dividers, {})
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                    role: "status",
                    children: props.title && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6m9zh.default), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $73a5X.default), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "password.strength.accessibility.hint",
                                    defaultMessage: "Password strength: ",
                                    description: "Text that precedes the password strength hint. Hidden except for screen reader users."
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)("span", {
                                id: $ef004fa0c55abdde$export$2609c3dd954de874,
                                className: (0, $c4hjl.default)([
                                    "_y3gn1h6o _p0ov18aq"
                                ]),
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $brQ4n.default), {
                                    size: "small",
                                    color: "color.text.subtlest",
                                    align: "center",
                                    children: props.title
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
const $ef004fa0c55abdde$var$Dividers = (0, $9Vz68.default).span($ef004fa0c55abdde$var$t2 || ($ef004fa0c55abdde$var$t2 = $ef004fa0c55abdde$var$_`
  border-left: 5px solid #fff;
  border-right: 5px solid #fff;
  bottom: 0;
  left: 19%;
  position: absolute;
  right: 19%;
  top: 0;

  &::after {
    border-left: 5px solid #fff;
    border-right: 5px solid #fff;
    bottom: 0;
    content: '';
    left: 30%;
    position: absolute;
    right: 30%;
    top: 0;
  }
`));
const $ef004fa0c55abdde$export$eebfb7c0549090 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const strengthLevelMessages = (0, $8ZuGG.useMemo)(()=>i18nLevels || [
            (0, $7mhBV.default).passwordStrengthMinimumRequirement,
            (0, $7mhBV.default).passwordStrengthLevel1,
            (0, $7mhBV.default).passwordStrengthLevel2,
            (0, $7mhBV.default).passwordStrengthLevel3,
            (0, $7mhBV.default).passwordStrengthLevel4,
            (0, $7mhBV.default).passwordStrengthLevel5
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || formatMessage((0, $7mhBV.default).passwordStrengthMinimumRequirement);
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $7mhBV.default).passwordStrengthUnavailable);
    const { score: score } = (0, $9aU91.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password) return noValueMessage;
        else if (password.length < 8) return strengthLevelMessages[0];
        else if (password === email) return formatMessage((0, $7mhBV.default).passwordStrengthCantMatchEmail);
        else if (password === displayName) return formatMessage((0, $7mhBV.default).passwordStrengthCantMatchDisplayName);
        else if ((0, $9aU91.atlassianKeywords).includes(password)) return formatMessage((0, $7mhBV.default).passwordStrengthCantMatchAtlassianKeyword);
        else return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)($ef004fa0c55abdde$var$Container, {
        title: getStrengthText(),
        score: score
    });
};

});
parcelRegister("7mhBV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f00d4649d3dd074$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $6f00d4649d3dd074$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    passwordStrengthAccessibilityHint: {
        id: 'password.strength.accessibility.hint',
        defaultMessage: 'Password strength:'
    },
    passwordStrengthMinimumRequirement: {
        id: 'password.strength.level.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    },
    passwordStrengthLevel1: {
        id: 'password.strength.level.1',
        defaultMessage: 'Weak'
    },
    passwordStrengthLevel2: {
        id: 'password.strength.level.2',
        defaultMessage: 'Fair'
    },
    passwordStrengthLevel3: {
        id: 'password.strength.level.3',
        defaultMessage: 'Good'
    },
    passwordStrengthLevel4: {
        id: 'password.strength.level.4',
        defaultMessage: 'Strong'
    },
    passwordStrengthLevel5: {
        id: 'password.strength.level.5',
        defaultMessage: 'Very strong'
    },
    passwordStrengthUnavailable: {
        id: 'password.strength.unavailable',
        defaultMessage: 'Password strength unavailable'
    },
    passwordStrengthCantMatchEmail: {
        id: 'password.strength.cant.match.email',
        defaultMessage: "Password can't match email address"
    },
    passwordStrengthCantMatchDisplayName: {
        id: 'password.strength.cant.match.display.name',
        defaultMessage: "Password can't match display name"
    },
    passwordStrengthCantMatchAtlassianKeyword: {
        id: 'password.strength.cant.match.atlassian.keyword',
        defaultMessage: "Password can't match Atlassian keyword"
    },
    weakPasswordAdvice: {
        id: 'password.strength.weak.advice',
        defaultMessage: 'Avoid common phrases or try adding more characters',
        description: 'Advice given to users when their password is weak'
    },
    weakPassword: {
        id: 'password.strength.weak',
        defaultMessage: 'Weak password',
        description: "Message shown below a user's password entry to indicate it is weak"
    },
    fairPassword: {
        id: 'password.strength.fair',
        defaultMessage: 'Fair password',
        description: "Message shown below a user's password entry to indicate it is a fair strength"
    },
    goodPassword: {
        id: 'password.strength.good',
        defaultMessage: 'Good password',
        description: "Message shown below a user's password entry to indicate it is a good strength"
    },
    strongPassword: {
        id: 'password.strength.strong',
        defaultMessage: 'Strong password',
        description: "Message shown below a user's password entry to indicate it is strong"
    },
    veryStrongPassword: {
        id: 'password.strength.veryStrong',
        defaultMessage: 'Very strong password',
        description: "Message shown below a user's password entry to indicate it is very strong"
    }
});

});

parcelRegister("9aU91", function(module, exports) {

$parcel$export(module.exports, "atlassianKeywords", function () { return $56c5b335d0fcc862$export$d1feeaf01c705d52; });
$parcel$export(module.exports, "usePasswordScore", function () { return $56c5b335d0fcc862$export$d135f8f04a83150a; });
/* usePasswordScore.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3ZIfq = parcelRequire("3ZIfq");
const $56c5b335d0fcc862$var$SPLITTER = /\W+/;
const $56c5b335d0fcc862$export$d1feeaf01c705d52 = [
    'atlassian',
    'bitbucket',
    'confluence',
    'jira',
    'opsgenie',
    'statuspage',
    'trello'
];
const $56c5b335d0fcc862$export$d135f8f04a83150a = ({ displayName: displayName, email: email, password: password })=>{
    const zxcvbn = (0, $3ZIfq.useZxcvbn)();
    const scoreWords = (0, $8ZuGG.useMemo)(()=>{
        return $56c5b335d0fcc862$export$9e2ea7bf181a4f5([
            email,
            displayName,
            ...$56c5b335d0fcc862$export$d1feeaf01c705d52
        ]);
    }, [
        displayName,
        email
    ]);
    const zxcvbnResult = (0, $8ZuGG.useMemo)(()=>{
        return zxcvbn && password ? zxcvbn(password, scoreWords) : null;
    }, [
        zxcvbn,
        password,
        scoreWords
    ]);
    const score = (0, $8ZuGG.useMemo)(()=>{
        if (password.length < 8 || [
            email,
            displayName,
            ...$56c5b335d0fcc862$export$d1feeaf01c705d52
        ].includes(password)) return 0;
        else {
            const baseScore = zxcvbnResult === null || zxcvbnResult === void 0 ? void 0 : zxcvbnResult.score;
            return typeof baseScore === 'number' ? baseScore + 1 : null;
        }
    }, [
        password,
        displayName,
        email,
        zxcvbnResult
    ]);
    return {
        score: score
    };
};
const $56c5b335d0fcc862$var$addUnique = (seen, chunk)=>seen.includes(chunk) ? seen : [
        ...seen,
        chunk
    ];
function $56c5b335d0fcc862$export$9e2ea7bf181a4f5(strings) {
    const deduped = strings.reduce($56c5b335d0fcc862$var$addUnique, []);
    return deduped.reduce((arr, str)=>str.split($56c5b335d0fcc862$var$SPLITTER).reduce($56c5b335d0fcc862$var$addUnique, arr), deduped);
}

});
parcelRegister("3ZIfq", function(module, exports) {

$parcel$export(module.exports, "useZxcvbn", function () { return $18ec3f9bb61f819c$export$edb73e506c7a3f1d; });

var $8ZuGG = parcelRequire("8ZuGG");

var $8f2pb = parcelRequire("8f2pb");

function $18ec3f9bb61f819c$export$edb73e506c7a3f1d() {
    const [zxcvbn, setZxcvbn] = (0, $8ZuGG.useState)();
    (0, $8ZuGG.useEffect)(()=>{
        let isMounted = true;
        // asynchronously imported as package is very large
        (parcelRequire("tweWq")).then((zxcvbn)=>{
            if (isMounted) setZxcvbn(()=>{
                /**
             * We have this divergence since we use Webpack for Jest testing and Parcel for dev/prod.
             * Webpack dynamic import returns: { default: fn }
             * Parcel dynamic import returns: fn
             * Why can't we use Parcel for Jest? See: https://parceljs.org/languages/javascript/#usage-with-other-tools
             */ return typeof zxcvbn === 'function' ? zxcvbn : zxcvbn.default;
            });
        }).catch((e)=>{
            (0, $8f2pb.captureErrorMessage)('Error while importing zxcvbn library', e);
            setZxcvbn(undefined);
        });
        return ()=>{
            isMounted = false;
        };
    }, []);
    return zxcvbn;
}

});
parcelRegister("tweWq", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hap0O")).then(()=>parcelRequire('6ReJk'));

});



parcelRegister("6m9zh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a0c382884211ef8$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $57fzU = parcelRequire("57fzU");

var $ld7ev = parcelRequire("ld7ev");
var $4a0c382884211ef8$var$flexGrowMap = {
    hug: (0, $57fzU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $57fzU.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $4a0c382884211ef8$var$Stack = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? 'stretch' : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role, id = _ref.id;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $4a0c382884211ef8$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $bl8w7.jsx)((0, $ld7ev.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4a0c382884211ef8$var$Stack.displayName = 'Stack';
var $4a0c382884211ef8$export$2e2bcd8739ae039 = $4a0c382884211ef8$var$Stack;

});

parcelRegister("brQ4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $855a9b45daf7e771$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $1RZ27 = parcelRequire("1RZ27");

var $209ZD = parcelRequire("209ZD");

var $bmth4 = parcelRequire("bmth4");

var $1S0T5 = parcelRequire("1S0T5");
var $855a9b45daf7e771$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
var $855a9b45daf7e771$var$resetStyles = (0, $bl8w7.css)({
    margin: 0,
    overflowWrap: 'anywhere'
});
var $855a9b45daf7e771$var$strongStyles = (0, $bl8w7.css)({
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
var $855a9b45daf7e771$var$emStyles = (0, $bl8w7.css)({
    fontStyle: 'italic'
});
var $855a9b45daf7e771$var$textAlignMap = {
    center: (0, $bl8w7.css)({
        textAlign: 'center'
    }),
    end: (0, $bl8w7.css)({
        textAlign: 'end'
    }),
    start: (0, $bl8w7.css)({
        textAlign: 'start'
    })
};
var $855a9b45daf7e771$var$truncationStyles = (0, $bl8w7.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
var $855a9b45daf7e771$var$wordBreakMap = {
    breakAll: (0, $bl8w7.css)({
        wordBreak: 'break-all'
    })
};
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ var $855a9b45daf7e771$var$useColor = function useColor(colorProp, hasTextAncestor) {
    var surface = (0, $bmth4.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $1S0T5.inverseColorMap).hasOwnProperty(surface)) return (0, $1S0T5.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ var $855a9b45daf7e771$var$Text = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'span' : _ref$as, colorProp = _ref.color, align = _ref.align, testId = _ref.testId, id = _ref.id, size = _ref.size, weight = _ref.weight, maxLines = _ref.maxLines, children = _ref.children;
    (0, $1RZ27.default)($855a9b45daf7e771$var$asAllowlist.includes(Component), "@atlaskit/primitives: Text received an invalid \"as\" value of \"".concat(Component, "\""));
    var hasTextAncestor = (0, $209ZD.useHasTextAncestor)();
    var color = $855a9b45daf7e771$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    var component = (0, $bl8w7.jsx)(Component, {
        ref: ref,
        css: [
            $855a9b45daf7e771$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $1S0T5.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $1S0T5.textColorStylesMap)[color],
            maxLines && $855a9b45daf7e771$var$truncationStyles,
            maxLines === 1 && $855a9b45daf7e771$var$wordBreakMap.breakAll,
            align && $855a9b45daf7e771$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $1S0T5.textWeightStylesMap)[weight],
            Component === 'em' && $855a9b45daf7e771$var$emStyles,
            Component === 'strong' && $855a9b45daf7e771$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $bl8w7.jsx)((0, $209ZD.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $855a9b45daf7e771$export$2e2bcd8739ae039 = $855a9b45daf7e771$var$Text;

});


parcelRegister("6RoHK", function(module, exports) {

$parcel$export(module.exports, "requestChangePassword", function () { return $f8fd7ded18ebbb06$export$5f18b9a6eb1df9f8; });

var $jSnDV = parcelRequire("jSnDV");

var $imnta = parcelRequire("imnta");

var $cZOfY = parcelRequire("cZOfY");

var $8f2pb = parcelRequire("8f2pb");
const $f8fd7ded18ebbb06$export$b7b281ad44bfa6c7 = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_INITIATE'
    });
const $f8fd7ded18ebbb06$export$592a066e988f52df = ()=>({
        type: 'CHANGE_PASSWORD_REQUEST_SUCCESS'
    });
const $f8fd7ded18ebbb06$export$a60289eb7ee45981 = (error)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FAILED',
        error: error
    });
const $f8fd7ded18ebbb06$export$ff1769767bfc512b = (fieldErrors)=>({
        type: 'CHANGE_PASSWORD_REQUEST_FIELD_ERRORS',
        fieldErrors: fieldErrors
    });
const $f8fd7ded18ebbb06$export$5f18b9a6eb1df9f8 = (requestParams, navigate)=>(dispatch)=>{
        const changePasswordAnalyticsError = {
            passwordCaseError: 'passwordResetDoesntMeetPolicy',
            passwordDigitOrSpecialError: 'passwordResetDoesntMeetPolicy',
            passwordLengthError: 'passwordResetDoesntMeetPolicy',
            passwordUsedBefore: 'passwordResetPreviouslyUsed',
            passwordLeaked: 'passwordLeaked',
            passwordCommon: 'passwordCommon',
            invalidPassword: 'invalidPassword',
            unexpectedError: 'passwordResetUnexpectedError',
            passwordStrengthErrorWeak: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorFair: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorGood: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorStrong: 'passwordResetDoesntMeetPolicy',
            passwordStrengthErrorVeryStrong: 'passwordResetDoesntMeetPolicy'
        };
        const { signature: signature, password: password, resetType: resetType, csrfToken: csrfToken, microbranding: microbranding, intl: intl, analyticsClient: analyticsClient } = requestParams;
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(microbranding)}` : '';
        dispatch($f8fd7ded18ebbb06$export$b7b281ad44bfa6c7());
        if (!password) {
            const message = intl.formatMessage((0, $cZOfY.default).emptyPasswordErrorMessage);
            dispatch($f8fd7ded18ebbb06$export$ff1769767bfc512b({
                password: message
            }));
            return Promise.resolve();
        }
        const request = {
            password: password,
            resetType: resetType,
            signature: signature
        };
        return fetch(`/rest/changepassword${qs}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            if (response.redirectTo !== undefined) {
                dispatch($f8fd7ded18ebbb06$export$592a066e988f52df());
                navigate(response.redirectTo);
            } else {
                const { csrfToken: csrfToken, uiErrors: uiErrors, fieldErrors: fieldErrors } = response;
                // SIS doesn't set a new CSRF token on every request (like aid-signup does), and so it
                // doesn't return one. We need to handle both cases though.
                if (csrfToken) dispatch((0, $imnta.updateCsrfToken)(csrfToken));
                if (uiErrors && uiErrors.length) {
                    const subjectId = changePasswordAnalyticsError[uiErrors[0].key] || 'passwordResetUnknownUiError';
                    analyticsClient.errorShownEvent('accountRecoveryScreen', subjectId);
                    dispatch($f8fd7ded18ebbb06$export$a60289eb7ee45981(uiErrors[0].key));
                }
                if (Object.entries(fieldErrors).length) dispatch($f8fd7ded18ebbb06$export$ff1769767bfc512b(fieldErrors));
            }
        }).catch((error)=>{
            dispatch($f8fd7ded18ebbb06$export$a60289eb7ee45981('unknown'));
            (0, $8f2pb.captureErrorMessage)('Change password failed', error);
        });
    };

});

parcelRegister("lp6gZ", function(module, exports) {

$parcel$export(module.exports, "FormErrorWrapper", function () { return $42694174d473e344$export$21ea266f0fa7d7c3; });
$parcel$export(module.exports, "default", function () { return $42694174d473e344$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "SectionError", function () { return $42694174d473e344$export$1142f7f46d50535e; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $jHLOy = parcelRequire("jHLOy");
let $42694174d473e344$var$_ = (t)=>t, $42694174d473e344$var$t, $42694174d473e344$var$t1;
const $42694174d473e344$export$21ea266f0fa7d7c3 = (0, $9Vz68.default).div($42694174d473e344$var$t || ($42694174d473e344$var$t = $42694174d473e344$var$_`
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $42694174d473e344$var$SectionErrorWrapper = (0, $9Vz68.default).div($42694174d473e344$var$t1 || ($42694174d473e344$var$t1 = $42694174d473e344$var$_`
  margin-top: ${0}px;
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)());
function $42694174d473e344$export$2e2bcd8739ae039({ testId: testId, title: title, children: children, appearance: appearance = 'warning' }) {
    return children ? /*#__PURE__*/ (0, $6rcps.jsx)($42694174d473e344$export$21ea266f0fa7d7c3, {
        role: "alert",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
            testId: testId || 'form-error',
            appearance: appearance,
            title: title,
            children: children
        })
    }) : null;
}
function $42694174d473e344$export$1142f7f46d50535e({ id: id, testId: testId, title: title, children: children }) {
    return children ? /*#__PURE__*/ (0, $6rcps.jsx)($42694174d473e344$var$SectionErrorWrapper, {
        id: id,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
            testId: testId || 'form-error',
            appearance: "warning",
            title: title,
            children: children
        })
    }) : null;
}

});

parcelRegister("97pBx", function(module, exports) {

$parcel$export(module.exports, "useTranslateFormErrorIfAvailable", function () { return $a7f685877ccb31d1$export$61b698e3c147347c; });

var $3VrrU = parcelRequire("3VrrU");
var $iSD9t = parcelRequire("iSD9t");

var $8ZuGG = parcelRequire("8ZuGG");
const $a7f685877ccb31d1$export$61b698e3c147347c = (formError)=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const message = (0, $8ZuGG.useMemo)(()=>Object.values($a7f685877ccb31d1$var$formValidationMessages).find(({ id: id })=>id === formError), [
        formError
    ]);
    if (message) return formatMessage(message);
    else return formError;
};
const $a7f685877ccb31d1$var$formValidationMessages = (0, $3VrrU.defineMessages)({
    unknownError: {
        id: 'com.atlassian.profile.unknownError',
        defaultMessage: 'An unknown error occurred'
    },
    errorRequiredField: {
        id: 'error.required',
        defaultMessage: 'This field is required'
    },
    loginFormNoPassword: {
        id: 'login.form.no.password',
        defaultMessage: 'Enter your password'
    },
    loginFormPasswordTooLong: {
        id: 'login.form.password.too.long',
        defaultMessage: 'Password length capped at 100 characters'
    },
    loginFormPasswordTooShort: {
        id: 'login.form.password.too.short',
        defaultMessage: 'The password is too short.'
    },
    resetPasswordGenericError: {
        id: 'resetPassword.error',
        defaultMessage: 'An error occurred while attempting to reset your password.'
    },
    resetPasswordEmailFormatError: {
        id: 'requestPasswordReset.email.format.error',
        defaultMessage: 'Please enter a valid email address'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support.'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});


parcelRegister("gjxi0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $a7b090696def91b6$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "socialRecoveryLoader", function () { return $a7b090696def91b6$export$5e59ec17884bc552; });
$parcel$export(module.exports, "SocialLoginRecoveryPage", function () { return $a7b090696def91b6$export$ee564d35600efee8; });
$parcel$export(module.exports, "default", function () { return $a7b090696def91b6$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $jSnDV = parcelRequire("jSnDV");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $kZj5j = parcelRequire("kZj5j");

var $7CMue = parcelRequire("7CMue");

var $HBurV = parcelRequire("HBurV");

var $24Vx8 = parcelRequire("24Vx8");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $day6I = parcelRequire("day6I");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $9NVnN = parcelRequire("9NVnN");
let $a7b090696def91b6$var$_ = (t)=>t, $a7b090696def91b6$var$t, $a7b090696def91b6$var$t1, $a7b090696def91b6$var$t2, $a7b090696def91b6$var$t3;
const $a7b090696def91b6$var$Image = (0, $9Vz68.default).img($a7b090696def91b6$var$t || ($a7b090696def91b6$var$t = $a7b090696def91b6$var$_`
  margin: ${0}px auto ${0}px;
  width: 100px;
`), (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)());
const $a7b090696def91b6$var$Messsage = (0, $9Vz68.default).div($a7b090696def91b6$var$t1 || ($a7b090696def91b6$var$t1 = $a7b090696def91b6$var$_`
  margin-top: ${0}px;
  overflow-wrap: break-word;
`), (0, $5b7Z4.gridSize)());
const $a7b090696def91b6$var$ErrorMesssage = (0, $9Vz68.default)($a7b090696def91b6$var$Messsage)($a7b090696def91b6$var$t2 || ($a7b090696def91b6$var$t2 = $a7b090696def91b6$var$_`
  text-align: center;
`));
const $a7b090696def91b6$var$ExpectedEmailWrapper = (0, $9Vz68.default).div($a7b090696def91b6$var$t3 || ($a7b090696def91b6$var$t3 = $a7b090696def91b6$var$_`
  margin-top: ${0}px;
  font-weight: bold;
`), (0, $5b7Z4.gridSize)() * 0.75);
const $a7b090696def91b6$export$703ba2e7ea526c1b = 'atlassianAccountSocialLoginRecoveryScreen';
async function $a7b090696def91b6$export$5e59ec17884bc552({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/social/recovery/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $a7b090696def91b6$export$ee564d35600efee8 = ()=>{
    const product = (0, $8ZuGG.useMemo)(()=>{
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
        return queryParams.application && (0, $kZj5j.applications)[queryParams.application];
    }, []);
    const { error: error, expectedEmail: expectedEmail, foundEmail: foundEmail, recoveryUrl: recoveryUrl } = (0, $kOqgB.useAppSelector)((state)=>state.socialLoginRecovery);
    const isMobileApp = (0, $kOqgB.useAppSelector)((state)=>(0, $day6I.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $3ir1n.usePageViewedEvent)($a7b090696def91b6$export$703ba2e7ea526c1b, error && {
        errorCode: error
    });
    (0, $8xW40.usePageStateLoader)();
    const recover = (recoveryUrl)=>{
        analyticsClient.buttonClickedEvent($a7b090696def91b6$export$703ba2e7ea526c1b, 'tryAgainButton');
        navigate(recoveryUrl.toString());
    };
    const renderWhiteboxFooter = ()=>{
        return isMobileApp ? null : /*#__PURE__*/ (0, $6rcps.jsx)("a", {
            id: "social-login-recovery-documentation-link",
            target: "_blank",
            rel: "noreferrer noopener",
            onClick: ()=>analyticsClient.linkClickedEvent($a7b090696def91b6$export$703ba2e7ea526c1b, 'documentationLink'),
            href: "https://support.atlassian.com/atlassian-account/docs/login-issues-related-to-an-incorrect-email-address-error/",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $24Vx8.default).documentationLinkMessage))
        });
    };
    const renderRecoveryPage = (recoveryUrl, expectedEmail, foundEmail)=>{
        const destinationProduct = product ? product.name : formatMessage((0, $24Vx8.default).productFallback);
        return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
            pageId: $a7b090696def91b6$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $24Vx8.default).title), {
                tagName: "h5"
            })),
            whiteboxFooter: renderWhiteboxFooter(),
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($a7b090696def91b6$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)($a7b090696def91b6$var$Messsage, {
                    children: foundEmail ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $24Vx8.default).bodyMessageUnableToLoginWithFoundEmail), {
                        values: {
                            product: destinationProduct,
                            foundEmail: foundEmail
                        }
                    })) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $24Vx8.default).bodyMessageUnableToLoginWithThisEmailAddress), {
                        values: {
                            product: destinationProduct
                        }
                    }))
                }),
                /*#__PURE__*/ (0, $6rcps.jsxs)($a7b090696def91b6$var$Messsage, {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "social.recovery.body.try.again",
                            defaultMessage: "To continue, select <b>Try again</b> and use",
                            description: `Message instructing the user that they logged in via a social
          provider (eg. Log in with Google) and selected an account that we didn't expect.
          This occurs when we know that we want the user to log in with myemail@gmail.com, but
          in the social provider they log in with otheraccount@gmail.com. They should press the Try again button and use the expected email address.`,
                            values: {
                                b: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                        children: chunks
                                    })
                            }
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)($a7b090696def91b6$var$ExpectedEmailWrapper, {
                            children: expectedEmail
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        appearance: "primary",
                        id: "recovery-button",
                        isFullWidth: true,
                        onClick: ()=>recover(recoveryUrl),
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $24Vx8.default).buttonText))
                    })
                })
            ]
        });
    };
    const renderRecoveryError = (error)=>{
        const errorMessage = ()=>{
            switch(error){
                case 'expired_token':
                    return (0, $24Vx8.default).expiredTokenErrorMessage;
                case 'future_issued_token':
                case 'invalid_token':
                    return (0, $24Vx8.default).tokenErrorMessage;
                default:
                    return (0, $24Vx8.default).unknownErrorMessage;
            }
        };
        return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
            pageId: $a7b090696def91b6$export$703ba2e7ea526c1b,
            header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $24Vx8.default).errorTitle), {
                tagName: "h5"
            })),
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($a7b090696def91b6$var$Image, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    alt: ""
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)($a7b090696def91b6$var$ErrorMesssage, {
                    "data-testid": "default-error-message",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, errorMessage()))
                })
            ]
        });
    };
    if (expectedEmail && recoveryUrl) return renderRecoveryPage(recoveryUrl, expectedEmail, foundEmail);
    else if (error) return renderRecoveryError(error);
    else return renderRecoveryError('unknown_error');
};
var $a7b090696def91b6$export$2e2bcd8739ae039 = $a7b090696def91b6$export$ee564d35600efee8;

});
parcelRegister("24Vx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11394c94ea15801b$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $11394c94ea15801b$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    bodyMessageUnableToLoginWithThisEmailAddress: {
        id: 'social.recovery.body.unable.with.this.email.address',
        defaultMessage: "We\u2019re unable to log you in to {product} with this email address.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    bodyMessageUnableToLoginWithFoundEmail: {
        id: 'social.recovery.body.unable.with.found.email',
        defaultMessage: "We\u2019re unable to log you in to {product} with {foundEmail}.",
        description: `Message describing to the user that when they logged in via a social
      provider (eg. Log in with Google) they selected an account that we didn't expect.
      This occurs when we know that we want the user to log in with myemail@gmail.com, but
      in the social provider they log in with otheraccount@gmail.com.
      If we can't detect the product, we use 'your Atlassian account' as {product}.
      `
    },
    documentationLinkMessage: {
        id: 'social.recovery.documentation.link',
        defaultMessage: 'Get login help',
        description: 'Link to documentation page with help information'
    },
    productFallback: {
        id: 'social.recovery.product-fallback',
        defaultMessage: 'your Atlassian account',
        description: `If we can't determine the product the user is attempting to land on, then we
    will fall back to this value. Usage: We\u{2019}re unable to log you in to your Atlassian account with unexpectedemail@example.com`
    },
    buttonText: {
        id: 'social.recovery.button',
        defaultMessage: 'Try again',
        description: 'Button for user to try log in again.'
    },
    unknownErrorMessage: {
        id: 'social.recovery.error.unknown',
        defaultMessage: 'Try again later.'
    },
    tokenErrorMessage: {
        id: 'social.recovery.error.token-error',
        defaultMessage: "We're unable to service your request. Please try again."
    },
    expiredTokenErrorMessage: {
        id: 'social.recovery.error.token-expired',
        defaultMessage: 'Your session has expired. Please try again.'
    },
    title: {
        id: 'social.recovery.title',
        defaultMessage: 'Try again with another email address'
    },
    errorTitle: {
        id: 'social.recovery.title.error',
        defaultMessage: 'Something went wrong'
    }
});

});


parcelRegister("akKks", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailSentLoader", function () { return $580bd08865a2df7e$export$fae024edc929c93e; });
$parcel$export(module.exports, "VerifyOrReverifyEmailSentPage", function () { return $580bd08865a2df7e$export$980c3b624c0da509; });
$parcel$export(module.exports, "default", function () { return $580bd08865a2df7e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $8xW40 = parcelRequire("8xW40");

var $04Sj4 = parcelRequire("04Sj4");

var $3rMgh = parcelRequire("3rMgh");

var $8dHAc = parcelRequire("8dHAc");

var $kOqgB = parcelRequire("kOqgB");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
async function $580bd08865a2df7e$export$fae024edc929c93e({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/verify-email/sent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $580bd08865a2df7e$export$980c3b624c0da509 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const verificationType = (0, $kOqgB.useAppSelector)((state)=>state.verifyEmailSent.verificationType);
    return verificationType === (0, $8dHAc.VerificationType).Verify ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $04Sj4.default), {}) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $3rMgh.default), {});
};
var $580bd08865a2df7e$export$2e2bcd8739ae039 = $580bd08865a2df7e$export$980c3b624c0da509;

});

parcelRegister("5S2Pz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "verifyEmailLoader", function () { return $52257526e21d8d63$export$4af04dd5c668b91a; });
$parcel$export(module.exports, "VerifyOrReverifyEmailErrorPage", function () { return $52257526e21d8d63$export$647c199e9f3e1159; });
$parcel$export(module.exports, "default", function () { return $52257526e21d8d63$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $8dHAc = parcelRequire("8dHAc");

var $kaHtn = parcelRequire("kaHtn");

var $ksyFJ = parcelRequire("ksyFJ");

var $f2PQm = parcelRequire("f2PQm");

var $kOqgB = parcelRequire("kOqgB");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
async function $52257526e21d8d63$export$4af04dd5c668b91a({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/verify-email/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $52257526e21d8d63$export$647c199e9f3e1159 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const { error: error, url: url, verificationType: verificationType } = (0, $kOqgB.useAppSelector)((state)=>state.verifyEmail);
    switch(error){
        case (0, $8dHAc.VerifyOrReverifyEmailError).ExpiredToken:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $kaHtn.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $8dHAc.VerifyOrReverifyEmailError).InvalidToken:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $f2PQm.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        case (0, $8dHAc.VerifyOrReverifyEmailError).RateLimitExceeded:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $ksyFJ.default), {
                recoverUrl: url,
                verificationType: verificationType
            });
        default:
            return null;
    }
};
var $52257526e21d8d63$export$2e2bcd8739ae039 = $52257526e21d8d63$export$647c199e9f3e1159;

});
parcelRegister("kaHtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b90577ca69a00b9f$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $7CMue = parcelRequire("7CMue");

var $gGDrC = parcelRequire("gGDrC");

var $HBurV = parcelRequire("HBurV");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $9Vz68 = parcelRequire("9Vz68");

var $3ir1n = parcelRequire("3ir1n");

var $9NVnN = parcelRequire("9NVnN");
let $b90577ca69a00b9f$var$_ = (t)=>t, $b90577ca69a00b9f$var$t;
const $b90577ca69a00b9f$var$MessageContainer = (0, $9Vz68.default).div($b90577ca69a00b9f$var$t || ($b90577ca69a00b9f$var$t = $b90577ca69a00b9f$var$_`
  margin-bottom: 24px;
`));
const $b90577ca69a00b9f$export$f9171eab4ea79921 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const pageId = 'verifyEmailExpiredTokenErrorPage';
    (0, $3ir1n.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'resendVerificationEmail', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($b90577ca69a00b9f$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.expire.title",
                        defaultMessage: "Resend verification email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "reverify.email.expire.body",
                defaultMessage: "The link to verify your account has expired."
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "reverify.email.expire.button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.expire.button",
                        defaultMessage: "Resend verification email"
                    })
                })
            })
        ]
    });
};
var $b90577ca69a00b9f$export$2e2bcd8739ae039 = $b90577ca69a00b9f$export$f9171eab4ea79921;

});

parcelRegister("ksyFJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63e0b36ba0973cf7$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gJFTu = parcelRequire("gJFTu");

var $gGDrC = parcelRequire("gGDrC");

var $HBurV = parcelRequire("HBurV");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $9Vz68 = parcelRequire("9Vz68");

var $3ir1n = parcelRequire("3ir1n");

var $9NVnN = parcelRequire("9NVnN");
let $63e0b36ba0973cf7$var$_ = (t)=>t, $63e0b36ba0973cf7$var$t;
const $63e0b36ba0973cf7$var$MessageContainer = (0, $9Vz68.default).div($63e0b36ba0973cf7$var$t || ($63e0b36ba0973cf7$var$t = $63e0b36ba0973cf7$var$_`
  margin-bottom: 24px;
`));
const $63e0b36ba0973cf7$var$pageId = 'reverifyEmailRateLimitExceededErrorPage';
const $63e0b36ba0973cf7$export$1b84bfc67fc5d43a = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const displayRecoverUrl = (0, $8ZuGG.useMemo)(()=>new URL(recoverUrl).hostname, [
        recoverUrl
    ]);
    (0, $3ir1n.usePageViewedEvent)($63e0b36ba0973cf7$var$pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent($63e0b36ba0973cf7$var$pageId, 'backToStartButton', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $63e0b36ba0973cf7$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($63e0b36ba0973cf7$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "reverify.email.rate-limit-exceeded.error.main-action",
                defaultMessage: "There have been too many attempts to reverify your account in the past hour. You'll need to try again later.",
                description: "Telling the user that they have exceeded welcome email limit"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.rate-limit-exceeded.error.button-text",
                        defaultMessage: "Go back to {startUrl}",
                        values: {
                            startUrl: displayRecoverUrl
                        }
                    })
                })
            })
        ]
    });
};
var $63e0b36ba0973cf7$export$2e2bcd8739ae039 = $63e0b36ba0973cf7$export$1b84bfc67fc5d43a;

});

parcelRegister("f2PQm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b7f8502c898e2e6$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gJFTu = parcelRequire("gJFTu");

var $gGDrC = parcelRequire("gGDrC");

var $HBurV = parcelRequire("HBurV");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $9Vz68 = parcelRequire("9Vz68");

var $3ir1n = parcelRequire("3ir1n");

var $9NVnN = parcelRequire("9NVnN");
let $9b7f8502c898e2e6$var$_ = (t)=>t, $9b7f8502c898e2e6$var$t;
const $9b7f8502c898e2e6$var$MessageContainer = (0, $9Vz68.default).div($9b7f8502c898e2e6$var$t || ($9b7f8502c898e2e6$var$t = $9b7f8502c898e2e6$var$_`
  margin-bottom: 24px;
`));
const $9b7f8502c898e2e6$export$4ad664360e6dde74 = ({ recoverUrl: recoverUrl, verificationType: verificationType })=>{
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const pageId = 'verifyEmailInvalidTokenErrorPage';
    (0, $3ir1n.usePageViewedEvent)(pageId, {
        flow: verificationType
    });
    const recover = ()=>{
        analyticsClient.buttonClickedEvent(pageId, 'startAgain', {
            flow: verificationType
        });
        navigate(recoverUrl);
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($9b7f8502c898e2e6$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "reverify.email.invalid-token.error.main-action",
                defaultMessage: "Something went wrong while trying to validate your email."
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "go-back-button",
                    isFullWidth: true,
                    onClick: recover,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "reverify.email.invalid-token.error.button-text",
                        defaultMessage: "Go back to verify your email"
                    })
                })
            })
        ]
    });
};
var $9b7f8502c898e2e6$export$2e2bcd8739ae039 = $9b7f8502c898e2e6$export$4ad664360e6dde74;

});


parcelRegister("aZgOq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeSentLoader", function () { return $e6b4b686899eb4a6$export$518566b71566715e; });
$parcel$export(module.exports, "WelcomeSentPage", function () { return $e6b4b686899eb4a6$export$9feca1f6b3b10306; });
$parcel$export(module.exports, "default", function () { return $e6b4b686899eb4a6$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $8dHAc = parcelRequire("8dHAc");

var $jRUoI = parcelRequire("jRUoI");

var $dDpqV = parcelRequire("dDpqV");

var $a4Y7d = parcelRequire("a4Y7d");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
async function $e6b4b686899eb4a6$export$518566b71566715e({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/signup/welcome/sent/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $e6b4b686899eb4a6$export$9feca1f6b3b10306 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const error = (0, $kOqgB.useAppSelector)((state)=>state.welcomeSent.error);
    if (error === (0, $8dHAc.WelcomeSentError).InvalidToken) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $jRUoI.default), {});
    else if (error === (0, $8dHAc.WelcomeSentError).ExpiredToken) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $dDpqV.default), {});
    else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $a4Y7d.default), {});
};
var $e6b4b686899eb4a6$export$2e2bcd8739ae039 = $e6b4b686899eb4a6$export$9feca1f6b3b10306;

});
parcelRegister("jRUoI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c907e593ef338eac$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $HBurV = parcelRequire("HBurV");

var $7CMue = parcelRequire("7CMue");

var $9Vz68 = parcelRequire("9Vz68");

var $3ir1n = parcelRequire("3ir1n");
let $c907e593ef338eac$var$_ = (t)=>t, $c907e593ef338eac$var$t;
const $c907e593ef338eac$var$MessageContainer = (0, $9Vz68.default).div($c907e593ef338eac$var$t || ($c907e593ef338eac$var$t = $c907e593ef338eac$var$_`
  margin-bottom: 24px;
`));
const $c907e593ef338eac$export$703ba2e7ea526c1b = 'welcomeSentInvalidTokenErrorPage';
const $c907e593ef338eac$export$5592c2a3db83a69d = ()=>{
    (0, $3ir1n.usePageViewedEvent)($c907e593ef338eac$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $c907e593ef338eac$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($c907e593ef338eac$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "welcome.send.invalid-token.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused if the user tampers with the token.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "welcome.send.invalid-token.error.main-action",
            defaultMessage: "Something went wrong while trying to validate your email. Try again from a verification email in your inbox.",
            description: "Telling the user that there was an error while trying to send the welcome link. The error is caused if the user tampers with the token."
        })
    });
};
var $c907e593ef338eac$export$2e2bcd8739ae039 = $c907e593ef338eac$export$5592c2a3db83a69d;

});

parcelRegister("dDpqV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a81a0500b530c356$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $HBurV = parcelRequire("HBurV");

var $7CMue = parcelRequire("7CMue");

var $9Vz68 = parcelRequire("9Vz68");

var $3ir1n = parcelRequire("3ir1n");
let $a81a0500b530c356$var$_ = (t)=>t, $a81a0500b530c356$var$t;
const $a81a0500b530c356$var$MessageContainer = (0, $9Vz68.default).div($a81a0500b530c356$var$t || ($a81a0500b530c356$var$t = $a81a0500b530c356$var$_`
  margin-bottom: 24px;
`));
const $a81a0500b530c356$export$703ba2e7ea526c1b = 'welcomeSentExpiredTokenErrorPage';
const $a81a0500b530c356$export$807f21bb9e47b82c = ()=>{
    (0, $3ir1n.usePageViewedEvent)($a81a0500b530c356$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $a81a0500b530c356$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($a81a0500b530c356$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "welcome.sent.expire.title",
                        defaultMessage: "The link has expired",
                        description: "Telling the user that there is an error with the welcome link. The error is caused by submitting the resend link again after the token has expired.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "welcome.sent.expire.body",
            defaultMessage: "Check your inbox for the verification email.",
            description: "Telling the user that the welcome resend link is expired and they're not verified. The error is caused by submitting the resend link again after the token has expired. The user should try again by clicking the link in their email."
        })
    });
};
var $a81a0500b530c356$export$2e2bcd8739ae039 = $a81a0500b530c356$export$807f21bb9e47b82c;

});

parcelRegister("a4Y7d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5767e500bb1bc9d$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $jSnDV = parcelRequire("jSnDV");

var $jHLOy = parcelRequire("jHLOy");

var $xe7jL = parcelRequire("xe7jL");

var $hX7Rq = parcelRequire("hX7Rq");

var $9OvaU = parcelRequire("9OvaU");

var $7CMue = parcelRequire("7CMue");

var $1fJfd = parcelRequire("1fJfd");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $kZj5j = parcelRequire("kZj5j");

var $5VQjR = parcelRequire("5VQjR");
const $a5767e500bb1bc9d$export$703ba2e7ea526c1b = 'welcomeSentScreen';
const $a5767e500bb1bc9d$export$e3675ba991d10a22 = 'resendWelcomeSentEmail';
const $a5767e500bb1bc9d$export$cb17d40f6b542a55 = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { email: email, redirectType: redirectType, migratingApplications: migratingApplications, showBrowserWarning: showBrowserWarning } = (0, $kOqgB.useAppSelector)((state)=>state.welcomeSent);
    const location = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    (0, $3ir1n.usePageViewedEvent)($a5767e500bb1bc9d$export$703ba2e7ea526c1b, {
        browserWarningMessageShown: showBrowserWarning,
        redirectType: redirectType
    });
    function handleResendVerificationEmail() {
        const { token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
        analyticsClient.buttonClickedEvent($a5767e500bb1bc9d$export$703ba2e7ea526c1b, $a5767e500bb1bc9d$export$e3675ba991d10a22, {
            redirectType: redirectType
        });
        return fetch(`/rest/signup/welcome/resend${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token
            })
        }).then((response)=>{
            if (response.status === 204) dispatch((0, $xe7jL.addFlag)('success', (0, $1fJfd.default).verifyEmailFlagSuccessTitle, (0, $1fJfd.default).verifyEmailFlagSuccessDesc));
            else throw new Error($a5767e500bb1bc9d$export$703ba2e7ea526c1b + ' Invalid Token');
        }).catch(()=>{
            dispatch((0, $xe7jL.addFlag)('error', (0, $1fJfd.default).verifyEmailFlagErrorTitle, (0, $1fJfd.default).verifyEmailFlagErrorDesc));
        });
    }
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $a5767e500bb1bc9d$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $1fJfd.default).migrationVerifyHeader))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "welcome-send-validation-submit",
            spacing: "none",
            className: "link-color-override",
            onClick: handleResendVerificationEmail,
            children: formatMessage((0, $1fJfd.default).button)
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $1fJfd.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                email: email,
                message: /*#__PURE__*/ (0, $6rcps.jsx)($a5767e500bb1bc9d$var$MigrationVerifyMessage, {
                    migratingApplications: migratingApplications
                }),
                warningMessage: showBrowserWarning && /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
                    testId: "browser-warning",
                    appearance: "information",
                    children: formatMessage((0, $1fJfd.default).browserWarning)
                })
            })
        ]
    });
};
var $a5767e500bb1bc9d$export$2e2bcd8739ae039 = $a5767e500bb1bc9d$export$cb17d40f6b542a55;
const $a5767e500bb1bc9d$var$MigrationVerifyMessage = ({ migratingApplications: migratingApplications })=>{
    var _applications_migratingApplications_;
    var _applications_migratingApplications__name;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            migratingApplications !== undefined && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $1fJfd.default).resumeMigrationVerifyMessage), {
                        values: {
                            product: migratingApplications.includes('trello') ? (0, $kZj5j.applications)['trello'].name : (_applications_migratingApplications__name = (_applications_migratingApplications_ = (0, $kZj5j.applications)[migratingApplications[0]]) === null || _applications_migratingApplications_ === void 0 ? void 0 : _applications_migratingApplications_.name) !== null && _applications_migratingApplications__name !== void 0 ? _applications_migratingApplications__name : migratingApplications[0]
                        }
                    })),
                    ' '
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $1fJfd.default).migrationVerifyMessage))
        ]
    });
};

});


parcelRegister("lFKa2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "logoutLoader", function () { return $2139a2a02c74c0d9$export$fe06aa2603bb1f9a; });
$parcel$export(module.exports, "LogoutPage", function () { return $2139a2a02c74c0d9$export$ae5920452e7cb547; });
$parcel$export(module.exports, "default", function () { return $2139a2a02c74c0d9$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $3o9o3 = parcelRequire("3o9o3");

var $5b7Z4 = parcelRequire("5b7Z4");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $pO9YU = parcelRequire("pO9YU");

var $day6I = parcelRequire("day6I");

var $aSbA9 = parcelRequire("aSbA9");

var $fLB9o = parcelRequire("fLB9o");

var $bceLx = parcelRequire("bceLx");

var $3ir1n = parcelRequire("3ir1n");

var $lp6gZ = parcelRequire("lp6gZ");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $a8rGb = parcelRequire("a8rGb");

var $kOqgB = parcelRequire("kOqgB");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $2139a2a02c74c0d9$var$_ = (t)=>t, $2139a2a02c74c0d9$var$t, $2139a2a02c74c0d9$var$t1, $2139a2a02c74c0d9$var$t2;
const $2139a2a02c74c0d9$var$AccountWrapper = (0, $9Vz68.default).div($2139a2a02c74c0d9$var$t || ($2139a2a02c74c0d9$var$t = $2139a2a02c74c0d9$var$_`
  > * {
    padding-bottom: ${0}px !important;
    border-bottom: none !important;
  }
`), (0, $5b7Z4.gridSize)());
const $2139a2a02c74c0d9$var$Form = (0, $9Vz68.default).form($2139a2a02c74c0d9$var$t1 || ($2139a2a02c74c0d9$var$t1 = $2139a2a02c74c0d9$var$_`
  margin-top: 0;
`));
const $2139a2a02c74c0d9$var$ButtonContainer = (0, $9Vz68.default).div($2139a2a02c74c0d9$var$t2 || ($2139a2a02c74c0d9$var$t2 = $2139a2a02c74c0d9$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $2139a2a02c74c0d9$var$pageId = 'logoutPage';
async function $2139a2a02c74c0d9$export$fe06aa2603bb1f9a({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/logout/state', request, {
        capabilities: [
            'capability-group--logout'
        ]
    });
}
const $2139a2a02c74c0d9$export$ae5920452e7cb547 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const autoSubmit = (0, $kOqgB.useAppSelector)((state)=>state.logout.autoSubmit);
    return autoSubmit ? /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$LogoutAutoSubmit, {}) : /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$LogoutConfirmationPage, {});
};
const $2139a2a02c74c0d9$var$LogoutAutoSubmit = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    (0, $8ZuGG.useEffect)(()=>{
        dispatch((0, $a8rGb.doLogout)());
    }, [
        dispatch
    ]);
    // When the browser loads the logout page the user will see the spinner on that page so we don't
    // want to show anything on this page, not even a spinner, to make the redirect more transparent.
    return null;
};
const $2139a2a02c74c0d9$var$LogoutConfirmationPage = ()=>{
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const { userData: userData, formError: formError } = (0, $kOqgB.useAppSelector)((state)=>state.logout);
    const location = (0, $5WDNl.useLocation)();
    const intl = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    (0, $3ir1n.usePageViewedEvent)($2139a2a02c74c0d9$var$pageId, {
        isAuthenticatedUser: !!userData
    });
    const buildHeader = ()=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "logout.title",
                defaultMessage: "Log out of your Atlassian account"
            }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "logout.title.multiple",
                defaultMessage: "Log out of your Atlassian accounts"
            })
        });
    const buildFooter = ()=>{
        return isEmbedded ? undefined : /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
            className: "fine-print",
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                        isMobileLink: (0, $day6I.isMobileOidc)(oidcContext)
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                        isMobileLink: (0, $day6I.isMobileOidc)(oidcContext)
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("title", {
                    children: intl.formatMessage((0, $fLB9o.default).logoutTitle)
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
                pageId: $2139a2a02c74c0d9$var$pageId,
                header: buildHeader(),
                footer: buildFooter(),
                whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)("a", {
                    href: '/login/select-account' + location.search,
                    onClick: ()=>{
                        analyticsClient.linkClickedEvent($2139a2a02c74c0d9$var$pageId, 'selectAccount');
                    },
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "logout.switch-account",
                        defaultMessage: "Log in to another account"
                    })
                }),
                children: [
                    !!formError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.SectionError), {
                        children: formError
                    }),
                    !!userData && userData.associatedSessions.length === 0 && /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$AccountWrapper, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                            primary: true,
                            avatarUrl: userData.avatarUrl,
                            displayName: userData.displayName,
                            email: userData.email
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$LogoutForm, {})
                ]
            })
        ]
    });
};
const $2139a2a02c74c0d9$var$LogoutForm = ()=>{
    const userData = (0, $kOqgB.useAppSelector)((state)=>state.logout.userData);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [submitting, setSubmitting] = (0, $8ZuGG.useState)(false);
    return /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$Form, {
        onSubmit: (event)=>{
            event.preventDefault();
            setSubmitting(true);
            analyticsClient.formSubmittedEvent($2139a2a02c74c0d9$var$pageId, 'logout');
            dispatch((0, $a8rGb.doLogout)());
        },
        "data-testid": "logout-form",
        children: /*#__PURE__*/ (0, $6rcps.jsx)($2139a2a02c74c0d9$var$ButtonContainer, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                appearance: "primary",
                id: "logout-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: submitting,
                testId: "logout-button",
                children: !userData || userData.associatedSessions.length === 0 ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "logout.confirm",
                    defaultMessage: "Log out"
                }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "logout.confirm.multiple",
                    defaultMessage: "Log out of all accounts"
                })
            })
        })
    });
};
var $2139a2a02c74c0d9$export$2e2bcd8739ae039 = $2139a2a02c74c0d9$export$ae5920452e7cb547;

});
parcelRegister("aSbA9", function(module, exports) {

$parcel$export(module.exports, "AccountContainer", function () { return $d59931200c9103b8$export$5baee99c5c7ba187; });
$parcel$export(module.exports, "AvatarContainer", function () { return $d59931200c9103b8$export$6027454d331df3c4; });
$parcel$export(module.exports, "RowButtonContainer", function () { return $d59931200c9103b8$export$fadcaf242d6ed62f; });
$parcel$export(module.exports, "TextContainer", function () { return $d59931200c9103b8$export$762240c6611b6ed2; });
$parcel$export(module.exports, "Paragraph", function () { return $d59931200c9103b8$export$358a232cca1ab2ac; });
$parcel$export(module.exports, "default", function () { return $d59931200c9103b8$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $iqmJy = parcelRequire("iqmJy");

var $9Vz68 = parcelRequire("9Vz68");

var $bl8w7 = parcelRequire("bl8w7");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");
let $d59931200c9103b8$var$_ = (t)=>t, $d59931200c9103b8$var$t, $d59931200c9103b8$var$t1, $d59931200c9103b8$var$t2, $d59931200c9103b8$var$t3, $d59931200c9103b8$var$t4, $d59931200c9103b8$var$t5, $d59931200c9103b8$var$t6, $d59931200c9103b8$var$t7, $d59931200c9103b8$var$t8;
const $d59931200c9103b8$export$5baee99c5c7ba187 = (0, $9Vz68.default).button($d59931200c9103b8$var$t1 || ($d59931200c9103b8$var$t1 = $d59931200c9103b8$var$_`
  /* reset button styles */
  appearance: none;
  background: none;
  border: 0;
  padding: 0;
  width: 100%;
  text-align: left;

  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: ${0};
  padding-bottom: ${0};

  &:last-child {
    border-bottom: 1px solid ${0};
    ${0}
  }

  ${0}

  ${0}
`), (props)=>props.primary ? '0' : '16px', (props)=>props.primary ? '24px' : '16px', (0, $kTdw7).N30A, (props)=>props.noBorder && (0, $bl8w7.css)($d59931200c9103b8$var$t || ($d59931200c9103b8$var$t = $d59931200c9103b8$var$_`
        border-bottom: none;
        margin-bottom: ${0}px;
      `), -(0, $5b7Z4.gridSize)() * 3), (props)=>props.primary && `  &:only-child {
        margin-bottom: 0;
        border-bottom: 0;
        padding: 8px 0;
    }
      `, (props)=>props.onClick ? `&:hover, &:focus {
      border-radius: 3px;
      transition: background 0s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38);
      cursor: pointer;
      background-color: ${(0, $kTdw7).N30A};
    }` : '');
const $d59931200c9103b8$var$primaryAvatarSize = '72px';
const $d59931200c9103b8$var$defaultAvatarSize = '36px';
const $d59931200c9103b8$export$6027454d331df3c4 = (0, $9Vz68.default).div($d59931200c9103b8$var$t2 || ($d59931200c9103b8$var$t2 = $d59931200c9103b8$var$_`
  margin: 0 0 0 ${0};
  width: ${0};
  display: flex;
  align-items: center;
  justify-content: center;

  ${0}

  ${0}
`), (props)=>props.primary ? '0' : '8px', (props)=>props.primary ? $d59931200c9103b8$var$primaryAvatarSize : $d59931200c9103b8$var$defaultAvatarSize, (props)=>props.primary && `padding-left: 8px;`, (props)=>props.primary && `
    div, span {
      padding: 0;
      width: ${$d59931200c9103b8$var$primaryAvatarSize} !important;
      height: ${$d59931200c9103b8$var$primaryAvatarSize} !important;
    }
  `);
const $d59931200c9103b8$var$Avatar = (props)=>/*#__PURE__*/ (0, $6rcps.jsx)($d59931200c9103b8$export$6027454d331df3c4, {
        primary: props.primary,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $iqmJy.default), {
            appearance: "circle",
            src: props.avatarUrl,
            size: props.primary ? 'xlarge' : 'medium'
        })
    });
const $d59931200c9103b8$export$a9754b3c8daa5172 = (0, $9Vz68.default).section($d59931200c9103b8$var$t3 || ($d59931200c9103b8$var$t3 = $d59931200c9103b8$var$_`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`));
const $d59931200c9103b8$export$fadcaf242d6ed62f = (0, $9Vz68.default)($d59931200c9103b8$export$a9754b3c8daa5172)($d59931200c9103b8$var$t4 || ($d59931200c9103b8$var$t4 = $d59931200c9103b8$var$_`
  padding: 8px 0;
`));
const $d59931200c9103b8$export$762240c6611b6ed2 = (0, $9Vz68.default).section($d59931200c9103b8$var$t5 || ($d59931200c9103b8$var$t5 = $d59931200c9103b8$var$_`
  flex-grow: 1;

  min-width: 0;
  // IE11 expands width to the parent container until the overflow kicks in
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    width: 0;
  }

  display: inline-block;
  margin: 0 16px;

  > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`));
const $d59931200c9103b8$export$8b251419efc915eb = (0, $9Vz68.default).span($d59931200c9103b8$var$t6 || ($d59931200c9103b8$var$t6 = $d59931200c9103b8$var$_`
  font: ${0};
  font-size: ${0};
  line-height: ${0};
  color: ${0};
  overflow-wrap: break-word;
`), (props)=>props.primary ? (0, $g5rao.default)('font.heading.medium') : (0, $g5rao.default)('font.heading.xsmall'), (props)=>props.primary ? '20px' : '14px', (props)=>props.primary ? '24px' : '20px', (0, $kTdw7).N800);
const $d59931200c9103b8$export$358a232cca1ab2ac = (0, $9Vz68.default).p($d59931200c9103b8$var$t7 || ($d59931200c9103b8$var$t7 = $d59931200c9103b8$var$_`
  font-size: 14px;
  line-height: 20px;
  color: ${0};
  margin-top: ${0};
  overflow-wrap: break-word;
`), (0, $kTdw7).N700, (props)=>props.primary ? '4px' : '0');
const $d59931200c9103b8$export$8f314e512d92575f = (0, $9Vz68.default).section($d59931200c9103b8$var$t8 || ($d59931200c9103b8$var$t8 = $d59931200c9103b8$var$_`
  margin-right: 8px;
`));
/**
 * Representation of an account in a row format, used for rendering lists of accounts, e.g. for switching an account
 * or selecting one to log in
 */ const $d59931200c9103b8$var$Account = ({ avatarUrl: avatarUrl, children: children, displayName: displayName, email: email, header: header, icon: icon, id: id, onClick: onClick, primary: primary })=>{
    const title = displayName ? displayName : email;
    const paragraph = displayName ? email : undefined;
    return /*#__PURE__*/ (0, $6rcps.jsxs)($d59931200c9103b8$export$5baee99c5c7ba187, {
        id: id,
        className: "account-entry" // account-entry used by pollinators
        ,
        "data-testid": "account-entry",
        as: primary ? 'div' : 'button',
        primary: primary,
        onClick: onClick,
        children: [
            header,
            /*#__PURE__*/ (0, $6rcps.jsxs)($d59931200c9103b8$export$a9754b3c8daa5172, {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($d59931200c9103b8$var$Avatar, {
                        avatarUrl: avatarUrl,
                        primary: primary
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsxs)($d59931200c9103b8$export$762240c6611b6ed2, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)($d59931200c9103b8$export$8b251419efc915eb, {
                                primary: primary,
                                "data-testid": "email",
                                children: title
                            }),
                            paragraph && /*#__PURE__*/ (0, $6rcps.jsx)($d59931200c9103b8$export$358a232cca1ab2ac, {
                                primary: primary,
                                children: paragraph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)($d59931200c9103b8$export$8f314e512d92575f, {
                        children: icon
                    })
                ]
            }),
            children
        ]
    });
};
var $d59931200c9103b8$export$2e2bcd8739ae039 = $d59931200c9103b8$var$Account;

});
parcelRegister("iqmJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d69c4a2d1dac005a$export$2e2bcd8739ae039; });
/* avatar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $gvAuA = parcelRequire("gvAuA");

var $iNlvH = parcelRequire("iNlvH");

var $3yBgB = parcelRequire("3yBgB");

var $5cpSM = parcelRequire("5cpSM");

var $8JQ0R = parcelRequire("8JQ0R");

var $9EyEg = parcelRequire("9EyEg");

var $eRrtb = parcelRequire("eRrtb");

var $iM0sL = parcelRequire("iM0sL");
function $d69c4a2d1dac005a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d69c4a2d1dac005a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d69c4a2d1dac005a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d69c4a2d1dac005a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d69c4a2d1dac005a$var$packageName = "@atlaskit/avatar";
var $d69c4a2d1dac005a$var$packageVersion = "25.1.17";
var $d69c4a2d1dac005a$var$containerStyles = null;
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
/**
 * __Avatar__
 *
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage)
 */ var $d69c4a2d1dac005a$var$Avatar = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var analyticsContext = _ref.analyticsContext, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'circle' : _ref$appearance, label = _ref.label, borderColor = _ref.borderColor, children = _ref.children, href = _ref.href, isDisabled = _ref.isDisabled, name = _ref.name, onClick = _ref.onClick, presence = _ref.presence, sizeProp = _ref.size, src = _ref.src, stackIndex = _ref.stackIndex, status = _ref.status, target = _ref.target, testId = _ref.testId, _ref$as = _ref.as, AvatarContainer = _ref$as === void 0 ? 'div' : _ref$as, _ref$isDecorative = _ref.isDecorative, isDecorative = _ref$isDecorative === void 0 ? false : _ref$isDecorative, imgLoading = _ref.imgLoading;
    var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var context = (0, $5cpSM.useAvatarContext)();
    var size = sizeProp || (context === null || context === void 0 ? void 0 : context.size) || 'medium';
    var customPresenceNode = /*#__PURE__*/ (0, $8ZuGG.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $8ZuGG.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $8ZuGG.useRef)(analyticsContext);
    var labelId = (0, $iNlvH.useId)();
    (0, $8ZuGG.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $8ZuGG.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $d69c4a2d1dac005a$var$packageName,
                packageVersion: $d69c4a2d1dac005a$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $d69c4a2d1dac005a$var$_objectSpread({
            componentName: 'avatar',
            packageName: $d69c4a2d1dac005a$var$packageName,
            packageVersion: $d69c4a2d1dac005a$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5cpSM.EnsureIsInsideAvatarContext).Provider, {
        value: true
    }, /*#__PURE__*/ $8ZuGG.createElement(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage && !isDecorative ? labelId : undefined,
        style: {
            zIndex: stackIndex
        },
        className: (0, $c4hjl.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5cpSM.AvatarContentContext).Provider, {
        value: {
            as: (0, $iM0sL.getCustomElement)(isDisabled, href, onClick),
            appearance: appearance,
            borderColor: borderColor,
            href: href,
            isDisabled: isDisabled,
            label: label || defaultLabel,
            onClick: isInteractive ? onClickHandler : undefined,
            ref: ref,
            size: size,
            stackIndex: stackIndex,
            target: target,
            testId: testId ? "".concat(testId, "--inner") : undefined,
            avatarImage: /*#__PURE__*/ $8ZuGG.createElement((0, $8JQ0R.default), {
                alt: !containerShouldBeImage && src ? name : undefined,
                src: src,
                appearance: appearance,
                size: size,
                testId: testId,
                imgLoading: imgLoading
            })
        }
    }, children || /*#__PURE__*/ $8ZuGG.createElement((0, $3yBgB.AvatarContent), null)), isPresence && /*#__PURE__*/ $8ZuGG.createElement((0, $9EyEg.PresenceWrapper), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && /*#__PURE__*/ $8ZuGG.createElement((0, $eRrtb.StatusWrapper), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId && "".concat(testId, "--label"),
        id: labelId,
        hidden: true
    }, defaultLabel) : undefined));
});
$d69c4a2d1dac005a$var$Avatar.displayName = 'Avatar';
var $d69c4a2d1dac005a$export$2e2bcd8739ae039 = $d69c4a2d1dac005a$var$Avatar;

});
parcelRegister("3yBgB", function(module, exports) {

$parcel$export(module.exports, "AvatarContent", function () { return $29717474db36d78a$export$47fbc0b44cae5559; });
/* avatar-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");

var $5cpSM = parcelRequire("5cpSM");
var $29717474db36d78a$var$boxShadowCssVar = '--avatar-box-shadow';
var $29717474db36d78a$var$bgColorCssVar = '--avatar-bg-color';
var $29717474db36d78a$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw _1ejjglyw _mizu194a _1ah3v77o _ra3xnqa1 _128m1bk5 _4dave4h9",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peqs237"
};
var $29717474db36d78a$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1g4v _ez1ykb7n _gcm1182g _eeh8kb7n _jlxit94y"
};
var $29717474db36d78a$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
var $29717474db36d78a$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
var $29717474db36d78a$export$47fbc0b44cae5559 = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children;
    (0, $5cpSM.useEnsureIsInsideAvatar)();
    var _useAvatarContent = (0, $5cpSM.useAvatarContent)(), Container = _useAvatarContent.as, appearance = _useAvatarContent.appearance, avatarImage = _useAvatarContent.avatarImage, _useAvatarContent$bor = _useAvatarContent.borderColor, borderColor = _useAvatarContent$bor === void 0 ? (0, $i2LcI.fg)('platform-component-visual-refresh') ? "var(--ds-surface, #FFFFFF)" : "var(--ds-surface-overlay, #FFFFFF)" : _useAvatarContent$bor, href = _useAvatarContent.href, isDisabled = _useAvatarContent.isDisabled, label = _useAvatarContent.label, onClick = _useAvatarContent.onClick, contextRef = _useAvatarContent.ref, tabIndex = _useAvatarContent.tabIndex, target = _useAvatarContent.target, testId = _useAvatarContent.testId, size = _useAvatarContent.size, stackIndex = _useAvatarContent.stackIndex;
    var isInteractive = Boolean(onClick || href || isDisabled);
    return /*#__PURE__*/ $8ZuGG.createElement(Container, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $29717474db36d78a$var$bgColorCssVar, borderColor), $29717474db36d78a$var$boxShadowCssVar, "0 0 0 2px ".concat(borderColor)),
        ref: ref || contextRef,
        "aria-label": isInteractive ? label : undefined,
        onClick: onClick,
        tabIndex: tabIndex,
        "data-testid": testId,
        disabled: isDisabled,
        type: Container === 'button' ? 'button' : undefined
    }, href && {
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined
    }, {
        className: (0, $c4hjl.default)([
            $29717474db36d78a$var$unboundStyles.root,
            $29717474db36d78a$var$styles.root,
            $29717474db36d78a$var$borderRadiusMap[size],
            appearance === 'circle' && $29717474db36d78a$var$styles.circle,
            $29717474db36d78a$var$widthHeightMap[size],
            stackIndex !== undefined && $29717474db36d78a$var$styles.positionRelative,
            isInteractive && !isDisabled && $29717474db36d78a$var$unboundStyles.interactive,
            isDisabled && $29717474db36d78a$var$styles.disabled
        ])
    }), children || avatarImage);
});

});
parcelRegister("5cpSM", function(module, exports) {

$parcel$export(module.exports, "useAvatarContext", function () { return $3c922673d46fe1dc$export$b50b87a1c4086b23; });
$parcel$export(module.exports, "AvatarContentContext", function () { return $3c922673d46fe1dc$export$b983474ddd0b6d28; });
$parcel$export(module.exports, "useAvatarContent", function () { return $3c922673d46fe1dc$export$79d078b69b7e4842; });
$parcel$export(module.exports, "EnsureIsInsideAvatarContext", function () { return $3c922673d46fe1dc$export$6b4cbd90d24955ad; });
$parcel$export(module.exports, "useEnsureIsInsideAvatar", function () { return $3c922673d46fe1dc$export$7db5c57474082dd9; });

var $8ZuGG = parcelRequire("8ZuGG");
var $3c922673d46fe1dc$export$a20dad690e1279e2 = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
var $3c922673d46fe1dc$export$b50b87a1c4086b23 = function useAvatarContext() {
    return (0, $8ZuGG.useContext)($3c922673d46fe1dc$export$a20dad690e1279e2);
};
var $3c922673d46fe1dc$var$defaultAvatarContentProps = {
    as: 'span',
    appearance: 'circle',
    avatarImage: null,
    ref: null,
    size: 'medium'
};
var $3c922673d46fe1dc$export$b983474ddd0b6d28 = /*#__PURE__*/ (0, $8ZuGG.createContext)($3c922673d46fe1dc$var$defaultAvatarContentProps);
var $3c922673d46fe1dc$export$79d078b69b7e4842 = function useAvatarContent() {
    return (0, $8ZuGG.useContext)($3c922673d46fe1dc$export$b983474ddd0b6d28);
};
var $3c922673d46fe1dc$export$6b4cbd90d24955ad = /*#__PURE__*/ (0, $8ZuGG.createContext)(false);
var $3c922673d46fe1dc$export$7db5c57474082dd9 = function useEnsureIsInsideAvatar() {
    var context = (0, $8ZuGG.useContext)($3c922673d46fe1dc$export$6b4cbd90d24955ad);
    if (!context) throw new Error('Avatar sub-components must be used within a Avatar component.');
};

});


parcelRegister("8JQ0R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65cadf5d3f859f51$export$2e2bcd8739ae039; });
/* avatar-image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $5SmVT = parcelRequire("5SmVT");

var $1t5hd = parcelRequire("1t5hd");

var $i2LcI = parcelRequire("i2LcI");
var $65cadf5d3f859f51$var$styles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq",
    icon: "_1e0c1txw _1bsb1osq _4t3i1osq",
    iconBg: "_bfhkr4aa",
    iconBGVisualRefresh: "_bfhk1v33",
    circle: "_2rko1rr0"
};
var $65cadf5d3f859f51$var$borderRadiusMap = {
    xsmall: "_2rkolb4i",
    small: "_2rkolb4i",
    medium: "_2rkofajl",
    large: "_2rkofajl",
    xlarge: "_2rko1qi0",
    xxlarge: "_2rkopb1k"
};
var $65cadf5d3f859f51$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l516xz _175216xz",
    xxlarge: "_w8l51qr7 _17521qr7"
};
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $65cadf5d3f859f51$var$AvatarImage = function AvatarImage(_ref) {
    var _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? '' : _ref$alt, src = _ref.src, appearance = _ref.appearance, size = _ref.size, testId = _ref.testId, imgLoading = _ref.imgLoading;
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    // If src changes, reset state
    (0, $8ZuGG.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            $65cadf5d3f859f51$var$styles.icon,
            (0, $i2LcI.fg)('platform-component-visual-refresh') ? $65cadf5d3f859f51$var$styles.iconBGVisualRefresh : $65cadf5d3f859f51$var$styles.iconBg,
            $65cadf5d3f859f51$var$nestedSvgStylesMap[size]
        ])
    }, appearance === 'circle' ? /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SmVT))), {
        label: alt,
        color: (0, $i2LcI.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--person"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }) : /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1t5hd))), {
        label: alt,
        color: (0, $i2LcI.fg)('platform-component-visual-refresh') ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-inverse, #FFFFFF)",
        testId: testId && "".concat(testId, "--ship"),
        spacing: "spacious",
        LEGACY_secondaryColor: "var(--ds-icon-subtle, #626F86)"
    }));
    return /*#__PURE__*/ $8ZuGG.createElement("img", {
        loading: imgLoading,
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": !alt ? true : undefined,
        "data-vc": testId ? "".concat(testId, "--image") : 'avatar-image',
        "data-ssr-placeholder-ignored": true,
        className: (0, $c4hjl.default)([
            $65cadf5d3f859f51$var$styles.image,
            $65cadf5d3f859f51$var$borderRadiusMap[size],
            appearance === 'circle' && $65cadf5d3f859f51$var$styles.circle
        ])
    });
};
var $65cadf5d3f859f51$export$2e2bcd8739ae039 = $65cadf5d3f859f51$var$AvatarImage;

});
parcelRegister("5SmVT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29971dcd1e1cc09403d75aea4f4ed622>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4473c8e06c8fee4f$var$_react = $4473c8e06c8fee4f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $4473c8e06c8fee4f$var$_person = $4473c8e06c8fee4f$var$_interopRequireDefault((parcelRequire("ciNSY")));

var $4473c8e06c8fee4f$var$_person2 = $4473c8e06c8fee4f$var$_interopRequireDefault((parcelRequire("iXnGj")));
function $4473c8e06c8fee4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonIcon.
 * This component is PersonIcon, with `UNSAFE_fallbackIcon` set to "PersonIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4473c8e06c8fee4f$var$PersonIcon = (props)=>/*#__PURE__*/ $4473c8e06c8fee4f$var$_react.default.createElement($4473c8e06c8fee4f$var$_person.default, Object.assign({
        name: "PersonIcon",
        LEGACY_fallbackIcon: $4473c8e06c8fee4f$var$_person2.default
    }, props));
$4473c8e06c8fee4f$var$PersonIcon.displayName = 'PersonIconMigration';
var $4473c8e06c8fee4f$var$_default = module.exports.default = $4473c8e06c8fee4f$var$PersonIcon;

});
parcelRegister("ciNSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fc4353a18034f564a0b3573d4163ea60>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f4ddcbe72aadb74$var$_react = $8f4ddcbe72aadb74$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $8f4ddcbe72aadb74$var$_baseNew = $8f4ddcbe72aadb74$var$_interopRequireDefault((parcelRequire("4Wp5P")));
function $8f4ddcbe72aadb74$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8f4ddcbe72aadb74$var$PersonIcon = (props)=>/*#__PURE__*/ $8f4ddcbe72aadb74$var$_react.default.createElement($8f4ddcbe72aadb74$var$_baseNew.default, Object.assign({
        name: "PersonIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$8f4ddcbe72aadb74$var$PersonIcon.displayName = 'PersonIcon';
var $8f4ddcbe72aadb74$var$_default = module.exports.default = $8f4ddcbe72aadb74$var$PersonIcon;

});
parcelRegister("4Wp5P", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("3VlWd")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("3VlWd")).Icon; });

var $3VlWd = parcelRequire("3VlWd");

});
parcelRegister("3VlWd", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $2db7b65fdd0811e7$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $2db7b65fdd0811e7$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $2db7b65fdd0811e7$var$svgStyles = null;
var $2db7b65fdd0811e7$var$iconStyles = null;
var $2db7b65fdd0811e7$var$utilityIconStyles = null;
var $2db7b65fdd0811e7$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $2db7b65fdd0811e7$var$baseHcmStyles = null;
var $2db7b65fdd0811e7$var$scaleSize = null;
var $2db7b65fdd0811e7$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2db7b65fdd0811e7$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2db7b65fdd0811e7$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $2db7b65fdd0811e7$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $2db7b65fdd0811e7$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $2db7b65fdd0811e7$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $2db7b65fdd0811e7$var$baseSizeMap[type];
    var viewBoxPadding = $2db7b65fdd0811e7$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $2db7b65fdd0811e7$var$utilSizes[spacing] : size === 'small' ? $2db7b65fdd0811e7$var$coreSizeSmall[spacing] : $2db7b65fdd0811e7$var$coreSizeMedium[spacing]
        ])
    }));
});
var $2db7b65fdd0811e7$export$2e2bcd8739ae039 = $2db7b65fdd0811e7$export$f04a61298a47a40f;

});



parcelRegister("iXnGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dcd01b54470afbfa$var$_react = $dcd01b54470afbfa$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5HwCG = parcelRequire("5HwCG");
function $dcd01b54470afbfa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dcd01b54470afbfa$var$PersonIcon = (props)=>/*#__PURE__*/ $dcd01b54470afbfa$var$_react.default.createElement($5HwCG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$dcd01b54470afbfa$var$PersonIcon.displayName = 'PersonIcon';
var $dcd01b54470afbfa$var$_default = module.exports.default = $dcd01b54470afbfa$var$PersonIcon;

});
parcelRegister("5HwCG", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $426a4622b24d1444$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $426a4622b24d1444$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $426a4622b24d1444$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $426a4622b24d1444$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $426a4622b24d1444$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $426a4622b24d1444$var$iconStyles = null;
var $426a4622b24d1444$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $426a4622b24d1444$var$baseHcmStyles = null;
var $426a4622b24d1444$var$primaryEqualsSecondaryHcmStyles = null;
var $426a4622b24d1444$var$secondaryTransparentHcmStyles = null;
var $426a4622b24d1444$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $426a4622b24d1444$var$_objectSpread($426a4622b24d1444$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $426a4622b24d1444$var$sizeStyles[size]
        ])
    }));
});
var $426a4622b24d1444$export$2e2bcd8739ae039 = $426a4622b24d1444$export$f04a61298a47a40f;

});



parcelRegister("1t5hd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d0234a675d9b1e030b7622cea0db1767>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $111c97b9891df0d1$var$_react = $111c97b9891df0d1$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $111c97b9891df0d1$var$_release = $111c97b9891df0d1$var$_interopRequireDefault((parcelRequire("dUTVo")));

var $111c97b9891df0d1$var$_ship = $111c97b9891df0d1$var$_interopRequireDefault((parcelRequire("dX8hZ")));
function $111c97b9891df0d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ReleaseIcon.
 * This component is ReleaseIcon, with `UNSAFE_fallbackIcon` set to "ShipIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $111c97b9891df0d1$var$ReleaseIcon = (props)=>/*#__PURE__*/ $111c97b9891df0d1$var$_react.default.createElement($111c97b9891df0d1$var$_release.default, Object.assign({
        name: "ReleaseIcon",
        LEGACY_fallbackIcon: $111c97b9891df0d1$var$_ship.default
    }, props));
$111c97b9891df0d1$var$ReleaseIcon.displayName = 'ReleaseIconMigration';
var $111c97b9891df0d1$var$_default = module.exports.default = $111c97b9891df0d1$var$ReleaseIcon;

});
parcelRegister("dUTVo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b5b008ccfed50bccf7a8bb78b89f8a48>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a21be2d308c339cc$var$_react = $a21be2d308c339cc$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $a21be2d308c339cc$var$_baseNew = $a21be2d308c339cc$var$_interopRequireDefault((parcelRequire("4Wp5P")));
function $a21be2d308c339cc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Release".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for releases in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a21be2d308c339cc$var$ReleaseIcon = (props)=>/*#__PURE__*/ $a21be2d308c339cc$var$_react.default.createElement($a21be2d308c339cc$var$_baseNew.default, Object.assign({
        name: "ReleaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2h3v2h2a.75.75 0 0 1 .648.372L11.18 7h4.069a.75.75 0 0 1 .646 1.132l-2.887 4.886a2 2 0 0 1-1.722.982H2a2 2 0 0 1-2-2V7.75A.75.75 0 0 1 .75 7H2V4.75A.75.75 0 0 1 2.75 4H4zm-.5 5h5.944L8.57 5.5H3.5zm-2 1.5V12a.5.5 0 0 0 .5.5h9.287a.5.5 0 0 0 .43-.246L13.936 8.5z" clip-rule="evenodd"/>`
    }, props));
$a21be2d308c339cc$var$ReleaseIcon.displayName = 'ReleaseIcon';
var $a21be2d308c339cc$var$_default = module.exports.default = $a21be2d308c339cc$var$ReleaseIcon;

});

parcelRegister("dX8hZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a287371651d1323a$var$_react = $a287371651d1323a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $5HwCG = parcelRequire("5HwCG");
function $a287371651d1323a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a287371651d1323a$var$ShipIcon = (props)=>/*#__PURE__*/ $a287371651d1323a$var$_react.default.createElement($5HwCG.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 12h8v-2H6zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4z"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6zm4 0V7H7.999c.005 0 .002.003.002.005V8h2z"/><path fill-rule="nonzero" d="M4.5 17h13.994l1.002-3H4.14zm-2.495-4.012A.862.862 0 0 1 2.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.15 1.15 0 0 1-1.118-.988z"/></g></svg>`
    }, props));
$a287371651d1323a$var$ShipIcon.displayName = 'ShipIcon';
var $a287371651d1323a$var$_default = module.exports.default = $a287371651d1323a$var$ShipIcon;

});



parcelRegister("9EyEg", function(module, exports) {

$parcel$export(module.exports, "PresenceWrapper", function () { return $7072b9f549c7ce22$export$972c5e90200fa0ef; });
/* presence.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $c8NQt = parcelRequire("c8NQt");

var $7Y5zA = parcelRequire("7Y5zA");
var $7072b9f549c7ce22$var$BusyIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $c8NQt.R300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $c8NQt.N0), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $7072b9f549c7ce22$var$FocusIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $c8NQt.P300), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $7072b9f549c7ce22$var$OfflineIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $c8NQt.N200), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $c8NQt.N40), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $7072b9f549c7ce22$var$OnlineIndicator = /*#__PURE__*/ $8ZuGG.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $c8NQt.G300), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $7072b9f549c7ce22$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $7072b9f549c7ce22$var$BusyIndicator;
        case 'focus':
            return $7072b9f549c7ce22$var$FocusIndicator;
        case 'offline':
            return $7072b9f549c7ce22$var$OfflineIndicator;
        case 'online':
            return $7072b9f549c7ce22$var$OnlineIndicator;
    }
}
/**
 * __Avatar presence__
 *
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage)
 */ var $7072b9f549c7ce22$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $7Y5zA.default), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ $8ZuGG.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $7072b9f549c7ce22$var$getPresence(presence)) : children);
};
var $7072b9f549c7ce22$export$2e2bcd8739ae039 = $7072b9f549c7ce22$var$AvatarPresence;
var $7072b9f549c7ce22$var$styles = {
    root: "_kqswstnw _lcxvglyw"
};
var $7072b9f549c7ce22$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $7072b9f549c7ce22$var$iconOffsetMap = {
    square: "_94n5myb0 _1xi2myb0",
    small: "_94n5idpf _1xi2idpf",
    medium: "_94n5idpf _1xi2idpf",
    large: "_94n5t94y _1xi2t94y",
    xlarge: "_94n51v6z _1xi21v6z"
};
var $7072b9f549c7ce22$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        className: (0, $c4hjl.default)([
            $7072b9f549c7ce22$var$styles.root,
            $7072b9f549c7ce22$var$iconSizeMap[size],
            $7072b9f549c7ce22$var$iconOffsetMap[size],
            appearance === 'square' && $7072b9f549c7ce22$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement($7072b9f549c7ce22$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};

});
parcelRegister("c8NQt", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $8d6ce59fa9009c38$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $8d6ce59fa9009c38$export$2010d0fb4295b346; });
$parcel$export(module.exports, "G300", function () { return $8d6ce59fa9009c38$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $8d6ce59fa9009c38$export$a49394138f7b8e85; });
$parcel$export(module.exports, "P300", function () { return $8d6ce59fa9009c38$export$b48405b95304b5a1; });
$parcel$export(module.exports, "N0", function () { return $8d6ce59fa9009c38$export$29a4f05edc054374; });
$parcel$export(module.exports, "N40", function () { return $8d6ce59fa9009c38$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N200", function () { return $8d6ce59fa9009c38$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N500", function () { return $8d6ce59fa9009c38$export$c39c0fe0f26207ae; });
// Reds
var $8d6ce59fa9009c38$export$4b84fd0e2c617bd = '#FFEBE6';
var $8d6ce59fa9009c38$export$b34b069eff244586 = '#FFBDAD';
var $8d6ce59fa9009c38$export$be802dd0d8b57f35 = '#FF8F73';
var $8d6ce59fa9009c38$export$60847d42f9da92a6 = '#FF7452';
var $8d6ce59fa9009c38$export$4a7404f376229999 = '#FF5630';
var $8d6ce59fa9009c38$export$2010d0fb4295b346 = '#DE350B';
var $8d6ce59fa9009c38$export$2837b5a1a71d5c02 = '#BF2600';
var $8d6ce59fa9009c38$export$8d9596b529bbb9cf = '#FFFAE6';
var $8d6ce59fa9009c38$export$41060a744ab0b7ae = '#FFF0B3';
var $8d6ce59fa9009c38$export$1cc05bbbf340e559 = '#FFE380';
var $8d6ce59fa9009c38$export$5aae31392d72caaa = '#FFC400';
var $8d6ce59fa9009c38$export$c6930421db9fa514 = '#FFAB00';
var $8d6ce59fa9009c38$export$59619663aa6500fb = '#FF991F';
var $8d6ce59fa9009c38$export$874739ea9e379ab6 = '#FF8B00';
var $8d6ce59fa9009c38$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $8d6ce59fa9009c38$export$69a3bf21b9686c2b = '#ABF5D1';
var $8d6ce59fa9009c38$export$afbce1382ec95f73 = '#79F2C0';
var $8d6ce59fa9009c38$export$747d86715d4175de = '#57D9A3';
var $8d6ce59fa9009c38$export$940e1f69e873f202 = '#36B37E';
var $8d6ce59fa9009c38$export$a49394138f7b8e85 = '#00875A';
var $8d6ce59fa9009c38$export$6fa04827ac68a4fb = '#006644';
var $8d6ce59fa9009c38$export$226de0355ed012f8 = '#DEEBFF';
var $8d6ce59fa9009c38$export$8c13c2ee36917869 = '#B3D4FF';
var $8d6ce59fa9009c38$export$ecfc1dff386a3e7a = '#4C9AFF';
var $8d6ce59fa9009c38$export$215b7063051591f1 = '#2684FF';
var $8d6ce59fa9009c38$export$e62e8919cca44969 = '#0065FF';
var $8d6ce59fa9009c38$export$b3de0ae08da2ce64 = '#0052CC';
var $8d6ce59fa9009c38$export$a6ee3d71bc067634 = '#0747A6';
var $8d6ce59fa9009c38$export$67f15409e87642a1 = '#669DF1';
var $8d6ce59fa9009c38$export$f0539dbc42dbb067 = '#8FB8F6';
var $8d6ce59fa9009c38$export$363e4475840015bb = '#EAE6FF';
var $8d6ce59fa9009c38$export$4b0a4417ed59760f = '#C0B6F2';
var $8d6ce59fa9009c38$export$6011520a64d9a187 = '#998DD9';
var $8d6ce59fa9009c38$export$a7175d4e9206bc80 = '#8777D9';
var $8d6ce59fa9009c38$export$b48405b95304b5a1 = '#6554C0';
var $8d6ce59fa9009c38$export$c71e4279dd54a18d = '#5243AA';
var $8d6ce59fa9009c38$export$147899de772240ec = '#403294';
var $8d6ce59fa9009c38$export$2cf711fe14c66f06 = '#E6FCFF';
var $8d6ce59fa9009c38$export$7a8f4d33f6f9772c = '#B3F5FF';
var $8d6ce59fa9009c38$export$776c9c497ef08533 = '#79E2F2';
var $8d6ce59fa9009c38$export$69cb3ca10c1e330e = '#00C7E6';
var $8d6ce59fa9009c38$export$9dc1ef0f3f48059b = '#00B8D9';
var $8d6ce59fa9009c38$export$7c835c78b6fcdef8 = '#00A3BF';
var $8d6ce59fa9009c38$export$6036577f95c3877e = '#008DA6';
var $8d6ce59fa9009c38$export$29a4f05edc054374 = '#FFFFFF';
var $8d6ce59fa9009c38$export$e655ef011c4aa1a2 = '#FAFBFC';
var $8d6ce59fa9009c38$export$9fdfb749e33cdf97 = '#F4F5F7';
var $8d6ce59fa9009c38$export$3e51e8f1440314ba = '#EBECF0';
var $8d6ce59fa9009c38$export$1ce2d1575d444ceb = '#DFE1E6';
var $8d6ce59fa9009c38$export$8754fc7e6d8b3000 = '#C1C7D0';
var $8d6ce59fa9009c38$export$c2e91cbeada39b8b = '#B3BAC5';
var $8d6ce59fa9009c38$export$5f71e19f3a7ad9de = '#A5ADBA';
var $8d6ce59fa9009c38$export$eaa8c8a70ac22806 = '#97A0AF';
var $8d6ce59fa9009c38$export$7c87d337fb91a97d = '#8993A4';
var $8d6ce59fa9009c38$export$d6447c357493214f = '#7A869A';
var $8d6ce59fa9009c38$export$f563ee71e9ee74cd = '#6B778C';
var $8d6ce59fa9009c38$export$e2ef2124cf4024b1 = '#5E6C84';
var $8d6ce59fa9009c38$export$eece5f492e429f08 = '#505F79';
var $8d6ce59fa9009c38$export$c39c0fe0f26207ae = '#42526E';
var $8d6ce59fa9009c38$export$7090862dc3038a9f = '#344563';
var $8d6ce59fa9009c38$export$ad0bacf983b7ddaa = '#253858';
var $8d6ce59fa9009c38$export$7d61b15e0da132af = '#172B4D';
var $8d6ce59fa9009c38$export$fbda843f0a27fe96 = '#091E42';
var $8d6ce59fa9009c38$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $8d6ce59fa9009c38$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $8d6ce59fa9009c38$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $8d6ce59fa9009c38$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $8d6ce59fa9009c38$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $8d6ce59fa9009c38$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $8d6ce59fa9009c38$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $8d6ce59fa9009c38$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $8d6ce59fa9009c38$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $8d6ce59fa9009c38$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $8d6ce59fa9009c38$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $8d6ce59fa9009c38$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $8d6ce59fa9009c38$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $8d6ce59fa9009c38$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $8d6ce59fa9009c38$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $8d6ce59fa9009c38$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $8d6ce59fa9009c38$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $8d6ce59fa9009c38$export$2f6319cf7d736c2a = '#E6EDFA';
var $8d6ce59fa9009c38$export$95126bc8884d6634 = '#DCE5F5';
var $8d6ce59fa9009c38$export$8338d8c35d44ff1 = '#CED9EB';
var $8d6ce59fa9009c38$export$5368d76ae4fbbda7 = '#B8C7E0';
var $8d6ce59fa9009c38$export$9f0a771d16ec8d36 = '#ABBBD6';
var $8d6ce59fa9009c38$export$abcf8c38338b4aa5 = '#9FB0CC';
var $8d6ce59fa9009c38$export$97e81faa16a182c7 = '#8C9CB8';
var $8d6ce59fa9009c38$export$bfe21c59123ecf33 = '#7988A3';
var $8d6ce59fa9009c38$export$ee82aa2ea6a1558 = '#67758F';
var $8d6ce59fa9009c38$export$682927c6ed76be02 = '#56637A';
var $8d6ce59fa9009c38$export$91fd9994c5be9757 = '#455166';
var $8d6ce59fa9009c38$export$d281fbfe3cff2df6 = '#3B475C';
var $8d6ce59fa9009c38$export$3902c91d8b98a753 = '#313D52';
var $8d6ce59fa9009c38$export$8e8133c1ba5845b5 = '#283447';
var $8d6ce59fa9009c38$export$33ff357f6620b39 = '#202B3D';
var $8d6ce59fa9009c38$export$633847cf062b69e0 = '#1B2638';
var $8d6ce59fa9009c38$export$9776a6e503bdbf76 = '#121A29';
var $8d6ce59fa9009c38$export$6c813d5160dff5db = '#0E1624';
var $8d6ce59fa9009c38$export$3d4f271a500072a = '#0D1424';
var $8d6ce59fa9009c38$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $8d6ce59fa9009c38$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $8d6ce59fa9009c38$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $8d6ce59fa9009c38$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $8d6ce59fa9009c38$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $8d6ce59fa9009c38$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $8d6ce59fa9009c38$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $8d6ce59fa9009c38$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $8d6ce59fa9009c38$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $8d6ce59fa9009c38$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $8d6ce59fa9009c38$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $8d6ce59fa9009c38$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $8d6ce59fa9009c38$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $8d6ce59fa9009c38$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $8d6ce59fa9009c38$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $8d6ce59fa9009c38$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $8d6ce59fa9009c38$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $8d6ce59fa9009c38$export$d2adc5dedf09fced = '#292A2E';
var $8d6ce59fa9009c38$export$f51762073d2bb381 = '#94C748';
var $8d6ce59fa9009c38$export$95e26d54def96891 = '#B3DF72';

});

parcelRegister("7Y5zA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5cd275a986abb15a$export$2e2bcd8739ae039; });
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $5cd275a986abb15a$var$styles = {
    root: "_2rko1qll _1reo15vq _18m915vq _189e1bk5 _1dqonqa1 _1e0c1txw _vchhusvi _1bsb1osq _4t3i1osq _4cvr1h6o _ae4v1h6o _bfhk1bhr"
};
var $5cd275a986abb15a$var$unboundStyles = {
    root: "_1h6d1bhr"
};
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $5cd275a986abb15a$var$IconWrapper = function IconWrapper(_ref) {
    var bgColor = _ref.bgColor, children = _ref.children;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        role: "presentation",
        style: {
            borderColor: bgColor,
            backgroundColor: bgColor
        },
        className: (0, $c4hjl.default)([
            $5cd275a986abb15a$var$styles.root,
            $5cd275a986abb15a$var$unboundStyles.root
        ])
    }, children);
};
var $5cd275a986abb15a$export$2e2bcd8739ae039 = $5cd275a986abb15a$var$IconWrapper;

});


parcelRegister("eRrtb", function(module, exports) {

$parcel$export(module.exports, "StatusWrapper", function () { return $ad1b52da8d7a91cc$export$8045894f255f9726; });
/* status.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $c8NQt = parcelRequire("c8NQt");

var $7Y5zA = parcelRequire("7Y5zA");
var $ad1b52da8d7a91cc$var$styles = {
    root: "_kqswstnw"
};
var $ad1b52da8d7a91cc$var$iconSizeMap = {
    small: "_4t3i1crf _1bsb1crf",
    medium: "_4t3idlk8 _1bsbdlk8",
    large: "_4t3io7ao _1bsbo7ao",
    xlarge: "_4t3if6fq _1bsbf6fq"
};
var $ad1b52da8d7a91cc$var$iconOffsetMap = {
    square: "_1xi2idpf _154iidpf",
    small: "_1xi2idpf _154iidpf",
    medium: "_1xi2idpf _154iidpf",
    large: "_1xi2t94y _154it94y",
    xlarge: "_1xi21v6z _154i1v6z"
};
var $ad1b52da8d7a91cc$var$ApprovedIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $c8NQt.G400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $c8NQt.N0), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $ad1b52da8d7a91cc$var$DeclinedIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $c8NQt.R400), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $c8NQt.N0), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $ad1b52da8d7a91cc$var$LockedIndicator = /*#__PURE__*/ $8ZuGG.createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ $8ZuGG.createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $c8NQt.N40), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ $8ZuGG.createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $c8NQt.N500), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $ad1b52da8d7a91cc$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $ad1b52da8d7a91cc$var$ApprovedIndicator;
        case 'declined':
            return $ad1b52da8d7a91cc$var$DeclinedIndicator;
        case 'locked':
            return $ad1b52da8d7a91cc$var$LockedIndicator;
    }
}
/**
 * __Avatar status__
 *
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code)
 */ var $ad1b52da8d7a91cc$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $7Y5zA.default), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ $8ZuGG.createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $ad1b52da8d7a91cc$var$getStatus(status)) : children);
};
var $ad1b52da8d7a91cc$export$2e2bcd8739ae039 = $ad1b52da8d7a91cc$var$AvatarStatus;
var $ad1b52da8d7a91cc$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        className: (0, $c4hjl.default)([
            $ad1b52da8d7a91cc$var$styles.root,
            $ad1b52da8d7a91cc$var$iconSizeMap[size],
            $ad1b52da8d7a91cc$var$iconOffsetMap[size],
            appearance === 'square' && $ad1b52da8d7a91cc$var$iconOffsetMap['square']
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement($ad1b52da8d7a91cc$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};

});

parcelRegister("iM0sL", function(module, exports) {

$parcel$export(module.exports, "getCustomElement", function () { return $daad119f55048014$export$83ee468102cdf04c; });
var $daad119f55048014$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};

});



parcelRegister("fLB9o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $898dd6bc1bdf1ccc$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $898dd6bc1bdf1ccc$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    logoutTitle: {
        id: 'logout.title',
        defaultMessage: 'Log out of your Atlassian account'
    }
});

});

parcelRegister("a8rGb", function(module, exports) {

$parcel$export(module.exports, "manageSession", function () { return $c472b6fe46713b56$export$66e31b319f474a64; });
$parcel$export(module.exports, "continueWithCurrentSession", function () { return $c472b6fe46713b56$export$5e0dba42c9dac553; });
$parcel$export(module.exports, "doLogout", function () { return $c472b6fe46713b56$export$61d11f3cbabcb5f4; });

var $ty6PY = parcelRequire("ty6PY");

var $jSnDV = parcelRequire("jSnDV");

var $8FHU2 = parcelRequire("8FHU2");

var $8f2pb = parcelRequire("8f2pb");
const $c472b6fe46713b56$export$66e31b319f474a64 = (request, navigate, additionalParameters = {})=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch({
            type: 'SESSION_REQUEST'
        });
        return fetch(`/rest/session`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json().then((data)=>{
                if (response.ok) {
                    const redirectUrl = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parseUrl(data.redirectUrl);
                    const currentParameters = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
                    const mergedQuery = (0, $ty6PY._)({}, currentParameters, additionalParameters, redirectUrl.query);
                    return navigate(`${redirectUrl.url}?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(mergedQuery)}`);
                } else (0, $8f2pb.captureErrorMessage)('manageSession failed', {
                    statusCode: response.status,
                    formErrors: data.formErrors
                });
            }));
    };
const $c472b6fe46713b56$export$5e0dba42c9dac553 = (navigate)=>async ()=>{
        navigate(`/login${$c472b6fe46713b56$var$getSanitizedQueryString()}`);
    };
const $c472b6fe46713b56$export$61d11f3cbabcb5f4 = (continueUrl)=>async (dispatch, getState)=>{
        const state = getState();
        // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
        (0, $8FHU2.default)({
            method: 'POST',
            action: `/logout${$c472b6fe46713b56$var$getSanitizedQueryString(continueUrl)}`,
            payload: {
                csrfToken: state.hashedCsrfToken
            }
        });
    };
const $c472b6fe46713b56$var$getSanitizedQueryString = (continueUrl)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
    delete params.login_hint;
    delete params.prompt;
    if (continueUrl) params.continue = continueUrl;
    const paramsString = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(params);
    return paramsString && `?${paramsString}`;
};

});
parcelRegister("8FHU2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7fe475ec19d31e5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "submitFormHackReplacement", function () { return $b7fe475ec19d31e5$export$79d03e6f07528b0a; });
/**
 * This is the type definition for the submitFormHack as-is, so that I can re-use it in the replacement function.
 */ 
var $ty6PY = parcelRequire("ty6PY");
function $b7fe475ec19d31e5$export$2e2bcd8739ae039({ method: method, action: action = '', payload: payload, skipSanitizationKeys: skipSanitizationKeys = [] }) {
    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = method;
    form.action = action;
    if (payload) Object.entries(payload).filter(([, value])=>value != null).forEach(([name, value])=>{
        const input = document.createElement('input');
        input.name = $b7fe475ec19d31e5$var$sanitizeInput(name);
        input.value = skipSanitizationKeys.includes(name) ? String(value) : $b7fe475ec19d31e5$var$sanitizeInput(String(value));
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
/**
 * This function takes an input string, assigns it to the textContent property of a newly created div,
 * and then returns the sanitized HTML content of the div. Since textContent does not parse HTML,
 * any harmful tags or scripts in the input will be treated as plain text, not as code.
 *
 * i.e.:
 * sanitizeInput("<script>window.alert('hi')</script>") -> "&lt;script&gt;window.alert('hi')&lt;/script&gt;"
 *
 * https://asecurityteam.atlassian.net/browse/VULN-1229071
 */ function $b7fe475ec19d31e5$var$sanitizeInput(input) {
    const div = document.createElement('div');
    div.textContent = input;
    return div.innerHTML;
}
function $b7fe475ec19d31e5$export$79d03e6f07528b0a({ method: method = 'POST', action: action = '', payload: payload, csrfToken: csrfToken, enablePassingCookies: enablePassingCookies = false }) {
    const requestPromise = fetch(action, {
        method: method,
        headers: (0, $ty6PY._)({
            'Content-Type': 'application/json'
        }, csrfToken ? {
            'X-CSRF-TOKEN': csrfToken
        } : {}, enablePassingCookies ? {
            credentials: 'same-origin'
        } : {}),
        body: JSON.stringify(payload)
    });
    return requestPromise;
}

});



parcelRegister("lGfVq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $dfa500857acb6b4e$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpSsoLoader", function () { return $dfa500857acb6b4e$export$947a31480e10f4f8; });
$parcel$export(module.exports, "StepUpSsoPage", function () { return $dfa500857acb6b4e$export$61fae207a78c2e53; });
$parcel$export(module.exports, "default", function () { return $dfa500857acb6b4e$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $7CMue = parcelRequire("7CMue");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $pO9YU = parcelRequire("pO9YU");

var $bceLx = parcelRequire("bceLx");

var $day6I = parcelRequire("day6I");

var $kOqgB = parcelRequire("kOqgB");

var $20ogY = parcelRequire("20ogY");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $3ir1n = parcelRequire("3ir1n");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $1SvOA = parcelRequire("1SvOA");

var $7UIb1 = parcelRequire("7UIb1");

var $gJFTu = parcelRequire("gJFTu");

var $8f2pb = parcelRequire("8f2pb");

var $5sqTs = parcelRequire("5sqTs");
var $cQfrC = parcelRequire("cQfrC");
var $iBEMg = parcelRequire("iBEMg");
var $h8BLt = parcelRequire("h8BLt");
var $ghBUC = parcelRequire("ghBUC");
var $gUTCM = parcelRequire("gUTCM");

var $iRVQ8 = parcelRequire("iRVQ8");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
let $dfa500857acb6b4e$var$_ = (t)=>t, $dfa500857acb6b4e$var$t, $dfa500857acb6b4e$var$t1;
const $dfa500857acb6b4e$export$703ba2e7ea526c1b = 'stepUpSsoScreen';
const $dfa500857acb6b4e$var$SecondaryLinkWrapper = (0, $9Vz68.default).ul($dfa500857acb6b4e$var$t || ($dfa500857acb6b4e$var$t = $dfa500857acb6b4e$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $dfa500857acb6b4e$var$PadlockImageContainer = (0, $9Vz68.default).div($dfa500857acb6b4e$var$t1 || ($dfa500857acb6b4e$var$t1 = $dfa500857acb6b4e$var$_`
  background: url(${0}) no-repeat center bottom;
  background-size: contain;
  height: 140px;
  margin: ${0}px 0 ${0}px;
`), (0, (/*@__PURE__*/$parcel$interopDefault($7UIb1))), (0, $5b7Z4.gridSize)(), (0, $5b7Z4.gridSize)() * 2);
async function $dfa500857acb6b4e$export$947a31480e10f4f8({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/step-up/sso/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $dfa500857acb6b4e$export$61fae207a78c2e53 = ()=>{
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    const ssoSamlRedirectUrl = (0, $kOqgB.useAppSelector)((state)=>state.stepUpSso.ssoRedirectUrl);
    const idpDetails = (0, $kOqgB.useAppSelector)((state)=>state.stepUpSso.idp);
    const isMobile = (0, $day6I.isMobileOidc)(oidcContext);
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const returnLoginLink = `/login/select-account${search}`;
    const intl = (0, $iSD9t.default)();
    const [isWarningModalOpen, setWarningModalOpen] = (0, $8ZuGG.useState)(false);
    (0, $8xW40.usePageStateLoader)();
    const eventFlowValue = idpDetails.trusted ? 'trusted-idp' : 'untrusted-idp';
    const shouldOpenWarningModalOnVerify = !idpDetails.trusted && ssoSamlRedirectUrl;
    (0, $3ir1n.usePageViewedEvent)($dfa500857acb6b4e$export$703ba2e7ea526c1b, {
        flow: eventFlowValue
    });
    (0, $3ir1n.useOperationalEvent)({
        page: $dfa500857acb6b4e$export$703ba2e7ea526c1b,
        action: `loadStepUpSsoPageSuccessful`,
        subject: 'sli'
    });
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($dfa500857acb6b4e$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        if (ssoSamlRedirectUrl) navigate(ssoSamlRedirectUrl);
        else {
            (0, $8f2pb.captureErrorMessage)('StepUpSsoPage verify failed: ssoSamlRedirectUrl not available');
            navigate('/login?errorCode=step_up_sso_saml_redirect_url_not_available');
        }
    };
    const openWarningModal = (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($dfa500857acb6b4e$export$703ba2e7ea526c1b, 'verify', {
            flow: eventFlowValue
        });
        setWarningModalOpen(true);
    }, [
        analyticsClient,
        eventFlowValue
    ]);
    const closeWarningModal = (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($dfa500857acb6b4e$export$703ba2e7ea526c1b, 'close-warning-modal');
        setWarningModalOpen(false);
    }, [
        analyticsClient
    ]);
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($dfa500857acb6b4e$export$703ba2e7ea526c1b, 'switchAccount');
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("title", {
                    children: intl.formatMessage((0, $20ogY.default).stepUpSsoHeader)
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
                pageId: $dfa500857acb6b4e$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoHeader), {
                    tagName: "h5"
                })),
                footer: /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                        /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
                    children: !isMobile && /*#__PURE__*/ (0, $6rcps.jsx)("ul", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)($dfa500857acb6b4e$var$SecondaryLinkWrapper, {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoReturnToLogin))
                                })
                            })
                        })
                    })
                }),
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($dfa500857acb6b4e$var$PadlockImageContainer, {}),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoDescription1), {
                        tagName: "p"
                    })),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoDescription2), {
                        tagName: "p"
                    })),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            id: "step-up-sso-button",
                            appearance: "primary",
                            type: 'button',
                            onClick: shouldOpenWarningModalOnVerify ? openWarningModal : handleVerify,
                            isFullWidth: true,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoVerifyButton))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gUTCM.default), {
                children: isWarningModalOpen && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $5sqTs.default), {
                    onClose: closeWarningModal,
                    width: "small",
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $h8BLt.default), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $ghBUC.default), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoWarningModalHeader))
                            })
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsxs)((0, $cQfrC.default), {
                            children: [
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoWarningModalDescription1), {
                                    tagName: "p",
                                    values: {
                                        idpRedirectLocation: /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                            children: idpDetails.humanReadableRedirectLocation
                                        })
                                    }
                                })),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoWarningModalDescription2), {
                                    tagName: "p"
                                }))
                            ]
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsxs)((0, $iBEMg.default), {
                            children: [
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                                    appearance: "subtle",
                                    onClick: closeWarningModal,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $20ogY.default).stepUpWarningCancelButton))
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                                    id: "continue-step-up",
                                    appearance: "primary",
                                    onClick: handleVerify,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $20ogY.default).stepUpSsoWarningLogInButton))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $dfa500857acb6b4e$export$2e2bcd8739ae039 = $dfa500857acb6b4e$export$61fae207a78c2e53;

});
parcelRegister("20ogY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ffcdd3c02e682a4$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $8ffcdd3c02e682a4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    stepUpSsoHeader: {
        id: 'stepUp.sso.header',
        defaultMessage: 'Verify your identity'
    },
    stepUpSsoReturnToLogin: {
        id: 'stepUp.sso.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpSsoDescription1: {
        id: 'stepUp.sso.description1',
        defaultMessage: 'To access this content, you need to log in with single sign-on and verify your identity.'
    },
    stepUpSsoDescription2: {
        id: 'stepUp.sso.description2',
        defaultMessage: "If you\u2019re unable to log in, contact the admin."
    },
    stepUpSsoVerifyButton: {
        id: 'stepUp.sso.button.verify',
        defaultMessage: 'Verify'
    },
    stepUpSsoWarningModalHeader: {
        id: 'stepUp.sso.warning.modal.header',
        defaultMessage: 'Log in to verify identity'
    },
    stepUpSsoWarningModalDescription1: {
        id: 'stepUp.sso.warning.modal.description',
        defaultMessage: "You\u2019re about to leave Atlassian with this external link {idpRedirectLocation}"
    },
    stepUpSsoWarningModalDescription2: {
        id: 'stepUp.sso.warning.modal.description2',
        defaultMessage: 'If you trust the link, then continue to log in with single sign-on.'
    },
    stepUpSsoWarningLogInButton: {
        id: 'stepUp.sso.warning.log.in.button',
        defaultMessage: 'Log in'
    },
    stepUpWarningCancelButton: {
        id: 'stepUp.warning.cancel.button',
        defaultMessage: 'Cancel'
    }
});

});

parcelRegister("5sqTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f946dc564799448$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $izJ3X = parcelRequire("izJ3X");
function $3f946dc564799448$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $izJ3X.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, {
        isFullScreen: false
    }));
}

});
parcelRegister("izJ3X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d85e7368f9ef762d$export$2e2bcd8739ae039; });
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $aZVA2 = parcelRequire("aZVA2");

var $kLJZu = parcelRequire("kLJZu");

var $1Muvn = parcelRequire("1Muvn");

var $yS2bK = parcelRequire("yS2bK");

var $5AVd4 = parcelRequire("5AVd4");

var $8fZ6c = parcelRequire("8fZ6c");

var $gWxJe = parcelRequire("gWxJe");

var $jTcCE = parcelRequire("jTcCE");

var $e056m = parcelRequire("e056m");

var $5fBNd = parcelRequire("5fBNd");

var $jNDuW = parcelRequire("jNDuW");

var $a4m1X = parcelRequire("a4m1X");
var $d85e7368f9ef762d$var$fillScreenStyles = null;
var $d85e7368f9ef762d$var$allowlistElements = function allowlistElements(element, callback) {
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
    // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d85e7368f9ef762d$var$InternalModalWrapper = function InternalModalWrapper(props) {
    var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, focusLockAllowlist = props.focusLockAllowlist, _props$shouldCloseOnE = props.shouldCloseOnEscapePress, shouldCloseOnEscapePress = _props$shouldCloseOnE === void 0 ? true : _props$shouldCloseOnE, _props$shouldCloseOnO = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _props$shouldCloseOnO === void 0 ? true : _props$shouldCloseOnO, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, _props$shouldReturnFo = props.shouldReturnFocus, shouldReturnFocus = _props$shouldReturnFo === void 0 ? true : _props$shouldReturnFo, stackIndexOverride = props.stackIndex, providedOnClose = props.onClose, _props$onStackChange = props.onStackChange, onStackChange = _props$onStackChange === void 0 ? (0, $5AVd4.default) : _props$onStackChange, isBlanketHidden = props.isBlanketHidden, children = props.children, height = props.height, width = props.width, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, label = props.label, testId = props.testId, isFullScreen = props.isFullScreen;
    var calculatedStackIndex = (0, $5fBNd.default)({
        onStackChange: onStackChange
    });
    var stackIndex = stackIndexOverride || calculatedStackIndex;
    var isForeground = stackIndex === 0;
    // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    var autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    var onCloseHandler = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $5AVd4.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "@atlaskit/modal-dialog",
        packageVersion: "0.0.0-development"
    });
    var onBlanketClicked = (0, $8ZuGG.useCallback)(function(e) {
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]);
    // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    var allowListCallback = (0, $8ZuGG.useCallback)(function(element) {
        return $d85e7368f9ef762d$var$allowlistElements(element, focusLockAllowlist);
    }, [
        focusLockAllowlist
    ]);
    (0, $jNDuW.default)();
    var modalDialogWithBlanket = /*#__PURE__*/ $8ZuGG.createElement((0, $yS2bK.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && "".concat(testId, "--blanket")
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $a4m1X.default), {
        testId: testId,
        label: label,
        autoFocus: autoFocus,
        stackIndex: stackIndex,
        onClose: onCloseHandler,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
        shouldScrollInViewport: shouldScrollInViewport,
        height: height,
        width: width,
        onCloseComplete: onCloseComplete,
        onOpenComplete: onOpenComplete,
        hasProvidedOnClose: Boolean(providedOnClose),
        isFullScreen: isFullScreen
    }, children));
    var returnFocus = true;
    var onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = function onDeactivation() {
        window.setTimeout(function() {
            var _shouldReturnFocus$cu;
            (_shouldReturnFocus$cu = shouldReturnFocus.current) === null || _shouldReturnFocus$cu === void 0 || _shouldReturnFocus$cu.focus();
        }, 0);
    };
    return /*#__PURE__*/ $8ZuGG.createElement((0, $8fZ6c.Layering), {
        isDisabled: false
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $jTcCE.default), {
        zIndex: (0, $e056m.layers).modal()
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $gWxJe.default), null, function(fadeInProps) {
        return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, fadeInProps, {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $c4hjl.default)([
                "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                fadeInProps.className
            ]),
            "aria-hidden": !isForeground
        }), /*#__PURE__*/ $8ZuGG.createElement((0, $aZVA2.default), {
            autoFocus: autoFocusLock,
            returnFocus: returnFocus,
            onDeactivation: onDeactivation,
            whiteList: allowListCallback
        }, /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kLJZu))), null), shouldScrollInViewport ? /*#__PURE__*/ $8ZuGG.createElement((0, $kLJZu.TouchScrollable), null, modalDialogWithBlanket) : modalDialogWithBlanket));
    })));
};
var $d85e7368f9ef762d$export$2e2bcd8739ae039 = $d85e7368f9ef762d$var$InternalModalWrapper;

});
parcelRegister("aZVA2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $801c441bc06b1481$export$2e2bcd8739ae039; });

var $erPPx = parcelRequire("erPPx");

var $801c441bc06b1481$export$2e2bcd8739ae039 = (0, $erPPx.default);

});
parcelRegister("erPPx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a84bcab6db476833$export$2e2bcd8739ae039; });

var $4KVmf = parcelRequire("4KVmf");

var $6vRlT = parcelRequire("6vRlT");

var $8ZuGG = parcelRequire("8ZuGG");

var $5zfJm = parcelRequire("5zfJm");

var $6xmyo = parcelRequire("6xmyo");
var $a84bcab6db476833$var$FocusLockCombination = /*#__PURE__*/ $8ZuGG.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5zfJm.default), (0, $6vRlT.default)({
        sideCar: (0, $6xmyo.default),
        ref: ref
    }, props));
});
var $a84bcab6db476833$var$_ref = (0, $5zfJm.default).propTypes || {}, $a84bcab6db476833$var$sideCar = $a84bcab6db476833$var$_ref.sideCar, $a84bcab6db476833$var$propTypes = (0, $4KVmf.default)($a84bcab6db476833$var$_ref, [
    "sideCar"
]);
$a84bcab6db476833$var$FocusLockCombination.propTypes = {};
var $a84bcab6db476833$export$2e2bcd8739ae039 = $a84bcab6db476833$var$FocusLockCombination;

});
parcelRegister("5zfJm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40dc6c697e911737$export$2e2bcd8739ae039; });

var $6vRlT = parcelRequire("6vRlT");

var $8ZuGG = parcelRequire("8ZuGG");


var $cUviw = parcelRequire("cUviw");

var $aexoi = parcelRequire("aexoi");

var $aiZVP = parcelRequire("aiZVP");

var $clSNX = parcelRequire("clSNX");

var $34KR3 = parcelRequire("34KR3");
var $40dc6c697e911737$var$emptyArray = [];
var $40dc6c697e911737$var$FocusLock = /*#__PURE__*/ $8ZuGG.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _React$useState = $8ZuGG.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
    var observed = $8ZuGG.useRef();
    var isActive = $8ZuGG.useRef(false);
    var originalFocusedElement = $8ZuGG.useRef(null);
    var _React$useState2 = $8ZuGG.useState({}), update = _React$useState2[1];
    var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? $40dc6c697e911737$var$emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? 'div' : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
    var _React$useState3 = $8ZuGG.useState({}), id = _React$useState3[0];
    var onActivation = $8ZuGG.useCallback(function(_ref) {
        var captureFocusRestore = _ref.captureFocusRestore;
        if (!originalFocusedElement.current) {
            var _document;
            var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
            originalFocusedElement.current = activeElement;
            if (activeElement !== document.body) originalFocusedElement.current = captureFocusRestore(activeElement);
        }
        if (observed.current && onActivationCallback) onActivationCallback(observed.current);
        isActive.current = true;
        update();
    }, [
        onActivationCallback
    ]);
    var onDeactivation = $8ZuGG.useCallback(function() {
        isActive.current = false;
        if (onDeactivationCallback) onDeactivationCallback(observed.current);
        update();
    }, [
        onDeactivationCallback
    ]);
    var returnFocus = $8ZuGG.useCallback(function(allowDefer) {
        var focusRestore = originalFocusedElement.current;
        if (focusRestore) {
            var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
            var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
            if (howToReturnFocus) {
                var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
                originalFocusedElement.current = null;
                if (allowDefer) Promise.resolve().then(function() {
                    return returnFocusTo.focus(returnFocusOptions);
                });
                else returnFocusTo.focus(returnFocusOptions);
            }
        }
    }, [
        shouldReturnFocus
    ]);
    var onFocus = $8ZuGG.useCallback(function(event) {
        if (isActive.current) (0, $clSNX.mediumFocus).useMedium(event);
    }, []);
    var onBlur = (0, $clSNX.mediumBlur).useMedium;
    var setObserveNode = $8ZuGG.useCallback(function(newObserved) {
        if (observed.current !== newObserved) {
            observed.current = newObserved;
            setObserved(newObserved);
        }
    }, []);
    var lockProps = (0, $6vRlT.default)((_extends2 = {}, _extends2[$cUviw.FOCUS_DISABLED] = disabled && 'disabled', _extends2[$cUviw.FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = (0, $aexoi.useMergeRefs)([
        parentRef,
        setObserveNode
    ]);
    var focusScopeValue = $8ZuGG.useMemo(function() {
        return {
            observed: observed,
            shards: shards,
            enabled: !disabled,
            active: isActive.current
        };
    }, [
        disabled,
        isActive.current,
        shards,
        realObserved
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, hasLeadingGuards && [
        /*#__PURE__*/ $8ZuGG.createElement("div", {
            key: "guard-first",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 0,
            style: (0, $aiZVP.hiddenGuard)
        }),
        hasPositiveIndices ? /*#__PURE__*/ $8ZuGG.createElement("div", {
            key: "guard-nearest",
            "data-focus-guard": true,
            tabIndex: disabled ? -1 : 1,
            style: (0, $aiZVP.hiddenGuard)
        }) : null
    ], !disabled && /*#__PURE__*/ $8ZuGG.createElement(SideCar, {
        id: id,
        sideCar: (0, $clSNX.mediumSidecar),
        observed: realObserved,
        disabled: disabled,
        persistentFocus: persistentFocus,
        crossFrame: crossFrame,
        autoFocus: autoFocus,
        whiteList: whiteList,
        shards: shards,
        onActivation: onActivation,
        onDeactivation: onDeactivation,
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }), /*#__PURE__*/ $8ZuGG.createElement(Container, (0, $6vRlT.default)({
        ref: mergedRef
    }, lockProps, {
        className: className,
        onBlur: onBlur,
        onFocus: onFocus
    }), /*#__PURE__*/ $8ZuGG.createElement((0, $34KR3.focusScope).Provider, {
        value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-focus-guard": true,
        tabIndex: disabled ? -1 : 0,
        style: (0, $aiZVP.hiddenGuard)
    }));
});
$40dc6c697e911737$var$FocusLock.propTypes = {};
var $40dc6c697e911737$export$2e2bcd8739ae039 = $40dc6c697e911737$var$FocusLock;

});
parcelRegister("cUviw", function(module, exports) {

$parcel$export(module.exports, "FOCUS_GROUP", function () { return $9662fe17d4072a4c$export$4f9a06cb7441a087; });
$parcel$export(module.exports, "FOCUS_DISABLED", function () { return $9662fe17d4072a4c$export$aeda8252e54b50f7; });
$parcel$export(module.exports, "FOCUS_ALLOW", function () { return $9662fe17d4072a4c$export$54ecf528c58f9ef6; });
$parcel$export(module.exports, "FOCUS_AUTO", function () { return $9662fe17d4072a4c$export$70e9b4a1820af101; });
$parcel$export(module.exports, "FOCUS_NO_AUTOFOCUS", function () { return $9662fe17d4072a4c$export$134ebef29fd94853; });
/**
 * defines a focus group
 */ var $9662fe17d4072a4c$export$4f9a06cb7441a087 = 'data-focus-lock';
var $9662fe17d4072a4c$export$aeda8252e54b50f7 = 'data-focus-lock-disabled';
var $9662fe17d4072a4c$export$54ecf528c58f9ef6 = 'data-no-focus-lock';
var $9662fe17d4072a4c$export$70e9b4a1820af101 = 'data-autofocus-inside';
var $9662fe17d4072a4c$export$134ebef29fd94853 = 'data-no-autofocus';

});

parcelRegister("aexoi", function(module, exports) {

$parcel$export(module.exports, "useMergeRefs", function () { return $77351ce60581061a$export$74665b213cb5c4cf; });

var $8ZuGG = parcelRequire("8ZuGG");

var $keOpX = parcelRequire("keOpX");

var $d5uGO = parcelRequire("d5uGO");
var $77351ce60581061a$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $8ZuGG.useLayoutEffect : $8ZuGG.useEffect;
var $77351ce60581061a$var$currentValues = new WeakMap();
function $77351ce60581061a$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $d5uGO.useCallbackRef)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $keOpX.assignRef)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $77351ce60581061a$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $77351ce60581061a$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $keOpX.assignRef)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $keOpX.assignRef)(ref, current_1);
            });
        }
        $77351ce60581061a$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}

});
parcelRegister("keOpX", function(module, exports) {

$parcel$export(module.exports, "assignRef", function () { return $ebbc3960c8f1803a$export$d734136a7b018efe; });
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $ebbc3960c8f1803a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}

});

parcelRegister("d5uGO", function(module, exports) {

$parcel$export(module.exports, "useCallbackRef", function () { return $98738c4fbee7c663$export$25bec8c6f54ee79a; });

var $8ZuGG = parcelRequire("8ZuGG");
function $98738c4fbee7c663$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $8ZuGG.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

});


parcelRegister("aiZVP", function(module, exports) {

$parcel$export(module.exports, "hiddenGuard", function () { return $780ba0273a0bf456$export$b8c7b07253306600; });

var $8ZuGG = parcelRequire("8ZuGG");

var $780ba0273a0bf456$export$b8c7b07253306600 = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
};
var $780ba0273a0bf456$var$InFocusGuard = function InFocusGuard(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement("div", {
        key: "guard-first",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $780ba0273a0bf456$export$b8c7b07253306600
    }), children, children && /*#__PURE__*/ $8ZuGG.createElement("div", {
        key: "guard-last",
        "data-focus-guard": true,
        "data-focus-auto-guard": true,
        style: $780ba0273a0bf456$export$b8c7b07253306600
    }));
};
$780ba0273a0bf456$var$InFocusGuard.propTypes = {};
var $780ba0273a0bf456$export$2e2bcd8739ae039 = $780ba0273a0bf456$var$InFocusGuard;

});

parcelRegister("clSNX", function(module, exports) {

$parcel$export(module.exports, "mediumFocus", function () { return $8fe1f54f7264125f$export$5733e022b1d538cb; });
$parcel$export(module.exports, "mediumBlur", function () { return $8fe1f54f7264125f$export$b3e9a9312f73723c; });
$parcel$export(module.exports, "mediumEffect", function () { return $8fe1f54f7264125f$export$3a1d52767cbc07b8; });
$parcel$export(module.exports, "mediumSidecar", function () { return $8fe1f54f7264125f$export$892cbf28e5518020; });

var $a1daE = parcelRequire("a1daE");
var $8fe1f54f7264125f$export$5733e022b1d538cb = (0, $a1daE.createMedium)({}, function(_ref) {
    var target = _ref.target, currentTarget = _ref.currentTarget;
    return {
        target: target,
        currentTarget: currentTarget
    };
});
var $8fe1f54f7264125f$export$b3e9a9312f73723c = (0, $a1daE.createMedium)();
var $8fe1f54f7264125f$export$3a1d52767cbc07b8 = (0, $a1daE.createMedium)();
var $8fe1f54f7264125f$export$892cbf28e5518020 = (0, $a1daE.createSidecarMedium)({
    async: true,
    ssr: typeof document !== 'undefined'
});

});
parcelRegister("a1daE", function(module, exports) {

$parcel$export(module.exports, "createMedium", function () { return $74b436cdbdb51804$export$9ffbfcaf067b02c6; });
$parcel$export(module.exports, "createSidecarMedium", function () { return $74b436cdbdb51804$export$e13ec7dd7a14088d; });

var $67Ijb = parcelRequire("67Ijb");
function $74b436cdbdb51804$var$ItoI(a) {
    return a;
}
function $74b436cdbdb51804$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $74b436cdbdb51804$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $74b436cdbdb51804$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $74b436cdbdb51804$var$ItoI;
    return $74b436cdbdb51804$var$innerCreateMedium(defaults, middleware);
}
function $74b436cdbdb51804$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $74b436cdbdb51804$var$innerCreateMedium(null);
    medium.options = (0, $67Ijb.__assign)({
        async: true,
        ssr: false
    }, options);
    return medium;
}

});


parcelRegister("34KR3", function(module, exports) {

$parcel$export(module.exports, "focusScope", function () { return $23d61732162445cc$export$f5272e9b1168239c; });

var $8ZuGG = parcelRequire("8ZuGG");
var $23d61732162445cc$export$f5272e9b1168239c = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);

});


parcelRegister("6xmyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c2751dceb931a85$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");


var $dQveO = parcelRequire("dQveO");

var $4TUgo = parcelRequire("4TUgo");
var $fThKE = parcelRequire("fThKE");
var $exR5C = parcelRequire("exR5C");
var $29MZV = parcelRequire("29MZV");
var $39vkO = parcelRequire("39vkO");parcelRequire("JAufa");
var $7iAMM = parcelRequire("7iAMM");

var $9R2o4 = parcelRequire("9R2o4");

var $clSNX = parcelRequire("clSNX");
var $4c2751dceb931a85$var$focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
};
var $4c2751dceb931a85$var$isFreeFocus = function isFreeFocus() {
    return $4c2751dceb931a85$var$focusOnBody() || (0, $39vkO.focusIsHidden)();
};
var $4c2751dceb931a85$var$lastActiveTrap = null;
var $4c2751dceb931a85$var$lastActiveFocus = null;
var $4c2751dceb931a85$var$lastPortaledElement = null;
var $4c2751dceb931a85$var$focusWasOutsideWindow = false;
var $4c2751dceb931a85$var$defaultWhitelist = function defaultWhitelist() {
    return true;
};
var $4c2751dceb931a85$var$focusWhitelisted = function focusWhitelisted(activeElement) {
    return ($4c2751dceb931a85$var$lastActiveTrap.whiteList || $4c2751dceb931a85$var$defaultWhitelist)(activeElement);
};
var $4c2751dceb931a85$var$recordPortal = function recordPortal(observerNode, portaledElement) {
    $4c2751dceb931a85$var$lastPortaledElement = {
        observerNode: observerNode,
        portaledElement: portaledElement
    };
};
var $4c2751dceb931a85$var$focusIsPortaledPair = function focusIsPortaledPair(element) {
    return $4c2751dceb931a85$var$lastPortaledElement && $4c2751dceb931a85$var$lastPortaledElement.portaledElement === element;
};
function $4c2751dceb931a85$var$autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
        var item = allNodes[i];
        if (item.guard) {
            if (item.node.dataset.focusAutoGuard) lastGuard = item;
        } else if (item.lockItem) {
            if (i !== startIndex) return;
            lastGuard = null;
        } else break;
    }while ((i += step) !== end);
    if (lastGuard) lastGuard.node.tabIndex = 0;
}
var $4c2751dceb931a85$var$focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) return Boolean($4c2751dceb931a85$var$focusWasOutsideWindow);
    return $4c2751dceb931a85$var$focusWasOutsideWindow === 'meanwhile';
};
var $4c2751dceb931a85$var$checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
};
var $4c2751dceb931a85$var$withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function(area) {
        return $4c2751dceb931a85$var$checkInHost(activeElement, area, area);
    });
};
var $4c2751dceb931a85$var$activateTrap = function activateTrap() {
    var result = false;
    if ($4c2751dceb931a85$var$lastActiveTrap) {
        var _lastActiveTrap = $4c2751dceb931a85$var$lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
        var workingNode = observed || $4c2751dceb931a85$var$lastPortaledElement && $4c2751dceb931a85$var$lastPortaledElement.portaledElement;
        var activeElement = document && document.activeElement;
        if (workingNode) {
            var workingArea = [
                workingNode
            ].concat(shards.map((0, $9R2o4.extractRef)).filter(Boolean));
            if (!activeElement || $4c2751dceb931a85$var$focusWhitelisted(activeElement)) {
                if (persistentFocus || $4c2751dceb931a85$var$focusWasOutside(crossFrame) || !$4c2751dceb931a85$var$isFreeFocus() || !$4c2751dceb931a85$var$lastActiveFocus && autoFocus) {
                    if (workingNode && !((0, $29MZV.focusInside)(workingArea) || activeElement && $4c2751dceb931a85$var$withinHost(activeElement, workingArea) || $4c2751dceb931a85$var$focusIsPortaledPair(activeElement, workingNode))) {
                        if (document && !$4c2751dceb931a85$var$lastActiveFocus && activeElement && !autoFocus) {
                            if (activeElement.blur) activeElement.blur();
                            document.body.focus();
                        } else {
                            result = (0, $7iAMM.moveFocusInside)(workingArea, $4c2751dceb931a85$var$lastActiveFocus, {
                                focusOptions: focusOptions
                            });
                            $4c2751dceb931a85$var$lastPortaledElement = {};
                        }
                    }
                    $4c2751dceb931a85$var$focusWasOutsideWindow = false;
                    $4c2751dceb931a85$var$lastActiveFocus = document && document.activeElement;
                }
            }
            if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
                var newActiveElement = document && document.activeElement;
                var allNodes = (0, $fThKE.expandFocusableNodes)(workingArea);
                var focusedIndex = allNodes.map(function(_ref) {
                    var node = _ref.node;
                    return node;
                }).indexOf(newActiveElement);
                if (focusedIndex > -1) {
                    allNodes.filter(function(_ref2) {
                        var guard = _ref2.guard, node = _ref2.node;
                        return guard && node.dataset.focusAutoGuard;
                    }).forEach(function(_ref3) {
                        var node = _ref3.node;
                        return node.removeAttribute('tabIndex');
                    });
                    $4c2751dceb931a85$var$autoGuard(focusedIndex, allNodes.length, 1, allNodes);
                    $4c2751dceb931a85$var$autoGuard(focusedIndex, -1, -1, allNodes);
                }
            }
        }
    }
    return result;
};
var $4c2751dceb931a85$var$onTrap = function onTrap(event) {
    if ($4c2751dceb931a85$var$activateTrap() && event) {
        event.stopPropagation();
        event.preventDefault();
    }
};
var $4c2751dceb931a85$var$onBlur = function onBlur() {
    return (0, $9R2o4.deferAction)($4c2751dceb931a85$var$activateTrap);
};
var $4c2751dceb931a85$var$onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) $4c2751dceb931a85$var$recordPortal(currentNode, source);
};
var $4c2751dceb931a85$var$FocusWatcher = function FocusWatcher() {
    return null;
};
var $4c2751dceb931a85$var$FocusTrap = function FocusTrap(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        onBlur: $4c2751dceb931a85$var$onBlur,
        onFocus: $4c2751dceb931a85$var$onFocus
    }, children);
};
$4c2751dceb931a85$var$FocusTrap.propTypes = {};
var $4c2751dceb931a85$var$onWindowBlur = function onWindowBlur() {
    $4c2751dceb931a85$var$focusWasOutsideWindow = 'just';
    (0, $9R2o4.deferAction)(function() {
        $4c2751dceb931a85$var$focusWasOutsideWindow = 'meanwhile';
    });
};
var $4c2751dceb931a85$var$attachHandler = function attachHandler() {
    document.addEventListener('focusin', $4c2751dceb931a85$var$onTrap);
    document.addEventListener('focusout', $4c2751dceb931a85$var$onBlur);
    window.addEventListener('blur', $4c2751dceb931a85$var$onWindowBlur);
};
var $4c2751dceb931a85$var$detachHandler = function detachHandler() {
    document.removeEventListener('focusin', $4c2751dceb931a85$var$onTrap);
    document.removeEventListener('focusout', $4c2751dceb931a85$var$onBlur);
    window.removeEventListener('blur', $4c2751dceb931a85$var$onWindowBlur);
};
function $4c2751dceb931a85$var$reducePropsToState(propsList) {
    return propsList.filter(function(_ref5) {
        var disabled = _ref5.disabled;
        return !disabled;
    });
}
var $4c2751dceb931a85$var$focusLockAPI = {
    moveFocusInside: (0, $7iAMM.moveFocusInside),
    focusInside: (0, $29MZV.focusInside),
    focusNextElement: (0, $exR5C.focusNextElement),
    focusPrevElement: (0, $exR5C.focusPrevElement),
    focusFirstElement: (0, $exR5C.focusFirstElement),
    focusLastElement: (0, $exR5C.focusLastElement),
    captureFocusRestore: (0, $4TUgo.captureFocusRestore)
};
function $4c2751dceb931a85$var$handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !$4c2751dceb931a85$var$lastActiveTrap) $4c2751dceb931a85$var$attachHandler();
    var lastTrap = $4c2751dceb931a85$var$lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    $4c2751dceb931a85$var$lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
        lastTrap.onDeactivation();
        if (!traps.filter(function(_ref6) {
            var id = _ref6.id;
            return id === lastTrap.id;
        }).length) lastTrap.returnFocus(!trap);
    }
    if (trap) {
        $4c2751dceb931a85$var$lastActiveFocus = null;
        if (!sameTrap || lastTrap.observed !== trap.observed) trap.onActivation($4c2751dceb931a85$var$focusLockAPI);
        $4c2751dceb931a85$var$activateTrap(true);
        (0, $9R2o4.deferAction)($4c2751dceb931a85$var$activateTrap);
    } else {
        $4c2751dceb931a85$var$detachHandler();
        $4c2751dceb931a85$var$lastActiveFocus = null;
    }
}
(0, $clSNX.mediumFocus).assignSyncMedium($4c2751dceb931a85$var$onFocus);
(0, $clSNX.mediumBlur).assignMedium($4c2751dceb931a85$var$onBlur);
(0, $clSNX.mediumEffect).assignMedium(function(cb) {
    return cb($4c2751dceb931a85$var$focusLockAPI);
});
var $4c2751dceb931a85$export$2e2bcd8739ae039 = (0, $dQveO.default)($4c2751dceb931a85$var$reducePropsToState, $4c2751dceb931a85$var$handleStateChangeOnClient)($4c2751dceb931a85$var$FocusWatcher);

});
parcelRegister("dQveO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1485ce9d4b51451$export$2e2bcd8739ae039; });

var $2Ep50 = parcelRequire("2Ep50");

var $kSFIZ = parcelRequire("kSFIZ");

var $8ZuGG = parcelRequire("8ZuGG");
function $a1485ce9d4b51451$var$withSideEffect(reducePropsToState, handleStateChangeOnClient) {
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }
    return function wrap(WrappedComponent) {
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            handleStateChangeOnClient(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            (0, $2Ep50.default)(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            SideEffect.peek = function peek() {
                return state;
            };
            var _proto = SideEffect.prototype;
            _proto.componentDidMount = function componentDidMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }((0, $8ZuGG.PureComponent));
        (0, $kSFIZ.default)(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        return SideEffect;
    };
}
var $a1485ce9d4b51451$export$2e2bcd8739ae039 = $a1485ce9d4b51451$var$withSideEffect;

});
parcelRegister("2Ep50", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ee2c58052661f86$export$2e2bcd8739ae039; });

var $1SsNb = parcelRequire("1SsNb");
function $1ee2c58052661f86$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $1SsNb.default)(t, o);
}

});
parcelRegister("1SsNb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15e12b21683ab79a$export$2e2bcd8739ae039; });
function $15e12b21683ab79a$export$2e2bcd8739ae039(t, e) {
    return $15e12b21683ab79a$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $15e12b21683ab79a$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("4TUgo", function(module, exports) {

$parcel$export(module.exports, "captureFocusRestore", function () { return $3917f138a96707eb$export$d357db6e554ff59a; });

var $2nUsy = parcelRequire("2nUsy");
function $3917f138a96707eb$var$weakRef(value) {
    if (!value) return null;
    // #68 Safari 14.1 dont have it yet
    // FIXME: remove in 2025
    if (typeof WeakRef === 'undefined') return function() {
        return value || null;
    };
    var w = value ? new WeakRef(value) : null;
    return function() {
        return (w === null || w === void 0 ? void 0 : w.deref()) || null;
    };
}
var $3917f138a96707eb$export$5061a7725be48ff9 = function(element) {
    if (!element) return null;
    var stack = [];
    var currentElement = element;
    while(currentElement && currentElement !== document.body){
        stack.push({
            current: $3917f138a96707eb$var$weakRef(currentElement),
            parent: $3917f138a96707eb$var$weakRef(currentElement.parentElement),
            left: $3917f138a96707eb$var$weakRef(currentElement.previousElementSibling),
            right: $3917f138a96707eb$var$weakRef(currentElement.nextElementSibling)
        });
        currentElement = currentElement.parentElement;
    }
    return {
        element: $3917f138a96707eb$var$weakRef(element),
        stack: stack,
        ownerDocument: element.ownerDocument
    };
};
var $3917f138a96707eb$var$restoreFocusTo = function(location) {
    var _a, _b, _c, _d, _e;
    if (!location) return undefined;
    var stack = location.stack, ownerDocument = location.ownerDocument;
    var visibilityCache = new Map();
    for(var _i = 0, stack_1 = stack; _i < stack_1.length; _i++){
        var line = stack_1[_i];
        var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
        // is it still here?
        if (parent_1 && ownerDocument.contains(parent_1)) {
            var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
            var savedCurrent = line.current();
            var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
            var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
            var focusables = (0, $2nUsy.getTabbableNodes)([
                parent_1
            ], visibilityCache);
            var aim = // that is element itself
            (_e = (_d = current !== null && current !== void 0 ? current : // or something in it's place
            left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : // or somebody to the right, still close enough
            right) !== null && _e !== void 0 ? _e : // or somebody to the left, something?
            left;
            while(aim){
                for(var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++){
                    var focusable = focusables_1[_f];
                    if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) return focusable.node;
                }
                aim = aim.nextElementSibling;
            }
            if (focusables.length) // if parent contains a focusable - move there
            return focusables[0].node;
        }
    }
    // nothing matched
    return undefined;
};
var $3917f138a96707eb$export$d357db6e554ff59a = function(targetElement) {
    var location = $3917f138a96707eb$export$5061a7725be48ff9(targetElement);
    return function() {
        return $3917f138a96707eb$var$restoreFocusTo(location);
    };
};

});
parcelRegister("2nUsy", function(module, exports) {

$parcel$export(module.exports, "filterAutoFocusable", function () { return $1bc986702ed0ac88$export$2f70373d403a5d2b; });
$parcel$export(module.exports, "getTabbableNodes", function () { return $1bc986702ed0ac88$export$3738e313571e2ad2; });
$parcel$export(module.exports, "getFocusableNodes", function () { return $1bc986702ed0ac88$export$493d05a3a8e6532d; });
$parcel$export(module.exports, "parentAutofocusables", function () { return $1bc986702ed0ac88$export$dc26309a71d1ce47; });
$parcel$export(module.exports, "contains", function () { return $1bc986702ed0ac88$export$2344b14b097df817; });

var $iKGfS = parcelRequire("iKGfS");

var $bODSs = parcelRequire("bODSs");

var $huc3k = parcelRequire("huc3k");

var $gXRpt = parcelRequire("gXRpt");
var $1bc986702ed0ac88$export$6266a5cd5915dc33 = function(nodes, visibilityCache) {
    return (0, $iKGfS.toArray)(nodes).filter(function(node) {
        return (0, $bODSs.isVisibleCached)(visibilityCache, node);
    }).filter(function(node) {
        return (0, $bODSs.notHiddenInput)(node);
    });
};
var $1bc986702ed0ac88$export$2f70373d403a5d2b = function(nodes, cache) {
    if (cache === void 0) cache = new Map();
    return (0, $iKGfS.toArray)(nodes).filter(function(node) {
        return (0, $bODSs.isAutoFocusAllowedCached)(cache, node);
    });
};
var $1bc986702ed0ac88$export$3738e313571e2ad2 = function(topNodes, visibilityCache, withGuards) {
    return (0, $huc3k.orderByTabIndex)($1bc986702ed0ac88$export$6266a5cd5915dc33((0, $gXRpt.getFocusables)(topNodes, withGuards), visibilityCache), true, withGuards);
};
var $1bc986702ed0ac88$export$493d05a3a8e6532d = function(topNodes, visibilityCache) {
    return (0, $huc3k.orderByTabIndex)($1bc986702ed0ac88$export$6266a5cd5915dc33((0, $gXRpt.getFocusables)(topNodes), visibilityCache), false);
};
var $1bc986702ed0ac88$export$dc26309a71d1ce47 = function(topNode, visibilityCache) {
    return $1bc986702ed0ac88$export$6266a5cd5915dc33((0, $gXRpt.getParentAutofocusables)(topNode), visibilityCache);
};
var $1bc986702ed0ac88$export$2344b14b097df817 = function(scope, element) {
    if (scope.shadowRoot) return $1bc986702ed0ac88$export$2344b14b097df817(scope.shadowRoot, element);
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined && Object.getPrototypeOf(scope).contains.call(scope, element)) return true;
        return (0, $iKGfS.toArray)(scope.children).some(function(child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) return $1bc986702ed0ac88$export$2344b14b097df817(iframeBody, element);
                return false;
            }
            return $1bc986702ed0ac88$export$2344b14b097df817(child, element);
        });
    }
};

});
parcelRegister("iKGfS", function(module, exports) {

$parcel$export(module.exports, "toArray", function () { return $da6d4cd33e02a373$export$45b10814cc054894; });
$parcel$export(module.exports, "asArray", function () { return $da6d4cd33e02a373$export$75093a47a9fa838d; });
$parcel$export(module.exports, "getFirst", function () { return $da6d4cd33e02a373$export$bcd7afcd904dce14; });
/*
IE11 support
 */ var $da6d4cd33e02a373$export$45b10814cc054894 = function(a) {
    var ret = Array(a.length);
    for(var i = 0; i < a.length; ++i)ret[i] = a[i];
    return ret;
};
var $da6d4cd33e02a373$export$75093a47a9fa838d = function(a) {
    return Array.isArray(a) ? a : [
        a
    ];
};
var $da6d4cd33e02a373$export$bcd7afcd904dce14 = function(a) {
    return Array.isArray(a) ? a[0] : a;
};

});

parcelRegister("bODSs", function(module, exports) {

$parcel$export(module.exports, "isVisibleCached", function () { return $89a34c0a07e72979$export$3c9dc299685ad160; });
$parcel$export(module.exports, "isAutoFocusAllowedCached", function () { return $89a34c0a07e72979$export$bcaa50628f6a736e; });
$parcel$export(module.exports, "getDataset", function () { return $89a34c0a07e72979$export$698b339b0c8edae3; });
$parcel$export(module.exports, "isRadioElement", function () { return $89a34c0a07e72979$export$9d74f6fbc6f469d0; });
$parcel$export(module.exports, "notHiddenInput", function () { return $89a34c0a07e72979$export$8197b0ea56b3b055; });
$parcel$export(module.exports, "isGuard", function () { return $89a34c0a07e72979$export$d94b8b58ec2f30eb; });
$parcel$export(module.exports, "isNotAGuard", function () { return $89a34c0a07e72979$export$602e5a0d338d7750; });
$parcel$export(module.exports, "isDefined", function () { return $89a34c0a07e72979$export$4e62c701997796c1; });

var $cUviw = parcelRequire("cUviw");
var $89a34c0a07e72979$var$isElementHidden = function(node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) return false;
    return computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden';
};
var $89a34c0a07e72979$var$getParentNode = function(node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? node.parentNode.host : node.parentNode;
};
var $89a34c0a07e72979$var$isTopNode = function(node) {
    // @ts-ignore
    return node === document || node && node.nodeType === Node.DOCUMENT_NODE;
};
var $89a34c0a07e72979$var$isInert = function(node) {
    return node.hasAttribute('inert');
};
/**
 * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
 */ var $89a34c0a07e72979$var$isVisibleUncached = function(node, checkParent) {
    return !node || $89a34c0a07e72979$var$isTopNode(node) || !$89a34c0a07e72979$var$isElementHidden(node) && !$89a34c0a07e72979$var$isInert(node) && checkParent($89a34c0a07e72979$var$getParentNode(node));
};
var $89a34c0a07e72979$export$3c9dc299685ad160 = function(visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) return cached;
    var result = $89a34c0a07e72979$var$isVisibleUncached(node, $89a34c0a07e72979$export$3c9dc299685ad160.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var $89a34c0a07e72979$var$isAutoFocusAllowedUncached = function(node, checkParent) {
    return node && !$89a34c0a07e72979$var$isTopNode(node) ? $89a34c0a07e72979$export$b8550e27de209d85(node) ? checkParent($89a34c0a07e72979$var$getParentNode(node)) : false : true;
};
var $89a34c0a07e72979$export$bcaa50628f6a736e = function(cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) return cached;
    var result = $89a34c0a07e72979$var$isAutoFocusAllowedUncached(node, $89a34c0a07e72979$export$bcaa50628f6a736e.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var $89a34c0a07e72979$export$698b339b0c8edae3 = function(node) {
    // @ts-ignore
    return node.dataset;
};
var $89a34c0a07e72979$export$65aad1b6bc934b11 = function(node) {
    return node.tagName === 'BUTTON';
};
var $89a34c0a07e72979$export$88a6ceeed5737ba3 = function(node) {
    return node.tagName === 'INPUT';
};
var $89a34c0a07e72979$export$9d74f6fbc6f469d0 = function(node) {
    return $89a34c0a07e72979$export$88a6ceeed5737ba3(node) && node.type === 'radio';
};
var $89a34c0a07e72979$export$8197b0ea56b3b055 = function(node) {
    return !(($89a34c0a07e72979$export$88a6ceeed5737ba3(node) || $89a34c0a07e72979$export$65aad1b6bc934b11(node)) && (node.type === 'hidden' || node.disabled));
};
var $89a34c0a07e72979$export$b8550e27de209d85 = function(node) {
    var attribute = node.getAttribute((0, $cUviw.FOCUS_NO_AUTOFOCUS));
    return ![
        true,
        'true',
        ''
    ].includes(attribute);
};
var $89a34c0a07e72979$export$d94b8b58ec2f30eb = function(node) {
    var _a;
    return Boolean(node && ((_a = $89a34c0a07e72979$export$698b339b0c8edae3(node)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var $89a34c0a07e72979$export$602e5a0d338d7750 = function(node) {
    return !$89a34c0a07e72979$export$d94b8b58ec2f30eb(node);
};
var $89a34c0a07e72979$export$4e62c701997796c1 = function(x) {
    return Boolean(x);
};

});

parcelRegister("huc3k", function(module, exports) {

$parcel$export(module.exports, "orderByTabIndex", function () { return $cbae966c1d0a6a97$export$cb40ee071f0d5226; });

var $iKGfS = parcelRequire("iKGfS");
var $cbae966c1d0a6a97$export$350ee6c095d98996 = function(a, b) {
    var aTab = Math.max(0, a.tabIndex);
    var bTab = Math.max(0, b.tabIndex);
    var tabDiff = aTab - bTab;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!aTab) return 1;
        if (!bTab) return -1;
    }
    return tabDiff || indexDiff;
};
var $cbae966c1d0a6a97$var$getTabIndex = function(node) {
    if (node.tabIndex < 0) {
        // all "focusable" elements are already preselected
        // but some might have implicit negative tabIndex
        // return 0 for <audio without tabIndex attribute - it is "tabbable"
        if (!node.hasAttribute('tabindex')) return 0;
    }
    return node.tabIndex;
};
var $cbae966c1d0a6a97$export$cb40ee071f0d5226 = function(nodes, filterNegative, keepGuards) {
    return (0, $iKGfS.toArray)(nodes).map(function(node, index) {
        var tabIndex = $cbae966c1d0a6a97$var$getTabIndex(node);
        return {
            node: node,
            index: index,
            tabIndex: keepGuards && tabIndex === -1 ? (node.dataset || {}).focusGuard ? 0 : -1 : tabIndex
        };
    }).filter(function(data) {
        return !filterNegative || data.tabIndex >= 0;
    }).sort($cbae966c1d0a6a97$export$350ee6c095d98996);
};

});

parcelRegister("gXRpt", function(module, exports) {

$parcel$export(module.exports, "getFocusables", function () { return $c59b961fde6ff574$export$f6768025e418420e; });
$parcel$export(module.exports, "getParentAutofocusables", function () { return $c59b961fde6ff574$export$853fa94d922e78b9; });

var $cUviw = parcelRequire("cUviw");

var $iKGfS = parcelRequire("iKGfS");

var $047ll = parcelRequire("047ll");
var $c59b961fde6ff574$var$queryTabbables = (0, $047ll.tabbables).join(',');
var $c59b961fde6ff574$var$queryGuardTabbables = "".concat($c59b961fde6ff574$var$queryTabbables, ", [data-focus-guard]");
var $c59b961fde6ff574$var$getFocusablesWithShadowDom = function(parent, withGuards) {
    return (0, $iKGfS.toArray)((parent.shadowRoot || parent).children).reduce(function(acc, child) {
        return acc.concat(child.matches(withGuards ? $c59b961fde6ff574$var$queryGuardTabbables : $c59b961fde6ff574$var$queryTabbables) ? [
            child
        ] : [], $c59b961fde6ff574$var$getFocusablesWithShadowDom(child));
    }, []);
};
var $c59b961fde6ff574$var$getFocusablesWithIFrame = function(parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return $c59b961fde6ff574$export$f6768025e418420e([
        parent.contentDocument.body
    ], withGuards);
    return [
        parent
    ];
};
var $c59b961fde6ff574$export$f6768025e418420e = function(parents, withGuards) {
    return parents.reduce(function(acc, parent) {
        var _a;
        var focusableWithShadowDom = $c59b961fde6ff574$var$getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node) {
            return $c59b961fde6ff574$var$getFocusablesWithIFrame(node, withGuards);
        }));
        return acc.concat(// add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, // add if node is tabbable itself
        parent.parentNode ? (0, $iKGfS.toArray)(parent.parentNode.querySelectorAll($c59b961fde6ff574$var$queryTabbables)).filter(function(node) {
            return node === parent;
        }) : []);
    }, []);
};
var $c59b961fde6ff574$export$853fa94d922e78b9 = function(parent) {
    var parentFocus = parent.querySelectorAll("[".concat((0, $cUviw.FOCUS_AUTO), "]"));
    return (0, $iKGfS.toArray)(parentFocus).map(function(node) {
        return $c59b961fde6ff574$export$f6768025e418420e([
            node
        ]);
    }).reduce(function(acc, nodes) {
        return acc.concat(nodes);
    }, []);
};

});
parcelRegister("047ll", function(module, exports) {

$parcel$export(module.exports, "tabbables", function () { return $00c6121404b6ef09$export$8555f4622e95784; });
/**
 * list of the object to be considered as focusable
 */ var $00c6121404b6ef09$export$8555f4622e95784 = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]'
];

});




parcelRegister("fThKE", function(module, exports) {

$parcel$export(module.exports, "expandFocusableNodes", function () { return $b919c32576353b51$export$f89ac71e91767111; });

var $4wCmV = parcelRequire("4wCmV");

var $bODSs = parcelRequire("bODSs");

var $3dNrZ = parcelRequire("3dNrZ");

var $huc3k = parcelRequire("huc3k");

var $gXRpt = parcelRequire("gXRpt");
var $b919c32576353b51$export$f89ac71e91767111 = function(topNode) {
    var entries = (0, $4wCmV.getAllAffectedNodes)(topNode).filter((0, $bODSs.isNotAGuard));
    var commonParent = (0, $3dNrZ.getTopCommonParent)(topNode, topNode, entries);
    var outerNodes = (0, $huc3k.orderByTabIndex)((0, $gXRpt.getFocusables)([
        commonParent
    ], true), true, true);
    var innerElements = (0, $gXRpt.getFocusables)(entries, false);
    return outerNodes.map(function(_a) {
        var node = _a.node, index = _a.index;
        return {
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: (0, $bODSs.isGuard)(node)
        };
    });
};

});
parcelRegister("4wCmV", function(module, exports) {

$parcel$export(module.exports, "getAllAffectedNodes", function () { return $34b7e9d0c576b65b$export$7e87c4720b9b279b; });

var $cUviw = parcelRequire("cUviw");

var $iKGfS = parcelRequire("iKGfS");
/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */ var $34b7e9d0c576b65b$var$filterNested = function(nodes) {
    var contained = new Set();
    var l = nodes.length;
    for(var i = 0; i < l; i += 1)for(var j = i + 1; j < l; j += 1){
        var position = nodes[i].compareDocumentPosition(nodes[j]);
        /* eslint-disable no-bitwise */ if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) contained.add(j);
        if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) contained.add(i);
    /* eslint-enable */ }
    return nodes.filter(function(_, index) {
        return !contained.has(index);
    });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */ var $34b7e9d0c576b65b$var$getTopParent = function(node) {
    return node.parentNode ? $34b7e9d0c576b65b$var$getTopParent(node.parentNode) : node;
};
var $34b7e9d0c576b65b$export$7e87c4720b9b279b = function(node) {
    var nodes = (0, $iKGfS.asArray)(node);
    return nodes.filter(Boolean).reduce(function(acc, currentNode) {
        var group = currentNode.getAttribute((0, $cUviw.FOCUS_GROUP));
        acc.push.apply(acc, group ? $34b7e9d0c576b65b$var$filterNested((0, $iKGfS.toArray)($34b7e9d0c576b65b$var$getTopParent(currentNode).querySelectorAll("[".concat((0, $cUviw.FOCUS_GROUP), "=\"").concat(group, "\"]:not([").concat((0, $cUviw.FOCUS_DISABLED), "=\"disabled\"])")))) : [
            currentNode
        ]);
        return acc;
    }, []);
};

});

parcelRegister("3dNrZ", function(module, exports) {

$parcel$export(module.exports, "getTopCommonParent", function () { return $2588f1d90b262766$export$a9a7252b5f2e280e; });
$parcel$export(module.exports, "allParentAutofocusables", function () { return $2588f1d90b262766$export$8f99714c70a37db1; });

var $2nUsy = parcelRequire("2nUsy");

var $iKGfS = parcelRequire("iKGfS");
var $2588f1d90b262766$var$getParents = function(node, parents) {
    if (parents === void 0) parents = [];
    parents.push(node);
    if (node.parentNode) $2588f1d90b262766$var$getParents(node.parentNode.host || node.parentNode, parents);
    return parents;
};
var $2588f1d90b262766$export$a08e5f53769bce53 = function(nodeA, nodeB) {
    var parentsA = $2588f1d90b262766$var$getParents(nodeA);
    var parentsB = $2588f1d90b262766$var$getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for(var i = 0; i < parentsA.length; i += 1){
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) return currentParent;
    }
    return false;
};
var $2588f1d90b262766$export$a9a7252b5f2e280e = function(baseActiveElement, leftEntry, rightEntries) {
    var activeElements = (0, $iKGfS.asArray)(baseActiveElement);
    var leftEntries = (0, $iKGfS.asArray)(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function(entry) {
        topCommon = $2588f1d90b262766$export$a08e5f53769bce53(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function(subEntry) {
            var common = $2588f1d90b262766$export$a08e5f53769bce53(activeElement, subEntry);
            if (common) {
                if (!topCommon || (0, $2nUsy.contains)(common, topCommon)) topCommon = common;
                else topCommon = $2588f1d90b262766$export$a08e5f53769bce53(common, topCommon);
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
var $2588f1d90b262766$export$8f99714c70a37db1 = function(entries, visibilityCache) {
    return entries.reduce(function(acc, node) {
        return acc.concat((0, $2nUsy.parentAutofocusables)(node, visibilityCache));
    }, []);
};

});


parcelRegister("exR5C", function(module, exports) {

$parcel$export(module.exports, "focusNextElement", function () { return $a96d543f6d195c78$export$3b0237e8566c8d65; });
$parcel$export(module.exports, "focusPrevElement", function () { return $a96d543f6d195c78$export$33b47db07a82b2fb; });
$parcel$export(module.exports, "focusFirstElement", function () { return $a96d543f6d195c78$export$2a791d8097a66406; });
$parcel$export(module.exports, "focusLastElement", function () { return $a96d543f6d195c78$export$6a79073ddabfd6c3; });

var $kWK2n = parcelRequire("kWK2n");

var $2nUsy = parcelRequire("2nUsy");

var $iKGfS = parcelRequire("iKGfS");
var $a96d543f6d195c78$export$1b42c72592537703 = function(element, scope, useTabbables) {
    if (!element || !scope) {
        console.error('no element or scope given');
        return {};
    }
    var shards = (0, $iKGfS.asArray)(scope);
    if (shards.every(function(shard) {
        return !(0, $2nUsy.contains)(shard, element);
    })) {
        console.error('Active element is not contained in the scope');
        return {};
    }
    var focusables = useTabbables ? (0, $2nUsy.getTabbableNodes)(shards, new Map()) : (0, $2nUsy.getFocusableNodes)(shards, new Map());
    var current = focusables.findIndex(function(_a) {
        var node = _a.node;
        return node === element;
    });
    if (current === -1) // an edge case, when anchor element is not found
    return undefined;
    return {
        prev: focusables[current - 1],
        next: focusables[current + 1],
        first: focusables[0],
        last: focusables[focusables.length - 1]
    };
};
var $a96d543f6d195c78$var$getBoundary = function(shards, useTabbables) {
    var set = useTabbables ? (0, $2nUsy.getTabbableNodes)((0, $iKGfS.asArray)(shards), new Map()) : (0, $2nUsy.getFocusableNodes)((0, $iKGfS.asArray)(shards), new Map());
    return {
        first: set[0],
        last: set[set.length - 1]
    };
};
var $a96d543f6d195c78$var$defaultOptions = function(options) {
    return Object.assign({
        scope: document.body,
        cycle: true,
        onlyTabbable: true
    }, options);
};
var $a96d543f6d195c78$var$moveFocus = function(fromElement, options, cb) {
    if (options === void 0) options = {};
    var newOptions = $a96d543f6d195c78$var$defaultOptions(options);
    var solution = $a96d543f6d195c78$export$1b42c72592537703(fromElement, newOptions.scope, newOptions.onlyTabbable);
    if (!solution) return;
    var target = cb(solution, newOptions.cycle);
    if (target) (0, $kWK2n.focusOn)(target.node, newOptions.focusOptions);
};
var $a96d543f6d195c78$export$3b0237e8566c8d65 = function(fromElement, options) {
    if (options === void 0) options = {};
    $a96d543f6d195c78$var$moveFocus(fromElement, options, function(_a, cycle) {
        var next = _a.next, first = _a.first;
        return next || cycle && first;
    });
};
var $a96d543f6d195c78$export$33b47db07a82b2fb = function(fromElement, options) {
    if (options === void 0) options = {};
    $a96d543f6d195c78$var$moveFocus(fromElement, options, function(_a, cycle) {
        var prev = _a.prev, last = _a.last;
        return prev || cycle && last;
    });
};
var $a96d543f6d195c78$var$pickBoundary = function(scope, options, what) {
    var _a;
    var boundary = $a96d543f6d195c78$var$getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
    var node = boundary[what];
    if (node) (0, $kWK2n.focusOn)(node.node, options.focusOptions);
};
var $a96d543f6d195c78$export$2a791d8097a66406 = function(scope, options) {
    if (options === void 0) options = {};
    $a96d543f6d195c78$var$pickBoundary(scope, options, 'first');
};
var $a96d543f6d195c78$export$6a79073ddabfd6c3 = function(scope, options) {
    if (options === void 0) options = {};
    $a96d543f6d195c78$var$pickBoundary(scope, options, 'last');
};

});
parcelRegister("kWK2n", function(module, exports) {

$parcel$export(module.exports, "focusOn", function () { return $f3fcef76b9ceef23$export$c12b3da842c43a8; });
var $f3fcef76b9ceef23$export$c12b3da842c43a8 = function(target, focusOptions) {
    if (!target) // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
    return;
    if ('focus' in target) target.focus(focusOptions);
    if ('contentWindow' in target && target.contentWindow) target.contentWindow.focus();
};

});


parcelRegister("29MZV", function(module, exports) {

$parcel$export(module.exports, "focusInside", function () { return $19226dfa7b3f69d3$export$20115f8da7baa6fa; });

var $2nUsy = parcelRequire("2nUsy");

var $4wCmV = parcelRequire("4wCmV");

var $iKGfS = parcelRequire("iKGfS");

var $2VRae = parcelRequire("2VRae");
var $19226dfa7b3f69d3$var$focusInFrame = function(frame, activeElement) {
    return frame === activeElement;
};
var $19226dfa7b3f69d3$var$focusInsideIframe = function(topNode, activeElement) {
    return Boolean((0, $iKGfS.toArray)(topNode.querySelectorAll('iframe')).some(function(node) {
        return $19226dfa7b3f69d3$var$focusInFrame(node, activeElement);
    }));
};
var $19226dfa7b3f69d3$export$20115f8da7baa6fa = function(topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) activeElement = (0, $2VRae.getActiveElement)((0, $iKGfS.getFirst)(topNode).ownerDocument);
    if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) return false;
    return (0, $4wCmV.getAllAffectedNodes)(topNode).some(function(node) {
        return (0, $2nUsy.contains)(node, activeElement) || $19226dfa7b3f69d3$var$focusInsideIframe(node, activeElement);
    });
};

});
parcelRegister("2VRae", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", function () { return $222a24e729061e58$export$cd4e5573fbe2b576; });
/**
 * returns active element from document or from nested shadowdoms
 */ 
var $39vwt = parcelRequire("39vwt");
var $222a24e729061e58$export$cd4e5573fbe2b576 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    if (!inDocument || !inDocument.activeElement) return undefined;
    var activeElement = inDocument.activeElement;
    return activeElement.shadowRoot ? $222a24e729061e58$export$cd4e5573fbe2b576(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && (0, $39vwt.safeProbe)(function() {
        return activeElement.contentWindow.document;
    }) ? $222a24e729061e58$export$cd4e5573fbe2b576(activeElement.contentWindow.document) : activeElement;
};

});
parcelRegister("39vwt", function(module, exports) {

$parcel$export(module.exports, "safeProbe", function () { return $24baaa24c42c59a0$export$78d20aae35adef88; });
var $24baaa24c42c59a0$export$78d20aae35adef88 = function(cb) {
    try {
        return cb();
    } catch (e) {
        return undefined;
    }
};

});



parcelRegister("39vkO", function(module, exports) {

$parcel$export(module.exports, "focusIsHidden", function () { return $24ba84cacd2a44c4$export$be6b21806d3fd485; });

var $cUviw = parcelRequire("cUviw");

var $2nUsy = parcelRequire("2nUsy");

var $iKGfS = parcelRequire("iKGfS");

var $2VRae = parcelRequire("2VRae");
var $24ba84cacd2a44c4$export$be6b21806d3fd485 = function(inDocument) {
    if (inDocument === void 0) inDocument = document;
    var activeElement = (0, $2VRae.getActiveElement)(inDocument);
    if (!activeElement) return false;
    // this does not support setting FOCUS_ALLOW within shadow dom
    return (0, $iKGfS.toArray)(inDocument.querySelectorAll("[".concat((0, $cUviw.FOCUS_ALLOW), "]"))).some(function(node) {
        return (0, $2nUsy.contains)(node, activeElement);
    });
};

});

parcelRegister("JAufa", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return (parcelRequire("7iAMM")).moveFocusInside; });

var $cUviw = parcelRequire("cUviw");

var $29MZV = parcelRequire("29MZV");

var $39vkO = parcelRequire("39vkO");


var $fThKE = parcelRequire("fThKE");

var $7iAMM = parcelRequire("7iAMM");

var $4TUgo = parcelRequire("4TUgo");

var $exR5C = parcelRequire("exR5C");

/**
 * magic symbols to control focus behavior from DOM
 * see description of every particular one
 */ var $0890819a46df5b2f$export$1a988e7317c65621 = $cUviw;
/**
 * @deprecated - please use {@link moveFocusInside} named export
 */ var $0890819a46df5b2f$var$deprecated_default_moveFocusInside = (0, $7iAMM.moveFocusInside);
var $0890819a46df5b2f$export$2e2bcd8739ae039 //
 = $0890819a46df5b2f$var$deprecated_default_moveFocusInside;

});
parcelRegister("7iAMM", function(module, exports) {

$parcel$export(module.exports, "moveFocusInside", function () { return $5506bfb58df41e0b$export$cd599851e879a025; });

var $kWK2n = parcelRequire("kWK2n");

var $gn3lV = parcelRequire("gn3lV");
var $5506bfb58df41e0b$var$guardCount = 0;
var $5506bfb58df41e0b$var$lockDisabled = false;
var $5506bfb58df41e0b$export$cd599851e879a025 = function(topNode, lastNode, options) {
    if (options === void 0) options = {};
    var focusable = (0, $gn3lV.focusSolver)(topNode, lastNode);
    // global local side effect to countain recursive lock activation and resolve focus-fighting
    if ($5506bfb58df41e0b$var$lockDisabled) return;
    if (focusable) {
        /** +FOCUS-FIGHTING prevention **/ if ($5506bfb58df41e0b$var$guardCount > 2) {
            // we have recursive entered back the lock activation
            console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
            $5506bfb58df41e0b$var$lockDisabled = true;
            setTimeout(function() {
                $5506bfb58df41e0b$var$lockDisabled = false;
            }, 1);
            return;
        }
        $5506bfb58df41e0b$var$guardCount++;
        (0, $kWK2n.focusOn)(focusable.node, options.focusOptions);
        $5506bfb58df41e0b$var$guardCount--;
    }
};

});
parcelRegister("gn3lV", function(module, exports) {

$parcel$export(module.exports, "focusSolver", function () { return $beb1651a360e9408$export$305758c744b57f6f; });

var $abA12 = parcelRequire("abA12");

var $2nUsy = parcelRequire("2nUsy");

var $4wCmV = parcelRequire("4wCmV");

var $iKGfS = parcelRequire("iKGfS");

var $1BHXI = parcelRequire("1BHXI");

var $2VRae = parcelRequire("2VRae");

var $bODSs = parcelRequire("bODSs");

var $3dNrZ = parcelRequire("3dNrZ");
var $beb1651a360e9408$var$reorderNodes = function(srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function(entity) {
        return remap.set(entity.node, entity);
    });
    // remap to dstNodes
    return srcNodes.map(function(node) {
        return remap.get(node);
    }).filter((0, $bODSs.isDefined));
};
var $beb1651a360e9408$export$305758c744b57f6f = function(topNode, lastNode) {
    var activeElement = (0, $2VRae.getActiveElement)((0, $iKGfS.asArray)(topNode).length > 0 ? document : (0, $iKGfS.getFirst)(topNode).ownerDocument);
    var entries = (0, $4wCmV.getAllAffectedNodes)(topNode).filter((0, $bODSs.isNotAGuard));
    var commonParent = (0, $3dNrZ.getTopCommonParent)(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = (0, $2nUsy.getFocusableNodes)(entries, visibilityCache);
    var innerElements = anyFocusable.filter(function(_a) {
        var node = _a.node;
        return (0, $bODSs.isNotAGuard)(node);
    });
    if (!innerElements[0]) return undefined;
    var outerNodes = (0, $2nUsy.getFocusableNodes)([
        commonParent
    ], visibilityCache).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = $beb1651a360e9408$var$reorderNodes(outerNodes, innerElements);
    // collect inner focusable and separately tabbables
    var innerFocusables = orderedInnerElements.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var innerTabbable = orderedInnerElements.filter(function(_a) {
        var tabIndex = _a.tabIndex;
        return tabIndex >= 0;
    }).map(function(_a) {
        var node = _a.node;
        return node;
    });
    var newId = (0, $abA12.newFocus)(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
    if (newId === (0, $abA12.NEW_FOCUS)) {
        var focusNode = // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
        (0, $1BHXI.pickAutofocus)(anyFocusable, innerTabbable, (0, $3dNrZ.allParentAutofocusables)(entries, visibilityCache)) || (0, $1BHXI.pickAutofocus)(anyFocusable, innerFocusables, (0, $3dNrZ.allParentAutofocusables)(entries, visibilityCache));
        if (focusNode) return {
            node: focusNode
        };
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) return newId;
    return orderedInnerElements[newId];
};

});
parcelRegister("abA12", function(module, exports) {

$parcel$export(module.exports, "NEW_FOCUS", function () { return $76a6de757eceb300$export$85710b12cf912438; });
$parcel$export(module.exports, "newFocus", function () { return $76a6de757eceb300$export$65842178e9bb4205; });

var $6Dq2U = parcelRequire("6Dq2U");

var $f48B6 = parcelRequire("f48B6");

var $bODSs = parcelRequire("bODSs");
var $76a6de757eceb300$export$85710b12cf912438 = 'NEW_FOCUS';
var $76a6de757eceb300$export$65842178e9bb4205 = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = (0, $bODSs.isGuard)(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) return undefined;
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    // no active focus (or focus is on the body)
    if (activeIndex === -1) {
        // known fallback
        if (lastNodeInside !== -1) return lastNodeInside;
        return $76a6de757eceb300$export$85710b12cf912438;
    }
    // new focus, nothing to calculate
    if (lastNodeInside === -1) return $76a6de757eceb300$export$85710b12cf912438;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = (0, $6Dq2U.correctNodes)(outerNodes);
    var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
    var tabbableNodes = correctedNodes.filter(function(node) {
        return node.tabIndex >= 0;
    });
    var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
    var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
    var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0 ? previousTabbableIndex - currentTabbableIndex : previousFocusableIndex - currentFocusableIndex;
    // old focus
    if (!indexDiff && lastNodeInside >= 0) return lastNodeInside;
    // no tabbable elements, autofocus is not possible
    if (innerTabbables.length === 0) // an edge case with no tabbable elements
    // return the last focusable one
    // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
    return lastNodeInside;
    var returnFirstNode = (0, $f48B6.pickFocusable)(innerNodes, innerTabbables[0]);
    var returnLastNode = (0, $f48B6.pickFocusable)(innerNodes, innerTabbables[innerTabbables.length - 1]);
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnLastNode;
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) return returnFirstNode;
    // jump out, but not on the guard
    if (indexDiff && Math.abs(focusIndexDiff) > 1) return lastNodeInside;
    // focus above lock
    if (activeIndex <= firstNodeIndex) return returnLastNode;
    // focus below lock
    if (activeIndex > lastNodeIndex) return returnFirstNode;
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) return lastNodeInside;
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

});
parcelRegister("6Dq2U", function(module, exports) {

$parcel$export(module.exports, "correctNode", function () { return $4d4a96c0a7719514$export$5261662167ad7ced; });
$parcel$export(module.exports, "correctNodes", function () { return $4d4a96c0a7719514$export$4a5a72a7124e45f9; });

var $bODSs = parcelRequire("bODSs");
var $4d4a96c0a7719514$var$findSelectedRadio = function(node, nodes) {
    return nodes.filter((0, $bODSs.isRadioElement)).filter(function(el) {
        return el.name === node.name;
    }).filter(function(el) {
        return el.checked;
    })[0] || node;
};
var $4d4a96c0a7719514$export$5261662167ad7ced = function(node, nodes) {
    if ((0, $bODSs.isRadioElement)(node) && node.name) return $4d4a96c0a7719514$var$findSelectedRadio(node, nodes);
    return node;
};
var $4d4a96c0a7719514$export$4a5a72a7124e45f9 = function(nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function(node) {
        return resultSet.add($4d4a96c0a7719514$export$5261662167ad7ced(node, nodes));
    });
    // using filter to support IE11
    return nodes.filter(function(node) {
        return resultSet.has(node);
    });
};

});

parcelRegister("f48B6", function(module, exports) {

$parcel$export(module.exports, "pickFirstFocus", function () { return $af7de5ffb2980ed8$export$f4e86cfa0679b9cc; });
$parcel$export(module.exports, "pickFocusable", function () { return $af7de5ffb2980ed8$export$e06728ee87c96122; });

var $6Dq2U = parcelRequire("6Dq2U");
var $af7de5ffb2980ed8$export$f4e86cfa0679b9cc = function(nodes) {
    if (nodes[0] && nodes.length > 1) return (0, $6Dq2U.correctNode)(nodes[0], nodes);
    return nodes[0];
};
var $af7de5ffb2980ed8$export$e06728ee87c96122 = function(nodes, node) {
    return nodes.indexOf((0, $6Dq2U.correctNode)(node, nodes));
};

});


parcelRegister("1BHXI", function(module, exports) {

$parcel$export(module.exports, "pickAutofocus", function () { return $12bb5922477e28b6$export$cfb742983e257555; });

var $2nUsy = parcelRequire("2nUsy");

var $f48B6 = parcelRequire("f48B6");

var $bODSs = parcelRequire("bODSs");
var $12bb5922477e28b6$var$findAutoFocused = function(autoFocusables) {
    return function(node) {
        var _a;
        var autofocus = (_a = (0, $bODSs.getDataset)(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return(// @ts-expect-error
        node.autofocus || //
        autofocus !== undefined && autofocus !== 'false' || //
        autoFocusables.indexOf(node) >= 0);
    };
};
var $12bb5922477e28b6$export$cfb742983e257555 = function(nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function(_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = (0, $2nUsy.filterAutoFocusable)(nodes.filter($12bb5922477e28b6$var$findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) return (0, $f48B6.pickFirstFocus)(autoFocusable);
    return (0, $f48B6.pickFirstFocus)((0, $2nUsy.filterAutoFocusable)(orderedNodes));
};

});




parcelRegister("9R2o4", function(module, exports) {

$parcel$export(module.exports, "deferAction", function () { return $72caea56a1209cd7$export$6523025722806278; });
$parcel$export(module.exports, "extractRef", function () { return $72caea56a1209cd7$export$c613fed06e332533; });
function $72caea56a1209cd7$export$6523025722806278(action) {
    setTimeout(action, 1);
}
var $72caea56a1209cd7$export$db10c343af3f20fa = function inlineProp(name, value) {
    var obj = {};
    obj[name] = value;
    return obj;
};
var $72caea56a1209cd7$export$c613fed06e332533 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};

});




parcelRegister("kLJZu", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i3Ge4 = parcelRequire("i3Ge4");
Object.defineProperty(module.exports, 'default', {
    enumerable: true,
    get: function get() {
        return $f1ebdf41c263553c$var$_interopRequireDefault($i3Ge4).default;
    }
});

var $nwv8Y = parcelRequire("nwv8Y");
Object.defineProperty(module.exports, 'TouchScrollable', {
    enumerable: true,
    get: function get() {
        return $nwv8Y.TouchScrollable;
    }
});
function $f1ebdf41c263553c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("i3Ge4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d259430564ca7a2e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8ZuGG = parcelRequire("8ZuGG");
var $d259430564ca7a2e$var$_react2 = $d259430564ca7a2e$var$_interopRequireDefault($8ZuGG);

var $6LDWb = parcelRequire("6LDWb");

var $nwv8Y = parcelRequire("nwv8Y");

var $8Njmg = parcelRequire("8Njmg");
var $d259430564ca7a2e$var$_withLockSheet2 = $d259430564ca7a2e$var$_interopRequireDefault($8Njmg);

var $8Kfpa = parcelRequire("8Kfpa");
var $d259430564ca7a2e$var$_withTouchListeners2 = $d259430564ca7a2e$var$_interopRequireDefault($8Kfpa);

var $p5kZQ = parcelRequire("p5kZQ");
function $d259430564ca7a2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d259430564ca7a2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d259430564ca7a2e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d259430564ca7a2e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d259430564ca7a2e$var$ScrollLock = function(_PureComponent) {
    $d259430564ca7a2e$var$_inherits(ScrollLock, _PureComponent);
    function ScrollLock() {
        $d259430564ca7a2e$var$_classCallCheck(this, ScrollLock);
        return $d259430564ca7a2e$var$_possibleConstructorReturn(this, (ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).apply(this, arguments));
    }
    $d259430564ca7a2e$var$_createClass(ScrollLock, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$6LDWb.canUseDOM) return;
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var offset = window.innerHeight - this.initialHeight;
                // adjust scroll if the window has been resized since the lock was engaged
                // e.g. mobile safari dynamic chrome heights
                if (offset) window.scrollTo(0, window.pageYOffset + offset);
                // reset the initial height in case this scroll lock is used again
                this.initialHeight = window.innerHeight;
            }
        },
        {
            key: 'render',
            value: function render() {
                var children = this.props.children;
                return children ? $d259430564ca7a2e$var$_react2.default.createElement($nwv8Y.TouchScrollable, null, children) : null;
            }
        }
    ]);
    return ScrollLock;
}($8ZuGG.PureComponent);
// attach the stylesheet and inject styles on [un]mount
var $d259430564ca7a2e$var$compose = (0, $p5kZQ.pipe)($d259430564ca7a2e$var$_withTouchListeners2.default, $d259430564ca7a2e$var$_withLockSheet2.default);
var $d259430564ca7a2e$var$SheetLock = $d259430564ca7a2e$var$compose($d259430564ca7a2e$var$ScrollLock);
// toggle the lock based on `isActive` prop
var $d259430564ca7a2e$var$LockToggle = function LockToggle(props) {
    return props.isActive ? $d259430564ca7a2e$var$_react2.default.createElement($d259430564ca7a2e$var$SheetLock, props) : props.children;
};
$d259430564ca7a2e$var$LockToggle.defaultProps = {
    accountForScrollbars: true,
    children: null,
    isActive: true
};
module.exports.default = $d259430564ca7a2e$var$LockToggle;

});
parcelRegister("6LDWb", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});

parcelRegister("nwv8Y", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TouchScrollable = undefined;
var $046b5c2e8b18cc0b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $046b5c2e8b18cc0b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8ZuGG = parcelRequire("8ZuGG");

var $6LDWb = parcelRequire("6LDWb");

var $p5kZQ = parcelRequire("p5kZQ");
function $046b5c2e8b18cc0b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $046b5c2e8b18cc0b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $046b5c2e8b18cc0b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $046b5c2e8b18cc0b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $046b5c2e8b18cc0b$var$TouchScrollable = module.exports.TouchScrollable = function(_PureComponent) {
    $046b5c2e8b18cc0b$var$_inherits(TouchScrollable, _PureComponent);
    function TouchScrollable() {
        var _ref;
        var _temp, _this, _ret;
        $046b5c2e8b18cc0b$var$_classCallCheck(this, TouchScrollable);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $046b5c2e8b18cc0b$var$_possibleConstructorReturn(this, (_ref = TouchScrollable.__proto__ || Object.getPrototypeOf(TouchScrollable)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.getScrollableArea = function(ref) {
            _this.scrollableArea = ref;
        }, _temp), $046b5c2e8b18cc0b$var$_possibleConstructorReturn(_this, _ret);
    }
    $046b5c2e8b18cc0b$var$_createClass(TouchScrollable, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                if (!$6LDWb.canUseEventListeners) return;
                this.scrollableArea.addEventListener('touchstart', $p5kZQ.preventInertiaScroll, $p5kZQ.listenerOptions);
                this.scrollableArea.addEventListener('touchmove', $p5kZQ.allowTouchMove, $p5kZQ.listenerOptions);
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (!$6LDWb.canUseEventListeners) return;
                this.scrollableArea.removeEventListener('touchstart', $p5kZQ.preventInertiaScroll, $p5kZQ.listenerOptions);
                this.scrollableArea.removeEventListener('touchmove', $p5kZQ.allowTouchMove, $p5kZQ.listenerOptions);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, rest = $046b5c2e8b18cc0b$var$_objectWithoutProperties(_props, [
                    'children'
                ]);
                return typeof children === 'function' ? children(this.getScrollableArea) : (0, $8ZuGG.cloneElement)(children, $046b5c2e8b18cc0b$var$_extends({
                    ref: this.getScrollableArea
                }, rest));
            }
        }
    ]);
    return TouchScrollable;
}($8ZuGG.PureComponent);

});
parcelRegister("p5kZQ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pipe = module.exports.listenerOptions = undefined;
module.exports.preventTouchMove = $04b679dc69ce2b47$var$preventTouchMove;
module.exports.allowTouchMove = $04b679dc69ce2b47$var$allowTouchMove;
module.exports.preventInertiaScroll = $04b679dc69ce2b47$var$preventInertiaScroll;
module.exports.isTouchDevice = $04b679dc69ce2b47$var$isTouchDevice;
module.exports.camelToKebab = $04b679dc69ce2b47$var$camelToKebab;
module.exports.parse = $04b679dc69ce2b47$var$parse;
module.exports.getPadding = $04b679dc69ce2b47$var$getPadding;
module.exports.getWindowHeight = $04b679dc69ce2b47$var$getWindowHeight;
module.exports.getDocumentHeight = $04b679dc69ce2b47$var$getDocumentHeight;
module.exports.makeStyleTag = $04b679dc69ce2b47$var$makeStyleTag;
module.exports.injectStyles = $04b679dc69ce2b47$var$injectStyles;
module.exports.insertStyleTag = $04b679dc69ce2b47$var$insertStyleTag;

var $6LDWb = parcelRequire("6LDWb");
var $04b679dc69ce2b47$var$listenerOptions = module.exports.listenerOptions = {
    capture: false,
    passive: false
};
// ==============================
// Touch Helpers
// ==============================
function $04b679dc69ce2b47$var$preventTouchMove(e) {
    e.preventDefault();
    return false;
}
function $04b679dc69ce2b47$var$allowTouchMove(e) {
    var target = e.currentTarget;
    if (target.scrollHeight > target.clientHeight) {
        e.stopPropagation();
        return true;
    }
    e.preventDefault();
    return false;
}
function $04b679dc69ce2b47$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $04b679dc69ce2b47$var$isTouchDevice() {
    if (!$6LDWb.canUseDOM) return false;
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
// ==============================
// Misc.
// ==============================
function $04b679dc69ce2b47$var$camelToKebab(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}
function $04b679dc69ce2b47$var$parse(val) {
    return isNaN(val) ? val : val + 'px';
}
// Take a list of functions and return a function that applies the list of
// functions from left to right
var $04b679dc69ce2b47$var$pipeFns = function pipeFns(a, b) {
    return function() {
        return b(a.apply(undefined, arguments));
    };
};
var $04b679dc69ce2b47$var$pipe = module.exports.pipe = function pipe() {
    for(var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return fns.reduce($04b679dc69ce2b47$var$pipeFns);
};
// ==============================
// Document Helpers
// ==============================
function $04b679dc69ce2b47$var$getPadding() {
    if (!$6LDWb.canUseDOM) return 0;
    var paddingRight = parseInt(window.getComputedStyle(document.body).paddingRight, 10);
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    return paddingRight + scrollbarWidth;
}
function $04b679dc69ce2b47$var$getWindowHeight() {
    var multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    if ($6LDWb.canUseDOM) return window.innerHeight * multiplier;
}
function $04b679dc69ce2b47$var$getDocumentHeight() {
    if ($6LDWb.canUseDOM) return document.body.clientHeight;
}
// ==============================
// Style Sheets
// ==============================
function $04b679dc69ce2b47$var$makeStyleTag() {
    if (!$6LDWb.canUseDOM) return;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    tag.setAttribute('data-react-scrolllock', '');
    return tag;
}
function $04b679dc69ce2b47$var$injectStyles(tag, css) {
    if (!$6LDWb.canUseDOM) return;
    if (tag.styleSheet) tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $04b679dc69ce2b47$var$insertStyleTag(tag) {
    if (!$6LDWb.canUseDOM) return;
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}

});


parcelRegister("8Njmg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6671ea6ee753e935$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $6671ea6ee753e935$var$withLockSheet;

var $8ZuGG = parcelRequire("8ZuGG");
var $6671ea6ee753e935$var$_react2 = $6671ea6ee753e935$var$_interopRequireDefault($8ZuGG);

var $p5kZQ = parcelRequire("p5kZQ");
function $6671ea6ee753e935$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6671ea6ee753e935$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6671ea6ee753e935$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6671ea6ee753e935$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function $6671ea6ee753e935$var$withLockSheet(WrappedComponent) {
    return function(_PureComponent) {
        $6671ea6ee753e935$var$_inherits(SheetProvider, _PureComponent);
        function SheetProvider() {
            var _ref;
            var _temp, _this, _ret;
            $6671ea6ee753e935$var$_classCallCheck(this, SheetProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $6671ea6ee753e935$var$_possibleConstructorReturn(this, (_ref = SheetProvider.__proto__ || Object.getPrototypeOf(SheetProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.addSheet = function() {
                var styles = _this.getStyles();
                var sheet = (0, $p5kZQ.makeStyleTag)();
                if (!sheet) return;
                (0, $p5kZQ.injectStyles)(sheet, styles);
                (0, $p5kZQ.insertStyleTag)(sheet);
                _this.sheet = sheet;
            }, _this.getStyles = function() {
                var accountForScrollbars = _this.props.accountForScrollbars;
                var height = (0, $p5kZQ.getDocumentHeight)();
                var paddingRight = accountForScrollbars ? (0, $p5kZQ.getPadding)() : null;
                var styles = 'body {\n        box-sizing: border-box !important;\n        overflow: hidden !important;\n        position: relative !important;\n        ' + (height ? 'height: ' + height + 'px !important;' : '') + '\n        ' + (paddingRight ? 'padding-right: ' + paddingRight + 'px !important;' : '') + '\n      }';
                return styles;
            }, _temp), $6671ea6ee753e935$var$_possibleConstructorReturn(_this, _ret);
        }
        $6671ea6ee753e935$var$_createClass(SheetProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    this.addSheet();
                }
            },
            {
                key: 'removeSheet',
                value: function removeSheet() {
                    if (!this.sheet) return;
                    // $FlowFixMe
                    this.sheet.parentNode.removeChild(this.sheet);
                    this.sheet = null;
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    this.removeSheet();
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $6671ea6ee753e935$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return SheetProvider;
    }($8ZuGG.PureComponent);
}

});

parcelRegister("8Kfpa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65de91afe8ae7877$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
module.exports.default = $65de91afe8ae7877$var$withTouchListeners;

var $8ZuGG = parcelRequire("8ZuGG");
var $65de91afe8ae7877$var$_react2 = $65de91afe8ae7877$var$_interopRequireDefault($8ZuGG);

var $6LDWb = parcelRequire("6LDWb");

var $p5kZQ = parcelRequire("p5kZQ");
function $65de91afe8ae7877$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65de91afe8ae7877$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $65de91afe8ae7877$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $65de91afe8ae7877$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Mobile Safari ignores { overflow: hidden } declaration on the body,
// so we have to prevent touchmove events via JS
function $65de91afe8ae7877$var$withTouchListeners(WrappedComponent) {
    return function(_PureComponent) {
        $65de91afe8ae7877$var$_inherits(TouchProvider, _PureComponent);
        function TouchProvider() {
            $65de91afe8ae7877$var$_classCallCheck(this, TouchProvider);
            return $65de91afe8ae7877$var$_possibleConstructorReturn(this, (TouchProvider.__proto__ || Object.getPrototypeOf(TouchProvider)).apply(this, arguments));
        }
        $65de91afe8ae7877$var$_createClass(TouchProvider, [
            {
                key: 'componentDidMount',
                value: function componentDidMount() {
                    if (!$6LDWb.canUseDOM || !(0, $p5kZQ.isTouchDevice)()) return;
                    document.addEventListener('touchmove', $p5kZQ.preventTouchMove, $p5kZQ.listenerOptions);
                }
            },
            {
                key: 'componentWillUnmount',
                value: function componentWillUnmount() {
                    if (!$6LDWb.canUseDOM || !(0, $p5kZQ.isTouchDevice)()) return;
                    document.removeEventListener('touchmove', $p5kZQ.preventTouchMove, $p5kZQ.listenerOptions);
                }
            },
            {
                key: 'render',
                value: function render() {
                    return $65de91afe8ae7877$var$_react2.default.createElement(WrappedComponent, this.props);
                }
            }
        ]);
        return TouchProvider;
    }($8ZuGG.PureComponent);
}

});



parcelRegister("e056m", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $a31505dc1709d7f1$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $ifQOz = parcelRequire("ifQOz");
var $a31505dc1709d7f1$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $a31505dc1709d7f1$export$c93026a968943f95 = 'light';
var $a31505dc1709d7f1$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $a31505dc1709d7f1$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $a31505dc1709d7f1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $ifQOz.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a31505dc1709d7f1$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $a31505dc1709d7f1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $a31505dc1709d7f1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $a31505dc1709d7f1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $a31505dc1709d7f1$export$ba1d834b86d72a09 = $a31505dc1709d7f1$export$a1b3edb637fb4f35;
var $a31505dc1709d7f1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $ifQOz.N20A), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $ifQOz.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $ifQOz.N30A), ")")
            }
        }
    };
};

});
parcelRegister("ifQOz", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $d4a29896b130ad51$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $d4a29896b130ad51$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $d4a29896b130ad51$export$920c0d5c49070351; });
// Reds
var $d4a29896b130ad51$export$4b84fd0e2c617bd = '#FFEBE6';
var $d4a29896b130ad51$export$b34b069eff244586 = '#FFBDAD';
var $d4a29896b130ad51$export$be802dd0d8b57f35 = '#FF8F73';
var $d4a29896b130ad51$export$60847d42f9da92a6 = '#FF7452';
var $d4a29896b130ad51$export$4a7404f376229999 = '#FF5630';
var $d4a29896b130ad51$export$2010d0fb4295b346 = '#DE350B';
var $d4a29896b130ad51$export$2837b5a1a71d5c02 = '#BF2600';
var $d4a29896b130ad51$export$8d9596b529bbb9cf = '#FFFAE6';
var $d4a29896b130ad51$export$41060a744ab0b7ae = '#FFF0B3';
var $d4a29896b130ad51$export$1cc05bbbf340e559 = '#FFE380';
var $d4a29896b130ad51$export$5aae31392d72caaa = '#FFC400';
var $d4a29896b130ad51$export$c6930421db9fa514 = '#FFAB00';
var $d4a29896b130ad51$export$59619663aa6500fb = '#FF991F';
var $d4a29896b130ad51$export$874739ea9e379ab6 = '#FF8B00';
var $d4a29896b130ad51$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $d4a29896b130ad51$export$69a3bf21b9686c2b = '#ABF5D1';
var $d4a29896b130ad51$export$afbce1382ec95f73 = '#79F2C0';
var $d4a29896b130ad51$export$747d86715d4175de = '#57D9A3';
var $d4a29896b130ad51$export$940e1f69e873f202 = '#36B37E';
var $d4a29896b130ad51$export$a49394138f7b8e85 = '#00875A';
var $d4a29896b130ad51$export$6fa04827ac68a4fb = '#006644';
var $d4a29896b130ad51$export$226de0355ed012f8 = '#DEEBFF';
var $d4a29896b130ad51$export$8c13c2ee36917869 = '#B3D4FF';
var $d4a29896b130ad51$export$ecfc1dff386a3e7a = '#4C9AFF';
var $d4a29896b130ad51$export$215b7063051591f1 = '#2684FF';
var $d4a29896b130ad51$export$e62e8919cca44969 = '#0065FF';
var $d4a29896b130ad51$export$b3de0ae08da2ce64 = '#0052CC';
var $d4a29896b130ad51$export$a6ee3d71bc067634 = '#0747A6';
var $d4a29896b130ad51$export$67f15409e87642a1 = '#669DF1';
var $d4a29896b130ad51$export$f0539dbc42dbb067 = '#8FB8F6';
var $d4a29896b130ad51$export$363e4475840015bb = '#EAE6FF';
var $d4a29896b130ad51$export$4b0a4417ed59760f = '#C0B6F2';
var $d4a29896b130ad51$export$6011520a64d9a187 = '#998DD9';
var $d4a29896b130ad51$export$a7175d4e9206bc80 = '#8777D9';
var $d4a29896b130ad51$export$b48405b95304b5a1 = '#6554C0';
var $d4a29896b130ad51$export$c71e4279dd54a18d = '#5243AA';
var $d4a29896b130ad51$export$147899de772240ec = '#403294';
var $d4a29896b130ad51$export$2cf711fe14c66f06 = '#E6FCFF';
var $d4a29896b130ad51$export$7a8f4d33f6f9772c = '#B3F5FF';
var $d4a29896b130ad51$export$776c9c497ef08533 = '#79E2F2';
var $d4a29896b130ad51$export$69cb3ca10c1e330e = '#00C7E6';
var $d4a29896b130ad51$export$9dc1ef0f3f48059b = '#00B8D9';
var $d4a29896b130ad51$export$7c835c78b6fcdef8 = '#00A3BF';
var $d4a29896b130ad51$export$6036577f95c3877e = '#008DA6';
var $d4a29896b130ad51$export$29a4f05edc054374 = '#FFFFFF';
var $d4a29896b130ad51$export$e655ef011c4aa1a2 = '#FAFBFC';
var $d4a29896b130ad51$export$9fdfb749e33cdf97 = '#F4F5F7';
var $d4a29896b130ad51$export$3e51e8f1440314ba = '#EBECF0';
var $d4a29896b130ad51$export$1ce2d1575d444ceb = '#DFE1E6';
var $d4a29896b130ad51$export$8754fc7e6d8b3000 = '#C1C7D0';
var $d4a29896b130ad51$export$c2e91cbeada39b8b = '#B3BAC5';
var $d4a29896b130ad51$export$5f71e19f3a7ad9de = '#A5ADBA';
var $d4a29896b130ad51$export$eaa8c8a70ac22806 = '#97A0AF';
var $d4a29896b130ad51$export$7c87d337fb91a97d = '#8993A4';
var $d4a29896b130ad51$export$d6447c357493214f = '#7A869A';
var $d4a29896b130ad51$export$f563ee71e9ee74cd = '#6B778C';
var $d4a29896b130ad51$export$e2ef2124cf4024b1 = '#5E6C84';
var $d4a29896b130ad51$export$eece5f492e429f08 = '#505F79';
var $d4a29896b130ad51$export$c39c0fe0f26207ae = '#42526E';
var $d4a29896b130ad51$export$7090862dc3038a9f = '#344563';
var $d4a29896b130ad51$export$ad0bacf983b7ddaa = '#253858';
var $d4a29896b130ad51$export$7d61b15e0da132af = '#172B4D';
var $d4a29896b130ad51$export$fbda843f0a27fe96 = '#091E42';
var $d4a29896b130ad51$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $d4a29896b130ad51$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $d4a29896b130ad51$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $d4a29896b130ad51$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $d4a29896b130ad51$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $d4a29896b130ad51$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $d4a29896b130ad51$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $d4a29896b130ad51$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $d4a29896b130ad51$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $d4a29896b130ad51$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $d4a29896b130ad51$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $d4a29896b130ad51$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $d4a29896b130ad51$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $d4a29896b130ad51$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $d4a29896b130ad51$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $d4a29896b130ad51$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $d4a29896b130ad51$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $d4a29896b130ad51$export$2f6319cf7d736c2a = '#E6EDFA';
var $d4a29896b130ad51$export$95126bc8884d6634 = '#DCE5F5';
var $d4a29896b130ad51$export$8338d8c35d44ff1 = '#CED9EB';
var $d4a29896b130ad51$export$5368d76ae4fbbda7 = '#B8C7E0';
var $d4a29896b130ad51$export$9f0a771d16ec8d36 = '#ABBBD6';
var $d4a29896b130ad51$export$abcf8c38338b4aa5 = '#9FB0CC';
var $d4a29896b130ad51$export$97e81faa16a182c7 = '#8C9CB8';
var $d4a29896b130ad51$export$bfe21c59123ecf33 = '#7988A3';
var $d4a29896b130ad51$export$ee82aa2ea6a1558 = '#67758F';
var $d4a29896b130ad51$export$682927c6ed76be02 = '#56637A';
var $d4a29896b130ad51$export$91fd9994c5be9757 = '#455166';
var $d4a29896b130ad51$export$d281fbfe3cff2df6 = '#3B475C';
var $d4a29896b130ad51$export$3902c91d8b98a753 = '#313D52';
var $d4a29896b130ad51$export$8e8133c1ba5845b5 = '#283447';
var $d4a29896b130ad51$export$33ff357f6620b39 = '#202B3D';
var $d4a29896b130ad51$export$633847cf062b69e0 = '#1B2638';
var $d4a29896b130ad51$export$9776a6e503bdbf76 = '#121A29';
var $d4a29896b130ad51$export$6c813d5160dff5db = '#0E1624';
var $d4a29896b130ad51$export$3d4f271a500072a = '#0D1424';
var $d4a29896b130ad51$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $d4a29896b130ad51$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $d4a29896b130ad51$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $d4a29896b130ad51$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $d4a29896b130ad51$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $d4a29896b130ad51$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $d4a29896b130ad51$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $d4a29896b130ad51$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $d4a29896b130ad51$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $d4a29896b130ad51$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $d4a29896b130ad51$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $d4a29896b130ad51$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $d4a29896b130ad51$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $d4a29896b130ad51$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $d4a29896b130ad51$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $d4a29896b130ad51$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $d4a29896b130ad51$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $d4a29896b130ad51$export$d2adc5dedf09fced = '#292A2E';
var $d4a29896b130ad51$export$f51762073d2bb381 = '#94C748';
var $d4a29896b130ad51$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("5fBNd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2bab57579c1396$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $bRhmz = parcelRequire("bRhmz");

var $h5jdA = parcelRequire("h5jdA");

var $29RqY = parcelRequire("29RqY");

var $9cyTu = parcelRequire("9cyTu");
/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ var $3d2bab57579c1396$var$modalStackRegister = [];
function $3d2bab57579c1396$export$2e2bcd8739ae039(_ref) {
    var onStackChange = _ref.onStackChange;
    var _useExitingPersistenc = (0, $9cyTu.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting;
    var _useStateRef = (0, $29RqY.default)(0), _useStateRef2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useStateRef, 2), stackIndexRef = _useStateRef2[0], setStackIndex = _useStateRef2[1];
    var currentStackIndex = stackIndexRef.current;
    var previousStackIndex = (0, $h5jdA.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    var updateStack = (0, $bRhmz.default)(function() {
        var newStackIndex = $3d2bab57579c1396$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $8ZuGG.useEffect)(function() {
        var currentStackIndex = $3d2bab57579c1396$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $3d2bab57579c1396$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $3d2bab57579c1396$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $3d2bab57579c1396$var$modalStackRegister.forEach(function(cb) {
            return cb();
        });
    }, [
        updateStack,
        isExiting
    ]);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            var currentStackIndex = $3d2bab57579c1396$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $3d2bab57579c1396$var$modalStackRegister.splice(currentStackIndex, 1);
                $3d2bab57579c1396$var$modalStackRegister.forEach(function(cb) {
                    return cb();
                });
            }
        };
    }, [
        updateStack
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});
parcelRegister("bRhmz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a221cdcc155168b$export$2e2bcd8739ae039; });

var $ltItp = parcelRequire("ltItp");
function $8a221cdcc155168b$export$2e2bcd8739ae039(callback) {
    var ref = (0, $ltItp.default)(function() {
        return callback;
    });
    return ref.current;
}

});
parcelRegister("ltItp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa2ecde170a548c3$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $fa2ecde170a548c3$var$uniqueReferencedValue = {};
function $fa2ecde170a548c3$export$2e2bcd8739ae039(initializer) {
    var ref = (0, $8ZuGG.useRef)($fa2ecde170a548c3$var$uniqueReferencedValue);
    if (ref.current === $fa2ecde170a548c3$var$uniqueReferencedValue) ref.current = initializer();
    return ref;
}

});


parcelRegister("h5jdA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c701cf9e59a90384$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
function $c701cf9e59a90384$export$2e2bcd8739ae039(value) {
    var ref = (0, $8ZuGG.useRef)();
    (0, $8ZuGG.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("29RqY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1925def1ccb1d0d4$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");
function $1925def1ccb1d0d4$export$2e2bcd8739ae039(initialState) {
    var _useState = (0, $8ZuGG.useState)(initialState), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), value = _useState2[0], setValue = _useState2[1];
    var valueRef = (0, $8ZuGG.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});


parcelRegister("jNDuW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6a13b6fa55f6c82$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");
/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $e6a13b6fa55f6c82$var$getScrollDistance() {
    var _document$documentEle, _document$body;
    return window.pageYOffset || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.scrollTop) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.scrollTop) || 0;
}
function $e6a13b6fa55f6c82$export$2e2bcd8739ae039() {
    var _useState = (0, $8ZuGG.useState)(0), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), scrollTopOffset = _useState2[0], setScrollTopOffset = _useState2[1];
    (0, $8ZuGG.useLayoutEffect)(function() {
        setScrollTopOffset($e6a13b6fa55f6c82$var$getScrollDistance());
    }, []);
    var onWindowScroll = (0, $8ZuGG.useCallback)(function() {
        if ($e6a13b6fa55f6c82$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $8ZuGG.useEffect)(function() {
        return (0, $k6Bkl.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("a4m1X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $754b5def4a2d83ed$export$2e2bcd8739ae039; });
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $30M5w = parcelRequire("30M5w");

var $c7GPs = parcelRequire("c7GPs");

var $iNlvH = parcelRequire("iNlvH");

var $lDjMh = parcelRequire("lDjMh");

var $gWxJe = parcelRequire("gWxJe");
parcelRequire("1sUoM");
var $cMdu5 = parcelRequire("cMdu5");

var $f371O = parcelRequire("f371O");

var $bTyyp = parcelRequire("bTyyp");

var $2vhhb = parcelRequire("2vhhb");

var $jqxT3 = parcelRequire("jqxT3");

var $87pya = parcelRequire("87pya");

var $axmCM = parcelRequire("axmCM");

var $g9W3m = parcelRequire("g9W3m");
var $754b5def4a2d83ed$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
var $754b5def4a2d83ed$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syaz1fxt _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1p6i _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p1cd0 _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl"
};
var $754b5def4a2d83ed$var$viewportScrollStyles = null;
var $754b5def4a2d83ed$var$bodyScrollStyles = null;
var $754b5def4a2d83ed$var$ModalDialog = function ModalDialog(props) {
    var _props$width = props.width, width = _props$width === void 0 ? 'medium' : _props$width, _props$shouldScrollIn = props.shouldScrollInViewport, shouldScrollInViewport = _props$shouldScrollIn === void 0 ? false : _props$shouldScrollIn, shouldCloseOnEscapePress = props.shouldCloseOnEscapePress, autoFocus = props.autoFocus, stackIndex = props.stackIndex, onClose = props.onClose, onCloseComplete = props.onCloseComplete, onOpenComplete = props.onOpenComplete, height = props.height, hasProvidedOnClose = props.hasProvidedOnClose, children = props.children, label = props.label, testId = props.testId, _props$isFullScreen = props.isFullScreen, isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen;
    var id = (0, $iNlvH.useId)();
    var titleId = "modal-dialog-title-".concat(id);
    var defaultTestId = testId || 'modal-dialog';
    (0, $8ZuGG.useEffect)(function() {
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $cMdu5.combine)((0, $2vhhb.disableDraggingToCrossOriginIFramesForElement)(), (0, $87pya.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $jqxT3.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $c7GPs.default)((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(autoFocus) === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(autoFocus) === 'object');
    var _useOnMotionFinish = (0, $bTyyp.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    }), _useOnMotionFinish2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useOnMotionFinish, 2), motionRef = _useOnMotionFinish2[0], onMotionFinish = _useOnMotionFinish2[1];
    var modalDialogContext = (0, $8ZuGG.useMemo)(function() {
        return {
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        };
    }, [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $lDjMh.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    var _useLayering = (0, $lDjMh.useLayering)(), currentLevel = _useLayering.currentLevel;
    return /*#__PURE__*/ $8ZuGG.createElement((0, $g9W3m.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $f371O.ModalContext).Provider, {
        value: modalDialogContext
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $f371O.ScrollContext).Provider, {
        value: shouldScrollInViewport
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $gWxJe.default), {
        entranceDirection: isFullScreen ? undefined : 'bottom',
        onFinish: onMotionFinish
    }, function(bottomFadeInProps) {
        return /*#__PURE__*/ $8ZuGG.createElement("section", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, bottomFadeInProps, {
            "aria-label": label,
            ref: (0, $30M5w.default)([
                bottomFadeInProps.ref,
                motionRef
            ]),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-width': (0, $axmCM.dialogWidth)(width),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                '--modal-dialog-height': (0, $axmCM.dialogHeight)(height)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $c4hjl.default)([
                $754b5def4a2d83ed$var$dialogStyles.root,
                !isFullScreen && $754b5def4a2d83ed$var$dialogStyles.borderRadius,
                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                bottomFadeInProps.className
            ]),
            role: "dialog",
            "aria-labelledby": label ? undefined : titleId,
            "data-testid": defaultTestId,
            "data-modal-stack": stackIndex,
            tabIndex: -1,
            "aria-modal": true,
            "data-ds--level": currentLevel
        }), children);
    }))));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$754b5def4a2d83ed$export$2e2bcd8739ae039 = $754b5def4a2d83ed$var$ModalDialog;

});
parcelRegister("1sUoM", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return (parcelRequire("cMdu5")).combine; });

var $cMdu5 = parcelRequire("cMdu5");

});
parcelRegister("cMdu5", function(module, exports) {

$parcel$export(module.exports, "combine", function () { return $94d46d6ad8b26ec4$export$1be1fc439b849fdf; });
/** Create a new combined function that will call all the provided functions */ function $94d46d6ad8b26ec4$export$1be1fc439b849fdf() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function cleanup() {
        fns.forEach(function(fn) {
            return fn();
        });
    };
}

});


parcelRegister("f371O", function(module, exports) {

$parcel$export(module.exports, "ModalContext", function () { return $af4c9680d41b879c$export$ab57792b9b6974a6; });
$parcel$export(module.exports, "ScrollContext", function () { return $af4c9680d41b879c$export$dece24112a937f92; });

var $8ZuGG = parcelRequire("8ZuGG");
var $af4c9680d41b879c$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
var $af4c9680d41b879c$export$dece24112a937f92 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("bTyyp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a8fa27208672000$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
function $8a8fa27208672000$export$2e2bcd8739ae039(_ref) {
    var onOpenComplete = _ref.onOpenComplete, onCloseComplete = _ref.onCloseComplete;
    var motionRef = (0, $8ZuGG.useRef)(null);
    var onMotionFinish = (0, $8ZuGG.useCallback)(function(state) {
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("2vhhb", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForElement", function () { return $1d2be0b0cc2505b3$export$ec28e97c7d8b1b35; });

var $k6Bkl = parcelRequire("k6Bkl");
parcelRequire("1sUoM");
var $cMdu5 = parcelRequire("cMdu5");
parcelRequire("lVkOt");
var $3ZVHC = parcelRequire("3ZVHC");

var $kDH6W = parcelRequire("kDH6W");
function $1d2be0b0cc2505b3$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var unbindEvents = (0, $k6Bkl.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $3ZVHC.monitorForElements)({
        onGenerateDragPreview: function onGenerateDragPreview() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $cMdu5.combine)(unbindEvents, unbindMonitor);
}
function $1d2be0b0cc2505b3$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $k6Bkl.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener(event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
var $1d2be0b0cc2505b3$var$api = (0, $kDH6W.makeFixForAdapter)({
    watchForInteractionStart: $1d2be0b0cc2505b3$var$watchForInteractionStart,
    watchForInteractionEnd: $1d2be0b0cc2505b3$var$watchForInteractionEnd
});
function $1d2be0b0cc2505b3$export$ec28e97c7d8b1b35() {
    return $1d2be0b0cc2505b3$var$api.registerUsage();
}

});
parcelRegister("lVkOt", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", function () { return (parcelRequire("3ZVHC")).monitorForElements; });

var $3ZVHC = parcelRequire("3ZVHC");
 // Payload for the draggable being dragged

});
parcelRegister("3ZVHC", function(module, exports) {

$parcel$export(module.exports, "monitorForElements", function () { return $2e93d418eb29c31f$export$59a074bac4c54f54; });

var $kg5sN = parcelRequire("kg5sN");

var $k6Bkl = parcelRequire("k6Bkl");

var $iYACs = parcelRequire("iYACs");

var $eRMnz = parcelRequire("eRMnz");

var $c8h3C = parcelRequire("c8h3C");

var $cMdu5 = parcelRequire("cMdu5");

var $82mi7 = parcelRequire("82mi7");

var $3CvKc = parcelRequire("3CvKc");

var $jvsVi = parcelRequire("jvsVi");

var $i4Iqj = parcelRequire("i4Iqj");

var $1os2S = parcelRequire("1os2S");

var $ivYQF = parcelRequire("ivYQF");

var $578kN = parcelRequire("578kN");
var $2e93d418eb29c31f$var$draggableRegistry = new WeakMap();
function $2e93d418eb29c31f$var$addToRegistry(args) {
    $2e93d418eb29c31f$var$draggableRegistry.set(args.element, args);
    return function cleanup() {
        $2e93d418eb29c31f$var$draggableRegistry.delete(args.element);
    };
}
var $2e93d418eb29c31f$var$honeyPotFix = (0, $eRMnz.makeHoneyPotFix)();
var $2e93d418eb29c31f$var$adapter = (0, $c8h3C.makeAdapter)({
    typeKey: 'element',
    defaultDropEffect: 'move',
    mount: function mount(api) {
        /**  Binding event listeners the `document` rather than `window` so that
     * this adapter always gets preference over the text adapter.
     * `document` is the first `EventTarget` under `window`
     * https://twitter.com/alexandereardon/status/1604658588311465985
     */ return (0, $cMdu5.combine)($2e93d418eb29c31f$var$honeyPotFix.bindEvents(), (0, $k6Bkl.bind)(document, {
            type: 'dragstart',
            listener: function listener(event) {
                var _entry$dragHandle, _entry$getInitialData, _entry$getInitialData2, _entry$dragHandle2, _entry$getInitialData3, _entry$getInitialData4;
                if (!api.canStart(event)) return;
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Technically `dataTransfer` can be `null` according to the types
                // But that behaviour does not seem to appear in the spec.
                // If there is not `dataTransfer`, we can assume something is wrong and not
                // start a drag
                if (!event.dataTransfer) return;
                // the closest parent that is a draggable element will be marked as
                // the `event.target` for the event
                var target = event.target;
                // this source is only for elements
                // Note: only HTMLElements can have the "draggable" attribute
                if (!(target instanceof HTMLElement)) return null;
                // see if the thing being dragged is owned by us
                var entry = $2e93d418eb29c31f$var$draggableRegistry.get(target);
                // no matching element found
                // → dragging an element with `draggable="true"` that is not controlled by us
                if (!entry) return null;
                /**
         * A text selection drag _can_ have the `draggable` element be
         * the `event.target` if the user is dragging the text selection
         * from the `draggable`.
         *
         * To know if the `draggable` is being dragged, we look at whether any
         * `"text/plain"` data is being dragged. If it is, then a text selection
         * drag is occurring.
         *
         * This behaviour has been validated on:
         *
         * - Chrome@128 on Android@14
         * - Chrome@128 on iOS@17.6.1
         * - Chrome@128 on Windows@11
         * - Chrome@128 on MacOS@14.6.1
         * - Firefox@129 on Windows@11 (not possible for user to select text in a draggable)
         * - Firefox@129 on MacOS@14.6.1 (not possible for user to select text in a draggable)
         *
         * Note: Could usually just use: `event.dataTransfer.types.includes(textMediaType)`
         * but unfortunately ProseMirror is always setting `""` as the dragged text
         *
         * Note: Unfortunately editor is (heavily) leaning on the current functionality today
         * and unwinding it will be a decent amount of effort. So for now, a text selection
         * where the `event.target` is a `draggable` element will still trigger the
         * element adapter.
         *
         * // Future state:
         * if(event.dataTransfer.getData(textMediaType)) {
         * 	return;
         * }
         *
         */ var input = (0, $i4Iqj.getInput)(event);
                var feedback = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle = entry.dragHandle) !== null && _entry$dragHandle !== void 0 ? _entry$dragHandle : null,
                    input: input
                };
                // Check: does the draggable want to allow dragging?
                if (entry.canDrag && !entry.canDrag(feedback)) {
                    // cancel drag operation if we cannot drag
                    event.preventDefault();
                    return null;
                }
                // Check: is there a drag handle and is the user using it?
                if (entry.dragHandle) {
                    // technically don't need this util, but just being
                    // consistent with how we look up what is under the users
                    // cursor.
                    var over = (0, $iYACs.getElementFromPointWithoutHoneypot)({
                        x: input.clientX,
                        y: input.clientY
                    });
                    // if we are not dragging from the drag handle (or something inside the drag handle)
                    // then we will cancel the active drag
                    if (!entry.dragHandle.contains(over)) {
                        event.preventDefault();
                        return null;
                    }
                }
                /**
         *  **Goal**
         *  Pass information to other applications
         *
         * **Approach**
         *  Put data into the native data store
         *
         *  **What about the native adapter?**
         *  When the element adapter puts native data into the native data store
         *  the native adapter is not triggered in the current window,
         *  but a native adapter in an external window _can_ be triggered
         *
         *  **Why bake this into core?**
         *  This functionality could be pulled out and exposed inside of
         *  `onGenerateDragPreview`. But decided to make it a part of the
         *  base API as it felt like a common enough use case and ended
         *  up being a similar amount of code to include this function as
         *  it was to expose the hook for it
         */ var nativeData = (_entry$getInitialData = (_entry$getInitialData2 = entry.getInitialDataForExternal) === null || _entry$getInitialData2 === void 0 ? void 0 : _entry$getInitialData2.call(entry, feedback)) !== null && _entry$getInitialData !== void 0 ? _entry$getInitialData : null;
                if (nativeData) for(var _i = 0, _Object$entries = Object.entries(nativeData); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], data = _Object$entries$_i[1];
                    event.dataTransfer.setData(key, data !== null && data !== void 0 ? data : '');
                }
                /**
         *  📱 For Android devices, a drag operation will not start unless
         * "text/plain" or "text/uri-list" data exists in the native data store
         * https://twitter.com/alexandereardon/status/1732189803754713424
         *
         * Tested on:
         * Device: Google Pixel 5
         * Android version: 14 (November 5, 2023)
         * Chrome version: 120.0
         */ if ((0, $jvsVi.isAndroid)() && !event.dataTransfer.types.includes((0, $1os2S.textMediaType)) && !event.dataTransfer.types.includes((0, $ivYQF.URLMediaType))) event.dataTransfer.setData((0, $1os2S.textMediaType), (0, $jvsVi.androidFallbackText));
                /**
         * 1. Must set any media type for `iOS15` to work
         * 2. We are also doing adding data so that the native adapter
         * can know that the element adapter has handled this drag
         *
         * We used to wrap this `setData()` in a `try/catch` for Firefox,
         * but it looks like that was not needed.
         *
         * Tested using: https://codesandbox.io/s/checking-firefox-throw-behaviour-on-dragstart-qt8h4f
         *
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Sonoma
         * - ✅ Firefox@70.0 (Oct 2019) on macOS Big Sur
         * - ✅ Firefox@70.0 (Oct 2019) on Windows 10
         *
         * // just checking a few more combinations to be super safe
         *
         * - ✅ Chrome@78 (Oct 2019) on macOS Big Sur
         * - ✅ Chrome@78 (Oct 2019) on Windows 10
         * - ✅ Safari@14.1 on macOS Big Sur
         */ event.dataTransfer.setData((0, $578kN.elementAdapterNativeDataKey), '');
                var payload = {
                    element: entry.element,
                    dragHandle: (_entry$dragHandle2 = entry.dragHandle) !== null && _entry$dragHandle2 !== void 0 ? _entry$dragHandle2 : null,
                    data: (_entry$getInitialData3 = (_entry$getInitialData4 = entry.getInitialData) === null || _entry$getInitialData4 === void 0 ? void 0 : _entry$getInitialData4.call(entry, feedback)) !== null && _entry$getInitialData3 !== void 0 ? _entry$getInitialData3 : {}
                };
                var dragType = {
                    type: 'element',
                    payload: payload,
                    startedFrom: 'internal'
                };
                api.start({
                    event: event,
                    dragType: dragType
                });
            }
        }));
    },
    dispatchEventToSource: function dispatchEventToSource(_ref) {
        var _draggableRegistry$ge, _draggableRegistry$ge2;
        var eventName = _ref.eventName, payload = _ref.payload;
        // During a drag operation, a draggable can be:
        // - remounted with different functions
        // - removed completely
        // So we need to get the latest entry from the registry in order
        // to call the latest event functions
        (_draggableRegistry$ge = $2e93d418eb29c31f$var$draggableRegistry.get(payload.source.element)) === null || _draggableRegistry$ge === void 0 || (_draggableRegistry$ge2 = _draggableRegistry$ge[eventName]) === null || _draggableRegistry$ge2 === void 0 || _draggableRegistry$ge2.call(_draggableRegistry$ge, // I cannot seem to get the types right here.
        // TS doesn't seem to like that one event can need `nativeSetDragImage`
        // @ts-expect-error
        payload);
    },
    onPostDispatch: $2e93d418eb29c31f$var$honeyPotFix.getOnPostDispatch()
});
var $2e93d418eb29c31f$export$e7140b68045b5036 = $2e93d418eb29c31f$var$adapter.dropTarget;
var $2e93d418eb29c31f$export$59a074bac4c54f54 = $2e93d418eb29c31f$var$adapter.monitor;
function $2e93d418eb29c31f$export$c746a5152d4ba26c(args) {
    var existing;
    var cleanup = (0, $cMdu5.combine)(// making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    $2e93d418eb29c31f$var$adapter.registerUsage(), $2e93d418eb29c31f$var$addToRegistry(args), (0, $3CvKc.addAttribute)(args.element, {
        attribute: 'draggable',
        value: 'true'
    }));
    // Wrapping in `once` to prevent unexpected side effects if consumers call
    // the clean up function multiple times.
    return (0, $82mi7.once)(cleanup);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrag()`) on for a `draggable()` */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForElements()` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForElements` */ 

});
parcelRegister("iYACs", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", function () { return $dd0a3c6d4f4bfe7d$export$81d0353f25f5dd; });

var $kg5sN = parcelRequire("kg5sN");

var $jWbP4 = parcelRequire("jWbP4");
function $dd0a3c6d4f4bfe7d$export$81d0353f25f5dd(client) {
    // eslint-disable-next-line no-restricted-syntax
    var _document$elementsFro = document.elementsFromPoint(client.x, client.y), _document$elementsFro2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_document$elementsFro, 2), top = _document$elementsFro2[0], second = _document$elementsFro2[1];
    if (!top) return null;
    if ((0, $jWbP4.isHoneyPotElement)(top)) return second !== null && second !== void 0 ? second : null;
    return top;
}

});
parcelRegister("jWbP4", function(module, exports) {

$parcel$export(module.exports, "isHoneyPotElement", function () { return $e83c9ad8ee250e23$export$821bdcd739a2706b; });

var $iNn9t = parcelRequire("iNn9t");
function $e83c9ad8ee250e23$export$821bdcd739a2706b(target) {
    return target instanceof Element && target.hasAttribute((0, $iNn9t.honeyPotDataAttribute));
}

});
parcelRegister("iNn9t", function(module, exports) {

$parcel$export(module.exports, "honeyPotDataAttribute", function () { return $daeec3103b79a915$export$6eafea55f7947469; });
// pulling this into a separate file so adapter(s) that don't
// need the honey pot can pay as little as possible for it.
var $daeec3103b79a915$export$6eafea55f7947469 = 'data-pdnd-honey-pot';

});



parcelRegister("eRMnz", function(module, exports) {

$parcel$export(module.exports, "makeHoneyPotFix", function () { return $ad2b8b079e463163$export$8ecad27c959e89e0; });

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $222Mp = parcelRequire("222Mp");

var $iNn9t = parcelRequire("iNn9t");
function $ad2b8b079e463163$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad2b8b079e463163$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad2b8b079e463163$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad2b8b079e463163$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ad2b8b079e463163$var$honeyPotSize = 2;
var $ad2b8b079e463163$var$halfHoneyPotSize = $ad2b8b079e463163$var$honeyPotSize / 2;
/**
 * `clientX` and `clientY` can be in sub pixels (eg `2.332`)
 * However, browser hitbox testing is commonly do to the closest pixel.
 *
 * → https://issues.chromium.org/issues/40940531
 *
 * To be sure that the honey pot will be over the `client` position,
 * we `.floor()` `clientX` and`clientY` and then make it `2px` in size.
 **/ function $ad2b8b079e463163$var$floorToClosestPixel(point) {
    return {
        x: Math.floor(point.x),
        y: Math.floor(point.y)
    };
}
/**
 * We want to make sure the honey pot sits around the users position.
 * This seemed to be the most resilient while testing.
 */ function $ad2b8b079e463163$var$pullBackByHalfHoneyPotSize(point) {
    return {
        x: point.x - $ad2b8b079e463163$var$halfHoneyPotSize,
        y: point.y - $ad2b8b079e463163$var$halfHoneyPotSize
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $ad2b8b079e463163$var$preventGoingBackwardsOffScreen(point) {
    return {
        x: Math.max(point.x, 0),
        y: Math.max(point.y, 0)
    };
}
/**
 * Prevent the honey pot from changing the window size.
 * This is super unlikely to occur, but just being safe.
 */ function $ad2b8b079e463163$var$preventGoingForwardsOffScreen(point) {
    return {
        x: Math.min(point.x, window.innerWidth - $ad2b8b079e463163$var$honeyPotSize),
        y: Math.min(point.y, window.innerHeight - $ad2b8b079e463163$var$honeyPotSize)
    };
}
/**
 * Create a `2x2` `DOMRect` around the `client` position
 */ function $ad2b8b079e463163$var$getHoneyPotRectFor(_ref) {
    var client = _ref.client;
    var point = $ad2b8b079e463163$var$preventGoingForwardsOffScreen($ad2b8b079e463163$var$preventGoingBackwardsOffScreen($ad2b8b079e463163$var$pullBackByHalfHoneyPotSize($ad2b8b079e463163$var$floorToClosestPixel(client))));
    // When debugging, it is helpful to
    // make this element a bit bigger
    return DOMRect.fromRect({
        x: point.x,
        y: point.y,
        width: $ad2b8b079e463163$var$honeyPotSize,
        height: $ad2b8b079e463163$var$honeyPotSize
    });
}
function $ad2b8b079e463163$var$getRectStyles(_ref2) {
    var clientRect = _ref2.clientRect;
    return {
        left: "".concat(clientRect.left, "px"),
        top: "".concat(clientRect.top, "px"),
        width: "".concat(clientRect.width, "px"),
        height: "".concat(clientRect.height, "px")
    };
}
function $ad2b8b079e463163$var$isWithin(_ref3) {
    var client = _ref3.client, clientRect = _ref3.clientRect;
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
/**
 * The honey pot fix is designed to get around a painful bug in all browsers.
 *
 * [Overview](https://www.youtube.com/watch?v=udE9qbFTeQg)
 *
 * **Background**
 *
 * When a drag starts, browsers incorrectly think that the users pointer is
 * still depressed where the drag started. Any element that goes under this position
 * will be entered into, causing `"mouseenter"` events and `":hover"` styles to be applied.
 *
 * _This is a violation of the spec_
 *
 * > "From the moment that the user agent is to initiate the drag-and-drop operation,
 * > until the end 	of the drag-and-drop operation, device input events
 * > (e.g. mouse and keyboard events) must be suppressed."
 * >
 * > - https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
 *
 * _Some impacts_
 *
 * - `":hover"` styles being applied where they shouldn't (looks messy)
 * - components such as tooltips responding to `"mouseenter"` can show during a drag,
 *   and on an element the user isn't even over
 *
 * Bug: https://issues.chromium.org/issues/41129937
 *
 * **Honey pot fix**
 *
 * 1. Create an element where the browser thinks the depressed pointer is
 *    to absorb the incorrect pointer events
 * 2. Remove that element when it is no longer needed
 */ function $ad2b8b079e463163$var$mountHoneyPot(_ref4) {
    var initial = _ref4.initial;
    var element = document.createElement('div');
    element.setAttribute((0, $iNn9t.honeyPotDataAttribute), 'true');
    // can shift during the drag thanks to Firefox
    var clientRect = $ad2b8b079e463163$var$getHoneyPotRectFor({
        client: initial
    });
    Object.assign(element.style, $ad2b8b079e463163$var$_objectSpread($ad2b8b079e463163$var$_objectSpread({
        // Setting a background color explicitly to avoid any inherited styles.
        // Looks like this could be `opacity: 0`, but worried that _might_
        // cause the element to be ignored on some platforms.
        // When debugging, set backgroundColor to something like "red".
        backgroundColor: 'transparent',
        position: 'fixed',
        // Being explicit to avoid inheriting styles
        padding: 0,
        margin: 0,
        boxSizing: 'border-box'
    }, $ad2b8b079e463163$var$getRectStyles({
        clientRect: clientRect
    })), {}, {
        // We want this element to absorb pointer events,
        // it's kind of the whole point 😉
        pointerEvents: 'auto',
        // Want to make sure the honey pot is top of everything else.
        // Don't need to worry about native drag previews, as they will
        // have been rendered (and removed) before the honey pot is rendered
        zIndex: (0, $222Mp.maxZIndex)
    }));
    document.body.appendChild(element);
    /**
   *  🦊 In firefox we can get `"pointermove"` events after the drag
   * has started, which is a spec violation.
   * The final `"pointermove"` will reveal where the "depressed" position
   * is for our honey pot fix.
   */ var unbindPointerMove = (0, $k6Bkl.bind)(window, {
        type: 'pointermove',
        listener: function listener(event) {
            var client = {
                x: event.clientX,
                y: event.clientY
            };
            clientRect = $ad2b8b079e463163$var$getHoneyPotRectFor({
                client: client
            });
            Object.assign(element.style, $ad2b8b079e463163$var$getRectStyles({
                clientRect: clientRect
            }));
        },
        // using capture so we are less likely to be impacted by event stopping
        options: {
            capture: true
        }
    });
    return function finish(_ref5) {
        var current = _ref5.current;
        // Don't need this any more
        unbindPointerMove();
        // If the user is hover the honey pot, we remove it
        // so that the user can continue to interact with the page normally.
        if ($ad2b8b079e463163$var$isWithin({
            client: current,
            clientRect: clientRect
        })) {
            element.remove();
            return;
        }
        function cleanup() {
            unbindPostDragEvents();
            element.remove();
        }
        var unbindPostDragEvents = (0, $k6Bkl.bindAll)(window, [
            {
                type: 'pointerdown',
                listener: cleanup
            },
            {
                type: 'pointermove',
                listener: cleanup
            },
            {
                type: 'focusin',
                listener: cleanup
            },
            {
                type: 'focusout',
                listener: cleanup
            },
            // a 'pointerdown' should happen before 'dragstart', but just being super safe
            {
                type: 'dragstart',
                listener: cleanup
            },
            // if the user has dragged something out of the window
            // and then is dragging something back into the window
            // the first events we will see are "dragenter" (and then "dragover").
            // So if we see any of these we need to clear the post drag fix.
            {
                type: 'dragenter',
                listener: cleanup
            },
            {
                type: 'dragover',
                listener: cleanup
            }
        ], {
            // Using `capture` so less likely to be impacted by other code stopping events
            capture: true
        });
    };
}
function $ad2b8b079e463163$export$8ecad27c959e89e0() {
    var latestPointerMove = null;
    function bindEvents() {
        // For sanity, only collecting this value from when events are first bound.
        // This prevents the case where a super old "pointermove" could be used
        // from a prior interaction.
        latestPointerMove = null;
        return (0, $k6Bkl.bind)(window, {
            type: 'pointermove',
            listener: function listener(event) {
                latestPointerMove = {
                    x: event.clientX,
                    y: event.clientY
                };
            },
            // listening for pointer move in capture phase
            // so we are less likely to be impacted by events being stopped.
            options: {
                capture: true
            }
        });
    }
    function getOnPostDispatch() {
        var finish = null;
        return function onPostEvent(_ref6) {
            var eventName = _ref6.eventName, payload = _ref6.payload;
            // We are adding the honey pot `onDragStart` so we don't
            // impact the creation of the native drag preview.
            if (eventName === 'onDragStart') {
                var input = payload.location.initial.input;
                // Sometimes there will be no latest "pointermove" (eg iOS).
                // In which case, we use the start position of the drag.
                var initial = latestPointerMove !== null && latestPointerMove !== void 0 ? latestPointerMove : {
                    x: input.clientX,
                    y: input.clientY
                };
                // Don't need to defensively call `finish()` as `onDrop` from
                // one interaction is guaranteed to be called before `onDragStart`
                // of the next.
                finish = $ad2b8b079e463163$var$mountHoneyPot({
                    initial: initial
                });
            }
            if (eventName === 'onDrop') {
                var _finish;
                var _input = payload.location.current.input;
                (_finish = finish) === null || _finish === void 0 || _finish({
                    current: {
                        x: _input.clientX,
                        y: _input.clientY
                    }
                });
                finish = null;
                // this interaction is finished, we want to use
                // the latest "pointermove" for each interaction
                latestPointerMove = null;
            }
        };
    }
    return {
        bindEvents: bindEvents,
        getOnPostDispatch: getOnPostDispatch
    };
}

});
parcelRegister("222Mp", function(module, exports) {

$parcel$export(module.exports, "maxZIndex", function () { return $17adecad1c0cea22$export$7d0a15ee70427305; });
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
var $17adecad1c0cea22$export$7d0a15ee70427305 = 2147483647;

});


parcelRegister("c8h3C", function(module, exports) {

$parcel$export(module.exports, "makeAdapter", function () { return $8d5376a1224346f9$export$2aa3a33160990d96; });

var $GXq3s = parcelRequire("GXq3s");

var $7nUng = parcelRequire("7nUng");

var $aqWlM = parcelRequire("aqWlM");

var $6Q9MY = parcelRequire("6Q9MY");
function $8d5376a1224346f9$export$2aa3a33160990d96(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount, dispatchEventToSource = _ref.dispatchEventToSource, onPostDispatch = _ref.onPostDispatch, defaultDropEffect = _ref.defaultDropEffect;
    var monitorAPI = (0, $6Q9MY.makeMonitor)();
    var dropTargetAPI = (0, $aqWlM.makeDropTarget)({
        typeKey: typeKey,
        defaultDropEffect: defaultDropEffect
    });
    function dispatchEvent(args) {
        // 1. forward the event to source
        dispatchEventToSource === null || dispatchEventToSource === void 0 || dispatchEventToSource(args);
        // 2. forward the event to relevant dropTargets
        dropTargetAPI.dispatchEvent(args);
        // 3. forward event to monitors
        monitorAPI.dispatchEvent(args);
        // 4. post consumer dispatch (used for honey pot fix)
        onPostDispatch === null || onPostDispatch === void 0 || onPostDispatch(args);
    }
    function start(_ref2) {
        var event = _ref2.event, dragType = _ref2.dragType;
        (0, $GXq3s.lifecycle).start({
            event: event,
            dragType: dragType,
            getDropTargetsOver: dropTargetAPI.getIsOver,
            dispatchEvent: dispatchEvent
        });
    }
    function registerUsage() {
        function mountAdapter() {
            var api = {
                canStart: (0, $GXq3s.lifecycle).canStart,
                start: start
            };
            return mount(api);
        }
        return (0, $7nUng.register)({
            typeKey: typeKey,
            mount: mountAdapter
        });
    }
    return {
        registerUsage: registerUsage,
        dropTarget: dropTargetAPI.dropTargetForConsumers,
        monitor: monitorAPI.monitorForConsumers
    };
}

});
parcelRegister("GXq3s", function(module, exports) {

$parcel$export(module.exports, "lifecycle", function () { return $081203c827da0e46$export$3efdceeb8ca25c51; });

var $cF8Kw = parcelRequire("cF8Kw");

var $k6Bkl = parcelRequire("k6Bkl");

var $iYACs = parcelRequire("iYACs");

var $jWbP4 = parcelRequire("jWbP4");

var $1GBYN = parcelRequire("1GBYN");

var $gg3MR = parcelRequire("gg3MR");

var $i4Iqj = parcelRequire("i4Iqj");

var $X78OI = parcelRequire("X78OI");
var $081203c827da0e46$var$globalState = {
    isActive: false
};
function $081203c827da0e46$var$canStart() {
    return !$081203c827da0e46$var$globalState.isActive;
}
function $081203c827da0e46$var$getNativeSetDragImage(event) {
    if (event.dataTransfer) // need to use `.bind` as `setDragImage` is required
    // to be run with `event.dataTransfer` as the "this" context
    return event.dataTransfer.setDragImage.bind(event.dataTransfer);
    return null;
}
function $081203c827da0e46$var$hasHierarchyChanged(_ref) {
    var current = _ref.current, next = _ref.next;
    if (current.length !== next.length) return true;
    // not checking stickiness, data or dropEffect,
    // just whether the hierarchy has changed
    for(var i = 0; i < current.length; i++){
        if (current[i].element !== next[i].element) return true;
    }
    return false;
}
function $081203c827da0e46$var$start(_ref2) {
    var event = _ref2.event, dragType = _ref2.dragType, getDropTargetsOver = _ref2.getDropTargetsOver, dispatchEvent = _ref2.dispatchEvent;
    if (!$081203c827da0e46$var$canStart()) return;
    var initial = $081203c827da0e46$var$getStartLocation({
        event: event,
        dragType: dragType,
        getDropTargetsOver: getDropTargetsOver
    });
    $081203c827da0e46$var$globalState.isActive = true;
    var state = {
        current: initial
    };
    // Setting initial drop effect for the drag
    $081203c827da0e46$var$setDropEffectOnEvent({
        event: event,
        current: initial.dropTargets
    });
    var dispatch = (0, $X78OI.makeDispatch)({
        source: dragType.payload,
        dispatchEvent: dispatchEvent,
        initial: initial
    });
    function updateState(next) {
        // only looking at whether hierarchy has changed to determine whether something as 'changed'
        var hasChanged = $081203c827da0e46$var$hasHierarchyChanged({
            current: state.current.dropTargets,
            next: next.dropTargets
        });
        // Always updating the state to include latest data, dropEffect and stickiness
        // Only updating consumers if the hierarchy has changed in some way
        // Consumers can get the latest data by using `onDrag`
        state.current = next;
        if (hasChanged) dispatch.dragUpdate({
            current: state.current
        });
    }
    function onUpdateEvent(event) {
        var input = (0, $i4Iqj.getInput)(event);
        // If we are over the honey pot, we need to get the element
        // that the user would have been over if not for the honey pot
        var target = (0, $jWbP4.isHoneyPotElement)(event.target) ? (0, $iYACs.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        }) : event.target;
        var nextDropTargets = getDropTargetsOver({
            target: target,
            input: input,
            source: dragType.payload,
            current: state.current.dropTargets
        });
        if (nextDropTargets.length) {
            // 🩸 must call `event.preventDefault()` to allow a browser drop to occur
            event.preventDefault();
            $081203c827da0e46$var$setDropEffectOnEvent({
                event: event,
                current: nextDropTargets
            });
        }
        updateState({
            dropTargets: nextDropTargets,
            input: input
        });
    }
    function cancel() {
        // The spec behaviour is that when a drag is cancelled, or when dropping on no drop targets,
        // a "dragleave" event is fired on the active drop target before a "dragend" event.
        // We are replicating that behaviour in `cancel` if there are any active drop targets to
        // ensure consistent behaviour.
        //
        // Note: When cancelling, or dropping on no drop targets, a "dragleave" event
        // will have already cleared the dropTargets to `[]` (as that particular "dragleave" has a `relatedTarget` of `null`)
        if (state.current.dropTargets.length) updateState({
            dropTargets: [],
            input: state.current.input
        });
        dispatch.drop({
            current: state.current,
            updatedSourcePayload: null
        });
        finish();
    }
    function finish() {
        $081203c827da0e46$var$globalState.isActive = false;
        unbindEvents();
    }
    var unbindEvents = (0, $k6Bkl.bindAll)(window, [
        {
            // 👋 Note: we are repurposing the `dragover` event as our `drag` event
            // this is because firefox does not publish pointer coordinates during
            // a `drag` event, but does for every other type of drag event
            // `dragover` fires on all elements that are being dragged over
            // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
            // 🦊😤
            type: 'dragover',
            listener: function listener(event) {
                // We need to regularly calculate the drop targets in order to allow:
                //  - dynamic `canDrop()` checks
                //  - rapid updating `getData()` calls to attach data in response to user input (eg for edge detection)
                // Sadly we cannot schedule inspecting changes resulting from this event
                // we need to be able to conditionally cancel the event with `event.preventDefault()`
                // to enable the correct native drop experience.
                // 1. check to see if anything has changed
                onUpdateEvent(event);
                // 2. let consumers know a move has occurred
                // This will include the latest 'input' values
                dispatch.drag({
                    current: state.current
                });
            }
        },
        {
            type: 'dragenter',
            listener: onUpdateEvent
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                if (!(0, $1GBYN.isLeavingWindow)({
                    dragLeave: event
                })) return;
                /**
       * At this point we don't know if a drag is being cancelled,
       * or if a drag is leaving the `window`.
       *
       * Both have:
       *   1. "dragleave" (with `relatedTarget: null`)
       *   2. "dragend" (a "dragend" can occur when outside the `window`)
       *
       * **Clearing drop targets**
       *
       * For either case we are clearing the the drop targets
       *
       * - cancelling: we clear drop targets in `"dragend"` anyway
       * - leaving the `window`: we clear the drop targets (to clear stickiness)
       *
       * **Leaving the window and finishing the drag**
       *
       * _internal drags_
       *
       * - The drag continues when the user is outside the `window`
       *   and can resume if the user drags back over the `window`,
       *   or end when the user drops in an external `window`.
       * - We will get a `"dragend"`, or we can listen for other
       *   events to determine the drag is finished when the user re-enters the `window`).
       *
       * _external drags_
       *
       * - We conclude the drag operation.
       * - We have no idea if the user will drag back over the `window`,
       *   or if the drag ends elsewhere.
       * - We will create a new drag if the user re-enters the `window`.
       *
       * **Not updating `input`**
       *
       * 🐛 Bug[Chrome] the final `"dragleave"` has default input values (eg `clientX == 0`)
       * Workaround: intentionally not updating `input` in "dragleave"
       * rather than the users current input values
       * - [Conversation](https://twitter.com/alexandereardon/status/1642697633864241152)
       * - [Bug](https://bugs.chromium.org/p/chromium/issues/detail?id=1429937)
       **/ updateState({
                    input: state.current.input,
                    dropTargets: []
                });
                if (dragType.startedFrom === 'external') cancel();
            }
        },
        {
            // A "drop" can only happen if the browser allowed the drop
            type: 'drop',
            listener: function listener(event) {
                // Capture the final input.
                // We are capturing the final `input` for the
                // most accurate honey pot experience
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $i4Iqj.getInput)(event)
                };
                /** If there are no drop targets, then we will get
       * a "drop" event if:
       * - `preventUnhandled()` is being used
       * - there is an unmanaged drop target (eg another library)
       * In these cases, it's up to the consumer
       * to handle the drop if it's not over one of our drop targets
       * - `preventUnhandled()` will cancel the "drop"
       * - unmanaged drop targets can handle the "drop" how they want to
       * We won't call `event.preventDefault()` in this call path */ if (!state.current.dropTargets.length) {
                    cancel();
                    return;
                }
                event.preventDefault();
                // applying the latest drop effect to the event
                $081203c827da0e46$var$setDropEffectOnEvent({
                    event: event,
                    current: state.current.dropTargets
                });
                dispatch.drop({
                    current: state.current,
                    // When dropping something native, we need to extract the latest
                    // `.items` from the "drop" event as it is now accessible
                    updatedSourcePayload: dragType.type === 'external' ? dragType.getDropPayload(event) : null
                });
                finish();
            }
        },
        {
            // "dragend" fires when on the drag source (eg a draggable element)
            // when the drag is finished.
            // "dragend" will fire after "drop" (if there was a successful drop)
            // "dragend" does not fire if the draggable source has been removed during the drag
            // or for external drag sources (eg files)
            // This "dragend" listener will not fire if there was a successful drop
            // as we will have already removed the event listener
            type: 'dragend',
            listener: function listener(event) {
                // In firefox, the position of the "dragend" event can
                // be a bit different to the last "dragover" event.
                // Updating the input so we can get the best possible
                // information for the honey pot.
                state.current = {
                    dropTargets: state.current.dropTargets,
                    input: (0, $i4Iqj.getInput)(event)
                };
                cancel();
            }
        }
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))((0, $gg3MR.getBindingsForBrokenDrags)({
        onDragEnd: cancel
    }))), // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
        capture: true
    });
    dispatch.start({
        nativeSetDragImage: $081203c827da0e46$var$getNativeSetDragImage(event)
    });
}
function $081203c827da0e46$var$setDropEffectOnEvent(_ref3) {
    var _current$;
    var event = _ref3.event, current = _ref3.current;
    // setting the `dropEffect` to be the innerMost drop targets dropEffect
    var innerMost = (_current$ = current[0]) === null || _current$ === void 0 ? void 0 : _current$.dropEffect;
    if (innerMost != null && event.dataTransfer) event.dataTransfer.dropEffect = innerMost;
}
function $081203c827da0e46$var$getStartLocation(_ref4) {
    var event = _ref4.event, dragType = _ref4.dragType, getDropTargetsOver = _ref4.getDropTargetsOver;
    var input = (0, $i4Iqj.getInput)(event);
    // When dragging from outside of the browser,
    // the drag is not being sourced from any local drop targets
    if (dragType.startedFrom === 'external') return {
        input: input,
        dropTargets: []
    };
    var dropTargets = getDropTargetsOver({
        input: input,
        source: dragType.payload,
        target: event.target,
        current: []
    });
    return {
        input: input,
        dropTargets: dropTargets
    };
}
var $081203c827da0e46$export$3efdceeb8ca25c51 = {
    canStart: $081203c827da0e46$var$canStart,
    start: $081203c827da0e46$var$start
};

});
parcelRegister("1GBYN", function(module, exports) {

$parcel$export(module.exports, "isLeavingWindow", function () { return $13a72ca6bfcd1e63$export$57d220c74e84a273; });

var $jOw0P = parcelRequire("jOw0P");

var $fBjMl = parcelRequire("fBjMl");

var $fiCEq = parcelRequire("fiCEq");

var $eYtjj = parcelRequire("eYtjj");
function $13a72ca6bfcd1e63$export$57d220c74e84a273(_ref) {
    var dragLeave = _ref.dragLeave;
    var type = dragLeave.type, relatedTarget = dragLeave.relatedTarget;
    if (type !== 'dragleave') return false;
    if ((0, $fBjMl.isSafari)()) return (0, $fiCEq.isLeavingWindowInSafari)({
        dragLeave: dragLeave
    });
    // Standard check: if going to `null` we are leaving the `window`
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is element _inside_ the child `iframe`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   * (foreign element)
   */ if ((0, $jOw0P.isFirefox)()) return (0, $eYtjj.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `dragLeave.relatedTarget` is the `iframe` in the parent `window`
   *
   * Case 2: child `iframe` → parent `window`
   * `dragLeave.relatedTarget` is `null` *(standard check)*
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});
parcelRegister("jOw0P", function(module, exports) {

$parcel$export(module.exports, "isFirefox", function () { return $e6cb84cd04409833$export$b7d78993b74f766d; });

var $82mi7 = parcelRequire("82mi7");
var $e6cb84cd04409833$export$b7d78993b74f766d = (0, $82mi7.once)(function isFirefox() {
    return navigator.userAgent.includes('Firefox');
});

});
parcelRegister("82mi7", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $5d9fcd33e78e602a$export$d2de3aaeafa91619; });
/** Provide a function that you only ever want to be called a single time */ function $5d9fcd33e78e602a$export$d2de3aaeafa91619(fn) {
    var cache = null;
    return function wrapped() {
        if (!cache) {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var result = fn.apply(this, args);
            cache = {
                result: result
            };
        }
        return cache.result;
    };
}

});


parcelRegister("fBjMl", function(module, exports) {

$parcel$export(module.exports, "isSafari", function () { return $b5b9a75806fcdb8d$export$95df08bae54cb4df; });

var $82mi7 = parcelRequire("82mi7");
var $b5b9a75806fcdb8d$export$95df08bae54cb4df = (0, $82mi7.once)(function isSafari() {
    var _navigator = navigator, userAgent = _navigator.userAgent;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
});

});

parcelRegister("fiCEq", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindowInSafari", function () { return $b23684c160dc7367$export$de68634bd94ed596; });
$parcel$export(module.exports, "isLeavingWindowInSafari", function () { return $b23684c160dc7367$export$f21837c338005454; });

var $k6Bkl = parcelRequire("k6Bkl");

var $fBjMl = parcelRequire("fBjMl");
/* For "dragenter" events, the browser should set `relatedTarget` to the previous element.
 * For external drag operations, our first "dragenter" event should have a `event.relatedTarget` of `null`.
 *
 *  Unfortunately in Safari `event.relatedTarget` is *always* set to `null`
 *  Safari bug: https://bugs.webkit.org/show_bug.cgi?id=242627
 *  To work around this we count "dragenter" and "dragleave" events */ // Using symbols for event properties so we don't clash with
// anything on the `event` object
var $b23684c160dc7367$var$symbols = {
    isLeavingWindow: Symbol('leaving'),
    isEnteringWindow: Symbol('entering')
};
function $b23684c160dc7367$export$de68634bd94ed596(_ref) {
    var dragEnter = _ref.dragEnter;
    if (!(0, $fBjMl.isSafari)()) return false;
    return dragEnter.hasOwnProperty($b23684c160dc7367$var$symbols.isEnteringWindow);
}
function $b23684c160dc7367$export$f21837c338005454(_ref2) {
    var dragLeave = _ref2.dragLeave;
    if (!(0, $fBjMl.isSafari)()) return false;
    return dragLeave.hasOwnProperty($b23684c160dc7367$var$symbols.isLeavingWindow);
}
(function fixSafari() {
    // Don't do anything when server side rendering
    if (typeof window === 'undefined') return;
    if (!(0, $fBjMl.isSafari)()) return;
    function getInitialState() {
        return {
            enterCount: 0,
            isOverWindow: false
        };
    }
    var state = getInitialState();
    function resetState() {
        state = getInitialState();
    }
    // These event listeners are bound _forever_ and _never_ removed
    // We don't bother cleaning up these event listeners (for now)
    // as this workaround is only for Safari
    // This is how the event count works:
    //
    // lift (+1 enterCount)
    // - dragstart(draggable) [enterCount: 0]
    // - dragenter(draggable) [enterCount: 1]
    // leaving draggable (+0 enterCount)
    // - dragenter(document.body) [enterCount: 2]
    // - dragleave(draggable) [enterCount: 1]
    // leaving window (-1 enterCount)
    // - dragleave(document.body) [enterCount: 0] {leaving the window}
    // Things to note:
    // - dragenter and dragleave bubble
    // - the first dragenter when entering a window might not be on `window`
    //   - it could be on an element that is pressed up against the window
    //   - (so we cannot rely on `event.target` values)
    (0, $k6Bkl.bindAll)(window, [
        {
            type: 'dragstart',
            listener: function listener() {
                state.enterCount = 0;
                // drag start occurs in the source window
                state.isOverWindow = true;
            // When a drag first starts it will also trigger a "dragenter" on the draggable element
            }
        },
        {
            type: 'drop',
            listener: resetState
        },
        {
            type: 'dragend',
            listener: resetState
        },
        {
            type: 'dragenter',
            listener: function listener(event) {
                if (!state.isOverWindow && state.enterCount === 0) // Patching the `event` object
                // The `event` object is shared with all event listeners for the event
                // @ts-expect-error: adding property to the event object
                event[$b23684c160dc7367$var$symbols.isEnteringWindow] = true;
                state.isOverWindow = true;
                state.enterCount++;
            }
        },
        {
            type: 'dragleave',
            listener: function listener(event) {
                state.enterCount--;
                if (state.isOverWindow && state.enterCount === 0) {
                    // Patching the `event` object as it is shared with all event listeners
                    // The `event` object is shared with all event listeners for the event
                    // @ts-expect-error: adding property to the event object
                    event[$b23684c160dc7367$var$symbols.isLeavingWindow] = true;
                    state.isOverWindow = false;
                }
            }
        }
    ], // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
        capture: true
    });
})();

});

parcelRegister("eYtjj", function(module, exports) {

$parcel$export(module.exports, "isFromAnotherWindow", function () { return $ae6d67c2f78f8091$export$e46810fef53b5b0e; });
/**
 * Does the `EventTarget` look like a `Node` based on "duck typing".
 *
 * Helpful when the `Node` might be outside of the current document
 * so we cannot to an `target instanceof Node` check.
 */ function $ae6d67c2f78f8091$var$isNodeLike(target) {
    return 'nodeName' in target;
}
function $ae6d67c2f78f8091$export$e46810fef53b5b0e(eventTarget) {
    return $ae6d67c2f78f8091$var$isNodeLike(eventTarget) && eventTarget.ownerDocument !== document;
}

});


parcelRegister("gg3MR", function(module, exports) {

$parcel$export(module.exports, "getBindingsForBrokenDrags", function () { return $bd6113ff9bfbbef2$export$ac5e5b0daf997b2; });
function $bd6113ff9bfbbef2$export$ac5e5b0daf997b2(_ref) {
    var onDragEnd = _ref.onDragEnd;
    return [
        // ## Detecting drag ending for removed draggables
        //
        // If a draggable element is removed during a drag and the user drops:
        // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
        // 2. if not over a valid drop target (or cancelled): we get nothing
        // The "dragend" event will not fire on the source draggable if it has been
        // removed from the DOM.
        // So we need to figure out if a drag operation has finished by looking at other events
        // We can do this by looking at other events
        // ### First detection: "pointermove" events
        // 1. "pointermove" events cannot fire during a drag and drop operation
        // according to the spec. So if we get a "pointermove" it means that
        // the drag and drop operations has finished. So if we get a "pointermove"
        // we know that the drag is over
        // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
        // other pointer events. However, firefox will allow a few
        // pointer event to get through after a drag starts.
        // The most I've seen is 3
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    onDragEnd();
                };
            }()
        },
        // ### Second detection: "pointerdown" events
        // If we receive this event then we know that a drag operation has finished
        // and potentially another one is about to start.
        // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
        {
            type: 'pointerdown',
            listener: onDragEnd
        }
    ];
}

});

parcelRegister("i4Iqj", function(module, exports) {

$parcel$export(module.exports, "getInput", function () { return $d28b0f42f38967f9$export$7c112ceec8941e67; });
function $d28b0f42f38967f9$export$7c112ceec8941e67(event) {
    return {
        altKey: event.altKey,
        button: event.button,
        buttons: event.buttons,
        ctrlKey: event.ctrlKey,
        metaKey: event.metaKey,
        shiftKey: event.shiftKey,
        clientX: event.clientX,
        clientY: event.clientY,
        pageX: event.pageX,
        pageY: event.pageY
    };
}

});

parcelRegister("X78OI", function(module, exports) {

$parcel$export(module.exports, "makeDispatch", function () { return $0b1b0ce5ffa85461$export$9f13ecc44e83d682; });

var $gulVP = parcelRequire("gulVP");
var $0b1b0ce5ffa85461$var$scheduleOnDrag = (0, $gulVP.default)(function(fn) {
    return fn();
});
var $0b1b0ce5ffa85461$var$dragStart = function() {
    var scheduled = null;
    function schedule(fn) {
        var frameId = requestAnimationFrame(function() {
            scheduled = null;
            fn();
        });
        scheduled = {
            frameId: frameId,
            fn: fn
        };
    }
    function flush() {
        if (scheduled) {
            cancelAnimationFrame(scheduled.frameId);
            scheduled.fn();
            scheduled = null;
        }
    }
    return {
        schedule: schedule,
        flush: flush
    };
}();
function $0b1b0ce5ffa85461$export$9f13ecc44e83d682(_ref) {
    var source = _ref.source, initial = _ref.initial, dispatchEvent = _ref.dispatchEvent;
    var previous = {
        dropTargets: []
    };
    function safeDispatch(args) {
        dispatchEvent(args);
        previous = {
            dropTargets: args.payload.location.current.dropTargets
        };
    }
    var dispatch = {
        start: function start(_ref2) {
            var nativeSetDragImage = _ref2.nativeSetDragImage;
            // Ensuring that both `onGenerateDragPreview` and `onDragStart` get the same location.
            // We do this so that `previous` is`[]` in `onDragStart` (which is logical)
            var location = {
                current: initial,
                previous: previous,
                initial: initial
            };
            // a `onGenerateDragPreview` does _not_ add another entry for `previous`
            // onDragPreview
            safeDispatch({
                eventName: 'onGenerateDragPreview',
                payload: {
                    source: source,
                    location: location,
                    nativeSetDragImage: nativeSetDragImage
                }
            });
            $0b1b0ce5ffa85461$var$dragStart.schedule(function() {
                safeDispatch({
                    eventName: 'onDragStart',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        dragUpdate: function dragUpdate(_ref3) {
            var current = _ref3.current;
            $0b1b0ce5ffa85461$var$dragStart.flush();
            $0b1b0ce5ffa85461$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDropTargetChange',
                payload: {
                    source: source,
                    location: {
                        initial: initial,
                        previous: previous,
                        current: current
                    }
                }
            });
        },
        drag: function drag(_ref4) {
            var current = _ref4.current;
            $0b1b0ce5ffa85461$var$scheduleOnDrag(function() {
                $0b1b0ce5ffa85461$var$dragStart.flush();
                var location = {
                    initial: initial,
                    previous: previous,
                    current: current
                };
                safeDispatch({
                    eventName: 'onDrag',
                    payload: {
                        source: source,
                        location: location
                    }
                });
            });
        },
        drop: function drop(_ref5) {
            var current = _ref5.current, updatedSourcePayload = _ref5.updatedSourcePayload;
            $0b1b0ce5ffa85461$var$dragStart.flush();
            $0b1b0ce5ffa85461$var$scheduleOnDrag.cancel();
            safeDispatch({
                eventName: 'onDrop',
                payload: {
                    source: updatedSourcePayload !== null && updatedSourcePayload !== void 0 ? updatedSourcePayload : source,
                    location: {
                        current: current,
                        previous: previous,
                        initial: initial
                    }
                }
            });
        }
    };
    return dispatch;
}

});
parcelRegister("gulVP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01075db169f1121$export$2e2bcd8739ae039; });
var $c01075db169f1121$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $c01075db169f1121$export$2e2bcd8739ae039 = $c01075db169f1121$var$rafSchd;

});



parcelRegister("7nUng", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $5606691f53bd8a97$export$6503ec6e8aabbaf; });
// Extending `Map` to allow us to link Key and Values together
var $5606691f53bd8a97$var$ledger = new Map();
function $5606691f53bd8a97$var$registerUsage(_ref) {
    var typeKey = _ref.typeKey, mount = _ref.mount;
    var entry = $5606691f53bd8a97$var$ledger.get(typeKey);
    if (entry) {
        entry.usageCount++;
        return entry;
    }
    var initial = {
        typeKey: typeKey,
        unmount: mount(),
        usageCount: 1
    };
    $5606691f53bd8a97$var$ledger.set(typeKey, initial);
    return initial;
}
function $5606691f53bd8a97$export$6503ec6e8aabbaf(args) {
    var entry = $5606691f53bd8a97$var$registerUsage(args);
    return function unregister() {
        entry.usageCount--;
        if (entry.usageCount > 0) return;
        // Only a single usage left, remove it
        entry.unmount();
        $5606691f53bd8a97$var$ledger.delete(args.typeKey);
    };
}

});

parcelRegister("aqWlM", function(module, exports) {

$parcel$export(module.exports, "makeDropTarget", function () { return $79899842ae081ad2$export$47d10e7bd9c81890; });

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $cMdu5 = parcelRequire("cMdu5");

var $82mi7 = parcelRequire("82mi7");

var $3CvKc = parcelRequire("3CvKc");
function $79899842ae081ad2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $79899842ae081ad2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $79899842ae081ad2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $79899842ae081ad2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $79899842ae081ad2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $79899842ae081ad2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $79899842ae081ad2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $79899842ae081ad2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $79899842ae081ad2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $79899842ae081ad2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $79899842ae081ad2$var$copyReverse(array) {
    return array.slice(0).reverse();
}
function $79899842ae081ad2$export$47d10e7bd9c81890(_ref) {
    var typeKey = _ref.typeKey, defaultDropEffect = _ref.defaultDropEffect;
    var registry = new WeakMap();
    var dropTargetDataAtt = "data-drop-target-for-".concat(typeKey);
    var dropTargetSelector = "[".concat(dropTargetDataAtt, "]");
    function addToRegistry(args) {
        registry.set(args.element, args);
        return function() {
            return registry.delete(args.element);
        };
    }
    function dropTargetForConsumers(args) {
        var existing;
        var cleanup = (0, $cMdu5.combine)((0, $3CvKc.addAttribute)(args.element, {
            attribute: dropTargetDataAtt,
            value: 'true'
        }), addToRegistry(args));
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $82mi7.once)(cleanup);
    }
    function getActualDropTargets(_ref2) {
        var _args$getData, _args$getData2, _args$getDropEffect, _args$getDropEffect2;
        var source = _ref2.source, target = _ref2.target, input = _ref2.input, _ref2$result = _ref2.result, result = _ref2$result === void 0 ? [] : _ref2$result;
        if (target == null) return result;
        if (!(target instanceof Element)) {
            // For "text-selection" drags, the original `target`
            // is not an `Element`, so we need to start looking from
            // the parent element
            if (target instanceof Node) return getActualDropTargets({
                source: source,
                target: target.parentElement,
                input: input,
                result: result
            });
            // not sure what we are working with,
            // so we can exit.
            return result;
        }
        var closest = target.closest(dropTargetSelector);
        // Cannot find anything else
        if (closest == null) return result;
        var args = registry.get(closest);
        // error: something had a dropTargetSelector but we could not
        // find a match. For now, failing silently
        if (args == null) return result;
        var feedback = {
            input: input,
            source: source,
            element: args.element
        };
        // if dropping is not allowed, skip this drop target
        // and continue looking up the DOM tree
        if (args.canDrop && !args.canDrop(feedback)) return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            result: result
        });
        // calculate our new record
        var data = (_args$getData = (_args$getData2 = args.getData) === null || _args$getData2 === void 0 ? void 0 : _args$getData2.call(args, feedback)) !== null && _args$getData !== void 0 ? _args$getData : {};
        var dropEffect = (_args$getDropEffect = (_args$getDropEffect2 = args.getDropEffect) === null || _args$getDropEffect2 === void 0 ? void 0 : _args$getDropEffect2.call(args, feedback)) !== null && _args$getDropEffect !== void 0 ? _args$getDropEffect : defaultDropEffect;
        var record = {
            data: data,
            element: args.element,
            dropEffect: dropEffect,
            // we are collecting _actual_ drop targets, so these are
            // being applied _not_ due to stickiness
            isActiveDueToStickiness: false
        };
        return getActualDropTargets({
            source: source,
            target: args.element.parentElement,
            input: input,
            // Using bubble ordering. Same ordering as `event.getPath()`
            result: [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(result), [
                record
            ])
        });
    }
    function notifyCurrent(_ref3) {
        var eventName = _ref3.eventName, payload = _ref3.payload;
        var _iterator = $79899842ae081ad2$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _entry$eventName;
                var record = _step.value;
                var entry = registry.get(record.element);
                var args = $79899842ae081ad2$var$_objectSpread($79899842ae081ad2$var$_objectSpread({}, payload), {}, {
                    self: record
                });
                entry === null || entry === void 0 || (_entry$eventName = entry[eventName]) === null || _entry$eventName === void 0 || _entry$eventName.call(entry, // I cannot seem to get the types right here.
                // TS doesn't seem to like that one event can need `nativeSetDragImage`
                // @ts-expect-error
                args);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    var actions = {
        onGenerateDragPreview: notifyCurrent,
        onDrag: notifyCurrent,
        onDragStart: notifyCurrent,
        onDrop: notifyCurrent,
        onDropTargetChange: function onDropTargetChange(_ref4) {
            var payload = _ref4.payload;
            var isCurrent = new Set(payload.location.current.dropTargets.map(function(record) {
                return record.element;
            }));
            var visited = new Set();
            var _iterator2 = $79899842ae081ad2$var$_createForOfIteratorHelper(payload.location.previous.dropTargets), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _entry$onDropTargetCh;
                    var record = _step2.value;
                    visited.add(record.element);
                    var entry = registry.get(record.element);
                    var isOver = isCurrent.has(record.element);
                    var args = $79899842ae081ad2$var$_objectSpread($79899842ae081ad2$var$_objectSpread({}, payload), {}, {
                        self: record
                    });
                    entry === null || entry === void 0 || (_entry$onDropTargetCh = entry.onDropTargetChange) === null || _entry$onDropTargetCh === void 0 || _entry$onDropTargetCh.call(entry, args);
                    // if we cannot find the drop target in the current array, then it has been left
                    if (!isOver) {
                        var _entry$onDragLeave;
                        entry === null || entry === void 0 || (_entry$onDragLeave = entry.onDragLeave) === null || _entry$onDragLeave === void 0 || _entry$onDragLeave.call(entry, args);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var _iterator3 = $79899842ae081ad2$var$_createForOfIteratorHelper(payload.location.current.dropTargets), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _entry$onDropTargetCh2, _entry$onDragEnter;
                    var _record = _step3.value;
                    // already published an update to this drop target
                    if (visited.has(_record.element)) continue;
                    // at this point we have a new drop target that is being entered into
                    var _args = $79899842ae081ad2$var$_objectSpread($79899842ae081ad2$var$_objectSpread({}, payload), {}, {
                        self: _record
                    });
                    var _entry = registry.get(_record.element);
                    _entry === null || _entry === void 0 || (_entry$onDropTargetCh2 = _entry.onDropTargetChange) === null || _entry$onDropTargetCh2 === void 0 || _entry$onDropTargetCh2.call(_entry, _args);
                    _entry === null || _entry === void 0 || (_entry$onDragEnter = _entry.onDragEnter) === null || _entry$onDragEnter === void 0 || _entry$onDragEnter.call(_entry, _args);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    };
    function dispatchEvent(args) {
        actions[args.eventName](args);
    }
    function getIsOver(_ref5) {
        var source = _ref5.source, target = _ref5.target, input = _ref5.input, current = _ref5.current;
        var actual = getActualDropTargets({
            source: source,
            target: target,
            input: input
        });
        // stickiness is only relevant when we have less
        // drop targets than we did before
        if (actual.length >= current.length) return actual;
        // less 'actual' drop targets than before,
        // we need to see if 'stickiness' applies
        // An old drop target will continue to be dropped on if:
        // 1. it has the same parent
        // 2. nothing exists in it's previous index
        var lastCaptureOrdered = $79899842ae081ad2$var$copyReverse(current);
        var actualCaptureOrdered = $79899842ae081ad2$var$copyReverse(actual);
        var resultCaptureOrdered = [];
        for(var index = 0; index < lastCaptureOrdered.length; index++){
            var _argsForLast$getIsSti;
            var last = lastCaptureOrdered[index];
            var fresh = actualCaptureOrdered[index];
            // if a record is in the new index -> use that
            // it will have the latest data + dropEffect
            if (fresh != null) {
                resultCaptureOrdered.push(fresh);
                continue;
            }
            // At this point we have no drop target in the old spot
            // Check to see if we can use a previous sticky drop target
            // The "parent" is the one inside of `resultCaptureOrdered`
            // (the parent might be a drop target that was sticky)
            var parent = resultCaptureOrdered[index - 1];
            var lastParent = lastCaptureOrdered[index - 1];
            // Stickiness is based on parent relationships, so if the parent relationship has change
            // then we can stop our search
            if ((parent === null || parent === void 0 ? void 0 : parent.element) !== (lastParent === null || lastParent === void 0 ? void 0 : lastParent.element)) break;
            // We need to check whether the old drop target can still be dropped on
            var argsForLast = registry.get(last.element);
            // We cannot drop on a drop target that is no longer mounted
            if (!argsForLast) break;
            var feedback = {
                input: input,
                source: source,
                element: argsForLast.element
            };
            // We cannot drop on a drop target that no longer allows being dropped on
            if (argsForLast.canDrop && !argsForLast.canDrop(feedback)) break;
            // We cannot drop on a drop target that is no longer sticky
            if (!((_argsForLast$getIsSti = argsForLast.getIsSticky) !== null && _argsForLast$getIsSti !== void 0 && _argsForLast$getIsSti.call(argsForLast, feedback))) break;
            // Note: intentionally not recollecting `getData()` or `getDropEffect()`
            // Previous values for `data` and `dropEffect` will be borrowed
            // This is to prevent things like the 'closest edge' changing when
            // no longer over a drop target.
            // We could change our mind on this behaviour in the future
            resultCaptureOrdered.push($79899842ae081ad2$var$_objectSpread($79899842ae081ad2$var$_objectSpread({}, last), {}, {
                // making it clear to consumers this drop target is active due to stickiness
                isActiveDueToStickiness: true
            }));
        }
        // return bubble ordered result
        return $79899842ae081ad2$var$copyReverse(resultCaptureOrdered);
    }
    return {
        dropTargetForConsumers: dropTargetForConsumers,
        getIsOver: getIsOver,
        dispatchEvent: dispatchEvent
    };
}

});
parcelRegister("3CvKc", function(module, exports) {

$parcel$export(module.exports, "addAttribute", function () { return $2a2d8b6a2fe79ff0$export$5dcb5c23b6ba980a; });
function $2a2d8b6a2fe79ff0$export$5dcb5c23b6ba980a(element, _ref) {
    var attribute = _ref.attribute, value = _ref.value;
    element.setAttribute(attribute, value);
    return function() {
        return element.removeAttribute(attribute);
    };
}

});


parcelRegister("6Q9MY", function(module, exports) {

$parcel$export(module.exports, "makeMonitor", function () { return $014904ec6a9c8e3a$export$5dd4ed888d5b12ca; });

var $6bkHe = parcelRequire("6bkHe");

var $82mi7 = parcelRequire("82mi7");
function $014904ec6a9c8e3a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $014904ec6a9c8e3a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $014904ec6a9c8e3a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $014904ec6a9c8e3a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $014904ec6a9c8e3a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $014904ec6a9c8e3a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $014904ec6a9c8e3a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $014904ec6a9c8e3a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $014904ec6a9c8e3a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $014904ec6a9c8e3a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $014904ec6a9c8e3a$export$5dd4ed888d5b12ca() {
    var registry = new Set();
    var dragging = null;
    function tryAddToActive(monitor) {
        if (!dragging) return;
        // Monitor is allowed to monitor events if:
        // 1. It has no `canMonitor` function (default is that a monitor can listen to everything)
        // 2. `canMonitor` returns true
        if (!monitor.canMonitor || monitor.canMonitor(dragging.canMonitorArgs)) dragging.active.add(monitor);
    }
    function monitorForConsumers(args) {
        // We are giving each `args` a new reference so that you
        // can create multiple monitors with the same `args`.
        var entry = $014904ec6a9c8e3a$var$_objectSpread({}, args);
        registry.add(entry);
        // if there is an active drag we need to see if this new monitor is relevant
        tryAddToActive(entry);
        function cleanup() {
            registry.delete(entry);
            // We need to stop publishing events during a drag to this monitor!
            if (dragging) dragging.active.delete(entry);
        }
        // Wrapping in `once` to prevent unexpected side effects if consumers call
        // the clean up function multiple times.
        return (0, $82mi7.once)(cleanup);
    }
    function dispatchEvent(_ref) {
        var eventName = _ref.eventName, payload = _ref.payload;
        if (eventName === 'onGenerateDragPreview') {
            dragging = {
                canMonitorArgs: {
                    initial: payload.location.initial,
                    source: payload.source
                },
                active: new Set()
            };
            var _iterator = $014904ec6a9c8e3a$var$_createForOfIteratorHelper(registry), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var monitor = _step.value;
                    tryAddToActive(monitor);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        // This should never happen.
        if (!dragging) return;
        // Creating an array from the set _before_ iterating
        // This is so that monitors added during the current event will not be called.
        // This behaviour matches native EventTargets where an event listener
        // cannot add another event listener during an active event to the same
        // event target in the same event (for us we have a single global event target)
        var active = Array.from(dragging.active);
        for(var _i = 0, _active = active; _i < _active.length; _i++){
            var _monitor = _active[_i];
            // A monitor can be removed by another monitor during an event.
            // We need to check that the monitor is still registered before calling it
            if (dragging.active.has(_monitor)) {
                var _monitor$eventName;
                // @ts-expect-error: I cannot get this type working!
                (_monitor$eventName = _monitor[eventName]) === null || _monitor$eventName === void 0 || _monitor$eventName.call(_monitor, payload);
            }
        }
        if (eventName === 'onDrop') {
            dragging.active.clear();
            dragging = null;
        }
    }
    return {
        dispatchEvent: dispatchEvent,
        monitorForConsumers: monitorForConsumers
    };
}

});


parcelRegister("jvsVi", function(module, exports) {

$parcel$export(module.exports, "isAndroid", function () { return $e3375917319f2afe$export$a11b0059900ceec8; });
$parcel$export(module.exports, "androidFallbackText", function () { return $e3375917319f2afe$export$aceb3ed8b7f7bd2c; });

var $82mi7 = parcelRequire("82mi7");
var $e3375917319f2afe$export$a11b0059900ceec8 = (0, $82mi7.once)(function isAndroid() {
    return navigator.userAgent.toLocaleLowerCase().includes('android');
});
var $e3375917319f2afe$export$aceb3ed8b7f7bd2c = 'pdnd:android-fallback';

});

parcelRegister("1os2S", function(module, exports) {

$parcel$export(module.exports, "textMediaType", function () { return $103dc98e66238d85$export$fd3d00026297c0ad; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $103dc98e66238d85$export$fd3d00026297c0ad = 'text/plain';

});

parcelRegister("ivYQF", function(module, exports) {

$parcel$export(module.exports, "URLMediaType", function () { return $d7aa527f46e501fb$export$4c44a460f123106; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $d7aa527f46e501fb$export$4c44a460f123106 = 'text/uri-list';

});

parcelRegister("578kN", function(module, exports) {

$parcel$export(module.exports, "elementAdapterNativeDataKey", function () { return $3b94124229172a14$export$c9c4cc54e73b125d; });
/**
 * This key has been pulled into a separate module
 * so that the external adapter does not need to import
 * the element adapter
 */ var $3b94124229172a14$export$c9c4cc54e73b125d = 'application/vnd.pdnd';

});



parcelRegister("kDH6W", function(module, exports) {

$parcel$export(module.exports, "makeFixForAdapter", function () { return $f068e41c97d448c9$export$a74bff2507e6126b; });

var $cF8Kw = parcelRequire("cF8Kw");
parcelRequire("1sUoM");
var $cMdu5 = parcelRequire("cMdu5");
/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $f068e41c97d448c9$var$setStyle(el, _ref) {
    var property = _ref.property, rule = _ref.rule, _ref$priority = _ref.priority, priority = _ref$priority === void 0 ? '' : _ref$priority;
    var originalValue = el.style.getPropertyValue(property);
    var originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $f068e41c97d448c9$var$hasSameOrigin(href1, href2) {
    var url1;
    var url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch (error) {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $f068e41c97d448c9$var$isIframeOnAnotherDomain(iframe) {
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
   */ if (iframe.srcdoc) return false;
    /**
   * iframe with contents defined inline. Runs on the current origin.
   * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
   */ if (iframe.src.startsWith('data:')) return false;
    return !$f068e41c97d448c9$var$hasSameOrigin(window.location.href, iframe.src);
}
var $f068e41c97d448c9$var$registry = new Map();
function $f068e41c97d448c9$var$applyFix(watchForEndOfInteraction) {
    var iframes = Array.from(document.querySelectorAll('iframe')).filter($f068e41c97d448c9$var$isIframeOnAnotherDomain);
    var cleanups = iframes.map(function(iframe) {
        var entry = $f068e41c97d448c9$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $f068e41c97d448c9$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $f068e41c97d448c9$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $f068e41c97d448c9$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $cMdu5.combine).apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(cleanups))();
    }
    var cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $f068e41c97d448c9$export$a74bff2507e6126b(_ref2) {
    var watchForInteractionStart = _ref2.watchForInteractionStart, watchForInteractionEnd = _ref2.watchForInteractionEnd;
    var registrationCount = 0;
    var stopWatchingInteractionStart = null;
    function start() {
        $f068e41c97d448c9$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            var _stopWatchingInteract;
            registrationCount--;
            if (registrationCount !== 0) return;
            (_stopWatchingInteract = stopWatchingInteractionStart) === null || _stopWatchingInteract === void 0 || _stopWatchingInteract();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}

});


parcelRegister("jqxT3", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForExternal", function () { return $e24abb4c54cc4ba7$export$27d79116d3a4e7d5; });
parcelRequire("gOibZ");
var $au3Lf = parcelRequire("au3Lf");

var $kDH6W = parcelRequire("kDH6W");
function $e24abb4c54cc4ba7$var$watchForInteractionStart(_ref) {
    var start = _ref.start;
    return (0, $au3Lf.monitorForExternal)({
        onDragStart: function onDragStart() {
            start();
        }
    });
}
function $e24abb4c54cc4ba7$var$watchForInteractionEnd(_ref2) {
    var stop = _ref2.stop;
    return (0, $au3Lf.monitorForExternal)({
        onDrop: function onDrop() {
            stop();
        }
    });
}
var $e24abb4c54cc4ba7$var$api = (0, $kDH6W.makeFixForAdapter)({
    watchForInteractionStart: $e24abb4c54cc4ba7$var$watchForInteractionStart,
    watchForInteractionEnd: $e24abb4c54cc4ba7$var$watchForInteractionEnd
});
function $e24abb4c54cc4ba7$export$27d79116d3a4e7d5() {
    return $e24abb4c54cc4ba7$var$api.registerUsage();
}

});
parcelRegister("gOibZ", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return (parcelRequire("au3Lf")).monitorForExternal; });

var $au3Lf = parcelRequire("au3Lf");
 // The data that is being dragged

});
parcelRegister("au3Lf", function(module, exports) {

$parcel$export(module.exports, "monitorForExternal", function () { return $7a1f9f9ba8d1b74d$export$bb1740f3194979c1; });

var $cF8Kw = parcelRequire("cF8Kw");

var $k6Bkl = parcelRequire("k6Bkl");

var $c8h3C = parcelRequire("c8h3C");

var $jvsVi = parcelRequire("jvsVi");

var $fII72 = parcelRequire("fII72");

var $gg3MR = parcelRequire("gg3MR");

var $1os2S = parcelRequire("1os2S");

var $578kN = parcelRequire("578kN");
function $7a1f9f9ba8d1b74d$export$a8e56a860d7957c7(_ref) {
    var type = _ref.type, value = _ref.value;
    // We don't want to expose our private elementAdapter key / value
    if (type === (0, $578kN.elementAdapterNativeDataKey)) return false;
    // Not exposing "text/plain" if it contains the android fallback text
    // We _could_ add an `isAndroid()` check, but it's probably safest
    // to trim this data out, regardless of what OS we see it on.
    if (type === (0, $1os2S.textMediaType) && value === (0, $jvsVi.androidFallbackText)) return false;
    return true;
}
function $7a1f9f9ba8d1b74d$export$8c257a3856120a77(transfer) {
    return Array.from(transfer.types).filter(function(type) {
        return $7a1f9f9ba8d1b74d$export$a8e56a860d7957c7({
            type: type,
            value: transfer.getData(type)
        });
    });
}
function $7a1f9f9ba8d1b74d$export$8d28cfecded8dcab(dataTransfer) {
    // item.kind is 'string' | 'file'
    // For 'string' item.type is the mimeType (eg 'text/plain')
    // For 'file' item.type is the file type (eg 'image/jpg')
    return Array.from(dataTransfer.items).filter(function(item) {
        return item.kind === 'file' || $7a1f9f9ba8d1b74d$export$a8e56a860d7957c7({
            type: item.type,
            value: dataTransfer.getData(item.type)
        });
    });
}
var $7a1f9f9ba8d1b74d$var$didDragStartLocally = false;
var $7a1f9f9ba8d1b74d$var$adapter = (0, $c8h3C.makeAdapter)({
    typeKey: 'external',
    // for external drags, we are generally making a copy of something that is being dragged
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter
        // has a chance to get in first on the`document`.
        // We are giving preference to the element adapter.
        return (0, $k6Bkl.bind)(window, {
            type: 'dragenter',
            listener: function listener(event) {
                // drag operation was started within the document, it won't be an "external" drag
                if ($7a1f9f9ba8d1b74d$var$didDragStartLocally) return;
                // Note: not checking if event was cancelled (`event.defaultPrevented`) as
                // cancelling a "dragenter" accepts the drag operation (not prevent it)
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                if (!api.canStart(event)) return;
                if (!(0, $fII72.isEnteringWindow)({
                    dragEnter: event
                })) return;
                // Note: not checking types for `elementAdapterNativeDataKey` as we expect to see that
                // key when pdnd started the drag in another document
                var types = $7a1f9f9ba8d1b74d$export$8c257a3856120a77(event.dataTransfer);
                if (!types.length) return;
                var locked = {
                    types: types,
                    items: [],
                    getStringData: function getStringData() {
                        return null;
                    }
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'external',
                        startedFrom: 'external',
                        payload: locked,
                        getDropPayload: function getDropPayload(event) {
                            // this would be a platform error
                            // trying to handle it gracefully rather than throwing (for now)
                            if (!event.dataTransfer) return locked;
                            var items = $7a1f9f9ba8d1b74d$export$8d28cfecded8dcab(event.dataTransfer);
                            // need to use `.bind` as `getData` is required
                            // to be run with `event.dataTransfer` as the "this" context
                            var nativeGetData = event.dataTransfer.getData.bind(event.dataTransfer);
                            return {
                                types: types,
                                items: items,
                                // return `null` if there is no result, otherwise string
                                getStringData: function getStringData(mediaType) {
                                    // not dragging the requested type
                                    // return `null` (no result)
                                    if (!types.includes(mediaType)) return null;
                                    // nativeGetData will return `""` when there is no value,
                                    // but at this point we know we will only get explicitly set
                                    // values back as we have checked the `types`.
                                    // `""` can be an explicitly set value.
                                    var value = nativeGetData(mediaType);
                                    // not exposing data for unavailable types
                                    if (!$7a1f9f9ba8d1b74d$export$a8e56a860d7957c7({
                                        type: mediaType,
                                        value: value
                                    })) return null;
                                    return value;
                                }
                            };
                        }
                    }
                });
            }
        });
    }
});
function $7a1f9f9ba8d1b74d$export$9edc779df9a85289(args) {
    // not removing unused events, just leaning on the type system
    return $7a1f9f9ba8d1b74d$var$adapter.dropTarget(args);
}
function $7a1f9f9ba8d1b74d$export$bb1740f3194979c1(args) {
    // not removing unused events, just leaning on the type system
    return $7a1f9f9ba8d1b74d$var$adapter.monitor(args);
}
(function startup() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    // A shared single usage registration as we want to capture
    // all external drag operations, even if there are no drop targets
    // on the page yet
    $7a1f9f9ba8d1b74d$var$adapter.registerUsage();
    // independent of pdnd, we need to keep track of
    // all drag operations so that we can know if a drag operation
    // has started locally
    var idle = {
        type: 'idle'
    };
    var state = idle;
    function clear() {
        if (state.type !== 'dragging') return;
        $7a1f9f9ba8d1b74d$var$didDragStartLocally = false;
        state.cleanup();
        state = idle;
    }
    function bindEndEvents() {
        return (0, $k6Bkl.bindAll)(window, [
            {
                type: 'dragend',
                listener: clear
            }
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))((0, $gg3MR.getBindingsForBrokenDrags)({
            onDragEnd: clear
        }))), // we want to make sure we get all the events,
        // and this helps avoid not seeing events when folks stop
        // them later on the event path
        {
            capture: true
        });
    }
    // we always keep this event listener active
    (0, $k6Bkl.bind)(window, {
        type: 'dragstart',
        listener: function listener() {
            // something bad has happened if this is true!
            if (state.type !== 'idle') return;
            // set our global flag
            $7a1f9f9ba8d1b74d$var$didDragStartLocally = true;
            state = {
                type: 'dragging',
                cleanup: bindEndEvents()
            };
        },
        // binding in the capture phase so these listeners are called
        // before our listeners in the adapters `mount` function
        options: {
            capture: true
        }
    });
})(); /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Arguments given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Arguments given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("fII72", function(module, exports) {

$parcel$export(module.exports, "isEnteringWindow", function () { return $b71d2eeba10575bc$export$d1c6f249e893cdf4; });

var $jOw0P = parcelRequire("jOw0P");

var $fBjMl = parcelRequire("fBjMl");

var $fiCEq = parcelRequire("fiCEq");

var $eYtjj = parcelRequire("eYtjj");
function $b71d2eeba10575bc$export$d1c6f249e893cdf4(_ref) {
    var dragEnter = _ref.dragEnter;
    var type = dragEnter.type, relatedTarget = dragEnter.relatedTarget;
    if (type !== 'dragenter') return false;
    if ((0, $fBjMl.isSafari)()) return (0, $fiCEq.isEnteringWindowInSafari)({
        dragEnter: dragEnter
    });
    // standard check
    if (relatedTarget == null) return true;
    /**
   * 🦊 Exception: `iframe` in Firefox (`125.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is the `iframe` element in the parent `window`
   * (foreign element)
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is an element inside the child `iframe`
   * (foreign element)
   */ if ((0, $jOw0P.isFirefox)()) return (0, $eYtjj.isFromAnotherWindow)(relatedTarget);
    /**
   * 🌏 Exception: `iframe` in Chrome (`124.0`)
   *
   * Case 1: parent `window` → child `iframe`
   * `relatedTarget` is `null` *(standard check)*
   *
   * Case 2: child `iframe` → parent `window`
   * `relatedTarget` is the `iframe` element in the parent `window`
   */ // Case 2
    // Using `instanceof` check as the element will be in the same `window`
    return relatedTarget instanceof HTMLIFrameElement;
}

});




parcelRegister("87pya", function(module, exports) {

$parcel$export(module.exports, "disableDraggingToCrossOriginIFramesForTextSelection", function () { return $5e92cbe2f6b4d374$export$9c0606fcefb5d1e2; });

var $k6Bkl = parcelRequire("k6Bkl");
parcelRequire("1sUoM");
var $cMdu5 = parcelRequire("cMdu5");
parcelRequire("18H4O");
var $cWYzQ = parcelRequire("cWYzQ");

var $kDH6W = parcelRequire("kDH6W");
function $5e92cbe2f6b4d374$var$watchForInteractionEnd(_ref) {
    var stop = _ref.stop;
    var isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    var frameId = null;
    var unbindEvents = (0, $k6Bkl.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener: function listener() {
                /**
       * The pdnd `onDragStart()` fires in the frame after "dragstart"
       * So we are delaying our isDragging check to give a chance
       * for `onDragStart()` to set the value correctly.
       *
       * Note: could not use "pointercancel" as it is not
       * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
       */ frameId = requestAnimationFrame(function() {
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    var unbindMonitor = (0, $cWYzQ.monitorForTextSelection)({
        onDragStart: function onDragStart() {
            isDragging = true;
        },
        onDrop: function onDrop() {
            isDragging = false;
            stop();
        }
    });
    return (0, $cMdu5.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $5e92cbe2f6b4d374$var$watchForInteractionStart(_ref2) {
    var start = _ref2.start;
    return (0, $k6Bkl.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener: function listener() {
            // A text selection drag will only start when there is
            // an active text selection.
            var selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
var $5e92cbe2f6b4d374$var$api = (0, $kDH6W.makeFixForAdapter)({
    watchForInteractionStart: $5e92cbe2f6b4d374$var$watchForInteractionStart,
    watchForInteractionEnd: $5e92cbe2f6b4d374$var$watchForInteractionEnd
});
function $5e92cbe2f6b4d374$export$9c0606fcefb5d1e2() {
    return $5e92cbe2f6b4d374$var$api.registerUsage();
}

});
parcelRegister("18H4O", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return (parcelRequire("cWYzQ")).monitorForTextSelection; });

var $cWYzQ = parcelRequire("cWYzQ");
 // Payload for the text selection being dragged

});
parcelRegister("cWYzQ", function(module, exports) {

$parcel$export(module.exports, "monitorForTextSelection", function () { return $96d9e42ba8ba8580$export$2e178e3647f5e6e9; });

var $k6Bkl = parcelRequire("k6Bkl");

var $eRMnz = parcelRequire("eRMnz");

var $c8h3C = parcelRequire("c8h3C");

var $cMdu5 = parcelRequire("cMdu5");

var $fBjMl = parcelRequire("fBjMl");

var $iWdkT = parcelRequire("iWdkT");

var $1os2S = parcelRequire("1os2S");

var $578kN = parcelRequire("578kN");
function $96d9e42ba8ba8580$var$findTextNode(event) {
    var _event$dataTransfer;
    // Standard: the `event.target` should be the closest `Text` node.
    if (event.target instanceof Text) return event.target;
    // Structuring things this way so that if Safari fixes their bug
    // then the standard check will start working
    if (!(0, $fBjMl.isSafari)()) return null;
    /**
   * According to the spec, `event.target` should be the `Text` node that
   * the drag started from when dragging a text selection.
   *
   * → https://html.spec.whatwg.org/multipage/dnd.html#drag-and-drop-processing-model
   *
   * However, in Safari the closest `HTMLElement` is returned.
   * So we need to figure out if text is dragging ourselves.
   *
   * → https://bugs.webkit.org/show_bug.cgi?id=268959
   */ if (!(event.target instanceof HTMLElement)) return null;
    // Unlikely that this particular drag is a text selection drag
    if (event.target.draggable) return null;
    // if the drag contains no text data, then not dragging selected text
    // return `null` if there is no dataTransfer, or if `getData()` returns ""
    if (!((_event$dataTransfer = event.dataTransfer) !== null && _event$dataTransfer !== void 0 && _event$dataTransfer.getData((0, $1os2S.textMediaType)))) return null;
    /**
   * Grab the first Text node and use that.
   * Only doing a single level search as that is all we need for this bug.
   */ var text = Array.from(event.target.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE;
    });
    return text !== null && text !== void 0 ? text : null;
}
var $96d9e42ba8ba8580$var$honeyPotFix = (0, $eRMnz.makeHoneyPotFix)();
var $96d9e42ba8ba8580$var$adapter = (0, $c8h3C.makeAdapter)({
    typeKey: 'text-selection',
    // for text selection, we will usually be making a copy of the text
    defaultDropEffect: 'copy',
    mount: function mount(api) {
        // Binding to the `window` so that the element adapter has a
        // chance to get in first on the `document`.
        // We are giving preference to the element adapter.
        return (0, $cMdu5.combine)($96d9e42ba8ba8580$var$honeyPotFix.bindEvents(), (0, $k6Bkl.bind)(window, {
            type: 'dragstart',
            listener: function listener(event) {
                // If the "dragstart" event is cancelled, then a drag won't start
                // There will be no further drag operation events (eg no "dragend" event)
                if (event.defaultPrevented) return;
                // Something has gone wrong with our drag event
                if (!event.dataTransfer) return;
                // Drag is being handled by the element adapter
                if (event.dataTransfer.types.includes((0, $578kN.elementAdapterNativeDataKey))) return;
                // Something else is handling this drag
                if (!api.canStart(event)) return;
                // no text being dragged
                if (!event.dataTransfer.types.includes((0, $1os2S.textMediaType))) return;
                var target = $96d9e42ba8ba8580$var$findTextNode(event);
                // could not find `Text` node that is being dragged from
                if (!target) return;
                var payload = {
                    // The `Text` node that is the `target` is the `Text` node
                    // that the user started the drag from.
                    // The full text being dragged can be looked up from the `dataTransfer`.
                    target: target,
                    plain: event.dataTransfer.getData((0, $1os2S.textMediaType)),
                    HTML: event.dataTransfer.getData((0, $iWdkT.HTMLMediaType))
                };
                api.start({
                    event: event,
                    dragType: {
                        type: 'text-selection',
                        startedFrom: 'internal',
                        payload: payload
                    }
                });
            }
        }));
    },
    onPostDispatch: $96d9e42ba8ba8580$var$honeyPotFix.getOnPostDispatch()
});
function $96d9e42ba8ba8580$export$9bfaa8eb182300d1(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $96d9e42ba8ba8580$var$adapter.dropTarget(args);
}
// A shared single usage registration as any text can be dragged at any time
(function register() {
    // server side rendering check
    if (typeof window === 'undefined') return;
    $96d9e42ba8ba8580$var$adapter.registerUsage();
})();
function $96d9e42ba8ba8580$export$2e178e3647f5e6e9(args) {
    // note: not removing `onGenerateDragPreview`; just leaning on the type system
    return $96d9e42ba8ba8580$var$adapter.monitor(args);
} /** Common event payload for all events */  /** A map containing payloads for all events */  /** Common event payload for all drop target events */  /** A map containing payloads for all events on drop targets */  /** Argument given to all feedback functions (eg `canDrop()`) on a `dropTargetForExternal` */  /** Argument given to all monitor feedback functions (eg `canMonitor()`) for a `monitorForExternal` */ 

});
parcelRegister("iWdkT", function(module, exports) {

$parcel$export(module.exports, "HTMLMediaType", function () { return $dc97fd0019e6dacf$export$338a9f6c7a1f02b0; });
// Why we put the media types in their own files:
//
// - we are not putting them all in one file as not all adapters need all types
// - we are not putting them in the external helpers as some things just need the
//   types and not the external functions code
var $dc97fd0019e6dacf$export$338a9f6c7a1f02b0 = 'text/html';

});




parcelRegister("axmCM", function(module, exports) {

$parcel$export(module.exports, "dialogWidth", function () { return $7abe8938951dfcbf$export$a3da89b899389ed8; });
$parcel$export(module.exports, "dialogHeight", function () { return $7abe8938951dfcbf$export$ceba93bf0bdd16f2; });
var $7abe8938951dfcbf$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
var $7abe8938951dfcbf$export$a3da89b899389ed8 = function dialogWidth(input) {
    if (!input) return 'auto';
    var isWidthName = $7abe8938951dfcbf$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    var widthName = isWidthName && input;
    if (widthName) return "".concat($7abe8938951dfcbf$export$7e3df82ee760448c.widths[widthName], "px");
    return typeof input === 'number' ? "".concat(input, "px") : input;
};
var $7abe8938951dfcbf$export$ceba93bf0bdd16f2 = function dialogHeight(input) {
    if (!input) return 'auto';
    return typeof input === 'number' ? "".concat(input, "px") : input;
};

});

parcelRegister("g9W3m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc3a84c75ec7b7b4$export$2e2bcd8739ae039; });
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $4xaIc = parcelRequire("4xaIc");

var $9tcFo = parcelRequire("9tcFo");

var $i2LcI = parcelRequire("i2LcI");

function $bc3a84c75ec7b7b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc3a84c75ec7b7b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc3a84c75ec7b7b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc3a84c75ec7b7b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bc3a84c75ec7b7b4$var$gutter = 60;
var $bc3a84c75ec7b7b4$var$maxWidthDimensions = "calc(100vw - ".concat($bc3a84c75ec7b7b4$var$gutter * 2, "px)");
var $bc3a84c75ec7b7b4$var$maxHeightDimensions = "calc(100vh - ".concat($bc3a84c75ec7b7b4$var$gutter * 2 - 1, "px)");
// Flex and min-content are set to constrain the height of the body and support multi-column scrolling experiences
var $bc3a84c75ec7b7b4$var$positionerStyles = null;
var $bc3a84c75ec7b7b4$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1sg41wqb _maxs1wug _1jvh1wqb _1uca1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41wqb _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
/**
 * TODO: when tidying this feature gate, add `!important` to `scrollStyles.body`
 */ var $bc3a84c75ec7b7b4$var$importantBodyFeatureGateStyles = null;
var $bc3a84c75ec7b7b4$var$stackTransitionStyles = null;
var $bc3a84c75ec7b7b4$var$stackTransformStyles = null;
var $bc3a84c75ec7b7b4$var$stackIdleStyles = null;
function $bc3a84c75ec7b7b4$var$getScrollBehavior(_ref) {
    var isFullScreen = _ref.isFullScreen, shouldScrollInViewport = _ref.shouldScrollInViewport;
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
var $bc3a84c75ec7b7b4$var$Positioner = function Positioner(props) {
    var children = props.children, stackIndex = props.stackIndex, shouldScrollInViewport = props.shouldScrollInViewport, testId = props.testId, isFullScreen = props.isFullScreen;
    var scrollBehavior = $bc3a84c75ec7b7b4$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId && "".concat(testId, "--positioner"),
        className: (0, $c4hjl.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            "_k8m01e03 _1bumglyw _sedtglyw",
            stackIndex > 0 ? "_t9ec1b95" : "_t9ecglyw",
            $bc3a84c75ec7b7b4$var$scrollStyles[scrollBehavior],
            scrollBehavior === 'body' && (0, $i2LcI.fg)('platform_dst_modal_dialog_AFBH_1489') && "_5ee41kr1"
        ]),
        style: $bc3a84c75ec7b7b4$var$_objectSpread($bc3a84c75ec7b7b4$var$_objectSpread({}, {
            '--modal-dialog-translate-y': "calc(".concat(stackIndex, "px * ", "var(--ds-space-100, 8px)", ")"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: "".concat((0, $9tcFo.durations).medium, "ms"),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $4xaIc.easeInOut)
        }), {}, {
            "--_imv74m": (0, $bT1Ur.default)("".concat($bc3a84c75ec7b7b4$var$gutter, "px !important"))
        })
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bc3a84c75ec7b7b4$export$2e2bcd8739ae039 = $bc3a84c75ec7b7b4$var$Positioner;

});
parcelRegister("4xaIc", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $34d28dacc3f8375b$export$c07234257a03d5e9; });
var $34d28dacc3f8375b$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $34d28dacc3f8375b$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $34d28dacc3f8375b$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
var $34d28dacc3f8375b$export$fc825baa2ef870d0 = 'cubic-bezier(0.4,0,0,1)';
var $34d28dacc3f8375b$export$816ee5d79b5bd9a5 = 'cubic-bezier(0.6,0,0,1)';
var $34d28dacc3f8375b$export$53ce3390a1a8f2a2 = 'cubic-bezier(0.8,0,0,1)';
var $34d28dacc3f8375b$export$45db2fc2f15997e7 = 'cubic-bezier(0,0,1,1)';

});





parcelRegister("cQfrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9596524ad906d344$export$2e2bcd8739ae039; });
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c4hjl = parcelRequire("c4hjl");

var $8ZuGG = parcelRequire("8ZuGG");

var $kLJZu = parcelRequire("kLJZu");

var $i2LcI = parcelRequire("i2LcI");

var $iWbDH = parcelRequire("iWbDH");

var $80YI9 = parcelRequire("80YI9");

var $U3WW8 = parcelRequire("U3WW8");
var $9596524ad906d344$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug",
    font: "_11c82smr",
    paddingBlock: "_1rjc1bk5",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $9596524ad906d344$var$ModalBody = function ModalBody(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasInlinePaddi = props.hasInlinePadding, hasInlinePadding = _props$hasInlinePaddi === void 0 ? true : _props$hasInlinePaddi;
    var _useModal = (0, $iWbDH.useModal)(), modalTestId = _useModal.testId;
    var shouldScrollInViewport = (0, $U3WW8.default)();
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
    return shouldScrollInViewport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $9596524ad906d344$var$styles.root,
            hasInlinePadding && $9596524ad906d344$var$styles.paddingInline,
            (0, $i2LcI.fg)('platform_ads_explicit_font_styles') && $9596524ad906d344$var$styles.font
        ])
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kLJZu.TouchScrollable), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $80YI9.default), {
        testId: userDefinedTestId || modalTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            $9596524ad906d344$var$styles.root,
            /**
     * Adding block padding for scroll keylines, which are only shown when the scrolling
     * is on the container.
     */ $9596524ad906d344$var$styles.paddingBlock,
            hasInlinePadding && $9596524ad906d344$var$styles.paddingInline,
            (0, $i2LcI.fg)('platform_ads_explicit_font_styles') && $9596524ad906d344$var$styles.font
        ])
    }, children)));
};
var $9596524ad906d344$export$2e2bcd8739ae039 = $9596524ad906d344$var$ModalBody;

});
parcelRegister("iWbDH", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $dc96ac1d76a91634$export$33ffd74ebf07f060; });

var $8ZuGG = parcelRequire("8ZuGG");

var $f371O = parcelRequire("f371O");
var $dc96ac1d76a91634$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $8ZuGG.useContext)((0, $f371O.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("80YI9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d5d6ac938818cdd$export$2e2bcd8739ae039; });
/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $kg5sN = parcelRequire("kg5sN");


var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $gulVP = parcelRequire("gulVP");

var $25i4M = parcelRequire("25i4M");

var $30M5w = parcelRequire("30M5w");

var $5AVd4 = parcelRequire("5AVd4");

var $bRhmz = parcelRequire("bRhmz");

var $dBxAn = parcelRequire("dBxAn");
var $5d5d6ac938818cdd$var$keylineColor = "var(--ds-border, #091E4224)";
var $5d5d6ac938818cdd$var$styles = {
    base: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm2v2xi",
    bottomKeyline: "_179rv2xi"
};
var $5d5d6ac938818cdd$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ var $5d5d6ac938818cdd$var$ScrollContainer = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var testId = _ref.testId, children = _ref.children;
    var scrollableRef = (0, $8ZuGG.useRef)(null);
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), showTopKeyline = _useState2[0], setTopKeyline = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), showBottomKeyline = _useState4[0], setBottomKeyline = _useState4[1];
    var _useState5 = (0, $8ZuGG.useState)(false), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), showContentFocus = _useState6[0], setContentFocus = _useState6[1];
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $8ZuGG.useEffect)(function() {
        var schedule = (0, $gulVP.default)(function() {
            var target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    var setLazyKeylines = (0, $bRhmz.default)((0, $gulVP.default)(function() {
        var target = scrollableRef.current;
        if (target) {
            var scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $5d5d6ac938818cdd$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $5d5d6ac938818cdd$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $8ZuGG.useEffect)(function() {
        var target = scrollableRef.current;
        setLazyKeylines();
        var unbindWindowEvent = (0, $k6Bkl.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        var unbindTargetEvent = target ? (0, $k6Bkl.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $5AVd4.default);
        return function() {
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dBxAn.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && "".concat(testId, "--scrollable"),
        ref: (0, $30M5w.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $25i4M.cx)($5d5d6ac938818cdd$var$styles.base, showTopKeyline && $5d5d6ac938818cdd$var$styles.topKeyline, showBottomKeyline && $5d5d6ac938818cdd$var$styles.bottomKeyline)
    }, children);
});
$5d5d6ac938818cdd$var$ScrollContainer.displayName = 'ScrollContainer';
var $5d5d6ac938818cdd$export$2e2bcd8739ae039 = $5d5d6ac938818cdd$var$ScrollContainer;

});

parcelRegister("U3WW8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a884b623151f2c1$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $f371O = parcelRequire("f371O");
function $0a884b623151f2c1$export$2e2bcd8739ae039() {
    var shouldScrollInViewport = (0, $8ZuGG.useContext)((0, $f371O.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}

});


parcelRegister("iBEMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8bb503efccf3ca5$export$2e2bcd8739ae039; });
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $iWbDH = parcelRequire("iWbDH");
var $d8bb503efccf3ca5$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $d8bb503efccf3ca5$var$ModalFooter = function ModalFooter(props) {
    var children = props.children, userDefinedTestId = props.testId;
    var _useModal = (0, $iWbDH.useModal)(), modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--footer");
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfhmufe _85i51ejb _1q51pxbi"
        ]),
        style: {
            "--_t7lu6v": (0, $bT1Ur.default)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, children);
};
var $d8bb503efccf3ca5$export$2e2bcd8739ae039 = $d8bb503efccf3ca5$var$ModalFooter;

});

parcelRegister("h8BLt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7a07a4cd3bf26ec$export$2e2bcd8739ae039; });
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $8ZuGG = parcelRequire("8ZuGG");

var $ld7ev = parcelRequire("ld7ev");
var $57fzU = parcelRequire("57fzU");

var $fg4V0 = parcelRequire("fg4V0");

var $iWbDH = parcelRequire("iWbDH");
var $c7a07a4cd3bf26ec$var$headerStyles = null;
var $c7a07a4cd3bf26ec$var$flexStyles = (0, $57fzU.xcss)({
    flexDirection: 'row-reverse',
    width: '100%'
});
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $c7a07a4cd3bf26ec$var$ModalHeader = function ModalHeader(props) {
    var children = props.children, userDefinedTestId = props.testId, _props$hasCloseButton = props.hasCloseButton, hasCloseButton = _props$hasCloseButton === void 0 ? false : _props$hasCloseButton;
    var _useModal = (0, $iWbDH.useModal)(), hasProvidedOnClose = _useModal.hasProvidedOnClose, onClose = _useModal.onClose, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--header");
    // Only show if an onClose was provided for the modal dialog
    var shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rthmufe _85i5pxbi _1q511ejb"
        ]),
        style: {
            "--_t7lu6v": (0, $bT1Ur.default)("calc(-1 * ".concat("var(--ds-border-width-outline, 2px)", ")"))
        }
    }, shouldShowCloseButton ? /*#__PURE__*/ // The reason we are putting the close button first in the DOM and then
    // reordering them is to ensure that users of assistive technology get
    // all the context of a modal when initial focus is placed on the close
    // button, since it's the first interactive element.
    (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $ld7ev.default), {
        gap: "space.200",
        justifyContent: "space-between",
        xcss: $c7a07a4cd3bf26ec$var$flexStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $ld7ev.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fg4V0.CloseButton), {
        onClick: onClose,
        testId: modalTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $ld7ev.default), {
        justifyContent: "start",
        alignItems: "center"
    }, children)) : children);
};
var $c7a07a4cd3bf26ec$export$2e2bcd8739ae039 = $c7a07a4cd3bf26ec$var$ModalHeader;

});
parcelRegister("fg4V0", function(module, exports) {

$parcel$export(module.exports, "CloseButton", function () { return $b1bc2a51711d4f66$export$de65de8213222d10; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1fdMd = parcelRequire("1fdMd");

var $2buUU = parcelRequire("2buUU");
var $b1bc2a51711d4f66$export$de65de8213222d10 = function CloseButton(_ref) {
    var label = _ref.label, onClick = _ref.onClick, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1fdMd.default), {
        testId: testId && "".concat(testId, "--close-button"),
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2buUU))),
        label: label || 'Close Modal',
        onClick: onClick
    });
};

});
parcelRegister("2buUU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c17176afeb2169f76dc501092efdf0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974974c58dbead6$var$_react = $1974974c58dbead6$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $1974974c58dbead6$var$_cross = $1974974c58dbead6$var$_interopRequireDefault((parcelRequire("p27r1")));

var $1974974c58dbead6$var$_cross2 = $1974974c58dbead6$var$_interopRequireDefault((parcelRequire("2Frgu")));
function $1974974c58dbead6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1974974c58dbead6$var$CrossIcon = (props)=>/*#__PURE__*/ $1974974c58dbead6$var$_react.default.createElement($1974974c58dbead6$var$_cross.default, Object.assign({
        name: "CrossIcon",
        LEGACY_fallbackIcon: $1974974c58dbead6$var$_cross2.default
    }, props));
$1974974c58dbead6$var$CrossIcon.displayName = 'CrossIconMigration';
var $1974974c58dbead6$var$_default = module.exports.default = $1974974c58dbead6$var$CrossIcon;

});
parcelRegister("p27r1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04b3faafd859ee35$var$_react = $04b3faafd859ee35$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $04b3faafd859ee35$var$_baseNew = $04b3faafd859ee35$var$_interopRequireDefault((parcelRequire("6k1I2")));
function $04b3faafd859ee35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04b3faafd859ee35$var$CrossIcon = (props)=>/*#__PURE__*/ $04b3faafd859ee35$var$_react.default.createElement($04b3faafd859ee35$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$04b3faafd859ee35$var$CrossIcon.displayName = 'CrossIcon';
var $04b3faafd859ee35$var$_default = module.exports.default = $04b3faafd859ee35$var$CrossIcon;

});
parcelRegister("6k1I2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("eWr5u")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("eWr5u")).Icon; });

var $eWr5u = parcelRequire("eWr5u");

});
parcelRegister("eWr5u", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ae0b7e836bb5b6b5$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $ae0b7e836bb5b6b5$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $ae0b7e836bb5b6b5$var$svgStyles = null;
var $ae0b7e836bb5b6b5$var$iconStyles = null;
var $ae0b7e836bb5b6b5$var$utilityIconStyles = null;
var $ae0b7e836bb5b6b5$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $ae0b7e836bb5b6b5$var$baseHcmStyles = null;
var $ae0b7e836bb5b6b5$var$scaleSize = null;
var $ae0b7e836bb5b6b5$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ae0b7e836bb5b6b5$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ae0b7e836bb5b6b5$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $ae0b7e836bb5b6b5$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $ae0b7e836bb5b6b5$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $ae0b7e836bb5b6b5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $ae0b7e836bb5b6b5$var$baseSizeMap[type];
    var viewBoxPadding = $ae0b7e836bb5b6b5$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $ae0b7e836bb5b6b5$var$utilSizes[spacing] : size === 'small' ? $ae0b7e836bb5b6b5$var$coreSizeSmall[spacing] : $ae0b7e836bb5b6b5$var$coreSizeMedium[spacing]
        ])
    }));
});
var $ae0b7e836bb5b6b5$export$2e2bcd8739ae039 = $ae0b7e836bb5b6b5$export$f04a61298a47a40f;

});



parcelRegister("2Frgu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f148f5840e2a6fe$var$_react = $1f148f5840e2a6fe$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $gGadQ = parcelRequire("gGadQ");
function $1f148f5840e2a6fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1f148f5840e2a6fe$var$CrossIcon = (props)=>/*#__PURE__*/ $1f148f5840e2a6fe$var$_react.default.createElement($gGadQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props));
$1f148f5840e2a6fe$var$CrossIcon.displayName = 'CrossIcon';
var $1f148f5840e2a6fe$var$_default = module.exports.default = $1f148f5840e2a6fe$var$CrossIcon;

});
parcelRegister("gGadQ", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $c2487f89768137b4$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $c2487f89768137b4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2487f89768137b4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2487f89768137b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2487f89768137b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $c2487f89768137b4$var$iconStyles = null;
var $c2487f89768137b4$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $c2487f89768137b4$var$baseHcmStyles = null;
var $c2487f89768137b4$var$primaryEqualsSecondaryHcmStyles = null;
var $c2487f89768137b4$var$secondaryTransparentHcmStyles = null;
var $c2487f89768137b4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $c2487f89768137b4$var$_objectSpread($c2487f89768137b4$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $c2487f89768137b4$var$sizeStyles[size]
        ])
    }));
});
var $c2487f89768137b4$export$2e2bcd8739ae039 = $c2487f89768137b4$export$f04a61298a47a40f;

});





parcelRegister("ghBUC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdaba474ab7521c8$export$2e2bcd8739ae039; });
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $9gbkJ = parcelRequire("9gbkJ");

var $er6M8 = parcelRequire("er6M8");

var $iWbDH = parcelRequire("iWbDH");
var $bdaba474ab7521c8$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E56910)"
};
var $bdaba474ab7521c8$var$iconStyles = null;
var $bdaba474ab7521c8$var$titleStyles = null;
var $bdaba474ab7521c8$var$textStyles = null;
var $bdaba474ab7521c8$var$truncatedTextStyles = null;
var $bdaba474ab7521c8$var$TitleIcon = function TitleIcon(_ref) {
    var appearance = _ref.appearance;
    var Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($9gbkJ))) : (0, (/*@__PURE__*/$parcel$interopDefault($er6M8)));
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement(Icon, {
        label: appearance,
        color: $bdaba474ab7521c8$var$iconColor[appearance],
        spacing: "spacious"
    }));
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $bdaba474ab7521c8$var$ModalTitle = function ModalTitle(props) {
    var appearance = props.appearance, children = props.children, _props$isMultiline = props.isMultiline, isMultiline = _props$isMultiline === void 0 ? true : _props$isMultiline, userDefinedTestId = props.testId;
    var _useModal = (0, $iWbDH.useModal)(), titleId = _useModal.titleId, modalTestId = _useModal.testId;
    var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--title");
    return /*#__PURE__*/ $8ZuGG.createElement("h1", {
        "data-testid": testId,
        className: (0, $c4hjl.default)([
            "_zulpu2gc _11c8lodh _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ])
    }, appearance && /*#__PURE__*/ $8ZuGG.createElement($bdaba474ab7521c8$var$TitleIcon, {
        appearance: appearance
    }), /*#__PURE__*/ $8ZuGG.createElement("span", {
        id: titleId,
        "data-testid": testId && "".concat(testId, "-text"),
        className: (0, $c4hjl.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
            !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ])
    }, children));
};
var $bdaba474ab7521c8$export$2e2bcd8739ae039 = $bdaba474ab7521c8$var$ModalTitle;

});
parcelRegister("9gbkJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f636032ea4a949f6a3ed21b2a88730cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6bde664766670d93$var$_react = $6bde664766670d93$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $6bde664766670d93$var$_statusError = $6bde664766670d93$var$_interopRequireDefault((parcelRequire("5OpAa")));

var $6bde664766670d93$var$_error = $6bde664766670d93$var$_interopRequireDefault((parcelRequire("lJJcf")));
function $6bde664766670d93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusErrorIcon.
 * This component is StatusErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6bde664766670d93$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $6bde664766670d93$var$_react.default.createElement($6bde664766670d93$var$_statusError.default, Object.assign({
        name: "StatusErrorIcon",
        LEGACY_fallbackIcon: $6bde664766670d93$var$_error.default
    }, props));
$6bde664766670d93$var$StatusErrorIcon.displayName = 'StatusErrorIconMigration';
var $6bde664766670d93$var$_default = module.exports.default = $6bde664766670d93$var$StatusErrorIcon;

});
parcelRegister("5OpAa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f93f06e22108e36edaead143b4f646b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $43b57763aa4cfdeb$var$_react = $43b57763aa4cfdeb$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $43b57763aa4cfdeb$var$_baseNew = $43b57763aa4cfdeb$var$_interopRequireDefault((parcelRequire("6k1I2")));
function $43b57763aa4cfdeb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusError".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for error statuses and messaging.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $43b57763aa4cfdeb$var$StatusErrorIcon = (props)=>/*#__PURE__*/ $43b57763aa4cfdeb$var$_react.default.createElement($43b57763aa4cfdeb$var$_baseNew.default, Object.assign({
        name: "StatusErrorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.603a2 2 0 0 1 2.828 0l5.983 5.983a2 2 0 0 1 0 2.828l-5.983 5.982a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM8 10.25a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-.75-6.5V9h1.5V3.75z" clip-rule="evenodd"/>`
    }, props));
$43b57763aa4cfdeb$var$StatusErrorIcon.displayName = 'StatusErrorIcon';
var $43b57763aa4cfdeb$var$_default = module.exports.default = $43b57763aa4cfdeb$var$StatusErrorIcon;

});

parcelRegister("lJJcf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd30dc07480f9d7a$var$_react = $fd30dc07480f9d7a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $gGadQ = parcelRequire("gGadQ");
function $fd30dc07480f9d7a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd30dc07480f9d7a$var$ErrorIcon = (props)=>/*#__PURE__*/ $fd30dc07480f9d7a$var$_react.default.createElement($gGadQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$fd30dc07480f9d7a$var$ErrorIcon.displayName = 'ErrorIcon';
var $fd30dc07480f9d7a$var$_default = module.exports.default = $fd30dc07480f9d7a$var$ErrorIcon;

});


parcelRegister("er6M8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::715767a087f47b16ede12b841c1dd7f2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a828d7c0353fecd7$var$_react = $a828d7c0353fecd7$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $a828d7c0353fecd7$var$_statusWarning = $a828d7c0353fecd7$var$_interopRequireDefault((parcelRequire("3E42Q")));

var $a828d7c0353fecd7$var$_warning = $a828d7c0353fecd7$var$_interopRequireDefault((parcelRequire("Z6rat")));
function $a828d7c0353fecd7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StatusWarningIcon.
 * This component is StatusWarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a828d7c0353fecd7$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $a828d7c0353fecd7$var$_react.default.createElement($a828d7c0353fecd7$var$_statusWarning.default, Object.assign({
        name: "StatusWarningIcon",
        LEGACY_fallbackIcon: $a828d7c0353fecd7$var$_warning.default
    }, props));
$a828d7c0353fecd7$var$StatusWarningIcon.displayName = 'StatusWarningIconMigration';
var $a828d7c0353fecd7$var$_default = module.exports.default = $a828d7c0353fecd7$var$StatusWarningIcon;

});
parcelRegister("3E42Q", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2ee7b3f114c675eea0f953c33a485bcf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2a783ebf67b4c7f8$var$_react = $2a783ebf67b4c7f8$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $2a783ebf67b4c7f8$var$_baseNew = $2a783ebf67b4c7f8$var$_interopRequireDefault((parcelRequire("6k1I2")));
function $2a783ebf67b4c7f8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2a783ebf67b4c7f8$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $2a783ebf67b4c7f8$var$_react.default.createElement($2a783ebf67b4c7f8$var$_baseNew.default, Object.assign({
        name: "StatusWarningIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$2a783ebf67b4c7f8$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $2a783ebf67b4c7f8$var$_default = module.exports.default = $2a783ebf67b4c7f8$var$StatusWarningIcon;

});

parcelRegister("Z6rat", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0b7ab0e99f892f7f$var$_react = $0b7ab0e99f892f7f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $gGadQ = parcelRequire("gGadQ");
function $0b7ab0e99f892f7f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0b7ab0e99f892f7f$var$WarningIcon = (props)=>/*#__PURE__*/ $0b7ab0e99f892f7f$var$_react.default.createElement($gGadQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props));
$0b7ab0e99f892f7f$var$WarningIcon.displayName = 'WarningIcon';
var $0b7ab0e99f892f7f$var$_default = module.exports.default = $0b7ab0e99f892f7f$var$WarningIcon;

});



parcelRegister("gUTCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c50d062adef5b4e1$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9cyTu = parcelRequire("9cyTu");
/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ var $c50d062adef5b4e1$var$ModalTransition = function ModalTransition(props) {
    var _props$children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9cyTu.default), {
        appear: true
    }, (_props$children = props.children) !== null && _props$children !== void 0 ? _props$children : null);
};
var $c50d062adef5b4e1$export$2e2bcd8739ae039 = $c50d062adef5b4e1$var$ModalTransition;

});


parcelRegister("4GJDT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "pageId", function () { return $c6f42ef6aed37318$export$703ba2e7ea526c1b; });
$parcel$export(module.exports, "stepUpStartLoader", function () { return $c6f42ef6aed37318$export$3661a07f17c95cba; });
$parcel$export(module.exports, "StepUpStartPage", function () { return $c6f42ef6aed37318$export$e561dacd818ab41; });
$parcel$export(module.exports, "default", function () { return $c6f42ef6aed37318$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $pO9YU = parcelRequire("pO9YU");

var $day6I = parcelRequire("day6I");

var $6apti = parcelRequire("6apti");

var $hX7Rq = parcelRequire("hX7Rq");

var $lk7yL = parcelRequire("lk7yL");

var $9OvaU = parcelRequire("9OvaU");

var $xe7jL = parcelRequire("xe7jL");

var $h2HlW = parcelRequire("h2HlW");

var $bceLx = parcelRequire("bceLx");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
let $c6f42ef6aed37318$var$_ = (t)=>t, $c6f42ef6aed37318$var$t, $c6f42ef6aed37318$var$t1, $c6f42ef6aed37318$var$t2, $c6f42ef6aed37318$var$t3;
const $c6f42ef6aed37318$export$703ba2e7ea526c1b = 'stepUpOtpChallengeScreen';
const $c6f42ef6aed37318$var$OTP_CODE_LENGTH = 8;
const $c6f42ef6aed37318$var$Form = (0, $9Vz68.default).form($c6f42ef6aed37318$var$t || ($c6f42ef6aed37318$var$t = $c6f42ef6aed37318$var$_`
  margin: ${0}px 0 0;
`), (0, $5b7Z4.gridSize)());
const $c6f42ef6aed37318$var$ButtonContainer = (0, $9Vz68.default).div($c6f42ef6aed37318$var$t1 || ($c6f42ef6aed37318$var$t1 = $c6f42ef6aed37318$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $c6f42ef6aed37318$var$RequestPasscodeButtonContainer = (0, $9Vz68.default).div($c6f42ef6aed37318$var$t2 || ($c6f42ef6aed37318$var$t2 = $c6f42ef6aed37318$var$_`
  margin-top: ${0}px;
`), 3 * (0, $5b7Z4.gridSize)());
const $c6f42ef6aed37318$var$SecondaryLinkWrapper = (0, $9Vz68.default).ul($c6f42ef6aed37318$var$t3 || ($c6f42ef6aed37318$var$t3 = $c6f42ef6aed37318$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
/**
 * This restores the state from session storage and saves it to session storage if it changes.
 */ function $c6f42ef6aed37318$var$useSyncWithSessionStorage(sessionStorageKey, sessionStorageValue, onStorageUpdate) {
    (0, $8ZuGG.useEffect)(()=>{
        const storageListener = (event)=>{
            if (event.key === sessionStorageKey) {
                if (event.newValue !== sessionStorageValue) onStorageUpdate(event.newValue);
            }
        };
        window.addEventListener('storage', storageListener);
        const sessionStorageItem = window.sessionStorage.getItem(sessionStorageKey);
        if (sessionStorageItem) onStorageUpdate(sessionStorageItem);
        return ()=>{
            window.removeEventListener('storage', storageListener);
        };
    // This code looks intended to only run on component mount. Missing deps assumed okay at the
    // time the linting rule was added, but may need further investigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $8ZuGG.useEffect)(()=>{
        if (sessionStorageValue) window.sessionStorage.setItem(sessionStorageKey, sessionStorageValue);
    }, [
        sessionStorageValue,
        sessionStorageKey
    ]);
    const clearSessionStorage = (0, $8ZuGG.useCallback)(()=>{
        window.sessionStorage.removeItem(sessionStorageKey);
    }, [
        sessionStorageKey
    ]);
    return [
        clearSessionStorage
    ];
}
async function $c6f42ef6aed37318$export$3661a07f17c95cba({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/step-up/start/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa'
        ]
    });
}
const $c6f42ef6aed37318$export$e561dacd818ab41 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const intl = (0, $iSD9t.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isMobile = (0, $day6I.isMobileOidc)(oidcContext);
    const email = (0, $kOqgB.useAppSelector)((state)=>state.stepUp.email);
    const mfaToken = (0, $kOqgB.useAppSelector)((state)=>state.stepUp.mfaToken);
    const dispatchAddFlag = (0, $8ZuGG.useCallback)((flag)=>dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const [otpCode, setOtpCode] = (0, $8ZuGG.useState)('');
    const [isLoading, setLoading] = (0, $8ZuGG.useState)(false);
    const [verificationError, setVerificationError] = (0, $8ZuGG.useState)();
    const { hash: hash, search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const setHash = (0, $8ZuGG.useCallback)((hash)=>navigate(search + '#' + hash, {
            replace: true
        }), [
        navigate,
        search
    ]);
    const [clearSessionStorageMfaToken] = $c6f42ef6aed37318$var$useSyncWithSessionStorage('mfaToken', mfaToken, (mfaToken)=>{
        dispatch((0, $h2HlW.updateFromSessionStorage)(mfaToken));
    });
    const [manualOtpCodeTriggerMode, setManualOtpCodeTriggerMode] = (0, $8ZuGG.useState)(()=>{
        return document.visibilityState === 'hidden';
    });
    (0, $3ir1n.usePageViewedEvent)($c6f42ef6aed37318$export$703ba2e7ea526c1b, {
        value: manualOtpCodeTriggerMode ? 'manualOtpSend' : 'autoOtpSend'
    });
    (0, $3ir1n.useOperationalEvent)({
        page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
        action: `loadStepUpStartPageSuccessful`,
        subject: 'sli'
    });
    const triggerCodeSend = (0, $8ZuGG.useCallback)(async ()=>{
        const codeSendResult = await dispatch((0, $h2HlW.sendCode)());
        if (codeSendResult.success) {
            analyticsClient.trackingEvent({
                page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
                subject: 'sendCode',
                action: 'succeed'
            });
            setHash('sent');
        } else if (codeSendResult.errorCode === 'too_many_requests') {
            dispatchAddFlag({
                type: 'error',
                title: (0, $6apti.default).stepUpStartFlagErrorRateLimitTitle,
                description: (0, $6apti.default).stepUpStartFlagErrorRateLimitDesc
            });
            analyticsClient.errorShownEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        } else {
            dispatchAddFlag({
                type: 'error',
                title: (0, $6apti.default).stepUpStartFlagErrorTitle,
                description: (0, $6apti.default).stepUpStartFlagErrorDesc
            });
            analyticsClient.errorShownEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'sendCode', {
                errorCode: codeSendResult.errorCode
            });
        }
    }, [
        analyticsClient,
        dispatch,
        dispatchAddFlag,
        setHash
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (hash === '#sent') analyticsClient.trackingEvent({
            page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'already sent'
            }
        });
        else if (manualOtpCodeTriggerMode) analyticsClient.trackingEvent({
            page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
            subject: 'sendCode',
            action: 'skipped',
            attributes: {
                reason: 'opened in background'
            }
        });
        else triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $6apti.default).stepUpStartFlagErrorTitle,
                description: (0, $6apti.default).stepUpStartFlagErrorDesc
            }));
    // We only want to ever trigger this effect once.
    // Otherwise we risk triggering multiple email code sends due to race conditions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleSubmit = (0, $8ZuGG.useCallback)(async (e)=>{
        if (e) e.preventDefault();
        analyticsClient.uiEvent({
            page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
            subject: 'form',
            subjectId: 'otpForm',
            action: 'submitted'
        });
        setLoading(true);
        try {
            const result = await dispatch((0, $h2HlW.verifyOtpCode)(otpCode));
            if ('redirectUri' in result) {
                clearSessionStorageMfaToken();
                analyticsClient.trackingEvent({
                    page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
                    action: 'succeeded',
                    subject: 'stepUpChallenge'
                });
                navigate(result.redirectUri);
            } else {
                analyticsClient.trackingEvent({
                    page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
                    action: 'failed',
                    subject: 'stepUpChallenge',
                    attributes: {
                        errorCode: result.errorCode
                    }
                });
                setVerificationError(result);
            }
        } catch (e) {
            const errorCode = 'unknown';
            analyticsClient.trackingEvent({
                page: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
                action: 'failed',
                subject: 'stepUpChallenge',
                attributes: {
                    errorCode: errorCode
                }
            });
            setVerificationError({
                errorCode: errorCode
            });
        } finally{
            setLoading(false);
        }
    }, [
        analyticsClient,
        dispatch,
        otpCode,
        clearSessionStorageMfaToken,
        navigate
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (otpCode.length === $c6f42ef6aed37318$var$OTP_CODE_LENGTH) handleSubmit();
    }, [
        handleSubmit,
        otpCode
    ]);
    const handleInputChange = (e)=>{
        setVerificationError(undefined);
        setOtpCode(e.target.value);
    };
    const handleResendCode = async ()=>{
        analyticsClient.linkClickedEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'resendOtp');
        const result = await dispatch(mfaToken ? (0, $h2HlW.resendCode)() : (0, $h2HlW.sendCode)());
        if (result.success) dispatchAddFlag({
            type: 'success',
            title: (0, $6apti.default).stepUpStartFlagSuccessTitle,
            description: (0, $6apti.default).stepUpStartFlagSuccessDesc
        });
        else dispatchAddFlag({
            type: 'error',
            title: (0, $6apti.default).stepUpStartFlagErrorTitle,
            description: (0, $6apti.default).stepUpStartFlagErrorDesc
        });
    };
    const handleVerify = ()=>{
        analyticsClient.buttonClickedEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'verifyOtp');
    };
    const handleReturnToLogin = ()=>{
        analyticsClient.linkClickedEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'switchAccount');
    };
    const handleSendOtpCode = async ()=>{
        analyticsClient.buttonClickedEvent($c6f42ef6aed37318$export$703ba2e7ea526c1b, 'sendOtpCode');
        await triggerCodeSend().catch(()=>dispatchAddFlag({
                type: 'error',
                title: (0, $6apti.default).stepUpStartFlagErrorTitle,
                description: (0, $6apti.default).stepUpStartFlagErrorDesc
            }));
        setManualOtpCodeTriggerMode(false);
    };
    const returnLoginLink = `/login/select-account${search}`;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("title", {
                    children: intl.formatMessage((0, $6apti.default).stepUpStartTitle)
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
                pageId: $c6f42ef6aed37318$export$703ba2e7ea526c1b,
                header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, manualOtpCodeTriggerMode ? (0, $6apti.default).stepUpOpenedInBackgroundHeader : (0, $6apti.default).stepUpStartTitle), {
                    tagName: "h5"
                })),
                footer: /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
                    className: "fine-print",
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                                isMobileLink: isMobile
                            })
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                        /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                                isMobileLink: isMobile
                            })
                        })
                    ]
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)("ul", {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                                    id: "resend-code",
                                    spacing: "none",
                                    onClick: handleResendCode,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $6apti.default).stepUpStartResendCode))
                                })
                            })
                        }),
                        !isMobile && /*#__PURE__*/ (0, $6rcps.jsx)($c6f42ef6aed37318$var$SecondaryLinkWrapper, {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
                                    id: "return-to-login",
                                    "data-testid": "return-to-login",
                                    to: returnLoginLink,
                                    onClick: handleReturnToLogin,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $6apti.default).stepUpStartReturnToLogin))
                                })
                            })
                        })
                    ]
                }),
                children: [
                    !manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                                email: email,
                                message: intl.formatMessage((0, $6apti.default).stepUpStartEmailSentHeader)
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsxs)($c6f42ef6aed37318$var$Form, {
                                autoComplete: "off",
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $lk7yL.default), {
                                        id: "otp-code-input",
                                        disabled: isLoading,
                                        fieldErrorFromParent: verificationError,
                                        onChange: handleInputChange,
                                        codeLength: $c6f42ef6aed37318$var$OTP_CODE_LENGTH,
                                        codeType: "numeric"
                                    }),
                                    /*#__PURE__*/ (0, $6rcps.jsx)($c6f42ef6aed37318$var$ButtonContainer, {
                                        id: "verify-submit",
                                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                                            appearance: "primary",
                                            type: "submit",
                                            isFullWidth: true,
                                            isLoading: isLoading,
                                            onClick: handleVerify,
                                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $6apti.default).stepUpStartVerify))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    manualOtpCodeTriggerMode && /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $hX7Rq.default), {
                                email: email,
                                message: intl.formatMessage((0, $6apti.default).stepUpOpenedInBackgroundMessage)
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($c6f42ef6aed37318$var$RequestPasscodeButtonContainer, {
                                id: "send-otp-code",
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    onClick: handleSendOtpCode,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $6apti.default).stepUpStartSendCode))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $c6f42ef6aed37318$export$2e2bcd8739ae039 = $c6f42ef6aed37318$export$e561dacd818ab41;

});
parcelRegister("6apti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef61cbe8bdaf03b4$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $ef61cbe8bdaf03b4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    stepUpStartTitle: {
        id: 'stepUp.start.title',
        defaultMessage: 'Verify your identity'
    },
    stepUpStartFlagSuccessTitle: {
        id: 'stepUp.start.sent.flag.success.title',
        defaultMessage: 'Email resent'
    },
    stepUpStartFlagSuccessDesc: {
        id: 'stepUp.start.sent.flag.success.description',
        defaultMessage: 'You should have a new code waiting for you in your inbox.'
    },
    stepUpStartFlagErrorTitle: {
        id: 'stepUp.start.sent.flag.error.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorDesc: {
        id: 'stepUp.start.sent.flag.error.description',
        defaultMessage: 'Please try again later.'
    },
    stepUpStartFlagErrorRateLimitTitle: {
        id: 'stepUp.start.sent.flag.error.rate.limit.title',
        defaultMessage: 'Something went wrong.'
    },
    stepUpStartFlagErrorRateLimitDesc: {
        id: 'stepUp.start.sent.flag.error.rate.limit.description',
        defaultMessage: 'Wait for a few minutes, then try again.'
    },
    stepUpStartResendCode: {
        id: 'stepUp.start.resend.code',
        defaultMessage: "Didn't get the code? Resend it"
    },
    stepUpStartReturnToLogin: {
        id: 'stepUp.start.return.to.login',
        defaultMessage: 'Need to log in to a different account?'
    },
    stepUpStartEmailSentHeader: {
        id: 'stepUp.start.email.sent.header',
        defaultMessage: 'To access, enter the verification code that we emailed to:'
    },
    stepUpStartVerify: {
        id: 'stepUp.start.verify',
        defaultMessage: 'Verify'
    },
    stepUpStartSendCode: {
        id: 'stepUp.start.sendCode',
        defaultMessage: 'Request passcode'
    },
    stepUpOpenedInBackgroundHeader: {
        id: 'stepUp.start.opened.in.background.header',
        defaultMessage: 'Request one-time passcode'
    },
    stepUpOpenedInBackgroundMessage: {
        id: 'stepUp.start.opened.in.background.message',
        defaultMessage: 'To verify your identity, request a one-time passcode that we send to:'
    }
});

});

parcelRegister("h2HlW", function(module, exports) {

$parcel$export(module.exports, "updateFromSessionStorage", function () { return $b3b64e6e74e3da8a$export$60734d01582497d4; });
$parcel$export(module.exports, "sendCode", function () { return $b3b64e6e74e3da8a$export$74ede56a84543af4; });
$parcel$export(module.exports, "resendCode", function () { return $b3b64e6e74e3da8a$export$90e3d721ed7e24a8; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $b3b64e6e74e3da8a$export$a5c568dd7addf7ae; });

var $jSnDV = parcelRequire("jSnDV");
const $b3b64e6e74e3da8a$export$dc6765fdde20a9c1 = (mfaToken)=>({
        type: 'STEP_UP_SEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $b3b64e6e74e3da8a$export$72ac8a8529ba0de5 = (mfaToken)=>({
        type: 'STEP_UP_RESEND_CODE_SUCCESS',
        mfaToken: mfaToken
    });
const $b3b64e6e74e3da8a$export$60734d01582497d4 = (mfaToken)=>({
        type: 'STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE',
        mfaToken: mfaToken
    });
const $b3b64e6e74e3da8a$export$74ede56a84543af4 = ()=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, stepUp: { token: token } } = getState();
        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
        const response = await fetch('/rest/step-up/start', {
            method: 'POST',
            body: JSON.stringify({
                continue: queryParams.continue,
                application: queryParams.application,
                token: token
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            }
        });
        if (response.ok) {
            const responseBody = await response.json();
            dispatch($b3b64e6e74e3da8a$export$dc6765fdde20a9c1(responseBody.transactionToken));
            return {
                success: true
            };
        } else if (response.status === 429) return {
            success: false,
            errorCode: 'too_many_requests'
        };
        else return {
            success: false,
            errorCode: 'unknown_error'
        };
    };
const $b3b64e6e74e3da8a$export$90e3d721ed7e24a8 = ()=>async (dispatch, getState)=>{
        const { stepUp: { mfaToken: mfaToken }, csrfToken: csrfToken } = getState();
        try {
            const response = await fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                }
            });
            if (response.ok) {
                const responseBody = await response.json();
                dispatch($b3b64e6e74e3da8a$export$72ac8a8529ba0de5(responseBody.transactionToken));
                return {
                    success: true
                };
            } else return {
                success: false,
                errorCode: 'resend_failed'
            };
        } catch (error) {
            return {
                success: false,
                errorCode: 'resend_failed'
            };
        }
    };
const $b3b64e6e74e3da8a$export$a5c568dd7addf7ae = (otpCode)=>async (dispatch, getState)=>{
        const { stepUp: stepUp, csrfToken: csrfToken } = getState();
        const continueUrl = new URLSearchParams(window.location.search).get('continue');
        try {
            const response = await fetch(`/rest/mfa/verify?transactionToken=${stepUp.mfaToken}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    otpCode: otpCode
                })
            });
            if (response.ok) {
                const responseBody = await response.json();
                const loginAuthorizeResp = await fetch(`/rest/mfa/authorize?transactionToken=${responseBody.transactionToken}`);
                if (loginAuthorizeResp.ok) {
                    const loginAuthorizeUrl = new URL((await loginAuthorizeResp.json()).redirectUri);
                    if (continueUrl !== null) loginAuthorizeUrl.searchParams.append('continue', continueUrl);
                    return {
                        redirectUri: loginAuthorizeUrl.toString()
                    };
                } else return {
                    errorCode: 'invalid_otp'
                };
            } else switch(response.status){
                case 400:
                    const body = await response.json();
                    if (body.context.reason === 'invalid_transaction_token') return {
                        errorCode: 'expired_otp'
                    };
                    else return {
                        errorCode: 'invalid_otp'
                    };
                case 403:
                    return {
                        errorCode: 'invalid_otp'
                    };
                case 429:
                    return {
                        errorCode: 'too_many_requests'
                    };
                default:
                    return {
                        errorCode: 'unknown'
                    };
            }
        } catch (error) {
            return {
                errorCode: 'unknown'
            };
        }
    };

});


parcelRegister("c8zx1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "changeEmailLoader", function () { return $2d761249b534f5cb$export$6d7f213d69a144e5; });
$parcel$export(module.exports, "EmailConfirmationPage", function () { return $2d761249b534f5cb$export$98b365c355bab28e; });
$parcel$export(module.exports, "default", function () { return $2d761249b534f5cb$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $eg96f = parcelRequire("eg96f");

var $1nZOG = parcelRequire("1nZOG");

var $aP2Er = parcelRequire("aP2Er");

var $kOqgB = parcelRequire("kOqgB");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $8xW40 = parcelRequire("8xW40");
async function $2d761249b534f5cb$export$6d7f213d69a144e5({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/verify-email/change-email/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--change-email'
        ]
    });
}
const $2d761249b534f5cb$export$98b365c355bab28e = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const error = (0, $kOqgB.useAppSelector)((state)=>state.changeEmail.error);
    const isFeatureGateEnabled = (0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL);
    if (error === 'invalid_token') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $eg96f.default), {});
    if (isFeatureGateEnabled) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $1nZOG.default), {});
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aP2Er.default), {});
};
var $2d761249b534f5cb$export$2e2bcd8739ae039 = $2d761249b534f5cb$export$98b365c355bab28e;

});
parcelRegister("eg96f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aa3998bd09aa76d$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $7tB0e = parcelRequire("7tB0e");

var $05e3b = parcelRequire("05e3b");

var $3ir1n = parcelRequire("3ir1n");

var $9DcmP = parcelRequire("9DcmP");

var $gyRZh = parcelRequire("gyRZh");
const $4aa3998bd09aa76d$export$703ba2e7ea526c1b = 'emailConfirmationInvalidTokenErrorPage';
const $4aa3998bd09aa76d$export$de2e70c0e2bb29f5 = ()=>{
    (0, $3ir1n.usePageViewedEvent)($4aa3998bd09aa76d$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7tB0e.default), {
        title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $9DcmP.default).invalidTokenTitle)),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("p", {
                "data-testid": "email-confirmation-error-container-idf-testid",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $9DcmP.default).invalidTokenDescription))
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("p", {
                className: "error-action",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
                    to: "/login",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $05e3b.default), {
                        appearance: "primary",
                        testId: "email-confirmation-error-page-button-idf-testid",
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $9DcmP.default).invalidTokenReturnToLoginButton))
                    })
                })
            })
        ]
    });
};
var $4aa3998bd09aa76d$export$2e2bcd8739ae039 = $4aa3998bd09aa76d$export$de2e70c0e2bb29f5;

});
parcelRegister("9DcmP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ca18ef6a813a12d$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $7ca18ef6a813a12d$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});


parcelRegister("1nZOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f46c0718b074cd75$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $gyRZh = parcelRequire("gyRZh");

var $5VQjR = parcelRequire("5VQjR");

var $jSnDV = parcelRequire("jSnDV");

var $31oBR = parcelRequire("31oBR");

var $7CMue = parcelRequire("7CMue");

var $3su9k = parcelRequire("3su9k");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $1ysah = parcelRequire("1ysah");
parcelRequire("f2IKy");
var $gsGhI = parcelRequire("gsGhI");
const $f46c0718b074cd75$var$pageId = 'EmailConfirmationPage';
const $f46c0718b074cd75$export$b1860081753d8e7a = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error, isLoading: isLoading, redirectTo: redirectTo } = (0, $kOqgB.useAppSelector)((state)=>state.changeEmail);
    const handleEmailChangeConfirmationSubmitClick = (0, $3ir1n.useButtonClickedEvent)($f46c0718b074cd75$var$pageId, 'EmailConfirmationSubmit');
    (0, $3ir1n.usePageViewedEvent)($f46c0718b074cd75$var$pageId);
    // These values are provided by SIS in the email that's sent to verify the user's email address.
    // We need to pass them in the URL of the API call.
    const { token: token, userId: userId, source: source = '' } = $jSnDV.parse(window.location.search);
    const handleSubmit = (0, $8ZuGG.useCallback)((newEmail, password)=>{
        // If the user gets here without the token - something went really wrong
        // This should have been caught by the initial page load
        if (!token) {
            dispatch((0, $3su9k.changeEmailRequestFailedAction)('invalid_token'));
            return;
        }
        if (!userId) {
            dispatch((0, $3su9k.changeEmailRequestFailedAction)('unknown_error'));
            return;
        }
        dispatch((0, $3su9k.changeEmailConfirmation)(newEmail, password, token, userId, source));
    }, [
        dispatch,
        source,
        token,
        userId
    ]);
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    // `redirectTo` is set in the success case of the email change flow.
    (0, $gsGhI.useForceRedirect)({
        redirectTo: redirectTo
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $f46c0718b074cd75$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $1ysah.default).title))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $31oBR.default), {
            email: newEmail,
            isLoading: isLoading,
            error: error,
            onSubmitButtonClick: handleEmailChangeConfirmationSubmitClick,
            onSubmit: handleSubmit
        })
    });
};
var $f46c0718b074cd75$export$2e2bcd8739ae039 = $f46c0718b074cd75$export$b1860081753d8e7a;

});
parcelRegister("31oBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95e9685683fd0ac6$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $dZRKj = parcelRequire("dZRKj");

var $lp6gZ = parcelRequire("lp6gZ");

var $8PH8E = parcelRequire("8PH8E");

var $4JKmU = parcelRequire("4JKmU");

var $hAzIv = parcelRequire("hAzIv");

var $hlQLf = parcelRequire("hlQLf");

var $g5rao = parcelRequire("g5rao");

var $05e3b = parcelRequire("05e3b");

var $1ysah = parcelRequire("1ysah");
let $95e9685683fd0ac6$var$_ = (t)=>t, $95e9685683fd0ac6$var$t;
const $95e9685683fd0ac6$var$StyledForm = (0, $9Vz68.default).form($95e9685683fd0ac6$var$t || ($95e9685683fd0ac6$var$t = $95e9685683fd0ac6$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${0}px;
`), (0, $g5rao.default)('space.100'));
const $95e9685683fd0ac6$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'invalid_password':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.change-email.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'invalid_token':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.change-email.invalid_token",
                defaultMessage: "Something went wrong. Please try again later."
            });
        case 'unknown_error':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.change-email.unknown_error",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.change-email.unknown",
                defaultMessage: "Something went wrong while attempting to change your email. Please try again."
            });
    }
};
const $95e9685683fd0ac6$var$ChangeEmailForm = ({ email: email, isLoading: isLoading, error: error, onSubmit: onSubmit, onSubmitButtonClick: onSubmitButtonClick })=>{
    const intl = (0, $iSD9t.default)();
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const [passwordFieldError, setPasswordFieldError] = (0, $8ZuGG.useState)(null);
    const emailInputRef = (0, $8ZuGG.useRef)(null);
    const passwordInputRef = (0, $8ZuGG.useRef)(null);
    const handleSubmit = (e)=>{
        // Reset the error state to let the validation happen again.
        setPasswordFieldError(null);
        // Prevent submission/default behaviour. We return early in the cases of validation errors, but otherwise call the submit function
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') {
            setPasswordFieldError(intl.formatMessage((0, $hAzIv.default).passwordEmpty));
            return;
        }
        if (error === 'invalid_password') {
            setPasswordFieldError(intl.formatMessage((0, $1ysah.default).incorrectPassword));
            return;
        }
        onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        "data-testid": "email-verification-page-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)($95e9685683fd0ac6$var$ErrorContent, {
                    error: error
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($95e9685683fd0ac6$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "form-change-email",
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: intl.formatMessage((0, $hAzIv.default).emailEmpty),
                            label: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $1ysah.default).emailLabel)),
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $4JKmU.default), {
                            name: "password",
                            autoComplete: "current-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: intl.formatMessage((0, $hAzIv.default).passwordEmpty),
                            label: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $hlQLf.default).passwordLabel)),
                            autoFocus: true,
                            isInvalid: !!passwordFieldError,
                            invalidMessage: passwordFieldError,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $05e3b.default), {
                        appearance: "primary",
                        type: "submit",
                        testId: "change-email-submit-button-idf-testid",
                        onClick: onSubmitButtonClick,
                        isLoading: isLoading,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "common.confirm",
                            defaultMessage: "Confirm"
                        })
                    })
                ]
            })
        ]
    });
};
var $95e9685683fd0ac6$export$2e2bcd8739ae039 = $95e9685683fd0ac6$var$ChangeEmailForm;

});
parcelRegister("hAzIv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d72d10d30826a01$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $1d72d10d30826a01$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    unexpectedErrorHappened: {
        id: 'login.form.sso.check.unknown.error',
        defaultMessage: 'Unexpected error happened.',
        description: ''
    },
    emailPlaceholder: {
        id: 'login.form.email.placeholder',
        defaultMessage: 'Enter your email'
    },
    emailEmpty: {
        id: 'login.form.email.empty',
        defaultMessage: 'Enter an email address'
    },
    emailInvalid: {
        id: 'login.form.email.invalid',
        defaultMessage: "Email address must contain text before and after an '@' symbol"
    },
    passwordEmpty: {
        id: 'login.form.password.empty',
        defaultMessage: 'Enter your password'
    },
    migrateAccountInfo: {
        id: 'login.form.info.migrate.account',
        defaultMessage: "It looks like you already have an Atlassian account with other products such as Jira or Confluence. Log in to finish migrating your {application} account.",
        description: 'Login form info container message'
    },
    existingUserSignupAttemptInfo: {
        id: 'login.form.info.existing.user.signup.attempt',
        defaultMessage: "It looks like you've already got an account associated with this email. Log in instead or reset your password if you've forgotten it",
        description: 'Login form info container message for existing user signup attempt'
    },
    rateLimitErrorMessage: {
        id: 'login.form.email.rate-limit-exceeded.error',
        defaultMessage: 'There have been too many attempts to reverify your account in the past hour. Please try again later.',
        description: 'Telling the user that they have exceeded welcome email limit'
    },
    rememberMeCheckboxLabel: {
        id: 'login.form.remember.me.checkbox.label',
        defaultMessage: 'Remember me',
        description: "Label for the checkbox that will enable the behaviour to remember a user's account on this device"
    },
    rememberMeMoreInfoLabel: {
        id: 'login.form.remember.me.moreinfo.label',
        defaultMessage: 'More info about Remember Me.',
        description: 'Label for info icon that describes what Remember Me is'
    },
    rememberMeTooltip: {
        id: 'login.form.remember.me.tooltip',
        defaultMessage: 'We remember your account information for the next time you log in.',
        description: 'Tooltip content for the remember me checkbox'
    }
});

});

parcelRegister("hlQLf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33a50aa84d9159e$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $c33a50aa84d9159e$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    passwordPlaceholder: {
        id: 'login.form.password.placeholder',
        defaultMessage: 'Enter password'
    },
    passwordLabel: {
        id: 'login.form.password.label',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("1ysah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02bfa0de31238251$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $02bfa0de31238251$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    unknownError: {
        id: 'email-confirmation.form.unknown_error',
        defaultMessage: 'An unknown error occurred, please try again later.'
    }
});

});


parcelRegister("3su9k", function(module, exports) {

$parcel$export(module.exports, "changeEmailRequestFailedAction", function () { return $558caf401cc5f69b$export$85474e738669d18a; });
$parcel$export(module.exports, "changeEmailConfirmation", function () { return $558caf401cc5f69b$export$c78d0a07bbf517cd; });

var $gjw2g = parcelRequire("gjw2g");

var $8FHU2 = parcelRequire("8FHU2");

var $gV6nD = parcelRequire("gV6nD");
const $558caf401cc5f69b$export$593c8d2584e1aebe = ()=>({
        type: 'CHANGE_EMAIL_RESET_STATE'
    });
const $558caf401cc5f69b$export$377eca5680d6a582 = ()=>({
        type: 'CHANGE_EMAIL_REQUEST'
    });
const $558caf401cc5f69b$export$85474e738669d18a = (error)=>({
        type: 'CHANGE_EMAIL_REQUEST_FAILED',
        error: error
    });
const $558caf401cc5f69b$export$17c00f40906a7c06 = (redirectTo)=>({
        type: 'CHANGE_EMAIL_REQUEST_SUCCEEDED',
        redirectTo: redirectTo
    });
const $558caf401cc5f69b$export$98860bcb84091494 = (backendState)=>({
        type: 'CHANGE_EMAIL_STATE_UPDATE',
        backendState: backendState
    });
const $558caf401cc5f69b$var$CHANGE_EMAIL_REST_ENDPOINT = '/rest/verify-email/change-email';
const $558caf401cc5f69b$export$c78d0a07bbf517cd = (email, password, token, userId, source)=>async (dispatch, getState)=>{
        // Fork to use either the old submitFormHack or new submitFormHackReplacement function, well as the old or new endpoint
        // old endpoint: /verify-email/change-email (submitFormHack - form submission with input div manipulation)
        // new endpoint: /rest/verify-email/change-email (submitFormHackReplacement - REST POST request with JSON payload)
        if (!(0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).ENABLE_JSON_ENDPOINT_FOR_VERIFY_EMAIL)) {
            (0, $8FHU2.default)({
                method: 'POST',
                payload: {
                    email: email,
                    password: password
                },
                skipSanitizationKeys: [
                    'password'
                ]
            });
            return;
        }
        try {
            var _response_changeEmail, _response_changeEmail1;
            const csrfToken = getState().csrfToken;
            const res = await (0, $8FHU2.submitFormHackReplacement)({
                method: 'POST',
                // These three parameters are included in the link from the verification email, therefore including to match existing functionality.
                action: `${$558caf401cc5f69b$var$CHANGE_EMAIL_REST_ENDPOINT}?token=${token}&userId=${userId}&source=${source}`,
                payload: {
                    email: email,
                    password: password
                },
                csrfToken: csrfToken
            });
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($558caf401cc5f69b$export$85474e738669d18a('unknown_error'));
                return;
            }
            const response = await res.json();
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (response.changeEmail) {
                // Want to make sure the response is a valid object.
                const isChangeEmailObject = typeof response.changeEmail === 'object' && !Array.isArray(response.changeEmail);
                dispatch($558caf401cc5f69b$export$98860bcb84091494(isChangeEmailObject ? response.changeEmail : {}));
            }
            if (response === null || response === void 0 ? void 0 : (_response_changeEmail = response.changeEmail) === null || _response_changeEmail === void 0 ? void 0 : _response_changeEmail.error) {
                const error = response.changeEmail.error;
                const validErrorTypes = [
                    'invalid_token',
                    'invalid_password',
                    'unknown_error'
                ];
                if (!validErrorTypes.includes(error)) {
                    dispatch($558caf401cc5f69b$export$85474e738669d18a('unknown_error'));
                    return;
                }
                dispatch($558caf401cc5f69b$export$85474e738669d18a(error));
                return;
            }
            // The types on the FE define the response to always be under `changeEmail` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = (response === null || response === void 0 ? void 0 : (_response_changeEmail1 = response.changeEmail) === null || _response_changeEmail1 === void 0 ? void 0 : _response_changeEmail1.redirectTo) || (response === null || response === void 0 ? void 0 : response.redirectTo);
            if (!redirectTo) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($558caf401cc5f69b$export$85474e738669d18a('unknown_error'));
                return;
            }
            dispatch($558caf401cc5f69b$export$17c00f40906a7c06(redirectTo));
            return;
        } catch (error) {
            dispatch($558caf401cc5f69b$export$85474e738669d18a('unknown_error'));
        }
    };

});


parcelRegister("aP2Er", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b63a12eacaa36b5$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $gyRZh = parcelRequire("gyRZh");

var $5VQjR = parcelRequire("5VQjR");

var $jSnDV = parcelRequire("jSnDV");

var $5r3NL = parcelRequire("5r3NL");

var $7CMue = parcelRequire("7CMue");

var $3su9k = parcelRequire("3su9k");

var $3ir1n = parcelRequire("3ir1n");

var $la9hV = parcelRequire("la9hV");

var $kOqgB = parcelRequire("kOqgB");
const $2b63a12eacaa36b5$var$pageId = 'EmailConfirmationPage';
const $2b63a12eacaa36b5$export$b1860081753d8e7a = ()=>{
    const intl = (0, $iSD9t.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { email: email, newEmail: newEmail, error: error } = (0, $kOqgB.useAppSelector)((state)=>state.changeEmail);
    const [fieldErrors, setFieldErrors] = (0, $8ZuGG.useState)(error === 'invalid_password' ? {
        password: intl.formatMessage((0, $la9hV.default).incorrectPassword)
    } : {});
    const [isLoading, setIsLoading] = (0, $8ZuGG.useState)(false);
    const handleLoginClick = (0, $3ir1n.useButtonClickedEvent)($2b63a12eacaa36b5$var$pageId, 'EmailConfirmationSubmit');
    (0, $3ir1n.usePageViewedEvent)($2b63a12eacaa36b5$var$pageId);
    // In the URL from the verification email, but used by SIS to validate that they have access to the email address.
    // These three are included in the URL
    const { token: token = '', userId: userId = '', source: source = '' } = $jSnDV.parse(window.location.search);
    const handleChangePassword = (newEmail, password)=>{
        setIsLoading(true);
        dispatch((0, $3su9k.changeEmailConfirmation)(newEmail, password, token, userId, source));
    };
    const resetPasswordLink = '/login/resetpassword?' + new URLSearchParams([
        [
            'redirectedFrom',
            'change-email'
        ],
        [
            'email',
            email
        ],
        [
            'continue',
            window.location.href
        ]
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $2b63a12eacaa36b5$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: 'h1',
            size: 'small',
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $la9hV.default).title))
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
            to: resetPasswordLink,
            id: "resetPassword",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "having.trouble.logging.in",
                defaultMessage: "Having trouble logging in?"
            })
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5r3NL.default), {
            email: newEmail,
            emailFieldLabel: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $la9hV.default).emailLabel)),
            isLoading: isLoading,
            fieldErrors: fieldErrors,
            onValidationError: setFieldErrors,
            submitButtonText: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "common.confirm",
                defaultMessage: "Confirm"
            }),
            onSubmitClick: handleLoginClick,
            onSubmit: handleChangePassword
        })
    });
};
var $2b63a12eacaa36b5$export$2e2bcd8739ae039 = $2b63a12eacaa36b5$export$b1860081753d8e7a;

});
parcelRegister("5r3NL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ae21156091bf401$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $dZRKj = parcelRequire("dZRKj");

var $lp6gZ = parcelRequire("lp6gZ");

var $8PH8E = parcelRequire("8PH8E");

var $4JKmU = parcelRequire("4JKmU");

var $1SvOA = parcelRequire("1SvOA");

var $hAzIv = parcelRequire("hAzIv");

var $hlQLf = parcelRequire("hlQLf");

var $97pBx = parcelRequire("97pBx");
let $3ae21156091bf401$var$_ = (t)=>t, $3ae21156091bf401$var$t, $3ae21156091bf401$var$t1;
const $3ae21156091bf401$var$Form = (0, $9Vz68.default).form($3ae21156091bf401$var$t || ($3ae21156091bf401$var$t = $3ae21156091bf401$var$_`
  margin: 0;
`));
const $3ae21156091bf401$var$ButtonContainer = (0, $9Vz68.default).div($3ae21156091bf401$var$t1 || ($3ae21156091bf401$var$t1 = $3ae21156091bf401$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $3ae21156091bf401$var$ErrorContent = ({ error: error })=>{
    switch(error){
        case 'tsvForm.password.valid':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.password.incorrect",
                defaultMessage: "The password you entered is incorrect. Please try again."
            });
        case 'tsvForm.password.error':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.unexpected",
                defaultMessage: "Something went wrong while trying to contact the server. Please refresh the page and try again."
            });
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "recovery.error.unknown",
                defaultMessage: "Something went wrong while attempting to login. Please try again."
            });
    }
};
const $3ae21156091bf401$var$AccountVerificationForm = (props)=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const passwordFieldError = (0, $97pBx.useTranslateFormErrorIfAvailable)(props.fieldErrors.password);
    const email = props.email || '';
    const previousPasswordFieldError = (0, $8ZuGG.useRef)(undefined);
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const emailInputRef = (0, $8ZuGG.useRef)(null);
    const passwordInputRef = (0, $8ZuGG.useRef)(null);
    const handleSubmit = (e)=>{
        const { isLoading: isLoading, onValidationError: onValidationError } = props;
        const validationErrors = {};
        e.preventDefault();
        if (isLoading) return;
        if (password.trim() === '') validationErrors.password = formatMessage((0, $hAzIv.default).passwordEmpty);
        if (Object.keys(validationErrors).length) {
            onValidationError(validationErrors);
            return;
        }
        props.onSubmit && props.onSubmit(email, password);
    };
    const handlePasswordChange = (e)=>{
        props.onValidationError({}); // clear validation errors
        setPassword(e.currentTarget.value);
    };
    (0, $8ZuGG.useEffect)(()=>{
        var _passwordInputRef_current;
        const passwordError = passwordFieldError && passwordFieldError !== previousPasswordFieldError.current;
        if (passwordError) (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
        previousPasswordFieldError.current = passwordFieldError;
    }, [
        props.fieldErrors.password,
        passwordFieldError
    ]);
    const { error: error, title: title, emailFieldLabel: emailFieldLabel } = props;
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        "data-testid": "email-verification-page-old-idf-testid",
        children: [
            error && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)($3ae21156091bf401$var$ErrorContent, {
                    error: error
                })
            }),
            title && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($3ae21156091bf401$var$Form, {
                onSubmit: handleSubmit,
                id: "form-accountverification-up",
                onClick: props.onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
                            id: "email",
                            name: "email",
                            type: "email",
                            autoComplete: "off",
                            placeholder: formatMessage((0, $hAzIv.default).emailEmpty),
                            label: emailFieldLabel,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: true,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $4JKmU.default), {
                            name: "password",
                            autoComplete: "new-password",
                            id: "password",
                            testId: "password" // used in pollinators
                            ,
                            placeholder: formatMessage((0, $hAzIv.default).passwordEmpty),
                            label: formatMessage((0, $hlQLf.default).passwordLabel),
                            autoFocus: true,
                            isInvalid: !!props.fieldErrors.password,
                            invalidMessage: props.fieldErrors.password,
                            onChange: handlePasswordChange,
                            value: password,
                            ref: passwordInputRef,
                            isRequired: true
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)($3ae21156091bf401$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            appearance: "primary",
                            type: "submit",
                            isFullWidth: true,
                            id: "tsvrecovery-submit" // used in pollinators
                            ,
                            onClick: ()=>props.onSubmitClick && props.onSubmitClick(),
                            isLoading: props.isLoading,
                            children: props.submitButtonText
                        })
                    })
                ]
            })
        ]
    });
};
var $3ae21156091bf401$export$2e2bcd8739ae039 = $3ae21156091bf401$var$AccountVerificationForm;

});

parcelRegister("la9hV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae2ee55ecb172a49$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $ae2ee55ecb172a49$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    title: {
        id: 'email-confirmation.title',
        defaultMessage: 'Enter your password to confirm your updated email'
    },
    emailLabel: {
        id: 'account.verification.form.emailField.label',
        defaultMessage: 'Updated email',
        description: 'The label shown above a disabled email field when the user is confirming that they have updated their email.'
    },
    incorrectPassword: {
        id: 'email-confirmation.form.incorrect-password',
        defaultMessage: 'Your password was incorrect'
    },
    invalidTokenTitle: {
        id: 'email-confirmation.invalid-token.title',
        defaultMessage: 'Unable to verify your email address'
    },
    invalidTokenDescription: {
        id: 'email-confirmation.invalid-token.description',
        defaultMessage: 'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.'
    },
    invalidTokenReturnToLoginButton: {
        id: 'email-confirmation.invalid-token.return-login-button',
        defaultMessage: 'Return to log in'
    }
});

});



parcelRegister("50Ge8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "removeAccountLoader", function () { return $83386f4da6fedfcc$export$d62f2a9a504f29d1; });
$parcel$export(module.exports, "RemoveAccountPage", function () { return $83386f4da6fedfcc$export$66bcaaca6b1eddac; });
$parcel$export(module.exports, "default", function () { return $83386f4da6fedfcc$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $iRVQ8 = parcelRequire("iRVQ8");

var $9Vz68 = parcelRequire("9Vz68");

var $8dHAc = parcelRequire("8dHAc");

var $a8rGb = parcelRequire("a8rGb");

var $8bNLi = parcelRequire("8bNLi");

var $3ir1n = parcelRequire("3ir1n");

var $2JKod = parcelRequire("2JKod");

var $5sqTs = parcelRequire("5sqTs");
var $cQfrC = parcelRequire("cQfrC");
var $iBEMg = parcelRequire("iBEMg");
var $h8BLt = parcelRequire("h8BLt");
var $ghBUC = parcelRequire("ghBUC");

var $aSbA9 = parcelRequire("aSbA9");

var $cmPew = parcelRequire("cmPew");

var $T3hrv = parcelRequire("T3hrv");

var $1dt6e = parcelRequire("1dt6e");

var $9OvaU = parcelRequire("9OvaU");

var $7CMue = parcelRequire("7CMue");

var $day6I = parcelRequire("day6I");

var $hTZm6 = parcelRequire("hTZm6");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $83386f4da6fedfcc$var$_ = (t)=>t, $83386f4da6fedfcc$var$t;
const $83386f4da6fedfcc$var$pageId = 'forgetAccountFromBrowserScreen';
async function $83386f4da6fedfcc$export$d62f2a9a504f29d1({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/remove-account/state', request, {
        capabilities: [
            'capability-group--manage-profile',
            'capability-name--remove-account'
        ]
    });
}
const $83386f4da6fedfcc$export$66bcaaca6b1eddac = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const loginHint = (0, $hTZm6.useLoginHint)();
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigateToLoginPrompt = (0, $8bNLi.useNavigateToLoginPrompt)();
    const [modalDialog, setModalDialog] = (0, $8ZuGG.useState)(null);
    const sessions = (0, $kOqgB.useAppSelector)((state)=>(0, $cmPew.sessionsSelector)(state, search, loginHint));
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isLoading = (0, $kOqgB.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const eventAttributes = (0, $8ZuGG.useMemo)(()=>({
            accountCount: sessions.length
        }), [
        sessions.length
    ]);
    (0, $3ir1n.usePageViewedEvent)($83386f4da6fedfcc$var$pageId, eventAttributes);
    const renderFooter = ()=>{
        if ((0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).ManageSessions)) return null;
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
            id: "navigate-to-select-account",
            onClick: ()=>{
                analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'dismissAccountSwitcher', eventAttributes);
                navigate({
                    pathname: '/login/select-account',
                    search: search
                });
            },
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "remove.account.footer.navigate.to.select.account",
                defaultMessage: "Done"
            })
        });
    };
    const handleSessionClick = (0, $8ZuGG.useCallback)((session, eventAttributes)=>{
        return ()=>{
            const handleDissociate = ()=>{
                analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'confirmForgetAccount', eventAttributes);
                dispatch((0, $a8rGb.manageSession)({
                    sessionId: session.sessionId,
                    command: 'dissociate'
                }, navigate, {
                    continue: window.location.href
                }));
            };
            const handleCloseModalDialog = ()=>{
                analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'cancelForgetAccount', eventAttributes);
                setModalDialog(null);
            };
            const modalDialogElement = /*#__PURE__*/ (0, $6rcps.jsxs)((0, $5sqTs.default), {
                width: "small",
                onClose: handleCloseModalDialog,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $h8BLt.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $ghBUC.default), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "remove.account.dialog.header",
                                defaultMessage: "Remove account"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $cQfrC.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "remove.account.dialog.body",
                            defaultMessage: "You can always add the account for <strong>{email}</strong> back to this browser when you're ready to use it again.",
                            values: {
                                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                        children: chunks
                                    }),
                                email: session.email
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsxs)((0, $iBEMg.default), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                                appearance: "subtle",
                                onClick: handleCloseModalDialog,
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $2JKod.default).removeAccountDialogClose))
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                                appearance: "primary",
                                onClick: handleDissociate,
                                autoFocus: true,
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $2JKod.default).removeAccountDialogConfirm))
                            })
                        ]
                    })
                ]
            });
            analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'forgetAccountFromBrowser', eventAttributes);
            setModalDialog(modalDialogElement);
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const handleLogoutClick = (0, $8ZuGG.useCallback)(()=>{
        const handleCloseModalDialog = ()=>{
            analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'cancelForgetAllAccounts', eventAttributes);
            setModalDialog(null);
        };
        const modalDialogElement = /*#__PURE__*/ (0, $6rcps.jsxs)((0, $5sqTs.default), {
            width: "small",
            onClose: handleCloseModalDialog,
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $h8BLt.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $ghBUC.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "remove.account.logout.dialog.header",
                            defaultMessage: "Remove all accounts"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $cQfrC.default), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "remove.account.logout.dialog.body",
                        defaultMessage: "You can always add the accounts back to this browser when you're ready to use any of them again."
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsxs)((0, $iBEMg.default), {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                            appearance: "subtle",
                            onClick: handleCloseModalDialog,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $2JKod.default).removeAccountDialogClose))
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $iRVQ8.default), {
                            appearance: "primary",
                            onClick: async ()=>{
                                await analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'confirmForgetAllAccounts', eventAttributes);
                                const continueUrl = (0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).ManageSessions) ? window.location.href : undefined;
                                await dispatch((0, $a8rGb.doLogout)(continueUrl));
                            },
                            autoFocus: true,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $2JKod.default).removeAccountDialogConfirm))
                        })
                    ]
                })
            ]
        });
        analyticsClient.buttonClickedEvent($83386f4da6fedfcc$var$pageId, 'forgetAllAccounts', eventAttributes);
        setModalDialog(modalDialogElement);
    }, [
        analyticsClient,
        dispatch,
        eventAttributes,
        oidcContext
    ]);
    const renderAccounts = ()=>{
        const accounts = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email } = session;
            const handleOnClick = handleSessionClick(session, (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                accountIndex: index
            }));
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                id: `account-${accountId}`,
                onClick: handleOnClick,
                avatarUrl: session.avatarUrl,
                displayName: displayName,
                email: email,
                icon: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dt6e))), {
                    label: formatMessage((0, $2JKod.default).removeAccountIconLabel),
                    size: "small"
                })
            }, `account-${accountId}`);
        });
        accounts.push(/*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AccountContainer), {
            id: "redirect-to-logout",
            onClick: handleLogoutClick,
            children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $aSbA9.RowButtonContainer), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AvatarContainer), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dt6e))), {
                            label: formatMessage((0, $2JKod.default).removeAccountIconLabel)
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.TextContainer), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.Paragraph), {
                            id: "remove-all",
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "remove.account.all",
                                defaultMessage: "Remove all accounts"
                            })
                        })
                    })
                ]
            })
        }, "redirect-to-logout"));
        return accounts;
    };
    if (sessions.length > 0) return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $83386f4da6fedfcc$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "remove.account.title",
                defaultMessage: "Remove accounts from this browser"
            })
        }),
        footer: true,
        whiteboxFooter: renderFooter(),
        isLoading: isLoading,
        children: [
            modalDialog,
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $T3hrv.default), {
                children: renderAccounts()
            })
        ]
    });
    else if ((0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).ManageSessions)) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $83386f4da6fedfcc$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "manage.sessions.no.sessions.header",
                defaultMessage: "You're logged out of all accounts on this browser"
            })
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)($83386f4da6fedfcc$var$CenterText, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                tagName: "p",
                id: "manage.sessions.no.sessions.body",
                defaultMessage: "Close this page to return to the app."
            })
        })
    });
    else {
        navigateToLoginPrompt();
        return null;
    }
};
const $83386f4da6fedfcc$var$CenterText = (0, $9Vz68.default).div($83386f4da6fedfcc$var$t || ($83386f4da6fedfcc$var$t = $83386f4da6fedfcc$var$_`
  text-align: center;
`));
var $83386f4da6fedfcc$export$2e2bcd8739ae039 = $83386f4da6fedfcc$export$66bcaaca6b1eddac;

});
parcelRegister("2JKod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9abefafb7743d80$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $c9abefafb7743d80$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    removeAccountIconLabel: {
        id: 'remove.account.icon.label',
        defaultMessage: 'Remove account',
        description: ''
    },
    removeAccountDialogConfirm: {
        id: 'remove.account.dialog.confirm',
        defaultMessage: 'Remove',
        description: ''
    },
    removeAccountDialogClose: {
        id: 'remove.account.dialog.close',
        defaultMessage: 'Cancel',
        description: ''
    }
});

});

parcelRegister("cmPew", function(module, exports) {

$parcel$export(module.exports, "sessionsSelector", function () { return $6c7c92c8b1dcfb77$export$28c41c0d40d1bdce; });
$parcel$export(module.exports, "default", function () { return $6c7c92c8b1dcfb77$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");
parcelRequire("6jPF3");
var $hzjk7 = parcelRequire("hzjk7");

var $jSnDV = parcelRequire("jSnDV");

var $hTZm6 = parcelRequire("hTZm6");
const $6c7c92c8b1dcfb77$export$28c41c0d40d1bdce = (0, $hzjk7.createSelector)([
    (state)=>state.selectAccount.sessions,
    (_state, search)=>search,
    (_state, _search, loginHint)=>loginHint
], (sessions, search, loginHint)=>{
    if (!sessions) return [];
    const { suggested: suggested } = $jSnDV.parse(search);
    const combined = sessions.associated.map((session)=>{
        return (0, $6EnDC._)((0, $ty6PY._)({}, session), {
            current: false,
            suggested: false
        });
    });
    combined.unshift((0, $6EnDC._)((0, $ty6PY._)({}, sessions.current), {
        current: true,
        suggested: false
    }));
    return combined.reduce((sorted, session)=>{
        if (loginHint && loginHint.value === session.email) switch(loginHint.type){
            case (0, $hTZm6.LoginHintType).EmailAddress:
            case (0, $hTZm6.LoginHintType).NotEmailAddress:
                sorted.unshift((0, $6EnDC._)((0, $ty6PY._)({}, session), {
                    hint: loginHint.type
                }));
                break;
            default:
                sorted.push(session);
        }
        else sorted.push((0, $6EnDC._)((0, $ty6PY._)({}, session), {
            suggested: session.email === suggested
        }));
        return sorted;
    }, []);
});
var $6c7c92c8b1dcfb77$export$2e2bcd8739ae039 = $6c7c92c8b1dcfb77$export$28c41c0d40d1bdce;

});

parcelRegister("T3hrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1caf4e523fc70b93$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
let $1caf4e523fc70b93$var$_ = (t)=>t, $1caf4e523fc70b93$var$t;
const $1caf4e523fc70b93$var$Accounts = (0, $9Vz68.default).div($1caf4e523fc70b93$var$t || ($1caf4e523fc70b93$var$t = $1caf4e523fc70b93$var$_`
  > * + * {
    border-top: 1px solid ${0} !important;
  }
`), (0, $kTdw7).N30A);
var $1caf4e523fc70b93$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $6rcps.jsx)($1caf4e523fc70b93$var$Accounts, {
        className: "accounts-list",
        children: props.children
    });

});

parcelRegister("1dt6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e2d93ea89390897$var$_react = $0e2d93ea89390897$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $0e2d93ea89390897$var$_logOut = $0e2d93ea89390897$var$_interopRequireDefault((parcelRequire("d1FwI")));
function $0e2d93ea89390897$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0e2d93ea89390897$var$SignOutIcon = (props)=>/*#__PURE__*/ $0e2d93ea89390897$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M4.977 11A.99.99 0 0 0 4 12c0 .551.437 1 .977 1h11.046A.99.99 0 0 0 17 12a.99.99 0 0 0-.977-1z"/><path d="M6.23 8.31 3.3 11.27a1.05 1.05 0 0 0 0 1.48l2.93 2.96a1.03 1.03 0 0 0 1.47 0 1.05 1.05 0 0 0 0-1.48L5.5 12l2.2-2.22a1.05 1.05 0 0 0 0-1.48 1.03 1.03 0 0 0-1.47 0M15.5 3H12v2h7v14h-7v2h7.01c1.1 0 1.99-.89 1.99-1.99V5a1.99 1.99 0 0 0-1.99-2z"/></g></svg>`
    }, props, {
        newIcon: $0e2d93ea89390897$var$_logOut.default
    }));
$0e2d93ea89390897$var$SignOutIcon.displayName = 'SignOutIcon';
var $0e2d93ea89390897$var$_default = module.exports.default = $0e2d93ea89390897$var$SignOutIcon;

});
parcelRegister("d1FwI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b0ad8e82692fcbf05d6af098ca724db>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97bb94b03e8d124e$var$_react = $97bb94b03e8d124e$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $97bb94b03e8d124e$var$_baseNew = $97bb94b03e8d124e$var$_interopRequireDefault((parcelRequire("d9We0")));
function $97bb94b03e8d124e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LogOut".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for log out.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97bb94b03e8d124e$var$LogOutIcon = (props)=>/*#__PURE__*/ $97bb94b03e8d124e$var$_react.default.createElement($97bb94b03e8d124e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5h5V1H3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h5v-1.5H3a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5m11.78 4.97-3.5-3.5-1.06 1.06 2.22 2.22H6v1.5h6.44l-2.22 2.22 1.06 1.06 3.5-3.5a.75.75 0 0 0 0-1.06" clip-rule="evenodd"/>`
    }, props));
$97bb94b03e8d124e$var$LogOutIcon.displayName = 'LogOutIcon';
var $97bb94b03e8d124e$var$_default = module.exports.default = $97bb94b03e8d124e$var$LogOutIcon;

});



parcelRegister("889Xg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "selectAccountLoader", function () { return $2988abb9807de7eb$export$f44e7fa0a0dba44f; });
$parcel$export(module.exports, "SelectAccountPage", function () { return $2988abb9807de7eb$export$134466789cb44107; });
$parcel$export(module.exports, "default", function () { return $2988abb9807de7eb$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $a8rGb = parcelRequire("a8rGb");

var $8bNLi = parcelRequire("8bNLi");

var $3ir1n = parcelRequire("3ir1n");

var $jSnDV = parcelRequire("jSnDV");

var $hTZm6 = parcelRequire("hTZm6");

var $7w7rY = parcelRequire("7w7rY");

var $ftgIj = parcelRequire("ftgIj");

var $aSbA9 = parcelRequire("aSbA9");

var $cmPew = parcelRequire("cmPew");

var $hwVV4 = parcelRequire("hwVV4");

var $9OvaU = parcelRequire("9OvaU");

var $T3hrv = parcelRequire("T3hrv");

var $9REcQ = parcelRequire("9REcQ");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $day6I = parcelRequire("day6I");

var $pO9YU = parcelRequire("pO9YU");

var $jHLOy = parcelRequire("jHLOy");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $5WDNl = parcelRequire("5WDNl");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $2988abb9807de7eb$var$_ = (t)=>t, $2988abb9807de7eb$var$t, $2988abb9807de7eb$var$t1, $2988abb9807de7eb$var$t2, $2988abb9807de7eb$var$t3, $2988abb9807de7eb$var$t4, $2988abb9807de7eb$var$t5;
const $2988abb9807de7eb$var$MAXIMUM_ASSOCIATED_SESSIONS = 9;
const $2988abb9807de7eb$var$ButtonWrapper = (0, $9Vz68.default).div($2988abb9807de7eb$var$t || ($2988abb9807de7eb$var$t = $2988abb9807de7eb$var$_`
  padding-bottom: 0;
`));
const $2988abb9807de7eb$var$SectionMessageWrapper = (0, $9Vz68.default).div($2988abb9807de7eb$var$t1 || ($2988abb9807de7eb$var$t1 = $2988abb9807de7eb$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $2988abb9807de7eb$var$UnauthorizedWrapper = (0, $9Vz68.default).div($2988abb9807de7eb$var$t2 || ($2988abb9807de7eb$var$t2 = $2988abb9807de7eb$var$_`
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $2988abb9807de7eb$var$UnauthorizedHeader = (0, $9Vz68.default).div($2988abb9807de7eb$var$t3 || ($2988abb9807de7eb$var$t3 = $2988abb9807de7eb$var$_`
  padding-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $2988abb9807de7eb$var$AccountsList = (0, $9Vz68.default).ul($2988abb9807de7eb$var$t4 || ($2988abb9807de7eb$var$t4 = $2988abb9807de7eb$var$_`
  margin-top: 0px;
  padding: 0px;
  list-style-type: none;
`));
const $2988abb9807de7eb$var$AccountsListItem = (0, $9Vz68.default).li($2988abb9807de7eb$var$t5 || ($2988abb9807de7eb$var$t5 = $2988abb9807de7eb$var$_`
  margin-top: 0px;
`));
const $2988abb9807de7eb$var$pageId = 'selectAccountScreen';
const $2988abb9807de7eb$var$generateDestUrl = (parsedUrl)=>{
    let destUrl = '';
    if (parsedUrl.pathname) destUrl += parsedUrl.pathname;
    if (parsedUrl.search) destUrl += parsedUrl.search;
    return destUrl;
};
async function $2988abb9807de7eb$export$f44e7fa0a0dba44f({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/select-account/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--select-account'
        ]
    });
}
const $2988abb9807de7eb$export$134466789cb44107 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { search: search } = (0, $5WDNl.useLocation)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const loginHint = (0, $hTZm6.useLoginHint)();
    const sessions = (0, $kOqgB.useAppSelector)((state)=>(0, $cmPew.default)(state, search, loginHint));
    const applicationDestination = (0, $kOqgB.useAppSelector)((state)=>(0, $hwVV4.applicationDestinationSelector)(state, search));
    const hideLogout = (0, $kOqgB.useAppSelector)((state)=>(0, $day6I.isMobileOidc)(state.microbranding.oidcContext) || state.microbranding.isEmbedded);
    const isLoading = (0, $kOqgB.useAppSelector)((state)=>state.selectAccount.isLoading);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const shouldShowRequestAccessLink = (0, $8ZuGG.useCallback)(()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(search);
        let parsedUrl = '';
        try {
            parsedUrl = $2988abb9807de7eb$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        // Do nothing
        }
        return params.showRequestAccessLink === 'true' && applicationDestination !== null && parsedUrl !== '';
    }, [
        applicationDestination,
        search
    ]);
    const eventAttributes = (0, $8ZuGG.useMemo)(()=>({
            accountCount: sessions.length,
            loginHintType: loginHint ? loginHint.type : undefined,
            hideLogout: hideLogout,
            requestAccessLinkShown: shouldShowRequestAccessLink(),
            suggestedAccountShown: sessions.some((session)=>session.suggested)
        }), [
        hideLogout,
        loginHint,
        sessions,
        shouldShowRequestAccessLink
    ]);
    (0, $3ir1n.usePageViewedEvent)($2988abb9807de7eb$var$pageId, (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
        noAccess: !!loginHint && loginHint.type === (0, $hTZm6.LoginHintType).NotEmailAddress,
        accounts: sessions.map((session)=>session.accountId)
    }));
    const renderHeader = ()=>{
        const suggestedAccount = getSuggestedAccount();
        if (sessions.length === 1 && sessions[0].hint === (0, $hTZm6.LoginHintType).NotEmailAddress) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "try.another.account.title",
                defaultMessage: "Try a different account"
            })
        });
        else if (suggestedAccount) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "select.account.switch.title",
                defaultMessage: "Switch account"
            })
        });
        else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            size: "small",
            as: "h1",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "select.account.title",
                defaultMessage: "Choose or add another account"
            })
        });
    };
    const handleClickRequestAccessLink = (0, $3ir1n.useLinkClickedEvent)($2988abb9807de7eb$var$pageId, 'requestAccessLink');
    const renderMainContentFooter = ()=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(search);
        let destUrl = '';
        try {
            destUrl = $2988abb9807de7eb$var$generateDestUrl(new URL(decodeURIComponent(params.continue || '')));
        } catch (error) {
        //
        }
        const requestAccessLink = shouldShowRequestAccessLink() && applicationDestination && /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.RequestAccessLink), {
            onClick: handleClickRequestAccessLink,
            destUrl: destUrl,
            applicationDestination: applicationDestination
        });
        if (hideLogout) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {});
        if (requestAccessLink) return requestAccessLink;
        else {
            if (sessions.length <= 1) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                id: "redirect-to-logout",
                onClick: async ()=>{
                    await analyticsClient.buttonClickedEvent($2988abb9807de7eb$var$pageId, 'forgetAllAccounts', eventAttributes);
                    await dispatch((0, $a8rGb.doLogout)());
                },
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "select.account.footer.redirect.to.logout",
                    defaultMessage: "Log out"
                })
            });
        }
    };
    const handleSessionClick = (0, $8ZuGG.useCallback)((session, eventAttributes)=>{
        return ()=>{
            if (session.current) (async ()=>{
                await analyticsClient.buttonClickedEvent($2988abb9807de7eb$var$pageId, 'continueWithCurrentAccount', eventAttributes);
                await dispatch((0, $a8rGb.continueWithCurrentSession)(navigate));
            })();
            else {
                analyticsClient.buttonClickedEvent($2988abb9807de7eb$var$pageId, 'switchToAccount', eventAttributes);
                const request = {
                    sessionId: session.sessionId,
                    command: 'switch'
                };
                dispatch((0, $a8rGb.manageSession)(request, navigate));
            }
        };
    }, [
        analyticsClient,
        dispatch,
        navigate
    ]);
    const navigateToLogin = (0, $8bNLi.useNavigateToLoginPrompt)();
    const navigateToLoginPrompt = (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($2988abb9807de7eb$var$pageId, 'addAccount', eventAttributes);
        navigateToLogin();
    }, [
        analyticsClient,
        navigateToLogin,
        eventAttributes
    ]);
    const navigateToRemoveAccountPrompt = (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent($2988abb9807de7eb$var$pageId, 'removeAccountFromList', eventAttributes);
        navigate({
            pathname: '/login/remove-account',
            search: search
        });
    }, [
        analyticsClient,
        eventAttributes,
        navigate,
        search
    ]);
    const LoginHintNotEmailAddress = ({ index: index, suggestedAccount: suggestedAccount, session: session })=>{
        return suggestedAccount ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
            id: `account-${suggestedAccount.accountId}`,
            primary: true,
            avatarUrl: suggestedAccount.avatarUrl,
            displayName: suggestedAccount.displayName,
            email: suggestedAccount.email,
            header: /*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$UnauthorizedHeader, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9REcQ.default), {
                    applicationDestination: applicationDestination,
                    emailAddress: session.email,
                    suggested: true
                })
            }),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    onClick: handleSessionClick(suggestedAccount, (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                        accountIndex: index
                    })) || undefined,
                    isFullWidth: true,
                    id: "continue",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "select.account.continue",
                        defaultMessage: "Continue"
                    })
                })
            })
        }, `session-${suggestedAccount.sessionId}`) : /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$UnauthorizedWrapper, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9REcQ.default), {
                            applicationDestination: applicationDestination,
                            emailAddress: session.email,
                            suggested: false
                        })
                    })
                }, `session-${session.sessionId}`),
                sessions.length === 1 && /*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$ButtonWrapper, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                        id: "navigate-to-login-prompt",
                        appearance: "primary",
                        isFullWidth: true,
                        onClick: navigateToLoginPrompt,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "select.account.add",
                            defaultMessage: "Log in to another account"
                        })
                    })
                })
            ]
        });
    };
    const LoginHint = ({ session: session, index: index, suggestedAccount: suggestedAccount, handleOnClick: handleOnClick })=>{
        if (!session.hint) return null;
        switch(session.hint){
            case (0, $hTZm6.LoginHintType).EmailAddress:
                if (handleOnClick) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                    id: `account-${session.accountId}`,
                    primary: true,
                    avatarUrl: session.avatarUrl,
                    displayName: session.displayName,
                    email: session.email,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            appearance: "primary",
                            onClick: handleOnClick,
                            isFullWidth: true,
                            id: "continue",
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "select.account.continue",
                                defaultMessage: "Continue"
                            })
                        })
                    })
                }, `session-${session.sessionId}`);
                break;
            case (0, $hTZm6.LoginHintType).NotEmailAddress:
                return /*#__PURE__*/ (0, $6rcps.jsx)(LoginHintNotEmailAddress, {
                    index: index,
                    suggestedAccount: suggestedAccount,
                    session: session
                });
            default:
                return null;
        }
        return null;
    };
    const renderAccounts = ()=>{
        const suggestedAccount = getSuggestedAccount();
        const accountsList = sessions.map((session, index)=>{
            const { accountId: accountId, displayName: displayName, email: email } = session;
            const handleOnClick = handleSessionClick(session, (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                accountIndex: index
            }));
            return session.hint ? /*#__PURE__*/ (0, $6rcps.jsx)(LoginHint, {
                session: session,
                index: index,
                suggestedAccount: suggestedAccount,
                handleOnClick: handleOnClick
            }, "session-hint") : !session.suggested && /*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                    id: `account-${accountId}`,
                    onClick: handleOnClick || undefined,
                    avatarUrl: session.avatarUrl,
                    displayName: displayName,
                    email: email
                })
            }, `session-${session.sessionId}`);
        });
        const hasMultipleSessions = sessions.length > 1;
        const noLoginHint = sessions.length >= 1 && sessions[0].hint !== (0, $hTZm6.LoginHintType).NotEmailAddress;
        const canAddSessions = (hasMultipleSessions || noLoginHint) && sessions.length <= $2988abb9807de7eb$var$MAXIMUM_ASSOCIATED_SESSIONS;
        if (canAddSessions) accountsList.push(/*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$AccountsListItem, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AccountContainer), {
                id: "navigate-to-login-prompt",
                onClick: navigateToLoginPrompt,
                children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $aSbA9.RowButtonContainer), {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AvatarContainer), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7w7rY))), {
                                label: "",
                                size: "medium"
                            })
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.TextContainer), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.Paragraph), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "select.account.another",
                                    defaultMessage: "Add another account"
                                })
                            })
                        })
                    ]
                })
            })
        }, "navigate-to-login-prompt"));
        if (hasMultipleSessions) {
            const showRequestAccessLink = shouldShowRequestAccessLink();
            const showMaximumSessionsText = sessions.length > $2988abb9807de7eb$var$MAXIMUM_ASSOCIATED_SESSIONS;
            const noBorder = !showMaximumSessionsText && !showRequestAccessLink;
            accountsList.push(/*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$AccountsListItem, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AccountContainer), {
                    id: "navigate-to-remove-account-prompt",
                    noBorder: noBorder,
                    onClick: navigateToRemoveAccountPrompt,
                    children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $aSbA9.RowButtonContainer), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.AvatarContainer), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ftgIj))), {
                                    label: "",
                                    size: "medium"
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.TextContainer), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.Paragraph), {
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                        id: "select.account.footer.navigate.to.remove.account",
                                        defaultMessage: "Remove accounts from this browser"
                                    })
                                })
                            })
                        ]
                    })
                })
            }, "navigate-to-remove-account-prompt"));
        }
        const loginHintAccountIndex = sessions.findIndex((session)=>session.hint);
        const loginHintAccount = loginHintAccountIndex >= 0 ? accountsList.splice(loginHintAccountIndex, 1) : [];
        const accounts = loginHintAccount.concat(/*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$AccountsList, {
            children: accountsList
        }));
        return accounts;
    };
    const getSuggestedAccount = ()=>sessions.find((session)=>session.suggested);
    if (sessions.length > 0) return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $2988abb9807de7eb$var$pageId,
        header: renderHeader(),
        whiteboxFooter: renderMainContentFooter(),
        isLoading: isLoading,
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $T3hrv.default), {
                children: renderAccounts()
            }),
            sessions.length > $2988abb9807de7eb$var$MAXIMUM_ASSOCIATED_SESSIONS && /*#__PURE__*/ (0, $6rcps.jsx)($2988abb9807de7eb$var$SectionMessageWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
                    testId: "selectaccountmaximumassociatedsessions",
                    appearance: "warning",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "select.account.maximum.associated.sessions",
                        defaultMessage: "You can only add up to 10 accounts. Remove at least one account from this browser to add another."
                    })
                })
            })
        ]
    });
    navigateToLoginPrompt();
    return null;
};
var $2988abb9807de7eb$export$2e2bcd8739ae039 = $2988abb9807de7eb$export$134466789cb44107;

});
parcelRegister("7w7rY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57914d024a7dcef9$var$_react = $57914d024a7dcef9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $57914d024a7dcef9$var$_personAvatar = $57914d024a7dcef9$var$_interopRequireDefault((parcelRequire("57DVL")));
function $57914d024a7dcef9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57914d024a7dcef9$var$UserAvatarCircleIcon = (props)=>/*#__PURE__*/ $57914d024a7dcef9$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><circle cx="12" cy="9" r="3" fill="inherit"/><path fill="inherit" fill-rule="nonzero" d="M7 18.245A7.97 7.97 0 0 0 12 20c1.892 0 3.63-.657 5-1.755V15c0-1.115-.895-2-2-2H9c-1.113 0-2 .895-2 2z"/></g></svg>`
    }, props, {
        newIcon: $57914d024a7dcef9$var$_personAvatar.default
    }));
$57914d024a7dcef9$var$UserAvatarCircleIcon.displayName = 'UserAvatarCircleIcon';
var $57914d024a7dcef9$var$_default = module.exports.default = $57914d024a7dcef9$var$UserAvatarCircleIcon;

});
parcelRegister("57DVL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aedef9bb726854d64999097926d2fc86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bac949602df013a$var$_react = $3bac949602df013a$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $3bac949602df013a$var$_baseNew = $3bac949602df013a$var$_interopRequireDefault((parcelRequire("d9We0")));
function $3bac949602df013a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAvatar".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for user avatar.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bac949602df013a$var$PersonAvatarIcon = (props)=>/*#__PURE__*/ $3bac949602df013a$var$_react.default.createElement($3bac949602df013a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-4.148 11.505A2.75 2.75 0 0 1 6.5 11h3c1.26 0 2.323.848 2.648 2.005A6.5 6.5 0 0 0 8 1.5m2.75 12.392v-.142c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v.142l.06.027c.82.373 1.73.581 2.69.581s1.87-.208 2.69-.58q.03-.016.06-.028M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-3.5 2a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" clip-rule="evenodd"/>`
    }, props));
$3bac949602df013a$var$PersonAvatarIcon.displayName = 'PersonAvatarIcon';
var $3bac949602df013a$var$_default = module.exports.default = $3bac949602df013a$var$PersonAvatarIcon;

});


parcelRegister("ftgIj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b436876be5395f41$var$_react = $b436876be5395f41$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $b436876be5395f41$var$_crossCircle = $b436876be5395f41$var$_interopRequireDefault((parcelRequire("jwJqt")));
function $b436876be5395f41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b436876be5395f41$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $b436876be5395f41$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $b436876be5395f41$var$_crossCircle.default
    }));
$b436876be5395f41$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $b436876be5395f41$var$_default = module.exports.default = $b436876be5395f41$var$CrossCircleIcon;

});
parcelRegister("jwJqt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::70e4741cbfa8f6087ac64902b38a7366>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3743e28c6152feb$var$_react = $e3743e28c6152feb$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $e3743e28c6152feb$var$_baseNew = $e3743e28c6152feb$var$_interopRequireDefault((parcelRequire("d9We0")));
function $e3743e28c6152feb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3743e28c6152feb$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $e3743e28c6152feb$var$_react.default.createElement($e3743e28c6152feb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$e3743e28c6152feb$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $e3743e28c6152feb$var$_default = module.exports.default = $e3743e28c6152feb$var$CrossCircleIcon;

});


parcelRegister("hwVV4", function(module, exports) {

$parcel$export(module.exports, "applicationDestinationSelector", function () { return $1a6b63335ee60bca$export$2305087f4689eaf8; });

var $jSnDV = parcelRequire("jSnDV");

var $kZj5j = parcelRequire("kZj5j");
parcelRequire("6jPF3");
var $hzjk7 = parcelRequire("hzjk7");
const $1a6b63335ee60bca$var$parseContinueUrl = (search)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(search);
    if (params.continue) try {
        return new URL(params.continue);
    } catch (e) {
    //
    }
    return null;
};
const $1a6b63335ee60bca$export$2305087f4689eaf8 = (0, $hzjk7.createSelector)([
    (0, $kZj5j.applicationSelector),
    (_state, search)=>search
], (applicationData, search)=>{
    const continueUrl = $1a6b63335ee60bca$var$parseContinueUrl(search);
    const destinationHostname = continueUrl && continueUrl.hostname || null;
    if (applicationData) {
        if (applicationData.application === 'jira' || applicationData.application === 'confluence') return {
            destinationHostname: destinationHostname,
            applicationName: applicationData.name
        };
        return {
            destinationHostname: null,
            applicationName: applicationData.name
        };
    }
    return null;
});
var $1a6b63335ee60bca$export$2e2bcd8739ae039 = $1a6b63335ee60bca$export$2305087f4689eaf8;

});

parcelRegister("9REcQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1c1fb2a495eeaef$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $jHLOy = parcelRequire("jHLOy");
const $f1c1fb2a495eeaef$var$Message = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    if (!applicationDestination) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "login.unauthorized.email.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                    children: chunks
                }),
            email: emailAddress
        }
    });
    if (applicationDestination.destinationHostname) {
        if (suggested) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "login.unauthorized.host.suggested.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to <strong>{host}</strong>. Switch to the below account to continue.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    }),
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "login.unauthorized.host.body",
            defaultMessage: "<strong>{email}</strong> doesn't have access to {application} on <strong>{host}</strong>.",
            values: {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    }),
                application: applicationDestination.applicationName,
                email: emailAddress,
                host: applicationDestination.destinationHostname
            }
        });
    }
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "login.unauthorized.application.body",
        defaultMessage: "<strong>{email}</strong> doesn't have access to this content on <strong>{application}</strong>.",
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                    children: chunks
                }),
            application: applicationDestination.applicationName,
            email: emailAddress
        }
    });
};
const $f1c1fb2a495eeaef$var$UnauthorizedComponent = ({ applicationDestination: applicationDestination, emailAddress: emailAddress, suggested: suggested })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
        testId: "unauthorized-user",
        appearance: "warning",
        children: /*#__PURE__*/ (0, $6rcps.jsx)($f1c1fb2a495eeaef$var$Message, {
            applicationDestination: applicationDestination,
            emailAddress: emailAddress,
            suggested: !!suggested
        })
    });
};
var $f1c1fb2a495eeaef$export$2e2bcd8739ae039 = $f1c1fb2a495eeaef$var$UnauthorizedComponent;

});


parcelRegister("e0qo2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "continueAsLoader", function () { return $a8f186b48f2eee40$export$643f9a1ed27aa5c4; });
$parcel$export(module.exports, "ContinueAsPage", function () { return $a8f186b48f2eee40$export$a4ce1932d7e73468; });
$parcel$export(module.exports, "default", function () { return $a8f186b48f2eee40$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $1gkGY = parcelRequire("1gkGY");

var $9OvaU = parcelRequire("9OvaU");

var $1SvOA = parcelRequire("1SvOA");

var $aSbA9 = parcelRequire("aSbA9");

var $9Vz68 = parcelRequire("9Vz68");

var $8dHAc = parcelRequire("8dHAc");

var $day6I = parcelRequire("day6I");

var $7CMue = parcelRequire("7CMue");

var $5b7Z4 = parcelRequire("5b7Z4");

var $3ir1n = parcelRequire("3ir1n");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
let $a8f186b48f2eee40$var$_ = (t)=>t, $a8f186b48f2eee40$var$t;
const $a8f186b48f2eee40$var$AccountWrapper = (0, $9Vz68.default).div($a8f186b48f2eee40$var$t || ($a8f186b48f2eee40$var$t = $a8f186b48f2eee40$var$_`
  .account-entry {
    padding-bottom: ${0}px;
    border-bottom: none;
  }
`), (0, $5b7Z4.gridSize)() * 2);
const $a8f186b48f2eee40$var$pageId = 'continueAsScreen';
async function $a8f186b48f2eee40$export$643f9a1ed27aa5c4({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/continue-as/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--continue-as'
        ]
    });
}
const $a8f186b48f2eee40$export$a4ce1932d7e73468 = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const [isLoading, setIsLoading] = (0, $8ZuGG.useState)(false);
    const { avatarUrl: avatarUrl, continueUrl: continueUrl, displayName: displayName, email: email } = (0, $kOqgB.useAppSelector)((state)=>state.continueAs);
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const location = (0, $5WDNl.useLocation)();
    (0, $3ir1n.usePageViewedEvent)($a8f186b48f2eee40$var$pageId);
    const trackContinueButtonClicked = (0, $3ir1n.useButtonClickedEvent)($a8f186b48f2eee40$var$pageId, 'continueAsButton');
    const handleContinueButton = (0, $8ZuGG.useCallback)(()=>{
        trackContinueButtonClicked();
        setIsLoading(true);
        navigate(continueUrl);
    }, [
        continueUrl,
        trackContinueButtonClicked,
        navigate
    ]);
    const trackLoginWithOtherAccountClicked = (0, $3ir1n.useButtonClickedEvent)($a8f186b48f2eee40$var$pageId, 'loginWithOtherAccount');
    const whiteboxFooter = ()=>{
        const operand = location.search && location.search.length > 0 ? '&' : '?';
        const loginLink = `/login${location.search}${operand}prompt=true`;
        if (!(0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).Continue)) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                onClick: trackLoginWithOtherAccountClicked,
                href: loginLink,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "continue.as.login.with.another.account",
                    defaultMessage: "Login with a different account"
                })
            })
        });
        return null;
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $a8f186b48f2eee40$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1gkGY.default), {
            displayName: displayName
        }),
        whiteboxFooter: whiteboxFooter(),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)($a8f186b48f2eee40$var$AccountWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aSbA9.default), {
                    primary: true,
                    avatarUrl: avatarUrl,
                    displayName: displayName,
                    email: email
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                appearance: "primary",
                id: "login-submit",
                type: "submit",
                isFullWidth: true,
                isLoading: isLoading,
                onClick: handleContinueButton,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "continue.as.button",
                    defaultMessage: "Continue"
                })
            })
        ]
    });
};
var $a8f186b48f2eee40$export$2e2bcd8739ae039 = $a8f186b48f2eee40$export$a4ce1932d7e73468;

});
parcelRegister("1gkGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3ecfbef6a6f246e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $5VQjR = parcelRequire("5VQjR");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
const $f3ecfbef6a6f246e$var$ContinueAsHeader = ({ displayName: displayName })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, {
        children: displayName ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "continue.as.title.as",
                defaultMessage: "Continue as"
            })
        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "continue.as.title.as.application",
            tagName: "div",
            defaultMessage: "Continue to the application"
        })
    });
};
var $f3ecfbef6a6f246e$export$2e2bcd8739ae039 = $f3ecfbef6a6f246e$var$ContinueAsHeader;

});


parcelRegister("4RcrL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "migrateConfirmationLoader", function () { return $41801772930afdca$export$14853815c59b96ba; });
$parcel$export(module.exports, "MigrateAccountConfirmationPage", function () { return $41801772930afdca$export$3432bb22f729c42b; });
$parcel$export(module.exports, "default", function () { return $41801772930afdca$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $g5rao = parcelRequire("g5rao");

var $fBMWS = parcelRequire("fBMWS");

var $gJFTu = parcelRequire("gJFTu");

var $1SvOA = parcelRequire("1SvOA");

var $4SAl7 = parcelRequire("4SAl7");

var $7CMue = parcelRequire("7CMue");

var $kZj5j = parcelRequire("kZj5j");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $5VQjR = parcelRequire("5VQjR");
let $41801772930afdca$var$_ = (t)=>t, $41801772930afdca$var$t;
const $41801772930afdca$var$MigrateAccountConfirmationSubHeading = (0, $9Vz68.default).p($41801772930afdca$var$t || ($41801772930afdca$var$t = $41801772930afdca$var$_`
  font: ${0};
  margin-top: ${0}px;
`), (0, $g5rao.default)('font.body'), (0, $5b7Z4.gridSize)());
const $41801772930afdca$var$pageId = 'accountMigrationSuccessfulScreen';
async function $41801772930afdca$export$14853815c59b96ba({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/signup/migrate-confirmation/state', request, {
        capabilities: []
    });
}
const $41801772930afdca$export$3432bb22f729c42b = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const redirectTo = (0, $kOqgB.useAppSelector)((state)=>state.migrateConfirmation.redirectTo);
    const location = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { infoCode: infoCode } = (0, (/*@__PURE__*/$parcel$interopDefault($fBMWS))).parse(location.search.slice(1));
    const migratingUserInfoCode = infoCode || null;
    const pageViewedAttributes = migratingUserInfoCode ? {
        reasonViewingScreen: migratingUserInfoCode
    } : {};
    (0, $3ir1n.usePageViewedEvent)($41801772930afdca$var$pageId, pageViewedAttributes);
    const trackContinueToProduct = (0, $3ir1n.useButtonClickedEvent)($41801772930afdca$var$pageId, 'continueToProduct');
    const handleOnClick = ()=>{
        trackContinueToProduct();
        navigate(redirectTo);
    };
    const productDisplayName = cobranding && cobranding.application && (0, $kZj5j.applications)[cobranding.application] ? (0, $kZj5j.applications)[cobranding.application].name : 'Product';
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $41801772930afdca$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $4SAl7.default).migrateAccountConfirmationTitle))
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)($41801772930afdca$var$MigrateAccountConfirmationSubHeading, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $4SAl7.default).migrateAccountConfirmationSummaryText), {
                    values: {
                        productDisplayName: productDisplayName
                    }
                }))
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "continue-submit",
                    type: "submit",
                    isFullWidth: true,
                    onClick: handleOnClick,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $4SAl7.default).migrateAccountConfirmationButtonText), {
                        values: {
                            productDisplayName: productDisplayName
                        }
                    }))
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $4SAl7.default).headTitle)
            })
        ]
    });
};
var $41801772930afdca$export$2e2bcd8739ae039 = $41801772930afdca$export$3432bb22f729c42b;

});
parcelRegister("fBMWS", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $b5d047e8c3bc0039$export$2f872c0f2117be69; }, function (v) { return $b5d047e8c3bc0039$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "parse", function () { return $b5d047e8c3bc0039$export$98e6a39c04603d36; }, function (v) { return $b5d047e8c3bc0039$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "encode", function () { return $b5d047e8c3bc0039$export$c564cdbbe6da493; }, function (v) { return $b5d047e8c3bc0039$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "stringify", function () { return $b5d047e8c3bc0039$export$fac44ee5b035f737; }, function (v) { return $b5d047e8c3bc0039$export$fac44ee5b035f737 = v; });
var $b5d047e8c3bc0039$export$2f872c0f2117be69;
var $b5d047e8c3bc0039$export$98e6a39c04603d36;
var $b5d047e8c3bc0039$export$c564cdbbe6da493;
var $b5d047e8c3bc0039$export$fac44ee5b035f737;
'use strict';

$b5d047e8c3bc0039$export$2f872c0f2117be69 = $b5d047e8c3bc0039$export$98e6a39c04603d36 = (parcelRequire("hTd7w"));

$b5d047e8c3bc0039$export$c564cdbbe6da493 = $b5d047e8c3bc0039$export$fac44ee5b035f737 = (parcelRequire("kPSmv"));

});
parcelRegister("hTd7w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $d061c02270f5a630$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$d061c02270f5a630$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($d061c02270f5a630$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $d061c02270f5a630$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("kPSmv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $f2b2bd3b35b76d55$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $f2b2bd3b35b76d55$var$map($f2b2bd3b35b76d55$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($f2b2bd3b35b76d55$var$stringifyPrimitive(k)) + eq;
        if ($f2b2bd3b35b76d55$var$isArray(obj[k])) return $f2b2bd3b35b76d55$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($f2b2bd3b35b76d55$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($f2b2bd3b35b76d55$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($f2b2bd3b35b76d55$var$stringifyPrimitive(name)) + eq + encodeURIComponent($f2b2bd3b35b76d55$var$stringifyPrimitive(obj));
};
var $f2b2bd3b35b76d55$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $f2b2bd3b35b76d55$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $f2b2bd3b35b76d55$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("4SAl7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7f59c4e78342960$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $c7f59c4e78342960$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    migrateAccountConfirmationTitle: {
        id: 'migrate.account.confirmation.title',
        defaultMessage: "We've migrated your account!",
        description: 'Page heading'
    },
    migrateAccountConfirmationButtonText: {
        id: 'migrate.account.confirmation.button.text',
        defaultMessage: 'Continue to {productDisplayName}',
        description: 'Button text'
    },
    migrateAccountConfirmationSummaryText: {
        id: 'migrate.account.confirmation.summary.text',
        defaultMessage: "Your {productDisplayName} password has expired. From now on, use your Atlassian account to access {productDisplayName}.",
        description: 'Summary text'
    },
    headTitle: {
        id: 'migrate.account.confirmation.head.title',
        defaultMessage: 'Confirmed'
    }
});

});


parcelRegister("9GYqm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "recoverLoader", function () { return $4819a6543f465714$export$1e2056400c8bd3bc; });
$parcel$export(module.exports, "RecoveryPage", function () { return $4819a6543f465714$export$280a36f5ba1cc19f; });
$parcel$export(module.exports, "default", function () { return $4819a6543f465714$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $5VQjR = parcelRequire("5VQjR");

var $5r3NL = parcelRequire("5r3NL");

var $QzX7o = parcelRequire("QzX7o");

var $4C0Hc = parcelRequire("4C0Hc");

var $7CMue = parcelRequire("7CMue");

var $2rhJJ = parcelRequire("2rhJJ");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");
let $4819a6543f465714$var$_ = (t)=>t, $4819a6543f465714$var$t;
const $4819a6543f465714$var$FormWrapper = (0, $9Vz68.default).div($4819a6543f465714$var$t || ($4819a6543f465714$var$t = $4819a6543f465714$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $4819a6543f465714$var$pageId = '2svRecoveryLoginScreen';
async function $4819a6543f465714$export$1e2056400c8bd3bc({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/2step/recover/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--mfa-recover'
        ]
    });
}
const $4819a6543f465714$export$280a36f5ba1cc19f = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $3ir1n.usePageViewedEvent)($4819a6543f465714$var$pageId);
    (0, $8xW40.usePageStateLoader)();
    const { error: error, fieldErrors: fieldErrors, redirectTo: redirectTo, isLoading: isLoading } = (0, $kOqgB.useAppSelector)((state)=>state.recovery);
    const email = (0, $kOqgB.useAppSelector)((state)=>state.user.email);
    (0, $8ZuGG.useEffect)(()=>{
        return ()=>{
            dispatch((0, $2rhJJ.reset)());
        };
    }, [
        dispatch
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (redirectTo) navigate(redirectTo);
    }, [
        redirectTo,
        navigate
    ]);
    const handleValidationError = (0, $8ZuGG.useCallback)((errors)=>{
        dispatch((0, $2rhJJ.showFieldErrors)(errors));
    }, [
        dispatch
    ]);
    const handleLogIn = (0, $8ZuGG.useCallback)((username, password)=>{
        dispatch((0, $2rhJJ.loginRecovery)({
            username: username,
            password: password,
            location: window.location,
            pageId: $4819a6543f465714$var$pageId,
            analyticsClient: analyticsClient
        }));
    }, [
        dispatch,
        analyticsClient
    ]);
    const buildHeader = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)("div", {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                size: "small",
                as: "h1",
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "recovery.title",
                    defaultMessage: "Login to your Atlassian account"
                })
            })
        });
    };
    const onTsvLoginClick = (0, $3ir1n.useButtonClickedEvent)($4819a6543f465714$var$pageId, '2svRecoveryLogin');
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $4819a6543f465714$var$pageId,
        header: buildHeader(),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $QzX7o.RecoveryPageMessages).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)($4819a6543f465714$var$FormWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5r3NL.default), {
                    email: email,
                    emailFieldLabel: formatMessage((0, $4C0Hc.default).loginFormUsernameLabel),
                    error: error,
                    fieldErrors: fieldErrors,
                    isLoading: isLoading,
                    onValidationError: handleValidationError,
                    submitButtonText: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "common.login",
                        defaultMessage: "Log in"
                    }),
                    onSubmitClick: onTsvLoginClick,
                    onSubmit: handleLogIn
                })
            })
        ]
    });
};
var $4819a6543f465714$export$2e2bcd8739ae039 = $4819a6543f465714$export$280a36f5ba1cc19f;

});
parcelRegister("QzX7o", function(module, exports) {

$parcel$export(module.exports, "RecoveryPageMessages", function () { return $38872f260e817f59$export$d587a18b8a3f34fa; });

var $3VrrU = parcelRequire("3VrrU");
const $38872f260e817f59$export$d587a18b8a3f34fa = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    }
});

});

parcelRegister("4C0Hc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dca5ef32e4df834d$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $dca5ef32e4df834d$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    loginFormUsernamePlaceholder: {
        id: 'login.form.username.placeholder',
        defaultMessage: 'Enter email'
    },
    loginFormUsernameLabel: {
        id: 'login.form.username.label',
        defaultMessage: 'Email'
    },
    loginFormReadOnlyUsernameAriaLabel: {
        id: 'login.form.readonly.username.aria.label',
        defaultMessage: 'Edit email'
    }
});

});

parcelRegister("2rhJJ", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $744aca20885a3f5f$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $744aca20885a3f5f$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "loginRecovery", function () { return $744aca20885a3f5f$export$29e90b35a0be5386; });
const $744aca20885a3f5f$export$aad8462122ac592b = ()=>({
        type: 'TSV_RECOVERY_RESET'
    });
const $744aca20885a3f5f$export$808a667858638948 = (redirectTo)=>({
        type: 'TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT',
        redirectTo: redirectTo
    });
const $744aca20885a3f5f$export$51ae2c0618607c9f = (error)=>({
        type: 'TSV_RECOVERY_REQUEST_FAILED',
        error: error
    });
const $744aca20885a3f5f$export$f17d5fd8029ff8d7 = (error)=>({
        type: 'TSV_RECOVERY_SHOW_FIELD_ERRORS',
        error: error
    });
const $744aca20885a3f5f$export$29e90b35a0be5386 = ({ location: location, password: password, pageId: pageId, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($744aca20885a3f5f$export$aad8462122ac592b());
        return fetch(`/2step/recover${location.search}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify({
                password: password
            })
        }).then((res)=>res.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($744aca20885a3f5f$export$808a667858638948(redirectTo));
            else {
                if (fieldErrors && Object.keys(fieldErrors).length) dispatch($744aca20885a3f5f$export$f17d5fd8029ff8d7(fieldErrors));
                else if (uiErrors && uiErrors.length) {
                    const uiError = uiErrors[0];
                    if (uiError.key === 'password') analyticsClient.errorShownEvent(pageId, '2svRecoveryIncorrectPassword');
                    else analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
                    dispatch($744aca20885a3f5f$export$51ae2c0618607c9f(uiError.error));
                }
            }
        }).catch(()=>{
            analyticsClient.errorShownEvent(pageId, '2svRecoveryUnexpectedError');
            dispatch($744aca20885a3f5f$export$51ae2c0618607c9f('unknown'));
        });
    };

});



parcelRegister("22H0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a13f29e657c584ac$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $gyRZh = parcelRequire("gyRZh");

var $lk8Tl = parcelRequire("lk8Tl");
const $a13f29e657c584ac$var$mobileAppToUrlPatterns = {
    jira: [
        '/secure',
        '/issues',
        '/browse',
        '#issue',
        '#myjirahome',
        '#browse'
    ],
    confluence: [
        '/wiki'
    ]
};
const $a13f29e657c584ac$var$iosAppId = {
    jira: '1006972087',
    confluence: '1006971684'
};
const $a13f29e657c584ac$var$slackAppId = {
    jira: 'A2RPP3NFR',
    confluence: 'AC23SDS77'
};
/**
 * Checks if the continueUrl contains the specified pattern.
 * Additionally searches for the url encoded form of the pattern,
 * which can be encoded up to 3 times e.g. openId continue urls.
 */ const $a13f29e657c584ac$var$checkForPattern = (continueUrl, pattern)=>{
    if (continueUrl.includes(pattern)) return true;
    const encode1 = encodeURIComponent(pattern);
    const encode2 = encodeURIComponent(encode1);
    const encode3 = encodeURIComponent(encode2);
    return continueUrl.includes(encode1) || continueUrl.includes(encode2) || continueUrl.includes(encode3);
};
/**
 * Adds mobile app meta tags to the document head if the continueUrl matches a pattern configured for mobile apps.
 */ const $a13f29e657c584ac$var$MobileAppMetaTags = ()=>{
    const [queryParams] = (0, $gyRZh.useSearchParams)();
    const continueUrl = queryParams.get('continue');
    const maybeMobileApp = (0, $8ZuGG.useMemo)(()=>{
        if (!continueUrl) return null;
        for (const [mobileApp, urlPatterns] of Object.entries($a13f29e657c584ac$var$mobileAppToUrlPatterns)){
            if (urlPatterns.find((urlPattern)=>$a13f29e657c584ac$var$checkForPattern(continueUrl, urlPattern))) return mobileApp;
        }
        return null;
    }, [
        continueUrl
    ]);
    return maybeMobileApp && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $3o9o3.default), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("meta", {
                name: "apple-itunes-app",
                content: `app-id=${$a13f29e657c584ac$var$iosAppId[maybeMobileApp]}`
            }),
            (0, $lk8Tl.getCurrentCloudType)() === 'commercial' && /*#__PURE__*/ (0, $6rcps.jsx)("meta", {
                name: "slack-app-id",
                content: $a13f29e657c584ac$var$slackAppId[maybeMobileApp]
            })
        ]
    });
};
var $a13f29e657c584ac$export$2e2bcd8739ae039 = $a13f29e657c584ac$var$MobileAppMetaTags;

});

parcelRegister("7gtNi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9620e8d7f2a05fd6$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $7tB0e = parcelRequire("7tB0e");

var $9JJFg = parcelRequire("9JJFg");

var $k2gF6 = parcelRequire("k2gF6");

var $kOqgB = parcelRequire("kOqgB");
const $9620e8d7f2a05fd6$export$f90bece7989dfdb6 = ({ children: children })=>{
    const intl = (0, $iSD9t.default)();
    const serverError = (0, $kOqgB.useAppSelector)((state)=>state.serverError);
    if (serverError) {
        if (serverError.type === 'not_found') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $k2gF6.default).notFoundTitle)
        });
        else if (serverError.type === 'internal_server_error') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $k2gF6.default).internalServerErrorTitle),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $k2gF6.default).internalServerErrorDescription))
        });
        else if (serverError.type === 'bad_request') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $k2gF6.default).badRequestTitle),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.badrequest.desc.xml",
                defaultMessage: "Often, clearing your browsers cache and restarting your browser will solve this problem.{br}If that doesn't work, please <support-link>contact support</support-link>.",
                values: {
                    br: /*#__PURE__*/ (0, $6rcps.jsx)("br", {}),
                    'support-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                            href: "https://support.atlassian.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: chunks
                        })
                }
            })
        });
        else if (serverError.type === 'csrf_token_mismatch') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9JJFg.default), {});
        else throw new Error(serverError.type || 'ServerError');
    }
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};
var $9620e8d7f2a05fd6$export$2e2bcd8739ae039 = $9620e8d7f2a05fd6$export$f90bece7989dfdb6;

});
parcelRegister("9JJFg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $993cb5104798db5b$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $jSnDV = parcelRequire("jSnDV");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $HBurV = parcelRequire("HBurV");

var $0pf8M = parcelRequire("0pf8M");

var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $3ir1n = parcelRequire("3ir1n");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $9NVnN = parcelRequire("9NVnN");

var $5VQjR = parcelRequire("5VQjR");
let $993cb5104798db5b$var$_ = (t)=>t, $993cb5104798db5b$var$t;
const $993cb5104798db5b$var$pageId = 'atlassianAccountCsrfTokenMismatchErrorScreen';
const $993cb5104798db5b$var$StyledOptions = (0, $9Vz68.default).ul($993cb5104798db5b$var$t || ($993cb5104798db5b$var$t = $993cb5104798db5b$var$_`
  padding-left: ${0}px;
`), 3 * (0, $5b7Z4.gridSize)());
const $993cb5104798db5b$export$2529ac9c93e3a3c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const preservedParamsKeys = [
        'application',
        'continue',
        'display',
        'email',
        'login_hint',
        'tenant'
    ];
    const originalParams = $jSnDV.parse(window.location.search);
    const preservedParams = Object.keys(originalParams).filter((key)=>preservedParamsKeys.includes(key)).reduce((obj, key)=>{
        obj[key] = originalParams[key];
        return obj;
    }, {});
    (0, $3ir1n.usePageViewedEvent)($993cb5104798db5b$var$pageId, {
        application: preservedParams.application
    });
    const tryLoginAgainAction = ()=>{
        analyticsClient.buttonClickedEvent($993cb5104798db5b$var$pageId, 'csrfTokenMismatchTryAgainButton', {
            application: preservedParams.application
        });
        const queryParamsString = $jSnDV.stringify(preservedParams);
        navigate('/login' + (queryParamsString ? `?${queryParamsString}` : ''));
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $993cb5104798db5b$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
            as: "h1",
            size: "small",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $0pf8M.default).csrfMismatchTitle))
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                height: "150",
                alt: "",
                className: "error-image"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("br", {}),
            /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                className: "error-description",
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $0pf8M.default).csrfMismatchDescriptionFirstLine)),
                    /*#__PURE__*/ (0, $6rcps.jsxs)($993cb5104798db5b$var$StyledOptions, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "error.csrfmismatch.description.secondline",
                                    defaultMessage: "Close any <b>{siteName}</b> windows in your browser",
                                    values: {
                                        b: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                                children: chunks
                                            }),
                                        siteName: window.location.hostname
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $0pf8M.default).csrfMismatchDescriptionThirdLine))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "try-again-button",
                    isFullWidth: true,
                    onClick: tryLoginAgainAction,
                    children: formatMessage((0, $0pf8M.default).csrfMismatchButtonText)
                })
            })
        ]
    });
};
var $993cb5104798db5b$export$2e2bcd8739ae039 = $993cb5104798db5b$export$2529ac9c93e3a3c2;

});
parcelRegister("0pf8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aea8a4ae1ebffbe2$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $aea8a4ae1ebffbe2$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    csrfMismatchTitle: {
        id: 'error.csrfmismatch.title',
        defaultMessage: "We couldn't log you in"
    },
    csrfMismatchDescriptionFirstLine: {
        id: 'error.csrfmismatch.description.firstline',
        defaultMessage: 'Before trying again:'
    },
    csrfMismatchDescriptionThirdLine: {
        id: 'error.csrfmismatch.description.thirdline',
        defaultMessage: 'Check your browser settings and disable any extensions that may interfere with cookies.'
    },
    csrfMismatchButtonText: {
        id: 'error.csrfmismatch.button',
        defaultMessage: 'Try logging in again'
    }
});

});


parcelRegister("k2gF6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caaed7f68f806aa4$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $caaed7f68f806aa4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    genericErrorTitle: {
        id: 'error.title',
        defaultMessage: 'Something went wrong.'
    },
    internalServerErrorTitle: {
        id: 'error.internalservererror.title',
        defaultMessage: 'Something went wrong while executing your request.'
    },
    internalServerErrorDescription: {
        id: 'error.internalservererror.desc',
        defaultMessage: "We're working on it, please try again shortly."
    },
    notFoundTitle: {
        id: 'error.notfound.title',
        defaultMessage: 'Page Not Found'
    },
    badRequestTitle: {
        id: 'error.badrequest.title',
        defaultMessage: "Oops, you've made a malformed request."
    }
});

});


parcelRegister("jApGI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b20cf8091a47c413$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $day6I = parcelRequire("day6I");

var $7tB0e = parcelRequire("7tB0e");

var $kOqgB = parcelRequire("kOqgB");
const $b20cf8091a47c413$var$isUnSupportedMobileBrowser = ()=>{
    return /UC.*Browser|UCWEB/.test(window.navigator.userAgent);
};
const $b20cf8091a47c413$export$3746f9f8319adede = ({ children: children })=>{
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    if ((0, $day6I.isMobileOidc)(oidcContext) && $b20cf8091a47c413$var$isUnSupportedMobileBrowser()) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
        title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "unsupported.mobile.browser.error.message.heading",
            defaultMessage: "We\u2019re unable to log you in"
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "unsupported.mobile.browser.error.message.content",
            defaultMessage: "You are currently using an unsupported browser. Please use a supported browser such as Chrome, Firefox, Opera or Samsung Internet."
        })
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};
var $b20cf8091a47c413$export$2e2bcd8739ae039 = $b20cf8091a47c413$export$3746f9f8319adede;

});

parcelRegister("9Li6K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $077a30f4e66457c5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "UnexpectedApplicationErrorPage", function () { return $077a30f4e66457c5$export$4f726a446dcd19f1; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tB0e = parcelRequire("7tB0e");

var $gGDrC = parcelRequire("gGDrC");

var $8f2pb = parcelRequire("8f2pb");
class $077a30f4e66457c5$export$2e2bcd8739ae039 extends (0, $8ZuGG.Component) {
    componentDidCatch(error, errorInfo) {
        // Handle case where the error is not specific enough for SLO but we still want to know about it
        // Example: build tools result in Event being thrown instead of Error, for failures to load
        // dynamically imported modules - should not burn SLO but is worth alerting via Sentry.
        if (!(error instanceof Error)) {
            this.setState({
                errorType: 'unexpected'
            });
            (0, $8f2pb.captureMalformedError)(new Error(`Caught object that is not of type Error: ${error}`), {
                error: error
            }, 'not-an-instance-of-error');
            return;
        }
        // Failed to fetch dynamically imported module:
        // Importing a module script failed.
        // error loading dynamically imported module:
        // Cannot find module
        if (/(import|find).*.module/i.test(error.message)) {
            this.setState({
                errorType: 'network'
            });
            return;
        }
        this.setState({
            errorType: 'unexpected'
        });
        if (this.props.skipAnalytics) return;
        const page = window.location.pathname;
        const attributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorComponentStack: errorInfo.componentStack || undefined,
            errorStack: error.stack
        };
        (0, $8f2pb.captureTaggedReactException)(error, errorInfo, {
            capabilities: this.props.capabilities || [],
            extraProperties: {
                'ErrorBoundary.action': 'loadPageFailure',
                'ErrorBoundary.pageId': page
            }
        });
        this.props.analyticsClient.operationalEvent({
            page: page,
            action: 'loadPageFailure',
            subject: 'sli',
            attributes: attributes
        });
    }
    render() {
        const { errorType: errorType } = this.state;
        const anonymousId = this.props.analyticsClient.getAnonymousId();
        if (errorType === 'network') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.BaseErrorPage), {
            title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.boundary.error.title",
                defaultMessage: "Something went wrong"
            }),
            anonymousId: anonymousId,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.boundary.network.error",
                defaultMessage: "We were unable to load this page, possibly due to a network connectivity issue. Please check your network connection and try again.",
                tagName: "p"
            })
        });
        if (errorType === 'unexpected') return /*#__PURE__*/ (0, $6rcps.jsx)($077a30f4e66457c5$export$4f726a446dcd19f1, {
            anonymousId: anonymousId
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
const $077a30f4e66457c5$export$4f726a446dcd19f1 = ({ anonymousId: anonymousId })=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.BaseErrorPage), {
        title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "error.boundary.error.title",
            defaultMessage: "Something went wrong"
        }),
        anonymousId: anonymousId,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "error.boundary.unexpected.error",
            defaultMessage: "An unexpected error occurred. We are looking into it. Please try again later.",
            tagName: "p"
        })
    });

});

parcelRegister("jqdIA", function(module, exports) {

$parcel$export(module.exports, "reactRouterFutureFlags", function () { return $1d28e13941f1bfea$export$d4ead9fca2c685ee; });
const $1d28e13941f1bfea$export$d4ead9fca2c685ee = {
    // Enabled all future flags for v7 upgrade: https://reactrouter.com/6.29.0/upgrading/future
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true
};

});

parcelRegister("aSgj5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "loginLoader", function () { return $4f10db27a3b37ac0$export$b2919fa8ecdd2f51; });
$parcel$export(module.exports, "default", function () { return $4f10db27a3b37ac0$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $iSD9t = parcelRequire("iSD9t");

var $fouZP = parcelRequire("fouZP");

var $avtAy = parcelRequire("avtAy");

var $7NASj = parcelRequire("7NASj");

var $7CMue = parcelRequire("7CMue");

var $40CJF = parcelRequire("40CJF");

var $kOqgB = parcelRequire("kOqgB");

var $9Codz = parcelRequire("9Codz");

var $oXIXy = parcelRequire("oXIXy");

var $1yJSg = parcelRequire("1yJSg");

var $kyxFY = parcelRequire("kyxFY");

var $hQdhs = parcelRequire("hQdhs");

var $5Nhr0 = parcelRequire("5Nhr0");

var $hm82Q = parcelRequire("hm82Q");

var $4nIlz = parcelRequire("4nIlz");

var $7zDhH = parcelRequire("7zDhH");

var $galVA = parcelRequire("galVA");

var $hPjb0 = parcelRequire("hPjb0");

var $dpD1g = parcelRequire("dpD1g");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $97yOV = parcelRequire("97yOV");

var $kvSBU = parcelRequire("kvSBU");
async function $4f10db27a3b37ac0$export$b2919fa8ecdd2f51({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/state', request, {
        capabilities: [
            'capability-group--login'
        ]
    });
}
const $4f10db27a3b37ac0$var$LoginPage = ()=>{
    const { state: state } = (0, $9Codz.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsername: checkUsername, isUsernameChecked: isUsernameChecked, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, isCheckUsernameLoading: isCheckUsernameLoading, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $4nIlz.useLogin)();
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $7zDhH.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $galVA.useSocialLogin)();
    const { onPasskeyLogin: onPasskeyLogin, authenticating: authenticating } = (0, $kvSBU.usePasskeyLogin)();
    const cobrandingApplication = (0, $hm82Q.useCobrandingApplication)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const emailFromSearchParams = (0, $hm82Q.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $8ZuGG.useState)(()=>emailFromSearchParams || '');
    // Sync state with query params
    // In the case when the query params change after the component is first rendered
    (0, $8ZuGG.useEffect)(()=>{
        if (emailFromSearchParams) setEmail(emailFromSearchParams);
    }, [
        emailFromSearchParams
    ]);
    (0, $hPjb0.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handlePasskeyLogin = (0, $8ZuGG.useCallback)(()=>{
        onPasskeyLogin();
    }, [
        onPasskeyLogin
    ]);
    const handleValidationError = (0, $8ZuGG.useCallback)((errors)=>dispatch((0, $fouZP.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === 'mobile') onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $8ZuGG.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("title", {
                    children: formatMessage((0, $40CJF.LoginPageMessages).headTitle)
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
                pageId: (0, $5Nhr0.loginPageId),
                header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1yJSg.default), {
                    highlightedSocialProvider: highlightedSocialProvider,
                    showSocialLoginOnly: showSocialLoginOnly
                }),
                footer: /*#__PURE__*/ (0, $6rcps.jsx)((0, $oXIXy.default), {
                    oidcContext: oidcContext,
                    isEmbedded: isEmbedded
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $hQdhs.default), {
                    showSocialLoginOnly: showSocialLoginOnly,
                    isMobileApp: isMobileApp,
                    oidcContext: oidcContext
                }),
                children: showSocialLoginOnly ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $7NASj.default), {
                    email: email,
                    highlightedSocialProvider: highlightedSocialProvider,
                    handleGoogleLogin: handleGoogleSocialLogin,
                    handleMicrosoftLogin: handleMicrosoftLogin,
                    handleAppleLogin: handleAppleLogin,
                    handleSlackLogin: handleSlackLogin
                }) : /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $avtAy.default), {
                            application: cobrandingApplication || null,
                            redirectType: !isLoginSecondStep ? redirectType : null,
                            isRedirecting: redirectType !== null,
                            isSecondStep: isLoginSecondStep,
                            isPasswordlessAllowed: isPasswordlessAllowed,
                            isLoading: isLoading,
                            isCheckUsernameLoading: isCheckUsernameLoading,
                            onContinue: handleContinue,
                            onLogIn: handleLogIn,
                            onPasswordlessLogIn: handlePasswordlessLogIn,
                            error: loginError,
                            info: infoCode,
                            fieldErrors: {
                                email: checkUsernameError
                            },
                            email: email,
                            onValidationError: handleValidationError,
                            onEditEmail: resetLogin,
                            onFormClick: handleFormClick,
                            restrictedEmail: isRestrictedEmail,
                            pageId: (0, $5Nhr0.loginPageId),
                            onEmailChange: handleEmailChange,
                            showRememberMeCheckbox: rememberMeEnabled,
                            rememberMeChecked: isRememberMeChecked,
                            onToggleRememberMeCheckbox: onToggleRememberMeCheckbox
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $97yOV.default), {
                            onPasskeyLogin: handlePasskeyLogin,
                            authenticating: authenticating
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $kyxFY.default), {
                            isEmbedded: isEmbedded,
                            envSupportsSocialLogin: envSupportsSocialLogin,
                            isSocialBlocked: isSocialBlocked,
                            onSlackLogin: handleSlackLogin,
                            onAppleLogin: handleAppleLogin,
                            onMicrosoftLogin: handleMicrosoftLogin,
                            onGoogleLogin: handleGoogleSocialLogin
                        })
                    ]
                })
            })
        ]
    });
};
function $4f10db27a3b37ac0$var$LoginRoute() {
    // TODO: KIRBY-8427: tidy up this double check.
    const { shouldShowRememberedAccounts: shouldShowRememberedAccounts } = (0, $4nIlz.useLogin)();
    if (shouldShowRememberedAccounts) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $dpD1g.default), {});
    return /*#__PURE__*/ (0, $6rcps.jsx)($4f10db27a3b37ac0$var$LoginPage, {});
}
var $4f10db27a3b37ac0$export$2e2bcd8739ae039 = $4f10db27a3b37ac0$var$LoginRoute;

});
parcelRegister("fouZP", function(module, exports) {

$parcel$export(module.exports, "requestCheckUsername", function () { return $6b5dc6f422f54109$export$46a04796807ec7cb; });
$parcel$export(module.exports, "requestCheckUsernameV2", function () { return $6b5dc6f422f54109$export$100ac3ffc8db9b3e; });
$parcel$export(module.exports, "checkUsernameCaptchaFailure", function () { return $6b5dc6f422f54109$export$c48d28459d63299c; });
$parcel$export(module.exports, "resetLoginForm", function () { return $6b5dc6f422f54109$export$6a45e1ba06bcfd40; });
$parcel$export(module.exports, "resetRememberMeState", function () { return $6b5dc6f422f54109$export$f89c906644f34324; });
$parcel$export(module.exports, "showFormErrors", function () { return $6b5dc6f422f54109$export$f89084e6f067bb43; });
$parcel$export(module.exports, "setRememberMeCheckbox", function () { return $6b5dc6f422f54109$export$8eb90c84b47e7339; });
$parcel$export(module.exports, "toggleRememberMeCheckbox", function () { return $6b5dc6f422f54109$export$64749aae889ad7b0; });
$parcel$export(module.exports, "loginSetState", function () { return $6b5dc6f422f54109$export$10cc404412d31053; });
$parcel$export(module.exports, "checkUsername", function () { return $6b5dc6f422f54109$export$4929d86c6e4e281e; });
$parcel$export(module.exports, "checkUsernameV2", function () { return $6b5dc6f422f54109$export$67b7193bb8e24ea6; });
$parcel$export(module.exports, "loginUsernamePassword", function () { return $6b5dc6f422f54109$export$5391cc01902916c6; });
$parcel$export(module.exports, "loginPasswordless", function () { return $6b5dc6f422f54109$export$a6eaf375001ea98a; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");

var $8rEue = parcelRequire("8rEue");

var $jFLig = parcelRequire("jFLig");

var $8f2pb = parcelRequire("8f2pb");

var $8dHAc = parcelRequire("8dHAc");

var $bjLjm = parcelRequire("bjLjm");

var $5Nhr0 = parcelRequire("5Nhr0");

var $lpGhN = parcelRequire("lpGhN");

var $imnta = parcelRequire("imnta");

var $jSO9M = parcelRequire("jSO9M");

var $aiuZa = parcelRequire("aiuZa");
const $6b5dc6f422f54109$export$9cdc46fdb2ee9975 = (response)=>response.ok ? response : response.text().then((error)=>{
        throw new Error(error || response.statusText);
    });
const $6b5dc6f422f54109$export$46a04796807ec7cb = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME'
    });
const $6b5dc6f422f54109$export$100ac3ffc8db9b3e = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_V2'
    });
const $6b5dc6f422f54109$export$34d1ed284038d066 = (accounts)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_V2_SUCCEEDED',
        accounts: accounts
    });
const $6b5dc6f422f54109$export$2edff4284d04f803 = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_REDIRECT',
        redirectUrl: userAction.redirect_uri,
        redirectType: userAction.redirect_type
    });
const $6b5dc6f422f54109$export$5cc9c4683c14face = ()=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SIGNUP'
    });
const $6b5dc6f422f54109$export$c7d021a470828fad = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION',
        passwordless: userAction.passwordless || (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
        social: userAction.social || 'allowed'
    });
const $6b5dc6f422f54109$export$a7eb3c2b6fb70d6e = (userAction)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN',
        passwordless: userAction.passwordless || (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
        identities: userAction.identities
    });
const $6b5dc6f422f54109$var$requestCheckUsernameSucceeded = (userAction, analyticsClient)=>(dispatch)=>{
        switch(userAction.action){
            case 'redirect':
                dispatch($6b5dc6f422f54109$export$2edff4284d04f803(userAction));
                break;
            case 'signup':
                dispatch($6b5dc6f422f54109$export$5cc9c4683c14face());
                break;
            case 'no_action':
                dispatch($6b5dc6f422f54109$export$c7d021a470828fad(userAction));
                break;
            case 'social_login':
                if (!userAction.identities || userAction.identities.password === undefined) // this event is needed for growth team's experiment slo
                // we want to silently fire this event and not show any error
                // this will just not enrol user in the experiment
                analyticsClient.operationalEvent({
                    page: (0, $5Nhr0.loginPageId),
                    action: 'loadSocialLoginPage',
                    subject: 'sli',
                    attributes: {
                        hasError: true,
                        errorName: 'identities not as expected'
                    }
                });
                dispatch($6b5dc6f422f54109$export$a7eb3c2b6fb70d6e(userAction));
                break;
        }
        return Promise.resolve();
    };
const $6b5dc6f422f54109$export$c48d28459d63299c = (isOnline)=>$6b5dc6f422f54109$export$c445752097d9b598({
        code: isOnline ? 'captcha' : 'request_error'
    });
const $6b5dc6f422f54109$export$9cd96a2b004cc2f1 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_FAILED',
        error: error
    });
const $6b5dc6f422f54109$export$c445752097d9b598 = (error)=>({
        type: 'LOGIN_REQUEST_CHECK_USERNAME_ERROR',
        error: error
    });
const $6b5dc6f422f54109$export$6a45e1ba06bcfd40 = ()=>({
        type: 'LOGIN_RESET'
    });
const $6b5dc6f422f54109$export$f89c906644f34324 = ()=>({
        type: 'RESET_REMEMBER_ME_STATE'
    });
const $6b5dc6f422f54109$export$8a7c7d5c19ae03dc = ()=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN'
    });
const $6b5dc6f422f54109$export$e35197b32bd33011 = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN'
    });
const $6b5dc6f422f54109$export$2195b30ff9688f1f = ()=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS'
    });
const $6b5dc6f422f54109$export$9fbe8d742e3cfe1f = (error)=>({
        type: 'LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED',
        error: error
    });
const $6b5dc6f422f54109$export$8d0d1628cde4bf96 = (redirectUrl = '')=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS',
        redirectUrl: redirectUrl
    });
const $6b5dc6f422f54109$export$72f5cc903fa26407 = (error)=>({
        type: 'LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED',
        error: error
    });
const $6b5dc6f422f54109$export$7598c3f25ced4803 = (redirectUrl)=>({
        type: 'LOGIN_REDIRECT_USER',
        redirectUrl: redirectUrl
    });
const $6b5dc6f422f54109$export$84085369fb3df1bc = (nextAttempt)=>({
        type: 'UPDATE_LOGIN_ATTEMPT_DETAILS',
        nextAttempt: nextAttempt
    });
const $6b5dc6f422f54109$export$3e87c66a234f33b9 = (isCaptchaRequired)=>({
        type: 'LOGIN_UPDATE_CAPTCHA_REQUIREMENT',
        isCaptchaRequired: isCaptchaRequired
    });
const $6b5dc6f422f54109$export$f89084e6f067bb43 = (errors)=>({
        type: 'LOGIN_SHOW_LOGIN_FORM_ERRORS',
        errors: errors
    });
const $6b5dc6f422f54109$export$8eb90c84b47e7339 = (checked)=>({
        type: 'REMEMBER_ME_CHECKBOX_UPDATE',
        payload: {
            enabled: checked
        }
    });
const $6b5dc6f422f54109$export$64749aae889ad7b0 = ()=>({
        type: 'REMEMBER_ME_CHECKBOX_TOGGLE'
    });
const $6b5dc6f422f54109$export$10cc404412d31053 = (state)=>({
        type: 'LOGIN_SET_STATE',
        state: state
    });
const $6b5dc6f422f54109$var$usernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($6b5dc6f422f54109$export$46a04796807ec7cb());
        let response;
        try {
            response = await fetch(`/rest/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $jSO9M.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $5Nhr0.loginPageId),
                action: 'checkUsernameFailure',
                subject: 'sli'
            });
            dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        let analyticsAction;
        if (response.ok) try {
            dispatch($6b5dc6f422f54109$var$requestCheckUsernameSucceeded(await response.json(), analyticsClient));
            analyticsAction = 'checkUsernameSuccessful';
        } catch (parseError) {
            dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                code: 'unknown'
            }));
            analyticsAction = 'checkUsernameFailure';
            (0, $8f2pb.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username response OK but failed to parse it'
                }
            });
        }
        else {
            analyticsAction = 'checkUsernameFailure';
            let responseErrorText = null;
            try {
                if (response.status === 429) dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                    code: 'too_many_username_requests'
                }));
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    if (uiErrors && uiErrors.length) dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                        code: uiErrors[0].key || 'unknown'
                    }));
                } else {
                    responseErrorText = await response.text() || response.statusText;
                    const extractedError = JSON.parse(responseErrorText).formErrors[0];
                    dispatch($6b5dc6f422f54109$export$9cd96a2b004cc2f1(extractedError));
                }
            } catch (parseError) {
                (0, $8f2pb.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: 'Failed to handle non-OK response from check-username',
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
                dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                    code: 'unknown'
                }));
            }
        }
        analyticsClient.operationalEvent({
            page: (0, $5Nhr0.loginPageId),
            action: analyticsAction,
            subject: 'sli'
        });
    };
const $6b5dc6f422f54109$var$v2UsernameCheck = ({ username: username, csrfToken: csrfToken, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>async (dispatch)=>{
        dispatch($6b5dc6f422f54109$export$100ac3ffc8db9b3e());
        let response;
        try {
            response = await fetch(`/rest/v2/check-username${params}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken
                },
                body: JSON.stringify({
                    username: username,
                    recoveryToken: recoveryToken,
                    'challenge-response': (0, $jSO9M.toChallengeRequest)(challengeResponse)
                })
            });
        } catch (networkError) {
            analyticsClient.operationalEvent({
                page: (0, $5Nhr0.loginPageId),
                action: 'checkUsernameV2Failure',
                subject: 'sli'
            });
            dispatch($6b5dc6f422f54109$export$c445752097d9b598({
                code: 'request_error'
            }));
            return;
        }
        // TODO: add analytics https://hello.jira.atlassian.cloud/browse/IDOASIS-131
        // let analyticsAction: 'checkV2UsernameSuccessful' | 'checkV2UsernameFailure';
        if (response.ok) try {
            const accounts = await response.json();
            dispatch($6b5dc6f422f54109$export$34d1ed284038d066(accounts));
        // analyticsAction = 'checkV2UsernameSuccessful';
        } catch (parseError) {
            // TODO: add error handling https://hello.jira.atlassian.cloud/browse/IDOASIS-289
            // dispatch(requestCheckUsernameV2Error({ code: 'unknown' }));
            // analyticsAction = 'checkV2UsernameFailure';
            (0, $8f2pb.captureTaggedException)(parseError, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Check-username V2 response OK but failed to parse it'
                }
            });
        }
        else {
            // analyticsAction = 'checkUsernameV2Failure';
            let responseErrorText = null;
            try {
                if (response.status === 429) ;
                else if (response.status === 400) {
                    const { uiErrors: uiErrors } = await response.json();
                    uiErrors && uiErrors.length;
                } else responseErrorText = await response.text() || response.statusText;
            } catch (parseError) {
                (0, $8f2pb.captureTaggedException)(parseError, {
                    capabilities: [
                        'capability-group--login',
                        'capability-subgroup--username-password-login',
                        'capability-name--login-with-username-password'
                    ],
                    extraProperties: {
                        description: 'Failed to handle non-OK response from check-username V2',
                        responseStatus: response.status,
                        responseErrorText: responseErrorText
                    }
                });
            }
        }
    // analyticsClient.operationalEvent({
    //   page: loginPageId,
    //   action: analyticsAction,
    //   subject: 'sli',
    // });
    };
const $6b5dc6f422f54109$export$4929d86c6e4e281e = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $5Nhr0.loginPageId),
            action: 'checkUsernameStart',
            subject: 'sli'
        });
        return dispatch($6b5dc6f422f54109$var$usernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
const $6b5dc6f422f54109$export$67b7193bb8e24ea6 = ({ username: username, params: params, analyticsClient: analyticsClient, recoveryToken: recoveryToken, challengeResponse: challengeResponse })=>(dispatch, getState)=>{
        analyticsClient.operationalEvent({
            page: (0, $aiuZa.StatelessLoginPageId),
            action: 'checkUsernameV2Start',
            subject: 'sli'
        });
        return dispatch($6b5dc6f422f54109$var$v2UsernameCheck({
            username: username,
            csrfToken: getState().csrfToken,
            params: params,
            analyticsClient: analyticsClient,
            recoveryToken: recoveryToken,
            challengeResponse: challengeResponse
        }));
    };
function $6b5dc6f422f54109$var$reportFrontendError(error) {
    function removeField(obj, fieldName) {
        for(const prop in obj){
            if (prop === fieldName) delete obj[prop];
            else if (typeof obj[prop] === 'object') removeField(obj[prop], fieldName);
        }
    }
    function decodeJsonField(obj, path) {
        const val = (0, (/*@__PURE__*/$parcel$interopDefault($jFLig)))(obj, path);
        if (val !== 'undefined') try {
            (0, (/*@__PURE__*/$parcel$interopDefault($8rEue)))(obj, path, JSON.parse(val));
        } catch (_) {}
    }
    removeField(error, 'password');
    decodeJsonField(error, 'original.response.text');
    const errorCode = error['error'];
    (0, $8f2pb.captureTaggedException)(error, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--username-password-login',
            'capability-name--login-with-username-password'
        ],
        extraProperties: {
            description: (error === null || error === void 0 ? void 0 : error.error_description) || 'Failed to login for an unexpected reason',
            code: errorCode
        }
    });
}
function $6b5dc6f422f54109$var$parseAdditionalData(err) {
    try {
        return JSON.parse(atob(err.error_description));
    } catch (e) {
        return {};
    }
}
function $6b5dc6f422f54109$var$handleLoginError(err, username, application, dispatch, getState, onLoginError) {
    const additionalData = $6b5dc6f422f54109$var$parseAdditionalData(err);
    const code = (additionalData['custom_error'] || err['error'] || '').toLowerCase();
    const isBitbucket = application && application.toLowerCase() === 'bitbucket';
    if (code === 'too_many_attempts' || code === 'invalid_captcha') {
        dispatch($6b5dc6f422f54109$export$3e87c66a234f33b9(true));
        dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
            code: 'captcha'
        }));
    } else if (code === 'access_denied') {
        dispatch($6b5dc6f422f54109$export$84085369fb3df1bc(getState().login.nextAttempt + 1));
        dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
            code: 'invalid_user_password'
        }));
    } else if (code === 'ambiguous_user') dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'ambiguous_user'
    }));
    else if (code === 'no_email_on_remote_user') dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'no_email_on_remote_user',
        args: {
            username: username
        }
    }));
    else if (code === 'username_is_not_email') {
        const errorCode = isBitbucket ? 'bitbucket_username_is_not_email' : 'username_is_not_email';
        dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'email_is_not_primary') {
        const errorCode = isBitbucket ? 'bitbucket_email_is_not_primary' : 'email_is_not_primary';
        dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
            code: errorCode,
            args: {
                username: additionalData['email']
            }
        }));
    } else if (code === 'too_many_logins') dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'too_many_logins'
    }));
    else if (code === 'password_leaked') dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'password_leaked'
    }));
    else if (code === 'blocked_user') {
        const redirectURL = application ? `/login/inactive?application=${application}` : '/login/inactive';
        dispatch($6b5dc6f422f54109$export$7598c3f25ced4803(redirectURL));
    } else if (code === 'request_error') // 'request_error' auth0-js: connection fails due to offline or cross domain issue
    dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'request_error'
    }));
    else if (code === 'invalid.session.token') dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
        code: 'invalid.session.token'
    }));
    else {
        $6b5dc6f422f54109$var$reportFrontendError(err);
        dispatch($6b5dc6f422f54109$export$72f5cc903fa26407({
            code: 'unknown'
        }));
    }
    if (code !== 'too_many_attempts' && code !== 'invalid_captcha') dispatch($6b5dc6f422f54109$export$3e87c66a234f33b9(false));
    onLoginError(code);
}
function $6b5dc6f422f54109$var$verifyCaptchaIfRequired(captchaValue, username) {
    if (!captchaValue) return Promise.resolve();
    return fetch('/rest/captcha/verify', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            'g-recaptcha-response': captchaValue,
            email: username
        })
    }).then($6b5dc6f422f54109$export$9cdc46fdb2ee9975).catch(()=>{
        const error = new Error('invalid_captcha');
        return Promise.reject(error);
    });
}
const $6b5dc6f422f54109$export$beb986ec1c64324 = (csrfToken, config, marketingConsentState, anonymousId, userFlow)=>{
    let state = {
        csrfToken: csrfToken,
        anonymousId: anonymousId,
        userFlow: userFlow
    };
    const marketingConsent = (0, $bjLjm.buildMarketingConsent)(config, marketingConsentState);
    if (marketingConsent) state = (0, $6EnDC._)((0, $ty6PY._)({}, state), {
        marketingConsent: marketingConsent
    });
    return state;
};
const $6b5dc6f422f54109$export$5391cc01902916c6 = (loginParams, navigate)=>(dispatch, getState)=>{
        const { location: location, username: username, password: password, captchaValue: captchaValue, onLoginError: onLoginError, anonymousId: anonymousId } = loginParams;
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
        const { application: application, userFlow: userFlow } = params;
        const state = getState();
        const { isRememberMeChecked: isRememberMeChecked } = state.login;
        const { csrfToken: csrfToken, marketingConsent: marketingConsent } = state;
        dispatch($6b5dc6f422f54109$export$8a7c7d5c19ae03dc());
        const loginState = $6b5dc6f422f54109$export$beb986ec1c64324(csrfToken, marketingConsent.config, loginParams.marketingConsent, anonymousId, userFlow);
        // This passes the `remember` flag to the backend, "remembering" the account that we're logging into.
        if (isRememberMeChecked) params.remember = 'true';
        const query = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(params);
        const loginWithAtlassianAuth = (navigate)=>(0, $lpGhN.login)({
                username: username,
                password: password,
                state: loginState,
                query: `?${query}${location.hash}`
            }).then((result)=>{
                switch(result.kind){
                    case 'failure':
                        {
                            const err = {
                                error: result.reason
                            };
                            return $6b5dc6f422f54109$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
                        }
                    case 'success':
                        return navigate(result.redirectUri);
                }
            });
        return $6b5dc6f422f54109$var$verifyCaptchaIfRequired(captchaValue, username).then(()=>loginWithAtlassianAuth(navigate)).catch((err)=>{
            (0, $8f2pb.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--username-password-login',
                    'capability-name--login-with-username-password'
                ],
                extraProperties: {
                    description: 'Failed to login'
                }
            });
            $6b5dc6f422f54109$var$handleLoginError(err, username, application, dispatch, getState, onLoginError);
        });
    };
const $6b5dc6f422f54109$export$a6eaf375001ea98a = ({ email: email, captchaValue: captchaValue, location: location })=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, login: { isRememberMeChecked: isRememberMeChecked } } = getState();
        dispatch($6b5dc6f422f54109$export$e35197b32bd33011());
        const urlParams = new URLSearchParams(location.search);
        if (isRememberMeChecked) urlParams.set('remember', 'true');
        const apiParams = urlParams.toString();
        try {
            const response = await fetch(`/rest/login/passwordless?${apiParams}`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    captchaValue: captchaValue
                })
            });
            const { csrfToken: newCsrfToken } = await response.json();
            if (newCsrfToken) dispatch((0, $imnta.updateCsrfToken)(newCsrfToken));
            if (response.ok) {
                dispatch($6b5dc6f422f54109$export$2195b30ff9688f1f());
                return {
                    success: true
                };
            } else {
                dispatch($6b5dc6f422f54109$export$9fbe8d742e3cfe1f({
                    code: 'unknown'
                }));
                return {
                    success: false
                };
            }
        } catch (error) {
            (0, $8f2pb.captureTaggedException)(error, {
                capabilities: [
                    'capability-group--login',
                    'capability-subgroup--passwordless-login',
                    'capability-name--passwordless-login'
                ],
                extraProperties: {
                    description: 'Failed passwordless login'
                }
            });
            dispatch($6b5dc6f422f54109$export$9fbe8d742e3cfe1f({
                code: 'request_error'
            }));
            return {
                success: false
            };
        }
    };

});
parcelRegister("jFLig", function(module, exports) {

var $bQSGY = parcelRequire("bQSGY");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $e526882a51f46611$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $bQSGY(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $e526882a51f46611$var$get;

});
parcelRegister("bQSGY", function(module, exports) {

var $4AEPk = parcelRequire("4AEPk");

var $9AU0a = parcelRequire("9AU0a");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $8a0ef9bcc06b90fd$var$baseGet(object, path) {
    path = $4AEPk(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$9AU0a(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $8a0ef9bcc06b90fd$var$baseGet;

});


parcelRegister("bjLjm", function(module, exports) {

$parcel$export(module.exports, "IMPLICIT_CONSENT_TEXT", function () { return $aa966e0ce495532b$export$a18e359a3f598d3b; });
$parcel$export(module.exports, "buildMarketingConsent", function () { return $aa966e0ce495532b$export$689cf67bd4c05bd3; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");
const $aa966e0ce495532b$export$a18e359a3f598d3b = 'general consent captured';
const $aa966e0ce495532b$export$689cf67bd4c05bd3 = (config, checkboxState, privacyPolicyText)=>{
    let marketingConsent = null;
    if (config && config.locale) {
        const hasConsent = checkboxState.state !== 'not_shown' || config.implicitConsent;
        if (hasConsent) {
            const consent = checkboxState.state === 'checked' || config.implicitConsent;
            // @ts-ignore
            const marketingConsentText = checkboxState.consentText || $aa966e0ce495532b$export$a18e359a3f598d3b;
            marketingConsent = {
                consent: consent,
                locale: config.locale,
                marketingConsentText: marketingConsentText
            };
            if (privacyPolicyText) marketingConsent = (0, $6EnDC._)((0, $ty6PY._)({}, marketingConsent), {
                privacyPolicyText: privacyPolicyText
            });
        }
    }
    return marketingConsent;
};
const $aa966e0ce495532b$var$FORCE_SHOW_MARKETING_CONSENT_PARAM = 'showMarketingConsent';
const $aa966e0ce495532b$export$44896947615de4a4 = (location)=>{
    const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
    return $aa966e0ce495532b$var$FORCE_SHOW_MARKETING_CONSENT_PARAM in params;
};

});

parcelRegister("5Nhr0", function(module, exports) {

$parcel$export(module.exports, "loginPageId", function () { return $f7f41aae139f496f$export$bb0bd0af2c24d0c1; });
const $f7f41aae139f496f$export$bb0bd0af2c24d0c1 = 'loginScreen';

});

parcelRegister("lpGhN", function(module, exports) {

$parcel$export(module.exports, "login", function () { return $ade599c5d26969e0$export$596d806903d1f59e; });

var $jSnDV = parcelRequire("jSnDV");

var $lk8Tl = parcelRequire("lk8Tl");
var $ade599c5d26969e0$export$db7ad81c1149bb91 = /*#__PURE__*/ function(LoginFailureReason) {
    LoginFailureReason["AccessDenied"] = "access_denied";
    LoginFailureReason["PasswordLeaked"] = "password_leaked";
    LoginFailureReason["BlockedUser"] = "blocked_user";
    LoginFailureReason["TooManyAttempts"] = "too_many_attempts";
    LoginFailureReason["TooManyLogins"] = "too_many_logins";
    return LoginFailureReason;
}({});
var $ade599c5d26969e0$export$5e64a9683d127ef6 = /*#__PURE__*/ function(LoginError) {
    LoginError["PreconditionFailed"] = "precondition_failed";
    LoginError["UnexpectedError"] = "unexpected_error";
    return LoginError;
}({});
function $ade599c5d26969e0$var$failure(reason) {
    return {
        kind: 'failure',
        reason: reason
    };
}
function $ade599c5d26969e0$var$success(redirectUri) {
    return {
        kind: 'success',
        redirectUri: redirectUri
    };
}

async function $ade599c5d26969e0$export$596d806903d1f59e({ state: state, username: username, password: password, query: query }) {
    const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
    const token = isCommercial ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
    return fetch(`/rest/authenticate${query}`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            username: username,
            password: password,
            state: state,
            token: token
        })
    }).then((response)=>{
        switch(response.status){
            case 200:
                return response.json().then((r)=>$ade599c5d26969e0$var$success(r.redirectUri));
            case 403:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'access_denied':
                            return $ade599c5d26969e0$var$failure("access_denied");
                        case 'blocked_user':
                            return $ade599c5d26969e0$var$failure("blocked_user");
                        case 'password_leaked':
                            return $ade599c5d26969e0$var$failure("password_leaked");
                        case 'too_many_attempts':
                            return $ade599c5d26969e0$var$failure("too_many_attempts");
                        default:
                            return Promise.reject(new Error("unexpected_error"));
                    }
                });
            case 429:
                return response.json().then((r)=>r.error === 'too_many_logins' ? $ade599c5d26969e0$var$failure("too_many_logins") : Promise.reject(new Error("unexpected_error")));
            case 412:
                return response.json().then((r)=>{
                    switch(r.error){
                        case 'mfa_required':
                            {
                                const currentQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
                                currentQueryParams.transactionToken = r.token;
                                const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(currentQueryParams);
                                return $ade599c5d26969e0$var$success(`/login/mfa?${currentQueryString}`);
                            }
                        default:
                            return Promise.reject(new Error("precondition_failed"));
                    }
                });
            default:
                return Promise.reject(new Error("unexpected_error", {
                    cause: {
                        description: 'Unexpected response status',
                        response: response
                    }
                }));
        }
    });
}

});

parcelRegister("jSO9M", function(module, exports) {

$parcel$export(module.exports, "toChallengeRequest", function () { return $e3ef8ddbb77a671d$export$79b8871c3ed7cc2a; });
function $e3ef8ddbb77a671d$export$79b8871c3ed7cc2a(response) {
    if (!response) return null;
    return {
        'challenge-kind': response.challengeKind,
        token: {
            value: response.token
        },
        type: response.type
    };
}

});

parcelRegister("aiuZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "StatelessLoginPageId", function () { return $245216afe76ecfbf$export$3238684376aef113; });
$parcel$export(module.exports, "default", function () { return $245216afe76ecfbf$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $iSD9t = parcelRequire("iSD9t");

var $fouZP = parcelRequire("fouZP");

var $kOqgB = parcelRequire("kOqgB");

var $h6fsn = parcelRequire("h6fsn");

var $7NASj = parcelRequire("7NASj");

var $7CMue = parcelRequire("7CMue");

var $40CJF = parcelRequire("40CJF");

var $9Codz = parcelRequire("9Codz");

var $oXIXy = parcelRequire("oXIXy");

var $1yJSg = parcelRequire("1yJSg");

var $kyxFY = parcelRequire("kyxFY");

var $hQdhs = parcelRequire("hQdhs");

var $5Nhr0 = parcelRequire("5Nhr0");

var $hm82Q = parcelRequire("hm82Q");

var $4nIlz = parcelRequire("4nIlz");

var $7zDhH = parcelRequire("7zDhH");

var $galVA = parcelRequire("galVA");

var $hPjb0 = parcelRequire("hPjb0");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");
const $245216afe76ecfbf$export$3238684376aef113 = (0, $5Nhr0.loginPageId) + '_isolated_cloud';
const $245216afe76ecfbf$var$LoginPage = ()=>{
    const { state: state } = (0, $9Codz.useLoginState)();
    const { oidcContext: oidcContext } = state || {};
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const isNewV2CheckUsernameFlowEnabled = (0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).ENABLE_NEW_V2_CHECK_USERNAME_IC_FLOW);
    const { isPasswordlessAllowed: isPasswordlessAllowed, checkUsernameError: checkUsernameError, error: loginError, redirectType: redirectType, isRestrictedEmail: isRestrictedEmail, resetLogin: resetLogin, infoCode: infoCode, rememberMeEnabled: rememberMeEnabled, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox, isUsernameChecked: isUsernameChecked, isCheckUsernameLoading: isCheckUsernameLoading, checkUsername: checkUsername, v2Accounts: v2Accounts } = (0, $4nIlz.useLogin)({
        useV2CheckUsernameFlow: isNewV2CheckUsernameFlowEnabled
    });
    const { isLoading: isLoading, onLogin: handleLogIn, onPasswordlessLogin: handlePasswordlessLogIn } = (0, $7zDhH.useLoginSubmission)();
    const { onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin, onMicrosoftLogin: onMicrosoftLogin, onGoogleSocialLogin: onGoogleSocialLogin, onDismissGoogleOneTap: onDismissGoogleOneTap, socialLoginEligibility: socialLoginEligibility, envSupportsSocialLogin: envSupportsSocialLogin, isSocialBlocked: isSocialBlocked } = (0, $galVA.useSocialLogin)();
    const { isMobileApp: isMobileApp, isEmbedded: isEmbedded, screenSize: screenSize } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const isLoginSecondStep = isUsernameChecked;
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const emailFromSearchParams = (0, $hm82Q.useEmailFromSearchParams)();
    const [email, setEmail] = (0, $8ZuGG.useState)(()=>emailFromSearchParams || '');
    // Sync state with query params
    // In the case when the query params change after the component is first rendered
    (0, $8ZuGG.useEffect)(()=>{
        if (emailFromSearchParams) setEmail(emailFromSearchParams);
    }, [
        emailFromSearchParams
    ]);
    (0, $hPjb0.useGoogleOneTap)({
        email: email
    });
    const { highlightedSocialProvider: highlightedSocialProvider = null, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly = null } = socialLoginEligibility || {};
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && envSupportsSocialLogin;
    const handleGoogleSocialLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onGoogleSocialLogin(email);
    }, [
        email,
        onGoogleSocialLogin,
        envSupportsSocialLogin
    ]);
    const handleMicrosoftLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onMicrosoftLogin(email);
    }, [
        email,
        onMicrosoftLogin,
        envSupportsSocialLogin
    ]);
    const handleAppleLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onAppleLogin(email);
    }, [
        email,
        onAppleLogin,
        envSupportsSocialLogin
    ]);
    const handleSlackLogin = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin) onSlackLogin(email);
    }, [
        email,
        onSlackLogin,
        envSupportsSocialLogin
    ]);
    const handleValidationError = (0, $8ZuGG.useCallback)((errors)=>dispatch((0, $fouZP.showFormErrors)(errors)), [
        dispatch
    ]);
    const handleContinue = (email)=>{
        checkUsername(email);
    };
    const handleFormClick = (0, $8ZuGG.useCallback)(()=>{
        if (envSupportsSocialLogin && screenSize === 'mobile') onDismissGoogleOneTap();
    }, [
        onDismissGoogleOneTap,
        screenSize,
        envSupportsSocialLogin
    ]);
    const handleEmailChange = (0, $8ZuGG.useCallback)((email)=>{
        setEmail(email);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $3o9o3.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("title", null, formatMessage((0, $40CJF.LoginPageMessages).headTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7CMue.default), {
        pageId: $245216afe76ecfbf$export$3238684376aef113,
        header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1yJSg.default), {
            highlightedSocialProvider: highlightedSocialProvider,
            showSocialLoginOnly: showSocialLoginOnly
        }),
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $oXIXy.default), {
            oidcContext: oidcContext,
            isEmbedded: isEmbedded
        }),
        whiteboxFooter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hQdhs.default), {
            showSocialLoginOnly: showSocialLoginOnly,
            isMobileApp: isMobileApp,
            oidcContext: oidcContext
        })
    }, showSocialLoginOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7NASj.default), {
        email: email,
        highlightedSocialProvider: highlightedSocialProvider,
        handleGoogleLogin: handleGoogleSocialLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $h6fsn.default), {
        application: 'support',
        redirectType: !isLoginSecondStep ? redirectType : null,
        isRedirecting: redirectType !== null,
        isSecondStep: isLoginSecondStep,
        isPasswordlessAllowed: isPasswordlessAllowed,
        isLoading: isLoading,
        isCheckUsernameLoading: isCheckUsernameLoading,
        onContinue: handleContinue,
        onLogIn: handleLogIn,
        onPasswordlessLogIn: handlePasswordlessLogIn,
        error: loginError,
        info: infoCode,
        fieldErrors: {
            email: checkUsernameError
        },
        email: email,
        onValidationError: handleValidationError,
        onEditEmail: resetLogin,
        onFormClick: handleFormClick,
        restrictedEmail: isRestrictedEmail,
        pageId: $245216afe76ecfbf$export$3238684376aef113,
        onEmailChange: handleEmailChange,
        showRememberMeCheckbox: rememberMeEnabled,
        rememberMeChecked: isRememberMeChecked,
        onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
        v2Accounts: v2Accounts || [],
        isNewV2CheckUsernameFlow: isNewV2CheckUsernameFlowEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kyxFY.default), {
        isEmbedded: isEmbedded,
        envSupportsSocialLogin: envSupportsSocialLogin,
        isSocialBlocked: isSocialBlocked,
        onSlackLogin: handleSlackLogin,
        onAppleLogin: handleAppleLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleLogin: handleGoogleSocialLogin
    }))));
};
var $245216afe76ecfbf$export$2e2bcd8739ae039 = $245216afe76ecfbf$var$LoginPage;

});
parcelRegister("h6fsn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6b6fba4df1b888ae$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $cufV0 = parcelRequire("cufV0");

var $9Vz68 = parcelRequire("9Vz68");

var $hPm2F = parcelRequire("hPm2F");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $8PH8E = parcelRequire("8PH8E");

var $4Rgc6 = parcelRequire("4Rgc6");

var $dilb2 = parcelRequire("dilb2");

var $1SvOA = parcelRequire("1SvOA");

var $lp6gZ = parcelRequire("lp6gZ");

var $eaMRk = parcelRequire("eaMRk");

var $l1nfA = parcelRequire("l1nfA");

var $hAzIv = parcelRequire("hAzIv");

var $8dHAc = parcelRequire("8dHAc");

var $kZj5j = parcelRequire("kZj5j");

var $3ir1n = parcelRequire("3ir1n");

var $5Nhr0 = parcelRequire("5Nhr0");

var $kR60c = parcelRequire("kR60c");

var $ciYFg = parcelRequire("ciYFg");

var $4j6Os = parcelRequire("4j6Os");

var $97pBx = parcelRequire("97pBx");

var $FXESS = parcelRequire("FXESS");

var $lThM2 = parcelRequire("lThM2");
var $ld7ev = parcelRequire("ld7ev");

var $dMtGq = parcelRequire("dMtGq");

var $kdV6G = parcelRequire("kdV6G");

var $9NVnN = parcelRequire("9NVnN");
let $6b6fba4df1b888ae$var$_ = (t)=>t, $6b6fba4df1b888ae$var$t, $6b6fba4df1b888ae$var$t1, $6b6fba4df1b888ae$var$t2;
const $6b6fba4df1b888ae$export$d55ce944e082b58f = (0, $9Vz68.default).div($6b6fba4df1b888ae$var$t || ($6b6fba4df1b888ae$var$t = $6b6fba4df1b888ae$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kTdw7).N90);
const $6b6fba4df1b888ae$export$a7fed597f4b8afd8 = (0, $9Vz68.default).form($6b6fba4df1b888ae$var$t1 || ($6b6fba4df1b888ae$var$t1 = $6b6fba4df1b888ae$var$_`
  margin: 0;
`));
const $6b6fba4df1b888ae$var$InputsWrapper = (0, $9Vz68.default).div($6b6fba4df1b888ae$var$t2 || ($6b6fba4df1b888ae$var$t2 = $6b6fba4df1b888ae$var$_`
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $6b6fba4df1b888ae$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isThirdStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $8dHAc.CheckUserNameRedirectType).Sso) return (0, $4Rgc6.FieldViewType).Restricted;
    else if (isThirdStep || isLoading || isSecondStep) return (0, $4Rgc6.FieldViewType).ReadOnlyWithEditButton;
    return (0, $4Rgc6.FieldViewType).Editable;
};
const $6b6fba4df1b888ae$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox, v2Accounts: v2Accounts, isNewV2CheckUsernameFlow: isNewV2CheckUsernameFlow })=>{
    const intl = (0, $iSD9t.default)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { formatMessage: formatMessage } = intl;
    const translatedEmailFieldError = (0, $97pBx.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const [accountEnv, setAccountEnv] = (0, $8ZuGG.useState)('');
    const [buttonClicked, setButtonClicked] = (0, $8ZuGG.useState)('submit');
    const inputRef = (0, $8ZuGG.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $8ZuGG.useState)(null);
    const [accountEnvFieldError, setAccountEnvFieldError] = (0, $8ZuGG.useState)(undefined);
    const [isThirdStep, setIsThirdStep] = (0, $8ZuGG.useState)(false);
    const onAccountEnvChange = (0, $8ZuGG.useCallback)((value)=>{
        setAccountEnv(value);
        setAccountEnvFieldError(undefined);
    }, []);
    const onEmailClick = (0, $8ZuGG.useCallback)(()=>{
        setPassword('');
        setPasswordFieldError(null);
        setAccountEnv('');
        setAccountEnvFieldError(undefined);
        setIsThirdStep(false);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $ciYFg.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === '';
        const emailInvalid = !trimmedEmail.match(/.+@.+/);
        const passwordEmpty = password === '';
        const accountEnvEmpty = accountEnv === '';
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        setButtonClicked('submit');
        analyticsClient.buttonClickedEvent(pageId, isThirdStep ? 'login' : 'continueToLogin');
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $hAzIv.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $5Nhr0.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (emailInvalid) {
            var _inputRef_current1;
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
            const emailValidationError = formatMessage((0, $hAzIv.default).emailInvalid);
            analyticsClient.errorShownEvent((0, $5Nhr0.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (isThirdStep && passwordEmpty) {
            setPasswordFieldError(formatMessage((0, $hAzIv.default).passwordEmpty));
            return;
        }
        if (isSecondStep && accountEnvEmpty) {
            setAccountEnvFieldError(formatMessage((0, $hAzIv.default).unexpectedErrorHappened));
            return;
        }
        if (!isSecondStep && !isThirdStep) onContinue(trimmedEmail);
        else if (isSecondStep && !isThirdStep && accountEnv === 'atlassian-cloud') {
            setIsThirdStep(true);
            return;
        } else if (isSecondStep && !isThirdStep && !accountEnvEmpty && accountEnv !== 'atlassian-cloud') {
            // Redirect to the selected IC environment
            const selected = v2Accounts === null || v2Accounts === void 0 ? void 0 : v2Accounts.find((acc)=>acc.action === 'ic_redirect' && acc.ic_id === accountEnv);
            if (selected && selected.action === 'ic_redirect') navigate(selected.redirect_uri);
            return;
        } else if (isThirdStep && !accountEnvEmpty && accountEnv === 'atlassian-cloud') onLogIn(trimmedEmail, password);
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked('passwordless');
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $8ZuGG.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isThirdStep) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $kZj5j.applications)[application].name : 'Product';
        const testId = 'login-info-test-id';
        if (info) switch(info.code){
            case 'migratingExistingUser':
                {
                    const summary = formatMessage((0, $hAzIv.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eaMRk.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            case 'existingUserSignupAttempt':
                {
                    const summary = formatMessage((0, $hAzIv.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eaMRk.default), {
                        id: "login-info",
                        "data-testid": testId
                    }, summary);
                }
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eaMRk.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true
                }, ' ');
        }
    };
    // if not using the new V2 check username flow, allow the user to bypass the environment selection step
    (0, $8ZuGG.useEffect)(()=>{
        if (!isNewV2CheckUsernameFlow && isSecondStep) {
            setAccountEnv('atlassian-cloud');
            setIsThirdStep(true);
        }
    }, [
        isNewV2CheckUsernameFlow,
        isSecondStep
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent('viewLoginPage');
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case 'unknown':
                return intl.formatMessage((0, $hAzIv.default).unexpectedErrorHappened);
            case 'rate_limit_exceeded_message':
                return intl.formatMessage((0, $hAzIv.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $8dHAc.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6b6fba4df1b888ae$export$d55ce944e082b58f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "login.form.opening.sso",
            defaultMessage: "Opening your single sign-on provider"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cufV0.default), null));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1SvOA.default), {
            appearance: "primary",
            id: "login-submit",
            testId: "login-submit-idf-testid",
            type: "submit",
            isFullWidth: true,
            isDisabled: isThirdStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
        }, buttonContent());
    };
    const options = (0, $8ZuGG.useMemo)(()=>{
        if (!v2Accounts || v2Accounts.length === 0) return [];
        return v2Accounts.map((account)=>{
            if (account.action === 'ic_redirect') return {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
                    id: "isolated-cloud-label",
                    defaultMessage: "{name} Isolated Cloud",
                    description: "Label for selecting the Isolated Cloud environment",
                    values: {
                        name: account.ic_display_name
                    }
                }),
                value: account.ic_id
            };
            return {
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
                    id: "atlassian-cloud-label",
                    defaultMessage: "Atlassian Cloud",
                    description: "Label for selecting the Atlassian Cloud environment"
                }),
                value: 'atlassian-cloud'
            };
        });
    }, [
        v2Accounts
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", null, error && !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lp6gZ.default), null, error === null || error === void 0 ? void 0 : error.message), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", null, " ", infoContent(), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6b6fba4df1b888ae$export$a7fed597f4b8afd8, {
        id: "form-login",
        "data-testid": "form-login",
        onSubmit: handleSubmit,
        onClick: onFormClick,
        noValidate: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6b6fba4df1b888ae$var$InputsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4Rgc6.default), {
        fieldViewType: $6b6fba4df1b888ae$var$getEmailFieldViewType(restrictedEmail, redirectType, isThirdStep, isSecondStep, isLoading),
        fieldError: emailError(),
        onChange: onEmailChange,
        value: email,
        onEmailClick: onEmailClick,
        placeholderOverride: formatMessage((0, $hAzIv.default).emailPlaceholder),
        inputRef: inputRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kdV6G.default), {
        isHidden: !isSecondStep || !isNewV2CheckUsernameFlow,
        fieldError: accountEnvFieldError,
        onSelectEnvChange: onAccountEnvChange,
        isRequired: isSecondStep && isNewV2CheckUsernameFlow,
        isInvalid: !!accountEnvFieldError,
        options: options
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dilb2.default), {
        isHidden: !isThirdStep,
        fieldError: passwordFieldError || undefined,
        onChange: handlePasswordChange,
        value: password,
        className: `field-group password-field ${isThirdStep ? 'expanded' : 'hidden'}`,
        isRequired: isThirdStep
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kR60c.LoginRecaptcha), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4j6Os.LoginMarketingConsent), null), showRememberMeCheckbox && redirectType !== (0, $8dHAc.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lThM2.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $ld7ev.default), {
        direction: "row",
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $FXESS.default), {
        testId: "remember-me-checkbox",
        isChecked: rememberMeChecked,
        onClick: onToggleRememberMeCheckbox,
        name: "remember",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), (0, $hAzIv.default).rememberMeCheckboxLabel),
        // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
        isDisabled: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dMtGq.default), {
        // TODO [KIRBY-8737]: once it is available, use prop spacing='compact'
        // https://hello.jira.atlassian.cloud/browse/KIRBY-8737
        appearance: "info",
        iconLabel: formatMessage((0, $hAzIv.default).rememberMeMoreInfoLabel),
        placement: "right",
        fallbackPlacements: [
            'bottom'
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), (0, $hAzIv.default).rememberMeTooltip))))), renderExperimentButtons(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8PH8E.default), {
        isHidden: !isThirdStep || !isPasswordlessAllowed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $l1nfA.StyledSocialLoginButton), {
        id: "passwordless-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hPm2F))), {
            label: "email"
        }),
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
            style: {
                width: 24
            }
        }),
        isFullWidth: true,
        advisoryEnabled: false,
        onClick: handlePasswordlessButtonClick,
        isLoading: buttonClicked === 'passwordless' && (!!isRedirecting || isLoading),
        isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
        id: "login.form.passwordless.button",
        defaultMessage: "Log in with email"
    })))));
};
var $6b6fba4df1b888ae$export$2e2bcd8739ae039 = $6b6fba4df1b888ae$export$1f58f750f20f344b;

});
parcelRegister("hPm2F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa84c2afbcd1492$var$_react = $cfa84c2afbcd1492$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $cfa84c2afbcd1492$var$_email = $cfa84c2afbcd1492$var$_interopRequireDefault((parcelRequire("bTzHG")));
function $cfa84c2afbcd1492$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cfa84c2afbcd1492$var$EmailIcon = (props)=>/*#__PURE__*/ $cfa84c2afbcd1492$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $cfa84c2afbcd1492$var$_email.default
    }));
$cfa84c2afbcd1492$var$EmailIcon.displayName = 'EmailIcon';
var $cfa84c2afbcd1492$var$_default = module.exports.default = $cfa84c2afbcd1492$var$EmailIcon;

});
parcelRegister("bTzHG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::19440c8dd0e3db5766add744ad314d45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a9086c5303de6d9$var$_react = $8a9086c5303de6d9$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $8a9086c5303de6d9$var$_baseNew = $8a9086c5303de6d9$var$_interopRequireDefault((parcelRequire("d9We0")));
function $8a9086c5303de6d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a9086c5303de6d9$var$EmailIcon = (props)=>/*#__PURE__*/ $8a9086c5303de6d9$var$_react.default.createElement($8a9086c5303de6d9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v.529L8 8.128l6.5-3.6V4a.5.5 0 0 0-.5-.5zm12.5 2.743L8.363 9.641a.75.75 0 0 1-.726 0L1.5 6.243V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$8a9086c5303de6d9$var$EmailIcon.displayName = 'EmailIcon';
var $8a9086c5303de6d9$var$_default = module.exports.default = $8a9086c5303de6d9$var$EmailIcon;

});


parcelRegister("4Rgc6", function(module, exports) {

$parcel$export(module.exports, "FieldViewType", function () { return $baf62fc29196932d$export$63009c89ca139043; });
$parcel$export(module.exports, "default", function () { return $baf62fc29196932d$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $dZRKj = parcelRequire("dZRKj");

var $8PH8E = parcelRequire("8PH8E");

var $4C0Hc = parcelRequire("4C0Hc");

var $iSD9t = parcelRequire("iSD9t");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");

var $1fdMd = parcelRequire("1fdMd");

var $h9Tv5 = parcelRequire("h9Tv5");
let $baf62fc29196932d$var$_ = (t)=>t, $baf62fc29196932d$var$t;
const $baf62fc29196932d$var$IconButtonWrapper = (0, $9Vz68.default).div($baf62fc29196932d$var$t || ($baf62fc29196932d$var$t = $baf62fc29196932d$var$_`
  padding: 3px;
  margin-left: -1px;
`));
var $baf62fc29196932d$export$63009c89ca139043 = /*#__PURE__*/ function(FieldViewType) {
    FieldViewType["Editable"] = "editable";
    FieldViewType["ReadOnlyWithEditButton"] = "read-only-with-edit-button";
    FieldViewType["Restricted"] = "restricted";
    return FieldViewType;
}({});
const $baf62fc29196932d$var$EmailContainer = ({ fieldError: fieldError, fieldViewType: fieldViewType, onChange: onChange, onEmailClick: onEmailClick, placeholderOverride: placeholderOverride, value: value, inputRef: inputRef })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const isEditable = fieldViewType === "editable";
    const prevIsReadOnly = (0, $7AZRg.usePrevious)(!isEditable);
    (0, $8ZuGG.useEffect)(()=>{
        var _inputRef_current;
        if (isEditable && prevIsReadOnly) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isEditable,
        prevIsReadOnly,
        inputRef
    ]);
    const handleChange = (e)=>{
        const newValue = e.currentTarget.value;
        onChange(newValue);
    };
    const placeholder = placeholderOverride || formatMessage((0, $4C0Hc.default).loginFormUsernamePlaceholder);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
            testId: "username" // used in pollinators
            ,
            name: "username",
            autoComplete: "username",
            type: "email",
            placeholder: placeholder,
            label: formatMessage((0, $4C0Hc.default).loginFormUsernameLabel),
            autoFocus: isEditable,
            onChange: handleChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldError,
            value: value,
            ref: inputRef,
            isRequired: true,
            isDisabled: !isEditable,
            elemAfterInput: fieldViewType === "read-only-with-edit-button" && /*#__PURE__*/ (0, $6rcps.jsx)($baf62fc29196932d$var$IconButtonWrapper, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1fdMd.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($h9Tv5))),
                    label: formatMessage((0, $4C0Hc.default).loginFormReadOnlyUsernameAriaLabel),
                    onClick: onEmailClick,
                    appearance: "subtle"
                })
            })
        })
    });
};
var $baf62fc29196932d$export$2e2bcd8739ae039 = $baf62fc29196932d$var$EmailContainer;

});
parcelRegister("h9Tv5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7de542c3251d413$var$_react = $c7de542c3251d413$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $c7de542c3251d413$var$_edit = $c7de542c3251d413$var$_interopRequireDefault((parcelRequire("6DcPU")));
function $c7de542c3251d413$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c7de542c3251d413$var$EditIcon = (props)=>/*#__PURE__*/ $c7de542c3251d413$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $c7de542c3251d413$var$_edit.default
    }));
$c7de542c3251d413$var$EditIcon.displayName = 'EditIcon';
var $c7de542c3251d413$var$_default = module.exports.default = $c7de542c3251d413$var$EditIcon;

});
parcelRegister("6DcPU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4d40579fa0a134a3$var$_react = $4d40579fa0a134a3$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $4d40579fa0a134a3$var$_baseNew = $4d40579fa0a134a3$var$_interopRequireDefault((parcelRequire("d9We0")));
function $4d40579fa0a134a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4d40579fa0a134a3$var$EditIcon = (props)=>/*#__PURE__*/ $4d40579fa0a134a3$var$_react.default.createElement($4d40579fa0a134a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$4d40579fa0a134a3$var$EditIcon.displayName = 'EditIcon';
var $4d40579fa0a134a3$var$_default = module.exports.default = $4d40579fa0a134a3$var$EditIcon;

});



parcelRegister("dilb2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a68b13f5cc44ee9a$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $8PH8E = parcelRequire("8PH8E");

var $4JKmU = parcelRequire("4JKmU");

var $hlQLf = parcelRequire("hlQLf");

var $iSD9t = parcelRequire("iSD9t");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
const $a68b13f5cc44ee9a$var$PasswordContainer = ({ className: className, fieldError: fieldError, isHidden: isHidden, onChange: onChange, value: value, isRequired: isRequired = false })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const inputRef = (0, $8ZuGG.useRef)(null);
    const wasHidden = (0, $7AZRg.usePrevious)(isHidden);
    (0, $8ZuGG.useEffect)(()=>{
        var _inputRef_current;
        if (!isHidden && wasHidden) (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, [
        isHidden,
        wasHidden
    ]);
    const fieldErrorNode = fieldError && /*#__PURE__*/ (0, $6rcps.jsx)("span", {
        id: "password-error",
        "data-testid": "password-error-idf-testid" // used in pollinators
        ,
        children: fieldError
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
        isHidden: isHidden,
        className: className,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $4JKmU.default), {
            id: "password",
            testId: "password" // used in pollinators
            ,
            name: "password",
            autoComplete: "current-password",
            placeholder: formatMessage((0, $hlQLf.default).passwordPlaceholder),
            label: formatMessage((0, $hlQLf.default).passwordLabel),
            autoFocus: !isHidden,
            onChange: onChange,
            isInvalid: !!fieldError,
            invalidMessage: fieldErrorNode,
            value: value,
            ref: inputRef,
            isRequired: isRequired
        })
    });
};
var $a68b13f5cc44ee9a$export$2e2bcd8739ae039 = $a68b13f5cc44ee9a$var$PasswordContainer;

});

parcelRegister("eaMRk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dfd0056848cc3f3$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
let $5dfd0056848cc3f3$var$_ = (t)=>t, $5dfd0056848cc3f3$var$t;
const $5dfd0056848cc3f3$var$FormInfo = (0, $9Vz68.default).div($5dfd0056848cc3f3$var$t || ($5dfd0056848cc3f3$var$t = $5dfd0056848cc3f3$var$_`
  color: ${0};
  font-size: 13px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: -4px;
  transform: rotateX(0deg);
  transform-origin: 50% 0;
  transition-property: visibility, height, margin-bottom, opacity, transform, padding;
  transition-duration: 0s, 0.2s, 0.2s, 0.2s, 0.2s;
  transition-timing-function: ease-in-out;
  text-align: center;

  &.hidden {
    height: 0;
    margin-bottom: 0;
    opacity: 0;
    padding: 0 ${0}px;
    pointer-events: none;
    transform: rotateX(-90deg);
    visibility: hidden;
  }
`), (0, $kTdw7).N700, (0, $5b7Z4.gridSize)() * 2);
const $5dfd0056848cc3f3$var$FormInfoComponent = (_param)=>{
    var { children: children } = _param, props = (0, $42tc5._)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($5dfd0056848cc3f3$var$FormInfo, (0, $6EnDC._)((0, $ty6PY._)({
        role: "alert"
    }, props), {
        className: props.isHidden ? 'hidden' : '',
        children: children
    }));
};
var $5dfd0056848cc3f3$export$2e2bcd8739ae039 = $5dfd0056848cc3f3$var$FormInfoComponent;

});

parcelRegister("l1nfA", function(module, exports) {

$parcel$export(module.exports, "SocialLoginOptionWrapper", function () { return $3dd58956ca5894f8$export$84dac62724cf046; });
$parcel$export(module.exports, "SocialLoginButton", function () { return $3dd58956ca5894f8$export$e42ebbbcc1226808; });
$parcel$export(module.exports, "SocialLoginButtonRowGroup", function () { return $3dd58956ca5894f8$export$b2f108f5851fd592; });
$parcel$export(module.exports, "SocialLoginPanelWrapper", function () { return $3dd58956ca5894f8$export$e61ba37bbdbb1966; });
$parcel$export(module.exports, "StyledSocialLoginButton", function () { return $3dd58956ca5894f8$export$27110045cf7ea8db; });
$parcel$export(module.exports, "default", function () { return $3dd58956ca5894f8$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");

var $9Vz68 = parcelRequire("9Vz68");

var $2eWKq = parcelRequire("2eWKq");

var $hRWcy = parcelRequire("hRWcy");

var $8B60H = parcelRequire("8B60H");

var $kp1Z7 = parcelRequire("kp1Z7");

var $fT7xM = parcelRequire("fT7xM");

var $jOHwz = parcelRequire("jOHwz");

var $1SvOA = parcelRequire("1SvOA");

var $jHLOy = parcelRequire("jHLOy");

var $oyAPa = parcelRequire("oyAPa");

var $8dRDh = parcelRequire("8dRDh");

var $erZlf = parcelRequire("erZlf");
let $3dd58956ca5894f8$var$_ = (t)=>t, $3dd58956ca5894f8$var$t, $3dd58956ca5894f8$var$t1, $3dd58956ca5894f8$var$t2, $3dd58956ca5894f8$var$t3;
const $3dd58956ca5894f8$export$969af4902a13348e = ({ handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const dynamicConfigs = (0, $erZlf.useDynamicConfigs)();
    const googleOutageEnabled = (0, $fT7xM.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const microsoftOutageEnabled = (0, $fT7xM.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const appleOutageEnabled = (0, $fT7xM.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const slackOutageEnabled = (0, $fT7xM.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs);
    const isSocialLoginOutage = googleOutageEnabled || microsoftOutageEnabled || appleOutageEnabled || slackOutageEnabled;
    const getAdvisorySectionMessage = ()=>{
        const multipleOutages = [
            googleOutageEnabled,
            microsoftOutageEnabled,
            appleOutageEnabled,
            slackOutageEnabled
        ].filter(Boolean).length > 1;
        const sectionMessageTitle = multipleOutages ? formatMessage((0, $jOHwz.default).someOutageTitle) : getAdvisorySectionMessageTitle();
        const sectionMessageDescription = multipleOutages ? formatMessage((0, $jOHwz.default).someOutageDescription) : getAdvisorySectionMessageDescription();
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
            testId: "social-login-outage-section-message",
            title: sectionMessageTitle,
            appearance: "warning",
            children: /*#__PURE__*/ (0, $6rcps.jsx)("p", {
                children: sectionMessageDescription
            })
        });
    };
    const getAdvisorySectionMessageTitle = ()=>googleOutageEnabled ? formatMessage((0, $jOHwz.default).googleOutageTitle) : microsoftOutageEnabled ? formatMessage((0, $jOHwz.default).microsoftOutageTitle) : appleOutageEnabled ? formatMessage((0, $jOHwz.default).appleOutageTitle) : slackOutageEnabled ? formatMessage((0, $jOHwz.default).slackOutageTitle) : formatMessage((0, $jOHwz.default).someOutageTitle);
    const getAdvisorySectionMessageDescription = ()=>googleOutageEnabled ? formatMessage((0, $jOHwz.default).googleOutageDescription) : microsoftOutageEnabled ? formatMessage((0, $jOHwz.default).microsoftOutageDescription) : appleOutageEnabled ? formatMessage((0, $jOHwz.default).appleOutageDescription) : slackOutageEnabled ? formatMessage((0, $jOHwz.default).slackOutageDescription) : formatMessage((0, $jOHwz.default).someOutageDescription);
    const handleGoogleLoginOnClick = ()=>{
        handleGoogleLogin();
    };
    const GoogleButton = ()=>/*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$e42ebbbcc1226808, {
                id: "google-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($hRWcy))),
                onClick: handleGoogleLoginOnClick,
                advisoryEnabled: googleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $jOHwz.default).googleOutageDescription),
                children: "Google"
            })
        });
    const MicrosoftButton = ()=>/*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$e42ebbbcc1226808, {
                id: "microsoft-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($8B60H))),
                onClick: handleMicrosoftLogin,
                advisoryEnabled: microsoftOutageEnabled,
                outageTooltipMessage: formatMessage((0, $jOHwz.default).microsoftOutageDescription),
                children: "Microsoft"
            })
        });
    const AppleButton = ()=>/*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$e42ebbbcc1226808, {
                id: "apple-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($2eWKq))),
                onClick: handleAppleLogin,
                advisoryEnabled: appleOutageEnabled,
                outageTooltipMessage: formatMessage((0, $jOHwz.default).appleOutageDescription),
                children: "Apple"
            })
        });
    const SlackButton = ()=>/*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$84dac62724cf046, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$e42ebbbcc1226808, {
                id: "slack-auth-button",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($kp1Z7))),
                onClick: handleSlackLogin,
                advisoryEnabled: slackOutageEnabled,
                outageTooltipMessage: formatMessage((0, $jOHwz.default).slackOutageDescription),
                children: "Slack"
            })
        });
    const showButtonsGridLayout = ()=>/*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsxs)($3dd58956ca5894f8$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        GoogleButton(),
                        MicrosoftButton()
                    ]
                }),
                /*#__PURE__*/ (0, $6rcps.jsxs)($3dd58956ca5894f8$export$b2f108f5851fd592, {
                    "data-testid": "social-login-button-row",
                    children: [
                        AppleButton(),
                        SlackButton()
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $6rcps.jsxs)($3dd58956ca5894f8$export$e61ba37bbdbb1966, {
        role: "list",
        "data-i18n-or": formatMessage((0, $jOHwz.default).socialAuthOr),
        "data-i18n-continue": formatMessage((0, $jOHwz.default).socialAuthOrContinueWith),
        className: "google-login social-login",
        "data-testid": "social-login-wrapper",
        children: [
            showButtonsGridLayout(),
            isSocialLoginOutage && getAdvisorySectionMessage()
        ]
    });
};
const $3dd58956ca5894f8$export$e61ba37bbdbb1966 = (0, $9Vz68.default).ul($3dd58956ca5894f8$var$t || ($3dd58956ca5894f8$var$t = $3dd58956ca5894f8$var$_`
  margin-top: ${0}px;
  list-style: none;
  padding-inline: 0;
  margin-block-end: 0;
  &::before {
    color: ${0};
    content: attr(data-i18n-continue);
    display: block;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: ${0}px;
    font-weight: 600;
    text-align: center;
  }
`), (0, $5b7Z4.gridSize)() * 3, (0, $kTdw7).N300, (0, $5b7Z4.gridSize)() * 2);
const $3dd58956ca5894f8$export$b2f108f5851fd592 = (0, $9Vz68.default).div($3dd58956ca5894f8$var$t1 || ($3dd58956ca5894f8$var$t1 = $3dd58956ca5894f8$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $5b7Z4.gridSize)() * 2);
const $3dd58956ca5894f8$export$84dac62724cf046 = (0, $9Vz68.default).li($3dd58956ca5894f8$var$t2 || ($3dd58956ca5894f8$var$t2 = $3dd58956ca5894f8$var$_`
  &:not(:last-child) {
    margin-bottom: ${0}px;
  }
`), (0, $5b7Z4.gridSize)() * 2);
const $3dd58956ca5894f8$export$e42ebbbcc1226808 = (_param)=>{
    var { children: children, logo: logo, advisoryEnabled: advisoryEnabled, outageTooltipMessage: outageTooltipMessage } = _param, props = (0, $42tc5._)(_param, [
        "children",
        "logo",
        "advisoryEnabled",
        "outageTooltipMessage"
    ]);
    const commonProps = {
        isFullWidth: true,
        iconBefore: logo ? /*#__PURE__*/ (0, $6rcps.jsx)("img", {
            src: logo,
            alt: ""
        }) : undefined
    };
    if (advisoryEnabled) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8dRDh.default), {
        testId: "social-auth-button-tooltip",
        content: outageTooltipMessage,
        children: /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$27110045cf7ea8db, (0, $6EnDC._)((0, $ty6PY._)({
            advisoryEnabled: true,
            iconAfter: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($oyAPa))), {
                testId: "social-auth-button-warning-icon",
                label: "",
                primaryColor: (0, $kTdw7).Y500,
                secondaryColor: (0, $kTdw7).Y50
            })
        }, commonProps, props), {
            children: children
        }))
    });
    else return /*#__PURE__*/ (0, $6rcps.jsx)($3dd58956ca5894f8$export$27110045cf7ea8db, (0, $6EnDC._)((0, $ty6PY._)({
        advisoryEnabled: false
    }, commonProps, props), {
        children: children
    }));
};
const $3dd58956ca5894f8$export$27110045cf7ea8db = (0, $9Vz68.default)((0, $1SvOA.default), {
    shouldForwardProp: (propName)=>![
            'advisoryEnabled'
        ].includes(propName)
})($3dd58956ca5894f8$var$t3 || ($3dd58956ca5894f8$var$t3 = $3dd58956ca5894f8$var$_`
  background: ${0} !important;
  box-shadow: none;
  font-weight: bold;
  border: 1px solid ${0};
  border-radius: 3px;
  color: ${0};
  span {
    flex-grow: unset;
  }

  &:not(:last-child) {
    margin-bottom: ${0}px;
  }

  &:hover {
    background: ${0} !important;
  }
  &:active {
    background: ${0} !important;
    color: ${0} !important;
  }
  &:focus {
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.2), 0 0 0 2px rgba(38, 132, 255, 0.6) !important;
  }
  img {
    height: 24px;
    width: 24px;
    margin-right: 6px;
  }
`), (props)=>props.advisoryEnabled ? (0, $kTdw7).Y50 : (0, $kTdw7).N0, (0, $kTdw7).N50, (0, $kTdw7).N800, (0, $5b7Z4.gridSize)() * 0.5, (0, $kTdw7).N10A, (0, $kTdw7).N20A, (0, $kTdw7).N400);
var $3dd58956ca5894f8$export$2e2bcd8739ae039 = $3dd58956ca5894f8$export$969af4902a13348e;

});
parcelRegister("2eWKq", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "apple-logo.54e0d711.svg";

});

parcelRegister("hRWcy", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "google-logo.5867462c.svg";

});

parcelRegister("8B60H", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "microsoft-logo.c73d8dca.svg";

});

parcelRegister("kp1Z7", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "slack-logo.5d730c10.svg";

});

parcelRegister("jOHwz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1834882ccfdd2e7c$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $1834882ccfdd2e7c$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    socialAuthContinue: {
        id: 'social.auth.continue',
        defaultMessage: 'Or continue with',
        description: `Precedes third party login buttons. For example, "Or continue with Google"`
    },
    someOutageTitle: {
        id: 'some.outage.title',
        defaultMessage: 'Issues with some login options',
        description: 'Message to the user that there are currently issues logging in with some providers due to an outage'
    },
    googleOutageTitle: {
        id: 'google.outage.title',
        defaultMessage: 'Issues with Google login',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageTitle: {
        id: 'microsoft.outage.title',
        defaultMessage: 'Issues with Microsoft login',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageTitle: {
        id: 'apple.outage.title',
        defaultMessage: 'Issues with Apple login',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageTitle: {
        id: 'slack.outage.title',
        defaultMessage: 'Issues with Slack login',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    },
    someOutageDescription: {
        id: 'some.outage.description',
        defaultMessage: 'Some login options are experiencing issues at the moment. You may be able to log in or sign up with your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with due to a login provider outage'
    },
    googleOutageDescription: {
        id: 'google.outage.description',
        defaultMessage: 'There are issues with Google login and signup at the moment. If you are unable to continue with Google, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Google due to an outage'
    },
    microsoftOutageDescription: {
        id: 'microsoft.outage.description',
        defaultMessage: 'There are issues with Microsoft login and signup at the moment. If you are unable to continue with Microsoft, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Microsoft due to an outage'
    },
    appleOutageDescription: {
        id: 'apple.outage.description',
        defaultMessage: 'There are issues with Apple login and signup at the moment. If you are unable to continue with Apple, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Apple due to an outage'
    },
    slackOutageDescription: {
        id: 'slack.outage.description',
        defaultMessage: 'There are issues with Slack login and signup at the moment. If you are unable to continue with Slack, you may be able to use your email and password instead.',
        description: 'Message to the user that there are currently issues logging in with Slack due to an outage'
    }
});

});

parcelRegister("oyAPa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $049d137157a4a920$var$_react = $049d137157a4a920$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $dlpYS = parcelRequire("dlpYS");

var $049d137157a4a920$var$_statusWarning = $049d137157a4a920$var$_interopRequireDefault((parcelRequire("8S7JP")));
function $049d137157a4a920$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $049d137157a4a920$var$WarningIcon = (props)=>/*#__PURE__*/ $049d137157a4a920$var$_react.default.createElement($dlpYS.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $049d137157a4a920$var$_statusWarning.default
    }));
$049d137157a4a920$var$WarningIcon.displayName = 'WarningIcon';
var $049d137157a4a920$var$_default = module.exports.default = $049d137157a4a920$var$WarningIcon;

});
parcelRegister("8S7JP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435e803a057e79e21a0d31c5b12f3f81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67595e87270d6335$var$_react = $67595e87270d6335$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $67595e87270d6335$var$_baseNew = $67595e87270d6335$var$_interopRequireDefault((parcelRequire("d9We0")));
function $67595e87270d6335$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWarning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $67595e87270d6335$var$StatusWarningIcon = (props)=>/*#__PURE__*/ $67595e87270d6335$var$_react.default.createElement($67595e87270d6335$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.168c.756-1.395 2.76-1.395 3.516 0l5.9 10.878c.723 1.333-.242 2.953-1.758 2.953H2.1C.584 15-.38 13.38.342 12.046zM8 10.75a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2M7.25 4.5v5h1.5v-5z" clip-rule="evenodd"/>`
    }, props));
$67595e87270d6335$var$StatusWarningIcon.displayName = 'StatusWarningIcon';
var $67595e87270d6335$var$_default = module.exports.default = $67595e87270d6335$var$StatusWarningIcon;

});



parcelRegister("kR60c", function(module, exports) {

$parcel$export(module.exports, "LoginRecaptcha", function () { return $6be2381f7f785555$export$1e978f900466132e; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $7o26r = parcelRequire("7o26r");

var $f19CI = parcelRequire("f19CI");

var $61XRM = parcelRequire("61XRM");

var $ciYFg = parcelRequire("ciYFg");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $6be2381f7f785555$export$1e978f900466132e = ()=>{
    (0, $aavUY.useRegisterComponent)($6be2381f7f785555$export$1e978f900466132e.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $61XRM.useRecaptchaContext)();
    const isSecondStep = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCaptchaRequired = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const shouldRenderCheckUsernameRecaptcha = !isSecondStep && recaptchaEnabled && recaptchaComponent;
    const { setCaptchaValue: setCaptchaValue } = (0, $ciYFg.useLoginTooManyAttemptsRecaptchaContext)();
    const shouldRenderTooManyAttemptsRecaptcha = isSecondStep && isCaptchaRequired;
    const prevIsCaptchaRequired = (0, $7AZRg.usePrevious)(isCaptchaRequired);
    (0, $8ZuGG.useEffect)(()=>{
        if (prevIsCaptchaRequired && !isCaptchaRequired) setCaptchaValue(null);
    }, [
        isCaptchaRequired,
        prevIsCaptchaRequired,
        setCaptchaValue
    ]);
    const isCaptchaEnabledByConfig = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnable;
    });
    const recaptchaEnterpriseCheckboxKeySite = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.recaptchaEnterpriseCheckboxKeySite;
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: isCaptchaEnabledByConfig && (shouldRenderCheckUsernameRecaptcha ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $f19CI.default), {
            children: recaptchaComponent
        }) : shouldRenderTooManyAttemptsRecaptcha && /*#__PURE__*/ (0, $6rcps.jsx)((0, $f19CI.default), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $7o26r.default), {
                sitekey: recaptchaEnterpriseCheckboxKeySite,
                onChange: setCaptchaValue
            })
        }))
    });
};

});
parcelRegister("7o26r", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d60514635d3e06e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $eqEzl = parcelRequire("eqEzl");

var $8f2pb = parcelRequire("8f2pb");
const $3d60514635d3e06e$export$c8e68dd3bf26af81 = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function ReCAPTCHAEnterprise(props, ref) {
    const { grecaptcha: grecaptcha, onChange: onChange, onErrored: onErrored, onExpired: onExpired, size: size, sitekey: sitekey, action: action } = props;
    const enterprise = grecaptcha === null || grecaptcha === void 0 ? void 0 : grecaptcha.enterprise;
    const [widgetId, setWidgetId] = (0, $8ZuGG.useState)();
    const containerRef = (0, $8ZuGG.useRef)(null);
    const hasRendered = (0, $8ZuGG.useRef)(false);
    /**
     * The execution callbacks and states (hasRequest, resetRequired) etc.
     * are being tracked in a useRef since we don't want to react to its changes
     * but need to track it in-between renders.
     */ const executionRef = (0, $8ZuGG.useRef)({
        hasRequested: false,
        resetRequired: false
    });
    const resetExecutionHandlers = (0, $8ZuGG.useCallback)(()=>{
        delete executionRef.current.onResolve;
        delete executionRef.current.onReject;
    }, []);
    const reset = (0, $8ZuGG.useCallback)(()=>{
        if (enterprise && typeof widgetId === 'number') enterprise.reset(widgetId);
    }, [
        enterprise,
        widgetId
    ]);
    const handleError = (0, $8ZuGG.useCallback)((cause)=>{
        var _executionRef_current;
        if (onErrored) onErrored();
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
            executionRef.current.onReject(new Error(`ReCAPTCHAEnterprise rejected due to: ${cause}`, {
                cause: cause
            }));
            resetExecutionHandlers();
        }
    }, [
        onErrored,
        resetExecutionHandlers
    ]);
    const handleChange = (0, $8ZuGG.useCallback)((token)=>{
        var _executionRef_current;
        if (onChange) onChange(token);
        if (!token) handleError('no-token');
        else if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onResolve) {
            executionRef.current.onResolve(token);
            resetExecutionHandlers();
        }
    }, [
        handleError,
        onChange,
        resetExecutionHandlers
    ]);
    const handleExpired = (0, $8ZuGG.useCallback)(()=>{
        if (onExpired) {
            var _executionRef_current;
            onExpired();
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.onReject) {
                executionRef.current.onReject(new Error('ReCAPTCHAEnterprise rejected due to expired token'));
                resetExecutionHandlers();
            }
        } else handleChange(null);
    }, [
        handleChange,
        onExpired,
        resetExecutionHandlers
    ]);
    const execute = (0, $8ZuGG.useCallback)((targetWidgetId)=>{
        const id = typeof targetWidgetId === 'undefined' ? widgetId : targetWidgetId;
        if (enterprise && id !== undefined) {
            var _executionRef_current;
            // Tokens are cached, reset is needed after first execute
            if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.resetRequired) reset();
            executionRef.current.resetRequired = true;
            enterprise.execute(id);
        } else executionRef.current.hasRequested = true;
    }, [
        enterprise,
        reset,
        widgetId
    ]);
    const renderExplicit = (0, $8ZuGG.useCallback)(()=>{
        var _executionRef_current;
        if (!sitekey) {
            (0, $8f2pb.captureErrorMessage)('ReCAPTCHAEnterprise: recaptcha enterprise site key not provided');
            return;
        }
        // Check if grecaptcha is available and if it hasn't been rendered already
        if (!(enterprise === null || enterprise === void 0 ? void 0 : enterprise.render) || widgetId !== undefined || hasRendered.current) return;
        const wrapper = document.createElement('div');
        const id = enterprise.render(wrapper, {
            sitekey: sitekey,
            action: action,
            size: size,
            callback: handleChange,
            'expired-callback': handleExpired,
            'error-callback': ()=>// NOTE: recaptcha script does not provide a value to this callback: https://cloud.google.com/recaptcha/docs/api-ref-checkbox-keys#attributes_parameters
                // This is just our own error handler
                handleError('script invoked error-callback')
        });
        setWidgetId(id);
        containerRef.current.appendChild(wrapper);
        if ((_executionRef_current = executionRef.current) === null || _executionRef_current === void 0 ? void 0 : _executionRef_current.hasRequested) {
            executionRef.current.hasRequested = false;
            execute(id);
        }
        hasRendered.current = true;
    }, [
        action,
        enterprise,
        execute,
        handleChange,
        handleError,
        handleExpired,
        sitekey,
        size,
        widgetId
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        /**
       * This has to run on every render, hence why there is no dependency array.
       * renderExplicit was called on componentDidMount & componentDidUpdate when it was a class component.
       */ renderExplicit();
    });
    (0, $8ZuGG.useEffect)(()=>{
        const delayOfCaptchaIframeRemoving = ()=>{
            var _containerRef_current;
            const temporaryNode = document.createElement('div');
            document.body.appendChild(temporaryNode);
            temporaryNode.style.display = 'none';
            // move of the recaptcha to a temporary node
            while((_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.firstChild)temporaryNode.appendChild(containerRef.current.firstChild);
            // delete the temporary node after reset will be done
            setTimeout(()=>document.body.removeChild(temporaryNode), 5000);
        };
        return ()=>{
            if (widgetId !== undefined) {
                delayOfCaptchaIframeRemoving();
                reset();
                hasRendered.current = false;
            }
        };
    }, [
        reset,
        widgetId
    ]);
    (0, $8ZuGG.useImperativeHandle)(ref, ()=>({
            executeAsync () {
                return new Promise((resolve, reject)=>{
                    executionRef.current.onResolve = resolve;
                    executionRef.current.onReject = reject;
                    execute();
                });
            }
        }), [
        execute
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)("div", {
        "data-testid": "ReCAPTCHAEnterprise",
        ref: containerRef
    });
});
var $3d60514635d3e06e$export$2e2bcd8739ae039 = (0, $eqEzl.default)(()=>'https://www.recaptcha.net/recaptcha/enterprise.js?onload=onloadcallback&render=explicit', {
    callbackName: 'onloadcallback',
    globalName: 'grecaptcha'
})($3d60514635d3e06e$export$c8e68dd3bf26af81);

});
parcelRegister("eqEzl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a812f68f2f315c5a$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $6CJPF = parcelRequire("6CJPF");

var $fiQA5 = parcelRequire("fiQA5");
function $a812f68f2f315c5a$var$_extends() {
    $a812f68f2f315c5a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a812f68f2f315c5a$var$_extends.apply(this, arguments);
}
function $a812f68f2f315c5a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a812f68f2f315c5a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a812f68f2f315c5a$var$SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
var $a812f68f2f315c5a$var$idCount = 0;
function $a812f68f2f315c5a$export$2e2bcd8739ae039(getScriptURL, options) {
    options = options || {};
    return function wrapWithAsyncScript(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var AsyncScriptLoader = /*#__PURE__*/ function(_Component) {
            $a812f68f2f315c5a$var$_inheritsLoose(AsyncScriptLoader, _Component);
            function AsyncScriptLoader(props, context) {
                var _this;
                _this = _Component.call(this, props, context) || this;
                _this.state = {};
                _this.__scriptURL = "";
                return _this;
            }
            var _proto = AsyncScriptLoader.prototype;
            _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
                if (!this.__scriptLoaderID) this.__scriptLoaderID = "async-script-loader-" + $a812f68f2f315c5a$var$idCount++;
                return this.__scriptLoaderID;
            };
            _proto.setupScriptURL = function setupScriptURL() {
                this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
                return this.__scriptURL;
            };
            _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
                var _this2 = this;
                // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
                this.setState(state, function() {
                    return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
                });
            };
            _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
                var mapEntry = $a812f68f2f315c5a$var$SCRIPT_MAP[this.__scriptURL];
                if (!mapEntry || !mapEntry.loaded) throw new Error("Script is not loaded.");
                for(var obsKey in mapEntry.observers)mapEntry.observers[obsKey](mapEntry);
                delete window[options.callbackName];
            };
            _proto.componentDidMount = function componentDidMount() {
                var _this3 = this;
                var scriptURL = this.setupScriptURL();
                var key = this.asyncScriptLoaderGetScriptLoaderID();
                var _options = options, globalName = _options.globalName, callbackName = _options.callbackName, scriptId = _options.scriptId; // check if global object already attached to window
                if (globalName && typeof window[globalName] !== "undefined") $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL] = {
                    loaded: true,
                    observers: {}
                };
                 // check if script loading already
                if ($a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL]) {
                    var entry = $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
                    if (entry && (entry.loaded || entry.errored)) {
                        this.asyncScriptLoaderHandleLoad(entry);
                        return;
                    } // if still loading then callback to observer queue
                    entry.observers[key] = function(entry) {
                        return _this3.asyncScriptLoaderHandleLoad(entry);
                    };
                    return;
                }
                /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */ var observers = {};
                observers[key] = function(entry) {
                    return _this3.asyncScriptLoaderHandleLoad(entry);
                };
                $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL] = {
                    loaded: false,
                    observers: observers
                };
                var script = document.createElement("script");
                script.src = scriptURL;
                script.async = true;
                for(var attribute in options.attributes)script.setAttribute(attribute, options.attributes[attribute]);
                if (scriptId) script.id = scriptId;
                var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
                    if ($a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL]) {
                        var mapEntry = $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL];
                        var observersMap = mapEntry.observers;
                        for(var obsKey in observersMap)if (func(observersMap[obsKey])) delete observersMap[obsKey];
                    }
                };
                if (callbackName && typeof window !== "undefined") window[callbackName] = function() {
                    return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
                };
                script.onload = function() {
                    var mapEntry = $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.loaded = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            if (callbackName) return false;
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                script.onerror = function() {
                    var mapEntry = $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL];
                    if (mapEntry) {
                        mapEntry.errored = true;
                        callObserverFuncAndRemoveObserver(function(observer) {
                            observer(mapEntry);
                            return true;
                        });
                    }
                };
                document.body.appendChild(script);
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                // Remove tag script
                var scriptURL = this.__scriptURL;
                if (options.removeOnUnmount === true) {
                    var allScripts = document.getElementsByTagName("script");
                    for(var i = 0; i < allScripts.length; i += 1){
                        if (allScripts[i].src.indexOf(scriptURL) > -1) {
                            if (allScripts[i].parentNode) allScripts[i].parentNode.removeChild(allScripts[i]);
                        }
                    }
                } // Clean the observer entry
                var mapEntry = $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL];
                if (mapEntry) {
                    delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
                    if (options.removeOnUnmount === true) delete $a812f68f2f315c5a$var$SCRIPT_MAP[scriptURL];
                }
            };
            _proto.render = function render() {
                var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
                var _this$props = this.props, asyncScriptOnLoad = _this$props.asyncScriptOnLoad, forwardedRef = _this$props.forwardedRef, childProps = $a812f68f2f315c5a$var$_objectWithoutPropertiesLoose(_this$props, [
                    "asyncScriptOnLoad",
                    "forwardedRef"
                ]); // eslint-disable-line no-unused-vars
                if (globalName && typeof window !== "undefined") childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
                childProps.ref = forwardedRef;
                return (0, $8ZuGG.createElement)(WrappedComponent, childProps);
            };
            return AsyncScriptLoader;
        }((0, $8ZuGG.Component)); // Note the second param "ref" provided by React.forwardRef.
        // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
        // And it can then be attached to the Component.
        var ForwardedComponent = (0, $8ZuGG.forwardRef)(function(props, ref) {
            return (0, $8ZuGG.createElement)(AsyncScriptLoader, $a812f68f2f315c5a$var$_extends({}, props, {
                forwardedRef: ref
            }));
        });
        ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
        ForwardedComponent.propTypes = {
            asyncScriptOnLoad: (0, (/*@__PURE__*/$parcel$interopDefault($6CJPF))).func
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(ForwardedComponent, WrappedComponent);
    };
}

});


parcelRegister("f19CI", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNotice", function () { return $433928230be93259$export$4faf58f44fb24e61; });
$parcel$export(module.exports, "default", function () { return $433928230be93259$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");
parcelRequire("8ZuGG");

var $5mHsu = parcelRequire("5mHsu");

var $lk8Tl = parcelRequire("lk8Tl");
let $433928230be93259$var$_ = (t)=>t, $433928230be93259$var$t;
const $433928230be93259$var$ReCaptchaContainer = (0, $9Vz68.default).div($433928230be93259$var$t || ($433928230be93259$var$t = $433928230be93259$var$_`
  margin-top: ${0}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`), (0, $5b7Z4.gridSize)());
const $433928230be93259$export$4faf58f44fb24e61 = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    if ((0, $lk8Tl.isIsolatedCloud)()) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "signup.form.recaptcha.notice.xml",
        defaultMessage: "This site is protected by reCAPTCHA and the Google <google-pp-link>Privacy Policy</google-pp-link> and <google-tos-link>Terms of Service</google-tos-link> apply.",
        values: {
            'google-pp-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
                    href: "https://policies.google.com/privacy",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.pp.link.aria.label',
                        defaultMessage: 'Google Privacy Policy',
                        description: "Aria label for link to let users learn more about Google's Privacy Policy."
                    }),
                    children: chunks
                }),
            'google-tos-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
                    href: "https://policies.google.com/terms",
                    target: "_blank",
                    rel: "noreferrer noopener",
                    "aria-label": formatMessage({
                        id: 'signup.form.recaptcha.notice.google.tos.link.aria.label',
                        defaultMessage: 'Google Terms of Service',
                        description: "Aria label for link to let users learn more about Google's Terms of Service."
                    }),
                    children: chunks
                })
        }
    });
};
var $433928230be93259$export$2e2bcd8739ae039 = $433928230be93259$var$ReCaptchaContainer;

});

parcelRegister("61XRM", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaContext", function () { return $3742be976c24cb90$export$744a1a543fe96347; });
$parcel$export(module.exports, "RecaptchaContextProvider", function () { return $3742be976c24cb90$export$3f8996f6160b8ff2; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $83iBV = parcelRequire("83iBV");
const $3742be976c24cb90$export$2b9e9205883624e = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $3742be976c24cb90$export$744a1a543fe96347 = ()=>{
    const context = (0, $8ZuGG.useContext)($3742be976c24cb90$export$2b9e9205883624e);
    if (!context) throw new Error('useRecaptchaContext must be used within a RecaptchaContextProvider');
    return context;
};
const $3742be976c24cb90$export$3f8996f6160b8ff2 = ({ children: children, pageId: pageId, type: type, action: action, enabledProp: enabledProp })=>{
    const { isLoaded: isLoaded, enabled: enabled, errorMessage: errorMessage, component: component, fetchToken: baseFetchToken } = (0, $83iBV.useRecaptcha)({
        pageId: pageId,
        type: type,
        action: action,
        enabledProp: enabledProp
    });
    const fetchToken = (0, $8ZuGG.useCallback)(baseFetchToken, [
        baseFetchToken
    ]);
    const state = (0, $8ZuGG.useMemo)(()=>({
            isLoaded: isLoaded,
            enabled: enabled,
            errorMessage: errorMessage,
            component: component,
            fetchToken: fetchToken,
            recaptchaType: type
        }), [
        isLoaded,
        enabled,
        errorMessage,
        component,
        fetchToken,
        type
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($3742be976c24cb90$export$2b9e9205883624e.Provider, {
        value: state,
        children: children
    });
};

});
parcelRegister("83iBV", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", function () { return $e90dd9c815186a72$export$f7242fdfba1703e8; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $fDCCZ = parcelRequire("fDCCZ");

var $6JKsh = parcelRequire("6JKsh");

var $kOqgB = parcelRequire("kOqgB");

var $8f2pb = parcelRequire("8f2pb");
const $e90dd9c815186a72$var$noOpScoreConfig = {
    sitekey: '',
    pageId: '',
    enabled: false
};
const $e90dd9c815186a72$var$noOpCheckboxConfig = {
    sitekey: '',
    pageId: '',
    enabled: false,
    action: ''
};
const $e90dd9c815186a72$export$f7242fdfba1703e8 = (props)=>{
    const { pageId: pageId, type: type, enabledProp: enabledProp = true, action: action } = props;
    const { config: config } = $e90dd9c815186a72$export$9b70e8251564d9ec(pageId, type, enabledProp, action);
    const isScore = type === 'score';
    const isCheckbox = type === 'checkbox';
    const scoreRecaptcha = (0, $6JKsh.useScoreRecaptcha)(isScore ? config : $e90dd9c815186a72$var$noOpScoreConfig);
    const checkboxRecaptcha = (0, $fDCCZ.useCheckboxRecaptcha)(isCheckbox ? config : $e90dd9c815186a72$var$noOpCheckboxConfig);
    return (0, $8ZuGG.useMemo)(()=>isScore ? $e90dd9c815186a72$var$handleScore(scoreRecaptcha, action) : $e90dd9c815186a72$var$handleCheckbox(checkboxRecaptcha), [
        isScore,
        scoreRecaptcha,
        checkboxRecaptcha,
        action
    ]);
};
function $e90dd9c815186a72$export$9b70e8251564d9ec(pageId, type, enabledProp, action) {
    const captchaEnabledByConfig = (0, $kOqgB.useAppSelector)((state)=>state.appConfig.recaptchaEnable);
    const scoreSitekey = (0, $kOqgB.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseScoreKeySite);
    const checkboxSitekey = (0, $kOqgB.useAppSelector)((state)=>state.appConfig.recaptchaEnterpriseCheckboxKeySite);
    const enabled = captchaEnabledByConfig && enabledProp;
    const commonConfig = {
        pageId: pageId,
        enabled: enabled,
        action: action
    };
    const scoreConfig = (0, $6EnDC._)((0, $ty6PY._)({}, commonConfig), {
        sitekey: scoreSitekey,
        displayBadge: false
    });
    const checkboxConfig = (0, $6EnDC._)((0, $ty6PY._)({}, commonConfig), {
        sitekey: checkboxSitekey,
        action: action !== null && action !== void 0 ? action : 'unknown'
    });
    const policyConfig = (0, $6EnDC._)((0, $ty6PY._)({}, commonConfig), {
        sitekey: ''
    });
    switch(type){
        case 'score':
            return {
                type: type,
                config: scoreConfig
            };
        case 'checkbox':
            return {
                type: type,
                config: checkboxConfig
            };
        case 'policy':
            return {
                type: type,
                config: policyConfig
            };
        default:
            (0, $8f2pb.captureTaggedException)(new Error(`Unexpected captcha type: ${type}`), {
                capabilities: action === 'signup' ? [
                    'capability-group--signup'
                ] : [],
                tags: {
                    recaptcha: 'unexpected_captcha_type'
                }
            });
            return {
                type: type,
                config: (0, $6EnDC._)((0, $ty6PY._)({}, commonConfig), {
                    sitekey: '',
                    enabled: false
                })
            };
    }
}
const $e90dd9c815186a72$var$handleCheckbox = (checkboxRecaptcha)=>{
    var _checkboxRecaptcha_error;
    const wrapToken = ()=>{
        return Promise.resolve({
            token: checkboxRecaptcha.token || '',
            type: 'checkbox',
            challengeKind: 'recaptcha'
        });
    };
    const isLoaded = checkboxRecaptcha.isLoaded;
    const enabled = checkboxRecaptcha === null || checkboxRecaptcha === void 0 ? void 0 : checkboxRecaptcha.enabled;
    var _checkboxRecaptcha_error_message;
    const errorMessage = (_checkboxRecaptcha_error_message = checkboxRecaptcha === null || checkboxRecaptcha === void 0 ? void 0 : (_checkboxRecaptcha_error = checkboxRecaptcha.error) === null || _checkboxRecaptcha_error === void 0 ? void 0 : _checkboxRecaptcha_error.message) !== null && _checkboxRecaptcha_error_message !== void 0 ? _checkboxRecaptcha_error_message : undefined;
    const component = checkboxRecaptcha.component;
    const onFetchToken = async ()=>{
        const response = await wrapToken();
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $8f2pb.captureRecaptchaMessage)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'no token returned from checkbox recaptcha', {}, 'no_token_checkbox');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage,
        component: component
    };
};
const $e90dd9c815186a72$var$handleScore = (scoreRecaptcha, action)=>{
    const fetchAndWrapToken = (action)=>scoreRecaptcha.fetchRecaptchaToken(action).then((token)=>{
            return {
                token: token || '',
                type: 'score',
                challengeKind: 'recaptcha'
            };
        });
    const isLoaded = scoreRecaptcha.isLoaded;
    const enabled = scoreRecaptcha === null || scoreRecaptcha === void 0 ? void 0 : scoreRecaptcha.enabled;
    var _scoreRecaptcha_loadRecaptchaErrorReason;
    const errorMessage = (_scoreRecaptcha_loadRecaptchaErrorReason = scoreRecaptcha === null || scoreRecaptcha === void 0 ? void 0 : scoreRecaptcha.loadRecaptchaErrorReason) !== null && _scoreRecaptcha_loadRecaptchaErrorReason !== void 0 ? _scoreRecaptcha_loadRecaptchaErrorReason : undefined;
    const onFetchToken = async ()=>{
        const response = await fetchAndWrapToken(action);
        // TODO once the flag is cleaned up, the type of response will always be truthy so we can change the check to response.token === ''
        if ((!response || !response.token) && enabled) (0, $8f2pb.captureRecaptchaMessage)(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'no token returned from score recaptcha', {}, 'no_token_score');
        return response;
    };
    return {
        fetchToken: onFetchToken,
        isLoaded: isLoaded || false,
        enabled: enabled || false,
        errorMessage: errorMessage
    };
};

});
parcelRegister("fDCCZ", function(module, exports) {

$parcel$export(module.exports, "useCheckboxRecaptcha", function () { return $c225ccf58a1d57e4$export$25db2ae7b91eff3b; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $2NnAn = parcelRequire("2NnAn");

var $8f2pb = parcelRequire("8f2pb");

var $3ir1n = parcelRequire("3ir1n");

var $eSSTZ = parcelRequire("eSSTZ");
const $c225ccf58a1d57e4$export$25db2ae7b91eff3b = (config)=>{
    const [instanceId, setInstanceId] = (0, $8ZuGG.useState)();
    const [token, setToken] = (0, $8ZuGG.useState)('');
    const [isLoaded, setIsLoaded] = (0, $8ZuGG.useState)(false);
    const [isExpired, setIsExpired] = (0, $8ZuGG.useState)(false);
    const [error, setError] = (0, $8ZuGG.useState)();
    const { sitekey: sitekey, action: action, enabled: enabled, pageId: pageId } = config;
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const scriptLogic = (0, $2NnAn.useCheckboxRecaptchaScripts)();
    const sendTrackingEvent = (0, $8ZuGG.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent((0, $ty6PY._)({
            page: pageId,
            action: action,
            subject: 'checkbox-recaptcha'
        }, errorType && {
            attributes: {
                hasError: true,
                errorName: errorType
            }
        }));
    }, [
        analyticsClient,
        pageId
    ]);
    const handleVerify = (0, $8ZuGG.useCallback)((newToken)=>{
        setToken(newToken);
        setIsExpired(false);
        sendTrackingEvent('checkbox-completed');
    }, [
        sendTrackingEvent
    ]);
    const handleExpire = (0, $8ZuGG.useCallback)(()=>{
        setToken('');
        setIsExpired(true);
        sendTrackingEvent('expired-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleError = (0, $8ZuGG.useCallback)(()=>{
        const newError = (0, $eSSTZ.RecaptchaError).fromMessage('Failed to load recaptcha script');
        setError(newError);
        (0, $8f2pb.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
        sendTrackingEvent('error-callback', 'recaptcha-script-error');
    }, [
        sendTrackingEvent
    ]);
    const handleOnLoad = (0, $8ZuGG.useCallback)(()=>{
        sendTrackingEvent('loaded-recaptcha');
        setIsLoaded(true);
    }, [
        sendTrackingEvent
    ]);
    // This callback is used for rendering recaptcha into the ref associated HTML Element.
    // The recaptcha script is loaded, if not done already, and then rendered.
    const refCallback = (0, $8ZuGG.useCallback)(async (node)=>{
        if (!node) return;
        try {
            // Dynamically loads the recaptcha script when needed.
            await scriptLogic.injectRecaptchaScript();
            handleOnLoad();
            // Renders the recaptcha component into the given node.
            const newInstanceId = scriptLogic.getRecaptchaMethods().render(node, {
                sitekey: sitekey,
                action: action,
                callback: handleVerify,
                'expired-callback': handleExpire,
                'error-callback': handleError
            });
            setInstanceId(newInstanceId);
        } catch (error) {
            const newError = (0, $eSSTZ.RecaptchaError).fromMessage('Failed to load recaptcha script');
            setError(newError);
            (0, $8f2pb.captureRecaptchaException)(newError, {}, 'no_token_checkbox');
            sendTrackingEvent('load-recaptcha-failed', 'recaptcha-window-error');
        }
    }, [
        scriptLogic,
        handleOnLoad,
        sitekey,
        action,
        handleVerify,
        handleExpire,
        handleError,
        sendTrackingEvent
    ]);
    const component = (0, $8ZuGG.useMemo)(()=>enabled ? /*#__PURE__*/ (0, $6rcps.jsx)("div", {
            id: "checkbox-recaptcha-hook",
            ref: refCallback
        }) : null, [
        enabled,
        refCallback
    ]);
    const reset = (0, $8ZuGG.useCallback)(()=>{
        if (instanceId === undefined) return;
        scriptLogic.getRecaptchaMethods().reset(instanceId);
        setToken('');
        setIsLoaded(false);
        setIsExpired(false);
    }, [
        instanceId,
        scriptLogic
    ]);
    const getResponse = (0, $8ZuGG.useCallback)(()=>{
        return instanceId !== undefined ? scriptLogic.getRecaptchaMethods().getResponse(instanceId) : '';
    }, [
        instanceId,
        scriptLogic
    ]);
    return {
        component: component,
        reset: reset,
        token: token,
        error: error,
        getResponse: getResponse,
        enabled: enabled,
        isLoaded: isLoaded,
        isExpired: isExpired
    };
};

});
parcelRegister("2NnAn", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptchaScripts", function () { return $38f008b8634544d4$export$4b37d6e6c5707b8a; });
$parcel$export(module.exports, "useCheckboxRecaptchaScripts", function () { return $38f008b8634544d4$export$b48db21c95021cdf; });

var $8f2pb = parcelRequire("8f2pb");

var $8ZuGG = parcelRequire("8ZuGG");

var $eSSTZ = parcelRequire("eSSTZ");
const $38f008b8634544d4$var$RECAPTCHA_SCRIPT_DOMAIN = 'www.recaptcha.net';
const $38f008b8634544d4$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise.';
const $38f008b8634544d4$export$3bfe7d4134a81119 = ()=>{
    var _window_grecaptcha;
    return (_window_grecaptcha = window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : _window_grecaptcha.enterprise;
};
/**
 * Loads the reCAPTCHA script if it hasn't been loaded already.
 *
 * Loading states:
 *  0. Script <src> element does not exist on the DOM.
 *  1. Script is asynchronously downloading and the reCAPTCHA methods are not available yet.
 *  2. Script has been downloaded and a 'load' event is fired for the DOM element and the reCAPTCHA methods are now available.
 *  3. Google fires a 'ready' event when the reCAPTCHA methods are available.
 *      Recaptcha can be considered to be fully ready to use at this point.
 *  4. Extra dependencies and scripts are downloaded asynchronously.
 *      This extra step should not be relevant to checkbox or score, but may be relevant for invisible.
 */ // Keep a track of all loaded scripts so the promise can be re-used by different React components/hooks:
const $38f008b8634544d4$var$scriptCache = new Map();
const $38f008b8634544d4$export$62fae4128d19343d = (scriptId)=>$38f008b8634544d4$var$scriptCache.delete(scriptId);
const $38f008b8634544d4$export$c80de0a5a6afcd7c = async (scriptId, scriptSrc)=>{
    let scriptPromise = $38f008b8634544d4$var$scriptCache.get(scriptId);
    if (!scriptPromise) {
        scriptPromise = new Promise((resolve, reject)=>{
            const scriptElement = document.createElement('script');
            scriptElement.id = scriptId;
            scriptElement.src = `https://${$38f008b8634544d4$var$RECAPTCHA_SCRIPT_DOMAIN}${scriptSrc}`;
            scriptElement.async = true;
            scriptElement.defer = true;
            scriptElement.addEventListener('load', ()=>{
                if (window && window.grecaptcha && window.grecaptcha.enterprise) // reCAPTCHA script was injected and library 'finished' loading once ready() completes
                $38f008b8634544d4$export$3bfe7d4134a81119().ready(()=>resolve());
                else {
                    (0, $8f2pb.captureErrorMessage)($38f008b8634544d4$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
                    reject((0, $eSSTZ.RecaptchaError).fromMessage($38f008b8634544d4$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE));
                }
            });
            // investigate - error undefined
            scriptElement.addEventListener('error', (errorEvent)=>{
                (0, $8f2pb.captureException)(errorEvent.error);
                reject((0, $eSSTZ.RecaptchaError).fromError(errorEvent.error || new Error($38f008b8634544d4$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE)));
            });
            document.head.appendChild(scriptElement);
        });
        $38f008b8634544d4$var$scriptCache.set(scriptId, scriptPromise);
    }
    return scriptPromise;
};
const $38f008b8634544d4$export$a0a588829684d44 = (scriptId)=>{
    const script = document.getElementById(scriptId);
    return script !== null;
};
const $38f008b8634544d4$export$924e44702e93d253 = (scriptId)=>{
    const id = `${scriptId}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = id;
    styleElement.innerText = '.grecaptcha-badge { visibility: hidden; }';
    document.head.appendChild(styleElement);
};
const $38f008b8634544d4$export$684246aaf6783333 = (scriptId)=>{
    const scriptElement = document.getElementById(scriptId);
    if (scriptElement) scriptElement.remove();
};
const $38f008b8634544d4$export$42b99ab155dad274 = (scriptId)=>{
    const styleElement = document.getElementById(`${scriptId}-styles`);
    if (styleElement) styleElement.remove();
};
const $38f008b8634544d4$export$f124d412b77f93b3 = ()=>{
    document.querySelectorAll('.grecaptcha-badge').forEach((element)=>element.remove());
};
const $38f008b8634544d4$export$4b37d6e6c5707b8a = ({ sitekey: sitekey })=>{
    const scriptSrc = `/recaptcha/enterprise.js?render=${sitekey}`;
    return (0, $8ZuGG.useMemo)(()=>({
            injectRecaptchaScript: ()=>$38f008b8634544d4$export$c80de0a5a6afcd7c(sitekey, scriptSrc),
            getRecaptchaMethods: ()=>$38f008b8634544d4$export$3bfe7d4134a81119(),
            hideRecaptchaBadge: ()=>$38f008b8634544d4$export$924e44702e93d253(sitekey),
            unloadRecaptcha () {
                $38f008b8634544d4$export$684246aaf6783333(sitekey);
                $38f008b8634544d4$export$42b99ab155dad274(sitekey);
                $38f008b8634544d4$export$f124d412b77f93b3();
                $38f008b8634544d4$export$62fae4128d19343d(sitekey);
            }
        }), [
        sitekey,
        scriptSrc
    ]);
};
const $38f008b8634544d4$export$b48db21c95021cdf = ()=>{
    const scriptId = 'checkbox-recaptcha';
    const scriptSrc = '/recaptcha/enterprise.js?render=explicit';
    return (0, $8ZuGG.useMemo)(()=>({
            injectRecaptchaScript: ()=>$38f008b8634544d4$export$c80de0a5a6afcd7c(scriptId, scriptSrc),
            getRecaptchaMethods: ()=>$38f008b8634544d4$export$3bfe7d4134a81119()
        }), []);
};

});
parcelRegister("eSSTZ", function(module, exports) {

$parcel$export(module.exports, "RecaptchaError", function () { return $263ad2288c6442f8$export$e037dc82f45cc746; });
class $263ad2288c6442f8$export$e037dc82f45cc746 extends Error {
    static fromError(error) {
        const instance = new $263ad2288c6442f8$export$e037dc82f45cc746(error.message);
        instance.stack = error.stack;
        return instance;
    }
    static fromMessage(message) {
        const instance = new $263ad2288c6442f8$export$e037dc82f45cc746(message);
        instance.stack = new Error().stack;
        return instance;
    }
    constructor(message){
        super(message);
        this.name = 'RecaptchaError';
    }
}

});



parcelRegister("6JKsh", function(module, exports) {

$parcel$export(module.exports, "useScoreRecaptcha", function () { return $bd08fbe74f9726bb$export$afce2c1d72c48fc5; });

var $ty6PY = parcelRequire("ty6PY");

var $8ZuGG = parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $8f2pb = parcelRequire("8f2pb");

var $2NnAn = parcelRequire("2NnAn");

var $eSSTZ = parcelRequire("eSSTZ");
const $bd08fbe74f9726bb$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE = 'Failed to invoke grecaptcha execute function as it is not ready.';
const $bd08fbe74f9726bb$export$afce2c1d72c48fc5 = (config)=>{
    const [loadRecaptchaErrorReason, setLoadRecaptchaErrorReason] = (0, $8ZuGG.useState)();
    const [isLoaded, setIsLoaded] = (0, $8ZuGG.useState)(false);
    const scriptInitializationRef = (0, $8ZuGG.useRef)();
    const { sitekey: sitekey, enabled: enabled, displayBadge: displayBadge = false, pageId: pageId } = config;
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const scriptLogic = (0, $2NnAn.useScoreRecaptchaScripts)({
        sitekey: sitekey
    });
    const sendTrackingEvent = (0, $8ZuGG.useCallback)((action, errorType)=>{
        analyticsClient.trackingEvent((0, $ty6PY._)({
            page: pageId,
            action: action,
            subject: 'score-recaptcha'
        }, errorType && {
            attributes: {
                hasError: true,
                errorName: errorType
            }
        }));
    }, [
        analyticsClient,
        pageId
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (!enabled) return;
        const initRecaptcha = async ()=>{
            try {
                await scriptLogic.injectRecaptchaScript();
                sendTrackingEvent('loaded-recaptcha');
                if (!displayBadge) scriptLogic.hideRecaptchaBadge();
                setIsLoaded(true);
            } catch (error) {
                const errorMessage = String(error);
                setLoadRecaptchaErrorReason(errorMessage);
                (0, $8f2pb.captureException)(error);
                sendTrackingEvent('load-recaptcha-failed', 'recaptcha-script-error');
            }
        };
        scriptInitializationRef.current = initRecaptcha();
        return ()=>{
            scriptLogic.unloadRecaptcha();
            setLoadRecaptchaErrorReason(undefined);
            scriptInitializationRef.current = undefined;
        };
    }, [
        displayBadge,
        sitekey,
        pageId,
        enabled,
        analyticsClient,
        sendTrackingEvent,
        scriptLogic
    ]);
    const fetchRecaptchaToken = (0, $8ZuGG.useCallback)(async (action)=>{
        var _window_grecaptcha_enterprise, _window_grecaptcha, _window;
        if (!enabled) return '';
        if (scriptInitializationRef.current) await scriptInitializationRef.current;
        if (!((_window = window) === null || _window === void 0 ? void 0 : (_window_grecaptcha = _window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : (_window_grecaptcha_enterprise = _window_grecaptcha.enterprise) === null || _window_grecaptcha_enterprise === void 0 ? void 0 : _window_grecaptcha_enterprise.execute)) {
            (0, $8f2pb.captureRecaptchaException)((0, $eSSTZ.RecaptchaError).fromMessage($bd08fbe74f9726bb$var$RECAPTCHA_ENTERPRISE_EXECUTE_UNAVAILABLE), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-window-error');
            return '';
        }
        try {
            return await window.grecaptcha.enterprise.execute(sitekey, {
                action: action
            });
        } catch (err) {
            (0, $8f2pb.captureRecaptchaException)((0, $eSSTZ.RecaptchaError).fromError(err), {}, 'no_token_score');
            sendTrackingEvent('get-recaptcha-token', 'recaptcha-script-error');
            return '';
        }
    }, [
        enabled,
        sendTrackingEvent,
        sitekey
    ]);
    return {
        isLoaded: isLoaded,
        fetchRecaptchaToken: fetchRecaptchaToken,
        loadRecaptchaErrorReason: loadRecaptchaErrorReason,
        enabled: enabled
    };
};

});



parcelRegister("ciYFg", function(module, exports) {

$parcel$export(module.exports, "LoginTooManyAttemptsRecaptchaContextProvider", function () { return $de8acbc8768941c0$export$b27cbe0302f9b08b; });
$parcel$export(module.exports, "useLoginTooManyAttemptsRecaptchaContext", function () { return $de8acbc8768941c0$export$5c1b73ca6a070fab; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");
const $de8acbc8768941c0$export$d98a10b0f5602870 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $de8acbc8768941c0$export$b27cbe0302f9b08b = ({ children: children })=>{
    const [captchaValue, setCaptchaValue] = (0, $8ZuGG.useState)(null);
    const isRequired = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCaptchaRequired;
    });
    const value = (0, $8ZuGG.useMemo)(()=>({
            isRequired: isRequired,
            captchaValue: captchaValue,
            setCaptchaValue: setCaptchaValue
        }), [
        captchaValue,
        setCaptchaValue,
        isRequired
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($de8acbc8768941c0$export$d98a10b0f5602870.Provider, {
        value: value,
        children: children
    });
};
const $de8acbc8768941c0$export$5c1b73ca6a070fab = ()=>{
    const context = (0, $8ZuGG.useContext)($de8acbc8768941c0$export$d98a10b0f5602870);
    if (!context) throw new Error('useLoginTooManyAttemptsRecaptchaContext must be used within a LoginTooManyAttemptsRecaptchaContextProvider');
    return context;
};

});

parcelRegister("cGo6O", function(module, exports) {
$parcel$export(module.exports, "useRegisterComponent", function () { return (parcelRequire("aavUY")).useRegisterComponent; });
$parcel$export(module.exports, "PageOrchestrator", function () { return (parcelRequire("9xklD")).PageOrchestrator; });
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("4yknl")).useShouldOrchestrate; });
parcelRequire("aavUY");
parcelRequire("eo9iU");
parcelRequire("9xklD");
parcelRequire("fyt8t");

});
parcelRegister("aavUY", function(module, exports) {

$parcel$export(module.exports, "AdvancedCobrandingContext", function () { return $dfad93e4f5be9a22$export$5253ee94c7927efc; });
$parcel$export(module.exports, "useAdvancedCobrandingContext", function () { return $dfad93e4f5be9a22$export$12168a8568483640; });
$parcel$export(module.exports, "useRegisterComponent", function () { return $dfad93e4f5be9a22$export$24eaf8ff4dcf9c58; });

var $8ZuGG = parcelRequire("8ZuGG");
const $dfad93e4f5be9a22$export$5253ee94c7927efc = (0, $8ZuGG.createContext)(undefined);
const $dfad93e4f5be9a22$export$12168a8568483640 = ()=>{
    const context = (0, $8ZuGG.useContext)($dfad93e4f5be9a22$export$5253ee94c7927efc);
    if (!context) throw new Error('useAdvancedCobrandingContext used outside of AdvancedCobrandingContext');
    return context;
};
const $dfad93e4f5be9a22$export$24eaf8ff4dcf9c58 = (name)=>{
    const registered = (0, $8ZuGG.useRef)(false);
    const context = (0, $8ZuGG.useContext)($dfad93e4f5be9a22$export$5253ee94c7927efc);
    (0, $8ZuGG.useEffect)(()=>{
        if (registered.current) return;
        if (!context) return;
        registered.current = true;
        context.registerComponent(name);
    }, [
        context,
        name
    ]);
};

});

parcelRegister("eo9iU", function(module, exports) {

});

parcelRegister("9xklD", function(module, exports) {

$parcel$export(module.exports, "PageOrchestrator", function () { return $9d691ff2a096498c$export$ab5ed25a9459596a; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $cugIF = parcelRequire("cugIF");

var $3ir1n = parcelRequire("3ir1n");

var $aavUY = parcelRequire("aavUY");

var $9VoJB = parcelRequire("9VoJB");

var $9Li6K = parcelRequire("9Li6K");
const $9d691ff2a096498c$export$ab5ed25a9459596a = ({ fallback: fallback, pages: pages, requiredComponents: requiredComponents })=>{
    const [registrationStarted, setRegistrationStarted] = (0, $8ZuGG.useState)(false);
    const [components, setComponents] = (0, $8ZuGG.useState)();
    const { cobranding: cobranding } = (0, $cugIF.useCobranding)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const page = (0, $8ZuGG.useMemo)(()=>{
        return pages.find((page)=>page.cobranding === cobranding);
    }, [
        pages,
        cobranding
    ]);
    const Component = (0, $8ZuGG.useMemo)(()=>{
        return (page === null || page === void 0 ? void 0 : page.Component) || fallback;
    }, [
        page,
        fallback
    ]);
    // The fallback is the base page. This occurs when there is a cobranding defined, but not for the page that the user is requesting
    const isUsingFallback = !(page === null || page === void 0 ? void 0 : page.Component);
    const registerComponent = (0, $8ZuGG.useCallback)((component)=>{
        setComponents((components)=>{
            return components ? [
                ...components,
                component
            ] : [
                component
            ];
        });
    }, []);
    const value = (0, $8ZuGG.useMemo)(()=>({
            components: components,
            registerComponent: registerComponent
        }), [
        components,
        registerComponent
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        setTimeout(()=>setRegistrationStarted(true), 0);
    }, []);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $aavUY.AdvancedCobrandingContext).Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9VoJB.PageGuard), {
            requiredComponents: requiredComponents,
            registrationStarted: registrationStarted,
            skipRequiredChecks: isUsingFallback,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.default), {
                analyticsClient: analyticsClient,
                capabilities: [
                    'non-kirby-code'
                ],
                skipAnalytics: true,
                children: /*#__PURE__*/ (0, $6rcps.jsx)(Component, {})
            })
        })
    });
};

});
parcelRegister("9VoJB", function(module, exports) {

$parcel$export(module.exports, "PageGuard", function () { return $3b0455d380b15e53$export$c2e3d7bea8403012; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $cugIF = parcelRequire("cugIF");

var $aavUY = parcelRequire("aavUY");

var $cufV0 = parcelRequire("cufV0");

var $8f2pb = parcelRequire("8f2pb");
const $3b0455d380b15e53$export$a303b4f7b8d504d8 = 2000;
/**
 * Whether or not to show the missing component error overlay. We do not want to show this in production (to real users).
 * The overlay is for developers to see the missing components and debug the issue
 */ const $3b0455d380b15e53$var$canShowOverlay = false;
const $3b0455d380b15e53$export$c2e3d7bea8403012 = ({ children: children, requiredComponents: requiredComponents, registrationStarted: registrationStarted, skipRequiredChecks: skipRequiredChecks = false })=>{
    const { cobranding: cobranding } = (0, $cugIF.useCobranding)();
    const { components: components } = (0, $aavUY.useAdvancedCobrandingContext)();
    const [registrationTimedOut, setRegistrationTimedOut] = (0, $8ZuGG.useState)(false);
    const missingComponents = (0, $8ZuGG.useMemo)(()=>{
        return requiredComponents.filter((requiredComponent)=>!(components === null || components === void 0 ? void 0 : components.includes(requiredComponent)));
    }, [
        requiredComponents,
        components
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (!registrationStarted) return;
        const timeout = setTimeout(()=>{
            setRegistrationTimedOut(true);
        }, $3b0455d380b15e53$export$a303b4f7b8d504d8);
        return ()=>clearTimeout(timeout);
    }, [
        registrationStarted
    ]);
    const hasRegisteredAllRequiredComponents = missingComponents.length === 0;
    const isWaitingForRegistration = !registrationTimedOut;
    (0, $8ZuGG.useEffect)(()=>{
        if (!hasRegisteredAllRequiredComponents && !isWaitingForRegistration && !$3b0455d380b15e53$var$canShowOverlay) console.warn(`[COBRANDING] ${window.location.pathname} has not registered all required components.`);
    }, [
        cobranding,
        hasRegisteredAllRequiredComponents,
        isWaitingForRegistration
    ]);
    // skipRequiredChecks:
    // We want to skip these checks if we are using a fallback (i.e. a base page/non cobranded page) and we do not want to
    // enforce the required components. This is at least until we either audit all of the fallback pages, or we start
    // dogfooding the cobranding orchestrator in our base pages, to ensure that we are not breaking any pages.
    // hasRegisteredAllRequiredComponents:
    // If all required components have been registered, we can safely render the children without any further checks.
    if (skipRequiredChecks || hasRegisteredAllRequiredComponents) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8ZuGG.Suspense), {
        fallback: /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $6rcps.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
    if (isWaitingForRegistration) // Displays the loading overlay while the page is lazy-loading and while the registration is in progress.
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8ZuGG.Suspense), {
        fallback: /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$LoadingOverlay, {}),
        children: [
            children,
            /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$LoadingOverlay, {})
        ]
    });
    // This handles the case where the registration has timed out and the required components are still not registered
    return /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$PageGuardMissingComponent, {
        canShowOverlay: $3b0455d380b15e53$var$canShowOverlay,
        missingComponents: missingComponents,
        children: children
    });
};
/**
 * Responsible for rendering the children component (which is either the cobranded page or the fallback/non-cobranded/default/base page)
 * and checking that the page includes the components that the relevant page level cobranded config declares that it needs
 * When running locally, it also renders details of the missing components to let the developers know as well as aid with debugging the issue.
 * In production we do not show this to the user.
 * In all cases, we render the children despite it missing some details as a fallback.
 *
 * @note We send an event to Sentry in the case that this component is rendered, because we should _not_ see this in customer facing code.
 */ const $3b0455d380b15e53$var$PageGuardMissingComponent = ({ children: children, canShowOverlay: canShowOverlay, missingComponents: missingComponents })=>{
    const { cobranding: cobranding } = (0, $cugIF.useCobranding)();
    // Generating here so that cobranding does not become a dependency of the useEffect. errorMessage will be, but it won't run again unless the string itself has changed.
    const errorMessage = `Cobranding experience missing required components after registration waiting period ${cobranding}`;
    (0, $8ZuGG.useEffect)(()=>{
        // If we get to this point, it means that after waiting for REGISTRATION_TIMEOUT_MS the required components are still not present
        (0, $8f2pb.captureTaggedException)(new Error(errorMessage), {
            capabilities: [
                'non-kirby-code'
            ],
            tags: {
                cobrandingOrchestrator: 'missing_required_components'
            }
        });
    }, [
        errorMessage
    ]);
    if (canShowOverlay) return /*#__PURE__*/ (0, $6rcps.jsx)("div", {
        "data-testid": "registration-complete",
        children: /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$MissingComponentErrorDisplay, {
            cobranding: cobranding,
            missingComponents: missingComponents,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8ZuGG.Suspense), {
        fallback: /*#__PURE__*/ (0, $6rcps.jsx)($3b0455d380b15e53$var$LoadingOverlay, {}),
        children: /*#__PURE__*/ (0, $6rcps.jsx)("div", {
            style: {
                height: '100%'
            },
            "data-testid": "registration-complete",
            children: children
        })
    });
};
const $3b0455d380b15e53$var$MissingComponentErrorDisplay = ({ cobranding: cobranding, missingComponents: missingComponents, children: children })=>{
    const search = new URLSearchParams(window.location.search);
    search.delete('token');
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                style: {
                    position: 'fixed',
                    zIndex: 100,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '1rem',
                    alignItems: 'center',
                    justifyContent: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                        style: {
                            position: 'fixed',
                            zIndex: -1,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            opacity: 0.25,
                            backgroundColor: '#FFADB0'
                        }
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                        style: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '1rem',
                            padding: '4rem',
                            borderRadius: '0.5rem',
                            background: '#FFADB0',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)("h2", {
                                        style: {
                                            fontWeight: 'bold'
                                        },
                                        children: "Advanced Cobranding"
                                    }),
                                    /*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                        children: "Unable to render page due to missing required components:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.1rem',
                                    padding: '1rem',
                                    borderRadius: '0.25rem',
                                    color: 'white',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#c92216'
                                },
                                children: missingComponents.map((component)=>/*#__PURE__*/ (0, $6rcps.jsx)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: /*#__PURE__*/ (0, $6rcps.jsx)("span", {
                                            "data-testid": "missing-component",
                                            children: component
                                        })
                                    }, component))
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.25rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsxs)("p", {
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                                children: "Cobranding"
                                            }),
                                            ": ",
                                            cobranding
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $6rcps.jsxs)("p", {
                                        style: {
                                            margin: 0,
                                            display: 'flex',
                                            flexWrap: 'wrap'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                                children: "URL"
                                            }),
                                            ": ",
                                            `${window.location.pathname}?${search}`
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
const $3b0455d380b15e53$var$LoadingOverlay = ()=>/*#__PURE__*/ (0, $6rcps.jsx)("div", {
        style: {
            position: 'fixed',
            top: 0,
            zIndex: 2,
            pointerEvents: 'none',
            left: 0,
            right: 0,
            bottom: 0,
            flexDirection: 'column',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white'
        },
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {})
    });

});


parcelRegister("fyt8t", function(module, exports) {
$parcel$export(module.exports, "useShouldOrchestrate", function () { return (parcelRequire("4yknl")).useShouldOrchestrate; });
parcelRequire("4yknl");

});
parcelRegister("4yknl", function(module, exports) {

$parcel$export(module.exports, "useShouldOrchestrate", function () { return $45f95a2afa71b5c4$export$eab7ff4ea760bf6a; });

var $cugIF = parcelRequire("cugIF");
const $45f95a2afa71b5c4$export$eab7ff4ea760bf6a = ()=>{
    const { cobranding: cobranding } = (0, $cugIF.useCobranding)();
    const forceOrchestration = (0, $cugIF.isAdvancedCobranding)(cobranding);
    return forceOrchestration;
};

});




parcelRegister("4j6Os", function(module, exports) {

$parcel$export(module.exports, "LoginMarketingConsent", function () { return $0238a61448642865$export$7f3ec3ad6a2266d2; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $ajWBM = parcelRequire("ajWBM");

var $kdW7h = parcelRequire("kdW7h");
let $0238a61448642865$var$_ = (t)=>t, $0238a61448642865$var$t;
const $0238a61448642865$var$StyledMarketingConsentWrapper = (0, $9Vz68.default).div($0238a61448642865$var$t || ($0238a61448642865$var$t = $0238a61448642865$var$_`
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $0238a61448642865$export$7f3ec3ad6a2266d2 = ()=>{
    (0, $aavUY.useRegisterComponent)($0238a61448642865$export$7f3ec3ad6a2266d2.name);
    const config = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_marketingConsent;
        return (_state_marketingConsent = state.marketingConsent) === null || _state_marketingConsent === void 0 ? void 0 : _state_marketingConsent.config;
    });
    const isUsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isV2UsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const { setMarketingConsent: setMarketingConsent } = (0, $ajWBM.useMarketingConsentContext)();
    if (!isUsernameChecked && !isV2UsernameChecked) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)($0238a61448642865$var$StyledMarketingConsentWrapper, {
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $kdW7h.default), {
            config: config,
            onConsentChange: setMarketingConsent
        })
    });
};

});
parcelRegister("ajWBM", function(module, exports) {

$parcel$export(module.exports, "MarketingConsentContextProvider", function () { return $f52b4cca952a3f7b$export$a01df84c5b0bda88; });
$parcel$export(module.exports, "useMarketingConsentContext", function () { return $f52b4cca952a3f7b$export$3bf9eae4cd157a8c; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
const $f52b4cca952a3f7b$var$MarketingConsentContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $f52b4cca952a3f7b$export$a01df84c5b0bda88 = ({ children: children })=>{
    const [marketingConsent, setMarketingConsent] = (0, $8ZuGG.useState)(undefined);
    const value = (0, $8ZuGG.useMemo)(()=>({
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        setMarketingConsent
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($f52b4cca952a3f7b$var$MarketingConsentContext.Provider, {
        value: value,
        children: children
    });
};
const $f52b4cca952a3f7b$export$3bf9eae4cd157a8c = ()=>{
    const context = (0, $8ZuGG.useContext)($f52b4cca952a3f7b$var$MarketingConsentContext);
    if (!context) throw new Error('useMarketingConsentContext must be used within MarketingConsentContextProvider');
    return context;
};

});

parcelRegister("kdW7h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49839fe2300092c1$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $FXESS = parcelRequire("FXESS");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $9Vz68 = parcelRequire("9Vz68");

var $iSD9t = parcelRequire("iSD9t");

var $7OAGr = parcelRequire("7OAGr");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
let $49839fe2300092c1$var$_ = (t)=>t, $49839fe2300092c1$var$t;
const $49839fe2300092c1$var$MarketingConsentWrapper = (0, $9Vz68.default).div($49839fe2300092c1$var$t || ($49839fe2300092c1$var$t = $49839fe2300092c1$var$_`
  margin-top: ${0}px;
  div {
    align-items: flex-start;
  }
  [aria-label='checkboxIcon'] {
    margin-left: -8px;
    margin-top: -4px;
  }
  label {
    font-size: 12px;
    line-height: 16px;
    color: ${0};
  }
`), (0, $5b7Z4.gridSize)(), (0, $kTdw7).N300);
const $49839fe2300092c1$var$MarketingConsentCheckbox = ({ className: className, config: config, forceShow: forceShow, onConsentChange: onConsentChange })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const previousConfig = (0, $7AZRg.usePrevious)(config);
    const consentText = formatMessage((0, $7OAGr.default).marketingConsentPromptText);
    const notifyConsentChange = (0, $8ZuGG.useCallback)(()=>{
        let consent = {
            state: 'not_shown'
        };
        if (config && config.showCheckbox) consent = {
            state: 'unchecked',
            consentText: consentText
        };
        onConsentChange(consent);
    }, [
        config,
        consentText,
        onConsentChange
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        notifyConsentChange();
    }, [
        notifyConsentChange
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (previousConfig !== config) notifyConsentChange();
    }, [
        previousConfig,
        config,
        notifyConsentChange
    ]);
    const consentCheckboxChanged = (e)=>{
        const state = e.target.checked ? 'checked' : 'unchecked';
        onConsentChange({
            state: state,
            consentText: consentText
        });
    };
    if (!config || !config.showCheckbox && !forceShow) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)($49839fe2300092c1$var$MarketingConsentWrapper, {
        className: className,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $FXESS.default), {
            testId: "marketing-consent-checkbox",
            id: "marketing-consent-checkbox",
            label: consentText,
            onChange: consentCheckboxChanged
        })
    });
};
var $49839fe2300092c1$export$2e2bcd8739ae039 = $49839fe2300092c1$var$MarketingConsentCheckbox;

});
parcelRegister("FXESS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e21b5ea75a18e2$export$2e2bcd8739ae039; });
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $1Muvn = parcelRequire("1Muvn");

var $30M5w = parcelRequire("30M5w");

var $6Z2qL = parcelRequire("6Z2qL");
var $6J3Pz = parcelRequire("6J3Pz");
var $dm2KY = parcelRequire("dm2KY");
var $jMOFV = parcelRequire("jMOFV");
var $07e21b5ea75a18e2$var$_excluded = [
    "isChecked",
    "isDisabled",
    "isInvalid",
    "defaultChecked",
    "isIndeterminate",
    "onChange",
    "analyticsContext",
    "label",
    "name",
    "value",
    "isRequired",
    "testId",
    "xcss",
    "className"
];
/**
 * Using `cssMap` to avoid a Compiled bug with the transformed styles.
 * It was using a CSS variable for the outline template string,
 * which broke because of the use of a sibling selector.
 *
 * Related to: https://github.com/atlassian-labs/compiled/pull/1795
 *
 * Using `cssMap` seems to be a workaround for this.
 */ var $07e21b5ea75a18e2$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef78r4n _1h6r8r4n _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
};
/**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ var $07e21b5ea75a18e2$var$Checkbox = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function Checkbox(_ref, ref) {
    var isCheckedProp = _ref.isChecked, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isInvalid = _ref.isInvalid, isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, _ref$isIndeterminate = _ref.isIndeterminate, isIndeterminate = _ref$isIndeterminate === void 0 ? false : _ref$isIndeterminate, onChangeProps = _ref.onChange, analyticsContext = _ref.analyticsContext, label = _ref.label, name = _ref.name, value = _ref.value, isRequired = _ref.isRequired, testId = _ref.testId, xcss = _ref.xcss, className = _ref.className, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $07e21b5ea75a18e2$var$_excluded);
    var _useState = (0, $8ZuGG.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isCheckedState = _useState2[0], setIsCheckedState = _useState2[1];
    var onChange = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    var onChangeAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "17.1.13"
    });
    var internalRef = (0, $8ZuGG.useRef)(null);
    var mergedRefs = (0, $30M5w.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    var isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $8ZuGG.useEffect)(function() {
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $6J3Pz.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? "".concat(rest.id, "-label") : undefined,
        testId: testId && "".concat(testId, "--checkbox-label"),
        xcss: xcss
    }, /*#__PURE__*/ $8ZuGG.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4hjl.default)([
            $07e21b5ea75a18e2$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && "".concat(testId, "--hidden-checkbox"),
        "data-invalid": isInvalid ? 'true' : undefined
    })), /*#__PURE__*/ $8ZuGG.createElement((0, $6Z2qL.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $8ZuGG.createElement((0, $dm2KY.default), null, label, isRequired && /*#__PURE__*/ $8ZuGG.createElement((0, $jMOFV.default), null)));
}));
$07e21b5ea75a18e2$var$Checkbox.displayName = 'Checkbox';
var $07e21b5ea75a18e2$export$2e2bcd8739ae039 = $07e21b5ea75a18e2$var$Checkbox;

});
parcelRegister("6Z2qL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $515a5342a50acf3b$export$2e2bcd8739ae039; });
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");


var $lByEw = parcelRequire("lByEw");

var $i2LcI = parcelRequire("i2LcI");
function $515a5342a50acf3b$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $i2LcI.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $8ZuGG.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $8ZuGG.createElement("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $i2LcI.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ $8ZuGG.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ $8ZuGG.createElement("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ var $515a5342a50acf3b$var$CheckboxIcon = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var isIndeterminate = _ref.isIndeterminate, isChecked = _ref.isChecked;
    var icon = (0, $8ZuGG.useMemo)(function() {
        return $515a5342a50acf3b$var$getIcon(isIndeterminate, isChecked);
    }, [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $lByEw.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ $8ZuGG.createElement("g", {
        fillRule: "evenodd"
    }, // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $i2LcI.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ $8ZuGG.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5"
    }) : /*#__PURE__*/ $8ZuGG.createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $515a5342a50acf3b$export$2e2bcd8739ae039 = $515a5342a50acf3b$var$CheckboxIcon;

});
parcelRegister("lByEw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fba7eef23aaa3abf$export$2e2bcd8739ae039; });
/* svg.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $fba7eef23aaa3abf$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
var $fba7eef23aaa3abf$var$svgStyles = null;
/**
 * __SVG__
 *
 * @deprecated Custom SVG is deprecated and will be removed from `atlaskit/icon` in an upcoming major release. Please use either an existing icon from @atlaskit/icon or @atlaskit/icon-lab, or contributing to @atlaskit/icon-lab directly. For third party logos, use an SVG element along with a label.
 *
 * An icon is used as a visual representation of common actions and commands to provide context.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-svgs)
 */ var $fba7eef23aaa3abf$var$SVG = /*#__PURE__*/ (0, $8ZuGG.memo)(function SVG(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, label = _ref.label, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, testId = _ref.testId, children = _ref.children;
    return /*#__PURE__*/ $8ZuGG.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            fill: secondaryColor
        },
        "data-testid": testId,
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw _vc881r31",
            $fba7eef23aaa3abf$var$sizeStyles[size]
        ])
    }, children);
});
var $fba7eef23aaa3abf$export$2e2bcd8739ae039 = $fba7eef23aaa3abf$var$SVG;

});


parcelRegister("6J3Pz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e59eac1dea722ef$export$2e2bcd8739ae039; });
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $gHbw4 = parcelRequire("gHbw4");
var $4e59eac1dea722ef$var$baseStyles = null;
var $4e59eac1dea722ef$var$textLabelLayoutStyles = null;
var $4e59eac1dea722ef$var$disabledStyles = null;
var $4e59eac1dea722ef$var$labelStyles = null;
function $4e59eac1dea722ef$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, isDisabled = _ref.isDisabled, testId = _ref.testId, label = _ref.label, id = _ref.id, xcss = _ref.xcss;
    return /*#__PURE__*/ $8ZuGG.createElement("label", {
        className: (0, $c4hjl.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazovqm _80om73ad",
            label && "_zulp1te3 _yv0ey09t",
            isDisabled && "_syaz7wap _80om13gf",
            "_h5e31kd8 _1nzs1kc0 _1esz1j4g _yp0j1ehr _ay2w1ouc _d51u12ci _phftddza _1g1fe69j _l6wk1j4g _1dik1ehr _1sfg1380 _fpdj1ouc _1yjc3zdg _oaj1ddza _1j3h1380 _eawbxz7c _1rdaeh7q _18q0snw8 _13hr1j28",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        style: {
            "--_5xk3r4": (0, $bT1Ur.default)("var(--ds-text, ".concat((0, $gHbw4.N900), ")")),
            "--_1l71759": (0, $bT1Ur.default)("var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")),
            "--_1ynhf1h": (0, $bT1Ur.default)("var(--ds-text-disabled, ".concat((0, $gHbw4.N80), ")")),
            "--_4mkb4g": (0, $bT1Ur.default)("var(--ds-background-input, ".concat((0, $gHbw4.N10), ")")),
            "--_1cd0fcx": (0, $bT1Ur.default)("var(--ds-background-input-pressed, ".concat((0, $gHbw4.B50), ")")),
            "--_1gcp7nr": (0, $bT1Ur.default)("var(--ds-background-selected-bold, ".concat((0, $gHbw4.B400), ")")),
            "--_14y1fod": (0, $bT1Ur.default)("var(--ds-background-selected-bold-hovered, ".concat((0, $gHbw4.B300), ")")),
            "--_r5pknd": (0, $bT1Ur.default)("var(--ds-background-disabled, ".concat((0, $gHbw4.N20), ")")),
            "--_1z08gfx": (0, $bT1Ur.default)("var(--ds-background-input-hovered, ".concat((0, $gHbw4.N30), ")")),
            "--_vnm8xo": (0, $bT1Ur.default)("var(--ds-border-input, ".concat((0, $gHbw4.N100), ")")),
            "--_rczcge": (0, $bT1Ur.default)("var(--ds-border, ".concat((0, $gHbw4.B50), ")")),
            "--_1i4xulb": (0, $bT1Ur.default)("var(--ds-border-danger, ".concat((0, $gHbw4.R300), ")")),
            "--_xjqa3d": (0, $bT1Ur.default)("var(--ds-border-focused, ".concat((0, $gHbw4.B200), ")")),
            "--_uq1ko9": (0, $bT1Ur.default)("var(--ds-icon-inverse, ".concat((0, $gHbw4.B400), ")")),
            "--_jf353p": (0, $bT1Ur.default)("var(--ds-icon-inverse, ".concat((0, $gHbw4.N10), ")")),
            "--_1xmcmw9": (0, $bT1Ur.default)("var(--ds-icon-disabled, ".concat((0, $gHbw4.N70), ")"))
        }
    }, children);
}

});
parcelRegister("gHbw4", function(module, exports) {

$parcel$export(module.exports, "R300", function () { return $c27998615a0a7b2c$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $c27998615a0a7b2c$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "B50", function () { return $c27998615a0a7b2c$export$226de0355ed012f8; });
$parcel$export(module.exports, "B200", function () { return $c27998615a0a7b2c$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $c27998615a0a7b2c$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $c27998615a0a7b2c$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N10", function () { return $c27998615a0a7b2c$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $c27998615a0a7b2c$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $c27998615a0a7b2c$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N70", function () { return $c27998615a0a7b2c$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $c27998615a0a7b2c$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N100", function () { return $c27998615a0a7b2c$export$d6447c357493214f; });
$parcel$export(module.exports, "N900", function () { return $c27998615a0a7b2c$export$fbda843f0a27fe96; });
// Reds
var $c27998615a0a7b2c$export$4b84fd0e2c617bd = '#FFEBE6';
var $c27998615a0a7b2c$export$b34b069eff244586 = '#FFBDAD';
var $c27998615a0a7b2c$export$be802dd0d8b57f35 = '#FF8F73';
var $c27998615a0a7b2c$export$60847d42f9da92a6 = '#FF7452';
var $c27998615a0a7b2c$export$4a7404f376229999 = '#FF5630';
var $c27998615a0a7b2c$export$2010d0fb4295b346 = '#DE350B';
var $c27998615a0a7b2c$export$2837b5a1a71d5c02 = '#BF2600';
var $c27998615a0a7b2c$export$8d9596b529bbb9cf = '#FFFAE6';
var $c27998615a0a7b2c$export$41060a744ab0b7ae = '#FFF0B3';
var $c27998615a0a7b2c$export$1cc05bbbf340e559 = '#FFE380';
var $c27998615a0a7b2c$export$5aae31392d72caaa = '#FFC400';
var $c27998615a0a7b2c$export$c6930421db9fa514 = '#FFAB00';
var $c27998615a0a7b2c$export$59619663aa6500fb = '#FF991F';
var $c27998615a0a7b2c$export$874739ea9e379ab6 = '#FF8B00';
var $c27998615a0a7b2c$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $c27998615a0a7b2c$export$69a3bf21b9686c2b = '#ABF5D1';
var $c27998615a0a7b2c$export$afbce1382ec95f73 = '#79F2C0';
var $c27998615a0a7b2c$export$747d86715d4175de = '#57D9A3';
var $c27998615a0a7b2c$export$940e1f69e873f202 = '#36B37E';
var $c27998615a0a7b2c$export$a49394138f7b8e85 = '#00875A';
var $c27998615a0a7b2c$export$6fa04827ac68a4fb = '#006644';
var $c27998615a0a7b2c$export$226de0355ed012f8 = '#DEEBFF';
var $c27998615a0a7b2c$export$8c13c2ee36917869 = '#B3D4FF';
var $c27998615a0a7b2c$export$ecfc1dff386a3e7a = '#4C9AFF';
var $c27998615a0a7b2c$export$215b7063051591f1 = '#2684FF';
var $c27998615a0a7b2c$export$e62e8919cca44969 = '#0065FF';
var $c27998615a0a7b2c$export$b3de0ae08da2ce64 = '#0052CC';
var $c27998615a0a7b2c$export$a6ee3d71bc067634 = '#0747A6';
var $c27998615a0a7b2c$export$67f15409e87642a1 = '#669DF1';
var $c27998615a0a7b2c$export$f0539dbc42dbb067 = '#8FB8F6';
var $c27998615a0a7b2c$export$363e4475840015bb = '#EAE6FF';
var $c27998615a0a7b2c$export$4b0a4417ed59760f = '#C0B6F2';
var $c27998615a0a7b2c$export$6011520a64d9a187 = '#998DD9';
var $c27998615a0a7b2c$export$a7175d4e9206bc80 = '#8777D9';
var $c27998615a0a7b2c$export$b48405b95304b5a1 = '#6554C0';
var $c27998615a0a7b2c$export$c71e4279dd54a18d = '#5243AA';
var $c27998615a0a7b2c$export$147899de772240ec = '#403294';
var $c27998615a0a7b2c$export$2cf711fe14c66f06 = '#E6FCFF';
var $c27998615a0a7b2c$export$7a8f4d33f6f9772c = '#B3F5FF';
var $c27998615a0a7b2c$export$776c9c497ef08533 = '#79E2F2';
var $c27998615a0a7b2c$export$69cb3ca10c1e330e = '#00C7E6';
var $c27998615a0a7b2c$export$9dc1ef0f3f48059b = '#00B8D9';
var $c27998615a0a7b2c$export$7c835c78b6fcdef8 = '#00A3BF';
var $c27998615a0a7b2c$export$6036577f95c3877e = '#008DA6';
var $c27998615a0a7b2c$export$29a4f05edc054374 = '#FFFFFF';
var $c27998615a0a7b2c$export$e655ef011c4aa1a2 = '#FAFBFC';
var $c27998615a0a7b2c$export$9fdfb749e33cdf97 = '#F4F5F7';
var $c27998615a0a7b2c$export$3e51e8f1440314ba = '#EBECF0';
var $c27998615a0a7b2c$export$1ce2d1575d444ceb = '#DFE1E6';
var $c27998615a0a7b2c$export$8754fc7e6d8b3000 = '#C1C7D0';
var $c27998615a0a7b2c$export$c2e91cbeada39b8b = '#B3BAC5';
var $c27998615a0a7b2c$export$5f71e19f3a7ad9de = '#A5ADBA';
var $c27998615a0a7b2c$export$eaa8c8a70ac22806 = '#97A0AF';
var $c27998615a0a7b2c$export$7c87d337fb91a97d = '#8993A4';
var $c27998615a0a7b2c$export$d6447c357493214f = '#7A869A';
var $c27998615a0a7b2c$export$f563ee71e9ee74cd = '#6B778C';
var $c27998615a0a7b2c$export$e2ef2124cf4024b1 = '#5E6C84';
var $c27998615a0a7b2c$export$eece5f492e429f08 = '#505F79';
var $c27998615a0a7b2c$export$c39c0fe0f26207ae = '#42526E';
var $c27998615a0a7b2c$export$7090862dc3038a9f = '#344563';
var $c27998615a0a7b2c$export$ad0bacf983b7ddaa = '#253858';
var $c27998615a0a7b2c$export$7d61b15e0da132af = '#172B4D';
var $c27998615a0a7b2c$export$fbda843f0a27fe96 = '#091E42';
var $c27998615a0a7b2c$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $c27998615a0a7b2c$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $c27998615a0a7b2c$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $c27998615a0a7b2c$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $c27998615a0a7b2c$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $c27998615a0a7b2c$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $c27998615a0a7b2c$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $c27998615a0a7b2c$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $c27998615a0a7b2c$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $c27998615a0a7b2c$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $c27998615a0a7b2c$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $c27998615a0a7b2c$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $c27998615a0a7b2c$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $c27998615a0a7b2c$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $c27998615a0a7b2c$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $c27998615a0a7b2c$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $c27998615a0a7b2c$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $c27998615a0a7b2c$export$2f6319cf7d736c2a = '#E6EDFA';
var $c27998615a0a7b2c$export$95126bc8884d6634 = '#DCE5F5';
var $c27998615a0a7b2c$export$8338d8c35d44ff1 = '#CED9EB';
var $c27998615a0a7b2c$export$5368d76ae4fbbda7 = '#B8C7E0';
var $c27998615a0a7b2c$export$9f0a771d16ec8d36 = '#ABBBD6';
var $c27998615a0a7b2c$export$abcf8c38338b4aa5 = '#9FB0CC';
var $c27998615a0a7b2c$export$97e81faa16a182c7 = '#8C9CB8';
var $c27998615a0a7b2c$export$bfe21c59123ecf33 = '#7988A3';
var $c27998615a0a7b2c$export$ee82aa2ea6a1558 = '#67758F';
var $c27998615a0a7b2c$export$682927c6ed76be02 = '#56637A';
var $c27998615a0a7b2c$export$91fd9994c5be9757 = '#455166';
var $c27998615a0a7b2c$export$d281fbfe3cff2df6 = '#3B475C';
var $c27998615a0a7b2c$export$3902c91d8b98a753 = '#313D52';
var $c27998615a0a7b2c$export$8e8133c1ba5845b5 = '#283447';
var $c27998615a0a7b2c$export$33ff357f6620b39 = '#202B3D';
var $c27998615a0a7b2c$export$633847cf062b69e0 = '#1B2638';
var $c27998615a0a7b2c$export$9776a6e503bdbf76 = '#121A29';
var $c27998615a0a7b2c$export$6c813d5160dff5db = '#0E1624';
var $c27998615a0a7b2c$export$3d4f271a500072a = '#0D1424';
var $c27998615a0a7b2c$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $c27998615a0a7b2c$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $c27998615a0a7b2c$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $c27998615a0a7b2c$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $c27998615a0a7b2c$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $c27998615a0a7b2c$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $c27998615a0a7b2c$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $c27998615a0a7b2c$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $c27998615a0a7b2c$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $c27998615a0a7b2c$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $c27998615a0a7b2c$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $c27998615a0a7b2c$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $c27998615a0a7b2c$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $c27998615a0a7b2c$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $c27998615a0a7b2c$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $c27998615a0a7b2c$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $c27998615a0a7b2c$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $c27998615a0a7b2c$export$d2adc5dedf09fced = '#292A2E';
var $c27998615a0a7b2c$export$f51762073d2bb381 = '#94C748';
var $c27998615a0a7b2c$export$95e26d54def96891 = '#B3DF72';

});


parcelRegister("dm2KY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b8f77d3b710c285$export$2e2bcd8739ae039; });
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $9b8f77d3b710c285$var$labelTextStyles = null;
function $9b8f77d3b710c285$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        className: (0, $c4hjl.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
}

});

parcelRegister("jMOFV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e679cf0b067907c7$export$2e2bcd8739ae039; });
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $gHbw4 = parcelRequire("gHbw4");
var $e679cf0b067907c7$var$requiredIndicatorStyles = null;
function $e679cf0b067907c7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "aria-hidden": true,
        className: (0, $c4hjl.default)([
            "_syaz1ml5 _bozgv77o"
        ]),
        style: {
            "--_1xw92dq": (0, $bT1Ur.default)("var(--ds-text-danger, ".concat((0, $gHbw4.R500), ")"))
        }
    }, "*");
}

});


parcelRegister("7OAGr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $191150642ba5c931$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $191150642ba5c931$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    marketingConsentPromptText: {
        id: 'marketing.consent.text',
        defaultMessage: 'Yes! Send me news and offers from Atlassian about products, events, and more.',
        description: ''
    }
});

});



parcelRegister("lThM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fefc8589746da7f2$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $bl8w7 = parcelRequire("bl8w7");

var $bmth4 = parcelRequire("bmth4");

var $1S0T5 = parcelRequire("1S0T5");

var $57fzU = parcelRequire("57fzU");
var $fefc8589746da7f2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $fefc8589746da7f2$var$_excluded2 = [
    "className"
];
var $fefc8589746da7f2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $fefc8589746da7f2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $fefc8589746da7f2$var$_excluded2);
    var resolvedStyles = (0, $57fzU.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $bl8w7.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $fefc8589746da7f2$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1S0T5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1S0T5.isSurfaceColorToken)(backgroundColor) && (0, $1S0T5.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1S0T5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1S0T5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1S0T5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1S0T5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1S0T5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1S0T5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1S0T5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $bl8w7.jsx)((0, $bmth4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $fefc8589746da7f2$export$2e2bcd8739ae039 = $fefc8589746da7f2$export$e71c4d32a2263218;
var $fefc8589746da7f2$var$baseStyles = (0, $bl8w7.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});

parcelRegister("kdV6G", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3a140a09871a32d$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $93Imk = parcelRequire("93Imk");

var $elF0p = parcelRequire("elF0p");
var $1VVi7 = parcelRequire("1VVi7");

var $5b7Z4 = parcelRequire("5b7Z4");
let $b3a140a09871a32d$var$_ = (t)=>t, $b3a140a09871a32d$var$t;
const $b3a140a09871a32d$var$AccountEnvSelectorWrapper = (0, $9Vz68.default).div($b3a140a09871a32d$var$t || ($b3a140a09871a32d$var$t = $b3a140a09871a32d$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $b3a140a09871a32d$export$f6c6978db589fd79 = [
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "atlassian-cloud-label",
            defaultMessage: "Atlassian Cloud",
            description: "Label for selecting the Atlassian Cloud environment"
        }),
        value: 'atlassian-cloud'
    },
    {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "atlassian-isolated-cloud-label",
            defaultMessage: "Atlassian Isolated Cloud",
            description: "Label for selecting the Atlassian Isolated Cloud environment"
        }),
        value: 'atlassian-isolated-cloud'
    }
];
const $b3a140a09871a32d$var$AccountEnvSelector = ({ isHidden: isHidden = false, options: options, onSelectEnvChange: onSelectEnvChange, fieldError: fieldError, isRequired: isRequired, isInvalid: isInvalid })=>{
    if (isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($b3a140a09871a32d$var$AccountEnvSelectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $elF0p.Label), {
        htmlFor: "account-env-selector",
        "aria-required": isRequired,
        "aria-label": "Environment",
        id: "account-env-selector-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
        id: "account-env-selector-label",
        defaultMessage: "Environment",
        description: "Label for the account environment selector"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1VVi7.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $93Imk.default), {
        placeholder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gGDrC.default), {
            id: "account-env-selector-placeholder",
            defaultMessage: "Select Environment",
            description: "Placeholder for the account env selector"
        }),
        isRequired: isRequired,
        options: options,
        isClearable: false,
        inputId: "account-env-selector",
        testId: "account-env-selector-idf-testid",
        onChange: (selected)=>onSelectEnvChange === null || onSelectEnvChange === void 0 ? void 0 : onSelectEnvChange(selected ? selected.value : ''),
        isInvalid: isInvalid,
        invalidMessage: fieldError
    }));
};
var $b3a140a09871a32d$export$2e2bcd8739ae039 = $b3a140a09871a32d$var$AccountEnvSelector;

});
parcelRegister("93Imk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6986cdab8f900789$export$2e2bcd8739ae039; });
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $4v0fZ = parcelRequire("4v0fZ");
var $aQLTK = parcelRequire("aQLTK");
var $6tnxI = parcelRequire("6tnxI");

var $dN8LZ = parcelRequire("dN8LZ");

var $8a92z = parcelRequire("8a92z");
var $6986cdab8f900789$var$packageName = "@atlaskit/select";
var $6986cdab8f900789$var$packageVersion = "21.2.7";
var $6986cdab8f900789$export$d1de3b251ccaa8a3 = (0, $8a92z.default)((0, $dN8LZ.default));
var $6986cdab8f900789$var$createAndFireEventOnAtlaskit = (0, $4v0fZ.default)('atlaskit');
var $6986cdab8f900789$var$Select = (0, $aQLTK.default)({
    componentName: 'select',
    packageName: $6986cdab8f900789$var$packageName,
    packageVersion: $6986cdab8f900789$var$packageVersion
})((0, $6tnxI.default)({
    onChange: $6986cdab8f900789$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $6986cdab8f900789$var$packageName,
            packageVersion: $6986cdab8f900789$var$packageVersion
        }
    })
})($6986cdab8f900789$export$d1de3b251ccaa8a3));
var $6986cdab8f900789$export$2e2bcd8739ae039 = $6986cdab8f900789$var$Select;

});
parcelRegister("4v0fZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $346a41b437762d7f$export$2e2bcd8739ae039; });
var $346a41b437762d7f$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};

});

parcelRegister("aQLTK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e63ea44ec8d947c$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $bAzNa = parcelRequire("bAzNa");
var $7e63ea44ec8d947c$var$_excluded = [
    "analyticsContext"
];
function $7e63ea44ec8d947c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7e63ea44ec8d947c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7e63ea44ec8d947c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7e63ea44ec8d947c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7e63ea44ec8d947c$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $7e63ea44ec8d947c$var$_excluded);
            var analyticsData = (0, $8ZuGG.useMemo)(function() {
                return $7e63ea44ec8d947c$var$_objectSpread($7e63ea44ec8d947c$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bAzNa.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $7e63ea44ec8d947c$export$2e2bcd8739ae039 = $7e63ea44ec8d947c$var$withAnalyticsContext;

});
parcelRegister("bAzNa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86fed20c428d42c5$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");

var $6AZom = parcelRequire("6AZom");

var $lmczz = parcelRequire("lmczz");

var $3gXSz = parcelRequire("3gXSz");
var $86fed20c428d42c5$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var isModernContext = (0, $6AZom.default) || (0, $i2LcI.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $3gXSz.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lmczz.default), props);
};
var $86fed20c428d42c5$export$2e2bcd8739ae039 = $86fed20c428d42c5$var$ExportedAnalyticsContext;

});
parcelRegister("6AZom", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cd5ba08260a9a5d$export$2e2bcd8739ae039; });

var $1RdT6 = parcelRequire("1RdT6");
var $4cd5ba08260a9a5d$var$_process$env;
var /// <reference types="node" />
$4cd5ba08260a9a5d$export$2e2bcd8739ae039 = typeof $1RdT6 !== 'undefined' && $1RdT6 !== null && (($4cd5ba08260a9a5d$var$_process$env = {}, $4cd5ba08260a9a5d$var$_process$env === void 0) ? void 0 : $4cd5ba08260a9a5d$var$_process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);

});

parcelRegister("lmczz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8c567bde98d7570$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $6CJPF = parcelRequire("6CJPF");

var $akh0H = parcelRequire("akh0H");
function $f8c567bde98d7570$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $f8c567bde98d7570$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $f8c567bde98d7570$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f8c567bde98d7570$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f8c567bde98d7570$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($6CJPF))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($6CJPF))).func
};
var $f8c567bde98d7570$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f8c567bde98d7570$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, AnalyticsContext);
        _this = $f8c567bde98d7570$var$_callSuper(this, AnalyticsContext, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f8c567bde98d7570$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f8c567bde98d7570$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(AnalyticsContext, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $akh0H.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
}((0, $8ZuGG.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($f8c567bde98d7570$var$AnalyticsContext, "contextTypes", $f8c567bde98d7570$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($f8c567bde98d7570$var$AnalyticsContext, "childContextTypes", $f8c567bde98d7570$var$ContextTypes);
var $f8c567bde98d7570$export$2e2bcd8739ae039 = $f8c567bde98d7570$var$AnalyticsContext;

});

parcelRegister("3gXSz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26215074bccb6986$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $akh0H = parcelRequire("akh0H");

var $ltvlR = parcelRequire("ltvlR");

var $gCnIo = parcelRequire("gCnIo");
var $26215074bccb6986$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $gCnIo.useTrackedRef)(data);
    var _useAnalyticsContext = (0, $ltvlR.useAnalyticsContext)(), getAtlaskitAnalyticsEventHandlers = _useAnalyticsContext.getAtlaskitAnalyticsEventHandlers, getOriginalAnalyticsContext = _useAnalyticsContext.getAtlaskitAnalyticsContext;
    var getAtlaskitAnalyticsContext = (0, $8ZuGG.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(getOriginalAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    var value = (0, $8ZuGG.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }, [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $akh0H.default).Provider, {
        value: value
    }, children);
};
var $26215074bccb6986$export$2e2bcd8739ae039 = $26215074bccb6986$var$AnalyticsContext;

});



parcelRegister("6tnxI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b67b6a54fa3e896$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $gvAuA = parcelRequire("gvAuA");

var $dtIdF = parcelRequire("dtIdF");
var $4b67b6a54fa3e896$var$withAnalyticsEvents = function withAnalyticsEvents() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function(WrappedComponent) {
        var WithAnalyticsEvents = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
            var _usePatchedProps = (0, $dtIdF.usePatchedProps)(createEventMap, props), patchedEventProps = _usePatchedProps.patchedEventProps;
            var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, props, patchedEventProps, {
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            }));
        });
        WithAnalyticsEvents.displayName = "WithAnalyticsEvents(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsEvents;
    };
};
var $4b67b6a54fa3e896$export$2e2bcd8739ae039 = $4b67b6a54fa3e896$var$withAnalyticsEvents;

});
parcelRegister("dtIdF", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", function () { return $9d0048da11212002$export$9ebb5a84d17e5d18; });

var $6bkHe = parcelRequire("6bkHe");

var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $gvAuA = parcelRequire("gvAuA");
function $9d0048da11212002$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d0048da11212002$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d0048da11212002$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d0048da11212002$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9d0048da11212002$export$9ebb5a84d17e5d18() {
    var createEventMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wrappedComponentProps = arguments.length > 1 ? arguments[1] : undefined;
    var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var handlerCache = (0, $8ZuGG.useRef)({});
    var patchedProps = (0, $8ZuGG.useMemo)(function() {
        var cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter(function(key) {
            return !(key in createEventMap);
        }).forEach(function(key) {
            return delete cache[key];
        });
        return Object.keys(createEventMap).reduce(function(p, k) {
            var eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(eventCreator))) return p;
            var propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return $9d0048da11212002$var$_objectSpread($9d0048da11212002$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, k, cache[k].wrappedCallback));
            var wrappedCallback = function wrappedCallback() {
                var analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    propValue.apply(void 0, args.concat([
                        analyticsEvent
                    ]));
                }
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return $9d0048da11212002$var$_objectSpread($9d0048da11212002$var$_objectSpread({}, p), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, k, wrappedCallback));
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("dN8LZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a0a6a81c1a9e3c91$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $1oaC3 = parcelRequire("1oaC3");

var $8YsWW = parcelRequire("8YsWW");

var $eLAgR = parcelRequire("eLAgR");
var $a0a6a81c1a9e3c91$var$AsyncSelect = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
    // when isAsync is true, options are not provided and async props are used, we will enable async
    var isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    var stateManagedProps = (0, $8YsWW.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    var selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    var selectProps = (0, $eLAgR.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $1oaC3.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        ref: ref
    }, selectProps));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a0a6a81c1a9e3c91$export$2e2bcd8739ae039 = $a0a6a81c1a9e3c91$var$AsyncSelect;

});
parcelRegister("1oaC3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $103043ca735aaf61$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");
parcelRequire("anG6o");

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $7Ar6h = parcelRequire("7Ar6h");

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $bJl4r = parcelRequire("bJl4r");

var $i2LcI = parcelRequire("i2LcI");

var $fDFKi = parcelRequire("fDFKi");

var $2YG4y = parcelRequire("2YG4y");

var $4uUwO = parcelRequire("4uUwO");
var $hnn75 = parcelRequire("hnn75");
var $eoLTl = parcelRequire("eoLTl");

var $2HjZS = parcelRequire("2HjZS");

var $dkmve = parcelRequire("dkmve");

var $6TEmx = parcelRequire("6TEmx");

var $5d1uE = parcelRequire("5d1uE");

var $8uyTq = parcelRequire("8uyTq");

var $25MrG = parcelRequire("25MrG");
function $103043ca735aaf61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $103043ca735aaf61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $103043ca735aaf61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $103043ca735aaf61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $103043ca735aaf61$var$_callSuper(t, o, e) {
    return o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(o), (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(t, $103043ca735aaf61$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t).constructor) : o.apply(t, e));
}
function $103043ca735aaf61$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($103043ca735aaf61$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $103043ca735aaf61$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $25MrG.isTouchCapable)(),
    captureMenuScroll: !(0, $25MrG.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5d1uE.createFilter)(),
    formatGroupLabel: (0, $fDFKi.formatGroupLabel),
    getOptionLabel: (0, $fDFKi.getOptionLabel),
    getOptionValue: (0, $fDFKi.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $fDFKi.isOptionDisabled),
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $25MrG.isMobileDevice)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false
};
function $103043ca735aaf61$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $103043ca735aaf61$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $103043ca735aaf61$var$_isOptionSelected(props, option, selectValue);
    var label = $103043ca735aaf61$var$getOptionLabel(props, option);
    var value = $103043ca735aaf61$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $103043ca735aaf61$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        //@ts-ignore
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $103043ca735aaf61$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $103043ca735aaf61$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $103043ca735aaf61$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $103043ca735aaf61$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $25MrG.notNullish));
}
function $103043ca735aaf61$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $103043ca735aaf61$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $103043ca735aaf61$var$buildFocusableOptions(props, selectValue) {
    return $103043ca735aaf61$var$buildFocusableOptionsFromCategorizedOptions($103043ca735aaf61$var$buildCategorizedOptions(props, selectValue));
}
function $103043ca735aaf61$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$103043ca735aaf61$var$shouldHideSelectedOptions(props) || !isSelected) && $103043ca735aaf61$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $103043ca735aaf61$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $103043ca735aaf61$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $103043ca735aaf61$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $103043ca735aaf61$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $103043ca735aaf61$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $103043ca735aaf61$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $103043ca735aaf61$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $103043ca735aaf61$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $103043ca735aaf61$var$getOptionValue(props, i) === candidate;
    });
}
function $103043ca735aaf61$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $103043ca735aaf61$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $103043ca735aaf61$var$instanceId = 1;
// eslint-disable-next-line @repo/internal/react/no-class-components
var $103043ca735aaf61$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Select);
        _this = $103043ca735aaf61$var$_callSuper(this, Select, [
            _props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "state", {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        });
        // Misc. Instance Properties
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "blockOptionHover", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "isComposing", false);
        // TODO
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "initialTouchX", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "initialTouchY", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "openAfterFocus", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "scrollToFocusedOptionOnUpdate", false);
        // Refs
        // ------------------------------
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "controlRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getControlRef", function(ref) {
            _this.controlRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "focusedOptionRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getFocusedOptionRef", function(ref) {
            _this.focusedOptionRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "menuListRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getMenuListRef", function(ref) {
            _this.menuListRef = ref;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "inputRef", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getInputRef", function(ref) {
            _this.inputRef = ref;
        });
        // aliased for consumers
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "focus", _this.focusInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "blur", _this.blurInput);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onChange", function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "setValue", function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            // for multiple selection options, do not clear the search input value
            if (isMulti && (0, $i2LcI.fg)('platform_do_not_clear_input_for_multiselect')) _this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "selectOption", function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $25MrG.multiValueAsValue)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $25MrG.multiValueAsValue)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $25MrG.singleValueAsValue)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $25MrG.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "removeValue", function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $25MrG.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "clearValue", function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $25MrG.valueTernary)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "popValue", function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $25MrG.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        });
        // ==============================
        // Getters
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getFocusedOptionId", function(focusedOption) {
            return $103043ca735aaf61$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getFocusableOptionsWithIds", function() {
            return $103043ca735aaf61$var$buildFocusableOptionsWithIds($103043ca735aaf61$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getValue", function() {
            return _this.state.selectValue;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "cx", function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $25MrG.classNames).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getOptionLabel", function(data) {
            return $103043ca735aaf61$var$getOptionLabel(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getOptionValue", function(data) {
            return $103043ca735aaf61$var$getOptionValue(_this.props, data);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getStyles", function(key, props) {
            var base = (0, $8uyTq.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            if (!custom) return base;
            var customStyles = (0, $25MrG.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getClassNames", function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getElementId", function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getComponents", function() {
            return (0, $2YG4y.defaultComponents)(_this.props);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "buildCategorizedOptions", function() {
            return $103043ca735aaf61$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getCategorizedOptions", function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "buildFocusableOptions", function() {
            return $103043ca735aaf61$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "getFocusableOptions", function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        });
        // ==============================
        // Helpers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "ariaOnChange", function(value, actionMeta) {
            _this.setState({
                ariaSelection: $103043ca735aaf61$var$_objectSpread({
                    value: value
                }, actionMeta)
            });
        });
        // ==============================
        // Mouse Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onMenuMouseDown", function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onMenuMouseMove", function(event) {
            _this.blockOptionHover = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onControlMouseDown", function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                var _this$controlRef;
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!((_this$controlRef = _this.controlRef) !== null && _this$controlRef !== void 0 && _this$controlRef.closest('[data-rbd-draggable-context-id]'))) return;
            }
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onDropdownIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onClearIndicatorMouseDown", function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onScroll", function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $25MrG.isDocumentElement)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onCompositionStart", function() {
            _this.isComposing = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onCompositionEnd", function() {
            _this.isComposing = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onTouchStart", function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onTouchMove", function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onControlTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onClearIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onDropdownIndicatorTouchEnd", function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        });
        // ==============================
        // Focus Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "handleInputChange", function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onInputFocus", function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onInputBlur", function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $i2LcI.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            _this.props.menuIsOpen && _this.onMenuClose();
            else _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onOptionHover", function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "shouldHideSelectedOptions", function() {
            return $103043ca735aaf61$var$shouldHideSelectedOptions(_this.props);
        });
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onValueInputFocus", function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        });
        // ==============================
        // Keyboard Handlers
        // ==============================
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "onKeyDown", function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus, shouldPreventEscapePropagation = _this$props5.shouldPreventEscapePropagation;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) _this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_this, "handleOpenLayerObserverCloseSignal", function() {
            _this.onMenuClose();
        });
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$103043ca735aaf61$var$instanceId);
        _this.state.selectValue = (0, $25MrG.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $103043ca735aaf61$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(Select, _Component);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $25MrG.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $25MrG.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                var focusedOption = focusableOptions[openAtIndex];
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusedOption,
                    focusedOptionId: this.getFocusedOptionId(focusedOption)
                }, function() {
                    return _this2.onMenuOpen();
                });
                (0, $bJl4r.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
            }
        },
        {
            key: "updateInputLabel",
            value: function updateInputLabel(inputLabel) {
                var _this3 = this;
                if (inputLabel) {
                    var _this$inputRef;
                    (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.setAttribute('aria-label', inputLabel);
                    setTimeout(function() {
                        var normalizedLabel = _this3.props['aria-label'] || _this3.props.label;
                        if (normalizedLabel) {
                            var _this3$inputRef;
                            (_this3$inputRef = _this3.inputRef) === null || _this3$inputRef === void 0 || _this3$inputRef.setAttribute('aria-label', normalizedLabel);
                        } else {
                            var _this3$inputRef2;
                            (_this3$inputRef2 = _this3.inputRef) === null || _this3$inputRef2 === void 0 || _this3$inputRef2.removeAttribute('aria-label');
                        }
                    }, 500);
                }
            }
        },
        {
            key: "calculateInputLabel",
            value: function calculateInputLabel(focusedOption, optionIndex) {
                var _this4 = this;
                var options = this.props.options;
                var isOptionsGrouped = options === null || options === void 0 ? void 0 : options.every(function(obj) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(obj) === 'object' && obj !== null && 'options' in obj;
                });
                var inputLabel = this.getOptionLabel(focusedOption);
                var isOptionFocused = function isOptionFocused(option) {
                    return _this4.getOptionLabel(option) === inputLabel;
                };
                var groupData = options === null || options === void 0 ? void 0 : options.find(function(option) {
                    var _groupCandidate$optio, _groupCandidate$optio2;
                    var groupCandidate = option;
                    return (_groupCandidate$optio = (_groupCandidate$optio2 = groupCandidate.options) === null || _groupCandidate$optio2 === void 0 ? void 0 : _groupCandidate$optio2.some(isOptionFocused)) !== null && _groupCandidate$optio !== void 0 ? _groupCandidate$optio : false;
                });
                if (isOptionsGrouped) {
                    var _groupData$options$fi;
                    var groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
                    var totalLength = options === null || options === void 0 ? void 0 : options.reduce(function(acc, currentGroup) {
                        var _group$options;
                        var group = currentGroup;
                        acc += group === null || group === void 0 || (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
                        return acc;
                    }, 0);
                    inputLabel = "".concat(inputLabel, ", ").concat(groupData === null || groupData === void 0 ? void 0 : groupData.label, " (").concat(groupOptionIndex + 1, " of ").concat(totalLength, ")");
                } else inputLabel = "".concat(inputLabel, " (").concat(optionIndex + 1, " of ").concat(options === null || options === void 0 ? void 0 : options.length, ")");
                return inputLabel;
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus],
                    focusedValueId: "".concat(this.getElementId('selected-value'), "-").concat(nextFocus, "-remove"),
                    focusedOption: null,
                    focusedOptionId: null
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedValueId: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $103043ca735aaf61$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $103043ca735aaf61$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $103043ca735aaf61$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "calculateDescription",
            value: function calculateDescription() {
                var descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
                var isMulti = this.props.isMulti;
                var hasValue = this.state.selectValue.length > 0;
                // Determine base description based on selection state
                var baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
                // Fast path for single select with no description prop
                if (!isMulti && !descriptionProp) return {
                    'aria-describedby': baseDescriptionId
                };
                // Build the describedby string efficiently
                var describedBy = baseDescriptionId;
                // Add description prop if it exists
                if (descriptionProp) describedBy = describedBy ? "".concat(descriptionProp, " ").concat(describedBy) : descriptionProp;
                // For multi-select, always add multi-message ID
                if (isMulti) {
                    var multiMessage = this.getElementId('multi-message');
                    describedBy = describedBy ? "".concat(describedBy, " ").concat(multiMessage) : multiMessage;
                }
                return {
                    'aria-describedby': describedBy
                };
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchstart', this.onTouchStart);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchmove', this.onTouchMove);
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, form = _this$props8.form, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, isDisabled = _this$props8.isDisabled, isInvalid = _this$props8.isInvalid, isRequired = _this$props8.isRequired, isSearchable = _this$props8.isSearchable, label = _this$props8.label, labelId = _this$props8.labelId, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required, _this$props8$tabIndex = _this$props8.tabIndex, tabIndex = _this$props8$tabIndex === void 0 ? 0 : _this$props8$tabIndex, testId = _this$props8.testId;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({
                    'aria-autocomplete': 'both',
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-expanded': menuIsOpen,
                    // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
                    'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                    'aria-invalid': this.props['aria-invalid'] || isInvalid,
                    'aria-label': this.props['aria-label'] || label,
                    'aria-labelledby': this.props['aria-labelledby'] || labelId,
                    'aria-required': required || isRequired,
                    role: 'combobox',
                    'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.calculateDescription());
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4uUwO.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $25MrG.noop),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: "",
                    "data-testid": testId && "".concat(testId, "-select--input")
                }, ariaAttributes));
                // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
                // Adding `name` to this Input will cause unexpected behavior.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Input, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    testId: testId,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this5 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder, testId = _this$props9.testId;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue, isFocused = _this$state4.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Placeholder, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: $103043ca735aaf61$var$_objectSpread({
                        id: this.getElementId('placeholder')
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--placeholder")
                    })
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this5.getOptionLabel(opt), "-").concat(_this5.getOptionValue(opt));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(MultiValue, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({
                            onClick: function onClick() {
                                return _this5.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this5.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index, "-remove")
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index, "-remove")
                        }),
                        data: opt,
                        innerProps: $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--multivalue-").concat(index)
                        }), {}, {
                            id: "".concat(_this5.getElementId('selected-value'), "-").concat(index)
                        })
                    }), _this5.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(SingleValue, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled,
                    innerProps: {
                        id: this.getElementId('single-value')
                    }
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props0 = this.props, clearControlLabel = _this$props0.clearControlLabel, isDisabled = _this$props0.isDisabled, isLoading = _this$props0.isLoading, spacing = _this$props0.spacing, testId = _this$props0.testId;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = $103043ca735aaf61$var$_objectSpread({
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd
                }, testId && {
                    'data-testid': "".concat(testId, "-select--clear-indicator")
                });
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ClearIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
                    clearControlLabel: clearControlLabel
                }, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props1 = this.props, isDisabled = _this$props1.isDisabled, isLoading = _this$props1.isLoading, spacing = _this$props1.spacing, testId = _this$props1.testId;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var isCompact = spacing === 'compact';
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(LoadingIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
                    "data-testid": testId && "".concat(testId, "-select--loading-indicator")
                }, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, spacing = _this$props10.spacing, testId = _this$props10.testId;
                var isFocused = this.state.isFocused;
                var isCompact = spacing === 'compact';
                var innerProps = $103043ca735aaf61$var$_objectSpread({
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                }, testId && {
                    'data-testid': "".concat(testId, "-select--dropdown-indicator")
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(DropdownIndicator, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    isCompact: isCompact
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this6 = this;
                var _this$getComponents6 = this.getComponents(), Group = _this$getComponents6.Group, GroupHeading = _this$getComponents6.GroupHeading, Menu = _this$getComponents6.Menu, MenuList = _this$getComponents6.MenuList, MenuPortal = _this$getComponents6.MenuPortal, LoadingMessage = _this$getComponents6.LoadingMessage, NoOptionsMessage = _this$getComponents6.NoOptionsMessage, Option = _this$getComponents6.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props11 = this.props, captureMenuScroll = _this$props11.captureMenuScroll, inputValue = _this$props11.inputValue, isLoading = _this$props11.isLoading, loadingMessage = _this$props11.loadingMessage, minMenuHeight = _this$props11.minMenuHeight, maxMenuHeight = _this$props11.maxMenuHeight, menuIsOpen = _this$props11.menuIsOpen, menuPlacement = _this$props11.menuPlacement, menuPosition = _this$props11.menuPosition, menuPortalTarget = _this$props11.menuPortalTarget, menuShouldBlockScroll = _this$props11.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props11.menuShouldScrollIntoView, noOptionsMessage = _this$props11.noOptionsMessage, onMenuScrollToTop = _this$props11.onMenuScrollToTop, onMenuScrollToBottom = _this$props11.onMenuScrollToBottom, testId = _this$props11.testId;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id, headingId) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this6.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this6.selectOption(data);
                    };
                    var optionId = "".concat(_this6.getElementId('option'), "-").concat(id);
                    var innerProps = $103043ca735aaf61$var$_objectSpread({
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        role: _this6.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                        'aria-selected': _this6.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                        // We don't want aria-disabled if it's false. It's just noisy.
                        'aria-disabled': !isDisabled ? undefined : isDisabled,
                        'aria-describedby': headingId
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--option-").concat(id)
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Option, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this6.getFocusedOptionRef : undefined
                    }), _this6.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) {
                    var items = this.getCategorizedOptions();
                    menuUI = items.map(function(item) {
                        if (item.type === 'group') {
                            var data = item.data, options = item.options, groupIndex = item.index;
                            var groupId = "".concat(_this6.getElementId('group'), "-").concat(groupIndex);
                            var headingId = "".concat(groupId, "-heading");
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Group, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                                key: groupId,
                                data: data,
                                options: options,
                                Heading: GroupHeading,
                                headingProps: $103043ca735aaf61$var$_objectSpread({
                                    id: headingId,
                                    data: item.data
                                }, testId && {
                                    'data-testid': "".concat(testId, "-select--group-").concat(groupIndex, "-heading")
                                }),
                                label: _this6.formatGroupLabel(item.data)
                            }), item.options.map(function(option) {
                                return render(option, "".concat(groupIndex, "-").concat(option.index), headingId);
                            }));
                        } else if (item.type === 'option') return render(item, "".concat(item.index));
                    });
                } else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(NoOptionsMessage, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                        innerProps: $103043ca735aaf61$var$_objectSpread({}, testId && {
                            'data-testid': "".concat(testId, "-select--no-options")
                        })
                    }), _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $6TEmx.MenuPlacer), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Menu, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: $103043ca735aaf61$var$_objectSpread({
                            onMouseDown: _this6.onMenuMouseDown,
                            onMouseMove: _this6.onMenuMouseMove,
                            id: _this6.props.components.Menu ? _this6.getElementId('listbox') : undefined
                        }, testId && {
                            'data-testid': "".concat(testId, "-select--listbox-container")
                        }),
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eoLTl.default), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        var _this6$inputRef, _this6$inputRef2;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(MenuList, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this6.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({
                                role: _this6.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox'
                            }, _this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-labelledby': ((_this6$inputRef = _this6.inputRef) === null || _this6$inputRef === void 0 ? void 0 : _this6$inputRef.id) || _this6.getElementId('input')
                            }), {}, {
                                'aria-multiselectable': !commonProps.isMulti || _this6.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                id: _this6.getElementId('listbox')
                            }, testId && {
                                'data-testid': "".concat(testId, "-select--listbox")
                            }), (0, $bJl4r.isSafari)() && !_this6.props['UNSAFE_is_experimental_generic'] && {
                                'aria-describedby': ((_this6$inputRef2 = _this6.inputRef) === null || _this6$inputRef2 === void 0 ? void 0 : _this6$inputRef2.id) || _this6.getElementId('input')
                            }),
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), _this6.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
                            role: "list"
                        }, menuUI) : menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(MenuPortal, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this7 = this;
                var _this$props12 = this.props, delimiter = _this$props12.delimiter, isDisabled = _this$props12.isDisabled, isMulti = _this$props12.isMulti, required = _this$props12.required, name = _this$props12.name;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hnn75.default), {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this7.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this7.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state5 = this.state, ariaSelection = _this$state5.ariaSelection, isFocused = _this$state5.isFocused, selectValue = _this$state5.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dkmve.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "renderMultiselectMessage",
            value: function renderMultiselectMessage() {
                // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
                // Also, since this is rendered onscreen, it should be transtlated automatically.
                var msg = ", multiple selections available, ".concat(this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : '');
                return(/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
                (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
                    id: this.getElementId('multi-message'),
                    hidden: true
                }, msg));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents7 = this.getComponents(), Control = _this$getComponents7.Control, IndicatorsContainer = _this$getComponents7.IndicatorsContainer, SelectContainer = _this$getComponents7.SelectContainer, ValueContainer = _this$getComponents7.ValueContainer;
                var _this$props13 = this.props, className = _this$props13.className, id = _this$props13.id, isDisabled = _this$props13.isDisabled, menuIsOpen = _this$props13.menuIsOpen, isInvalid = _this$props13.isInvalid, testId = _this$props13.testId, _this$props13$appeara = _this$props13.appearance, appearance = _this$props13$appeara === void 0 ? 'default' : _this$props13$appeara, _this$props13$spacing = _this$props13.spacing, spacing = _this$props13$spacing === void 0 ? 'default' : _this$props13$spacing;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                var isCompact = spacing === 'compact';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(SelectContainer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                    className: className,
                    innerProps: $103043ca735aaf61$var$_objectSpread({
                        id: id,
                        onKeyDown: this.onKeyDown
                    }, testId && {
                        'data-testid': testId && "".concat(testId, "-select--container")
                    }),
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), commonProps.isMulti && this.renderMultiselectMessage(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Control, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: $103043ca735aaf61$var$_objectSpread({
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    }, testId && {
                        'data-testid': "".concat(testId, "-select--control")
                    }),
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ValueContainer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    isDisabled: isDisabled,
                    isCompact: isCompact,
                    innerProps: $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--value-container")
                    }), commonProps.isMulti && commonProps.hasValue && !(0, $bJl4r.isAppleDevice)() && {
                        // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                        // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                        // DST Accessibility.
                        role: 'application'
                    })
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(IndicatorsContainer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, commonProps, {
                    isDisabled: isDisabled,
                    innerProps: $103043ca735aaf61$var$_objectSpread({}, testId && {
                        'data-testid': "".concat(testId, "-select--indicators-container")
                    })
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2HjZS.NotifyOpenLayerObserver), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $25MrG.cleanValue)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $103043ca735aaf61$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $103043ca735aaf61$var$buildFocusableOptionsWithIds($103043ca735aaf61$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $103043ca735aaf61$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $103043ca735aaf61$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $103043ca735aaf61$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $25MrG.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return $103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread($103043ca735aaf61$var$_objectSpread({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
}((0, $8ZuGG.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($103043ca735aaf61$export$2e2bcd8739ae039, "defaultProps", $103043ca735aaf61$export$9c21a3269931e1e6);

});
parcelRegister("anG6o", function(module, exports) {
function $78ecb5f207057b76$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
module.exports = $78ecb5f207057b76$var$_readOnlyError, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fDFKi", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", function () { return $b62ae15c7df6194f$export$f4da216a6ca54656; });
$parcel$export(module.exports, "getOptionLabel", function () { return $b62ae15c7df6194f$export$dac6ace3020563ca; });
$parcel$export(module.exports, "getOptionValue", function () { return $b62ae15c7df6194f$export$40be908210c5a79c; });
$parcel$export(module.exports, "isOptionDisabled", function () { return $b62ae15c7df6194f$export$56bd0c8d90db075; });
/* eslint-disable @repo/internal/fs/filename-pattern-match */ var $b62ae15c7df6194f$export$f4da216a6ca54656 = function formatGroupLabel(group) {
    return group.label;
};
var $b62ae15c7df6194f$export$dac6ace3020563ca = function getOptionLabel(option) {
    return option.label;
};
var $b62ae15c7df6194f$export$40be908210c5a79c = function getOptionValue(option) {
    return option.value;
};
var $b62ae15c7df6194f$export$56bd0c8d90db075 = function isOptionDisabled(option) {
    return !!option.isDisabled;
};

});

parcelRegister("2YG4y", function(module, exports) {

$parcel$export(module.exports, "defaultComponents", function () { return $22b1d2144819f26e$export$71abc632aa29e6fe; });

var $6bkHe = parcelRequire("6bkHe");

var $kVnoh = parcelRequire("kVnoh");

var $bPKfZ = parcelRequire("bPKfZ");

var $eH3YC = parcelRequire("eH3YC");

var $7rsQT = parcelRequire("7rsQT");

var $jewLi = parcelRequire("jewLi");

var $6TEmx = parcelRequire("6TEmx");

var $7liN9 = parcelRequire("7liN9");

var $9xrYw = parcelRequire("9xrYw");

var $6UaX5 = parcelRequire("6UaX5");

var $4n8Y0 = parcelRequire("4n8Y0");
function $22b1d2144819f26e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $22b1d2144819f26e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $22b1d2144819f26e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $22b1d2144819f26e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $22b1d2144819f26e$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $7rsQT.ClearIndicator),
    Control: (0, $bPKfZ.default),
    DropdownIndicator: (0, $7rsQT.DropdownIndicator),
    Group: (0, $eH3YC.default),
    GroupHeading: (0, $eH3YC.GroupHeading),
    IndicatorsContainer: (0, $kVnoh.IndicatorsContainer),
    Input: (0, $jewLi.default),
    LoadingIndicator: (0, $7rsQT.LoadingIndicator),
    Menu: (0, $6TEmx.default),
    MenuList: (0, $6TEmx.MenuList),
    MenuPortal: (0, $6TEmx.MenuPortal),
    LoadingMessage: (0, $6TEmx.LoadingMessage),
    NoOptionsMessage: (0, $6TEmx.NoOptionsMessage),
    MultiValue: (0, $7liN9.default),
    MultiValueContainer: (0, $7liN9.MultiValueContainer),
    MultiValueLabel: (0, $7liN9.MultiValueLabel),
    MultiValueRemove: (0, $7liN9.MultiValueRemove),
    Option: (0, $9xrYw.default),
    Placeholder: (0, $6UaX5.default),
    SelectContainer: (0, $kVnoh.SelectContainer),
    SingleValue: (0, $4n8Y0.default),
    ValueContainer: (0, $kVnoh.ValueContainer)
};
var $22b1d2144819f26e$export$71abc632aa29e6fe = function defaultComponents(props) {
    return $22b1d2144819f26e$var$_objectSpread($22b1d2144819f26e$var$_objectSpread({}, $22b1d2144819f26e$export$9b5ac10f59f76296), props.components);
};

});
parcelRegister("kVnoh", function(module, exports) {

$parcel$export(module.exports, "containerCSS", function () { return $f3bb466e12fc2e8c$export$949392aeaf7d2e3a; });
$parcel$export(module.exports, "SelectContainer", function () { return $f3bb466e12fc2e8c$export$446eebadefe1123b; });
$parcel$export(module.exports, "valueContainerCSS", function () { return $f3bb466e12fc2e8c$export$47aec73c7aa6b9aa; });
$parcel$export(module.exports, "ValueContainer", function () { return $f3bb466e12fc2e8c$export$4dc9f58ad9a1a000; });
$parcel$export(module.exports, "indicatorsContainerCSS", function () { return $f3bb466e12fc2e8c$export$9d74e3c8b5868ad7; });
$parcel$export(module.exports, "IndicatorsContainer", function () { return $f3bb466e12fc2e8c$export$d0ffd7e649cab6f; });
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $i2LcI = parcelRequire("i2LcI");

var $25MrG = parcelRequire("25MrG");
var $f3bb466e12fc2e8c$export$949392aeaf7d2e3a = function containerCSS() {
    return {};
};
var $f3bb466e12fc2e8c$var$containerStyles = {
    default: "_11c82smr _kqswh2mm _lcxv1rj4",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf",
    ff_safari_input_fix: "_11c81ixg _1tn22smr"
};
var $f3bb466e12fc2e8c$export$446eebadefe1123b = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), className = _getStyleProps.className, css = _getStyleProps.css;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $f3bb466e12fc2e8c$var$containerStyles.default,
            isRtl && $f3bb466e12fc2e8c$var$containerStyles.rtl,
            isDisabled && $f3bb466e12fc2e8c$var$containerStyles.disabled,
            (0, $i2LcI.fg)('platform_design_system_team_safari_input_fix') && $f3bb466e12fc2e8c$var$containerStyles.ff_safari_input_fix,
            (0, $4vuwT.cx)(className, xcss, '-container')
        ]),
        style: css
    }, innerProps), children);
};
var $f3bb466e12fc2e8c$export$47aec73c7aa6b9aa = function valueContainerCSS() {
    return {};
};
var $f3bb466e12fc2e8c$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
};
var $f3bb466e12fc2e8c$export$4dc9f58ad9a1a000 = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue, isCompact = props.isCompact, xcss = props.xcss, controlShouldRenderValue = props.selectProps.controlShouldRenderValue;
    var _getStyleProps2 = (0, $25MrG.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $f3bb466e12fc2e8c$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $f3bb466e12fc2e8c$var$valueContainerStyles.flex,
            isCompact && $f3bb466e12fc2e8c$var$valueContainerStyles.compact,
            (0, $4vuwT.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css
    }, innerProps), children);
};
var $f3bb466e12fc2e8c$export$9d74e3c8b5868ad7 = function indicatorsContainerCSS() {
    return {};
};
var $f3bb466e12fc2e8c$var$indicatorContainerStyles = null;
var $f3bb466e12fc2e8c$export$d0ffd7e649cab6f = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps3 = (0, $25MrG.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $4vuwT.cx)(className, xcss, '-IndicatorsContainer')
        ])
    }, innerProps), children);
};

});
parcelRegister("25MrG", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $1861a0abf90beb09$export$8793edee2d425525; });
$parcel$export(module.exports, "classNames", function () { return $1861a0abf90beb09$export$ce4ab0c55987d1ff; });
$parcel$export(module.exports, "cleanValue", function () { return $1861a0abf90beb09$export$33f062f47f21a01; });
$parcel$export(module.exports, "cleanCommonProps", function () { return $1861a0abf90beb09$export$8e9fd4287627890c; });
$parcel$export(module.exports, "getStyleProps", function () { return $1861a0abf90beb09$export$26417cabd806a658; });
$parcel$export(module.exports, "handleInputChange", function () { return $1861a0abf90beb09$export$2096bae78ecda911; });
$parcel$export(module.exports, "isDocumentElement", function () { return $1861a0abf90beb09$export$d8a62a489b442872; });
$parcel$export(module.exports, "normalizedHeight", function () { return $1861a0abf90beb09$export$2e0654fad740d2e4; });
$parcel$export(module.exports, "getScrollTop", function () { return $1861a0abf90beb09$export$c4a223a8ba9e4ea5; });
$parcel$export(module.exports, "scrollTo", function () { return $1861a0abf90beb09$export$3f99968195accfaf; });
$parcel$export(module.exports, "getScrollParent", function () { return $1861a0abf90beb09$export$cfa2225e87938781; });
$parcel$export(module.exports, "animatedScrollTo", function () { return $1861a0abf90beb09$export$858c30343199f3af; });
$parcel$export(module.exports, "scrollIntoView", function () { return $1861a0abf90beb09$export$53a0910f038337bd; });
$parcel$export(module.exports, "getBoundingClientObj", function () { return $1861a0abf90beb09$export$7807c2a424c2f6d1; });
$parcel$export(module.exports, "isTouchCapable", function () { return $1861a0abf90beb09$export$56963d77dbffdde7; });
$parcel$export(module.exports, "isMobileDevice", function () { return $1861a0abf90beb09$export$44f917bf91becd01; });
$parcel$export(module.exports, "supportsPassiveEvents", function () { return $1861a0abf90beb09$export$b0622a6911dbeaf5; });
$parcel$export(module.exports, "notNullish", function () { return $1861a0abf90beb09$export$aedb69ff3e31596c; });
$parcel$export(module.exports, "valueTernary", function () { return $1861a0abf90beb09$export$40fb9515c784cc3b; });
$parcel$export(module.exports, "singleValueAsValue", function () { return $1861a0abf90beb09$export$dea4763e29237f4c; });
$parcel$export(module.exports, "multiValueAsValue", function () { return $1861a0abf90beb09$export$d1ca752ec761b95b; });
$parcel$export(module.exports, "removeProps", function () { return $1861a0abf90beb09$export$4213b25a1c4e877; });
$parcel$export(module.exports, "filterUnsupportedSelectors", function () { return $1861a0abf90beb09$export$bf2eda47afa5f369; });

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $cd8Dz = parcelRequire("cd8Dz");
var $1861a0abf90beb09$var$_excluded = [
    "className",
    "clearValue",
    "cx",
    "xcss",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue"
];
function $1861a0abf90beb09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1861a0abf90beb09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1861a0abf90beb09$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1861a0abf90beb09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1861a0abf90beb09$export$8793edee2d425525 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $1861a0abf90beb09$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $1861a0abf90beb09$export$ce4ab0c55987d1ff(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($1861a0abf90beb09$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
var $1861a0abf90beb09$export$33f062f47f21a01 = function cleanValue(value) {
    if ($1861a0abf90beb09$var$isArray(value)) return value.filter(Boolean);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
var $1861a0abf90beb09$export$8e9fd4287627890c = function cleanCommonProps(props) {
    //className
    var className = props.className, clearValue = props.clearValue, cx = props.cx, xcss = props.xcss, getStyles = props.getStyles, getClassNames = props.getClassNames, getValue = props.getValue, hasValue = props.hasValue, isMulti = props.isMulti, isRtl = props.isRtl, options = props.options, selectOption = props.selectOption, selectProps = props.selectProps, setValue = props.setValue, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $1861a0abf90beb09$var$_excluded);
    return $1861a0abf90beb09$var$_objectSpread({}, innerProps);
};
var $1861a0abf90beb09$export$26417cabd806a658 = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
function $1861a0abf90beb09$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $1861a0abf90beb09$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $1861a0abf90beb09$export$2e0654fad740d2e4(el) {
    if ($1861a0abf90beb09$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $1861a0abf90beb09$export$c4a223a8ba9e4ea5(el) {
    if ($1861a0abf90beb09$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $1861a0abf90beb09$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($1861a0abf90beb09$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $1861a0abf90beb09$export$cfa2225e87938781(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $1861a0abf90beb09$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $1861a0abf90beb09$export$858c30343199f3af(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $1861a0abf90beb09$export$8793edee2d425525;
    var start = $1861a0abf90beb09$export$c4a223a8ba9e4ea5(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $1861a0abf90beb09$var$easeOutCubic(currentTime, start, change, duration);
        $1861a0abf90beb09$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $1861a0abf90beb09$export$53a0910f038337bd(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $1861a0abf90beb09$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $1861a0abf90beb09$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $1861a0abf90beb09$export$7807c2a424c2f6d1(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $1861a0abf90beb09$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $1861a0abf90beb09$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $1861a0abf90beb09$var$passiveOptionAccessed = false;
var $1861a0abf90beb09$var$options = {
    get passive () {
        return $1861a0abf90beb09$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $1861a0abf90beb09$var$w = typeof window !== 'undefined' ? window : {};
if ($1861a0abf90beb09$var$w.addEventListener && $1861a0abf90beb09$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $1861a0abf90beb09$var$w.addEventListener('p', $1861a0abf90beb09$export$8793edee2d425525, $1861a0abf90beb09$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $1861a0abf90beb09$var$w.removeEventListener('p', $1861a0abf90beb09$export$8793edee2d425525, false);
}
var $1861a0abf90beb09$export$b0622a6911dbeaf5 = $1861a0abf90beb09$var$passiveOptionAccessed;
function $1861a0abf90beb09$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $1861a0abf90beb09$var$isArray(arg) {
    return Array.isArray(arg);
}
function $1861a0abf90beb09$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $1861a0abf90beb09$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $1861a0abf90beb09$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
var $1861a0abf90beb09$export$4213b25a1c4e877 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $1861a0abf90beb09$export$bf2eda47afa5f369 = function filterUnsupportedSelectors(styles) {
    var unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce(function(filteredStyles, key) {
        if (!unsupportedSelectors.some(function(selector) {
            return key.includes(selector);
        })) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};

});


parcelRegister("bPKfZ", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $89d856c9955820bf$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $89d856c9955820bf$export$2e2bcd8739ae039; });
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $25MrG = parcelRequire("25MrG");
var $89d856c9955820bf$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6d1elr _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _15peftgi _1ke8ftgi _jaboglyw _1u6l1bml _4cvx1elr _123byq51 _d0altlke _irr31d5g _1ogl1caj",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsq049",
    disabled: "_1h6dsyzs _lcxvglyw _bfhksyzs _1u6llkwx",
    focused: "_1h6d1p6i _bfhkr01l _16qsq049 _1u6lq049 _4cvx1p6i _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
var $89d856c9955820bf$export$dbf350e5966cf602 = function css() {
    return {};
};
var $89d856c9955820bf$var$Control = function Control(props) {
    var children = props.children, appearance = props.appearance, isCompact = props.isCompact, isDisabled = props.isDisabled, isFocused = props.isFocused, isInvalid = props.isInvalid, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        ref: innerRef,
        className: (0, $c4hjl.default)([
            $89d856c9955820bf$var$styles.default,
            isDisabled && $89d856c9955820bf$var$styles.disabled,
            isInvalid && $89d856c9955820bf$var$styles.invalid,
            isCompact && $89d856c9955820bf$var$styles.compact,
            appearance === 'subtle' && $89d856c9955820bf$var$styles.subtle,
            appearance === 'subtle' && isFocused && $89d856c9955820bf$var$styles.subtleFocused,
            isFocused && $89d856c9955820bf$var$styles.focused,
            appearance === 'none' && $89d856c9955820bf$var$styles.none,
            (0, $4vuwT.cx)(className, xcss, '-control')
        ]),
        style: css
    }, innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$89d856c9955820bf$export$2e2bcd8739ae039 = $89d856c9955820bf$var$Control;

});

parcelRegister("eH3YC", function(module, exports) {

$parcel$export(module.exports, "groupCSS", function () { return $ab282a88075f6cd8$export$b6794329c1460634; });
$parcel$export(module.exports, "groupHeadingCSS", function () { return $ab282a88075f6cd8$export$e5a7fbb542efcb7d; });
$parcel$export(module.exports, "GroupHeading", function () { return $ab282a88075f6cd8$export$85c8b41a3cd87edc; });
$parcel$export(module.exports, "default", function () { return $ab282a88075f6cd8$export$2e2bcd8739ae039; });
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1Wcv5 = parcelRequire("1Wcv5");

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $25MrG = parcelRequire("25MrG");
var $ab282a88075f6cd8$var$_excluded = [
    "data"
];
var $ab282a88075f6cd8$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
var $ab282a88075f6cd8$export$b6794329c1460634 = function groupCSS() {
    return {};
};
var $ab282a88075f6cd8$var$Group = function Group(props) {
    var children = props.children, builtinCX = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, selectProps = props.selectProps, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'group', {
        group: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css
    }, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $ab282a88075f6cd8$var$styles.root,
            (0, $4vuwT.cx)(className, xcss, innerProps === null || innerProps === void 0 ? void 0 : innerProps.className, '-Group')
        ])
    }), label && /*#__PURE__*/ $8ZuGG.createElement(Heading, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, headingProps, {
        selectProps: selectProps,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: builtinCX
    }), label), /*#__PURE__*/ $8ZuGG.createElement("div", null, children));
};
var $ab282a88075f6cd8$var$headingStyles = null;
var $ab282a88075f6cd8$export$e5a7fbb542efcb7d = function groupHeadingCSS() {
    return {};
};
var $ab282a88075f6cd8$export$85c8b41a3cd87edc = function GroupHeading(props) {
    var xcss = props.xcss;
    var _cleanCommonProps = (0, $25MrG.cleanCommonProps)(props), data = _cleanCommonProps.data, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_cleanCommonProps, $ab282a88075f6cd8$var$_excluded);
    var _getStyleProps2 = (0, $25MrG.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            "_11c81o8v _1e0c1ule _syaz1gjq _80om73ad _k48pmoej _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $4vuwT.cx)(className, xcss, '-group')
        ]),
        style: css
    }, innerProps));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ab282a88075f6cd8$export$2e2bcd8739ae039 = $ab282a88075f6cd8$var$Group;

});

parcelRegister("7rsQT", function(module, exports) {

$parcel$export(module.exports, "dropdownIndicatorCSS", function () { return $56b16f70395d8f83$export$e1687335805e1230; });
$parcel$export(module.exports, "DropdownIndicator", function () { return $56b16f70395d8f83$export$ec98719d3db7f2e4; });
$parcel$export(module.exports, "clearIndicatorCSS", function () { return $56b16f70395d8f83$export$9c0419fd944c1def; });
$parcel$export(module.exports, "ClearIndicator", function () { return $56b16f70395d8f83$export$ecf9cf59142dd54a; });
$parcel$export(module.exports, "loadingIndicatorCSS", function () { return $56b16f70395d8f83$export$1d3f24cde248e6b5; });
$parcel$export(module.exports, "LoadingIndicator", function () { return $56b16f70395d8f83$export$7c20be4c1d342248; });
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $bcLBt = parcelRequire("bcLBt");

var $kYKeT = parcelRequire("kYKeT");

var $fkdQ8 = parcelRequire("fkdQ8");
var $4lDUI = parcelRequire("4lDUI");

var $cufV0 = parcelRequire("cufV0");

var $25MrG = parcelRequire("25MrG");
var $56b16f70395d8f83$var$_excluded = [
    "innerProps",
    "isRtl",
    "size",
    "isCompact",
    "xcss"
];
function $56b16f70395d8f83$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56b16f70395d8f83$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56b16f70395d8f83$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56b16f70395d8f83$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $56b16f70395d8f83$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
};
var $56b16f70395d8f83$var$dropdownWrapperStyles = {
    root: "_ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7"
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $56b16f70395d8f83$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1gjq _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf",
    disabled: "_syaz1lh4"
};
var $56b16f70395d8f83$export$e1687335805e1230 = function dropdownIndicatorCSS() {
    return {};
};
var $56b16f70395d8f83$export$ec98719d3db7f2e4 = function DropdownIndicator(props) {
    var innerProps = props.innerProps, children = props.children, isDisabled = props.isDisabled, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $56b16f70395d8f83$var$dropdownStyles.default,
            isDisabled && $56b16f70395d8f83$var$dropdownStyles.disabled,
            isCompact && $56b16f70395d8f83$var$dropdownStyles.compact,
            (0, $4vuwT.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), children ? children : /*#__PURE__*/ $8ZuGG.createElement((0, $fkdQ8.default), {
        as: "span",
        xcss: $56b16f70395d8f83$var$dropdownWrapperStyles.root
    }, /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bcLBt))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)",
        size: "small"
    })));
};
var $56b16f70395d8f83$export$9c0419fd944c1def = function clearIndicatorCSS() {
    return {};
};
var $56b16f70395d8f83$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz131l _ca0q12x7 _u5f3v77o _n3td12x7 _19bvv77o _30l31gjq",
    compact: "_ca0qidpf _n3tdidpf"
};
var $56b16f70395d8f83$export$ecf9cf59142dd54a = function ClearIndicator(props) {
    var innerProps = props.innerProps, _props$clearControlLa = props.clearControlLabel, clearControlLabel = _props$clearControlLa === void 0 ? 'clear' : _props$clearControlLa, isCompact = props.isCompact, xcss = props.xcss;
    var _getStyleProps2 = (0, $25MrG.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $56b16f70395d8f83$var$clearIndicatorStyles.default,
            isCompact && $56b16f70395d8f83$var$clearIndicatorStyles.compact,
            (0, $4vuwT.cx)(className, xcss, '-indicatorContainer')
        ])
    }, innerProps), /*#__PURE__*/ $8ZuGG.createElement((0, $4lDUI.default), {
        xcss: $56b16f70395d8f83$var$iconContainerStyles.root,
        tabIndex: -1,
        "aria-label": clearControlLabel
    }, /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYKeT))), {
        label: "",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)",
        size: "small"
    })));
};
var $56b16f70395d8f83$export$1d3f24cde248e6b5 = function loadingIndicatorCSS() {
    return {};
};
var $56b16f70395d8f83$var$loadingIndicatorStyles = {
    default: "_ca0q12x7 _u5f3u2gc _n3td12x7 _19bvu2gc",
    compact: "_ca0qidpf _n3tdidpf"
};
var $56b16f70395d8f83$export$7c20be4c1d342248 = function LoadingIndicator(_ref) {
    var innerProps = _ref.innerProps, isRtl = _ref.isRtl, _ref$size = _ref.size, size = _ref$size === void 0 ? 4 : _ref$size, isCompact = _ref.isCompact, xcss = _ref.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $56b16f70395d8f83$var$_excluded);
    var _getStyleProps3 = (0, $25MrG.getStyleProps)($56b16f70395d8f83$var$_objectSpread($56b16f70395d8f83$var$_objectSpread({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $56b16f70395d8f83$var$loadingIndicatorStyles.default,
            isCompact && $56b16f70395d8f83$var$loadingIndicatorStyles.compact,
            (0, $4vuwT.cx)(className, xcss, '-loadingIndicator')
        ])
    }, innerProps), /*#__PURE__*/ $8ZuGG.createElement((0, $cufV0.default), {
        size: "small"
    }));
};

});
parcelRegister("bcLBt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03862cd3f81bd2eb2145cf11d082237>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8285bdb965e0247d$var$_react = $8285bdb965e0247d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $8285bdb965e0247d$var$_chevronDown = $8285bdb965e0247d$var$_interopRequireDefault((parcelRequire("9gel0")));

var $8285bdb965e0247d$var$_chevronDown2 = $8285bdb965e0247d$var$_interopRequireDefault((parcelRequire("aI3g9")));
function $8285bdb965e0247d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "ChevronDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8285bdb965e0247d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $8285bdb965e0247d$var$_react.default.createElement($8285bdb965e0247d$var$_chevronDown.default, Object.assign({
        name: "ChevronDownIcon",
        LEGACY_fallbackIcon: $8285bdb965e0247d$var$_chevronDown2.default
    }, props));
$8285bdb965e0247d$var$ChevronDownIcon.displayName = 'ChevronDownIconMigration';
var $8285bdb965e0247d$var$_default = module.exports.default = $8285bdb965e0247d$var$ChevronDownIcon;

});
parcelRegister("9gel0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56e8662eb8a8d2462ec3a39ff3aa40b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6be0badc95c8f0ac$var$_react = $6be0badc95c8f0ac$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $6be0badc95c8f0ac$var$_baseNew = $6be0badc95c8f0ac$var$_interopRequireDefault((parcelRequire("bkBMq")));
function $6be0badc95c8f0ac$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6be0badc95c8f0ac$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $6be0badc95c8f0ac$var$_react.default.createElement($6be0badc95c8f0ac$var$_baseNew.default, Object.assign({
        name: "ChevronDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$6be0badc95c8f0ac$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $6be0badc95c8f0ac$var$_default = module.exports.default = $6be0badc95c8f0ac$var$ChevronDownIcon;

});
parcelRegister("bkBMq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("c8hmr")).default; });
$parcel$export(module.exports, "Icon", function () { return (parcelRequire("c8hmr")).Icon; });

var $c8hmr = parcelRequire("c8hmr");

});
parcelRegister("c8hmr", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $8d53b2e686fc81cb$export$f04a61298a47a40f; });
$parcel$export(module.exports, "default", function () { return $8d53b2e686fc81cb$export$2e2bcd8739ae039; });
/* icon-new.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $i2LcI = parcelRequire("i2LcI");
/**
 * We are hiding this props from consumers as it's reserved
 * for use by Icon Tile.
 */ var $8d53b2e686fc81cb$var$svgStyles = null;
var $8d53b2e686fc81cb$var$iconStyles = null;
var $8d53b2e686fc81cb$var$utilityIconStyles = null;
var $8d53b2e686fc81cb$var$scaleStyles = null;
/**
 * For windows high contrast mode
 */ var $8d53b2e686fc81cb$var$baseHcmStyles = null;
var $8d53b2e686fc81cb$var$scaleSize = null;
var $8d53b2e686fc81cb$var$coreSizeMedium = {
    none: "_1bsbpxbi _4t3ipxbi",
    compact: "_1bsb1ejb _4t3i1ejb",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8d53b2e686fc81cb$var$coreSizeSmall = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8d53b2e686fc81cb$var$utilSizes = {
    none: "_1bsbutpp _4t3iutpp",
    compact: "_1bsbpxbi _4t3ipxbi",
    spacious: "_1bsb1ejb _4t3i1ejb"
};
var $8d53b2e686fc81cb$var$baseSizeMap = {
    core: 16,
    utility: 12
};
var $8d53b2e686fc81cb$var$paddingMap = {
    core: {
        medium: {
            none: 0,
            compact: 4,
            spacious: 4
        },
        small: {
            none: 0,
            compact: 2.66,
            spacious: 8
        }
    },
    utility: {
        medium: {
            none: 0,
            compact: 2,
            spacious: 6
        },
        small: {
            none: 0,
            compact: 2,
            spacious: 6
        }
    }
};
var $8d53b2e686fc81cb$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _props$type;
    var _ref = props, _ref$color = _ref.color, color = _ref$color === void 0 ? 'currentColor' : _ref$color, testId = _ref.testId, label = _ref.label, LEGACY_primaryColor = _ref.LEGACY_primaryColor, LEGACY_secondaryColor = _ref.LEGACY_secondaryColor, LEGACY_size = _ref.LEGACY_size, FallbackIcon = _ref.LEGACY_fallbackIcon, dangerouslySetGlyph = _ref.dangerouslySetGlyph, shouldScale = _ref.shouldScale, LEGACY_margin = _ref.LEGACY_margin, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'none' : _ref$spacing, name = _ref.name;
    var dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if (FallbackIcon && !(0, $i2LcI.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ $8ZuGG.createElement(FallbackIcon, {
        primaryColor: LEGACY_primaryColor !== null && LEGACY_primaryColor !== void 0 ? LEGACY_primaryColor : color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        UNSAFE_margin: LEGACY_margin
    });
    var type = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : 'core';
    var size = 'medium';
    if ('size' in props && props.size !== undefined) {
        if (typeof props.size === 'string') size = props.size === 'small' || props.size === 'medium' ? props.size : size;
        else if (name) {
            var newSize = props.size(name);
            size = newSize === 'small' || newSize === 'medium' ? newSize : size;
        }
    }
    var baseSize = $8d53b2e686fc81cb$var$baseSizeMap[type];
    var viewBoxPadding = $8d53b2e686fc81cb$var$paddingMap[type][size][spacing];
    var viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ $8ZuGG.createElement("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _vchhusvi _1o9zidpf _vwz4kb7n _y4ti1igz _bozg1mb9",
            "_12va1onz _jcxd1r8n",
            shouldScale && "_1bsb1kw7 _4t3i1kw7",
            (type === 'utility' || size === 'small') && "_vwz4utpp"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement("svg", {
        fill: "none",
        viewBox: "".concat(0 - viewBoxPadding, " ").concat(0 - viewBoxPadding, " ").concat(viewBoxSize, " ").concat(viewBoxSize),
        role: "presentation",
        dangerouslySetInnerHTML: dangerouslySetInnerHTML,
        className: (0, $c4hjl.default)([
            "_1reo15vq _18m915vq _syaz1r31 _lcxvglyw _s7n4yfq0 _vc881r31",
            shouldScale ? "_1bsb1kw7 _4t3i1kw7" : type === 'utility' ? $8d53b2e686fc81cb$var$utilSizes[spacing] : size === 'small' ? $8d53b2e686fc81cb$var$coreSizeSmall[spacing] : $8d53b2e686fc81cb$var$coreSizeMedium[spacing]
        ])
    }));
});
var $8d53b2e686fc81cb$export$2e2bcd8739ae039 = $8d53b2e686fc81cb$export$f04a61298a47a40f;

});



parcelRegister("aI3g9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7cc08ab13024f508$var$_react = $7cc08ab13024f508$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $blMtb = parcelRequire("blMtb");
function $7cc08ab13024f508$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7cc08ab13024f508$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $7cc08ab13024f508$var$_react.default.createElement($blMtb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"/></svg>`
    }, props));
$7cc08ab13024f508$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $7cc08ab13024f508$var$_default = module.exports.default = $7cc08ab13024f508$var$ChevronDownIcon;

});
parcelRegister("blMtb", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $843740f288c467f4$export$f04a61298a47a40f; });
/* icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
function $843740f288c467f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $843740f288c467f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $843740f288c467f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $843740f288c467f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $843740f288c467f4$var$iconStyles = null;
var $843740f288c467f4$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
};
/**
 * For windows high contrast mode
 */ var $843740f288c467f4$var$baseHcmStyles = null;
var $843740f288c467f4$var$primaryEqualsSecondaryHcmStyles = null;
var $843740f288c467f4$var$secondaryTransparentHcmStyles = null;
var $843740f288c467f4$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height, UNSAFE_margin = _ref.UNSAFE_margin;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $8ZuGG.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    var customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        "data-vc": "icon-".concat(testId),
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: $843740f288c467f4$var$_objectSpread($843740f288c467f4$var$_objectSpread({}, customDimensions), {}, {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        })
    }, glyphProps, {
        className: (0, $c4hjl.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $843740f288c467f4$var$sizeStyles[size]
        ])
    }));
});
var $843740f288c467f4$export$2e2bcd8739ae039 = $843740f288c467f4$export$f04a61298a47a40f;

});



parcelRegister("kYKeT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1c64b1bb7f30549dd379d26abd8d4a76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f45d475ce7fbeb9f$var$_react = $f45d475ce7fbeb9f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $f45d475ce7fbeb9f$var$_crossCircle = $f45d475ce7fbeb9f$var$_interopRequireDefault((parcelRequire("13EWA")));

var $f45d475ce7fbeb9f$var$_selectClear = $f45d475ce7fbeb9f$var$_interopRequireDefault((parcelRequire("iIfnd")));
function $f45d475ce7fbeb9f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f45d475ce7fbeb9f$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $f45d475ce7fbeb9f$var$_react.default.createElement($f45d475ce7fbeb9f$var$_crossCircle.default, Object.assign({
        name: "CrossCircleIcon",
        LEGACY_fallbackIcon: $f45d475ce7fbeb9f$var$_selectClear.default
    }, props));
$f45d475ce7fbeb9f$var$CrossCircleIcon.displayName = 'CrossCircleIconMigration';
var $f45d475ce7fbeb9f$var$_default = module.exports.default = $f45d475ce7fbeb9f$var$CrossCircleIcon;

});
parcelRegister("13EWA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3eb90e0e095210547df6d71f04e27a56>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0c55d4dd86fa8f96$var$_react = $0c55d4dd86fa8f96$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $0c55d4dd86fa8f96$var$_baseNew = $0c55d4dd86fa8f96$var$_interopRequireDefault((parcelRequire("bkBMq")));
function $0c55d4dd86fa8f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0c55d4dd86fa8f96$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $0c55d4dd86fa8f96$var$_react.default.createElement($0c55d4dd86fa8f96$var$_baseNew.default, Object.assign({
        name: "CrossCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$0c55d4dd86fa8f96$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $0c55d4dd86fa8f96$var$_default = module.exports.default = $0c55d4dd86fa8f96$var$CrossCircleIcon;

});

parcelRegister("iIfnd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9f842ebd9ffd10c$var$_react = $d9f842ebd9ffd10c$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $blMtb = parcelRequire("blMtb");
function $d9f842ebd9ffd10c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d9f842ebd9ffd10c$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d9f842ebd9ffd10c$var$_react.default.createElement($blMtb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props));
$d9f842ebd9ffd10c$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d9f842ebd9ffd10c$var$_default = module.exports.default = $d9f842ebd9ffd10c$var$SelectClearIcon;

});



parcelRegister("jewLi", function(module, exports) {

$parcel$export(module.exports, "inputCSS", function () { return $e008bcf0763b7612$export$14a7781d0ca7abea; });
$parcel$export(module.exports, "default", function () { return $e008bcf0763b7612$export$2e2bcd8739ae039; });
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $i2LcI = parcelRequire("i2LcI");

var $25MrG = parcelRequire("25MrG");
var $e008bcf0763b7612$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName",
    "testId"
];
var $e008bcf0763b7612$export$14a7781d0ca7abea = function inputCSS() {
    return {};
};
var $e008bcf0763b7612$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $e008bcf0763b7612$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syaz1fxt _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
var $e008bcf0763b7612$var$nativeInputStylesOld = null;
var $e008bcf0763b7612$var$nativeInputStyles = null;
var $e008bcf0763b7612$var$hidden = null;
var $e008bcf0763b7612$var$Input = function Input(props) {
    var builtinCX = props.cx, value = props.value, xcss = props.xcss;
    var _cleanCommonProps = (0, $25MrG.cleanCommonProps)(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, testId = _cleanCommonProps.testId, innerProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_cleanCommonProps, $e008bcf0763b7612$var$_excluded);
    var dataId = testId ? "".concat(testId, "-select--input") : null;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'input', {
        'input-container': true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    if ((0, $i2LcI.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ $8ZuGG.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $e008bcf0763b7612$var$inputStyles.root,
            isDisabled && $e008bcf0763b7612$var$inputStyles.disabled,
            (0, $4vuwT.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $8ZuGG.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4hjl.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
    return /*#__PURE__*/ $8ZuGG.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $e008bcf0763b7612$var$inputStylesOld.root,
            isDisabled && $e008bcf0763b7612$var$inputStylesOld.disabled,
            (0, $4vuwT.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && "".concat(dataId, "-container")
    }, /*#__PURE__*/ $8ZuGG.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4hjl.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
            isHidden && "_tzy4idpf",
            builtinCX({
                input: true
            }, inputClassName, '-input')
        ]),
        ref: innerRef,
        disabled: isDisabled,
        "data-testid": dataId
    }, innerProps)));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e008bcf0763b7612$export$2e2bcd8739ae039 = $e008bcf0763b7612$var$Input;

});

parcelRegister("6TEmx", function(module, exports) {

$parcel$export(module.exports, "menuCSS", function () { return $505730499a714ae3$export$a228922d5ca42a79; });
$parcel$export(module.exports, "MenuPlacer", function () { return $505730499a714ae3$export$f32337f3a7617699; });
$parcel$export(module.exports, "default", function () { return $505730499a714ae3$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "menuListCSS", function () { return $505730499a714ae3$export$abafed69cff95d5e; });
$parcel$export(module.exports, "MenuList", function () { return $505730499a714ae3$export$d4c4e98c5044dc8; });
$parcel$export(module.exports, "noOptionsMessageCSS", function () { return $505730499a714ae3$export$cf0e22534d8b0074; });
$parcel$export(module.exports, "loadingMessageCSS", function () { return $505730499a714ae3$export$98ec46397a8cb3cd; });
$parcel$export(module.exports, "NoOptionsMessage", function () { return $505730499a714ae3$export$d58b72b7d3c4072c; });
$parcel$export(module.exports, "LoadingMessage", function () { return $505730499a714ae3$export$e928a71d039d3102; });
$parcel$export(module.exports, "menuPortalCSS", function () { return $505730499a714ae3$export$1dbbeb9648d1fdc9; });
$parcel$export(module.exports, "MenuPortal", function () { return $505730499a714ae3$export$793392f970497feb; });
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $1Wcv5 = parcelRequire("1Wcv5");

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $1rqGQ = parcelRequire("1rqGQ");

var $h1d60 = parcelRequire("h1d60");

var $f00Pp = parcelRequire("f00Pp");

var $2VWCX = parcelRequire("2VWCX");

var $25MrG = parcelRequire("25MrG");
var $505730499a714ae3$var$_excluded = [
    "children",
    "innerProps",
    "xcss"
], $505730499a714ae3$var$_excluded2 = [
    "children",
    "innerProps",
    "xcss"
];
function $505730499a714ae3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $505730499a714ae3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $505730499a714ae3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $505730499a714ae3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Menu
// ==============================
// Get Menu Placement
// ------------------------------
function $505730499a714ae3$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = (0, $25MrG.getScrollParent)(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : (0, $25MrG.normalizedHeight)(scrollParent);
    var scrollTop = (0, $25MrG.getScrollTop)(scrollParent);
    var menuTopFromParent = menuTop;
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTopFromParent;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $25MrG.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $25MrG.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $25MrG.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $25MrG.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $25MrG.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
var $505730499a714ae3$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $505730499a714ae3$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _otyru2gc _19pku2gc _bfhk1bhr _16qsd0yg",
    bottom: "_154i1osq",
    top: "_94n51osq"
};
var $505730499a714ae3$export$a228922d5ca42a79 = function menuCSS() {
    return {};
};
var $505730499a714ae3$var$PortalPlacementContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
var $505730499a714ae3$export$f32337f3a7617699 = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView;
    var _ref2 = (0, $8ZuGG.useContext)($505730499a714ae3$var$PortalPlacementContext) || {}, setPortalPlacement = _ref2.setPortalPlacement;
    var ref = (0, $8ZuGG.useRef)(null);
    var _useState = (0, $8ZuGG.useState)(maxMenuHeight), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    // The minimum height of the control
    var controlHeight = 38;
    (0, $f00Pp.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $505730499a714ae3$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: $505730499a714ae3$var$_objectSpread($505730499a714ae3$var$_objectSpread({}, props), {}, {
            placement: placement || $505730499a714ae3$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $505730499a714ae3$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps, _props$placement = props.placement, placement = _props$placement === void 0 ? 'bottom' : _props$placement, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'menu', {
        menu: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $505730499a714ae3$var$menuStyles.root,
            $505730499a714ae3$var$menuStyles[placement],
            (0, $4vuwT.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$505730499a714ae3$export$2e2bcd8739ae039 = $505730499a714ae3$var$Menu;
var $505730499a714ae3$export$abafed69cff95d5e = function menuListCSS() {
    return {};
};
var $505730499a714ae3$var$menuListStyles = null;
var $505730499a714ae3$export$d4c4e98c5044dc8 = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti, maxHeight = props.maxHeight, xcss = props.xcss;
    var _getStyleProps2 = (0, $25MrG.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), css = _getStyleProps2.css, className = _getStyleProps2.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $4vuwT.cx)(className, xcss, '-MenuList')
        ]),
        style: $505730499a714ae3$var$_objectSpread($505730499a714ae3$var$_objectSpread({}, css), {}, {
            maxHeight: maxHeight
        }),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
// ==============================
// Menu Notices
// ==============================
var $505730499a714ae3$var$noticeCSS = function noticeCSS() {
    return {};
};
var $505730499a714ae3$var$noticeStyles = null;
var $505730499a714ae3$export$cf0e22534d8b0074 = $505730499a714ae3$var$noticeCSS;
var $505730499a714ae3$export$98ec46397a8cb3cd = $505730499a714ae3$var$noticeCSS;
var $505730499a714ae3$export$d58b72b7d3c4072c = function NoOptionsMessage(_ref3) {
    var _ref3$children = _ref3.children, children = _ref3$children === void 0 ? 'No options' : _ref3$children, innerProps = _ref3.innerProps, xcss = _ref3.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref3, $505730499a714ae3$var$_excluded);
    var _getStyleProps3 = (0, $25MrG.getStyleProps)($505730499a714ae3$var$_objectSpread($505730499a714ae3$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), css = _getStyleProps3.css, className = _getStyleProps3.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $4vuwT.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option"
    }, innerProps), /*#__PURE__*/ $8ZuGG.createElement((0, $2VWCX.default), {
        color: "color.text.subtle"
    }, children));
};
var $505730499a714ae3$export$e928a71d039d3102 = function LoadingMessage(_ref4) {
    var _ref4$children = _ref4.children, children = _ref4$children === void 0 ? 'Loading...' : _ref4$children, innerProps = _ref4.innerProps, xcss = _ref4.xcss, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref4, $505730499a714ae3$var$_excluded2);
    var _getStyleProps4 = (0, $25MrG.getStyleProps)($505730499a714ae3$var$_objectSpread($505730499a714ae3$var$_objectSpread({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), css = _getStyleProps4.css, className = _getStyleProps4.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $4vuwT.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css
    }, innerProps, {
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }), /*#__PURE__*/ $8ZuGG.createElement((0, $2VWCX.default), {
        color: "color.text.subtle"
    }, children));
};
var $505730499a714ae3$export$1dbbeb9648d1fdc9 = function menuPortalCSS() {
    return {};
};
var $505730499a714ae3$var$menuPortalStyles = {
    root: "_1pbykb7n _1ltva1vk _kqswcp1v _154i1nmo _1bsb1qxj"
};
var $505730499a714ae3$export$793392f970497feb = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, xcss = props.xcss;
    var menuPortalRef = (0, $8ZuGG.useRef)(null);
    var cleanupRef = (0, $8ZuGG.useRef)(null);
    var _useState5 = (0, $8ZuGG.useState)($505730499a714ae3$var$coercePlacement(menuPlacement)), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $8ZuGG.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $8ZuGG.useState)(null), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $8ZuGG.useCallback)(function() {
        if (!controlElement) return;
        var rect = (0, $25MrG.getBoundingClientObj)(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $f00Pp.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $8ZuGG.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $1rqGQ.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $f00Pp.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $8ZuGG.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    var _getStyleProps5 = (0, $25MrG.getStyleProps)($505730499a714ae3$var$_objectSpread($505730499a714ae3$var$_objectSpread({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), css = _getStyleProps5.css, className = _getStyleProps5.className;
    // same wrapper element whether fixed or portalled
    var menuWrapper = /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $505730499a714ae3$var$menuPortalStyles.root,
            (0, $4vuwT.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: $505730499a714ae3$var$_objectSpread({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': "".concat(computedPosition.rect.left, "px"),
            '--menu-position': menuPosition,
            '--menu-top': "".concat(computedPosition.offset, "px"),
            '--menu-width': "".concat(computedPosition.rect.width, "px")
        }, css)
    }, innerProps), children);
    return /*#__PURE__*/ $8ZuGG.createElement($505730499a714ae3$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $h1d60.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("1rqGQ", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", function () { return $10cd0423f1b6d057$export$deee3a793edee05f; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $lMpRQ = parcelRequire("lMpRQ");
var $2DoiL = parcelRequire("2DoiL");

var $2DoiL = parcelRequire("2DoiL");

var $1JZck = parcelRequire("1JZck");
function $10cd0423f1b6d057$var$getCssDimensions(element) {
    const css = (0, $1JZck.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $1JZck.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $2DoiL.round)(width) !== offsetWidth || (0, $2DoiL.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $10cd0423f1b6d057$var$unwrapElement(element) {
    return !(0, $1JZck.isElement)(element) ? element.contextElement : element;
}
function $10cd0423f1b6d057$var$getScale(element) {
    const domElement = $10cd0423f1b6d057$var$unwrapElement(element);
    if (!(0, $1JZck.isHTMLElement)(domElement)) return (0, $2DoiL.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $10cd0423f1b6d057$var$getCssDimensions(domElement);
    let x = ($ ? (0, $2DoiL.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $2DoiL.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $10cd0423f1b6d057$var$noOffsets = /*#__PURE__*/ (0, $2DoiL.createCoords)(0);
function $10cd0423f1b6d057$var$getVisualOffsets(element) {
    const win = (0, $1JZck.getWindow)(element);
    if (!(0, $1JZck.isWebKit)() || !win.visualViewport) return $10cd0423f1b6d057$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $10cd0423f1b6d057$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $1JZck.getWindow)(element)) return false;
    return isFixed;
}
function $10cd0423f1b6d057$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $10cd0423f1b6d057$var$unwrapElement(element);
    let scale = (0, $2DoiL.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $1JZck.isElement)(offsetParent)) scale = $10cd0423f1b6d057$var$getScale(offsetParent);
        } else scale = $10cd0423f1b6d057$var$getScale(element);
    }
    const visualOffsets = $10cd0423f1b6d057$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $10cd0423f1b6d057$var$getVisualOffsets(domElement) : (0, $2DoiL.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $1JZck.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $1JZck.isElement)(offsetParent) ? (0, $1JZck.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = currentWin.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $10cd0423f1b6d057$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $1JZck.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $1JZck.getWindow)(currentIFrame);
            currentIFrame = currentWin.frameElement;
        }
    }
    return (0, $2DoiL.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $10cd0423f1b6d057$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $1JZck.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $1JZck.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $2DoiL.createCoords)(1);
    const offsets = (0, $2DoiL.createCoords)(0);
    const isOffsetParentAnElement = (0, $1JZck.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1JZck.getNodeName)(offsetParent) !== 'body' || (0, $1JZck.isOverflowElement)(documentElement)) scroll = (0, $1JZck.getNodeScroll)(offsetParent);
        if ((0, $1JZck.isHTMLElement)(offsetParent)) {
            const offsetRect = $10cd0423f1b6d057$var$getBoundingClientRect(offsetParent);
            scale = $10cd0423f1b6d057$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $10cd0423f1b6d057$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $10cd0423f1b6d057$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $10cd0423f1b6d057$var$getBoundingClientRect((0, $1JZck.getDocumentElement)(element)).left + (0, $1JZck.getNodeScroll)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $10cd0423f1b6d057$var$getDocumentRect(element) {
    const html = (0, $1JZck.getDocumentElement)(element);
    const scroll = (0, $1JZck.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $2DoiL.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $2DoiL.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $10cd0423f1b6d057$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $1JZck.getComputedStyle)(body).direction === 'rtl') x += (0, $2DoiL.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $10cd0423f1b6d057$var$getViewportRect(element, strategy) {
    const win = (0, $1JZck.getWindow)(element);
    const html = (0, $1JZck.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $1JZck.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $10cd0423f1b6d057$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $10cd0423f1b6d057$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $1JZck.isHTMLElement)(element) ? $10cd0423f1b6d057$var$getScale(element) : (0, $2DoiL.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $10cd0423f1b6d057$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $10cd0423f1b6d057$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $10cd0423f1b6d057$var$getDocumentRect((0, $1JZck.getDocumentElement)(element));
    else if ((0, $1JZck.isElement)(clippingAncestor)) rect = $10cd0423f1b6d057$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $10cd0423f1b6d057$var$getVisualOffsets(element);
        rect = (0, $6EnDC._)((0, $ty6PY._)({}, clippingAncestor), {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        });
    }
    return (0, $2DoiL.rectToClientRect)(rect);
}
function $10cd0423f1b6d057$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $1JZck.getParentNode)(element);
    if (parentNode === stopNode || !(0, $1JZck.isElement)(parentNode) || (0, $1JZck.isLastTraversableNode)(parentNode)) return false;
    return (0, $1JZck.getComputedStyle)(parentNode).position === 'fixed' || $10cd0423f1b6d057$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $10cd0423f1b6d057$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $1JZck.getOverflowAncestors)(element, [], false).filter((el)=>(0, $1JZck.isElement)(el) && (0, $1JZck.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $1JZck.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $1JZck.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $1JZck.isElement)(currentNode) && !(0, $1JZck.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $1JZck.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $1JZck.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $1JZck.isOverflowElement)(currentNode) && !currentNodeIsContaining && $10cd0423f1b6d057$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $1JZck.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $10cd0423f1b6d057$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $1JZck.isTopLayer)(element) ? [] : $10cd0423f1b6d057$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $10cd0423f1b6d057$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $2DoiL.max)(rect.top, accRect.top);
        accRect.right = (0, $2DoiL.min)(rect.right, accRect.right);
        accRect.bottom = (0, $2DoiL.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $2DoiL.max)(rect.left, accRect.left);
        return accRect;
    }, $10cd0423f1b6d057$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $10cd0423f1b6d057$var$getDimensions(element) {
    const { width: width, height: height } = $10cd0423f1b6d057$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $10cd0423f1b6d057$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $1JZck.isHTMLElement)(offsetParent);
    const documentElement = (0, $1JZck.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $10cd0423f1b6d057$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $2DoiL.createCoords)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $1JZck.getNodeName)(offsetParent) !== 'body' || (0, $1JZck.isOverflowElement)(documentElement)) scroll = (0, $1JZck.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $10cd0423f1b6d057$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $10cd0423f1b6d057$var$getWindowScrollBarX(documentElement);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x;
    const y = rect.top + scroll.scrollTop - offsets.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $10cd0423f1b6d057$var$isStaticPositioned(element) {
    return (0, $1JZck.getComputedStyle)(element).position === 'static';
}
function $10cd0423f1b6d057$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $1JZck.isHTMLElement)(element) || (0, $1JZck.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $10cd0423f1b6d057$var$getOffsetParent(element, polyfill) {
    const win = (0, $1JZck.getWindow)(element);
    if ((0, $1JZck.isTopLayer)(element)) return win;
    if (!(0, $1JZck.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $1JZck.getParentNode)(element);
        while(svgOffsetParent && !(0, $1JZck.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $1JZck.isElement)(svgOffsetParent) && !$10cd0423f1b6d057$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $1JZck.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $10cd0423f1b6d057$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $1JZck.isTableElement)(offsetParent) && $10cd0423f1b6d057$var$isStaticPositioned(offsetParent))offsetParent = $10cd0423f1b6d057$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $1JZck.isLastTraversableNode)(offsetParent) && $10cd0423f1b6d057$var$isStaticPositioned(offsetParent) && !(0, $1JZck.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $1JZck.getContainingBlock)(element) || win;
}
const $10cd0423f1b6d057$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $10cd0423f1b6d057$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $10cd0423f1b6d057$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $10cd0423f1b6d057$var$isRTL(element) {
    return (0, $1JZck.getComputedStyle)(element).direction === 'rtl';
}
const $10cd0423f1b6d057$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $10cd0423f1b6d057$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $1JZck.getDocumentElement,
    getClippingRect: $10cd0423f1b6d057$var$getClippingRect,
    getOffsetParent: $10cd0423f1b6d057$var$getOffsetParent,
    getElementRects: $10cd0423f1b6d057$var$getElementRects,
    getClientRects: $10cd0423f1b6d057$var$getClientRects,
    getDimensions: $10cd0423f1b6d057$var$getDimensions,
    getScale: $10cd0423f1b6d057$var$getScale,
    isElement: $1JZck.isElement,
    isRTL: $10cd0423f1b6d057$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $10cd0423f1b6d057$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $1JZck.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $2DoiL.floor)(top);
        const insetRight = (0, $2DoiL.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $2DoiL.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $2DoiL.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $2DoiL.max)(0, (0, $2DoiL.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $6EnDC._)((0, $ty6PY._)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $10cd0423f1b6d057$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $10cd0423f1b6d057$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $1JZck.getOverflowAncestors)(referenceEl) : [],
        ...(0, $1JZck.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $10cd0423f1b6d057$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $10cd0423f1b6d057$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $10cd0423f1b6d057$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $10cd0423f1b6d057$export$37b6bde19b108ecc = (0, $lMpRQ.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $10cd0423f1b6d057$export$cc800923e997bb8 = (0, $lMpRQ.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $10cd0423f1b6d057$export$91fb6ecbd551914 = (0, $lMpRQ.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $10cd0423f1b6d057$export$fba63a578e423eb = (0, $lMpRQ.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $10cd0423f1b6d057$export$8a83211c878a3f1f = (0, $lMpRQ.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $10cd0423f1b6d057$export$346677f925de839c = (0, $lMpRQ.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $10cd0423f1b6d057$export$fe8985bb6374093c = (0, $lMpRQ.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $10cd0423f1b6d057$export$f2120bbfa5450bd2 = (0, $lMpRQ.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $10cd0423f1b6d057$export$18c8ad048e32c7d5 = (0, $lMpRQ.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $10cd0423f1b6d057$export$7bf07e38f3dc4b69 = (0, $lMpRQ.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $10cd0423f1b6d057$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $ty6PY._)({
        platform: $10cd0423f1b6d057$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $6EnDC._)((0, $ty6PY._)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $lMpRQ.computePosition)(reference, floating, (0, $6EnDC._)((0, $ty6PY._)({}, mergedOptions), {
        platform: platformWithCache
    }));
};

});
parcelRegister("lMpRQ", function(module, exports) {

$parcel$export(module.exports, "computePosition", function () { return $fdb2256725c31782$export$48a53dcb22e581d0; });
$parcel$export(module.exports, "detectOverflow", function () { return $fdb2256725c31782$export$37b6bde19b108ecc; });
$parcel$export(module.exports, "arrow", function () { return $fdb2256725c31782$export$f2120bbfa5450bd2; });
$parcel$export(module.exports, "autoPlacement", function () { return $fdb2256725c31782$export$91fb6ecbd551914; });
$parcel$export(module.exports, "flip", function () { return $fdb2256725c31782$export$8a83211c878a3f1f; });
$parcel$export(module.exports, "hide", function () { return $fdb2256725c31782$export$fe8985bb6374093c; });
$parcel$export(module.exports, "inline", function () { return $fdb2256725c31782$export$18c8ad048e32c7d5; });
$parcel$export(module.exports, "offset", function () { return $fdb2256725c31782$export$cc800923e997bb8; });
$parcel$export(module.exports, "shift", function () { return $fdb2256725c31782$export$fba63a578e423eb; });
$parcel$export(module.exports, "limitShift", function () { return $fdb2256725c31782$export$7bf07e38f3dc4b69; });
$parcel$export(module.exports, "size", function () { return $fdb2256725c31782$export$346677f925de839c; });
$parcel$export(module.exports, "rectToClientRect", function () { return (parcelRequire("2DoiL")).rectToClientRect; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $2DoiL = parcelRequire("2DoiL");
function $fdb2256725c31782$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $2DoiL.getSideAxis)(placement);
    const alignmentAxis = (0, $2DoiL.getAlignmentAxis)(placement);
    const alignLength = (0, $2DoiL.getAxisLength)(alignmentAxis);
    const side = (0, $2DoiL.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $2DoiL.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $fdb2256725c31782$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $fdb2256725c31782$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = (0, $6EnDC._)((0, $ty6PY._)({}, middlewareData), {
            [name]: (0, $ty6PY._)({}, middlewareData[name], data)
        });
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $fdb2256725c31782$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $fdb2256725c31782$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $2DoiL.evaluate)(options, state);
    const paddingObject = (0, $2DoiL.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $2DoiL.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $2DoiL.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $fdb2256725c31782$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $2DoiL.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $2DoiL.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $2DoiL.getAlignmentAxis)(placement);
            const length = (0, $2DoiL.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $2DoiL.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $2DoiL.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $2DoiL.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $2DoiL.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $ty6PY._)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $fdb2256725c31782$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $2DoiL.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $2DoiL.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $2DoiL.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $2DoiL.getAlignment)(placement) === alignment || (autoAlignment ? (0, $2DoiL.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $fdb2256725c31782$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $2DoiL.evaluate)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $2DoiL.placements), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $42tc5._)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $2DoiL.placements) ? $fdb2256725c31782$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $2DoiL.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $2DoiL.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $2DoiL.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $2DoiL.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $fdb2256725c31782$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $2DoiL.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $42tc5._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $2DoiL.getSide)(placement);
            const initialSideAxis = (0, $2DoiL.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $2DoiL.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $2DoiL.getOppositePlacement)(initialPlacement)
            ] : (0, $2DoiL.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $2DoiL.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $2DoiL.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $2DoiL.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $fdb2256725c31782$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $fdb2256725c31782$var$isAnySideFullyClipped(overflow) {
    return (0, $2DoiL.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $fdb2256725c31782$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const _evaluate = (0, $2DoiL.evaluate)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $42tc5._)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, (0, $6EnDC._)((0, $ty6PY._)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $fdb2256725c31782$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $fdb2256725c31782$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, (0, $6EnDC._)((0, $ty6PY._)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $fdb2256725c31782$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $fdb2256725c31782$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $fdb2256725c31782$var$getBoundingRect(rects) {
    const minX = (0, $2DoiL.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $2DoiL.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $2DoiL.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $2DoiL.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $fdb2256725c31782$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $2DoiL.rectToClientRect)($fdb2256725c31782$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $fdb2256725c31782$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $2DoiL.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $fdb2256725c31782$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $2DoiL.rectToClientRect)($fdb2256725c31782$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $2DoiL.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $2DoiL.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $2DoiL.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $2DoiL.getSide)(placement) === 'left';
                    const maxRight = (0, $2DoiL.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $2DoiL.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $fdb2256725c31782$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $2DoiL.getSide)(placement);
    const alignment = (0, $2DoiL.getAlignment)(placement);
    const isVertical = (0, $2DoiL.getSideAxis)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $2DoiL.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : (0, $ty6PY._)({
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null
    }, rawValue);
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $fdb2256725c31782$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $fdb2256725c31782$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $6EnDC._)((0, $ty6PY._)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $fdb2256725c31782$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const _evaluate = (0, $2DoiL.evaluate)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $42tc5._)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $2DoiL.getSideAxis)((0, $2DoiL.getSide)(placement));
            const mainAxis = (0, $2DoiL.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $2DoiL.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $2DoiL.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $6EnDC._)((0, $ty6PY._)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $6EnDC._)((0, $ty6PY._)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $fdb2256725c31782$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $2DoiL.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $2DoiL.getSideAxis)(placement);
            const mainAxis = (0, $2DoiL.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $2DoiL.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $ty6PY._)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $2DoiL.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $fdb2256725c31782$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $2DoiL.evaluate)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $42tc5._)(_evaluate, [
                "apply"
            ]);
            const overflow = await $fdb2256725c31782$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $2DoiL.getSide)(placement);
            const alignment = (0, $2DoiL.getAlignment)(placement);
            const isYAxis = (0, $2DoiL.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $2DoiL.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $2DoiL.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) availableWidth = alignment || noShift ? (0, $2DoiL.min)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            else availableHeight = alignment || noShift ? (0, $2DoiL.min)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $2DoiL.max)(overflow.left, 0);
                const xMax = (0, $2DoiL.max)(overflow.right, 0);
                const yMin = (0, $2DoiL.max)(overflow.top, 0);
                const yMax = (0, $2DoiL.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $2DoiL.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $2DoiL.max)(overflow.top, overflow.bottom));
            }
            await apply((0, $6EnDC._)((0, $ty6PY._)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};

});
parcelRegister("2DoiL", function(module, exports) {

$parcel$export(module.exports, "sides", function () { return $1eb2131d159f17e8$export$832b6fa47fa053d2; });
$parcel$export(module.exports, "placements", function () { return $1eb2131d159f17e8$export$803cd8101b6c182b; });
$parcel$export(module.exports, "min", function () { return $1eb2131d159f17e8$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $1eb2131d159f17e8$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $1eb2131d159f17e8$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "floor", function () { return $1eb2131d159f17e8$export$a3fe094919f356fd; });
$parcel$export(module.exports, "createCoords", function () { return $1eb2131d159f17e8$export$a397704b5e280835; });
$parcel$export(module.exports, "clamp", function () { return $1eb2131d159f17e8$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "evaluate", function () { return $1eb2131d159f17e8$export$fef61f332f2c0afc; });
$parcel$export(module.exports, "getSide", function () { return $1eb2131d159f17e8$export$3c915306cb7fc97a; });
$parcel$export(module.exports, "getAlignment", function () { return $1eb2131d159f17e8$export$f0989780f32bfcda; });
$parcel$export(module.exports, "getOppositeAxis", function () { return $1eb2131d159f17e8$export$8a000a963141ac32; });
$parcel$export(module.exports, "getAxisLength", function () { return $1eb2131d159f17e8$export$320bd9d53520c68a; });
$parcel$export(module.exports, "getSideAxis", function () { return $1eb2131d159f17e8$export$f28e8f882010718a; });
$parcel$export(module.exports, "getAlignmentAxis", function () { return $1eb2131d159f17e8$export$2b57e0052a6d6d4c; });
$parcel$export(module.exports, "getAlignmentSides", function () { return $1eb2131d159f17e8$export$be42861551f17911; });
$parcel$export(module.exports, "getOppositePlacement", function () { return $1eb2131d159f17e8$export$9c5e28bad23365fa; });
$parcel$export(module.exports, "getExpandedPlacements", function () { return $1eb2131d159f17e8$export$496432a3699e50b1; });
$parcel$export(module.exports, "getOppositeAlignmentPlacement", function () { return $1eb2131d159f17e8$export$2b182c584985588b; });
$parcel$export(module.exports, "getOppositeAxisPlacements", function () { return $1eb2131d159f17e8$export$a9b6fb18fd92c3ec; });
$parcel$export(module.exports, "getPaddingObject", function () { return $1eb2131d159f17e8$export$598c291c29bc2e71; });
$parcel$export(module.exports, "rectToClientRect", function () { return $1eb2131d159f17e8$export$ee05aea0aeecbad4; });
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
var $ty6PY = parcelRequire("ty6PY");
const $1eb2131d159f17e8$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $1eb2131d159f17e8$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $1eb2131d159f17e8$export$803cd8101b6c182b = /*#__PURE__*/ $1eb2131d159f17e8$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $1eb2131d159f17e8$export$27b07d8a310ed8b5[0], side + "-" + $1eb2131d159f17e8$export$27b07d8a310ed8b5[1]), []);
const $1eb2131d159f17e8$export$96ec731ed4dcb222 = Math.min;
const $1eb2131d159f17e8$export$8960430cfd85939f = Math.max;
const $1eb2131d159f17e8$export$2077e0241d6afd3c = Math.round;
const $1eb2131d159f17e8$export$a3fe094919f356fd = Math.floor;
const $1eb2131d159f17e8$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $1eb2131d159f17e8$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $1eb2131d159f17e8$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $1eb2131d159f17e8$export$7d15b64cf5a3a4c4(start, value, end) {
    return $1eb2131d159f17e8$export$8960430cfd85939f(start, $1eb2131d159f17e8$export$96ec731ed4dcb222(value, end));
}
function $1eb2131d159f17e8$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $1eb2131d159f17e8$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $1eb2131d159f17e8$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $1eb2131d159f17e8$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $1eb2131d159f17e8$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $1eb2131d159f17e8$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($1eb2131d159f17e8$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $1eb2131d159f17e8$export$2b57e0052a6d6d4c(placement) {
    return $1eb2131d159f17e8$export$8a000a963141ac32($1eb2131d159f17e8$export$f28e8f882010718a(placement));
}
function $1eb2131d159f17e8$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $1eb2131d159f17e8$export$f0989780f32bfcda(placement);
    const alignmentAxis = $1eb2131d159f17e8$export$2b57e0052a6d6d4c(placement);
    const length = $1eb2131d159f17e8$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $1eb2131d159f17e8$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $1eb2131d159f17e8$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $1eb2131d159f17e8$export$496432a3699e50b1(placement) {
    const oppositePlacement = $1eb2131d159f17e8$export$9c5e28bad23365fa(placement);
    return [
        $1eb2131d159f17e8$export$2b182c584985588b(placement),
        oppositePlacement,
        $1eb2131d159f17e8$export$2b182c584985588b(oppositePlacement)
    ];
}
function $1eb2131d159f17e8$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$1eb2131d159f17e8$var$oppositeAlignmentMap[alignment]);
}
function $1eb2131d159f17e8$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $1eb2131d159f17e8$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $1eb2131d159f17e8$export$f0989780f32bfcda(placement);
    let list = $1eb2131d159f17e8$var$getSideList($1eb2131d159f17e8$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($1eb2131d159f17e8$export$2b182c584985588b));
    }
    return list;
}
function $1eb2131d159f17e8$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$1eb2131d159f17e8$var$oppositeSideMap[side]);
}
function $1eb2131d159f17e8$export$1c66dbf1a9e34223(padding) {
    return (0, $ty6PY._)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $1eb2131d159f17e8$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $1eb2131d159f17e8$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $1eb2131d159f17e8$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}

});


parcelRegister("1JZck", function(module, exports) {

$parcel$export(module.exports, "getNodeName", function () { return $1449770e218ad528$export$651544f548703224; });
$parcel$export(module.exports, "getWindow", function () { return $1449770e218ad528$export$38b2d434cce3ea22; });
$parcel$export(module.exports, "getDocumentElement", function () { return $1449770e218ad528$export$e495491855dc5418; });
$parcel$export(module.exports, "isElement", function () { return $1449770e218ad528$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $1449770e218ad528$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isOverflowElement", function () { return $1449770e218ad528$export$989e911fa9af580a; });
$parcel$export(module.exports, "getComputedStyle", function () { return $1449770e218ad528$export$3735103072e4a80; });
$parcel$export(module.exports, "isTableElement", function () { return $1449770e218ad528$export$71535ffaa902797f; });
$parcel$export(module.exports, "isTopLayer", function () { return $1449770e218ad528$export$89e651af02346cd4; });
$parcel$export(module.exports, "isContainingBlock", function () { return $1449770e218ad528$export$d6c4e8150c35fed1; });
$parcel$export(module.exports, "isWebKit", function () { return $1449770e218ad528$export$78551043582a6a98; });
$parcel$export(module.exports, "getContainingBlock", function () { return $1449770e218ad528$export$940d8225183e1404; });
$parcel$export(module.exports, "getParentNode", function () { return $1449770e218ad528$export$4e12058fc4d51d56; });
$parcel$export(module.exports, "isLastTraversableNode", function () { return $1449770e218ad528$export$d1162fb0b6d4cd51; });
$parcel$export(module.exports, "getNodeScroll", function () { return $1449770e218ad528$export$dc8fc79fa2800137; });
$parcel$export(module.exports, "getOverflowAncestors", function () { return $1449770e218ad528$export$3b57c1601291186b; });
function $1449770e218ad528$export$651544f548703224(node) {
    if ($1449770e218ad528$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $1449770e218ad528$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $1449770e218ad528$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($1449770e218ad528$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $1449770e218ad528$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $1449770e218ad528$export$38b2d434cce3ea22(value).Node;
}
function $1449770e218ad528$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $1449770e218ad528$export$38b2d434cce3ea22(value).Element;
}
function $1449770e218ad528$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $1449770e218ad528$export$38b2d434cce3ea22(value).HTMLElement;
}
function $1449770e218ad528$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $1449770e218ad528$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $1449770e218ad528$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $1449770e218ad528$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $1449770e218ad528$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($1449770e218ad528$export$651544f548703224(element));
}
function $1449770e218ad528$export$89e651af02346cd4(element) {
    return [
        ':popover-open',
        ':modal'
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $1449770e218ad528$export$d6c4e8150c35fed1(element) {
    const webkit = $1449770e218ad528$export$78551043582a6a98();
    const css = $1449770e218ad528$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $1449770e218ad528$export$940d8225183e1404(element) {
    let currentNode = $1449770e218ad528$export$4e12058fc4d51d56(element);
    while($1449770e218ad528$export$1b3bfaa9684536aa(currentNode) && !$1449770e218ad528$export$d1162fb0b6d4cd51(currentNode)){
        if ($1449770e218ad528$export$89e651af02346cd4(currentNode)) return null;
        if ($1449770e218ad528$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        currentNode = $1449770e218ad528$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $1449770e218ad528$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $1449770e218ad528$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($1449770e218ad528$export$651544f548703224(node));
}
function $1449770e218ad528$export$3735103072e4a80(element) {
    return $1449770e218ad528$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $1449770e218ad528$export$dc8fc79fa2800137(element) {
    if ($1449770e218ad528$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $1449770e218ad528$export$4e12058fc4d51d56(node) {
    if ($1449770e218ad528$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $1449770e218ad528$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $1449770e218ad528$export$e495491855dc5418(node);
    return $1449770e218ad528$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $1449770e218ad528$export$7cd01a57c8ca906c(node) {
    const parentNode = $1449770e218ad528$export$4e12058fc4d51d56(node);
    if ($1449770e218ad528$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($1449770e218ad528$export$1b3bfaa9684536aa(parentNode) && $1449770e218ad528$export$989e911fa9af580a(parentNode)) return parentNode;
    return $1449770e218ad528$export$7cd01a57c8ca906c(parentNode);
}
function $1449770e218ad528$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $1449770e218ad528$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $1449770e218ad528$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $1449770e218ad528$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $1449770e218ad528$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $1449770e218ad528$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}

});


parcelRegister("f00Pp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aeb77f948d48cd02$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $aeb77f948d48cd02$var$index = (0, $8ZuGG.useLayoutEffect);
var $aeb77f948d48cd02$export$2e2bcd8739ae039 = $aeb77f948d48cd02$var$index;

});


parcelRegister("7liN9", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", function () { return $55891232467813cf$export$23c213f7717186af; });
$parcel$export(module.exports, "multiValueLabelCSS", function () { return $55891232467813cf$export$f40612612e0af964; });
$parcel$export(module.exports, "multiValueRemoveCSS", function () { return $55891232467813cf$export$283467f6c4ac142b; });
$parcel$export(module.exports, "MultiValueContainer", function () { return $55891232467813cf$export$cf9cf2a30a59265c; });
$parcel$export(module.exports, "MultiValueLabel", function () { return $55891232467813cf$export$544aeea2a5ce08ee; });
$parcel$export(module.exports, "MultiValueRemove", function () { return $55891232467813cf$export$8e1fd1a40e7a2f4a; });
$parcel$export(module.exports, "default", function () { return $55891232467813cf$export$2e2bcd8739ae039; });
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $6bkHe = parcelRequire("6bkHe");

var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $jbNRo = parcelRequire("jbNRo");

var $iIfnd = parcelRequire("iIfnd");

var $i2LcI = parcelRequire("i2LcI");

var $25MrG = parcelRequire("25MrG");
function $55891232467813cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55891232467813cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55891232467813cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55891232467813cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $55891232467813cf$var$multiValueStyles = {
    root: "_2rkolb4i _1e0c1txw _1ul9ze3t _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _bfhkm7j4 _p12f1osq _syazjpor _3yq3glyw",
    disabled: "_syaz1lh4 _bfhkm7j4",
    focused: "_syaz1wum _bfhkfg4m _16qs7ex6 _1aewe4h9 _6up51j28 _1xdnnqa1",
    refresh: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _bfhk1j9a"
};
var $55891232467813cf$export$23c213f7717186af = function multiValueCSS() {
    return {};
};
var $55891232467813cf$export$f40612612e0af964 = function multiValueLabelCSS() {
    return {};
};
var $55891232467813cf$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8dcr7 _o5721q9c _ca0qv77o _u5f3v77o _n3tdv77o _19bv12x7 _syaz1kw7",
    disabled: "_syaz1lh4",
    ellipsis: "_1bto1l2s",
    refresh: "_11c82smr _ca0qidpf _n3tdidpf _19bv1b66"
};
var $55891232467813cf$export$283467f6c4ac142b = function multiValueRemoveCSS() {
    return {};
};
var $55891232467813cf$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu1rrc",
    root: "_2rkovtp2 _4cvr1h6o _1e0c1txw _lswu1dx5 _19bvv77o _u5f3v77o _irr31yvi _13br1jjn _1di61io2 _i5f81jjn",
    refresh: "_19itglyw _2rko12b0 _bfhksm61 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _syaz1fxt _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _2hwxv77o _1ah312gs _irr3166n _1di61dty"
};
var $55891232467813cf$export$cf9cf2a30a59265c = function MultiValueContainer(_ref) {
    var children = _ref.children, innerProps = _ref.innerProps, isFocused = _ref.isFocused, isDisabled = _ref.isDisabled, className = _ref.className, xcss = _ref.xcss;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $55891232467813cf$var$multiValueStyles.root,
            isDisabled && $55891232467813cf$var$multiValueStyles.disabled,
            isFocused && $55891232467813cf$var$multiValueStyles.focused,
            (0, $i2LcI.fg)('platform-component-visual-refresh') && $55891232467813cf$var$multiValueStyles.refresh,
            (0, $4vuwT.cx)(className, xcss, '-multiValue')
        ])
    }), children);
};
var $55891232467813cf$export$544aeea2a5ce08ee = function MultiValueLabel(_ref2) {
    var children = _ref2.children, innerProps = _ref2.innerProps, isDisabled = _ref2.isDisabled, hasEllipsis = _ref2.hasEllipsis, className = _ref2.className, xcss = _ref2.xcss;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $55891232467813cf$var$multiValueLabelStyles.root,
            isDisabled && $55891232467813cf$var$multiValueLabelStyles.disabled,
            hasEllipsis && $55891232467813cf$var$multiValueLabelStyles.ellipsis,
            (0, $i2LcI.fg)('platform-component-visual-refresh') && $55891232467813cf$var$multiValueLabelStyles.refresh,
            (0, $4vuwT.cx)(className, xcss, '-MultiValueLabel')
        ])
    }), children);
};
var $55891232467813cf$var$disabledStyles = null;
var $55891232467813cf$var$enabledStyles = null;
function $55891232467813cf$export$8e1fd1a40e7a2f4a(_ref3) {
    var isDisabled = _ref3.isDisabled, isFocused = _ref3.isFocused, innerProps = _ref3.innerProps, className = _ref3.className, xcss = _ref3.xcss;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, innerProps, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
        className: (0, $c4hjl.default)([
            $55891232467813cf$var$multiValueRemoveStyles.root,
            isFocused && $55891232467813cf$var$multiValueRemoveStyles.focused,
            (0, $i2LcI.fg)('platform-component-visual-refresh') && $55891232467813cf$var$multiValueRemoveStyles.refresh,
            (0, $4vuwT.cx)(className, xcss, '-MultiValueRemove')
        ])
    }), /*#__PURE__*/ $8ZuGG.createElement("div", {
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
        className: (0, $c4hjl.default)([
            isDisabled && "_1e0cglyw",
            !isDisabled && "_1e0c1kw7"
        ])
    }, /*#__PURE__*/ $8ZuGG.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jbNRo))), {
        label: "",
        color: "currentColor",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iIfnd))),
        LEGACY_primaryColor: "transparent",
        LEGACY_secondaryColor: "inherit",
        LEGACY_size: "small",
        size: "small"
    })));
}
var $55891232467813cf$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, isFocused = props.isFocused, removeProps = props.removeProps, selectProps = props.selectProps, cropWithEllipsis = props.cropWithEllipsis;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    var ariaLabel = typeof children === 'string' ? children : data.label;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    }), containerCss = _getStyleProps.css, containerClassName = _getStyleProps.className;
    var _getStyleProps2 = (0, $25MrG.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    }), labelCss = _getStyleProps2.css, labelClassName = _getStyleProps2.className;
    var _getStyleProps3 = (0, $25MrG.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    }), removeCss = _getStyleProps3.css, removeClassName = _getStyleProps3.className;
    return /*#__PURE__*/ $8ZuGG.createElement(Container, {
        data: data,
        innerProps: $55891232467813cf$var$_objectSpread({
            style: containerCss,
            className: containerClassName
        }, innerProps),
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps
    }, /*#__PURE__*/ $8ZuGG.createElement(Label, {
        data: data,
        innerProps: {
            style: labelCss,
            className: labelClassName
        },
        className: labelClassName,
        hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
        selectProps: selectProps
    }, children), /*#__PURE__*/ $8ZuGG.createElement(Remove, {
        data: data,
        innerProps: $55891232467813cf$var$_objectSpread({
            style: removeCss,
            className: removeClassName,
            role: 'button',
            tabIndex: -1,
            'aria-label': "".concat(ariaLabel || 'option', ", remove")
        }, removeProps),
        className: removeClassName,
        isDisabled: isDisabled,
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55891232467813cf$export$2e2bcd8739ae039 = $55891232467813cf$var$MultiValue;

});
parcelRegister("jbNRo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13080645a1b889dca339823c8ecd9929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df85b89b3964742b$var$_react = $df85b89b3964742b$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $df85b89b3964742b$var$_baseNew = $df85b89b3964742b$var$_interopRequireDefault((parcelRequire("bkBMq")));
function $df85b89b3964742b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Cross".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: closing modals, panels, and transient views; removing tags
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $df85b89b3964742b$var$CrossIcon = (props)=>/*#__PURE__*/ $df85b89b3964742b$var$_react.default.createElement($df85b89b3964742b$var$_baseNew.default, Object.assign({
        name: "CrossIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.03 3.03 9.06 8l4.97 4.97-1.06 1.06L8 9.06l-4.97 4.97-1.06-1.06L6.94 8 1.97 3.03l1.06-1.06L8 6.94l4.97-4.97z"/>`
    }, props));
$df85b89b3964742b$var$CrossIcon.displayName = 'CrossIcon';
var $df85b89b3964742b$var$_default = module.exports.default = $df85b89b3964742b$var$CrossIcon;

});


parcelRegister("9xrYw", function(module, exports) {

$parcel$export(module.exports, "optionCSS", function () { return $6f1ce56a22a24403$export$ef897119b7e920ba; });
$parcel$export(module.exports, "default", function () { return $6f1ce56a22a24403$export$2e2bcd8739ae039; });
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $25MrG = parcelRequire("25MrG");
var $6f1ce56a22a24403$export$ef897119b7e920ba = function optionCSS() {
    return {};
};
var $6f1ce56a22a24403$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syaz1fxt _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di61dty",
    disabled: "_syaz1lh4 _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _1pknglyw",
    focused: "_bfhk166n _16qsu4to _1pkn1vrj",
    selected: "_syazaqb7 _bfhkfg4m _16qsu4to _1di619ru _1pkn1vrj",
    focusedSelected: "_bfhki1yw"
};
var $6f1ce56a22a24403$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $6f1ce56a22a24403$var$optionStyles.root,
            isFocused && $6f1ce56a22a24403$var$optionStyles.focused,
            isSelected && $6f1ce56a22a24403$var$optionStyles.selected,
            isFocused && isSelected && $6f1ce56a22a24403$var$optionStyles.focusedSelected,
            isDisabled && $6f1ce56a22a24403$var$optionStyles.disabled,
            (0, $4vuwT.cx)(className, xcss, '-option')
        ]),
        ref: innerRef
    }, innerProps, {
        tabIndex: -1
    }), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6f1ce56a22a24403$export$2e2bcd8739ae039 = $6f1ce56a22a24403$var$Option;

});

parcelRegister("6UaX5", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", function () { return $507077dd7f427527$export$5f3ffacd6594d90f; });
$parcel$export(module.exports, "default", function () { return $507077dd7f427527$export$2e2bcd8739ae039; });
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $25MrG = parcelRequire("25MrG");
var $507077dd7f427527$export$5f3ffacd6594d90f = function placeholderCSS() {
    return {};
};
var $507077dd7f427527$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz131l",
    disabled: "_syaz1lh4"
};
var $507077dd7f427527$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'placeholder', {
        placeholder: true
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $507077dd7f427527$var$placeholderStyles.root,
            isDisabled && $507077dd7f427527$var$placeholderStyles.disabled,
            (0, $4vuwT.cx)(className, xcss, '-placeholder')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$507077dd7f427527$export$2e2bcd8739ae039 = $507077dd7f427527$var$Placeholder;

});

parcelRegister("4n8Y0", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $32f0440e379ec9ba$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $32f0440e379ec9ba$export$2e2bcd8739ae039; });
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $4vuwT = parcelRequire("4vuwT");

var $25MrG = parcelRequire("25MrG");
var $32f0440e379ec9ba$export$dbf350e5966cf602 = function css() {
    return {};
};
var $32f0440e379ec9ba$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1fxt",
    disalbed: "_syaz1lh4"
};
var $32f0440e379ec9ba$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps, xcss = props.xcss;
    var _getStyleProps = (0, $25MrG.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), css = _getStyleProps.css, className = _getStyleProps.className;
    return /*#__PURE__*/ $8ZuGG.createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: css,
        className: (0, $c4hjl.default)([
            $32f0440e379ec9ba$var$styles.root,
            isDisabled && $32f0440e379ec9ba$var$styles.disalbed,
            (0, $4vuwT.cx)(className, xcss, '-singleValue')
        ])
    }, innerProps), children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$32f0440e379ec9ba$export$2e2bcd8739ae039 = $32f0440e379ec9ba$var$SingleValue;

});


parcelRegister("4uUwO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3465d01c78d206dc$export$2e2bcd8739ae039; });
/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $25MrG = parcelRequire("25MrG");
var $3465d01c78d206dc$var$_excluded = [
    "innerRef"
];
var $3465d01c78d206dc$var$dummyInputStyles = null;
function $3465d01c78d206dc$export$2e2bcd8739ae039(_ref) {
    var innerRef = _ref.innerRef, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $3465d01c78d206dc$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $25MrG.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ $8ZuGG.createElement("input", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        ref: innerRef,
        className: (0, $c4hjl.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ])
    }, filteredProps));
}

});

parcelRegister("hnn75", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6683761313122d$export$2e2bcd8739ae039; });
/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");

var $5AVd4 = parcelRequire("5AVd4");
var $ca6683761313122d$var$styles = null;
var $ca6683761313122d$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return /*#__PURE__*/ $8ZuGG.createElement("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $c4hjl.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $5AVd4.default)
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$ca6683761313122d$export$2e2bcd8739ae039 = $ca6683761313122d$var$RequiredInput;

});

parcelRegister("eoLTl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7b874e1b68041a6$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $8xG3o = parcelRequire("8xG3o");

var $bZKkE = parcelRequire("bZKkE");
var $a7b874e1b68041a6$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $a7b874e1b68041a6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = (0, $8xG3o.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = (0, $bZKkE.default)({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Fragment), null, lockEnabled && /*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        onClick: $a7b874e1b68041a6$var$blurSelectInput,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            position: 'fixed',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetBlockStart: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineEnd: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            insetInlineStart: 0
        }
    }), children(targetRef));
}

});
parcelRegister("8xG3o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $638206cb43c88edd$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $25MrG = parcelRequire("25MrG");
var $638206cb43c88edd$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $638206cb43c88edd$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $8ZuGG.useRef)(false);
    var isTop = (0, $8ZuGG.useRef)(false);
    var touchStart = (0, $8ZuGG.useRef)(0);
    var scrollTarget = (0, $8ZuGG.useRef)(null);
    var handleEventDelta = (0, $8ZuGG.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $638206cb43c88edd$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $8ZuGG.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $8ZuGG.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $8ZuGG.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $8ZuGG.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $25MrG.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $8ZuGG.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});

parcelRegister("bZKkE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bb954d22882c70a$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $8bb954d22882c70a$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $8bb954d22882c70a$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $8bb954d22882c70a$var$preventTouchMove(e) {
    e.preventDefault();
}
function $8bb954d22882c70a$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $8bb954d22882c70a$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8bb954d22882c70a$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $8bb954d22882c70a$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $8bb954d22882c70a$var$activeScrollLocks = 0;
var $8bb954d22882c70a$var$listenerOptions = {
    capture: false,
    passive: false
};
function $8bb954d22882c70a$export$2e2bcd8739ae039(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $8ZuGG.useRef)({});
    var scrollTarget = (0, $8ZuGG.useRef)(null);
    var addScrollLock = (0, $8ZuGG.useCallback)(function(touchScrollTarget) {
        if (!$8bb954d22882c70a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $8bb954d22882c70a$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $8bb954d22882c70a$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($8bb954d22882c70a$var$LOCK_STYLES).forEach(function(key) {
                var val = $8bb954d22882c70a$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $8bb954d22882c70a$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $8bb954d22882c70a$var$preventTouchMove, $8bb954d22882c70a$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $8bb954d22882c70a$var$preventInertiaScroll, $8bb954d22882c70a$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $8bb954d22882c70a$var$allowTouchMove, $8bb954d22882c70a$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $8bb954d22882c70a$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $8ZuGG.useCallback)(function(touchScrollTarget) {
        if (!$8bb954d22882c70a$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $8bb954d22882c70a$var$activeScrollLocks = Math.max($8bb954d22882c70a$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $8bb954d22882c70a$var$activeScrollLocks < 1) $8bb954d22882c70a$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $8bb954d22882c70a$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $8bb954d22882c70a$var$preventTouchMove, $8bb954d22882c70a$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $8bb954d22882c70a$var$preventInertiaScroll, $8bb954d22882c70a$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $8bb954d22882c70a$var$allowTouchMove, $8bb954d22882c70a$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}

});


parcelRegister("2HjZS", function(module, exports) {

$parcel$export(module.exports, "NotifyOpenLayerObserver", function () { return $1f6f1bec59ef0e9c$export$17baa7c95b6ba1b8; });

var $k4ILS = parcelRequire("k4ILS");
function $1f6f1bec59ef0e9c$export$17baa7c95b6ba1b8(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose;
    // @ts-ignore - hot-116676
    (0, $k4ILS.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}

});

parcelRegister("dkmve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b3e99310b90a883$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $kqdSN = parcelRequire("kqdSN");

var $OlGPf = parcelRequire("OlGPf");
function $9b3e99310b90a883$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9b3e99310b90a883$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9b3e99310b90a883$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9b3e99310b90a883$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// ==============================
// Root Container
// ==============================
var $9b3e99310b90a883$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isOptionDisabled = selectProps.isOptionDisabled, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, isLoading = selectProps.isLoading;
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $8ZuGG.useMemo)(function() {
        return $9b3e99310b90a883$var$_objectSpread($9b3e99310b90a883$var$_objectSpread({}, (0, $kqdSN.defaultAriaLiveMessages)), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $8ZuGG.useMemo)(function() {
        var message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            var onChangeProps = $9b3e99310b90a883$var$_objectSpread({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    var ariaResults = (0, $8ZuGG.useMemo)(function() {
        var resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ScreenReaderText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("span", {
        id: "aria-results"
    }, ariaResults));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ZuGG.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $OlGPf.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $OlGPf.default), {
        "aria-live": ariaLive // Should be undefined by default unless a specific use case requires it
        ,
        role: "status"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9b3e99310b90a883$export$2e2bcd8739ae039 = $9b3e99310b90a883$var$LiveRegion;

});
parcelRegister("kqdSN", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", function () { return $ede1013214f93d00$export$a7265767c78f9bae; });
/* eslint-disable @atlaskit/platform/ensure-feature-flag-prefix */ var $ede1013214f93d00$export$a7265767c78f9bae = {
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? "option ".concat(label, ", deselected") : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
            default:
                return '';
        }
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
    }
};

});

parcelRegister("OlGPf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09757ec18996a29b$export$2e2bcd8739ae039; });
/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $c4hjl = parcelRequire("c4hjl");
// Assistive text to describe visual elements. Hidden for sighted users.
var $09757ec18996a29b$var$styles = null;
var $09757ec18996a29b$var$A11yText = function A11yText(props) {
    return /*#__PURE__*/ $8ZuGG.createElement("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $c4hjl.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ])
    }, props));
};
var $09757ec18996a29b$export$2e2bcd8739ae039 = $09757ec18996a29b$var$A11yText;

});


parcelRegister("5d1uE", function(module, exports) {

$parcel$export(module.exports, "createFilter", function () { return $3caf53355817bab5$export$5d81789ff4aeccdf; });

var $6bkHe = parcelRequire("6bkHe");

var $tazez = parcelRequire("tazez");

var $FQVRP = parcelRequire("FQVRP");
function $3caf53355817bab5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3caf53355817bab5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3caf53355817bab5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3caf53355817bab5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3caf53355817bab5$var$memoizedStripDiacriticsForInput = (0, $tazez.default)((0, $FQVRP.stripDiacritics));
var $3caf53355817bab5$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $3caf53355817bab5$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $3caf53355817bab5$export$5d81789ff4aeccdf = function createFilter(config) {
    return function(option, rawInput) {
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = $3caf53355817bab5$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $3caf53355817bab5$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $3caf53355817bab5$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $3caf53355817bab5$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $3caf53355817bab5$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $FQVRP.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};

});
parcelRegister("FQVRP", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", function () { return $07dce3b5d839c0e0$export$b5bee4b27048330b; });
var $07dce3b5d839c0e0$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $07dce3b5d839c0e0$var$anyDiacritic = new RegExp('[' + $07dce3b5d839c0e0$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $07dce3b5d839c0e0$var$diacriticToBase = {};
for(var $07dce3b5d839c0e0$var$i = 0; $07dce3b5d839c0e0$var$i < $07dce3b5d839c0e0$var$diacritics.length; $07dce3b5d839c0e0$var$i++){
    var $07dce3b5d839c0e0$var$diacritic = $07dce3b5d839c0e0$var$diacritics[$07dce3b5d839c0e0$var$i];
    for(var $07dce3b5d839c0e0$var$j = 0; $07dce3b5d839c0e0$var$j < $07dce3b5d839c0e0$var$diacritic.letters.length; $07dce3b5d839c0e0$var$j++)$07dce3b5d839c0e0$var$diacriticToBase[$07dce3b5d839c0e0$var$diacritic.letters[$07dce3b5d839c0e0$var$j]] = $07dce3b5d839c0e0$var$diacritic.base;
}
var $07dce3b5d839c0e0$export$b5bee4b27048330b = function stripDiacritics(str) {
    return str.replace($07dce3b5d839c0e0$var$anyDiacritic, function(match) {
        return $07dce3b5d839c0e0$var$diacriticToBase[match];
    });
};

});


parcelRegister("8uyTq", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", function () { return $62ec3116107e9097$export$214b055320e0bf32; });

var $6bkHe = parcelRequire("6bkHe");

var $kVnoh = parcelRequire("kVnoh");

var $bPKfZ = parcelRequire("bPKfZ");

var $eH3YC = parcelRequire("eH3YC");

var $7rsQT = parcelRequire("7rsQT");

var $jewLi = parcelRequire("jewLi");

var $6TEmx = parcelRequire("6TEmx");

var $7liN9 = parcelRequire("7liN9");

var $9xrYw = parcelRequire("9xrYw");

var $6UaX5 = parcelRequire("6UaX5");

var $4n8Y0 = parcelRequire("4n8Y0");
function $62ec3116107e9097$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62ec3116107e9097$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62ec3116107e9097$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62ec3116107e9097$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $62ec3116107e9097$export$214b055320e0bf32 = {
    clearIndicator: (0, $7rsQT.clearIndicatorCSS),
    container: (0, $kVnoh.containerCSS),
    control: (0, $bPKfZ.css),
    dropdownIndicator: (0, $7rsQT.dropdownIndicatorCSS),
    group: (0, $eH3YC.groupCSS),
    groupHeading: (0, $eH3YC.groupHeadingCSS),
    indicatorsContainer: (0, $kVnoh.indicatorsContainerCSS),
    input: (0, $jewLi.inputCSS),
    loadingIndicator: (0, $7rsQT.loadingIndicatorCSS),
    loadingMessage: (0, $6TEmx.loadingMessageCSS),
    menu: (0, $6TEmx.menuCSS),
    menuList: (0, $6TEmx.menuListCSS),
    menuPortal: (0, $6TEmx.menuPortalCSS),
    multiValue: (0, $7liN9.multiValueCSS),
    multiValueLabel: (0, $7liN9.multiValueLabelCSS),
    multiValueRemove: (0, $7liN9.multiValueRemoveCSS),
    noOptionsMessage: (0, $6TEmx.noOptionsMessageCSS),
    option: (0, $9xrYw.optionCSS),
    placeholder: (0, $6UaX5.placeholderCSS),
    singleValue: (0, $4n8Y0.css),
    valueContainer: (0, $kVnoh.valueContainerCSS)
};
function $62ec3116107e9097$export$e618dc39ac9ad607(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $62ec3116107e9097$var$_objectSpread({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});


parcelRegister("8YsWW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $688a6223cefade4f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $25MrG = parcelRequire("25MrG");
var $688a6223cefade4f$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $688a6223cefade4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $688a6223cefade4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $688a6223cefade4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $688a6223cefade4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $688a6223cefade4f$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions, propsOptions = _ref.options, _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $688a6223cefade4f$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $8ZuGG.useRef)(undefined);
    var mounted = (0, $8ZuGG.useRef)(false);
    var _useState = (0, $8ZuGG.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $8ZuGG.useState)(propsDefaultOptions === true), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $8ZuGG.useState)(undefined), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $8ZuGG.useState)([]), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState9, 2), loadedOptions = _useState0[0], setLoadedOptions = _useState0[1];
    var _useState1 = (0, $8ZuGG.useState)(false), _useState10 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState1, 2), passEmptyOptions = _useState10[0], setPassEmptyOptions = _useState10[1];
    var _useState11 = (0, $8ZuGG.useState)({}), _useState12 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState11, 2), optionsCache = _useState12[0], setOptionsCache = _useState12[1];
    var _useState13 = (0, $8ZuGG.useState)(undefined), _useState14 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState13, 2), prevDefaultOptions = _useState14[0], setPrevDefaultOptions = _useState14[1];
    var _useState15 = (0, $8ZuGG.useState)(undefined), _useState16 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState15, 2), prevCacheOptions = _useState16[0], setPrevCacheOptions = _useState16[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $8ZuGG.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $8ZuGG.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $8ZuGG.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $25MrG.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? $688a6223cefade4f$var$_objectSpread($688a6223cefade4f$var$_objectSpread({}, optionsCache), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return $688a6223cefade4f$var$_objectSpread($688a6223cefade4f$var$_objectSpread({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});

parcelRegister("eLAgR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac01971d59c9d958$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");
var $ac01971d59c9d958$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $ac01971d59c9d958$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ac01971d59c9d958$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ac01971d59c9d958$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ac01971d59c9d958$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ac01971d59c9d958$export$2e2bcd8739ae039(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $ac01971d59c9d958$var$_excluded);
    var _useState = (0, $8ZuGG.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $8ZuGG.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $8ZuGG.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $8ZuGG.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $8ZuGG.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $8ZuGG.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return $ac01971d59c9d958$var$_objectSpread($ac01971d59c9d958$var$_objectSpread({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});


parcelRegister("8a92z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f164529bf95e81e$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");
var $5f164529bf95e81e$var$_excluded = [
    "ariaLiveMessages",
    "isInvalid",
    "onClickPreventDefault",
    "tabSelectsValue",
    "validationState"
];
function $5f164529bf95e81e$export$2e2bcd8739ae039(WrappedComponent) {
    var AtlaskitSelect = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        var ariaLiveMessages = props.ariaLiveMessages, isInvalid = props.isInvalid, _props$onClickPrevent = props.onClickPreventDefault, onClickPreventDefault = _props$onClickPrevent === void 0 ? true : _props$onClickPrevent, _props$tabSelectsValu = props.tabSelectsValue, tabSelectsValue = _props$tabSelectsValu === void 0 ? false : _props$tabSelectsValu, _props$validationStat = props.validationState, validationState = _props$validationStat === void 0 ? 'default' : _props$validationStat, restProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $5f164529bf95e81e$var$_excluded);
        var internalSelectRef = (0, $8ZuGG.useRef)(null);
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $8ZuGG.useImperativeHandle)(forwardedRef, function() {
            return {
                select: internalSelectRef.current,
                focus: function focus() {
                    var _internalSelectRef$cu;
                    return (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.focus();
                },
                blur: function blur() {
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.blur();
                }
            };
        }, []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(WrappedComponent, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            ref: internalSelectRef,
            ariaLiveMessages: ariaLiveMessages,
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            isInvalid: isInvalid || validationState === 'error'
        }, restProps, {
            // indicates react-select to be async by default using the base Select component
            // so that makers can pass all async props on the base select to async load options.
            isAsync: true
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});




parcelRegister("7NASj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f179d2c79d896e64$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $kTdw7 = parcelRequire("kTdw7");

var $1SvOA = parcelRequire("1SvOA");

var $bzwdU = parcelRequire("bzwdU");

var $hRWcy = parcelRequire("hRWcy");

var $8B60H = parcelRequire("8B60H");

var $2eWKq = parcelRequire("2eWKq");

var $kp1Z7 = parcelRequire("kp1Z7");

var $8dHAc = parcelRequire("8dHAc");
let $f179d2c79d896e64$var$_ = (t)=>t, $f179d2c79d896e64$var$t, $f179d2c79d896e64$var$t1, $f179d2c79d896e64$var$t2, $f179d2c79d896e64$var$t3;
const $f179d2c79d896e64$var$SocialLoginBlock = (0, $9Vz68.default).div($f179d2c79d896e64$var$t || ($f179d2c79d896e64$var$t = $f179d2c79d896e64$var$_`
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${0}px;

  border: 1px solid ${0};
  border-radius: 3px;
`), (0, $5b7Z4.gridSize)() * 1.5, (0, $kTdw7.N50));
const $f179d2c79d896e64$var$Header = (0, $9Vz68.default).div($f179d2c79d896e64$var$t1 || ($f179d2c79d896e64$var$t1 = $f179d2c79d896e64$var$_`
  display: flex;
  align-self: center;
  justify-content: center;

  width: 100%;
  padding-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 1.5);
const $f179d2c79d896e64$var$Email = (0, $9Vz68.default).div($f179d2c79d896e64$var$t2 || ($f179d2c79d896e64$var$t2 = $f179d2c79d896e64$var$_`
  font-weight: 600;
  font-size: 14px;
  line-height: ${0}px;
  color: ${0};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`), (0, $5b7Z4.gridSize)() * 3, (0, $kTdw7.N800));
const $f179d2c79d896e64$var$Logo = (0, $9Vz68.default).img($f179d2c79d896e64$var$t3 || ($f179d2c79d896e64$var$t3 = $f179d2c79d896e64$var$_`
  height: ${0}px;
  padding-right: ${0}px;
`), (0, $5b7Z4.gridSize)() * 3, (0, $5b7Z4.gridSize)());
const $f179d2c79d896e64$var$getLogo = (highlightedSocialProvider)=>{
    switch(highlightedSocialProvider){
        case (0, $8dHAc.SocialProvider).Google:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hRWcy));
        case (0, $8dHAc.SocialProvider).Microsoft:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8B60H));
        case (0, $8dHAc.SocialProvider).Apple:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2eWKq));
        case (0, $8dHAc.SocialProvider).Slack:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kp1Z7));
    }
};
const $f179d2c79d896e64$var$getSocialLoginHandler = ({ highlightedSocialProvider: highlightedSocialProvider, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleAppleLogin: handleAppleLogin, handleSlackLogin: handleSlackLogin })=>{
    switch(highlightedSocialProvider){
        case (0, $8dHAc.SocialProvider).Google:
            return handleGoogleLogin;
        case (0, $8dHAc.SocialProvider).Microsoft:
            return handleMicrosoftLogin;
        case (0, $8dHAc.SocialProvider).Apple:
            return handleAppleLogin;
        case (0, $8dHAc.SocialProvider).Slack:
            return handleSlackLogin;
    }
};
const $f179d2c79d896e64$var$SocialLoginForm = (props)=>{
    const { highlightedSocialProvider: highlightedSocialProvider, email: email } = props;
    const handleSocialLogin = $f179d2c79d896e64$var$getSocialLoginHandler(props);
    return /*#__PURE__*/ (0, $6rcps.jsxs)($f179d2c79d896e64$var$SocialLoginBlock, {
        "data-testid": "social-login-form",
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)($f179d2c79d896e64$var$Header, {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)($f179d2c79d896e64$var$Logo, {
                        src: $f179d2c79d896e64$var$getLogo(highlightedSocialProvider),
                        alt: `${highlightedSocialProvider} logo`
                    }),
                    email && /*#__PURE__*/ (0, $6rcps.jsx)($f179d2c79d896e64$var$Email, {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                isFullWidth: true,
                id: "social-login-submit",
                appearance: "primary",
                onClick: handleSocialLogin,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $bzwdU.default).continueWith), {
                    values: {
                        socialProviderName: highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
                    }
                }))
            })
        ]
    });
};
var $f179d2c79d896e64$export$2e2bcd8739ae039 = $f179d2c79d896e64$var$SocialLoginForm;

});
parcelRegister("bzwdU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b139620356dc33c$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $1b139620356dc33c$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    continueWith: {
        id: 'social.login.form.continue-button',
        defaultMessage: 'Continue with {socialProviderName}',
        description: 'Button label that is a CTA for users to continue logging in using the selected social provider.'
    }
});

});


parcelRegister("40CJF", function(module, exports) {

$parcel$export(module.exports, "LoginPageMessages", function () { return $a267e8dbeb6a098f$export$81a860015c7169ad; });

var $3VrrU = parcelRequire("3VrrU");
const $a267e8dbeb6a098f$export$81a860015c7169ad = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'login.head.title',
        defaultMessage: 'Log in to continue'
    },
    contextualTitle: {
        id: 'login.contextual.title',
        defaultMessage: 'Continue to',
        description: `Precedes a page title or issue number. For example, "Continue to Sarah's Blogpost" or "Continue to TED-1024"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    createAnAccount: {
        id: 'login.create.an.account',
        defaultMessage: 'Create an account'
    },
    passwordlessSuccessTitle: {
        id: 'login.passwordless.success.title',
        defaultMessage: 'Email sent'
    },
    passwordlessSuccessDescription: {
        id: 'login.passwordless.success.description',
        defaultMessage: "We've sent you an email to log in."
    },
    socialFormHeader: {
        id: 'login.social.form.header',
        defaultMessage: 'Log in',
        description: 'Subtle header shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormTitle: {
        id: 'login.social.form.title',
        defaultMessage: 'You logged in with your {socialProviderName} account before',
        description: 'Title shown on the social login form which allows users to login with the chosen social provider'
    },
    socialFormUseDifferentLoginMethod: {
        id: 'login.social.form.use-different-login-method',
        defaultMessage: 'Use a different login method',
        description: 'Button label shown on the social login form which allows users to login using another method. Takes the user back to the original login form.'
    },
    continueAs: {
        id: 'continue.as.title.as',
        defaultMessage: 'Continue as',
        description: 'This is a page title that will be followed by an avatar hero with name and email'
    }
});

});

parcelRegister("9Codz", function(module, exports) {

$parcel$export(module.exports, "useLoginState", function () { return $c85ffdeeaa93c7c3$export$bb159be17b1f5f11; });

var $jtt5y = parcelRequire("jtt5y");

var $1uBrV = parcelRequire("1uBrV");

var $kOqgB = parcelRequire("kOqgB");

var $fouZP = parcelRequire("fouZP");

var $8ZuGG = parcelRequire("8ZuGG");

var $9NVnN = parcelRequire("9NVnN");
const $c85ffdeeaa93c7c3$var$usePreloadedState = ()=>{
    const appConfig = (0, $kOqgB.useAppSelector)((state)=>state.appConfig);
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const hashedCsrfToken = (0, $kOqgB.useAppSelector)((state)=>state.hashedCsrfToken);
    const login = (0, $kOqgB.useAppSelector)((state)=>state.login);
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    return {
        appConfig: appConfig,
        csrfToken: csrfToken,
        cobranding: cobranding,
        hashedCsrfToken: hashedCsrfToken,
        login: login,
        oidcContext: oidcContext
    };
};
const $c85ffdeeaa93c7c3$export$bb159be17b1f5f11 = ()=>{
    const noServerState = (0, $1uBrV.isSasStateEndpointEnabled)() && (0, $jtt5y.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $1uBrV.usePageState)('/login/state', {
        enabled: noServerState
    });
    (0, $8ZuGG.useEffect)(()=>{
        if ((0, $1uBrV.isPageStateResult)(stateFromApi)) dispatch((0, $fouZP.loginSetState)(stateFromApi));
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $c85ffdeeaa93c7c3$var$usePreloadedState();
    if ((0, $1uBrV.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: stateFromApi,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});

parcelRegister("oXIXy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0a5e81d1b879ffb$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $bceLx = parcelRequire("bceLx");

var $pO9YU = parcelRequire("pO9YU");

var $f19CI = parcelRequire("f19CI");

var $day6I = parcelRequire("day6I");

var $8XRuq = parcelRequire("8XRuq");
const $b0a5e81d1b879ffb$var$Footer = ({ isEmbedded: isEmbedded, oidcContext: oidcContext })=>{
    if (isEmbedded) return null;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
                className: "fine-print",
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.PrivacyPolicyLink), {
                            isMobileLink: (0, $day6I.isMobileOidc)(oidcContext)
                        })
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                    /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.UserNoticeLink), {
                            isMobileLink: (0, $day6I.isMobileOidc)(oidcContext)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $8XRuq.RecaptchaNoticeContainer), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $f19CI.RecaptchaNotice), {})
            })
        ]
    });
};
var $b0a5e81d1b879ffb$export$2e2bcd8739ae039 = $b0a5e81d1b879ffb$var$Footer;

});
parcelRegister("8XRuq", function(module, exports) {

$parcel$export(module.exports, "RecaptchaNoticeContainer", function () { return $ce0fa0d16dcb2048$export$e55f3ed22cb4599; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $ce0fa0d16dcb2048$var$_ = (t)=>t, $ce0fa0d16dcb2048$var$t;
const $ce0fa0d16dcb2048$export$e55f3ed22cb4599 = (0, $9Vz68.default).div($ce0fa0d16dcb2048$var$t || ($ce0fa0d16dcb2048$var$t = $ce0fa0d16dcb2048$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());

});


parcelRegister("1yJSg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f82df67c5df6760a$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $40CJF = parcelRequire("40CJF");

var $5VQjR = parcelRequire("5VQjR");
const $f82df67c5df6760a$var$Header = ({ highlightedSocialProvider: highlightedSocialProvider, showSocialLoginOnly: showSocialLoginOnly })=>{
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $40CJF.LoginPageMessages).socialFormTitle), {
            values: {
                socialProviderName: highlightedSocialProvider === null || highlightedSocialProvider === void 0 ? void 0 : highlightedSocialProvider.replace(/^./, (str)=>str.toUpperCase())
            }
        }))
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
        size: "small",
        as: "h1",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $40CJF.LoginPageMessages).headTitle))
    });
};
var $f82df67c5df6760a$export$2e2bcd8739ae039 = $f82df67c5df6760a$var$Header;

});

parcelRegister("kyxFY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd5e88d0ab81a9f2$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $l1nfA = parcelRequire("l1nfA");
const $cd5e88d0ab81a9f2$var$MaybeSocialLoginPanel = ({ isEmbedded: isEmbedded, isSocialBlocked: isSocialBlocked, envSupportsSocialLogin: envSupportsSocialLogin, onGoogleLogin: onGoogleLogin, onMicrosoftLogin: onMicrosoftLogin, onAppleLogin: onAppleLogin, onSlackLogin: onSlackLogin })=>{
    if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.default), {
        handleGoogleLogin: onGoogleLogin,
        handleMicrosoftLogin: onMicrosoftLogin,
        handleAppleLogin: onAppleLogin,
        handleSlackLogin: onSlackLogin
    });
};
var $cd5e88d0ab81a9f2$export$2e2bcd8739ae039 = $cd5e88d0ab81a9f2$var$MaybeSocialLoginPanel;

});

parcelRegister("hQdhs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b254402a60807448$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $jSnDV = parcelRequire("jSnDV");

var $kOqgB = parcelRequire("kOqgB");

var $fouZP = parcelRequire("fouZP");

var $bceLx = parcelRequire("bceLx");

var $9OvaU = parcelRequire("9OvaU");

var $8dHAc = parcelRequire("8dHAc");

var $day6I = parcelRequire("day6I");

var $lk8Tl = parcelRequire("lk8Tl");

var $40CJF = parcelRequire("40CJF");

var $5Nhr0 = parcelRequire("5Nhr0");

var $52ngs = parcelRequire("52ngs");

var $iLUF6 = parcelRequire("iLUF6");

var $3ir1n = parcelRequire("3ir1n");
const $b254402a60807448$var$WhiteboxFooter = ({ isMobileApp: isMobileApp, oidcContext: oidcContext, showSocialLoginOnly: showSocialLoginOnly })=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
    const signupLinkEnabled = (0, $8ZuGG.useMemo)(()=>{
        // Due to Apple Store rules, we don't want sign up link on login page in Mobile OAuth case, unless we provide redirection from login to signup
        const shouldRenderSignupLink = isCommercial && (!isMobileApp || (0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).LoginWithRedirect));
        return queryParams.shide !== 'true' && shouldRenderSignupLink;
    }, [
        isCommercial,
        isMobileApp,
        oidcContext,
        queryParams.shide
    ]);
    if (showSocialLoginOnly) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
        id: "use-a-different-login-method",
        spacing: "none",
        onClick: ()=>{
            dispatch((0, $fouZP.resetLoginForm)());
        },
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $40CJF.LoginPageMessages).socialFormUseDifferentLoginMethod))
    });
    return /*#__PURE__*/ (0, $6rcps.jsxs)("ul", {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "trouble.logging.in",
                        defaultMessage: "Can't log in?"
                    })
                })
            }),
            signupLinkEnabled && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $bceLx.default), {}),
                    /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $iLUF6.LinkToSignupPage), {
                            onClick: ()=>analyticsClient.linkClickedEvent((0, $5Nhr0.loginPageId), 'signUpLink'),
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $40CJF.LoginPageMessages).createAnAccount))
                        })
                    })
                ]
            })
        ]
    });
};
var $b254402a60807448$export$2e2bcd8739ae039 = $b254402a60807448$var$WhiteboxFooter;

});
parcelRegister("52ngs", function(module, exports) {

$parcel$export(module.exports, "ResetPasswordLink", function () { return $48d3bb3cd226aaf7$export$67fc22a75e0cc5ca; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $5mHsu = parcelRequire("5mHsu");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $48d3bb3cd226aaf7$export$67fc22a75e0cc5ca = ({ children: children })=>{
    (0, $aavUY.useRegisterComponent)($48d3bb3cd226aaf7$export$67fc22a75e0cc5ca.name);
    const location = (0, $5WDNl.useLocation)();
    const resetPasswordLink = (0, $8ZuGG.useMemo)(()=>'/login/resetpassword' + location.search, [
        location.search
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
        href: resetPasswordLink,
        id: "resetPassword",
        children: children
    });
};

});

parcelRegister("iLUF6", function(module, exports) {

$parcel$export(module.exports, "LinkToSignupPage", function () { return $99f336ad2c221c69$export$d592e43397b27498; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gyRZh = parcelRequire("gyRZh");
const $99f336ad2c221c69$export$d592e43397b27498 = ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
        to: '/signup' + location.search,
        id: "signup",
        className: "primary-action",
        onClick: onClick,
        children: children
    });
};

});


parcelRegister("hm82Q", function(module, exports) {

$parcel$export(module.exports, "useLoginRecoveryOptions", function () { return $ced6d1852f98fd89$export$7355ce4dcfe6714; });
$parcel$export(module.exports, "useCobrandingApplication", function () { return $ced6d1852f98fd89$export$1d0a4295a0540e3; });
$parcel$export(module.exports, "useSearchParamCodes", function () { return $ced6d1852f98fd89$export$e66bdd3af3ee2b13; });
$parcel$export(module.exports, "useEmailFromSearchParams", function () { return $ced6d1852f98fd89$export$79b4d72483651c8e; });
$parcel$export(module.exports, "useAppendReasonViewingScreen", function () { return $ced6d1852f98fd89$export$833646c3f87e042d; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $5WDNl = parcelRequire("5WDNl");

var $gyRZh = parcelRequire("gyRZh");

var $kZj5j = parcelRequire("kZj5j");

var $hTZm6 = parcelRequire("hTZm6");

var $9Codz = parcelRequire("9Codz");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $ced6d1852f98fd89$export$7355ce4dcfe6714 = ()=>{
    const { state: state } = (0, $9Codz.useLoginState)();
    const { login: login } = state || {};
    const loginRecoveryOptions = (0, $8ZuGG.useCallback)((email)=>{
        return (login === null || login === void 0 ? void 0 : login.recoveryToken) && email ? {
            expectedEmail: email,
            recoveryToken: login.recoveryToken
        } : undefined;
    }, [
        login === null || login === void 0 ? void 0 : login.recoveryToken
    ]);
    return loginRecoveryOptions;
};
const $ced6d1852f98fd89$export$1d0a4295a0540e3 = ()=>{
    const { state: state } = (0, $9Codz.useLoginState)();
    const { cobranding: cobranding } = state || {};
    const applicationData = (0, $8ZuGG.useMemo)(()=>{
        if (cobranding === undefined) return null;
        return (0, $kZj5j.lookupApplication)(cobranding);
    }, [
        cobranding
    ]);
    return applicationData === null || applicationData === void 0 ? void 0 : applicationData.application;
};
const $ced6d1852f98fd89$export$e66bdd3af3ee2b13 = ()=>{
    const location = (0, $5WDNl.useLocation)();
    const queryParams = Object.fromEntries(new URLSearchParams(location.search).entries());
    const infoCode = (0, $8ZuGG.useMemo)(()=>queryParams.infoCode ? {
            code: queryParams.infoCode
        } : null, [
        queryParams.infoCode
    ]);
    const errorCode = (0, $8ZuGG.useMemo)(()=>queryParams.errorCode ? {
            code: queryParams.errorCode
        } : null, [
        queryParams.errorCode
    ]);
    return {
        errorCode: errorCode,
        infoCode: infoCode
    };
};
const $ced6d1852f98fd89$export$79b4d72483651c8e = ()=>{
    (0, $aavUY.useRegisterComponent)($ced6d1852f98fd89$export$79b4d72483651c8e.name);
    const loginHint = (0, $hTZm6.useLoginHint)();
    const [queryParams] = (0, $gyRZh.useSearchParams)();
    return (0, $hTZm6.getEmailFromLoginHint)(loginHint) || queryParams.get('email') || '';
};
const $ced6d1852f98fd89$export$833646c3f87e042d = ()=>{
    const { search: search } = (0, $5WDNl.useLocation)();
    const infoCode = (0, $8ZuGG.useMemo)(()=>{
        const queryParams = new URLSearchParams(search);
        return queryParams.has('infoCode') ? {
            code: queryParams.get('infoCode')
        } : null;
    }, [
        search
    ]);
    const appendReasonViewingScreen = (0, $8ZuGG.useCallback)((eventAttributes)=>{
        if (infoCode) switch(infoCode.code){
            case 'migratingExistingUser':
                return (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                    reasonViewingScreen: 'migratingUser'
                });
            case 'existingUserSignupAttempt':
                return (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                    reasonViewingScreen: 'existingUserSignupAttempt'
                });
            case 'invitedUser':
                return (0, $6EnDC._)((0, $ty6PY._)({}, eventAttributes), {
                    reasonViewingScreen: 'invitedUser'
                });
            default:
                return eventAttributes;
        }
        return eventAttributes;
    }, [
        infoCode
    ]);
    return appendReasonViewingScreen;
};

});

parcelRegister("4nIlz", function(module, exports) {

$parcel$export(module.exports, "useLogin", function () { return $d5ff80907334de2d$export$d4e22f05f73ea56b; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $5WDNl = parcelRequire("5WDNl");

var $fouZP = parcelRequire("fouZP");

var $2Qf9b = parcelRequire("2Qf9b");

var $61XRM = parcelRequire("61XRM");

var $kOqgB = parcelRequire("kOqgB");

var $8dHAc = parcelRequire("8dHAc");

var $3ir1n = parcelRequire("3ir1n");

var $9Codz = parcelRequire("9Codz");

var $day6I = parcelRequire("day6I");

var $5Nhr0 = parcelRequire("5Nhr0");

var $hm82Q = parcelRequire("hm82Q");

var $7k83O = parcelRequire("7k83O");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $iSD9t = parcelRequire("iSD9t");

var $8IdNM = parcelRequire("8IdNM");

var $lu7Jt = parcelRequire("lu7Jt");

var $l75yM = parcelRequire("l75yM");

var $9NVnN = parcelRequire("9NVnN");
const $d5ff80907334de2d$export$d4e22f05f73ea56b = ({ autoRedirect: autoRedirect = true, autoCheckUsername: autoCheckUsername = true, useV2CheckUsernameFlow: useV2CheckUsernameFlow = false } = {
    autoRedirect: true,
    autoCheckUsername: true,
    useV2CheckUsernameFlow: false
})=>{
    (0, $aavUY.useRegisterComponent)($d5ff80907334de2d$export$d4e22f05f73ea56b.name);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const location = (0, $5WDNl.useLocation)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const queryParams = (0, $8ZuGG.useMemo)(()=>Object.fromEntries(new URLSearchParams(location.search).entries()), [
        location.search
    ]);
    const { rememberMeEnabled: rememberMeEnabled, rememberedAccounts: rememberedAccounts, isRememberMeChecked: isRememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox } = (0, $l75yM.useRememberMe)();
    const isV1UsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isV2UsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const isV2CheckingUsername = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2CheckingUsername;
    });
    const isLoggingIn = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const passwordless = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.passwordless;
    });
    const usernameExists = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const nextAttemptCount = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.nextAttempt;
    });
    const redirectUrl = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectUrl;
    });
    const redirectType = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.redirectType;
    });
    const isMobileApp = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.isMobileApp);
    const isAnyMobile = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.isAnyMobile);
    const restrictedEmail = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.restrictedEmail;
    });
    const error = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.error;
    });
    const checkUsernameError = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login_fieldErrors, _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : (_state_login_fieldErrors = _state_login.fieldErrors) === null || _state_login_fieldErrors === void 0 ? void 0 : _state_login_fieldErrors.email;
    });
    const v2Accounts = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.v2Accounts;
    });
    const isRestrictedEmail = restrictedEmail || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.restrict) === 'true';
    const isLoading = isCheckingUsername || isLoggingIn;
    const { state: state } = (0, $9Codz.useLoginState)();
    const { oidcContext: oidcContext, login: login } = state || {};
    const { error: errorFromInjectedState } = login || {};
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const loginRecoveryOptions = (0, $hm82Q.useLoginRecoveryOptions)();
    const application = (0, $hm82Q.useCobrandingApplication)();
    const loginPrompt = queryParams === null || queryParams === void 0 ? void 0 : queryParams.prompt;
    const isUsernameChecked = useV2CheckUsernameFlow ? isV2UsernameChecked : isV1UsernameChecked;
    // redirect
    (0, $8ZuGG.useEffect)(()=>{
        if (!autoRedirect || useV2CheckUsernameFlow) return;
        const shouldRedirect = !isMobileApp || (0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).LoginWithRedirect);
        if (redirectUrl) navigate(redirectUrl);
        else if (!isLoading && isUsernameChecked && !usernameExists && shouldRedirect) {
            dispatch((0, $fouZP.resetLoginForm)());
            analyticsClient.operationalEvent({
                page: (0, $5Nhr0.loginPageId),
                subject: 'loginAttempt',
                action: 'redirectedToSignup'
            });
            if (location.search.length === 0) navigate('/signup?redirectedFrom=login');
            else navigate(`/signup${location.search}&redirectedFrom=login`);
        }
    }, [
        autoRedirect,
        useV2CheckUsernameFlow,
        analyticsClient,
        application,
        dispatch,
        navigate,
        isAnyMobile,
        isLoading,
        isMobileApp,
        isUsernameChecked,
        oidcContext,
        redirectUrl,
        usernameExists,
        location.search
    ]);
    // redirect to signup if no accounts are found when using the new V2 check username flow
    (0, $8ZuGG.useEffect)(()=>{
        if (useV2CheckUsernameFlow && isV2UsernameChecked && (!v2Accounts || v2Accounts.length === 0)) navigate('/signup');
    }, [
        isV2UsernameChecked,
        useV2CheckUsernameFlow,
        v2Accounts,
        navigate
    ]);
    const [isCheckUsernameCaptchaLoading, setIsCheckUsernameCaptchaLoading] = (0, $8ZuGG.useState)(false);
    const { errorCode: errorCode, infoCode: infoCode } = (0, $hm82Q.useSearchParamCodes)();
    // This 'combines' multiple error sources into one for easier consumption downstream.
    // 1. redux store (from server, either injected or fetched via separate api call to /frontend/state)
    // 2. fetched via api endpoint call to /login/state (which never gets written to the redux store)
    // 3. Any error code set externally via URL search param.
    //
    // Cases 1 and 2 are needed to reliably cover errors returned by server in both SAS and non-SAS contexts.
    const combinedError = (0, $8ZuGG.useMemo)(()=>error || errorFromInjectedState || errorCode, [
        error,
        errorFromInjectedState,
        errorCode
    ]);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const signupLink = (0, $lu7Jt.useSignupLink)();
    const combinedErrorWithMessage = (0, $8ZuGG.useMemo)(()=>{
        if (!combinedError) return;
        const message = (0, $8IdNM.buildLoginErrorMessage)({
            error: combinedError,
            formatMessage: formatMessage,
            signupLink: signupLink,
            nextAttempt: nextAttemptCount,
            application: application
        });
        return (0, $6EnDC._)((0, $ty6PY._)({}, combinedError), {
            message: message
        });
    }, [
        combinedError,
        formatMessage,
        signupLink,
        nextAttemptCount,
        application
    ]);
    const { isLoaded: recaptchaIsLoaded, recaptchaType: recaptchaType, fetchToken: fetchToken } = (0, $61XRM.useRecaptchaContext)();
    const dispatchCaptchaFailure = (0, $8ZuGG.useCallback)(()=>{
        dispatch((0, $fouZP.checkUsernameCaptchaFailure)(navigator.onLine));
    }, [
        dispatch
    ]);
    const fetchRecaptchaToken = (0, $8ZuGG.useCallback)(async ()=>{
        try {
            setIsCheckUsernameCaptchaLoading(true);
            (0, $2Qf9b.recaptchaCheckUsernameFetchTokenInteraction).start();
            const challengeResponse = await fetchToken();
            (0, $2Qf9b.recaptchaCheckUsernameFetchTokenInteraction).stop({
                customData: {
                    restrict: isRestrictedEmail
                }
            });
            return challengeResponse;
        } catch (error) {
            analyticsClient.errorShownEvent((0, $5Nhr0.loginPageId), 'recaptchaError', {
                errorMessage: error.message
            });
            dispatchCaptchaFailure();
            return null;
        } finally{
            setIsCheckUsernameCaptchaLoading(false);
        }
    }, [
        analyticsClient,
        dispatchCaptchaFailure,
        isRestrictedEmail,
        fetchToken
    ]);
    const onValidationError = (0, $8ZuGG.useCallback)((errors)=>dispatch((0, $fouZP.showFormErrors)(errors)), [
        dispatch
    ]);
    /**
   * @param username username to check the redirect that's required (e.g. SSO). Usually an email address.
   * @param rememberOverride used to override the current states value for the remember me checkbox. Used when selecting an SSO user from the remembered accounts page.
   */ const checkUsernameV1 = (0, $8ZuGG.useCallback)(async (username, rememberOverride)=>{
        var _loginRecoveryOptions;
        let challengeResponse = null;
        const remember = rememberOverride !== null && rememberOverride !== void 0 ? rememberOverride : isRememberMeChecked;
        const query = (0, $6EnDC._)((0, $ty6PY._)({}, queryParams), {
            email: username
        });
        if (remember) dispatch((0, $fouZP.setRememberMeCheckbox)(true));
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        // Using the state to "hack" loading state for selecting a remembered account.
        dispatch((0, $fouZP.requestCheckUsername)());
        if (recaptchaIsLoaded) challengeResponse = await fetchRecaptchaToken();
        analyticsClient.formSubmittedEvent((0, $5Nhr0.loginPageId), 'checkUsername', {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type,
            rememberMeChecked: !!remember
        });
        const checkUsernameParams = new URLSearchParams(location.search);
        // if remember me is enabled, then we also include `remember`
        if (remember) checkUsernameParams.append('remember', 'true');
        dispatch((0, $fouZP.checkUsername)({
            analyticsClient: analyticsClient,
            username: username,
            params: `?${checkUsernameParams.toString()}`,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions(username)) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $7k83O.fetchConsentConfig)(username));
    }, [
        isRememberMeChecked,
        queryParams,
        navigate,
        location.hash,
        location.search,
        dispatch,
        recaptchaIsLoaded,
        analyticsClient,
        loginRecoveryOptions,
        fetchRecaptchaToken
    ]);
    // V2 version that sets the correct loading state
    const checkUsernameV2 = (0, $8ZuGG.useCallback)(async (username, rememberOverride)=>{
        var _loginRecoveryOptions;
        let challengeResponse = null;
        const remember = rememberOverride !== null && rememberOverride !== void 0 ? rememberOverride : isRememberMeChecked;
        const query = (0, $6EnDC._)((0, $ty6PY._)({}, queryParams), {
            email: username
        });
        if (remember) dispatch((0, $fouZP.setRememberMeCheckbox)(true));
        delete query.errorCode;
        const searchParams = new URLSearchParams(query);
        navigate(`/login?${searchParams.toString()}${location.hash}`);
        // Set V2 loading state
        dispatch((0, $fouZP.requestCheckUsernameV2)());
        if (recaptchaIsLoaded) challengeResponse = await fetchRecaptchaToken();
        analyticsClient.formSubmittedEvent((0, $5Nhr0.loginPageId), 'checkUsernameV2', {
            recaptchaType: challengeResponse === null || challengeResponse === void 0 ? void 0 : challengeResponse.type,
            rememberMeChecked: !!remember
        });
        const checkUsernameParams = new URLSearchParams(location.search);
        if (remember) checkUsernameParams.append('remember', 'true');
        dispatch((0, $fouZP.checkUsernameV2)({
            analyticsClient: analyticsClient,
            username: username,
            params: `?${checkUsernameParams.toString()}`,
            recoveryToken: (_loginRecoveryOptions = loginRecoveryOptions(username)) === null || _loginRecoveryOptions === void 0 ? void 0 : _loginRecoveryOptions.recoveryToken,
            challengeResponse: challengeResponse
        }));
        dispatch((0, $7k83O.fetchConsentConfig)(username));
    }, [
        isRememberMeChecked,
        queryParams,
        navigate,
        location.hash,
        location.search,
        dispatch,
        recaptchaIsLoaded,
        analyticsClient,
        loginRecoveryOptions,
        fetchRecaptchaToken
    ]);
    const emailFromSearchParams = (0, $hm82Q.useEmailFromSearchParams)();
    // This code is intended to auto-submit the check-username request if email is restricted
    (0, $8ZuGG.useEffect)(()=>{
        const handleMount = async ()=>{
            if (!recaptchaIsLoaded) return;
            if (!autoCheckUsername) return;
            if (!isRestrictedEmail) return;
            const emailWithDefault = emailFromSearchParams || '';
            if (!emailWithDefault) return;
            // recaptchaType 'checkbox' should not be auto-submitted
            if (recaptchaType === 'score') await checkUsernameV1(emailWithDefault);
        };
        handleMount();
    // We only want this to run when the component mounts or
    // when recaptcha.isLoaded becomes true (if it was false)
    // We need to investigate why `useRecaptcha` always returns a new object,
    // So we can remove this eslint-disable rule and add all the correct dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        recaptchaIsLoaded
    ]);
    const checkUsername = useV2CheckUsernameFlow ? checkUsernameV2 : checkUsernameV1;
    const resetLogin = (0, $8ZuGG.useCallback)(()=>dispatch((0, $fouZP.resetLoginForm)()), [
        dispatch
    ]);
    const isPasswordlessAllowed = passwordless !== (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed && !(0, $day6I.isMobileOidc)(oidcContext);
    const isV1CheckUsernameLoading = isCheckingUsername || isCheckUsernameCaptchaLoading;
    const isV2CheckUsernameLoading = isV2CheckingUsername || isCheckUsernameCaptchaLoading;
    const isCheckUsernameLoading = useV2CheckUsernameFlow ? isV2CheckUsernameLoading : isV1CheckUsernameLoading;
    // This prevents redirecting to the list of remembered accounts in certain situations.
    // TODO: KIRBY-8427: consider moving this check into a separate hook to avoid calling
    //                   `useLogin` for the check in the login OrchestratedPage.
    const shouldShowRememberedAccounts = rememberMeEnabled && emailFromSearchParams === '' && !isCheckUsernameLoading && loginPrompt !== 'true' && loginPrompt !== 'login' && rememberedAccounts && rememberedAccounts.length > 0;
    return {
        isPasswordlessAllowed: /**
     * Indicates whether the user is eligible to log in via a link emailed to them.
     * */ isPasswordlessAllowed,
        isUsernameChecked: /**
     * Reflects the state of the first essential step of the login process.
     *
     * Will be false until `checkUsername` has been called. True thereafter (until reset via
     * a call to `resetLogin`).
     *
     * */ isUsernameChecked,
        isCheckUsernameLoading: /**
     * Reflects loading state following a call to `checkUsername`.
     * */ isCheckUsernameLoading,
        checkUsernameError: /**
     * Indicates the reason `checkUsername` has failed. See type definition for details.
     * */ checkUsernameError,
        isRestrictedEmail: /**
     * Indicates whether the user's username/email has been deemed restricted. In such cases,
     * `checkUsername` will be called automatically for this username, unless opted out by setting
     * the `autoCheckUsername` option to `false` in the args to `useLogin`.
     *
     * For example, the username may be restricted by admins in the user's org.
     * */ isRestrictedEmail,
        checkUsername: /**
     * This is the essential first step of the login process.
     *
     * @warning NOTE: Until this handler has been called, username and password submission will not work.
     *
     * This function handles the commercial `checkUsername` and the isolated cloud `checkUsernameV2`
     * API call to sign-in-service, which we use to handle either the redirect for a user given their
     * configuration in commercial (e.g. password user, SSO user, social user, etc) or to show all available accounts for a user given their
     * IC (isolated cloud) configurations.
     *
     * This must be called by any cobranding that implements the login page.
     * */ checkUsername,
        loginPrompt: /**
     * Login "prompt" query parameter. If set, shows the email input to the user.
     * In case of `select_account` value, the user is redirected to the account switcher.
     * */ loginPrompt,
        /**
     * Indicates that login has failed for a particular reason. See type definition for details.
     * */ error: combinedErrorWithMessage,
        infoCode: /**
     * An externally set code indicating a message for the user may need to be rendered. See type
     * definition for details.
     * */ infoCode,
        nextAttemptCount: /**
     * The number of times the user will have attempted to login (at their next attempt). After a
     * certain number of attempts, it may be desirable to render a message directing the user to try
     * to reset their password.
     *
     * (The base login experience does this when the count is greater than 4).
     * */ nextAttemptCount,
        redirectUrl: /**
     * The URL to which the user ought to be redirected, as indicated by the server. This
     * redirection will be automatic unless opted out in the args to `useLogin`.
     * */ redirectUrl,
        redirectType: /**
     * Indicates the reason given by the server for redirecting the user. Useful for rendering
     * relevant UI while the redirect is taking place (e.g. SSO).
     * */ redirectType,
        resetLogin: /**
     * Resets the state of the login process back to the first step (where `checkUsername` must be
     * called again).
     *
     * Should be called when user has chosen to enter a different username than the one they had
     * already entered.
     * */ resetLogin,
        rememberMeEnabled: /**
     * Whether or not the `remember me` feature is enabled.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberMeEnabled,
        rememberedAccounts: /**
     * The list of accounts that have been remembered by the user.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     * */ rememberedAccounts,
        shouldShowRememberedAccounts: /**
     * Whether or not to show the remembered accounts list.
     */ shouldShowRememberedAccounts,
        isRememberMeChecked: /**
     * Whether or not the remember me checkbox is checked. Used to pre-check the checkbox when selecting a remembered account.
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ isRememberMeChecked,
        onToggleRememberMeCheckbox: /**
     * Toggles the remember me checkbox.'
     *
     * Re-exported from `useRememberMe` hook for convenience.
     */ onToggleRememberMeCheckbox,
        onValidationError: /**
     * Used to provide any additional errors (i.e. ones that aren't provided directly by this hook) that should be rendered on the login page.
     *
     * @param errors any errors that should be shown in the login form.
     */ onValidationError,
        v2Accounts: /**
     * The list of available accounts returned from the V2 check username API call. Only available when `useV2CheckUsernameFlow` is true.
     * Used to display the list of available accounts to the user across all available Atlassian Cloud and Isolated Cloud environments.
     */ v2Accounts
    };
};

});
parcelRegister("2Qf9b", function(module, exports) {

$parcel$export(module.exports, "recaptchaCheckUsernameFetchTokenInteraction", function () { return $55300b6d24d28392$export$b7874a5a14992cfe; });

var $hZ7M7 = parcelRequire("hZ7M7");
const $55300b6d24d28392$export$b7874a5a14992cfe = (0, $hZ7M7.metrics).interaction({
    key: 'aid-frontend-recaptcha-fetch-token-check-username'
});

});

parcelRegister("7k83O", function(module, exports) {

$parcel$export(module.exports, "fetchConsentConfig", function () { return $e3f91dae9479f09c$export$58e2aa80c90a0ce1; });

var $8f2pb = parcelRequire("8f2pb");
const $e3f91dae9479f09c$export$cff006d34f7616ad = (config)=>({
        type: 'UPDATE_MARKETING_CONSENT_CONFIG',
        config: config
    });
const $e3f91dae9479f09c$export$58e2aa80c90a0ce1 = (email)=>(dispatch)=>{
        return fetch('/rest/marketing-consent/config', {
            method: 'POST',
            credentials: 'omit',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email
            })
        }).then((response)=>{
            if (response.status === 200) return response.json().then((cfg)=>dispatch($e3f91dae9479f09c$export$cff006d34f7616ad(cfg)));
            else if (response.status === 204) {
                // No response from ConsentHub for some reason
                const level = 'warning';
                (0, $8f2pb.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'no_content'
                }, level);
            } else if (response.status === 400) {
                // Signup was unable to extract IP
                const level = 'warning';
                (0, $8f2pb.captureMessage)('Unable to retrieve marketing consent config', {
                    status: response.status,
                    reason: 'cannot_extract_ip'
                }, level);
            } else return response.text().then((error)=>{
                throw new Error(error || response.statusText);
            });
        }).catch((0, $8f2pb.captureException));
    };

});

parcelRegister("8IdNM", function(module, exports) {

$parcel$export(module.exports, "buildLoginErrorMessage", function () { return $d610112e8d4eb73f$export$7a0831816210b6bb; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $5mHsu = parcelRequire("5mHsu");

var $pO9YU = parcelRequire("pO9YU");

var $lk8Tl = parcelRequire("lk8Tl");

var $52ngs = parcelRequire("52ngs");
const $d610112e8d4eb73f$export$7a0831816210b6bb = ({ error: error, formatMessage: formatMessage, signupLink: signupLink, nextAttempt: nextAttempt, application: application })=>{
    if (!error) return;
    const { args: args = {} } = error;
    switch(error === null || error === void 0 ? void 0 : error.code){
        case 'captcha':
            return formatMessage({
                id: 'login.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'login.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'invalid_user_password':
            return $d610112e8d4eb73f$var$incorrectCredentialsErrorMessage(formatMessage, nextAttempt, signupLink, application);
        case 'ambiguous_user':
            return formatMessage({
                id: 'login.error.details.ambiguous',
                defaultMessage: 'It seems that you have multiple accounts associated with your email. Please contact your administrator to remove the duplicate.'
            });
        case 'no_email_on_remote_user':
            return formatMessage({
                id: 'login.error.remote.user.no.email',
                defaultMessage: "Your {username} user doesn't have an associated email address, so we can't create your Atlassian account. Please contact support."
            }, (0, $ty6PY._)({}, args));
        case 'bitbucket_username_is_not_email':
            return formatMessage({
                id: 'login.error.remote.user.using.username',
                defaultMessage: 'You can no longer log in with a username. Use your primary email address {username} instead.'
            }, (0, $ty6PY._)({}, args));
        case 'username_is_not_email':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, (0, $ty6PY._)({}, args));
        case 'bitbucket_email_is_not_primary':
            return formatMessage({
                id: 'login.error.remote.user.using.alias',
                defaultMessage: 'You can no longer log in with an email alias. Use your primary email address {username} instead.'
            }, (0, $ty6PY._)({}, args));
        case 'bitbucket_mfa_enforced':
            return formatMessage({
                id: 'login.error.user.mfa.enforced',
                defaultMessage: 'Your organization wants you to secure your account by setting up two-step verification.'
            }, (0, $ty6PY._)({}, args));
        case 'bitbucket_mfa_required':
            return formatMessage({
                id: 'login.error.user.mfa.required',
                defaultMessage: 'For added security, your organization wants you to log in with two-step verification.'
            }, (0, $ty6PY._)({}, args));
        case 'bitbucket_saml_user':
            return formatMessage({
                id: 'login.error.saml.user',
                defaultMessage: 'For added security, your organization wants you to log in with single sign-on.'
            }, (0, $ty6PY._)({}, args));
        case 'email_is_not_primary':
            return formatMessage({
                id: 'login.error.email.not.username',
                defaultMessage: 'You must use your email address to log in. Did you mean to use {username}?'
            }, (0, $ty6PY._)({}, args));
        case 'too_many_logins':
        case 'too_many_requests':
            return formatMessage({
                id: 'login.error.too.many.logins',
                defaultMessage: "For security purposes, we've temporarily locked your account due to multiple log in attempts within a short period of time. Please try again in a few minutes. If this issue persists, please contact Atlassian Support."
            });
        case 'multiple_google_accounts':
            return formatMessage({
                id: 'login.error.google.auth.contact.support',
                defaultMessage: "We've encountered problems signing you in with your Google Account. Please contact support to resolve this problem."
            });
        case 'unable_to_verify_google_token':
            return formatMessage({
                id: 'login.error.unable.to.verify.google.token',
                defaultMessage: 'We were unable to verify your Google Account. Please try again later.'
            });
        case 'google_email_change_not_allowed_by_auth_policy':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.auth.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with an email address that matches your account."
            });
        case 'google_email_change_not_allowed_by_user_managed_status':
            return formatMessage({
                id: 'login.error.google.email.change.not.allowed.by.user.managed.status',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_missing_email':
            return formatMessage({
                id: 'login.error.social.missing.email',
                defaultMessage: 'We did not receive a valid email address from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_email_verified':
            return formatMessage({
                id: 'login.error.social.missing.email.verified',
                defaultMessage: 'We did not receive a valid email verification from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_unexpected_login_type':
            return formatMessage({
                id: 'login.error.social.unexpected.login.type',
                defaultMessage: 'We did not receive valid information from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_missing_slack_email_date_verified':
            return formatMessage({
                id: 'login.error.slack.missing.email.date.verified',
                defaultMessage: 'We did not receive a valid email date verified from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_invalid_social_id':
            return formatMessage({
                id: 'login.error.social.invalid.social.id',
                defaultMessage: 'We did not receive valid id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'slack_login_invalid_team_id':
            return formatMessage({
                id: 'login.error.slack.invalid.team.id',
                defaultMessage: 'We did not receive valid team id from your identity provider. Please try logging in again by typing your email address. If you don\'t have a password, use the "Can\'t log in" link to set one.'
            });
        case 'social_login_managed_user':
            return formatMessage({
                id: 'login.error.social.managed.user',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'social_login_requires_password_change':
            return formatMessage({
                id: 'login.error.social.requires.password.change',
                defaultMessage: 'Your current password has expired, so you need to reset your password to continue.'
            });
        case 'social_login_hide_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.hide.email.change.not.allowed.to.bypass.policy',
                defaultMessage: 'Sorry, you cannot hide your email once you are part of an organization. Please ensure that you share your real email.'
            });
        case 'social_login_email_change_not_allowed_to_bypass_policy':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed.to.bypass.policy',
                defaultMessage: "Sorry, we detected an email change that is not supported by your organization's authentication policy. Please log in with a email address that matches your account."
            });
        case 'social_login_email_change_not_allowed':
            return formatMessage({
                id: 'login.error.social.email.change.not.allowed',
                defaultMessage: 'We detected an email change that would remove you from your organization. Contact your organization admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'social_login_consent_required':
            return formatMessage({
                id: 'login.error.social.login.consent.required',
                defaultMessage: 'Please grant access to your account details if you wish to login to your Atlassian account.'
            });
        case 'user_is_blocked':
            return formatMessage({
                id: 'login.error.user.blocked',
                defaultMessage: 'This account has been deactivated. Please contact your organization admin.'
            });
        case 'social_login_banned':
            return formatMessage({
                id: 'login.error.social.login.banned',
                defaultMessage: 'Your admin has blocked third-party login. Log in with your email address instead.'
            });
        case 'apple_login_disabled':
            return formatMessage({
                id: 'login.error.apple.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Apple at this time. We are working on it.'
            });
        case 'microsoft_login_disabled':
            return formatMessage({
                id: 'login.error.microsoft.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Microsoft at this time. We are working on it.'
            });
        case 'slack_login_disabled':
            return formatMessage({
                id: 'login.error.slack.login.disabled',
                defaultMessage: 'Sorry, it is not possible to log in with Slack at this time. We are working on it.'
            });
        case 'password_leaked':
            return formatMessage({
                id: 'login.error.password.leaked.xml',
                defaultMessage: 'You must <reset-password-link>change your password</reset-password-link> to log in. Your current password has appeared in an external data breach and your Atlassian account is at risk. <password-leaked-link>Learn more</password-leaked-link>'
            }, {
                'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                        children: chunks
                    }),
                'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                        href: (0, $pO9YU.PASSWORD_LEAKED_LINK),
                        children: chunks
                    })
            });
        case 'login.form.token.expired':
            return formatMessage({
                id: 'login.error.token.expired',
                defaultMessage: 'Your login request has expired.'
            });
        case 'login.form.problem.encountered':
            return formatMessage({
                id: 'login.error.problem.encountered',
                defaultMessage: "We've encountered a problem. Please try again in a few minutes."
            });
        case 'login.form.email.does.not.match.loggedin.user':
            return formatMessage({
                id: 'login.form.email.does.not.match.loggedin.user',
                defaultMessage: "You're currently logged in as {username}, logging in as another user will log you out of your current session."
            }, (0, $ty6PY._)({}, args));
        case 'hosted_domain_mismatch':
            return formatMessage({
                id: 'google.hosted.domain.mismatch',
                defaultMessage: 'Unable to log in with Google. Contact your admin to check your account is configured correctly or try to log in a different way.'
            });
        case 'switch.session.expired':
            return formatMessage({
                id: 'session.switch.error.expired',
                defaultMessage: 'Your account session expired. Log in again to continue.'
            });
        case 'request_error':
            return formatMessage({
                id: 'network.request.error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'invalid.session.token':
            return formatMessage({
                id: 'invalid.session.token',
                defaultMessage: 'Your session token is invalid. Log in again to continue.'
            });
        case 'verify.email.expired':
            return formatMessage({
                id: 'verify.email.expired',
                defaultMessage: 'Your email verification attempt has expired. Enter your email address and try again.'
            });
        case 'verify.email.error':
            return formatMessage({
                id: 'verify.email.error',
                defaultMessage: 'Something went wrong while verifying your email address. Enter your email address and try again.'
            });
        case 'too_many_username_requests':
            return formatMessage({
                id: 'check.username.rate.limit.exceeded',
                defaultMessage: 'Too many login attempts detected. Please wait for a few minutes before trying again.'
            });
        case 'generic-consent-error':
            return formatMessage({
                id: 'generic-consent-error',
                defaultMessage: 'To access this page, you must accept the Privacy Notice.'
            });
        case 'consent-validation-error':
            return formatMessage({
                id: 'consent-validation-error',
                defaultMessage: 'Something went wrong while attempting to validate your consent. Try logging in again later.'
            });
        case 'consent-loading-error':
            return formatMessage({
                id: 'consent-loading-error',
                defaultMessage: 'Something went wrong while loading the consent screen. Try logging in again later.'
            });
        case 'remember-me-cookie-error':
            return formatMessage({
                id: 'remember-me-cookie-error',
                defaultMessage: 'Something went wrong while loading your remembered accounts. Log in again to continue.'
            });
        case 'invalid_passkey':
            return formatMessage({
                id: 'invalid-passkey-error',
                defaultMessage: 'The provided passkey is invalid. Please try again with a different authentication method.'
            });
        case 'passkey_managed_account':
            return formatMessage({
                id: 'managed-account-passkey-error',
                defaultMessage: "Hmm... we're having trouble logging you in. Please try again with a different authentication method."
            });
        case 'webauthn_not_supported':
            return formatMessage({
                id: 'webauthn-not-supported-error',
                defaultMessage: "We\u2019re unable to verify your passkey. Make sure your browser supports WebAuthn."
            });
        case 'webauthn_challenge_failed':
            return formatMessage({
                id: 'webauthn-challenge-failed-error',
                defaultMessage: "Your passkey couldn\u2019t complete the authentication. Try again. If this keeps happening, contact support."
            });
        default:
            return formatMessage({
                id: 'login.error.unknown',
                defaultMessage: 'Something went wrong while attempting to validate your credentials.'
            });
    }
};
const $d610112e8d4eb73f$var$incorrectCredentialsErrorMessage = (formatMessage, nextAttempt, signupLink, application)=>{
    if (nextAttempt > 4) return formatMessage({
        id: 'login.error.invalid.credentials.more.help.xml',
        defaultMessage: "We've recently made changes to the login page. If you are having difficulty logging in, <reset-password-link>reset your password</reset-password-link>."
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                children: chunks
            })
    });
    else if (application === 'trello') return formatMessage({
        id: 'login.error.invalid.credentials.trello.specific.help.xml',
        defaultMessage: 'Incorrect email address and / or password. If you recently migrated your Trello account to an Atlassian account, you will need to use your Atlassian account password. Alternatively, you can get help <reset-password-link>logging in</reset-password-link>.'
    }, {
        'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                children: chunks
            })
    });
    else {
        // Fedramp doesn't have a sign up flow, so we don't want to show the sign up link.
        if ((0, $lk8Tl.isFedM)()) return formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                    children: chunks
                })
        });
        const invalidCredentials = formatMessage({
            id: 'login.error.invalid.credentials.xml',
            defaultMessage: 'Incorrect email address and/or password. Try again or <reset-password-link>reset your password</reset-password-link>.'
        }, {
            'reset-password-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $52ngs.ResetPasswordLink), {
                    children: chunks
                })
        });
        const signupSuffix = formatMessage({
            id: 'login.error.invalid.credentials.xml.sign_up',
            defaultMessage: '<sign-up-link>Sign up</sign-up-link> for an Atlassian account.'
        }, {
            'sign-up-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
                    href: signupLink,
                    children: chunks
                })
        });
        return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                invalidCredentials,
                /*#__PURE__*/ (0, $6rcps.jsx)("br", {}),
                signupSuffix
            ]
        });
    }
};

});

parcelRegister("lu7Jt", function(module, exports) {

$parcel$export(module.exports, "useSignupLink", function () { return $f63bf8b5e24e4c95$export$2608a74d725f1f9f; });
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");
const $f63bf8b5e24e4c95$export$2608a74d725f1f9f = ()=>{
    const location = (0, $5WDNl.useLocation)();
    // Note: location.search includes the leading `?` character.
    return `/signup${location.search}`;
};

});

parcelRegister("l75yM", function(module, exports) {

$parcel$export(module.exports, "useRememberMe", function () { return $dce727cfa1d296dd$export$a988c57eb90dc982; });

var $8ZuGG = parcelRequire("8ZuGG");

var $5WDNl = parcelRequire("5WDNl");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $gyRZh = parcelRequire("gyRZh");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $6i2Pq = parcelRequire("6i2Pq");

var $fouZP = parcelRequire("fouZP");

var $9NVnN = parcelRequire("9NVnN");
const $dce727cfa1d296dd$export$a988c57eb90dc982 = ()=>{
    (0, $aavUY.useRegisterComponent)($dce727cfa1d296dd$export$a988c57eb90dc982.name);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const location = (0, $5WDNl.useLocation)();
    const [searchParams] = (0, $gyRZh.useSearchParams)();
    const [isDeleteModeEnabled, setIsDeleteModeEnabled] = (0, $8ZuGG.useState)(false);
    const rememberMeEnabled = (0, $kOqgB.useAppSelector)((state)=>state.login.rememberMeEnabled);
    const rememberedAccounts = (0, $kOqgB.useAppSelector)((state)=>state.login.rememberedAccounts);
    const isRememberMeChecked = (0, $kOqgB.useAppSelector)((state)=>state.login.isRememberMeChecked);
    const rememberedAccountsResponseCodes = (0, $kOqgB.useAppSelector)((state)=>state.login.rememberedAccountsResponseCodes);
    const onAddAccountSelected = (0, $8ZuGG.useCallback)(()=>{
        searchParams.set('prompt', 'login');
        dispatch((0, $fouZP.resetRememberMeState)());
        navigate({
            pathname: '/login',
            search: `?${searchParams.toString()}`,
            hash: location.hash
        });
    }, [
        searchParams,
        dispatch,
        navigate,
        location.hash
    ]);
    const onEnableDeleteMode = (0, $8ZuGG.useCallback)(()=>{
        setIsDeleteModeEnabled(true);
    }, []);
    const onDeleteAccount = (0, $8ZuGG.useCallback)((account)=>{
        // The backend supports deleting multiple accounts at once, so we need to provide accountIds not just the one.
        const accountIds = [
            account.accountId
        ];
        dispatch((0, $6i2Pq.requestRemoveRememberedAccount)({
            accountIds: accountIds,
            analyticsClient: analyticsClient
        }));
    }, [
        analyticsClient,
        dispatch
    ]);
    const onDisableDeleteMode = (0, $8ZuGG.useCallback)(()=>{
        dispatch((0, $6i2Pq.resetRememberMeResponseCodes)());
        setIsDeleteModeEnabled(false);
    }, [
        dispatch
    ]);
    const onToggleRememberMeCheckbox = (0, $8ZuGG.useCallback)(()=>{
        dispatch((0, $fouZP.toggleRememberMeCheckbox)());
    }, [
        dispatch
    ]);
    return {
        onAddAccountSelected: onAddAccountSelected,
        onEnableDeleteMode: onEnableDeleteMode,
        rememberMeEnabled: rememberMeEnabled,
        rememberedAccounts: rememberedAccounts,
        onDeleteAccount: onDeleteAccount,
        onDisableDeleteMode: onDisableDeleteMode,
        isDeleteModeEnabled: isDeleteModeEnabled,
        isRememberMeChecked: isRememberMeChecked,
        onToggleRememberMeCheckbox: onToggleRememberMeCheckbox,
        rememberedAccountsResponseCodes: rememberedAccountsResponseCodes
    };
};

});
parcelRegister("6i2Pq", function(module, exports) {

$parcel$export(module.exports, "resetRememberMeResponseCodes", function () { return $0c658f242b022288$export$d13bbaa5ba2d003d; });
$parcel$export(module.exports, "requestRemoveRememberedAccount", function () { return $0c658f242b022288$export$d1be4757a4663fa7; });

var $8f2pb = parcelRequire("8f2pb");

var $b03sO = parcelRequire("b03sO");
const $0c658f242b022288$export$d13bbaa5ba2d003d = ()=>({
        type: 'RESET_REMEMBERED_ACCOUNT_RESPONSE_CODES'
    });
const $0c658f242b022288$export$a939d190fcd5712b = (accountIds)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_INITIATE',
        payload: {
            accountIds: accountIds
        }
    });
const $0c658f242b022288$export$7e60d7595a30bdee = (accountIds, success)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_SUCCESS',
        payload: {
            accountIds: accountIds,
            response: success
        }
    });
const $0c658f242b022288$export$701cdcf57b5adbcd = (error)=>({
        type: 'REMOVE_REMEMBERED_ACCOUNT_REQUEST_FAILED',
        payload: {
            response: error
        }
    });
const $0c658f242b022288$var$ValidResponseValues = [
    'success',
    'cookie_removed'
];
/**
 * Helper function to type guard the response from the remove remembered account API.
 */ function $0c658f242b022288$var$isRemoveRememberedAccountSuccessResponse(response) {
    if ('result' in response) return $0c658f242b022288$var$ValidResponseValues.includes(response.result);
    return false;
}
const $0c658f242b022288$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS = {
    bad_request: 'removeRememberedAccountBadRequest',
    invalid_cookie: 'removeRememberedAccountCookieInvalid',
    rate_limited: 'removeRememberedAccountRateLimited',
    unexpected_error: 'removeRememberedAccountUnexpectedError'
};
const $0c658f242b022288$export$d1be4757a4663fa7 = ({ accountIds: accountIds, analyticsClient: analyticsClient })=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        dispatch($0c658f242b022288$export$a939d190fcd5712b(accountIds));
        if (!accountIds || accountIds.length === 0) {
            dispatch($0c658f242b022288$export$701cdcf57b5adbcd('bad_request'));
            return Promise.resolve();
        }
        const request = {
            accountIds: accountIds
        };
        analyticsClient.trackingEvent({
            page: (0, $b03sO.PAGE_ID),
            action: 'removeRememberedAccountInitiate',
            subject: 'account'
        });
        return fetch(`/rest/remember/remove`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(request)
        }).then((response)=>response.json()).then((response)=>{
            // Successful case
            if ($0c658f242b022288$var$isRemoveRememberedAccountSuccessResponse(response)) {
                analyticsClient.trackingEvent({
                    page: (0, $b03sO.PAGE_ID),
                    action: 'removeRememberedAccountSuccess',
                    subject: 'account'
                });
                // Success, UI will update with the new values assuming state is updated.
                dispatch($0c658f242b022288$export$7e60d7595a30bdee(accountIds, response.result));
                return;
            }
            var _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode;
            const analyticsErrorType = (_REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode = $0c658f242b022288$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS[response === null || response === void 0 ? void 0 : response.errorCode]) !== null && _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode !== void 0 ? _REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS_response_errorCode : 'removeRememberedAccountError';
            analyticsClient.trackingEvent({
                page: (0, $b03sO.PAGE_ID),
                action: analyticsErrorType,
                subject: 'account'
            });
            // Handle errors, depending on the result
            dispatch($0c658f242b022288$export$701cdcf57b5adbcd(response.errorCode));
        }).catch((error)=>{
            dispatch($0c658f242b022288$export$701cdcf57b5adbcd('unexpected_error'));
            analyticsClient.trackingEvent({
                page: (0, $b03sO.PAGE_ID),
                action: $0c658f242b022288$var$REMOVE_REMEMEMBERED_ACCOUNTS_ANALYTICS_ERRORS.unexpected_error,
                subject: 'account'
            });
            (0, $8f2pb.captureErrorMessage)('Remove Remembered Account failure', error);
        });
    };

});
parcelRegister("b03sO", function(module, exports) {

$parcel$export(module.exports, "PAGE_ID", function () { return $69286d05ca887761$export$e8b953ecde3e0a56; });
const $69286d05ca887761$export$e8b953ecde3e0a56 = 'rememberMeAccountSelectScreen';

});




parcelRegister("7zDhH", function(module, exports) {

$parcel$export(module.exports, "useLoginSubmission", function () { return $44974235ce1d291e$export$b40fe35861b4a878; });

var $8ZuGG = parcelRequire("8ZuGG");

var $fvOZR = parcelRequire("fvOZR");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $5Nhr0 = parcelRequire("5Nhr0");

var $ciYFg = parcelRequire("ciYFg");

var $fouZP = parcelRequire("fouZP");

var $xe7jL = parcelRequire("xe7jL");

var $40CJF = parcelRequire("40CJF");

var $hm82Q = parcelRequire("hm82Q");

var $ajWBM = parcelRequire("ajWBM");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $9NVnN = parcelRequire("9NVnN");
const $44974235ce1d291e$export$b40fe35861b4a878 = ({ onFailure: onFailure, onSuccess: onSuccess } = {})=>{
    (0, $aavUY.useRegisterComponent)($44974235ce1d291e$export$b40fe35861b4a878.name);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const anonymousId = (0, $3ir1n.useAnalyticsAnonymousId)();
    const isUsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const isCheckingUsername = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isV2UsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2UsernameChecked;
    });
    const isV2CheckingUsername = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isV2CheckingUsername;
    });
    const isLoggingIn = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const isLoading = isCheckingUsername || isV2CheckingUsername || isLoggingIn;
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const appendReasonViewingScreen = (0, $hm82Q.useAppendReasonViewingScreen)();
    const { captchaValue: captchaValue } = (0, $ciYFg.useLoginTooManyAttemptsRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $ajWBM.useMarketingConsentContext)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    // Wrap redirect to call onSuccess before redirecting
    const redirectWithCallback = (0, $8ZuGG.useCallback)((url)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const handleLogIn = (0, $8ZuGG.useCallback)((username, password)=>{
        if (!marketingConsent) {
            console.error('Form cannot be submitted without showing Marketing Consent');
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        if (!isUsernameChecked && !isV2UsernameChecked) {
            console.error('Cannot submit a username & password login attempt until check-username endpoint has been called (V1 or V2)');
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            return;
        }
        analyticsClient.formSubmittedEvent((0, $5Nhr0.loginPageId), 'loginForm', appendReasonViewingScreen({
            marketingConsent: (0, $fvOZR.dangerouslyCreateSafeString)(marketingConsent.state)
        }));
        const onLoginError = (code)=>{
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            analyticsClient.trackingEvent({
                page: (0, $5Nhr0.loginPageId),
                action: 'submitted',
                subject: 'credentials',
                attributes: {
                    successfulAuthentication: false,
                    errorCode: code
                }
            });
        };
        dispatch((0, $fouZP.loginUsernamePassword)({
            username: username,
            password: password,
            captchaValue: captchaValue,
            location: window.location,
            onLoginError: onLoginError,
            marketingConsent: marketingConsent,
            anonymousId: anonymousId
        }, redirectWithCallback));
    }, [
        analyticsClient,
        anonymousId,
        appendReasonViewingScreen,
        captchaValue,
        dispatch,
        isUsernameChecked,
        isV2UsernameChecked,
        marketingConsent,
        onFailure,
        redirectWithCallback
    ]);
    const handlePasswordlessLogIn = (0, $8ZuGG.useCallback)(async (email)=>{
        const { success: success } = await dispatch((0, $fouZP.loginPasswordless)({
            email: email,
            captchaValue: captchaValue,
            location: window.location
        }));
        if (success) dispatch((0, $xe7jL.addFlag)('success', (0, $40CJF.LoginPageMessages).passwordlessSuccessTitle, (0, $40CJF.LoginPageMessages).passwordlessSuccessDescription));
    }, [
        dispatch,
        captchaValue
    ]);
    return {
        isLoading: /**
     * Indicates whether username & password submission is in progress.
     * */ isLoading,
        /**
     * Errors around the username (email) and password fields.
     * */ onPasswordlessLogin: handlePasswordlessLogIn,
        /**
     * Handle login with username and password.
     *
     * Note: this will be a no-op if the username (email) has not been checked by calling
     * `checkUsername` before calling `onLogin`.
     *
     * For accessing the state and handlers around working with `checkUsername`, see:
     * {@link file://./useLogin.ts}.
     * */ onLogin: handleLogIn
    };
};

});

parcelRegister("galVA", function(module, exports) {

$parcel$export(module.exports, "useSocialLogin", function () { return $089a07eddfb3da12$export$c599a88026ac50ef; });

var $8ZuGG = parcelRequire("8ZuGG");

var $2qqPL = parcelRequire("2qqPL");

var $kOqgB = parcelRequire("kOqgB");

var $8dHAc = parcelRequire("8dHAc");

var $3ir1n = parcelRequire("3ir1n");

var $lk8Tl = parcelRequire("lk8Tl");

var $9Codz = parcelRequire("9Codz");

var $fT7xM = parcelRequire("fT7xM");

var $jmNJW = parcelRequire("jmNJW");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $5Nhr0 = parcelRequire("5Nhr0");

var $hm82Q = parcelRequire("hm82Q");

var $erZlf = parcelRequire("erZlf");
const $089a07eddfb3da12$export$c599a88026ac50ef = ()=>{
    (0, $aavUY.useRegisterComponent)($089a07eddfb3da12$export$c599a88026ac50ef.name);
    const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $hm82Q.useAppendReasonViewingScreen)();
    const isUsernameChecked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isUsernameChecked;
    });
    const identities = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.identities;
    });
    const isLoginSecondStep = isUsernameChecked;
    const isGoogleOneTapDismissed = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_googleOneTap;
        return state === null || state === void 0 ? void 0 : (_state_googleOneTap = state.googleOneTap) === null || _state_googleOneTap === void 0 ? void 0 : _state_googleOneTap.dismissed;
    });
    const isSocialBlocked = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isSocialBlocked;
    });
    const { errorCode: errorCode } = (0, $hm82Q.useSearchParamCodes)();
    const { state: state } = (0, $9Codz.useLoginState)();
    const { appConfig: appConfig, csrfToken: csrfToken } = state || {};
    const application = (0, $hm82Q.useCobrandingApplication)();
    const dynamicConfigs = (0, $erZlf.useDynamicConfigs)();
    const socialLoginEligibility = (0, $8ZuGG.useMemo)(()=>(0, $jmNJW.getSocialLoginEligibility)(identities, application, dynamicConfigs), [
        application,
        identities,
        dynamicConfigs
    ]);
    const { highlightedSocialProvider: highlightedSocialProvider, isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly } = socialLoginEligibility;
    const showSocialLoginOnly = isLoginSecondStep && isEligibleForSocialLoginOnly && highlightedSocialProvider && isCommercial;
    const socialButtonClickedEvent = (0, $8ZuGG.useCallback)((socialProvider)=>{
        analyticsClient.buttonClickedEvent(showSocialLoginOnly ? 'socialLoginForm' : (0, $5Nhr0.loginPageId), `${socialProvider}LoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen,
        showSocialLoginOnly
    ]);
    const loginRecoveryOptions = (0, $hm82Q.useLoginRecoveryOptions)();
    const handleGoogleSocialLogin = (0, $8ZuGG.useCallback)((email)=>{
        socialButtonClickedEvent((0, $8dHAc.SocialProvider).Google);
        (0, $fT7xM.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $5Nhr0.loginPageId),
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleAuth0SocialLogin = (0, $8ZuGG.useCallback)((socialProvider, email, redirectFn)=>{
        socialButtonClickedEvent(socialProvider);
        redirectFn({
            location: window.location,
            auth0Config: appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
            csrfToken: csrfToken !== null && csrfToken !== void 0 ? csrfToken : 'token-should-be-loaded',
            source: (0, $5Nhr0.loginPageId),
            email: email || undefined,
            recoveryOptions: loginRecoveryOptions(email)
        });
    }, [
        appConfig === null || appConfig === void 0 ? void 0 : appConfig.auth0Config,
        csrfToken,
        loginRecoveryOptions,
        socialButtonClickedEvent
    ]);
    const handleMicrosoftLogin = (0, $8ZuGG.useCallback)((email)=>handleAuth0SocialLogin((0, $8dHAc.SocialProvider).Microsoft, email, (0, $fT7xM.redirectToMicrosoftLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleAppleLogin = (0, $8ZuGG.useCallback)((email)=>handleAuth0SocialLogin((0, $8dHAc.SocialProvider).Apple, email, (0, $fT7xM.redirectToAppleLogin)), [
        handleAuth0SocialLogin
    ]);
    const handleSlackLogin = (0, $8ZuGG.useCallback)((email)=>handleAuth0SocialLogin((0, $8dHAc.SocialProvider).Slack, email, (0, $fT7xM.redirectToSlackLogin)), [
        handleAuth0SocialLogin
    ]);
    const onDismissGoogleOneTap = (0, $8ZuGG.useCallback)(()=>dispatch((0, $2qqPL.dismissGoogleOneTap)()), [
        dispatch
    ]);
    const isCheckingUsername = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isCheckingUsername;
    });
    const isLoggingIn = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.isLoggingIn;
    });
    const usernameExists = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_login;
        return (_state_login = state.login) === null || _state_login === void 0 ? void 0 : _state_login.usernameExists;
    });
    const isLoading = isCheckingUsername || isLoggingIn;
    (0, $8ZuGG.useEffect)(()=>{
        if (!isLoading && isLoginSecondStep && usernameExists && identities) analyticsClient.trackingEvent({
            page: (0, $5Nhr0.loginPageId),
            action: 'triggered',
            subject: 'loginSecondStep',
            attributes: {
                eligibility: socialLoginEligibility
            }
        });
    }, [
        analyticsClient,
        identities,
        isLoading,
        isLoginSecondStep,
        socialLoginEligibility,
        usernameExists
    ]);
    if (isCommercial) return {
        envSupportsSocialLogin: true,
        socialLoginEligibility: socialLoginEligibility,
        onAppleLogin: handleAppleLogin,
        onSlackLogin: handleSlackLogin,
        onMicrosoftLogin: handleMicrosoftLogin,
        onGoogleSocialLogin: handleGoogleSocialLogin,
        onDismissGoogleOneTap: onDismissGoogleOneTap,
        isGoogleOneTapDismissed: isGoogleOneTapDismissed,
        isSocialBlocked: isSocialBlocked || (errorCode === null || errorCode === void 0 ? void 0 : errorCode.code) === 'social_login_banned'
    };
    return {
        envSupportsSocialLogin: false,
        socialLoginEligibility: null,
        onAppleLogin: null,
        onSlackLogin: null,
        onMicrosoftLogin: null,
        onGoogleSocialLogin: null,
        onDismissGoogleOneTap: null,
        isGoogleOneTapDismissed: null,
        isSocialBlocked: false
    };
};

});
parcelRegister("2qqPL", function(module, exports) {

$parcel$export(module.exports, "dismissGoogleOneTap", function () { return $07e206e16c6ac775$export$7634a565805a5f09; });
const $07e206e16c6ac775$export$7634a565805a5f09 = ()=>({
        type: 'GOOGLE_ONE_TAP_DISMISS'
    });

});

parcelRegister("jmNJW", function(module, exports) {

$parcel$export(module.exports, "getSocialLoginEligibility", function () { return $c9ae2ff9ddf7e854$export$e8b4b1bf168dca09; });

var $8dHAc = parcelRequire("8dHAc");

var $fT7xM = parcelRequire("fT7xM");
const $c9ae2ff9ddf7e854$export$c612d878ad73a6c0 = [
    (0, $8dHAc.SocialProvider).Google,
    (0, $8dHAc.SocialProvider).Microsoft,
    (0, $8dHAc.SocialProvider).Apple,
    (0, $8dHAc.SocialProvider).Slack
];
const $c9ae2ff9ddf7e854$export$94af6b531db26586 = (dynamicConfigs)=>{
    const highPriority = [];
    const lowPriority = [];
    const isProviderEnabled = {
        [(0, $8dHAc.SocialProvider).Google]: !(0, $fT7xM.isGoogleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $8dHAc.SocialProvider).Microsoft]: !(0, $fT7xM.isMicrosoftLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $8dHAc.SocialProvider).Apple]: !(0, $fT7xM.isAppleLoginOutageAdvisoryEnabled)(dynamicConfigs),
        [(0, $8dHAc.SocialProvider).Slack]: !(0, $fT7xM.isSlackLoginOutageAdvisoryEnabled)(dynamicConfigs)
    };
    $c9ae2ff9ddf7e854$export$c612d878ad73a6c0.forEach((provider)=>{
        if (!isProviderEnabled[provider]) lowPriority.push(provider);
        else // If it's enabled or undefined (not in the record), it's high priority
        highPriority.push(provider);
    });
    return [
        ...highPriority,
        ...lowPriority
    ];
};
const $c9ae2ff9ddf7e854$export$47bb6da133b3804e = (connected, dynamicConfigs)=>{
    const rankedSocialProviders = $c9ae2ff9ddf7e854$export$94af6b531db26586(dynamicConfigs);
    for (const socialProvider of rankedSocialProviders){
        if (connected.includes(socialProvider)) return socialProvider;
    }
    return null;
};
const $c9ae2ff9ddf7e854$export$e5abae2d758ca82f = (identities)=>{
    if (!identities) return [];
    return Object.values((0, $8dHAc.SocialProvider)).filter((provider)=>!!(identities === null || identities === void 0 ? void 0 : identities[provider]));
};
const $c9ae2ff9ddf7e854$export$55a908504dbef32d = (socialProvider, application, hasPassword = true)=>Boolean(socialProvider && !hasPassword && application !== 'trello');
const $c9ae2ff9ddf7e854$export$e8b4b1bf168dca09 = (identities, application, dynamicConfigs)=>{
    const connectedSocialProviders = $c9ae2ff9ddf7e854$export$e5abae2d758ca82f(identities);
    const highlightedSocialProvider = $c9ae2ff9ddf7e854$export$47bb6da133b3804e(connectedSocialProviders, dynamicConfigs);
    const hasPassword = identities === null || identities === void 0 ? void 0 : identities.password;
    const isEligibleForSocialLoginOnly = $c9ae2ff9ddf7e854$export$55a908504dbef32d(highlightedSocialProvider, application, hasPassword);
    return {
        isEligibleForSocialLoginOnly: isEligibleForSocialLoginOnly,
        highlightedSocialProvider: highlightedSocialProvider,
        connectedSocialProviders: connectedSocialProviders,
        enabledSocialButtons: $c9ae2ff9ddf7e854$export$c612d878ad73a6c0,
        firstProductAccessed: application || 'unknown',
        hasPassword: hasPassword
    };
};

});


parcelRegister("hPjb0", function(module, exports) {

$parcel$export(module.exports, "useGoogleOneTap", function () { return $d2847ff195e6aedb$export$84fc8ad34c97e462; });

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $6zbiR = parcelRequire("6zbiR");

var $hm82Q = parcelRequire("hm82Q");
const $d2847ff195e6aedb$export$84fc8ad34c97e462 = ({ email: email })=>{
    (0, $aavUY.useRegisterComponent)($d2847ff195e6aedb$export$84fc8ad34c97e462.name);
    const { setLoginRecoveryOptions: setLoginRecoveryOptions } = (0, $6zbiR.useLoginRecoveryOptionsContext)();
    const buildLoginRecoveryOptions = (0, $hm82Q.useLoginRecoveryOptions)();
    (0, $8ZuGG.useEffect)(()=>{
        if (!email) return;
        const loginRecoveryOptions = buildLoginRecoveryOptions(email);
        setLoginRecoveryOptions(loginRecoveryOptions);
    }, [
        email,
        setLoginRecoveryOptions,
        buildLoginRecoveryOptions
    ]);
};

});
parcelRegister("6zbiR", function(module, exports) {

$parcel$export(module.exports, "LoginRecoveryOptionsContextProvider", function () { return $776c2329f0898418$export$4df382a2361d8131; });
$parcel$export(module.exports, "useLoginRecoveryOptionsContext", function () { return $776c2329f0898418$export$402ee3e11776bab7; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
const $776c2329f0898418$export$84bd9b573c96976b = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $776c2329f0898418$export$4df382a2361d8131 = ({ children: children })=>{
    const [loginRecoveryOptions, setLoginRecoveryOptions] = (0, $8ZuGG.useState)();
    const value = (0, $8ZuGG.useMemo)(()=>({
            loginRecoveryOptions: loginRecoveryOptions,
            setLoginRecoveryOptions: setLoginRecoveryOptions
        }), [
        loginRecoveryOptions
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($776c2329f0898418$export$84bd9b573c96976b.Provider, {
        value: value,
        children: children
    });
};
const $776c2329f0898418$export$402ee3e11776bab7 = ()=>{
    const context = (0, $8ZuGG.useContext)($776c2329f0898418$export$84bd9b573c96976b);
    if (!context) throw new Error('useLoginRecoveryOptionsContext must be used within a LoginRecoveryOptionsContextProvider');
    return context;
};

});




parcelRegister("avtAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18c69f98217b020e$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $cufV0 = parcelRequire("cufV0");

var $9Vz68 = parcelRequire("9Vz68");

var $hPm2F = parcelRequire("hPm2F");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $8PH8E = parcelRequire("8PH8E");

var $4Rgc6 = parcelRequire("4Rgc6");

var $dilb2 = parcelRequire("dilb2");

var $1SvOA = parcelRequire("1SvOA");

var $lp6gZ = parcelRequire("lp6gZ");

var $eaMRk = parcelRequire("eaMRk");

var $l1nfA = parcelRequire("l1nfA");

var $hAzIv = parcelRequire("hAzIv");

var $8dHAc = parcelRequire("8dHAc");

var $kZj5j = parcelRequire("kZj5j");

var $3ir1n = parcelRequire("3ir1n");

var $5Nhr0 = parcelRequire("5Nhr0");

var $kR60c = parcelRequire("kR60c");

var $ciYFg = parcelRequire("ciYFg");

var $4j6Os = parcelRequire("4j6Os");

var $97pBx = parcelRequire("97pBx");

var $FXESS = parcelRequire("FXESS");

var $lThM2 = parcelRequire("lThM2");
var $ld7ev = parcelRequire("ld7ev");

var $dMtGq = parcelRequire("dMtGq");
let $18c69f98217b020e$var$_ = (t)=>t, $18c69f98217b020e$var$t, $18c69f98217b020e$var$t1, $18c69f98217b020e$var$t2;
const $18c69f98217b020e$export$d55ce944e082b58f = (0, $9Vz68.default).div($18c69f98217b020e$var$t || ($18c69f98217b020e$var$t = $18c69f98217b020e$var$_`
  align-items: center;
  color: ${0};
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 0 8px;
`), (0, $kTdw7).N90);
const $18c69f98217b020e$export$a7fed597f4b8afd8 = (0, $9Vz68.default).form($18c69f98217b020e$var$t1 || ($18c69f98217b020e$var$t1 = $18c69f98217b020e$var$_`
  margin: 0;
`));
const $18c69f98217b020e$var$InputsWrapper = (0, $9Vz68.default).div($18c69f98217b020e$var$t2 || ($18c69f98217b020e$var$t2 = $18c69f98217b020e$var$_`
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $18c69f98217b020e$var$getEmailFieldViewType = (restrictedEmail, redirectType, isSecondStep, isLoading)=>{
    if (restrictedEmail || redirectType === (0, $8dHAc.CheckUserNameRedirectType).Sso) return (0, $4Rgc6.FieldViewType).Restricted;
    else if (isSecondStep || isLoading) return (0, $4Rgc6.FieldViewType).ReadOnlyWithEditButton;
    return (0, $4Rgc6.FieldViewType).Editable;
};
const $18c69f98217b020e$export$1f58f750f20f344b = ({ application: application, email: email, error: error, fieldErrors: fieldErrors, info: info, isLoading: isLoading, isPasswordlessAllowed: isPasswordlessAllowed, isRedirecting: isRedirecting, isSecondStep: isSecondStep, isCheckUsernameLoading: isCheckUsernameLoading, onContinue: onContinue, onEditEmail: onEditEmail, onEmailChange: onEmailChange, onFormClick: onFormClick, onLogIn: onLogIn, onPasswordlessLogIn: onPasswordlessLogIn, onValidationError: onValidationError, pageId: pageId, redirectType: redirectType, restrictedEmail: restrictedEmail, showRememberMeCheckbox: showRememberMeCheckbox, rememberMeChecked: rememberMeChecked, onToggleRememberMeCheckbox: onToggleRememberMeCheckbox })=>{
    const intl = (0, $iSD9t.default)();
    const translatedEmailFieldError = (0, $97pBx.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const [buttonClicked, setButtonClicked] = (0, $8ZuGG.useState)('submit');
    const inputRef = (0, $8ZuGG.useRef)(null);
    const [passwordFieldError, setPasswordFieldError] = (0, $8ZuGG.useState)(null);
    const onEmailClick = (0, $8ZuGG.useCallback)(()=>{
        setPassword('');
        setPasswordFieldError(null);
        onEditEmail();
    }, [
        onEditEmail
    ]);
    const { captchaValue: captchaValue, isRequired: isTooManyAttemptsRecaptchaRequired } = (0, $ciYFg.useLoginTooManyAttemptsRecaptchaContext)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const trimmedEmail = email.trim();
        const emailEmpty = trimmedEmail === '';
        const emailInvalid = !trimmedEmail.match(/.+@.+/);
        const passwordEmpty = password === '';
        // Ignore submission of form while the app is loading.
        if (isLoading) return;
        setButtonClicked('submit');
        analyticsClient.buttonClickedEvent(pageId, isSecondStep ? 'login' : 'continueToLogin');
        if (emailEmpty) {
            var _inputRef_current;
            (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            const emailValidationError = formatMessage((0, $hAzIv.default).emailEmpty);
            analyticsClient.errorShownEvent((0, $5Nhr0.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (emailInvalid) {
            var _inputRef_current1;
            (_inputRef_current1 = inputRef.current) === null || _inputRef_current1 === void 0 ? void 0 : _inputRef_current1.focus();
            const emailValidationError = formatMessage((0, $hAzIv.default).emailInvalid);
            analyticsClient.errorShownEvent((0, $5Nhr0.loginPageId), 'validationError');
            onValidationError({
                email: emailValidationError
            });
            return;
        }
        if (isSecondStep && passwordEmpty) {
            setPasswordFieldError(formatMessage((0, $hAzIv.default).passwordEmpty));
            return;
        }
        if (!isSecondStep) onContinue(trimmedEmail);
        else onLogIn(trimmedEmail, password);
    };
    const handlePasswordlessButtonClick = async ()=>{
        const trimmedEmail = email.trim();
        if (isLoading || !trimmedEmail) return;
        setButtonClicked('passwordless');
        onPasswordlessLogIn(trimmedEmail);
    };
    const handlePasswordChange = (0, $8ZuGG.useCallback)((e)=>{
        if (passwordFieldError) setPasswordFieldError(null);
        setPassword(e.currentTarget.value);
    }, [
        passwordFieldError,
        setPasswordFieldError,
        setPassword
    ]);
    const buttonContent = ()=>{
        if (!isSecondStep) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "login.form.continue",
            defaultMessage: "Continue"
        });
        if (isPasswordlessAllowed) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.login.with.password",
            defaultMessage: "Log in with password"
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.login",
            defaultMessage: "Log in"
        });
    };
    const infoContent = ()=>{
        const { formatMessage: formatMessage } = intl;
        const applicationName = application ? (0, $kZj5j.applications)[application].name : 'Product';
        const testId = 'login-info-test-id';
        if (info) switch(info.code){
            case 'migratingExistingUser':
                {
                    const summary = formatMessage((0, $hAzIv.default).migrateAccountInfo, {
                        application: applicationName
                    });
                    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $eaMRk.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            case 'existingUserSignupAttempt':
                {
                    const summary = formatMessage((0, $hAzIv.default).existingUserSignupAttemptInfo);
                    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $eaMRk.default), {
                        id: "login-info",
                        "data-testid": testId,
                        children: summary
                    });
                }
            default:
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $eaMRk.default), {
                    id: "login-info",
                    "data-testid": testId,
                    isHidden: true,
                    children: ' '
                });
        }
    };
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.stopInitialLoadApdexEvent('viewLoginPage');
    }, [
        analyticsClient
    ]);
    const emailError = ()=>{
        switch(fieldErrors.email){
            case 'unknown':
                return intl.formatMessage((0, $hAzIv.default).unexpectedErrorHappened);
            case 'rate_limit_exceeded_message':
                return intl.formatMessage((0, $hAzIv.default).rateLimitErrorMessage);
            default:
                return translatedEmailFieldError;
        }
    };
    const renderExperimentButtons = ()=>{
        if (redirectType === (0, $8dHAc.CheckUserNameRedirectType).Sso) return /*#__PURE__*/ (0, $6rcps.jsxs)($18c69f98217b020e$export$d55ce944e082b58f, {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "login.form.opening.sso",
                    defaultMessage: "Opening your single sign-on provider"
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {})
            ]
        });
        else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
            appearance: "primary",
            id: "login-submit",
            testId: "login-submit-idf-testid",
            type: "submit",
            isFullWidth: true,
            isDisabled: isSecondStep && isTooManyAttemptsRecaptchaRequired && !captchaValue,
            isLoading: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading),
            children: buttonContent()
        });
    };
    const { formatMessage: formatMessage } = intl;
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        children: [
            error && !isLoading && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: error === null || error === void 0 ? void 0 : error.message
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)("span", {
                children: [
                    " ",
                    infoContent(),
                    " "
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)($18c69f98217b020e$export$a7fed597f4b8afd8, {
                id: "form-login",
                "data-testid": "form-login",
                onSubmit: handleSubmit,
                onClick: onFormClick,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsxs)($18c69f98217b020e$var$InputsWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $4Rgc6.default), {
                                fieldViewType: $18c69f98217b020e$var$getEmailFieldViewType(restrictedEmail, redirectType, isSecondStep, isLoading),
                                fieldError: emailError(),
                                onChange: onEmailChange,
                                value: email,
                                onEmailClick: onEmailClick,
                                placeholderOverride: formatMessage((0, $hAzIv.default).emailPlaceholder),
                                inputRef: inputRef
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $dilb2.default), {
                                isHidden: !isSecondStep,
                                fieldError: passwordFieldError || undefined,
                                onChange: handlePasswordChange,
                                value: password,
                                className: `field-group password-field ${isSecondStep ? 'expanded' : 'hidden'}`,
                                isRequired: isSecondStep
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $kR60c.LoginRecaptcha), {}),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $4j6Os.LoginMarketingConsent), {}),
                            showRememberMeCheckbox && redirectType !== (0, $8dHAc.CheckUserNameRedirectType).Sso && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lThM2.default), {
                                paddingBlockStart: "space.100",
                                paddingBlockEnd: "space.100",
                                children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $ld7ev.default), {
                                    direction: "row",
                                    gap: "space.050",
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $FXESS.default), {
                                            testId: "remember-me-checkbox",
                                            isChecked: rememberMeChecked,
                                            onClick: onToggleRememberMeCheckbox,
                                            name: "remember",
                                            label: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $hAzIv.default).rememberMeCheckboxLabel)),
                                            // During the redirect process (and while loading), we want to disable the checkbox so that the user doesn't interact with the checkbox.
                                            isDisabled: buttonClicked === 'submit' && (!!isRedirecting || isLoading || isCheckUsernameLoading)
                                        }),
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $dMtGq.default), {
                                            // TODO [KIRBY-8737]: once it is available, use prop spacing='compact'
                                            // https://hello.jira.atlassian.cloud/browse/KIRBY-8737
                                            appearance: "info",
                                            iconLabel: formatMessage((0, $hAzIv.default).rememberMeMoreInfoLabel),
                                            placement: "right",
                                            fallbackPlacements: [
                                                'bottom'
                                            ],
                                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $hAzIv.default).rememberMeTooltip))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    renderExperimentButtons(),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                        isHidden: !isSecondStep || !isPasswordlessAllowed,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.StyledSocialLoginButton), {
                            id: "passwordless-button",
                            iconBefore: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hPm2F))), {
                                label: "email"
                            }),
                            iconAfter: /*#__PURE__*/ (0, $6rcps.jsx)("span", {
                                style: {
                                    width: 24
                                }
                            }),
                            isFullWidth: true,
                            advisoryEnabled: false,
                            onClick: handlePasswordlessButtonClick,
                            isLoading: buttonClicked === 'passwordless' && (!!isRedirecting || isLoading),
                            isDisabled: isTooManyAttemptsRecaptchaRequired && !captchaValue || isLoading || isRedirecting,
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                id: "login.form.passwordless.button",
                                defaultMessage: "Log in with email"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $18c69f98217b020e$export$2e2bcd8739ae039 = $18c69f98217b020e$export$1f58f750f20f344b;

});

parcelRegister("dpD1g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38adc0ea68eec99b$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

const $38adc0ea68eec99b$var$BaseRememberedAccountsPage = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("kFjNe")));
const $38adc0ea68eec99b$var$RememberedAccountsPage = ()=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)($38adc0ea68eec99b$var$BaseRememberedAccountsPage, {});
};
var $38adc0ea68eec99b$export$2e2bcd8739ae039 = $38adc0ea68eec99b$var$RememberedAccountsPage;

});
parcelRegister("kFjNe", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("oTLOT")).then(()=>parcelRequire('jNEMT'));

});


parcelRegister("97yOV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdec27b420594fdf$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $3abKe = parcelRequire("3abKe");

var $lk8Tl = parcelRequire("lk8Tl");
const $fdec27b420594fdf$var$MaybePasskeyLoginPanel = ({ onPasskeyLogin: onPasskeyLogin, authenticating: authenticating })=>{
    const isPasskeyAuthEnabled = (0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).ENABLE_PASSKEY_AUTH);
    const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
    if (!isPasskeyAuthEnabled || !isCommercial) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $3abKe.default), {
        handlePasskeyLogin: onPasskeyLogin,
        authenticating: authenticating
    });
};
var $fdec27b420594fdf$export$2e2bcd8739ae039 = $fdec27b420594fdf$var$MaybePasskeyLoginPanel;

});
parcelRegister("3abKe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d884584484c1522$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");

var $bzXLr = parcelRequire("bzXLr");

var $8q9Xi = parcelRequire("8q9Xi");

var $l1nfA = parcelRequire("l1nfA");
const $9d884584484c1522$export$a40fa4dfd66c03fa = ({ handlePasskeyLogin: handlePasskeyLogin, authenticating: authenticating = false })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.SocialLoginPanelWrapper), {
        role: "list",
        "data-i18n-or": formatMessage((0, $8q9Xi.default).passkeyAuthOrLoginWith),
        "data-i18n-continue": formatMessage((0, $8q9Xi.default).passkeyAuthOrLoginWith),
        className: "passkey-login",
        "data-testid": "passkey-login-wrapper-idf-testid",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.SocialLoginButtonRowGroup), {
            "data-testid": "passkey-login-idf-testid",
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.SocialLoginOptionWrapper), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.SocialLoginButton), {
                    id: "passkey-auth-button",
                    advisoryEnabled: false,
                    isLoading: authenticating,
                    logo: (0, (/*@__PURE__*/$parcel$interopDefault($bzXLr))),
                    onClick: handlePasskeyLogin,
                    children: "Passkey"
                })
            })
        })
    });
};
var $9d884584484c1522$export$2e2bcd8739ae039 = $9d884584484c1522$export$a40fa4dfd66c03fa;

});
parcelRegister("bzXLr", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL('7VwIV') + "key-logo.39b27441.svg";

});

parcelRegister("8q9Xi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0fc968aec2b2ef7$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $c0fc968aec2b2ef7$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    passkeyAuthOrLoginWith: {
        id: 'passkey.auth.or-login-with',
        defaultMessage: 'Or login with:'
    }
});

});



parcelRegister("kvSBU", function(module, exports) {

$parcel$export(module.exports, "usePasskeyLogin", function () { return $aad6718eb195b5f4$export$8649dfc50d6433ff; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $4Jkx8 = parcelRequire("4Jkx8");

var $9NVnN = parcelRequire("9NVnN");

var $5Nhr0 = parcelRequire("5Nhr0");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $hm82Q = parcelRequire("hm82Q");

var $gyRZh = parcelRequire("gyRZh");

var $lk8Tl = parcelRequire("lk8Tl");

const $aad6718eb195b5f4$export$8649dfc50d6433ff = ({ onSuccess: onSuccess } = {})=>{
    (0, $aavUY.useRegisterComponent)($aad6718eb195b5f4$export$8649dfc50d6433ff.name);
    const [searchParams] = (0, $gyRZh.useSearchParams)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const appendReasonViewingScreen = (0, $hm82Q.useAppendReasonViewingScreen)();
    const [authenticating, setAuthenticating] = (0, $8ZuGG.useState)(false);
    const passkeyButtonClickedEvent = (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent((0, $5Nhr0.loginPageId), `PasskeyLoginButton`, appendReasonViewingScreen({}));
    }, [
        analyticsClient,
        appendReasonViewingScreen
    ]);
    const redirectWithCallback = (0, $8ZuGG.useCallback)((url)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        navigate(url);
    }, [
        onSuccess,
        navigate
    ]);
    const onErrorWithTrackingAnalytics = (0, $8ZuGG.useCallback)((error)=>{
        analyticsClient.trackingEvent({
            page: (0, $5Nhr0.loginPageId),
            action: 'failed',
            subject: $aad6718eb195b5f4$var$ANALYTIC_EVENT_SUBJECT_ID,
            attributes: {
                reason: error
            }
        });
    }, [
        analyticsClient
    ]);
    const startPasskeyChallenge = (0, $8ZuGG.useCallback)(async ()=>{
        const isSupported = (0, $4Jkx8.isWebAuthnSupported)();
        analyticsClient.trackingEvent({
            page: (0, $5Nhr0.loginPageId),
            action: 'started',
            subject: $aad6718eb195b5f4$var$ANALYTIC_EVENT_SUBJECT_ID
        });
        if (!isSupported) {
            const redirectUri = $aad6718eb195b5f4$var$redirectToErrorPage({
                analyticsClient: analyticsClient,
                loginError: 'webauthn_not_supported',
                currentQueryParams: searchParams
            });
            return redirectWithCallback(redirectUri);
        }
        try {
            setAuthenticating(true);
            const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
            const token = isCommercial ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>'') : 'dummy-token'; // a token is expected by id-auth in IC and disabled entirely within FedRAMP
            const passkeyChallengeResponseResult = await $aad6718eb195b5f4$var$challenge();
            if (!passkeyChallengeResponseResult.success) {
                const redirectUri = $aad6718eb195b5f4$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: passkeyChallengeResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            const { requestOptions: requestOptions, transactionToken: transactionToken } = passkeyChallengeResponseResult.data;
            const authenticatorChallengeResult = await (0, $4Jkx8.challengeWithAuthenticator)(requestOptions);
            if (!authenticatorChallengeResult.success) {
                const redirectUri = $aad6718eb195b5f4$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: 'webauthn_challenge_failed',
                    currentQueryParams: searchParams,
                    webAuthnError: authenticatorChallengeResult.error
                });
                return redirectWithCallback(redirectUri);
            }
            const passkeyCredentialJson = authenticatorChallengeResult.data;
            const verifyResponseResult = await $aad6718eb195b5f4$var$verify({
                transactionToken: transactionToken,
                assertionJson: passkeyCredentialJson,
                analyticsClient: analyticsClient,
                token: token
            });
            if (!verifyResponseResult.success) {
                const redirectUri = $aad6718eb195b5f4$var$redirectToErrorPage({
                    analyticsClient: analyticsClient,
                    loginError: verifyResponseResult.error,
                    currentQueryParams: searchParams
                });
                return redirectWithCallback(redirectUri);
            }
            return redirectWithCallback(verifyResponseResult.data.redirectUri);
        } catch (e) {
            return onErrorWithTrackingAnalytics("challengeFailure");
        } finally{
            setAuthenticating(false);
        }
    }, [
        analyticsClient,
        onErrorWithTrackingAnalytics,
        redirectWithCallback,
        searchParams
    ]);
    const handlePasskeyLogin = (0, $8ZuGG.useCallback)(()=>{
        passkeyButtonClickedEvent();
        startPasskeyChallenge();
    }, [
        passkeyButtonClickedEvent,
        startPasskeyChallenge
    ]);
    return {
        onPasskeyLogin: handlePasskeyLogin,
        authenticating: authenticating
    };
};
const $aad6718eb195b5f4$var$ANALYTIC_EVENT_SUBJECT_ID = 'challengePasskey';
var $aad6718eb195b5f4$var$PasskeyChallengeApiError = /*#__PURE__*/ function(PasskeyChallengeApiError) {
    PasskeyChallengeApiError["challengeFailure"] = "challengeFailure";
    PasskeyChallengeApiError["tooManyRequests"] = "tooManyRequests";
    return PasskeyChallengeApiError;
}($aad6718eb195b5f4$var$PasskeyChallengeApiError || {});
const $aad6718eb195b5f4$var$challenge = async ()=>{
    try {
        const response = await fetch(`/v2/passkey/challenge${location.search}`, {
            method: 'GET'
        });
        switch(response.status){
            case 200:
                const challengeResponse = await response.json();
                return {
                    success: true,
                    data: challengeResponse
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            case 400:
                return {
                    success: false,
                    error: await $aad6718eb195b5f4$var$errorFromBadRequest(response)
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error from fetch: /v2/passkey/challenge`);
    }
};
const $aad6718eb195b5f4$var$verify = async ({ transactionToken: transactionToken, assertionJson: assertionJson, token: token })=>{
    try {
        const clientExtensionResultsJsonString = JSON.stringify(assertionJson.clientExtensionResults);
        const query = location.search ? `${location.search}&transactionToken=${transactionToken}` : '?transactionToken=' + transactionToken;
        const response = await fetch(`/v2/passkey/verify${query}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify((0, $6EnDC._)((0, $ty6PY._)({}, assertionJson), {
                clientExtensionResults: clientExtensionResultsJsonString,
                token: token
            }))
        });
        switch(response.status){
            case 200:
                const verifyResponse = await response.json();
                return {
                    success: true,
                    data: verifyResponse
                };
            case 400:
                return {
                    success: false,
                    error: await $aad6718eb195b5f4$var$errorFromBadRequest(response)
                };
            case 429:
                return {
                    success: false,
                    error: 'too_many_requests'
                };
            default:
                throw response;
        }
    } catch (error) {
        throw new Error(`error during verification of passkey`);
    }
};
const $aad6718eb195b5f4$var$errorFromBadRequest = (response)=>response.json().then((body)=>{
        switch(body.context.reason){
            case 'bad_request':
                return 'unknown';
            case 'unknown':
                return 'unknown';
            case 'login.form.token.expired':
                return 'login.form.token.expired';
            case 'login.form.invalid_token':
                return 'unknown';
            case 'invalid_passkey':
                return 'invalid_passkey';
            case 'passkey_managed_account':
                return 'passkey_managed_account';
            default:
                return 'unknown';
        }
    }).catch(()=>'unknown');
function $aad6718eb195b5f4$var$redirectToErrorPage({ analyticsClient: analyticsClient, loginError: loginError, currentQueryParams: currentQueryParams, webAuthnError: webAuthnError }) {
    if (webAuthnError) analyticsClient.trackingEvent({
        page: (0, $5Nhr0.loginPageId),
        action: 'failed',
        subject: $aad6718eb195b5f4$var$ANALYTIC_EVENT_SUBJECT_ID,
        attributes: {
            reason: webAuthnError
        }
    });
    else analyticsClient.trackingEvent({
        page: (0, $5Nhr0.loginPageId),
        subject: $aad6718eb195b5f4$var$ANALYTIC_EVENT_SUBJECT_ID,
        action: 'failed',
        attributes: {
            reason: loginError
        }
    });
    currentQueryParams.delete('errorCode');
    currentQueryParams.set('errorCode', loginError);
    return new URL(`/login?${currentQueryParams.toString()}`, window.location.origin);
}

});


parcelRegister("lvSNx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupLoader", function () { return $ff1930c573904a03$export$f820bc2fe9d1bd78; });
$parcel$export(module.exports, "SignupPage", function () { return $ff1930c573904a03$export$a2f4b65ede167ce5; });
$parcel$export(module.exports, "default", function () { return $ff1930c573904a03$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $2qqPL = parcelRequire("2qqPL");

var $bRdVV = parcelRequire("bRdVV");
parcelRequire("aApON");
var $6AFBV = parcelRequire("6AFBV");
var $1ZbjE = parcelRequire("1ZbjE");

var $l1nfA = parcelRequire("l1nfA");

var $7CMue = parcelRequire("7CMue");

var $1kz4j = parcelRequire("1kz4j");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $jFPWe = parcelRequire("jFPWe");

var $hHBfv = parcelRequire("hHBfv");

var $bMfEw = parcelRequire("bMfEw");

var $hldfT = parcelRequire("hldfT");

var $eVxty = parcelRequire("eVxty");

var $gfM1G = parcelRequire("gfM1G");

var $bMGX2 = parcelRequire("bMGX2");

var $8xW40 = parcelRequire("8xW40");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $5VQjR = parcelRequire("5VQjR");
const $ff1930c573904a03$var$subjectIds = {
    email: 'selfSignupNoEmail'
};
async function $ff1930c573904a03$export$f820bc2fe9d1bd78({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/signup/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $ff1930c573904a03$export$a2f4b65ede167ce5 = ()=>{
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { screenSize: screenSize } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const { error: error, userJourneyContextError: userJourneyContextError } = (0, $bMGX2.useSignup)();
    const { onSignup: onSignup, email: email, fieldErrors: fieldErrors, shouldDisableEmailInput: shouldDisableEmailInput } = (0, $eVxty.useSignupSubmit)();
    const handleValidationError = (0, $8ZuGG.useCallback)((errors)=>{
        const errorEventNames = Object.keys(errors).map((error)=>$ff1930c573904a03$var$subjectIds[error] || 'selfSignupUnknownUiError');
        errorEventNames.forEach((eventName)=>analyticsClient.errorShownEvent((0, $bMfEw.pageId), eventName));
        dispatch((0, $bRdVV.showFieldErrors)(errors));
    }, [
        analyticsClient,
        dispatch
    ]);
    const handleFormClick = (0, $8ZuGG.useCallback)(()=>{
        if (screenSize === 'mobile') dispatch((0, $2qqPL.dismissGoogleOneTap)());
    }, [
        dispatch,
        screenSize
    ]);
    const onSubmitClick = (0, $8ZuGG.useCallback)(async ()=>{
        const isWebAuthnSupported = async ()=>{
            try {
                return await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
            } catch (err) {
                return false;
            }
        };
        analyticsClient.buttonClickedEvent((0, $bMfEw.pageId), 'signupFormSubmit', {
            isWebAuthnSupported: await isWebAuthnSupported()
        });
    }, [
        analyticsClient
    ]);
    const { envSupportsSocialSignup: envSupportsSocialSignup, handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $gfM1G.useSocialSignup)();
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $1kz4j.default).headTitle)
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
                pageId: (0, $bMfEw.pageId),
                header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                    as: "h1",
                    size: "small",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $1kz4j.default).headerTitle))
                }),
                footer: /*#__PURE__*/ (0, $6rcps.jsx)((0, $hHBfv.FooterLogoWrapper), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1ZbjE.SignupRecaptchaNotice), {})
                }),
                whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6AFBV.LoginLink), {}),
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $hldfT.default), {
                        email: email,
                        error: error,
                        userJourneyContextError: userJourneyContextError,
                        fieldErrors: fieldErrors,
                        onSignup: onSignup,
                        onValidationError: handleValidationError,
                        onFormClick: handleFormClick,
                        onSubmitClick: onSubmitClick,
                        disableEmailInput: Boolean(email && shouldDisableEmailInput),
                        privacyPolicy: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jFPWe.SignupPrivacyPolicy), {})
                    }),
                    envSupportsSocialSignup && /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.default), {
                        handleGoogleLogin: handleGoogleLogin,
                        handleMicrosoftLogin: handleMicrosoftLogin,
                        handleAppleLogin: handleAppleLogin,
                        handleSlackLogin: handleSlackLogin
                    })
                ]
            })
        ]
    });
};
var $ff1930c573904a03$export$2e2bcd8739ae039 = $ff1930c573904a03$export$a2f4b65ede167ce5;

});
parcelRegister("bRdVV", function(module, exports) {

$parcel$export(module.exports, "reset", function () { return $b52729a36961a3cc$export$aad8462122ac592b; });
$parcel$export(module.exports, "showFieldErrors", function () { return $b52729a36961a3cc$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "signupCaptchaFailure", function () { return $b52729a36961a3cc$export$f4ba837a66b5be0a; });
$parcel$export(module.exports, "signup", function () { return $b52729a36961a3cc$export$7200a869094fec36; });

var $jSnDV = parcelRequire("jSnDV");

var $kZj5j = parcelRequire("kZj5j");

var $jSO9M = parcelRequire("jSO9M");

var $8f2pb = parcelRequire("8f2pb");

var $lk8Tl = parcelRequire("lk8Tl");
const $b52729a36961a3cc$export$aad8462122ac592b = ()=>({
        type: 'SIGNUP_RESET'
    });
const $b52729a36961a3cc$export$e786d9c820defe79 = ()=>({
        type: 'SIGNUP_REQUEST'
    });
const $b52729a36961a3cc$export$99986585b9b9a16 = (redirectTo)=>({
        type: 'SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $b52729a36961a3cc$export$addc2691c91f42be = (error)=>({
        type: 'SIGNUP_REQUEST_FAILED',
        error: error
    });
const $b52729a36961a3cc$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $b52729a36961a3cc$export$f4ba837a66b5be0a = (isOnline)=>$b52729a36961a3cc$export$addc2691c91f42be(isOnline ? 'captcha' : 'request_error');

const $b52729a36961a3cc$export$7200a869094fec36 = (signupParams, location = window.location, options)=>async (dispatch, getState)=>{
        const { email: email, challengeResponse: challengeResponse } = signupParams;
        const { display: display } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
        const { cobranding: { productHint: productHint } } = getState();
        const microbranding = (0, $kZj5j.getMicrobrandingFromUrl)(location);
        const qs = microbranding && Object.keys(microbranding).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(microbranding)}` : '';
        // fire castle action
        const castleToken = (0, $lk8Tl.currentCloudType) === 'commercial' ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch((e)=>{
            console.error('castle error', e);
            (0, $8f2pb.captureException)(e);
            return undefined;
        }) : undefined;
        dispatch($b52729a36961a3cc$export$e786d9c820defe79());
        // TODO: confirm whether we should be including privacy policy text in the payload
        // https://hello.jira.atlassian.cloud/browse/KIRBY-7103
        const payload = {
            'challenge-response': (0, $jSO9M.toChallengeRequest)(challengeResponse),
            email: email,
            productHint: productHint,
            display: display || null,
            castleToken: castleToken
        };
        let response;
        try {
            response = await fetch(`/rest/signup${qs}`, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
        } catch (networkError) {
            dispatch($b52729a36961a3cc$export$addc2691c91f42be('request_error'));
            return;
        }
        try {
            const { fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo } = await response.json();
            if (redirectTo) {
                const fullRedirectUrl = new URL(redirectTo);
                const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
                const continueUrlFromParams = redirectUrlParams.get('continue');
                if ((options === null || options === void 0 ? void 0 : options.addParamsToContinueUrl) && continueUrlFromParams) {
                    const continueUrl = new URL(continueUrlFromParams);
                    const paramsToAdd = options.addParamsToContinueUrl({
                        fullRedirectUrl: fullRedirectUrl,
                        continueUrl: continueUrl
                    });
                    const updatedRedirectTo = $b52729a36961a3cc$var$updateRedirectContinueUrlParams({
                        fullRedirectUrlValue: redirectTo,
                        continueUrlValue: continueUrlFromParams,
                        paramsToAdd: paramsToAdd
                    });
                    dispatch($b52729a36961a3cc$export$99986585b9b9a16(updatedRedirectTo));
                    return;
                }
                dispatch($b52729a36961a3cc$export$99986585b9b9a16(redirectTo));
            } else {
                if (uiErrors && uiErrors.length) dispatch($b52729a36961a3cc$export$addc2691c91f42be(uiErrors[0].key || 'unknown'));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($b52729a36961a3cc$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($b52729a36961a3cc$export$addc2691c91f42be('unknown'));
            }
        } catch (error) {
            dispatch($b52729a36961a3cc$export$addc2691c91f42be('unknown'));
        }
    };
/**
 * This function allows additive changes only to continue URL search params.
 *
 * The full redirect URL often has a continue URL defined in its search params, usually pointing to
 * a destination product, like Loom. This continue URL, in turn, may have search params of its own.
 *
 * In some cases, consumers of the signup function may want to include certain additional params
 * inside the continue URL, based on what happened during the signup flow. This is useful to be able
 * to make decisions once the user lands on the product's domain.
 *
 * For example, a product may want to include a param to indicate that the user attempted to sign
 * up, but was redirected to /login on IDAC because they already have an account. They can include a
 * param in the continue URL to indicate that this was the case.
 */ const $b52729a36961a3cc$var$updateRedirectContinueUrlParams = ({ fullRedirectUrlValue: fullRedirectUrlValue, paramsToAdd: paramsToAdd, continueUrlValue: continueUrlValue })=>{
    const fullRedirectUrl = new URL(fullRedirectUrlValue);
    const redirectUrlParams = new URLSearchParams(fullRedirectUrl.search);
    const continueUrl = new URL(continueUrlValue);
    // update the params of the continue URL
    const existingParams = new URLSearchParams(continueUrl.search);
    const combinedParams = new URLSearchParams([
        ...existingParams,
        ...paramsToAdd
    ]);
    continueUrl.search = combinedParams.toString();
    // update the continue param of the full redirect URL
    redirectUrlParams.set('continue', continueUrl.toString());
    fullRedirectUrl.search = redirectUrlParams.toString();
    return fullRedirectUrl.toString();
};

});

parcelRegister("aApON", function(module, exports) {
$parcel$export(module.exports, "LoginLink", function () { return (parcelRequire("6AFBV")).LoginLink; });
$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return (parcelRequire("jFPWe")).SignupPrivacyPolicy; });
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("bSzBh")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("1ZbjE")).SignupRecaptchaNotice; });
parcelRequire("6AFBV");
parcelRequire("hldfT");
parcelRequire("93adm");
parcelRequire("jFPWe");
parcelRequire("4dReS");

});
parcelRegister("6AFBV", function(module, exports) {

$parcel$export(module.exports, "LoginLink", function () { return $738b8e4c8575c5d1$export$ae88ed303b99c258; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gyRZh = parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $kOqgB = parcelRequire("kOqgB");

var $8dHAc = parcelRequire("8dHAc");

var $day6I = parcelRequire("day6I");

var $gGDrC = parcelRequire("gGDrC");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $738b8e4c8575c5d1$export$ae88ed303b99c258 = ({ children: children })=>{
    (0, $aavUY.useRegisterComponent)($738b8e4c8575c5d1$export$ae88ed303b99c258.name);
    const location = (0, $5WDNl.useLocation)();
    const { isEmbedded: isEmbedded, oidcContext: oidcContext } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const loginLink = '/login' + location.search;
    if (isEmbedded) return null;
    if ((0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).Signup)) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
        id: "already-have-an-account",
        to: loginLink,
        children: children || /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "signup.already.have.account.log.in",
                defaultMessage: "Already have an Atlassian account? Log in"
            })
        })
    });
};

});

parcelRegister("hldfT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b69ff70cff5f6ae$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $jHLOy = parcelRequire("jHLOy");

var $dZRKj = parcelRequire("dZRKj");

var $lp6gZ = parcelRequire("lp6gZ");

var $1SvOA = parcelRequire("1SvOA");

var $99Gnb = parcelRequire("99Gnb");

var $8f2pb = parcelRequire("8f2pb");
parcelRequire("f2IKy");
var $7AZRg = parcelRequire("7AZRg");
parcelRequire("4dReS");
var $bSzBh = parcelRequire("bSzBh");

var $hHBfv = parcelRequire("hHBfv");

var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");
const $4b69ff70cff5f6ae$export$cc15cfe224a6a69b = ({ title: title, email: emailProp, onEmailChange: onEmailChange, error: error, userJourneyContextError: userJourneyContextError, fieldErrors: fieldErrors, onSignup: onSignup, onSubmitClick: onSubmitClick, onFormClick: onFormClick, hideEmailInput: hideEmailInput, disableEmailInput: disableEmailInput, onValidationError: onValidationError, privacyPolicy: privacyPolicy })=>{
    var _fieldErrors_email;
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const [email, setEmail] = (0, $8ZuGG.useState)(emailProp || '');
    const [shouldShowSpinner, setShouldShowSpinner] = (0, $8ZuGG.useState)(false);
    const emailInputRef = (0, $8ZuGG.useRef)(null);
    const currentEmailError = (_fieldErrors_email = fieldErrors.email) === null || _fieldErrors_email === void 0 ? void 0 : _fieldErrors_email.message;
    const previousEmailError = (0, $7AZRg.usePrevious)(currentEmailError);
    (0, $8ZuGG.useEffect)(()=>{
        var _emailInputRef_current;
        const emailError = currentEmailError && currentEmailError !== previousEmailError;
        if (emailError) (_emailInputRef_current = emailInputRef.current) === null || _emailInputRef_current === void 0 ? void 0 : _emailInputRef_current.focus();
    }, [
        currentEmailError,
        previousEmailError
    ]);
    const handleSubmit = (0, $8ZuGG.useCallback)(async ()=>{
        const validationErrors = {};
        if (shouldShowSpinner) return;
        if (!hideEmailInput && email.trim() === '') validationErrors.email = formatMessage((0, $99Gnb.SignupFormMessages).emailEmpty);
        if (Object.keys(validationErrors).length) {
            var _emailInputRef_current;
            onValidationError(validationErrors);
            const hasEmailError = validationErrors.email;
            if (hasEmailError) (_emailInputRef_current = emailInputRef.current) === null || _emailInputRef_current === void 0 ? void 0 : _emailInputRef_current.focus();
            return;
        }
        setShouldShowSpinner(true);
        try {
            await onSignup({
                email: email
            });
        } catch (e) {
            (0, $8f2pb.captureException)(e);
        }
        setShouldShowSpinner(false);
    }, [
        shouldShowSpinner,
        hideEmailInput,
        email,
        formatMessage,
        onValidationError,
        onSignup
    ]);
    const handleEmailChange = (e)=>{
        const email = e.currentTarget.value;
        setEmail(email);
        if (onEmailChange) onEmailChange(email);
    };
    const renderPrivacyPolicy = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $hHBfv.PrivacyPolicyContainer), {
                children: privacyPolicy
            })
        });
    };
    const renderSubmitButton = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)((0, $hHBfv.SignUpButtonWrapper), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                appearance: "primary",
                type: "submit",
                isFullWidth: true,
                id: "signup-submit",
                isLoading: shouldShowSpinner,
                onClick: ()=>onSubmitClick && onSubmitClick(),
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "signup.form.submit.verify",
                    defaultMessage: "Sign up"
                })
            })
        });
    };
    const replaceEmailIdWithTestId = (0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).REPLACE_EMAIL_ID_WITH_TEST_ID);
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        children: [
            userJourneyContextError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.FormErrorWrapper), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $jHLOy.default), {
                    testId: 'redirect-from-resetPassword-error',
                    appearance: "information",
                    children: userJourneyContextError.errorMessage
                })
            }),
            error ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: error.errorMessage
            }) : null,
            title && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: title
            }),
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $hHBfv.Form), {
                onSubmit: (e)=>{
                    e.preventDefault();
                    handleSubmit();
                },
                id: "form-sign-up",
                onClick: onFormClick,
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $hHBfv.EmailFieldGroup), {
                        isHidden: hideEmailInput,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
                            id: replaceEmailIdWithTestId ? undefined : 'email',
                            testId: replaceEmailIdWithTestId ? 'email-idf-testid' : undefined,
                            name: "email",
                            autoComplete: hideEmailInput ? 'off' : 'username',
                            type: "email",
                            placeholder: formatMessage((0, $99Gnb.SignupFormMessages).emailPlaceholder),
                            label: formatMessage((0, $99Gnb.SignupFormMessages).emailLabel),
                            autoFocus: !email,
                            isInvalid: !!currentEmailError,
                            invalidMessage: currentEmailError,
                            onChange: handleEmailChange,
                            value: email,
                            ref: emailInputRef,
                            isDisabled: disableEmailInput
                        })
                    }),
                    renderPrivacyPolicy(),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $bSzBh.SignupRecaptcha), {}),
                    renderSubmitButton()
                ]
            })
        ]
    });
};
var $4b69ff70cff5f6ae$export$2e2bcd8739ae039 = $4b69ff70cff5f6ae$export$cc15cfe224a6a69b;

});
parcelRegister("99Gnb", function(module, exports) {

$parcel$export(module.exports, "SignupFormMessages", function () { return $22f6e45bb2f70f96$export$ef21cebdb5785715; });

var $3VrrU = parcelRequire("3VrrU");
const $22f6e45bb2f70f96$export$ef21cebdb5785715 = (0, $3VrrU.defineMessages)({
    emailEmpty: {
        id: 'signup.form.email.empty',
        defaultMessage: 'Please enter an email address',
        description: ''
    },
    emailPlaceholder: {
        id: 'signup.form.email.placeholder',
        defaultMessage: 'Enter your email',
        description: ''
    },
    emailLabel: {
        id: 'signup.form.email.label',
        defaultMessage: 'Email',
        description: 'Label for the email input'
    },
    signupDisplayNameEmpty: {
        id: 'signup.display.name.empty',
        defaultMessage: 'Full name must not be empty'
    },
    signupDisplayNameTooLong: {
        id: 'signup.display.name.too.long',
        defaultMessage: 'Full name must not be greater than 255 characters'
    },
    signupEmailFormatError: {
        id: 'signup.email.format.error',
        defaultMessage: 'Email is required to be in correct format'
    },
    signupEmailReachedMaxAliases: {
        id: 'signup.email.reached.max.aliases',
        defaultMessage: 'Email aliases are rate limited'
    },
    signupEmailRestrictedDomain: {
        id: 'signup.email.restricted.domain.error',
        defaultMessage: 'The provided email address is not allowed, please use a different one'
    },
    signupGenericFailure: {
        id: 'signup.failure',
        defaultMessage: 'We are unable to sign you up. Please contact support and provide this message: {0}'
    },
    signupCaptchaResponseError: {
        id: 'signup.captcha.response.required.error',
        defaultMessage: "Are you sure you're not a robot?"
    }
});

});

parcelRegister("4dReS", function(module, exports) {
$parcel$export(module.exports, "SignupRecaptcha", function () { return (parcelRequire("bSzBh")).SignupRecaptcha; });
$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return (parcelRequire("1ZbjE")).SignupRecaptchaNotice; });
parcelRequire("bSzBh");
parcelRequire("1ZbjE");

});
parcelRegister("bSzBh", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptcha", function () { return $b4c6d57b1a1117bf$export$650ffb8b3f19a565; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $61XRM = parcelRequire("61XRM");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $6e7xx = parcelRequire("6e7xx");
const $b4c6d57b1a1117bf$export$650ffb8b3f19a565 = ()=>{
    (0, $aavUY.useRegisterComponent)($b4c6d57b1a1117bf$export$650ffb8b3f19a565.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $61XRM.useRecaptchaContext)();
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6e7xx.SignupRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("6e7xx", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaContainer", function () { return $61e288eece843590$export$7f3c0d51ba2e627e; });

var $9Vz68 = parcelRequire("9Vz68");

var $f19CI = parcelRequire("f19CI");
let $61e288eece843590$var$_ = (t)=>t, $61e288eece843590$var$t;
const $61e288eece843590$export$7f3c0d51ba2e627e = (0, $9Vz68.default)((0, $f19CI.default))($61e288eece843590$var$t || ($61e288eece843590$var$t = $61e288eece843590$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});


parcelRegister("1ZbjE", function(module, exports) {

$parcel$export(module.exports, "SignupRecaptchaNotice", function () { return $4510a0f369e940d7$export$3ce9549b7ed98745; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $f19CI = parcelRequire("f19CI");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $4510a0f369e940d7$export$3ce9549b7ed98745 = ()=>{
    (0, $aavUY.useRegisterComponent)($4510a0f369e940d7$export$3ce9549b7ed98745.name);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $f19CI.RecaptchaNotice), {});
};

});


parcelRegister("hHBfv", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $86e7adf9fab19a7b$export$648d5009980d0c69; });
$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $86e7adf9fab19a7b$export$6b077d087ec15a10; });
$parcel$export(module.exports, "SignUpButtonWrapper", function () { return $86e7adf9fab19a7b$export$5d58eaf357166f34; });
$parcel$export(module.exports, "Form", function () { return $86e7adf9fab19a7b$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "EmailFieldGroup", function () { return $86e7adf9fab19a7b$export$2ad90a8dcd76cc44; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $8PH8E = parcelRequire("8PH8E");
let $86e7adf9fab19a7b$var$_ = (t)=>t, $86e7adf9fab19a7b$var$t, $86e7adf9fab19a7b$var$t1, $86e7adf9fab19a7b$var$t2, $86e7adf9fab19a7b$var$t3, $86e7adf9fab19a7b$var$t4;
const $86e7adf9fab19a7b$export$648d5009980d0c69 = (0, $9Vz68.default).div($86e7adf9fab19a7b$var$t || ($86e7adf9fab19a7b$var$t = $86e7adf9fab19a7b$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize));
const $86e7adf9fab19a7b$export$6b077d087ec15a10 = (0, $9Vz68.default).div($86e7adf9fab19a7b$var$t1 || ($86e7adf9fab19a7b$var$t1 = $86e7adf9fab19a7b$var$_`
  margin-top: ${0}px;
  text-align: left;
  padding-left: 0;
`), (0, $5b7Z4.gridSize)());
const $86e7adf9fab19a7b$export$5d58eaf357166f34 = (0, $9Vz68.default).div($86e7adf9fab19a7b$var$t2 || ($86e7adf9fab19a7b$var$t2 = $86e7adf9fab19a7b$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $86e7adf9fab19a7b$export$a7fed597f4b8afd8 = (0, $9Vz68.default).form($86e7adf9fab19a7b$var$t3 || ($86e7adf9fab19a7b$var$t3 = $86e7adf9fab19a7b$var$_`
  margin: 0;
`));
const $86e7adf9fab19a7b$export$2ad90a8dcd76cc44 = (0, $9Vz68.default)((0, $8PH8E.default))($86e7adf9fab19a7b$var$t4 || ($86e7adf9fab19a7b$var$t4 = $86e7adf9fab19a7b$var$_`
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)());

});


parcelRegister("93adm", function(module, exports) {

$parcel$export(module.exports, "SignupGoogleOneTap", function () { return $1c490d8d31f4b157$export$afc76af3b27474ba; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $29Dh8 = parcelRequire("29Dh8");

var $kOqgB = parcelRequire("kOqgB");

var $bMfEw = parcelRequire("bMfEw");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $erZlf = parcelRequire("erZlf");

var $2O78M = parcelRequire("2O78M");

var $f81B8 = parcelRequire("f81B8");
const $1c490d8d31f4b157$export$afc76af3b27474ba = ({ children: children })=>{
    (0, $aavUY.useRegisterComponent)($1c490d8d31f4b157$export$afc76af3b27474ba.name);
    const dynamicConfigs = (0, $erZlf.useDynamicConfigs)();
    const googleOneTapDismissed = (0, $kOqgB.useAppSelector)((state)=>state.googleOneTap.dismissed);
    const hashedCsrfToken = (0, $kOqgB.useAppSelector)((state)=>state.hashedCsrfToken);
    const { googleAuthClientId: googleAuthClientId } = (0, $kOqgB.useAppSelector)((state)=>state.appConfig);
    const disableOneTap = googleOneTapDismissed || (0, $f81B8.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $2O78M.AidFrontendDynamicConfig).GOOGLE_ONE_TAP_KILL_SWITCH);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $29Dh8.default), {
        csrfToken: hashedCsrfToken,
        googleAuthClientId: googleAuthClientId,
        source: (0, $bMfEw.pageId),
        enabled: !disableOneTap,
        children: children
    });
};

});
parcelRegister("29Dh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b9a6cd21d659a67$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $eqEzl = parcelRequire("eqEzl");

var $fT7xM = parcelRequire("fT7xM");

var $jSnDV = parcelRequire("jSnDV");

var $8FHU2 = parcelRequire("8FHU2");

var $3ir1n = parcelRequire("3ir1n");

var $lk8Tl = parcelRequire("lk8Tl");
const $5b9a6cd21d659a67$var$oneTapClientUrl = 'https://accounts.google.com/gsi/client';
const $5b9a6cd21d659a67$export$dc57f6202fda5ffc = ({ children: children, csrfToken: csrfToken, enabled: enabled, google: google, googleAuthClientId: googleAuthClientId, recoveryOptions: recoveryOptions, source: source })=>{
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    (0, $8ZuGG.useEffect)(()=>{
        var _google_accounts;
        const isCommercial = (0, $lk8Tl.currentCloudType) === 'commercial';
        if ((google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : _google_accounts.id) && enabled && isCommercial) {
            google.accounts.id.initialize({
                client_id: googleAuthClientId,
                cancel_on_tap_outside: false,
                use_fedcm_for_prompt: true,
                itp_support: false,
                callback: (credentialResponse)=>{
                    analyticsClient.buttonClickedEvent(source, 'googleYoloAccountSelected');
                    const { userFlow: userFlow } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(window.location.search);
                    // [KIRBY-7902] TODO: use feature flag to determine if we should use the new endpoint (and submitFormHackReplacement) or the old one
                    // Backend URL and endpoint to be in a new place if it requires changes to accept and response with JSON, but the owner of the service is outside of Kirby.
                    const callbackBase = `${window.location.origin}/login/google`;
                    const callbackParams = {
                        state: (0, $fT7xM.buildState)({
                            location: window.location,
                            csrfToken: csrfToken,
                            source: source,
                            loginType: (0, $fT7xM.LoginType).GoogleOneTap,
                            anonymousId: analyticsClient.getAnonymousId(),
                            userFlow: userFlow,
                            recoveryOptions: recoveryOptions
                        })
                    };
                    // [KIRBY-7902] TODO: replace with `submitFormHackReplacement` once the backend endpoint is ready.
                    (0, $8FHU2.default)({
                        method: 'POST',
                        action: `${callbackBase}?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(callbackParams)}`,
                        payload: {
                            id_token: credentialResponse.credential
                        }
                    });
                }
            });
            google.accounts.id.prompt((notification)=>{
                if (notification.isDismissedMoment()) {
                    const reason = notification.getDismissedReason();
                    analyticsClient.buttonClickedEvent(source, 'googleYoloDismissed', {
                        reason: reason
                    });
                }
            });
        }
        return ()=>{
            var _google_accounts_id, _google_accounts;
            return google === null || google === void 0 ? void 0 : (_google_accounts = google.accounts) === null || _google_accounts === void 0 ? void 0 : (_google_accounts_id = _google_accounts.id) === null || _google_accounts_id === void 0 ? void 0 : _google_accounts_id.cancel();
        };
    }, [
        google,
        enabled,
        googleAuthClientId,
        csrfToken,
        analyticsClient,
        source,
        recoveryOptions
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};
var $5b9a6cd21d659a67$export$2e2bcd8739ae039 = (0, $eqEzl.default)($5b9a6cd21d659a67$var$oneTapClientUrl, {
    globalName: 'google',
    attributes: {
        nonce: window.cspNonce
    }
})($5b9a6cd21d659a67$export$dc57f6202fda5ffc);

});

parcelRegister("bMfEw", function(module, exports) {

$parcel$export(module.exports, "pageId", function () { return $b6f691f8b75e9fba$export$703ba2e7ea526c1b; });
const $b6f691f8b75e9fba$export$703ba2e7ea526c1b = 'atlassianAccountSignupScreen';

});


parcelRegister("jFPWe", function(module, exports) {

$parcel$export(module.exports, "SignupPrivacyPolicy", function () { return $a63a29c8a3575510$export$873af88187638697; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $6lpHq = parcelRequire("6lpHq");

var $day6I = parcelRequire("day6I");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $bMfEw = parcelRequire("bMfEw");

var $4aujX = parcelRequire("4aujX");

var $kOqgB = parcelRequire("kOqgB");
const $a63a29c8a3575510$export$873af88187638697 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $aavUY.useRegisterComponent)($a63a29c8a3575510$export$873af88187638697.name);
    const privacyPolicyMessageRef = (0, $8ZuGG.useRef)(null);
    const isEmbedded = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_microbranding;
        return (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.isEmbedded;
    });
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_microbranding;
        return (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.oidcContext;
    });
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $4aujX.useSignupPageContext)();
    (0, $8ZuGG.useEffect)(()=>{
        var _privacyPolicyMessageRef_current;
        const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        (_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6lpHq.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $day6I.isMobileOidc)(oidcContext),
        pageId: (0, $bMfEw.pageId),
        privacyPolicyText: (0, $6lpHq.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("6lpHq", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyText", function () { return $136ba3ac3c83bb10$export$e6f99b88cb37902d; });
$parcel$export(module.exports, "default", function () { return $136ba3ac3c83bb10$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $pO9YU = parcelRequire("pO9YU");

var $3ir1n = parcelRequire("3ir1n");

var $5mHsu = parcelRequire("5mHsu");
let $136ba3ac3c83bb10$var$_ = (t)=>t, $136ba3ac3c83bb10$var$t;
const $136ba3ac3c83bb10$var$SignupLegal = (0, $9Vz68.default).p($136ba3ac3c83bb10$var$t || ($136ba3ac3c83bb10$var$t = $136ba3ac3c83bb10$var$_`
  font-size: 12px;
`));
var $136ba3ac3c83bb10$export$e6f99b88cb37902d = /*#__PURE__*/ function(PrivacyPolicyText) {
    PrivacyPolicyText["passwordSignup"] = "passwordSignup";
    PrivacyPolicyText["oauthSignup"] = "oauthSignup";
    return PrivacyPolicyText;
}({});
const $136ba3ac3c83bb10$var$PrivacyPolicy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(({ isEmbedded: isEmbedded, isMobileOidc: isMobileOidc, pageId: pageId, privacyPolicyText: privacyPolicyText }, ref)=>{
    const cloudTOSLinkClicked = (0, $3ir1n.useLinkClickedEvent)(pageId, 'cloudTermsOfService');
    const privacyPolicyLinkClicked = (0, $3ir1n.useLinkClickedEvent)(pageId, 'privacyPolicy');
    const privacyPolicyMessage = (0, $8ZuGG.useMemo)(()=>{
        const shouldUseMobileLinks = isEmbedded || isMobileOidc;
        const privacyPolicyUrl = shouldUseMobileLinks ? (0, $pO9YU.PRIVACY_POLICY_URL_MOBILE) : (0, $pO9YU.PRIVACY_POLICY_URL);
        const cloudTermsOfServiceUrl = shouldUseMobileLinks ? (0, $pO9YU.CLOUD_TERMS_OF_SERVICE_URL_MOBILE) : (0, $pO9YU.CLOUD_TERMS_OF_SERVICE_URL);
        const messageValues = {
            'cloud-tos-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
                    href: cloudTermsOfServiceUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: cloudTOSLinkClicked,
                    children: chunks
                }),
            'privacy-policy-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $5mHsu.default), {
                    href: privacyPolicyUrl,
                    target: "_blank",
                    rel: "noreferrer noopener",
                    onClick: privacyPolicyLinkClicked,
                    children: chunks
                })
        };
        return privacyPolicyText === "passwordSignup" ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "signup.form.legal.updated.password.xml",
            defaultMessage: "By signing up, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when signing up for an Atlassian account",
            values: messageValues
        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "signup.form.legal.updated.Oauth.xml",
            defaultMessage: "By creating an account, I accept the Atlassian <cloud-tos-link>Cloud Terms of Service</cloud-tos-link> and acknowledge the <privacy-policy-link>Privacy Policy</privacy-policy-link>.",
            description: "Cloud Terms of Service and Privacy Policy notice displayed to users when creating an Atlassian account",
            values: messageValues
        });
    }, [
        cloudTOSLinkClicked,
        privacyPolicyLinkClicked,
        isEmbedded,
        isMobileOidc,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($136ba3ac3c83bb10$var$SignupLegal, {
        "data-testid": "legal-message",
        ref: ref,
        children: privacyPolicyMessage
    });
});
$136ba3ac3c83bb10$var$PrivacyPolicy.displayName = 'PrivacyPolicy';
var $136ba3ac3c83bb10$export$2e2bcd8739ae039 = $136ba3ac3c83bb10$var$PrivacyPolicy;

});

parcelRegister("4aujX", function(module, exports) {

$parcel$export(module.exports, "useSignupPageContext", function () { return $3edbf01174c524cc$export$ca302230e223e610; });
$parcel$export(module.exports, "SignupPageContextProvider", function () { return $3edbf01174c524cc$export$840533f74aa75441; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
const $3edbf01174c524cc$export$77a8faae8f9f5eab = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $3edbf01174c524cc$export$ca302230e223e610 = ()=>{
    const context = (0, $8ZuGG.useContext)($3edbf01174c524cc$export$77a8faae8f9f5eab);
    if (!context) throw new Error('useSignupPageContext must be used within a SignupPageContextProvider');
    return context;
};
const $3edbf01174c524cc$export$840533f74aa75441 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $8ZuGG.useState)();
    const state = (0, $8ZuGG.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText
        }), [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($3edbf01174c524cc$export$77a8faae8f9f5eab.Provider, {
        value: state,
        children: children
    });
};

});



parcelRegister("1kz4j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b96ecf262762088$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $3b96ecf262762088$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'signup.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    }
});

});

parcelRegister("eVxty", function(module, exports) {

$parcel$export(module.exports, "useSignupSubmit", function () { return $50ae2ebf082c1926$export$5757fd9e6194326b; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $gyRZh = parcelRequire("gyRZh");

var $bRdVV = parcelRequire("bRdVV");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $hTZm6 = parcelRequire("hTZm6");

var $bMfEw = parcelRequire("bMfEw");

var $4aujX = parcelRequire("4aujX");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $61XRM = parcelRequire("61XRM");

var $97pBx = parcelRequire("97pBx");

var $8f2pb = parcelRequire("8f2pb");
const $50ae2ebf082c1926$var$useEmailFromSearchParams = ()=>{
    const loginHint = (0, $hTZm6.useLoginHint)();
    const [queryParams] = (0, $gyRZh.useSearchParams)();
    const email = (0, $hTZm6.getEmailFromLoginHint)(loginHint) || queryParams.get('email');
    const shouldDisableEmailInput = queryParams.get('disableEmailInput') === 'true';
    return {
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};
const $50ae2ebf082c1926$export$5757fd9e6194326b = ({ autoSubmit: autoSubmitOption = true } = {})=>{
    (0, $aavUY.useRegisterComponent)($50ae2ebf082c1926$export$5757fd9e6194326b.name);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const [hasAutoSubmitted, setHasAutoSubmitted] = (0, $8ZuGG.useState)(false);
    const { privacyPolicyText: privacyPolicyText = '' } = (0, $4aujX.useSignupPageContext)();
    const [_, setQueryParams] = (0, $gyRZh.useSearchParams)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $61XRM.useRecaptchaContext)();
    const fieldErrors = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.fieldErrors;
    });
    const autoSubmitDefault = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.autoSubmit;
    });
    const autoSubmit = (0, $8ZuGG.useMemo)(()=>autoSubmitDefault && autoSubmitOption, [
        autoSubmitDefault,
        autoSubmitOption
    ]);
    const onSignup = (0, $8ZuGG.useCallback)(async (signupData, options)=>{
        try {
            const challengeResponse = await fetchToken();
            setQueryParams((urlParams)=>{
                urlParams.delete('errorCode');
                if (urlParams.has('email')) urlParams.delete('email');
                urlParams.append('email', signupData.email);
                return urlParams;
            });
            analyticsClient.formSubmittedEvent((0, $bMfEw.pageId), 'signupForm', {
                autoSubmit: autoSubmit,
                recaptchaType: recaptchaType
            });
            return dispatch((0, $bRdVV.signup)((0, $6EnDC._)((0, $ty6PY._)({}, signupData), {
                challengeResponse: challengeResponse,
                privacyPolicyText: privacyPolicyText
            }), undefined, options));
        } catch (e) {
            (0, $8f2pb.captureException)(e);
            dispatch((0, $bRdVV.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        setQueryParams,
        analyticsClient,
        dispatch,
        fetchToken,
        recaptchaType,
        privacyPolicyText,
        autoSubmit
    ]);
    const { email: email, shouldDisableEmailInput: shouldDisableEmailInput } = $50ae2ebf082c1926$var$useEmailFromSearchParams();
    (0, $8ZuGG.useEffect)(()=>{
        if (autoSubmit && email && !hasAutoSubmitted) {
            onSignup({
                email: email
            });
            setHasAutoSubmitted(true);
        }
    }, [
        autoSubmit,
        email,
        onSignup,
        hasAutoSubmitted,
        setHasAutoSubmitted
    ]);
    const emailTranslation = (0, $97pBx.useTranslateFormErrorIfAvailable)(fieldErrors.email);
    const fieldErrorsWithTranslations = (0, $8ZuGG.useCallback)((fieldErrors)=>{
        // fieldErrors.email could either be a code or a pre-translated message.
        const emailErrorIsCode = fieldErrors.email !== emailTranslation;
        return (0, $ty6PY._)({}, fieldErrors.email && {
            email: {
                code: emailErrorIsCode ? fieldErrors.email : undefined,
                // TODO [KIRBY-7532]: remove fallback to empty string after removing useTranslateFormErrorIfAvailable.
                //   emailTranslation will always be defined if fieldErrors.email is defined.
                message: emailTranslation || ''
            }
        });
    }, [
        emailTranslation
    ]);
    return {
        onSignup: onSignup,
        fieldErrors: fieldErrorsWithTranslations(fieldErrors),
        email: email,
        shouldDisableEmailInput: shouldDisableEmailInput
    };
};

});

parcelRegister("gfM1G", function(module, exports) {

$parcel$export(module.exports, "useSocialSignup", function () { return $025f2bd9782d08b9$export$a4d24b27d4eb9a3e; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $bbCID = parcelRequire("bbCID");

var $fT7xM = parcelRequire("fT7xM");

var $bMfEw = parcelRequire("bMfEw");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $lk8Tl = parcelRequire("lk8Tl");
const $025f2bd9782d08b9$export$a4d24b27d4eb9a3e = ()=>{
    (0, $aavUY.useRegisterComponent)($025f2bd9782d08b9$export$a4d24b27d4eb9a3e.name);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const handleGoogleLogin = (0, $8ZuGG.useCallback)((analyticsAttributes = {})=>{
        analyticsClient.buttonClickedEvent((0, $bMfEw.pageId), 'googleLoginButton', analyticsAttributes);
        (0, $fT7xM.redirectToGoogleLogin)({
            location: window.location,
            source: (0, $bMfEw.pageId)
        });
    }, [
        analyticsClient
    ]);
    const auth0Config = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_appConfig;
        return (_state_appConfig = state.appConfig) === null || _state_appConfig === void 0 ? void 0 : _state_appConfig.auth0Config;
    });
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $bbCID.useSocialLoginHandlers)({
        pageId: $bMfEw.pageId,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $bMfEw.pageId)
        }
    });
    const { isEmbedded: isEmbedded } = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const isCommercial = (0, $lk8Tl.getCurrentCloudType)() === 'commercial';
    const envSupportsSocialSignup = (0, $8ZuGG.useMemo)(()=>!isEmbedded && isCommercial, [
        isEmbedded,
        isCommercial
    ]);
    if (!envSupportsSocialSignup) return {
        envSupportsSocialSignup: false,
        handleGoogleLogin: null,
        handleAppleLogin: null,
        handleMicrosoftLogin: null,
        handleSlackLogin: null
    };
    return {
        envSupportsSocialSignup: true,
        handleGoogleLogin: handleGoogleLogin,
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});

parcelRegister("bMGX2", function(module, exports) {

$parcel$export(module.exports, "useSignup", function () { return $addebed28449f922$export$da8941e4c91255e0; });

var $8ZuGG = parcelRequire("8ZuGG");

var $gyRZh = parcelRequire("gyRZh");

var $iSD9t = parcelRequire("iSD9t");

var $bRdVV = parcelRequire("bRdVV");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $9NVnN = parcelRequire("9NVnN");
const $addebed28449f922$export$da8941e4c91255e0 = ({ forceRedirect: forceRedirect = true } = {})=>{
    (0, $aavUY.useRegisterComponent)($addebed28449f922$export$da8941e4c91255e0.name);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const errorCode = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.error;
    });
    const redirectTo = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_signup;
        return (_state_signup = state.signup) === null || _state_signup === void 0 ? void 0 : _state_signup.redirectTo;
    });
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8ZuGG.useEffect)(()=>{
        if (redirectTo && forceRedirect) try {
            const url = new URL(redirectTo);
            navigate(url.toString());
        } catch (e) {
        // invalid URL provided
        }
    }, [
        redirectTo,
        forceRedirect,
        navigate
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        // On unmount, dispatch reset:
        return ()=>{
            dispatch((0, $bRdVV.reset)());
        };
    }, [
        dispatch
    ]);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const error = (0, $8ZuGG.useMemo)(()=>{
        return errorCode ? {
            errorCode: errorCode,
            errorMessage: $addebed28449f922$var$signupErrorMessageFromCode(errorCode, formatMessage)
        } : undefined;
    }, [
        errorCode,
        formatMessage
    ]);
    const [queryParams] = (0, $gyRZh.useSearchParams)();
    const isRedirectFromResetPassord = queryParams.get('errorCode') === 'account_does_not_exist';
    const userJourneyContextError = isRedirectFromResetPassord ? {
        errorCode: 'account_does_not_exist',
        errorMessage: formatMessage({
            id: 'signup.form.redirect.account.does.not.exist.error',
            defaultMessage: "We can't find an account for that email address.",
            description: 'Error message shown when user tries to reset password for account that does not exist and is redirected to sign up'
        })
    } : undefined;
    return {
        error: /**
     * An error resulting from the user's actions on the signup page (often server error from
     * submitting the form).
     * */ error,
        redirectTo: /** URL to redirect to, if opted out of forced redirect */ redirectTo,
        userJourneyContextError: /**
     * An error within the wider context of the user's journey, during which they have been
     * redirected to or otherwise landed on the signup page (i.e. not a result of something they did
     * while on the page).
     * */ userJourneyContextError
    };
};
const $addebed28449f922$var$signupErrorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'unknown':
            return formatMessage({
                id: 'signup.error.unknown',
                defaultMessage: 'Something went wrong while attempting to sign up. Please try again.'
            });
        case 'captcha':
            return formatMessage({
                id: 'signup.error.captcha',
                defaultMessage: 'We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'signup.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'signup.error.request_error',
                defaultMessage: 'Unable to connect. Check your internet connection or the network settings for your browser and try again.'
            });
        case 'unexpectedError':
            return formatMessage({
                id: 'signup.error.unexpected_error',
                defaultMessage: "We couldn't create your account. Try again in a few minutes."
            });
        default:
            return formatMessage({
                id: 'signup.form.random.error',
                defaultMessage: 'An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.'
            }, {
                error: errorCode
            });
    }
};

});


parcelRegister("lJpee", function(module, exports) {

$parcel$export(module.exports, "consentLoader", function () { return $3fedd9d5e8820020$export$51cb5cf91bb86b88; });
$parcel$export(module.exports, "default", function () { return $3fedd9d5e8820020$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $8EIEv = parcelRequire("8EIEv");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $hB9Ab = parcelRequire("hB9Ab");

var $kOqgB = parcelRequire("kOqgB");

var $cugIF = parcelRequire("cugIF");

var $9NVnN = parcelRequire("9NVnN");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");

var $8f2pb = parcelRequire("8f2pb");




const $3fedd9d5e8820020$var$consentComponents = {
    fedramp: /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("cvY7F"))),
    'a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy': /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("gw1MU"))),
    '2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy': /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("e5aXV"))),
    '6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy': /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("fMdaP")))
};
async function $3fedd9d5e8820020$export$51cb5cf91bb86b88({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/consent/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-name--consent-screen'
        ]
    });
}
const $3fedd9d5e8820020$export$68f39a5ef8cea54d = ()=>{
    (0, $8xW40.usePageStateLoader)();
    const { cobranding: cobranding } = (0, $cugIF.useCobranding)();
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const { background: Background } = (0, $hB9Ab.getCobrandedComponents)(cobranding);
    const { organisationId: organisationId, consentType: consentType } = (0, $kOqgB.useAppSelector)((state)=>state.loginConsent);
    const { search: search } = (0, $5WDNl.useLocation)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const handleRedirectToLogin = (0, $8ZuGG.useCallback)((errorKey)=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.set('errorCode', errorKey);
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?prompt=true&${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const handleOnAccept = (0, $8ZuGG.useCallback)(async ()=>{
        const requestPayload = {
            consent: 'provided'
        };
        const response = await fetch(`/v2/login/authorize/consent${search}`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(requestPayload)
        });
        switch(response.status){
            case 200:
                const responseBody = await response.json();
                navigate(responseBody.uri);
                break;
            case 400:
                handleRedirectToLogin('consent-validation-error');
                break;
            default:
                handleRedirectToLogin('consent-validation-error');
                break;
        }
    }, [
        csrfToken,
        search,
        handleRedirectToLogin,
        navigate
    ]);
    const handleOnCancel = (0, $8ZuGG.useCallback)(()=>{
        const existingQueryParams = new URLSearchParams(search);
        existingQueryParams.delete('token');
        existingQueryParams.set('prompt', 'true');
        existingQueryParams.set('errorCode', 'generic-consent-error');
        const queryParamsWithErrorCode = existingQueryParams.toString();
        navigate(`/login?${queryParamsWithErrorCode}`);
    }, [
        search,
        navigate
    ]);
    const consentId = (0, $8ZuGG.useMemo)(()=>{
        if (organisationId) return `${organisationId}-${consentType}`;
        return consentType;
    }, [
        consentType,
        organisationId
    ]);
    const ConsentComponent = consentId && $3fedd9d5e8820020$var$consentComponents[consentId];
    (0, $8ZuGG.useEffect)(()=>{
        if (!ConsentComponent) {
            (0, $8f2pb.captureTaggedException)(`[ConsentScreen] no component rendered for organisation: ${organisationId}. Redirected to /login instead.`, {
                capabilities: [
                    'capability-group--login',
                    'capability-name--consent-screen'
                ]
            });
            handleRedirectToLogin('consent-loading-error');
        }
    }, [
        ConsentComponent,
        handleRedirectToLogin,
        organisationId
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8EIEv.default), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)(Background, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $8ZuGG.Suspense), {
                fallback: null,
                children: ConsentComponent ? /*#__PURE__*/ (0, $6rcps.jsx)(ConsentComponent, {
                    onAccept: handleOnAccept,
                    onCancel: handleOnCancel
                }) : null
            })
        })
    });
};
var $3fedd9d5e8820020$export$2e2bcd8739ae039 = $3fedd9d5e8820020$export$68f39a5ef8cea54d;

});
parcelRegister("cvY7F", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("l9p8w")).then(()=>parcelRequire('hZ1Yn'));

});

parcelRegister("gw1MU", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("inezq")).then(()=>parcelRequire('30JJN'));

});

parcelRegister("e5aXV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2XyyO")).then(()=>parcelRequire('gbjie'));

});

parcelRegister("fMdaP", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7T0Aw")).then(()=>parcelRequire('bMplV'));

});


parcelRegister("jY1fP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "socialConfirmationLoader", function () { return $77a08e00cf4e1954$export$1e349fd991386427; });
$parcel$export(module.exports, "CreateAccountConfirmationPage", function () { return $77a08e00cf4e1954$export$74ab7a9a192e1a7a; });
$parcel$export(module.exports, "default", function () { return $77a08e00cf4e1954$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $7CMue = parcelRequire("7CMue");

var $3ir1n = parcelRequire("3ir1n");
parcelRequire("f2IKy");
var $geQuT = parcelRequire("geQuT");
parcelRequire("4pCpP");
var $2tVDe = parcelRequire("2tVDe");

var $kcjY1 = parcelRequire("kcjY1");

var $8xW40 = parcelRequire("8xW40");

var $i6EM3 = parcelRequire("i6EM3");

var $c2Ycs = parcelRequire("c2Ycs");

var $dsiq9 = parcelRequire("dsiq9");

var $3V1om = parcelRequire("3V1om");

var $iggIg = parcelRequire("iggIg");

var $6TFzg = parcelRequire("6TFzg");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
async function $77a08e00cf4e1954$export$1e349fd991386427({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/login/social/confirmation/state', request, {
        capabilities: [
            'capability-group--login',
            'capability-subgroup--social-login'
        ]
    });
}
const $77a08e00cf4e1954$export$74ab7a9a192e1a7a = ()=>{
    const pageState = (0, $2tVDe.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, isEmbedded: isEmbedded, isLoading: isLoading, loginType: loginType, oidcContext: oidcContext, verifyNeeded: verifyNeeded } = pageState;
    // TODO: move to our recaptcha component for this page?
    (0, $geQuT.useRecaptchaChallengeObserver)((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID));
    const onSubmitClick = (0, $3ir1n.useButtonClickedEvent)((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmationSignup');
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: (0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dsiq9.Header), {
            createNeeded: createNeeded
        }),
        whiteboxFooter: /*#__PURE__*/ (0, $6rcps.jsx)((0, $iggIg.WhiteboxFooter), {
            loginType: loginType,
            verifyNeeded: verifyNeeded,
            createNeeded: createNeeded,
            isEmbedded: isEmbedded,
            oidcContext: oidcContext
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $i6EM3.default), {
            isEmbedded: isEmbedded,
            isLoading: isLoading,
            privacyPolicy: /*#__PURE__*/ (0, $6rcps.jsx)((0, $kcjY1.CreateAccountConfirmationPrivacyPolicy), {}),
            onSubmitClick: onSubmitClick,
            title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $3V1om.TitleText), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6TFzg.ConfirmationFormTitleText), {
                    loginType: loginType,
                    createNeeded: createNeeded
                })
            })
        })
    });
};
var $77a08e00cf4e1954$export$2e2bcd8739ae039 = $77a08e00cf4e1954$export$74ab7a9a192e1a7a;

});
parcelRegister("kcjY1", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationPrivacyPolicy", function () { return $60b2557b1cf9fdad$export$4f3ec0472a168e52; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $6lpHq = parcelRequire("6lpHq");

var $day6I = parcelRequire("day6I");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $c2Ycs = parcelRequire("c2Ycs");

var $0nu8f = parcelRequire("0nu8f");

var $kOqgB = parcelRequire("kOqgB");
const $60b2557b1cf9fdad$export$4f3ec0472a168e52 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $aavUY.useRegisterComponent)($60b2557b1cf9fdad$export$4f3ec0472a168e52.name);
    const privacyPolicyMessageRef = (0, $8ZuGG.useRef)(null);
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_microbranding;
        return state === null || state === void 0 ? void 0 : (_state_microbranding = state.microbranding) === null || _state_microbranding === void 0 ? void 0 : _state_microbranding.oidcContext;
    });
    const isEmbedded = (0, $kOqgB.useAppSelector)((state)=>Boolean(state.microbranding.isEmbedded));
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $0nu8f.useCreateAccountConfirmationPageContext)();
    const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
    (0, $8ZuGG.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6lpHq.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $day6I.isMobileOidc)(oidcContext),
        pageId: (0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
        privacyPolicyText: (0, $6lpHq.PrivacyPolicyText).oauthSignup,
        ref: privacyPolicyMessageRef
    });
};

});
parcelRegister("c2Ycs", function(module, exports) {

$parcel$export(module.exports, "CREATE_ACCOUNT_CONFIRMATION_PAGE_ID", function () { return $2c1dcbc49777ea61$export$eda9461179ec043e; });
const $2c1dcbc49777ea61$export$eda9461179ec043e = 'confirmCreateAccountIdpScreen';

});

parcelRegister("0nu8f", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmationPageContext", function () { return $b283b9b9bb691d66$export$4b772b7a2dc6f7e0; });
$parcel$export(module.exports, "CreateAccountConfirmationPageProvider", function () { return $b283b9b9bb691d66$export$a212ad9eda3f2daa; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
const $b283b9b9bb691d66$export$3906f31e8e2451c7 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $b283b9b9bb691d66$export$4b772b7a2dc6f7e0 = ()=>{
    const context = (0, $8ZuGG.useContext)($b283b9b9bb691d66$export$3906f31e8e2451c7);
    if (!context) throw new Error('useCreateAccountConfirmationPageContext must be used within a CreateAccountConfirmationPageContext provider');
    return context;
};
const $b283b9b9bb691d66$export$a212ad9eda3f2daa = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $8ZuGG.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $8ZuGG.useState)({
        state: 'not_shown'
    });
    const state = (0, $8ZuGG.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($b283b9b9bb691d66$export$3906f31e8e2451c7.Provider, {
        value: state,
        children: children
    });
};

});


parcelRegister("i6EM3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a92f92426cd3dd34$export$2e2bcd8739ae039; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $cT1nw = parcelRequire("cT1nw");

var $9h4E7 = parcelRequire("9h4E7");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $lp6gZ = parcelRequire("lp6gZ");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $8PH8E = parcelRequire("8PH8E");

var $fT7xM = parcelRequire("fT7xM");

var $jjRCi = parcelRequire("jjRCi");
var $2iPY4 = parcelRequire("2iPY4");

var $aywtZ = parcelRequire("aywtZ");

var $4W1sD = parcelRequire("4W1sD");

var $1SCpc = parcelRequire("1SCpc");
let $a92f92426cd3dd34$var$_ = (t)=>t, $a92f92426cd3dd34$var$t, $a92f92426cd3dd34$var$t1, $a92f92426cd3dd34$var$t2, $a92f92426cd3dd34$var$t3, $a92f92426cd3dd34$var$t4, $a92f92426cd3dd34$var$t5;
const $a92f92426cd3dd34$export$6b077d087ec15a10 = (0, $9Vz68.default).div($a92f92426cd3dd34$var$t || ($a92f92426cd3dd34$var$t = $a92f92426cd3dd34$var$_`
  margin-top: ${0}px;
  text-align: left;
`), (0, $5b7Z4.gridSize)());
const $a92f92426cd3dd34$var$ConsentAndLegalContainer = (0, $9Vz68.default)((0, $8PH8E.default))($a92f92426cd3dd34$var$t1 || ($a92f92426cd3dd34$var$t1 = $a92f92426cd3dd34$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $a92f92426cd3dd34$export$9951c1d20fa87009 = (0, $9Vz68.default).div($a92f92426cd3dd34$var$t2 || ($a92f92426cd3dd34$var$t2 = $a92f92426cd3dd34$var$_`
  display: flex;
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $a92f92426cd3dd34$var$StyledForm = (0, $9Vz68.default).form($a92f92426cd3dd34$var$t3 || ($a92f92426cd3dd34$var$t3 = $a92f92426cd3dd34$var$_`
  margin: 0;
`));
const $a92f92426cd3dd34$export$60374ee25b7d5e87 = (0, $9Vz68.default).div($a92f92426cd3dd34$var$t4 || ($a92f92426cd3dd34$var$t4 = $a92f92426cd3dd34$var$_`
  font-weight: bold;
  color: ${0};
  word-wrap: break-word;
`), (0, $kTdw7).N800);
const $a92f92426cd3dd34$var$VerificationWrapper = (0, $9Vz68.default).div($a92f92426cd3dd34$var$t5 || ($a92f92426cd3dd34$var$t5 = $a92f92426cd3dd34$var$_`
  margin: ${0}px 0 0;
`), (0, $5b7Z4.gridSize)() * 2);
const $a92f92426cd3dd34$export$ca6de4c099a9b97d = ({ isLoading: isLoading, onSubmitClick: onSubmitClick, privacyPolicy: privacyPolicy, title: title })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const { onCreateAccountConfirmation: onCreateAccountConfirmation, createAccountNeeded: createNeeded, verifyEmailNeeded: verifyNeeded, email: email, displayName: initialDisplayName, canEditDisplayName: canEditDisplayName, formError: formError, fieldErrors: fieldErrors } = (0, $4W1sD.useCreateAccountConfirmation)({});
    const [code, setCode] = (0, $8ZuGG.useState)('');
    const [displayName, setDisplayName] = (0, $8ZuGG.useState)('');
    (0, $8ZuGG.useEffect)(()=>{
        if (initialDisplayName && displayName === '') setDisplayName(initialDisplayName);
    }, [
        initialDisplayName,
        displayName
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        await onCreateAccountConfirmation({
            displayName: displayName,
            code: code
        });
    };
    const handleDisplayNameChange = (e)=>{
        const displayName = e.currentTarget.value;
        setDisplayName(displayName);
    };
    const handleCodeChange = (e)=>{
        const code = e.currentTarget.value;
        setCode(code);
    };
    const submitButtonText = ()=>{
        if (createNeeded) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "confirmation.form.submit.create",
            defaultMessage: "Create your account",
            description: "Button to submit form and create account"
        });
        else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "confirmation.form.submit.verify",
            defaultMessage: "Verify your account",
            description: "Button to submit form and verify account"
        });
    };
    const renderHiddenEmailWarning = ()=>{
        return /*#__PURE__*/ (0, $6rcps.jsx)($a92f92426cd3dd34$export$9951c1d20fa87009, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                title: formatMessage((0, $9h4E7.default).hiddenEmailWarningTitle),
                children: /*#__PURE__*/ (0, $6rcps.jsx)("p", {
                    "data-testid": "hidden-email-warning",
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "confirmation.form.hiddenemailwarning.message",
                        defaultMessage: "Your team may not recognize you and you won't receive their updates. When you are ready to work with a team, just update your Apple ID settings to share your real email."
                    })
                })
            })
        });
    };
    const renderCodeError = (error)=>{
        switch(error){
            case 'invalid_code':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "confirmation.form.code.invalid.server",
                    defaultMessage: "Provided verification code is invalid"
                });
            case 'invalid_length':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "confirmation.form.code.invalid.length",
                    defaultMessage: "Your verification code needs to be {length, plural, one {# digit} other {# digits}} or longer",
                    values: {
                        length: 8
                    }
                });
            case 'empty_code':
                return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "confirmation.form.code.empty",
                    defaultMessage: "Please enter a verification code"
                });
        }
    };
    const displayNameError = fieldErrors && fieldErrors.displayName;
    const codeError = fieldErrors && fieldErrors.code;
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: formError === null || formError === void 0 ? void 0 : formError.message
            }),
            title && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: title
            }),
            email && (0, $fT7xM.isAppleHiddenEmail)(email) && renderHiddenEmailWarning(),
            /*#__PURE__*/ (0, $6rcps.jsxs)($a92f92426cd3dd34$var$StyledForm, {
                onSubmit: handleSubmit,
                id: "confirmation-form",
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $2iPY4.default), {
                        name: "email",
                        label: formatMessage((0, $9h4E7.default).emailLabel),
                        children: ()=>/*#__PURE__*/ (0, $6rcps.jsx)($a92f92426cd3dd34$export$60374ee25b7d5e87, {
                                children: email
                            })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $6rcps.jsx)((0, $2iPY4.default), {
                        name: "displayName",
                        label: formatMessage((0, $9h4E7.default).displayNameLabel),
                        children: ({ fieldProps: fieldProps })=>!canEditDisplayName ? /*#__PURE__*/ (0, $6rcps.jsx)($a92f92426cd3dd34$export$60374ee25b7d5e87, {
                                role: "caption",
                                children: initialDisplayName
                            }) : /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $cT1nw.default), (0, $6EnDC._)((0, $ty6PY._)({}, fieldProps), {
                                        placeholder: formatMessage((0, $9h4E7.default).displayNamePlaceholder),
                                        type: "text",
                                        defaultValue: initialDisplayName,
                                        onChange: handleDisplayNameChange,
                                        isInvalid: !!displayNameError,
                                        autoFocus: !!email && !initialDisplayName
                                    })),
                                    !!displayNameError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $jjRCi.ErrorMessage), {
                                        children: displayNameError
                                    })
                                ]
                            })
                    }),
                    verifyNeeded && /*#__PURE__*/ (0, $6rcps.jsx)($a92f92426cd3dd34$var$VerificationWrapper, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $2iPY4.default), {
                            name: "code",
                            label: formatMessage((0, $9h4E7.default).codeLabel),
                            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $cT1nw.default), (0, $6EnDC._)((0, $ty6PY._)({}, fieldProps), {
                                            id: "code",
                                            placeholder: formatMessage((0, $9h4E7.default).codePlaceHolder),
                                            type: "text",
                                            onChange: handleCodeChange,
                                            isInvalid: !!codeError,
                                            "aria-describedby": codeError ? `${fieldProps.id}-error` : undefined,
                                            spellCheck: false,
                                            autoComplete: "off",
                                            maxLength: 16
                                        })),
                                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $jjRCi.MessageWrapper), {
                                            children: !!codeError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $jjRCi.ErrorMessage), {
                                                children: renderCodeError(codeError)
                                            })
                                        })
                                    ]
                                })
                        })
                    }),
                    createNeeded && /*#__PURE__*/ (0, $6rcps.jsxs)($a92f92426cd3dd34$var$ConsentAndLegalContainer, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $aywtZ.CreateAccountConfirmationMarketingConsent), {}),
                            /*#__PURE__*/ (0, $6rcps.jsx)($a92f92426cd3dd34$export$6b077d087ec15a10, {
                                children: privacyPolicy
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SCpc.CreateAccountConfirmationRecaptcha), {}),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                            appearance: "primary",
                            id: "login-submit",
                            type: "submit",
                            isFullWidth: true,
                            isLoading: isLoading,
                            onClick: onSubmitClick,
                            children: submitButtonText()
                        })
                    })
                ]
            })
        ]
    });
};
var $a92f92426cd3dd34$export$2e2bcd8739ae039 = $a92f92426cd3dd34$export$ca6de4c099a9b97d;

});
parcelRegister("9h4E7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75c67c209e5ec9a5$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $75c67c209e5ec9a5$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    displayNameEmpty: {
        id: 'confirmation.form.displayName.empty',
        defaultMessage: 'Please enter a name',
        description: ''
    },
    displayNamePlaceholder: {
        id: 'confirmation.form.displayName.placeholder',
        defaultMessage: 'Enter full name',
        description: ''
    },
    displayNameLabel: {
        id: 'confirmation.form.displayName.label',
        defaultMessage: 'Full name',
        description: ''
    },
    codePlaceHolder: {
        id: 'confirmation.form.code.placeholder',
        defaultMessage: 'Enter the code sent to your email',
        description: 'Placeholder for text input'
    },
    codeLabel: {
        id: 'confirmation.form.code.label',
        defaultMessage: 'Verification code',
        description: 'Label for text input'
    },
    emailLabel: {
        id: 'confirmation.form.emailaddress.label',
        defaultMessage: 'Email address',
        description: ''
    },
    hiddenEmailWarningTitle: {
        id: 'confirmation.form.hiddenemailwarning.title',
        defaultMessage: "You're hiding your real email",
        description: ''
    }
});

});

parcelRegister("aywtZ", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationMarketingConsent", function () { return $4f787f7e5974a90f$export$3340e585d36bf8e8; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $0nu8f = parcelRequire("0nu8f");

var $kdW7h = parcelRequire("kdW7h");

var $kOqgB = parcelRequire("kOqgB");

var $7k83O = parcelRequire("7k83O");
const $4f787f7e5974a90f$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $4f787f7e5974a90f$var$createAccountEmailSelector = (state)=>state.createAccount.email;
const $4f787f7e5974a90f$export$3340e585d36bf8e8 = ()=>{
    (0, $aavUY.useRegisterComponent)($4f787f7e5974a90f$export$3340e585d36bf8e8.name);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $0nu8f.useCreateAccountConfirmationPageContext)();
    const marketingConsentConfig = (0, $kOqgB.useAppSelector)($4f787f7e5974a90f$var$marketingConsentSelector);
    const email = (0, $kOqgB.useAppSelector)($4f787f7e5974a90f$var$createAccountEmailSelector);
    (0, $8ZuGG.useEffect)(()=>{
        if (email) dispatch((0, $7k83O.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $kdW7h.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});

parcelRegister("4W1sD", function(module, exports) {

$parcel$export(module.exports, "useCreateAccountConfirmation", function () { return $962b212e54bc00ff$export$e91af0855b7bcb2e; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $0nu8f = parcelRequire("0nu8f");
parcelRequire("4pCpP");
var $2tVDe = parcelRequire("2tVDe");

var $9h4E7 = parcelRequire("9h4E7");

var $iSD9t = parcelRequire("iSD9t");

var $g5vsn = parcelRequire("g5vsn");

var $61XRM = parcelRequire("61XRM");

var $kOqgB = parcelRequire("kOqgB");

var $jSO9M = parcelRequire("jSO9M");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $3ir1n = parcelRequire("3ir1n");

var $c2Ycs = parcelRequire("c2Ycs");

var $fT7xM = parcelRequire("fT7xM");

var $9NVnN = parcelRequire("9NVnN");
parcelRequire("f2IKy");
var $gsGhI = parcelRequire("gsGhI");
const $962b212e54bc00ff$export$e91af0855b7bcb2e = ({ onFailure: onFailure, onSubmit: onSubmit, autoRedirect: autoRedirect = true } = {
    autoRedirect: true
})=>{
    (0, $aavUY.useRegisterComponent)($962b212e54bc00ff$export$e91af0855b7bcb2e.name);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const pageState = (0, $2tVDe.useCreateAccountConfirmationPageState)();
    const { redirectTo: redirectTo, createNeeded: createNeeded, displayName: displayName, email: email, verifyNeeded: verifyNeeded, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, loginType: loginType } = pageState;
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $61XRM.useRecaptchaContext)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    // Prevent redirect if the autoRedirect flag is true
    // Used in cases where cobranding wants to redirect the user themselves.
    // NOTE: `autoRedirect` is deprecated, please do not use
    // @see: UseCreateAccountConfirmationHookProps['autoRedirect']
    (0, $gsGhI.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { marketingConsent: marketingConsent, privacyPolicyText: privacyPolicyText = '' } = (0, $0nu8f.useCreateAccountConfirmationPageContext)();
    const getEventAttributes = (0, $8ZuGG.useCallback)((verificationCodeEntered)=>{
        return {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded,
            verificationCodeEntered: verificationCodeEntered,
            formError: formError,
            recaptchaType: recaptchaType
        };
    }, [
        createNeeded,
        formError,
        loginType,
        recaptchaType,
        verifyNeeded
    ]);
    const onValidationErrorAnalytics = (0, $8ZuGG.useCallback)((errors, verificationCodeEntered)=>{
        if (errors.displayName) {
            const errorBooleanMap = Object.keys(errors).reduce((acc, val)=>(0, $6EnDC._)((0, $ty6PY._)({}, acc), {
                    [val + 'Error']: true
                }), {});
            analyticsClient.uiEvent({
                page: (0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID),
                action: 'shown',
                subject: 'error',
                subjectId: 'confirmCreateAccountIdpNoName',
                attributes: {
                    errors: errorBooleanMap
                }
            });
        }
        if (errors.code === 'empty_code') analyticsClient.errorShownEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'emptyCode', getEventAttributes(verificationCodeEntered));
        else if (errors.code === 'invalid_length') analyticsClient.errorShownEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'invalidCodeLength', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes
    ]);
    const onSubmitAnalytics = (0, $8ZuGG.useCallback)((verificationCodeEntered)=>{
        analyticsClient.checkboxChangedEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'marketingConsent', (0, $6EnDC._)((0, $ty6PY._)({}, getEventAttributes(verificationCodeEntered)), {
            status: marketingConsent === null || marketingConsent === void 0 ? void 0 : marketingConsent.state
        }));
        analyticsClient.formSubmittedEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'confirmCreateAccountIdp', getEventAttributes(verificationCodeEntered));
    }, [
        analyticsClient,
        getEventAttributes,
        marketingConsent === null || marketingConsent === void 0 ? void 0 : marketingConsent.state
    ]);
    const handleSubmit = (0, $8ZuGG.useCallback)((confirmationData)=>{
        navigate(location.pathname + location.search + location.hash);
        const challengeRequest = (0, $jSO9M.toChallengeRequest)(confirmationData.challengeResponse);
        const { loginType: loginType, hashedCsrfToken: hashedCsrfToken, confirmationToken: confirmationToken, mfaToken: mfaToken } = pageState;
        dispatch((0, $g5vsn.inHouseSocialConfirmation)((0, $6EnDC._)((0, $ty6PY._)({}, confirmationData), {
            privacyPolicyText: privacyPolicyText,
            hashedCsrfToken: hashedCsrfToken,
            mfaToken: mfaToken,
            confirmationToken: confirmationToken,
            loginType: loginType,
            challengeRequest: challengeRequest
        })));
    }, [
        navigate,
        pageState,
        dispatch,
        privacyPolicyText
    ]);
    const onCreateAccountConfirmation = (0, $8ZuGG.useCallback)(async ({ displayName: displayName, code: code })=>{
        const validationErrors = {};
        if (isLoading) return;
        if (createNeeded && (!displayName || displayName.trim() === '')) validationErrors.displayName = formatMessage((0, $9h4E7.default).displayNameEmpty); // TODO: do we want to create message codes here like in the OTP page?
        if (verifyNeeded) {
            if (!code || code.trim() === '') validationErrors.code = 'empty_code';
            else if (code.trim().length < 7) // Codes could be length 8 or 16, see HOT-94320 changes.
            // Condition of < 7 to allow for flexibility if further code length changes are needed.
            validationErrors.code = 'invalid_length';
        }
        const verificationCodeEntered = Boolean(code);
        if (Object.keys(validationErrors).length) {
            dispatch((0, $g5vsn.showFieldErrors)(validationErrors));
            onValidationErrorAnalytics(validationErrors, verificationCodeEntered);
            onFailure === null || onFailure === void 0 ? void 0 : onFailure(validationErrors);
            return;
        }
        const challengeResponse = await fetchToken();
        onSubmitAnalytics(verificationCodeEntered);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        if (createNeeded && verifyNeeded) handleSubmit({
            displayName: displayName,
            code: code,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else if (createNeeded) handleSubmit({
            displayName: displayName,
            marketingConsentState: marketingConsent,
            challengeResponse: challengeResponse
        });
        else handleSubmit({
            code: code,
            challengeResponse: challengeResponse
        });
    }, [
        isLoading,
        createNeeded,
        verifyNeeded,
        fetchToken,
        onSubmitAnalytics,
        onSubmit,
        formatMessage,
        dispatch,
        onValidationErrorAnalytics,
        onFailure,
        handleSubmit,
        marketingConsent
    ]);
    const canEditDisplayName = (0, $8ZuGG.useMemo)(()=>{
        return loginType === (0, $fT7xM.LoginType).Apple || loginType === (0, $fT7xM.LoginType).Slack || loginType === (0, $fT7xM.LoginType).Microsoft;
    }, [
        loginType
    ]);
    const formErrorWithMessage = (0, $8ZuGG.useMemo)(()=>{
        if (!formError) return;
        const message = $962b212e54bc00ff$var$errorMessageFromCode(formError, formatMessage);
        return {
            code: formError,
            message: message
        };
    }, [
        formError,
        formatMessage
    ]);
    return {
        createAccountNeeded: createNeeded,
        canEditDisplayName: canEditDisplayName,
        displayName: displayName,
        verifyEmailNeeded: verifyNeeded,
        onCreateAccountConfirmation: onCreateAccountConfirmation,
        email: email,
        fieldErrors: fieldErrors,
        formError: formErrorWithMessage,
        isLoading: isLoading,
        redirectTo: redirectTo
    };
};
const $962b212e54bc00ff$var$errorMessageFromCode = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'captcha_not_loaded':
        case 'captcha_failed':
            return formatMessage({
                id: 'confirmation.error.captcha.failed',
                defaultMessage: 'We are having trouble verifying ReCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support.'
            });
        case 'captchaScoreTooLow':
            return formatMessage({
                id: 'confirmation.error.captcha.score_too_low',
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: 'Message asking user to tick the reCAPTCHA checkbox and resubmit the form'
            });
        case 'request_error':
            return formatMessage({
                id: 'confirmation.error.offline',
                defaultMessage: 'We seem to have lost the connection. Check your network settings, then try again. '
            });
        default:
            return formatMessage({
                id: 'confirmation.error.unknown',
                defaultMessage: 'Something went wrong while trying to create your account. Wait a few moments, then try again.'
            });
    }
};

});
parcelRegister("g5vsn", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $39e887e657211f00$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "inHouseSocialConfirmation", function () { return $39e887e657211f00$export$fc20e580ac82d1bc; });
$parcel$export(module.exports, "resendInHouseVerificationCode", function () { return $39e887e657211f00$export$1b8c49d1a252ff84; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $bjLjm = parcelRequire("bjLjm");

var $8FHU2 = parcelRequire("8FHU2");

var $jSnDV = parcelRequire("jSnDV");
const $39e887e657211f00$export$aad8462122ac592b = ()=>({
        type: 'CONFIRMATION_RESET'
    });
const $39e887e657211f00$export$ff19f4caed0eaf31 = ()=>({
        type: 'CONFIRMATION_REQUEST'
    });
const $39e887e657211f00$export$1cb045489d712953 = (redirectTo)=>({
        type: 'CONFIRMATION_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $39e887e657211f00$export$bf1ddd88318577cc = (error)=>({
        type: 'CONFIRMATION_REQUEST_FAILED',
        error: error
    });
const $39e887e657211f00$export$bd2309d55d5d70da = (backendState)=>({
        type: 'CONFIRMATION_STATE_UPDATE',
        backendState: backendState
    });
const $39e887e657211f00$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'CONFIRMATION_SHOW_FIELD_ERROR',
        errors: errors
    });
const $39e887e657211f00$export$4b98afed05a66101 = (mfaToken)=>({
        type: 'CONFIRMATION_RESEND_SUCCESS',
        mfaToken: mfaToken
    });
const $39e887e657211f00$var$buildBaseConfirmationJsonPayload = (confirmationParams, state)=>{
    const { source: source, displayName: displayName, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText } = confirmationParams;
    const payload = {
        fullName: displayName,
        source: source,
        atlassianAccountCreationConfirmed: true
    };
    if (marketingConsentState) {
        const marketingConsent = (0, $bjLjm.buildMarketingConsent)(state.marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload.marketingConsent = marketingConsent;
    }
    return payload;
};
const $39e887e657211f00$export$fc20e580ac82d1bc = (confirmationParams)=>async (dispatch, getState)=>{
        const { loginType: loginType, confirmationToken: confirmationToken, mfaToken: mfaToken, hashedCsrfToken: hashedCsrfToken, code: code, challengeRequest: challengeRequest } = confirmationParams;
        dispatch($39e887e657211f00$export$ff19f4caed0eaf31());
        try {
            var _response_createAccount, _response_createAccount1;
            const payload = (0, $6EnDC._)((0, $ty6PY._)({}, $39e887e657211f00$var$buildBaseConfirmationJsonPayload(confirmationParams, getState())), {
                challengeResponse: challengeRequest,
                loginType: loginType,
                csrfToken: hashedCsrfToken,
                confirmationToken: confirmationToken,
                mfaToken: mfaToken,
                code: code
            });
            const csrfToken = getState().csrfToken;
            const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
            const ENDPOINT_PATH = '/rest/login/social/confirmation';
            // These are used by SIS to redirect the user to the correct place.
            // In the "old" implementation (i.e. `submitFormHack`)
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify((0, $ty6PY._)({}, params.continue ? {
                continue: params.continue
            } : {}, params.application ? {
                application: params.application
            } : {}));
            // Only include the query parameters if any exist on the url
            const qs = queryParams.length > 0 ? `?${queryParams}` : '';
            const action = `${ENDPOINT_PATH}${qs}`;
            const res = await (0, $8FHU2.submitFormHackReplacement)({
                method: 'POST',
                action: action,
                payload: payload,
                csrfToken: csrfToken,
                enablePassingCookies: true
            });
            const response = await res.json();
            const hasCreateAccountSpecificState = !!response.createAccount;
            // We have state from the backend, which we want to ensure is updated in the FE state.
            if (hasCreateAccountSpecificState) {
                // Want to make sure that it's the shape that we expect before updating the state
                const isCreateAccountObject = typeof response.createAccount === 'object' && !Array.isArray(response.createAccount);
                dispatch($39e887e657211f00$export$bd2309d55d5d70da(isCreateAccountObject ? response.createAccount : {}));
            }
            const hasError = !!(response === null || response === void 0 ? void 0 : (_response_createAccount = response.createAccount) === null || _response_createAccount === void 0 ? void 0 : _response_createAccount.formError);
            if (hasError) {
                dispatch($39e887e657211f00$export$bf1ddd88318577cc(response.createAccount.formError));
                return;
            }
            // This indicates the backend is not behaving as expected
            // since even in error cases, we expect the backend endpoint to return a 200
            if (!res.ok) {
                dispatch($39e887e657211f00$export$bf1ddd88318577cc('unknown'));
                return;
            }
            // The types on the FE define the response to always be under `createAccount` for this endpoint
            // but in practice the BE returns in some cases (i.e. success) in a different format
            // so we want to handle that
            const redirectTo = (response === null || response === void 0 ? void 0 : (_response_createAccount1 = response.createAccount) === null || _response_createAccount1 === void 0 ? void 0 : _response_createAccount1.redirectTo) || (response === null || response === void 0 ? void 0 : response.redirectTo);
            const hasRedirect = !!redirectTo;
            if (!hasRedirect) {
                // If we don't get a redirect URL from the BE _and_ we haven't been able to understand the error
                // we don't know where to send the user and there aren't enough details of the error (or they aren't in the expected format) so we are assuming the request failed.
                dispatch($39e887e657211f00$export$bf1ddd88318577cc('unknown'));
                return;
            }
            dispatch($39e887e657211f00$export$1cb045489d712953(redirectTo));
        } catch (error) {
            dispatch($39e887e657211f00$export$bf1ddd88318577cc('unknown'));
        }
    };
const $39e887e657211f00$export$1b8c49d1a252ff84 = (mfaToken)=>(dispatch, getState)=>{
        const { csrfToken: csrfToken } = getState();
        return fetch(`/rest/mfa/resend?transactionToken=${mfaToken}`, {
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).then((res)=>{
            if (res.ok) return res.json().then((json)=>{
                dispatch($39e887e657211f00$export$4b98afed05a66101(json.transactionToken));
            });
            else return Promise.reject(new Error(`Failed to resend MFA code: ${res.status} ${res.statusText}`));
        });
    };

});


parcelRegister("1SCpc", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptcha", function () { return $2e81b6378a33685c$export$4803e5c20b611abd; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $61XRM = parcelRequire("61XRM");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $5AH6G = parcelRequire("5AH6G");
const $2e81b6378a33685c$export$4803e5c20b611abd = ()=>{
    (0, $aavUY.useRegisterComponent)($2e81b6378a33685c$export$4803e5c20b611abd.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $61XRM.useRecaptchaContext)();
    // TODO: confirm if server can tell this page to skip recaptcha by including a boolean flag in
    // the state, as it can for other pages (like Welcome)
    const shouldShow = recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5AH6G.CreateAccountConfirmationRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("5AH6G", function(module, exports) {

$parcel$export(module.exports, "CreateAccountConfirmationRecaptchaContainer", function () { return $356f95560cd8a399$export$35fe2d48d1cfa8a6; });

var $9Vz68 = parcelRequire("9Vz68");

var $f19CI = parcelRequire("f19CI");
let $356f95560cd8a399$var$_ = (t)=>t, $356f95560cd8a399$var$t;
const $356f95560cd8a399$export$35fe2d48d1cfa8a6 = (0, $9Vz68.default)((0, $f19CI.default))($356f95560cd8a399$var$t || ($356f95560cd8a399$var$t = $356f95560cd8a399$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});



parcelRegister("dsiq9", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $07b624984ce58c20$export$8b251419efc915eb; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
const $07b624984ce58c20$export$8b251419efc915eb = ({ createNeeded: createNeeded })=>{
    if (createNeeded) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "account.creation.confirmation.title",
        defaultMessage: "Create your account",
        description: "Title of form for creating an account",
        tagName: "h5"
    });
    else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "account.verification.title",
        defaultMessage: "Verify your email",
        description: "Title of form for verifying an account",
        tagName: "h5"
    });
};

});

parcelRegister("3V1om", function(module, exports) {

$parcel$export(module.exports, "TitleText", function () { return $c9a889daafecbfdc$export$5c707c04c5c45fff; });
$parcel$export(module.exports, "LoginLinkWrapper", function () { return $c9a889daafecbfdc$export$daf565b81da2dd58; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $c9a889daafecbfdc$var$_ = (t)=>t, $c9a889daafecbfdc$var$t, $c9a889daafecbfdc$var$t1;
const $c9a889daafecbfdc$export$5c707c04c5c45fff = (0, $9Vz68.default).div($c9a889daafecbfdc$var$t || ($c9a889daafecbfdc$var$t = $c9a889daafecbfdc$var$_`
  margin-top: ${0}px;
  margin-bottom: 16px;
`), (0, $5b7Z4.gridSize)());
const $c9a889daafecbfdc$export$daf565b81da2dd58 = (0, $9Vz68.default).div($c9a889daafecbfdc$var$t1 || ($c9a889daafecbfdc$var$t1 = $c9a889daafecbfdc$var$_`
  margin-top: ${0};
`), ({ addTopMargin: addTopMargin })=>addTopMargin ? `${(0, $5b7Z4.gridSize)()}px` : 'initial');

});

parcelRegister("iggIg", function(module, exports) {

$parcel$export(module.exports, "WhiteboxFooter", function () { return $4e1228665b877199$export$bad5896fb5d45c0b; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gyRZh = parcelRequire("gyRZh");

var $gGDrC = parcelRequire("gGDrC");

var $jSnDV = parcelRequire("jSnDV");

var $8dHAc = parcelRequire("8dHAc");

var $day6I = parcelRequire("day6I");

var $3ir1n = parcelRequire("3ir1n");

var $elWwF = parcelRequire("elWwF");

var $c2Ycs = parcelRequire("c2Ycs");

var $3V1om = parcelRequire("3V1om");

var $9OvaU = parcelRequire("9OvaU");
const $4e1228665b877199$export$bad5896fb5d45c0b = ({ loginType: loginType, createNeeded: createNeeded, isEmbedded: isEmbedded, oidcContext: oidcContext, verifyNeeded: verifyNeeded })=>{
    const showLoginLink = createNeeded && !isEmbedded && !(0, $day6I.isOidcDisplayMode)(oidcContext, (0, $8dHAc.OidcDisplay).Signup);
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const handleOnLoginLinkClick = (0, $8ZuGG.useCallback)(async ()=>{
        const eventAttributes = {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        };
        await analyticsClient.linkClickedEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'alreadyHaveAccountCreateAccountIdp', eventAttributes);
    }, [
        loginType,
        createNeeded,
        verifyNeeded,
        analyticsClient
    ]);
    const { resendVerificationCode: resendVerificationCode } = (0, $elWwF.useRetryAccountCreation)();
    const stripAuth0StateToken = (0, $8ZuGG.useCallback)((search)=>{
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(search);
        delete params.state;
        return Object.keys(params).length ? '?' + (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(params) : '';
    }, []);
    // TODO: encapsulate in our hook, to ensure the auth0 state token is stripped?
    const loginLink = '/login' + stripAuth0StateToken(location.search);
    if (showLoginLink || verifyNeeded) return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            verifyNeeded && /*#__PURE__*/ (0, $6rcps.jsx)("ul", {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
                        id: "didnt-get-an-email-start-again",
                        spacing: "none",
                        className: "link-color-override",
                        onClick: resendVerificationCode,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                            id: "accountcreationconfirmation.resend.verification.code",
                            defaultMessage: "Resend verification code",
                            description: "Link button to resend the verification code if the user did not receive an email"
                        })
                    })
                })
            }),
            showLoginLink && /*#__PURE__*/ (0, $6rcps.jsx)((0, $3V1om.LoginLinkWrapper), {
                addTopMargin: verifyNeeded,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), {
                    id: "already-have-an-account",
                    to: loginLink,
                    onClick: handleOnLoginLinkClick,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "accountcreationconfirmation.already.have.account.log.in",
                        defaultMessage: "Already have an Atlassian account? Log in"
                    })
                })
            })
        ]
    });
    return null;
};

});
parcelRegister("elWwF", function(module, exports) {

$parcel$export(module.exports, "useRetryAccountCreation", function () { return $87fc02e8d067230b$export$1afab6e7aab1dd93; });

var $8ZuGG = parcelRequire("8ZuGG");

var $g5vsn = parcelRequire("g5vsn");

var $3ir1n = parcelRequire("3ir1n");

var $xe7jL = parcelRequire("xe7jL");

var $8f2pb = parcelRequire("8f2pb");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("4pCpP");
var $2tVDe = parcelRequire("2tVDe");

var $i7mHb = parcelRequire("i7mHb");

var $c2Ycs = parcelRequire("c2Ycs");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $87fc02e8d067230b$export$1afab6e7aab1dd93 = ()=>{
    (0, $aavUY.useRegisterComponent)($87fc02e8d067230b$export$1afab6e7aab1dd93.name);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const pageState = (0, $2tVDe.useCreateAccountConfirmationPageState)();
    const { createNeeded: createNeeded, verifyNeeded: verifyNeeded, loginType: loginType } = pageState;
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const dispatchAddFlag = (0, $8ZuGG.useCallback)((flag)=>dispatch((0, $xe7jL.addFlag)(flag.type, flag.title, flag.description)), [
        dispatch
    ]);
    const resendVerificationCode = async ()=>{
        analyticsClient.linkClickedEvent((0, $c2Ycs.CREATE_ACCOUNT_CONFIRMATION_PAGE_ID), 'startAgainCreateAccountIdp', {
            loginType: loginType,
            confirmationCreateAccountNeeded: createNeeded,
            confirmationVerifyEmailNeeded: verifyNeeded
        });
        const { mfaToken: mfaToken } = pageState;
        if (!mfaToken) {
            (0, $8f2pb.captureErrorMessage)('MFA token missing');
            return;
        }
        await dispatch((0, $g5vsn.resendInHouseVerificationCode)(mfaToken));
        dispatchAddFlag({
            type: 'success',
            title: (0, $i7mHb.default).resendVerificationCodeSuccessTitle,
            description: (0, $i7mHb.default).resendVerificationCodeSuccessDesc
        });
    };
    return {
        resendVerificationCode: resendVerificationCode
    };
};

});
parcelRegister("i7mHb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86ee1376d10f9eb6$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $86ee1376d10f9eb6$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    resendVerificationCodeSuccessTitle: {
        id: 'account.creation.confirmation.email.sent.title',
        defaultMessage: 'Email sent'
    },
    resendVerificationCodeSuccessDesc: {
        id: 'account.creation.confirmation.email.sent.desc',
        defaultMessage: 'We sent you another verification code'
    },
    resendVerificationCodeFailureTitle: {
        id: 'account.creation.confirmation.email.error.title',
        defaultMessage: 'Error'
    },
    resendVerificationCodeFailureDesc: {
        id: 'account.creation.confirmation.email.error.body',
        defaultMessage: "We couldn\u2019t send the verification code. Please try again."
    }
});

});



parcelRegister("6TFzg", function(module, exports) {

$parcel$export(module.exports, "ConfirmationFormTitleText", function () { return $27cb0d4171023bda$export$4306c5e98031f4d1; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $fT7xM = parcelRequire("fT7xM");
const $27cb0d4171023bda$export$4306c5e98031f4d1 = ({ loginType: loginType, createNeeded: createNeeded })=>{
    switch(loginType){
        case (0, $fT7xM.LoginType).GoogleButton:
        case (0, $fT7xM.LoginType).GoogleOneTap:
            if (createNeeded) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.creation.confirmation.explanation.google",
                defaultMessage: "We'll use your details from Google to create an account:"
            });
            else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.verification.confirmation.explanation.google",
                defaultMessage: "To keep your account secure, please verify your login."
            });
        case (0, $fT7xM.LoginType).Apple:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.creation.confirmation.explanation.apple",
                defaultMessage: "We'll use your details from Apple to create an account:"
            });
        case (0, $fT7xM.LoginType).Slack:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.creation.confirmation.explanation.slack",
                defaultMessage: "We'll use your details from Slack to create an account for:",
                description: "Message shown to the user when they're creating an account using their Slack credentials"
            });
        case (0, $fT7xM.LoginType).Microsoft:
            if (createNeeded) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.creation.confirmation.explanation.microsoft",
                defaultMessage: "We'll use your details from Microsoft to create an account:"
            });
            else return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.verification.confirmation.explanation.microsoft",
                defaultMessage: "We were unable to verify the email associated with your Microsoft account, so let's do that now."
            });
        case (0, $fT7xM.LoginType).SSO:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "account.creation.confirmation.explanation.sso",
                defaultMessage: "We'll use the details from your single sign-on provider to create an account. Contact your administrator if you want to change them."
            });
        default:
            return null;
    }
};

});


parcelRegister("aPeXX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "signupVerifyEmailOtpLoader", function () { return $bb921decaf471d3b$export$ee12460ca2fbd2d1; });
$parcel$export(module.exports, "VerifyEmailOtpPage", function () { return $bb921decaf471d3b$export$a16cb21d1f9bc820; });
$parcel$export(module.exports, "default", function () { return $bb921decaf471d3b$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");
parcelRequire("fvCYX");
var $cmpXW = parcelRequire("cmpXW");
var $6Fvwc = parcelRequire("6Fvwc");
var $P7UWS = parcelRequire("P7UWS");

var $cufV0 = parcelRequire("cufV0");

var $bbINW = parcelRequire("bbINW");

var $9ZfZq = parcelRequire("9ZfZq");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
const $bb921decaf471d3b$var$verifyEmailOtpErrorCodeMapping = {
    invalid_otp: 'invalid_otp',
    invalid_otp_length: 'invalid_otp_length',
    invalid_token: 'invalid_token',
    expired_token: 'expired_token',
    rate_limit_exceeded: 'rate_limited',
    internal_server_error: 'unexpected_error',
    unexpected_error: 'unexpected_error',
    'Too many requests. Please inspect Retry-After header.': 'rate_limited'
};
async function $bb921decaf471d3b$export$ee12460ca2fbd2d1({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/signup/verify-email/otp/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--verify-email'
        ]
    });
}
const $bb921decaf471d3b$export$a16cb21d1f9bc820 = ()=>{
    const { onVerifyEmailOtp: onVerifyEmailOtp, onInvalidEmailOtpLength: onInvalidEmailOtpLength, isLoading: isLoading, error: error } = (0, $P7UWS.useVerifyEmailOtp)();
    const { onResendEmailOtp: onResendEmailOtp } = (0, $cmpXW.useResendEmailOtp)();
    const { state: state, isLoading: isStateLoading, error: pageStateError } = (0, $6Fvwc.useSignupVerifyEmailOtpState)();
    if (isStateLoading) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
        label: "Signup verify email OTP page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { email: email } = state;
    const verifyEmailOtpErrorCode = !(error === null || error === void 0 ? void 0 : error.errorCode) ? undefined : $bb921decaf471d3b$var$verifyEmailOtpErrorCodeMapping[error === null || error === void 0 ? void 0 : error.errorCode] || 'unexpected_error';
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $bbINW.VerifyEmailOtp), {
        pageId: (0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID),
        flow: "sign-up",
        email: email,
        isLoading: isLoading,
        errorCode: verifyEmailOtpErrorCode,
        onVerifyEmailOtp: onVerifyEmailOtp,
        onResendEmailOtp: onResendEmailOtp,
        onInvalidEmailOtpLength: onInvalidEmailOtpLength
    });
};
var $bb921decaf471d3b$export$2e2bcd8739ae039 = $bb921decaf471d3b$export$a16cb21d1f9bc820;

});
parcelRegister("fvCYX", function(module, exports) {
$parcel$export(module.exports, "useVerifyEmailOtp", function () { return (parcelRequire("P7UWS")).useVerifyEmailOtp; });
$parcel$export(module.exports, "useResendEmailOtp", function () { return (parcelRequire("cmpXW")).useResendEmailOtp; });
$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return (parcelRequire("6Fvwc")).useSignupVerifyEmailOtpState; });
parcelRequire("P7UWS");
parcelRequire("cmpXW");
parcelRequire("6Fvwc");

});
parcelRegister("P7UWS", function(module, exports) {

$parcel$export(module.exports, "useVerifyEmailOtp", function () { return $52da65012ccf9012$export$dbb09362ea05a8a7; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $3ir1n = parcelRequire("3ir1n");

var $aYPRN = parcelRequire("aYPRN");

var $iSD9t = parcelRequire("iSD9t");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $8Ji6M = parcelRequire("8Ji6M");

var $9ZfZq = parcelRequire("9ZfZq");

var $9NVnN = parcelRequire("9NVnN");
const $52da65012ccf9012$var$verifyEmailOtpSelectorFn = (state)=>state.verifyEmailOtp;
const $52da65012ccf9012$export$dbb09362ea05a8a7 = ({ onSubmit: onSubmit, onFailure: onFailure, onSuccess: onSuccess, autoRedirect: autoRedirect = true } = {})=>{
    (0, $aavUY.useRegisterComponent)($52da65012ccf9012$export$dbb09362ea05a8a7.name);
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const { redirectType: redirectType, error: errorCode, isLoading: isLoading, redirectTo: redirectTo } = (0, $kOqgB.useAppSelector)($52da65012ccf9012$var$verifyEmailOtpSelectorFn);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    (0, $8ZuGG.useEffect)(()=>{
        if (redirectTo && autoRedirect) navigate(redirectTo);
    }, [
        autoRedirect,
        redirectTo,
        navigate
    ]);
    const trackSubmitEmailOtp = (0, $3ir1n.useFormSubmittedEvent)((0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const trackSubmissionFailure = (0, $3ir1n.useFormSubmittedEvent)((0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID), 'verifyEmailOtp', {
        signupType: redirectType,
        result: 'invalid_otp_length'
    });
    const onVerifyEmailOtp = (0, $8ZuGG.useCallback)((otp)=>{
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        if (otp.length !== (0, $8Ji6M.OTP_CODE_FULL_LENGTH)) {
            const error = 'invalid_otp_length';
            onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            trackSubmissionFailure();
            dispatch((0, $aYPRN.verifyEmailOtpFailure)(error));
        } else {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            trackSubmitEmailOtp();
            dispatch((0, $aYPRN.verifyEmailOtp)(otp, (0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient));
        }
    }, [
        analyticsClient,
        dispatch,
        onFailure,
        onSubmit,
        onSuccess,
        trackSubmissionFailure,
        trackSubmitEmailOtp
    ]);
    const error = (0, $8ZuGG.useMemo)(()=>errorCode ? {
            errorCode: errorCode,
            errorMessage: $52da65012ccf9012$var$otpErrorMessage(errorCode, formatMessage)
        } : undefined, [
        errorCode,
        formatMessage
    ]);
    return {
        onVerifyEmailOtp: onVerifyEmailOtp,
        onInvalidEmailOtpLength: trackSubmissionFailure,
        redirectTo: redirectTo,
        error: error,
        isLoading: isLoading
    };
};
const $52da65012ccf9012$var$otpErrorMessage = (errorCode, formatMessage)=>{
    switch(errorCode){
        case 'invalid_otp_length':
            return formatMessage({
                id: 'validate.email.otp.error.otp_length',
                defaultMessage: 'Complete the verification code'
            });
        case 'invalid_otp':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_otp',
                defaultMessage: 'Provided verification code is invalid'
            });
        case 'invalid_token':
            return formatMessage({
                id: 'validate.email.otp.error.invalid_token',
                defaultMessage: 'Invalid token'
            });
        case 'expired_token':
            return formatMessage({
                id: 'validate.email.otp.error.expired_token',
                defaultMessage: 'Token expired'
            });
        case 'internal_server_error':
            return formatMessage({
                id: 'validate.email.otp.error.internal_server_error',
                defaultMessage: 'Internal server error'
            });
        case 'rate_limit_exceeded':
        case 'Too many requests. Please inspect Retry-After header.':
            return formatMessage({
                id: 'validate.email.otp.error.rate_limit_exceeded',
                defaultMessage: 'Rate limit exceeded. Try again in a couple of minutes.'
            });
        case 'unexpected_error':
        default:
            return formatMessage({
                id: 'validate.email.otp.error.unexpected_error',
                defaultMessage: 'Unexpected error'
            });
    }
};

});
parcelRegister("aYPRN", function(module, exports) {

$parcel$export(module.exports, "verifyEmailOtpFailure", function () { return $3054cd68edf11c99$export$3871df646f7b1bd; });
$parcel$export(module.exports, "verifyEmailOtpSetState", function () { return $3054cd68edf11c99$export$993f69d6007872a4; });
$parcel$export(module.exports, "verifyEmailOtp", function () { return $3054cd68edf11c99$export$f73803bb4b67b64c; });
$parcel$export(module.exports, "resendEmailOtp", function () { return $3054cd68edf11c99$export$7738159be2c9b2bf; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");

var $xe7jL = parcelRequire("xe7jL");

var $3VrrU = parcelRequire("3VrrU");

var $kZj5j = parcelRequire("kZj5j");

var $8f2pb = parcelRequire("8f2pb");
const $3054cd68edf11c99$export$43047bab95c658dd = (redirectTo)=>({
        type: 'VERIFY_EMAIL_OTP_SUCCESS',
        redirectTo: redirectTo
    });
const $3054cd68edf11c99$export$3871df646f7b1bd = (error)=>({
        type: 'VERIFY_EMAIL_OTP_FAILURE',
        error: error
    });
const $3054cd68edf11c99$export$840a1b6b804c3952 = ()=>({
        type: 'VERIFY_EMAIL_OTP_REQUEST'
    });
const $3054cd68edf11c99$export$993f69d6007872a4 = (state)=>({
        type: 'VERIFY_EMAIL_OTP_SET_STATE',
        state: state
    });
const $3054cd68edf11c99$export$f73803bb4b67b64c = (otp, pageId, analyticsClient)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $jSnDV.parse(window.location.search);
        const params = (0, $kZj5j.cobrandingURLParams)(window.location, productHint);
        const payload = {
            otpCode: otp,
            token: token
        };
        dispatch($3054cd68edf11c99$export$840a1b6b804c3952());
        return fetch('/rest/signup/verify-email/otp', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (token) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    const redirectToUrl = new URLSearchParams((0, $ty6PY._)({
                        token: token
                    }, params));
                    const redirectTo = `/signup/welcome?${redirectToUrl.toString()}`;
                    dispatch($3054cd68edf11c99$export$43047bab95c658dd(redirectTo));
                } else {
                    const result = error || 'internal_server_error';
                    dispatch($3054cd68edf11c99$export$3871df646f7b1bd(result));
                    (0, $8f2pb.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'otp_submission'
                        }
                    });
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'submitted',
                        subject: 'otp_submission',
                        attributes: {
                            result: result,
                            signupType: redirectType
                        }
                    });
                }
            })).catch((err)=>{
            dispatch($3054cd68edf11c99$export$3871df646f7b1bd('unexpected_error'));
            (0, $8f2pb.captureTaggedException)(err, {
                capabilities: [
                    'capability-group--signup',
                    'capability-name--verify-email'
                ],
                tags: {
                    otp: 'otp_submission'
                }
            });
            analyticsClient.trackingEvent({
                page: pageId,
                action: 'submitted',
                subject: 'otp_submission',
                attributes: {
                    result: 'unexpected_error',
                    signupType: redirectType
                }
            });
        });
    };
const $3054cd68edf11c99$export$7738159be2c9b2bf = (pageId, analyticsClient, navigate)=>async (dispatch, getState)=>{
        const { csrfToken: csrfToken, cobranding: { productHint: productHint }, verifyEmailOtp: { redirectType: redirectType } } = getState();
        const { token: token } = $jSnDV.parse(window.location.search);
        const params = (0, $kZj5j.cobrandingURLParams)(window.location, productHint);
        const loginRedirectWithError = (error)=>{
            // @ts-expect-error URLSearchParams types aren't up to date
            const url = new URLSearchParams((0, $6EnDC._)((0, $ty6PY._)({}, params), {
                errorCode: error,
                prompt: true
            }));
            return url.toString();
        };
        const payload = {
            token: token
        };
        return fetch('/rest/signup/verify-email/otp/resend', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json().then(({ error: error, token: token })=>{
                if (response.status === 200) {
                    const urlWithNewToken = new URLSearchParams((0, $ty6PY._)({
                        token: token
                    }, params));
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: 'success',
                            signupType: redirectType
                        }
                    });
                    dispatch((0, $xe7jL.addFlag)('success', $3054cd68edf11c99$export$ca00cef23f46407b.resendEmailOtpSuccessTitle, $3054cd68edf11c99$export$ca00cef23f46407b.resendEmailOtpSuccessBody));
                    return window.history.replaceState(window.history.state, '', `/signup/verify-email/otp?${urlWithNewToken.toString()}`);
                }
                if (response.status === 400) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    (0, $8f2pb.captureTaggedException)(error, {
                        capabilities: [
                            'capability-group--signup',
                            'capability-name--verify-email'
                        ],
                        tags: {
                            otp: 'resend_otp'
                        }
                    });
                    if (error === 'expired_token') return navigate(`/login?${loginRedirectWithError('verify.email.expired')}`);
                    else return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
                }
                if (response.status === 429) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: 'link clicked',
                        subject: 'resend_otp',
                        attributes: {
                            result: error,
                            signupType: redirectType
                        }
                    });
                    return dispatch((0, $xe7jL.addFlag)('error', $3054cd68edf11c99$export$ca00cef23f46407b.emailSentFailFlagTitle, $3054cd68edf11c99$export$ca00cef23f46407b.emailSentFailFlagBody));
                }
            }).catch((err)=>{
                analyticsClient.trackingEvent({
                    page: pageId,
                    action: 'link clicked',
                    subject: 'resend_otp',
                    attributes: {
                        result: 'unexpected_error',
                        signupType: redirectType
                    }
                });
                (0, $8f2pb.captureTaggedException)(err, {
                    capabilities: [
                        'capability-group--signup',
                        'capability-name--verify-email'
                    ],
                    tags: {
                        otp: 'resend_otp'
                    }
                });
                return navigate(`/login?${loginRedirectWithError('verify.email.error')}`);
            }));
    };
const $3054cd68edf11c99$export$ca00cef23f46407b = (0, $3VrrU.defineMessages)({
    emailSentFailFlagTitle: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.title',
        description: 'Title of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Too many attempts.'
    },
    emailSentFailFlagBody: {
        id: 'signup.verify-email.otp.resend.rate.limit.exceeded.body',
        description: 'Body of flag to show that the request for a new one time code failed due to a rate limit error',
        defaultMessage: 'Try again later.'
    },
    resendEmailOtpSuccessTitle: {
        id: 'signup.verify-email.otp.resend.success.title',
        description: 'Title of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Email sent with new code'
    },
    resendEmailOtpSuccessBody: {
        id: 'signup.verify-email.otp.resend.success.body',
        description: 'Body of flag to show that the request for a new one time code was successful',
        defaultMessage: 'Please check your inbox.'
    }
});

});

parcelRegister("9ZfZq", function(module, exports) {

$parcel$export(module.exports, "VERIFY_EMAIL_OTP_PAGE_ID", function () { return $c60b768cebaee52e$export$7a9d926185563d77; });
const $c60b768cebaee52e$export$7a9d926185563d77 = 'emailOtpScreen';

});


parcelRegister("cmpXW", function(module, exports) {

$parcel$export(module.exports, "useResendEmailOtp", function () { return $eac78d0a37d2eb9c$export$43b5c30416b6c2b8; });

var $8ZuGG = parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $9ZfZq = parcelRequire("9ZfZq");

var $kOqgB = parcelRequire("kOqgB");

var $aYPRN = parcelRequire("aYPRN");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $9NVnN = parcelRequire("9NVnN");
const $eac78d0a37d2eb9c$export$43b5c30416b6c2b8 = ({ onResend: onResend } = {})=>{
    (0, $aavUY.useRegisterComponent)($eac78d0a37d2eb9c$export$43b5c30416b6c2b8.name);
    const { redirectType: redirectType } = (0, $kOqgB.useAppSelector)((state)=>state.verifyEmailOtp);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const trackResendEmailOtp = (0, $3ir1n.useLinkClickedEvent)((0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID), 'resentEmailOtp', {
        signupType: redirectType,
        source: 'emailOtpScreen'
    });
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const onResendEmailOtp = (0, $8ZuGG.useCallback)(()=>{
        onResend === null || onResend === void 0 ? void 0 : onResend();
        trackResendEmailOtp();
        dispatch((0, $aYPRN.resendEmailOtp)((0, $9ZfZq.VERIFY_EMAIL_OTP_PAGE_ID), analyticsClient, navigate));
    }, [
        onResend,
        trackResendEmailOtp,
        dispatch,
        analyticsClient,
        navigate
    ]);
    return {
        onResendEmailOtp: onResendEmailOtp
    };
};

});

parcelRegister("6Fvwc", function(module, exports) {

$parcel$export(module.exports, "useSignupVerifyEmailOtpState", function () { return $57a89dd555d623aa$export$2a002f6397be0f3; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");

var $jtt5y = parcelRequire("jtt5y");

var $1uBrV = parcelRequire("1uBrV");

var $aYPRN = parcelRequire("aYPRN");

var $9NVnN = parcelRequire("9NVnN");
const $57a89dd555d623aa$var$usePreloadedState = ()=>{
    const { email: email } = (0, $kOqgB.useAppSelector)((state)=>state.verifyEmailOtp);
    return {
        email: email
    };
};
const $57a89dd555d623aa$export$2a002f6397be0f3 = ()=>{
    const noServerState = (0, $1uBrV.isSasStateEndpointEnabled)() && (0, $jtt5y.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $1uBrV.usePageState)('/signup/verify-email/otp/state', {
        enabled: noServerState
    });
    (0, $8ZuGG.useEffect)(()=>{
        if ((0, $1uBrV.isPageStateResult)(stateFromApi)) dispatch((0, $aYPRN.verifyEmailOtpSetState)(stateFromApi));
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $57a89dd555d623aa$var$usePreloadedState();
    if ((0, $1uBrV.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: stateFromApi,
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});



parcelRegister("9kNno", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "welcomeLoader", function () { return $6ecb3ab34eb545cc$export$eaf9dac678ad1491; });
$parcel$export(module.exports, "WelcomePage", function () { return $6ecb3ab34eb545cc$export$630ad10f0e1a953d; });
$parcel$export(module.exports, "default", function () { return $6ecb3ab34eb545cc$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");

var $3o9o3 = parcelRequire("3o9o3");

var $8dHAc = parcelRequire("8dHAc");

var $l1nfA = parcelRequire("l1nfA");

var $7CMue = parcelRequire("7CMue");

var $hmxfg = parcelRequire("hmxfg");
parcelRequire("fblTd");
var $jiicU = parcelRequire("jiicU");
var $aZBDq = parcelRequire("aZBDq");
var $7V7Ns = parcelRequire("7V7Ns");
var $lV2Te = parcelRequire("lV2Te");

var $pegyt = parcelRequire("pegyt");
parcelRequire("fmCfK");
var $6KAi4 = parcelRequire("6KAi4");
parcelRequire("gUzPq");
var $fjFtg = parcelRequire("fjFtg");
var $dm4jh = parcelRequire("dm4jh");
var $jQMDT = parcelRequire("jQMDT");

var $j33qQ = parcelRequire("j33qQ");

var $3ir1n = parcelRequire("3ir1n");

var $cufV0 = parcelRequire("cufV0");

var $8xW40 = parcelRequire("8xW40");

var $gjw2g = parcelRequire("gjw2g");

var $gV6nD = parcelRequire("gV6nD");
async function $6ecb3ab34eb545cc$export$eaf9dac678ad1491({ request: request }) {
    if (!await (0, $gV6nD.checkFeatureGateOnceInitialized)((0, $gjw2g.AidFrontendFeatureGate).USE_STATE_DATA_LOADERS)) return null;
    return await (0, $8xW40.fetchPageState)('/rest/signup/welcome/state', request, {
        capabilities: [
            'capability-group--signup',
            'capability-name--signup'
        ]
    });
}
const $6ecb3ab34eb545cc$export$630ad10f0e1a953d = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const { state: state, isLoading: isStateLoading, error: pageStateError } = (0, $dm4jh.useWelcomeState)();
    const { isEmbedded: isEmbedded, displayName: displayName, error: error } = state || {};
    const { onWelcomeSubmit: onWelcomeSubmit } = (0, $jQMDT.useWelcomeSubmission)();
    const onWelcomeClick = (0, $3ir1n.useButtonClickedEvent)((0, $j33qQ.WELCOME_PAGE_ID), 'welcomeSignup', {
        redirectType: state === null || state === void 0 ? void 0 : state.redirectType
    });
    const { handleAppleLogin: handleAppleLogin, handleGoogleLogin: handleGoogleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $fjFtg.useWelcomePageActions)();
    if (isStateLoading) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
        label: "Signup verify email OTP page loading"
    });
    else if (!state || pageStateError) throw new Error(`Page state loading unsuccessful. \nPage state error: ${pageStateError}`);
    const { email: email, redirectType: redirectType, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading } = state;
    if (error === (0, $8dHAc.WelcomeError).RateLimitExceeded) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7V7Ns.WelcomeRateLimitExceededError), {});
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: (0, $j33qQ.WELCOME_PAGE_ID),
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6KAi4.WelcomeHeader), {}),
        footer: /*#__PURE__*/ (0, $6rcps.jsx)((0, $hmxfg.FooterLogoWrapper), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $lV2Te.WelcomeRecaptchaNotice), {})
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                title: formatMessage((0, $pegyt.default).subheadingResumeSignup)
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $jiicU.WelcomeForm), {
                redirectType: redirectType,
                fieldErrors: fieldErrors,
                formError: formError,
                isLoading: isLoading,
                onSubmit: onWelcomeSubmit,
                onWelcomeClick: onWelcomeClick,
                email: email,
                displayName: displayName,
                privacyPolicy: /*#__PURE__*/ (0, $6rcps.jsx)((0, $aZBDq.WelcomePrivacyPolicy), {})
            }),
            isEmbedded ? null : redirectType === (0, $8dHAc.RedirectType).Migration && /*#__PURE__*/ (0, $6rcps.jsx)((0, $l1nfA.default), {
                handleGoogleLogin: handleGoogleLogin,
                handleMicrosoftLogin: handleMicrosoftLogin,
                handleAppleLogin: handleAppleLogin,
                handleSlackLogin: handleSlackLogin
            })
        ]
    });
};
var $6ecb3ab34eb545cc$export$2e2bcd8739ae039 = $6ecb3ab34eb545cc$export$630ad10f0e1a953d;

});
parcelRegister("hmxfg", function(module, exports) {

$parcel$export(module.exports, "FooterLogoWrapper", function () { return $e689f1806218eaba$export$648d5009980d0c69; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");
let $e689f1806218eaba$var$_ = (t)=>t, $e689f1806218eaba$var$t;
const $e689f1806218eaba$export$648d5009980d0c69 = (0, $9Vz68.default).div($e689f1806218eaba$var$t || ($e689f1806218eaba$var$t = $e689f1806218eaba$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize));

});

parcelRegister("fblTd", function(module, exports) {
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("5aNnP")).emailRegex; });
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("jiicU")).WelcomeForm; });
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("7V7Ns")).WelcomeRateLimitExceededError; });
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("aZBDq")).WelcomePrivacyPolicy; });
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("l5Hi4")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("lV2Te")).WelcomeRecaptchaNotice; });
parcelRequire("9vST6");
parcelRequire("i2BLb");
parcelRequire("56I9x");
parcelRequire("59rw8");

});
parcelRegister("9vST6", function(module, exports) {
$parcel$export(module.exports, "WelcomeForm", function () { return (parcelRequire("jiicU")).WelcomeForm; });
$parcel$export(module.exports, "emailRegex", function () { return (parcelRequire("5aNnP")).emailRegex; });
parcelRequire("jiicU");
parcelRequire("5aNnP");

});
parcelRegister("jiicU", function(module, exports) {

$parcel$export(module.exports, "WelcomeForm", function () { return $e88892afc9afa733$export$aed3bcf545666c02; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");
parcelRequire("9k6h9");
var $idats = parcelRequire("idats");

var $8PH8E = parcelRequire("8PH8E");

var $lp6gZ = parcelRequire("lp6gZ");

var $dZRKj = parcelRequire("dZRKj");

var $4JKmU = parcelRequire("4JKmU");

var $1SvOA = parcelRequire("1SvOA");

var $1ncK5 = parcelRequire("1ncK5");

var $iRMnQ = parcelRequire("iRMnQ");
parcelRequire("lRkKS");
var $3QXjy = parcelRequire("3QXjy");
var $9B1mM = parcelRequire("9B1mM");
parcelRequire("lvtqo");
var $kmbBZ = parcelRequire("kmbBZ");
parcelRequire("59rw8");
var $l5Hi4 = parcelRequire("l5Hi4");

var $97pBx = parcelRequire("97pBx");
const $e88892afc9afa733$export$aed3bcf545666c02 = ({ displayName: displayName, email: email, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, onSubmit: onSubmit, onWelcomeClick: onWelcomeClick, privacyPolicy: privacyPolicy, redirectType: redirectType })=>{
    const intl = (0, $iSD9t.default)();
    const [fullName, setFullName] = (0, $8ZuGG.useState)(()=>displayName || '');
    const [password, setPassword] = (0, $8ZuGG.useState)('');
    const displayNameInputRef = (0, $8ZuGG.useRef)(null);
    const passwordInputRef = (0, $8ZuGG.useRef)(null);
    const fieldErrorPassword = (0, $97pBx.useTranslateFormErrorIfAvailable)(fieldErrors.password);
    const fieldErrorDisplayName = (0, $97pBx.useTranslateFormErrorIfAvailable)(fieldErrors.displayName);
    (0, $8ZuGG.useEffect)(()=>{
        var _displayNameInputRef_current, _passwordInputRef_current;
        const { displayName: displayName, emailUsedAsName: emailUsedAsName, passwordUsedAsName: passwordUsedAsName } = fieldErrors;
        const displayNameError = displayName || emailUsedAsName || passwordUsedAsName;
        const passwordError = fieldErrors.password;
        if (displayNameError) (_displayNameInputRef_current = displayNameInputRef.current) === null || _displayNameInputRef_current === void 0 ? void 0 : _displayNameInputRef_current.focus();
        else if (passwordError) (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
    }, [
        fieldErrors
    ]);
    const handleSubmit = async (e)=>{
        e.preventDefault();
        if (isLoading) return;
        await onSubmit({
            displayName: fullName,
            password: password
        });
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
        children: [
            formError && /*#__PURE__*/ (0, $6rcps.jsx)((0, $lp6gZ.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9B1mM.WelcomeFormErrors), {
                    error: formError
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1ncK5.StyledForm), {
                onSubmit: handleSubmit,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $6rcps.jsxs)("form", (0, $6EnDC._)((0, $ty6PY._)({}, formProps), {
                        id: "form-sign-up",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3QXjy.EmailVerified), {
                                email: email,
                                redirectType: redirectType,
                                iconLabel: intl.formatMessage((0, $iRMnQ.default).emailAddressVerifiedLabel)
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $8PH8E.default), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $dZRKj.default), {
                                    testId: "displayName" // used in pollinators
                                    ,
                                    name: "displayName",
                                    autoComplete: 'name',
                                    placeholder: intl.formatMessage((0, $iRMnQ.default).displayNamePlaceholder),
                                    label: intl.formatMessage((0, $iRMnQ.default).fullNameLabel),
                                    autoFocus: !!email && !displayName,
                                    isLabelHidden: false,
                                    isInvalid: !!fieldErrorDisplayName || !!fieldErrors.emailUsedAsName || !!fieldErrors.passwordUsedAsName,
                                    invalidMessage: fieldErrorDisplayName || fieldErrors.emailUsedAsName || fieldErrors.passwordUsedAsName,
                                    onChange: (e)=>setFullName(e.currentTarget.value),
                                    value: fullName,
                                    ref: displayNameInputRef
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $1ncK5.PasswordFieldGroup), {
                                children: [
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $4JKmU.default), {
                                        testId: "password" // used in pollinators
                                        ,
                                        name: "password",
                                        autoComplete: "new-password",
                                        "aria-describedby": (0, $idats.passwordStrengthMessageId),
                                        placeholder: intl.formatMessage((0, $iRMnQ.default).passwordPlaceholder),
                                        label: intl.formatMessage((0, $iRMnQ.default).passwordLabelNew),
                                        autoFocus: !!email && !!displayName,
                                        isLabelHidden: false,
                                        isInvalid: !!fieldErrorPassword,
                                        invalidMessage: fieldErrorPassword,
                                        onChange: (e)=>setPassword(e.currentTarget.value),
                                        value: password,
                                        ref: passwordInputRef
                                    }),
                                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $idats.PasswordStrengthMeter), {
                                        password: password,
                                        email: email,
                                        displayName: fullName,
                                        "data-testid": "password-strength-meter"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $kmbBZ.WelcomeMarketingConsent), {}),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1ncK5.PrivacyPolicyContainer), {
                                children: privacyPolicy
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $l5Hi4.WelcomeRecaptcha), {}),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $1ncK5.WelcomeButtonWrapper), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isFullWidth: true,
                                    id: "signup-submit",
                                    isLoading: isLoading,
                                    onClick: onWelcomeClick,
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                        id: "welcome.form.submit.continue",
                                        defaultMessage: "Continue"
                                    })
                                })
                            })
                        ]
                    }))
            })
        ]
    });
};

});
parcelRegister("9k6h9", function(module, exports) {
$parcel$export(module.exports, "passwordStrengthMessageId", function () { return (parcelRequire("idats")).passwordStrengthMessageId; });
$parcel$export(module.exports, "PasswordStrengthMeter", function () { return (parcelRequire("idats")).PasswordStrengthMeter; });
$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return (parcelRequire("iNcRq")).PasswordStrengthMeterExperimental; });
parcelRequire("idats");
parcelRequire("iNcRq");

});
parcelRegister("iNcRq", function(module, exports) {

$parcel$export(module.exports, "PasswordStrengthMeterExperimental", function () { return $3983462970efc1c8$export$f3f4fe3da2813049; });
/* PasswordStrengthMeterExperimental.tsx generated by @compiled/babel-plugin v0.37.0 */ /* eslint-disable react/no-unknown-property */ 
var $6rcps = parcelRequire("6rcps");

var $c4hjl = parcelRequire("c4hjl");
var $bT1Ur = parcelRequire("bT1Ur");

var $8ZuGG = parcelRequire("8ZuGG");

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $7mhBV = parcelRequire("7mhBV");

var $iSD9t = parcelRequire("iSD9t");

var $9aU91 = parcelRequire("9aU91");
let $3983462970efc1c8$var$_ = (t)=>t, $3983462970efc1c8$var$t, $3983462970efc1c8$var$t1;
const $3983462970efc1c8$var$barWidths = [
    '0%',
    '20%',
    '40%',
    '60%',
    '80%',
    '100%'
];
const $3983462970efc1c8$var$Wrapper = (0, $9Vz68.default).div($3983462970efc1c8$var$t || ($3983462970efc1c8$var$t = $3983462970efc1c8$var$_`
  margin-bottom: ${0}px;
  padding-inline: 10px;
`), (0, $5b7Z4.gridSize)());
const $3983462970efc1c8$var$Bar = (0, $9Vz68.default).div($3983462970efc1c8$var$t1 || ($3983462970efc1c8$var$t1 = $3983462970efc1c8$var$_`
  background: ${0};
  height: 4px;
  margin-top: 8px;
  margin-bottom: 4px;
  position: relative;
  border-radius: 2px;

  &::before {
    background: ${0};
    bottom: 0;
    content: '';
    left: 0;
    border-radius: 2px;
    position: absolute;
    top: 0;
    transition: all 0.2s ease-out;
    width: ${0};
  }
`), (0, $kTdw7).N40, (props)=>props.score === null ? (0, $kTdw7).N40 : $3983462970efc1c8$var$barColours[props.score], (props)=>props.score === null ? 0 : $3983462970efc1c8$var$barWidths[props.score]);
const $3983462970efc1c8$var$barColours = [
    (0, $kTdw7).N40,
    "var(--ds-text-accent-red, #AE2E24)",
    // Weak
    '#FFC716',
    // Fair
    '#94C748',
    // Good
    '#6A9A23',
    // Strong
    '#678933' // Very strong
];
const $3983462970efc1c8$var$hintStyles = null;
const $3983462970efc1c8$var$errorStyle = null;
const $3983462970efc1c8$var$Hint = ({ score: score, errorText: errorText, strengthText: strengthText })=>{
    const styleAsError = !!errorText || score === 1;
    const textToDisplay = errorText || strengthText;
    return textToDisplay ? /*#__PURE__*/ (0, $6rcps.jsx)("p", {
        className: (0, $c4hjl.default)([
            "_syaz1k2n _1wyb1crf _4t3i7vkz _19pk1y44 _kqswh2mm _ect418aq",
            styleAsError && "_syaz166f"
        ]),
        style: {
            "--_w5zcw3": (0, $bT1Ur.default)((0, $kTdw7).N90)
        },
        children: textToDisplay
    }) : null;
};
const $3983462970efc1c8$var$Container = (props)=>{
    return /*#__PURE__*/ (0, $6rcps.jsxs)($3983462970efc1c8$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)($3983462970efc1c8$var$Bar, {
                score: props.score
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                role: "status",
                children: /*#__PURE__*/ (0, $6rcps.jsx)($3983462970efc1c8$var$Hint, {
                    score: props.score || 0,
                    errorText: props.errorText,
                    strengthText: props.strengthText
                })
            })
        ]
    });
};
const $3983462970efc1c8$export$f3f4fe3da2813049 = ({ displayName: displayName, email: email, i18nLevels: i18nLevels, i18nNoValue: i18nNoValue, i18nNoZxcvbn: i18nNoZxcvbn, password: password, errorText: errorText, passwordSelected: passwordSelected })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const strengthLevelMessages = (0, $8ZuGG.useMemo)(()=>i18nLevels || [
            (0, $7mhBV.default).passwordStrengthMinimumRequirement,
            (0, $7mhBV.default).weakPasswordAdvice,
            (0, $7mhBV.default).fairPassword,
            (0, $7mhBV.default).goodPassword,
            (0, $7mhBV.default).strongPassword,
            (0, $7mhBV.default).veryStrongPassword
        ].map((message)=>formatMessage(message)), [
        formatMessage,
        i18nLevels
    ]);
    const noValueMessage = i18nNoValue || '';
    const noZxcvbnMessage = i18nNoZxcvbn || formatMessage((0, $7mhBV.default).passwordStrengthUnavailable);
    const { score: score } = (0, $9aU91.usePasswordScore)({
        displayName: displayName,
        email: email,
        password: password
    });
    const getStrengthText = ()=>{
        if (!password && !passwordSelected) return noValueMessage;
        return typeof score === 'number' ? strengthLevelMessages[score] : noZxcvbnMessage;
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)($3983462970efc1c8$var$Container, {
        errorText: errorText,
        strengthText: getStrengthText(),
        score: score
    });
};

});


parcelRegister("1ncK5", function(module, exports) {

$parcel$export(module.exports, "PrivacyPolicyContainer", function () { return $b0a094b4c8756371$export$6b077d087ec15a10; });
$parcel$export(module.exports, "PasswordFieldGroup", function () { return $b0a094b4c8756371$export$fc9115768a73fd6d; });
$parcel$export(module.exports, "WelcomeButtonWrapper", function () { return $b0a094b4c8756371$export$610e57aac9703b0f; });
$parcel$export(module.exports, "StyledForm", function () { return $b0a094b4c8756371$export$71655785c758526a; });

var $9Vz68 = parcelRequire("9Vz68");

var $5b7Z4 = parcelRequire("5b7Z4");

var $iPnAZ = parcelRequire("iPnAZ");

var $8PH8E = parcelRequire("8PH8E");
let $b0a094b4c8756371$var$_ = (t)=>t, $b0a094b4c8756371$var$t, $b0a094b4c8756371$var$t1, $b0a094b4c8756371$var$t2, $b0a094b4c8756371$var$t3, $b0a094b4c8756371$var$t4;
const $b0a094b4c8756371$export$6b077d087ec15a10 = (0, $9Vz68.default).div($b0a094b4c8756371$var$t || ($b0a094b4c8756371$var$t = $b0a094b4c8756371$var$_`
  margin-top: ${0}px;
  text-align: left;
  margin-left: 6px;
`), (0, $5b7Z4.gridSize)());
const $b0a094b4c8756371$export$fc9115768a73fd6d = (0, $9Vz68.default)((0, $8PH8E.default))($b0a094b4c8756371$var$t1 || ($b0a094b4c8756371$var$t1 = $b0a094b4c8756371$var$_`
  padding-top: ${0};
`), ({ isHidden: isHidden })=>isHidden ? `${(0, $5b7Z4.gridSize)() * 2}px` : 0);
const $b0a094b4c8756371$export$610e57aac9703b0f = (0, $9Vz68.default).div($b0a094b4c8756371$var$t2 || ($b0a094b4c8756371$var$t2 = $b0a094b4c8756371$var$_`
  margin-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $b0a094b4c8756371$export$585a3b23e887288b = (0, $9Vz68.default).div($b0a094b4c8756371$var$t3 || ($b0a094b4c8756371$var$t3 = $b0a094b4c8756371$var$_`
  text-align: center;
  padding-top: 4px;
`));
const $b0a094b4c8756371$export$71655785c758526a = (0, $9Vz68.default)((0, $iPnAZ.default))($b0a094b4c8756371$var$t4 || ($b0a094b4c8756371$var$t4 = $b0a094b4c8756371$var$_`
  margin: 0;
`));

});

parcelRegister("iRMnQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65c928c80f392a4$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $f65c928c80f392a4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    displayNamePlaceholder: {
        id: 'signup.form.displayName.placeholder',
        defaultMessage: 'Enter full name'
    },
    fullNameLabel: {
        id: 'signup.form.fullName.label',
        defaultMessage: 'Full name'
    },
    emailAddressVerifiedLabel: {
        id: 'welcome.form.email.address.verified.label',
        defaultMessage: 'Verified'
    },
    passwordPlaceholder: {
        id: 'signup.form.password.placeholder',
        defaultMessage: 'Create password'
    },
    passwordLabelNew: {
        id: 'signup.form.password.label.new',
        defaultMessage: 'Password'
    }
});

});

parcelRegister("lRkKS", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("3QXjy")).EmailVerified; });
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("9B1mM")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("10Eoq")).WelcomeFormErrorsExperimental; });
parcelRequire("1ArdA");
parcelRequire("as3VY");

});
parcelRegister("1ArdA", function(module, exports) {
$parcel$export(module.exports, "EmailVerified", function () { return (parcelRequire("3QXjy")).EmailVerified; });
parcelRequire("3QXjy");

});
parcelRegister("3QXjy", function(module, exports) {

$parcel$export(module.exports, "EmailVerified", function () { return $24ace115b1841b8f$export$320c6c46c464dd37; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $elF0p = parcelRequire("elF0p");

var $5BHjB = parcelRequire("5BHjB");

var $8dHAc = parcelRequire("8dHAc");

var $cU7aK = parcelRequire("cU7aK");

var $dUt0X = parcelRequire("dUt0X");

var $gGDrC = parcelRequire("gGDrC");
const $24ace115b1841b8f$export$320c6c46c464dd37 = ({ email: email, iconLabel: iconLabel, redirectType: redirectType })=>{
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $cU7aK.VerifiedEmailWrapper), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsxs)((0, $elF0p.Label), {
                htmlFor: "email-verified",
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $dUt0X.default).emailAddressLabel)),
                    redirectType !== (0, $8dHAc.RedirectType).Signup && redirectType !== (0, $8dHAc.RedirectType).ResumeSignup && /*#__PURE__*/ (0, $6rcps.jsx)((0, $cU7aK.VerifiedIconWrapper), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5BHjB))), {
                            label: iconLabel,
                            size: "small"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $cU7aK.BoldEmailWrapper), {
                id: "email-verified",
                children: email
            })
        ]
    });
};

});
parcelRegister("cU7aK", function(module, exports) {

$parcel$export(module.exports, "VerifiedEmailWrapper", function () { return $32f269f016faf909$export$6b03a82aa573dee0; });
$parcel$export(module.exports, "BoldEmailWrapper", function () { return $32f269f016faf909$export$33307c8166f2d281; });
$parcel$export(module.exports, "VerifiedIconWrapper", function () { return $32f269f016faf909$export$caa84cc45eb72ca8; });

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
let $32f269f016faf909$var$_ = (t)=>t, $32f269f016faf909$var$t, $32f269f016faf909$var$t1, $32f269f016faf909$var$t2;
const $32f269f016faf909$export$6b03a82aa573dee0 = (0, $9Vz68.default).div($32f269f016faf909$var$t || ($32f269f016faf909$var$t = $32f269f016faf909$var$_`
  margin-top: 10px;
  color: ${0};
`), (0, $kTdw7).N800);
const $32f269f016faf909$export$33307c8166f2d281 = (0, $9Vz68.default).p($32f269f016faf909$var$t1 || ($32f269f016faf909$var$t1 = $32f269f016faf909$var$_`
  font-weight: bold;
  overflow-wrap: break-word;
  margin: 0;
`));
const $32f269f016faf909$export$caa84cc45eb72ca8 = (0, $9Vz68.default).span($32f269f016faf909$var$t2 || ($32f269f016faf909$var$t2 = $32f269f016faf909$var$_`
  padding: 0 4px;
  color: ${0};
`), (0, $kTdw7).G400);

});

parcelRegister("dUt0X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fd11ff56feb0dbc$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $0fd11ff56feb0dbc$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    emailAddressLabel: {
        id: 'welcome.form.email.verified.label',
        defaultMessage: 'Email address'
    }
});

});



parcelRegister("as3VY", function(module, exports) {
$parcel$export(module.exports, "WelcomeFormErrors", function () { return (parcelRequire("9B1mM")).WelcomeFormErrors; });
$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return (parcelRequire("10Eoq")).WelcomeFormErrorsExperimental; });
parcelRequire("9B1mM");
parcelRequire("10Eoq");

});
parcelRegister("9B1mM", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrors", function () { return $56d158d356682610$export$647bfbe5c6b51f7d; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $pO9YU = parcelRequire("pO9YU");

var $evo12 = parcelRequire("evo12");
const $56d158d356682610$export$647bfbe5c6b51f7d = ({ error: error })=>{
    switch(error){
        case 'unknown':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $evo12.default).passwordLeakedXML), {
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                            href: (0, $pO9YU.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            }));
        case 'passwordCommon':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordCommon",
                defaultMessage: "This password is too widely used. Choose a password that's harder to guess."
            });
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordStrengthErrorWeak",
                defaultMessage: "Your password must have a minimum strength of weak."
            });
        case 'passwordStrengthErrorFair':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordStrengthErrorFair",
                defaultMessage: "Your password must have a minimum strength of fair."
            });
        case 'passwordStrengthErrorGood':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordStrengthErrorGood",
                defaultMessage: "Your password must have a minimum strength of good."
            });
        case 'passwordStrengthErrorStrong':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordStrengthErrorStrong",
                defaultMessage: "Your password must have a minimum strength of strong."
            });
        case 'passwordStrengthErrorVeryStrong':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordStrengthErrorVeryStrong",
                defaultMessage: "Your password must have a minimum strength of very strong."
            });
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});
parcelRegister("evo12", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3db61110c3a864e4$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $3db61110c3a864e4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    passwordLeakedXML: {
        id: 'signup.form.password.leaked.xml',
        defaultMessage: 'This password has appeared in an external data breach. To continue, enter another password. <password-leaked-link>Learn more</password-leaked-link>'
    }
});

});


parcelRegister("10Eoq", function(module, exports) {

$parcel$export(module.exports, "WelcomeFormErrorsExperimental", function () { return $29a3393bab5a0c36$export$f51e84a78cbc2d9b; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3VrrU = parcelRequire("3VrrU");
var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $pO9YU = parcelRequire("pO9YU");

var $evo12 = parcelRequire("evo12");
const $29a3393bab5a0c36$var$invalidPasswordTradukiDescription = 'Reason why a password is invalid';
const $29a3393bab5a0c36$var$errorWithAdvice = (0, $3VrrU.defineMessage)({
    id: 'welcome.error.adviceWrapper',
    defaultMessage: '{errorDescriptionSentence} Avoid common phrases and predictable sequences, and use a mix of characters.',
    description: 'Error describing why a password is invalid, followed by advice on how to fix it'
});
const $29a3393bab5a0c36$export$f51e84a78cbc2d9b = ({ error: error, hintError: hintError })=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const withAdvice = (errorDescriptionSentence)=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
            children: formatMessage($29a3393bab5a0c36$var$errorWithAdvice, {
                errorDescriptionSentence: errorDescriptionSentence
            })
        });
    const welcomeError = hintError !== null && hintError !== void 0 ? hintError : error;
    switch(welcomeError){
        case 'passwordStrengthCantMatchDisplayName':
        case 'passwordMatchesDisplayNameError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesDisplayName',
                defaultMessage: "Your password can't match your <strong>display name</strong>.",
                description: $29a3393bab5a0c36$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchAtlassianKeyword':
        case 'passwordMatchesAtlassianKeywordError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesAtlassianKeyword',
                defaultMessage: "Your password can't match an <strong>Atlassian keyword</strong>.",
                description: $29a3393bab5a0c36$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthCantMatchEmail':
        case 'passwordMatchesEmailError':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordMatchesEmail',
                defaultMessage: "Your password can't match your <strong>email address</strong>.",
                description: $29a3393bab5a0c36$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'unknown':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.unknown",
                defaultMessage: "Something went wrong while attempting to sign up. Please try again."
            });
        case 'captcha':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.captcha",
                defaultMessage: "We are having trouble verifying reCAPTCHA for this request. Please try again. If the problem persists, try another browser/device or reach out to Atlassian Support."
            });
        case 'captchaScoreTooLow':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.captcha.score_too_low",
                defaultMessage: "We'd like to make sure it's really you creating your account. Please confirm you're not a robot.",
                description: "Message asking user to tick the reCAPTCHA checkbox and resubmit the form"
            });
        case 'request_error':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.request_error",
                defaultMessage: "Unable to connect. Check your internet connection or the network settings for your browser and try again."
            });
        case 'passwordLeaked':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $6EnDC._)((0, $ty6PY._)({}, (0, $evo12.default).passwordLeakedXML), {
                tagName: "p",
                values: {
                    'password-leaked-link': (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                            href: (0, $pO9YU.PASSWORD_LEAKED_LINK),
                            children: chunks
                        })
                }
            }));
        case 'passwordCommon':
            return withAdvice(formatMessage({
                id: 'welcome.error.passwordIsCommon',
                defaultMessage: 'This is a <strong>common password</strong>.',
                description: $29a3393bab5a0c36$var$invalidPasswordTradukiDescription
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'invalidPassword':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.invalidPassword",
                defaultMessage: "Invalid password"
            });
        case 'passwordCaseError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordCaseError",
                defaultMessage: "Your password must contain at least one uppercase and one lowercase letter."
            });
        case 'passwordDigitOrSpecialError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordDigitOrSpecialError",
                defaultMessage: "Your password must contain at least one digit or special character."
            });
        case 'passwordLengthError':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordLengthError",
                defaultMessage: "Your password must be between 8 and 72 characters long."
            });
        case 'passwordUsedBefore':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.passwordUsedBefore",
                defaultMessage: "You've used that password before. Please choose a different one."
            });
        case 'usernameMustBeEmail':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.error.usernameMustBeEmail",
                defaultMessage: "Your account username must be a valid email address."
            });
        case 'passwordStrengthErrorWeak':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorWeak',
                defaultMessage: 'Your password must have a minimum strength of <strong>weak</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorFair':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorFair',
                defaultMessage: 'Your password must have a minimum strength of <strong>fair</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorGood':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorGood',
                defaultMessage: 'Your password must have a minimum strength of <strong>good</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        case 'passwordStrengthErrorVeryStrong':
            return withAdvice(formatMessage({
                id: 'welcome.error.bold.passwordStrengthErrorVeryStrong',
                defaultMessage: 'Your password must have a minimum strength of <strong>very strong</strong>.'
            }, {
                strong: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                        children: chunks
                    })
            }));
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "welcome.form.random.error",
                defaultMessage: "An error occurred while attempting to sign up: {error}. Please try again or reach out to Atlassian Support.",
                values: {
                    error: error
                }
            });
    }
};

});



parcelRegister("lvtqo", function(module, exports) {
$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return (parcelRequire("kmbBZ")).WelcomeMarketingConsent; });
parcelRequire("kmbBZ");

});
parcelRegister("kmbBZ", function(module, exports) {

$parcel$export(module.exports, "WelcomeMarketingConsent", function () { return $33c3de833d7dbd91$export$2ba9993ec03b7ee5; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
parcelRequire("iHiV1");
var $8HPoh = parcelRequire("8HPoh");

var $kdW7h = parcelRequire("kdW7h");

var $kOqgB = parcelRequire("kOqgB");

var $7k83O = parcelRequire("7k83O");
const $33c3de833d7dbd91$var$marketingConsentSelector = (state)=>state.marketingConsent.config;
const $33c3de833d7dbd91$var$welcomeEmailSelector = (state)=>state.welcome.email;
const $33c3de833d7dbd91$export$2ba9993ec03b7ee5 = ()=>{
    (0, $aavUY.useRegisterComponent)($33c3de833d7dbd91$export$2ba9993ec03b7ee5.name);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { setMarketingConsent: setMarketingConsent } = (0, $8HPoh.useWelcomePageContext)();
    const marketingConsentConfig = (0, $kOqgB.useAppSelector)($33c3de833d7dbd91$var$marketingConsentSelector);
    const email = (0, $kOqgB.useAppSelector)($33c3de833d7dbd91$var$welcomeEmailSelector);
    (0, $8ZuGG.useEffect)(()=>{
        if (email !== '') dispatch((0, $7k83O.fetchConsentConfig)(email));
    }, [
        dispatch,
        email
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $kdW7h.default), {
        config: marketingConsentConfig,
        onConsentChange: setMarketingConsent
    });
};

});
parcelRegister("iHiV1", function(module, exports) {
$parcel$export(module.exports, "useWelcomePageContext", function () { return (parcelRequire("8HPoh")).useWelcomePageContext; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return (parcelRequire("8HPoh")).WelcomePageProvider; });
parcelRequire("8HPoh");

});
parcelRegister("8HPoh", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageContext", function () { return $5a84cde8cdb4dd52$export$417cf5d67969d32f; });
$parcel$export(module.exports, "WelcomePageProvider", function () { return $5a84cde8cdb4dd52$export$96494047c552bc09; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");
const $5a84cde8cdb4dd52$export$46030b7a3a8bf13f = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);
const $5a84cde8cdb4dd52$export$417cf5d67969d32f = ()=>{
    const context = (0, $8ZuGG.useContext)($5a84cde8cdb4dd52$export$46030b7a3a8bf13f);
    if (!context) throw new Error('useWelcomePageContext must be used within a WelcomePageContextProvider');
    return context;
};
const $5a84cde8cdb4dd52$export$96494047c552bc09 = ({ children: children })=>{
    const [privacyPolicyText, setPrivacyPolicyText] = (0, $8ZuGG.useState)();
    const [marketingConsent, setMarketingConsent] = (0, $8ZuGG.useState)({
        state: 'not_shown'
    });
    const state = (0, $8ZuGG.useMemo)(()=>({
            privacyPolicyText: privacyPolicyText,
            setPrivacyPolicyText: setPrivacyPolicyText,
            marketingConsent: marketingConsent,
            setMarketingConsent: setMarketingConsent
        }), [
        marketingConsent,
        privacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($5a84cde8cdb4dd52$export$46030b7a3a8bf13f.Provider, {
        value: state,
        children: children
    });
};

});




parcelRegister("59rw8", function(module, exports) {
$parcel$export(module.exports, "WelcomeRecaptcha", function () { return (parcelRequire("l5Hi4")).WelcomeRecaptcha; });
$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return (parcelRequire("lV2Te")).WelcomeRecaptchaNotice; });
parcelRequire("l5Hi4");
parcelRequire("lV2Te");

});
parcelRegister("l5Hi4", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptcha", function () { return $d3a8c2ad030ed6ac$export$288894e7e6fbc9f; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $61XRM = parcelRequire("61XRM");
parcelRequire("gUzPq");
var $dm4jh = parcelRequire("dm4jh");

var $2DqQ6 = parcelRequire("2DqQ6");
const $d3a8c2ad030ed6ac$export$288894e7e6fbc9f = ()=>{
    (0, $aavUY.useRegisterComponent)($d3a8c2ad030ed6ac$export$288894e7e6fbc9f.name);
    const { enabled: recaptchaEnabled, component: recaptchaComponent } = (0, $61XRM.useRecaptchaContext)();
    const { state: state } = (0, $dm4jh.useWelcomeState)();
    const { recaptchaEnable: recaptchaEnable, shouldSkipCaptcha: shouldSkipCaptcha } = state || {};
    const shouldShow = recaptchaEnable && !shouldSkipCaptcha && recaptchaEnabled && recaptchaComponent;
    if (!shouldShow) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $2DqQ6.WelcomeRecaptchaContainer), {
        children: recaptchaComponent
    });
};

});
parcelRegister("gUzPq", function(module, exports) {
$parcel$export(module.exports, "useWelcomeState", function () { return (parcelRequire("dm4jh")).useWelcomeState; });
$parcel$export(module.exports, "useWelcomePageActions", function () { return (parcelRequire("fjFtg")).useWelcomePageActions; });
$parcel$export(module.exports, "useWelcomeSubmission", function () { return (parcelRequire("jQMDT")).useWelcomeSubmission; });
parcelRequire("dm4jh");
parcelRequire("fjFtg");
parcelRequire("jQMDT");

});
parcelRegister("dm4jh", function(module, exports) {

$parcel$export(module.exports, "useWelcomeState", function () { return $6bc0f185729c74e3$export$ac89f9e632e22c81; });
/* eslint-disable react-redux/useSelector-prefer-selectors */ 
var $ty6PY = parcelRequire("ty6PY");

var $kOqgB = parcelRequire("kOqgB");

var $1uBrV = parcelRequire("1uBrV");

var $jtt5y = parcelRequire("jtt5y");

var $8ZuGG = parcelRequire("8ZuGG");

var $7ZOCz = parcelRequire("7ZOCz");

var $gSYii = parcelRequire("gSYii");

var $9NVnN = parcelRequire("9NVnN");
const $6bc0f185729c74e3$var$usePreloadedState = ()=>{
    const csrfToken = (0, $kOqgB.useAppSelector)((state)=>state.csrfToken);
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    const isEmbedded = (0, $kOqgB.useAppSelector)((state)=>Boolean(state.microbranding.isEmbedded));
    const marketingConsentConfig = (0, $kOqgB.useAppSelector)((state)=>state.marketingConsent.config);
    const { recaptchaEnable: recaptchaEnable, auth0Config: auth0Config } = (0, $kOqgB.useAppSelector)((state)=>state.appConfig);
    const { displayName: displayName, email: email, error: error, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading, recoveryToken: recoveryToken, redirectTo: redirectTo, redirectType: redirectType, shouldSkipCaptcha: shouldSkipCaptcha } = (0, $kOqgB.useAppSelector)((state)=>state.welcome);
    return {
        auth0Config: auth0Config,
        csrfToken: csrfToken,
        displayName: displayName,
        email: email || '',
        error: error,
        fieldErrors: fieldErrors,
        formError: formError,
        isEmbedded: isEmbedded,
        isLoading: isLoading,
        marketingConsentConfig: marketingConsentConfig,
        oidcContext: oidcContext,
        recaptchaEnable: recaptchaEnable,
        recoveryToken: recoveryToken,
        redirectTo: redirectTo,
        redirectType: redirectType,
        shouldSkipCaptcha: shouldSkipCaptcha
    };
};
const $6bc0f185729c74e3$export$ac89f9e632e22c81 = ()=>{
    const noServerState = (0, $1uBrV.isSasStateEndpointEnabled)() && (0, $jtt5y.default)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const { state: stateFromApi, isLoading: isLoading, isError: isError, error: error } = (0, $1uBrV.usePageState)('/signup/welcome/state', {
        enabled: noServerState
    });
    (0, $8ZuGG.useEffect)(()=>{
        if ((0, $1uBrV.isPageStateResult)(stateFromApi)) {
            dispatch((0, $7ZOCz.updateMicrobranding)(stateFromApi.oidcContext));
            dispatch((0, $gSYii.welcomeSetState)(stateFromApi));
        }
    }, [
        dispatch,
        stateFromApi
    ]);
    const preloadedState = $6bc0f185729c74e3$var$usePreloadedState();
    if ((0, $1uBrV.isRedirectResult)(stateFromApi)) {
        navigate(stateFromApi.uri);
        return {
            state: undefined,
            isLoading: true,
            isError: false
        };
    }
    if (noServerState) return {
        state: (0, $ty6PY._)({}, preloadedState, stateFromApi),
        isLoading: isLoading,
        isError: isError,
        error: error
    };
    return {
        state: preloadedState,
        isLoading: false,
        isError: false,
        error: error
    };
};

});
parcelRegister("7ZOCz", function(module, exports) {

$parcel$export(module.exports, "updateMicrobranding", function () { return $3f349ac082a7f12a$export$f31be3fc25ea8015; });

var $82mu7 = parcelRequire("82mu7");
const $3f349ac082a7f12a$export$f31be3fc25ea8015 = (oidcContext)=>({
        type: 'MICROBRANDING_UPDATE',
        microbranding: (0, $82mu7.buildMicrobranding)(oidcContext)
    });

});

parcelRegister("gSYii", function(module, exports) {

$parcel$export(module.exports, "showFieldErrors", function () { return $7262c0a32d86fc9c$export$f17d5fd8029ff8d7; });
$parcel$export(module.exports, "welcomeSetState", function () { return $7262c0a32d86fc9c$export$675233984e8f052; });
$parcel$export(module.exports, "welcome", function () { return $7262c0a32d86fc9c$export$424aefd0ddb3521d; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $jSnDV = parcelRequire("jSnDV");

var $bjLjm = parcelRequire("bjLjm");

var $jSO9M = parcelRequire("jSO9M");

var $8f2pb = parcelRequire("8f2pb");

var $lk8Tl = parcelRequire("lk8Tl");
const $7262c0a32d86fc9c$export$aad8462122ac592b = ()=>({
        type: 'WELCOME_SIGNUP_RESET'
    });
const $7262c0a32d86fc9c$export$41790ce653e273fc = ()=>({
        type: 'WELCOME_SIGNUP_REQUEST'
    });
const $7262c0a32d86fc9c$export$4d8221b509914ddc = (redirectTo)=>({
        type: 'WELCOME_SIGNUP_REQUEST_SUCCESS',
        redirectTo: redirectTo
    });
const $7262c0a32d86fc9c$export$cacbe64ca8591e58 = (formError)=>({
        type: 'WELCOME_SIGNUP_REQUEST_FAILED',
        formError: formError
    });
const $7262c0a32d86fc9c$export$f17d5fd8029ff8d7 = (errors)=>({
        type: 'WELCOME_SIGNUP_SHOW_FIELD_ERRORS',
        errors: errors
    });
const $7262c0a32d86fc9c$export$675233984e8f052 = (state)=>({
        type: 'WELCOME_SIGNUP_SET_STATE',
        state: state
    });

const $7262c0a32d86fc9c$export$424aefd0ddb3521d = (welcomeParams)=>async (dispatch, getState)=>{
        const { displayName: displayName, password: password, token: token, microbrandingParams: microbrandingParams, challengeResponse: challengeResponse, marketingConsentState: marketingConsentState, privacyPolicyText: privacyPolicyText, csrfToken: csrfToken } = welcomeParams;
        // fire castle action
        const castleToken = (0, $lk8Tl.currentCloudType) === 'commercial' ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch((e)=>{
            console.error('castle error', e);
            (0, $8f2pb.captureException)(e);
            return undefined;
        }) : undefined;
        const qs = microbrandingParams && Object.keys(microbrandingParams).length ? `?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(microbrandingParams)}` : '';
        dispatch($7262c0a32d86fc9c$export$41790ce653e273fc());
        let payload = {
            'challenge-response': (0, $jSO9M.toChallengeRequest)(challengeResponse),
            displayName: displayName,
            password: password,
            token: token,
            display: null,
            castleToken: castleToken
        };
        const marketingConsent = (0, $bjLjm.buildMarketingConsent)(getState().marketingConsent.config, marketingConsentState, privacyPolicyText);
        if (marketingConsent) payload = (0, $6EnDC._)((0, $ty6PY._)({}, payload), {
            marketingConsent: marketingConsent
        });
        return fetch(`/rest/signup/welcome${qs}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken
            },
            body: JSON.stringify(payload)
        }).then((response)=>response.json()).then(({ fieldErrors: fieldErrors, uiErrors: uiErrors, redirectTo: redirectTo })=>{
            if (redirectTo) dispatch($7262c0a32d86fc9c$export$4d8221b509914ddc(redirectTo));
            else {
                if (uiErrors && uiErrors.length) dispatch($7262c0a32d86fc9c$export$cacbe64ca8591e58(uiErrors[0].key));
                else if (fieldErrors && Object.keys(fieldErrors).length) dispatch($7262c0a32d86fc9c$export$f17d5fd8029ff8d7(fieldErrors));
                else dispatch($7262c0a32d86fc9c$export$cacbe64ca8591e58('unknown'));
            }
        }).catch(()=>{
            dispatch($7262c0a32d86fc9c$export$cacbe64ca8591e58('unknown'));
        });
    };

});


parcelRegister("fjFtg", function(module, exports) {

$parcel$export(module.exports, "useWelcomePageActions", function () { return $2f0aea9dc7f8b657$export$a7ba34b740a66255; });

var $8ZuGG = parcelRequire("8ZuGG");

var $dm4jh = parcelRequire("dm4jh");
parcelRequire("f2IKy");
var $bbCID = parcelRequire("bbCID");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $j33qQ = parcelRequire("j33qQ");
const $2f0aea9dc7f8b657$export$a7ba34b740a66255 = ()=>{
    (0, $aavUY.useRegisterComponent)($2f0aea9dc7f8b657$export$a7ba34b740a66255.name);
    const { state: state } = (0, $dm4jh.useWelcomeState)();
    const { auth0Config: auth0Config, csrfToken: csrfToken, email: email, recoveryToken: recoveryToken, redirectType: redirectType } = state || {};
    const recoveryOptions = (0, $8ZuGG.useMemo)(()=>{
        return recoveryToken && email ? {
            expectedEmail: email,
            recoveryToken: recoveryToken
        } : undefined;
    }, [
        email,
        recoveryToken
    ]);
    const handleGoogleLogin = (0, $bbCID.useGoogleLoginHandler)({
        pageId: (0, $j33qQ.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            source: (0, $j33qQ.WELCOME_PAGE_ID),
            recoveryOptions: recoveryOptions
        }
    });
    const { handleAppleLogin: handleAppleLogin, handleMicrosoftLogin: handleMicrosoftLogin, handleSlackLogin: handleSlackLogin } = (0, $bbCID.useSocialLoginHandlers)({
        pageId: (0, $j33qQ.WELCOME_PAGE_ID),
        redirectType: redirectType,
        redirectParams: {
            location: window.location,
            auth0Config: auth0Config,
            csrfToken: csrfToken,
            source: (0, $j33qQ.WELCOME_PAGE_ID),
            email: email,
            recoveryOptions: recoveryOptions
        }
    });
    return {
        handleAppleLogin: handleAppleLogin,
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleSlackLogin: handleSlackLogin,
        handleGoogleLogin: handleGoogleLogin
    };
};

});
parcelRegister("j33qQ", function(module, exports) {

$parcel$export(module.exports, "WELCOME_PAGE_ID", function () { return $16af813e80b9e4c3$export$ce43a0b457ba42a3; });
const $16af813e80b9e4c3$export$ce43a0b457ba42a3 = 'welcomeScreen';

});


parcelRegister("jQMDT", function(module, exports) {

$parcel$export(module.exports, "useWelcomeSubmission", function () { return $60aab9f4a2cf434e$export$1a7f914df8351aa8; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $8ZuGG = parcelRequire("8ZuGG");

var $jSnDV = parcelRequire("jSnDV");

var $fvOZR = parcelRequire("fvOZR");

var $3VrrU = parcelRequire("3VrrU");
var $iSD9t = parcelRequire("iSD9t");

var $dm4jh = parcelRequire("dm4jh");

var $gSYii = parcelRequire("gSYii");

var $kZj5j = parcelRequire("kZj5j");

var $3ir1n = parcelRequire("3ir1n");

var $kOqgB = parcelRequire("kOqgB");

var $bRdVV = parcelRequire("bRdVV");

var $8f2pb = parcelRequire("8f2pb");

var $61XRM = parcelRequire("61XRM");
parcelRequire("iHiV1");
var $8HPoh = parcelRequire("8HPoh");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $j33qQ = parcelRequire("j33qQ");
parcelRequire("fblTd");
var $5aNnP = parcelRequire("5aNnP");
parcelRequire("f2IKy");
var $gsGhI = parcelRequire("gsGhI");

var $9NVnN = parcelRequire("9NVnN");
const $60aab9f4a2cf434e$var$subjectIds = {
    displayName: 'welcomeSignupNoName',
    password: 'welcomeSignupNoPassword',
    emailUsedAsName: 'welcomeSignupEmailUsedAsName',
    passwordUsedAsName: 'welcomeSignupPasswordUsedAsName'
};
const $60aab9f4a2cf434e$var$messages = (0, $3VrrU.defineMessages)({
    displayNameEmpty: {
        id: 'signup.form.displayName.empty',
        defaultMessage: 'Please enter a name'
    },
    displayNameIsEmail: {
        id: 'signup.form.displayName.is.email',
        defaultMessage: 'Please ensure your full name is not an email address'
    },
    displayNameIsPassword: {
        id: 'signup.form.displayName.is.password',
        defaultMessage: 'Please ensure your full name is not your password'
    },
    passwordEmpty: {
        id: 'signup.form.password.empty',
        defaultMessage: 'Please enter a password'
    },
    passwordMinimumRequirement: {
        id: 'signup.form.password.minimum',
        defaultMessage: 'Password must have at least 8 characters'
    }
});
const $60aab9f4a2cf434e$export$6f63e37550343081 = 8;
const $60aab9f4a2cf434e$export$1a7f914df8351aa8 = ({ autoRedirect: autoRedirect = true } = {})=>{
    (0, $aavUY.useRegisterComponent)($60aab9f4a2cf434e$export$1a7f914df8351aa8.name);
    const navigate = (0, $9NVnN.useNavigateSoftOrHard)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const intl = (0, $iSD9t.default)();
    const { fetchToken: fetchToken, recaptchaType: recaptchaType } = (0, $61XRM.useRecaptchaContext)();
    const { marketingConsent: marketingConsent } = (0, $8HPoh.useWelcomePageContext)();
    const { state: state } = (0, $dm4jh.useWelcomeState)();
    const { csrfToken: csrfToken, redirectType: redirectType, error: error, fieldErrors: fieldErrors, formError: formError, isLoading: isLoading = false, redirectTo: redirectTo = null } = state || {};
    (0, $gsGhI.useForceRedirect)({
        redirectTo: autoRedirect ? redirectTo : undefined
    });
    const { privacyPolicyText: privacyPolicyText } = (0, $8HPoh.useWelcomePageContext)();
    const onWelcomeInputValidate = (0, $8ZuGG.useCallback)((data)=>{
        const validationErrors = {};
        const { displayName: displayName, password: password } = data;
        const hasDisplayName = typeof displayName !== 'undefined';
        const hasPassword = typeof password !== 'undefined';
        if (hasDisplayName && displayName.trim() === '') validationErrors.displayName = intl.formatMessage($60aab9f4a2cf434e$var$messages.displayNameEmpty);
        if (hasPassword) {
            if (password.trim() === '') validationErrors.password = intl.formatMessage($60aab9f4a2cf434e$var$messages.passwordEmpty);
            else if (password.length < $60aab9f4a2cf434e$export$6f63e37550343081) validationErrors.password = intl.formatMessage($60aab9f4a2cf434e$var$messages.passwordMinimumRequirement);
        }
        if (hasDisplayName && (0, $5aNnP.emailRegex).test(displayName.trim())) validationErrors.emailUsedAsName = intl.formatMessage($60aab9f4a2cf434e$var$messages.displayNameIsEmail);
        if (hasDisplayName && hasPassword && displayName.toLowerCase().trim() === password.toLowerCase().trim()) validationErrors.passwordUsedAsName = intl.formatMessage($60aab9f4a2cf434e$var$messages.displayNameIsPassword);
        return validationErrors;
    }, [
        intl
    ]);
    const onWelcomeSubmit = (0, $8ZuGG.useCallback)(async (data)=>{
        try {
            if (!privacyPolicyText) {
                console.error('Form cannot be submitted without showing Privacy Policy');
                return;
            }
            if (!marketingConsent) {
                console.error('Form cannot be submitted without showing Marketing Consent');
                return;
            }
            const validationErrors = onWelcomeInputValidate(data);
            if (Object.keys(validationErrors).length) {
                Object.keys(validationErrors).forEach((errorKey)=>analyticsClient.errorShownEvent((0, $j33qQ.WELCOME_PAGE_ID), $60aab9f4a2cf434e$var$subjectIds[errorKey] || 'welcomeSignupUnknownUiError'));
                dispatch((0, $gSYii.showFieldErrors)(validationErrors));
                return;
            }
            const challengeResponse = await fetchToken();
            const { signature: signature, token: token } = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search);
            const welcomeToken = token || signature;
            const query = (0, $ty6PY._)({}, (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(location.search));
            navigate(`/signup/welcome?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(query)}`);
            const microbrandingParams = (0, $kZj5j.getMicrobrandingFromUrl)(location);
            analyticsClient.formSubmittedEvent((0, $j33qQ.WELCOME_PAGE_ID), 'welcomeForm', {
                marketingConsent: (0, $fvOZR.dangerouslyCreateSafeString)(marketingConsent.state),
                redirectType: redirectType,
                recaptchaType: recaptchaType
            });
            await dispatch((0, $gSYii.welcome)((0, $6EnDC._)((0, $ty6PY._)({}, data), {
                marketingConsentState: marketingConsent,
                privacyPolicyText: privacyPolicyText,
                microbrandingParams: microbrandingParams,
                challengeResponse: challengeResponse,
                password: data.password || '',
                token: welcomeToken || '',
                // TODO: Should not need this non-null assertion
                csrfToken: csrfToken
            })));
        } catch (e) {
            (0, $8f2pb.captureException)(e);
            dispatch((0, $bRdVV.signupCaptchaFailure)(navigator.onLine));
        }
    }, [
        analyticsClient,
        csrfToken,
        dispatch,
        marketingConsent,
        navigate,
        onWelcomeInputValidate,
        privacyPolicyText,
        fetchToken,
        recaptchaType,
        redirectType
    ]);
    return {
        onWelcomeSubmit: onWelcomeSubmit,
        onWelcomeInputValidate: onWelcomeInputValidate,
        isLoading: isLoading,
        redirectTo: redirectTo,
        formError: formError,
        fieldErrors: fieldErrors,
        error: error
    };
};

});


parcelRegister("2DqQ6", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaContainer", function () { return $282bfe0c79d2476d$export$bb84fe97ed03d9ef; });

var $9Vz68 = parcelRequire("9Vz68");

var $f19CI = parcelRequire("f19CI");
let $282bfe0c79d2476d$var$_ = (t)=>t, $282bfe0c79d2476d$var$t;
const $282bfe0c79d2476d$export$bb84fe97ed03d9ef = (0, $9Vz68.default)((0, $f19CI.default))($282bfe0c79d2476d$var$t || ($282bfe0c79d2476d$var$t = $282bfe0c79d2476d$var$_`
  .grecaptcha-badge {
    display: none;
  }
`));

});


parcelRegister("lV2Te", function(module, exports) {

$parcel$export(module.exports, "WelcomeRecaptchaNotice", function () { return $72ad20434d8c2bd7$export$de0d13e777a02b5b; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $f19CI = parcelRequire("f19CI");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");
const $72ad20434d8c2bd7$export$de0d13e777a02b5b = ()=>{
    (0, $aavUY.useRegisterComponent)($72ad20434d8c2bd7$export$de0d13e777a02b5b.name);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $f19CI.RecaptchaNotice), {});
};

});



parcelRegister("5aNnP", function(module, exports) {

$parcel$export(module.exports, "emailRegex", function () { return $ec75463e2deb42d3$export$976c37132e9c6a10; });
// Identity accepted email validator
const $ec75463e2deb42d3$var$regexLiteral = /([a-z0-9._%\-+!#$&/=?^|~ ]+)@([a-z0-9 -]+\.)+ *[a-z]+/;
const $ec75463e2deb42d3$export$976c37132e9c6a10 = new RegExp($ec75463e2deb42d3$var$regexLiteral);

});


parcelRegister("i2BLb", function(module, exports) {
$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return (parcelRequire("7V7Ns")).WelcomeRateLimitExceededError; });
parcelRequire("7V7Ns");

});
parcelRegister("7V7Ns", function(module, exports) {

$parcel$export(module.exports, "WelcomeRateLimitExceededError", function () { return $4430ed17e2ced671$export$30b9e8215a118df0; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $9Vz68 = parcelRequire("9Vz68");

var $HBurV = parcelRequire("HBurV");

var $7CMue = parcelRequire("7CMue");

var $3ir1n = parcelRequire("3ir1n");
let $4430ed17e2ced671$var$_ = (t)=>t, $4430ed17e2ced671$var$t;
const $4430ed17e2ced671$var$MessageContainer = (0, $9Vz68.default).div($4430ed17e2ced671$var$t || ($4430ed17e2ced671$var$t = $4430ed17e2ced671$var$_`
  margin-bottom: 24px;
`));
const $4430ed17e2ced671$export$703ba2e7ea526c1b = 'welcomeRateLimitExceededErrorPage';
const $4430ed17e2ced671$export$30b9e8215a118df0 = ()=>{
    (0, $3ir1n.usePageViewedEvent)($4430ed17e2ced671$export$703ba2e7ea526c1b);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7CMue.default), {
        pageId: $4430ed17e2ced671$export$703ba2e7ea526c1b,
        header: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
            children: [
                /*#__PURE__*/ (0, $6rcps.jsx)($4430ed17e2ced671$var$MessageContainer, {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        id: "welcome.rate-limit-exceeded.error.title",
                        defaultMessage: "We couldn't verify your email",
                        description: "Telling the user that there is an error and they're not verified. The error is caused by too many attempts submitting the link.",
                        tagName: "h5"
                    })
                }),
                /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    width: "99",
                    alt: ""
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "welcome.rate-limit-exceeded.error.main-action",
            defaultMessage: "There have been too many attempts to verify your account in the past hour. Please try again after an hour.",
            description: "Telling the user that there has been too many attempts on the welcome link and to try again later by refreshing or clicking the link again."
        })
    });
};
var $4430ed17e2ced671$export$2e2bcd8739ae039 = $4430ed17e2ced671$export$30b9e8215a118df0;

});


parcelRegister("56I9x", function(module, exports) {
$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return (parcelRequire("aZBDq")).WelcomePrivacyPolicy; });
parcelRequire("aZBDq");

});
parcelRegister("aZBDq", function(module, exports) {

$parcel$export(module.exports, "WelcomePrivacyPolicy", function () { return $cbabdc8caf4d43d1$export$3c67e645c8f59d72; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $6lpHq = parcelRequire("6lpHq");

var $day6I = parcelRequire("day6I");
parcelRequire("cGo6O");
var $aavUY = parcelRequire("aavUY");

var $j33qQ = parcelRequire("j33qQ");
parcelRequire("iHiV1");
var $8HPoh = parcelRequire("8HPoh");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("gUzPq");
var $dm4jh = parcelRequire("dm4jh");
const $cbabdc8caf4d43d1$var$isEmbeddedSelectorFn = (state)=>Boolean(state.microbranding.isEmbedded);
const $cbabdc8caf4d43d1$export$3c67e645c8f59d72 = ()=>{
    var _privacyPolicyMessageRef_current;
    (0, $aavUY.useRegisterComponent)($cbabdc8caf4d43d1$export$3c67e645c8f59d72.name);
    const privacyPolicyMessageRef = (0, $8ZuGG.useRef)(null);
    const { state: { oidcContext: oidcContext } = {} } = (0, $dm4jh.useWelcomeState)();
    const isEmbedded = (0, $kOqgB.useAppSelector)($cbabdc8caf4d43d1$var$isEmbeddedSelectorFn);
    const { setPrivacyPolicyText: setPrivacyPolicyText } = (0, $8HPoh.useWelcomePageContext)();
    const privacyPolicyText = ((_privacyPolicyMessageRef_current = privacyPolicyMessageRef.current) === null || _privacyPolicyMessageRef_current === void 0 ? void 0 : _privacyPolicyMessageRef_current.innerHTML) || '';
    (0, $8ZuGG.useEffect)(()=>{
        if (privacyPolicyText) setPrivacyPolicyText(privacyPolicyText);
    }, [
        privacyPolicyText,
        setPrivacyPolicyText
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6lpHq.default), {
        isEmbedded: isEmbedded,
        isMobileOidc: (0, $day6I.isMobileOidc)(oidcContext),
        pageId: (0, $j33qQ.WELCOME_PAGE_ID),
        privacyPolicyText: (0, $6lpHq.PrivacyPolicyText).passwordSignup,
        ref: privacyPolicyMessageRef
    });
};

});



parcelRegister("pegyt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $686c31860742b579$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $686c31860742b579$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'welcome.head.title',
        defaultMessage: 'Sign up'
    },
    subheadingResumeSignup: {
        id: 'welcome.signup.subheading.title',
        defaultMessage: 'Finish setting up your account',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    subheadingMigration: {
        id: 'welcome.migration.subheading.title',
        defaultMessage: 'Complete your migration'
    },
    emailVerifiedTitle: {
        id: 'resume.signup.head.title',
        defaultMessage: 'Email address verified'
    },
    contextualHeadTitle: {
        id: 'signup.contextual.head.title',
        defaultMessage: 'Sign up to continue to',
        description: `Precedes a page title or issue number. For example, "Sign up to continue to Sarah's Blogpost"`
    },
    socialAuthOr: {
        id: 'social.auth.or',
        defaultMessage: 'or'
    },
    socialAuthOrContinueWith: {
        id: 'social.auth.or-continue-with',
        defaultMessage: 'Or continue with:'
    },
    headerTitle: {
        id: 'signup.header.title',
        defaultMessage: 'Sign up to continue',
        description: 'Shown before the login form. e.g. "Sign up first then we will show you the content you requested"'
    },
    startCollaboratingHeaderTitle: {
        id: 'welcome.header.start.collaborating.title',
        defaultMessage: 'Sign up to start collaborating',
        description: 'Shown before the signup form. e.g. "Sign up first then we will show you the content you requested"'
    },
    headerWACExperiment: {
        id: 'welcome.signup.wac.header.title',
        defaultMessage: 'Add your account details',
        description: 'Heading for the signup form'
    },
    subheadingWACExperiment: {
        id: 'welcome.signup.wac.subheading.title',
        defaultMessage: 'This account can be used for {productName} and any other Atlassian product you add in the future.',
        description: 'Subheading for the signup form. productName is the name of the product the user is signing up for, e.g. "This account can be used for Jira and ..."'
    }
});

});

parcelRegister("fmCfK", function(module, exports) {
$parcel$export(module.exports, "WelcomeHeader", function () { return (parcelRequire("6KAi4")).WelcomeHeader; });
parcelRequire("6KAi4");

});
parcelRegister("6KAi4", function(module, exports) {

$parcel$export(module.exports, "WelcomeHeader", function () { return $da38bda79b3adcc3$export$8e8630c5f5e8e2b0; });

var $ty6PY = parcelRequire("ty6PY");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $5BHjB = parcelRequire("5BHjB");

var $5VQjR = parcelRequire("5VQjR");

var $pnolE = parcelRequire("pnolE");

var $pegyt = parcelRequire("pegyt");

var $27nmU = parcelRequire("27nmU");
parcelRequire("gUzPq");
var $dm4jh = parcelRequire("dm4jh");
const $da38bda79b3adcc3$export$8e8630c5f5e8e2b0 = ()=>{
    const { state: { redirectType: redirectType } = {} } = (0, $dm4jh.useWelcomeState)();
    switch(redirectType){
        case 'signup':
        case 'resume_signup':
            return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $27nmU.HeaderWrapper), {
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsxs)((0, $27nmU.TitleWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                                as: 'h1',
                                size: 'small',
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $pegyt.default).emailVerifiedTitle))
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5BHjB))), {
                                size: "small",
                                label: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                        as: 'h2',
                        size: 'xxsmall',
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $pegyt.default).subheadingResumeSignup))
                    })
                ]
            });
        case 'invite':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $pnolE.default).inviteTitle))
            });
        case 'migration':
        case 'resume_migration':
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $pegyt.default).subheadingMigration))
            });
        default:
            return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5VQjR.default), {
                as: 'h1',
                size: 'small',
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), (0, $ty6PY._)({}, (0, $pegyt.default).subheadingResumeSignup))
            });
    }
};

});
parcelRegister("pnolE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca7ccb1bf1aa3cd1$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $ca7ccb1bf1aa3cd1$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: 'signup.head.title',
        defaultMessage: 'Sign up'
    },
    inviteTitle: {
        id: 'signup.invite.title',
        defaultMessage: 'Sign up to join your team'
    },
    titleNormal: {
        id: 'invitesignup.title.normal',
        defaultMessage: 'We need a few details, to create an account for {email}'
    }
});

});

parcelRegister("27nmU", function(module, exports) {

$parcel$export(module.exports, "HeaderWrapper", function () { return $1cdcfb8d9f61c4d5$export$960a49cc3d27a090; });
$parcel$export(module.exports, "TitleWrapper", function () { return $1cdcfb8d9f61c4d5$export$585a3b23e887288b; });

var $9Vz68 = parcelRequire("9Vz68");

var $kTdw7 = parcelRequire("kTdw7");
let $1cdcfb8d9f61c4d5$var$_ = (t)=>t, $1cdcfb8d9f61c4d5$var$t, $1cdcfb8d9f61c4d5$var$t1;
const $1cdcfb8d9f61c4d5$export$960a49cc3d27a090 = (0, $9Vz68.default).div($1cdcfb8d9f61c4d5$var$t || ($1cdcfb8d9f61c4d5$var$t = $1cdcfb8d9f61c4d5$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
`));
const $1cdcfb8d9f61c4d5$export$585a3b23e887288b = (0, $9Vz68.default).div($1cdcfb8d9f61c4d5$var$t1 || ($1cdcfb8d9f61c4d5$var$t1 = $1cdcfb8d9f61c4d5$var$_`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  svg {
    margin-left: 4px;
    color: ${0};
  }
`), (0, $kTdw7).G400);

});







parcelRegister("bGowL", function(module, exports) {

$parcel$export(module.exports, "Mutation", function () { return $8816a4920e39c68d$export$17b8b19c814bcf56; });
$parcel$export(module.exports, "getDefaultState", function () { return $8816a4920e39c68d$export$a1659b54bac3252a; });

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $eoogg = parcelRequire("eoogg");

var $7iBIE = parcelRequire("7iBIE");

var $13OCx = parcelRequire("13OCx");

var $hGQfz = parcelRequire("hGQfz");
// CLASS
class $8816a4920e39c68d$export$17b8b19c814bcf56 extends (0, $13OCx.Removable) {
    setOptions(options) {
        this.options = (0, $ty6PY._)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $hGQfz.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        failureCount: action.failureCount,
                        failureReason: action.error
                    });
                case 'pause':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        isPaused: true
                    });
                case 'continue':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        isPaused: false
                    });
                case 'loading':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $hGQfz.canFetch)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    });
                case 'success':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    });
                case 'error':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    });
                case 'setState':
                    return (0, $ty6PY._)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $7iBIE.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $eoogg.defaultLogger);
        this.observers = [];
        this.state = config.state || $8816a4920e39c68d$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $8816a4920e39c68d$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}

});
parcelRegister("eoogg", function(module, exports) {

$parcel$export(module.exports, "defaultLogger", function () { return $a7a62065dcd8c6cb$export$1cf3d545f2d4635c; });
const $a7a62065dcd8c6cb$export$1cf3d545f2d4635c = console;

});

parcelRegister("13OCx", function(module, exports) {

$parcel$export(module.exports, "Removable", function () { return $0c5d56767fd842d9$export$e09608847fcc8c59; });

var $eyuWU = parcelRequire("eyuWU");
class $0c5d56767fd842d9$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $eyuWU.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $eyuWU.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}

});


var $0c75de60f607a9ea$exports = {};


(parcelRequire("WpYDg")).register((parcelRequire("5ptLS")).getBundleURL('7VwIV'), JSON.parse("[\"7VwIV\",\"index.b81438b1.js\",\"iNurv\",\"Error.b0f67bec.svg\",\"69GGh\",\"web-vitals.f8eeb03d.js\",\"38OVK\",\"tti-polyfill.b32f9fdc.js\",\"fxF5P\",\"castle.6bf8aa43.js\",\"ftyoZ\",\"pt-BR.7a74dc74.js\",\"61GGu\",\"en-ZZ.6e8800d9.js\",\"2lNCA\",\"en-GB.19eed1b7.js\",\"buCkT\",\"zh-CN.6b1826b8.js\",\"fZ5pR\",\"zh-TW.46528492.js\",\"9YoXx\",\"cs-CZ.ce334810.js\",\"lJivj\",\"da-DK.4cbd939f.js\",\"ilWCw\",\"de-DE.65b7468b.js\",\"4C5B7\",\"en.41036dc5.js\",\"agqiQ\",\"es.4f97cb7b.js\",\"cbcf1\",\"fi-FI.f6fb1fb8.js\",\"assWM\",\"fr-FR.9bd2890f.js\",\"et9BZ\",\"hu-HU.70a4111e.js\",\"fOCIn\",\"it-IT.c65c0706.js\",\"fgQyO\",\"ja-JP.d52b38c1.js\",\"7po9d\",\"ko-KR.935b0072.js\",\"iSFDb\",\"nb-NO.d5b15b32.js\",\"eN5Fq\",\"nl-NL.638b8233.js\",\"1bASk\",\"pl-PL.f8941783.js\",\"johxQ\",\"ru-RU.c932cae1.js\",\"1ec6N\",\"sv-SE.a5a02b72.js\",\"a4TDP\",\"th-TH.d614a305.js\",\"GXJZ8\",\"tr-TR.becc64c6.js\",\"e6XXT\",\"uk-UA.cebabc21.js\",\"ajfHd\",\"vi-VN.73b0475e.js\",\"5RhAq\",\"atlassian-light.7c2fe7d3.js\",\"gK1Yq\",\"atlassian-light-future.2b237760.js\",\"9gbDH\",\"atlassian-light-increased-contrast.e7a672c9.js\",\"4Oijb\",\"atlassian-dark.3fcc7f5b.js\",\"j2dhL\",\"atlassian-dark-future.f6f5b406.js\",\"95iyH\",\"atlassian-dark-increased-contrast.e6d3707a.js\",\"f6mth\",\"atlassian-legacy-light.aa7500fa.js\",\"02w4q\",\"atlassian-legacy-dark.0128ca78.js\",\"lTbXm\",\"atlassian-spacing.f7f6b610.js\",\"80IXv\",\"atlassian-typography.f88b1886.js\",\"3XOdM\",\"atlassian-typography-adg3.c95cbd27.js\",\"bd7QQ\",\"atlassian-shape.efc43406.js\",\"7PqAR\",\"atlassian-shape-rounder.e7d2d0d0.js\",\"fwQFC\",\"atlassian-shape-roundest.34d8a761.js\",\"dKPoJ\",\"atlassian-typography-modernized.3b3558af.js\",\"jP2fr\",\"atlassian-typography-refreshed.83c13808.js\",\"aMC4s\",\"atlassian-light-brand-refresh.26d43e83.js\",\"6Amvt\",\"atlassian-dark-brand-refresh.53d41b29.js\",\"e0PVZ\",\"custom-theme.4ceb55c7.js\",\"7GeoT\",\"MfaAppsPage.a93bfa7a.js\",\"2I1PI\",\"authy_icon.814b7ffa.png\",\"lQF32\",\"duo_icon.b136e666.png\",\"4OuJ3\",\"google_authenticator_icon.e16260d2.png\",\"4N04D\",\"other_app_icon.d89fb9f9.svg\",\"2wzjx\",\"check-your-email-open-letter.58fc87ea.svg\",\"4JF1U\",\"default_left.dfc31853.svg\",\"4qfVe\",\"default_right.a801c0cc.svg\",\"hE3pQ\",\"opsgenie-left.49c0f64b.svg\",\"hD9Vo\",\"opsgenie-right.77c52ee2.svg\",\"aNwmN\",\"statuspage-left.6c5cd6d4.svg\",\"i3YuR\",\"statuspage-right.447da08b.svg\",\"3lDFB\",\"trello-left.4f52d13c.svg\",\"843Uy\",\"trello-right.e6e102c7.svg\",\"bg1SA\",\"wac.92a80da2.svg\",\"8bkOw\",\"trust-and-security.2e60671c.svg\",\"gxhbY\",\"MfaEnrollmentPage.c83a68f4.js\",\"heL7e\",\"mfa-enable.f2e108a8.png\",\"inzfR\",\"security-wall.788bd489.svg\",\"1XojH\",\"lock-closed.59f9256b.svg\",\"8k8MH\",\"check-your-email.39bc0dca.svg\",\"6KPGI\",\"save-recovery-key.57011d69.svg\",\"1gsC9\",\"LoginConsentNoticePage.9a77a022.js\",\"l9p8w\",\"fedramp.d0a69cf4.js\",\"inezq\",\"a53d6b63-3k57-1408-j79d-0b60b08kb685-privacy.bfa0bd3f.js\",\"2XyyO\",\"2a85b822-1ba4-44ec-968a-c2f95bf4b469-privacy.054e847a.js\",\"7T0Aw\",\"6e62b4f0-a2f3-4cb5-b61c-1bd397640f04-privacy.8b0fd471.js\",\"7Bk3r\",\"cancel-deletion-hourglass.714e127f.svg\",\"1b58t\",\"InactiveAccountPage.7d4ba0f9.js\",\"498HI\",\"lock.10ed9279.svg\",\"iAwwt\",\"PendingDeletionPage.25a7ea40.js\",\"fJ1OD\",\"DeletionRequestConfirmationPage.e063185d.js\",\"hap0O\",\"main.c4a50582.js\",\"gRQp7\",\"AuthCallbackErrorPage.8629a088.js\",\"5Ycje\",\"SecurityExpiredLinkPage.e1b133eb.js\",\"ldkNR\",\"SecuritySuccessPage.48d8cfc2.js\",\"1xGEb\",\"MfaEnrollmentChooseMethodPage.fd64bd60.js\",\"2LWIJ\",\"MfaEnrollmentChooseMethodPage.0ac0d175.js\",\"jQoZC\",\"MfaEnrollmentConfigurePhonePage.88fb5731.js\",\"S6oZD\",\"phone_black_message.b83c9523.png\",\"59bCS\",\"MfaEnrollmentConfigurePhonePage.014fac5f.js\",\"bRVWW\",\"MfaEnrollmentConfigureAppPage.0d900250.js\",\"jWnnk\",\"configure_app_desktop.e3f196e8.svg\",\"2GE3c\",\"MfaEnrollmentSaveRecoveryKeyPage.4a4f5c08.js\",\"d7q9g\",\"MfaEnrollmentRegisterSecurityKeyPage.bd8b7561.js\",\"2QftC\",\"MfaEnrollmentRegisterSecurityKeyPage.5e9bc94a.js\",\"hn1ai\",\"MultiMfaEnrollmentAddAuthenticatorPage.25cf3f35.js\",\"hGrAk\",\"MultiMfaEnrollmentAddSecurityKeyPage.ad309004.js\",\"Ou8I6\",\"page.79bc4b80.js\",\"kOtYg\",\"LoginPage.3145ec82.js\",\"kUGxn\",\"LoginPage.b2c73515.js\",\"b1Jii\",\"LoginPage.b35bc14e.js\",\"11E2B\",\"defaultPage.60f9e3f9.js\",\"58K0P\",\"login-page.eb7e5847.js\",\"gzceX\",\"login-page.77915c37.js\",\"e4Yfr\",\"LoginPage.46b486a1.js\",\"7sZoS\",\"apple-logo.54e0d711.svg\",\"aTIOo\",\"google-logo.5867462c.svg\",\"h9Swc\",\"microsoft-logo.c73d8dca.svg\",\"j4nll\",\"slack-logo.5d730c10.svg\",\"udxJU\",\"loom-atlassian-logo.72f9b02d.svg\",\"6Bi4f\",\"LoginPage.ea0b1f1c.js\",\"oTLOT\",\"BasePage.735771b8.js\",\"hseuv\",\"key-logo.39b27441.svg\",\"hIuXM\",\"page.16c26eef.js\",\"aCATi\",\"CreateAccountConfirmationPage.3b77b0d7.js\",\"kNMcW\",\"CreateAccountConfirmationPage.624ac0db.js\",\"8X3jm\",\"defaultPage.ff2d813b.js\",\"lah4S\",\"defaultPage.84ce4ff6.js\",\"iKhTp\",\"custom-theme.8a60ec3e.js\",\"iPH5P\",\"atlassian-light.7ddf261f.js\",\"lvdlC\",\"atlassian-light-future.f58d00bc.js\",\"kKNwF\",\"atlassian-light-increased-contrast.0a2ef825.js\",\"9Gbup\",\"atlassian-dark.465a4356.js\",\"uREXG\",\"atlassian-dark-future.c2b6ddd7.js\",\"gEtDF\",\"atlassian-dark-increased-contrast.0f3d2eb4.js\",\"e00jf\",\"atlassian-legacy-light.f7db4075.js\",\"frYDR\",\"atlassian-legacy-dark.df99b051.js\",\"jBrSn\",\"atlassian-spacing.96f063f5.js\",\"fHoue\",\"atlassian-typography-adg3.d0342b16.js\",\"47aRS\",\"atlassian-shape.2d1e38d3.js\",\"4oCj6\",\"atlassian-typography-modernized.2a96f974.js\",\"hcB1y\",\"atlassian-typography-refreshed.f0053d17.js\",\"4Y2jm\",\"atlassian-light-brand-refresh.849c4bd2.js\",\"4qVzd\",\"atlassian-dark-brand-refresh.22fdaa02.js\",\"870jg\",\"defaultPage.d7580f9b.js\",\"ejRVX\",\"defaultPage.c2ac81be.js\",\"68l8J\",\"defaultPage.24dcccc8.js\",\"6UQDE\",\"defaultPage.416c49bd.css\",\"3bNK5\",\"defaultPage.bcb20278.js\",\"aF8uR\",\"defaultPage.614271b3.js\",\"ddSVw\",\"defaultPage.b844f3ad.js\",\"jGJf3\",\"defaultPage.10cb03b0.css\",\"ltJcJ\",\"SocialWelcomePage.42ac181c.js\",\"bh62i\",\"SocialWelcomePage.369d1851.js\",\"iRfkW\",\"routing-middleware.cdeebfc0.js\",\"bqGv8\",\"ajs-destination.e5d3416e.js\",\"guxk7\",\"legacy-video-plugins.f1e2c228.js\",\"8qqJr\",\"index.umd.9e289656.js\",\"hszcO\",\"schema-filter.5923b99a.js\",\"ahZLe\",\"remote-middleware.2ee6aa31.js\",\"d78Gr\",\"auto-track.3f8b99f8.js\",\"hft9v\",\"query-string.56e4449a.js\",\"fzp2b\",\"SocialWelcomePage.8def89ae.js\",\"46wh4\",\"SocialWelcomePage.d813e0aa.js\",\"8mHuU\",\"SocialWelcomePage.439baa23.js\",\"djFKR\",\"SocialWelcomePage.37823370.js\",\"fUzKI\",\"SocialWelcomePage.2ff8ef39.js\",\"79lNF\",\"SocialWelcomePage.6466ee8d.css\",\"1lBiz\",\"SocialWelcomePage.c8d8758f.js\",\"lEnzc\",\"SocialWelcomePage.254c45e6.css\",\"hExuV\",\"page.18f3652c.js\",\"1ry2J\",\"WelcomePage.74df7450.js\",\"8XR2E\",\"defaultPage.02f263af.js\",\"gNcSN\",\"defaultPage.b7d9c1be.js\",\"hzpXu\",\"defaultPage.41e71198.css\",\"1UfEd\",\"defaultPage.0978be00.js\",\"kmr7H\",\"defaultPage.6520a1f1.css\",\"fGdTB\",\"defaultPage.0ab332a1.js\",\"hzoJ6\",\"defaultPage.03a35f89.css\",\"iE5iE\",\"WelcomePage.41331fe1.js\",\"aByvu\",\"WelcomePage.f4f42a87.js\",\"sTafr\",\"WelcomePage.65fc6d6e.css\",\"cx1P8\",\"WelcomePage.f2cf7283.js\",\"7nIRl\",\"WelcomePage.eec182e2.css\",\"1FLJ3\",\"WelcomePage.d424a64e.js\",\"enut8\",\"WelcomePage.7354f62d.css\",\"4u6Nq\",\"WelcomePage.3f5fdb39.js\",\"3CDCH\",\"WelcomePage.c5eaf73d.css\",\"7K3fd\",\"WelcomePage.d699d50f.js\",\"cWOlE\",\"WelcomePage.8b7060e0.css\",\"3q3uM\",\"page.3625b956.js\",\"cwXjI\",\"OrchestratedPage.4b4f5b3d.js\",\"12N2v\",\"VerifyEmailOtpPage.b4f4792f.js\",\"dM983\",\"defaultPage.24f6adec.js\",\"hHDiS\",\"defaultPage.ed1381cb.js\",\"3JCU9\",\"defaultPage.31cda5d3.css\",\"drURt\",\"defaultPage.1f19e602.js\",\"6x08c\",\"defaultPage.9b086b94.css\",\"2tEkF\",\"defaultPage.62b1154a.js\",\"hVjZI\",\"OtpPage.dace34d1.js\",\"3xvPh\",\"OtpPage.7100290a.js\",\"evnvM\",\"OtpPage.668da847.js\",\"5oOiT\",\"OtpPage.94331150.js\",\"6vn86\",\"OtpPage.3d892794.js\",\"esFgw\",\"OtpPage.dcea6d86.css\",\"1GkoK\",\"OtpPage.c6448ac2.js\",\"bDq2p\",\"OtpPage.bee8b9ce.css\",\"i6HCB\",\"page.dd93e395.js\",\"du5sD\",\"OrchestratedPage.4c1b04a0.js\",\"hsbG6\",\"BasePage.621ab5ee.js\",\"kQdzn\",\"page.58d45eb7.js\",\"eawEb\",\"SignupPage.53ce2a50.js\",\"9kWCW\",\"SignupPage.04d8d66a.js\",\"dGJGd\",\"colby.9b10f128.png\",\"6B76X\",\"signup-page.6811a9fb.js\",\"h7Lx1\",\"signup-page.1b0819b7.js\",\"4aatB\",\"page.58fa419b.js\",\"cZpGd\",\"SignupOnboardPage.0e27fe90.js\",\"04kWc\",\"BasePage.4a49a1ce.js\",\"4KusB\",\"LoomWorkspaceCreationPage.53f7c97d.js\",\"5oavH\",\"index.60abf0f0.css\"]"));


var $6rcps = parcelRequire("6rcps");
/**
 * CoreJS https://github.com/zloirock/core-js
 * Our package.json['browserslist'] drives how Parcel/swc polyfills our application.
 * However we want to manually polyfill a handful of features that enables more of the application for more users.
 */ 'use strict';
'use strict';
var $75395d4d1502b249$exports = {};
'use strict';
var $e70b94985eb51192$exports = {};
'use strict';
var $e70b94985eb51192$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$e70b94985eb51192$exports = // eslint-disable-next-line es/no-global-this -- safe
$e70b94985eb51192$var$check(typeof globalThis == 'object' && globalThis) || $e70b94985eb51192$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$e70b94985eb51192$var$check(typeof self == 'object' && self) || $e70b94985eb51192$var$check(typeof $parcel$global == 'object' && $parcel$global) || $e70b94985eb51192$var$check(typeof $e70b94985eb51192$exports == 'object' && $e70b94985eb51192$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $ce77c1f0936b11bf$export$2d1720544b23b823;
'use strict';
var $52f9c610bf0521fc$exports = {};
'use strict';
var $7fbdf4c0599ef462$exports = {};
'use strict';
$7fbdf4c0599ef462$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$52f9c610bf0521fc$exports = !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $0c06b1aeebe22a6e$exports = {};
'use strict';
var $e66e7bf0d4cfee4a$exports = {};
'use strict';

$e66e7bf0d4cfee4a$exports = !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $0c06b1aeebe22a6e$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$0c06b1aeebe22a6e$exports = $e66e7bf0d4cfee4a$exports ? $0c06b1aeebe22a6e$var$call.bind($0c06b1aeebe22a6e$var$call) : function() {
    return $0c06b1aeebe22a6e$var$call.apply($0c06b1aeebe22a6e$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $3f7aa21c8f18f10f$export$2d1720544b23b823;
'use strict';
var $3f7aa21c8f18f10f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3f7aa21c8f18f10f$var$NASHORN_BUG = $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor && !$3f7aa21c8f18f10f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$3f7aa21c8f18f10f$export$2d1720544b23b823 = $3f7aa21c8f18f10f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3f7aa21c8f18f10f$var$$propertyIsEnumerable;


var $280423f212a26849$exports = {};
'use strict';
$280423f212a26849$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $9d811c44f1b32f82$exports = {};
'use strict';
var $07c591c29318e081$exports = {};
'use strict';
var $c800df2b7efc8f14$exports = {};
'use strict';

var $c800df2b7efc8f14$var$FunctionPrototype = Function.prototype;
var $c800df2b7efc8f14$var$call = $c800df2b7efc8f14$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $c800df2b7efc8f14$var$uncurryThisWithBind = $e66e7bf0d4cfee4a$exports && $c800df2b7efc8f14$var$FunctionPrototype.bind.bind($c800df2b7efc8f14$var$call, $c800df2b7efc8f14$var$call);
$c800df2b7efc8f14$exports = $e66e7bf0d4cfee4a$exports ? $c800df2b7efc8f14$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c800df2b7efc8f14$var$call.apply(fn, arguments);
    };
};



var $6b7f47111eaca73a$exports = {};
'use strict';

var $6b7f47111eaca73a$var$toString = $c800df2b7efc8f14$exports({}.toString);
var $6b7f47111eaca73a$var$stringSlice = $c800df2b7efc8f14$exports(''.slice);
$6b7f47111eaca73a$exports = function(it) {
    return $6b7f47111eaca73a$var$stringSlice($6b7f47111eaca73a$var$toString(it), 8, -1);
};


var $07c591c29318e081$var$$Object = Object;
var $07c591c29318e081$var$split = $c800df2b7efc8f14$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$07c591c29318e081$exports = $7fbdf4c0599ef462$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$07c591c29318e081$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $6b7f47111eaca73a$exports(it) === 'String' ? $07c591c29318e081$var$split(it, '') : $07c591c29318e081$var$$Object(it);
} : $07c591c29318e081$var$$Object;


var $dc13fa5d6a969043$exports = {};
'use strict';
var $4961f37f7ea715b0$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$4961f37f7ea715b0$exports = function(it) {
    return it === null || it === undefined;
};


var $dc13fa5d6a969043$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$dc13fa5d6a969043$exports = function(it) {
    if ($4961f37f7ea715b0$exports(it)) throw new $dc13fa5d6a969043$var$$TypeError("Can't call method on " + it);
    return it;
};


$9d811c44f1b32f82$exports = function(it) {
    return $07c591c29318e081$exports($dc13fa5d6a969043$exports(it));
};


var $557ce3c5a27f1e8c$exports = {};
'use strict';
var $40e7e1ffc2bc7815$exports = {};
'use strict';

var $fbd29800d02822fa$exports = {};
'use strict';
var $a7eaff0338821e23$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $a7eaff0338821e23$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$a7eaff0338821e23$exports = typeof $a7eaff0338821e23$var$documentAll == 'undefined' && $a7eaff0338821e23$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $a7eaff0338821e23$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$fbd29800d02822fa$exports = function(it) {
    return typeof it == 'object' ? it !== null : $a7eaff0338821e23$exports(it);
};


var $ddbceefbd7001b7f$exports = {};
'use strict';
var $4ea75fe1d4279dda$exports = {};
'use strict';


var $4ea75fe1d4279dda$var$aFunction = function(argument) {
    return $a7eaff0338821e23$exports(argument) ? argument : undefined;
};
$4ea75fe1d4279dda$exports = function(namespace, method) {
    return arguments.length < 2 ? $4ea75fe1d4279dda$var$aFunction($e70b94985eb51192$exports[namespace]) : $e70b94985eb51192$exports[namespace] && $e70b94985eb51192$exports[namespace][method];
};



var $931b0ab7ad810eb0$exports = {};
'use strict';

$931b0ab7ad810eb0$exports = $c800df2b7efc8f14$exports({}.isPrototypeOf);


var $9523c6a2ad8fa394$exports = {};
'use strict';
var $8a705df41e267127$exports = {};
'use strict';
var $131f458e39339f96$exports = {};
'use strict';

var $8087c5854054bb14$exports = {};
'use strict';

var $8087c5854054bb14$var$navigator = $e70b94985eb51192$exports.navigator;
var $8087c5854054bb14$var$userAgent = $8087c5854054bb14$var$navigator && $8087c5854054bb14$var$navigator.userAgent;
$8087c5854054bb14$exports = $8087c5854054bb14$var$userAgent ? String($8087c5854054bb14$var$userAgent) : '';


var $131f458e39339f96$var$process = $e70b94985eb51192$exports.process;
var $131f458e39339f96$var$Deno = $e70b94985eb51192$exports.Deno;
var $131f458e39339f96$var$versions = $131f458e39339f96$var$process && $131f458e39339f96$var$process.versions || $131f458e39339f96$var$Deno && $131f458e39339f96$var$Deno.version;
var $131f458e39339f96$var$v8 = $131f458e39339f96$var$versions && $131f458e39339f96$var$versions.v8;
var $131f458e39339f96$var$match, $131f458e39339f96$var$version;
if ($131f458e39339f96$var$v8) {
    $131f458e39339f96$var$match = $131f458e39339f96$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $131f458e39339f96$var$version = $131f458e39339f96$var$match[0] > 0 && $131f458e39339f96$var$match[0] < 4 ? 1 : +($131f458e39339f96$var$match[0] + $131f458e39339f96$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$131f458e39339f96$var$version && $8087c5854054bb14$exports) {
    $131f458e39339f96$var$match = $8087c5854054bb14$exports.match(/Edge\/(\d+)/);
    if (!$131f458e39339f96$var$match || $131f458e39339f96$var$match[1] >= 74) {
        $131f458e39339f96$var$match = $8087c5854054bb14$exports.match(/Chrome\/(\d+)/);
        if ($131f458e39339f96$var$match) $131f458e39339f96$var$version = +$131f458e39339f96$var$match[1];
    }
}
$131f458e39339f96$exports = $131f458e39339f96$var$version;




var $8a705df41e267127$var$$String = $e70b94985eb51192$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$8a705df41e267127$exports = !!Object.getOwnPropertySymbols && !$7fbdf4c0599ef462$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$8a705df41e267127$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $131f458e39339f96$exports && $131f458e39339f96$exports < 41;
});


$9523c6a2ad8fa394$exports = $8a705df41e267127$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $ddbceefbd7001b7f$var$$Object = Object;
$ddbceefbd7001b7f$exports = $9523c6a2ad8fa394$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $4ea75fe1d4279dda$exports('Symbol');
    return $a7eaff0338821e23$exports($Symbol) && $931b0ab7ad810eb0$exports($Symbol.prototype, $ddbceefbd7001b7f$var$$Object(it));
};


var $f32de95dd0610261$exports = {};
'use strict';
var $11648e8ec26b6ecd$exports = {};
'use strict';

var $ff2dcd98892ae4f4$exports = {};
'use strict';
var $ff2dcd98892ae4f4$var$$String = String;
$ff2dcd98892ae4f4$exports = function(argument) {
    try {
        return $ff2dcd98892ae4f4$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $11648e8ec26b6ecd$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$11648e8ec26b6ecd$exports = function(argument) {
    if ($a7eaff0338821e23$exports(argument)) return argument;
    throw new $11648e8ec26b6ecd$var$$TypeError($ff2dcd98892ae4f4$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$f32de95dd0610261$exports = function(V, P) {
    var func = V[P];
    return $4961f37f7ea715b0$exports(func) ? undefined : $11648e8ec26b6ecd$exports(func);
};


var $1f3ca27c7e1ee501$exports = {};
'use strict';



var $1f3ca27c7e1ee501$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$1f3ca27c7e1ee501$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $a7eaff0338821e23$exports(fn = input.toString) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    if ($a7eaff0338821e23$exports(fn = input.valueOf) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    if (pref !== 'string' && $a7eaff0338821e23$exports(fn = input.toString) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    throw new $1f3ca27c7e1ee501$var$$TypeError("Can't convert object to primitive value");
};


var $0b105ffe14c0d5a5$exports = {};
'use strict';

var $de060b0c07c00dae$exports = {};
'use strict';
var $7b0d7577e35530be$exports = {};
'use strict';
var $6ad9df1f2e7ebd85$exports = {};
'use strict';
$6ad9df1f2e7ebd85$exports = false;



var $7f3648e7cf38ebc9$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7f3648e7cf38ebc9$var$defineProperty = Object.defineProperty;
$7f3648e7cf38ebc9$exports = function(key, value) {
    try {
        $7f3648e7cf38ebc9$var$defineProperty($e70b94985eb51192$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $e70b94985eb51192$exports[key] = value;
    }
    return value;
};


var $7b0d7577e35530be$var$SHARED = '__core-js_shared__';
var $7b0d7577e35530be$var$store = $7b0d7577e35530be$exports = $e70b94985eb51192$exports[$7b0d7577e35530be$var$SHARED] || $7f3648e7cf38ebc9$exports($7b0d7577e35530be$var$SHARED, {});
($7b0d7577e35530be$var$store.versions || ($7b0d7577e35530be$var$store.versions = [])).push({
    version: '3.40.0',
    mode: $6ad9df1f2e7ebd85$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.40.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$de060b0c07c00dae$exports = function(key, value) {
    return $7b0d7577e35530be$exports[key] || ($7b0d7577e35530be$exports[key] = value || {});
};


var $cad4bbfed17498c2$exports = {};
'use strict';

var $9979de0a9e7dae17$exports = {};
'use strict';

var $9979de0a9e7dae17$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$9979de0a9e7dae17$exports = function(argument) {
    return $9979de0a9e7dae17$var$$Object($dc13fa5d6a969043$exports(argument));
};


var $cad4bbfed17498c2$var$hasOwnProperty = $c800df2b7efc8f14$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$cad4bbfed17498c2$exports = Object.hasOwn || function hasOwn(it, key) {
    return $cad4bbfed17498c2$var$hasOwnProperty($9979de0a9e7dae17$exports(it), key);
};


var $00c072c5b94e6c06$exports = {};
'use strict';

var $00c072c5b94e6c06$var$id = 0;
var $00c072c5b94e6c06$var$postfix = Math.random();
var $00c072c5b94e6c06$var$toString = $c800df2b7efc8f14$exports(1.0.toString);
$00c072c5b94e6c06$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $00c072c5b94e6c06$var$toString(++$00c072c5b94e6c06$var$id + $00c072c5b94e6c06$var$postfix, 36);
};




var $0b105ffe14c0d5a5$var$Symbol = $e70b94985eb51192$exports.Symbol;
var $0b105ffe14c0d5a5$var$WellKnownSymbolsStore = $de060b0c07c00dae$exports('wks');
var $0b105ffe14c0d5a5$var$createWellKnownSymbol = $9523c6a2ad8fa394$exports ? $0b105ffe14c0d5a5$var$Symbol['for'] || $0b105ffe14c0d5a5$var$Symbol : $0b105ffe14c0d5a5$var$Symbol && $0b105ffe14c0d5a5$var$Symbol.withoutSetter || $00c072c5b94e6c06$exports;
$0b105ffe14c0d5a5$exports = function(name) {
    if (!$cad4bbfed17498c2$exports($0b105ffe14c0d5a5$var$WellKnownSymbolsStore, name)) $0b105ffe14c0d5a5$var$WellKnownSymbolsStore[name] = $8a705df41e267127$exports && $cad4bbfed17498c2$exports($0b105ffe14c0d5a5$var$Symbol, name) ? $0b105ffe14c0d5a5$var$Symbol[name] : $0b105ffe14c0d5a5$var$createWellKnownSymbol('Symbol.' + name);
    return $0b105ffe14c0d5a5$var$WellKnownSymbolsStore[name];
};


var $40e7e1ffc2bc7815$var$$TypeError = TypeError;
var $40e7e1ffc2bc7815$var$TO_PRIMITIVE = $0b105ffe14c0d5a5$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$40e7e1ffc2bc7815$exports = function(input, pref) {
    if (!$fbd29800d02822fa$exports(input) || $ddbceefbd7001b7f$exports(input)) return input;
    var exoticToPrim = $f32de95dd0610261$exports(input, $40e7e1ffc2bc7815$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $0c06b1aeebe22a6e$exports(exoticToPrim, input, pref);
        if (!$fbd29800d02822fa$exports(result) || $ddbceefbd7001b7f$exports(result)) return result;
        throw new $40e7e1ffc2bc7815$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $1f3ca27c7e1ee501$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$557ce3c5a27f1e8c$exports = function(argument) {
    var key = $40e7e1ffc2bc7815$exports(argument, 'string');
    return $ddbceefbd7001b7f$exports(key) ? key : key + '';
};



var $2fc96a6036cafd3b$exports = {};
'use strict';


var $c5824977ab5a14ea$exports = {};
'use strict';


var $c5824977ab5a14ea$var$document = $e70b94985eb51192$exports.document;
// typeof document.createElement is 'object' in old IE
var $c5824977ab5a14ea$var$EXISTS = $fbd29800d02822fa$exports($c5824977ab5a14ea$var$document) && $fbd29800d02822fa$exports($c5824977ab5a14ea$var$document.createElement);
$c5824977ab5a14ea$exports = function(it) {
    return $c5824977ab5a14ea$var$EXISTS ? $c5824977ab5a14ea$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$2fc96a6036cafd3b$exports = !$52f9c610bf0521fc$exports && !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($c5824977ab5a14ea$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$ce77c1f0936b11bf$export$2d1720544b23b823 = $52f9c610bf0521fc$exports ? $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $9d811c44f1b32f82$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    if ($2fc96a6036cafd3b$exports) try {
        return $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($cad4bbfed17498c2$exports(O, P)) return $280423f212a26849$exports(!$0c06b1aeebe22a6e$exports($3f7aa21c8f18f10f$export$2d1720544b23b823, O, P), O[P]);
};


var $75395d4d1502b249$require$getOwnPropertyDescriptor = $ce77c1f0936b11bf$export$2d1720544b23b823;
var $13b85566beee9498$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $722eb9ecceb224f8$export$2d1720544b23b823;
'use strict';


var $76b8d485b6e52872$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$76b8d485b6e52872$exports = $52f9c610bf0521fc$exports && $7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $3972fdbff685207b$exports = {};
'use strict';

var $3972fdbff685207b$var$$String = String;
var $3972fdbff685207b$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3972fdbff685207b$exports = function(argument) {
    if ($fbd29800d02822fa$exports(argument)) return argument;
    throw new $3972fdbff685207b$var$$TypeError($3972fdbff685207b$var$$String(argument) + ' is not an object');
};



var $722eb9ecceb224f8$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $722eb9ecceb224f8$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $722eb9ecceb224f8$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $722eb9ecceb224f8$var$ENUMERABLE = 'enumerable';
var $722eb9ecceb224f8$var$CONFIGURABLE = 'configurable';
var $722eb9ecceb224f8$var$WRITABLE = 'writable';
$722eb9ecceb224f8$export$2d1720544b23b823 = $52f9c610bf0521fc$exports ? $76b8d485b6e52872$exports ? function defineProperty(O, P, Attributes) {
    $3972fdbff685207b$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    $3972fdbff685207b$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $722eb9ecceb224f8$var$WRITABLE in Attributes && !Attributes[$722eb9ecceb224f8$var$WRITABLE]) {
        var current = $722eb9ecceb224f8$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$722eb9ecceb224f8$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $722eb9ecceb224f8$var$CONFIGURABLE in Attributes ? Attributes[$722eb9ecceb224f8$var$CONFIGURABLE] : current[$722eb9ecceb224f8$var$CONFIGURABLE],
                enumerable: $722eb9ecceb224f8$var$ENUMERABLE in Attributes ? Attributes[$722eb9ecceb224f8$var$ENUMERABLE] : current[$722eb9ecceb224f8$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $722eb9ecceb224f8$var$$defineProperty(O, P, Attributes);
} : $722eb9ecceb224f8$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3972fdbff685207b$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    $3972fdbff685207b$exports(Attributes);
    if ($2fc96a6036cafd3b$exports) try {
        return $722eb9ecceb224f8$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $722eb9ecceb224f8$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$13b85566beee9498$exports = $52f9c610bf0521fc$exports ? function(object, key, value) {
    return $722eb9ecceb224f8$export$2d1720544b23b823(object, key, $280423f212a26849$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $0610e46059a94cbd$exports = {};
'use strict';


var $b9e70daef8851f0b$exports = {};
'use strict';





var $4c1919cb72ce1a0c$exports = {};
'use strict';


var $4c1919cb72ce1a0c$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4c1919cb72ce1a0c$var$getDescriptor = $52f9c610bf0521fc$exports && Object.getOwnPropertyDescriptor;
var $4c1919cb72ce1a0c$var$EXISTS = $cad4bbfed17498c2$exports($4c1919cb72ce1a0c$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $4c1919cb72ce1a0c$var$PROPER = $4c1919cb72ce1a0c$var$EXISTS && (function something() {}).name === 'something';
var $4c1919cb72ce1a0c$var$CONFIGURABLE = $4c1919cb72ce1a0c$var$EXISTS && (!$52f9c610bf0521fc$exports || $52f9c610bf0521fc$exports && $4c1919cb72ce1a0c$var$getDescriptor($4c1919cb72ce1a0c$var$FunctionPrototype, 'name').configurable);
$4c1919cb72ce1a0c$exports = {
    EXISTS: $4c1919cb72ce1a0c$var$EXISTS,
    PROPER: $4c1919cb72ce1a0c$var$PROPER,
    CONFIGURABLE: $4c1919cb72ce1a0c$var$CONFIGURABLE
};


var $b9e70daef8851f0b$require$CONFIGURABLE_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.CONFIGURABLE;
var $94b2f3bb3c74e175$exports = {};
'use strict';



var $94b2f3bb3c74e175$var$functionToString = $c800df2b7efc8f14$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$a7eaff0338821e23$exports($7b0d7577e35530be$exports.inspectSource)) $7b0d7577e35530be$exports.inspectSource = function(it) {
    return $94b2f3bb3c74e175$var$functionToString(it);
};
$94b2f3bb3c74e175$exports = $7b0d7577e35530be$exports.inspectSource;


var $f87bb15e699cf95b$exports = {};
'use strict';
var $d1fc8e6ada472082$exports = {};
'use strict';


var $d1fc8e6ada472082$var$WeakMap = $e70b94985eb51192$exports.WeakMap;
$d1fc8e6ada472082$exports = $a7eaff0338821e23$exports($d1fc8e6ada472082$var$WeakMap) && /native code/.test(String($d1fc8e6ada472082$var$WeakMap));







var $37f7417c6f6b2b99$exports = {};
'use strict';


var $37f7417c6f6b2b99$var$keys = $de060b0c07c00dae$exports('keys');
$37f7417c6f6b2b99$exports = function(key) {
    return $37f7417c6f6b2b99$var$keys[key] || ($37f7417c6f6b2b99$var$keys[key] = $00c072c5b94e6c06$exports(key));
};


var $c30c863eb145c5a8$exports = {};
'use strict';
$c30c863eb145c5a8$exports = {};


var $f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $f87bb15e699cf95b$var$TypeError = $e70b94985eb51192$exports.TypeError;
var $f87bb15e699cf95b$var$WeakMap = $e70b94985eb51192$exports.WeakMap;
var $f87bb15e699cf95b$var$set, $f87bb15e699cf95b$var$get, $f87bb15e699cf95b$var$has;
var $f87bb15e699cf95b$var$enforce = function(it) {
    return $f87bb15e699cf95b$var$has(it) ? $f87bb15e699cf95b$var$get(it) : $f87bb15e699cf95b$var$set(it, {});
};
var $f87bb15e699cf95b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$fbd29800d02822fa$exports(it) || (state = $f87bb15e699cf95b$var$get(it)).type !== TYPE) throw new $f87bb15e699cf95b$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($d1fc8e6ada472082$exports || $7b0d7577e35530be$exports.state) {
    var $f87bb15e699cf95b$var$store = $7b0d7577e35530be$exports.state || ($7b0d7577e35530be$exports.state = new $f87bb15e699cf95b$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $f87bb15e699cf95b$var$store.get = $f87bb15e699cf95b$var$store.get;
    $f87bb15e699cf95b$var$store.has = $f87bb15e699cf95b$var$store.has;
    $f87bb15e699cf95b$var$store.set = $f87bb15e699cf95b$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $f87bb15e699cf95b$var$set = function(it, metadata) {
        if ($f87bb15e699cf95b$var$store.has(it)) throw new $f87bb15e699cf95b$var$TypeError($f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f87bb15e699cf95b$var$store.set(it, metadata);
        return metadata;
    };
    $f87bb15e699cf95b$var$get = function(it) {
        return $f87bb15e699cf95b$var$store.get(it) || {};
    };
    $f87bb15e699cf95b$var$has = function(it) {
        return $f87bb15e699cf95b$var$store.has(it);
    };
} else {
    var $f87bb15e699cf95b$var$STATE = $37f7417c6f6b2b99$exports('state');
    $c30c863eb145c5a8$exports[$f87bb15e699cf95b$var$STATE] = true;
    $f87bb15e699cf95b$var$set = function(it, metadata) {
        if ($cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE)) throw new $f87bb15e699cf95b$var$TypeError($f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $13b85566beee9498$exports(it, $f87bb15e699cf95b$var$STATE, metadata);
        return metadata;
    };
    $f87bb15e699cf95b$var$get = function(it) {
        return $cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE) ? it[$f87bb15e699cf95b$var$STATE] : {};
    };
    $f87bb15e699cf95b$var$has = function(it) {
        return $cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE);
    };
}
$f87bb15e699cf95b$exports = {
    set: $f87bb15e699cf95b$var$set,
    get: $f87bb15e699cf95b$var$get,
    has: $f87bb15e699cf95b$var$has,
    enforce: $f87bb15e699cf95b$var$enforce,
    getterFor: $f87bb15e699cf95b$var$getterFor
};


var $b9e70daef8851f0b$var$enforceInternalState = $f87bb15e699cf95b$exports.enforce;
var $b9e70daef8851f0b$var$getInternalState = $f87bb15e699cf95b$exports.get;
var $b9e70daef8851f0b$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $b9e70daef8851f0b$var$defineProperty = Object.defineProperty;
var $b9e70daef8851f0b$var$stringSlice = $c800df2b7efc8f14$exports(''.slice);
var $b9e70daef8851f0b$var$replace = $c800df2b7efc8f14$exports(''.replace);
var $b9e70daef8851f0b$var$join = $c800df2b7efc8f14$exports([].join);
var $b9e70daef8851f0b$var$CONFIGURABLE_LENGTH = $52f9c610bf0521fc$exports && !$7fbdf4c0599ef462$exports(function() {
    return $b9e70daef8851f0b$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $b9e70daef8851f0b$var$TEMPLATE = String(String).split('String');
var $b9e70daef8851f0b$var$makeBuiltIn = $b9e70daef8851f0b$exports = function(value, name, options) {
    if ($b9e70daef8851f0b$var$stringSlice($b9e70daef8851f0b$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $b9e70daef8851f0b$var$replace($b9e70daef8851f0b$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$cad4bbfed17498c2$exports(value, 'name') || $b9e70daef8851f0b$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($52f9c610bf0521fc$exports) $b9e70daef8851f0b$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($b9e70daef8851f0b$var$CONFIGURABLE_LENGTH && options && $cad4bbfed17498c2$exports(options, 'arity') && value.length !== options.arity) $b9e70daef8851f0b$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $cad4bbfed17498c2$exports(options, 'constructor') && options.constructor) {
            if ($52f9c610bf0521fc$exports) $b9e70daef8851f0b$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $b9e70daef8851f0b$var$enforceInternalState(value);
    if (!$cad4bbfed17498c2$exports(state, 'source')) state.source = $b9e70daef8851f0b$var$join($b9e70daef8851f0b$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $b9e70daef8851f0b$var$makeBuiltIn(function toString() {
    return $a7eaff0338821e23$exports(this) && $b9e70daef8851f0b$var$getInternalState(this).source || $94b2f3bb3c74e175$exports(this);
}, 'toString');



$0610e46059a94cbd$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($a7eaff0338821e23$exports(value)) $b9e70daef8851f0b$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $7f3648e7cf38ebc9$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $722eb9ecceb224f8$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $e936b86422279645$exports = {};
'use strict';

var $36eb3102175944c8$exports = {};
'use strict';


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $63553e39e7798603$export$2d1720544b23b823;
'use strict';
var $b3e319add4fe1dfd$exports = {};
'use strict';



var $538f3c10b3b3f45e$exports = {};
'use strict';

var $4358a7aa0cd0bcdd$exports = {};
'use strict';
var $dd070c356673d59c$exports = {};
'use strict';
var $71f29641d8c90c7d$exports = {};
'use strict';
var $71f29641d8c90c7d$var$ceil = Math.ceil;
var $71f29641d8c90c7d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$71f29641d8c90c7d$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $71f29641d8c90c7d$var$floor : $71f29641d8c90c7d$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$dd070c356673d59c$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $71f29641d8c90c7d$exports(number);
};


var $4358a7aa0cd0bcdd$var$max = Math.max;
var $4358a7aa0cd0bcdd$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$4358a7aa0cd0bcdd$exports = function(index, length) {
    var integer = $dd070c356673d59c$exports(index);
    return integer < 0 ? $4358a7aa0cd0bcdd$var$max(integer + length, 0) : $4358a7aa0cd0bcdd$var$min(integer, length);
};


var $a25bd31168207e91$exports = {};
'use strict';
var $17b8713bace259ee$exports = {};
'use strict';

var $17b8713bace259ee$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$17b8713bace259ee$exports = function(argument) {
    var len = $dd070c356673d59c$exports(argument);
    return len > 0 ? $17b8713bace259ee$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$a25bd31168207e91$exports = function(obj) {
    return $17b8713bace259ee$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $538f3c10b3b3f45e$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $9d811c44f1b32f82$exports($this);
        var length = $a25bd31168207e91$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $4358a7aa0cd0bcdd$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$538f3c10b3b3f45e$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $538f3c10b3b3f45e$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $538f3c10b3b3f45e$var$createMethod(false)
};


var $b3e319add4fe1dfd$require$indexOf = $538f3c10b3b3f45e$exports.indexOf;

var $b3e319add4fe1dfd$var$push = $c800df2b7efc8f14$exports([].push);
$b3e319add4fe1dfd$exports = function(object, names) {
    var O = $9d811c44f1b32f82$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$cad4bbfed17498c2$exports($c30c863eb145c5a8$exports, key) && $cad4bbfed17498c2$exports(O, key) && $b3e319add4fe1dfd$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($cad4bbfed17498c2$exports(O, key = names[i++])) ~$b3e319add4fe1dfd$require$indexOf(result, key) || $b3e319add4fe1dfd$var$push(result, key);
    return result;
};


var $2c7a9530035f509a$exports = {};
'use strict';
// IE8- don't enum bug keys
$2c7a9530035f509a$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $63553e39e7798603$var$hiddenKeys = $2c7a9530035f509a$exports.concat('length', 'prototype');
$63553e39e7798603$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b3e319add4fe1dfd$exports(O, $63553e39e7798603$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $7e6f79981172a35d$export$2d1720544b23b823;
'use strict';
$7e6f79981172a35d$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $36eb3102175944c8$var$concat = $c800df2b7efc8f14$exports([].concat);
// all object keys, includes non-enumerable and symbols
$36eb3102175944c8$exports = $4ea75fe1d4279dda$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $63553e39e7798603$export$2d1720544b23b823($3972fdbff685207b$exports(it));
    var getOwnPropertySymbols = $7e6f79981172a35d$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $36eb3102175944c8$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$e936b86422279645$exports = function(target, source, exceptions) {
    var keys = $36eb3102175944c8$exports(source);
    var defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $ce77c1f0936b11bf$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$cad4bbfed17498c2$exports(target, key) && !(exceptions && $cad4bbfed17498c2$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $aa1234bb61540248$exports = {};
'use strict';


var $aa1234bb61540248$var$replacement = /#|\.prototype\./;
var $aa1234bb61540248$var$isForced = function(feature, detection) {
    var value = $aa1234bb61540248$var$data[$aa1234bb61540248$var$normalize(feature)];
    return value === $aa1234bb61540248$var$POLYFILL ? true : value === $aa1234bb61540248$var$NATIVE ? false : $a7eaff0338821e23$exports(detection) ? $7fbdf4c0599ef462$exports(detection) : !!detection;
};
var $aa1234bb61540248$var$normalize = $aa1234bb61540248$var$isForced.normalize = function(string) {
    return String(string).replace($aa1234bb61540248$var$replacement, '.').toLowerCase();
};
var $aa1234bb61540248$var$data = $aa1234bb61540248$var$isForced.data = {};
var $aa1234bb61540248$var$NATIVE = $aa1234bb61540248$var$isForced.NATIVE = 'N';
var $aa1234bb61540248$var$POLYFILL = $aa1234bb61540248$var$isForced.POLYFILL = 'P';
$aa1234bb61540248$exports = $aa1234bb61540248$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $75395d4d1502b249$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $e70b94985eb51192$exports;
    else if (STATIC) target = $e70b94985eb51192$exports[TARGET] || $7f3648e7cf38ebc9$exports(TARGET, {});
    else target = $e70b94985eb51192$exports[TARGET] && $e70b94985eb51192$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $75395d4d1502b249$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $aa1234bb61540248$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $e936b86422279645$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $13b85566beee9498$exports(sourceProperty, 'sham', true);
        $0610e46059a94cbd$exports(target, key, sourceProperty, options);
    }
};




// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $669e6c84da4bfea7$export$2d1720544b23b823;
'use strict';

var $669e6c84da4bfea7$var$$TypeError = TypeError;
var $669e6c84da4bfea7$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $669e6c84da4bfea7$var$$TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $11648e8ec26b6ecd$exports(resolve);
    this.reject = $11648e8ec26b6ecd$exports(reject);
};
$669e6c84da4bfea7$export$2d1720544b23b823 = function(C) {
    return new $669e6c84da4bfea7$var$PromiseCapability(C);
};


var $df917240a5fd81a7$exports = {};
'use strict';
$df917240a5fd81a7$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


var $326565c1b25fdb3e$exports = {};
'use strict';
var $bd008ec4ae504cf2$exports = {};
'use strict';
var $22f471ac77cc41b7$exports = {};
'use strict';


$22f471ac77cc41b7$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($6b7f47111eaca73a$exports(fn) === 'Function') return $c800df2b7efc8f14$exports(fn);
};




var $bd008ec4ae504cf2$var$bind = $22f471ac77cc41b7$exports($22f471ac77cc41b7$exports.bind);
// optional / simple context binding
$bd008ec4ae504cf2$exports = function(fn, that) {
    $11648e8ec26b6ecd$exports(fn);
    return that === undefined ? fn : $e66e7bf0d4cfee4a$exports ? $bd008ec4ae504cf2$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $03921241703ed0a4$exports = {};
'use strict';

var $95f4729b625bb7e4$exports = {};
'use strict';
$95f4729b625bb7e4$exports = {};


var $03921241703ed0a4$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
var $03921241703ed0a4$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$03921241703ed0a4$exports = function(it) {
    return it !== undefined && ($95f4729b625bb7e4$exports.Array === it || $03921241703ed0a4$var$ArrayPrototype[$03921241703ed0a4$var$ITERATOR] === it);
};




var $eb3f950a8684bf37$exports = {};
'use strict';




var $8732c0df95152353$exports = {};
'use strict';
var $4d020c4f4ca990f0$exports = {};
'use strict';
var $9462e87e207cd0ad$exports = {};
'use strict';

var $9462e87e207cd0ad$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports('toStringTag');
var $9462e87e207cd0ad$var$test = {};
$9462e87e207cd0ad$var$test[$9462e87e207cd0ad$var$TO_STRING_TAG] = 'z';
$9462e87e207cd0ad$exports = String($9462e87e207cd0ad$var$test) === '[object z]';





var $4d020c4f4ca990f0$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports('toStringTag');
var $4d020c4f4ca990f0$var$$Object = Object;
// ES3 wrong here
var $4d020c4f4ca990f0$var$CORRECT_ARGUMENTS = $6b7f47111eaca73a$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $4d020c4f4ca990f0$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$4d020c4f4ca990f0$exports = $9462e87e207cd0ad$exports ? $6b7f47111eaca73a$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $4d020c4f4ca990f0$var$tryGet(O = $4d020c4f4ca990f0$var$$Object(it), $4d020c4f4ca990f0$var$TO_STRING_TAG)) == 'string' ? tag : $4d020c4f4ca990f0$var$CORRECT_ARGUMENTS ? $6b7f47111eaca73a$exports(O) : (result = $6b7f47111eaca73a$exports(O)) === 'Object' && $a7eaff0338821e23$exports(O.callee) ? 'Arguments' : result;
};






var $8732c0df95152353$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
$8732c0df95152353$exports = function(it) {
    if (!$4961f37f7ea715b0$exports(it)) return $f32de95dd0610261$exports(it, $8732c0df95152353$var$ITERATOR) || $f32de95dd0610261$exports(it, '@@iterator') || $95f4729b625bb7e4$exports[$4d020c4f4ca990f0$exports(it)];
};


var $eb3f950a8684bf37$var$$TypeError = TypeError;
$eb3f950a8684bf37$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8732c0df95152353$exports(argument) : usingIterator;
    if ($11648e8ec26b6ecd$exports(iteratorMethod)) return $3972fdbff685207b$exports($0c06b1aeebe22a6e$exports(iteratorMethod, argument));
    throw new $eb3f950a8684bf37$var$$TypeError($ff2dcd98892ae4f4$exports(argument) + ' is not iterable');
};



var $83cc9c7df832fea4$exports = {};
'use strict';



$83cc9c7df832fea4$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $3972fdbff685207b$exports(iterator);
    try {
        innerResult = $f32de95dd0610261$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $0c06b1aeebe22a6e$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $3972fdbff685207b$exports(innerResult);
    return value;
};


var $326565c1b25fdb3e$var$$TypeError = TypeError;
var $326565c1b25fdb3e$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $326565c1b25fdb3e$var$ResultPrototype = $326565c1b25fdb3e$var$Result.prototype;
$326565c1b25fdb3e$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $bd008ec4ae504cf2$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $83cc9c7df832fea4$exports(iterator, 'normal', condition);
        return new $326565c1b25fdb3e$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $3972fdbff685207b$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8732c0df95152353$exports(iterable);
        if (!iterFn) throw new $326565c1b25fdb3e$var$$TypeError($ff2dcd98892ae4f4$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($03921241703ed0a4$exports(iterFn)) {
            for(index = 0, length = $a25bd31168207e91$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $931b0ab7ad810eb0$exports($326565c1b25fdb3e$var$ResultPrototype, result)) return result;
            }
            return new $326565c1b25fdb3e$var$Result(false);
        }
        iterator = $eb3f950a8684bf37$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $0c06b1aeebe22a6e$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $83cc9c7df832fea4$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $931b0ab7ad810eb0$exports($326565c1b25fdb3e$var$ResultPrototype, result)) return result;
    }
    return new $326565c1b25fdb3e$var$Result(false);
};


var $8c0fc3f64f140a34$exports = {};
'use strict';
var $7af76ae23e077640$exports = {};
'use strict';

$7af76ae23e077640$exports = $e70b94985eb51192$exports.Promise;


var $e1124fa8137a8aa0$exports = {};
'use strict';

var $e1124fa8137a8aa0$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
var $e1124fa8137a8aa0$var$SAFE_CLOSING = false;
try {
    var $e1124fa8137a8aa0$var$called = 0;
    var $e1124fa8137a8aa0$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$e1124fa8137a8aa0$var$called++
            };
        },
        'return': function() {
            $e1124fa8137a8aa0$var$SAFE_CLOSING = true;
        }
    };
    $e1124fa8137a8aa0$var$iteratorWithReturn[$e1124fa8137a8aa0$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($e1124fa8137a8aa0$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$e1124fa8137a8aa0$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$e1124fa8137a8aa0$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$e1124fa8137a8aa0$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $72dc8e0778c344a5$exports = {};
'use strict';






var $c1ca2e50b2ea3685$exports = {};
'use strict';



var $c1ca2e50b2ea3685$var$userAgentStartsWith = function(string) {
    return $8087c5854054bb14$exports.slice(0, string.length) === string;
};
$c1ca2e50b2ea3685$exports = function() {
    if ($c1ca2e50b2ea3685$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($c1ca2e50b2ea3685$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($c1ca2e50b2ea3685$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($c1ca2e50b2ea3685$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($e70b94985eb51192$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($e70b94985eb51192$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($6b7f47111eaca73a$exports($e70b94985eb51192$exports.process) === 'process') return 'NODE';
    if ($e70b94985eb51192$exports.window && $e70b94985eb51192$exports.document) return 'BROWSER';
    return 'REST';
}();




var $72dc8e0778c344a5$var$NativePromisePrototype = $7af76ae23e077640$exports && $7af76ae23e077640$exports.prototype;
var $72dc8e0778c344a5$var$SPECIES = $0b105ffe14c0d5a5$exports('species');
var $72dc8e0778c344a5$var$SUBCLASSING = false;
var $72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT = $a7eaff0338821e23$exports($e70b94985eb51192$exports.PromiseRejectionEvent);
var $72dc8e0778c344a5$var$FORCED_PROMISE_CONSTRUCTOR = $aa1234bb61540248$exports('Promise', function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $94b2f3bb3c74e175$exports($7af76ae23e077640$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($7af76ae23e077640$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $131f458e39339f96$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($6ad9df1f2e7ebd85$exports && !($72dc8e0778c344a5$var$NativePromisePrototype['catch'] && $72dc8e0778c344a5$var$NativePromisePrototype['finally'])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$131f458e39339f96$exports || $131f458e39339f96$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $7af76ae23e077640$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$72dc8e0778c344a5$var$SPECIES] = FakePromise;
        $72dc8e0778c344a5$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$72dc8e0778c344a5$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($c1ca2e50b2ea3685$exports === 'BROWSER' || $c1ca2e50b2ea3685$exports === 'DENO') && !$72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$72dc8e0778c344a5$exports = {
    CONSTRUCTOR: $72dc8e0778c344a5$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $72dc8e0778c344a5$var$SUBCLASSING
};


var $8c0fc3f64f140a34$require$FORCED_PROMISE_CONSTRUCTOR = $72dc8e0778c344a5$exports.CONSTRUCTOR;
$8c0fc3f64f140a34$exports = $8c0fc3f64f140a34$require$FORCED_PROMISE_CONSTRUCTOR || !$e1124fa8137a8aa0$exports(function(iterable) {
    $7af76ae23e077640$exports.all(iterable).then(undefined, function() {});
});


// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$75395d4d1502b249$exports({
    target: 'Promise',
    stat: true,
    forced: $8c0fc3f64f140a34$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $669e6c84da4bfea7$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $df917240a5fd81a7$exports(function() {
            var promiseResolve = $11648e8ec26b6ecd$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $326565c1b25fdb3e$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $0c06b1aeebe22a6e$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'fulfilled',
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: 'rejected',
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




'use strict';

var $e58a769b5c316bc3$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$e58a769b5c316bc3$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c304d3413cc13bcd$exports = {};
'use strict';

var $c304d3413cc13bcd$var$classList = $c5824977ab5a14ea$exports('span').classList;
var $c304d3413cc13bcd$var$DOMTokenListPrototype = $c304d3413cc13bcd$var$classList && $c304d3413cc13bcd$var$classList.constructor && $c304d3413cc13bcd$var$classList.constructor.prototype;
$c304d3413cc13bcd$exports = $c304d3413cc13bcd$var$DOMTokenListPrototype === Object.prototype ? undefined : $c304d3413cc13bcd$var$DOMTokenListPrototype;


var $3dd1d4531fe4b9d5$exports = {};
'use strict';

var $664ec0493109aa88$exports = {};
'use strict';

var $21da32aa197e9369$exports = {};
'use strict';

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $776aae61651a64af$export$2d1720544b23b823;
'use strict';





var $e0e1484389826131$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$e0e1484389826131$exports = Object.keys || function keys(O) {
    return $b3e319add4fe1dfd$exports(O, $2c7a9530035f509a$exports);
};


$776aae61651a64af$export$2d1720544b23b823 = $52f9c610bf0521fc$exports && !$76b8d485b6e52872$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $3972fdbff685207b$exports(O);
    var props = $9d811c44f1b32f82$exports(Properties);
    var keys = $e0e1484389826131$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$722eb9ecceb224f8$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $271aa357825a8811$exports = {};
'use strict';

$271aa357825a8811$exports = $4ea75fe1d4279dda$exports('document', 'documentElement');




var $21da32aa197e9369$var$GT = '>';
var $21da32aa197e9369$var$LT = '<';
var $21da32aa197e9369$var$PROTOTYPE = 'prototype';
var $21da32aa197e9369$var$SCRIPT = 'script';
var $21da32aa197e9369$var$IE_PROTO = $37f7417c6f6b2b99$exports('IE_PROTO');
var $21da32aa197e9369$var$EmptyConstructor = function() {};
var $21da32aa197e9369$var$scriptTag = function(content) {
    return $21da32aa197e9369$var$LT + $21da32aa197e9369$var$SCRIPT + $21da32aa197e9369$var$GT + content + $21da32aa197e9369$var$LT + '/' + $21da32aa197e9369$var$SCRIPT + $21da32aa197e9369$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $21da32aa197e9369$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($21da32aa197e9369$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $21da32aa197e9369$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $c5824977ab5a14ea$exports('iframe');
    var JS = 'java' + $21da32aa197e9369$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $271aa357825a8811$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($21da32aa197e9369$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $21da32aa197e9369$var$activeXDocument;
var $21da32aa197e9369$var$NullProtoObject = function() {
    try {
        $21da32aa197e9369$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $21da32aa197e9369$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $21da32aa197e9369$var$activeXDocument ? $21da32aa197e9369$var$NullProtoObjectViaActiveX($21da32aa197e9369$var$activeXDocument) // old IE
     : $21da32aa197e9369$var$NullProtoObjectViaIFrame() : $21da32aa197e9369$var$NullProtoObjectViaActiveX($21da32aa197e9369$var$activeXDocument); // WSH
    var length = $2c7a9530035f509a$exports.length;
    while(length--)delete $21da32aa197e9369$var$NullProtoObject[$21da32aa197e9369$var$PROTOTYPE][$2c7a9530035f509a$exports[length]];
    return $21da32aa197e9369$var$NullProtoObject();
};
$c30c863eb145c5a8$exports[$21da32aa197e9369$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$21da32aa197e9369$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $21da32aa197e9369$var$EmptyConstructor[$21da32aa197e9369$var$PROTOTYPE] = $3972fdbff685207b$exports(O);
        result = new $21da32aa197e9369$var$EmptyConstructor();
        $21da32aa197e9369$var$EmptyConstructor[$21da32aa197e9369$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$21da32aa197e9369$var$IE_PROTO] = O;
    } else result = $21da32aa197e9369$var$NullProtoObject();
    return Properties === undefined ? result : $776aae61651a64af$export$2d1720544b23b823(result, Properties);
};



var $664ec0493109aa88$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
var $664ec0493109aa88$var$UNSCOPABLES = $0b105ffe14c0d5a5$exports('unscopables');
var $664ec0493109aa88$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($664ec0493109aa88$var$ArrayPrototype[$664ec0493109aa88$var$UNSCOPABLES] === undefined) $664ec0493109aa88$require$defineProperty($664ec0493109aa88$var$ArrayPrototype, $664ec0493109aa88$var$UNSCOPABLES, {
    configurable: true,
    value: $21da32aa197e9369$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$664ec0493109aa88$exports = function(key) {
    $664ec0493109aa88$var$ArrayPrototype[$664ec0493109aa88$var$UNSCOPABLES][key] = true;
};





var $3dd1d4531fe4b9d5$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
var $00ee7d8cefddb502$exports = {};
'use strict';





var $2aaebeededb83b7e$exports = {};
'use strict';
var $d4c634f75c944ca5$exports = {};
'use strict';




var $44b2740ddbb64f07$exports = {};
'use strict';




var $9604c7aa55203397$exports = {};
'use strict';

$9604c7aa55203397$exports = !$7fbdf4c0599ef462$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $44b2740ddbb64f07$var$IE_PROTO = $37f7417c6f6b2b99$exports('IE_PROTO');
var $44b2740ddbb64f07$var$$Object = Object;
var $44b2740ddbb64f07$var$ObjectPrototype = $44b2740ddbb64f07$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$44b2740ddbb64f07$exports = $9604c7aa55203397$exports ? $44b2740ddbb64f07$var$$Object.getPrototypeOf : function(O) {
    var object = $9979de0a9e7dae17$exports(O);
    if ($cad4bbfed17498c2$exports(object, $44b2740ddbb64f07$var$IE_PROTO)) return object[$44b2740ddbb64f07$var$IE_PROTO];
    var constructor = object.constructor;
    if ($a7eaff0338821e23$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $44b2740ddbb64f07$var$$Object ? $44b2740ddbb64f07$var$ObjectPrototype : null;
};





var $d4c634f75c944ca5$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
var $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $d4c634f75c944ca5$var$IteratorPrototype, $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype, $d4c634f75c944ca5$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $d4c634f75c944ca5$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $d4c634f75c944ca5$var$arrayIterator)) $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype = $44b2740ddbb64f07$exports($44b2740ddbb64f07$exports($d4c634f75c944ca5$var$arrayIterator));
        if ($d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $d4c634f75c944ca5$var$IteratorPrototype = $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $d4c634f75c944ca5$var$NEW_ITERATOR_PROTOTYPE = !$fbd29800d02822fa$exports($d4c634f75c944ca5$var$IteratorPrototype) || $7fbdf4c0599ef462$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $d4c634f75c944ca5$var$IteratorPrototype[$d4c634f75c944ca5$var$ITERATOR].call(test) !== test;
});
if ($d4c634f75c944ca5$var$NEW_ITERATOR_PROTOTYPE) $d4c634f75c944ca5$var$IteratorPrototype = {};
else if ($6ad9df1f2e7ebd85$exports) $d4c634f75c944ca5$var$IteratorPrototype = $21da32aa197e9369$exports($d4c634f75c944ca5$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$a7eaff0338821e23$exports($d4c634f75c944ca5$var$IteratorPrototype[$d4c634f75c944ca5$var$ITERATOR])) $0610e46059a94cbd$exports($d4c634f75c944ca5$var$IteratorPrototype, $d4c634f75c944ca5$var$ITERATOR, function() {
    return this;
});
$d4c634f75c944ca5$exports = {
    IteratorPrototype: $d4c634f75c944ca5$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS
};


var $2aaebeededb83b7e$require$IteratorPrototype = $d4c634f75c944ca5$exports.IteratorPrototype;


var $f4a284a3b2ffc725$exports = {};
'use strict';

var $f4a284a3b2ffc725$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;


var $f4a284a3b2ffc725$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports('toStringTag');
$f4a284a3b2ffc725$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$cad4bbfed17498c2$exports(target, $f4a284a3b2ffc725$var$TO_STRING_TAG)) $f4a284a3b2ffc725$require$defineProperty(target, $f4a284a3b2ffc725$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $2aaebeededb83b7e$var$returnThis = function() {
    return this;
};
$2aaebeededb83b7e$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $21da32aa197e9369$exports($2aaebeededb83b7e$require$IteratorPrototype, {
        next: $280423f212a26849$exports(+!ENUMERABLE_NEXT, next)
    });
    $f4a284a3b2ffc725$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $95f4729b625bb7e4$exports[TO_STRING_TAG] = $2aaebeededb83b7e$var$returnThis;
    return IteratorConstructor;
};



var $272762809cba1f01$exports = {};
'use strict';
var $794046773695e4c1$exports = {};
'use strict';


$794046773695e4c1$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $c800df2b7efc8f14$exports($11648e8ec26b6ecd$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $14994f6e66f859e1$exports = {};
'use strict';
var $638415392bcad94e$exports = {};
'use strict';

$638415392bcad94e$exports = function(argument) {
    return $fbd29800d02822fa$exports(argument) || argument === null;
};


var $14994f6e66f859e1$var$$String = String;
var $14994f6e66f859e1$var$$TypeError = TypeError;
$14994f6e66f859e1$exports = function(argument) {
    if ($638415392bcad94e$exports(argument)) return argument;
    throw new $14994f6e66f859e1$var$$TypeError("Can't set " + $14994f6e66f859e1$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$272762809cba1f01$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $794046773695e4c1$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $dc13fa5d6a969043$exports(O);
        $14994f6e66f859e1$exports(proto);
        if (!$fbd29800d02822fa$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $00ee7d8cefddb502$var$PROPER_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.PROPER;
var $00ee7d8cefddb502$var$CONFIGURABLE_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.CONFIGURABLE;
var $00ee7d8cefddb502$var$IteratorPrototype = $d4c634f75c944ca5$exports.IteratorPrototype;
var $00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS = $d4c634f75c944ca5$exports.BUGGY_SAFARI_ITERATORS;
var $00ee7d8cefddb502$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
var $00ee7d8cefddb502$var$KEYS = 'keys';
var $00ee7d8cefddb502$var$VALUES = 'values';
var $00ee7d8cefddb502$var$ENTRIES = 'entries';
var $00ee7d8cefddb502$var$returnThis = function() {
    return this;
};
$00ee7d8cefddb502$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2aaebeededb83b7e$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $00ee7d8cefddb502$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00ee7d8cefddb502$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00ee7d8cefddb502$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$00ee7d8cefddb502$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $44b2740ddbb64f07$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$6ad9df1f2e7ebd85$exports && $44b2740ddbb64f07$exports(CurrentIteratorPrototype) !== $00ee7d8cefddb502$var$IteratorPrototype) {
                if ($272762809cba1f01$exports) $272762809cba1f01$exports(CurrentIteratorPrototype, $00ee7d8cefddb502$var$IteratorPrototype);
                else if (!$a7eaff0338821e23$exports(CurrentIteratorPrototype[$00ee7d8cefddb502$var$ITERATOR])) $0610e46059a94cbd$exports(CurrentIteratorPrototype, $00ee7d8cefddb502$var$ITERATOR, $00ee7d8cefddb502$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $f4a284a3b2ffc725$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($6ad9df1f2e7ebd85$exports) $95f4729b625bb7e4$exports[TO_STRING_TAG] = $00ee7d8cefddb502$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($00ee7d8cefddb502$var$PROPER_FUNCTION_NAME && DEFAULT === $00ee7d8cefddb502$var$VALUES && nativeIterator && nativeIterator.name !== $00ee7d8cefddb502$var$VALUES) {
        if (!$6ad9df1f2e7ebd85$exports && $00ee7d8cefddb502$var$CONFIGURABLE_FUNCTION_NAME) $13b85566beee9498$exports(IterablePrototype, 'name', $00ee7d8cefddb502$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $0c06b1aeebe22a6e$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($00ee7d8cefddb502$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($00ee7d8cefddb502$var$KEYS),
            entries: getIterationMethod($00ee7d8cefddb502$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $0610e46059a94cbd$exports(IterablePrototype, KEY, methods[KEY]);
        } else $75395d4d1502b249$exports({
            target: NAME,
            proto: true,
            forced: $00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$6ad9df1f2e7ebd85$exports || FORCED) && IterablePrototype[$00ee7d8cefddb502$var$ITERATOR] !== defaultIterator) $0610e46059a94cbd$exports(IterablePrototype, $00ee7d8cefddb502$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $95f4729b625bb7e4$exports[NAME] = defaultIterator;
    return methods;
};


var $6712d89e16ffd986$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$6712d89e16ffd986$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $3dd1d4531fe4b9d5$var$ARRAY_ITERATOR = 'Array Iterator';
var $3dd1d4531fe4b9d5$var$setInternalState = $f87bb15e699cf95b$exports.set;
var $3dd1d4531fe4b9d5$var$getInternalState = $f87bb15e699cf95b$exports.getterFor($3dd1d4531fe4b9d5$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$3dd1d4531fe4b9d5$exports = $00ee7d8cefddb502$exports(Array, 'Array', function(iterated, kind) {
    $3dd1d4531fe4b9d5$var$setInternalState(this, {
        type: $3dd1d4531fe4b9d5$var$ARRAY_ITERATOR,
        target: $9d811c44f1b32f82$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $3dd1d4531fe4b9d5$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $6712d89e16ffd986$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $6712d89e16ffd986$exports(index, false);
        case 'values':
            return $6712d89e16ffd986$exports(target[index], false);
    }
    return $6712d89e16ffd986$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $3dd1d4531fe4b9d5$var$values = $95f4729b625bb7e4$exports.Arguments = $95f4729b625bb7e4$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$664ec0493109aa88$exports('keys');
$664ec0493109aa88$exports('values');
$664ec0493109aa88$exports('entries');
// V8 ~ Chrome 45- bug
if (!$6ad9df1f2e7ebd85$exports && $52f9c610bf0521fc$exports && $3dd1d4531fe4b9d5$var$values.name !== 'values') try {
    $3dd1d4531fe4b9d5$require$defineProperty($3dd1d4531fe4b9d5$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}





var $8cc0c75cf23be5a0$var$ITERATOR = $0b105ffe14c0d5a5$exports('iterator');
var $8cc0c75cf23be5a0$var$ArrayValues = $3dd1d4531fe4b9d5$exports.values;
var $8cc0c75cf23be5a0$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$8cc0c75cf23be5a0$var$ITERATOR] !== $8cc0c75cf23be5a0$var$ArrayValues) try {
            $13b85566beee9498$exports(CollectionPrototype, $8cc0c75cf23be5a0$var$ITERATOR, $8cc0c75cf23be5a0$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$8cc0c75cf23be5a0$var$ITERATOR] = $8cc0c75cf23be5a0$var$ArrayValues;
        }
        $f4a284a3b2ffc725$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($e58a769b5c316bc3$exports[COLLECTION_NAME]) for(var METHOD_NAME in $3dd1d4531fe4b9d5$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $3dd1d4531fe4b9d5$exports[METHOD_NAME]) try {
                $13b85566beee9498$exports(CollectionPrototype, METHOD_NAME, $3dd1d4531fe4b9d5$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $3dd1d4531fe4b9d5$exports[METHOD_NAME];
            }
        }
    }
};
for(var $8cc0c75cf23be5a0$var$COLLECTION_NAME in $e58a769b5c316bc3$exports)$8cc0c75cf23be5a0$var$handlePrototype($e70b94985eb51192$exports[$8cc0c75cf23be5a0$var$COLLECTION_NAME] && $e70b94985eb51192$exports[$8cc0c75cf23be5a0$var$COLLECTION_NAME].prototype, $8cc0c75cf23be5a0$var$COLLECTION_NAME);
$8cc0c75cf23be5a0$var$handlePrototype($c304d3413cc13bcd$exports, 'DOMTokenList');




parcelRequire("8ZuGG");
var $11bb442d9fd66b68$export$882461b6382ed46c;
var $11bb442d9fd66b68$export$757ceba2d55c277e;
'use strict';

var $h1d60 = parcelRequire("h1d60");
var $11bb442d9fd66b68$var$i;
$11bb442d9fd66b68$export$882461b6382ed46c = $h1d60.createRoot;
$11bb442d9fd66b68$export$757ceba2d55c277e = $h1d60.hydrateRoot;


parcelRequire("iBTcr");
var $e1hxF = parcelRequire("e1hxF");

var $cufV0 = parcelRequire("cufV0");

var $9Li6K = parcelRequire("9Li6K");

var $8f2pb = parcelRequire("8f2pb");

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $4OQoZ = parcelRequire("4OQoZ");

var $8f2pb = parcelRequire("8f2pb");

var $kOqgB = parcelRequire("kOqgB");

























const $b47ccb028625d76a$var$languages = {
    'pt-BR': ()=>(parcelRequire("9ek8N")),
    'en-ZZ': ()=>(parcelRequire("imyZ9")),
    'en-GB': ()=>(parcelRequire("41CBD")),
    'zh-CN': ()=>(parcelRequire("hQLzx")),
    'zh-TW': ()=>(parcelRequire("2n6QC")),
    cs: ()=>(parcelRequire("jgIFg")),
    da: ()=>(parcelRequire("eQS3o")),
    de: ()=>(parcelRequire("d8wgI")),
    en: ()=>(parcelRequire("g4zfV")),
    es: ()=>(parcelRequire("3uRuL")),
    fi: ()=>(parcelRequire("b6QhV")),
    fr: ()=>(parcelRequire("4MwDy")),
    hu: ()=>(parcelRequire("2zMlh")),
    it: ()=>(parcelRequire("2TaUl")),
    ja: ()=>(parcelRequire("bfqCY")),
    ko: ()=>(parcelRequire("lEJ78")),
    nb: ()=>(parcelRequire("gqK4f")),
    nl: ()=>(parcelRequire("3omAS")),
    pl: ()=>(parcelRequire("7yvG1")),
    ru: ()=>(parcelRequire("e7JDz")),
    sv: ()=>(parcelRequire("gQVR5")),
    th: ()=>(parcelRequire("4R2AC")),
    tr: ()=>(parcelRequire("jrFLZ")),
    uk: ()=>(parcelRequire("b05HP")),
    vi: ()=>(parcelRequire("2FOdn"))
};
const $b47ccb028625d76a$var$fetchLanguage = async (locale)=>{
    if (locale in $b47ccb028625d76a$var$languages) {
        const messages = await $b47ccb028625d76a$var$languages[locale]();
        return {
            locale: locale,
            messages: messages.default || messages
        };
    }
    throw new Error(`${locale} not found in languages config`);
};
const $b47ccb028625d76a$var$LocaleSwitcher = ({ children: children })=>{
    const locale = (0, $kOqgB.useAppSelector)((state)=>state.locale);
    const [fallbackLocale] = locale.split('-', 1);
    const [{ loading: loading, messages: messages, derivedLocale: derivedLocale }, setState] = (0, $8ZuGG.useState)({
        loading: true,
        messages: {},
        derivedLocale: locale
    });
    (0, $8ZuGG.useEffect)(()=>{
        $b47ccb028625d76a$var$fetchLanguage(locale).catch(()=>$b47ccb028625d76a$var$fetchLanguage(fallbackLocale)).then((i18n)=>{
            setState({
                loading: false,
                messages: i18n.messages,
                derivedLocale: i18n.locale
            });
        }, ()=>{
            const content = `no translations were found for localeId ${locale} or fallbackLocale ${fallbackLocale}.`;
            console.debug(content);
            (0, $8f2pb.captureErrorMessage)('i18n_fetch_language_error', {
                content: content,
                locale: locale,
                fallbackLocale: fallbackLocale
            });
            setState((prevState)=>(0, $6EnDC._)((0, $ty6PY._)({}, prevState), {
                    loading: false
                }));
        });
    }, [
        locale,
        fallbackLocale
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $4OQoZ.default), {
        locale: derivedLocale,
        messages: messages,
        children: loading ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {}) : children
    });
};
var $b47ccb028625d76a$export$2e2bcd8739ae039 = $b47ccb028625d76a$var$LocaleSwitcher;



var $82mu7 = parcelRequire("82mu7");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $iSD9t = parcelRequire("iSD9t");

var $kOqgB = parcelRequire("kOqgB");
const $55e2f1fb9825dd5f$var$AnalyticsClientProvider = ({ children: children })=>{
    const { locale: locale } = (0, $iSD9t.default)();
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const microbranding = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const tenantCloudId = (0, $kOqgB.useAppSelector)((state)=>state.context.tenantCloudId);
    const userId = (0, $kOqgB.useAppSelector)((state)=>state.context.userId);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $3ir1n.AnalyticsClientContext).Provider, {
        value: new (0, $3ir1n.AnalyticsClientImpl)({
            cobranding: cobranding,
            locale: locale,
            microbranding: microbranding,
            tenantCloudId: tenantCloudId,
            userId: userId
        }),
        children: children
    });
};
var $55e2f1fb9825dd5f$export$2e2bcd8739ae039 = $55e2f1fb9825dd5f$var$AnalyticsClientProvider;



var $fHARP = parcelRequire("fHARP");
parcelRequire("62Jrh");
var $2xiyk = parcelRequire("2xiyk");

var $kOqgB = parcelRequire("kOqgB");

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $eyuWU = parcelRequire("eyuWU");

var $eyuWU = parcelRequire("eyuWU");

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $eyuWU = parcelRequire("eyuWU");

var $eoogg = parcelRequire("eoogg");

var $7iBIE = parcelRequire("7iBIE");

var $hGQfz = parcelRequire("hGQfz");

var $13OCx = parcelRequire("13OCx");
// CLASS
class $34964cecc1580de1$export$62297b13309008b2 extends (0, $13OCx.Removable) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = (0, $ty6PY._)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $eyuWU.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $eyuWU.noop)).catch((0, $eyuWU.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $eyuWU.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $eyuWU.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $hGQfz.isCancelledError)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $hGQfz.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $hGQfz.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    });
                case 'pause':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        fetchStatus: 'paused'
                    });
                case 'continue':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        fetchStatus: 'fetching'
                    });
                case 'fetch':
                    return (0, $ty6PY._)((0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $hGQfz.canFetch)(this.options.networkMode) ? 'fetching' : 'paused'
                    }), !state.dataUpdatedAt && {
                        error: null,
                        status: 'loading'
                    });
                case 'success':
                    return (0, $ty6PY._)((0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success'
                    }), !action.manual && {
                        fetchStatus: 'idle',
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    });
                case 'error':
                    const error = action.error;
                    if ((0, $hGQfz.isCancelledError)(error) && error.revert && this.revertState) return (0, $6EnDC._)((0, $ty6PY._)({}, this.revertState), {
                        fetchStatus: 'idle'
                    });
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    });
                case 'invalidate':
                    return (0, $6EnDC._)((0, $ty6PY._)({}, state), {
                        isInvalidated: true
                    });
                case 'setState':
                    return (0, $ty6PY._)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $7iBIE.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $eoogg.defaultLogger);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $34964cecc1580de1$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $34964cecc1580de1$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}



var $7iBIE = parcelRequire("7iBIE");

var $4QQ45 = parcelRequire("4QQ45");
// CLASS
class $8d134b4488e50629$export$5dde0cd941da8468 extends (0, $4QQ45.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $eyuWU.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $34964cecc1580de1$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $eyuWU.matchQuery)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $eyuWU.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}



var $7iBIE = parcelRequire("7iBIE");

var $bGowL = parcelRequire("bGowL");

var $eyuWU = parcelRequire("eyuWU");

var $4QQ45 = parcelRequire("4QQ45");
// CLASS
class $4533a9a1191d6293$export$1fcfd9a244434844 extends (0, $4QQ45.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $bGowL.Mutation)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $eyuWU.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $eyuWU.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $7iBIE.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $eyuWU.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}



var $efras = parcelRequire("efras");

var $gF9Ao = parcelRequire("gF9Ao");

var $7iBIE = parcelRequire("7iBIE");
function $95ee09b8df45fcd1$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $95ee09b8df45fcd1$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $95ee09b8df45fcd1$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $95ee09b8df45fcd1$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $95ee09b8df45fcd1$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $95ee09b8df45fcd1$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $95ee09b8df45fcd1$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $95ee09b8df45fcd1$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $95ee09b8df45fcd1$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $95ee09b8df45fcd1$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



var $eoogg = parcelRequire("eoogg");
// CLASS
class $987a37d76b93c345$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $efras.focusManager).subscribe(()=>{
            if ((0, $efras.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $gF9Ao.onlineManager).subscribe(()=>{
            if ((0, $gF9Ao.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll((0, $6EnDC._)((0, $ty6PY._)({}, filters), {
            fetching: true
        })).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $eyuWU.functionalUpdate)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, (0, $6EnDC._)((0, $ty6PY._)({}, options), {
            manual: true
        }));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $7iBIE.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $7iBIE.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = (0, $ty6PY._)({
            type: 'active'
        }, filters);
        return (0, $7iBIE.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $7iBIE.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $7iBIE.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = (0, $6EnDC._)((0, $ty6PY._)({}, filters), {
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $7iBIE.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, (0, $6EnDC._)((0, $ty6PY._)({}, options), {
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                }));
            }));
        let promise = Promise.all(promises).then((0, $eyuWU.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $eyuWU.noop));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $95ee09b8df45fcd1$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $eyuWU.hashQueryKey)(queryKey) === (0, $eyuWU.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $eyuWU.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $eyuWU.hashQueryKey)(mutationKey) === (0, $eyuWU.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $eyuWU.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = (0, $6EnDC._)((0, $ty6PY._)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options), {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $eyuWU.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return (0, $6EnDC._)((0, $ty6PY._)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options), {
            _defaulted: true
        });
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $8d134b4488e50629$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $4533a9a1191d6293$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $eoogg.defaultLogger);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}


var $6b5zr = parcelRequire("6b5zr");
parcelRequire("ie5oO");
var $4KLgf = parcelRequire("4KLgf");

var $8wTJJ = parcelRequire("8wTJJ");

var $ty6PY = parcelRequire("ty6PY");

var $6EnDC = parcelRequire("6EnDC");

var $42tc5 = parcelRequire("42tc5");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $8ZuGG = parcelRequire("8ZuGG");

var $9P7k6 = parcelRequire("9P7k6");

var $7f5qq = parcelRequire("7f5qq");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $5msJs = parcelRequire("5msJs");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $6KhR5 = parcelRequire("6KhR5");
var $l9koH = parcelRequire("l9koH");
var $rG0so = parcelRequire("rG0so");
function $f024180bd64697ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f024180bd64697ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f024180bd64697ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f024180bd64697ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f024180bd64697ea$var$defaultThemeSettings = function defaultThemeSettings() {
    return {
        dark: 'dark',
        light: 'light',
        spacing: 'spacing',
        typography: 'typography'
    };
};
var $f024180bd64697ea$var$ColorModeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
var $f024180bd64697ea$var$SetColorModeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
var $f024180bd64697ea$var$ThemeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
var $f024180bd64697ea$var$SetThemeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(undefined);
function $f024180bd64697ea$export$ce91654eb9fea460() {
    var value = (0, $8ZuGG.useContext)($f024180bd64697ea$var$ColorModeContext);
    return value;
}
function $f024180bd64697ea$export$20f3076712c8dfa() {
    var value = (0, $8ZuGG.useContext)($f024180bd64697ea$var$ColorModeContext);
    var _getGlobalTheme = (0, $6KhR5.default)(), colorMode = _getGlobalTheme.colorMode;
    var _useState = (0, $8ZuGG.useState)(colorMode || 'light'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), resolvedColorMode = _useState2[0], setResolvedColorMode = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (value) return;
        var observer = new (0, $rG0so.default)(function(theme) {
            setResolvedColorMode(theme.colorMode || 'light');
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        value
    ]);
    return value ? value : resolvedColorMode;
}
function $f024180bd64697ea$export$e2afe7397c3d11c7() {
    var value = (0, $8ZuGG.useContext)($f024180bd64697ea$var$SetColorModeContext);
    if (!value) throw new Error('useSetColorMode must be used within AppProvider.');
    return value;
}
function $f024180bd64697ea$export$93d4e7f90805808f() {
    var theme = (0, $8ZuGG.useContext)($f024180bd64697ea$var$ThemeContext);
    var _useState3 = (0, $8ZuGG.useState)(theme || (0, $6KhR5.default)()), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), resolvedTheme = _useState4[0], setResolvedTheme = _useState4[1];
    (0, $8ZuGG.useEffect)(function() {
        // We are using theme from context so no need to reference the DOM
        if (theme) return;
        var observer = new (0, $rG0so.default)(setResolvedTheme);
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, [
        theme
    ]);
    return theme ? theme : resolvedTheme;
}
function $f024180bd64697ea$export$501aa0dcd5527a48() {
    var value = (0, $8ZuGG.useContext)($f024180bd64697ea$var$SetThemeContext);
    if (!value) throw new Error('useSetTheme must be used within AppProvider.');
    return value;
}
var $f024180bd64697ea$var$isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
var $f024180bd64697ea$var$prefersDarkModeMql = $f024180bd64697ea$var$isMatchMediaAvailable ? window.matchMedia('(prefers-color-scheme: dark)') : undefined;
// TODO: currently 'auto' color mode will always return 'light' in SSR.
// Additional work required: https://product-fabric.atlassian.net/browse/DSP-9781
function $f024180bd64697ea$var$getReconciledColorMode(colorMode) {
    if (colorMode === 'auto') return $f024180bd64697ea$var$prefersDarkModeMql !== null && $f024180bd64697ea$var$prefersDarkModeMql !== void 0 && $f024180bd64697ea$var$prefersDarkModeMql.matches ? 'dark' : 'light';
    return colorMode;
}
/**
 * __Theme provider__
 *
 * Provides global theming configuration.
 *
 * @internal
 */ function $f024180bd64697ea$var$ThemeProvider(_ref) {
    var children = _ref.children, defaultColorMode = _ref.defaultColorMode, defaultTheme = _ref.defaultTheme;
    var _useState5 = (0, $8ZuGG.useState)(defaultColorMode), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), chosenColorMode = _useState6[0], setChosenColorMode = _useState6[1];
    var _useState7 = (0, $8ZuGG.useState)($f024180bd64697ea$var$getReconciledColorMode(defaultColorMode)), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState7, 2), reconciledColorMode = _useState8[0], setReconciledColorMode = _useState8[1];
    var _useState9 = (0, $8ZuGG.useState)(function() {
        return $f024180bd64697ea$var$_objectSpread($f024180bd64697ea$var$_objectSpread({}, $f024180bd64697ea$var$defaultThemeSettings()), defaultTheme);
    }), _useState0 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState9, 2), theme = _useState0[0], setTheme = _useState0[1];
    var setColorMode = (0, $8ZuGG.useCallback)(function(colorMode) {
        setChosenColorMode(colorMode);
        setReconciledColorMode($f024180bd64697ea$var$getReconciledColorMode(colorMode));
    }, []);
    var setPartialTheme = (0, $8ZuGG.useCallback)(function(nextTheme) {
        setTheme(function(theme) {
            return $f024180bd64697ea$var$_objectSpread($f024180bd64697ea$var$_objectSpread({}, theme), nextTheme);
        });
    }, []);
    var lastSetGlobalThemePromiseRef = (0, $8ZuGG.useRef)(null);
    (0, $8ZuGG.useEffect)(function() {
        /**
     * We need to wait for any previous `setGlobalTheme` calls to finish before calling it again.
     * This is to prevent race conditions as `setGlobalTheme` is async and mutates the DOM (e.g. sets the
     * `data-color-mode` attribute on the root element).
     *
     * Since we can't safely abort the `setGlobalTheme` execution, we need to wait for it to properly finish before
     * applying the new theme.
     *
     * Without this, we can end up in the following scenario:
     * 1. app loads with the default 'light' theme, kicking off `setGlobalTheme`
     * 2. app switches to 'dark' theme after retrieving value persisted in local storage, calling `setGlobalTheme` again
     * 3. `setGlobalTheme` function execution for `dark` finishes before the initial `light` execution
     * 4. `setGlobalTheme` function execution for `light` then finishes, resulting in the 'light' theme being applied.
     */ var cleanupLastFnCall = /*#__PURE__*/ function() {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                var unbindFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!lastSetGlobalThemePromiseRef.current) {
                                _context.next = 6;
                                break;
                            }
                            _context.next = 3;
                            return lastSetGlobalThemePromiseRef.current;
                        case 3:
                            unbindFn = _context.sent;
                            unbindFn();
                            lastSetGlobalThemePromiseRef.current = null;
                        case 6:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function cleanupLastFnCall() {
                return _ref2.apply(this, arguments);
            };
        }();
        var safelySetGlobalTheme = /*#__PURE__*/ function() {
            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                var promise;
                return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            _context2.next = 2;
                            return cleanupLastFnCall();
                        case 2:
                            promise = (0, $l9koH.default)($f024180bd64697ea$var$_objectSpread($f024180bd64697ea$var$_objectSpread({}, theme), {}, {
                                colorMode: reconciledColorMode
                            }));
                            lastSetGlobalThemePromiseRef.current = promise;
                        case 4:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee2);
            }));
            return function safelySetGlobalTheme() {
                return _ref3.apply(this, arguments);
            };
        }();
        safelySetGlobalTheme();
        return function cleanup() {
            cleanupLastFnCall();
        };
    }, [
        theme,
        reconciledColorMode
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (!$f024180bd64697ea$var$prefersDarkModeMql) return;
        var unbindListener = (0, $k6Bkl.bind)($f024180bd64697ea$var$prefersDarkModeMql, {
            type: 'change',
            listener: function listener(event) {
                if (chosenColorMode === 'auto') setReconciledColorMode(event.matches ? 'dark' : 'light');
            }
        });
        return unbindListener;
    }, [
        chosenColorMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f024180bd64697ea$var$ColorModeContext.Provider, {
        value: reconciledColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f024180bd64697ea$var$SetColorModeContext.Provider, {
        value: setColorMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f024180bd64697ea$var$ThemeContext.Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f024180bd64697ea$var$SetThemeContext.Provider, {
        value: setPartialTheme
    }, children))));
}
var $f024180bd64697ea$export$2e2bcd8739ae039 = $f024180bd64697ea$var$ThemeProvider;


var $2438dc251fd5ddae$var$InsideAppProviderContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(false);
/**
 * __App provider__
 *
 * An app provider provides app level configuration such as global theming.
 *
 * Place it at the root of your application.
 */ function $2438dc251fd5ddae$var$AppProvider(_ref) {
    var children = _ref.children, _ref$defaultColorMode = _ref.defaultColorMode, defaultColorMode = _ref$defaultColorMode === void 0 ? 'light' : _ref$defaultColorMode, defaultTheme = _ref.defaultTheme, routerLinkComponent = _ref.routerLinkComponent, UNSAFE_isThemingDisabled = _ref.UNSAFE_isThemingDisabled;
    var isInsideAppProvider = (0, $8ZuGG.useContext)($2438dc251fd5ddae$var$InsideAppProviderContext);
    if (isInsideAppProvider) throw new Error('App provider should not be nested within another app provider.');
    var routerLinkProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9P7k6.default), {
        routerLinkComponent: routerLinkComponent
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($2438dc251fd5ddae$var$InsideAppProviderContext.Provider, {
        value: true
    }, UNSAFE_isThemingDisabled ? routerLinkProvider : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $f024180bd64697ea$export$2e2bcd8739ae039), {
        defaultColorMode: defaultColorMode,
        defaultTheme: defaultTheme
    }, routerLinkProvider));
}
var $2438dc251fd5ddae$export$2e2bcd8739ae039 = $2438dc251fd5ddae$var$AppProvider;



var $gyRZh = parcelRequire("gyRZh");
/**
 * This component is used to replace Atlaskit linking components with links that use react-router-dom for navigation.
 * The AppProvider determines when to use this component (it does not replace all Atlaskit linking components).
 * See https://atlassian.design/components/primitives/anchor/examples#router-links for more details.
 */ const $e67a321637458b33$var$RouterLinkComponent = /*#__PURE__*/ (0, $8ZuGG.forwardRef)((_param, ref)=>{
    var { href: href, children: children } = _param, rest = (0, $42tc5._)(_param, [
        "href",
        "children"
    ]);
    if (typeof href === 'string') return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), (0, $6EnDC._)((0, $ty6PY._)({
        ref: ref,
        to: href
    }, rest), {
        children: children
    }));
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.Link), (0, $6EnDC._)((0, $ty6PY._)({
        ref: ref
    }, href, rest), {
        children: children
    }));
});
$e67a321637458b33$var$RouterLinkComponent.displayName = 'RouterLinkComponent';
const $e67a321637458b33$var$AppProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $2438dc251fd5ddae$export$2e2bcd8739ae039), {
        routerLinkComponent: $e67a321637458b33$var$RouterLinkComponent,
        children: children
    });
};
var $e67a321637458b33$export$2e2bcd8739ae039 = $e67a321637458b33$var$AppProvider;



var $gyRZh = parcelRequire("gyRZh");
// Render a spinner to remove the "failed to load scripts" error while loading the app
const $1d5a93c8cd6b268e$var$container = document.getElementById('root');
const $1d5a93c8cd6b268e$var$root = (0, $11bb442d9fd66b68$export$882461b6382ed46c)($1d5a93c8cd6b268e$var$container);
$1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)("div", {
    style: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
        size: "large"
    })
}));
const $1d5a93c8cd6b268e$var$preloadedState = (0, $82mu7.preloadAppState)();
(0, $82mu7.buildInitialState)($1d5a93c8cd6b268e$var$preloadedState).then(async (initialState)=>{
    const { initialStoreState: initialStoreState, cspNonce: cspNonce } = initialState;
    (0, $8f2pb.initClient)(initialStoreState.microbranding);
    const analyticsClient = (0, $82mu7.createAnalyticsClient)(initialState);
    (0, $8f2pb.setUserId)(analyticsClient.getAnonymousId());
    (0, $82mu7.startupAnalyticEvent)(analyticsClient);
    (0, $2xiyk.startBrowserMetrics)(analyticsClient);
    const ffsId = (0, $8wTJJ.getFfsId)();
    if (ffsId) analyticsClient.setFfsId(ffsId);
    (0, $82mu7.pushGlobals)(initialStoreState.appConfig, cspNonce);
    const store = (0, $kOqgB.createAppStore)(initialStoreState);
    if (initialStoreState.appConfig) (0, $82mu7.initCastle)(initialStoreState.appConfig);
    const queryClient = new (0, $987a37d76b93c345$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                retry: false
            }
        }
    });
    $1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)((0, $e1hxF.default), {
        store: store,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $b47ccb028625d76a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.default), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $e67a321637458b33$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6b5zr.QueryClientProvider), {
                        client: queryClient,
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $55e2f1fb9825dd5f$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $4KLgf.FeatureGateProvider), {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.RouterProvider), {
                                    router: (0, $fHARP.router)
                                })
                            })
                        })
                    })
                })
            })
        })
    }));
}).catch((error)=>{
    (0, $8f2pb.captureException)(error);
    const emptyStore = (0, $kOqgB.createAppStore)({});
    $1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)((0, $e1hxF.default), {
        store: emptyStore,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $b47ccb028625d76a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.UnexpectedApplicationErrorPage), {})
        })
    }));
});

})();
//# sourceMappingURL=index.b81438b1.js.map
